/*
 * jsreports 1.4.122
 * Copyright (c) 2017 jsreports
 * http://jsreports.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["jsreports"] = factory();
	else
		root["jsreports"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _indexCore = __webpack_require__(1);

	var _indexCore2 = _interopRequireDefault(_indexCore);

	var _indexDesigner = __webpack_require__(293);

	var _indexDesigner2 = _interopRequireDefault(_indexDesigner);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Combine ditto-core and ditto-designer into one module
	 */
	(0, _indexDesigner2.default)(_indexCore2.default);

	module.exports = _indexCore2.default;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ReportElement = __webpack_require__(2);

	var _CompositeElement = __webpack_require__(4);

	var _CompositeElement2 = _interopRequireDefault(_CompositeElement);

	var _ElementUtils = __webpack_require__(5);

	var _ElementUtils2 = _interopRequireDefault(_ElementUtils);

	var _Checkbox = __webpack_require__(6);

	var _Checkbox2 = _interopRequireDefault(_Checkbox);

	var _Text = __webpack_require__(9);

	var _Text2 = _interopRequireDefault(_Text);

	var _Line = __webpack_require__(10);

	var _Line2 = _interopRequireDefault(_Line);

	var _Table = __webpack_require__(11);

	var _Table2 = _interopRequireDefault(_Table);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	__webpack_require__(25); /**
	                         * Ditto client-side package root.  This is the entry point for Webpack to build
	                         * the browser module.  This module can be loaded directly in the browser, and is also
	                         * bundled into the ditto-server module for use in a Jasper context for server-side
	                         * rendering.
	                         */


	var saveAs = typeof window !== 'undefined' && window.saveAs ? window.saveAs : __webpack_require__(75).saveAs;
	var $ = __webpack_require__(13);
	var ditto = __webpack_require__(78)(window, saveAs, $);
	__webpack_require__(291)(ditto);
	__webpack_require__(292)(ditto, $);

	Object.assign(ditto, {
	  ReportElement: _ReportElement.ReportElement,
	  CompositeElement: _CompositeElement2.default,
	  ElementUtils: _ElementUtils2.default,
	  PropTypes: _ReportElement.PropTypes,
	  elements: {
	    Checkbox: _Checkbox2.default,
	    Text: _Text2.default,
	    Table: _Table2.default,
	    Line: _Line2.default
	  }
	});

	module.exports = ditto;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ReportElement = exports.LengthUnits = exports.PropTypes = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PropTypes = exports.PropTypes = {
	    number: 'NUMBER',
	    object: 'OBJECT',
	    string: 'STRING',
	    array: 'ARRAY',
	    boolean: 'BOOL',
	    color: 'COLOR',
	    font: 'FONT',
	    oneOf: function oneOf(list) {
	        return { type: 'oneOf', values: list };
	    }
	};

	var LengthUnits = exports.LengthUnits = {
	    INCHES: 'INCHES',
	    MM: 'MM'
	};

	var validators = {
	    number: function number(v) {
	        return typeof v === 'number';
	    },
	    object: function object(v) {
	        return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object';
	    },
	    string: function string(v) {
	        return typeof v === 'string';
	    },
	    array: function array(v) {
	        return Array.isArray(v);
	    },
	    boolean: function boolean(v) {
	        return typeof v === 'boolean';
	    },
	    color: function color(v) {
	        return true;
	    } /* TODO */
	    , oneOf: function oneOf(v, t) {
	        return t.values.indexOf(v) >= 0;
	    }
	};

	/**
	 * Defines a type of element (e.g. chart, box, text) that can be added to a report.
	 * Extend this class to define your own element types.  See the Line class for an
	 * example.
	 */

	var ReportElement = exports.ReportElement = function () {
	    function ReportElement(props) {
	        _classCallCheck(this, ReportElement);

	        props = JSON.parse(JSON.stringify(_underscore2.default.extend({}, this.constructor.defaultProps, props)));
	        this.validateProps(props);
	        this.props = props;
	    }

	    _createClass(ReportElement, [{
	        key: 'validateProp',
	        value: function validateProp(propKey, value) {
	            var expectedType = this.constructor.propTypes[propKey];
	            if (!expectedType) return true;
	            /** Always allow calculated values regardless of final type */
	            if (typeof value === 'string' && value.indexOf('=') === 0) return true;
	            // Coerce numeric strings to numbers
	            if (typeof value !== 'number' && expectedType === PropTypes.number) {
	                var numeric = Number(value);
	                if (!isNaN(numeric)) {
	                    value = numeric;
	                    // Otherwise, leave as string to hit type check below
	                }
	            }
	            var typeKey = Object.keys(PropTypes).find(function (key) {
	                return PropTypes[key] === expectedType || expectedType.type === key;
	            });
	            if (validators[typeKey](value, expectedType)) return true;
	            var expectedTypeDesc = typeKey === 'oneOf' ? 'one of: ' + JSON.stringify(expectedType.values) : typeKey;
	            console.warn('Invalid value for ' + this.constructor.name + ' element property "' + propKey + '": ' + ('expected ' + expectedTypeDesc + '; got ' + JSON.stringify(value) + ' instead'));
	            return false;
	        }
	    }, {
	        key: 'validateProps',
	        value: function validateProps(props) {
	            var _this = this;

	            Object.keys(props).forEach(function (propKey) {
	                if (!_this.validateProp(propKey, props[propKey])) {
	                    props[propKey] = _this.constructor.defaultProps[propKey];
	                }
	            });
	            return props;
	        }

	        /** These properties should be overridden by subclasses */
	        // Options: 'hierarchical', 'dashboard'

	    }, {
	        key: 'getDesignerHtml',


	        /**
	         * Return the HTML to show inside the designer preview element.
	         * Will be called after any property change.
	         */
	        value: function getDesignerHtml() {
	            return 'Designer not supported';
	        }


	    }, {
	        key: 'getHtml',
	        value: function getHtml() {
	            return 'HTML rendering not supported';
	        }

	        /**
	         * Return a single array of item configs for a single row of
	         * toolbar items; array of arrays for multiple rows 
	         */

	    }, {
	        key: 'getToolbarItems',
	        value: function getToolbarItems() {
	            return [];
	        }
	    }, {
	        key: 'saveExtendedProperties',
	        value: function saveExtendedProperties(props) {
	            this.validateProps(props);
	            _underscore2.default.extend(this.props, this.removeClearedProperties(props));
	        }

	        /** 
	         * For number properties, allow entering an empty string to set the property to undefined
	         */

	    }, {
	        key: 'removeClearedProperties',
	        value: function removeClearedProperties(props, propTypes) {
	            if (!propTypes) {
	                propTypes = this.constructor.propTypes;
	            }
	            Object.keys(props).forEach(function (propKey) {
	                var propType = propTypes[propKey];
	                if (props[propKey] === '' && propType === PropTypes.number) {
	                    props[propKey] = undefined;
	                }
	            });
	            return props;
	        }
	    }, {
	        key: 'getDataSource',
	        value: function getDataSource(id) {
	            // Placeholder for function injected at render time by Ditto
	            return console.error('getDataSource() called outside of render context');
	        }
	    }]);

	    return ReportElement;
	}();

	ReportElement.propTypes = {
	    top: PropTypes.number,
	    left: PropTypes.number,
	    width: PropTypes.number,
	    height: PropTypes.number,
	    conditionalRules: PropTypes.array
	};
	ReportElement.defaultProps = {
	    top: 0,
	    left: 0,
	    width: 1,
	    height: 1,
	    conditionalRules: []
	};
	ReportElement.typeId = '';
	ReportElement.cssClass = '';
	ReportElement.displayName = '';
	ReportElement.allowedReportTypes = ['hierarchical'];
	ReportElement.units = LengthUnits.INCHES;
	;

	exports.default = ReportElement;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.

	(function() {

	  // Baseline setup
	  // --------------

	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;

	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;

	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;

	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;

	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};

	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };

	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }

	  // Current version.
	  _.VERSION = '1.8.3';

	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };

	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };

	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };

	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };

	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };

	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };

	  // Collection Functions
	  // --------------------

	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };

	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };

	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }

	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }

	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);

	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);

	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };

	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };

	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };

	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };

	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };

	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };

	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };

	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };

	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };

	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };

	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };

	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };

	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };

	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };

	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };

	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };

	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });

	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });

	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });

	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };

	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };

	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };

	  // Array Functions
	  // ---------------

	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };

	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };

	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };

	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };

	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };

	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };

	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };

	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };

	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };

	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };

	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };

	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };

	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };

	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);

	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };

	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };

	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }

	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);

	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };

	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }

	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;

	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);

	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }

	    return range;
	  };

	  // Function (ahem) Functions
	  // ------------------

	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };

	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };

	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };

	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };

	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };

	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };

	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);

	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };

	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;

	    var later = function() {
	      var last = _.now() - timestamp;

	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };

	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }

	      return result;
	    };
	  };

	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };

	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };

	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };

	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };

	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };

	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);

	  // Object Functions
	  // ----------------

	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }

	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };

	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };

	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };

	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };

	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };

	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };

	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };

	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);

	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);

	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };

	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };

	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };

	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);

	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };

	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };

	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };

	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };


	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }

	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;

	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }

	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);

	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };

	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };

	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };

	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };

	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };

	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };

	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });

	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }

	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }

	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };

	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };

	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };

	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };

	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };

	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };

	  // Utility Functions
	  // -----------------

	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };

	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };

	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };

	  _.noop = function(){};

	  _.property = property;

	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };

	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };

	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };

	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };

	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };

	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);

	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);

	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };

	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };

	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };

	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;

	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };

	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);

	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');

	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;

	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }

	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";

	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';

	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }

	    var template = function(data) {
	      return render.call(this, data, _);
	    };

	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';

	    return template;
	  };

	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };

	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.

	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };

	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };

	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);

	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });

	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });

	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };

	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };

	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CompositeElement = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _ReportElement2 = __webpack_require__(2);

	var _ElementUtils = __webpack_require__(5);

	var _ElementUtils2 = _interopRequireDefault(_ElementUtils);

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * A pre-defined element made up out of built-in Ditto elements.
	 * To define a new CompositeElement, extend CompositeElement and implement
	 * propTypes and getDefinition.  See the Checkbox implementation for an
	 * example.
	 */
	var CompositeElement = exports.CompositeElement = function (_ReportElement) {
	    _inherits(CompositeElement, _ReportElement);

	    function CompositeElement() {
	        _classCallCheck(this, CompositeElement);

	        return _possibleConstructorReturn(this, Object.getPrototypeOf(CompositeElement).apply(this, arguments));
	    }

	    _createClass(CompositeElement, [{
	        key: 'getHtml',
	        value: function getHtml() {
	            return 'HTML rendering not supported';
	        }

	        /**
	         * Generate the element definition objects that will be used to
	         * render the element.  This should be an array of plain JavaScript
	         * objects defining elements, and will be serialized to JSON as part
	         * of the report definition.
	         * Element positions should be relative to this element - that is,
	         * a position of (0, 0) means the top-left corner of this element.
	         * Units are in absolute report units, i.e. inches or mm.
	         */

	    }, {
	        key: 'getChildElementDefinitions',
	        value: function getChildElementDefinitions() {
	            return [];
	        }

	        /**
	         * Returns an array of toolbar items to show in the designer
	         * toolbar when the element is selected.
	         */

	    }, {
	        key: 'getToolbarItems',
	        value: function getToolbarItems() {
	            return [];
	        }
	    }]);

	    return CompositeElement;
	}(_ReportElement2.ReportElement);

	CompositeElement.isComposite = true;
	;

	exports.default = CompositeElement;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var ElementUtils = {

	  commonDef: {
	    left: 0,
	    top: 0,
	    width: 1,
	    height: 1,
	    visible: true
	  },

	  builtInDefs: {
	    text: {
	      type: "text",
	      text: "Text",
	      fit_content: "vertical"
	    },
	    box: {
	      type: 'box'
	    },
	    image: {
	      type: 'image',
	      url: ''
	    },
	    subreport: {
	      type: 'subreport'
	    },
	    chart_line: {
	      type: 'chart_line',
	      series: [{
	        value_field: null
	      }],
	      x_axis: {
	        label_field: null
	      }
	    },
	    chart_pie: {
	      type: 'chart_pie'
	    },
	    chart_bar: {
	      type: 'chart_bar',
	      series: [{
	        value_field: null
	      }],
	      x_axis: {
	        label_field: null
	      }
	    },
	    break: {},
	    barcode: {}
	  },

	  getDefaultDef: function getDefaultDef(typeName) {
	    return _underscore2.default.extend({}, ElementUtils.commonDef, ElementUtils.builtInDefs[typeName]);
	  }
	};

	exports.default = ElementUtils;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _ReportElement = __webpack_require__(2);

	var _CompositeElement2 = __webpack_require__(4);

	var _CompositeElement3 = _interopRequireDefault(_CompositeElement2);

	var _ElementUtils = __webpack_require__(5);

	var _ElementUtils2 = _interopRequireDefault(_ElementUtils);

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _base = __webpack_require__(7);

	var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var checkedImageUrl = 'data:image/png;base64,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';

	var uncheckedImageUrl = 'data:image/png;base64,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';

	/**
	 * Checkbox element.  Demonstrates how to use CompositeElement to render an element
	 * made up out of one or more built-in Ditto elements, with its own properties that
	 * determine the child element rendering.
	 * 
	 * This element just provides one property, "checked," and chooses one of two images
	 * to display based on whether that property is true or false.
	 */

	var Checkbox = function (_CompositeElement) {
	    _inherits(Checkbox, _CompositeElement);

	    function Checkbox() {
	        _classCallCheck(this, Checkbox);

	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Checkbox).apply(this, arguments));
	    }

	    _createClass(Checkbox, [{
	        key: 'getChildElementDefinitions',


	        /**
	         * Returns an array of child element definitions, generated based on the composite
	         * element's properties.  The resulting element definitions are used to render the
	         * element both in the designer and at runtime.
	         */
	        value: function getChildElementDefinitions() {
	            /** 
	             * Start with a regular Image element, then override the url property
	             * with the correct image data URL based on whether the element is checked.
	             * Here is where you should modify the child elements based on the current
	             * property values of the parent composite element.
	             */
	            var lesserDimension = Math.min(this.props.width, this.props.height);
	            var checkboxImage = _underscore2.default.extend(_ElementUtils2.default.getDefaultDef('image'), {
	                url: this.props.checked ? checkedImageUrl : uncheckedImageUrl,
	                width: lesserDimension,
	                height: lesserDimension
	            });
	            /** Return an array of elements to render */
	            return [checkboxImage];
	        }


	    }, {
	        key: 'getToolbarItems',


	        /** 
	         * Define the selectors that appear in the designer toolbar when an element
	         * of this type is selected.  For the Checkbox, we have only one selector: a drop-down
	         * with true/false.  The dropdown must allow free text input to allow for calculated
	         * expressions, for example: =rowIsChecked
	         */
	        value: function getToolbarItems(currentSchema, context) {
	            return [{
	                type: 'dropdown',
	                label: 'Checked',
	                options: Checkbox.getCheckedOptions(currentSchema),
	                allowTextInput: true,
	                boundProperty: 'checked',
	                /** 
	                 * Whenever a value is chosen in the selector, normalizeValue will be called
	                 * to convert the value into the correct type for the property.  String values
	                 * beginning with an equals sign (=) (i.e., calculated property expressions)
	                 * do not pass through normalizeValue and are stored directly as strings.
	                 */
	                normalizeValue: function normalizeValue(val) {
	                    return val === 'true';
	                }
	            }];
	        }
	    }], [{
	        key: 'getCheckedOptions',
	        value: function getCheckedOptions(schema) {
	            var options = ['true', 'false'];
	            if (schema) {
	                options = [].concat(_toConsumableArray(options), _toConsumableArray(schema.fields.map(function (field) {
	                    return '=' + field.name.replace(/\W+/g, '_');
	                })));
	            }
	            return options;
	        }
	    }]);

	    return Checkbox;
	}(_CompositeElement3.default);

	Checkbox.propTypes = {
	    checked: _ReportElement.PropTypes.boolean
	};
	Checkbox.defaultProps = {
	    checked: true
	};
	Checkbox.typeId = 'checkbox';
	Checkbox.displayName = 'Checkbox';
	Checkbox.cssClass = 'jsr-checkbox';
	Checkbox.iconSrc = checkedImageUrl;
	exports.default = Checkbox;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
	;(function(root) {

		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;

		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;

		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}

		/*--------------------------------------------------------------------------*/

		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';

		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};

		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};

		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var d;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;

			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}

			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}

			return output;
		};

		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '0.1.0'
		};

		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}

	}(this));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)(module), (function() { return this; }())))

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var collectFieldNamesFromSchema = function collectFieldNamesFromSchema(schema) {
	  var fieldNames = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	  var prefix = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];

	  var fields = schema ? schema.fields : [];
	  fields.forEach(function (field) {
	    var safeFieldName = field.name.replace(/\W+/g, '_');
	    fieldNames.push('[' + prefix + safeFieldName + ']');
	    if (field.schema) {
	      collectFieldNamesFromSchema(field.schema, fieldNames, '' + prefix + safeFieldName + '.');
	    }
	  });
	  return fieldNames;
	};

	var Text = {
	  getTextSuggestions: function getTextSuggestions(schema) {
	    return collectFieldNamesFromSchema(schema);
	  }
	};

	exports.default = Text;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _ReportElement = __webpack_require__(2);

	var _CompositeElement2 = __webpack_require__(4);

	var _CompositeElement3 = _interopRequireDefault(_CompositeElement2);

	var _ElementUtils = __webpack_require__(5);

	var _ElementUtils2 = _interopRequireDefault(_ElementUtils);

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	/**
	 * Line element
	 */
	var Line = function (_CompositeElement) {
	    _inherits(Line, _CompositeElement);

	    function Line() {
	        _classCallCheck(this, Line);

	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Line).apply(this, arguments));
	    }

	    _createClass(Line, [{
	        key: 'getChildElementDefinitions',
	        value: function getChildElementDefinitions() {
	            var _this2 = this;

	            var horiz = this.props.direction === 'horizontal';
	            var ptsPerInch = 72;
	            var thicknessInches = this.props.thickness / ptsPerInch;
	            var box = _underscore2.default.extend(_ElementUtils2.default.getDefaultDef('box'), {
	                width: horiz ? this.props.width : thicknessInches,
	                height: horiz ? thicknessInches : this.props.height,
	                left: 0,
	                top: 0,
	                background_color: this.props.color,
	                border_color: 'transparent',
	                borderThickness: 0
	            });
	            ['zIndex' /*, ...other self props to copy */].forEach(function (ownProp) {
	                if (_this2.props.hasOwnProperty(ownProp)) {
	                    box[ownProp] = _this2.props[ownProp];
	                }
	            });
	            return [box];
	        }
	    }, {
	        key: 'getToolbarItems',
	        value: function getToolbarItems() {
	            return [{
	                type: 'dropdown',
	                label: 'Thickness',
	                options: ['0.25', '0.5', '1', '2', '4'],
	                allowTextInput: true,
	                boundProperty: 'thickness',
	                normalizeValue: function normalizeValue(val) {
	                    return Number(val);
	                }
	            }, {
	                type: 'color',
	                label: 'Color',
	                boundProperty: 'color'
	            }, {
	                type: 'dropdown',
	                label: 'Direction',
	                options: ['Horizontal', 'Vertical'],
	                boundProperty: 'direction',
	                normalizeValue: function normalizeValue(val) {
	                    return val.toLowerCase();
	                }
	            }];
	        }
	    }]);

	    return Line;
	}(_CompositeElement3.default);

	Line.propTypes = {
	    thickness: _ReportElement.PropTypes.number,
	    direction: _ReportElement.PropTypes.oneOf(['vertical', 'horizontal']),
	    color: _ReportElement.PropTypes.color
	};
	Line.defaultProps = {
	    thickness: 1,
	    direction: 'horizontal',
	    color: 'black'
	};
	Line.typeId = 'line';
	Line.displayName = 'Line';
	Line.cssClass = 'jsr-line';
	Line.iconSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoAQMAAAC2MCouAAAABlBMVEUAAAAAAAClZ7nPAAAAAXRSTlMAQObYZgAAABpJREFUCNdjoA/4AcTyDP3/////iExCxekIAIa4D6Y30X5tAAAAAElFTkSuQmCC';
	exports.default = Line;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _ReportElement2 = __webpack_require__(2);

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _dittoBase = __webpack_require__(12);

	var _dittoBase2 = _interopRequireDefault(_dittoBase);

	var _Popup = __webpack_require__(22);

	var _Popup2 = _interopRequireDefault(_Popup);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var $ = __webpack_require__(13);
	__webpack_require__(24)($);


	var t = _dittoBase2.default.translate;

	var newColumn = function newColumn(width, header, detail, footer) {
	    return {
	        width: width,
	        header: header,
	        footer: footer,
	        detail: detail
	    };
	};

	var newCell = function newCell(text) {
	    var cell = {
	        text: text,
	        textColor: '',
	        backgroundColor: '',
	        bold: false,
	        italic: false,
	        align: '',
	        wrap: undefined
	    };
	    ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	        cell['border' + side + 'Width'] = 0;
	        cell['border' + side + 'Color'] = '';
	    });
	    return cell;
	};

	var Table = function (_ReportElement) {
	    _inherits(Table, _ReportElement);

	    function Table() {
	        _classCallCheck(this, Table);

	        return _possibleConstructorReturn(this, Object.getPrototypeOf(Table).apply(this, arguments));
	    }

	    _createClass(Table, [{
	        key: 'getDesignerHtml',
	        value: function getDesignerHtml() {
	            var cols = this.props.columns;
	            var rows = [];
	            if (this.props.hasHeader) {
	                rows.push(cols.map(function (c, i) {
	                    return {
	                        cell: c.header || '',
	                        colIx: i,
	                        rowId: 'header',
	                        cellTag: 'th'
	                    };
	                }));
	            }
	            if (this.props.groupBy) {}
	            rows.push(cols.map(function (c, i) {
	                return {
	                    cell: c.detail || '',
	                    colIx: i,
	                    rowId: 'detail'
	                };
	            }));
	            if (this.props.groupBy) {}
	            if (this.props.hasFooter) {
	                rows.push(cols.map(function (c, i) {
	                    return {
	                        cell: c.footer || '',
	                        colIx: i,
	                        rowId: 'footer'
	                    };
	                }));
	            }
	            return this.getTableHtml(rows);
	        }
	    }, {
	        key: 'escapeHtml',
	        value: function escapeHtml(html) {
	            return html.replace(/\</g, '&lt;').replace(/\>/g, '&lt;').replace(/\&/g, '&amp;');
	        }
	    }, {
	        key: 'getHtml',
	        value: function getHtml() {}


	        /** @private */

	    }, {
	        key: 'getTableHtml',
	        value: function getTableHtml(rows) {
	            var _this2 = this;

	            var tableStyles = [];
	            ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	                var borderWidth = _this2.props['border' + side + 'Width'];
	                var borderColor = _this2.props['border' + side + 'Color'];
	                if (borderWidth) {
	                    tableStyles.push('border-' + side.toLowerCase() + '-width:' + borderWidth + 'pt');
	                }
	                if (borderColor) {
	                    tableStyles.push('border-' + side.toLowerCase() + '-color:' + borderColor);
	                }
	            });
	            return ['<div class="jsr-table-wrap">', '<table class="' + Table.cssClass + '" style="' + tableStyles.join(';') + '">'].concat(_toConsumableArray(rows.map(function (row) {
	                return ['<tr data-jsr-row-id="' + row.rowId + '">'].concat(_toConsumableArray(row.map(function (cellInfo, colIx) {
	                    var cell = cellInfo.cell;
	                    var tag = cellInfo.cellTag || 'td';
	                    var text = (typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) === 'object' ? cell.text : cell;
	                    return '<' + tag + ' data-jsr-col-ix="' + cellInfo.colIx + '" data-jsr-row-id="' + cellInfo.rowId + '" style="' + _this2.getCellStyles(cell) + '" width="' + _this2.props.columns[colIx].width + '">' + _this2.escapeHtml(text) + '</' + tag + '>';
	                })), ['</tr>']).join('');
	            })), ['</table>', '</div>']).join('');
	        }

	        /** @private */

	    }, {
	        key: 'getCellStyles',
	        value: function getCellStyles(cell) {
	            var _this3 = this;

	            var styles = [];
	            if (cell.backgroundColor) {
	                styles.push('background-color:' + cell.backgroundColor);
	            }
	            if (cell.textColor) {
	                styles.push('color:' + cell.textColor);
	            }
	            if (cell.bold) {
	                styles.push('font-weight:bold');
	            }
	            if (cell.italic) {
	                styles.push('font-style:italic');
	            }
	            if (cell.underline) {
	                styles.push('text-decoration:underline');
	            }
	            if (cell.align) {
	                styles.push('text-align:' + cell.align);
	            }
	            styles.push('white-space:' + (cell.wrap === false || this.props['cellWrap'] === false ? 'pre' : 'pre-wrap'));
	            ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	                var borderWidth = cell['border' + side + 'Width'] || _this3.props['cellBorder' + side + 'Width'];
	                var borderColor = cell['border' + side + 'Color'] || _this3.props['cellBorder' + side + 'Color'];
	                if (borderWidth) {
	                    styles.push('border-' + side.toLowerCase() + '-width:' + borderWidth + 'pt');
	                }
	                if (borderColor) {
	                    styles.push('border-' + side.toLowerCase() + '-color:' + borderColor);
	                }
	            });
	            return styles.join(';');
	        }
	    }, {
	        key: 'afterDesignerRender',
	        value: function afterDesignerRender(domEl) {
	            this.designerDomEl = domEl;
	            this.renderResizeBars(domEl);
	            var columnTab = $('<div class="jsr-table-column-tab">...</div>');
	            $(domEl).append(columnTab);
	            columnTab.on('click', this.onColumnTabClick.bind(this));
	            $(domEl).find('td, th').on('click', this.onCellClick.bind(this));
	            $(domEl).on('click', this.onElClick.bind(this));
	        }
	    }, {
	        key: 'onColumnTabClick',
	        value: function onColumnTabClick(evt) {
	            var tab = $(evt.target).closest('.jsr-table-column-tab')[0];
	            if (!this.columnPopup) {
	                this.columnPopup = new _Popup2.default({
	                    className: 'jsr-table-column-menu-popup',
	                    target: tab,
	                    placement: 'bottom',
	                    contentHtml: '\n                <div class="jsr-column-menu-item" data-action="insert-left">Insert column to left</div>\n                <div class="jsr-column-menu-item" data-action="insert-right">Insert column to right</div>\n                <div class="jsr-column-menu-item jsr-column-menu-remove" data-action="remove">Remove column</div>\n              '
	                });
	                this.columnPopup.el.addEventListener('click', this.onColumnMenuClick.bind(this));
	            }
	            this.columnPopup.el.querySelector('.jsr-column-menu-remove').style.display = this.props.columns.length > 1 ? 'block' : 'none';
	            this.columnPopup.show(tab);
	            evt.preventDefault();
	            evt.stopPropagation();
	        }
	    }, {
	        key: 'onColumnMenuClick',
	        value: function onColumnMenuClick(evt) {
	            var item = $(evt.target).closest('.jsr-column-menu-item')[0];
	            this.columnPopup.hide();
	            if (!item) return;
	            var action = item.dataset.action;
	            var currentColIx = this.selectedCellColIx;
	            switch (action) {
	                case 'insert-left':
	                    this.insertColumnBefore(this.selectedCellColIx);
	                    currentColIx++;
	                    break;
	                case 'insert-right':
	                    this.insertColumnBefore(this.selectedCellColIx + 1);
	                    break;
	                case 'remove':
	                    this.props.columns.splice(this.selectedCellColIx, 1);
	                    var scaleRatio = (this.props.columns.length + 1) / this.props.columns.length;
	                    this.props.columns.forEach(function (col) {
	                        col.width = parseFloat(col.width) * scaleRatio + '%';
	                    });
	                    break;
	            }
	            // Order is important here - must clear selection before raising propertychange, then restore it
	            this.deselectCells(this.designerDomEl);
	            this.raiseEvent('propertychange');
	            // Re-select to highlight rerendered cell and column tab (has moved)
	            if (action !== 'remove') {
	                this.selectCell(currentColIx, this.selectedCellRowId);
	            }
	        }
	    }, {
	        key: 'insertColumnBefore',
	        value: function insertColumnBefore(ix) {
	            var colCount = this.props.columns.length;
	            var newColWidthPct = 100 / (colCount + 1);
	            // Scale down original columns, keeping relative widths
	            var scaleRatio = colCount / (colCount + 1);
	            this.props.columns.forEach(function (col) {
	                col.width = parseFloat(col.width) * scaleRatio + '%';
	            });
	            this.props.columns.splice(ix, 0, newColumn(newColWidthPct + '%', newCell(''), newCell(''), newCell('')));
	        }
	    }, {
	        key: 'renderResizeBars',
	        value: function renderResizeBars(domEl) {
	            var me = this;
	            var offset = 0;
	            var $domEl = $(domEl);
	            var tableWidth = $domEl.width();
	            var prevBarPos = 0;
	            var prevBar = null;
	            for (var i = 0; i < this.props.columns.length - 1; i++) {
	                offset += parseFloat(this.props.columns[i].width) / 100 * tableWidth;
	                var bar = $('<div class="' + Table.RESIZE_BAR_CLS + '"></div>').css('left', offset - 2 + 'px').data({
	                    'jsr-col-ix': i,
	                    'jsr-bar-pos': offset,
	                    'jsr-left-bar-pos': prevBarPos
	                });
	                if (prevBar) {
	                    prevBar.data('jsr-right-bar-pos', offset);
	                }
	                $domEl.append(bar);
	                bar.drag('start', function (ev, dd) {
	                    dd.containerOffsetX = $domEl.offset().left;
	                    dd.maxX = $domEl.outerWidth() - $(this).outerWidth();
	                    $(this).addClass(Table.RESIZE_BAR_DRAG_CLS);
	                }).drag(function (ev, dd) {
	                    $(this).css({ left: Math.min(dd.maxX, Math.max(dd.offsetX - dd.containerOffsetX, 0)) });
	                }).drag('end', function (ev, dd) {
	                    $(this).removeClass(Table.RESIZE_BAR_DRAG_CLS);
	                    var leftBarPos = $(this).data('jsr-left-bar-pos') || 0;
	                    var rightBarPos = $(this).data('jsr-right-bar-pos') || tableWidth;
	                    var pos = Math.max(leftBarPos + 10, Math.min(rightBarPos - 10, dd.offsetX - dd.containerOffsetX));
	                    var colIx = $(this).data('jsr-col-ix');
	                    var leftPctChg = (pos - $(this).data('jsr-bar-pos')) / tableWidth * 100;
	                    var leftCol = me.props.columns[colIx];
	                    var rightCol = me.props.columns[colIx + 1];
	                    leftCol.width = (parseFloat(leftCol.width) + leftPctChg).toFixed(2) + '%';
	                    rightCol.width = (parseFloat(rightCol.width) - leftPctChg).toFixed(2) + '%';
	                    me.raiseEvent('propertychange');
	                    me.selectCell(me.selectedCellColIx, me.selectedCellRowId);
	                });
	                prevBarPos = offset;
	                prevBar = bar;
	            }
	        }

	        /** @private */

	    }, {
	        key: 'deselectCells',
	        value: function deselectCells(domEl) {
	            if (this.columnPopup) {
	                this.columnPopup.hide();
	            }
	            this.selectedCellColIx = null;
	            this.selectedCellRowId = null;
	            var wrapEl = $(domEl).closest('.preview-element')[0].querySelector('.jsr-table-wrap');
	            this.setColumnTabVisible(false);
	            $(domEl).find('.' + Table.selectedCellClass).removeClass(Table.selectedCellClass);
	        }
	    }, {
	        key: 'onDesignerSelect',
	        value: function onDesignerSelect(domEl) {
	            this.deselectCells(domEl);
	            this.isSelected = true;
	        }
	    }, {
	        key: 'onDesignerDeselect',
	        value: function onDesignerDeselect(domEl) {
	            this.deselectCells(domEl);
	            this.isSelected = false;
	        }
	    }, {
	        key: 'onCellClick',
	        value: function onCellClick(evt) {
	            if (!this.isSelected) return;
	            var $td = $(evt.target).closest('td, th');
	            var $tbl = $td.closest('table');
	            var wrapEl = $tbl.closest('.jsr-table-wrap')[0];
	            var prevColIx = this.selectedCellColIx;
	            var prevRowId = this.selectedCellRowId;
	            var newColIx = $td.data('jsr-col-ix');
	            var newRowId = $td.data('jsr-row-id');
	            this.deselectCells($tbl[0]);
	            // Re-clicking same cell switches back to table-selection
	            if (newColIx !== prevColIx || newRowId !== prevRowId) {
	                this.selectCell(newColIx, newRowId);
	            }
	            this.raiseEvent('toolbarchange');
	        }
	    }, {
	        key: 'selectCell',
	        value: function selectCell(colIx, rowId) {
	            var $cell = $(this.designerDomEl).find('td[data-jsr-row-id=' + rowId + '][data-jsr-col-ix=' + colIx + '], th[data-jsr-row-id=' + rowId + '][data-jsr-col-ix=' + colIx + ']');
	            this.selectedCellColIx = colIx;
	            this.selectedCellRowId = rowId;
	            $cell.addClass(Table.selectedCellClass);
	            this.setColumnTabVisible(true, colIx);
	        }

	        /**
	         * @private
	         * Show a tab above the given (zero-indexed) column that can be clicked to show a menu
	         */

	    }, {
	        key: 'setColumnTabVisible',
	        value: function setColumnTabVisible(visible, colIx) {
	            var tableDomEl = this.designerDomEl.querySelector('.jsr-table-wrap table');
	            var tab = this.designerDomEl.querySelector('.jsr-table-column-tab');
	            if (!visible) {
	                $(this.designerDomEl).removeClass('jsr-column-tab-visible');
	                return;
	            }
	            var left = 0;
	            var tableWidth = tableDomEl.getBoundingClientRect().width;
	            for (var i = 0; i < colIx; i++) {
	                left += parseFloat(this.props.columns[i].width) / 100 * tableWidth;
	            }
	            tab.style.left = left + 'px';
	            tab.style.width = parseFloat(this.props.columns[colIx].width) / 100 * tableWidth + 'px';
	            $(this.designerDomEl).addClass('jsr-column-tab-visible');
	        }

	        /** 
	        * Handle click on element outside of table (should deselect any cell)
	        * @private 
	        */

	    }, {
	        key: 'onElClick',
	        value: function onElClick(evt) {
	            if (!this.isSelected) return;
	            if ($(evt.target).closest('td, th').length > 0) return;
	            this.deselectCells($(evt.target)[0]);
	            this.raiseEvent('toolbarchange');
	        }
	    }, {
	        key: 'getToolbarItems',
	        value: function getToolbarItems(schema, context) {
	            return this.selectedCellRowId ? this.getCellToolbar(schema, context) : this.getTableToolbar(context);
	        }

	        /** @private */

	    }, {
	        key: 'getTableToolbar',
	        value: function getTableToolbar(context) {
	            var _this4 = this;

	            return [{
	                type: 'dropdown',
	                label: t('TABLE_DATA_SOURCE'),
	                options: context.dataSources.map(function (ds) {
	                    return {
	                        id: ds.id,
	                        text: ds.id === '__parentgroup' ? '(Current group)' : ds.name
	                    };
	                }),
	                boundProperty: 'dataSource'
	            }, {
	                type: 'checkbox',
	                label: t('TABLE_HAS_HEADER'),
	                boundProperty: 'hasHeader'
	            }, {
	                type: 'checkbox',
	                label: t('TABLE_HAS_FOOTER'),
	                boundProperty: 'hasFooter'
	            }, {
	                type: 'dropdown',
	                label: t('TABLE_COLUMNS'),
	                options: ['1', '2', '3', '4', '5', '6'],
	                allowTextInput: true,
	                value: String(this.props.columns.length),
	                onChange: function onChange(val) {
	                    var newCount = parseInt(val, 10);
	                    if (isNaN(newCount)) return;
	                    var origColCount = _this4.props.columns.length;
	                    var diff = newCount - origColCount;
	                    if (diff === 0) return;
	                    if (diff > 0) {
	                        (function () {
	                            // Adding cols
	                            var newColWidthPct = 100 / newCount;
	                            // Scale down original columns, keeping relative widths
	                            var scaleRatio = origColCount / newCount;
	                            _this4.props.columns.forEach(function (col) {
	                                col.width = parseFloat(col.width) * scaleRatio + '%';
	                            });
	                            for (var i = 0; i < diff; i++) {
	                                var ix = origColCount + i + 1;
	                                _this4.props.columns.push(newColumn(newColWidthPct + '%', newCell('Header ' + ix), newCell('Detail ' + ix), newCell('Footer ' + ix)));
	                            }
	                        })();
	                    } else {
	                        // Removing cols
	                        if (confirm('This will remove the rightmost ' + -diff + ' columns from the table.  Are you sure you want to continue?')) {
	                            // Scale up original columns, keeping relative widths
	                            for (var i = 0; i < origColCount; i++) {
	                                var col = _this4.props.columns[i];
	                                col.width = parseFloat(col.width) * (origColCount / newCount) + '%';
	                            }
	                            _this4.props.columns.splice(newCount, -diff);
	                        } else {
	                            // User cancelled; abort the change
	                            return false;
	                        }
	                    }
	                }
	            }];
	        }

	        /** @private */

	    }, {
	        key: 'getCellToolbar',
	        value: function getCellToolbar(schema, context) {
	            var _this5 = this;

	            var cell = this.getSelectedCell();
	            if (this.props.dataSource !== '__parentgroup') {
	                var ds = context.dataSources.find(function (ds) {
	                    return ds.id.toLowerCase() === _this5.props.dataSource.toLowerCase();
	                });
	                if (ds) {
	                    schema = ds.schema;
	                }
	            }
	            var suggestions = schema ? schema.fields.map(function (f) {
	                return '[' + f.name.replace(/\W+/g, '_') + ']';
	            }) : [];
	            var items = [{
	                type: 'text',
	                label: t('TABLE_CELL_TEXT'),
	                suggestions: suggestions,
	                value: cell && (typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) === 'object' ? cell.text : cell,
	                onChange: function onChange(val) {
	                    _this5.setSelectedCellText(val);
	                }
	            }];
	            if ((typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) === 'object') {
	                items.push({
	                    type: 'conditionalRules',
	                    value: cell.conditionalRules,
	                    onChange: function onChange(rules) {
	                        cell.conditionalRules = rules;
	                    }
	                });
	            }
	            return items;
	        }

	        /** @private */

	    }, {
	        key: 'getSelectedCell',
	        value: function getSelectedCell() {
	            if (!this.selectedCellRowId) return null;
	            var col = this.props.columns[this.selectedCellColIx];
	            return col[this.selectedCellRowId];
	        }
	    }, {
	        key: 'setSelectedCellText',
	        value: function setSelectedCellText(text) {
	            var cell = this.getSelectedCell();
	            if ((typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) === 'object') {
	                cell.text = text;
	            } else {
	                var col = this.props.columns[this.selectedCellColIx];
	                col[this.selectedCellRowId] = text;
	            }
	        }
	    }, {
	        key: 'getExtendedProperties',
	        value: function getExtendedProperties(context) {
	            return this.selectedCellRowId ? this.getExtendedCellProperties(context) : this.getExtendedTableProperties(context);
	        }

	        /** @private */

	    }, {
	        key: 'getExtendedTableProperties',
	        value: function getExtendedTableProperties(context) {
	            var props = {};
	            ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	                var sideLower = side.toLowerCase();
	                props['border' + side + 'Width'] = {
	                    group: 'Appearance',
	                    name: 'Table ' + sideLower + ' border thickness',
	                    type: 'number'
	                };
	                props['border' + side + 'Color'] = {
	                    group: 'Appearance',
	                    name: 'Table ' + sideLower + ' border color',
	                    type: 'color'
	                };
	                props['cellBorder' + side + 'Width'] = {
	                    group: 'Cell Defaults',
	                    name: 'Cell ' + sideLower + ' border thickness',
	                    type: 'number'
	                };
	                props['cellBorder' + side + 'Color'] = {
	                    group: 'Cell Defaults',
	                    name: 'Cell ' + sideLower + ' border color',
	                    type: 'color'
	                };
	                props['cellPadding' + side] = {
	                    group: 'Cell Defaults',
	                    name: 'Cell ' + sideLower + ' padding',
	                    type: 'number'
	                };
	            });
	            props['cellWrap'] = {
	                group: 'Cell Defaults',
	                name: 'Cell wrap',
	                type: 'boolean'
	            };
	            props['sortBy'] = {
	                group: 'Data',
	                name: 'Sort rows by',
	                type: 'string'
	            };
	            return props;
	        }

	        /** @private */

	    }, {
	        key: 'getExtendedCellProperties',
	        value: function getExtendedCellProperties(context) {
	            var props = {
	                'align': {
	                    group: 'Appearance',
	                    name: 'Align (horizontal)',
	                    type: 'string',
	                    options: ['left', 'center', 'right']
	                },
	                'text': {
	                    group: 'Content',
	                    name: 'Text',
	                    type: 'string'
	                },
	                'textColor': {
	                    group: 'Appearance',
	                    name: 'Text color',
	                    type: 'color'
	                },
	                'backgroundColor': {
	                    group: 'Appearance',
	                    name: 'Background color',
	                    type: 'color'
	                },
	                'bold': {
	                    group: 'Appearance',
	                    name: 'Bold',
	                    type: 'boolean'
	                },
	                'italic': {
	                    group: 'Appearance',
	                    name: 'Italic',
	                    type: 'boolean'
	                },
	                'wrap': {
	                    group: 'Appearance',
	                    name: 'Wrap',
	                    type: 'string',
	                    options: ['inherit', 'true', 'false']
	                }
	            };
	            ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	                props['border' + side + 'Width'] = {
	                    group: 'Appearance',
	                    name: side + ' border thickness',
	                    type: 'number'
	                };
	                props['border' + side + 'Color'] = {
	                    group: 'Appearance',
	                    name: side + ' border color',
	                    type: 'color'
	                };
	                props['padding' + side] = {
	                    group: 'Appearance',
	                    name: side + ' padding',
	                    type: 'number'
	                };
	            });
	            return props;
	        }
	    }, {
	        key: 'getExtendedPropertyValues',
	        value: function getExtendedPropertyValues() {
	            return this.selectedCellRowId ? this.getExtendedCellPropertyValues() : this.getExtendedTablePropertyValues();
	        }

	        /** @private */

	    }, {
	        key: 'getExtendedTablePropertyValues',
	        value: function getExtendedTablePropertyValues() {
	            var _this6 = this;

	            var props = {};
	            var propNames = ['left', 'top', 'width', 'height', 'cellWrap'];
	            ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	                propNames.push('border' + side + 'Width');
	                propNames.push('border' + side + 'Color');
	                propNames.push('cellBorder' + side + 'Width');
	                propNames.push('cellBorder' + side + 'Color');
	                propNames.push('cellPadding' + side);
	            });
	            propNames.forEach(function (prop) {
	                props[prop] = _this6.props[prop];
	            });
	            props['sortBy'] = this.props.sortBy ? this.props.sortBy.join(', ') : '';
	            return props;
	        }

	        /** @private */

	    }, {
	        key: 'getExtendedCellPropertyValues',
	        value: function getExtendedCellPropertyValues() {
	            var cell = {};
	            Object.keys(this.getExtendedCellProperties()).map(function (propName) {
	                cell[propName] = undefined;
	            });
	            cell = _extends({}, cell, this.getSelectedCell());
	            if (cell.wrap === undefined) {
	                cell.wrap = 'inherit';
	            } else {
	                cell.wrap = cell.wrap ? 'true' : 'false';
	            }
	            return cell;
	        }
	    }, {
	        key: 'saveExtendedProperties',
	        value: function saveExtendedProperties(props) {
	            return this.selectedCellRowId ? this.saveCellProps(props) : this.saveTableProps(props);
	        }

	        /** @private */

	    }, {
	        key: 'saveCellProps',
	        value: function saveCellProps(props) {
	            if (props.wrap) {
	                if (props.wrap === 'inherit') {
	                    props.wrap = undefined;
	                } else {
	                    props.wrap = props.wrap === 'true';
	                }
	            }
	            this.removeClearedProperties(props, {
	                cellPaddingTop: _ReportElement2.PropTypes.number,
	                cellPaddingLeft: _ReportElement2.PropTypes.number,
	                cellPaddingBottom: _ReportElement2.PropTypes.number,
	                cellPaddingRight: _ReportElement2.PropTypes.number
	            });
	            var cell = this.getSelectedCell();
	            _underscore2.default.extend(cell, props);
	        }

	        /** @private */

	    }, {
	        key: 'saveTableProps',
	        value: function saveTableProps(props) {
	            props.sortBy = (props.sortBy || '').split(',').map(function (p) {
	                return p.trim();
	            }).filter(function (p) {
	                return p !== '';
	            });
	            this.validateProps(props);
	            this.removeClearedProperties(props);
	            _underscore2.default.extend(this.props, props);
	        }
	    }]);

	    return Table;
	}(_ReportElement2.ReportElement);

	Table.propTypes = {
	    dataSource: _ReportElement2.PropTypes.string,
	    hasHeader: _ReportElement2.PropTypes.boolean,
	    hasFooter: _ReportElement2.PropTypes.boolean,
	    columns: _ReportElement2.PropTypes.array,
	    cellBorderTopWidth: _ReportElement2.PropTypes.number,
	    cellBorderTopColor: _ReportElement2.PropTypes.string,
	    cellBorderLeftWidth: _ReportElement2.PropTypes.number,
	    cellBorderLeftColor: _ReportElement2.PropTypes.string,
	    cellBorderBottomWidth: _ReportElement2.PropTypes.number,
	    cellBorderBottomColor: _ReportElement2.PropTypes.string,
	    cellBorderRightWidth: _ReportElement2.PropTypes.number,
	    cellBorderRightColor: _ReportElement2.PropTypes.string,
	    borderTopWidth: _ReportElement2.PropTypes.number,
	    borderTopColor: _ReportElement2.PropTypes.string,
	    borderLeftWidth: _ReportElement2.PropTypes.number,
	    borderLeftColor: _ReportElement2.PropTypes.string,
	    borderBottomWidth: _ReportElement2.PropTypes.number,
	    borderBottomColor: _ReportElement2.PropTypes.string,
	    borderRightWidth: _ReportElement2.PropTypes.number,
	    borderRightColor: _ReportElement2.PropTypes.string,
	    cellPaddingTop: _ReportElement2.PropTypes.number,
	    cellPaddingLeft: _ReportElement2.PropTypes.number,
	    cellPaddingRight: _ReportElement2.PropTypes.number,
	    cellPaddingBottom: _ReportElement2.PropTypes.number,
	    cellWrap: _ReportElement2.PropTypes.boolean,
	    sortBy: _ReportElement2.PropTypes.array
	};
	Table.defaultProps = {
	    width: 3,
	    height: 1,
	    dataSource: '__parentgroup',
	    hasHeader: true,
	    hasFooter: false,
	    // 3 dummy columns to start
	    columns: [1, 2, 3].map(function (ix) {
	        return newColumn('33%', newCell(ix === 1 ? 'Header Row' : ''), newCell(ix === 1 ? 'Detail Row' : ''), newCell(ix === 1 ? 'Footer Row' : ''));
	    }),
	    cellBorderTopWidth: 0,
	    cellBorderTopColor: '',
	    cellBorderLeftWidth: 0,
	    cellBorderLeftColor: '',
	    cellBorderBottomWidth: 0,
	    cellBorderBottomColor: '',
	    cellBorderRightWidth: 0,
	    cellBorderRightColor: '',
	    cellPaddingTop: undefined,
	    cellPaddingLeft: undefined,
	    cellPaddingRight: undefined,
	    cellPaddingBottom: undefined,
	    borderTopWidth: 0,
	    borderTopColor: '',
	    borderLeftWidth: 0,
	    borderLeftColor: '',
	    borderBottomWidth: 0,
	    borderBottomColor: '',
	    borderRightWidth: 0,
	    borderRightColor: '',
	    cellWrap: true,
	    sortBy: []
	};
	Table.typeId = 'table';
	Table.displayName = 'Table';
	Table.cssClass = 'jsr-table';
	Table.selectedCellClass = 'jsr-table-cell-selected';
	Table.iconSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAAAAAClZ7nPAAAAAXRSTlMAQObYZgAAABpJREFUGNNjIBf8B4EP2KkP/CCEQg1KDWQCAAladplDnw68AAAAAElFTkSuQmCC';
	Table.RESIZE_BAR_CLS = 'jsr-table-column-resize-bar';
	Table.RESIZE_BAR_DRAG_CLS = 'jsr-table-column-resize-bar-dragging';
	exports.default = Table;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, $) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _fonts = __webpack_require__(14);

	var _fonts2 = _interopRequireDefault(_fonts);

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _EN_US = __webpack_require__(15);

	var _EN_US2 = _interopRequireDefault(_EN_US);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var merge = __webpack_require__(16);


	if (typeof Object.assign != 'function') {
	    Object.assign = function (target) {
	        'use strict';

	        if (target == null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }

	        target = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source != null) {
	                for (var key in source) {
	                    if (Object.prototype.hasOwnProperty.call(source, key)) {
	                        target[key] = source[key];
	                    }
	                }
	            }
	        }
	        return target;
	    };
	}

	var ditto = {
	    version: '1.4.122',
	    ToolbarItemPosition: { RIGHT: "right", LEFT: "left" },
	    merge: merge,
	    locales: {
	        EN_US: _EN_US2.default
	    }
	};
	ditto.locale = ditto.locales.EN_US;

	ditto.version_less_than = function (versionA, versionB) {
	    var aParts = (versionA || "0.0.0").split('.').map(function (part) {
	        return parseInt(part, 10);
	    }),
	        bParts = versionB.split('.').map(function (part) {
	        return parseInt(part, 10);
	    });
	    for (var i = 0; i < aParts.length - 1; i++) {
	        if (aParts[i] < bParts[i]) {
	            return true;
	        } else if (aParts[i] > bParts[i]) {
	            return false;
	        }
	    }
	    return aParts[aParts.length - 1] < bParts[aParts.length - 1];
	};

	ditto.isMac = typeof navigator !== 'undefined' && navigator.platform.toLowerCase().indexOf('mac') > -1;

	ditto.defaultReport = {
	    title: "New Report",
	    "default_format": "html",
	    version: '1.4.122',
	    type: 'hierarchical',
	    "page": {
	        units: "inches",
	        paper_size: {
	            id: "letter",
	            inches: ["8.5", "11"],
	            mm: ["216", "279"]
	        },
	        margins: {
	            "top": 0.5,
	            "left": 0.5,
	            "right": 0.5,
	            "bottom": 0.5
	        }
	    },
	    filters: [],
	    inputs: [],
	    header: {
	        height: 1,
	        elements: []
	    },
	    body: {
	        data_source: null,
	        show_detail: true,
	        height: 1.5,
	        elements: [],
	        sublevels: [],
	        column_count: 1,
	        pivot_enabled: false,
	        pivot_expression: "",
	        pivot_column_sort_by: "",
	        pivot_column_bucket_type: "",
	        pivot_value_aggregate: ""
	    },
	    footer: {
	        height: 1,
	        elements: []
	    },
	    page_header: {
	        visible: false,
	        elements: [],
	        height: 1
	    },
	    page_footer: {
	        visible: false,
	        elements: [],
	        height: 1
	    }
	};

	ditto.imageToDataUri = function (imgUrl, format) {
	    var htmlDocument = ditto.window.document;
	    var tmpImage = new Image();
	    tmpImage.src = imgUrl;
	    var naturalWidth = tmpImage.width;
	    var naturalHeight = tmpImage.height;
	    var canvas = htmlDocument.createElement("canvas");
	    htmlDocument.body.appendChild(canvas);
	    canvas.width = naturalWidth;
	    canvas.height = naturalHeight;
	    var context = canvas.getContext("2d");
	    context.fillStyle = "rgb(255,255,255)";
	    context.fillRect(0, 0, naturalWidth, naturalHeight);
	    context.drawImage(tmpImage, 0, 0, naturalWidth, naturalHeight);
	    var imgData = canvas.toDataURL(format || 'image/jpeg');
	    htmlDocument.body.removeChild(canvas);
	    return imgData;
	};

	/** Deep-clone an object, while converting any snake_cased keys to camelCase */
	ditto.camelCaseKeys = function (obj) {
	    if (obj === null) return null;
	    var clone = {};
	    Object.keys(obj).forEach(function (key) {
	        var camel = key.replace(/(_\w)/g, function (m) {
	            return m[1].toUpperCase();
	        });
	        clone[camel] = _typeof(obj[key]) === 'object' ? ditto.camelCaseKeys(obj[key]) : obj[key];
	    });
	    return clone;
	};

	ditto.ns = function (str, root) {
	    var parts = str.split('.');
	    var parent = root || (typeof global !== 'undefined' ? global : window),
	        next;
	    while (next = parts.shift()) {
	        if (!parent[next]) {
	            parent[next] = {};
	        }
	        parent = parent[next];
	    }
	};

	ditto.nsExists = function (nsStr, root) {
	    var parts = nsStr.split('.');
	    var parent = root || (typeof global !== 'undefined' ? global : window),
	        next;
	    while (next = parts.shift()) {
	        if (typeof parent[next] === 'undefined') {
	            return false;
	        }
	        parent = parent[next];
	    }
	    return true;
	};

	ditto.svgToDataUri = function (svgDomEl, widthPx, heightPx, format) {
	    // Select the first svg element
	    var htmlDocument = ditto.window.document;
	    var serializer = new XMLSerializer(),
	        img = new Image(),
	        svgStr = serializer.serializeToString(svgDomEl);
	    if (!widthPx || !heightPx) {
	        widthPx = $(svgDomEl).width();
	        heightPx = $(svgDomEl).height();
	    }
	    // Re-render onto canvas
	    img.src = 'data:image/svg+xml;base64,' + window.btoa(svgStr);
	    var canvas = htmlDocument.createElement("canvas");
	    $(canvas).css('display', 'none');
	    htmlDocument.body.appendChild(canvas);
	    canvas.width = widthPx;
	    canvas.height = heightPx;
	    var context = canvas.getContext("2d");
	    context.fillStyle = "rgb(255,255,255)";
	    context.fillRect(0, 0, widthPx, heightPx);
	    context.fillStyle = "rgb(0,0,0)";
	    context.drawSvg(svgStr, 0, 0, widthPx, heightPx);
	    // context.drawImage(img, 0, 0, widthPx, heightPx);
	    var dataUri = canvas.toDataURL(format === 'jpg' ? 'image/jpeg' : 'image/png');
	    $(canvas).remove();
	    return dataUri;
	};

	ditto.firstDefined = function () {
	    for (var i = 0; i < arguments.length; i++) {
	        if (typeof arguments[i] !== 'undefined') {
	            return arguments[i];
	        }
	    }
	};

	var loadedFonts = {};
	var fontInfo = _underscore2.default.indexBy(_fonts2.default, function (font) {
	    return font.name.trim().toLowerCase();
	});

	var addStylesheet = function addStylesheet(url) {
	    var htmlDocument = ditto.window.document;
	    var link = htmlDocument.createElement('link');
	    link.type = 'text/css';
	    link.rel = 'stylesheet';
	    link.href = url;
	    htmlDocument.head.appendChild(link);
	};

	/** Fetch the named webfont if possible */
	ditto.requireWebFont = function (fontName) {
	    var lower = fontName.trim().toLowerCase();
	    if (loadedFonts[lower]) return;
	    var info = fontInfo[lower];
	    if (!info) return;
	    var urlName = fontName.replace(/\s/g, '+');
	    var stylesheetUrl = 'https://fonts.googleapis.com/css?family=' + urlName + ':400,400i,700,700i&amp;subset=latin-ext';
	    addStylesheet(stylesheetUrl);
	    loadedFonts[lower] = true;
	};

	ditto.setLocale = function (localeObj) {
	    if ((typeof localeObj === 'undefined' ? 'undefined' : _typeof(localeObj)) === 'object') {
	        ditto.locale = localeObj;
	    } else {
	        console.error('setLocale requires locale object as argument');
	    }
	};

	ditto.translate = function (s, data) {
	    var localized = void 0;
	    if (ditto.locale.translations) {
	        localized = ditto.locale.translations[s];
	    }
	    if (!localized) {
	        console.warn('Missing translation for:', s);
	        return '--';
	    }
	    return (localized || s).replace(/\{(\w*)\}/gi, function (match, g1) {
	        return data[g1] || '';
	    });
	};

	module.exports = ditto;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(13)))

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*!
	 * jQuery JavaScript Library v2.0.0
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2013 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2013-04-18
	 */
	(function( window, undefined ) {

	// Can't do this because several apps including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	// Support: Firefox 18+
	//"use strict";
	var
	  // A central reference to the root jQuery(document)
	  rootjQuery,

	  // The deferred used on DOM ready
	  readyList,

	  // Support: IE9
	  // For `typeof xmlNode.method` instead of `xmlNode.method !== undefined`
	  core_strundefined = typeof undefined,

	  // Use the correct document accordingly with window argument (sandbox)
	  location = window.location,
	  document = window.document,
	  docElem = document.documentElement,

	  // Map over jQuery in case of overwrite
	  _jQuery = __webpack_provided_window_dot_jQuery,

	  // Map over the $ in case of overwrite
	  _$ = window.$,

	  // [[Class]] -> type pairs
	  class2type = {},

	  // List of deleted data cache ids, so we can reuse them
	  core_deletedIds = [],

	  core_version = "2.0.0",

	  // Save a reference to some core methods
	  core_concat = core_deletedIds.concat,
	  core_push = core_deletedIds.push,
	  core_slice = core_deletedIds.slice,
	  core_indexOf = core_deletedIds.indexOf,
	  core_toString = class2type.toString,
	  core_hasOwn = class2type.hasOwnProperty,
	  core_trim = core_version.trim,

	  // Define a local copy of jQuery
	  jQuery = function( selector, context ) {
	    // The jQuery object is actually just the init constructor 'enhanced'
	    return new jQuery.fn.init( selector, context, rootjQuery );
	  },

	  // Used for matching numbers
	  core_pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,

	  // Used for splitting on whitespace
	  core_rnotwhite = /\S+/g,

	  // A simple way to check for HTML strings
	  // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	  // Strict HTML recognition (#11290: must start with <)
	  rquickExpr = /^(?:(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	  // Match a standalone tag
	  rsingleTag = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,

	  // Matches dashed string for camelizing
	  rmsPrefix = /^-ms-/,
	  rdashAlpha = /-([\da-z])/gi,

	  // Used by jQuery.camelCase as callback to replace()
	  fcamelCase = function( all, letter ) {
	    return letter.toUpperCase();
	  },

	  // The ready event handler and self cleanup method
	  completed = function() {
	    document.removeEventListener( "DOMContentLoaded", completed, false );
	    window.removeEventListener( "load", completed, false );
	    jQuery.ready();
	  };

	jQuery.fn = jQuery.prototype = {
	  // The current version of jQuery being used
	  jquery: core_version,

	  constructor: jQuery,
	  init: function( selector, context, rootjQuery ) {
	    var match, elem;

	    // HANDLE: $(""), $(null), $(undefined), $(false)
	    if ( !selector ) {
	      return this;
	    }

	    // Handle HTML strings
	    if ( typeof selector === "string" ) {
	      if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
	        // Assume that strings that start and end with <> are HTML and skip the regex check
	        match = [ null, selector, null ];

	      } else {
	        match = rquickExpr.exec( selector );
	      }

	      // Match html or make sure no context is specified for #id
	      if ( match && (match[1] || !context) ) {

	        // HANDLE: $(html) -> $(array)
	        if ( match[1] ) {
	          context = context instanceof jQuery ? context[0] : context;

	          // scripts is true for back-compat
	          jQuery.merge( this, jQuery.parseHTML(
	            match[1],
	            context && context.nodeType ? context.ownerDocument || context : document,
	            true
	          ) );

	          // HANDLE: $(html, props)
	          if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
	            for ( match in context ) {
	              // Properties of context are called as methods if possible
	              if ( jQuery.isFunction( this[ match ] ) ) {
	                this[ match ]( context[ match ] );

	              // ...and otherwise set as attributes
	              } else {
	                this.attr( match, context[ match ] );
	              }
	            }
	          }

	          return this;

	        // HANDLE: $(#id)
	        } else {
	          elem = document.getElementById( match[2] );

	          // Check parentNode to catch when Blackberry 4.6 returns
	          // nodes that are no longer in the document #6963
	          if ( elem && elem.parentNode ) {
	            // Inject the element directly into the jQuery object
	            this.length = 1;
	            this[0] = elem;
	          }

	          this.context = document;
	          this.selector = selector;
	          return this;
	        }

	      // HANDLE: $(expr, $(...))
	      } else if ( !context || context.jquery ) {
	        return ( context || rootjQuery ).find( selector );

	      // HANDLE: $(expr, context)
	      // (which is just equivalent to: $(context).find(expr)
	      } else {
	        return this.constructor( context ).find( selector );
	      }

	    // HANDLE: $(DOMElement)
	    } else if ( selector.nodeType ) {
	      this.context = this[0] = selector;
	      this.length = 1;
	      return this;

	    // HANDLE: $(function)
	    // Shortcut for document ready
	    } else if ( jQuery.isFunction( selector ) ) {
	      return rootjQuery.ready( selector );
	    }

	    if ( selector.selector !== undefined ) {
	      this.selector = selector.selector;
	      this.context = selector.context;
	    }

	    return jQuery.makeArray( selector, this );
	  },

	  // Start with an empty selector
	  selector: "",

	  // The default length of a jQuery object is 0
	  length: 0,

	  toArray: function() {
	    return core_slice.call( this );
	  },

	  // Get the Nth element in the matched element set OR
	  // Get the whole matched element set as a clean array
	  get: function( num ) {
	    return num == null ?

	      // Return a 'clean' array
	      this.toArray() :

	      // Return just the object
	      ( num < 0 ? this[ this.length + num ] : this[ num ] );
	  },

	  // Take an array of elements and push it onto the stack
	  // (returning the new matched element set)
	  pushStack: function( elems ) {

	    // Build a new jQuery matched element set
	    var ret = jQuery.merge( this.constructor(), elems );

	    // Add the old object onto the stack (as a reference)
	    ret.prevObject = this;
	    ret.context = this.context;

	    // Return the newly-formed element set
	    return ret;
	  },

	  // Execute a callback for every element in the matched set.
	  // (You can seed the arguments with an array of args, but this is
	  // only used internally.)
	  each: function( callback, args ) {
	    return jQuery.each( this, callback, args );
	  },

	  ready: function( fn ) {
	    // Add the callback
	    jQuery.ready.promise().done( fn );

	    return this;
	  },

	  slice: function() {
	    return this.pushStack( core_slice.apply( this, arguments ) );
	  },

	  first: function() {
	    return this.eq( 0 );
	  },

	  last: function() {
	    return this.eq( -1 );
	  },

	  eq: function( i ) {
	    var len = this.length,
	      j = +i + ( i < 0 ? len : 0 );
	    return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	  },

	  map: function( callback ) {
	    return this.pushStack( jQuery.map(this, function( elem, i ) {
	      return callback.call( elem, i, elem );
	    }));
	  },

	  end: function() {
	    return this.prevObject || this.constructor(null);
	  },

	  // For internal use only.
	  // Behaves like an Array's method, not like a jQuery method.
	  push: core_push,
	  sort: [].sort,
	  splice: [].splice
	};

	// Give the init function the jQuery prototype for later instantiation
	jQuery.fn.init.prototype = jQuery.fn;

	jQuery.extend = jQuery.fn.extend = function() {
	  var options, name, src, copy, copyIsArray, clone,
	    target = arguments[0] || {},
	    i = 1,
	    length = arguments.length,
	    deep = false;

	  // Handle a deep copy situation
	  if ( typeof target === "boolean" ) {
	    deep = target;
	    target = arguments[1] || {};
	    // skip the boolean and the target
	    i = 2;
	  }

	  // Handle case when target is a string or something (possible in deep copy)
	  if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
	    target = {};
	  }

	  // extend jQuery itself if only one argument is passed
	  if ( length === i ) {
	    target = this;
	    --i;
	  }

	  for ( ; i < length; i++ ) {
	    // Only deal with non-null/undefined values
	    if ( (options = arguments[ i ]) != null ) {
	      // Extend the base object
	      for ( name in options ) {
	        src = target[ name ];
	        copy = options[ name ];

	        // Prevent never-ending loop
	        if ( target === copy ) {
	          continue;
	        }

	        // Recurse if we're merging plain objects or arrays
	        if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
	          if ( copyIsArray ) {
	            copyIsArray = false;
	            clone = src && jQuery.isArray(src) ? src : [];

	          } else {
	            clone = src && jQuery.isPlainObject(src) ? src : {};
	          }

	          // Never move original objects, clone them
	          target[ name ] = jQuery.extend( deep, clone, copy );

	        // Don't bring in undefined values
	        } else if ( copy !== undefined ) {
	          target[ name ] = copy;
	        }
	      }
	    }
	  }

	  // Return the modified object
	  return target;
	};

	jQuery.extend({
	  // Unique for each copy of jQuery on the page
	  expando: "jQuery" + ( core_version + Math.random() ).replace( /\D/g, "" ),

	  noConflict: function( deep ) {
	    if ( window.$ === jQuery ) {
	      window.$ = _$;
	    }

	    if ( deep && __webpack_provided_window_dot_jQuery === jQuery ) {
	      __webpack_provided_window_dot_jQuery = _jQuery;
	    }

	    return jQuery;
	  },

	  // Is the DOM ready to be used? Set to true once it occurs.
	  isReady: false,

	  // A counter to track how many items to wait for before
	  // the ready event fires. See #6781
	  readyWait: 1,

	  // Hold (or release) the ready event
	  holdReady: function( hold ) {
	    if ( hold ) {
	      jQuery.readyWait++;
	    } else {
	      jQuery.ready( true );
	    }
	  },

	  // Handle when the DOM is ready
	  ready: function( wait ) {

	    // Abort if there are pending holds or we're already ready
	    if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
	      return;
	    }

	    // Remember that the DOM is ready
	    jQuery.isReady = true;

	    // If a normal DOM Ready event fired, decrement, and wait if need be
	    if ( wait !== true && --jQuery.readyWait > 0 ) {
	      return;
	    }

	    // If there are functions bound, to execute
	    readyList.resolveWith( document, [ jQuery ] );

	    // Trigger any bound ready events
	    if ( jQuery.fn.trigger ) {
	      jQuery( document ).trigger("ready").off("ready");
	    }
	  },

	  // See test/unit/core.js for details concerning isFunction.
	  // Since version 1.3, DOM methods and functions like alert
	  // aren't supported. They return false on IE (#2968).
	  isFunction: function( obj ) {
	    return jQuery.type(obj) === "function";
	  },

	  isArray: Array.isArray,

	  isWindow: function( obj ) {
	    return obj != null && obj === obj.window;
	  },

	  isNumeric: function( obj ) {
	    return !isNaN( parseFloat(obj) ) && isFinite( obj );
	  },

	  type: function( obj ) {
	    if ( obj == null ) {
	      return String( obj );
	    }
	    // Support: Safari <= 5.1 (functionish RegExp)
	    return typeof obj === "object" || typeof obj === "function" ?
	      class2type[ core_toString.call(obj) ] || "object" :
	      typeof obj;
	  },

	  isPlainObject: function( obj ) {
	    // Not plain objects:
	    // - Any object or value whose internal [[Class]] property is not "[object Object]"
	    // - DOM nodes
	    // - window
	    if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
	      return false;
	    }

	    // Support: Firefox <20
	    // The try/catch suppresses exceptions thrown when attempting to access
	    // the "constructor" property of certain host objects, ie. |window.location|
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=814622
	    try {
	      if ( obj.constructor &&
	          !core_hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
	        return false;
	      }
	    } catch ( e ) {
	      return false;
	    }

	    // If the function hasn't returned already, we're confident that
	    // |obj| is a plain object, created by {} or constructed with new Object
	    return true;
	  },

	  isEmptyObject: function( obj ) {
	    var name;
	    for ( name in obj ) {
	      return false;
	    }
	    return true;
	  },

	  error: function( msg ) {
	    throw new Error( msg );
	  },

	  // data: string of html
	  // context (optional): If specified, the fragment will be created in this context, defaults to document
	  // keepScripts (optional): If true, will include scripts passed in the html string
	  parseHTML: function( data, context, keepScripts ) {
	    if ( !data || typeof data !== "string" ) {
	      return null;
	    }
	    if ( typeof context === "boolean" ) {
	      keepScripts = context;
	      context = false;
	    }
	    context = context || document;

	    var parsed = rsingleTag.exec( data ),
	      scripts = !keepScripts && [];

	    // Single tag
	    if ( parsed ) {
	      return [ context.createElement( parsed[1] ) ];
	    }

	    parsed = jQuery.buildFragment( [ data ], context, scripts );

	    if ( scripts ) {
	      jQuery( scripts ).remove();
	    }

	    return jQuery.merge( [], parsed.childNodes );
	  },

	  parseJSON: JSON.parse,

	  // Cross-browser xml parsing
	  parseXML: function( data ) {
	    var xml, tmp;
	    if ( !data || typeof data !== "string" ) {
	      return null;
	    }

	    // Support: IE9
	    try {
	      tmp = new DOMParser();
	      xml = tmp.parseFromString( data , "text/xml" );
	    } catch ( e ) {
	      xml = undefined;
	    }

	    if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
	      jQuery.error( "Invalid XML: " + data );
	    }
	    return xml;
	  },

	  noop: function() {},

	  // Evaluates a script in a global context
	  globalEval: function( code ) {
	    var script,
	        indirect = eval;

	    code = jQuery.trim( code );

	    if ( code ) {
	      // If the code includes a valid, prologue position
	      // strict mode pragma, execute code by injecting a
	      // script tag into the document.
	      if ( code.indexOf("use strict") === 1 ) {
	        script = document.createElement("script");
	        script.text = code;
	        document.head.appendChild( script ).parentNode.removeChild( script );
	      } else {
	      // Otherwise, avoid the DOM node creation, insertion
	      // and removal by using an indirect global eval
	        indirect( code );
	      }
	    }
	  },

	  // Convert dashed to camelCase; used by the css and data modules
	  // Microsoft forgot to hump their vendor prefix (#9572)
	  camelCase: function( string ) {
	    return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	  },

	  nodeName: function( elem, name ) {
	    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	  },

	  // args is for internal usage only
	  each: function( obj, callback, args ) {
	    var value,
	      i = 0,
	      length = obj.length,
	      isArray = isArraylike( obj );

	    if ( args ) {
	      if ( isArray ) {
	        for ( ; i < length; i++ ) {
	          value = callback.apply( obj[ i ], args );

	          if ( value === false ) {
	            break;
	          }
	        }
	      } else {
	        for ( i in obj ) {
	          value = callback.apply( obj[ i ], args );

	          if ( value === false ) {
	            break;
	          }
	        }
	      }

	    // A special, fast, case for the most common use of each
	    } else {
	      if ( isArray ) {
	        for ( ; i < length; i++ ) {
	          value = callback.call( obj[ i ], i, obj[ i ] );

	          if ( value === false ) {
	            break;
	          }
	        }
	      } else {
	        for ( i in obj ) {
	          value = callback.call( obj[ i ], i, obj[ i ] );

	          if ( value === false ) {
	            break;
	          }
	        }
	      }
	    }

	    return obj;
	  },

	  trim: function( text ) {
	    return text == null ? "" : core_trim.call( text );
	  },

	  // results is for internal usage only
	  makeArray: function( arr, results ) {
	    var ret = results || [];

	    if ( arr != null ) {
	      if ( isArraylike( Object(arr) ) ) {
	        jQuery.merge( ret,
	          typeof arr === "string" ?
	          [ arr ] : arr
	        );
	      } else {
	        core_push.call( ret, arr );
	      }
	    }

	    return ret;
	  },

	  inArray: function( elem, arr, i ) {
	    return arr == null ? -1 : core_indexOf.call( arr, elem, i );
	  },

	  merge: function( first, second ) {
	    var l = second.length,
	      i = first.length,
	      j = 0;

	    if ( typeof l === "number" ) {
	      for ( ; j < l; j++ ) {
	        first[ i++ ] = second[ j ];
	      }
	    } else {
	      while ( second[j] !== undefined ) {
	        first[ i++ ] = second[ j++ ];
	      }
	    }

	    first.length = i;

	    return first;
	  },

	  grep: function( elems, callback, inv ) {
	    var retVal,
	      ret = [],
	      i = 0,
	      length = elems.length;
	    inv = !!inv;

	    // Go through the array, only saving the items
	    // that pass the validator function
	    for ( ; i < length; i++ ) {
	      retVal = !!callback( elems[ i ], i );
	      if ( inv !== retVal ) {
	        ret.push( elems[ i ] );
	      }
	    }

	    return ret;
	  },

	  // arg is for internal usage only
	  map: function( elems, callback, arg ) {
	    var value,
	      i = 0,
	      length = elems.length,
	      isArray = isArraylike( elems ),
	      ret = [];

	    // Go through the array, translating each of the items to their
	    if ( isArray ) {
	      for ( ; i < length; i++ ) {
	        value = callback( elems[ i ], i, arg );

	        if ( value != null ) {
	          ret[ ret.length ] = value;
	        }
	      }

	    // Go through every key on the object,
	    } else {
	      for ( i in elems ) {
	        value = callback( elems[ i ], i, arg );

	        if ( value != null ) {
	          ret[ ret.length ] = value;
	        }
	      }
	    }

	    // Flatten any nested arrays
	    return core_concat.apply( [], ret );
	  },

	  // A global GUID counter for objects
	  guid: 1,

	  // Bind a function to a context, optionally partially applying any
	  // arguments.
	  proxy: function( fn, context ) {
	    var tmp, args, proxy;

	    if ( typeof context === "string" ) {
	      tmp = fn[ context ];
	      context = fn;
	      fn = tmp;
	    }

	    // Quick check to determine if target is callable, in the spec
	    // this throws a TypeError, but we will just return undefined.
	    if ( !jQuery.isFunction( fn ) ) {
	      return undefined;
	    }

	    // Simulated bind
	    args = core_slice.call( arguments, 2 );
	    proxy = function() {
	      return fn.apply( context || this, args.concat( core_slice.call( arguments ) ) );
	    };

	    // Set the guid of unique handler to the same of original handler, so it can be removed
	    proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	    return proxy;
	  },

	  // Multifunctional method to get and set values of a collection
	  // The value/s can optionally be executed if it's a function
	  access: function( elems, fn, key, value, chainable, emptyGet, raw ) {
	    var i = 0,
	      length = elems.length,
	      bulk = key == null;

	    // Sets many values
	    if ( jQuery.type( key ) === "object" ) {
	      chainable = true;
	      for ( i in key ) {
	        jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
	      }

	    // Sets one value
	    } else if ( value !== undefined ) {
	      chainable = true;

	      if ( !jQuery.isFunction( value ) ) {
	        raw = true;
	      }

	      if ( bulk ) {
	        // Bulk operations run against the entire set
	        if ( raw ) {
	          fn.call( elems, value );
	          fn = null;

	        // ...except when executing function values
	        } else {
	          bulk = fn;
	          fn = function( elem, key, value ) {
	            return bulk.call( jQuery( elem ), value );
	          };
	        }
	      }

	      if ( fn ) {
	        for ( ; i < length; i++ ) {
	          fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
	        }
	      }
	    }

	    return chainable ?
	      elems :

	      // Gets
	      bulk ?
	        fn.call( elems ) :
	        length ? fn( elems[0], key ) : emptyGet;
	  },

	  now: Date.now,

	  // A method for quickly swapping in/out CSS properties to get correct calculations.
	  // Note: this method belongs to the css module but it's needed here for the support module.
	  // If support gets modularized, this method should be moved back to the css module.
	  swap: function( elem, options, callback, args ) {
	    var ret, name,
	      old = {};

	    // Remember the old values, and insert the new ones
	    for ( name in options ) {
	      old[ name ] = elem.style[ name ];
	      elem.style[ name ] = options[ name ];
	    }

	    ret = callback.apply( elem, args || [] );

	    // Revert the old values
	    for ( name in options ) {
	      elem.style[ name ] = old[ name ];
	    }

	    return ret;
	  }
	});

	jQuery.ready.promise = function( obj ) {
	  if ( !readyList ) {

	    readyList = jQuery.Deferred();

	    // Catch cases where $(document).ready() is called after the browser event has already occurred.
	    // we once tried to use readyState "interactive" here, but it caused issues like the one
	    // discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
	    if ( document.readyState === "complete" ) {
	      // Handle it asynchronously to allow scripts the opportunity to delay ready
	      setTimeout( jQuery.ready );

	    } else {

	      // Use the handy event callback
	      document.addEventListener( "DOMContentLoaded", completed, false );

	      // A fallback to window.onload, that will always work
	      window.addEventListener( "load", completed, false );
	    }
	  }
	  return readyList.promise( obj );
	};

	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	  class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});

	function isArraylike( obj ) {
	  var length = obj.length,
	    type = jQuery.type( obj );

	  if ( jQuery.isWindow( obj ) ) {
	    return false;
	  }

	  if ( obj.nodeType === 1 && length ) {
	    return true;
	  }

	  return type === "array" || type !== "function" &&
	    ( length === 0 ||
	    typeof length === "number" && length > 0 && ( length - 1 ) in obj );
	}

	// All jQuery objects should point back to these
	rootjQuery = jQuery(document);
	/*!
	 * Sizzle CSS Selector Engine v1.9.2-pre
	 * http://sizzlejs.com/
	 *
	 * Copyright 2013 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2013-04-16
	 */
	(function( window, undefined ) {

	var i,
	  cachedruns,
	  Expr,
	  getText,
	  isXML,
	  compile,
	  outermostContext,
	  sortInput,

	  // Local document vars
	  setDocument,
	  document,
	  docElem,
	  documentIsHTML,
	  rbuggyQSA,
	  rbuggyMatches,
	  matches,
	  contains,

	  // Instance-specific data
	  expando = "sizzle" + -(new Date()),
	  preferredDoc = window.document,
	  support = {},
	  dirruns = 0,
	  done = 0,
	  classCache = createCache(),
	  tokenCache = createCache(),
	  compilerCache = createCache(),
	  hasDuplicate = false,
	  sortOrder = function() { return 0; },

	  // General-purpose constants
	  strundefined = typeof undefined,
	  MAX_NEGATIVE = 1 << 31,

	  // Array methods
	  arr = [],
	  pop = arr.pop,
	  push_native = arr.push,
	  push = arr.push,
	  slice = arr.slice,
	  // Use a stripped-down indexOf if we can't use a native one
	  indexOf = arr.indexOf || function( elem ) {
	    var i = 0,
	      len = this.length;
	    for ( ; i < len; i++ ) {
	      if ( this[i] === elem ) {
	        return i;
	      }
	    }
	    return -1;
	  },

	  booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	  // Regular expressions

	  // Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	  whitespace = "[\\x20\\t\\r\\n\\f]",
	  // http://www.w3.org/TR/css3-syntax/#characters
	  characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	  // Loosely modeled on CSS identifier characters
	  // An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	  // Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	  identifier = characterEncoding.replace( "w", "w#" ),

	  // Acceptable operators http://www.w3.org/TR/selectors/#attribute-selectors
	  attributes = "\\[" + whitespace + "*(" + characterEncoding + ")" + whitespace +
	    "*(?:([*^$|!~]?=)" + whitespace + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + identifier + ")|)|)" + whitespace + "*\\]",

	  // Prefer arguments quoted,
	  //   then not containing pseudos/brackets,
	  //   then attribute selectors/non-parenthetical expressions,
	  //   then anything else
	  // These preferences are here to reduce the number of selectors
	  //   needing tokenize in the PSEUDO preFilter
	  pseudos = ":(" + characterEncoding + ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" + attributes.replace( 3, 8 ) + ")*)|.*)\\)|)",

	  // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	  rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	  rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	  rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	  rsibling = new RegExp( whitespace + "*[+~]" ),
	  rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*)" + whitespace + "*\\]", "g" ),

	  rpseudo = new RegExp( pseudos ),
	  ridentifier = new RegExp( "^" + identifier + "$" ),

	  matchExpr = {
	    "ID": new RegExp( "^#(" + characterEncoding + ")" ),
	    "CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
	    "TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
	    "ATTR": new RegExp( "^" + attributes ),
	    "PSEUDO": new RegExp( "^" + pseudos ),
	    "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
	      "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
	      "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
	    "boolean": new RegExp( "^(?:" + booleans + ")$", "i" ),
	    // For use in libraries implementing .is()
	    // We use this for POS matching in `select`
	    "needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
	      whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	  },

	  rnative = /^[^{]+\{\s*\[native \w/,

	  // Easily-parseable/retrievable ID or TAG or CLASS selectors
	  rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	  rinputs = /^(?:input|select|textarea|button)$/i,
	  rheader = /^h\d$/i,

	  rescape = /'|\\/g,

	  // CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	  runescape = /\\([\da-fA-F]{1,6}[\x20\t\r\n\f]?|.)/g,
	  funescape = function( _, escaped ) {
	    var high = "0x" + escaped - 0x10000;
	    // NaN means non-codepoint
	    return high !== high ?
	      escaped :
	      // BMP codepoint
	      high < 0 ?
	        String.fromCharCode( high + 0x10000 ) :
	        // Supplemental Plane codepoint (surrogate pair)
	        String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	  };

	// Optimize for push.apply( _, NodeList )
	try {
	  push.apply(
	    (arr = slice.call( preferredDoc.childNodes )),
	    preferredDoc.childNodes
	  );
	  // Support: Android<4.0
	  // Detect silently failing push.apply
	  arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
	  push = { apply: arr.length ?

	    // Leverage slice if possible
	    function( target, els ) {
	      push_native.apply( target, slice.call(els) );
	    } :

	    // Support: IE<9
	    // Otherwise append directly
	    function( target, els ) {
	      var j = target.length,
	        i = 0;
	      // Can't trust NodeList.length
	      while ( (target[j++] = els[i++]) ) {}
	      target.length = j - 1;
	    }
	  };
	}

	/**
	 * For feature detection
	 * @param {Function} fn The function to test for native support
	 */
	function isNative( fn ) {
	  return rnative.test( fn + "" );
	}

	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *  property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *  deleting the oldest entry
	 */
	function createCache() {
	  var cache,
	    keys = [];

	  return (cache = function( key, value ) {
	    // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
	    if ( keys.push( key += " " ) > Expr.cacheLength ) {
	      // Only keep the most recent entries
	      delete cache[ keys.shift() ];
	    }
	    return (cache[ key ] = value);
	  });
	}

	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
	  fn[ expando ] = true;
	  return fn;
	}

	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
	  var div = document.createElement("div");

	  try {
	    return !!fn( div );
	  } catch (e) {
	    return false;
	  } finally {
	    if ( div.parentNode ) {
	      div.parentNode.removeChild( div );
	    }
	    // release memory in IE
	    div = null;
	  }
	}

	function Sizzle( selector, context, results, seed ) {
	  var match, elem, m, nodeType,
	    // QSA vars
	    i, groups, old, nid, newContext, newSelector;

	  if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
	    setDocument( context );
	  }

	  context = context || document;
	  results = results || [];

	  if ( !selector || typeof selector !== "string" ) {
	    return results;
	  }

	  if ( (nodeType = context.nodeType) !== 1 && nodeType !== 9 ) {
	    return [];
	  }

	  if ( documentIsHTML && !seed ) {

	    // Shortcuts
	    if ( (match = rquickExpr.exec( selector )) ) {
	      // Speed-up: Sizzle("#ID")
	      if ( (m = match[1]) ) {
	        if ( nodeType === 9 ) {
	          elem = context.getElementById( m );
	          // Check parentNode to catch when Blackberry 4.6 returns
	          // nodes that are no longer in the document #6963
	          if ( elem && elem.parentNode ) {
	            // Handle the case where IE, Opera, and Webkit return items
	            // by name instead of ID
	            if ( elem.id === m ) {
	              results.push( elem );
	              return results;
	            }
	          } else {
	            return results;
	          }
	        } else {
	          // Context is not a document
	          if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
	            contains( context, elem ) && elem.id === m ) {
	            results.push( elem );
	            return results;
	          }
	        }

	      // Speed-up: Sizzle("TAG")
	      } else if ( match[2] ) {
	        push.apply( results, context.getElementsByTagName( selector ) );
	        return results;

	      // Speed-up: Sizzle(".CLASS")
	      } else if ( (m = match[3]) && support.getElementsByClassName && context.getElementsByClassName ) {
	        push.apply( results, context.getElementsByClassName( m ) );
	        return results;
	      }
	    }

	    // QSA path
	    if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	      nid = old = expando;
	      newContext = context;
	      newSelector = nodeType === 9 && selector;

	      // qSA works strangely on Element-rooted queries
	      // We can work around this by specifying an extra ID on the root
	      // and working up from there (Thanks to Andrew Dupont for the technique)
	      // IE 8 doesn't work on object elements
	      if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
	        groups = tokenize( selector );

	        if ( (old = context.getAttribute("id")) ) {
	          nid = old.replace( rescape, "\\$&" );
	        } else {
	          context.setAttribute( "id", nid );
	        }
	        nid = "[id='" + nid + "'] ";

	        i = groups.length;
	        while ( i-- ) {
	          groups[i] = nid + toSelector( groups[i] );
	        }
	        newContext = rsibling.test( selector ) && context.parentNode || context;
	        newSelector = groups.join(",");
	      }

	      if ( newSelector ) {
	        try {
	          push.apply( results,
	            newContext.querySelectorAll( newSelector )
	          );
	          return results;
	        } catch(qsaError) {
	        } finally {
	          if ( !old ) {
	            context.removeAttribute("id");
	          }
	        }
	      }
	    }
	  }

	  // All others
	  return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}

	/**
	 * Detect xml
	 * @param {Element|Object} elem An element or a document
	 */
	isXML = Sizzle.isXML = function( elem ) {
	  // documentElement is verified for cases where it doesn't yet exist
	  // (such as loading iframes in IE - #4833)
	  var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	  return documentElement ? documentElement.nodeName !== "HTML" : false;
	};

	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
	  var doc = node ? node.ownerDocument || node : preferredDoc;

	  // If no document and documentElement is available, return
	  if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
	    return document;
	  }

	  // Set our document
	  document = doc;
	  docElem = doc.documentElement;

	  // Support tests
	  documentIsHTML = !isXML( doc );

	  // Check if getElementsByTagName("*") returns only elements
	  support.getElementsByTagName = assert(function( div ) {
	    div.appendChild( doc.createComment("") );
	    return !div.getElementsByTagName("*").length;
	  });

	  // Support: IE<8
	  // Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)
	  support.attributes = assert(function( div ) {
	    div.className = "i";
	    return !div.getAttribute("className");
	  });

	  // Check if getElementsByClassName can be trusted
	  support.getElementsByClassName = assert(function( div ) {
	    div.innerHTML = "<div class='a'></div><div class='a i'></div>";

	    // Support: Safari<4
	    // Catch class over-caching
	    div.firstChild.className = "i";
	    // Support: Opera<10
	    // Catch gEBCN failure to find non-leading classes
	    return div.getElementsByClassName("i").length === 2;
	  });

	  // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	  // Detached nodes confoundingly follow *each other*
	  support.sortDetached = assert(function( div1 ) {
	    // Should return 1, but returns 4 (following)
	    return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	  });

	  // Support: IE<10
	  // Check if getElementById returns elements by name
	  // Support: Windows 8 Native Apps
	  // Assigning innerHTML with "name" attributes throws uncatchable exceptions
	  // (http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx)
	  // and the broken getElementById methods don't pick up programatically-set names,
	  // so use a roundabout getElementsByName test
	  support.getById = assert(function( div ) {
	    docElem.appendChild( div ).id = expando;
	    return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	  });

	  // ID find and filter
	  if ( support.getById ) {
	    Expr.find["ID"] = function( id, context ) {
	      if ( typeof context.getElementById !== strundefined && documentIsHTML ) {
	        var m = context.getElementById( id );
	        // Check parentNode to catch when Blackberry 4.6 returns
	        // nodes that are no longer in the document #6963
	        return m && m.parentNode ? [m] : [];
	      }
	    };
	    Expr.filter["ID"] = function( id ) {
	      var attrId = id.replace( runescape, funescape );
	      return function( elem ) {
	        return elem.getAttribute("id") === attrId;
	      };
	    };
	  } else {
	    Expr.find["ID"] = function( id, context ) {
	      if ( typeof context.getElementById !== strundefined && documentIsHTML ) {
	        var m = context.getElementById( id );

	        return m ?
	          m.id === id || typeof m.getAttributeNode !== strundefined && m.getAttributeNode("id").value === id ?
	            [m] :
	            undefined :
	          [];
	      }
	    };
	    Expr.filter["ID"] =  function( id ) {
	      var attrId = id.replace( runescape, funescape );
	      return function( elem ) {
	        var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
	        return node && node.value === attrId;
	      };
	    };
	  }

	  // Tag
	  Expr.find["TAG"] = support.getElementsByTagName ?
	    function( tag, context ) {
	      if ( typeof context.getElementsByTagName !== strundefined ) {
	        return context.getElementsByTagName( tag );
	      }
	    } :
	    function( tag, context ) {
	      var elem,
	        tmp = [],
	        i = 0,
	        results = context.getElementsByTagName( tag );

	      // Filter out possible comments
	      if ( tag === "*" ) {
	        while ( (elem = results[i++]) ) {
	          if ( elem.nodeType === 1 ) {
	            tmp.push( elem );
	          }
	        }

	        return tmp;
	      }
	      return results;
	    };

	  // Class
	  Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
	    if ( typeof context.getElementsByClassName !== strundefined && documentIsHTML ) {
	      return context.getElementsByClassName( className );
	    }
	  };

	  // QSA and matchesSelector support

	  // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	  rbuggyMatches = [];

	  // qSa(:focus) reports false when true (Chrome 21)
	  // We allow this because of a bug in IE8/9 that throws an error
	  // whenever `document.activeElement` is accessed on an iframe
	  // So, we allow :focus to pass through QSA all the time to avoid the IE error
	  // See http://bugs.jquery.com/ticket/13378
	  rbuggyQSA = [];

	  if ( (support.qsa = isNative(doc.querySelectorAll)) ) {
	    // Build QSA regex
	    // Regex strategy adopted from Diego Perini
	    assert(function( div ) {
	      // Select is set to empty string on purpose
	      // This is to test IE's treatment of not explicitly
	      // setting a boolean content attribute,
	      // since its presence should be enough
	      // http://bugs.jquery.com/ticket/12359
	      div.innerHTML = "<select><option selected=''></option></select>";

	      // Support: IE8
	      // Boolean attributes and "value" are not treated correctly
	      if ( !div.querySelectorAll("[selected]").length ) {
	        rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
	      }

	      // Webkit/Opera - :checked should return selected option elements
	      // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	      // IE8 throws error here and will not see later tests
	      if ( !div.querySelectorAll(":checked").length ) {
	        rbuggyQSA.push(":checked");
	      }
	    });

	    assert(function( div ) {

	      // Support: Opera 10-12/IE8
	      // ^= $= *= and empty values
	      // Should not select anything
	      // Support: Windows 8 Native Apps
	      // The type attribute is restricted during .innerHTML assignment
	      var input = document.createElement("input");
	      input.setAttribute( "type", "hidden" );
	      div.appendChild( input ).setAttribute( "t", "" );

	      if ( div.querySelectorAll("[t^='']").length ) {
	        rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
	      }

	      // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
	      // IE8 throws error here and will not see later tests
	      if ( !div.querySelectorAll(":enabled").length ) {
	        rbuggyQSA.push( ":enabled", ":disabled" );
	      }

	      // Opera 10-11 does not throw on post-comma invalid pseudos
	      div.querySelectorAll("*,:x");
	      rbuggyQSA.push(",.*:");
	    });
	  }

	  if ( (support.matchesSelector = isNative( (matches = docElem.webkitMatchesSelector ||
	    docElem.mozMatchesSelector ||
	    docElem.oMatchesSelector ||
	    docElem.msMatchesSelector) )) ) {

	    assert(function( div ) {
	      // Check to see if it's possible to do matchesSelector
	      // on a disconnected node (IE 9)
	      support.disconnectedMatch = matches.call( div, "div" );

	      // This should fail with an exception
	      // Gecko does not error, returns false instead
	      matches.call( div, "[s!='']:x" );
	      rbuggyMatches.push( "!=", pseudos );
	    });
	  }

	  rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	  rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	  // Element contains another
	  // Purposefully does not implement inclusive descendent
	  // As in, an element does not contain itself
	  contains = isNative(docElem.contains) || docElem.compareDocumentPosition ?
	    function( a, b ) {
	      var adown = a.nodeType === 9 ? a.documentElement : a,
	        bup = b && b.parentNode;
	      return a === bup || !!( bup && bup.nodeType === 1 && (
	        adown.contains ?
	          adown.contains( bup ) :
	          a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	      ));
	    } :
	    function( a, b ) {
	      if ( b ) {
	        while ( (b = b.parentNode) ) {
	          if ( b === a ) {
	            return true;
	          }
	        }
	      }
	      return false;
	    };

	  // Document order sorting
	  sortOrder = docElem.compareDocumentPosition ?
	  function( a, b ) {

	    // Flag for duplicate removal
	    if ( a === b ) {
	      hasDuplicate = true;
	      return 0;
	    }

	    var compare = b.compareDocumentPosition && a.compareDocumentPosition && a.compareDocumentPosition( b );

	    if ( compare ) {
	      // Disconnected nodes
	      if ( compare & 1 ||
	        (!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

	        // Choose the first element that is related to our preferred document
	        if ( a === doc || contains(preferredDoc, a) ) {
	          return -1;
	        }
	        if ( b === doc || contains(preferredDoc, b) ) {
	          return 1;
	        }

	        // Maintain original order
	        return sortInput ?
	          ( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
	          0;
	      }

	      return compare & 4 ? -1 : 1;
	    }

	    // Not directly comparable, sort on existence of method
	    return a.compareDocumentPosition ? -1 : 1;
	  } :
	  function( a, b ) {
	    var cur,
	      i = 0,
	      aup = a.parentNode,
	      bup = b.parentNode,
	      ap = [ a ],
	      bp = [ b ];

	    // Exit early if the nodes are identical
	    if ( a === b ) {
	      hasDuplicate = true;
	      return 0;

	    // Parentless nodes are either documents or disconnected
	    } else if ( !aup || !bup ) {
	      return a === doc ? -1 :
	        b === doc ? 1 :
	        aup ? -1 :
	        bup ? 1 :
	        sortInput ?
	        ( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
	        0;

	    // If the nodes are siblings, we can do a quick check
	    } else if ( aup === bup ) {
	      return siblingCheck( a, b );
	    }

	    // Otherwise we need full lists of their ancestors for comparison
	    cur = a;
	    while ( (cur = cur.parentNode) ) {
	      ap.unshift( cur );
	    }
	    cur = b;
	    while ( (cur = cur.parentNode) ) {
	      bp.unshift( cur );
	    }

	    // Walk down the tree looking for a discrepancy
	    while ( ap[i] === bp[i] ) {
	      i++;
	    }

	    return i ?
	      // Do a sibling check if the nodes have a common ancestor
	      siblingCheck( ap[i], bp[i] ) :

	      // Otherwise nodes in our document sort first
	      ap[i] === preferredDoc ? -1 :
	      bp[i] === preferredDoc ? 1 :
	      0;
	  };

	  return document;
	};

	Sizzle.matches = function( expr, elements ) {
	  return Sizzle( expr, null, null, elements );
	};

	Sizzle.matchesSelector = function( elem, expr ) {
	  // Set document vars if needed
	  if ( ( elem.ownerDocument || elem ) !== document ) {
	    setDocument( elem );
	  }

	  // Make sure that attribute selectors are quoted
	  expr = expr.replace( rattributeQuotes, "='$1']" );

	  // rbuggyQSA always contains :focus, so no need for an existence check
	  if ( support.matchesSelector && documentIsHTML &&
	    (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
	    (!rbuggyQSA     || !rbuggyQSA.test(expr)) ) {

	    try {
	      var ret = matches.call( elem, expr );

	      // IE 9's matchesSelector returns false on disconnected nodes
	      if ( ret || support.disconnectedMatch ||
	          // As well, disconnected nodes are said to be in a document
	          // fragment in IE 9
	          elem.document && elem.document.nodeType !== 11 ) {
	        return ret;
	      }
	    } catch(e) {}
	  }

	  return Sizzle( expr, document, null, [elem] ).length > 0;
	};

	Sizzle.contains = function( context, elem ) {
	  // Set document vars if needed
	  if ( ( context.ownerDocument || context ) !== document ) {
	    setDocument( context );
	  }
	  return contains( context, elem );
	};

	Sizzle.attr = function( elem, name ) {
	  // Set document vars if needed
	  if ( ( elem.ownerDocument || elem ) !== document ) {
	    setDocument( elem );
	  }

	  var fn = Expr.attrHandle[ name.toLowerCase() ],
	    val = fn && fn( elem, name, !documentIsHTML );

	  return val === undefined ?
	    support.attributes || !documentIsHTML ?
	      elem.getAttribute( name ) :
	      (val = elem.getAttributeNode(name)) && val.specified ?
	        val.value :
	        null :
	    val;
	};

	Sizzle.error = function( msg ) {
	  throw new Error( "Syntax error, unrecognized expression: " + msg );
	};

	// Document sorting and removing duplicates
	Sizzle.uniqueSort = function( results ) {
	  var elem,
	    duplicates = [],
	    j = 0,
	    i = 0;

	  // Unless we *know* we can detect duplicates, assume their presence
	  hasDuplicate = !support.detectDuplicates;
	  sortInput = !support.sortStable && results.slice( 0 );
	  results.sort( sortOrder );

	  if ( hasDuplicate ) {
	    while ( (elem = results[i++]) ) {
	      if ( elem === results[ i ] ) {
	        j = duplicates.push( i );
	      }
	    }
	    while ( j-- ) {
	      results.splice( duplicates[ j ], 1 );
	    }
	  }

	  return results;
	};

	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns Returns -1 if a precedes b, 1 if a follows b
	 */
	function siblingCheck( a, b ) {
	  var cur = b && a,
	    diff = cur && ( ~b.sourceIndex || MAX_NEGATIVE ) - ( ~a.sourceIndex || MAX_NEGATIVE );

	  // Use IE sourceIndex if available on both nodes
	  if ( diff ) {
	    return diff;
	  }

	  // Check if b follows a
	  if ( cur ) {
	    while ( (cur = cur.nextSibling) ) {
	      if ( cur === b ) {
	        return -1;
	      }
	    }
	  }

	  return a ? 1 : -1;
	}

	// Fetches boolean attributes by node
	function boolHandler( elem, name, isXML ) {
	  var val;
	  return isXML ?
	    undefined :
	    (val = elem.getAttributeNode( name )) && val.specified ?
	      val.value :
	      elem[ name ] === true ? name.toLowerCase() : null;
	}

	// Fetches attributes without interpolation
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	function interpolationHandler( elem, name, isXML ) {
	  var val;
	  return isXML ?
	    undefined :
	    (val = elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 ));
	}

	// Returns a function to use in pseudos for input types
	function createInputPseudo( type ) {
	  return function( elem ) {
	    var name = elem.nodeName.toLowerCase();
	    return name === "input" && elem.type === type;
	  };
	}

	// Returns a function to use in pseudos for buttons
	function createButtonPseudo( type ) {
	  return function( elem ) {
	    var name = elem.nodeName.toLowerCase();
	    return (name === "input" || name === "button") && elem.type === type;
	  };
	}

	// Returns a function to use in pseudos for positionals
	function createPositionalPseudo( fn ) {
	  return markFunction(function( argument ) {
	    argument = +argument;
	    return markFunction(function( seed, matches ) {
	      var j,
	        matchIndexes = fn( [], seed.length, argument ),
	        i = matchIndexes.length;

	      // Match elements found at the specified indexes
	      while ( i-- ) {
	        if ( seed[ (j = matchIndexes[i]) ] ) {
	          seed[j] = !(matches[j] = seed[j]);
	        }
	      }
	    });
	  });
	}

	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
	  var node,
	    ret = "",
	    i = 0,
	    nodeType = elem.nodeType;

	  if ( !nodeType ) {
	    // If no nodeType, this is expected to be an array
	    for ( ; (node = elem[i]); i++ ) {
	      // Do not traverse comment nodes
	      ret += getText( node );
	    }
	  } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	    // Use textContent for elements
	    // innerText usage removed for consistency of new lines (see #11153)
	    if ( typeof elem.textContent === "string" ) {
	      return elem.textContent;
	    } else {
	      // Traverse its children
	      for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
	        ret += getText( elem );
	      }
	    }
	  } else if ( nodeType === 3 || nodeType === 4 ) {
	    return elem.nodeValue;
	  }
	  // Do not include comment or processing instruction nodes

	  return ret;
	};

	Expr = Sizzle.selectors = {

	  // Can be adjusted by the user
	  cacheLength: 50,

	  createPseudo: markFunction,

	  match: matchExpr,

	  attrHandle: {},

	  find: {},

	  relative: {
	    ">": { dir: "parentNode", first: true },
	    " ": { dir: "parentNode" },
	    "+": { dir: "previousSibling", first: true },
	    "~": { dir: "previousSibling" }
	  },

	  preFilter: {
	    "ATTR": function( match ) {
	      match[1] = match[1].replace( runescape, funescape );

	      // Move the given value to match[3] whether quoted or unquoted
	      match[3] = ( match[4] || match[5] || "" ).replace( runescape, funescape );

	      if ( match[2] === "~=" ) {
	        match[3] = " " + match[3] + " ";
	      }

	      return match.slice( 0, 4 );
	    },

	    "CHILD": function( match ) {
	      /* matches from matchExpr["CHILD"]
	        1 type (only|nth|...)
	        2 what (child|of-type)
	        3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	        4 xn-component of xn+y argument ([+-]?\d*n|)
	        5 sign of xn-component
	        6 x of xn-component
	        7 sign of y-component
	        8 y of y-component
	      */
	      match[1] = match[1].toLowerCase();

	      if ( match[1].slice( 0, 3 ) === "nth" ) {
	        // nth-* requires argument
	        if ( !match[3] ) {
	          Sizzle.error( match[0] );
	        }

	        // numeric x and y parameters for Expr.filter.CHILD
	        // remember that false/true cast respectively to 0/1
	        match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
	        match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

	      // other types prohibit arguments
	      } else if ( match[3] ) {
	        Sizzle.error( match[0] );
	      }

	      return match;
	    },

	    "PSEUDO": function( match ) {
	      var excess,
	        unquoted = !match[5] && match[2];

	      if ( matchExpr["CHILD"].test( match[0] ) ) {
	        return null;
	      }

	      // Accept quoted arguments as-is
	      if ( match[4] ) {
	        match[2] = match[4];

	      // Strip excess characters from unquoted arguments
	      } else if ( unquoted && rpseudo.test( unquoted ) &&
	        // Get excess from tokenize (recursively)
	        (excess = tokenize( unquoted, true )) &&
	        // advance to the next closing parenthesis
	        (excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

	        // excess is a negative index
	        match[0] = match[0].slice( 0, excess );
	        match[2] = unquoted.slice( 0, excess );
	      }

	      // Return only captures needed by the pseudo filter method (type and argument)
	      return match.slice( 0, 3 );
	    }
	  },

	  filter: {

	    "TAG": function( nodeNameSelector ) {
	      var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
	      return nodeNameSelector === "*" ?
	        function() { return true; } :
	        function( elem ) {
	          return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	        };
	    },

	    "CLASS": function( className ) {
	      var pattern = classCache[ className + " " ];

	      return pattern ||
	        (pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
	        classCache( className, function( elem ) {
	          return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "" );
	        });
	    },

	    "ATTR": function( name, operator, check ) {
	      return function( elem ) {
	        var result = Sizzle.attr( elem, name );

	        if ( result == null ) {
	          return operator === "!=";
	        }
	        if ( !operator ) {
	          return true;
	        }

	        result += "";

	        return operator === "=" ? result === check :
	          operator === "!=" ? result !== check :
	          operator === "^=" ? check && result.indexOf( check ) === 0 :
	          operator === "*=" ? check && result.indexOf( check ) > -1 :
	          operator === "$=" ? check && result.slice( -check.length ) === check :
	          operator === "~=" ? ( " " + result + " " ).indexOf( check ) > -1 :
	          operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
	          false;
	      };
	    },

	    "CHILD": function( type, what, argument, first, last ) {
	      var simple = type.slice( 0, 3 ) !== "nth",
	        forward = type.slice( -4 ) !== "last",
	        ofType = what === "of-type";

	      return first === 1 && last === 0 ?

	        // Shortcut for :nth-*(n)
	        function( elem ) {
	          return !!elem.parentNode;
	        } :

	        function( elem, context, xml ) {
	          var cache, outerCache, node, diff, nodeIndex, start,
	            dir = simple !== forward ? "nextSibling" : "previousSibling",
	            parent = elem.parentNode,
	            name = ofType && elem.nodeName.toLowerCase(),
	            useCache = !xml && !ofType;

	          if ( parent ) {

	            // :(first|last|only)-(child|of-type)
	            if ( simple ) {
	              while ( dir ) {
	                node = elem;
	                while ( (node = node[ dir ]) ) {
	                  if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
	                    return false;
	                  }
	                }
	                // Reverse direction for :only-* (if we haven't yet done so)
	                start = dir = type === "only" && !start && "nextSibling";
	              }
	              return true;
	            }

	            start = [ forward ? parent.firstChild : parent.lastChild ];

	            // non-xml :nth-child(...) stores cache data on `parent`
	            if ( forward && useCache ) {
	              // Seek `elem` from a previously-cached index
	              outerCache = parent[ expando ] || (parent[ expando ] = {});
	              cache = outerCache[ type ] || [];
	              nodeIndex = cache[0] === dirruns && cache[1];
	              diff = cache[0] === dirruns && cache[2];
	              node = nodeIndex && parent.childNodes[ nodeIndex ];

	              while ( (node = ++nodeIndex && node && node[ dir ] ||

	                // Fallback to seeking `elem` from the start
	                (diff = nodeIndex = 0) || start.pop()) ) {

	                // When found, cache indexes on `parent` and break
	                if ( node.nodeType === 1 && ++diff && node === elem ) {
	                  outerCache[ type ] = [ dirruns, nodeIndex, diff ];
	                  break;
	                }
	              }

	            // Use previously-cached element index if available
	            } else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
	              diff = cache[1];

	            // xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
	            } else {
	              // Use the same loop as above to seek `elem` from the start
	              while ( (node = ++nodeIndex && node && node[ dir ] ||
	                (diff = nodeIndex = 0) || start.pop()) ) {

	                if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
	                  // Cache the index of each encountered element
	                  if ( useCache ) {
	                    (node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
	                  }

	                  if ( node === elem ) {
	                    break;
	                  }
	                }
	              }
	            }

	            // Incorporate the offset, then check against cycle size
	            diff -= last;
	            return diff === first || ( diff % first === 0 && diff / first >= 0 );
	          }
	        };
	    },

	    "PSEUDO": function( pseudo, argument ) {
	      // pseudo-class names are case-insensitive
	      // http://www.w3.org/TR/selectors/#pseudo-classes
	      // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
	      // Remember that setFilters inherits from pseudos
	      var args,
	        fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
	          Sizzle.error( "unsupported pseudo: " + pseudo );

	      // The user may use createPseudo to indicate that
	      // arguments are needed to create the filter function
	      // just as Sizzle does
	      if ( fn[ expando ] ) {
	        return fn( argument );
	      }

	      // But maintain support for old signatures
	      if ( fn.length > 1 ) {
	        args = [ pseudo, pseudo, "", argument ];
	        return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
	          markFunction(function( seed, matches ) {
	            var idx,
	              matched = fn( seed, argument ),
	              i = matched.length;
	            while ( i-- ) {
	              idx = indexOf.call( seed, matched[i] );
	              seed[ idx ] = !( matches[ idx ] = matched[i] );
	            }
	          }) :
	          function( elem ) {
	            return fn( elem, 0, args );
	          };
	      }

	      return fn;
	    }
	  },

	  pseudos: {
	    // Potentially complex pseudos
	    "not": markFunction(function( selector ) {
	      // Trim the selector passed to compile
	      // to avoid treating leading and trailing
	      // spaces as combinators
	      var input = [],
	        results = [],
	        matcher = compile( selector.replace( rtrim, "$1" ) );

	      return matcher[ expando ] ?
	        markFunction(function( seed, matches, context, xml ) {
	          var elem,
	            unmatched = matcher( seed, null, xml, [] ),
	            i = seed.length;

	          // Match elements unmatched by `matcher`
	          while ( i-- ) {
	            if ( (elem = unmatched[i]) ) {
	              seed[i] = !(matches[i] = elem);
	            }
	          }
	        }) :
	        function( elem, context, xml ) {
	          input[0] = elem;
	          matcher( input, null, xml, results );
	          return !results.pop();
	        };
	    }),

	    "has": markFunction(function( selector ) {
	      return function( elem ) {
	        return Sizzle( selector, elem ).length > 0;
	      };
	    }),

	    "contains": markFunction(function( text ) {
	      return function( elem ) {
	        return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
	      };
	    }),

	    // "Whether an element is represented by a :lang() selector
	    // is based solely on the element's language value
	    // being equal to the identifier C,
	    // or beginning with the identifier C immediately followed by "-".
	    // The matching of C against the element's language value is performed case-insensitively.
	    // The identifier C does not have to be a valid language name."
	    // http://www.w3.org/TR/selectors/#lang-pseudo
	    "lang": markFunction( function( lang ) {
	      // lang value must be a valid identifier
	      if ( !ridentifier.test(lang || "") ) {
	        Sizzle.error( "unsupported lang: " + lang );
	      }
	      lang = lang.replace( runescape, funescape ).toLowerCase();
	      return function( elem ) {
	        var elemLang;
	        do {
	          if ( (elemLang = documentIsHTML ?
	            elem.lang :
	            elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

	            elemLang = elemLang.toLowerCase();
	            return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
	          }
	        } while ( (elem = elem.parentNode) && elem.nodeType === 1 );
	        return false;
	      };
	    }),

	    // Miscellaneous
	    "target": function( elem ) {
	      var hash = window.location && window.location.hash;
	      return hash && hash.slice( 1 ) === elem.id;
	    },

	    "root": function( elem ) {
	      return elem === docElem;
	    },

	    "focus": function( elem ) {
	      return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	    },

	    // Boolean properties
	    "enabled": function( elem ) {
	      return elem.disabled === false;
	    },

	    "disabled": function( elem ) {
	      return elem.disabled === true;
	    },

	    "checked": function( elem ) {
	      // In CSS3, :checked should return both checked and selected elements
	      // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	      var nodeName = elem.nodeName.toLowerCase();
	      return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
	    },

	    "selected": function( elem ) {
	      // Accessing this property makes selected-by-default
	      // options in Safari work properly
	      if ( elem.parentNode ) {
	        elem.parentNode.selectedIndex;
	      }

	      return elem.selected === true;
	    },

	    // Contents
	    "empty": function( elem ) {
	      // http://www.w3.org/TR/selectors/#empty-pseudo
	      // :empty is only affected by element nodes and content nodes(including text(3), cdata(4)),
	      //   not comment, processing instructions, or others
	      // Thanks to Diego Perini for the nodeName shortcut
	      //   Greater than "@" means alpha characters (specifically not starting with "#" or "?")
	      for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
	        if ( elem.nodeName > "@" || elem.nodeType === 3 || elem.nodeType === 4 ) {
	          return false;
	        }
	      }
	      return true;
	    },

	    "parent": function( elem ) {
	      return !Expr.pseudos["empty"]( elem );
	    },

	    // Element/input types
	    "header": function( elem ) {
	      return rheader.test( elem.nodeName );
	    },

	    "input": function( elem ) {
	      return rinputs.test( elem.nodeName );
	    },

	    "button": function( elem ) {
	      var name = elem.nodeName.toLowerCase();
	      return name === "input" && elem.type === "button" || name === "button";
	    },

	    "text": function( elem ) {
	      var attr;
	      // IE6 and 7 will map elem.type to 'text' for new HTML5 types (search, etc)
	      // use getAttribute instead to test this case
	      return elem.nodeName.toLowerCase() === "input" &&
	        elem.type === "text" &&
	        ( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === elem.type );
	    },

	    // Position-in-collection
	    "first": createPositionalPseudo(function() {
	      return [ 0 ];
	    }),

	    "last": createPositionalPseudo(function( matchIndexes, length ) {
	      return [ length - 1 ];
	    }),

	    "eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
	      return [ argument < 0 ? argument + length : argument ];
	    }),

	    "even": createPositionalPseudo(function( matchIndexes, length ) {
	      var i = 0;
	      for ( ; i < length; i += 2 ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    }),

	    "odd": createPositionalPseudo(function( matchIndexes, length ) {
	      var i = 1;
	      for ( ; i < length; i += 2 ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    }),

	    "lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
	      var i = argument < 0 ? argument + length : argument;
	      for ( ; --i >= 0; ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    }),

	    "gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
	      var i = argument < 0 ? argument + length : argument;
	      for ( ; ++i < length; ) {
	        matchIndexes.push( i );
	      }
	      return matchIndexes;
	    })
	  }
	};

	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	  Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
	  Expr.pseudos[ i ] = createButtonPseudo( i );
	}

	function tokenize( selector, parseOnly ) {
	  var matched, match, tokens, type,
	    soFar, groups, preFilters,
	    cached = tokenCache[ selector + " " ];

	  if ( cached ) {
	    return parseOnly ? 0 : cached.slice( 0 );
	  }

	  soFar = selector;
	  groups = [];
	  preFilters = Expr.preFilter;

	  while ( soFar ) {

	    // Comma and first run
	    if ( !matched || (match = rcomma.exec( soFar )) ) {
	      if ( match ) {
	        // Don't consume trailing commas as valid
	        soFar = soFar.slice( match[0].length ) || soFar;
	      }
	      groups.push( tokens = [] );
	    }

	    matched = false;

	    // Combinators
	    if ( (match = rcombinators.exec( soFar )) ) {
	      matched = match.shift();
	      tokens.push( {
	        value: matched,
	        // Cast descendant combinators to space
	        type: match[0].replace( rtrim, " " )
	      } );
	      soFar = soFar.slice( matched.length );
	    }

	    // Filters
	    for ( type in Expr.filter ) {
	      if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
	        (match = preFilters[ type ]( match ))) ) {
	        matched = match.shift();
	        tokens.push( {
	          value: matched,
	          type: type,
	          matches: match
	        } );
	        soFar = soFar.slice( matched.length );
	      }
	    }

	    if ( !matched ) {
	      break;
	    }
	  }

	  // Return the length of the invalid excess
	  // if we're just parsing
	  // Otherwise, throw an error or return tokens
	  return parseOnly ?
	    soFar.length :
	    soFar ?
	      Sizzle.error( selector ) :
	      // Cache the tokens
	      tokenCache( selector, groups ).slice( 0 );
	}

	function toSelector( tokens ) {
	  var i = 0,
	    len = tokens.length,
	    selector = "";
	  for ( ; i < len; i++ ) {
	    selector += tokens[i].value;
	  }
	  return selector;
	}

	function addCombinator( matcher, combinator, base ) {
	  var dir = combinator.dir,
	    checkNonElements = base && dir === "parentNode",
	    doneName = done++;

	  return combinator.first ?
	    // Check against closest ancestor/preceding element
	    function( elem, context, xml ) {
	      while ( (elem = elem[ dir ]) ) {
	        if ( elem.nodeType === 1 || checkNonElements ) {
	          return matcher( elem, context, xml );
	        }
	      }
	    } :

	    // Check against all ancestor/preceding elements
	    function( elem, context, xml ) {
	      var data, cache, outerCache,
	        dirkey = dirruns + " " + doneName;

	      // We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
	      if ( xml ) {
	        while ( (elem = elem[ dir ]) ) {
	          if ( elem.nodeType === 1 || checkNonElements ) {
	            if ( matcher( elem, context, xml ) ) {
	              return true;
	            }
	          }
	        }
	      } else {
	        while ( (elem = elem[ dir ]) ) {
	          if ( elem.nodeType === 1 || checkNonElements ) {
	            outerCache = elem[ expando ] || (elem[ expando ] = {});
	            if ( (cache = outerCache[ dir ]) && cache[0] === dirkey ) {
	              if ( (data = cache[1]) === true || data === cachedruns ) {
	                return data === true;
	              }
	            } else {
	              cache = outerCache[ dir ] = [ dirkey ];
	              cache[1] = matcher( elem, context, xml ) || cachedruns;
	              if ( cache[1] === true ) {
	                return true;
	              }
	            }
	          }
	        }
	      }
	    };
	}

	function elementMatcher( matchers ) {
	  return matchers.length > 1 ?
	    function( elem, context, xml ) {
	      var i = matchers.length;
	      while ( i-- ) {
	        if ( !matchers[i]( elem, context, xml ) ) {
	          return false;
	        }
	      }
	      return true;
	    } :
	    matchers[0];
	}

	function condense( unmatched, map, filter, context, xml ) {
	  var elem,
	    newUnmatched = [],
	    i = 0,
	    len = unmatched.length,
	    mapped = map != null;

	  for ( ; i < len; i++ ) {
	    if ( (elem = unmatched[i]) ) {
	      if ( !filter || filter( elem, context, xml ) ) {
	        newUnmatched.push( elem );
	        if ( mapped ) {
	          map.push( i );
	        }
	      }
	    }
	  }

	  return newUnmatched;
	}

	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	  if ( postFilter && !postFilter[ expando ] ) {
	    postFilter = setMatcher( postFilter );
	  }
	  if ( postFinder && !postFinder[ expando ] ) {
	    postFinder = setMatcher( postFinder, postSelector );
	  }
	  return markFunction(function( seed, results, context, xml ) {
	    var temp, i, elem,
	      preMap = [],
	      postMap = [],
	      preexisting = results.length,

	      // Get initial elements from seed or context
	      elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

	      // Prefilter to get matcher input, preserving a map for seed-results synchronization
	      matcherIn = preFilter && ( seed || !selector ) ?
	        condense( elems, preMap, preFilter, context, xml ) :
	        elems,

	      matcherOut = matcher ?
	        // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
	        postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

	          // ...intermediate processing is necessary
	          [] :

	          // ...otherwise use results directly
	          results :
	        matcherIn;

	    // Find primary matches
	    if ( matcher ) {
	      matcher( matcherIn, matcherOut, context, xml );
	    }

	    // Apply postFilter
	    if ( postFilter ) {
	      temp = condense( matcherOut, postMap );
	      postFilter( temp, [], context, xml );

	      // Un-match failing elements by moving them back to matcherIn
	      i = temp.length;
	      while ( i-- ) {
	        if ( (elem = temp[i]) ) {
	          matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
	        }
	      }
	    }

	    if ( seed ) {
	      if ( postFinder || preFilter ) {
	        if ( postFinder ) {
	          // Get the final matcherOut by condensing this intermediate into postFinder contexts
	          temp = [];
	          i = matcherOut.length;
	          while ( i-- ) {
	            if ( (elem = matcherOut[i]) ) {
	              // Restore matcherIn since elem is not yet a final match
	              temp.push( (matcherIn[i] = elem) );
	            }
	          }
	          postFinder( null, (matcherOut = []), temp, xml );
	        }

	        // Move matched elements from seed to results to keep them synchronized
	        i = matcherOut.length;
	        while ( i-- ) {
	          if ( (elem = matcherOut[i]) &&
	            (temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {

	            seed[temp] = !(results[temp] = elem);
	          }
	        }
	      }

	    // Add elements to results, through postFinder if defined
	    } else {
	      matcherOut = condense(
	        matcherOut === results ?
	          matcherOut.splice( preexisting, matcherOut.length ) :
	          matcherOut
	      );
	      if ( postFinder ) {
	        postFinder( null, results, matcherOut, xml );
	      } else {
	        push.apply( results, matcherOut );
	      }
	    }
	  });
	}

	function matcherFromTokens( tokens ) {
	  var checkContext, matcher, j,
	    len = tokens.length,
	    leadingRelative = Expr.relative[ tokens[0].type ],
	    implicitRelative = leadingRelative || Expr.relative[" "],
	    i = leadingRelative ? 1 : 0,

	    // The foundational matcher ensures that elements are reachable from top-level context(s)
	    matchContext = addCombinator( function( elem ) {
	      return elem === checkContext;
	    }, implicitRelative, true ),
	    matchAnyContext = addCombinator( function( elem ) {
	      return indexOf.call( checkContext, elem ) > -1;
	    }, implicitRelative, true ),
	    matchers = [ function( elem, context, xml ) {
	      return ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
	        (checkContext = context).nodeType ?
	          matchContext( elem, context, xml ) :
	          matchAnyContext( elem, context, xml ) );
	    } ];

	  for ( ; i < len; i++ ) {
	    if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
	      matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
	    } else {
	      matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

	      // Return special upon seeing a positional matcher
	      if ( matcher[ expando ] ) {
	        // Find the next relative operator (if any) for proper handling
	        j = ++i;
	        for ( ; j < len; j++ ) {
	          if ( Expr.relative[ tokens[j].type ] ) {
	            break;
	          }
	        }
	        return setMatcher(
	          i > 1 && elementMatcher( matchers ),
	          i > 1 && toSelector( tokens.slice( 0, i - 1 ) ).replace( rtrim, "$1" ),
	          matcher,
	          i < j && matcherFromTokens( tokens.slice( i, j ) ),
	          j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
	          j < len && toSelector( tokens )
	        );
	      }
	      matchers.push( matcher );
	    }
	  }

	  return elementMatcher( matchers );
	}

	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	  // A counter to specify which element is currently being matched
	  var matcherCachedRuns = 0,
	    bySet = setMatchers.length > 0,
	    byElement = elementMatchers.length > 0,
	    superMatcher = function( seed, context, xml, results, expandContext ) {
	      var elem, j, matcher,
	        setMatched = [],
	        matchedCount = 0,
	        i = "0",
	        unmatched = seed && [],
	        outermost = expandContext != null,
	        contextBackup = outermostContext,
	        // We must always have either seed elements or context
	        elems = seed || byElement && Expr.find["TAG"]( "*", expandContext && context.parentNode || context ),
	        // Use integer dirruns iff this is the outermost matcher
	        dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1);

	      if ( outermost ) {
	        outermostContext = context !== document && context;
	        cachedruns = matcherCachedRuns;
	      }

	      // Add elements passing elementMatchers directly to results
	      // Keep `i` a string if there are no elements so `matchedCount` will be "00" below
	      for ( ; (elem = elems[i]) != null; i++ ) {
	        if ( byElement && elem ) {
	          j = 0;
	          while ( (matcher = elementMatchers[j++]) ) {
	            if ( matcher( elem, context, xml ) ) {
	              results.push( elem );
	              break;
	            }
	          }
	          if ( outermost ) {
	            dirruns = dirrunsUnique;
	            cachedruns = ++matcherCachedRuns;
	          }
	        }

	        // Track unmatched elements for set filters
	        if ( bySet ) {
	          // They will have gone through all possible matchers
	          if ( (elem = !matcher && elem) ) {
	            matchedCount--;
	          }

	          // Lengthen the array for every element, matched or not
	          if ( seed ) {
	            unmatched.push( elem );
	          }
	        }
	      }

	      // Apply set filters to unmatched elements
	      matchedCount += i;
	      if ( bySet && i !== matchedCount ) {
	        j = 0;
	        while ( (matcher = setMatchers[j++]) ) {
	          matcher( unmatched, setMatched, context, xml );
	        }

	        if ( seed ) {
	          // Reintegrate element matches to eliminate the need for sorting
	          if ( matchedCount > 0 ) {
	            while ( i-- ) {
	              if ( !(unmatched[i] || setMatched[i]) ) {
	                setMatched[i] = pop.call( results );
	              }
	            }
	          }

	          // Discard index placeholder values to get only actual matches
	          setMatched = condense( setMatched );
	        }

	        // Add matches to results
	        push.apply( results, setMatched );

	        // Seedless set matches succeeding multiple successful matchers stipulate sorting
	        if ( outermost && !seed && setMatched.length > 0 &&
	          ( matchedCount + setMatchers.length ) > 1 ) {

	          Sizzle.uniqueSort( results );
	        }
	      }

	      // Override manipulation of globals by nested matchers
	      if ( outermost ) {
	        dirruns = dirrunsUnique;
	        outermostContext = contextBackup;
	      }

	      return unmatched;
	    };

	  return bySet ?
	    markFunction( superMatcher ) :
	    superMatcher;
	}

	compile = Sizzle.compile = function( selector, group /* Internal Use Only */ ) {
	  var i,
	    setMatchers = [],
	    elementMatchers = [],
	    cached = compilerCache[ selector + " " ];

	  if ( !cached ) {
	    // Generate a function of recursive functions that can be used to check each element
	    if ( !group ) {
	      group = tokenize( selector );
	    }
	    i = group.length;
	    while ( i-- ) {
	      cached = matcherFromTokens( group[i] );
	      if ( cached[ expando ] ) {
	        setMatchers.push( cached );
	      } else {
	        elementMatchers.push( cached );
	      }
	    }

	    // Cache the compiled function
	    cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	  }
	  return cached;
	};

	function multipleContexts( selector, contexts, results ) {
	  var i = 0,
	    len = contexts.length;
	  for ( ; i < len; i++ ) {
	    Sizzle( selector, contexts[i], results );
	  }
	  return results;
	}

	function select( selector, context, results, seed ) {
	  var i, tokens, token, type, find,
	    match = tokenize( selector );

	  if ( !seed ) {
	    // Try to minimize operations if there is only one group
	    if ( match.length === 1 ) {

	      // Take a shortcut and set the context if the root selector is an ID
	      tokens = match[0] = match[0].slice( 0 );
	      if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
	          context.nodeType === 9 && documentIsHTML &&
	          Expr.relative[ tokens[1].type ] ) {

	        context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
	        if ( !context ) {
	          return results;
	        }

	        selector = selector.slice( tokens.shift().value.length );
	      }

	      // Fetch a seed set for right-to-left matching
	      i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
	      while ( i-- ) {
	        token = tokens[i];

	        // Abort if we hit a combinator
	        if ( Expr.relative[ (type = token.type) ] ) {
	          break;
	        }
	        if ( (find = Expr.find[ type ]) ) {
	          // Search, expanding context for leading sibling combinators
	          if ( (seed = find(
	            token.matches[0].replace( runescape, funescape ),
	            rsibling.test( tokens[0].type ) && context.parentNode || context
	          )) ) {

	            // If seed is empty or no tokens remain, we can return early
	            tokens.splice( i, 1 );
	            selector = seed.length && toSelector( tokens );
	            if ( !selector ) {
	              push.apply( results, seed );
	              return results;
	            }

	            break;
	          }
	        }
	      }
	    }
	  }

	  // Compile and execute a filtering function
	  // Provide `match` to avoid retokenization if we modified the selector above
	  compile( selector, match )(
	    seed,
	    context,
	    !documentIsHTML,
	    results,
	    rsibling.test( selector )
	  );
	  return results;
	}

	// Deprecated
	Expr.pseudos["nth"] = Expr.pseudos["eq"];

	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();

	// One-time assignments

	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

	// Initialize against the default document
	setDocument();

	// Support: Chrome<<14
	// Always assume duplicates if they aren't passed to the comparison function
	[0, 0].sort( sortOrder );
	support.detectDuplicates = hasDuplicate;

	// Support: IE<8
	// Prevent attribute/property "interpolation"
	assert(function( div ) {
	  div.innerHTML = "<a href='#'></a>";
	  if ( div.firstChild.getAttribute("href") !== "#" ) {
	    var attrs = "type|href|height|width".split("|"),
	      i = attrs.length;
	    while ( i-- ) {
	      Expr.attrHandle[ attrs[i] ] = interpolationHandler;
	    }
	  }
	});

	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	assert(function( div ) {
	  if ( div.getAttribute("disabled") != null ) {
	    var attrs = booleans.split("|"),
	      i = attrs.length;
	    while ( i-- ) {
	      Expr.attrHandle[ attrs[i] ] = boolHandler;
	    }
	  }
	});

	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;


	})( window );
	// String to Object options format cache
	var optionsCache = {};

	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
	  var object = optionsCache[ options ] = {};
	  jQuery.each( options.match( core_rnotwhite ) || [], function( _, flag ) {
	    object[ flag ] = true;
	  });
	  return object;
	}

	/*
	 * Create a callback list using the following parameters:
	 *
	 *  options: an optional list of space-separated options that will change how
	 *      the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *  once:     will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *  memory:     will keep track of previous values and will call any callback added
	 *          after the list has been fired right away with the latest "memorized"
	 *          values (like a Deferred)
	 *
	 *  unique:     will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *  stopOnFalse:  interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {

	  // Convert options from String-formatted to Object-formatted if needed
	  // (we check in cache first)
	  options = typeof options === "string" ?
	    ( optionsCache[ options ] || createOptions( options ) ) :
	    jQuery.extend( {}, options );

	  var // Last fire value (for non-forgettable lists)
	    memory,
	    // Flag to know if list was already fired
	    fired,
	    // Flag to know if list is currently firing
	    firing,
	    // First callback to fire (used internally by add and fireWith)
	    firingStart,
	    // End of the loop when firing
	    firingLength,
	    // Index of currently firing callback (modified by remove if needed)
	    firingIndex,
	    // Actual callback list
	    list = [],
	    // Stack of fire calls for repeatable lists
	    stack = !options.once && [],
	    // Fire callbacks
	    fire = function( data ) {
	      memory = options.memory && data;
	      fired = true;
	      firingIndex = firingStart || 0;
	      firingStart = 0;
	      firingLength = list.length;
	      firing = true;
	      for ( ; list && firingIndex < firingLength; firingIndex++ ) {
	        if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
	          memory = false; // To prevent further calls using add
	          break;
	        }
	      }
	      firing = false;
	      if ( list ) {
	        if ( stack ) {
	          if ( stack.length ) {
	            fire( stack.shift() );
	          }
	        } else if ( memory ) {
	          list = [];
	        } else {
	          self.disable();
	        }
	      }
	    },
	    // Actual Callbacks object
	    self = {
	      // Add a callback or a collection of callbacks to the list
	      add: function() {
	        if ( list ) {
	          // First, we save the current length
	          var start = list.length;
	          (function add( args ) {
	            jQuery.each( args, function( _, arg ) {
	              var type = jQuery.type( arg );
	              if ( type === "function" ) {
	                if ( !options.unique || !self.has( arg ) ) {
	                  list.push( arg );
	                }
	              } else if ( arg && arg.length && type !== "string" ) {
	                // Inspect recursively
	                add( arg );
	              }
	            });
	          })( arguments );
	          // Do we need to add the callbacks to the
	          // current firing batch?
	          if ( firing ) {
	            firingLength = list.length;
	          // With memory, if we're not firing then
	          // we should call right away
	          } else if ( memory ) {
	            firingStart = start;
	            fire( memory );
	          }
	        }
	        return this;
	      },
	      // Remove a callback from the list
	      remove: function() {
	        if ( list ) {
	          jQuery.each( arguments, function( _, arg ) {
	            var index;
	            while( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
	              list.splice( index, 1 );
	              // Handle firing indexes
	              if ( firing ) {
	                if ( index <= firingLength ) {
	                  firingLength--;
	                }
	                if ( index <= firingIndex ) {
	                  firingIndex--;
	                }
	              }
	            }
	          });
	        }
	        return this;
	      },
	      // Check if a given callback is in the list.
	      // If no argument is given, return whether or not list has callbacks attached.
	      has: function( fn ) {
	        return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
	      },
	      // Remove all callbacks from the list
	      empty: function() {
	        list = [];
	        firingLength = 0;
	        return this;
	      },
	      // Have the list do nothing anymore
	      disable: function() {
	        list = stack = memory = undefined;
	        return this;
	      },
	      // Is it disabled?
	      disabled: function() {
	        return !list;
	      },
	      // Lock the list in its current state
	      lock: function() {
	        stack = undefined;
	        if ( !memory ) {
	          self.disable();
	        }
	        return this;
	      },
	      // Is it locked?
	      locked: function() {
	        return !stack;
	      },
	      // Call all callbacks with the given context and arguments
	      fireWith: function( context, args ) {
	        args = args || [];
	        args = [ context, args.slice ? args.slice() : args ];
	        if ( list && ( !fired || stack ) ) {
	          if ( firing ) {
	            stack.push( args );
	          } else {
	            fire( args );
	          }
	        }
	        return this;
	      },
	      // Call all the callbacks with the given arguments
	      fire: function() {
	        self.fireWith( this, arguments );
	        return this;
	      },
	      // To know if the callbacks have already been called at least once
	      fired: function() {
	        return !!fired;
	      }
	    };

	  return self;
	};
	jQuery.extend({

	  Deferred: function( func ) {
	    var tuples = [
	        // action, add listener, listener list, final state
	        [ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
	        [ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
	        [ "notify", "progress", jQuery.Callbacks("memory") ]
	      ],
	      state = "pending",
	      promise = {
	        state: function() {
	          return state;
	        },
	        always: function() {
	          deferred.done( arguments ).fail( arguments );
	          return this;
	        },
	        then: function( /* fnDone, fnFail, fnProgress */ ) {
	          var fns = arguments;
	          return jQuery.Deferred(function( newDefer ) {
	            jQuery.each( tuples, function( i, tuple ) {
	              var action = tuple[ 0 ],
	                fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	              // deferred[ done | fail | progress ] for forwarding actions to newDefer
	              deferred[ tuple[1] ](function() {
	                var returned = fn && fn.apply( this, arguments );
	                if ( returned && jQuery.isFunction( returned.promise ) ) {
	                  returned.promise()
	                    .done( newDefer.resolve )
	                    .fail( newDefer.reject )
	                    .progress( newDefer.notify );
	                } else {
	                  newDefer[ action + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
	                }
	              });
	            });
	            fns = null;
	          }).promise();
	        },
	        // Get a promise for this deferred
	        // If obj is provided, the promise aspect is added to the object
	        promise: function( obj ) {
	          return obj != null ? jQuery.extend( obj, promise ) : promise;
	        }
	      },
	      deferred = {};

	    // Keep pipe for back-compat
	    promise.pipe = promise.then;

	    // Add list-specific methods
	    jQuery.each( tuples, function( i, tuple ) {
	      var list = tuple[ 2 ],
	        stateString = tuple[ 3 ];

	      // promise[ done | fail | progress ] = list.add
	      promise[ tuple[1] ] = list.add;

	      // Handle state
	      if ( stateString ) {
	        list.add(function() {
	          // state = [ resolved | rejected ]
	          state = stateString;

	        // [ reject_list | resolve_list ].disable; progress_list.lock
	        }, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
	      }

	      // deferred[ resolve | reject | notify ]
	      deferred[ tuple[0] ] = function() {
	        deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
	        return this;
	      };
	      deferred[ tuple[0] + "With" ] = list.fireWith;
	    });

	    // Make the deferred a promise
	    promise.promise( deferred );

	    // Call given func if any
	    if ( func ) {
	      func.call( deferred, deferred );
	    }

	    // All done!
	    return deferred;
	  },

	  // Deferred helper
	  when: function( subordinate /* , ..., subordinateN */ ) {
	    var i = 0,
	      resolveValues = core_slice.call( arguments ),
	      length = resolveValues.length,

	      // the count of uncompleted subordinates
	      remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

	      // the master Deferred. If resolveValues consist of only a single Deferred, just use that.
	      deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

	      // Update function for both resolve and progress values
	      updateFunc = function( i, contexts, values ) {
	        return function( value ) {
	          contexts[ i ] = this;
	          values[ i ] = arguments.length > 1 ? core_slice.call( arguments ) : value;
	          if( values === progressValues ) {
	            deferred.notifyWith( contexts, values );
	          } else if ( !( --remaining ) ) {
	            deferred.resolveWith( contexts, values );
	          }
	        };
	      },

	      progressValues, progressContexts, resolveContexts;

	    // add listeners to Deferred subordinates; treat others as resolved
	    if ( length > 1 ) {
	      progressValues = new Array( length );
	      progressContexts = new Array( length );
	      resolveContexts = new Array( length );
	      for ( ; i < length; i++ ) {
	        if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
	          resolveValues[ i ].promise()
	            .done( updateFunc( i, resolveContexts, resolveValues ) )
	            .fail( deferred.reject )
	            .progress( updateFunc( i, progressContexts, progressValues ) );
	        } else {
	          --remaining;
	        }
	      }
	    }

	    // if we're not waiting on anything, resolve the master
	    if ( !remaining ) {
	      deferred.resolveWith( resolveContexts, resolveValues );
	    }

	    return deferred.promise();
	  }
	});
	jQuery.support = (function( support ) {
	  var input = document.createElement("input"),
	    fragment = document.createDocumentFragment(),
	    div = document.createElement("div"),
	    select = document.createElement("select"),
	    opt = select.appendChild( document.createElement("option") );

	  // Finish early in limited environments
	  if ( !input.type ) {
	    return support;
	  }

	  input.type = "checkbox";

	  // Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
	  // Check the default checkbox/radio value ("" on old WebKit; "on" elsewhere)
	  support.checkOn = input.value !== "";

	  // Must access the parent to make an option select properly
	  // Support: IE9, IE10
	  support.optSelected = opt.selected;

	  // Will be defined later
	  support.reliableMarginRight = true;
	  support.boxSizingReliable = true;
	  support.pixelPosition = false;

	  // Make sure checked status is properly cloned
	  // Support: IE9, IE10
	  input.checked = true;
	  support.noCloneChecked = input.cloneNode( true ).checked;

	  // Make sure that the options inside disabled selects aren't marked as disabled
	  // (WebKit marks them as disabled)
	  select.disabled = true;
	  support.optDisabled = !opt.disabled;

	  // Check if an input maintains its value after becoming a radio
	  // Support: IE9, IE10
	  input = document.createElement("input");
	  input.value = "t";
	  input.type = "radio";
	  support.radioValue = input.value === "t";

	  // #11217 - WebKit loses check when the name is after the checked attribute
	  input.setAttribute( "checked", "t" );
	  input.setAttribute( "name", "t" );

	  fragment.appendChild( input );

	  // Support: Safari 5.1, Android 4.x, Android 2.3
	  // old WebKit doesn't clone checked state correctly in fragments
	  support.checkClone = fragment.cloneNode( true ).cloneNode( true ).lastChild.checked;

	  // Support: Firefox, Chrome, Safari
	  // Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
	  support.focusinBubbles = "onfocusin" in window;

	  div.style.backgroundClip = "content-box";
	  div.cloneNode( true ).style.backgroundClip = "";
	  support.clearCloneStyle = div.style.backgroundClip === "content-box";

	  // Run tests that need a body at doc ready
	  jQuery(function() {
	    var container, marginDiv,
	      // Support: Firefox, Android 2.3 (Prefixed box-sizing versions).
	      divReset = "padding:0;margin:0;border:0;display:block;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box",
	      body = document.getElementsByTagName("body")[ 0 ];

	    if ( !body ) {
	      // Return for frameset docs that don't have a body
	      return;
	    }

	    container = document.createElement("div");
	    container.style.cssText = "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px";

	    // Check box-sizing and margin behavior.
	    body.appendChild( container ).appendChild( div );
	    div.innerHTML = "";
	    // Support: Firefox, Android 2.3 (Prefixed box-sizing versions).
	    div.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%";

	    // Workaround failing boxSizing test due to offsetWidth returning wrong value
	    // with some non-1 values of body zoom, ticket #13543
	    jQuery.swap( body, body.style.zoom != null ? { zoom: 1 } : {}, function() {
	      support.boxSizing = div.offsetWidth === 4;
	    });

	    // Use window.getComputedStyle because jsdom on node.js will break without it.
	    if ( window.getComputedStyle ) {
	      support.pixelPosition = ( window.getComputedStyle( div, null ) || {} ).top !== "1%";
	      support.boxSizingReliable = ( window.getComputedStyle( div, null ) || { width: "4px" } ).width === "4px";

	      // Support: Android 2.3
	      // Check if div with explicit width and no margin-right incorrectly
	      // gets computed margin-right based on width of container. (#3333)
	      // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
	      marginDiv = div.appendChild( document.createElement("div") );
	      marginDiv.style.cssText = div.style.cssText = divReset;
	      marginDiv.style.marginRight = marginDiv.style.width = "0";
	      div.style.width = "1px";

	      support.reliableMarginRight =
	        !parseFloat( ( window.getComputedStyle( marginDiv, null ) || {} ).marginRight );
	    }

	    body.removeChild( container );
	  });

	  return support;
	})( {} );

	/*
	  Implementation Summary

	  1. Enforce API surface and semantic compatibility with 1.9.x branch
	  2. Improve the module's maintainability by reducing the storage
	    paths to a single mechanism.
	  3. Use the same single mechanism to support "private" and "user" data.
	  4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	  5. Avoid exposing implementation details on user objects (eg. expando properties)
	  6. Provide a clear path for implementation upgrade to WeakMap in 2014
	*/
	var data_user, data_priv,
	  rbrace = /(?:\{[\s\S]*\}|\[[\s\S]*\])$/,
	  rmultiDash = /([A-Z])/g;

	function Data() {
	  // Support: Android < 4,
	  // Old WebKit does not have Object.preventExtensions/freeze method,
	  // return new empty object instead with no [[set]] accessor
	  Object.defineProperty( this.cache = {}, 0, {
	    get: function() {
	      return {};
	    }
	  });

	  this.expando = jQuery.expando + Math.random();
	}

	Data.uid = 1;

	Data.accepts = function( owner ) {
	  // Accepts only:
	  //  - Node
	  //    - Node.ELEMENT_NODE
	  //    - Node.DOCUMENT_NODE
	  //  - Object
	  //    - Any
	  return owner.nodeType ?
	    owner.nodeType === 1 || owner.nodeType === 9 : true;
	};

	Data.prototype = {
	  key: function( owner ) {
	    // We can accept data for non-element nodes in modern browsers,
	    // but we should not, see #8335.
	    // Always return the key for a frozen object.
	    if ( !Data.accepts( owner ) ) {
	      return 0;
	    }

	    var descriptor = {},
	      // Check if the owner object already has a cache key
	      unlock = owner[ this.expando ];

	    // If not, create one
	    if ( !unlock ) {
	      unlock = Data.uid++;

	      // Secure it in a non-enumerable, non-writable property
	      try {
	        descriptor[ this.expando ] = { value: unlock };
	        Object.defineProperties( owner, descriptor );

	      // Support: Android < 4
	      // Fallback to a less secure definition
	      } catch ( e ) {
	        descriptor[ this.expando ] = unlock;
	        jQuery.extend( owner, descriptor );
	      }
	    }

	    // Ensure the cache object
	    if ( !this.cache[ unlock ] ) {
	      this.cache[ unlock ] = {};
	    }

	    return unlock;
	  },
	  set: function( owner, data, value ) {
	    var prop,
	      // There may be an unlock assigned to this node,
	      // if there is no entry for this "owner", create one inline
	      // and set the unlock as though an owner entry had always existed
	      unlock = this.key( owner ),
	      cache = this.cache[ unlock ];

	    // Handle: [ owner, key, value ] args
	    if ( typeof data === "string" ) {
	      cache[ data ] = value;

	    // Handle: [ owner, { properties } ] args
	    } else {
	      // Support an expectation from the old data system where plain
	      // objects used to initialize would be set to the cache by
	      // reference, instead of having properties and values copied.
	      // Note, this will kill the connection between
	      // "this.cache[ unlock ]" and "cache"
	      if ( jQuery.isEmptyObject( cache ) ) {
	        this.cache[ unlock ] = data;
	      // Otherwise, copy the properties one-by-one to the cache object
	      } else {
	        for ( prop in data ) {
	          cache[ prop ] = data[ prop ];
	        }
	      }
	    }
	  },
	  get: function( owner, key ) {
	    // Either a valid cache is found, or will be created.
	    // New caches will be created and the unlock returned,
	    // allowing direct access to the newly created
	    // empty data object. A valid owner object must be provided.
	    var cache = this.cache[ this.key( owner ) ];

	    return key === undefined ?
	      cache : cache[ key ];
	  },
	  access: function( owner, key, value ) {
	    // In cases where either:
	    //
	    //   1. No key was specified
	    //   2. A string key was specified, but no value provided
	    //
	    // Take the "read" path and allow the get method to determine
	    // which value to return, respectively either:
	    //
	    //   1. The entire cache object
	    //   2. The data stored at the key
	    //
	    if ( key === undefined ||
	        ((key && typeof key === "string") && value === undefined) ) {
	      return this.get( owner, key );
	    }

	    // [*]When the key is not a string, or both a key and value
	    // are specified, set or extend (existing objects) with either:
	    //
	    //   1. An object of properties
	    //   2. A key and value
	    //
	    this.set( owner, key, value );

	    // Since the "set" path can have two possible entry points
	    // return the expected data based on which path was taken[*]
	    return value !== undefined ? value : key;
	  },
	  remove: function( owner, key ) {
	    var i, name,
	      unlock = this.key( owner ),
	      cache = this.cache[ unlock ];

	    if ( key === undefined ) {
	      this.cache[ unlock ] = {};

	    } else {
	      // Support array or space separated string of keys
	      if ( jQuery.isArray( key ) ) {
	        // If "name" is an array of keys...
	        // When data is initially created, via ("key", "val") signature,
	        // keys will be converted to camelCase.
	        // Since there is no way to tell _how_ a key was added, remove
	        // both plain key and camelCase key. #12786
	        // This will only penalize the array argument path.
	        name = key.concat( key.map( jQuery.camelCase ) );
	      } else {
	        // Try the string as a key before any manipulation
	        if ( key in cache ) {
	          name = [ key ];
	        } else {
	          // If a key with the spaces exists, use it.
	          // Otherwise, create an array by matching non-whitespace
	          name = jQuery.camelCase( key );
	          name = name in cache ?
	            [ name ] : ( name.match( core_rnotwhite ) || [] );
	        }
	      }

	      i = name.length;
	      while ( i-- ) {
	        delete cache[ name[ i ] ];
	      }
	    }
	  },
	  hasData: function( owner ) {
	    return !jQuery.isEmptyObject(
	      this.cache[ owner[ this.expando ] ] || {}
	    );
	  },
	  discard: function( owner ) {
	    delete this.cache[ this.key( owner ) ];
	  }
	};

	// These may be used throughout the jQuery core codebase
	data_user = new Data();
	data_priv = new Data();


	jQuery.extend({
	  acceptData: Data.accepts,

	  hasData: function( elem ) {
	    return data_user.hasData( elem ) || data_priv.hasData( elem );
	  },

	  data: function( elem, name, data ) {
	    return data_user.access( elem, name, data );
	  },

	  removeData: function( elem, name ) {
	    data_user.remove( elem, name );
	  },

	  // with direct calls to data_priv methods, these can be deprecated.
	  _data: function( elem, name, data ) {
	    return data_priv.access( elem, name, data );
	  },

	  _removeData: function( elem, name ) {
	    data_priv.remove( elem, name );
	  }
	});

	jQuery.fn.extend({
	  data: function( key, value ) {
	    var attrs, name,
	      elem = this[ 0 ],
	      i = 0,
	      data = null;

	    // Gets all values
	    if ( key === undefined ) {
	      if ( this.length ) {
	        data = data_user.get( elem );

	        if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
	          attrs = elem.attributes;
	          for ( ; i < attrs.length; i++ ) {
	            name = attrs[ i ].name;

	            if ( name.indexOf( "data-" ) === 0 ) {
	              name = jQuery.camelCase( name.substring(5) );
	              dataAttr( elem, name, data[ name ] );
	            }
	          }
	          data_priv.set( elem, "hasDataAttrs", true );
	        }
	      }

	      return data;
	    }

	    // Sets multiple values
	    if ( typeof key === "object" ) {
	      return this.each(function() {
	        data_user.set( this, key );
	      });
	    }

	    return jQuery.access( this, function( value ) {
	      var data,
	        camelKey = jQuery.camelCase( key );

	      // The calling jQuery object (element matches) is not empty
	      // (and therefore has an element appears at this[ 0 ]) and the
	      // `value` parameter was not undefined. An empty jQuery object
	      // will result in `undefined` for elem = this[ 0 ] which will
	      // throw an exception if an attempt to read a data cache is made.
	      if ( elem && value === undefined ) {
	        // Attempt to get data from the cache
	        // with the key as-is
	        data = data_user.get( elem, key );
	        if ( data !== undefined ) {
	          return data;
	        }

	        // Attempt to get data from the cache
	        // with the key camelized
	        data = data_user.get( elem, camelKey );
	        if ( data !== undefined ) {
	          return data;
	        }

	        // Attempt to "discover" the data in
	        // HTML5 custom data-* attrs
	        data = dataAttr( elem, camelKey, undefined );
	        if ( data !== undefined ) {
	          return data;
	        }

	        // We tried really hard, but the data doesn't exist.
	        return;
	      }

	      // Set the data...
	      this.each(function() {
	        // First, attempt to store a copy or reference of any
	        // data that might've been store with a camelCased key.
	        var data = data_user.get( this, camelKey );

	        // For HTML5 data-* attribute interop, we have to
	        // store property names with dashes in a camelCase form.
	        // This might not apply to all properties...*
	        data_user.set( this, camelKey, value );

	        // *... In the case of properties that might _actually_
	        // have dashes, we need to also store a copy of that
	        // unchanged property.
	        if ( key.indexOf("-") !== -1 && data !== undefined ) {
	          data_user.set( this, key, value );
	        }
	      });
	    }, null, value, arguments.length > 1, null, true );
	  },

	  removeData: function( key ) {
	    return this.each(function() {
	      data_user.remove( this, key );
	    });
	  }
	});

	function dataAttr( elem, key, data ) {
	  var name;

	  // If nothing was found internally, try to fetch any
	  // data from the HTML5 data-* attribute
	  if ( data === undefined && elem.nodeType === 1 ) {
	    name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	    data = elem.getAttribute( name );

	    if ( typeof data === "string" ) {
	      try {
	        data = data === "true" ? true :
	          data === "false" ? false :
	          data === "null" ? null :
	          // Only convert to a number if it doesn't change the string
	          +data + "" === data ? +data :
	          rbrace.test( data ) ? JSON.parse( data ) :
	          data;
	      } catch( e ) {}

	      // Make sure we set the data so it isn't changed later
	      data_user.set( elem, key, data );
	    } else {
	      data = undefined;
	    }
	  }
	  return data;
	}
	jQuery.extend({
	  queue: function( elem, type, data ) {
	    var queue;

	    if ( elem ) {
	      type = ( type || "fx" ) + "queue";
	      queue = data_priv.get( elem, type );

	      // Speed up dequeue by getting out quickly if this is just a lookup
	      if ( data ) {
	        if ( !queue || jQuery.isArray( data ) ) {
	          queue = data_priv.access( elem, type, jQuery.makeArray(data) );
	        } else {
	          queue.push( data );
	        }
	      }
	      return queue || [];
	    }
	  },

	  dequeue: function( elem, type ) {
	    type = type || "fx";

	    var queue = jQuery.queue( elem, type ),
	      startLength = queue.length,
	      fn = queue.shift(),
	      hooks = jQuery._queueHooks( elem, type ),
	      next = function() {
	        jQuery.dequeue( elem, type );
	      };

	    // If the fx queue is dequeued, always remove the progress sentinel
	    if ( fn === "inprogress" ) {
	      fn = queue.shift();
	      startLength--;
	    }

	    hooks.cur = fn;
	    if ( fn ) {

	      // Add a progress sentinel to prevent the fx queue from being
	      // automatically dequeued
	      if ( type === "fx" ) {
	        queue.unshift( "inprogress" );
	      }

	      // clear up the last queue stop function
	      delete hooks.stop;
	      fn.call( elem, next, hooks );
	    }

	    if ( !startLength && hooks ) {
	      hooks.empty.fire();
	    }
	  },

	  // not intended for public consumption - generates a queueHooks object, or returns the current one
	  _queueHooks: function( elem, type ) {
	    var key = type + "queueHooks";
	    return data_priv.get( elem, key ) || data_priv.access( elem, key, {
	      empty: jQuery.Callbacks("once memory").add(function() {
	        data_priv.remove( elem, [ type + "queue", key ] );
	      })
	    });
	  }
	});

	jQuery.fn.extend({
	  queue: function( type, data ) {
	    var setter = 2;

	    if ( typeof type !== "string" ) {
	      data = type;
	      type = "fx";
	      setter--;
	    }

	    if ( arguments.length < setter ) {
	      return jQuery.queue( this[0], type );
	    }

	    return data === undefined ?
	      this :
	      this.each(function() {
	        var queue = jQuery.queue( this, type, data );

	        // ensure a hooks for this queue
	        jQuery._queueHooks( this, type );

	        if ( type === "fx" && queue[0] !== "inprogress" ) {
	          jQuery.dequeue( this, type );
	        }
	      });
	  },
	  dequeue: function( type ) {
	    return this.each(function() {
	      jQuery.dequeue( this, type );
	    });
	  },
	  // Based off of the plugin by Clint Helfers, with permission.
	  // http://blindsignals.com/index.php/2009/07/jquery-delay/
	  delay: function( time, type ) {
	    time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	    type = type || "fx";

	    return this.queue( type, function( next, hooks ) {
	      var timeout = setTimeout( next, time );
	      hooks.stop = function() {
	        clearTimeout( timeout );
	      };
	    });
	  },
	  clearQueue: function( type ) {
	    return this.queue( type || "fx", [] );
	  },
	  // Get a promise resolved when queues of a certain type
	  // are emptied (fx is the type by default)
	  promise: function( type, obj ) {
	    var tmp,
	      count = 1,
	      defer = jQuery.Deferred(),
	      elements = this,
	      i = this.length,
	      resolve = function() {
	        if ( !( --count ) ) {
	          defer.resolveWith( elements, [ elements ] );
	        }
	      };

	    if ( typeof type !== "string" ) {
	      obj = type;
	      type = undefined;
	    }
	    type = type || "fx";

	    while( i-- ) {
	      tmp = data_priv.get( elements[ i ], type + "queueHooks" );
	      if ( tmp && tmp.empty ) {
	        count++;
	        tmp.empty.add( resolve );
	      }
	    }
	    resolve();
	    return defer.promise( obj );
	  }
	});
	var nodeHook, boolHook,
	  rclass = /[\t\r\n]/g,
	  rreturn = /\r/g,
	  rfocusable = /^(?:input|select|textarea|button)$/i;

	jQuery.fn.extend({
	  attr: function( name, value ) {
	    return jQuery.access( this, jQuery.attr, name, value, arguments.length > 1 );
	  },

	  removeAttr: function( name ) {
	    return this.each(function() {
	      jQuery.removeAttr( this, name );
	    });
	  },

	  prop: function( name, value ) {
	    return jQuery.access( this, jQuery.prop, name, value, arguments.length > 1 );
	  },

	  removeProp: function( name ) {
	    return this.each(function() {
	      delete this[ jQuery.propFix[ name ] || name ];
	    });
	  },

	  addClass: function( value ) {
	    var classes, elem, cur, clazz, j,
	      i = 0,
	      len = this.length,
	      proceed = typeof value === "string" && value;

	    if ( jQuery.isFunction( value ) ) {
	      return this.each(function( j ) {
	        jQuery( this ).addClass( value.call( this, j, this.className ) );
	      });
	    }

	    if ( proceed ) {
	      // The disjunction here is for better compressibility (see removeClass)
	      classes = ( value || "" ).match( core_rnotwhite ) || [];

	      for ( ; i < len; i++ ) {
	        elem = this[ i ];
	        cur = elem.nodeType === 1 && ( elem.className ?
	          ( " " + elem.className + " " ).replace( rclass, " " ) :
	          " "
	        );

	        if ( cur ) {
	          j = 0;
	          while ( (clazz = classes[j++]) ) {
	            if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
	              cur += clazz + " ";
	            }
	          }
	          elem.className = jQuery.trim( cur );

	        }
	      }
	    }

	    return this;
	  },

	  removeClass: function( value ) {
	    var classes, elem, cur, clazz, j,
	      i = 0,
	      len = this.length,
	      proceed = arguments.length === 0 || typeof value === "string" && value;

	    if ( jQuery.isFunction( value ) ) {
	      return this.each(function( j ) {
	        jQuery( this ).removeClass( value.call( this, j, this.className ) );
	      });
	    }
	    if ( proceed ) {
	      classes = ( value || "" ).match( core_rnotwhite ) || [];

	      for ( ; i < len; i++ ) {
	        elem = this[ i ];
	        // This expression is here for better compressibility (see addClass)
	        cur = elem.nodeType === 1 && ( elem.className ?
	          ( " " + elem.className + " " ).replace( rclass, " " ) :
	          ""
	        );

	        if ( cur ) {
	          j = 0;
	          while ( (clazz = classes[j++]) ) {
	            // Remove *all* instances
	            while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
	              cur = cur.replace( " " + clazz + " ", " " );
	            }
	          }
	          elem.className = value ? jQuery.trim( cur ) : "";
	        }
	      }
	    }

	    return this;
	  },

	  toggleClass: function( value, stateVal ) {
	    var type = typeof value,
	      isBool = typeof stateVal === "boolean";

	    if ( jQuery.isFunction( value ) ) {
	      return this.each(function( i ) {
	        jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
	      });
	    }

	    return this.each(function() {
	      if ( type === "string" ) {
	        // toggle individual class names
	        var className,
	          i = 0,
	          self = jQuery( this ),
	          state = stateVal,
	          classNames = value.match( core_rnotwhite ) || [];

	        while ( (className = classNames[ i++ ]) ) {
	          // check each className given, space separated list
	          state = isBool ? state : !self.hasClass( className );
	          self[ state ? "addClass" : "removeClass" ]( className );
	        }

	      // Toggle whole class name
	      } else if ( type === core_strundefined || type === "boolean" ) {
	        if ( this.className ) {
	          // store className if set
	          data_priv.set( this, "__className__", this.className );
	        }

	        // If the element has a class name or if we're passed "false",
	        // then remove the whole classname (if there was one, the above saved it).
	        // Otherwise bring back whatever was previously saved (if anything),
	        // falling back to the empty string if nothing was stored.
	        this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
	      }
	    });
	  },

	  hasClass: function( selector ) {
	    var className = " " + selector + " ",
	      i = 0,
	      l = this.length;
	    for ( ; i < l; i++ ) {
	      if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
	        return true;
	      }
	    }

	    return false;
	  },

	  val: function( value ) {
	    var hooks, ret, isFunction,
	      elem = this[0];

	    if ( !arguments.length ) {
	      if ( elem ) {
	        hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

	        if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
	          return ret;
	        }

	        ret = elem.value;

	        return typeof ret === "string" ?
	          // handle most common string cases
	          ret.replace(rreturn, "") :
	          // handle cases where value is null/undef or number
	          ret == null ? "" : ret;
	      }

	      return;
	    }

	    isFunction = jQuery.isFunction( value );

	    return this.each(function( i ) {
	      var val,
	        self = jQuery(this);

	      if ( this.nodeType !== 1 ) {
	        return;
	      }

	      if ( isFunction ) {
	        val = value.call( this, i, self.val() );
	      } else {
	        val = value;
	      }

	      // Treat null/undefined as ""; convert numbers to string
	      if ( val == null ) {
	        val = "";
	      } else if ( typeof val === "number" ) {
	        val += "";
	      } else if ( jQuery.isArray( val ) ) {
	        val = jQuery.map(val, function ( value ) {
	          return value == null ? "" : value + "";
	        });
	      }

	      hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

	      // If set returns undefined, fall back to normal setting
	      if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
	        this.value = val;
	      }
	    });
	  }
	});

	jQuery.extend({
	  valHooks: {
	    option: {
	      get: function( elem ) {
	        // attributes.value is undefined in Blackberry 4.7 but
	        // uses .value. See #6932
	        var val = elem.attributes.value;
	        return !val || val.specified ? elem.value : elem.text;
	      }
	    },
	    select: {
	      get: function( elem ) {
	        var value, option,
	          options = elem.options,
	          index = elem.selectedIndex,
	          one = elem.type === "select-one" || index < 0,
	          values = one ? null : [],
	          max = one ? index + 1 : options.length,
	          i = index < 0 ?
	            max :
	            one ? index : 0;

	        // Loop through all the selected options
	        for ( ; i < max; i++ ) {
	          option = options[ i ];

	          // IE6-9 doesn't update selected after form reset (#2551)
	          if ( ( option.selected || i === index ) &&
	              // Don't return options that are disabled or in a disabled optgroup
	              ( jQuery.support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null ) &&
	              ( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

	            // Get the specific value for the option
	            value = jQuery( option ).val();

	            // We don't need an array for one selects
	            if ( one ) {
	              return value;
	            }

	            // Multi-Selects return an array
	            values.push( value );
	          }
	        }

	        return values;
	      },

	      set: function( elem, value ) {
	        var optionSet, option,
	          options = elem.options,
	          values = jQuery.makeArray( value ),
	          i = options.length;

	        while ( i-- ) {
	          option = options[ i ];
	          if ( (option.selected = jQuery.inArray( jQuery(option).val(), values ) >= 0) ) {
	            optionSet = true;
	          }
	        }

	        // force browsers to behave consistently when non-matching value is set
	        if ( !optionSet ) {
	          elem.selectedIndex = -1;
	        }
	        return values;
	      }
	    }
	  },

	  attr: function( elem, name, value ) {
	    var hooks, ret,
	      nType = elem.nodeType;

	    // don't get/set attributes on text, comment and attribute nodes
	    if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
	      return;
	    }

	    // Fallback to prop when attributes are not supported
	    if ( typeof elem.getAttribute === core_strundefined ) {
	      return jQuery.prop( elem, name, value );
	    }

	    // All attributes are lowercase
	    // Grab necessary hook if one is defined
	    if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	      name = name.toLowerCase();
	      hooks = jQuery.attrHooks[ name ] ||
	        ( jQuery.expr.match.boolean.test( name ) ? boolHook : nodeHook );
	    }

	    if ( value !== undefined ) {

	      if ( value === null ) {
	        jQuery.removeAttr( elem, name );

	      } else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
	        return ret;

	      } else {
	        elem.setAttribute( name, value + "" );
	        return value;
	      }

	    } else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
	      return ret;

	    } else {
	      ret = jQuery.find.attr( elem, name );

	      // Non-existent attributes return null, we normalize to undefined
	      return ret == null ?
	        undefined :
	        ret;
	    }
	  },

	  removeAttr: function( elem, value ) {
	    var name, propName,
	      i = 0,
	      attrNames = value && value.match( core_rnotwhite );

	    if ( attrNames && elem.nodeType === 1 ) {
	      while ( (name = attrNames[i++]) ) {
	        propName = jQuery.propFix[ name ] || name;

	        // Boolean attributes get special treatment (#10870)
	        if ( jQuery.expr.match.boolean.test( name ) ) {
	          // Set corresponding property to false
	          elem[ propName ] = false;
	        }

	        elem.removeAttribute( name );
	      }
	    }
	  },

	  attrHooks: {
	    type: {
	      set: function( elem, value ) {
	        if ( !jQuery.support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
	          // Setting the type on a radio button after the value resets the value in IE6-9
	          // Reset value to default in case type is set after value during creation
	          var val = elem.value;
	          elem.setAttribute( "type", value );
	          if ( val ) {
	            elem.value = val;
	          }
	          return value;
	        }
	      }
	    }
	  },

	  propFix: {
	    "for": "htmlFor",
	    "class": "className"
	  },

	  prop: function( elem, name, value ) {
	    var ret, hooks, notxml,
	      nType = elem.nodeType;

	    // don't get/set properties on text, comment and attribute nodes
	    if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
	      return;
	    }

	    notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

	    if ( notxml ) {
	      // Fix name and attach hooks
	      name = jQuery.propFix[ name ] || name;
	      hooks = jQuery.propHooks[ name ];
	    }

	    if ( value !== undefined ) {
	      return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
	        ret :
	        ( elem[ name ] = value );

	    } else {
	      return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
	        ret :
	        elem[ name ];
	    }
	  },

	  propHooks: {
	    tabIndex: {
	      get: function( elem ) {
	        return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
	          elem.tabIndex :
	          -1;
	      }
	    }
	  }
	});

	// Hooks for boolean attributes
	boolHook = {
	  set: function( elem, value, name ) {
	    if ( value === false ) {
	      // Remove boolean attributes when set to false
	      jQuery.removeAttr( elem, name );
	    } else {
	      elem.setAttribute( name, name );
	    }
	    return name;
	  }
	};
	jQuery.each( jQuery.expr.match.boolean.source.match( /\w+/g ), function( i, name ) {
	  var getter = jQuery.expr.attrHandle[ name ] || jQuery.find.attr;

	  jQuery.expr.attrHandle[ name ] = function( elem, name, isXML ) {
	    var fn = jQuery.expr.attrHandle[ name ],
	      ret = isXML ?
	        undefined :
	        /* jshint eqeqeq: false */
	        // Temporarily disable this handler to check existence
	        (jQuery.expr.attrHandle[ name ] = undefined) !=
	          getter( elem, name, isXML ) ?

	          name.toLowerCase() :
	          null;

	    // Restore handler
	    jQuery.expr.attrHandle[ name ] = fn;

	    return ret;
	  };
	});

	// Support: IE9+
	// Selectedness for an option in an optgroup can be inaccurate
	if ( !jQuery.support.optSelected ) {
	  jQuery.propHooks.selected = {
	    get: function( elem ) {
	      var parent = elem.parentNode;
	      if ( parent && parent.parentNode ) {
	        parent.parentNode.selectedIndex;
	      }
	      return null;
	    }
	  };
	}

	jQuery.each([
	  "tabIndex",
	  "readOnly",
	  "maxLength",
	  "cellSpacing",
	  "cellPadding",
	  "rowSpan",
	  "colSpan",
	  "useMap",
	  "frameBorder",
	  "contentEditable"
	], function() {
	  jQuery.propFix[ this.toLowerCase() ] = this;
	});

	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
	  jQuery.valHooks[ this ] = {
	    set: function( elem, value ) {
	      if ( jQuery.isArray( value ) ) {
	        return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
	      }
	    }
	  };
	  if ( !jQuery.support.checkOn ) {
	    jQuery.valHooks[ this ].get = function( elem ) {
	      // Support: Webkit
	      // "" is returned instead of "on" if a value isn't specified
	      return elem.getAttribute("value") === null ? "on" : elem.value;
	    };
	  }
	});
	var rkeyEvent = /^key/,
	  rmouseEvent = /^(?:mouse|contextmenu)|click/,
	  rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	  rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

	function returnTrue() {
	  return true;
	}

	function returnFalse() {
	  return false;
	}

	function safeActiveElement() {
	  try {
	    return document.activeElement;
	  } catch ( err ) { }
	}

	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {

	  global: {},

	  add: function( elem, types, handler, data, selector ) {

	    var handleObjIn, eventHandle, tmp,
	      events, t, handleObj,
	      special, handlers, type, namespaces, origType,
	      elemData = data_priv.get( elem );

	    // Don't attach events to noData or text/comment nodes (but allow plain objects)
	    if ( !elemData ) {
	      return;
	    }

	    // Caller can pass in an object of custom data in lieu of the handler
	    if ( handler.handler ) {
	      handleObjIn = handler;
	      handler = handleObjIn.handler;
	      selector = handleObjIn.selector;
	    }

	    // Make sure that the handler has a unique ID, used to find/remove it later
	    if ( !handler.guid ) {
	      handler.guid = jQuery.guid++;
	    }

	    // Init the element's event structure and main handler, if this is the first
	    if ( !(events = elemData.events) ) {
	      events = elemData.events = {};
	    }
	    if ( !(eventHandle = elemData.handle) ) {
	      eventHandle = elemData.handle = function( e ) {
	        // Discard the second event of a jQuery.event.trigger() and
	        // when an event is called after a page has unloaded
	        return typeof jQuery !== core_strundefined && (!e || jQuery.event.triggered !== e.type) ?
	          jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
	          undefined;
	      };
	      // Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
	      eventHandle.elem = elem;
	    }

	    // Handle multiple events separated by a space
	    types = ( types || "" ).match( core_rnotwhite ) || [""];
	    t = types.length;
	    while ( t-- ) {
	      tmp = rtypenamespace.exec( types[t] ) || [];
	      type = origType = tmp[1];
	      namespaces = ( tmp[2] || "" ).split( "." ).sort();

	      // There *must* be a type, no attaching namespace-only handlers
	      if ( !type ) {
	        continue;
	      }

	      // If event changes its type, use the special event handlers for the changed type
	      special = jQuery.event.special[ type ] || {};

	      // If selector defined, determine special event api type, otherwise given type
	      type = ( selector ? special.delegateType : special.bindType ) || type;

	      // Update special based on newly reset type
	      special = jQuery.event.special[ type ] || {};

	      // handleObj is passed to all event handlers
	      handleObj = jQuery.extend({
	        type: type,
	        origType: origType,
	        data: data,
	        handler: handler,
	        guid: handler.guid,
	        selector: selector,
	        needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
	        namespace: namespaces.join(".")
	      }, handleObjIn );

	      // Init the event handler queue if we're the first
	      if ( !(handlers = events[ type ]) ) {
	        handlers = events[ type ] = [];
	        handlers.delegateCount = 0;

	        // Only use addEventListener if the special events handler returns false
	        if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	          if ( elem.addEventListener ) {
	            elem.addEventListener( type, eventHandle, false );
	          }
	        }
	      }

	      if ( special.add ) {
	        special.add.call( elem, handleObj );

	        if ( !handleObj.handler.guid ) {
	          handleObj.handler.guid = handler.guid;
	        }
	      }

	      // Add to the element's handler list, delegates in front
	      if ( selector ) {
	        handlers.splice( handlers.delegateCount++, 0, handleObj );
	      } else {
	        handlers.push( handleObj );
	      }

	      // Keep track of which events have ever been used, for event optimization
	      jQuery.event.global[ type ] = true;
	    }

	    // Nullify elem to prevent memory leaks in IE
	    elem = null;
	  },

	  // Detach an event or set of events from an element
	  remove: function( elem, types, handler, selector, mappedTypes ) {

	    var j, origCount, tmp,
	      events, t, handleObj,
	      special, handlers, type, namespaces, origType,
	      elemData = data_priv.hasData( elem ) && data_priv.get( elem );

	    if ( !elemData || !(events = elemData.events) ) {
	      return;
	    }

	    // Once for each type.namespace in types; type may be omitted
	    types = ( types || "" ).match( core_rnotwhite ) || [""];
	    t = types.length;
	    while ( t-- ) {
	      tmp = rtypenamespace.exec( types[t] ) || [];
	      type = origType = tmp[1];
	      namespaces = ( tmp[2] || "" ).split( "." ).sort();

	      // Unbind all events (on this namespace, if provided) for the element
	      if ( !type ) {
	        for ( type in events ) {
	          jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
	        }
	        continue;
	      }

	      special = jQuery.event.special[ type ] || {};
	      type = ( selector ? special.delegateType : special.bindType ) || type;
	      handlers = events[ type ] || [];
	      tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

	      // Remove matching events
	      origCount = j = handlers.length;
	      while ( j-- ) {
	        handleObj = handlers[ j ];

	        if ( ( mappedTypes || origType === handleObj.origType ) &&
	          ( !handler || handler.guid === handleObj.guid ) &&
	          ( !tmp || tmp.test( handleObj.namespace ) ) &&
	          ( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
	          handlers.splice( j, 1 );

	          if ( handleObj.selector ) {
	            handlers.delegateCount--;
	          }
	          if ( special.remove ) {
	            special.remove.call( elem, handleObj );
	          }
	        }
	      }

	      // Remove generic event handler if we removed something and no more handlers exist
	      // (avoids potential for endless recursion during removal of special event handlers)
	      if ( origCount && !handlers.length ) {
	        if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	          jQuery.removeEvent( elem, type, elemData.handle );
	        }

	        delete events[ type ];
	      }
	    }

	    // Remove the expando if it's no longer used
	    if ( jQuery.isEmptyObject( events ) ) {
	      delete elemData.handle;
	      data_priv.remove( elem, "events" );
	    }
	  },

	  trigger: function( event, data, elem, onlyHandlers ) {

	    var i, cur, tmp, bubbleType, ontype, handle, special,
	      eventPath = [ elem || document ],
	      type = core_hasOwn.call( event, "type" ) ? event.type : event,
	      namespaces = core_hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

	    cur = tmp = elem = elem || document;

	    // Don't do events on text and comment nodes
	    if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
	      return;
	    }

	    // focus/blur morphs to focusin/out; ensure we're not firing them right now
	    if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
	      return;
	    }

	    if ( type.indexOf(".") >= 0 ) {
	      // Namespaced trigger; create a regexp to match event type in handle()
	      namespaces = type.split(".");
	      type = namespaces.shift();
	      namespaces.sort();
	    }
	    ontype = type.indexOf(":") < 0 && "on" + type;

	    // Caller can pass in a jQuery.Event object, Object, or just an event type string
	    event = event[ jQuery.expando ] ?
	      event :
	      new jQuery.Event( type, typeof event === "object" && event );

	    // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
	    event.isTrigger = onlyHandlers ? 2 : 3;
	    event.namespace = namespaces.join(".");
	    event.namespace_re = event.namespace ?
	      new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
	      null;

	    // Clean up the event in case it is being reused
	    event.result = undefined;
	    if ( !event.target ) {
	      event.target = elem;
	    }

	    // Clone any incoming data and prepend the event, creating the handler arg list
	    data = data == null ?
	      [ event ] :
	      jQuery.makeArray( data, [ event ] );

	    // Allow special events to draw outside the lines
	    special = jQuery.event.special[ type ] || {};
	    if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
	      return;
	    }

	    // Determine event propagation path in advance, per W3C events spec (#9951)
	    // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
	    if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

	      bubbleType = special.delegateType || type;
	      if ( !rfocusMorph.test( bubbleType + type ) ) {
	        cur = cur.parentNode;
	      }
	      for ( ; cur; cur = cur.parentNode ) {
	        eventPath.push( cur );
	        tmp = cur;
	      }

	      // Only add window if we got to document (e.g., not plain obj or detached DOM)
	      if ( tmp === (elem.ownerDocument || document) ) {
	        eventPath.push( tmp.defaultView || tmp.parentWindow || window );
	      }
	    }

	    // Fire handlers on the event path
	    i = 0;
	    while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

	      event.type = i > 1 ?
	        bubbleType :
	        special.bindType || type;

	      // jQuery handler
	      handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
	      if ( handle ) {
	        handle.apply( cur, data );
	      }

	      // Native handler
	      handle = ontype && cur[ ontype ];
	      if ( handle && jQuery.acceptData( cur ) && handle.apply && handle.apply( cur, data ) === false ) {
	        event.preventDefault();
	      }
	    }
	    event.type = type;

	    // If nobody prevented the default action, do it now
	    if ( !onlyHandlers && !event.isDefaultPrevented() ) {

	      if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
	        jQuery.acceptData( elem ) ) {

	        // Call a native DOM method on the target with the same name name as the event.
	        // Don't do default actions on window, that's where global variables be (#6170)
	        if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

	          // Don't re-trigger an onFOO event when we call its FOO() method
	          tmp = elem[ ontype ];

	          if ( tmp ) {
	            elem[ ontype ] = null;
	          }

	          // Prevent re-triggering of the same event, since we already bubbled it above
	          jQuery.event.triggered = type;
	          elem[ type ]();
	          jQuery.event.triggered = undefined;

	          if ( tmp ) {
	            elem[ ontype ] = tmp;
	          }
	        }
	      }
	    }

	    return event.result;
	  },

	  dispatch: function( event ) {

	    // Make a writable jQuery.Event from the native event object
	    event = jQuery.event.fix( event );

	    var i, j, ret, matched, handleObj,
	      handlerQueue = [],
	      args = core_slice.call( arguments ),
	      handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
	      special = jQuery.event.special[ event.type ] || {};

	    // Use the fix-ed jQuery.Event rather than the (read-only) native event
	    args[0] = event;
	    event.delegateTarget = this;

	    // Call the preDispatch hook for the mapped type, and let it bail if desired
	    if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
	      return;
	    }

	    // Determine handlers
	    handlerQueue = jQuery.event.handlers.call( this, event, handlers );

	    // Run delegates first; they may want to stop propagation beneath us
	    i = 0;
	    while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
	      event.currentTarget = matched.elem;

	      j = 0;
	      while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

	        // Triggered event must either 1) have no namespace, or
	        // 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
	        if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

	          event.handleObj = handleObj;
	          event.data = handleObj.data;

	          ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
	              .apply( matched.elem, args );

	          if ( ret !== undefined ) {
	            if ( (event.result = ret) === false ) {
	              event.preventDefault();
	              event.stopPropagation();
	            }
	          }
	        }
	      }
	    }

	    // Call the postDispatch hook for the mapped type
	    if ( special.postDispatch ) {
	      special.postDispatch.call( this, event );
	    }

	    return event.result;
	  },

	  handlers: function( event, handlers ) {
	    var i, matches, sel, handleObj,
	      handlerQueue = [],
	      delegateCount = handlers.delegateCount,
	      cur = event.target;

	    // Find delegate handlers
	    // Black-hole SVG <use> instance trees (#13180)
	    // Avoid non-left-click bubbling in Firefox (#3861)
	    if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

	      for ( ; cur !== this; cur = cur.parentNode || this ) {

	        // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
	        if ( cur.disabled !== true || event.type !== "click" ) {
	          matches = [];
	          for ( i = 0; i < delegateCount; i++ ) {
	            handleObj = handlers[ i ];

	            // Don't conflict with Object.prototype properties (#13203)
	            sel = handleObj.selector + " ";

	            if ( matches[ sel ] === undefined ) {
	              matches[ sel ] = handleObj.needsContext ?
	                jQuery( sel, this ).index( cur ) >= 0 :
	                jQuery.find( sel, this, null, [ cur ] ).length;
	            }
	            if ( matches[ sel ] ) {
	              matches.push( handleObj );
	            }
	          }
	          if ( matches.length ) {
	            handlerQueue.push({ elem: cur, handlers: matches });
	          }
	        }
	      }
	    }

	    // Add the remaining (directly-bound) handlers
	    if ( delegateCount < handlers.length ) {
	      handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
	    }

	    return handlerQueue;
	  },

	  // Includes some event props shared by KeyEvent and MouseEvent
	  props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	  fixHooks: {},

	  keyHooks: {
	    props: "char charCode key keyCode".split(" "),
	    filter: function( event, original ) {

	      // Add which for key events
	      if ( event.which == null ) {
	        event.which = original.charCode != null ? original.charCode : original.keyCode;
	      }

	      return event;
	    }
	  },

	  mouseHooks: {
	    props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
	    filter: function( event, original ) {
	      var eventDoc, doc, body,
	        button = original.button;

	      // Calculate pageX/Y if missing and clientX/Y available
	      if ( event.pageX == null && original.clientX != null ) {
	        eventDoc = event.target.ownerDocument || document;
	        doc = eventDoc.documentElement;
	        body = eventDoc.body;

	        event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
	        event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
	      }

	      // Add which for click: 1 === left; 2 === middle; 3 === right
	      // Note: button is not normalized, so don't use it
	      if ( !event.which && button !== undefined ) {
	        event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
	      }

	      return event;
	    }
	  },

	  fix: function( event ) {
	    if ( event[ jQuery.expando ] ) {
	      return event;
	    }

	    // Create a writable copy of the event object and normalize some properties
	    var i, prop, copy,
	      type = event.type,
	      originalEvent = event,
	      fixHook = this.fixHooks[ type ];

	    if ( !fixHook ) {
	      this.fixHooks[ type ] = fixHook =
	        rmouseEvent.test( type ) ? this.mouseHooks :
	        rkeyEvent.test( type ) ? this.keyHooks :
	        {};
	    }
	    copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

	    event = new jQuery.Event( originalEvent );

	    i = copy.length;
	    while ( i-- ) {
	      prop = copy[ i ];
	      event[ prop ] = originalEvent[ prop ];
	    }

	    // Support: Safari 6.0+, Chrome < 28
	    // Target should not be a text node (#504, #13143)
	    if ( event.target.nodeType === 3 ) {
	      event.target = event.target.parentNode;
	    }

	    return fixHook.filter? fixHook.filter( event, originalEvent ) : event;
	  },

	  special: {
	    load: {
	      // Prevent triggered image.load events from bubbling to window.load
	      noBubble: true
	    },
	    focus: {
	      // Fire native event if possible so blur/focus sequence is correct
	      trigger: function() {
	        if ( this !== safeActiveElement() && this.focus ) {
	          this.focus();
	          return false;
	        }
	      },
	      delegateType: "focusin"
	    },
	    blur: {
	      trigger: function() {
	        if ( this === safeActiveElement() && this.blur ) {
	          this.blur();
	          return false;
	        }
	      },
	      delegateType: "focusout"
	    },
	    click: {
	      // For checkbox, fire native event so checked state will be right
	      trigger: function() {
	        if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
	          this.click();
	          return false;
	        }
	      },

	      // For cross-browser consistency, don't fire native .click() on links
	      _default: function( event ) {
	        return jQuery.nodeName( event.target, "a" );
	      }
	    },

	    beforeunload: {
	      postDispatch: function( event ) {

	        // Support: Firefox 20+
	        // Firefox doesn't alert if the returnValue field is not set.
	        if ( event.result !== undefined ) {
	          event.originalEvent.returnValue = event.result;
	        }
	      }
	    }
	  },

	  simulate: function( type, elem, event, bubble ) {
	    // Piggyback on a donor event to simulate a different one.
	    // Fake originalEvent to avoid donor's stopPropagation, but if the
	    // simulated event prevents default then we do the same on the donor.
	    var e = jQuery.extend(
	      new jQuery.Event(),
	      event,
	      {
	        type: type,
	        isSimulated: true,
	        originalEvent: {}
	      }
	    );
	    if ( bubble ) {
	      jQuery.event.trigger( e, null, elem );
	    } else {
	      jQuery.event.dispatch.call( elem, e );
	    }
	    if ( e.isDefaultPrevented() ) {
	      event.preventDefault();
	    }
	  }
	};

	jQuery.removeEvent = function( elem, type, handle ) {
	  if ( elem.removeEventListener ) {
	    elem.removeEventListener( type, handle, false );
	  }
	};

	jQuery.Event = function( src, props ) {
	  // Allow instantiation without the 'new' keyword
	  if ( !(this instanceof jQuery.Event) ) {
	    return new jQuery.Event( src, props );
	  }

	  // Event object
	  if ( src && src.type ) {
	    this.originalEvent = src;
	    this.type = src.type;

	    // Events bubbling up the document may have been marked as prevented
	    // by a handler lower down the tree; reflect the correct value.
	    this.isDefaultPrevented = ( src.defaultPrevented ||
	      src.getPreventDefault && src.getPreventDefault() ) ? returnTrue : returnFalse;

	  // Event type
	  } else {
	    this.type = src;
	  }

	  // Put explicitly provided properties onto the event object
	  if ( props ) {
	    jQuery.extend( this, props );
	  }

	  // Create a timestamp if incoming event doesn't have one
	  this.timeStamp = src && src.timeStamp || jQuery.now();

	  // Mark it as fixed
	  this[ jQuery.expando ] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
	  isDefaultPrevented: returnFalse,
	  isPropagationStopped: returnFalse,
	  isImmediatePropagationStopped: returnFalse,

	  preventDefault: function() {
	    var e = this.originalEvent;

	    this.isDefaultPrevented = returnTrue;

	    if ( e && e.preventDefault ) {
	      e.preventDefault();
	    }
	  },
	  stopPropagation: function() {
	    var e = this.originalEvent;

	    this.isPropagationStopped = returnTrue;

	    if ( e && e.stopPropagation ) {
	      e.stopPropagation();
	    }
	  },
	  stopImmediatePropagation: function() {
	    this.isImmediatePropagationStopped = returnTrue;
	    this.stopPropagation();
	  }
	};

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// Support: Chrome 15+
	jQuery.each({
	  mouseenter: "mouseover",
	  mouseleave: "mouseout"
	}, function( orig, fix ) {
	  jQuery.event.special[ orig ] = {
	    delegateType: fix,
	    bindType: fix,

	    handle: function( event ) {
	      var ret,
	        target = this,
	        related = event.relatedTarget,
	        handleObj = event.handleObj;

	      // For mousenter/leave call the handler if related is outside the target.
	      // NB: No relatedTarget if the mouse left/entered the browser window
	      if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
	        event.type = handleObj.origType;
	        ret = handleObj.handler.apply( this, arguments );
	        event.type = fix;
	      }
	      return ret;
	    }
	  };
	});

	// Create "bubbling" focus and blur events
	// Support: Firefox, Chrome, Safari
	if ( !jQuery.support.focusinBubbles ) {
	  jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

	    // Attach a single capturing handler while someone wants focusin/focusout
	    var attaches = 0,
	      handler = function( event ) {
	        jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
	      };

	    jQuery.event.special[ fix ] = {
	      setup: function() {
	        if ( attaches++ === 0 ) {
	          document.addEventListener( orig, handler, true );
	        }
	      },
	      teardown: function() {
	        if ( --attaches === 0 ) {
	          document.removeEventListener( orig, handler, true );
	        }
	      }
	    };
	  });
	}

	jQuery.fn.extend({

	  on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
	    var origFn, type;

	    // Types can be a map of types/handlers
	    if ( typeof types === "object" ) {
	      // ( types-Object, selector, data )
	      if ( typeof selector !== "string" ) {
	        // ( types-Object, data )
	        data = data || selector;
	        selector = undefined;
	      }
	      for ( type in types ) {
	        this.on( type, selector, data, types[ type ], one );
	      }
	      return this;
	    }

	    if ( data == null && fn == null ) {
	      // ( types, fn )
	      fn = selector;
	      data = selector = undefined;
	    } else if ( fn == null ) {
	      if ( typeof selector === "string" ) {
	        // ( types, selector, fn )
	        fn = data;
	        data = undefined;
	      } else {
	        // ( types, data, fn )
	        fn = data;
	        data = selector;
	        selector = undefined;
	      }
	    }
	    if ( fn === false ) {
	      fn = returnFalse;
	    } else if ( !fn ) {
	      return this;
	    }

	    if ( one === 1 ) {
	      origFn = fn;
	      fn = function( event ) {
	        // Can use an empty set, since event contains the info
	        jQuery().off( event );
	        return origFn.apply( this, arguments );
	      };
	      // Use same guid so caller can remove using origFn
	      fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	    }
	    return this.each( function() {
	      jQuery.event.add( this, types, fn, data, selector );
	    });
	  },
	  one: function( types, selector, data, fn ) {
	    return this.on( types, selector, data, fn, 1 );
	  },
	  off: function( types, selector, fn ) {
	    var handleObj, type;
	    if ( types && types.preventDefault && types.handleObj ) {
	      // ( event )  dispatched jQuery.Event
	      handleObj = types.handleObj;
	      jQuery( types.delegateTarget ).off(
	        handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
	        handleObj.selector,
	        handleObj.handler
	      );
	      return this;
	    }
	    if ( typeof types === "object" ) {
	      // ( types-object [, selector] )
	      for ( type in types ) {
	        this.off( type, selector, types[ type ] );
	      }
	      return this;
	    }
	    if ( selector === false || typeof selector === "function" ) {
	      // ( types [, fn] )
	      fn = selector;
	      selector = undefined;
	    }
	    if ( fn === false ) {
	      fn = returnFalse;
	    }
	    return this.each(function() {
	      jQuery.event.remove( this, types, fn, selector );
	    });
	  },

	  trigger: function( type, data ) {
	    return this.each(function() {
	      jQuery.event.trigger( type, data, this );
	    });
	  },
	  triggerHandler: function( type, data ) {
	    var elem = this[0];
	    if ( elem ) {
	      return jQuery.event.trigger( type, data, elem, true );
	    }
	  }
	});
	var isSimple = /^.[^:#\[\.,]*$/,
	  rneedsContext = jQuery.expr.match.needsContext,
	  // methods guaranteed to produce a unique set when starting from a unique set
	  guaranteedUnique = {
	    children: true,
	    contents: true,
	    next: true,
	    prev: true
	  };

	jQuery.fn.extend({
	  find: function( selector ) {
	    var self, matched, i,
	      l = this.length;

	    if ( typeof selector !== "string" ) {
	      self = this;
	      return this.pushStack( jQuery( selector ).filter(function() {
	        for ( i = 0; i < l; i++ ) {
	          if ( jQuery.contains( self[ i ], this ) ) {
	            return true;
	          }
	        }
	      }) );
	    }

	    matched = [];
	    for ( i = 0; i < l; i++ ) {
	      jQuery.find( selector, this[ i ], matched );
	    }

	    // Needed because $( selector, context ) becomes $( context ).find( selector )
	    matched = this.pushStack( l > 1 ? jQuery.unique( matched ) : matched );
	    matched.selector = ( this.selector ? this.selector + " " : "" ) + selector;
	    return matched;
	  },

	  has: function( target ) {
	    var targets = jQuery( target, this ),
	      l = targets.length;

	    return this.filter(function() {
	      var i = 0;
	      for ( ; i < l; i++ ) {
	        if ( jQuery.contains( this, targets[i] ) ) {
	          return true;
	        }
	      }
	    });
	  },

	  not: function( selector ) {
	    return this.pushStack( winnow(this, selector || [], true) );
	  },

	  filter: function( selector ) {
	    return this.pushStack( winnow(this, selector || [], false) );
	  },

	  is: function( selector ) {
	    return !!selector && (
	      typeof selector === "string" ?
	        // If this is a positional/relative selector, check membership in the returned set
	        // so $("p:first").is("p:last") won't return true for a doc with two "p".
	        rneedsContext.test( selector ) ?
	          jQuery( selector, this.context ).index( this[ 0 ] ) >= 0 :
	          jQuery.filter( selector, this ).length > 0 :
	        this.filter( selector ).length > 0 );
	  },

	  closest: function( selectors, context ) {
	    var cur,
	      i = 0,
	      l = this.length,
	      matched = [],
	      pos = ( rneedsContext.test( selectors ) || typeof selectors !== "string" ) ?
	        jQuery( selectors, context || this.context ) :
	        0;

	    for ( ; i < l; i++ ) {
	      for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
	        // Always skip document fragments
	        if ( cur.nodeType < 11 && (pos ?
	          pos.index(cur) > -1 :

	          // Don't pass non-elements to Sizzle
	          cur.nodeType === 1 &&
	            jQuery.find.matchesSelector(cur, selectors)) ) {

	          cur = matched.push( cur );
	          break;
	        }
	      }
	    }

	    return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	  },

	  // Determine the position of an element within
	  // the matched set of elements
	  index: function( elem ) {

	    // No argument, return index in parent
	    if ( !elem ) {
	      return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
	    }

	    // index in selector
	    if ( typeof elem === "string" ) {
	      return core_indexOf.call( jQuery( elem ), this[ 0 ] );
	    }

	    // Locate the position of the desired element
	    return core_indexOf.call( this,

	      // If it receives a jQuery object, the first element is used
	      elem.jquery ? elem[ 0 ] : elem
	    );
	  },

	  add: function( selector, context ) {
	    var set = typeof selector === "string" ?
	        jQuery( selector, context ) :
	        jQuery.makeArray( selector && selector.nodeType ? [ selector ] : selector ),
	      all = jQuery.merge( this.get(), set );

	    return this.pushStack( jQuery.unique(all) );
	  },

	  addBack: function( selector ) {
	    return this.add( selector == null ?
	      this.prevObject : this.prevObject.filter(selector)
	    );
	  }
	});

	function sibling( cur, dir ) {
	  while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}

	  return cur;
	}

	jQuery.each({
	  parent: function( elem ) {
	    var parent = elem.parentNode;
	    return parent && parent.nodeType !== 11 ? parent : null;
	  },
	  parents: function( elem ) {
	    return jQuery.dir( elem, "parentNode" );
	  },
	  parentsUntil: function( elem, i, until ) {
	    return jQuery.dir( elem, "parentNode", until );
	  },
	  next: function( elem ) {
	    return sibling( elem, "nextSibling" );
	  },
	  prev: function( elem ) {
	    return sibling( elem, "previousSibling" );
	  },
	  nextAll: function( elem ) {
	    return jQuery.dir( elem, "nextSibling" );
	  },
	  prevAll: function( elem ) {
	    return jQuery.dir( elem, "previousSibling" );
	  },
	  nextUntil: function( elem, i, until ) {
	    return jQuery.dir( elem, "nextSibling", until );
	  },
	  prevUntil: function( elem, i, until ) {
	    return jQuery.dir( elem, "previousSibling", until );
	  },
	  siblings: function( elem ) {
	    return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	  },
	  children: function( elem ) {
	    return jQuery.sibling( elem.firstChild );
	  },
	  contents: function( elem ) {
	    return jQuery.nodeName( elem, "iframe" ) ?
	      elem.contentDocument || elem.contentWindow.document :
	      jQuery.merge( [], elem.childNodes );
	  }
	}, function( name, fn ) {
	  jQuery.fn[ name ] = function( until, selector ) {
	    var matched = jQuery.map( this, fn, until );

	    if ( name.slice( -5 ) !== "Until" ) {
	      selector = until;
	    }

	    if ( selector && typeof selector === "string" ) {
	      matched = jQuery.filter( selector, matched );
	    }

	    if ( this.length > 1 ) {
	      // Remove duplicates
	      if ( !guaranteedUnique[ name ] ) {
	        jQuery.unique( matched );
	      }

	      // Reverse order for parents* and prev*
	      if ( name[ 0 ] === "p" ) {
	        matched.reverse();
	      }
	    }

	    return this.pushStack( matched );
	  };
	});

	jQuery.extend({
	  filter: function( expr, elems, not ) {
	    var elem = elems[ 0 ];

	    if ( not ) {
	      expr = ":not(" + expr + ")";
	    }

	    return elems.length === 1 && elem.nodeType === 1 ?
	      jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
	      jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
	        return elem.nodeType === 1;
	      }));
	  },

	  dir: function( elem, dir, until ) {
	    var matched = [],
	      truncate = until !== undefined;

	    while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
	      if ( elem.nodeType === 1 ) {
	        if ( truncate && jQuery( elem ).is( until ) ) {
	          break;
	        }
	        matched.push( elem );
	      }
	    }
	    return matched;
	  },

	  sibling: function( n, elem ) {
	    var matched = [];

	    for ( ; n; n = n.nextSibling ) {
	      if ( n.nodeType === 1 && n !== elem ) {
	        matched.push( n );
	      }
	    }

	    return matched;
	  }
	});

	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
	  if ( jQuery.isFunction( qualifier ) ) {
	    return jQuery.grep( elements, function( elem, i ) {
	      /* jshint -W018 */
	      return !!qualifier.call( elem, i, elem ) !== not;
	    });

	  }

	  if ( qualifier.nodeType ) {
	    return jQuery.grep( elements, function( elem ) {
	      return ( elem === qualifier ) !== not;
	    });

	  }

	  if ( typeof qualifier === "string" ) {
	    if ( isSimple.test( qualifier ) ) {
	      return jQuery.filter( qualifier, elements, not );
	    }

	    qualifier = jQuery.filter( qualifier, elements );
	  }

	  return jQuery.grep( elements, function( elem ) {
	    return ( core_indexOf.call( qualifier, elem ) >= 0 ) !== not;
	  });
	}
	var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	  rtagName = /<([\w:]+)/,
	  rhtml = /<|&#?\w+;/,
	  rnoInnerhtml = /<(?:script|style|link)/i,
	  manipulation_rcheckableType = /^(?:checkbox|radio)$/i,
	  // checked="checked" or checked
	  rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	  rscriptType = /^$|\/(?:java|ecma)script/i,
	  rscriptTypeMasked = /^true\/(.*)/,
	  rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	  // We have to close these tags to support XHTML (#13200)
	  wrapMap = {

	    // Support: IE 9
	    option: [ 1, "<select multiple='multiple'>", "</select>" ],

	    thead: [ 1, "<table>", "</table>" ],
	    tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	    td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	    _default: [ 0, "", "" ]
	  };

	// Support: IE 9
	wrapMap.optgroup = wrapMap.option;

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.col = wrapMap.thead;
	wrapMap.th = wrapMap.td;

	jQuery.fn.extend({
	  text: function( value ) {
	    return jQuery.access( this, function( value ) {
	      return value === undefined ?
	        jQuery.text( this ) :
	        this.empty().append( ( this[ 0 ] && this[ 0 ].ownerDocument || document ).createTextNode( value ) );
	    }, null, value, arguments.length );
	  },

	  append: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
	        var target = manipulationTarget( this, elem );
	        target.appendChild( elem );
	      }
	    });
	  },

	  prepend: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
	        var target = manipulationTarget( this, elem );
	        target.insertBefore( elem, target.firstChild );
	      }
	    });
	  },

	  before: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.parentNode ) {
	        this.parentNode.insertBefore( elem, this );
	      }
	    });
	  },

	  after: function() {
	    return this.domManip( arguments, function( elem ) {
	      if ( this.parentNode ) {
	        this.parentNode.insertBefore( elem, this.nextSibling );
	      }
	    });
	  },

	  // keepData is for internal use only--do not document
	  remove: function( selector, keepData ) {
	    var elem,
	      elems = selector ? jQuery.filter( selector, this ) : this,
	      i = 0;

	    for ( ; (elem = elems[i]) != null; i++ ) {
	      if ( !keepData && elem.nodeType === 1 ) {
	        jQuery.cleanData( getAll( elem ) );
	      }

	      if ( elem.parentNode ) {
	        if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
	          setGlobalEval( getAll( elem, "script" ) );
	        }
	        elem.parentNode.removeChild( elem );
	      }
	    }

	    return this;
	  },

	  empty: function() {
	    var elem,
	      i = 0;

	    for ( ; (elem = this[i]) != null; i++ ) {
	      if ( elem.nodeType === 1 ) {

	        // Prevent memory leaks
	        jQuery.cleanData( getAll( elem, false ) );

	        // Remove any remaining nodes
	        elem.textContent = "";
	      }
	    }

	    return this;
	  },

	  clone: function( dataAndEvents, deepDataAndEvents ) {
	    dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
	    deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

	    return this.map( function () {
	      return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
	    });
	  },

	  html: function( value ) {
	    return jQuery.access( this, function( value ) {
	      var elem = this[ 0 ] || {},
	        i = 0,
	        l = this.length;

	      if ( value === undefined && elem.nodeType === 1 ) {
	        return elem.innerHTML;
	      }

	      // See if we can take a shortcut and just use innerHTML
	      if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
	        !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

	        value = value.replace( rxhtmlTag, "<$1></$2>" );

	        try {
	          for ( ; i < l; i++ ) {
	            elem = this[ i ] || {};

	            // Remove element nodes and prevent memory leaks
	            if ( elem.nodeType === 1 ) {
	              jQuery.cleanData( getAll( elem, false ) );
	              elem.innerHTML = value;
	            }
	          }

	          elem = 0;

	        // If using innerHTML throws an exception, use the fallback method
	        } catch( e ) {}
	      }

	      if ( elem ) {
	        this.empty().append( value );
	      }
	    }, null, value, arguments.length );
	  },

	  replaceWith: function() {
	    var
	      // Snapshot the DOM in case .domManip sweeps something relevant into its fragment
	      args = jQuery.map( this, function( elem ) {
	        return [ elem.nextSibling, elem.parentNode ];
	      }),
	      i = 0;

	    // Make the changes, replacing each context element with the new content
	    this.domManip( arguments, function( elem ) {
	      var next = args[ i++ ],
	        parent = args[ i++ ];

	      if ( parent ) {
	        jQuery( this ).remove();
	        parent.insertBefore( elem, next );
	      }
	    // Allow new content to include elements from the context set
	    }, true );

	    // Force removal if there was no new content (e.g., from empty arguments)
	    return i ? this : this.remove();
	  },

	  detach: function( selector ) {
	    return this.remove( selector, true );
	  },

	  domManip: function( args, callback, allowIntersection ) {

	    // Flatten any nested arrays
	    args = core_concat.apply( [], args );

	    var fragment, first, scripts, hasScripts, node, doc,
	      i = 0,
	      l = this.length,
	      set = this,
	      iNoClone = l - 1,
	      value = args[ 0 ],
	      isFunction = jQuery.isFunction( value );

	    // We can't cloneNode fragments that contain checked, in WebKit
	    if ( isFunction || !( l <= 1 || typeof value !== "string" || jQuery.support.checkClone || !rchecked.test( value ) ) ) {
	      return this.each(function( index ) {
	        var self = set.eq( index );
	        if ( isFunction ) {
	          args[ 0 ] = value.call( this, index, self.html() );
	        }
	        self.domManip( args, callback, allowIntersection );
	      });
	    }

	    if ( l ) {
	      fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, !allowIntersection && this );
	      first = fragment.firstChild;

	      if ( fragment.childNodes.length === 1 ) {
	        fragment = first;
	      }

	      if ( first ) {
	        scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
	        hasScripts = scripts.length;

	        // Use the original fragment for the last item instead of the first because it can end up
	        // being emptied incorrectly in certain situations (#8070).
	        for ( ; i < l; i++ ) {
	          node = fragment;

	          if ( i !== iNoClone ) {
	            node = jQuery.clone( node, true, true );

	            // Keep references to cloned scripts for later restoration
	            if ( hasScripts ) {
	              // Support: QtWebKit
	              // jQuery.merge because core_push.apply(_, arraylike) throws
	              jQuery.merge( scripts, getAll( node, "script" ) );
	            }
	          }

	          callback.call( this[ i ], node, i );
	        }

	        if ( hasScripts ) {
	          doc = scripts[ scripts.length - 1 ].ownerDocument;

	          // Reenable scripts
	          jQuery.map( scripts, restoreScript );

	          // Evaluate executable scripts on first document insertion
	          for ( i = 0; i < hasScripts; i++ ) {
	            node = scripts[ i ];
	            if ( rscriptType.test( node.type || "" ) &&
	              !data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

	              if ( node.src ) {
	                // Hope ajax is available...
	                jQuery._evalUrl( node.src );
	              } else {
	                jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
	              }
	            }
	          }
	        }
	      }
	    }

	    return this;
	  }
	});

	jQuery.each({
	  appendTo: "append",
	  prependTo: "prepend",
	  insertBefore: "before",
	  insertAfter: "after",
	  replaceAll: "replaceWith"
	}, function( name, original ) {
	  jQuery.fn[ name ] = function( selector ) {
	    var elems,
	      ret = [],
	      insert = jQuery( selector ),
	      last = insert.length - 1,
	      i = 0;

	    for ( ; i <= last; i++ ) {
	      elems = i === last ? this : this.clone( true );
	      jQuery( insert[ i ] )[ original ]( elems );

	      // Support: QtWebKit
	      // .get() because core_push.apply(_, arraylike) throws
	      core_push.apply( ret, elems.get() );
	    }

	    return this.pushStack( ret );
	  };
	});

	jQuery.extend({
	  clone: function( elem, dataAndEvents, deepDataAndEvents ) {
	    var i, l, srcElements, destElements,
	      clone = elem.cloneNode( true ),
	      inPage = jQuery.contains( elem.ownerDocument, elem );

	    // Support: IE >= 9
	    // Fix Cloning issues
	    if ( !jQuery.support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) && !jQuery.isXMLDoc( elem ) ) {

	      // We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
	      destElements = getAll( clone );
	      srcElements = getAll( elem );

	      for ( i = 0, l = srcElements.length; i < l; i++ ) {
	        fixInput( srcElements[ i ], destElements[ i ] );
	      }
	    }

	    // Copy the events from the original to the clone
	    if ( dataAndEvents ) {
	      if ( deepDataAndEvents ) {
	        srcElements = srcElements || getAll( elem );
	        destElements = destElements || getAll( clone );

	        for ( i = 0, l = srcElements.length; i < l; i++ ) {
	          cloneCopyEvent( srcElements[ i ], destElements[ i ] );
	        }
	      } else {
	        cloneCopyEvent( elem, clone );
	      }
	    }

	    // Preserve script evaluation history
	    destElements = getAll( clone, "script" );
	    if ( destElements.length > 0 ) {
	      setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
	    }

	    // Return the cloned set
	    return clone;
	  },

	  buildFragment: function( elems, context, scripts, selection ) {
	    var elem, tmp, tag, wrap, contains, j,
	      i = 0,
	      l = elems.length,
	      fragment = context.createDocumentFragment(),
	      nodes = [];

	    for ( ; i < l; i++ ) {
	      elem = elems[ i ];

	      if ( elem || elem === 0 ) {

	        // Add nodes directly
	        if ( jQuery.type( elem ) === "object" ) {
	          // Support: QtWebKit
	          // jQuery.merge because core_push.apply(_, arraylike) throws
	          jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

	        // Convert non-html into a text node
	        } else if ( !rhtml.test( elem ) ) {
	          nodes.push( context.createTextNode( elem ) );

	        // Convert html into DOM nodes
	        } else {
	          tmp = tmp || fragment.appendChild( context.createElement("div") );

	          // Deserialize a standard representation
	          tag = ( rtagName.exec( elem ) || ["", ""] )[ 1 ].toLowerCase();
	          wrap = wrapMap[ tag ] || wrapMap._default;
	          tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

	          // Descend through wrappers to the right content
	          j = wrap[ 0 ];
	          while ( j-- ) {
	            tmp = tmp.firstChild;
	          }

	          // Support: QtWebKit
	          // jQuery.merge because core_push.apply(_, arraylike) throws
	          jQuery.merge( nodes, tmp.childNodes );

	          // Remember the top-level container
	          tmp = fragment.firstChild;

	          // Fixes #12346
	          // Support: Webkit, IE
	          tmp.textContent = "";
	        }
	      }
	    }

	    // Remove wrapper from fragment
	    fragment.textContent = "";

	    i = 0;
	    while ( (elem = nodes[ i++ ]) ) {

	      // #4087 - If origin and destination elements are the same, and this is
	      // that element, do not do anything
	      if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
	        continue;
	      }

	      contains = jQuery.contains( elem.ownerDocument, elem );

	      // Append to fragment
	      tmp = getAll( fragment.appendChild( elem ), "script" );

	      // Preserve script evaluation history
	      if ( contains ) {
	        setGlobalEval( tmp );
	      }

	      // Capture executables
	      if ( scripts ) {
	        j = 0;
	        while ( (elem = tmp[ j++ ]) ) {
	          if ( rscriptType.test( elem.type || "" ) ) {
	            scripts.push( elem );
	          }
	        }
	      }
	    }

	    return fragment;
	  },

	  cleanData: function( elems ) {
	    var data, elem, type,
	      l = elems.length,
	      i = 0,
	      special = jQuery.event.special;

	    for ( ; i < l; i++ ) {
	      elem = elems[ i ];

	      if ( jQuery.acceptData( elem ) ) {

	        data = data_priv.access( elem );

	        if ( data ) {
	          for ( type in data.events ) {
	            if ( special[ type ] ) {
	              jQuery.event.remove( elem, type );

	            // This is a shortcut to avoid jQuery.event.remove's overhead
	            } else {
	              jQuery.removeEvent( elem, type, data.handle );
	            }
	          }
	        }
	      }
	      // Discard any remaining `private` and `user` data
	      // One day we'll replace the dual arrays with a WeakMap and this won't be an issue.
	      // (Splices the data objects out of the internal cache arrays)
	      data_user.discard( elem );
	      data_priv.discard( elem );
	    }
	  },

	  _evalUrl: function( url ) {
	    return jQuery.ajax({
	      url: url,
	      type: "GET",
	      dataType: "text",
	      async: false,
	      global: false,
	      success: jQuery.globalEval
	    });
	  }
	});

	// Support: 1.x compatibility
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
	  return jQuery.nodeName( elem, "table" ) &&
	    jQuery.nodeName( content.nodeType === 1 ? content : content.firstChild, "tr" ) ?

	    elem.getElementsByTagName("tbody")[0] ||
	      elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
	    elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
	  elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	  return elem;
	}
	function restoreScript( elem ) {
	  var match = rscriptTypeMasked.exec( elem.type );

	  if ( match ) {
	    elem.type = match[ 1 ];
	  } else {
	    elem.removeAttribute("type");
	  }

	  return elem;
	}

	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
	  var l = elems.length,
	    i = 0;

	  for ( ; i < l; i++ ) {
	    data_priv.set(
	      elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
	    );
	  }
	}

	function cloneCopyEvent( src, dest ) {
	  var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	  if ( dest.nodeType !== 1 ) {
	    return;
	  }

	  // 1. Copy private data: events, handlers, etc.
	  if ( data_priv.hasData( src ) ) {
	    pdataOld = data_priv.access( src );
	    pdataCur = jQuery.extend( {}, pdataOld );
	    events = pdataOld.events;

	    data_priv.set( dest, pdataCur );

	    if ( events ) {
	      delete pdataCur.handle;
	      pdataCur.events = {};

	      for ( type in events ) {
	        for ( i = 0, l = events[ type ].length; i < l; i++ ) {
	          jQuery.event.add( dest, type, events[ type ][ i ] );
	        }
	      }
	    }
	  }

	  // 2. Copy user data
	  if ( data_user.hasData( src ) ) {
	    udataOld = data_user.access( src );
	    udataCur = jQuery.extend( {}, udataOld );

	    data_user.set( dest, udataCur );
	  }
	}


	function getAll( context, tag ) {
	  var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
	      context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
	      [];

	  return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
	    jQuery.merge( [ context ], ret ) :
	    ret;
	}

	// Support: IE >= 9
	function fixInput( src, dest ) {
	  var nodeName = dest.nodeName.toLowerCase();

	  // Fails to persist the checked state of a cloned checkbox or radio button.
	  if ( nodeName === "input" && manipulation_rcheckableType.test( src.type ) ) {
	    dest.checked = src.checked;

	  // Fails to return the selected option to the default selected state when cloning options
	  } else if ( nodeName === "input" || nodeName === "textarea" ) {
	    dest.defaultValue = src.defaultValue;
	  }
	}
	jQuery.fn.extend({
	  wrapAll: function( html ) {
	    var wrap;

	    if ( jQuery.isFunction( html ) ) {
	      return this.each(function( i ) {
	        jQuery( this ).wrapAll( html.call(this, i) );
	      });
	    }

	    if ( this[ 0 ] ) {

	      // The elements to wrap the target around
	      wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

	      if ( this[ 0 ].parentNode ) {
	        wrap.insertBefore( this[ 0 ] );
	      }

	      wrap.map(function() {
	        var elem = this;

	        while ( elem.firstElementChild ) {
	          elem = elem.firstElementChild;
	        }

	        return elem;
	      }).append( this );
	    }

	    return this;
	  },

	  wrapInner: function( html ) {
	    if ( jQuery.isFunction( html ) ) {
	      return this.each(function( i ) {
	        jQuery( this ).wrapInner( html.call(this, i) );
	      });
	    }

	    return this.each(function() {
	      var self = jQuery( this ),
	        contents = self.contents();

	      if ( contents.length ) {
	        contents.wrapAll( html );

	      } else {
	        self.append( html );
	      }
	    });
	  },

	  wrap: function( html ) {
	    var isFunction = jQuery.isFunction( html );

	    return this.each(function( i ) {
	      jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
	    });
	  },

	  unwrap: function() {
	    return this.parent().each(function() {
	      if ( !jQuery.nodeName( this, "body" ) ) {
	        jQuery( this ).replaceWith( this.childNodes );
	      }
	    }).end();
	  }
	});
	var curCSS, iframe,
	  // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	  // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	  rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	  rmargin = /^margin/,
	  rnumsplit = new RegExp( "^(" + core_pnum + ")(.*)$", "i" ),
	  rnumnonpx = new RegExp( "^(" + core_pnum + ")(?!px)[a-z%]+$", "i" ),
	  rrelNum = new RegExp( "^([+-])=(" + core_pnum + ")", "i" ),
	  elemdisplay = { BODY: "block" },

	  cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	  cssNormalTransform = {
	    letterSpacing: 0,
	    fontWeight: 400
	  },

	  cssExpand = [ "Top", "Right", "Bottom", "Left" ],
	  cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {

	  // shortcut for names that are not vendor prefixed
	  if ( name in style ) {
	    return name;
	  }

	  // check for vendor prefixed names
	  var capName = name.charAt(0).toUpperCase() + name.slice(1),
	    origName = name,
	    i = cssPrefixes.length;

	  while ( i-- ) {
	    name = cssPrefixes[ i ] + capName;
	    if ( name in style ) {
	      return name;
	    }
	  }

	  return origName;
	}

	function isHidden( elem, el ) {
	  // isHidden might be called from jQuery#filter function;
	  // in that case, element will be second argument
	  elem = el || elem;
	  return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	}

	// NOTE: we've included the "window" in window.getComputedStyle
	// because jsdom on node.js will break without it.
	function getStyles( elem ) {
	  return window.getComputedStyle( elem, null );
	}

	function showHide( elements, show ) {
	  var display, elem, hidden,
	    values = [],
	    index = 0,
	    length = elements.length;

	  for ( ; index < length; index++ ) {
	    elem = elements[ index ];
	    if ( !elem.style ) {
	      continue;
	    }

	    values[ index ] = data_priv.get( elem, "olddisplay" );
	    display = elem.style.display;
	    if ( show ) {
	      // Reset the inline display of this element to learn if it is
	      // being hidden by cascaded rules or not
	      if ( !values[ index ] && display === "none" ) {
	        elem.style.display = "";
	      }

	      // Set elements which have been overridden with display: none
	      // in a stylesheet to whatever the default browser style is
	      // for such an element
	      if ( elem.style.display === "" && isHidden( elem ) ) {
	        values[ index ] = data_priv.access( elem, "olddisplay", css_defaultDisplay(elem.nodeName) );
	      }
	    } else {

	      if ( !values[ index ] ) {
	        hidden = isHidden( elem );

	        if ( display && display !== "none" || !hidden ) {
	          data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css(elem, "display") );
	        }
	      }
	    }
	  }

	  // Set the display of most of the elements in a second loop
	  // to avoid the constant reflow
	  for ( index = 0; index < length; index++ ) {
	    elem = elements[ index ];
	    if ( !elem.style ) {
	      continue;
	    }
	    if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
	      elem.style.display = show ? values[ index ] || "" : "none";
	    }
	  }

	  return elements;
	}

	jQuery.fn.extend({
	  css: function( name, value ) {
	    return jQuery.access( this, function( elem, name, value ) {
	      var styles, len,
	        map = {},
	        i = 0;

	      if ( jQuery.isArray( name ) ) {
	        styles = getStyles( elem );
	        len = name.length;

	        for ( ; i < len; i++ ) {
	          map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
	        }

	        return map;
	      }

	      return value !== undefined ?
	        jQuery.style( elem, name, value ) :
	        jQuery.css( elem, name );
	    }, name, value, arguments.length > 1 );
	  },
	  show: function() {
	    return showHide( this, true );
	  },
	  hide: function() {
	    return showHide( this );
	  },
	  toggle: function( state ) {
	    var bool = typeof state === "boolean";

	    return this.each(function() {
	      if ( bool ? state : isHidden( this ) ) {
	        jQuery( this ).show();
	      } else {
	        jQuery( this ).hide();
	      }
	    });
	  }
	});

	jQuery.extend({
	  // Add in style property hooks for overriding the default
	  // behavior of getting and setting a style property
	  cssHooks: {
	    opacity: {
	      get: function( elem, computed ) {
	        if ( computed ) {
	          // We should always get a number back from opacity
	          var ret = curCSS( elem, "opacity" );
	          return ret === "" ? "1" : ret;
	        }
	      }
	    }
	  },

	  // Exclude the following css properties to add px
	  cssNumber: {
	    "columnCount": true,
	    "fillOpacity": true,
	    "fontWeight": true,
	    "lineHeight": true,
	    "opacity": true,
	    "orphans": true,
	    "widows": true,
	    "zIndex": true,
	    "zoom": true
	  },

	  // Add in properties whose names you wish to fix before
	  // setting or getting the value
	  cssProps: {
	    // normalize float css property
	    "float": "cssFloat"
	  },

	  // Get and set the style property on a DOM Node
	  style: function( elem, name, value, extra ) {
	    // Don't set styles on text and comment nodes
	    if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
	      return;
	    }

	    // Make sure that we're working with the right name
	    var ret, type, hooks,
	      origName = jQuery.camelCase( name ),
	      style = elem.style;

	    name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

	    // gets hook for the prefixed version
	    // followed by the unprefixed version
	    hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

	    // Check if we're setting a value
	    if ( value !== undefined ) {
	      type = typeof value;

	      // convert relative number strings (+= or -=) to relative numbers. #7345
	      if ( type === "string" && (ret = rrelNum.exec( value )) ) {
	        value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
	        // Fixes bug #9237
	        type = "number";
	      }

	      // Make sure that NaN and null values aren't set. See: #7116
	      if ( value == null || type === "number" && isNaN( value ) ) {
	        return;
	      }

	      // If a number was passed in, add 'px' to the (except for certain CSS properties)
	      if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
	        value += "px";
	      }

	      // Fixes #8908, it can be done more correctly by specifying setters in cssHooks,
	      // but it would mean to define eight (for every problematic property) identical functions
	      if ( !jQuery.support.clearCloneStyle && value === "" && name.indexOf("background") === 0 ) {
	        style[ name ] = "inherit";
	      }

	      // If a hook was provided, use that value, otherwise just set the specified value
	      if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
	        style[ name ] = value;
	      }

	    } else {
	      // If a hook was provided get the non-computed value from there
	      if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
	        return ret;
	      }

	      // Otherwise just get the value from the style object
	      return style[ name ];
	    }
	  },

	  css: function( elem, name, extra, styles ) {
	    var val, num, hooks,
	      origName = jQuery.camelCase( name );

	    // Make sure that we're working with the right name
	    name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

	    // gets hook for the prefixed version
	    // followed by the unprefixed version
	    hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

	    // If a hook was provided get the computed value from there
	    if ( hooks && "get" in hooks ) {
	      val = hooks.get( elem, true, extra );
	    }

	    // Otherwise, if a way to get the computed value exists, use that
	    if ( val === undefined ) {
	      val = curCSS( elem, name, styles );
	    }

	    //convert "normal" to computed value
	    if ( val === "normal" && name in cssNormalTransform ) {
	      val = cssNormalTransform[ name ];
	    }

	    // Return, converting to number if forced or a qualifier was provided and val looks numeric
	    if ( extra === "" || extra ) {
	      num = parseFloat( val );
	      return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
	    }
	    return val;
	  }
	});

	curCSS = function( elem, name, _computed ) {
	  var width, minWidth, maxWidth,
	    computed = _computed || getStyles( elem ),

	    // Support: IE9
	    // getPropertyValue is only needed for .css('filter') in IE9, see #12537
	    ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined,
	    style = elem.style;

	  if ( computed ) {

	    if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
	      ret = jQuery.style( elem, name );
	    }

	    // Support: Safari 5.1
	    // A tribute to the "awesome hack by Dean Edwards"
	    // Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
	    // this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
	    if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

	      // Remember the original values
	      width = style.width;
	      minWidth = style.minWidth;
	      maxWidth = style.maxWidth;

	      // Put in the new values to get a computed value out
	      style.minWidth = style.maxWidth = style.width = ret;
	      ret = computed.width;

	      // Revert the changed values
	      style.width = width;
	      style.minWidth = minWidth;
	      style.maxWidth = maxWidth;
	    }
	  }

	  return ret;
	};


	function setPositiveNumber( elem, value, subtract ) {
	  var matches = rnumsplit.exec( value );
	  return matches ?
	    // Guard against undefined "subtract", e.g., when used as in cssHooks
	    Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
	    value;
	}

	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	  var i = extra === ( isBorderBox ? "border" : "content" ) ?
	    // If we already have the right measurement, avoid augmentation
	    4 :
	    // Otherwise initialize for horizontal or vertical properties
	    name === "width" ? 1 : 0,

	    val = 0;

	  for ( ; i < 4; i += 2 ) {
	    // both box models exclude margin, so add it if we want it
	    if ( extra === "margin" ) {
	      val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
	    }

	    if ( isBorderBox ) {
	      // border-box includes padding, so remove it if we want content
	      if ( extra === "content" ) {
	        val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	      }

	      // at this point, extra isn't border nor margin, so remove border
	      if ( extra !== "margin" ) {
	        val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	      }
	    } else {
	      // at this point, extra isn't content, so add padding
	      val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

	      // at this point, extra isn't content nor padding, so add border
	      if ( extra !== "padding" ) {
	        val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	      }
	    }
	  }

	  return val;
	}

	function getWidthOrHeight( elem, name, extra ) {

	  // Start with offset property, which is equivalent to the border-box value
	  var valueIsBorderBox = true,
	    val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
	    styles = getStyles( elem ),
	    isBorderBox = jQuery.support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	  // some non-html elements return undefined for offsetWidth, so check for null/undefined
	  // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	  // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	  if ( val <= 0 || val == null ) {
	    // Fall back to computed then uncomputed css if necessary
	    val = curCSS( elem, name, styles );
	    if ( val < 0 || val == null ) {
	      val = elem.style[ name ];
	    }

	    // Computed unit is not pixels. Stop here and return.
	    if ( rnumnonpx.test(val) ) {
	      return val;
	    }

	    // we need the check for style in case a browser which returns unreliable values
	    // for getComputedStyle silently falls back to the reliable elem.style
	    valueIsBorderBox = isBorderBox && ( jQuery.support.boxSizingReliable || val === elem.style[ name ] );

	    // Normalize "", auto, and prepare for extra
	    val = parseFloat( val ) || 0;
	  }

	  // use the active box-sizing model to add/subtract irrelevant styles
	  return ( val +
	    augmentWidthOrHeight(
	      elem,
	      name,
	      extra || ( isBorderBox ? "border" : "content" ),
	      valueIsBorderBox,
	      styles
	    )
	  ) + "px";
	}

	// Try to determine the default display value of an element
	function css_defaultDisplay( nodeName ) {
	  var doc = document,
	    display = elemdisplay[ nodeName ];

	  if ( !display ) {
	    display = actualDisplay( nodeName, doc );

	    // If the simple way fails, read from inside an iframe
	    if ( display === "none" || !display ) {
	      // Use the already-created iframe if possible
	      iframe = ( iframe ||
	        jQuery("<iframe frameborder='0' width='0' height='0'/>")
	        .css( "cssText", "display:block !important" )
	      ).appendTo( doc.documentElement );

	      // Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
	      doc = ( iframe[0].contentWindow || iframe[0].contentDocument ).document;
	      doc.write("<!doctype html><html><body>");
	      doc.close();

	      display = actualDisplay( nodeName, doc );
	      iframe.detach();
	    }

	    // Store the correct default display
	    elemdisplay[ nodeName ] = display;
	  }

	  return display;
	}

	// Called ONLY from within css_defaultDisplay
	function actualDisplay( name, doc ) {
	  var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	    display = jQuery.css( elem[0], "display" );
	  elem.remove();
	  return display;
	}

	jQuery.each([ "height", "width" ], function( i, name ) {
	  jQuery.cssHooks[ name ] = {
	    get: function( elem, computed, extra ) {
	      if ( computed ) {
	        // certain elements can have dimension info if we invisibly show them
	        // however, it must have a current display style that would benefit from this
	        return elem.offsetWidth === 0 && rdisplayswap.test( jQuery.css( elem, "display" ) ) ?
	          jQuery.swap( elem, cssShow, function() {
	            return getWidthOrHeight( elem, name, extra );
	          }) :
	          getWidthOrHeight( elem, name, extra );
	      }
	    },

	    set: function( elem, value, extra ) {
	      var styles = extra && getStyles( elem );
	      return setPositiveNumber( elem, value, extra ?
	        augmentWidthOrHeight(
	          elem,
	          name,
	          extra,
	          jQuery.support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
	          styles
	        ) : 0
	      );
	    }
	  };
	});

	// These hooks cannot be added until DOM ready because the support test
	// for it is not run until after DOM ready
	jQuery(function() {
	  // Support: Android 2.3
	  if ( !jQuery.support.reliableMarginRight ) {
	    jQuery.cssHooks.marginRight = {
	      get: function( elem, computed ) {
	        if ( computed ) {
	          // Support: Android 2.3
	          // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
	          // Work around by temporarily setting element display to inline-block
	          return jQuery.swap( elem, { "display": "inline-block" },
	            curCSS, [ elem, "marginRight" ] );
	        }
	      }
	    };
	  }

	  // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	  // getComputedStyle returns percent when specified for top/left/bottom/right
	  // rather than make the css module depend on the offset module, we just check for it here
	  if ( !jQuery.support.pixelPosition && jQuery.fn.position ) {
	    jQuery.each( [ "top", "left" ], function( i, prop ) {
	      jQuery.cssHooks[ prop ] = {
	        get: function( elem, computed ) {
	          if ( computed ) {
	            computed = curCSS( elem, prop );
	            // if curCSS returns percentage, fallback to offset
	            return rnumnonpx.test( computed ) ?
	              jQuery( elem ).position()[ prop ] + "px" :
	              computed;
	          }
	        }
	      };
	    });
	  }

	});

	if ( jQuery.expr && jQuery.expr.filters ) {
	  jQuery.expr.filters.hidden = function( elem ) {
	    // Support: Opera <= 12.12
	    // Opera reports offsetWidths and offsetHeights less than zero on some elements
	    return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
	  };

	  jQuery.expr.filters.visible = function( elem ) {
	    return !jQuery.expr.filters.hidden( elem );
	  };
	}

	// These hooks are used by animate to expand properties
	jQuery.each({
	  margin: "",
	  padding: "",
	  border: "Width"
	}, function( prefix, suffix ) {
	  jQuery.cssHooks[ prefix + suffix ] = {
	    expand: function( value ) {
	      var i = 0,
	        expanded = {},

	        // assumes a single number if not a string
	        parts = typeof value === "string" ? value.split(" ") : [ value ];

	      for ( ; i < 4; i++ ) {
	        expanded[ prefix + cssExpand[ i ] + suffix ] =
	          parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
	      }

	      return expanded;
	    }
	  };

	  if ( !rmargin.test( prefix ) ) {
	    jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	  }
	});
	var r20 = /%20/g,
	  rbracket = /\[\]$/,
	  rCRLF = /\r?\n/g,
	  rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	  rsubmittable = /^(?:input|select|textarea|keygen)/i;

	jQuery.fn.extend({
	  serialize: function() {
	    return jQuery.param( this.serializeArray() );
	  },
	  serializeArray: function() {
	    return this.map(function(){
	      // Can add propHook for "elements" to filter or add form elements
	      var elements = jQuery.prop( this, "elements" );
	      return elements ? jQuery.makeArray( elements ) : this;
	    })
	    .filter(function(){
	      var type = this.type;
	      // Use .is(":disabled") so that fieldset[disabled] works
	      return this.name && !jQuery( this ).is( ":disabled" ) &&
	        rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
	        ( this.checked || !manipulation_rcheckableType.test( type ) );
	    })
	    .map(function( i, elem ){
	      var val = jQuery( this ).val();

	      return val == null ?
	        null :
	        jQuery.isArray( val ) ?
	          jQuery.map( val, function( val ){
	            return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
	          }) :
	          { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
	    }).get();
	  }
	});

	//Serialize an array of form elements or a set of
	//key/values into a query string
	jQuery.param = function( a, traditional ) {
	  var prefix,
	    s = [],
	    add = function( key, value ) {
	      // If value is a function, invoke it and return its value
	      value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
	      s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
	    };

	  // Set traditional to true for jQuery <= 1.3.2 behavior.
	  if ( traditional === undefined ) {
	    traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	  }

	  // If an array was passed in, assume that it is an array of form elements.
	  if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	    // Serialize the form elements
	    jQuery.each( a, function() {
	      add( this.name, this.value );
	    });

	  } else {
	    // If traditional, encode the "old" way (the way 1.3.2 or older
	    // did it), otherwise encode params recursively.
	    for ( prefix in a ) {
	      buildParams( prefix, a[ prefix ], traditional, add );
	    }
	  }

	  // Return the resulting serialization
	  return s.join( "&" ).replace( r20, "+" );
	};

	function buildParams( prefix, obj, traditional, add ) {
	  var name;

	  if ( jQuery.isArray( obj ) ) {
	    // Serialize array item.
	    jQuery.each( obj, function( i, v ) {
	      if ( traditional || rbracket.test( prefix ) ) {
	        // Treat each array item as a scalar.
	        add( prefix, v );

	      } else {
	        // Item is non-scalar (array or object), encode its numeric index.
	        buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
	      }
	    });

	  } else if ( !traditional && jQuery.type( obj ) === "object" ) {
	    // Serialize object item.
	    for ( name in obj ) {
	      buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
	    }

	  } else {
	    // Serialize scalar item.
	    add( prefix, obj );
	  }
	}
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	  "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	  "change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	  // Handle event binding
	  jQuery.fn[ name ] = function( data, fn ) {
	    return arguments.length > 0 ?
	      this.on( name, null, data, fn ) :
	      this.trigger( name );
	  };
	});

	jQuery.fn.extend({
	  hover: function( fnOver, fnOut ) {
	    return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	  },

	  bind: function( types, data, fn ) {
	    return this.on( types, null, data, fn );
	  },
	  unbind: function( types, fn ) {
	    return this.off( types, null, fn );
	  },

	  delegate: function( selector, types, data, fn ) {
	    return this.on( types, selector, data, fn );
	  },
	  undelegate: function( selector, types, fn ) {
	    // ( namespace ) or ( selector, types [, fn] )
	    return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	  }
	});
	var
	  // Document location
	  ajaxLocParts,
	  ajaxLocation,

	  ajax_nonce = jQuery.now(),

	  ajax_rquery = /\?/,
	  rhash = /#.*$/,
	  rts = /([?&])_=[^&]*/,
	  rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	  // #7653, #8125, #8152: local protocol detection
	  rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	  rnoContent = /^(?:GET|HEAD)$/,
	  rprotocol = /^\/\//,
	  rurl = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,

	  // Keep a copy of the old load method
	  _load = jQuery.fn.load,

	  /* Prefilters
	   * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	   * 2) These are called:
	   *    - BEFORE asking for a transport
	   *    - AFTER param serialization (s.data is a string if s.processData is true)
	   * 3) key is the dataType
	   * 4) the catchall symbol "*" can be used
	   * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	   */
	  prefilters = {},

	  /* Transports bindings
	   * 1) key is the dataType
	   * 2) the catchall symbol "*" can be used
	   * 3) selection will start with transport dataType and THEN go to "*" if needed
	   */
	  transports = {},

	  // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	  allTypes = "*/".concat("*");

	// #8138, IE may throw an exception when accessing
	// a field from window.location if document.domain has been set
	try {
	  ajaxLocation = location.href;
	} catch( e ) {
	  // Use the href attribute of an A element
	  // since IE will modify it given document.location
	  ajaxLocation = document.createElement( "a" );
	  ajaxLocation.href = "";
	  ajaxLocation = ajaxLocation.href;
	}

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {

	  // dataTypeExpression is optional and defaults to "*"
	  return function( dataTypeExpression, func ) {

	    if ( typeof dataTypeExpression !== "string" ) {
	      func = dataTypeExpression;
	      dataTypeExpression = "*";
	    }

	    var dataType,
	      i = 0,
	      dataTypes = dataTypeExpression.toLowerCase().match( core_rnotwhite ) || [];

	    if ( jQuery.isFunction( func ) ) {
	      // For each dataType in the dataTypeExpression
	      while ( (dataType = dataTypes[i++]) ) {
	        // Prepend if requested
	        if ( dataType[0] === "+" ) {
	          dataType = dataType.slice( 1 ) || "*";
	          (structure[ dataType ] = structure[ dataType ] || []).unshift( func );

	        // Otherwise append
	        } else {
	          (structure[ dataType ] = structure[ dataType ] || []).push( func );
	        }
	      }
	    }
	  };
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	  var inspected = {},
	    seekingTransport = ( structure === transports );

	  function inspect( dataType ) {
	    var selected;
	    inspected[ dataType ] = true;
	    jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
	      var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
	      if( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	        options.dataTypes.unshift( dataTypeOrTransport );
	        inspect( dataTypeOrTransport );
	        return false;
	      } else if ( seekingTransport ) {
	        return !( selected = dataTypeOrTransport );
	      }
	    });
	    return selected;
	  }

	  return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
	  var key, deep,
	    flatOptions = jQuery.ajaxSettings.flatOptions || {};

	  for ( key in src ) {
	    if ( src[ key ] !== undefined ) {
	      ( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
	    }
	  }
	  if ( deep ) {
	    jQuery.extend( true, target, deep );
	  }

	  return target;
	}

	jQuery.fn.load = function( url, params, callback ) {
	  if ( typeof url !== "string" && _load ) {
	    return _load.apply( this, arguments );
	  }

	  var selector, type, response,
	    self = this,
	    off = url.indexOf(" ");

	  if ( off >= 0 ) {
	    selector = url.slice( off );
	    url = url.slice( 0, off );
	  }

	  // If it's a function
	  if ( jQuery.isFunction( params ) ) {

	    // We assume that it's the callback
	    callback = params;
	    params = undefined;

	  // Otherwise, build a param string
	  } else if ( params && typeof params === "object" ) {
	    type = "POST";
	  }

	  // If we have elements to modify, make the request
	  if ( self.length > 0 ) {
	    jQuery.ajax({
	      url: url,

	      // if "type" variable is undefined, then "GET" method will be used
	      type: type,
	      dataType: "html",
	      data: params
	    }).done(function( responseText ) {

	      // Save response for use in complete callback
	      response = arguments;

	      self.html( selector ?

	        // If a selector was specified, locate the right elements in a dummy div
	        // Exclude scripts to avoid IE 'Permission Denied' errors
	        jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

	        // Otherwise use the full result
	        responseText );

	    }).complete( callback && function( jqXHR, status ) {
	      self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
	    });
	  }

	  return this;
	};

	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ){
	  jQuery.fn[ type ] = function( fn ){
	    return this.on( type, fn );
	  };
	});

	jQuery.extend({

	  // Counter for holding the number of active queries
	  active: 0,

	  // Last-Modified header cache for next request
	  lastModified: {},
	  etag: {},

	  ajaxSettings: {
	    url: ajaxLocation,
	    type: "GET",
	    isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
	    global: true,
	    processData: true,
	    async: true,
	    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	    /*
	    timeout: 0,
	    data: null,
	    dataType: null,
	    username: null,
	    password: null,
	    cache: null,
	    throws: false,
	    traditional: false,
	    headers: {},
	    */

	    accepts: {
	      "*": allTypes,
	      text: "text/plain",
	      html: "text/html",
	      xml: "application/xml, text/xml",
	      json: "application/json, text/javascript"
	    },

	    contents: {
	      xml: /xml/,
	      html: /html/,
	      json: /json/
	    },

	    responseFields: {
	      xml: "responseXML",
	      text: "responseText",
	      json: "responseJSON"
	    },

	    // Data converters
	    // Keys separate source (or catchall "*") and destination types with a single space
	    converters: {

	      // Convert anything to text
	      "* text": String,

	      // Text to html (true = no transformation)
	      "text html": true,

	      // Evaluate text as a json expression
	      "text json": jQuery.parseJSON,

	      // Parse text as xml
	      "text xml": jQuery.parseXML
	    },

	    // For options that shouldn't be deep extended:
	    // you can add your own custom options here if
	    // and when you create one that shouldn't be
	    // deep extended (see ajaxExtend)
	    flatOptions: {
	      url: true,
	      context: true
	    }
	  },

	  // Creates a full fledged settings object into target
	  // with both ajaxSettings and settings fields.
	  // If target is omitted, writes into ajaxSettings.
	  ajaxSetup: function( target, settings ) {
	    return settings ?

	      // Building a settings object
	      ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

	      // Extending ajaxSettings
	      ajaxExtend( jQuery.ajaxSettings, target );
	  },

	  ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	  ajaxTransport: addToPrefiltersOrTransports( transports ),

	  // Main method
	  ajax: function( url, options ) {

	    // If url is an object, simulate pre-1.5 signature
	    if ( typeof url === "object" ) {
	      options = url;
	      url = undefined;
	    }

	    // Force options to be an object
	    options = options || {};

	    var transport,
	      // URL without anti-cache param
	      cacheURL,
	      // Response headers
	      responseHeadersString,
	      responseHeaders,
	      // timeout handle
	      timeoutTimer,
	      // Cross-domain detection vars
	      parts,
	      // To know if global events are to be dispatched
	      fireGlobals,
	      // Loop variable
	      i,
	      // Create the final options object
	      s = jQuery.ajaxSetup( {}, options ),
	      // Callbacks context
	      callbackContext = s.context || s,
	      // Context for global events is callbackContext if it is a DOM node or jQuery collection
	      globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
	        jQuery( callbackContext ) :
	        jQuery.event,
	      // Deferreds
	      deferred = jQuery.Deferred(),
	      completeDeferred = jQuery.Callbacks("once memory"),
	      // Status-dependent callbacks
	      statusCode = s.statusCode || {},
	      // Headers (they are sent all at once)
	      requestHeaders = {},
	      requestHeadersNames = {},
	      // The jqXHR state
	      state = 0,
	      // Default abort message
	      strAbort = "canceled",
	      // Fake xhr
	      jqXHR = {
	        readyState: 0,

	        // Builds headers hashtable if needed
	        getResponseHeader: function( key ) {
	          var match;
	          if ( state === 2 ) {
	            if ( !responseHeaders ) {
	              responseHeaders = {};
	              while ( (match = rheaders.exec( responseHeadersString )) ) {
	                responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
	              }
	            }
	            match = responseHeaders[ key.toLowerCase() ];
	          }
	          return match == null ? null : match;
	        },

	        // Raw string
	        getAllResponseHeaders: function() {
	          return state === 2 ? responseHeadersString : null;
	        },

	        // Caches the header
	        setRequestHeader: function( name, value ) {
	          var lname = name.toLowerCase();
	          if ( !state ) {
	            name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
	            requestHeaders[ name ] = value;
	          }
	          return this;
	        },

	        // Overrides response content-type header
	        overrideMimeType: function( type ) {
	          if ( !state ) {
	            s.mimeType = type;
	          }
	          return this;
	        },

	        // Status-dependent callbacks
	        statusCode: function( map ) {
	          var code;
	          if ( map ) {
	            if ( state < 2 ) {
	              for ( code in map ) {
	                // Lazy-add the new callback in a way that preserves old ones
	                statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
	              }
	            } else {
	              // Execute the appropriate callbacks
	              jqXHR.always( map[ jqXHR.status ] );
	            }
	          }
	          return this;
	        },

	        // Cancel the request
	        abort: function( statusText ) {
	          var finalText = statusText || strAbort;
	          if ( transport ) {
	            transport.abort( finalText );
	          }
	          done( 0, finalText );
	          return this;
	        }
	      };

	    // Attach deferreds
	    deferred.promise( jqXHR ).complete = completeDeferred.add;
	    jqXHR.success = jqXHR.done;
	    jqXHR.error = jqXHR.fail;

	    // Remove hash character (#7531: and string promotion)
	    // Add protocol if not provided (prefilters might expect it)
	    // Handle falsy url in the settings object (#10093: consistency with old signature)
	    // We also use the url parameter if available
	    s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
	      .replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

	    // Alias method option to type as per ticket #12004
	    s.type = options.method || options.type || s.method || s.type;

	    // Extract dataTypes list
	    s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( core_rnotwhite ) || [""];

	    // A cross-domain request is in order when we have a protocol:host:port mismatch
	    if ( s.crossDomain == null ) {
	      parts = rurl.exec( s.url.toLowerCase() );
	      s.crossDomain = !!( parts &&
	        ( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
	          ( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
	            ( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
	      );
	    }

	    // Convert data if not already a string
	    if ( s.data && s.processData && typeof s.data !== "string" ) {
	      s.data = jQuery.param( s.data, s.traditional );
	    }

	    // Apply prefilters
	    inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

	    // If request was aborted inside a prefilter, stop there
	    if ( state === 2 ) {
	      return jqXHR;
	    }

	    // We can fire global events as of now if asked to
	    fireGlobals = s.global;

	    // Watch for a new set of requests
	    if ( fireGlobals && jQuery.active++ === 0 ) {
	      jQuery.event.trigger("ajaxStart");
	    }

	    // Uppercase the type
	    s.type = s.type.toUpperCase();

	    // Determine if request has content
	    s.hasContent = !rnoContent.test( s.type );

	    // Save the URL in case we're toying with the If-Modified-Since
	    // and/or If-None-Match header later on
	    cacheURL = s.url;

	    // More options handling for requests with no content
	    if ( !s.hasContent ) {

	      // If data is available, append data to url
	      if ( s.data ) {
	        cacheURL = ( s.url += ( ajax_rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	        // #9682: remove data so that it's not used in an eventual retry
	        delete s.data;
	      }

	      // Add anti-cache in url if needed
	      if ( s.cache === false ) {
	        s.url = rts.test( cacheURL ) ?

	          // If there is already a '_' parameter, set its value
	          cacheURL.replace( rts, "$1_=" + ajax_nonce++ ) :

	          // Otherwise add one to the end
	          cacheURL + ( ajax_rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ajax_nonce++;
	      }
	    }

	    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
	    if ( s.ifModified ) {
	      if ( jQuery.lastModified[ cacheURL ] ) {
	        jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
	      }
	      if ( jQuery.etag[ cacheURL ] ) {
	        jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
	      }
	    }

	    // Set the correct header, if data is being sent
	    if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
	      jqXHR.setRequestHeader( "Content-Type", s.contentType );
	    }

	    // Set the Accepts header for the server, depending on the dataType
	    jqXHR.setRequestHeader(
	      "Accept",
	      s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
	        s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
	        s.accepts[ "*" ]
	    );

	    // Check for headers option
	    for ( i in s.headers ) {
	      jqXHR.setRequestHeader( i, s.headers[ i ] );
	    }

	    // Allow custom headers/mimetypes and early abort
	    if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	      // Abort if not done already and return
	      return jqXHR.abort();
	    }

	    // aborting is no longer a cancellation
	    strAbort = "abort";

	    // Install callbacks on deferreds
	    for ( i in { success: 1, error: 1, complete: 1 } ) {
	      jqXHR[ i ]( s[ i ] );
	    }

	    // Get transport
	    transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

	    // If no transport, we auto-abort
	    if ( !transport ) {
	      done( -1, "No Transport" );
	    } else {
	      jqXHR.readyState = 1;

	      // Send global event
	      if ( fireGlobals ) {
	        globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
	      }
	      // Timeout
	      if ( s.async && s.timeout > 0 ) {
	        timeoutTimer = setTimeout(function() {
	          jqXHR.abort("timeout");
	        }, s.timeout );
	      }

	      try {
	        state = 1;
	        transport.send( requestHeaders, done );
	      } catch ( e ) {
	        // Propagate exception as error if not done
	        if ( state < 2 ) {
	          done( -1, e );
	        // Simply rethrow otherwise
	        } else {
	          throw e;
	        }
	      }
	    }

	    // Callback for when everything is done
	    function done( status, nativeStatusText, responses, headers ) {
	      var isSuccess, success, error, response, modified,
	        statusText = nativeStatusText;

	      // Called once
	      if ( state === 2 ) {
	        return;
	      }

	      // State is "done" now
	      state = 2;

	      // Clear timeout if it exists
	      if ( timeoutTimer ) {
	        clearTimeout( timeoutTimer );
	      }

	      // Dereference transport for early garbage collection
	      // (no matter how long the jqXHR object will be used)
	      transport = undefined;

	      // Cache response headers
	      responseHeadersString = headers || "";

	      // Set readyState
	      jqXHR.readyState = status > 0 ? 4 : 0;

	      // Determine if successful
	      isSuccess = status >= 200 && status < 300 || status === 304;

	      // Get response data
	      if ( responses ) {
	        response = ajaxHandleResponses( s, jqXHR, responses );
	      }

	      // Convert no matter what (that way responseXXX fields are always set)
	      response = ajaxConvert( s, response, jqXHR, isSuccess );

	      // If successful, handle type chaining
	      if ( isSuccess ) {

	        // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
	        if ( s.ifModified ) {
	          modified = jqXHR.getResponseHeader("Last-Modified");
	          if ( modified ) {
	            jQuery.lastModified[ cacheURL ] = modified;
	          }
	          modified = jqXHR.getResponseHeader("etag");
	          if ( modified ) {
	            jQuery.etag[ cacheURL ] = modified;
	          }
	        }

	        // if no content
	        if ( status === 204 ) {
	          statusText = "nocontent";

	        // if not modified
	        } else if ( status === 304 ) {
	          statusText = "notmodified";

	        // If we have data, let's convert it
	        } else {
	          statusText = response.state;
	          success = response.data;
	          error = response.error;
	          isSuccess = !error;
	        }
	      } else {
	        // We extract error from statusText
	        // then normalize statusText and status for non-aborts
	        error = statusText;
	        if ( status || !statusText ) {
	          statusText = "error";
	          if ( status < 0 ) {
	            status = 0;
	          }
	        }
	      }

	      // Set data for the fake xhr object
	      jqXHR.status = status;
	      jqXHR.statusText = ( nativeStatusText || statusText ) + "";

	      // Success/Error
	      if ( isSuccess ) {
	        deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
	      } else {
	        deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
	      }

	      // Status-dependent callbacks
	      jqXHR.statusCode( statusCode );
	      statusCode = undefined;

	      if ( fireGlobals ) {
	        globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
	          [ jqXHR, s, isSuccess ? success : error ] );
	      }

	      // Complete
	      completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

	      if ( fireGlobals ) {
	        globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	        // Handle the global AJAX counter
	        if ( !( --jQuery.active ) ) {
	          jQuery.event.trigger("ajaxStop");
	        }
	      }
	    }

	    return jqXHR;
	  },

	  getJSON: function( url, data, callback ) {
	    return jQuery.get( url, data, callback, "json" );
	  },

	  getScript: function( url, callback ) {
	    return jQuery.get( url, undefined, callback, "script" );
	  }
	});

	jQuery.each( [ "get", "post" ], function( i, method ) {
	  jQuery[ method ] = function( url, data, callback, type ) {
	    // shift arguments if data argument was omitted
	    if ( jQuery.isFunction( data ) ) {
	      type = type || callback;
	      callback = data;
	      data = undefined;
	    }

	    return jQuery.ajax({
	      url: url,
	      type: method,
	      dataType: type,
	      data: data,
	      success: callback
	    });
	  };
	});

	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {

	  var ct, type, finalDataType, firstDataType,
	    contents = s.contents,
	    dataTypes = s.dataTypes;

	  // Remove auto dataType and get content-type in the process
	  while( dataTypes[ 0 ] === "*" ) {
	    dataTypes.shift();
	    if ( ct === undefined ) {
	      ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
	    }
	  }

	  // Check if we're dealing with a known content-type
	  if ( ct ) {
	    for ( type in contents ) {
	      if ( contents[ type ] && contents[ type ].test( ct ) ) {
	        dataTypes.unshift( type );
	        break;
	      }
	    }
	  }

	  // Check to see if we have a response for the expected dataType
	  if ( dataTypes[ 0 ] in responses ) {
	    finalDataType = dataTypes[ 0 ];
	  } else {
	    // Try convertible dataTypes
	    for ( type in responses ) {
	      if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
	        finalDataType = type;
	        break;
	      }
	      if ( !firstDataType ) {
	        firstDataType = type;
	      }
	    }
	    // Or just use first one
	    finalDataType = finalDataType || firstDataType;
	  }

	  // If we found a dataType
	  // We add the dataType to the list if needed
	  // and return the corresponding response
	  if ( finalDataType ) {
	    if ( finalDataType !== dataTypes[ 0 ] ) {
	      dataTypes.unshift( finalDataType );
	    }
	    return responses[ finalDataType ];
	  }
	}

	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
	  var conv2, current, conv, tmp, prev,
	    converters = {},
	    // Work with a copy of dataTypes in case we need to modify it for conversion
	    dataTypes = s.dataTypes.slice();

	  // Create converters map with lowercased keys
	  if ( dataTypes[ 1 ] ) {
	    for ( conv in s.converters ) {
	      converters[ conv.toLowerCase() ] = s.converters[ conv ];
	    }
	  }

	  current = dataTypes.shift();

	  // Convert to each sequential dataType
	  while ( current ) {

	    if ( s.responseFields[ current ] ) {
	      jqXHR[ s.responseFields[ current ] ] = response;
	    }

	    // Apply the dataFilter if provided
	    if ( !prev && isSuccess && s.dataFilter ) {
	      response = s.dataFilter( response, s.dataType );
	    }

	    prev = current;
	    current = dataTypes.shift();

	    if ( current ) {

	    // There's only work to do if current dataType is non-auto
	      if ( current === "*" ) {

	        current = prev;

	      // Convert response if prev dataType is non-auto and differs from current
	      } else if ( prev !== "*" && prev !== current ) {

	        // Seek a direct converter
	        conv = converters[ prev + " " + current ] || converters[ "* " + current ];

	        // If none found, seek a pair
	        if ( !conv ) {
	          for ( conv2 in converters ) {

	            // If conv2 outputs current
	            tmp = conv2.split( " " );
	            if ( tmp[ 1 ] === current ) {

	              // If prev can be converted to accepted input
	              conv = converters[ prev + " " + tmp[ 0 ] ] ||
	                converters[ "* " + tmp[ 0 ] ];
	              if ( conv ) {
	                // Condense equivalence converters
	                if ( conv === true ) {
	                  conv = converters[ conv2 ];

	                // Otherwise, insert the intermediate dataType
	                } else if ( converters[ conv2 ] !== true ) {
	                  current = tmp[ 0 ];
	                  dataTypes.unshift( tmp[ 1 ] );
	                }
	                break;
	              }
	            }
	          }
	        }

	        // Apply converter (if not an equivalence)
	        if ( conv !== true ) {

	          // Unless errors are allowed to bubble, catch and return them
	          if ( conv && s[ "throws" ] ) {
	            response = conv( response );
	          } else {
	            try {
	              response = conv( response );
	            } catch ( e ) {
	              return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
	            }
	          }
	        }
	      }
	    }
	  }

	  return { state: "success", data: response };
	}
	// Install script dataType
	jQuery.ajaxSetup({
	  accepts: {
	    script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	  },
	  contents: {
	    script: /(?:java|ecma)script/
	  },
	  converters: {
	    "text script": function( text ) {
	      jQuery.globalEval( text );
	      return text;
	    }
	  }
	});

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
	  if ( s.cache === undefined ) {
	    s.cache = false;
	  }
	  if ( s.crossDomain ) {
	    s.type = "GET";
	  }
	});

	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	  // This transport only deals with cross domain requests
	  if ( s.crossDomain ) {
	    var script, callback;
	    return {
	      send: function( _, complete ) {
	        script = jQuery("<script>").prop({
	          async: true,
	          charset: s.scriptCharset,
	          src: s.url
	        }).on(
	          "load error",
	          callback = function( evt ) {
	            script.remove();
	            callback = null;
	            if ( evt ) {
	              complete( evt.type === "error" ? 404 : 200, evt.type );
	            }
	          }
	        );
	        document.head.appendChild( script[ 0 ] );
	      },
	      abort: function() {
	        if ( callback ) {
	          callback();
	        }
	      }
	    };
	  }
	});
	var oldCallbacks = [],
	  rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup({
	  jsonp: "callback",
	  jsonpCallback: function() {
	    var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( ajax_nonce++ ) );
	    this[ callback ] = true;
	    return callback;
	  }
	});

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	  var callbackName, overwritten, responseContainer,
	    jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
	      "url" :
	      typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
	    );

	  // Handle iff the expected data type is "jsonp" or we have a parameter to set
	  if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

	    // Get callback name, remembering preexisting value associated with it
	    callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
	      s.jsonpCallback() :
	      s.jsonpCallback;

	    // Insert callback into url or form data
	    if ( jsonProp ) {
	      s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
	    } else if ( s.jsonp !== false ) {
	      s.url += ( ajax_rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
	    }

	    // Use data converter to retrieve json after script execution
	    s.converters["script json"] = function() {
	      if ( !responseContainer ) {
	        jQuery.error( callbackName + " was not called" );
	      }
	      return responseContainer[ 0 ];
	    };

	    // force json dataType
	    s.dataTypes[ 0 ] = "json";

	    // Install callback
	    overwritten = window[ callbackName ];
	    window[ callbackName ] = function() {
	      responseContainer = arguments;
	    };

	    // Clean-up function (fires after converters)
	    jqXHR.always(function() {
	      // Restore preexisting value
	      window[ callbackName ] = overwritten;

	      // Save back as free
	      if ( s[ callbackName ] ) {
	        // make sure that re-using the options doesn't screw things around
	        s.jsonpCallback = originalSettings.jsonpCallback;

	        // save the callback name for future use
	        oldCallbacks.push( callbackName );
	      }

	      // Call if it was a function and we have a response
	      if ( responseContainer && jQuery.isFunction( overwritten ) ) {
	        overwritten( responseContainer[ 0 ] );
	      }

	      responseContainer = overwritten = undefined;
	    });

	    // Delegate to script
	    return "script";
	  }
	});
	jQuery.ajaxSettings.xhr = function() {
	  try {
	    return new XMLHttpRequest();
	  } catch( e ) {}
	};

	var xhrSupported = jQuery.ajaxSettings.xhr(),
	  xhrSuccessStatus = {
	    // file protocol always yields status code 0, assume 200
	    0: 200,
	    // Support: IE9
	    // #1450: sometimes IE returns 1223 when it should be 204
	    1223: 204
	  },
	  // Support: IE9
	  // We need to keep track of outbound xhr and abort them manually
	  // because IE is not smart enough to do it all by itself
	  xhrId = 0,
	  xhrCallbacks = {};

	if ( window.ActiveXObject ) {
	  jQuery( window ).on( "unload", function() {
	    for( var key in xhrCallbacks ) {
	      xhrCallbacks[ key ]();
	    }
	    xhrCallbacks = undefined;
	  });
	}

	jQuery.support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	jQuery.support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport(function( options ) {
	  var callback;
	  // Cross domain only allowed if supported through XMLHttpRequest
	  if ( jQuery.support.cors || xhrSupported && !options.crossDomain ) {
	    return {
	      send: function( headers, complete ) {
	        var i, id,
	          xhr = options.xhr();
	        xhr.open( options.type, options.url, options.async, options.username, options.password );
	        // Apply custom fields if provided
	        if ( options.xhrFields ) {
	          for ( i in options.xhrFields ) {
	            xhr[ i ] = options.xhrFields[ i ];
	          }
	        }
	        // Override mime type if needed
	        if ( options.mimeType && xhr.overrideMimeType ) {
	          xhr.overrideMimeType( options.mimeType );
	        }
	        // X-Requested-With header
	        // For cross-domain requests, seeing as conditions for a preflight are
	        // akin to a jigsaw puzzle, we simply never set it to be sure.
	        // (it can always be set on a per-request basis or even using ajaxSetup)
	        // For same-domain requests, won't change header if already provided.
	        if ( !options.crossDomain && !headers["X-Requested-With"] ) {
	          headers["X-Requested-With"] = "XMLHttpRequest";
	        }
	        // Set headers
	        for ( i in headers ) {
	          xhr.setRequestHeader( i, headers[ i ] );
	        }
	        // Callback
	        callback = function( type ) {
	          return function() {
	            if ( callback ) {
	              delete xhrCallbacks[ id ];
	              callback = xhr.onload = xhr.onerror = null;
	              if ( type === "abort" ) {
	                xhr.abort();
	              } else if ( type === "error" ) {
	                complete(
	                  // file protocol always yields status 0, assume 404
	                  xhr.status || 404,
	                  xhr.statusText
	                );
	              } else {
	                complete(
	                  xhrSuccessStatus[ xhr.status ] || xhr.status,
	                  xhr.statusText,
	                  // Support: IE9
	                  // #11426: When requesting binary data, IE9 will throw an exception
	                  // on any attempt to access responseText
	                  typeof xhr.responseText === "string" ? {
	                    text: xhr.responseText
	                  } : undefined,
	                  xhr.getAllResponseHeaders()
	                );
	              }
	            }
	          };
	        };
	        // Listen to events
	        xhr.onload = callback();
	        xhr.onerror = callback("error");
	        // Create the abort callback
	        callback = xhrCallbacks[( id = xhrId++ )] = callback("abort");
	        // Do send the request
	        // This may raise an exception which is actually
	        // handled in jQuery.ajax (so no try/catch here)
	        xhr.send( options.hasContent && options.data || null );
	      },
	      abort: function() {
	        if ( callback ) {
	          callback();
	        }
	      }
	    };
	  }
	});
	var fxNow, timerId,
	  rfxtypes = /^(?:toggle|show|hide)$/,
	  rfxnum = new RegExp( "^(?:([+-])=|)(" + core_pnum + ")([a-z%]*)$", "i" ),
	  rrun = /queueHooks$/,
	  animationPrefilters = [ defaultPrefilter ],
	  tweeners = {
	    "*": [function( prop, value ) {
	      var end, unit,
	        tween = this.createTween( prop, value ),
	        parts = rfxnum.exec( value ),
	        target = tween.cur(),
	        start = +target || 0,
	        scale = 1,
	        maxIterations = 20;

	      if ( parts ) {
	        end = +parts[2];
	        unit = parts[3] || ( jQuery.cssNumber[ prop ] ? "" : "px" );

	        // We need to compute starting value
	        if ( unit !== "px" && start ) {
	          // Iteratively approximate from a nonzero starting point
	          // Prefer the current property, because this process will be trivial if it uses the same units
	          // Fallback to end or a simple constant
	          start = jQuery.css( tween.elem, prop, true ) || end || 1;

	          do {
	            // If previous iteration zeroed out, double until we get *something*
	            // Use a string for doubling factor so we don't accidentally see scale as unchanged below
	            scale = scale || ".5";

	            // Adjust and apply
	            start = start / scale;
	            jQuery.style( tween.elem, prop, start + unit );

	          // Update scale, tolerating zero or NaN from tween.cur()
	          // And breaking the loop if scale is unchanged or perfect, or if we've just had enough
	          } while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
	        }

	        tween.unit = unit;
	        tween.start = start;
	        // If a +=/-= token was provided, we're doing a relative animation
	        tween.end = parts[1] ? start + ( parts[1] + 1 ) * end : end;
	      }
	      return tween;
	    }]
	  };

	// Animations created synchronously will run synchronously
	function createFxNow() {
	  setTimeout(function() {
	    fxNow = undefined;
	  });
	  return ( fxNow = jQuery.now() );
	}

	function createTweens( animation, props ) {
	  jQuery.each( props, function( prop, value ) {
	    var collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
	      index = 0,
	      length = collection.length;
	    for ( ; index < length; index++ ) {
	      if ( collection[ index ].call( animation, prop, value ) ) {

	        // we're done with this property
	        return;
	      }
	    }
	  });
	}

	function Animation( elem, properties, options ) {
	  var result,
	    stopped,
	    index = 0,
	    length = animationPrefilters.length,
	    deferred = jQuery.Deferred().always( function() {
	      // don't match elem in the :animated selector
	      delete tick.elem;
	    }),
	    tick = function() {
	      if ( stopped ) {
	        return false;
	      }
	      var currentTime = fxNow || createFxNow(),
	        remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	        // archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
	        temp = remaining / animation.duration || 0,
	        percent = 1 - temp,
	        index = 0,
	        length = animation.tweens.length;

	      for ( ; index < length ; index++ ) {
	        animation.tweens[ index ].run( percent );
	      }

	      deferred.notifyWith( elem, [ animation, percent, remaining ]);

	      if ( percent < 1 && length ) {
	        return remaining;
	      } else {
	        deferred.resolveWith( elem, [ animation ] );
	        return false;
	      }
	    },
	    animation = deferred.promise({
	      elem: elem,
	      props: jQuery.extend( {}, properties ),
	      opts: jQuery.extend( true, { specialEasing: {} }, options ),
	      originalProperties: properties,
	      originalOptions: options,
	      startTime: fxNow || createFxNow(),
	      duration: options.duration,
	      tweens: [],
	      createTween: function( prop, end ) {
	        var tween = jQuery.Tween( elem, animation.opts, prop, end,
	            animation.opts.specialEasing[ prop ] || animation.opts.easing );
	        animation.tweens.push( tween );
	        return tween;
	      },
	      stop: function( gotoEnd ) {
	        var index = 0,
	          // if we are going to the end, we want to run all the tweens
	          // otherwise we skip this part
	          length = gotoEnd ? animation.tweens.length : 0;
	        if ( stopped ) {
	          return this;
	        }
	        stopped = true;
	        for ( ; index < length ; index++ ) {
	          animation.tweens[ index ].run( 1 );
	        }

	        // resolve when we played the last frame
	        // otherwise, reject
	        if ( gotoEnd ) {
	          deferred.resolveWith( elem, [ animation, gotoEnd ] );
	        } else {
	          deferred.rejectWith( elem, [ animation, gotoEnd ] );
	        }
	        return this;
	      }
	    }),
	    props = animation.props;

	  propFilter( props, animation.opts.specialEasing );

	  for ( ; index < length ; index++ ) {
	    result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
	    if ( result ) {
	      return result;
	    }
	  }

	  createTweens( animation, props );

	  if ( jQuery.isFunction( animation.opts.start ) ) {
	    animation.opts.start.call( elem, animation );
	  }

	  jQuery.fx.timer(
	    jQuery.extend( tick, {
	      elem: elem,
	      anim: animation,
	      queue: animation.opts.queue
	    })
	  );

	  // attach callbacks from options
	  return animation.progress( animation.opts.progress )
	    .done( animation.opts.done, animation.opts.complete )
	    .fail( animation.opts.fail )
	    .always( animation.opts.always );
	}

	function propFilter( props, specialEasing ) {
	  var index, name, easing, value, hooks;

	  // camelCase, specialEasing and expand cssHook pass
	  for ( index in props ) {
	    name = jQuery.camelCase( index );
	    easing = specialEasing[ name ];
	    value = props[ index ];
	    if ( jQuery.isArray( value ) ) {
	      easing = value[ 1 ];
	      value = props[ index ] = value[ 0 ];
	    }

	    if ( index !== name ) {
	      props[ name ] = value;
	      delete props[ index ];
	    }

	    hooks = jQuery.cssHooks[ name ];
	    if ( hooks && "expand" in hooks ) {
	      value = hooks.expand( value );
	      delete props[ name ];

	      // not quite $.extend, this wont overwrite keys already present.
	      // also - reusing 'index' from above because we have the correct "name"
	      for ( index in value ) {
	        if ( !( index in props ) ) {
	          props[ index ] = value[ index ];
	          specialEasing[ index ] = easing;
	        }
	      }
	    } else {
	      specialEasing[ name ] = easing;
	    }
	  }
	}

	jQuery.Animation = jQuery.extend( Animation, {

	  tweener: function( props, callback ) {
	    if ( jQuery.isFunction( props ) ) {
	      callback = props;
	      props = [ "*" ];
	    } else {
	      props = props.split(" ");
	    }

	    var prop,
	      index = 0,
	      length = props.length;

	    for ( ; index < length ; index++ ) {
	      prop = props[ index ];
	      tweeners[ prop ] = tweeners[ prop ] || [];
	      tweeners[ prop ].unshift( callback );
	    }
	  },

	  prefilter: function( callback, prepend ) {
	    if ( prepend ) {
	      animationPrefilters.unshift( callback );
	    } else {
	      animationPrefilters.push( callback );
	    }
	  }
	});

	function defaultPrefilter( elem, props, opts ) {
	  /* jshint validthis: true */
	  var index, prop, value, length, dataShow, toggle, tween, hooks, oldfire,
	    anim = this,
	    style = elem.style,
	    orig = {},
	    handled = [],
	    hidden = elem.nodeType && isHidden( elem );

	  // handle queue: false promises
	  if ( !opts.queue ) {
	    hooks = jQuery._queueHooks( elem, "fx" );
	    if ( hooks.unqueued == null ) {
	      hooks.unqueued = 0;
	      oldfire = hooks.empty.fire;
	      hooks.empty.fire = function() {
	        if ( !hooks.unqueued ) {
	          oldfire();
	        }
	      };
	    }
	    hooks.unqueued++;

	    anim.always(function() {
	      // doing this makes sure that the complete handler will be called
	      // before this completes
	      anim.always(function() {
	        hooks.unqueued--;
	        if ( !jQuery.queue( elem, "fx" ).length ) {
	          hooks.empty.fire();
	        }
	      });
	    });
	  }

	  // height/width overflow pass
	  if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	    // Make sure that nothing sneaks out
	    // Record all 3 overflow attributes because IE9-10 do not
	    // change the overflow attribute when overflowX and
	    // overflowY are set to the same value
	    opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

	    // Set display property to inline-block for height/width
	    // animations on inline elements that are having width/height animated
	    if ( jQuery.css( elem, "display" ) === "inline" &&
	        jQuery.css( elem, "float" ) === "none" ) {

	      style.display = "inline-block";
	    }
	  }

	  if ( opts.overflow ) {
	    style.overflow = "hidden";
	    anim.always(function() {
	      style.overflow = opts.overflow[ 0 ];
	      style.overflowX = opts.overflow[ 1 ];
	      style.overflowY = opts.overflow[ 2 ];
	    });
	  }


	  // show/hide pass
	  dataShow = data_priv.get( elem, "fxshow" );
	  for ( index in props ) {
	    value = props[ index ];
	    if ( rfxtypes.exec( value ) ) {
	      delete props[ index ];
	      toggle = toggle || value === "toggle";
	      if ( value === ( hidden ? "hide" : "show" ) ) {

	        // If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
	        if( value === "show" && dataShow !== undefined && dataShow[ index ] !== undefined ) {
	          hidden = true;
	        } else {
	          continue;
	        }
	      }
	      handled.push( index );
	    }
	  }

	  length = handled.length;
	  if ( length ) {
	    dataShow = data_priv.get( elem, "fxshow" ) || data_priv.access( elem, "fxshow", {} );
	    if ( "hidden" in dataShow ) {
	      hidden = dataShow.hidden;
	    }

	    // store state if its toggle - enables .stop().toggle() to "reverse"
	    if ( toggle ) {
	      dataShow.hidden = !hidden;
	    }
	    if ( hidden ) {
	      jQuery( elem ).show();
	    } else {
	      anim.done(function() {
	        jQuery( elem ).hide();
	      });
	    }
	    anim.done(function() {
	      var prop;

	      data_priv.remove( elem, "fxshow" );
	      for ( prop in orig ) {
	        jQuery.style( elem, prop, orig[ prop ] );
	      }
	    });
	    for ( index = 0 ; index < length ; index++ ) {
	      prop = handled[ index ];
	      tween = anim.createTween( prop, hidden ? dataShow[ prop ] : 0 );
	      orig[ prop ] = dataShow[ prop ] || jQuery.style( elem, prop );

	      if ( !( prop in dataShow ) ) {
	        dataShow[ prop ] = tween.start;
	        if ( hidden ) {
	          tween.end = tween.start;
	          tween.start = prop === "width" || prop === "height" ? 1 : 0;
	        }
	      }
	    }
	  }
	}

	function Tween( elem, options, prop, end, easing ) {
	  return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
	  constructor: Tween,
	  init: function( elem, options, prop, end, easing, unit ) {
	    this.elem = elem;
	    this.prop = prop;
	    this.easing = easing || "swing";
	    this.options = options;
	    this.start = this.now = this.cur();
	    this.end = end;
	    this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	  },
	  cur: function() {
	    var hooks = Tween.propHooks[ this.prop ];

	    return hooks && hooks.get ?
	      hooks.get( this ) :
	      Tween.propHooks._default.get( this );
	  },
	  run: function( percent ) {
	    var eased,
	      hooks = Tween.propHooks[ this.prop ];

	    if ( this.options.duration ) {
	      this.pos = eased = jQuery.easing[ this.easing ](
	        percent, this.options.duration * percent, 0, 1, this.options.duration
	      );
	    } else {
	      this.pos = eased = percent;
	    }
	    this.now = ( this.end - this.start ) * eased + this.start;

	    if ( this.options.step ) {
	      this.options.step.call( this.elem, this.now, this );
	    }

	    if ( hooks && hooks.set ) {
	      hooks.set( this );
	    } else {
	      Tween.propHooks._default.set( this );
	    }
	    return this;
	  }
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
	  _default: {
	    get: function( tween ) {
	      var result;

	      if ( tween.elem[ tween.prop ] != null &&
	        (!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
	        return tween.elem[ tween.prop ];
	      }

	      // passing an empty string as a 3rd parameter to .css will automatically
	      // attempt a parseFloat and fallback to a string if the parse fails
	      // so, simple values such as "10px" are parsed to Float.
	      // complex values such as "rotate(1rad)" are returned as is.
	      result = jQuery.css( tween.elem, tween.prop, "" );
	      // Empty strings, null, undefined and "auto" are converted to 0.
	      return !result || result === "auto" ? 0 : result;
	    },
	    set: function( tween ) {
	      // use step hook for back compat - use cssHook if its there - use .style if its
	      // available and use plain properties where available
	      if ( jQuery.fx.step[ tween.prop ] ) {
	        jQuery.fx.step[ tween.prop ]( tween );
	      } else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
	        jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
	      } else {
	        tween.elem[ tween.prop ] = tween.now;
	      }
	    }
	  }
	};

	// Support: IE9
	// Panic based approach to setting things on disconnected nodes

	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	  set: function( tween ) {
	    if ( tween.elem.nodeType && tween.elem.parentNode ) {
	      tween.elem[ tween.prop ] = tween.now;
	    }
	  }
	};

	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	  var cssFn = jQuery.fn[ name ];
	  jQuery.fn[ name ] = function( speed, easing, callback ) {
	    return speed == null || typeof speed === "boolean" ?
	      cssFn.apply( this, arguments ) :
	      this.animate( genFx( name, true ), speed, easing, callback );
	  };
	});

	jQuery.fn.extend({
	  fadeTo: function( speed, to, easing, callback ) {

	    // show any hidden elements after setting opacity to 0
	    return this.filter( isHidden ).css( "opacity", 0 ).show()

	      // animate to the value specified
	      .end().animate({ opacity: to }, speed, easing, callback );
	  },
	  animate: function( prop, speed, easing, callback ) {
	    var empty = jQuery.isEmptyObject( prop ),
	      optall = jQuery.speed( speed, easing, callback ),
	      doAnimation = function() {
	        // Operate on a copy of prop so per-property easing won't be lost
	        var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	        doAnimation.finish = function() {
	          anim.stop( true );
	        };
	        // Empty animations, or finishing resolves immediately
	        if ( empty || data_priv.get( this, "finish" ) ) {
	          anim.stop( true );
	        }
	      };
	      doAnimation.finish = doAnimation;

	    return empty || optall.queue === false ?
	      this.each( doAnimation ) :
	      this.queue( optall.queue, doAnimation );
	  },
	  stop: function( type, clearQueue, gotoEnd ) {
	    var stopQueue = function( hooks ) {
	      var stop = hooks.stop;
	      delete hooks.stop;
	      stop( gotoEnd );
	    };

	    if ( typeof type !== "string" ) {
	      gotoEnd = clearQueue;
	      clearQueue = type;
	      type = undefined;
	    }
	    if ( clearQueue && type !== false ) {
	      this.queue( type || "fx", [] );
	    }

	    return this.each(function() {
	      var dequeue = true,
	        index = type != null && type + "queueHooks",
	        timers = jQuery.timers,
	        data = data_priv.get( this );

	      if ( index ) {
	        if ( data[ index ] && data[ index ].stop ) {
	          stopQueue( data[ index ] );
	        }
	      } else {
	        for ( index in data ) {
	          if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
	            stopQueue( data[ index ] );
	          }
	        }
	      }

	      for ( index = timers.length; index--; ) {
	        if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
	          timers[ index ].anim.stop( gotoEnd );
	          dequeue = false;
	          timers.splice( index, 1 );
	        }
	      }

	      // start the next in the queue if the last step wasn't forced
	      // timers currently will call their complete callbacks, which will dequeue
	      // but only if they were gotoEnd
	      if ( dequeue || !gotoEnd ) {
	        jQuery.dequeue( this, type );
	      }
	    });
	  },
	  finish: function( type ) {
	    if ( type !== false ) {
	      type = type || "fx";
	    }
	    return this.each(function() {
	      var index,
	        data = data_priv.get( this ),
	        queue = data[ type + "queue" ],
	        hooks = data[ type + "queueHooks" ],
	        timers = jQuery.timers,
	        length = queue ? queue.length : 0;

	      // enable finishing flag on private data
	      data.finish = true;

	      // empty the queue first
	      jQuery.queue( this, type, [] );

	      if ( hooks && hooks.cur && hooks.cur.finish ) {
	        hooks.cur.finish.call( this );
	      }

	      // look for any active animations, and finish them
	      for ( index = timers.length; index--; ) {
	        if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
	          timers[ index ].anim.stop( true );
	          timers.splice( index, 1 );
	        }
	      }

	      // look for any animations in the old queue and finish them
	      for ( index = 0; index < length; index++ ) {
	        if ( queue[ index ] && queue[ index ].finish ) {
	          queue[ index ].finish.call( this );
	        }
	      }

	      // turn off finishing flag
	      delete data.finish;
	    });
	  }
	});

	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
	  var which,
	    attrs = { height: type },
	    i = 0;

	  // if we include width, step value is 1 to do all cssExpand values,
	  // if we don't include width, step value is 2 to skip over Left and Right
	  includeWidth = includeWidth? 1 : 0;
	  for( ; i < 4 ; i += 2 - includeWidth ) {
	    which = cssExpand[ i ];
	    attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	  }

	  if ( includeWidth ) {
	    attrs.opacity = attrs.width = type;
	  }

	  return attrs;
	}

	// Generate shortcuts for custom animations
	jQuery.each({
	  slideDown: genFx("show"),
	  slideUp: genFx("hide"),
	  slideToggle: genFx("toggle"),
	  fadeIn: { opacity: "show" },
	  fadeOut: { opacity: "hide" },
	  fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
	  jQuery.fn[ name ] = function( speed, easing, callback ) {
	    return this.animate( props, speed, easing, callback );
	  };
	});

	jQuery.speed = function( speed, easing, fn ) {
	  var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
	    complete: fn || !fn && easing ||
	      jQuery.isFunction( speed ) && speed,
	    duration: speed,
	    easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	  };

	  opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
	    opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	  // normalize opt.queue - true/undefined/null -> "fx"
	  if ( opt.queue == null || opt.queue === true ) {
	    opt.queue = "fx";
	  }

	  // Queueing
	  opt.old = opt.complete;

	  opt.complete = function() {
	    if ( jQuery.isFunction( opt.old ) ) {
	      opt.old.call( this );
	    }

	    if ( opt.queue ) {
	      jQuery.dequeue( this, opt.queue );
	    }
	  };

	  return opt;
	};

	jQuery.easing = {
	  linear: function( p ) {
	    return p;
	  },
	  swing: function( p ) {
	    return 0.5 - Math.cos( p*Math.PI ) / 2;
	  }
	};

	jQuery.timers = [];
	jQuery.fx = Tween.prototype.init;
	jQuery.fx.tick = function() {
	  var timer,
	    timers = jQuery.timers,
	    i = 0;

	  fxNow = jQuery.now();

	  for ( ; i < timers.length; i++ ) {
	    timer = timers[ i ];
	    // Checks the timer has not already been removed
	    if ( !timer() && timers[ i ] === timer ) {
	      timers.splice( i--, 1 );
	    }
	  }

	  if ( !timers.length ) {
	    jQuery.fx.stop();
	  }
	  fxNow = undefined;
	};

	jQuery.fx.timer = function( timer ) {
	  if ( timer() && jQuery.timers.push( timer ) ) {
	    jQuery.fx.start();
	  }
	};

	jQuery.fx.interval = 13;

	jQuery.fx.start = function() {
	  if ( !timerId ) {
	    timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	  }
	};

	jQuery.fx.stop = function() {
	  clearInterval( timerId );
	  timerId = null;
	};

	jQuery.fx.speeds = {
	  slow: 600,
	  fast: 200,
	  // Default speed
	  _default: 400
	};

	// Back Compat <1.8 extension point
	jQuery.fx.step = {};

	if ( jQuery.expr && jQuery.expr.filters ) {
	  jQuery.expr.filters.animated = function( elem ) {
	    return jQuery.grep(jQuery.timers, function( fn ) {
	      return elem === fn.elem;
	    }).length;
	  };
	}
	jQuery.fn.offset = function( options ) {
	  if ( arguments.length ) {
	    return options === undefined ?
	      this :
	      this.each(function( i ) {
	        jQuery.offset.setOffset( this, options, i );
	      });
	  }

	  var docElem, win,
	    elem = this[ 0 ],
	    box = { top: 0, left: 0 },
	    doc = elem && elem.ownerDocument;

	  if ( !doc ) {
	    return;
	  }

	  docElem = doc.documentElement;

	  // Make sure it's not a disconnected DOM node
	  if ( !jQuery.contains( docElem, elem ) ) {
	    return box;
	  }

	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if ( typeof elem.getBoundingClientRect !== core_strundefined ) {
	    box = elem.getBoundingClientRect();
	  }
	  win = getWindow( doc );
	  return {
	    top: box.top + win.pageYOffset - docElem.clientTop,
	    left: box.left + win.pageXOffset - docElem.clientLeft
	  };
	};

	jQuery.offset = {

	  setOffset: function( elem, options, i ) {
	    var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
	      position = jQuery.css( elem, "position" ),
	      curElem = jQuery( elem ),
	      props = {};

	    // Set position first, in-case top/left are set even on static elem
	    if ( position === "static" ) {
	      elem.style.position = "relative";
	    }

	    curOffset = curElem.offset();
	    curCSSTop = jQuery.css( elem, "top" );
	    curCSSLeft = jQuery.css( elem, "left" );
	    calculatePosition = ( position === "absolute" || position === "fixed" ) && ( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

	    // Need to be able to calculate position if either top or left is auto and position is either absolute or fixed
	    if ( calculatePosition ) {
	      curPosition = curElem.position();
	      curTop = curPosition.top;
	      curLeft = curPosition.left;

	    } else {
	      curTop = parseFloat( curCSSTop ) || 0;
	      curLeft = parseFloat( curCSSLeft ) || 0;
	    }

	    if ( jQuery.isFunction( options ) ) {
	      options = options.call( elem, i, curOffset );
	    }

	    if ( options.top != null ) {
	      props.top = ( options.top - curOffset.top ) + curTop;
	    }
	    if ( options.left != null ) {
	      props.left = ( options.left - curOffset.left ) + curLeft;
	    }

	    if ( "using" in options ) {
	      options.using.call( elem, props );

	    } else {
	      curElem.css( props );
	    }
	  }
	};


	jQuery.fn.extend({

	  position: function() {
	    if ( !this[ 0 ] ) {
	      return;
	    }

	    var offsetParent, offset,
	      elem = this[ 0 ],
	      parentOffset = { top: 0, left: 0 };

	    // Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is it's only offset parent
	    if ( jQuery.css( elem, "position" ) === "fixed" ) {
	      // We assume that getBoundingClientRect is available when computed position is fixed
	      offset = elem.getBoundingClientRect();

	    } else {
	      // Get *real* offsetParent
	      offsetParent = this.offsetParent();

	      // Get correct offsets
	      offset = this.offset();
	      if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
	        parentOffset = offsetParent.offset();
	      }

	      // Add offsetParent borders
	      parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
	      parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
	    }

	    // Subtract parent offsets and element margins
	    return {
	      top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
	      left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
	    };
	  },

	  offsetParent: function() {
	    return this.map(function() {
	      var offsetParent = this.offsetParent || docElem;

	      while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position") === "static" ) ) {
	        offsetParent = offsetParent.offsetParent;
	      }

	      return offsetParent || docElem;
	    });
	  }
	});


	// Create scrollLeft and scrollTop methods
	jQuery.each( {scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function( method, prop ) {
	  var top = "pageYOffset" === prop;

	  jQuery.fn[ method ] = function( val ) {
	    return jQuery.access( this, function( elem, method, val ) {
	      var win = getWindow( elem );

	      if ( val === undefined ) {
	        return win ? win[ prop ] : elem[ method ];
	      }

	      if ( win ) {
	        win.scrollTo(
	          !top ? val : window.pageXOffset,
	          top ? val : window.pageYOffset
	        );

	      } else {
	        elem[ method ] = val;
	      }
	    }, method, val, arguments.length, null );
	  };
	});

	function getWindow( elem ) {
	  return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	  jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
	    // margin is only for outerHeight, outerWidth
	    jQuery.fn[ funcName ] = function( margin, value ) {
	      var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
	        extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

	      return jQuery.access( this, function( elem, type, value ) {
	        var doc;

	        if ( jQuery.isWindow( elem ) ) {
	          // As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
	          // isn't a whole lot we can do. See pull request at this URL for discussion:
	          // https://github.com/jquery/jquery/pull/764
	          return elem.document.documentElement[ "client" + name ];
	        }

	        // Get document width or height
	        if ( elem.nodeType === 9 ) {
	          doc = elem.documentElement;

	          // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
	          // whichever is greatest
	          return Math.max(
	            elem.body[ "scroll" + name ], doc[ "scroll" + name ],
	            elem.body[ "offset" + name ], doc[ "offset" + name ],
	            doc[ "client" + name ]
	          );
	        }

	        return value === undefined ?
	          // Get width or height on the element, requesting but not forcing parseFloat
	          jQuery.css( elem, type, extra ) :

	          // Set width or height on the element
	          jQuery.style( elem, type, value, extra );
	      }, type, chainable ? margin : undefined, chainable, null );
	    };
	  });
	});
	// Limit scope pollution from any deprecated API
	// (function() {

	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
	  return this.length;
	};

	jQuery.fn.andSelf = jQuery.fn.addBack;

	// })();
	if ( typeof module === "object" && typeof module.exports === "object" ) {
	  // Expose jQuery as module.exports in loaders that implement the Node
	  // module pattern (including browserify). Do not create the global, since
	  // the user will be storing it themselves locally, and globals are frowned
	  // upon in the Node module world.
	  module.exports = jQuery;
	} else {
	  // Register as a named AMD module, since jQuery can be concatenated with other
	  // files that may use define, but not via a proper concatenation script that
	  // understands anonymous AMD modules. A named AMD is safest and most robust
	  // way to register. Lowercase jquery is used because AMD module names are
	  // derived from file names, and jQuery is normally delivered in a lowercase
	  // file name. Do this after creating the global so that if an AMD module wants
	  // to call noConflict to hide this version of jQuery, it will work.
	  if ( true ) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return jQuery; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}

	// If there is a window object, that at least has a document property,
	// define jQuery and $ identifiers
	if ( typeof window === "object" && typeof window.document === "object" ) {
	  //window.jQuery = window.$ = jQuery;
	}

	})( window );
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var fonts = ['Asap', 'Fira Sans', 'Fira Sans Condensed', 'Roboto', 'Open Sans', 'Lato', 'Roboto Condensed', 'Source Sans Pro', { name: 'Merriweather', fallback: 'serif' }, 'Overpass', 'Raleway', 'Rubik', { name: 'Playfair Display', fallback: 'serif' }, { name: 'Crimson Text', fallback: 'serif' }, 'Muli', 'Titillium Web', 'Cabin', 'Merriweather Sans', 'Exo 2', 'Josefin Sans', { name: 'Roboto Mono', fallback: 'monospace' }, { name: 'Alegreya', fallback: 'serif' }, 'Alegreya Sans', { name: 'Josefin Slab', fallback: 'serif' }, { name: 'Cormorant Garamond', fallback: 'serif' }, 'Proza Libre', 'Overlock'].map(function (el) {
	  return (typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'object' ? el : {
	    name: el,
	    fallback: 'sans-serif',
	    hasLatinExt: true
	  };
	}).sort(function (a, b) {
	  return a.name.localeCompare(b.name);
	});

	exports.default = fonts;

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = {
		"translations": {
			"ADD_FILTER": "Add filter",
			"ADD_GROUP": "Add level/group",
			"ADD_INPUT": "Add input",
			"ADD_SUBGROUP": "Add sub-level/group",
			"APPEARANCE": "APPEARANCE",
			"A_TO_Z": "A->Z",
			"BOTTOM": "Bottom",
			"CANCEL": "Cancel",
			"COLUMNS": "Columns",
			"COLUMN_FOOTER": "Column Footer",
			"COLUMN_HEADER": "Column Header",
			"CONFIRM_DELETE_GROUP": "This will permanently delete {count} element(s) from the header and footer of this group.  Are you sure you want to remove this group?",
			"CONFIRM_DESIGNER_CANCEL": "Are you sure you want to discard changes to this report?  This action cannot be undone.",
			"DATA": "Data",
			"DATA_SOURCE": "DATA SOURCE",
			"DATA_SOURCE_PLACEHOLDER": "None",
			"DATE": "Date",
			"DEFAULT_FONT": "Default font",
			"DEFAULT_FONT_SIZE": "Default font size",
			"DELETE": "Delete",
			"DETAIL": "Detail",
			"DETAIL_NUMBER": "Detail {index}",
			"DOWNLOAD": "Download",
			"EDIT": "EDIT",
			"EDITING_SUBREPORT": "Editing subreport",
			"ELEMENT_TYPE_NAME_BARCODE": "Barcode",
			"ELEMENT_TYPE_NAME_BOX": "Box",
			"ELEMENT_TYPE_NAME_BREAK": "Page Break",
			"ELEMENT_TYPE_NAME_CHART": "Chart",
			"ELEMENT_TYPE_NAME_CHECKBOX": "Checkbox",
			"ELEMENT_TYPE_NAME_IMAGE": "Image",
			"ELEMENT_TYPE_NAME_LINE": "Line",
			"ELEMENT_TYPE_NAME_SUBREPORT": "Subreport",
			"ELEMENT_TYPE_NAME_TABLE": "Table",
			"ELEMENT_TYPE_NAME_TEXT": "Text",
			"EMBEDDED_SCHEMA": "Embedded schema",
			"ENABLE_PIVOT": "Enable pivot",
			"EXCEL": "Excel",
			"FILTERS": "FILTERS",
			"FILTER_OPERAND_EXAMPLE_ANY": "e.g. Johnson or 42 or 5/14/2017 (m/d/y)",
			"FILTER_OPERAND_EXAMPLE_DATE": "e.g. 5/19/2017 (m/d/y) or 2017-05-19",
			"FILTER_OPERAND_EXAMPLE_NUMBER": "e.g. 42",
			"FILTER_OPERAND_EXAMPLE_ONE_OF": "e.g. 1, 8, 42 or Johnson, Stevens, Smith",
			"FILTER_OPERAND_EXAMPLE_TEXT": "e.g. Johnson",
			"FILTER_OPERATOR_AFTER": "is after",
			"FILTER_OPERATOR_BEFORE": "is before",
			"FILTER_OPERATOR_CONTAINS": "contains",
			"FILTER_OPERATOR_DOES_NOT_CONTAIN": "does not contain",
			"FILTER_OPERATOR_GT": "is greater than",
			"FILTER_OPERATOR_GTE": "is greater than or equal to",
			"FILTER_OPERATOR_IS": "is",
			"FILTER_OPERATOR_IS_NOT": "is not",
			"FILTER_OPERATOR_LT": "is less than",
			"FILTER_OPERATOR_LTE": "is less than or equal to",
			"FILTER_OPERATOR_ON_OR_AFTER": "is on or after",
			"FILTER_OPERATOR_ON_OR_BEFORE": "is on or before",
			"GROUPING": "GROUPING",
			"GROUP_BY_LABEL": "Group by",
			"GROUP_FOOTER_LABEL": "footer",
			"GROUP_HEADER_LABEL": "header",
			"GROUP_N_FOOTER": "Group {index} footer",
			"GROUP_N_HEADER": "Group {index} header",
			"GROUP_ORDER_LABEL": "ordered by",
			"GROUP_RECORDS": "Group records",
			"GROUP_WITH": "with",
			"INCHES": "inches",
			"INPUTS": "Inputs",
			"INPUT_DEFAULT_LABEL": "Initial value",
			"INPUT_DEFAULT_PLACEHOLDER": "enter a value",
			"INPUT_DEFAULT_VALUE_EXAMPLE_DATE": "ex: 5/19/2017, 3 days ago",
			"INPUT_DEFAULT_VALUE_EXAMPLE_NUMBER": "ex: 42",
			"INPUT_DEFAULT_VALUE_EXAMPLE_TEXT": "ex: Smith",
			"INPUT_NAME": "Name",
			"INPUT_NAME_PLACEHOLDER": "Input name",
			"INPUT_TYPE": "Type",
			"LEFT": "Left",
			"MARGINS": "MARGINS",
			"MISSING_SCHEMA": "Data source schema missing",
			"MM": "mm",
			"NONE": "None",
			"NO_REPORT_LOADED": "No report loaded",
			"NUMBER": "Number",
			"OK": "OK",
			"ORDER_DETAIL_BY": "Order detail rows by",
			"PAGE": "Page",
			"PAGE_FOOTER": "Page Footer",
			"PAGE_HEADER": "Page Header",
			"PAGE_HEADER_FOOTER": "PAGE HEADER & FOOTER",
			"PAGE_UNITS": "UNITS",
			"PAGE_UNITS_INCHES": "inches",
			"PAGE_UNITS_MM": "mm",
			"PAPER_SIZE": "PAPER SIZE",
			"PAPER_SIZE_A3": "A3",
			"PAPER_SIZE_A3_LANDSCAPE": "A3 (landscape)",
			"PAPER_SIZE_A4": "A4",
			"PAPER_SIZE_A4_LANDSCAPE": "A4 (landscape)",
			"PAPER_SIZE_LEDGER": "Ledger",
			"PAPER_SIZE_LEGAL": "Legal",
			"PAPER_SIZE_LEGAL_LANDSCAPE": "Legal (landscape)",
			"PAPER_SIZE_LETTER": "Letter",
			"PAPER_SIZE_LETTER_LANDSCAPE": "Letter (landscape)",
			"PAPER_SIZE_TABLOID": "Tabloid",
			"PDF": "PDF",
			"PIVOT": "PIVOT (CROSS-TAB)",
			"PIVOT_BUCKET_DAY": "day",
			"PIVOT_BUCKET_MONTH": "month",
			"PIVOT_BUCKET_NONE": "none",
			"PIVOT_BUCKET_TYPE": "Pivot value bucket type",
			"PIVOT_BUCKET_YEAR": "year",
			"PIVOT_FIELD": "Pivot field",
			"PIVOT_FIELD_PLACEHOLDER": "(none)",
			"REPORT_FOOTER": "Report Footer",
			"REPORT_HEADER": "Report Header",
			"REPORT_HEADER_FOOTER": "REPORT HEADER & FOOTER",
			"RIGHT": "Right",
			"SAVE": "Save",
			"SAVE_SUBREPORT": "Save and return to main report",
			"SECTION_LABEL_GROUP_FOOTER": "Group {index} footer",
			"SECTION_LABEL_GROUP_FOOTER_NAMED": "{group_field} group footer",
			"SECTION_LABEL_GROUP_HEADER": "Group {index} header",
			"SECTION_LABEL_GROUP_HEADER_NAMED": "{group_field} group header",
			"SELECT_FIELD": "select a field",
			"SHOW_DETAIL": "Show detail section",
			"SHOW_PAGE_FOOTER": "Show page footer (PDF only)",
			"SHOW_PAGE_HEADER": "Show page header (PDF only)",
			"SHOW_REPORT_FOOTER": "Show report footer",
			"SHOW_REPORT_HEADER": "Show report header",
			"SUBLEVEL_DATA_SOURCE_LABEL": "Using data",
			"SUBLEVEL_GROUP_BY": "group by",
			"SUBLEVEL_GROUP_BY_FIRST": "Group by",
			"SUBLEVEL_MATCH_CHILD_FIELD_LABEL": "where",
			"SUBLEVEL_MATCH_CHILD_FIELD_PLACEHOLDER": "no filter",
			"SUBLEVEL_MATCH_PARENT_FIELD_LABEL": "equals parent's",
			"TABLE_CELL_TEXT": "Text",
			"TABLE_COLUMNS": "Columns",
			"TABLE_DATA_SOURCE": "Data source",
			"TABLE_HAS_HEADER": "Has header",
			"TABLE_HAS_FOOTER": "Has footer",
			"TEXT": "Text",
			"TOP": "Top",
			"Z_TO_A": "Z->A"
		}
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	var baseClone = __webpack_require__(17),
	    isPlainObject = __webpack_require__(18),
	    keysIn = __webpack_require__(19),
	    rest = __webpack_require__(20),
	    root = __webpack_require__(21);

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;

	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = keysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;

	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}

	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);

	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;

	  var isCommon = newValue === undefined;

	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  stack.set(srcValue, newValue);

	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	  }
	  stack['delete'](srcValue);
	  assignMergeValue(object, key, newValue);
	}

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];

	    assignValue(object, key, newValue);
	  }
	  return object;
	}

	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return rest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;

	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;

	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}

	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object[key];
	  return isNative(value) ? value : undefined;
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}

	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}

	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});

	module.exports = merge;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;

	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};

	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;

	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = (freeModule && freeModule.exports === freeExports)
	  ? freeExports
	  : undefined;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);

	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);

	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array.length;

	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getOwnPropertySymbols = Object.getOwnPropertySymbols,
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf,
	    nativeKeys = Object.keys;

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}

	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;

	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);

	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  // Recursively populate clone (susceptible to call stack limits).
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}

	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return hasOwnProperty.call(object, key) ||
	    (typeof object == 'object' && key in object && getPrototype(object) === null);
	}

	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}

	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}

	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}

	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}

	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}

	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}

	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}

	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];

	    assignValue(object, key, newValue);
	  }
	  return object;
	}

	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}

	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object[key];
	  return isNative(value) ? value : undefined;
	}

	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}

	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	function getSymbols(object) {
	  // Coerce `object` to an object to avoid non-object errors in V8.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	  return getOwnPropertySymbols(Object(object));
	}

	// Fallback for IE < 11.
	if (!getOwnPropertySymbols) {
	  getSymbols = function() {
	    return [];
	  };
	}

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}

	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}

	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);

	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}

	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);

	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);

	    case dataViewTag:
	      return cloneDataView(object, isDeep);

	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);

	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);

	    case numberTag:
	    case stringTag:
	      return new Ctor(object);

	    case regexpTag:
	      return cloneRegExp(object);

	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);

	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}

	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? constant(false) : function(value) {
	  return value instanceof Buffer;
	};

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;

	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var getter = _.constant(object);
	 *
	 * getter() === object;
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}

	module.exports = baseClone;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)(module), (function() { return this; }())))

/***/ },
/* 18 */
/***/ function(module, exports) {

	/**
	 * lodash 4.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** `Object#toString` result references. */
	var objectTag = '[object Object]';

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);

	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;

	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}

	module.exports = isPlainObject;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    stringTag = '[object String]';

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};

	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;

	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);

	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);

	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];

	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Built-in value references. */
	var Reflect = root.Reflect,
	    enumerate = Reflect ? Reflect.enumerate : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;

	/**
	 * The base implementation of `_.keysIn` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  object = object == null ? object : Object(object);

	  var result = [];
	  for (var key in object) {
	    result.push(key);
	  }
	  return result;
	}

	// Fallback for IE < 9 with es6-shim.
	if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	  baseKeysIn = function(object) {
	    return iteratorToArray(enumerate(object));
	  };
	}

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');

	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  var index = -1,
	      isProto = isPrototype(object),
	      props = baseKeysIn(object),
	      propsLength = props.length,
	      indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;

	  while (++index < propsLength) {
	    var key = props[index];
	    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	module.exports = keysIn;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)(module), (function() { return this; }())))

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;

	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';

	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;

	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);

	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}

	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;

	  return result === result ? (remainder ? result - remainder : result) : 0;
	}

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	module.exports = rest;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */

	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};

	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;

	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);

	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);

	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);

	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);

	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}

	module.exports = root;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)(module), (function() { return this; }())))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _dedupe = __webpack_require__(23);

	var _dedupe2 = _interopRequireDefault(_dedupe);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Popup = function Popup(props) {
	  var _this = this;

	  _classCallCheck(this, Popup);

	  this.render = function () {
	    var _props = _this.props;
	    var className = _props.className;
	    var contentHtml = _props.contentHtml;
	    var arrow = _props.arrow;
	    var target = _props.target;
	    var constrainTo = _props.constrainTo;
	    var placement = _props.placement;
	    var align = _props.align;

	    var div = document.createElement('div');
	    div.className = 'jsr-popup ' + (className || '') + ' jsr-popup-placement-' + placement + ' jsr-popup-align-' + align;
	    div.innerHTML = '\n      <div class="jsr-popup-content">\n        ' + (contentHtml || '') + '\n      </div>\n      <div class="jsr-popup-arrow jsr-popup-arrow-' + arrow + '"></div>\n    ';
	    document.body.appendChild(div);
	    _this.el = div;
	    _this.align();
	    _this.rendered = true;
	    div.addEventListener('click', _this.onClick);
	    document.body.addEventListener('click', _this.onBodyClick);
	  };

	  this.align = function () {
	    var _props2 = _this.props;
	    var className = _props2.className;
	    var contentHtml = _props2.contentHtml;
	    var arrow = _props2.arrow;
	    var target = _props2.target;
	    var constrainTo = _props2.constrainTo;
	    var placement = _props2.placement;
	    var align = _props2.align;

	    var div = _this.el;
	    var box = div.getBoundingClientRect();
	    var origWidth = box.width;
	    var origHeight = box.height;
	    var isAboveOrBelow = ['top', 'bottom'].indexOf(placement) >= 0;
	    var top = 0;
	    var left = 0;
	    var width = 0;
	    var height = 0;
	    var arrowOffset = 15;
	    var constrain = constrainTo ? constrainTo.getBoundingClientRect() : {
	      top: 0,
	      left: 0,
	      right: window.innerWidth - 10,
	      bottom: window.innerHeight - 10
	    };
	    if (target) {
	      var targetBox = target.getBoundingClientRect();
	      switch (placement) {
	        case 'bottom':
	          top = targetBox.bottom + 5;
	          break;
	        case 'right':
	          left = targetBox.right + 5;
	          top = targetBox.top;
	          arrowOffset = targetBox.height / 2 - 4;
	          break;
	      }
	      switch (align) {
	        case 'left':
	          if (isAboveOrBelow) {
	            arrowOffset = targetBox.width / 2 - 4;
	            left = targetBox.left;
	          }
	          break;
	        case 'right':
	          if (isAboveOrBelow) {
	            left = targetBox.right - origWidth;
	            arrowOffset = origWidth - targetBox.width / 2 - 4;
	          }
	          break;
	      }
	    }
	    div.style.top = (document.body.scrollTop || 0) + top + 'px';
	    div.style.left = (document.body.scrollLeft || 0) + left + 'px';
	    if (origHeight > constrain.height) {
	      div.style.height = constrain.height + 'px';
	    }
	    if (origWidth > constrain.width) {
	      div.style.width = constrain.width + 'px';
	    }
	    if (top + origHeight > constrain.bottom) {
	      div.style.height = constrain.bottom - top + 'px';
	    }
	    if (left + origWidth > constrain.right) {
	      div.style.width = constrain.right - left + 'px';
	    }
	    var arrowOffsetProp = isAboveOrBelow ? 'left' : 'top';
	    div.querySelector('.jsr-popup-arrow').style[arrowOffsetProp] = arrowOffset + 'px';
	  };

	  this.onClick = function (evt) {
	    evt.stopPropagation();
	  };

	  this.onBodyClick = function () {
	    if (_this.visible) {
	      _this.hide();
	    }
	  };

	  this.setVisible = function (visible) {
	    _this.el.className = (0, _dedupe2.default)(_this.el.className, {
	      'jsr-popup-transitioning': true
	    });
	    setTimeout(function () {
	      _this.el.className = (0, _dedupe2.default)(_this.el.className, {
	        'jsr-popup-visible': visible
	      });
	      setTimeout(function () {
	        _this.el.className = (0, _dedupe2.default)(_this.el.className, {
	          'jsr-popup-transitioning': false
	        });
	      }, 200);
	      _this.visible = visible;
	    }, 0);
	  };

	  this.show = function (target) {
	    if (!_this.rendered) {
	      _this.render();
	    }
	    if (target) {
	      _this.props.target = target;
	    }
	    _this.align();
	    _this.setVisible(true);
	    if (_this.props.onShow) _this.props.onShow();
	  };

	  this.hide = function () {
	    _this.setVisible(false);
	    if (_this.props.onHide) _this.props.onHide();
	  };

	  this.props = _extends({}, Popup.defaultProps, props);
	  this.show();
	};

	Popup.defaultProps = {
	  arrow: 'top',
	  placement: 'bottom',
	  align: 'left'
	};
	;

	exports.default = Popup;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */

	(function () {
		'use strict';

		var classNames = (function () {
			// don't inherit from Object so we can skip hasOwnProperty check later
			// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
			function StorageObject() {}
			StorageObject.prototype = Object.create(null);

			function _parseArray (resultSet, array) {
				var length = array.length;

				for (var i = 0; i < length; ++i) {
					_parse(resultSet, array[i]);
				}
			}

			var hasOwn = {}.hasOwnProperty;

			function _parseNumber (resultSet, num) {
				resultSet[num] = true;
			}

			function _parseObject (resultSet, object) {
				for (var k in object) {
					if (hasOwn.call(object, k)) {
						// set value to false instead of deleting it to avoid changing object structure
						// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
						resultSet[k] = !!object[k];
					}
				}
			}

			var SPACE = /\s+/;
			function _parseString (resultSet, str) {
				var array = str.split(SPACE);
				var length = array.length;

				for (var i = 0; i < length; ++i) {
					resultSet[array[i]] = true;
				}
			}

			function _parse (resultSet, arg) {
				if (!arg) return;
				var argType = typeof arg;

				// 'foo bar'
				if (argType === 'string') {
					_parseString(resultSet, arg);

				// ['foo', 'bar', ...]
				} else if (Array.isArray(arg)) {
					_parseArray(resultSet, arg);

				// { 'foo': true, ... }
				} else if (argType === 'object') {
					_parseObject(resultSet, arg);

				// '130'
				} else if (argType === 'number') {
					_parseNumber(resultSet, arg);
				}
			}

			function _classNames () {
				// don't leak arguments
				// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
				var len = arguments.length;
				var args = Array(len);
				for (var i = 0; i < len; i++) {
					args[i] = arguments[i];
				}

				var classSet = new StorageObject();
				_parseArray(classSet, args);

				var list = [];

				for (var k in classSet) {
					if (classSet[k]) {
						list.push(k)
					}
				}

				return list.join(' ');
			}

			return _classNames;
		})();

		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * jquery.event.drag - v 2.2
	 * Copyright (c) 2010 Three Dub Media - http://threedubmedia.com
	 * Open Source MIT License - http://threedubmedia.com/code/license
	 */
	// Created: 2008-06-04
	// Updated: 2012-05-21
	// REQUIRES: jquery 1.7.x

	module.exports = function( $ ) {
	    // add the jquery instance method
	    $.fn.drag = function( str, arg, opts ){
	        // figure out the event type
	        var type = typeof str == "string" ? str : "",
	            // figure out the event handler...
	            fn = $.isFunction( str ) ? str : $.isFunction( arg ) ? arg : null;
	        // fix the event type
	        if ( type.indexOf("drag") !== 0 )
	            type = "drag"+ type;
	        // were options passed
	        opts = ( str == fn ? arg : opts ) || {};
	        // trigger or bind event handler
	        return fn ? this.on( type, opts, fn ) : this.trigger( type );
	    };

	    // local refs (increase compression)
	    var $event = $.event,
	        $special = $event.special,
	        // configure the drag special event
	        drag = $special.drag = {

	            // these are the default settings
	            defaults: {
	                which: 1, // mouse button pressed to start drag sequence
	                distance: 0, // distance dragged before dragstart
	                not: ':input', // selector to suppress dragging on target elements
	                handle: null, // selector to match handle target elements
	                relative: false, // true to use "position", false to use "offset"
	                drop: true, // false to suppress drop events, true or selector to allow
	                click: false // false to suppress click events after dragend (no proxy)
	            },

	            // the key name for stored drag data
	            datakey: "dragdata",

	            // prevent bubbling for better performance
	            noBubble: true,

	            // count bound related events
	            add: function( obj ){
	                // read the interaction data
	                var data = $.data( this, drag.datakey ),
	                    // read any passed options
	                    opts = obj.data || {};
	                // count another realted event
	                data.related += 1;
	                // extend data options bound with this event
	                // don't iterate "opts" in case it is a node
	                $.each( drag.defaults, function( key, def ){
	                    if ( opts[ key ] !== undefined )
	                        data[ key ] = opts[ key ];
	                });
	            },

	            // forget unbound related events
	            remove: function(){
	                $.data( this, drag.datakey ).related -= 1;
	            },

	            // configure interaction, capture settings
	            setup: function(){
	                // check for related events
	                if ( $.data( this, drag.datakey ) )
	                    return;
	                // initialize the drag data with copied defaults
	                var data = $.extend({ related:0 }, drag.defaults );
	                // store the interaction data
	                $.data( this, drag.datakey, data );
	                // bind the mousedown event, which starts drag interactions
	                $event.add( this, "touchstart mousedown", drag.init, data );
	                // prevent image dragging in IE...
	                if ( this.attachEvent )
	                    this.attachEvent("ondragstart", drag.dontstart );
	            },

	            // destroy configured interaction
	            teardown: function(){
	                var data = $.data( this, drag.datakey ) || {};
	                // check for related events
	                if ( data.related )
	                    return;
	                // remove the stored data
	                $.removeData( this, drag.datakey );
	                // remove the mousedown event
	                $event.remove( this, "touchstart mousedown", drag.init );
	                // enable text selection
	                drag.textselect( true );
	                // un-prevent image dragging in IE...
	                if ( this.detachEvent )
	                    this.detachEvent("ondragstart", drag.dontstart );
	            },

	            // initialize the interaction
	            init: function( event ){
	                // sorry, only one touch at a time
	                if ( drag.touched )
	                    return;
	                // the drag/drop interaction data
	                var dd = event.data, results;
	                // check the which directive
	                if ( event.which != 0 && dd.which > 0 && event.which != dd.which )
	                    return;
	                // check for suppressed selector
	                if ( $( event.target ).is( dd.not ) )
	                    return;
	                // check for handle selector
	                if ( dd.handle && !$( event.target ).closest( dd.handle, event.currentTarget ).length )
	                    return;

	                drag.touched = event.type == 'touchstart' ? this : null;
	                dd.propagates = 1;
	                dd.mousedown = this;
	                dd.interactions = [ drag.interaction( this, dd ) ];
	                dd.target = event.target;
	                dd.pageX = event.pageX;
	                dd.pageY = event.pageY;
	                dd.dragging = null;
	                // handle draginit event...
	                results = drag.hijack( event, "draginit", dd );
	                // early cancel
	                if ( !dd.propagates )
	                    return;
	                // flatten the result set
	                results = drag.flatten( results );
	                // insert new interaction elements
	                if ( results && results.length ){
	                    dd.interactions = [];
	                    $.each( results, function(){
	                        dd.interactions.push( drag.interaction( this, dd ) );
	                    });
	                }
	                // remember how many interactions are propagating
	                dd.propagates = dd.interactions.length;
	                // locate and init the drop targets
	                if ( dd.drop !== false && $special.drop )
	                    $special.drop.handler( event, dd );
	                // disable text selection
	                drag.textselect( false );
	                // bind additional events...
	                if ( drag.touched )
	                    $event.add( drag.touched, "touchmove touchend", drag.handler, dd );
	                else
	                    $event.add( document, "mousemove mouseup", drag.handler, dd );
	                // helps prevent text selection or scrolling
	                if ( !drag.touched || dd.live )
	                    return false;
	            },

	            // returns an interaction object
	            interaction: function( elem, dd ){
	                var offset = $( elem )[ dd.relative ? "position" : "offset" ]() || { top:0, left:0 };
	                return {
	                    drag: elem,
	                    callback: new drag.callback(),
	                    droppable: [],
	                    offset: offset
	                };
	            },

	            // handle drag-releatd DOM events
	            handler: function( event ){
	                // read the data before hijacking anything
	                var dd = event.data;
	                // handle various events
	                switch ( event.type ){
	                    // mousemove, check distance, start dragging
	                    case !dd.dragging && 'touchmove':
	                        event.preventDefault();
	                    case !dd.dragging && 'mousemove':
	                        //  drag tolerance, x² + y² = distance²
	                        if ( Math.pow(  event.pageX-dd.pageX, 2 ) + Math.pow(  event.pageY-dd.pageY, 2 ) < Math.pow( dd.distance, 2 ) )
	                            break; // distance tolerance not reached
	                        event.target = dd.target; // force target from "mousedown" event (fix distance issue)
	                        drag.hijack( event, "dragstart", dd ); // trigger "dragstart"
	                        if ( dd.propagates ) // "dragstart" not rejected
	                            dd.dragging = true; // activate interaction
	                        // mousemove, dragging
	                    case 'touchmove':
	                        event.preventDefault();
	                    case 'mousemove':
	                        if ( dd.dragging ){
	                            // trigger "drag"
	                            drag.hijack( event, "drag", dd );
	                            if ( dd.propagates ){
	                                // manage drop events
	                                if ( dd.drop !== false && $special.drop )
	                                    $special.drop.handler( event, dd ); // "dropstart", "dropend"
	                                break; // "drag" not rejected, stop
	                            }
	                            event.type = "mouseup"; // helps "drop" handler behave
	                        }
	                        // mouseup, stop dragging
	                    case 'touchend':
	                    case 'mouseup':
	                    default:
	                        if ( drag.touched )
	                            $event.remove( drag.touched, "touchmove touchend", drag.handler ); // remove touch events
	                        else
	                            $event.remove( document, "mousemove mouseup", drag.handler ); // remove page events
	                        if ( dd.dragging ){
	                            if ( dd.drop !== false && $special.drop )
	                                $special.drop.handler( event, dd ); // "drop"
	                            drag.hijack( event, "dragend", dd ); // trigger "dragend"
	                        }
	                        drag.textselect( true ); // enable text selection
	                        // if suppressing click events...
	                        if ( dd.click === false && dd.dragging )
	                            $.data( dd.mousedown, "suppress.click", new Date().getTime() + 5 );
	                        dd.dragging = drag.touched = false; // deactivate element
	                        break;
	                }
	            },

	            // re-use event object for custom events
	            hijack: function( event, type, dd, x, elem ){
	                // not configured
	                if ( !dd )
	                    return;
	                // remember the original event and type
	                var orig = { event:event.originalEvent, type:event.type },
	                    // is the event drag related or drog related?
	                    mode = type.indexOf("drop") ? "drag" : "drop",
	                    // iteration vars
	                    result, i = x || 0, ia, $elems, callback,
	                    len = !isNaN( x ) ? x : dd.interactions.length;
	                // modify the event type
	                event.type = type;
	                // protects originalEvent from side-effects
	                var noop = function(){};
	                event.originalEvent = new jQuery.Event(orig.event, {
	                    preventDefault: noop,
	                    stopPropagation: noop,
	                    stopImmediatePropagation: noop
	                });
	                // initialize the results
	                dd.results = [];
	                // handle each interacted element
	                do if ( ia = dd.interactions[ i ] ){
	                    // validate the interaction
	                    if ( type !== "dragend" && ia.cancelled )
	                        continue;
	                    // set the dragdrop properties on the event object
	                    callback = drag.properties( event, dd, ia );
	                    // prepare for more results
	                    ia.results = [];
	                    // handle each element
	                    $( elem || ia[ mode ] || dd.droppable ).each(function( p, subject ){
	                        // identify drag or drop targets individually
	                        callback.target = subject;
	                        // force propagtion of the custom event
	                        event.isPropagationStopped = function(){ return false; };
	                        // handle the event
	                        result = subject ? $event.dispatch.call( subject, event, callback ) : null;
	                        // stop the drag interaction for this element
	                        if ( result === false ){
	                            if ( mode == "drag" ){
	                                ia.cancelled = true;
	                                dd.propagates -= 1;
	                            }
	                            if ( type == "drop" ){
	                                ia[ mode ][p] = null;
	                            }
	                        }
	                        // assign any dropinit elements
	                        else if ( type == "dropinit" )
	                            ia.droppable.push( drag.element( result ) || subject );
	                        // accept a returned proxy element
	                        if ( type == "dragstart" )
	                            ia.proxy = $( drag.element( result ) || ia.drag )[0];
	                        // remember this result
	                        ia.results.push( result );
	                        // forget the event result, for recycling
	                        delete event.result;
	                        // break on cancelled handler
	                        if ( type !== "dropinit" )
	                            return result;
	                    });
	                    // flatten the results
	                    dd.results[ i ] = drag.flatten( ia.results );
	                    // accept a set of valid drop targets
	                    if ( type == "dropinit" )
	                        ia.droppable = drag.flatten( ia.droppable );
	                    // locate drop targets
	                    if ( type == "dragstart" && !ia.cancelled )
	                        callback.update();
	                }
	                while ( ++i < len )
	                    // restore the original event & type
	                    event.type = orig.type;
	                    event.originalEvent = orig.event;
	                    // return all handler results
	                    return drag.flatten( dd.results );
	            },

	            // extend the callback object with drag/drop properties...
	            properties: function( event, dd, ia ){
	                var obj = ia.callback;
	                // elements
	                obj.drag = ia.drag;
	                obj.proxy = ia.proxy || ia.drag;
	                // starting mouse position
	                obj.startX = dd.pageX;
	                obj.startY = dd.pageY;
	                // current distance dragged
	                obj.deltaX = event.pageX - dd.pageX;
	                obj.deltaY = event.pageY - dd.pageY;
	                // original element position
	                obj.originalX = ia.offset.left;
	                obj.originalY = ia.offset.top;
	                // adjusted element position
	                obj.offsetX = obj.originalX + obj.deltaX;
	                obj.offsetY = obj.originalY + obj.deltaY;
	                // assign the drop targets information
	                obj.drop = drag.flatten( ( ia.drop || [] ).slice() );
	                obj.available = drag.flatten( ( ia.droppable || [] ).slice() );
	                return obj;
	            },

	            // determine is the argument is an element or jquery instance
	            element: function( arg ){
	                if ( arg && ( arg.jquery || arg.nodeType == 1 ) )
	                    return arg;
	            },

	            // flatten nested jquery objects and arrays into a single dimension array
	            flatten: function( arr ){
	                return $.map( arr, function( member ){
	                    return member && member.jquery ? $.makeArray( member ) :
	                        member && member.length ? drag.flatten( member ) : member;
	                });
	            },

	            // toggles text selection attributes ON (true) or OFF (false)
	            textselect: function( bool ){
	                $( document )[ bool ? "off" : "on" ]("selectstart", drag.dontstart )
	                    .css("MozUserSelect", bool ? "" : "none" );
	                // .attr("unselectable", bool ? "off" : "on" )
	                document.unselectable = bool ? "off" : "on";
	            },

	            // suppress "selectstart" and "ondragstart" events
	            dontstart: function(){
	                return false;
	            },

	            // a callback instance contructor
	            callback: function(){}

	        };

	        // callback methods
	        drag.callback.prototype = {
	            update: function(){
	                if ( $special.drop && this.available.length )
	                    $.each( this.available, function( i ){
	                        $special.drop.locate( this, i );
	                    });
	            }
	        };

	        // patch $.event.$dispatch to allow suppressing clicks
	        var $dispatch = $event.dispatch;
	        $event.dispatch = function( event ){
	            if ( $.data( this, "suppress."+ event.type ) - new Date().getTime() > 0 ){
	                $.removeData( this, "suppress."+ event.type );
	                return;
	            }
	            return $dispatch.apply( this, arguments );
	        };

	        // share the same special event configuration with related events...
	        $special.draginit = $special.dragstart = $special.dragend = drag;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(26);
	__webpack_require__(30);
	// require('./styles/bootstrap-btn.css');
	__webpack_require__(32);
	__webpack_require__(34);
	__webpack_require__(39);
	__webpack_require__(41);
	__webpack_require__(43);
	__webpack_require__(45);
	__webpack_require__(47);
	__webpack_require__(49);
	__webpack_require__(73);

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(27);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./bootstrap-base.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./bootstrap-base.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".ditto-designer button,\n.ditto-designer input,\n.ditto-designer select,\n.ditto-designer textarea {\n  margin: 0;\n  font-size: 100%;\n  vertical-align: middle;\n}\n\n.ditto-designer button,\n.ditto-designer input {\n  *overflow: visible;\n  line-height: normal;\n}\n\n.ditto-designer button::-moz-focus-inner,\n.ditto-designer input::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\n\n.ditto-designer button,\n.ditto-designer html input[type=\"button\"],\n.ditto-designer input[type=\"reset\"],\n.ditto-designer input[type=\"submit\"] {\n  cursor: pointer;\n  -webkit-appearance: button;\n}\n\n.ditto-designer label,\n.ditto-designer select,\n.ditto-designer button,\n.ditto-designer input[type=\"button\"],\n.ditto-designer input[type=\"reset\"],\n.ditto-designer input[type=\"submit\"],\n.ditto-designer input[type=\"radio\"],\n.ditto-designer input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.ditto-designer input[type=\"search\"] {\n  -webkit-box-sizing: content-box;\n     -moz-box-sizing: content-box;\n          box-sizing: content-box;\n  -webkit-appearance: textfield;\n}\n\n.ditto-designer input[type=\"search\"]::-webkit-search-decoration,\n.ditto-designer input[type=\"search\"]::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n}\n\n.ditto-designer textarea {\n  overflow: auto;\n  vertical-align: top;\n}\n\n.ditto-designer {\n  margin: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 20px;\n  color: #333333;\n  background-color: #ffffff;\n}\n\n.ditto-designer a {\n  color: #0088cc;\n  text-decoration: none;\n}\n\n.ditto-designer a:hover,\n.ditto-designer a:focus {\n  color: #005580;\n  text-decoration: underline;\n}", ""]);

	// exports


/***/ },
/* 28 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(31);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./bootstrap-nav.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./bootstrap-nav.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".jsr-style-root .nav {\n  margin-bottom: 20px;\n  margin-left: 0;\n  list-style: none;\n}\n\n.jsr-style-root .nav > li > a {\n  display: block;\n}\n\n.jsr-style-root .nav > li > a:hover,\n.jsr-style-root .nav > li > a:focus {\n  text-decoration: none;\n  background-color: #eeeeee;\n}\n\n.jsr-style-root .nav > li > a > img {\n  max-width: none;\n}\n\n.jsr-style-root .nav > .pull-right {\n  float: right;\n}\n\n.jsr-style-root .nav-header {\n  display: block;\n  padding: 3px 15px;\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 20px;\n  color: #999999;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n}\n\n.jsr-style-root .nav li + .nav-header {\n  margin-top: 9px;\n}\n\n.jsr-style-root .nav-list {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-bottom: 0;\n}\n\n.jsr-style-root .nav-list > li > a,\n.jsr-style-root .nav-list .nav-header {\n  margin-right: -15px;\n  margin-left: -15px;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.jsr-style-root .nav-list > li > a {\n  padding: 3px 15px;\n}\n\n.jsr-style-root .nav-list > .active > a,\n.jsr-style-root .nav-list > .active > a:hover,\n.jsr-style-root .nav-list > .active > a:focus {\n  color: #ffffff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);\n  background-color: #0088cc;\n}\n\n.jsr-style-root .nav-list [class^=\"icon-\"],\n.jsr-style-root .nav-list [class*=\" icon-\"] {\n  margin-right: 2px;\n}\n\n.jsr-style-root .nav-list .divider {\n  *width: 100%;\n  height: 1px;\n  margin: 9px 1px;\n  *margin: -5px 0 5px;\n  overflow: hidden;\n  background-color: #e5e5e5;\n  border-bottom: 1px solid #ffffff;\n}\n\n.jsr-style-root .nav-tabs,\n.jsr-style-root .nav-pills {\n  *zoom: 1;\n}\n\n.jsr-style-root .nav-tabs:before,\n.jsr-style-root .nav-pills:before,\n.jsr-style-root .nav-tabs:after,\n.jsr-style-root .nav-pills:after {\n  display: table;\n  line-height: 0;\n  content: \"\";\n}\n\n.jsr-style-root .nav-tabs:after,\n.jsr-style-root .nav-pills:after {\n  clear: both;\n}\n\n.jsr-style-root .nav-tabs > li,\n.jsr-style-root .nav-pills > li {\n  float: left;\n}\n\n.jsr-style-root .nav-tabs > li > a,\n.jsr-style-root .nav-pills > li > a {\n  padding-right: 12px;\n  padding-left: 12px;\n  margin-right: 2px;\n  line-height: 14px;\n}\n\n.jsr-style-root .nav-tabs {\n  border-bottom: 1px solid #ddd;\n}\n\n.jsr-style-root .nav-tabs > li {\n  margin-bottom: -1px;\n}\n\n.jsr-style-root .nav-tabs > li > a {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  line-height: 20px;\n  border: 1px solid transparent;\n  -webkit-border-radius: 4px 4px 0 0;\n     -moz-border-radius: 4px 4px 0 0;\n          border-radius: 4px 4px 0 0;\n}\n\n.jsr-style-root .nav-tabs > li > a:hover,\n.jsr-style-root .nav-tabs > li > a:focus {\n  border-color: #eeeeee #eeeeee #dddddd;\n}\n\n.jsr-style-root .nav-tabs > .active > a,\n.jsr-style-root .nav-tabs > .active > a:hover,\n.jsr-style-root .nav-tabs > .active > a:focus {\n  color: #555555;\n  cursor: default;\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n}\n\n.jsr-style-root .nav-pills > li > a {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  -webkit-border-radius: 5px;\n     -moz-border-radius: 5px;\n          border-radius: 5px;\n}\n\n.jsr-style-root .nav-pills > .active > a,\n.jsr-style-root .nav-pills > .active > a:hover,\n.jsr-style-root .nav-pills > .active > a:focus {\n  color: #ffffff;\n  background-color: #0088cc;\n}\n\n.jsr-style-root .nav-stacked > li {\n  float: none;\n}\n\n.jsr-style-root .nav-stacked > li > a {\n  margin-right: 0;\n}\n\n.jsr-style-root .nav-tabs.nav-stacked {\n  border-bottom: 0;\n}\n\n.jsr-style-root .nav-tabs.nav-stacked > li > a {\n  border: 1px solid #ddd;\n  -webkit-border-radius: 0;\n     -moz-border-radius: 0;\n          border-radius: 0;\n}\n\n.jsr-style-root .nav-tabs.nav-stacked > li:first-child > a {\n  -webkit-border-top-right-radius: 4px;\n          border-top-right-radius: 4px;\n  -webkit-border-top-left-radius: 4px;\n          border-top-left-radius: 4px;\n  -moz-border-radius-topright: 4px;\n  -moz-border-radius-topleft: 4px;\n}\n\n.jsr-style-root .nav-tabs.nav-stacked > li:last-child > a {\n  -webkit-border-bottom-right-radius: 4px;\n          border-bottom-right-radius: 4px;\n  -webkit-border-bottom-left-radius: 4px;\n          border-bottom-left-radius: 4px;\n  -moz-border-radius-bottomright: 4px;\n  -moz-border-radius-bottomleft: 4px;\n}\n\n.jsr-style-root .nav-tabs.nav-stacked > li > a:hover,\n.jsr-style-root .nav-tabs.nav-stacked > li > a:focus {\n  z-index: 2;\n  border-color: #ddd;\n}\n\n.jsr-style-root .nav-pills.nav-stacked > li > a {\n  margin-bottom: 3px;\n}\n\n.jsr-style-root .nav-pills.nav-stacked > li:last-child > a {\n  margin-bottom: 1px;\n}\n\n.jsr-style-root .nav-tabs .dropdown-menu {\n  -webkit-border-radius: 0 0 6px 6px;\n     -moz-border-radius: 0 0 6px 6px;\n          border-radius: 0 0 6px 6px;\n}\n\n.jsr-style-root .nav-pills .dropdown-menu {\n  -webkit-border-radius: 6px;\n     -moz-border-radius: 6px;\n          border-radius: 6px;\n}\n\n.jsr-style-root .nav .dropdown-toggle .caret {\n  margin-top: 6px;\n  border-top-color: #0088cc;\n  border-bottom-color: #0088cc;\n}\n\n.jsr-style-root .nav .dropdown-toggle:hover .caret,\n.jsr-style-root .nav .dropdown-toggle:focus .caret {\n  border-top-color: #005580;\n  border-bottom-color: #005580;\n}\n\n/* move down carets for tabs */\n\n.jsr-style-root .nav-tabs .dropdown-toggle .caret {\n  margin-top: 8px;\n}\n\n.jsr-style-root .nav .active .dropdown-toggle .caret {\n  border-top-color: #fff;\n  border-bottom-color: #fff;\n}\n\n.jsr-style-root .nav-tabs .active .dropdown-toggle .caret {\n  border-top-color: #555555;\n  border-bottom-color: #555555;\n}\n\n.jsr-style-root .nav > .dropdown.active > a:hover,\n.jsr-style-root .nav > .dropdown.active > a:focus {\n  cursor: pointer;\n}\n\n.jsr-style-root .nav-tabs .open .dropdown-toggle,\n.jsr-style-root .nav-pills .open .dropdown-toggle,\n.jsr-style-root .nav > li.dropdown.open.active > a:hover,\n.jsr-style-root .nav > li.dropdown.open.active > a:focus {\n  color: #ffffff;\n  background-color: #999999;\n  border-color: #999999;\n}\n\n.jsr-style-root .nav li.dropdown.open .caret,\n.jsr-style-root .nav li.dropdown.open.active .caret,\n.jsr-style-root .nav li.dropdown.open a:hover .caret,\n.jsr-style-root .nav li.dropdown.open a:focus .caret {\n  border-top-color: #ffffff;\n  border-bottom-color: #ffffff;\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n\n.jsr-style-root .tabs-stacked .open > a:hover,\n.jsr-style-root .tabs-stacked .open > a:focus {\n  border-color: #999999;\n}\n\n.jsr-style-root .tabbable {\n  *zoom: 1;\n}\n\n.jsr-style-root .tabbable:before,\n.jsr-style-root .tabbable:after {\n  display: table;\n  line-height: 0;\n  content: \"\";\n}\n\n.jsr-style-root .tabbable:after {\n  clear: both;\n}\n\n.jsr-style-root .tab-content {\n  overflow: auto;\n}\n\n.jsr-style-root .tabs-below > .nav-tabs,\n.jsr-style-root .tabs-right > .nav-tabs,\n.jsr-style-root .tabs-left > .nav-tabs {\n  border-bottom: 0;\n}\n\n.jsr-style-root .tab-content > .tab-pane,\n.jsr-style-root .pill-content > .pill-pane {\n  display: none;\n}\n\n.jsr-style-root .tab-content > .active,\n.jsr-style-root .pill-content > .active {\n  display: block;\n}\n\n.jsr-style-root .tabs-below > .nav-tabs {\n  border-top: 1px solid #ddd;\n}\n\n.jsr-style-root .tabs-below > .nav-tabs > li {\n  margin-top: -1px;\n  margin-bottom: 0;\n}\n\n.jsr-style-root .tabs-below > .nav-tabs > li > a {\n  -webkit-border-radius: 0 0 4px 4px;\n     -moz-border-radius: 0 0 4px 4px;\n          border-radius: 0 0 4px 4px;\n}\n\n.jsr-style-root .tabs-below > .nav-tabs > li > a:hover,\n.jsr-style-root .tabs-below > .nav-tabs > li > a:focus {\n  border-top-color: #ddd;\n  border-bottom-color: transparent;\n}\n\n.jsr-style-root .tabs-below > .nav-tabs > .active > a,\n.jsr-style-root .tabs-below > .nav-tabs > .active > a:hover,\n.jsr-style-root .tabs-below > .nav-tabs > .active > a:focus {\n  border-color: transparent #ddd #ddd #ddd;\n}\n\n.jsr-style-root .tabs-left > .nav-tabs > li,\n.jsr-style-root .tabs-right > .nav-tabs > li {\n  float: none;\n}\n\n.jsr-style-root .tabs-left > .nav-tabs > li > a,\n.jsr-style-root .tabs-right > .nav-tabs > li > a {\n  min-width: 74px;\n  margin-right: 0;\n  margin-bottom: 3px;\n}\n\n.jsr-style-root .tabs-left > .nav-tabs {\n  float: left;\n  margin-right: 19px;\n  border-right: 1px solid #ddd;\n}\n\n.jsr-style-root .tabs-left > .nav-tabs > li > a {\n  margin-right: -1px;\n  -webkit-border-radius: 4px 0 0 4px;\n     -moz-border-radius: 4px 0 0 4px;\n          border-radius: 4px 0 0 4px;\n}\n\n.jsr-style-root .tabs-left > .nav-tabs > li > a:hover,\n.jsr-style-root .tabs-left > .nav-tabs > li > a:focus {\n  border-color: #eeeeee #dddddd #eeeeee #eeeeee;\n}\n\n.jsr-style-root .tabs-left > .nav-tabs .active > a,\n.jsr-style-root .tabs-left > .nav-tabs .active > a:hover,\n.jsr-style-root .tabs-left > .nav-tabs .active > a:focus {\n  border-color: #ddd transparent #ddd #ddd;\n  *border-right-color: #ffffff;\n}\n\n.jsr-style-root .tabs-right > .nav-tabs {\n  float: right;\n  margin-left: 19px;\n  border-left: 1px solid #ddd;\n}\n\n.jsr-style-root .tabs-right > .nav-tabs > li > a {\n  margin-left: -1px;\n  -webkit-border-radius: 0 4px 4px 0;\n     -moz-border-radius: 0 4px 4px 0;\n          border-radius: 0 4px 4px 0;\n}\n\n.jsr-style-root .tabs-right > .nav-tabs > li > a:hover,\n.jsr-style-root .tabs-right > .nav-tabs > li > a:focus {\n  border-color: #eeeeee #eeeeee #eeeeee #dddddd;\n}\n\n.jsr-style-root .tabs-right > .nav-tabs .active > a,\n.jsr-style-root .tabs-right > .nav-tabs .active > a:hover,\n.jsr-style-root .tabs-right > .nav-tabs .active > a:focus {\n  border-color: #ddd #ddd #ddd transparent;\n  *border-left-color: #ffffff;\n}\n\n.jsr-style-root .nav > .disabled > a {\n  color: #999999;\n}\n\n.jsr-style-root .nav > .disabled > a:hover,\n.jsr-style-root .nav > .disabled > a:focus {\n  text-decoration: none;\n  cursor: default;\n  background-color: transparent;\n}\n\n.jsr-style-root .navbar {\n  *position: relative;\n  *z-index: 2;\n  margin-bottom: 20px;\n  overflow: visible;\n}\n\n.jsr-style-root .navbar-inner {\n  min-height: 40px;\n  padding-right: 20px;\n  padding-left: 20px;\n  background-color: #fafafa;\n  background-image: -moz-linear-gradient(top, #ffffff, #f2f2f2);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#f2f2f2));\n  background-image: -webkit-linear-gradient(top, #ffffff, #f2f2f2);\n  background-image: -o-linear-gradient(top, #ffffff, #f2f2f2);\n  background-image: linear-gradient(to bottom, #ffffff, #f2f2f2);\n  background-repeat: repeat-x;\n  border: 1px solid #d4d4d4;\n  -webkit-border-radius: 4px;\n     -moz-border-radius: 4px;\n          border-radius: 4px;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#fff2f2f2', GradientType=0);\n  *zoom: 1;\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);\n     -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);\n          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);\n}\n\n.jsr-style-root .navbar-inner:before,\n.jsr-style-root .navbar-inner:after {\n  display: table;\n  line-height: 0;\n  content: \"\";\n}\n\n.jsr-style-root .navbar-inner:after {\n  clear: both;\n}\n\n.jsr-style-root .navbar .container {\n  width: auto;\n}\n\n.jsr-style-root .nav-collapse.collapse {\n  height: auto;\n  overflow: visible;\n}\n\n.jsr-style-root .navbar .brand {\n  display: block;\n  float: left;\n  padding: 10px 20px 10px;\n  margin-left: -20px;\n  font-size: 20px;\n  font-weight: 200;\n  color: #777777;\n  text-shadow: 0 1px 0 #ffffff;\n}\n\n.jsr-style-root .navbar .brand:hover,\n.jsr-style-root .navbar .brand:focus {\n  text-decoration: none;\n}\n\n.jsr-style-root .navbar-text {\n  margin-bottom: 0;\n  line-height: 40px;\n  color: #777777;\n}\n\n.jsr-style-root .navbar-link {\n  color: #777777;\n}\n\n.jsr-style-root .navbar-link:hover,\n.jsr-style-root .navbar-link:focus {\n  color: #333333;\n}\n\n.jsr-style-root .navbar .divider-vertical {\n  height: 40px;\n  margin: 0 9px;\n  border-right: 1px solid #ffffff;\n  border-left: 1px solid #f2f2f2;\n}\n\n.jsr-style-root .navbar .btn,\n.jsr-style-root .navbar .btn-group {\n  margin-top: 5px;\n}\n\n.jsr-style-root .navbar .btn-group .btn,\n.jsr-style-root .navbar .input-prepend .btn,\n.jsr-style-root .navbar .input-append .btn,\n.jsr-style-root .navbar .input-prepend .btn-group,\n.jsr-style-root .navbar .input-append .btn-group {\n  margin-top: 0;\n}\n\n.jsr-style-root .navbar-form {\n  margin-bottom: 0;\n  *zoom: 1;\n}\n\n.jsr-style-root .navbar-form:before,\n.jsr-style-root .navbar-form:after {\n  display: table;\n  line-height: 0;\n  content: \"\";\n}\n\n.jsr-style-root .navbar-form:after {\n  clear: both;\n}\n\n.jsr-style-root .navbar-form input,\n.jsr-style-root .navbar-form select,\n.jsr-style-root .navbar-form .radio,\n.jsr-style-root .navbar-form .checkbox {\n  margin-top: 5px;\n}\n\n.jsr-style-root .navbar-form input,\n.jsr-style-root .navbar-form select,\n.jsr-style-root .navbar-form .btn {\n  display: inline-block;\n  margin-bottom: 0;\n}\n\n.jsr-style-root .navbar-form input[type=\"image\"],\n.jsr-style-root .navbar-form input[type=\"checkbox\"],\n.jsr-style-root .navbar-form input[type=\"radio\"] {\n  margin-top: 3px;\n}\n\n.jsr-style-root .navbar-form .input-append,\n.jsr-style-root .navbar-form .input-prepend {\n  margin-top: 5px;\n  white-space: nowrap;\n}\n\n.jsr-style-root .navbar-form .input-append input,\n.jsr-style-root .navbar-form .input-prepend input {\n  margin-top: 0;\n}\n\n.jsr-style-root .navbar-search {\n  position: relative;\n  float: left;\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.jsr-style-root .navbar-search .search-query {\n  padding: 4px 14px;\n  margin-bottom: 0;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  font-weight: normal;\n  line-height: 1;\n  -webkit-border-radius: 15px;\n     -moz-border-radius: 15px;\n          border-radius: 15px;\n}\n\n.jsr-style-root .navbar-static-top {\n  position: static;\n  margin-bottom: 0;\n}\n\n.jsr-style-root .navbar-static-top .navbar-inner {\n  -webkit-border-radius: 0;\n     -moz-border-radius: 0;\n          border-radius: 0;\n}\n\n.jsr-style-root .navbar-fixed-top,\n.jsr-style-root .navbar-fixed-bottom {\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n  margin-bottom: 0;\n}\n\n.jsr-style-root .navbar-fixed-top .navbar-inner,\n.jsr-style-root .navbar-static-top .navbar-inner {\n  border-width: 0 0 1px;\n}\n\n.jsr-style-root .navbar-fixed-bottom .navbar-inner {\n  border-width: 1px 0 0;\n}\n\n.jsr-style-root .navbar-fixed-top .navbar-inner,\n.jsr-style-root .navbar-fixed-bottom .navbar-inner {\n  padding-right: 0;\n  padding-left: 0;\n  -webkit-border-radius: 0;\n     -moz-border-radius: 0;\n          border-radius: 0;\n}\n\n.jsr-style-root .navbar-static-top .container,\n.jsr-style-root .navbar-fixed-top .container,\n.jsr-style-root .navbar-fixed-bottom .container {\n  width: 940px;\n}\n\n.jsr-style-root .navbar-fixed-top {\n  top: 0;\n}\n\n.jsr-style-root .navbar-fixed-top .navbar-inner,\n.jsr-style-root .navbar-static-top .navbar-inner {\n  -webkit-box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);\n     -moz-box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);\n}\n\n.jsr-style-root .navbar-fixed-bottom {\n  bottom: 0;\n}\n\n.jsr-style-root .navbar-fixed-bottom .navbar-inner {\n  -webkit-box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.1);\n     -moz-box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.1);\n}\n\n.jsr-style-root .navbar .nav {\n  position: relative;\n  left: 0;\n  display: block;\n  float: left;\n  margin: 0 10px 0 0;\n}\n\n.jsr-style-root .navbar .nav.pull-right {\n  float: right;\n  margin-right: 0;\n}\n\n.jsr-style-root .navbar .nav > li {\n  float: left;\n}\n\n.jsr-style-root .navbar .nav > li > a {\n  float: none;\n  padding: 10px 15px 10px;\n  color: #777777;\n  text-decoration: none;\n  text-shadow: 0 1px 0 #ffffff;\n}\n\n.jsr-style-root .navbar .nav .dropdown-toggle .caret {\n  margin-top: 8px;\n}\n\n.jsr-style-root .navbar .nav > li > a:focus,\n.jsr-style-root .navbar .nav > li > a:hover {\n  color: #333333;\n  text-decoration: none;\n  background-color: transparent;\n}\n\n.jsr-style-root .navbar .nav > .active > a,\n.jsr-style-root .navbar .nav > .active > a:hover,\n.jsr-style-root .navbar .nav > .active > a:focus {\n  color: #555555;\n  text-decoration: none;\n  background-color: #e5e5e5;\n  -webkit-box-shadow: inset 0 3px 8px rgba(0, 0, 0, 0.125);\n     -moz-box-shadow: inset 0 3px 8px rgba(0, 0, 0, 0.125);\n          box-shadow: inset 0 3px 8px rgba(0, 0, 0, 0.125);\n}\n\n.jsr-style-root .navbar .btn-navbar {\n  display: none;\n  float: right;\n  padding: 7px 10px;\n  margin-right: 5px;\n  margin-left: 5px;\n  color: #ffffff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  background-color: #ededed;\n  *background-color: #e5e5e5;\n  background-image: -moz-linear-gradient(top, #f2f2f2, #e5e5e5);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#f2f2f2), to(#e5e5e5));\n  background-image: -webkit-linear-gradient(top, #f2f2f2, #e5e5e5);\n  background-image: -o-linear-gradient(top, #f2f2f2, #e5e5e5);\n  background-image: linear-gradient(to bottom, #f2f2f2, #e5e5e5);\n  background-repeat: repeat-x;\n  border-color: #e5e5e5 #e5e5e5 #bfbfbf;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff2f2f2', endColorstr='#ffe5e5e5', GradientType=0);\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.075);\n     -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.075);\n          box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.075);\n}\n\n.jsr-style-root .navbar .btn-navbar:hover,\n.jsr-style-root .navbar .btn-navbar:focus,\n.jsr-style-root .navbar .btn-navbar:active,\n.jsr-style-root .navbar .btn-navbar.active,\n.jsr-style-root .navbar .btn-navbar.disabled,\n.jsr-style-root .navbar .btn-navbar[disabled] {\n  color: #ffffff;\n  background-color: #e5e5e5;\n  *background-color: #d9d9d9;\n}\n\n.jsr-style-root .navbar .btn-navbar:active,\n.jsr-style-root .navbar .btn-navbar.active {\n  background-color: #cccccc \\9;\n}\n\n.jsr-style-root .navbar .btn-navbar .icon-bar {\n  display: block;\n  width: 18px;\n  height: 2px;\n  background-color: #f5f5f5;\n  -webkit-border-radius: 1px;\n     -moz-border-radius: 1px;\n          border-radius: 1px;\n  -webkit-box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n     -moz-box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n          box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n}\n\n.jsr-style-root .btn-navbar .icon-bar + .icon-bar {\n  margin-top: 3px;\n}\n\n.jsr-style-root .navbar .nav > li > .dropdown-menu:before {\n  position: absolute;\n  top: -7px;\n  left: 9px;\n  display: inline-block;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #ccc;\n  border-left: 7px solid transparent;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  content: '';\n}\n\n.jsr-style-root .navbar .nav > li > .dropdown-menu:after {\n  position: absolute;\n  top: -6px;\n  left: 10px;\n  display: inline-block;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #ffffff;\n  border-left: 6px solid transparent;\n  content: '';\n}\n\n.jsr-style-root .navbar-fixed-bottom .nav > li > .dropdown-menu:before {\n  top: auto;\n  bottom: -7px;\n  border-top: 7px solid #ccc;\n  border-bottom: 0;\n  border-top-color: rgba(0, 0, 0, 0.2);\n}\n\n.jsr-style-root .navbar-fixed-bottom .nav > li > .dropdown-menu:after {\n  top: auto;\n  bottom: -6px;\n  border-top: 6px solid #ffffff;\n  border-bottom: 0;\n}\n\n.jsr-style-root .navbar .nav li.dropdown > a:hover .caret,\n.jsr-style-root .navbar .nav li.dropdown > a:focus .caret {\n  border-top-color: #333333;\n  border-bottom-color: #333333;\n}\n\n.jsr-style-root .navbar .nav li.dropdown.open > .dropdown-toggle,\n.jsr-style-root .navbar .nav li.dropdown.active > .dropdown-toggle,\n.jsr-style-root .navbar .nav li.dropdown.open.active > .dropdown-toggle {\n  color: #555555;\n  background-color: #e5e5e5;\n}\n\n.jsr-style-root .navbar .nav li.dropdown > .dropdown-toggle .caret {\n  border-top-color: #777777;\n  border-bottom-color: #777777;\n}\n\n.jsr-style-root .navbar .nav li.dropdown.open > .dropdown-toggle .caret,\n.jsr-style-root .navbar .nav li.dropdown.active > .dropdown-toggle .caret,\n.jsr-style-root .navbar .nav li.dropdown.open.active > .dropdown-toggle .caret {\n  border-top-color: #555555;\n  border-bottom-color: #555555;\n}\n\n.jsr-style-root .navbar .pull-right > li > .dropdown-menu,\n.jsr-style-root .navbar .nav > li > .dropdown-menu.pull-right {\n  right: 0;\n  left: auto;\n}\n\n.jsr-style-root .navbar .pull-right > li > .dropdown-menu:before,\n.jsr-style-root .navbar .nav > li > .dropdown-menu.pull-right:before {\n  right: 12px;\n  left: auto;\n}\n\n.jsr-style-root .navbar .pull-right > li > .dropdown-menu:after,\n.jsr-style-root .navbar .nav > li > .dropdown-menu.pull-right:after {\n  right: 13px;\n  left: auto;\n}\n\n.jsr-style-root .navbar .pull-right > li > .dropdown-menu .dropdown-menu,\n.jsr-style-root .navbar .nav > li > .dropdown-menu.pull-right .dropdown-menu {\n  right: 100%;\n  left: auto;\n  margin-right: -1px;\n  margin-left: 0;\n  -webkit-border-radius: 6px 0 6px 6px;\n     -moz-border-radius: 6px 0 6px 6px;\n          border-radius: 6px 0 6px 6px;\n}\n\n.jsr-style-root .navbar-inverse .navbar-inner {\n  background-color: #1b1b1b;\n  background-image: -moz-linear-gradient(top, #222222, #111111);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#222222), to(#111111));\n  background-image: -webkit-linear-gradient(top, #222222, #111111);\n  background-image: -o-linear-gradient(top, #222222, #111111);\n  background-image: linear-gradient(to bottom, #222222, #111111);\n  background-repeat: repeat-x;\n  border-color: #252525;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff222222', endColorstr='#ff111111', GradientType=0);\n}\n\n.jsr-style-root .navbar-inverse .brand,\n.jsr-style-root .navbar-inverse .nav > li > a {\n  color: #999999;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n\n.jsr-style-root .navbar-inverse .brand:hover,\n.jsr-style-root .navbar-inverse .nav > li > a:hover,\n.jsr-style-root .navbar-inverse .brand:focus,\n.jsr-style-root .navbar-inverse .nav > li > a:focus {\n  color: #ffffff;\n}\n\n.jsr-style-root .navbar-inverse .brand {\n  color: #999999;\n}\n\n.jsr-style-root .navbar-inverse .navbar-text {\n  color: #999999;\n}\n\n.jsr-style-root .navbar-inverse .nav > li > a:focus,\n.jsr-style-root .navbar-inverse .nav > li > a:hover {\n  color: #ffffff;\n  background-color: transparent;\n}\n\n.jsr-style-root .navbar-inverse .nav .active > a,\n.jsr-style-root .navbar-inverse .nav .active > a:hover,\n.jsr-style-root .navbar-inverse .nav .active > a:focus {\n  color: #ffffff;\n  background-color: #111111;\n}\n\n.jsr-style-root .navbar-inverse .navbar-link {\n  color: #999999;\n}\n\n.jsr-style-root .navbar-inverse .navbar-link:hover,\n.jsr-style-root .navbar-inverse .navbar-link:focus {\n  color: #ffffff;\n}\n\n.jsr-style-root .navbar-inverse .divider-vertical {\n  border-right-color: #222222;\n  border-left-color: #111111;\n}\n\n.jsr-style-root .navbar-inverse .nav li.dropdown.open > .dropdown-toggle,\n.jsr-style-root .navbar-inverse .nav li.dropdown.active > .dropdown-toggle,\n.jsr-style-root .navbar-inverse .nav li.dropdown.open.active > .dropdown-toggle {\n  color: #ffffff;\n  background-color: #111111;\n}\n\n.jsr-style-root .navbar-inverse .nav li.dropdown > a:hover .caret,\n.jsr-style-root .navbar-inverse .nav li.dropdown > a:focus .caret {\n  border-top-color: #ffffff;\n  border-bottom-color: #ffffff;\n}\n\n.jsr-style-root .navbar-inverse .nav li.dropdown > .dropdown-toggle .caret {\n  border-top-color: #999999;\n  border-bottom-color: #999999;\n}\n\n.jsr-style-root .navbar-inverse .nav li.dropdown.open > .dropdown-toggle .caret,\n.jsr-style-root .navbar-inverse .nav li.dropdown.active > .dropdown-toggle .caret,\n.jsr-style-root .navbar-inverse .nav li.dropdown.open.active > .dropdown-toggle .caret {\n  border-top-color: #ffffff;\n  border-bottom-color: #ffffff;\n}\n\n.jsr-style-root .navbar-inverse .navbar-search .search-query {\n  color: #ffffff;\n  background-color: #515151;\n  border-color: #111111;\n  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 0 rgba(255, 255, 255, 0.15);\n     -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 0 rgba(255, 255, 255, 0.15);\n          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 0 rgba(255, 255, 255, 0.15);\n  -webkit-transition: none;\n     -moz-transition: none;\n       -o-transition: none;\n          transition: none;\n}\n\n.jsr-style-root .navbar-inverse .navbar-search .search-query:-moz-placeholder {\n  color: #cccccc;\n}\n\n.jsr-style-root .navbar-inverse .navbar-search .search-query:-ms-input-placeholder {\n  color: #cccccc;\n}\n\n.jsr-style-root .navbar-inverse .navbar-search .search-query::-webkit-input-placeholder {\n  color: #cccccc;\n}\n\n.jsr-style-root .navbar-inverse .navbar-search .search-query:focus,\n.jsr-style-root .navbar-inverse .navbar-search .search-query.focused {\n  padding: 5px 15px;\n  color: #333333;\n  text-shadow: 0 1px 0 #ffffff;\n  background-color: #ffffff;\n  border: 0;\n  outline: 0;\n  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);\n     -moz-box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);\n          box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);\n}\n\n.jsr-style-root .navbar-inverse .btn-navbar {\n  color: #ffffff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  background-color: #0e0e0e;\n  *background-color: #040404;\n  background-image: -moz-linear-gradient(top, #151515, #040404);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#151515), to(#040404));\n  background-image: -webkit-linear-gradient(top, #151515, #040404);\n  background-image: -o-linear-gradient(top, #151515, #040404);\n  background-image: linear-gradient(to bottom, #151515, #040404);\n  background-repeat: repeat-x;\n  border-color: #040404 #040404 #000000;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff151515', endColorstr='#ff040404', GradientType=0);\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n}\n\n.jsr-style-root .navbar-inverse .btn-navbar:hover,\n.jsr-style-root .navbar-inverse .btn-navbar:focus,\n.jsr-style-root .navbar-inverse .btn-navbar:active,\n.jsr-style-root .navbar-inverse .btn-navbar.active,\n.jsr-style-root .navbar-inverse .btn-navbar.disabled,\n.jsr-style-root .navbar-inverse .btn-navbar[disabled] {\n  color: #ffffff;\n  background-color: #040404;\n  *background-color: #000000;\n}\n\n.jsr-style-root .navbar-inverse .btn-navbar:active,\n.jsr-style-root .navbar-inverse .btn-navbar.active {\n  background-color: #000000 \\9;\n}", ""]);

	// exports


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(33);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./bootstrap-dropdown.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./bootstrap-dropdown.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".jsr-style-root .caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: 4px solid;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n.jsr-style-root .dropdown {\n  position: relative;\n}\n.jsr-style-root .dropdown-toggle:focus {\n  outline: 0;\n}\n.jsr-style-root .dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0;\n  list-style: none;\n  font-size: 14px;\n  text-align: left;\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n}\n.jsr-style-root .dropdown-menu.pull-right {\n  right: 0;\n  left: auto;\n}\n.jsr-style-root .dropdown-menu .divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n.jsr-style-root .dropdown-menu > li > a {\n  display: block;\n  padding: 3px 20px;\n  clear: both;\n  font-weight: normal;\n  line-height: 1.42857143;\n  color: #333333;\n  white-space: nowrap;\n  text-decoration: none;\n}\n.jsr-style-root .dropdown-menu > li > a:hover,\n.jsr-style-root .dropdown-menu > li > a:focus {\n  text-decoration: none;\n  color: #262626;\n  background-color: #f5f5f5;\n}\n.jsr-style-root .dropdown-menu > .active > a,\n.jsr-style-root .dropdown-menu > .active > a:hover,\n.jsr-style-root .dropdown-menu > .active > a:focus {\n  color: #ffffff;\n  text-decoration: none;\n  outline: 0;\n  background-color: #428bca;\n}\n.jsr-style-root .dropdown-menu > .disabled > a,\n.jsr-style-root .dropdown-menu > .disabled > a:hover,\n.jsr-style-root .dropdown-menu > .disabled > a:focus {\n  color: #777777;\n}\n.jsr-style-root .dropdown-menu > .disabled > a:hover,\n.jsr-style-root .dropdown-menu > .disabled > a:focus {\n  text-decoration: none;\n  background-color: transparent;\n  background-image: none;\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);\n  cursor: not-allowed;\n}\n.jsr-style-root .open > .dropdown-menu {\n  display: block;\n}\n.jsr-style-root .open > a {\n  outline: 0;\n}\n.jsr-style-root .dropdown-menu-right {\n  left: auto;\n  right: 0;\n}\n.jsr-style-root .dropdown-menu-left {\n  left: 0;\n  right: auto;\n}\n.jsr-style-root .dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: 12px;\n  line-height: 1.42857143;\n  color: #777777;\n  white-space: nowrap;\n}\n.jsr-style-root .dropdown-backdrop {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  z-index: 990;\n}\n.jsr-style-root .pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n.jsr-style-root .dropup .caret,\n.jsr-style-root .navbar-fixed-bottom .dropdown .caret {\n  border-top: 0;\n  border-bottom: 4px solid;\n  content: \"\";\n}\n.jsr-style-root .dropup .dropdown-menu,\n.jsr-style-root .navbar-fixed-bottom .dropdown .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 1px;\n}\n@media (min-width: 768px) {\n  .jsr-style-root .navbar-right .dropdown-menu {\n    left: auto;\n    right: 0;\n  }\n  .jsr-style-root .navbar-right .dropdown-menu-left {\n    left: 0;\n    right: auto;\n  }\n}\n.jsr-style-root .clearfix:before,\n.jsr-style-root .clearfix:after {\n  content: \" \";\n  display: table;\n}\n.jsr-style-root .clearfix:after {\n  clear: both;\n}\n.jsr-style-root .center-block {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.jsr-style-root .pull-right {\n  float: right !important;\n}\n.jsr-style-root .pull-left {\n  float: left !important;\n}\n.jsr-style-root .hide {\n  display: none !important;\n}\n.jsr-style-root .show {\n  display: block !important;\n}\n.jsr-style-root .invisible {\n  visibility: hidden;\n}\n.jsr-style-root .text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.jsr-style-root .hidden {\n  display: none !important;\n  visibility: hidden !important;\n}\n.jsr-style-root .affix {\n  position: fixed;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n.jsr-style-root .input-append .add-on,\n.jsr-style-root .input-prepend .add-on,\n.jsr-style-root .input-append .btn,\n.jsr-style-root .input-prepend .btn,\n.jsr-style-root .input-append .btn-group > .dropdown-toggle,\n.jsr-style-root .input-prepend .btn-group > .dropdown-toggle {\n  vertical-align: top;\n  -webkit-border-radius: 0;\n     -moz-border-radius: 0;\n          border-radius: 0;\n}", ""]);

	// exports


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(35);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./select2.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./select2.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, "/*\nVersion: 3.4.5 Timestamp: Mon Nov  4 08:22:42 PST 2013\n*/\n.select2-container {\n    margin: 0;\n    position: relative;\n    display: inline-block;\n    /* inline-block for ie7 */\n    zoom: 1;\n    *display: inline;\n    vertical-align: middle;\n}\n\n.select2-container,\n.select2-drop,\n.select2-search,\n.select2-search input {\n  /*\n    Force border-box so that % widths fit the parent\n    container without overlap because of margin/padding.\n\n    More Info : http://www.quirksmode.org/css/box.html\n  */\n  -webkit-box-sizing: border-box; /* webkit */\n     -moz-box-sizing: border-box; /* firefox */\n          box-sizing: border-box; /* css3 */\n}\n\n.select2-container .select2-choice {\n    display: block;\n    height: 26px;\n    padding: 0 0 0 8px;\n    overflow: hidden;\n    position: relative;\n\n    border: 1px solid #aaa;\n    white-space: nowrap;\n    line-height: 26px;\n    color: #444;\n    text-decoration: none;\n\n    border-radius: 4px;\n\n    background-clip: padding-box;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n\n    background-color: #fff;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.5, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#ffffff', endColorstr = '#eeeeee', GradientType = 0);\n    background-image: linear-gradient(top, #fff 0%, #eee 50%);\n}\n\n.select2-container.select2-drop-above .select2-choice {\n    border-bottom-color: #aaa;\n\n    border-radius: 0 0 4px 4px;\n\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #eee), color-stop(0.9, #fff));\n    background-image: -webkit-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    background-image: -moz-linear-gradient(center bottom, #eee 0%, #fff 90%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#eeeeee', GradientType=0);\n    background-image: linear-gradient(top, #eee 0%, #fff 90%);\n}\n\n.select2-container.select2-allowclear .select2-choice .select2-chosen {\n    margin-right: 42px;\n}\n\n.select2-container .select2-choice > .select2-chosen {\n    margin-right: 26px;\n    display: block;\n    overflow: hidden;\n\n    white-space: nowrap;\n\n    text-overflow: ellipsis;\n}\n\n.select2-container .select2-choice abbr {\n    display: none;\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 24px;\n    top: 8px;\n\n    font-size: 1px;\n    text-decoration: none;\n\n    border: 0;\n    background: url(" + __webpack_require__(36) + ") right top no-repeat;\n    cursor: pointer;\n    outline: 0;\n}\n\n.select2-container.select2-allowclear .select2-choice abbr {\n    display: inline-block;\n}\n\n.select2-container .select2-choice abbr:hover {\n    background-position: right -11px;\n    cursor: pointer;\n}\n\n.select2-drop-mask {\n    border: 0;\n    margin: 0;\n    padding: 0;\n    position: fixed;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    min-width: 100%;\n    height: auto;\n    width: auto;\n    opacity: 0;\n    z-index: 9998;\n    /* styles required for IE to work */\n    background-color: #fff;\n    filter: alpha(opacity=0);\n}\n\n.select2-drop {\n    width: 100%;\n    margin-top: -1px;\n    position: absolute;\n    z-index: 9999;\n    top: 100%;\n\n    background: #fff;\n    color: #000;\n    border: 1px solid #aaa;\n    border-top: 0;\n\n    border-radius: 0 0 4px 4px;\n\n    -webkit-box-shadow: 0 4px 5px rgba(0, 0, 0, .15);\n            box-shadow: 0 4px 5px rgba(0, 0, 0, .15);\n}\n\n.select2-drop-auto-width {\n    border-top: 1px solid #aaa;\n    width: auto;\n}\n\n.select2-drop-auto-width .select2-search {\n    padding-top: 4px;\n}\n\n.select2-drop.select2-drop-above {\n    margin-top: 1px;\n    border-top: 1px solid #aaa;\n    border-bottom: 0;\n\n    border-radius: 4px 4px 0 0;\n\n    -webkit-box-shadow: 0 -4px 5px rgba(0, 0, 0, .15);\n            box-shadow: 0 -4px 5px rgba(0, 0, 0, .15);\n}\n\n.select2-drop-active {\n    border: 1px solid #5897fb;\n    border-top: none;\n}\n\n.select2-drop.select2-drop-above.select2-drop-active {\n    border-top: 1px solid #5897fb;\n}\n\n.select2-container .select2-choice .select2-arrow {\n    display: inline-block;\n    width: 18px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n\n    border-left: 1px solid #aaa;\n    border-radius: 0 4px 4px 0;\n\n    background-clip: padding-box;\n\n    background: #ccc;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #ccc), color-stop(0.6, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    background-image: -moz-linear-gradient(center bottom, #ccc 0%, #eee 60%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr = '#eeeeee', endColorstr = '#cccccc', GradientType = 0);\n    background-image: linear-gradient(top, #ccc 0%, #eee 60%);\n}\n\n.select2-container .select2-choice .select2-arrow b {\n    display: block;\n    width: 100%;\n    height: 100%;\n    background: url(" + __webpack_require__(36) + ") no-repeat 0 1px;\n}\n\n.select2-search {\n    display: inline-block;\n    width: 100%;\n    min-height: 26px;\n    margin: 0;\n    padding-left: 4px;\n    padding-right: 4px;\n\n    position: relative;\n    z-index: 10000;\n\n    white-space: nowrap;\n}\n\n.select2-search input {\n    width: 100%;\n    height: auto !important;\n    min-height: 26px;\n    padding: 4px 20px 4px 5px;\n    margin: 0;\n\n    outline: 0;\n    font-family: sans-serif;\n    font-size: 1em;\n\n    border: 1px solid #aaa;\n    border-radius: 0;\n\n    -webkit-box-shadow: none;\n            box-shadow: none;\n\n    background: #fff url(" + __webpack_require__(36) + ") no-repeat 100% -22px;\n    background: url(" + __webpack_require__(36) + ") no-repeat 100% -22px, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(" + __webpack_require__(36) + ") no-repeat 100% -22px, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(" + __webpack_require__(36) + ") no-repeat 100% -22px, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(" + __webpack_require__(36) + ") no-repeat 100% -22px, linear-gradient(top, #fff 85%, #eee 99%);\n}\n\n.select2-drop.select2-drop-above .select2-search input {\n    margin-top: 4px;\n}\n\n.select2-search input.select2-active {\n    background: #fff url(" + __webpack_require__(37) + ") no-repeat 100%;\n    background: url(" + __webpack_require__(37) + ") no-repeat 100%, -webkit-gradient(linear, left bottom, left top, color-stop(0.85, #fff), color-stop(0.99, #eee));\n    background: url(" + __webpack_require__(37) + ") no-repeat 100%, -webkit-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(" + __webpack_require__(37) + ") no-repeat 100%, -moz-linear-gradient(center bottom, #fff 85%, #eee 99%);\n    background: url(" + __webpack_require__(37) + ") no-repeat 100%, linear-gradient(top, #fff 85%, #eee 99%);\n}\n\n.select2-container-active .select2-choice,\n.select2-container-active .select2-choices {\n    border: 1px solid #5897fb;\n    outline: none;\n\n    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n            box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n}\n\n.select2-dropdown-open .select2-choice {\n    border-bottom-color: transparent;\n    -webkit-box-shadow: 0 1px 0 #fff inset;\n            box-shadow: 0 1px 0 #fff inset;\n\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n\n    background-color: #eee;\n    background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center bottom, #fff 0%, #eee 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);\n    background-image: linear-gradient(top, #fff 0%, #eee 50%);\n}\n\n.select2-dropdown-open.select2-drop-above .select2-choice,\n.select2-dropdown-open.select2-drop-above .select2-choices {\n    border: 1px solid #5897fb;\n    border-top-color: transparent;\n\n    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fff), color-stop(0.5, #eee));\n    background-image: -webkit-linear-gradient(center top, #fff 0%, #eee 50%);\n    background-image: -moz-linear-gradient(center top, #fff 0%, #eee 50%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#ffffff', GradientType=0);\n    background-image: linear-gradient(bottom, #fff 0%, #eee 50%);\n}\n\n.select2-dropdown-open .select2-choice .select2-arrow {\n    background: transparent;\n    border-left: none;\n    filter: none;\n}\n.select2-dropdown-open .select2-choice .select2-arrow b {\n    background-position: -18px 1px;\n}\n\n/* results */\n.select2-results {\n    max-height: 200px;\n    padding: 0 0 0 4px;\n    margin: 4px 4px 4px 0;\n    position: relative;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.select2-results ul.select2-result-sub {\n    margin: 0;\n    padding-left: 0;\n}\n\n.select2-results ul.select2-result-sub > li .select2-result-label { padding-left: 20px }\n.select2-results ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 40px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 60px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 80px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 100px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 110px }\n.select2-results ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub ul.select2-result-sub > li .select2-result-label { padding-left: 120px }\n\n.select2-results li {\n    list-style: none;\n    display: list-item;\n    background-image: none;\n}\n\n.select2-results li.select2-result-with-children > .select2-result-label {\n    font-weight: bold;\n}\n\n.select2-results .select2-result-label {\n    padding: 3px 7px 4px;\n    margin: 0;\n    cursor: pointer;\n\n    min-height: 1em;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n}\n\n.select2-results .select2-highlighted {\n    background: #3875d7;\n    color: #fff;\n}\n\n.select2-results li em {\n    background: #feffde;\n    font-style: normal;\n}\n\n.select2-results .select2-highlighted em {\n    background: transparent;\n}\n\n.select2-results .select2-highlighted ul {\n    background: #fff;\n    color: #000;\n}\n\n\n.select2-results .select2-no-results,\n.select2-results .select2-searching,\n.select2-results .select2-selection-limit {\n    background: #f4f4f4;\n    display: list-item;\n}\n\n/*\ndisabled look for disabled choices in the results dropdown\n*/\n.select2-results .select2-disabled.select2-highlighted {\n    color: #666;\n    background: #f4f4f4;\n    display: list-item;\n    cursor: default;\n}\n.select2-results .select2-disabled {\n  background: #f4f4f4;\n  display: list-item;\n  cursor: default;\n}\n\n.select2-results .select2-selected {\n    display: none;\n}\n\n.select2-more-results.select2-active {\n    background: #f4f4f4 url(" + __webpack_require__(37) + ") no-repeat 100%;\n}\n\n.select2-more-results {\n    background: #f4f4f4;\n    display: list-item;\n}\n\n/* disabled styles */\n\n.select2-container.select2-container-disabled .select2-choice {\n    background-color: #f4f4f4;\n    background-image: none;\n    border: 1px solid #ddd;\n    cursor: default;\n}\n\n.select2-container.select2-container-disabled .select2-choice .select2-arrow {\n    background-color: #f4f4f4;\n    background-image: none;\n    border-left: 0;\n}\n\n.select2-container.select2-container-disabled .select2-choice abbr {\n    display: none;\n}\n\n\n/* multiselect */\n\n.select2-container-multi .select2-choices {\n    height: auto !important;\n    height: 1%;\n    margin: 0;\n    padding: 0;\n    position: relative;\n\n    border: 1px solid #aaa;\n    cursor: text;\n    overflow: hidden;\n\n    background-color: #fff;\n    background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(1%, #eee), color-stop(15%, #fff));\n    background-image: -webkit-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: -moz-linear-gradient(top, #eee 1%, #fff 15%);\n    background-image: linear-gradient(top, #eee 1%, #fff 15%);\n}\n\n.select2-locked {\n  padding: 3px 5px 3px 5px !important;\n}\n\n.select2-container-multi .select2-choices {\n    min-height: 26px;\n}\n\n.select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #5897fb;\n    outline: none;\n\n    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n            box-shadow: 0 0 5px rgba(0, 0, 0, .3);\n}\n.select2-container-multi .select2-choices li {\n    float: left;\n    list-style: none;\n}\n.select2-container-multi .select2-choices .select2-search-field {\n    margin: 0;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.select2-container-multi .select2-choices .select2-search-field input {\n    padding: 5px;\n    margin: 1px 0;\n\n    font-family: sans-serif;\n    font-size: 100%;\n    color: #666;\n    outline: 0;\n    border: 0;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    background: transparent !important;\n}\n\n.select2-container-multi .select2-choices .select2-search-field input.select2-active {\n    background: #fff url(" + __webpack_require__(37) + ") no-repeat 100% !important;\n}\n\n.select2-default {\n    color: #999 !important;\n}\n\n.select2-container-multi .select2-choices .select2-search-choice {\n    padding: 3px 5px 3px 18px;\n    margin: 3px 0 3px 5px;\n    position: relative;\n\n    line-height: 13px;\n    color: #333;\n    cursor: default;\n    border: 1px solid #aaaaaa;\n\n    border-radius: 3px;\n\n    -webkit-box-shadow: 0 0 2px #fff inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n            box-shadow: 0 0 2px #fff inset, 0 1px 0 rgba(0, 0, 0, 0.05);\n\n    background-clip: padding-box;\n\n    -webkit-touch-callout: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n\n    background-color: #e4e4e4;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#f4f4f4', GradientType=0);\n    background-image: -webkit-gradient(linear, 0% 0%, 0% 100%, color-stop(20%, #f4f4f4), color-stop(50%, #f0f0f0), color-stop(52%, #e8e8e8), color-stop(100%, #eee));\n    background-image: -webkit-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: -moz-linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n    background-image: linear-gradient(top, #f4f4f4 20%, #f0f0f0 50%, #e8e8e8 52%, #eee 100%);\n}\n.select2-container-multi .select2-choices .select2-search-choice .select2-chosen {\n    cursor: default;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus {\n    background: #d4d4d4;\n}\n\n.select2-search-choice-close {\n    display: block;\n    width: 12px;\n    height: 13px;\n    position: absolute;\n    right: 3px;\n    top: 4px;\n\n    font-size: 1px;\n    outline: none;\n    background: url(" + __webpack_require__(36) + ") right top no-repeat;\n}\n\n.select2-container-multi .select2-search-choice-close {\n    left: 3px;\n}\n\n.select2-container-multi .select2-choices .select2-search-choice .select2-search-choice-close:hover {\n  background-position: right -11px;\n}\n.select2-container-multi .select2-choices .select2-search-choice-focus .select2-search-choice-close {\n    background-position: right -11px;\n}\n\n/* disabled styles */\n.select2-container-multi.select2-container-disabled .select2-choices {\n    background-color: #f4f4f4;\n    background-image: none;\n    border: 1px solid #ddd;\n    cursor: default;\n}\n\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice {\n    padding: 3px 5px 3px 5px;\n    border: 1px solid #ddd;\n    background-image: none;\n    background-color: #f4f4f4;\n}\n\n.select2-container-multi.select2-container-disabled .select2-choices .select2-search-choice .select2-search-choice-close {    display: none;\n    background: none;\n}\n/* end multiselect */\n\n\n.select2-result-selectable .select2-match,\n.select2-result-unselectable .select2-match {\n    text-decoration: underline;\n}\n\n.select2-offscreen, .select2-offscreen:focus {\n    clip: rect(0 0 0 0) !important;\n    width: 1px !important;\n    height: 1px !important;\n    border: 0 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    position: absolute !important;\n    outline: 0 !important;\n    left: 0px !important;\n    top: 0px !important;\n}\n\n.select2-display-none {\n    display: none;\n}\n\n.select2-measure-scrollbar {\n    position: absolute;\n    top: -10000px;\n    left: -10000px;\n    width: 100px;\n    height: 100px;\n    overflow: scroll;\n}\n/* Retina-ize icons */\n\n@media only screen and (-webkit-min-device-pixel-ratio: 1.5), only screen and (min-resolution: 144dpi)  {\n  .select2-search input, .select2-search-choice-close, .select2-container .select2-choice abbr, .select2-container .select2-choice .select2-arrow b {\n      background-image: url(" + __webpack_require__(38) + ") !important;\n      background-repeat: no-repeat !important;\n      background-size: 60px 40px !important;\n  }\n  .select2-search input {\n      background-position: 100% -21px !important;\n  }\n}\n", ""]);

	// exports


/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAoCAYAAACiu5n/AAACLElEQVR42u3Zz0sUYRzH8bUISoyF1i5iXSooyYgOEXapZNYNojwU/aAfUAT9A4YhUgdxt1To0KFIBCMIvEcUEXntUtivpYuUhYFIdDBMmD69he/hObgsbSnb13ngdZjZhX3eO8/MDrMpSctKErwsg//HUSgU7uNYsB3hHla4CybqEoRPaMJGFCEMewxuxnsIk5iALPqg1yVdj9eQGUdjiuE1eAs+QOYztrsMJqwFk8EyHguW95klD+ZD08gsYvBFCBPYgHXBOT1UNpg3ncQpnAicRbrCCQ3j8SIf5QvYEWxvxnlb0mWDr0MIvcOaCiayC78gRKmlH+WDbaIjkJnDzgq/+VHIvMWqag3ehBkIAxXGdkAIDVRlsE24H9//4ty9hju4Hej710c5m83WYging32HMYjMnwSvx75UlQ+iOiDEaEMLZiA8dPc7TFQDnkGYxQ8Iz9Hs8k4riqIa4l5ApojVbm8tiduPL5CZRs5lMGFH8DNYxo+C5d3tMfgohJeow0qMQujxuqRb0RBsZ3DA2ZIuP5LgJDgJToKr4ZHOWjTOy+fzNa6DiezCFGReod1lMGF3IYzjMm5B5rirYIJyEJ4iHezfjW+YRr2n4EHE2LrAa1cg5DwFj2DWLlKljn67p+B+CIdKPAaOsddTcBOEKbTZvjp0Qvjo8Sp9DjJFfIVMjBsef4f34AHeYAxX0VfqMbDnfw97IXMTta6DLbobcxBa3Qdb9BPE2LZQ8G98530ecQi/2QAAAABJRU5ErkJggg=="

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABQCAYAAADSm7GJAAADFElEQVR42u2dsW4TQRBAI0ERCYpDpAUdJX/hAlxQ3SekovYXIIvKEiBRIUF1lHT+BP+Br0TCCCsFLW5cmCS3jKWNNFrdZu+EOG7sd9Irkl0p8r3s7Mzs5XLinIMD5uhvAIIBwYBgaMnNNZvNyj0nkUvPQbAdtDjnCSU3zkGwEbS4iOToHATbE6wptVwEGyUhcaW/JkTbT7JcCpIse4K7SC4pk4wRXreE5ZUMUwezgh03lT0YyKKBOhjoZHUi1oCf7mkYohd9ACVFrj50HgxzmtQifKwF15L1fxC8UD9/EQxzHtxC8KiD4FHPNWMhuIACwd33h3kLuXOZ2mc4yyLRZS1kCG6H3uc2Mbl+LO9Z8FRwEaYINnpDdWKVIEdwC/QVC4l97nk6sUqwQHA3wbGEa9Sj4CCxSlIguHtZMg8Tq/4Edy/bLNXB4/G4FKJ1sJ7zTwTrhMuTU3f+NVqc84SSG+bEJR99a3BoaHERybE5HDYYFKwptVwEGyUhcRX5PufBRoiH4Tg80WFMcBfJPJNljfC6JSzzVCUrGMHswUAWDdTBQCcLOveiCdEBnCYBb9kBBAOCAcGAYEDw0XP0NwDBgGBAMCAYEAwIHvD7QzJhIlSCE2rF0o9lav4eBBt5JWHR8EfzdYATfgkFgg2g5J4LdSD1WrjyXDeIPkfwsNErV6/Y38J34aXwWHgkvBJWwi74RSgQPGD8nrtRwrbCe+G0YX9+KHzyc2rPRsgQPFzBEyVrJ7xLvNTsjvBBuFQreYLg4Qpeqv32m3BP+YxJPhUulOAKwQMl2HsnymNK8mudeCF44IK9rCcdBD8XrhBsS/BTBBOibwTPCNEGCFqSX4X7LeSeCRdK8BLBwy6TdIPjo3A3kUF/pkyy1+ioPVsv8KxB7gPhi7BVcndCpqYheKCtSt1+vBR+CG+EZ8IL4a3wU69cRYlgC4cN4UFD/LDBNVAi2NZxYa0Ixe5ikhFs58B/2SC48mOZUMYkI/jw/61diWDzgtOSEWxdcFpyhWDTgtOSEWxccCgZwfZJ9akrJXiKYEDwMfAHMSYobVemsdsAAAAASUVORK5CYII="

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(40);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./select2-bootstrap.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./select2-bootstrap.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".form-control .select2-choice {\n    border: 0;\n    border-radius: 2px;\n}\n\n.form-control .select2-choice .select2-arrow {\n    border-radius: 0 2px 2px 0;   \n}\n\n.form-control.select2-container {\n    height: auto !important;\n    padding: 0px;\n}\n\n.form-control.select2-container.select2-dropdown-open {\n    border-color: #5897FB;\n    border-radius: 3px 3px 0 0;\n}\n\n.form-control .select2-container.select2-dropdown-open .select2-choices {\n    border-radius: 3px 3px 0 0;\n}\n\n.form-control.select2-container .select2-choices {\n    border: 0 !important;\n    border-radius: 3px;\n}\n\n.control-group.warning .select2-container .select2-choice,\n.control-group.warning .select2-container .select2-choices,\n.control-group.warning .select2-container-active .select2-choice,\n.control-group.warning .select2-container-active .select2-choices,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.warning .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.warning .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #C09853 !important;\n}\n\n.control-group.warning .select2-container .select2-choice div {\n    border-left: 1px solid #C09853 !important;\n    background: #FCF8E3 !important;\n}\n\n.control-group.error .select2-container .select2-choice,\n.control-group.error .select2-container .select2-choices,\n.control-group.error .select2-container-active .select2-choice,\n.control-group.error .select2-container-active .select2-choices,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.error .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.error .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #B94A48 !important;\n}\n\n.control-group.error .select2-container .select2-choice div {\n    border-left: 1px solid #B94A48 !important;\n    background: #F2DEDE !important;\n}\n\n.control-group.info .select2-container .select2-choice,\n.control-group.info .select2-container .select2-choices,\n.control-group.info .select2-container-active .select2-choice,\n.control-group.info .select2-container-active .select2-choices,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.info .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.info .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #3A87AD !important;\n}\n\n.control-group.info .select2-container .select2-choice div {\n    border-left: 1px solid #3A87AD !important;\n    background: #D9EDF7 !important;\n}\n\n.control-group.success .select2-container .select2-choice,\n.control-group.success .select2-container .select2-choices,\n.control-group.success .select2-container-active .select2-choice,\n.control-group.success .select2-container-active .select2-choices,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choice,\n.control-group.success .select2-dropdown-open.select2-drop-above .select2-choices,\n.control-group.success .select2-container-multi.select2-container-active .select2-choices {\n    border: 1px solid #468847 !important;\n}\n\n.control-group.success .select2-container .select2-choice div {\n    border-left: 1px solid #468847 !important;\n    background: #DFF0D8 !important;\n}\n", ""]);

	// exports


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(42);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./jquery.toolbar.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./jquery.toolbar.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".tool-container {\r\n\tbackground-color: #d0cbcb;\r\n\tbackground: -webkit-gradient(linear, left top, left bottom, color-stop(14%, #e9e5e5), color-stop(100%, #d0cbcb));\r\n\tbackground: -moz-linear-gradient(top, #d0cbcb 14%, #e9e5e5 100%);\r\n\tbackground: -ms-linear-gradient(top, #d0cbcb 14%,#e9e5e5 100%);\r\n\tbackground: linear-gradient(to bottom, #e9e5e5 14%, #d0cbcb 100%);\r\n\t/*\r\n\tbackground: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIxNCUiIHN0b3AtY29sb3I9IiNkMGNiY2IiIHN0b3Atb3BhY2l0eT0iMSIvPgogICAgPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjZTllNWU1IiBzdG9wLW9wYWNpdHk9IjEiLz4KICA8L2xpbmVhckdyYWRpZW50PgogIDxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9InVybCgjZ3JhZC11Y2dnLWdlbmVyYXRlZCkiIC8+Cjwvc3ZnPg==);\r\n\t*/\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d0cbcb', endColorstr='#e9e5e5',GradientType=0 );\r\n\tbackground-size: 100% 100%;\r\n\tborder-radius: 3px;\r\n\tbox-shadow: 0px 2px 10px rgba(0,0,0,0.3);\r\n\tposition: absolute;\t\t\t\t\r\n}\r\n\r\n.tool-container.tool-top, .tool-container.tool-bottom {\r\n\theight: 34px;\r\n\tborder-bottom: 1px solid #beb8b8 ; /* #B1A9A9 */\r\n}\r\n\r\n.tool-items {\r\n\theight: 100%;\t\r\n}\r\n\r\n.tool-top .tool-item, .tool-bottom .tool-item {\r\n\tfloat: left;\r\n\tborder-right: 1px solid #e2dfdf;\r\n\tborder-left: 1px solid #9f9898;\r\n}\r\n\r\n.tool-left .tool-item, .tool-right .tool-item {\r\n\theight: 34px;\r\n\tborder-top: 1px solid #e2dfdf;\r\n\tborder-bottom: 1px solid #9f9898;\r\n}\r\n\r\n\r\n.tool-item {\r\n\theight: 100%;\r\n\tdisplay: block;\t\t\t\t\r\n\twidth: 44px;\r\n\ttext-align: center;\r\n}\r\n\r\n.tool-item:first-child {\r\n\tborder-left: none;\r\n}\r\n\r\n.tool-left .tool-item:first-child, .tool-right .tool-item:first-child {\r\n\tborder-top: 1px solid transparent;\r\n}\r\n\r\n.tool-item:last-child {\r\n\tborder-right: none;\r\n\tborder-bottom: none;\r\n}\r\n\r\n.tool-item.selected, .tool-item:hover {\r\n\tbackground: #a79f9f;\r\n\tbackground: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #a79f9f), color-stop(93%, #e2dfdf));\r\n\tbackground: -moz-linear-gradient(top, #a79f9f 0%, #e2dfdf 93%);\r\n\tbackground: -ms-linear-gradient(top, #a79f9f 0%, #e2dfdf 93%);\r\n\tbackground: linear-gradient(to bottom, #a79f9f 0%, #e2dfdf 93%);\r\n\t/*\r\n\tbackground: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2E3OWY5ZiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjkzJSIgc3RvcC1jb2xvcj0iI2UyZGZkZiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2dyYWQtdWNnZy1nZW5lcmF0ZWQpIiAvPgo8L3N2Zz4=);\r\n\t*/\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a79f9f', endColorstr='#e2dfdf',GradientType=0 );\r\n}\r\n\r\n.tool-item.not-pressable.selected, \r\n.tool-item.not-pressable:hover {\r\n\tbackground: none;\r\n}\r\n\r\n.tool-top .tool-item:last-child:hover, .tool-bottom .tool-item:last-child:hover {\r\n\tborder-top-right-radius: 4px;\r\n\tborder-bottom-right-radius: 4px;\r\n}\r\n\r\n.tool-top  .tool-item:first-child:hover, .tool-bottom  .tool-item:first-child:hover {\r\n\tborder-top-left-radius: 4px;\r\n\tborder-bottom-left-radius: 4px;\r\n}\r\n\r\n.tool-left .tool-item:last-child:hover, .tool-right .tool-item:last-child:hover {\r\n\tborder-bottom-right-radius: 4px;\r\n\tborder-bottom-left-radius: 4px;\r\n}\r\n\r\n.tool-left .tool-item:first-child:hover, .tool-right .tool-item:first-child:hover {\r\n\tborder-top-right-radius: 4px;\r\n\tborder-top-left-radius: 4px;\r\n}\r\n\r\n.tool-container .arrow,\r\n.tool-container .arrow-bdr {\r\n\twidth:0;\r\n\theight:0;\r\n\tposition: absolute;\t\r\n\tborder-width:7px;\r\n\tborder-style:solid;\r\n}\r\n\r\n.tool-container.tool-top .arrow {\r\n\tborder-color: #e9e5e5 transparent transparent; \r\n\tleft: 50%;  \r\n\tbottom: -14px;\r\n\tmargin-left: -7px;\r\n\tz-index: 1;\r\n}\r\n\r\n.tool-container.tool-top .arrow-bdr {\r\n\tborder-color: #888 transparent transparent; \r\n\tleft: 50%;  \r\n\tbottom: -14px;\r\n\tmargin-left: -7px;\r\n\tz-index: 0;\r\n}\r\n\r\n.tool-container.tool-bottom .arrow {\r\n\tborder-color: transparent transparent #e9e5e5; \r\n\tleft: 50%;  \r\n\ttop: -14px;\r\n\tmargin-left: -7px;\r\n}\r\n\r\n.tool-container.tool-bottom .arrow-bdr {\r\n\tborder-color: transparent transparent #888; \r\n\tleft: 50%;  \r\n\ttop: -15px;\r\n\tmargin-left: -7px;\r\n\tz-index: 0;\r\n}\r\n\r\n.tool-container.tool-left .arrow {\r\n\tborder-color: transparent transparent transparent #E9E5E5;\r\n\ttop: 50%;\r\n\tright: -14px;\r\n\tmargin-top: -7px;\r\n}\r\n\r\n.tool-container.tool-right .arrow {\r\n\tborder-color: transparent #E9E5E5 transparent transparent;\r\n\ttop: 50%;\r\n\tleft: -14px;\r\n\tmargin-top: -7px;\r\n}\r\n\r\n.demo-link {\r\n\tcolor: #89CDE4;\r\n\ttext-decoration: underline;\r\n\tcursor: pointer;\r\n\tmargin-left: 30px;\r\n}\r\n\r\n.demo-link:hover {\r\n\ttext-decoration: none;\r\n\tcursor: pointer;\r\n}", ""]);

	// exports


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(44);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./spectrum.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./spectrum.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, "/***\nSpectrum Colorpicker v1.3.4\nhttps://github.com/bgrins/spectrum\nAuthor: Brian Grinstead\nLicense: MIT\n***/\n\n.sp-container {\n    position:absolute;\n    top:0;\n    left:0;\n    display:inline-block;\n    *display: inline;\n    *zoom: 1;\n    /* https://github.com/bgrins/spectrum/issues/40 */\n    z-index: 9999994;\n    overflow: hidden;\n}\n.sp-container.sp-flat {\n    position: relative;\n}\n\n/* Fix for * { box-sizing: border-box; } */\n.sp-container,\n.sp-container * {\n    -webkit-box-sizing: content-box;\n       -moz-box-sizing: content-box;\n            box-sizing: content-box;\n}\n\n/* http://ansciath.tumblr.com/post/7347495869/css-aspect-ratio */\n.sp-top {\n  position:relative;\n  width: 100%;\n  display:inline-block;\n}\n.sp-top-inner {\n   position:absolute;\n   top:0;\n   left:0;\n   bottom:0;\n   right:0;\n}\n.sp-color {\n    position: absolute;\n    top:0;\n    left:0;\n    bottom:0;\n    right:20%;\n}\n.sp-hue {\n    position: absolute;\n    top:0;\n    right:0;\n    bottom:0;\n    left:84%;\n    height: 100%;\n}\n\n.sp-clear-enabled .sp-hue {\n    top:33px;\n    height: 77.5%;\n}\n\n.sp-fill {\n    padding-top: 80%;\n}\n.sp-sat, .sp-val {\n    position: absolute;\n    top:0;\n    left:0;\n    right:0;\n    bottom:0;\n}\n\n.sp-alpha-enabled .sp-top {\n    margin-bottom: 18px;\n}\n.sp-alpha-enabled .sp-alpha {\n    display: block;\n}\n.sp-alpha-handle {\n    position:absolute;\n    top:-4px;\n    bottom: -4px;\n    width: 6px;\n    left: 50%;\n    cursor: pointer;\n    border: 1px solid black;\n    background: white;\n    opacity: .8;\n}\n.sp-alpha {\n    display: none;\n    position: absolute;\n    bottom: -14px;\n    right: 0;\n    left: 0;\n    height: 8px;\n}\n.sp-alpha-inner {\n    border: solid 1px #333;\n}\n\n.sp-clear {\n    display: none;\n}\n\n.sp-clear.sp-clear-display {\n    background-position: center;\n}\n\n.sp-clear-enabled .sp-clear {\n    display: block;\n    position:absolute;\n    top:0px;\n    right:0;\n    bottom:0;\n    left:84%;\n    height: 28px;\n}\n\n/* Don't allow text selection */\n.sp-container, .sp-replacer, .sp-preview, .sp-dragger, .sp-slider, .sp-alpha, .sp-clear, .sp-alpha-handle, .sp-container.sp-dragging .sp-input, .sp-container button  {\n    -webkit-user-select:none;\n    -moz-user-select: -moz-none;\n    -o-user-select:none;\n    user-select: none;\n}\n\n.sp-container.sp-input-disabled .sp-input-container {\n    display: none;\n}\n.sp-container.sp-buttons-disabled .sp-button-container {\n    display: none;\n}\n.sp-palette-only .sp-picker-container {\n    display: none;\n}\n.sp-palette-disabled .sp-palette-container {\n    display: none;\n}\n\n.sp-initial-disabled .sp-initial {\n    display: none;\n}\n\n\n/* Gradients for hue, saturation and value instead of images.  Not pretty... but it works */\n.sp-sat {\n    background-image: -webkit-gradient(linear,  0 0, 100% 0, from(#FFF), to(rgba(204, 154, 129, 0)));\n    background-image: -webkit-linear-gradient(left, #FFF, rgba(204, 154, 129, 0));\n    background-image: -moz-linear-gradient(left, #fff, rgba(204, 154, 129, 0));\n    background-image: -o-linear-gradient(left, #fff, rgba(204, 154, 129, 0));\n    background-image: -ms-linear-gradient(left, #fff, rgba(204, 154, 129, 0));\n    background-image: linear-gradient(to right, #fff, rgba(204, 154, 129, 0));\n    -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(GradientType = 1, startColorstr=#FFFFFFFF, endColorstr=#00CC9A81)\";\n    filter : progid:DXImageTransform.Microsoft.gradient(GradientType = 1, startColorstr='#FFFFFFFF', endColorstr='#00CC9A81');\n}\n.sp-val {\n    background-image: -webkit-gradient(linear, 0 100%, 0 0, from(#000000), to(rgba(204, 154, 129, 0)));\n    background-image: -webkit-linear-gradient(bottom, #000000, rgba(204, 154, 129, 0));\n    background-image: -moz-linear-gradient(bottom, #000, rgba(204, 154, 129, 0));\n    background-image: -o-linear-gradient(bottom, #000, rgba(204, 154, 129, 0));\n    background-image: -ms-linear-gradient(bottom, #000, rgba(204, 154, 129, 0));\n    background-image: linear-gradient(to top, #000, rgba(204, 154, 129, 0));\n    -ms-filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr=#00CC9A81, endColorstr=#FF000000)\";\n    filter : progid:DXImageTransform.Microsoft.gradient(startColorstr='#00CC9A81', endColorstr='#FF000000');\n}\n\n.sp-hue {\n    background: -moz-linear-gradient(top, #ff0000 0%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);\n    background: -ms-linear-gradient(top, #ff0000 0%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);\n    background: -o-linear-gradient(top, #ff0000 0%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);\n    background: -webkit-gradient(linear, left top, left bottom, from(#ff0000), color-stop(0.17, #ffff00), color-stop(0.33, #00ff00), color-stop(0.5, #00ffff), color-stop(0.67, #0000ff), color-stop(0.83, #ff00ff), to(#ff0000));\n    background: -webkit-linear-gradient(top, #ff0000 0%, #ffff00 17%, #00ff00 33%, #00ffff 50%, #0000ff 67%, #ff00ff 83%, #ff0000 100%);\n}\n\n/* IE filters do not support multiple color stops.\n   Generate 6 divs, line them up, and do two color gradients for each.\n   Yes, really.\n */\n.sp-1 {\n    height:17%;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff0000', endColorstr='#ffff00');\n}\n.sp-2 {\n    height:16%;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffff00', endColorstr='#00ff00');\n}\n.sp-3 {\n    height:17%;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ff00', endColorstr='#00ffff');\n}\n.sp-4 {\n    height:17%;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffff', endColorstr='#0000ff');\n}\n.sp-5 {\n    height:16%;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0000ff', endColorstr='#ff00ff');\n}\n.sp-6 {\n    height:17%;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff00ff', endColorstr='#ff0000');\n}\n\n.sp-hidden {\n    display: none !important;\n}\n\n/* Clearfix hack */\n.sp-cf:before, .sp-cf:after { content: \"\"; display: table; }\n.sp-cf:after { clear: both; }\n.sp-cf { *zoom: 1; }\n\n/* Mobile devices, make hue slider bigger so it is easier to slide */\n@media (max-device-width: 480px) {\n    .sp-color { right: 40%; }\n    .sp-hue { left: 63%; }\n    .sp-fill { padding-top: 60%; }\n}\n.sp-dragger {\n   border-radius: 5px;\n   height: 5px;\n   width: 5px;\n   border: 1px solid #fff;\n   background: #000;\n   cursor: pointer;\n   position:absolute;\n   top:0;\n   left: 0;\n}\n.sp-slider {\n    position: absolute;\n    top:0;\n    cursor:pointer;\n    height: 3px;\n    left: -1px;\n    right: -1px;\n    border: 1px solid #000;\n    background: white;\n    opacity: .8;\n}\n\n/*\nTheme authors:\nHere are the basic themeable display options (colors, fonts, global widths).\nSee http://bgrins.github.io/spectrum/themes/ for instructions.\n*/\n\n.sp-container {\n    border-radius: 0;\n    background-color: #ECECEC;\n    border: solid 1px #f0c49B;\n    padding: 0;\n}\n.sp-container, .sp-container button, .sp-container input, .sp-color, .sp-hue, .sp-clear\n{\n    font: normal 12px \"Lucida Grande\", \"Lucida Sans Unicode\", \"Lucida Sans\", Geneva, Verdana, sans-serif;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    -ms-box-sizing: border-box;\n    box-sizing: border-box;\n}\n.sp-top\n{\n    margin-bottom: 3px;\n}\n.sp-color, .sp-hue, .sp-clear\n{\n    border: solid 1px #666;\n}\n\n/* Input */\n.sp-input-container {\n    float:right;\n    width: 100px;\n    margin-bottom: 4px;\n}\n.sp-initial-disabled  .sp-input-container {\n    width: 100%;\n}\n.sp-input {\n   font-size: 12px !important;\n   border: 1px inset;\n   padding: 4px 5px;\n   margin: 0;\n   width: 100%;\n   background:transparent;\n   border-radius: 3px;\n   color: #222;\n}\n.sp-input:focus  {\n    border: 1px solid orange;\n}\n.sp-input.sp-validation-error\n{\n    border: 1px solid red;\n    background: #fdd;\n}\n.sp-picker-container , .sp-palette-container\n{\n    float:left;\n    position: relative;\n    padding: 10px;\n    padding-bottom: 300px;\n    margin-bottom: -290px;\n}\n.sp-picker-container\n{\n    width: 172px;\n    border-left: solid 1px #fff;\n}\n\n/* Palettes */\n.sp-palette-container\n{\n    border-right: solid 1px #ccc;\n}\n\n.sp-palette .sp-thumb-el {\n    display: block;\n    position:relative;\n    float:left;\n    width: 24px;\n    height: 15px;\n    margin: 3px;\n    cursor: pointer;\n    border:solid 2px transparent;\n}\n.sp-palette .sp-thumb-el:hover, .sp-palette .sp-thumb-el.sp-thumb-active {\n    border-color: orange;\n}\n.sp-thumb-el\n{\n    position:relative;\n}\n\n/* Initial */\n.sp-initial\n{\n    float: left;\n    border: solid 1px #333;\n}\n.sp-initial span {\n    width: 30px;\n    height: 25px;\n    border:none;\n    display:block;\n    float:left;\n    margin:0;\n}\n\n.sp-initial .sp-clear-display {\n    background-position: center;\n}\n\n/* Buttons */\n.sp-button-container {\n    float: right;\n}\n\n/* Replacer (the little preview div that shows up instead of the <input>) */\n.sp-replacer {\n    margin:0;\n    overflow:hidden;\n    cursor:pointer;\n    padding: 4px;\n    display:inline-block;\n    *zoom: 1;\n    *display: inline;\n    border: solid 1px #91765d;\n    background: #eee;\n    color: #333;\n    vertical-align: middle;\n}\n.sp-replacer:hover, .sp-replacer.sp-active {\n    border-color: #F0C49B;\n    color: #111;\n}\n.sp-replacer.sp-disabled {\n    cursor:default;\n    border-color: silver;\n    color: silver;\n}\n.sp-dd {\n    padding: 2px 0;\n    height: 16px;\n    line-height: 16px;\n    float:left;\n    font-size:10px;\n}\n.sp-preview\n{\n    position:relative;\n    width:25px;\n    height: 20px;\n    border: solid 1px #222;\n    margin-right: 5px;\n    float:left;\n    z-index: 0;\n}\n\n.sp-palette\n{\n    *width: 220px;\n    max-width: 220px;\n}\n.sp-palette .sp-thumb-el\n{\n    width:16px;\n    height: 16px;\n    margin:2px 1px;\n    border: solid 1px #d0d0d0;\n}\n\n.sp-container\n{\n    padding-bottom:0;\n}\n\n\n/* Buttons: http://hellohappy.org/css3-buttons/ */\n.sp-container button {\n  background-color: #eeeeee;\n  background-image: -webkit-linear-gradient(top, #eeeeee, #cccccc);\n  background-image: -moz-linear-gradient(top, #eeeeee, #cccccc);\n  background-image: -ms-linear-gradient(top, #eeeeee, #cccccc);\n  background-image: -o-linear-gradient(top, #eeeeee, #cccccc);\n  background-image: linear-gradient(to bottom, #eeeeee, #cccccc);\n  border: 1px solid #ccc;\n  border-bottom: 1px solid #bbb;\n  border-radius: 3px;\n  color: #333;\n  font-size: 14px;\n  line-height: 1;\n  padding: 5px 4px;\n  text-align: center;\n  text-shadow: 0 1px 0 #eee;\n  vertical-align: middle;\n}\n.sp-container button:hover {\n    background-color: #dddddd;\n    background-image: -webkit-linear-gradient(top, #dddddd, #bbbbbb);\n    background-image: -moz-linear-gradient(top, #dddddd, #bbbbbb);\n    background-image: -ms-linear-gradient(top, #dddddd, #bbbbbb);\n    background-image: -o-linear-gradient(top, #dddddd, #bbbbbb);\n    background-image: linear-gradient(to bottom, #dddddd, #bbbbbb);\n    border: 1px solid #bbb;\n    border-bottom: 1px solid #999;\n    cursor: pointer;\n    text-shadow: 0 1px 0 #ddd;\n}\n.sp-container button:active {\n    border: 1px solid #aaa;\n    border-bottom: 1px solid #888;\n    -webkit-box-shadow: inset 0 0 5px 2px #aaaaaa, 0 1px 0 0 #eeeeee;\n    -moz-box-shadow: inset 0 0 5px 2px #aaaaaa, 0 1px 0 0 #eeeeee;\n    -ms-box-shadow: inset 0 0 5px 2px #aaaaaa, 0 1px 0 0 #eeeeee;\n    -o-box-shadow: inset 0 0 5px 2px #aaaaaa, 0 1px 0 0 #eeeeee;\n    box-shadow: inset 0 0 5px 2px #aaaaaa, 0 1px 0 0 #eeeeee;\n}\n.sp-cancel\n{\n    font-size: 11px;\n    color: #d93f3f !important;\n    margin:0;\n    padding:2px;\n    margin-right: 5px;\n    vertical-align: middle;\n    text-decoration:none;\n\n}\n.sp-cancel:hover\n{\n    color: #d93f3f !important;\n    text-decoration: underline;\n}\n\n\n.sp-palette span:hover, .sp-palette span.sp-thumb-active\n{\n    border-color: #000;\n}\n\n.sp-preview, .sp-alpha, .sp-thumb-el\n{\n    position:relative;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);\n}\n.sp-preview-inner, .sp-alpha-inner, .sp-thumb-inner\n{\n    display:block;\n    position:absolute;\n    top:0;left:0;bottom:0;right:0;\n}\n\n.sp-palette .sp-thumb-inner\n{\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n}\n\n.sp-palette .sp-thumb-light.sp-thumb-active .sp-thumb-inner\n{\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIVJREFUeNpiYBhsgJFMffxAXABlN5JruT4Q3wfi/0DsT64h8UD8HmpIPCWG/KemIfOJCUB+Aoacx6EGBZyHBqI+WsDCwuQ9mhxeg2A210Ntfo8klk9sOMijaURm7yc1UP2RNCMbKE9ODK1HM6iegYLkfx8pligC9lCD7KmRof0ZhjQACDAAceovrtpVBRkAAAAASUVORK5CYII=);\n}\n\n.sp-palette .sp-thumb-dark.sp-thumb-active .sp-thumb-inner\n{\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAadEVYdFNvZnR3YXJlAFBhaW50Lk5FVCB2My41LjEwMPRyoQAAAMdJREFUOE+tkgsNwzAMRMugEAahEAahEAZhEAqlEAZhEAohEAYh81X2dIm8fKpEspLGvudPOsUYpxE2BIJCroJmEW9qJ+MKaBFhEMNabSy9oIcIPwrB+afvAUFoK4H0tMaQ3XtlrggDhOVVMuT4E5MMG0FBbCEYzjYT7OxLEvIHQLY2zWwQ3D+9luyOQTfKDiFD3iUIfPk8VqrKjgAiSfGFPecrg6HN6m/iBcwiDAo7WiBeawa+Kwh7tZoSCGLMqwlSAzVDhoK+6vH4G0P5wdkAAAAASUVORK5CYII=);\n}\n\n.sp-clear-display {\n    background-repeat:no-repeat;\n    background-position: center;\n    background-image: url(data:image/gif;base64,R0lGODlhFAAUAPcAAAAAAJmZmZ2dnZ6enqKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq/Hx8fLy8vT09PX19ff39/j4+Pn5+fr6+vv7+wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAP8ALAAAAAAUABQAAAihAP9FoPCvoMGDBy08+EdhQAIJCCMybCDAAYUEARBAlFiQQoMABQhKUJBxY0SPICEYHBnggEmDKAuoPMjS5cGYMxHW3IiT478JJA8M/CjTZ0GgLRekNGpwAsYABHIypcAgQMsITDtWJYBR6NSqMico9cqR6tKfY7GeBCuVwlipDNmefAtTrkSzB1RaIAoXodsABiZAEFB06gIBWC1mLVgBa0AAOw==);\n}\n", ""]);

	// exports


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(46);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./jquery.simple-dtpicker.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./jquery.simple-dtpicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, "/**\n * Style-sheet for dtpicker\n * https://github.com/mugifly/jquery-simple-datetimepicker\n */\n\n.datepicker {\n\tdisplay: inline-block;\n\tfont: 15px/1.5 \"Helvetica Neue\", mplus-2c, Helvetica, Arial, \"Hiragino Kaku Gothic Pro\", Meiryo, sans-serif;\n\tfont-weight: 300;\n\tborder: 1px solid #dfdfdf;\n\tborder-radius: 3px;\n\t\t-webkit-border-radius: 3px;  \n\t\t-moz-border-radius: 3px;\n\tbox-shadow: 0.5px 0.5px 0px #c8c8c8;\n\t\t-webkit-box-shadow: 0.5px 0.5px 3px #eeeeee;\n\t\t-moz-box-shadow: 0.5px 0.5px 3px #eeeeee;\n}\n\n/*\n * datepicker_header\n*/\n\n.datepicker > .datepicker_header{\n\tpadding-top:\t2px;\n\tpadding-bottom: 2px;\n\tpadding-left:\t5px;\n\tpadding-right: 5px;\n\tbackground-color:\t#eeeeee;\n\tcolor: #3f3f3f;\n\ttext-align: center;\n\tfont-size: 9pt;\n\tfont-weight: bold;\n\tuser-select: none;\n\t\t-webkit-user-select: none;\n\t\t-moz-user-select: none;\n}\n\n.datepicker > .datepicker_header > a {\n\tuser-select: none;\n\t\t-webkit-user-select: none;\n\t\t-moz-user-select: none;\n\tcursor: pointer;\n\tcolor: #3b7796;\n}\n\n.datepicker > .datepicker_header > a:hover {\n\tcolor: #303030;\n\tbackground-color:\t#c8c8c8;\n}\n\n.datepicker > .datepicker_header > a:active {\n\tcolor: #ffffff;\n\tbackground-color:\t#808080;\n}\n\n.datepicker > .datepicker_header > span {\n\tmargin-left: 20px;\n\tmargin-right: 20px;\n\tuser-select: none;\n\t\t-webkit-user-select: none;\n\t\t-moz-user-select: none;\n}\n\n.datepicker > .datepicker_header > .icon-home {\n\tposition:\tabsolute;\n\tdisplay:\t\tblock;\n\tfloat:\t\tleft;\n\tmargin-top:\t2px;\n\tmargin-left:\t5px;\n\twidth:\t\t11pt;\n\theight:\t\t11pt;\n\tvertical-align: middle;\n}\n\n.datepicker > .datepicker_header > .icon-home > svg > g > path {\n\tfill: #3b7796;\n}\n\n.datepicker > .datepicker_header > a:hover > svg > g > path {\n\tfill: #303030; /* Icon button hover color */\n}\n\n\n/*\n * datepicker_inner_container \n*/\n\n.datepicker > .datepicker_inner_container {\n\tmargin: -2px 0px -2px 0px;\n\tbackground-color: #d2d2d2;\n\tborder: 1px solid #c8c8c8;\n\tborder-radius: 3px;\n\t\t-webkit-border-radius: 3px;  \n\t\t-moz-border-radius: 3px;\n\n\tbox-shadow: 0.5px 0px 3px #c8c8c8;\n\t\t-webkit-box-shadow: 0.5px 0px 3px #c8c8c8;\n\t\t-moz-box-shadow: 0.5px 0px 3px #c8c8c8;\n}\n\n.datepicker > .datepicker_inner_container:after {\n\tcontent: \".\";\n\tdisplay: block;\n\theight: 0;\n\tclear: both;\n\tvisibility: hidden;\n}\n\n/*\n * datepicker_inner_container > datepicker_calendar\n*/\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar {\n\tfloat: left;\n\twidth: auto;\n\t\n\tmargin-top: -0.5px;\n\tmargin-left: -1px;\n\tmargin-bottom: -2px;\n\t\n\tbackground-color:\t#ffffff;\n\tborder: 1px solid #c8c8c8;\n\t\n\tborder-top:none;\n\tborder-top-left-radius: 3px;\n\tborder-bottom-left-radius: 3px;\n\t\t-webkit-border-top-left-radius:\t3px;\n\t\t-webkit-border-bottom-left-radius: 3px;\n\t\t-moz-border-radius-topleft:\t\t3px;\n\t\t-moz-border-radius-bottomleft:\t3px;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > table {\n    padding: 10px;\n}\n\n/*\n * datepicker_inner_container > datepicker_calendar > datepicker_table > tbody > tr > th (WDay-cell)\n*/\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > th {\n\tcolor:\t#646464;\n\twidth: 18px;\n\tfont-size: small;\n\tfont-weight: normal;\n\ttext-align:center;\n}\n\n/*\n * datepicker_inner_container > datepicker_calendar > datepicker_table > tbody > tr > td (Day-cell)\n*/\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td {\n\tcolor:\t#000000;\n\tfont-size: small;\n\ttext-align:center;\n\t\n\tuser-select: none;\n\t\t-webkit-user-select: none;\n\t\t-moz-user-select: none;\n\tcursor: pointer;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.today {\n\tborder-bottom: #bfbfbf solid 2px;\n\tmargin-bottom: -2px;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.wday_sat {\n\tcolor:\t#0044aa;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.wday_sun {\n\tcolor:\t#e13b00;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.day_another_month {\n\tcolor:\t#cccccc;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.day_in_past {\n\tcursor: default;\n\tcolor: #cccccc;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.day_in_unallowed {\n\tcursor: default;\n\tcolor: #cccccc;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.out_of_range {\n\tcursor: default;\n\tcolor: #cccccc;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.active {\n\tcolor: #ffffff;\n\tbackground-color:\t#808080;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_calendar > .datepicker_table > tbody > tr > td.hover {\n\tcolor: #000000;\n\tbackground-color:\t#c8c8c8;\n}\n\n/*\n * datepicker_inner_container > datepicker_timelist\n*/\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist {\n\tfloat: left;\n\twidth: 4.2em;\n\theight: 118px;\n\t\n\tmargin-top: -0.5px;\n\tpadding: 5px;\n\tpadding-left: 0px;\n\tpadding-right: 0px;\n\t\n\toverflow: auto;\n\toverflow-x: hidden; \n\t\n\tbackground-color:\t#ffffff;\n\t\n\tborder-top-right-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\t-webkit-border-top-right-radius:\t3px;\n\t-webkit-border-bottom-right-radius: 3px;\n\t-moz-border-radius-topright:\t\t3px;\n\t-moz-border-radius-bottomright:\t3px;\n}\n\n/*\n.datepicker > .datepicker_inner_container > .datepicker_timelist::after {\n\tcontent: \".\";\n\tdisplay: block;\n\theight: 0;\n\tclear: both;\n\tvisibility: hidden;\n}\n*/\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist::-webkit-scrollbar {\n\toverflow: hidden;\n\twidth: 6px;\n\tbackground: #fafafa;\n\t\n\tborder-top-right-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\t-webkit-border-top-right-radius:\t3px;\n\t-webkit-border-bottom-right-radius: 3px;\n\t-moz-border-radius-topright:\t\t3px;\n\t-moz-border-radius-bottomright:\t3px;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist::-webkit-scrollbar:horizontal {\n\theight: 1px;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist::-webkit-scrollbar-button {\n\tdisplay: none;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist::-webkit-scrollbar-piece {\n\tbackground: #eee;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist::-webkit-scrollbar-piece:start {\n\tbackground: #eee;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist::-webkit-scrollbar-thumb {\n\tbackground: #aaaaaa;\n\tborder-radius: 3px;\n\t\t-webkit-border-radius: 3px;  \n\t\t-moz-border-radius: 3px;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist::-webkit-scrollbar-corner {\n\tbackground: #333;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist > div.timelist_item {\n\tpadding-top:   1px;\n\tpadding-bottom:1px;\n\tpadding-left:  7px;\n\tpadding-right: 25px;\n\tmargin-top: 5px;\n\tmargin-bottom: 2px;\n\tfont-size: small;\n\t\n\tuser-select: none;\n\t\t-webkit-user-select: none;\n\t\t-moz-user-select: none;\n\tcursor: pointer;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist > div.timelist_item.time_in_past {\n\tcursor: default;\n\tcolor: #cccccc;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist > div.timelist_item.out_of_range {\n\tcursor: default;\n\tcolor: #cccccc;\n}\n.datepicker > .datepicker_inner_container > .datepicker_timelist > div.timelist_item.active {\n\tcolor: #ffffff;\n\tbackground-color:\t#808080;\n}\n\n.datepicker > .datepicker_inner_container > .datepicker_timelist > div.timelist_item.hover {\n\tcolor: #000000;\n\tbackground-color:\t#c8c8c8;\n}\n", ""]);

	// exports


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(48);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./datepicker.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./datepicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, "/*!\n * Datepicker for Bootstrap\n *\n * Copyright 2012 Stefan Petre\n * Improvements by Andrew Rowls\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n */\n.datepicker {\n  padding: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  direction: ltr;\n  /*.dow {\n\t\tborder-top: 1px solid #ddd !important;\n\t}*/\n}\n.datepicker-inline {\n  width: 220px;\n}\n.datepicker.datepicker-rtl {\n  direction: rtl;\n}\n.datepicker.datepicker-rtl table tr td span {\n  float: right;\n}\n.datepicker-dropdown {\n  top: 0;\n  left: 0;\n}\n.datepicker-dropdown:before {\n  content: '';\n  display: inline-block;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #ccc;\n  border-top: 0;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  position: absolute;\n}\n.datepicker-dropdown:after {\n  content: '';\n  display: inline-block;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #ffffff;\n  border-top: 0;\n  position: absolute;\n}\n.datepicker-dropdown.datepicker-orient-left:before {\n  left: 6px;\n}\n.datepicker-dropdown.datepicker-orient-left:after {\n  left: 7px;\n}\n.datepicker-dropdown.datepicker-orient-right:before {\n  right: 6px;\n}\n.datepicker-dropdown.datepicker-orient-right:after {\n  right: 7px;\n}\n.datepicker-dropdown.datepicker-orient-top:before {\n  top: -7px;\n}\n.datepicker-dropdown.datepicker-orient-top:after {\n  top: -6px;\n}\n.datepicker-dropdown.datepicker-orient-bottom:before {\n  bottom: -7px;\n  border-bottom: 0;\n  border-top: 7px solid #999;\n}\n.datepicker-dropdown.datepicker-orient-bottom:after {\n  bottom: -6px;\n  border-bottom: 0;\n  border-top: 6px solid #ffffff;\n}\n.datepicker > div {\n  display: none;\n}\n.datepicker.days div.datepicker-days {\n  display: block;\n}\n.datepicker.months div.datepicker-months {\n  display: block;\n}\n.datepicker.years div.datepicker-years {\n  display: block;\n}\n.datepicker table {\n  margin: 0;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.datepicker td,\n.datepicker th {\n  text-align: center;\n  width: 20px;\n  height: 20px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  border: none;\n}\n.table-striped .datepicker table tr td,\n.table-striped .datepicker table tr th {\n  background-color: transparent;\n}\n.datepicker table tr td.day:hover,\n.datepicker table tr td.day.focused {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.datepicker table tr td.old,\n.datepicker table tr td.new {\n  color: #999999;\n}\n.datepicker table tr td.disabled,\n.datepicker table tr td.disabled:hover {\n  background: none;\n  color: #999999;\n  cursor: default;\n}\n.datepicker table tr td.today,\n.datepicker table tr td.today:hover,\n.datepicker table tr td.today.disabled,\n.datepicker table tr td.today.disabled:hover {\n  background-color: #fde19a;\n  background-image: -moz-linear-gradient(top, #fdd49a, #fdf59a);\n  background-image: -ms-linear-gradient(top, #fdd49a, #fdf59a);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#fdd49a), to(#fdf59a));\n  background-image: -webkit-linear-gradient(top, #fdd49a, #fdf59a);\n  background-image: -o-linear-gradient(top, #fdd49a, #fdf59a);\n  background-image: linear-gradient(top, #fdd49a, #fdf59a);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fdd49a', endColorstr='#fdf59a', GradientType=0);\n  border-color: #fdf59a #fdf59a #fbed50;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n  color: #000;\n}\n.datepicker table tr td.today:hover,\n.datepicker table tr td.today:hover:hover,\n.datepicker table tr td.today.disabled:hover,\n.datepicker table tr td.today.disabled:hover:hover,\n.datepicker table tr td.today:active,\n.datepicker table tr td.today:hover:active,\n.datepicker table tr td.today.disabled:active,\n.datepicker table tr td.today.disabled:hover:active,\n.datepicker table tr td.today.active,\n.datepicker table tr td.today:hover.active,\n.datepicker table tr td.today.disabled.active,\n.datepicker table tr td.today.disabled:hover.active,\n.datepicker table tr td.today.disabled,\n.datepicker table tr td.today:hover.disabled,\n.datepicker table tr td.today.disabled.disabled,\n.datepicker table tr td.today.disabled:hover.disabled,\n.datepicker table tr td.today[disabled],\n.datepicker table tr td.today:hover[disabled],\n.datepicker table tr td.today.disabled[disabled],\n.datepicker table tr td.today.disabled:hover[disabled] {\n  background-color: #fdf59a;\n}\n.datepicker table tr td.today:active,\n.datepicker table tr td.today:hover:active,\n.datepicker table tr td.today.disabled:active,\n.datepicker table tr td.today.disabled:hover:active,\n.datepicker table tr td.today.active,\n.datepicker table tr td.today:hover.active,\n.datepicker table tr td.today.disabled.active,\n.datepicker table tr td.today.disabled:hover.active {\n  background-color: #fbf069 \\9;\n}\n.datepicker table tr td.today:hover:hover {\n  color: #000;\n}\n.datepicker table tr td.today.active:hover {\n  color: #fff;\n}\n.datepicker table tr td.range,\n.datepicker table tr td.range:hover,\n.datepicker table tr td.range.disabled,\n.datepicker table tr td.range.disabled:hover {\n  background: #eeeeee;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.datepicker table tr td.range.today,\n.datepicker table tr td.range.today:hover,\n.datepicker table tr td.range.today.disabled,\n.datepicker table tr td.range.today.disabled:hover {\n  background-color: #f3d17a;\n  background-image: -moz-linear-gradient(top, #f3c17a, #f3e97a);\n  background-image: -ms-linear-gradient(top, #f3c17a, #f3e97a);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#f3c17a), to(#f3e97a));\n  background-image: -webkit-linear-gradient(top, #f3c17a, #f3e97a);\n  background-image: -o-linear-gradient(top, #f3c17a, #f3e97a);\n  background-image: linear-gradient(top, #f3c17a, #f3e97a);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f3c17a', endColorstr='#f3e97a', GradientType=0);\n  border-color: #f3e97a #f3e97a #edde34;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.datepicker table tr td.range.today:hover,\n.datepicker table tr td.range.today:hover:hover,\n.datepicker table tr td.range.today.disabled:hover,\n.datepicker table tr td.range.today.disabled:hover:hover,\n.datepicker table tr td.range.today:active,\n.datepicker table tr td.range.today:hover:active,\n.datepicker table tr td.range.today.disabled:active,\n.datepicker table tr td.range.today.disabled:hover:active,\n.datepicker table tr td.range.today.active,\n.datepicker table tr td.range.today:hover.active,\n.datepicker table tr td.range.today.disabled.active,\n.datepicker table tr td.range.today.disabled:hover.active,\n.datepicker table tr td.range.today.disabled,\n.datepicker table tr td.range.today:hover.disabled,\n.datepicker table tr td.range.today.disabled.disabled,\n.datepicker table tr td.range.today.disabled:hover.disabled,\n.datepicker table tr td.range.today[disabled],\n.datepicker table tr td.range.today:hover[disabled],\n.datepicker table tr td.range.today.disabled[disabled],\n.datepicker table tr td.range.today.disabled:hover[disabled] {\n  background-color: #f3e97a;\n}\n.datepicker table tr td.range.today:active,\n.datepicker table tr td.range.today:hover:active,\n.datepicker table tr td.range.today.disabled:active,\n.datepicker table tr td.range.today.disabled:hover:active,\n.datepicker table tr td.range.today.active,\n.datepicker table tr td.range.today:hover.active,\n.datepicker table tr td.range.today.disabled.active,\n.datepicker table tr td.range.today.disabled:hover.active {\n  background-color: #efe24b \\9;\n}\n.datepicker table tr td.selected,\n.datepicker table tr td.selected:hover,\n.datepicker table tr td.selected.disabled,\n.datepicker table tr td.selected.disabled:hover {\n  background-color: #9e9e9e;\n  background-image: -moz-linear-gradient(top, #b3b3b3, #808080);\n  background-image: -ms-linear-gradient(top, #b3b3b3, #808080);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#b3b3b3), to(#808080));\n  background-image: -webkit-linear-gradient(top, #b3b3b3, #808080);\n  background-image: -o-linear-gradient(top, #b3b3b3, #808080);\n  background-image: linear-gradient(top, #b3b3b3, #808080);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#b3b3b3', endColorstr='#808080', GradientType=0);\n  border-color: #808080 #808080 #595959;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.datepicker table tr td.selected:hover,\n.datepicker table tr td.selected:hover:hover,\n.datepicker table tr td.selected.disabled:hover,\n.datepicker table tr td.selected.disabled:hover:hover,\n.datepicker table tr td.selected:active,\n.datepicker table tr td.selected:hover:active,\n.datepicker table tr td.selected.disabled:active,\n.datepicker table tr td.selected.disabled:hover:active,\n.datepicker table tr td.selected.active,\n.datepicker table tr td.selected:hover.active,\n.datepicker table tr td.selected.disabled.active,\n.datepicker table tr td.selected.disabled:hover.active,\n.datepicker table tr td.selected.disabled,\n.datepicker table tr td.selected:hover.disabled,\n.datepicker table tr td.selected.disabled.disabled,\n.datepicker table tr td.selected.disabled:hover.disabled,\n.datepicker table tr td.selected[disabled],\n.datepicker table tr td.selected:hover[disabled],\n.datepicker table tr td.selected.disabled[disabled],\n.datepicker table tr td.selected.disabled:hover[disabled] {\n  background-color: #808080;\n}\n.datepicker table tr td.selected:active,\n.datepicker table tr td.selected:hover:active,\n.datepicker table tr td.selected.disabled:active,\n.datepicker table tr td.selected.disabled:hover:active,\n.datepicker table tr td.selected.active,\n.datepicker table tr td.selected:hover.active,\n.datepicker table tr td.selected.disabled.active,\n.datepicker table tr td.selected.disabled:hover.active {\n  background-color: #666666 \\9;\n}\n.datepicker table tr td.active,\n.datepicker table tr td.active:hover,\n.datepicker table tr td.active.disabled,\n.datepicker table tr td.active.disabled:hover {\n  background-color: #006dcc;\n  background-image: -moz-linear-gradient(top, #0088cc, #0044cc);\n  background-image: -ms-linear-gradient(top, #0088cc, #0044cc);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#0088cc), to(#0044cc));\n  background-image: -webkit-linear-gradient(top, #0088cc, #0044cc);\n  background-image: -o-linear-gradient(top, #0088cc, #0044cc);\n  background-image: linear-gradient(top, #0088cc, #0044cc);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0088cc', endColorstr='#0044cc', GradientType=0);\n  border-color: #0044cc #0044cc #002a80;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.datepicker table tr td.active:hover,\n.datepicker table tr td.active:hover:hover,\n.datepicker table tr td.active.disabled:hover,\n.datepicker table tr td.active.disabled:hover:hover,\n.datepicker table tr td.active:active,\n.datepicker table tr td.active:hover:active,\n.datepicker table tr td.active.disabled:active,\n.datepicker table tr td.active.disabled:hover:active,\n.datepicker table tr td.active.active,\n.datepicker table tr td.active:hover.active,\n.datepicker table tr td.active.disabled.active,\n.datepicker table tr td.active.disabled:hover.active,\n.datepicker table tr td.active.disabled,\n.datepicker table tr td.active:hover.disabled,\n.datepicker table tr td.active.disabled.disabled,\n.datepicker table tr td.active.disabled:hover.disabled,\n.datepicker table tr td.active[disabled],\n.datepicker table tr td.active:hover[disabled],\n.datepicker table tr td.active.disabled[disabled],\n.datepicker table tr td.active.disabled:hover[disabled] {\n  background-color: #0044cc;\n}\n.datepicker table tr td.active:active,\n.datepicker table tr td.active:hover:active,\n.datepicker table tr td.active.disabled:active,\n.datepicker table tr td.active.disabled:hover:active,\n.datepicker table tr td.active.active,\n.datepicker table tr td.active:hover.active,\n.datepicker table tr td.active.disabled.active,\n.datepicker table tr td.active.disabled:hover.active {\n  background-color: #003399 \\9;\n}\n.datepicker table tr td span {\n  display: block;\n  width: 23%;\n  height: 54px;\n  line-height: 54px;\n  float: left;\n  margin: 1%;\n  cursor: pointer;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n.datepicker table tr td span:hover {\n  background: #eeeeee;\n}\n.datepicker table tr td span.disabled,\n.datepicker table tr td span.disabled:hover {\n  background: none;\n  color: #999999;\n  cursor: default;\n}\n.datepicker table tr td span.active,\n.datepicker table tr td span.active:hover,\n.datepicker table tr td span.active.disabled,\n.datepicker table tr td span.active.disabled:hover {\n  background-color: #006dcc;\n  background-image: -moz-linear-gradient(top, #0088cc, #0044cc);\n  background-image: -ms-linear-gradient(top, #0088cc, #0044cc);\n  background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#0088cc), to(#0044cc));\n  background-image: -webkit-linear-gradient(top, #0088cc, #0044cc);\n  background-image: -o-linear-gradient(top, #0088cc, #0044cc);\n  background-image: linear-gradient(top, #0088cc, #0044cc);\n  background-repeat: repeat-x;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#0088cc', endColorstr='#0044cc', GradientType=0);\n  border-color: #0044cc #0044cc #002a80;\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.datepicker table tr td span.active:hover,\n.datepicker table tr td span.active:hover:hover,\n.datepicker table tr td span.active.disabled:hover,\n.datepicker table tr td span.active.disabled:hover:hover,\n.datepicker table tr td span.active:active,\n.datepicker table tr td span.active:hover:active,\n.datepicker table tr td span.active.disabled:active,\n.datepicker table tr td span.active.disabled:hover:active,\n.datepicker table tr td span.active.active,\n.datepicker table tr td span.active:hover.active,\n.datepicker table tr td span.active.disabled.active,\n.datepicker table tr td span.active.disabled:hover.active,\n.datepicker table tr td span.active.disabled,\n.datepicker table tr td span.active:hover.disabled,\n.datepicker table tr td span.active.disabled.disabled,\n.datepicker table tr td span.active.disabled:hover.disabled,\n.datepicker table tr td span.active[disabled],\n.datepicker table tr td span.active:hover[disabled],\n.datepicker table tr td span.active.disabled[disabled],\n.datepicker table tr td span.active.disabled:hover[disabled] {\n  background-color: #0044cc;\n}\n.datepicker table tr td span.active:active,\n.datepicker table tr td span.active:hover:active,\n.datepicker table tr td span.active.disabled:active,\n.datepicker table tr td span.active.disabled:hover:active,\n.datepicker table tr td span.active.active,\n.datepicker table tr td span.active:hover.active,\n.datepicker table tr td span.active.disabled.active,\n.datepicker table tr td span.active.disabled:hover.active {\n  background-color: #003399 \\9;\n}\n.datepicker table tr td span.old,\n.datepicker table tr td span.new {\n  color: #999999;\n}\n.datepicker th.datepicker-switch {\n  width: 145px;\n}\n.datepicker thead tr:first-child th,\n.datepicker tfoot tr th {\n  cursor: pointer;\n}\n.datepicker thead tr:first-child th:hover,\n.datepicker tfoot tr th:hover {\n  background: #eeeeee;\n}\n.datepicker .cw {\n  font-size: 10px;\n  width: 12px;\n  padding: 0 2px 0 5px;\n  vertical-align: middle;\n}\n.datepicker thead tr:first-child th.cw {\n  cursor: default;\n  background-color: transparent;\n}\n.input-append.date .add-on i,\n.input-prepend.date .add-on i {\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n}\n.input-daterange input {\n  text-align: center;\n}\n.input-daterange input:first-child {\n  -webkit-border-radius: 3px 0 0 3px;\n  -moz-border-radius: 3px 0 0 3px;\n  border-radius: 3px 0 0 3px;\n}\n.input-daterange input:last-child {\n  -webkit-border-radius: 0 3px 3px 0;\n  -moz-border-radius: 0 3px 3px 0;\n  border-radius: 0 3px 3px 0;\n}\n.input-daterange .add-on {\n  display: inline-block;\n  width: auto;\n  min-width: 16px;\n  height: 20px;\n  padding: 4px 5px;\n  font-weight: normal;\n  line-height: 20px;\n  text-align: center;\n  text-shadow: 0 1px 0 #ffffff;\n  vertical-align: middle;\n  background-color: #eeeeee;\n  border: 1px solid #ccc;\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.datepicker.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  float: left;\n  display: none;\n  min-width: 160px;\n  list-style: none;\n  background-color: #ffffff;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  -moz-background-clip: padding;\n  background-clip: padding-box;\n  *border-right-width: 2px;\n  *border-bottom-width: 2px;\n  color: #333333;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 20px;\n}\n.datepicker.dropdown-menu th,\n.datepicker.datepicker-inline th,\n.datepicker.dropdown-menu td,\n.datepicker.datepicker-inline td {\n  padding: 4px 5px;\n}", ""]);

	// exports


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(50);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./ditto.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./ditto.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".ditto-designer {\n\tfont-family: helvetica, sans-serif;\n\tfont-weight: normal;\n\tfont-style: normal;\n\tz-index: 2;\n\tbox-sizing: border-box;\n}\n\n.ditto-designer input[type=\"radio\"], \n.ditto-designer input[type=\"checkbox\"] {\n\tmargin: 0;\n}\n\n.ditto-designer {\n\tposition: fixed;\n\tborder-radius: 4px;\n\tborder: 1px solid #aaa;\n\ttransition: transform 300ms, -webkit-transform 300ms, opacity 300ms;\n\tvisibility: visible;\n\ttransform: scale(1);\n\t-webkit-transform: scale(1);\n\topacity: 1;\n}\n\n.ditto-designer.before-fadein {\n\ttransform: scale(0.9);\n\t-webkit-transform: scale(0.9);\n\topacity: 0;\n\tvisibility: hidden;\n}\n\n.jsr-designer-embedded {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\ttransition: none;\n\ttransform: none;\n\t-webkit-transform: none;\n\tvisibility: visible;\n}\n\n.jsr-designer-popup {\n\tz-index: 1000;\n}\n\n.ditto-designer .navbar {\n\tmargin-bottom: 0;\n\tmin-height: 0;\n\tborder-width: 0;\n}\n\n.ditto-designer .navbar .nav {\n\tpadding-left: 0;\n}\n\n.jsr-style-root .navbar .nav > .active > a, \n.jsr-style-root .navbar .nav > .active > a:hover, \n.jsr-style-root .navbar .nav > .active > a:focus {\n\tbox-shadow: none;\n\t-webkit-box-shadow: none;\n\tbackground: none;\n\tposition: relative;\n}\n\n.jsr-style-root .navbar .nav > .active > a::after {\n\tcontent: '';\n\tdisplay: block;\n\tposition: absolute;\n\tleft: 5px;\n\tright: 5px;\n\tbottom: 0;\n\theight: 3px;\n\tbackground: orange;\t\n}\n\n.ditto-designer .jsr-designer-header,\n.ditto-designer .palette,\n.ditto-designer .preview\n{\n\tposition: relative;\n\tbox-shadow: 0 2px 3px rgba(0,20,40,0.2);\n}\n\n.ditto-designer .palette {\n\tdisplay: none !important;\n}\n\n.ditto-designer .jsr-designer-left .left-pane-toggle-btn {\n\tbox-sizing: border-box;\n\tposition: absolute;\n\ttop: 3px;\n\tright: 5px;\n\tz-index: 10;\n\tborder: 1px solid #aaa;\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 50%;\n\tcolor: #777;\n\tfont-size: 24px;\n\ttext-align: center;\n\tcursor: pointer;\n\ttransition: background-color 0.15s, border-color 0.15s;\n\tfont-weight: 700;\n}\n\n.ditto-designer .jsr-designer-left .left-pane-toggle-btn::before {\n\tcontent: '';\n\tdisplay: block;\n  position: absolute;\n  left: 6px;\n  top: 5px;\n  width: 8px;\n  height: 12px;\n\tbackground: url(" + __webpack_require__(51) + ") 0 0 no-repeat;\n\ttransform: rotate(180deg);\n\tbackground-size: 100%;\n\topacity: 0.6;\n}\n\n.ditto-designer .jsr-designer-left .left-pane-toggle-btn:hover {\n\topacity: 1;\n\tbackground-color: rgb(142,68,173);\n\tborder-color: rgb(142,68,173);\n}\n\n.ditto-designer .jsr-designer-left .left-pane-toggle-btn:hover::before {\n\tfilter: invert(100%);\n\topacity: 1;\n}\n\n.ditto-designer .jsr-designer-left.collapsed .left-pane-toggle-btn::before {\n  left: 8px;\n\ttransform: none;\n}\n\n.ditto-designer .jsr-designer-header {\n\tz-index: 5;\n\tborder-radius: 4px 4px 0 0;\n\tbackground: #fafafa;\n\tposition: relative;\n}\n\n.ditto-designer.jsr-designer-horizontal .jsr-designer-header {\n\tborder-radius: 0;\n\theight: 100%;\n}\n\n.ditto-designer .jsr-designer-header .navbar {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\theight: 33px;\n}\n\n.ditto-designer .jsr-designer-header .header-panel {\n\tposition: absolute;\n\ttop: 33px;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: auto;\n}\n\n.ditto-designer .preview {\n\tbackground: #e3e3e3;\n\tpadding: 10px;\n\toverflow: auto;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tbox-shadow: inset 0 1px 3px rgba(0,20,40,0.1);\n}\n\n.ditto-designer .preview .page {\n\tbackground-color: #fafafa;\n\tbox-shadow: 0 2px 5px rgba(0,0,0,0.5);\n\tposition: relative;\n}\n\n.ditto-designer .preview .page.redrawing * {\n\tdisplay: none;\n}\n\n.ditto-designer .divider {\n\tborder-color: #ddd;\n\tposition: absolute;\n}\n\n.ditto-designer .divider.horizontal {\n\t/*width: 100%;*/\n\theight: 5px;\n\tmargin-top: -2px;\n\tbackground: none;\n\tborder: none;\n}\n\n.ditto-designer .divider.horizontal.margin {\n\twidth: 100%;\n}\n\n.ditto-designer .divider.horizontal.movable {\n\tcursor: row-resize;\n}\n\n.ditto-designer .divider.horizontal:before {\n\tcontent: '';\n\theight: 0px;\n\ttop: 2px;\n\tposition: absolute;\n\tdisplay: block;\n\tborder-top: 1px solid #ddd;\n\twidth: 100%;\n}\n\n.ditto-designer .divider.section-divider.horizontal:before {\n\tborder-top: 1px dashed #aaa;\n}\n\n.ditto-designer .divider.left,\n.ditto-designer .divider.right,\n.ditto-designer .divider.column-divider,\n.ditto-designer .divider.pivot-column-divider {\n\ttop: 0;\n\tbottom: 0;\n\twidth: 5px;\n\tborder-left-width: 1px;\n\tborder-left-style: solid;\n\tmargin-left: -2px;\n\tz-index: 100;\n}\n\n.ditto-designer .divider.margin.left,\n.ditto-designer .divider.margin.right {\n\tborder-left-style: dashed;\n}\n\n.ditto-designer .divider.margin.horizontal:before {\n\tborder-top-style: dashed;\n}\n\n.ditto-designer .pivot-area-shading {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tbackground: url(" + __webpack_require__(52) + ");\n\topacity: 0.1;\n\tz-index: 1;\n}\n\n.ditto-designer .divider.pivot-column-divider {\n\tborder-color: #8e44ad;\n\tborder-left-style: solid;\n\topacity: 0.7;\n\tcursor: col-resize;\n}\n\n.ditto-designer .jsr-column-mask {\n\tbackground: rgba(20, 5, 0, 0.06);\n\tposition: absolute;\n}\n\n.ditto-designer .section-label {\n\tposition: absolute;\n\tdisplay: none;\n\tcolor: rgba(0, 80, 255, 0.6);\n\tfont-size: 13px;\n\tz-index: 1;\n\tcursor: default;\n}\n\n.ditto-designer .header-panel {\n\tpadding: 15px;\n\tdisplay: none;\n}\n\n.ditto-designer .header-panel.active {\n\tdisplay: block;\n}\n\n.jsr-new-element-palette .palette-item {\n\tdisplay: block;\n\tpadding: 5px 30px 5px 40px;\n\tbackground-repeat: no-repeat;\n\tbackground-size: 32px;\n\tbackground-position: 5px 0;\n\tcursor: pointer;\n\tposition: relative;\n\tcolor: #555;\n\tborder-bottom: 1px solid #eee;\n\twhite-space: nowrap;\n}\n\n.jsr-new-element-palette .palette-item:last-child {\n\tborder-bottom: none;\n}\n\n.jsr-new-element-palette .palette-item .jsr-designer-palette-icon {\n\tposition: absolute;\n\ttop: 5px;\n\tleft: 10px;\n\twidth: 20px;\n\theight: 20px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 0 0;\n\tbackground-size: 20px;\n\t/*opacity: 0.6;*/\n}\n\n.jsr-new-element-palette .palette-item:after {\n\twidth: 0;\n\theight: 24px;\n\tborder-left: 1px solid #aaa;\n}\n\n.jsr-new-element-palette .palette-item.chart {\n\tbackground-image: url(" + __webpack_require__(53) + ");\n}\n.jsr-new-element-palette .palette-item.text {\n\tbackground-image: url(" + __webpack_require__(54) + ");\n\tbackground-size: 31px;\n}\n.jsr-new-element-palette .palette-item.box {\n\tbackground-image: url(" + __webpack_require__(55) + ");\n}\n.jsr-new-element-palette .palette-item.image {\n\tbackground-image: url(" + __webpack_require__(56) + ");\n}\n.jsr-new-element-palette .palette-item.barcode {\n\tbackground-image: url(" + __webpack_require__(57) + ");\n}\n.jsr-new-element-palette .palette-item.break {\n\tbackground-image: url(" + __webpack_require__(58) + ");\n\tbackground-size: 26px;\n    background-position: 8px 2px;\n}\n.jsr-new-element-palette .palette-item.subreport {\n\tbackground-image: url(" + __webpack_require__(59) + ");\n}\n\n.jsr-new-element-palette .palette-item:hover {\n\tbackground-color: #eee;\n\tcolor: black;\n}\n\n.jsr-new-element-palette .palette-item:hover .jsr-designer-palette-icon {\n\topacity: 1;\n}\n\n.ditto-designer .jsr-designer-header h3 {\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: rgb(155,153,187);\n\tmargin: 0 0 0.5em 0;\n\tline-height: normal;\n  letter-spacing: 1px;\n}\n\n.ditto-designer .jsr-designer-header .settings-section {\n\tmargin-bottom: 1.5em;\n}\n\n.ditto-designer .jsr-designer-header .select2-container {\n\t/*min-width: 150px;\n\tmargin-left: 5px;*/\n}\n\n.ditto-designer .jsr-designer-header .indent {\n\tmargin-left: 20px;\n}\n\n.ditto-designer .jsr-designer-header label {\n\tdisplay: inline;\n\tfont-weight: normal;\n}\n\n.ditto-designer .editable-row {\n\tposition: relative;\n\tpadding-right: 25px;\n\tpadding-left: 15px;\n\ttext-indent: -15px;\n\tborder-radius: 3px;\n\tborder: 1px solid transparent;\n}\n\n.ditto-designer .editable-row .editable-row-buttons {\n\tposition: absolute;\n\ttop: 0;\n\tright: 4px;\n}\n\n.ditto-designer .editable-row * {\n\ttext-indent: initial;\n}\n\n.ditto-designer .editable-row .select2-container,\n.ditto-designer .editable-row .select2-container .select2-choice,\n.ditto-designer .editable-row.inactive .select2-container .select2-choice > .select2-chosen,\n.ditto-designer .editable-row.inactive .select2-container .select2-arrow {\n\t-webkit-transition: all 0.25s;\n}\n\n.ditto-designer .editable-row.inactive .select2-container {\n\tmin-width: 0;\n}\n\n.ditto-designer .editable-row.inactive .select2-container .select2-choice,\n.ditto-designer .editable-row.inactive input,\n.ditto-designer .editable-row.inactive .readonly {\n\tborder: none;\n\tpadding: 0;\n\tbackground: none;\n\tcolor: #33a; /* #77b; */\n\tborder-radius: 0;\n\tcursor: default;\n\ttext-decoration: none;\n}\n\n.ditto-designer .editable-row.inactive input {\n\tdisplay: none;\n}\n\n.ditto-designer .editable-row input[type=\"checkbox\"] {\n\tdisplay: inline;\n\tmargin: 0;\n}\n\n.ditto-designer .editable-row .readonly {\n\tdisplay: none;\n}\n.ditto-designer .editable-row.inactive .readonly {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: 26px;\n}\n\n.ditto-designer .editable-row.inactive .select2-container .select2-choice > .select2-chosen {\n\tmargin-right: 0;\n\tposition: relative;\n\ttop: 1px;\n\ttext-indent: 0;\n}\n\n.ditto-designer .editable-row.inactive .select2-container .select2-arrow,\n.ditto-designer .editable-row.inactive .select2-container .select2-search-choice-close\n{\n\tdisplay: none;\n}\n\n/*\n.preview:hover .preview-element {\n\tborder: 1px solid #ccc;\n}\n*/\n\n.ditto-designer .preview-element {\n\tbox-sizing: border-box;\n\tposition: absolute;\n\tborder: 1px solid #ccc;\n\ttransition: border 0.2s;\n\tz-index: 1000;\n\tline-height: 1.2;\n\tcursor: default;\n}\n\n.ditto-designer .preview-element.jsr-preview-element-box {\n\tz-index: 999;\n}\n\n.ditto-designer .preview-element .jsr-text {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n\tcursor: default;\n}\n\n.ditto-designer .preview-element .jsr-box {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tborder: 1px solid transparent;\n\tz-index: 999;\n}\n\n.ditto-designer .preview-element.active {\n\tz-index: 1010;\n}\n\n.ditto-designer .preview-element.jsr-break .jsr-break-icon {\n    background: white url(" + __webpack_require__(60) + ") 1px 1px no-repeat;\n    position: absolute;\n    top: -6px;\n    left: 5px;\n    border-radius: 3px;\n    width: 20px;\n    height: 12px;\n    background-size: 19px;\n}\n\n.ditto-designer .preview-element.jsr-break.active {\n\tbox-shadow: 0 0 5px #2980b9;\n}\n\n.ditto-designer .preview-element .jsr-resize-handle {\n\tposition: absolute;\n\tdisplay: none;\n\tz-index: 1000;\n\tbox-sizing: content-box;\n}\n\n.ditto-designer .preview-element.active .jsr-resize-handle {\n\tdisplay: block;\n}\n\n.ditto-designer .preview-element.active {\n\tcursor: move;\n}\n\n.ditto-designer .jsr-resize-handle {\n  border: 2px solid rgba(0, 80, 255, 0.7);\n  background-color: rgba(255,255,255,0.7);\n  height: 6px;\n  width: 6px;\n  border-radius: 3px;\n}\n\n.ditto-designer .jsr-resize-handle-b,\n.ditto-designer .jsr-resize-handle-t {\n\tmargin-left: -5px;\n\tleft: 50%;\n\tcursor: ns-resize;\n}\n\n.ditto-designer .jsr-resize-handle-l,\n.ditto-designer .jsr-resize-handle-r {\n\tmargin-top: -5px;\n\ttop: 50%;\n\tcursor: ew-resize;\n}\n\n.ditto-designer .jsr-resize-handle-t,\n.ditto-designer .jsr-resize-handle-tr,\n.ditto-designer .jsr-resize-handle-tl {\n\ttop: -5px;\n}\n\n.ditto-designer .jsr-resize-handle-b,\n.ditto-designer .jsr-resize-handle-br,\n.ditto-designer .jsr-resize-handle-bl {\n\tbottom: -5px;\n}\n\n.ditto-designer .jsr-resize-handle-l,\n.ditto-designer .jsr-resize-handle-bl,\n.ditto-designer .jsr-resize-handle-tl {\n\tleft: -5px;\n}\n\n.ditto-designer .jsr-resize-handle-r,\n.ditto-designer .jsr-resize-handle-br,\n.ditto-designer .jsr-resize-handle-tr {\n\tright: -5px;\n}\n\n.ditto-designer .jsr-resize-handle-tl,\n.ditto-designer .jsr-resize-handle-br {\n\tcursor: nwse-resize;\n}\n\n.ditto-designer .jsr-resize-handle-tr,\n.ditto-designer .jsr-resize-handle-bl {\n\tcursor: nesw-resize;\n}\n\n.ditto-designer .yui3-resize-knob .yui3-resize-handle-inner {\n\tbackground: none;\n\theight: 6px;\n\twidth: 6px;\n}\n\n.jsr-section {\n\tborder-bottom: 1px solid #ddd;\n\tposition: absolute; /*relative;*/\n\twidth: 100%;\n\tz-index: 1;\n}\n\n.jsr-section.jsr-page-background {\n\ttop: 0;\n\tz-index: 0;\n}\n\n.jsr-element {\n\tposition: absolute;\n\tz-index: 2;\n}\n\n.jsr-text {\n\twhite-space: pre-line;\n\tword-wrap: break-word;\n\toverflow: hidden;\n}\n\n.jsr-text.jsr-markdown {\n\twhite-space: normal;\n}\n\n.jsr-text-right {\n\ttext-align: right;\n}\n.jsr-text-center {\n\ttext-align: center;\n}\n\n.jsr-box {\n\tborder: 1px solid transparent;\n\tz-index: 1;\n}\n\n.jsr-designer-image {\n\topacity: 0.5;\n\twidth: 100%;\n}\n\n.jsr-barcode:not(.qrcode),\n.jsr-barcode:not(.qrcode) img {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ditto-designer .preview-element.jsr-break {\n\tborder: 0;\n\tleft: 0 !important;\n\twidth: 100% !important; \n\tborder-top: 1px dashed rgba(0,0,0,0.5);\n\tbackground: transparent;\n\tcursor: move;\n}\n\n.jsr-toolbar-break-type,\n.jsr-toolbar-break-every {\n\tpadding: 0 6px;\n}\n\n.jsr-toolbar-break-every input {\n\twidth: 2em;\n\ttext-align: right;\n}\n\n.jsr-toolbar.tool-container.tool-top, \n.jsr-toolbar.tool-container.tool-bottom {\n\tz-index: 1500 !important;\n\tborder: none;\n\tbox-shadow: 0 2px 3px rgba(0,20,40,0.2);\n}\n\n/*.jsr-toolbar-docked.tool-container.tool-top, \n.jsr-toolbar-docked.tool-container.tool-bottom {\n\tz-index: 1 !important;\n}*/\n\n.jsr-toolbar .jsr-toolbar-text-bold .icon {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: url(" + __webpack_require__(61) + ") 50% 50% no-repeat;\n\tbackground-size: 24px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-italic .icon {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: url(" + __webpack_require__(62) + ") 50% 50% no-repeat;\n\tbackground-size: 24px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-underline .icon {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: url(" + __webpack_require__(63) + ") 50% 62% no-repeat;\n\tbackground-size: 24px;\n}\n\n.jsr-toolbar .jsr-toolbar-conditional-properties .icon {\n\tbackground: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABiklEQVRYw+3Wv0tVcRjH8VeGPy4IoiLYYFPhIkKLf4AKDoZDNDhISFtIa0MNQZBLowgtgZtb4BA06CSkQ9FQuIiCTUYRuYig3uvyFQ5fuvfcezvnOHg/8OV7vvDcc97nOc/zfC4tXXfdzOm+AyjjLC2wLSeAMezgwVVl9iEqYa1jpFrgjcR1Jexfwv4Xu3iPTXRjHrN1AIygM3E+w1u8xJ9qP6rUWBu4jbt4nBJba/3Gk2Tt1VsD49gK8Z9CJppRB3rQXusTrIe9F/ciyF8B5gALmKjyoGPMJM5lrOAFDhshHsVelMYfGEzJ3nQi/gOG/6ei+7EdQXxGVwrAd0xm1VZ9+BZBLKcMolLWvT2EnxHEo6IHzBTOEwBHuFM0xKsoC1/zSHeaf3yMIFaLzsKt0M9JiGdREXblDTEZZvwlQDmM6cs23C/CDZ9GWSjjdSNumIXe/MN0TqLzKZbCPMlFi3m7YZqe437wiYbcMGuVMIe16M3P8S6YWCHK1A2bBcjUDZv5W17SUkt16AI/TYrMGB3l9wAAAABJRU5ErkJggg==) 50% 50% no-repeat;\n\tbackground-size: 21px;\n\twidth: 100%;\n\theight: 100%;\n\topacity: 0.6;\n\tcursor: pointer;\n}\n\n.jsr-toolbar .jsr-toolbar-text-font-family {\n\tline-height: 32px;\n\tvertical-align: middle;\n}\n\n.jsr-toolbar .jsr-toolbar-text-font-family select {\n\twidth: 140px;\t\n\tmargin: 0 2px 3px 3px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-font-size {\n\twidth: auto;\n\ttext-decoration: none;\n\tcolor: #333;\n\tfont-family: helvetica, sans-serif;\n\tline-height: 32px;\n\tvertical-align: middle;\n\tpadding-right: 4px;\n\tfont-size: 90%;\n}\n\n.jsr-toolbar .jsr-toolbar-text-wrap {\n\tpadding: 0 4px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-left .icon {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: url(" + __webpack_require__(64) + ") 50% 50% no-repeat;\n\tbackground-size: 21px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-center .icon {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: url(" + __webpack_require__(65) + ") 50% 50% no-repeat;\n\tbackground-size: 21px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-right .icon {\n\twidth: 100%;\n\theight: 100%;\n\tbackground: url(" + __webpack_require__(66) + ") 50% 50% no-repeat;\n\tbackground-size: 21px;\n}\n\ndiv.ditto-designer:before {\n\tposition: absolute;\n\tleft: -6px;\n\ttop: -6px;\n\tright: -6px;\n\tcontent: '';\n\tbackground: rgba(0,0,0,0.2);\n\tbottom: -6px;\n\tborder-radius: 6px;\n\tz-index: -1;\n}\n\ndiv.ditto-designer.jsr-designer-embedded:before {\n\tdisplay: none;\n}\n\n.jsr-toolbar.tool-container.tool-bottom > div {\n\twhite-space: nowrap;\n}\n\n.jsr-toolbar.tool-container.tool-bottom .tool-item {\n\tfloat: none;\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\twidth: auto;\n\tmin-width: 44px;\n\tborder: none;\n\tborder-radius: 0;\n\tcursor: pointer;\n}\n\n.jsr-toolbar .tool-item:hover {\n\tbackground: #edbbb4;\n}\n\n.jsr-toolbar .tool-item.not-pressable:hover {\n\tbackground: none;\n}\n\n.jsr-toolbar.tool-container .tool-item {\n\tfont-family: Helvetica, sans-serif;\n\tline-height: 35px;\n\tvertical-align: middle;\n}\n\n.jsr-toolbar .jsr-toolbar-chart-type,\n.jsr-toolbar .jsr-toolbar-chart-value-field,\n.jsr-toolbar .jsr-toolbar-chart-label-field {\n\tpadding: 0 2px 0 6px;\n}\n\n.jsr-toolbar .jsr-toolbar-chart-type select,\n.jsr-toolbar .jsr-toolbar-chart-value-field select,\n.jsr-toolbar .jsr-toolbar-chart-label-field select {\n\twidth: 125px;\n\tposition: relative;\n\ttop: 2px;\n\tpadding-left: 4px;\n}\n\n.jsr-toolbar .jsr-toolbar-chart-type select {\n\twidth: 70px;\n}\n\n.jsr-toolbar.tool-container.tool-bottom .tool-item .icon {\n\theight: 35px;\n}\n\n.jsr-toolbar.tool-container.tool-bottom {\n\theight: auto;\n}\n\n.jsr-toolbar.tool-container.tool-bottom .tool-items > div {\n\tborder: none;\n\tclear: both;\n\theight: 35px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-content,\n.jsr-toolbar .jsr-toolbar-item-text,\n.jsr-toolbar .jsr-toolbar-text-insertfield,\n.jsr-toolbar .jsr-toolbar-barcode-value {\n\twidth: auto;\n}\n\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text {\n\twidth: 445px;\n\tpadding: 3px;\n\tline-height: 20px;\n\theight: 29px;\n\tvertical-align: middle;\n}\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value {\n\twidth: 300px;\n}\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-type select {\n\tmin-width: 130px;\n}\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text {\n\tposition: relative;\n}\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content .input-wrap,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value .input-wrap,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text .input-wrap\n{\n\tposition: absolute;\n\ttop: 4px;\n\tleft: 4px;\n\tbottom: 4px;\n\tright: 4px;\n\tborder: 1px solid #aaa;\n\tbackground: white;\n\tborder-radius: 3px;\n\toverflow: hidden;\n}\n.jsr-toolbar.tool-container.tool-bottom .tool-item .input-wrap.jsr-input-active { \n\theight: 200px;\n\tbottom: auto;\n\tbox-shadow: 0 2px 15px rgba(0,0,0,0.2);\n}\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content .input-wrap textarea,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value .input-wrap textarea,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text .input-wrap textarea\n{\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 2px 4px;\n\tborder: 0;\n\tbackground: none;\n\tfont-family: helvetica, sans-serif !important;\n\tfont-size: 14px !important;\n\tline-height: 1.3;\n}\n\n.textcomplete-dropdown {\n  background: white;\n  list-style-type: none;\n  padding: 2px 0;\n  margin: 0;\n  border: 1px solid #aaa;\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);\n\tfont-family: helvetica, sans-serif !important;\n\toverflow: scroll;\n}\n\n.textcomplete-dropdown li {\n\tpadding: 2px 5px;\n\tcursor: pointer;\n}\n\n.textcomplete-dropdown li:hover,\n.textcomplete-dropdown li.active {\n\tbackground: #eee;\n}\n\n/*.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-text-content input:focus,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-barcode-value input:focus,\n.jsr-toolbar.tool-container.tool-bottom .tool-item.jsr-toolbar-item-text input:focus {\n\toutline: none !important;\n}*/\n\n.jsr-element-toolbar-item-custom {\n\tpadding: 0 0.5em;\n}\n\n.jsr-toolbar .jsr-toolbar-item-text label,\n.jsr-toolbar .jsr-toolbar-item-text .input-wrap {\n\tdisplay: inline-block;\n\tline-height: 1.2;\n}\n\n.jsr-toolbar .jsr-toolbar-item-text label {\n\tmargin-right: 0.5em;\n}\n\n.jsr-toolbar .jsr-toolbar-item-text .input-wrap {\n\twidth: 300px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-insertfield select {\n\tmargin: 2px;\n\twidth: 132px;\n\tborder: 1px solid #aaa;\n}\n\n.jsr-toolbar .jsr-toolbar-barcode-type,\n.jsr-toolbar .jsr-toolbar-barcode-show-value {\n\tpadding: 0 8px;\n}\n\n.jsr-toolbar .tool-item {\n\theight: 35px;\n}\n\n.jsr-toolbar.tool-container {\n\tbackground: #fafafa;\n\tborder-radius: 3px;\n\tposition: absolute;\n}\n\n/*\n.jsr-toolbar.jsr-toolbar-docked.tool-container {\n\tborder-radius: 0;\n\tbox-shadow: none;\n}\n*/\n\n.palette-item.jsr-drag-proxy {\n\tborder: 1px solid #aaa;\n\tborder-radius: 0;\n\twidth: 100px;\n\theight: 40px;\n\tz-index: 10000;\n\tbackground-repeat: no-repeat;\n}\n\n.palette-item.jsr-drag-proxy.break {\n\theight: 0px;\n\tborder: 0;\n\tborder-top: 1px solid #aaa;\n}\n\n.palette-item.jsr-drag-proxy.break:before,\n.palette-item.jsr-drag-proxy.break:after {\n\tcontent: '';\n\tdisplay: block;\n\tposition: absolute;\n\tleft: 0;\n\theight: 7px;\n\ttop: -4px;\n\twidth: 0;\n\tborder-left: 1px solid #aaa;\n}\n\n.palette-item.jsr-drag-proxy.break:after {\n\tleft: auto;\n\tright: 0;\n}\n\n.jsr-toolbar.tool-container.tool-bottom .tool-item.image-list {\n\theight: 150px;\n\twidth: 350px;\n\tbackground: #f0f0f0;\n\tvertical-align: top;\n\toverflow: auto;\n\tcursor: pointer;\n}\n\n.jsr-toolbar.jsr-toolbar-docked.tool-container.tool-bottom .tool-item.image-list {\n\theight: 110px;\n\twidth: 100%;\n\twhite-space: nowrap;\n}\n\n.jsr-toolbar.tool-container .image-list .image-item {\n\tfloat: left;\n\tmargin: 8px 5px 5px 5px;\n\ttext-align: center;\n\twidth: 70px;\n}\n\n.jsr-toolbar.tool-container .image-list .thumbnail {\n\tmargin-left: 5px;\n\tborder-radius: 0;\n\twidth: 60px;\n\theight: 60px;\n\tbackground-size: contain;\n\tbackground-color: #fff;\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.25);\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n}\n\n.jsr-toolbar.tool-container .image-list .caption {\n\tmargin-top: 3px;\n\twidth: 80px;\n\toverflow: hidden;\n\twhite-space: normal;\n\tline-height: 1.2em;\n  height: 2.4em;\n}\n\n.jsr-toolbar.tool-container.tool-bottom.jsr-toolbar.jsr-toolbar-docked {\n\tborder-left: none;\n\tborder-right: none;\n}\n\n.jsr-toolbar.jsr-toolbar-docked .arrow,\n.jsr-toolbar.jsr-toolbar-docked .arrow-bdr {\n\tdisplay: none;\n}\n\n.jsr-toolbar.jsr-toolbar-docked.tool-container.tool-bottom .tool-item {\n\tfloat: left;\n\tdisplay: block;\n}\n\n.ditto-designer .navbar .nav>li>a {\n\tpadding: 6px 15px;\n}\n\n.jsr-designer-toolbar {\n\tbackground-color: #fafafa;\n    background-image: -moz-linear-gradient(top,#fff,#f2f2f2);\n    background-image: -webkit-gradient(linear,0 0,0 100%,from(#fff),to(#f2f2f2));\n    background-image: -webkit-linear-gradient(top,#fff,#f2f2f2);\n    background-image: -o-linear-gradient(top,#fff,#f2f2f2);\n    background-image: linear-gradient(to bottom,#fff,#f2f2f2);\n    background-repeat: repeat-x;\n    border: 1px solid #d4d4d4;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff',endColorstr='#fff2f2f2',GradientType=0);\n    -webkit-box-shadow: 0 1px 4px rgba(0,0,0,0.065);\n    -moz-box-shadow: 0 1px 4px rgba(0,0,0,0.065);\n    box-shadow: 0 1px 4px rgba(0,0,0,0.065);\n}\n\n.jsr-toolbar.tool-container.jsr-toolbar-docked {\n\tborder-radius: 0;\n}\n\n.jsr-designer-toolbar .dropdown-menu {\n\tz-index: 1600;\n}\n\n.jsr-designer-toolbar,\n.ditto-designer .navbar-inner {\n\tmin-height: 32px;\n\tborder-radius: 4px 4px 0 0;\n\tborder: none;\n\tborder-bottom: 1px solid #ccc;\n\tpadding: 0 5px;\n}\n\n.jsr-toolbar-item-left {\n\tfloat: left;\n}\n\n.ditto-designer .jsr-designer-header hr {\n\tmargin: 10px 0;\n\tborder-top: 1px solid #ddd;\n\tborder-bottom: 1px solid #fafafa;\n}\n\n.ditto-designer .jsr-designer-toolbar .jsr-btn, \n.ditto-designer .jsr-designer-toolbar .jsr-btn-group {\n\tline-height: 16px;\n\tmargin-top: 3px;\n\theight: 26px;\n}\n\n.ditto-designer .jsr-designer-toolbar .designer-control-button,\n.ditto-designer .jsr-designer-toolbar .jsr-toolbar-item-right {\n\tfloat: right;\n\tmargin-left: 5px;\n}\n\n.ditto-designer .input-name,\n.ditto-designer .input-type,\n.ditto-designer .input-default {\n\tmargin-right: 10px;\n}\n\n.ditto-designer .filters-list {\n\tmargin-top: 8px;\n}\n\n.ditto-designer .filter-field {\n\twidth: 150px;\n}\n\n.ditto-designer .filter-operator {\n\twidth: auto;\n\t/*margin-left: 10px;*/\n\tmargin-right: 10px;\n}\n\n.ditto-designer .filter-operand {\n\twidth: 250px;\n\t/*margin-left: 10px;*/\n}\n\n.ditto-designer .filters-list {\n\tclear: both;\n}\n\n.ditto-designer .filter-row.inactive .filter-field,\n.ditto-designer .filter-row.inactive .filter-operator,\n.ditto-designer .filter-row.inactive .filter-operand\n{\n\twidth: auto;\n}\n\n.ditto-designer button.add-filter {\n\tmargin-top: 2px;\n}\n\n.ditto-designer .filter-row {\n\tmargin-bottom: 3px;\n    padding-left: 15px;\n    text-indent: -15px;\n\tposition: relative;\n}\n\n.ditto-designer .delete-row-icon {\n\tdisplay: inline-block;\n\tmargin-left: 10px;\n\tbackground: #ccc;\n\tcolor: #888;\n\ttext-shadow: 0 1px 1px rgba(255,255,255,0.7);\n\tborder-radius: 15px;\n\twidth: 20px;\n\ttext-align: center;\n\tline-height: 16px;\n\tpadding: 1px 0 3px 0;\n\tcursor: pointer;\n}\n\n.ditto-designer .editable-row.inactive .delete-row-icon {\n\tdisplay: none;\n}\n\n.ditto-designer .filter-row-preamble {\n\twidth: 60px;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\ttext-align: right;\n\tmargin-right: 10px;\n\tline-height: 26px;\n}\n\n.ditto-designer .page-margins label {\n\tdisplay: block;\n}\n\n.ditto-designer .page-margins label .text {\n\tdisplay: inline-block;\n\twidth: 75px;\n\ttext-align: right;\n}\n\n.ditto-designer .page-margins input {\n\twidth: 50px;\n\tmargin-bottom: 5px;\n\tmargin-right: 10px;\n\ttext-align: right;\n}\n\n.ditto-designer select.margin-units {\n\twidth: 100px;\n\tmargin-bottom: 0;\n}\n\n.ditto-designer .select2-drop,\n.jsr-toolbar .select2-drop {\n\tmin-width: 200px;\n\tz-index: 60000;\n}\n\n.ditto-designer .input-row input {\n\twidth: 150px;\n}\n\n.ditto-designer .input-row span.input-name,\n.ditto-designer .input-row span.input-type,\n.ditto-designer .input-row span.input-default {\n\tdisplay: inline-block;\n\tmin-width: 100px;\n\twhite-space: nowrap;\n}\n\n.ditto-report-toolbar,\n.jsr-report .ditto-report-toolbar {\n\tposition: absolute;\n\twidth: 100%;\n\tbackground: #eee;\n\tbox-shadow: 0 1px 3px rgba(0,0,0,0.5);\n\tmargin-bottom: 10px;\n\tfont-family: Helvetica, sans-serif;\n\tz-index: 5;\n}\n\n.ditto-report-toolbar .jsr-toolbar-buttons {\n\tmargin: 6px 10px;\n\twidth: 180px;\n\tfloat: right;\n\ttext-align: right;\n}\n\n.ditto-report-toolbar .ditto-input {\n\tdisplay: inline-block;\n\tmargin: 2px 20px 2px 0;\n\twhite-space: nowrap;\n\tvertical-align: middle;\n}\n\n.ditto-report-toolbar .ditto-input .select2-container {\n\tvertical-align: middle;\n\tmargin-left: 0.5em;\n}\n\n.ditto-report-toolbar .jsr-report-inputs {\n\tline-height: 30px;\n\tmargin-right: 181px;\n\tmargin: 6px 10px 0 10px;\n}\n\n.ditto-report-toolbar .jsr-btn {\n\tfont-size: 14px;\n}\n\n.ditto-input input {\n\twidth: 150px;\n\tmargin-bottom: 0;\n}\n\n.ditto-input.ditto-input-boolean input {\n\twidth: auto;\n}\n\n.ditto-designer .ditto-designer-trash {\n\tbackground: #333 url(" + __webpack_require__(67) + ") 27px 6px no-repeat;\n\tbackground-size: 13px;\n\tcolor: white;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: -50px;\n\twidth: 110px;\n\tmargin-left: -50px;\n\ttext-align: center;\n\tpadding: 6px 0 6px 12px;\n\tborder-radius: 0 0 20px 20px;\n\tz-index: 60000;\n\tbox-shadow: 0 2px 15px rgba(0,0,0,0.3);\n\ttransition: top 500ms;\n}\n\n.ditto-designer .ditto-designer-trash.active {\n\ttop: 0;\n}\n\n.ditto-designer .delete-element-button {\n\tcolor: white;\n\tbackground: #aaa;\n\tborder-radius: 3px 3px 0 0;\n\twidth: 22px;\n\ttext-align: right;\n\tpadding: 0px 3px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tposition: absolute;\n\ttransition: width 250ms;\n\tfont-size: 90%;\n\tcursor: pointer;\n\tz-index: 1400;\n}\n\n.ditto-designer .delete-element-button:hover {\n\tbackground: #333;\n\twidth: 60px;\n}\n\n.ditto-designer .delete-element-button .delete-element-icon {\n\tdisplay: inline-block;\n\tfont-weight: bold;\n\twidth: 16px;\n\ttext-align: center;\n}\n\n.ditto-designer .editable-row .editable-row-icon {\n\t/*display: inline-block;*/\n\tposition: relative;\n\ttop: 3px;\n\tmargin-left: 8px;\n\twidth: 16px;\n\theight: 16px;\n\tbackground: transparent none 50% 50% no-repeat;\n\tbackground-size: 16px 16px;\n\topacity: 0;\n\ttransition: opacity 200ms;\n\tcursor: pointer;\n}\n\n.ditto-designer .editable-row .editable-row-icon.icon-check {\n\tbackground-image: url(" + __webpack_require__(68) + ");\n}\n\n.ditto-designer .editable-row.inactive .editable-row-icon.icon-check {\n\tdisplay: none;\n}\n\n.ditto-designer .editable-row .editable-row-icon.icon-edit {\n\tdisplay: none;\n\tbackground-image: url(" + __webpack_require__(69) + ");\n}\n\n.ditto-designer .editable-row.inactive .editable-row-icon.icon-edit {\n\t/*display: inline-block;*/\n\tdisplay: block;\n}\n\n.ditto-designer .editable-row .editable-row-icon.icon-delete {\n\tbackground-image: url(" + __webpack_require__(70) + ");\n\tposition: relative;\n\tpadding-top: 1px;\n}\n\n.ditto-designer .editable-row.inactive .editable-row-icon.icon-delete {\n\t/*display: inline-block;*/\n\tdisplay: block;\n}\n\n.ditto-designer .editable-row:hover {\n\tborder-color: #aaa;\n}\n\n.ditto-designer .editable-row:hover .editable-row-icon {\n\topacity: 0.5;\n}\n\n.ditto-designer .editable-row:hover .editable-row-icon:hover {\n\topacity: 1;\n}\n\n/*.ditto-designer .jsr-section-highlight {\n\tposition: absolute;\n\tz-index: 1;\t\n\tbox-shadow: 0 0 3px rgba(50, 80, 180, 0.7);\n\tborder-left: 3px solid lime;\n\tborder-right: 3px solid lime;\n}*/\n\n.ditto-designer .grouping-row .group-header-footer-vis-cb {\n\tmargin-left: 5px;\n}\n\n.ditto-designer .preview-element .jsr-text {\n\ttext-decoration: inherit;\n\toverflow: hidden;\n}\n\n.jsr-toolbar .jsr-toolbar-text-font-size select {\n\twidth: 53px;\n\tmargin: 0 0 4px 3px;\n}\n\n.jsr-toolbar .jsr-toolbar-box-cornerradius input {\n\twidth: 30px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-textcolor .sp-preview,\n.jsr-toolbar .jsr-toolbar-text-textcolor .sp-preview-inner {\n\tbackground: none !important;\n}\n\n.jsr-toolbar .jsr-toolbar-text-textcolor .sp-preview {\n\ttext-align: center;\n\tborder: none;\n}\n\n.jsr-toolbar .jsr-toolbar-text-textcolor,\n.jsr-toolbar .jsr-toolbar-text-backgroundcolor {\n\tpadding: 0 2px;\n}\n\n.jsr-toolbar .jsr-toolbar-text-textcolor .sp-replacer,\n.jsr-toolbar .jsr-toolbar-text-backgroundcolor .sp-replacer,\n.jsr-toolbar .jsr-toolbar-box-bordercolor .sp-replacer,\n.jsr-toolbar .jsr-toolbar-box-backgroundcolor .sp-replacer {\n\tborder: none;\n\tbackground: none;\n}\n\n.jsr-toolbar .jsr-toolbar-box-cornerradius input {\n\tmargin: 0;\n}\n\n.jsr-toolbar .sp-dd {\n\tfont-size: 15px;\n\tcolor: #333;\n\tline-height: 14px;\n}\n\n.jsr-toolbar .jsr-toolbar-box-bordercolor,\n.jsr-toolbar .jsr-toolbar-box-backgroundcolor,\n.jsr-toolbar .jsr-toolbar-box-cornerradius {\n\tpadding: 0 3px 0 8px;\n}\n\n.jsr-toolbar .jsr-text-color-icon {\n\tdisplay: inline-block;\n\tfont-weight: bold;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 50%;\n\tmargin-left: -7px;\n\twidth: 14px;\n\theight: 14px;\n\tvertical-align: middle;\n\tline-height: 16px;\n\tborder-bottom: 4px solid #55f;\n}\n\n.ditto-designer .editable-row-icon {\n\tposition: relative;\n}\n\n.ditto-designer .editable-row-icon .icon-label {\n\tposition: absolute;\n\ttop: -1px;\n\tright: 17px;\n\tfont-size: 10px;\n\ttext-align: center;\n\toverflow: visible;\n\tdisplay: none;\n\tbackground: #f8f8f8;\n\ttext-shadow: 0 0 1px #f0f0f0;\n\tpadding: 0 4px;\n}\n\n.ditto-designer .editable-row-icon:hover .icon-label {\n\tdisplay: block;\n}\n\n.ditto-designer .editable-row-icon.icon-delete .icon-label {\n\tbackground: #c0392b;\n\tcolor: white;\n}\n\n.ditto-designer .select2-container {\n\ttop: -1px;\n}\n\nbody.jsr-designer-active {\n\toverflow: hidden;\n}\n\n/*body.jsr-designer-active > * {\n\t-webkit-filter: blur(6px);\n\tfilter: blur(2px);\n}\n\nbody.jsr-designer-active > .jsr-designer-container,\nbody.jsr-designer-active > .select2-drop,\nbody.jsr-designer-active > .tool-container {\n\t-webkit-filter: none;\n\tfilter: none;\n}\n*/\nbody.jsr-designer-active .datepicker-dropdown {\n\tz-index: 1500 !important;\n}\n\n.jsr-toolbar .sp-container .sp-palette {\n\tmax-width: 200px;\n}\n\n.ditto-designer .navbar-inner {\n    padding-left: 5px;\n}\n\n.ditto-preview-mask,\n.jsr-designer-mask {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0,0,0,0.3);\n\tz-index: 19000;\n}\n\n.jsr-designer-mask {\n\tposition: fixed;\n\tz-index: 1;\n\topacity: 0;\n\ttransition: opacity 300ms;\n}\n\n.ditto-logo {\n\tfont-weight: bolder;\n\ttext-shadow: 0 1px 0 white;\n\tcolor: #555;\n\tletter-spacing: -0.5px;\n\tfont-size: 14px;\n\t/*padding: 5px 10px 0 7px;*/\n\tcursor: pointer;\n\ttransition: color 200ms;\n}\n\n.ditto-logo:hover {\n\tcolor: #57f;\n}\n\n.ditto-preview-close-button {\n\twidth: 24px;\n\theight: 24px;\n\tborder-radius: 18px;\n\tborder: 3px solid white;\n\tbox-shadow: 0 0 1px black;\n\tbackground: #333;\n\tcolor: white;\n\tposition: absolute;\n\ttop: -25px;\n\tright: -25px;\n\tcursor: pointer;\n\tz-index: 20001;\n\ttext-align: center;\n\tline-height: 20px;\n\t/*font-weight: bold;*/\n\tfont-size: 24px;\n}\n\n.ditto-preview-content {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: auto;\n}\n\n.ditto-input-date input {\n\twidth: 100px;\n}\n\n.ditto-report-toolbar .jsr-toolbar-buttons > * {\n\tmargin-left: 10px;\n}\n\n.ditto-report-toolbar .jsr-save-dropdown-button {\n\tdisplay: inline-block;\n}\n\n.ditto-report-toolbar .jsr-save-dropdown-button .caret {\n\tmargin-left: 5px;\n}\n\n.jsr-report-mask {\n\tdisplay: none;\n\tbackground: rgba(255, 255, 255, 0.75);\n\tposition: absolute;\n\tz-index: 10000;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.jsr-report-mask .spinner {\n\tposition: absolute;\n\tz-index: 10001;\n\ttop: 50%;\n\tleft: 50%;\n\tmargin-left: -16px;\n\tmargin-top: -16px;\n\twidth: 32px;\n\theight: 32px;\n\tbackground: url(" + __webpack_require__(71) + ");\n}\n\n.jsr-save-dropdown-button .caret {\n\tmargin-top: 0;\n}\n\n.jsr-designer-horizontal .jsr-designer-left,\n.jsr-designer-horizontal .jsr-designer-right {\n\tvertical-align: top;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n}\n\n.jsr-designer-horizontal.jsr-overlay-left .jsr-designer-left {\n\tz-index: 1501;\n\ttransition: width 0.25s cubic-bezier(0.005, 1.025, 0.085, 0.990);\n}\n\n.jsr-designer-horizontal.jsr-overlay-left .jsr-designer-left:not(.collapsed) {\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\tz-index: 65000;\n\tbox-shadow: 3px 0 0px 0px rgba(0,0,0,0.07);\n}\n\n.jsr-designer-horizontal .jsr-designer-left {\n\tbackground: #f8f8f8;\n\toverflow-x: visible;\n\tborder-right: 1px solid #aaa;\n}\n\n.jsr-designer-horizontal .jsr-designer-left.collapsed {\n\toverflow-x: hidden;\n\toverflow-y: hidden;\n}\n\n.jsr-designer-horizontal .jsr-designer-left.collapsed .jsr-designer-header * {\n\tdisplay: none;\n}\n\n/*.jsr-designer-horizontal .jsr-designer-left.collapsed .left-pane-toggle-btn {\n\tdisplay: block;\n}\n*/\n.ditto-designer .editable-row label {\n\twhite-space: nowrap;\n}\n\n.jsr-report .jsr-image {\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n}\n\n.jsr-report .jsr-image img {\n\twidth: 100%;\n\theight: auto;\n\tvertical-align: top;\n}\n\n.jsr-downloadify-download-mask {\n\tbackground: rgba(50, 50, 50, 0.5);\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.jsr-pdf-manual-download {\n\tposition: absolute;\n\twidth: 250px;\n\tleft: 50%;\n\tmargin-left: -125px;\n\ttop: 33%;\n\tbackground: #fafafa;\n\tcolor: #444;\n\ttext-align: center;\n\tbox-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);\n\tpadding: 15px;\n}\n\n.jsr-downloadify-button {\n\tmargin-top: 10px;\n}\n\n.ditto-designer .detail-column-count {\n\twidth: 2em;\n}\n\n.ditto-designer .jsr-column-clone-element {\n\topacity: 0.5;\n}\n\n.jsr-print-only-section {\n\tdisplay: none;\n}\n\n.jsr-report .jsr-filter-label {\n\tcolor: #777;\n\tmargin-right: 0.5em;\n}\n\n.ditto-designer .jsr-designer-header .btn {\n\tpadding: 3px 8px;\n}\n\n.jsr-report {\n\toverflow: hidden;\n}\n\n.jsr-content-viewport {\n\tposition: absolute;\n\twidth: 100%;\n\toverflow: auto;\n}\n\n.jsr-toolbar.tool-container.tool-bottom .tool-items > div.jsr-toolbar-advanced {\n\tposition: absolute;\n\tbottom: 0px;\n\tright: 8px;\n\twidth: 32px;\n\theight: 32px;\n\tbackground-image: url(" + __webpack_require__(72) + ");\n\tbackground-size: 22px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50%;\n\tcursor: pointer;\n\topacity: 0.4;\n}\n\n.jsr-toolbar.tool-container.tool-bottom .tool-items > div.jsr-toolbar-advanced:hover {\n\topacity: 0.8;\n}\n\n.jsr-popup.jsr-property-editor {\n\tfont-family: helvetica, sans-serif;\t\n\tfont-size: 14px;\n\twidth: auto;\n\theight: auto;\n\tmax-width: 600px;\n}\n\n.jsr-popup.jsr-property-editor .jsr-popup-content {\n\tpadding: 15px;\n}\n\n.jsr-property-editor .jsr-property-editor-scrollarea {\n\twidth: 300px;\n\tmax-height: 300px;\n\toverflow: auto;\n}\n\n.jsr-property-editor .jsr-property-editor-buttons {\n\tborder-top: 1px solid #aaa;\n\tpadding: 4px;\n\ttext-align: right;\n}\n\n.jsr-property-editor .jsr-property-editor-ok {\n\tmargin-right: 4px;\n}\n\n.jsr-property-editor .pgTable {\n\tborder: none;\n  border-spacing: 0;\n  width: 100%;\n}\n\n.jsr-property-editor .pgGroupRow {\n  font-weight: bold;\n}\n\n.jsr-property-editor .pgGroupRow td {\n\tpadding-top: 8px;\n\tborder-bottom: 1px solid #556069;\n\tcolor: #556069;\n}\n\n.jsr-property-editor .pgGroupRow:first-child td {\n\tpadding-top: 0;\n}\n\n.jsr-property-editor .pgCell {\n    padding: 0;\n}\n\n.jsr-property-editor .pgGroupCell,\n.jsr-property-editor .pgCell:first-child {\n\tpadding: 0;\n\twhite-space: nowrap;\n}\n\n.jsr-property-editor .pgCell:first-child {\n\tpadding-right: 4px;\n}\n\n.jsr-property-editor .pgRow {\n}\n\n.jsr-property-editor .pgCell {\n    border: none;\n    position: relative;\n}\n\n.jsr-property-editor .pgCell:last-child {\n\twidth: 60%;\n}\n\n.jsr-property-editor .pgCell input {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tborder: none;\n\tfont-family: helvetica, sans-serif;\t\n\tfont-size: inherit;\n\tpadding: 4px;\n\tbackground: none;\n}\n\n.jsr-property-editor .pgCell input[type=checkbox] {\n\tposition: static;\n}\n\n.jsr-property-editor .pgTooltip {\n    margin-left: 5px;\n}\n\n.jsr-snap-marker,\n.ditto-snap-edge-highlight {\n\tposition: absolute;\n\tdisplay: none;\n\tbackground: rgba(41, 188, 255, 0.5);\n\tz-index: 1000;\n}\n\n.ditto-snap-edge-highlight {\n\tdisplay: block;\n\tbackground: rgba(41, 188, 255, 0.8);\n}\n\n.ditto-snap-edge-highlight-horizontal {\n\theight: 3px;\n\tborder-radius: 1.5px;\n}\n\n.ditto-snap-edge-highlight-vertical {\n\twidth: 3px;\n\tborder-radius: 1.5px;\n}\n\n.jsr-snap-marker-vertical {\n\twidth: 1px;\n\t/*border-left: 1px solid rgba(41, 188, 255, 0.5);*/\n\theight: 100%;\n\ttop: 0;\n\tbottom: 0;\n}\n\n.jsr-snap-marker-horizontal {\n\twidth: 100;\n\theight: 1px;\n\t/*border-top: 1px solid rgba(41, 188, 255, 0.8);*/\n\tleft: 0;\n\tright: 0;\n}\n\n.ditto-designer .preview-element.jsr-element-snapto {\n\tborder: 1px solid rgba(41,188,255,1);\n\tbox-shadow: 0 0 1px rgba(41,188,255,0.5);\n}\n\n.jsr-hint-bar {\n\tbackground: rgb(33,150,243);\n\tcolor: white;\n\ttext-align: center;\n\tpadding: 2px;\n\tposition: absolute;\n\tbottom: 0;\n\tz-index: 1400;\n\twidth: 100%;\n}\n\n.jsr-plugin-reportlist-select,\n.ditto-designer button.jsr-plugin-reportlist-new {\n\tmargin-right: 4px;\n}\n\n.ditto-designer .select2-container.jsr-plugin-reportlist-select {\n\ttop: 2px;\n}\n\n.jsr-plugin-reportlist .select2-container .select2-choice {\n\theight: 24px;\n\tline-height: 24px;\n}\n\n.jsr-plugin-reportlist-label {\n\tposition: relative;\n    top: 2px;\n    vertical-align: middle;\n    padding: 0 6px 0 4px;\n    height: 24px;\n    line-height: 24px;\n}\n\n.ditto-designer .select2-container .select2-choice {\n\ttext-decoration: none !important;\n}\n\n.jsr-select2-dropdown {\n\tfont-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n \tfont-size: 14px;\n}\n\n.jsr-designer-empty {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 33px;\n    bottom: 0;\n    background: #556;\n}\n\n.jsr-designer-empty-message {\n    text-align: center;\n    top: 50%;\n    position: absolute;\n    width: 100%;\n    margin-top: -14px;\n    font-size: 28px;\n    font-weight: bold;\n    opacity: 0.6;\n    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.jsr-chart-error {\n\tfont: bold 16px Helvetica, sans-serif;\n\tcolor: red;\n}\n\n.ditto-designer .jsr-toolbar-subreport-edit button {\n\tmargin: 2px 4px;\n}\n\n.ditto-designer .jsr-toolbar-subreport-link {\n\tpadding: 0 4px;\n}\n\n.ditto-designer .preview-element.jsr-subreport .preview-element {\n\toverflow: hidden;\n}\n\n.ditto-designer .jsr-subreport-preview {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tz-index: 1;\n}\n\n.ditto-designer .jsr-subreport-mask {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: 2;\n}\n\n.subreport-indicator {\n    display: inline-block;\n    background: #77f;\n    color: white;\n    padding: 2px 12px;\n    line-height: 24px;\n    position: relative;\n    top: 2px;\n}\n\n.jsr-unknown-jasper-element {\n\toverflow: hidden;\n}\n\n.jsr-table table {\n\twidth: 100%;\n\tborder-collapse: collapse;\n\ttable-layout: fixed;\n}\n\n/*.jsr-table td {\n\tborder: 1px solid black;\n}*/\n\n.jsr-table.preview-element .jsr-table-wrap {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.jsr-table.preview-element td,\n.jsr-table.preview-element th {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tborder: 1px solid #ddd;\n}\n\n.jsr-table.preview-element td::before,\n.jsr-table.preview-element th::before {\n\tcontent: '';\n\tdisplay: inline-block;\n\twidth: 0;\n\theight: 18px;\n}\n\n.jsr-report .jsr-spinner {\n  height: 60px;\n  width: 60px;\n  margin: -36px auto 0 auto;\n  position: relative;\n  top: 50%;\n  -webkit-animation: jsr-spinner-rotation .6s infinite linear;\n  -moz-animation: jsr-spinner-rotation .6s infinite linear;\n  -o-animation: jsr-spinner-rotation .6s infinite linear;\n  animation: jsr-spinner-rotation .6s infinite linear;\n  border: 6px solid rgba(0, 174, 239, 0.15);\n  border-top: 6px solid rgba(0, 174, 239, 0.8);\n  border-radius: 100%;\n  overflow: hidden;\n  z-index: 10001;\n}\n\n@-webkit-keyframes jsr-spinner-rotation {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(359deg);\n  }\n}\n@-moz-keyframes jsr-spinner-rotation {\n  from {\n    -moz-transform: rotate(0deg);\n  }\n  to {\n    -moz-transform: rotate(359deg);\n  }\n}\n@-o-keyframes jsr-spinner-rotation {\n  from {\n    -o-transform: rotate(0deg);\n  }\n  to {\n    -o-transform: rotate(359deg);\n  }\n}\n@keyframes jsr-spinner-rotation {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n/*.jsr-spinner .jsr-slice-clip,\n.jsr-spinner .jsr-slice-clip2 {\n    width: 60px;\n    height: 60px;\n    position: absolute;\n    clip: rect(0, 30px, 60px, 0);\n    animation: jsr-spinner-rotation 0.25s infinite linear;\n    animation-direction: reverse;\n}\n\n.jsr-spinner .jsr-slice-clip2 {\n    transform: rotate(180deg);\n    animation: jsr-spinner-rotation 0.4s infinite linear;\n    animation-direction: reverse;\n}\n\n.jsr-spinner .jsr-slice {\n    content: \"\";\n    position: absolute;\n    width: 60px;\n    height: 60px;\n    border-radius: 30px 0 0 30px;\n    background: #E1F5FE;\n    transform: rotate(10deg);\n    clip: rect(0px, 30px, 30px, 0px);\n}\n\n.jsr-spinner .jsr-slice-clip2 .jsr-slice {\n    transform: rotate(0deg);\n}*/\n\n.jsr-measure-sections {\n\tvisibility: hidden;\n}\n\n.jsr-measure-sections .jsr-section {\n\tposition: relative;\n\twidth: 999999px;\n\toverflow: auto;\n\theight: auto !important;\n\ttop: 0 !important;\n}\n\n.jsr-measure-sections .jsr-section.jsr-print-only-section,\n.jsr-measure-sections .jsr-section.jsr-page-background {\n\tposition: absolute;\n}\n\n.jsr-measure-sections .jsr-element {\n\tposition: relative;\n\tfloat: left;\n\tleft: 0 !important;\n}\n\n.jsr-vrender .jsr-section {\n\tdisplay: none;\n}\n\n.jsr-vrender .jsr-section.jsr-paged-in {\n\tdisplay: block;\n}\n\n.jsr-line-horizontal {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 0;\n\tborder: 0;\n}\n\n.jsr-line-vertical {\n\tposition: absolute;\n\theight: 100%;\n\twidth: 0;\n\tborder: 0;\n}\n\n.jsr-chart-line .dimple-axis-y .tick text,\n.jsr-chart-bar .dimple-axis-y .tick text {\n\ttext-anchor: end !important;\n}\n\n.jsr-chart-render-container {\n\tdisplay: block;\n\tposition: absolute;\n\tleft: -5000;\n\topacity: 0;\n}\n\n.jsr-designer-subelement {\n\tposition: absolute;\n}\n\n.jsr-dashboard {\n\t-webkit-perspective: 800;\n}\n\n.jsr-dashboard-tile.jsr-tile-before-show {\n\ttransform: rotateY(-40deg) rotateX(30deg) translate3d(0, 0, -50px);\n\ttransform-style: preserve-3d;\n\topacity: 0;\n}\n\n.jsr-dashboard-tile {\n\ttransition: transform 0.5s, opacity 0.5s;\n\topacity: 1;\n\ttransform: none;\n}\n\n.jsr-featherlight .featherlight-content {\n\tpadding: 0 !important;\n}\n\n.jsr-featherlight .featherlight-content .ditto-report-toolbar {\n\tpadding-right: 25px;\n}\n\n.jsr-featherlight .featherlight-content .featherlight-close-icon {\n\tline-height: 40px;\n\twidth: 30px;\n}\n\n.jsr-designer-image-dropzone {\n  width: 90px;\n  height: 90px;\n  float: left;\n  border: 2px dashed #aaa;\n  margin: 8px 5px 5px 10px;\n}\n\n.jsr-toolbar.tool-container .tool-item .jsr-designer-image-dropzone {\n\tline-height: 1.2;\n  overflow: hidden;\n}\n\n.jsr-designer-image-dropzone .dz-message {\n\tposition: relative;\n\ttop: 1.2em;\n\twhite-space: normal;\n}\n\n.ditto-report-toolbar .ditto-input .select2-container-multi {\n\tmin-width: 200px;\n}\n\n.jsr-table-cell-selected {\n\toutline: 4px solid rgba(0, 80, 255, 0.4);\n}\n\n.jsr-designer-grid {\n\tbackground-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA/wAAAKoCAYAAADKyfSuAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAABCVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIgogICAgICAgICAgICB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iCiAgICAgICAgICAgIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyI+CiAgICAgICAgIDx0aWZmOlJlc29sdXRpb25Vbml0PjI8L3RpZmY6UmVzb2x1dGlvblVuaXQ+CiAgICAgICAgIDx0aWZmOkNvbXByZXNzaW9uPjU8L3RpZmY6Q29tcHJlc3Npb24+CiAgICAgICAgIDx0aWZmOlhSZXNvbHV0aW9uPjcyPC90aWZmOlhSZXNvbHV0aW9uPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICAgICA8dGlmZjpZUmVzb2x1dGlvbj43MjwvdGlmZjpZUmVzb2x1dGlvbj4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjEwMjA8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjE8L2V4aWY6Q29sb3JTcGFjZT4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjY4MDwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgICAgIDxkYzpzdWJqZWN0PgogICAgICAgICAgICA8cmRmOkJhZy8+CiAgICAgICAgIDwvZGM6c3ViamVjdD4KICAgICAgICAgPHhtcDpNb2RpZnlEYXRlPjIwMTctMDItMTNUMjM6MDI6MzQ8L3htcDpNb2RpZnlEYXRlPgogICAgICAgICA8eG1wOkNyZWF0b3JUb29sPlBpeGVsbWF0b3IgMy41PC94bXA6Q3JlYXRvclRvb2w+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpntXRMAABAAElEQVR4Ae3dT24V5xc16iogPW6HRpQJpBN9RLrJXJhCdFv0owgl+sEAaCFGkxGEKxFoMYa0cC8i9Z2yQc7Cf5JVadTr48cdvO1dvHs93sdS2cf2/OLN+2W6+uX////+z//z3dXvvtnvOWR/dUjw/xYpeCQWDx4pkJX94JECWdkPHimQlf3gkQJZ2Q8eKZCV/eCRAlnduv24k/k/r5avP3/LcdVtvrb/pmm1+dp+HjdNIOdtP95tf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542fnUx3z/c8M/vxg/1XyZs87X9/2W2Pa5t87X9e2T6L2e2+dr+/zLbHte2+dr+PTL9lzPbfG3/f5ltj2vbfG3/Hpn+y5ltvrb/v8y2x7VtvrZ/j0z/5cw2X9v/X2bb49o2X9u/R6b/cmabr+3/L7PtcW2br+3fI9N/ObPN1/b/l9n2uLbN1/bvkem/nHkx37U3/PM8r095P9qXNl/bf9Pg2nxtP4+bJpDzth/vtj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG7+6LN+VN/zzNP05f5iejx9r+4RrvjXnv/kfeKQSDx4pkJX94JECWdkPHimQlf3gkQJZ2Q8eKZCV/eCRAlnd1v248oZ/mqenP3x7//dkOq7qNN8h579KxSOZePBIgazsB48UyMp+8EiBrOwHjxTIyn7wSIGs7AePFMjqlu7HhRv+9SsfB5knD97ef5ZCx1l9zPnkY+4LIXkkCQ8eBwGPl49r4PNHPh548EiBrOwHjxTIyn7wSIGs7AePFMjKflzvMZ/9abr1t/nN79bn/K9Pcz/27+wnyVn18vXJw+Xu9HhZlsOfIeTBI7eEB48UyMp+8EiBrOwHjxTIyn7wSIGs7AePFMjKfvBIgaw+7Ue+VUWAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECt0xgfvHm/atpWr6epvndPM+v5g/T8x++vf/7LXOYXr4+ebjcnR4vy/Idj4nHZw8A+5EgPHikQFb2g0cKZGU/eKRAVvaDRwpkZT94pEBW9uNyj/WGf/n7u+Zp+nOap6cP3t5/9ujR4fb/yF9+/nW599WXJz9Oy/TTAeKLz+PySBEePDxeznfA549zi/U1HjxSICv7wSMFsrIfPFIgK/vBIwWysh/Xe9zLdx++t73e9C7TL398c7J+IeB/n7//2Or15mU55L0qF4+U4cHD4+V8B3z+OLdYX+PBIwWysh88UiAr+8EjBbKyHzxSICv7cb3Hhe/wf2pfv5M7/zV/f8xP7z992sed5bfTm9hPwa/4l0fC8OCRAlnZDx4pkJX94JECWdkPHimQlf3gkQJZ2Q8eKZDVbd2PO8lwXq03wevPtJ+/5fheO/2Z/Uuexn9ZUh6pwoNHCmRlP3ikQFb2g0cKZGU/eKRAVvaDRwpkZT94pEBWt3U/rrzhX3nOfoFdQh1T1eZr+2+aVZuv7edx0wRy3vbj3fbnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXl+W79ob/7LfVjx9s+4TrXydoXtr+5v8eobfN1/aPkLGZoc3X9jezjNDb5mv7R8jYzNDma/ubWUbobfO1/SNkbGZo87X9zSwj9Lb52v4RMjYztPna/maWEXrbfG3/CBmbGdp8bX8zywi9bb62f4SMzQxtvra/mWWE3jZf2z9CxmaGi/n+4YZ/ftf89zevt83X9t80kTZf28/jpgnkvO3Hu+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08avLua79oZ/nudX44faPmGbr+3fPtk+V7b52v59Um0/tc3X9m+fbJ8r23xt/z6ptp/a5mv7t0+2z5VtvrZ/n1TbT23ztf3bJ9vnyjZf279Pqu2ntvna/u2T7XNlm6/t3yfV9lPbfG3/9sn2ubLN1/bvk2r7qW2+tn/7ZPtc2eZr+/dJtf3Uy/JdecN/+lsMP0zPtx83/pXzId+a899MyiOVePBIgazsB48UyMp+8EiBrOwHjxTIyn7wSIGs7AePFMjqtu7HlTf80zw9PeY/ybd++E/zHXLmKlxR8UgYHjxSICv7wSMFsrIfPFIgK/vBIwWysh88UiAr+8EjBbK6pftx4YZ//crHQebJg7f3n6XQcVYfcz75mPtCSB5JwoPHQcDj5eMa+PyRjwcePFIgK/vBIwWysh88UiAr+8EjBbKyH9d7zC/evD/8nP762/zmd+tz/tenuR/7d/aT5Kx6+frk4XJ3enz2pwx48Mgt4cEjBbKyHzxSICv7wSMFsrIfPFIgK/vBIwWysh88UiCrT/uRb1URIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwC0TmF+8ef9qmpavp2l+N8/zq/nD9PyHb+//fsscppevTx4ud6fHy7J8x2Pi8dkDwH4kCA8eKZCV/eCRAlnZDx4pkJX94JECWdkPHimQlf243GO94V/+/q55mv6c5unpg7f3nz16dLj9P/KXn39d7n315cmP0zL9dID44vO4PFKEBw+Pl/Md8Pnj3GJ9jQePFMjKfvBIgazsB48UyMp+8EiBrOzH9R738t2H722vN73L9Msf35ysXwj43+fvP7Z6vXlZDnmvysUjZXjw8Hg53wGfP84t1td48EiBrOwHjxTIyn7wSIGs7AePFMjKflzvceE7/J/a1+/kzn/N3x/z0/tPn/ZxZ/nt9Cb2U/Ar/uWRMDx4pEBW9oNHCmRlP3ikQFb2g0cKZGU/eKRAVvaDRwpkdVv3404ynFfrTfD6M+3nbzm+105/Zv+Sp/FflpRHqvDgkQJZ2Q8eKZCV/eCRAlnZDx4pkJX94JECWdkPHimQ1W3djytv+Fees19gl1DHVLX52v6bZtXma/t53DSBnLf9eLf9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr41WX5rr3hP/tt9eMH2z7h+tcJmpe2v/m/R+ht87X9I2RsZmjztf3NLCP0tvna/hEyNjO0+dr+ZpYRett8bf8IGZsZ2nxtfzPLCL1tvrZ/hIzNDG2+tr+ZZYTeNl/bP0LGZoY2X9vfzDJCb5uv7R8hYzNDm6/tb2YZobfN1/aPkLGZ4WK+f7jhn981//3N623ztf03TaTN1/bzuGkCOW/78W7787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787Txq4v5rr3hn+f51fihtk/Y5mv7t0+2z5VtvrZ/n1TbT23ztf3bJ9vnyjZf279Pqu2ntvna/u2T7XNlm6/t3yfV9lPbfG3/9sn2ubLN1/bvk2r7qW2+tn/7ZPtc2eZr+/dJtf3UNl/bv32yfa5s87X9+6Tafmqbr+3fPtk+V7b52v59Um0/9bJ8V97wn/4Www/T8+3HjX/lfMi35vw3k/JIJR48UiAr+8EjBbKyHzxSICv7wSMFsrIfPFIgK/vBIwWyuq37ceUN/zRPT4/5T/KtH/7TfIecuQpXVDwShgePFMjKfvBIgazsB48UyMp+8EiBrOwHjxTIyn7wSIGsbul+XLjhX7/ycZB58uDt/WcpdJzVx5xPPua+EJJHkvDgcRDwePm4Bj5/5OOBB48UyMp+8EiBrOwHjxTIyn7wSIGs7Mf1HvOLN+8PP6e//ja/+d36nP/1ae7H/p39JDmrXr4+ebjcnR6f/SkDHjxyS3jwSIGs7AePFMjKfvBIgazsB48UyMp+8EiBrOwHjxTI6tN+5FtVBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIHDLBOYXb96/mqbl62ma383z/Gr+MD3/4dv7v98yh+nl65OHy93p8bIs3/GYeHz2ALAfCcKDRwpkZT94pEBW9oNHCmRlP3ikQFb2g0cKZGU/LvdYb/iXv79rnqY/p3l6+uDt/WePHh1u/4/85edfl3tffXny47RMPx0gvvg8Lo8U4cHD4+V8B3z+OLdYX+PBIwWysh88UiAr+8EjBbKyHzxSICv7cb3HvXz34Xvb603vMv3yxzcn6xcC/vf5+4+tXm9elkPeq3LxSBkePDxeznfA549zi/U1HjxSICv7wSMFsrIfPFIgK/vBIwWysh/Xe1z4Dv+n9vU7ufNf8/fH/PT+06d93Fl+O72J/RT8in95JAwPHimQlf3gkQJZ2Q8eKZCV/eCRAlnZDx4pkJX94JECWd3W/biTDOfVehO8/kz7+VuO77XTn9m/5Gn8lyXlkSo8eKRAVvaDRwpkZT94pEBW9oNHCmRlP3ikQFb2g0cKZHVb9+PKG/6V5+wX2CXUMVVtvrb/plm1+dp+HjdNIOdtP95tf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542fnVZvmtv+M9+W/34wbZPuP51gual7W/+7xF623xt/wgZmxnafG1/M8sIvW2+tn+EjM0Mbb62v5llhN42X9s/QsZmhjZf29/MMkJvm6/tHyFjM0Obr+1vZhmht83X9o+QsZmhzdf2N7OM0Nvma/tHyNjM0OZr+5tZRuht87X9I2RsZriY7x9u+Od3zX9/83rbfG3/TRNp87X9PG6aQM7bfrzb/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/Opivmtv+Od5fjV+qO0Ttvna/u2T7XNlm6/t3yfV9lPbfG3/9sn2ubLN1/bvk2r7qW2+tn/7ZPtc2eZr+/dJtf3UNl/bv32yfa5s87X9+6Tafmqbr+3fPtk+V7b52v59Um0/tc3X9m+fbJ8r23xt/z6ptp/a5mv7t0+2z5VtvrZ/n1TbT70s35U3/Ke/xfDD9Hz7ceNfOR/yrTn/zaQ8UokHjxTIyn7wSIGs7AePFMjKfvBIgazsB48UyMp+8EiBrG7rflx5wz/N09Nj/pN864f/NN8hZ67CFRWPhOHBIwWysh88UiAr+8EjBbKyHzxSICv7wSMFsrIfPFIgq1u6Hxdu+NevfBxknjx4e/9ZCh1n9THnk4+5L4TkkSQ8eBwEPF4+roHPH/l44MEjBbKyHzxSICv7wSMFsrIfPFIgK/txvcf84s37w8/pr7/Nb363Pud/fZr7sX9nP0nOqpevTx4ud6fHZ3/KgAeP3BIePFIgK/vBIwWysh88UiAr+8EjBbKyHzxSICv7wSMFsvq0H/lWFQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAjcMoH5xZv3r6Zp+Xqa5nfzPL+aP0zPf/j2/u+3zGF6+frk4XJ3erwsy3c8Jh6fPQDsR4Lw4JECWdkPHimQlf3gkQJZ2Q8eKZCV/eCRAlnZj8s91hv+5e/vmqfpz2menj54e//Zo0eH2/8jf/n51+XeV1+e/Dgt008HiC8+j8sjRXjw8Hg53wGfP84t1td48EiBrOwHjxTIyn7wSIGs7AePFMjKflzvcS/fffje9nrTu0y//PHNyfqFgP99/v5jq9ebl+WQ96pcPFKGBw+Pl/Md8Pnj3GJ9jQePFMjKfvBIgazsB48UyMp+8EiBrOzH9R4XvsP/qX39Tu781/z9MT+9//RpH3eW305vYj8Fv+JfHgnDg0cKZGU/eKRAVvaDRwpkZT94pEBW9oNHCmRlP3ikQFa3dT/uJMN5td4Erz/Tfv6W43vt9Gf2L3ka/2VJeaQKDx4pkJX94JECWdkPHimQlf3gkQJZ2Q8eKZCV/eCRAlnd1v248oZ/5Tn7BXYJdUxVm6/tv2lWbb62n8dNE8h5249325+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV9dlu/aG/6z31Y/frDtE65/naB5afub/3uE3jZf2z9CxmaGNl/b38wyQm+br+0fIWMzQ5uv7W9mGaG3zdf2j5CxmaHN1/Y3s4zQ2+Zr+0fI2MzQ5mv7m1lG6G3ztf0jZGxmaPO1/c0sI/S2+dr+ETI2M7T52v5mlhF623xt/wgZmxku5vuHG/75XfPf37zeNl/bf9NE2nxtP4+bJpDzth/vtj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG7+6mO/aG/55nl+NH2r7hG2+tn/7ZPtc2eZr+/dJtf3UNl/bv32yfa5s87X9+6Tafmqbr+3fPtk+V7b52v59Um0/tc3X9m+fbJ8r23xt/z6ptp/a5mv7t0+2z5VtvrZ/n1TbT23ztf3bJ9vnyjZf279Pqu2ntvna/u2T7XNlm6/t3yfV9lMvy3flDf/pbzH8MD3fftz4V86HfGvOfzMpj1TiwSMFsrIfPFIgK/vBIwWysh88UiAr+8EjBbKyHzxSIKvbuh9X3vBP8/T0mP8k3/rhP813yJmrcEXFI2F48EiBrOwHjxTIyn7wSIGs7AePFMjKfvBIgazsB48UyOqW7seFG/71Kx8HmScP3t5/lkLHWX3M+eRj7gsheSQJDx4HAY+Xj2vg80c+HnjwSIGs7AePFMjKfvBIgazsB48UyMp+XO8xv3jz/vBz+utv85vfrc/5X5/mfuzf2U+Ss+rl65OHy93p8dmfMuDBI7eEB48UyMp+8EiBrOwHjxTIyn7wSIGs7AePFMjKfvBIgaw+7Ue+VUWAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECt0xgfvHm/atpWr6epvndPM+v5g/T8x++vf/7LXOYXr4+ebjcnR4vy/Idj4nHZw8A+5EgPHikQFb2g0cKZGU/eKRAVvaDRwpkZT94pEBW9uNyj/WGf/n7u+Zp+nOap6cP3t5/9ujR4fb/yF9+/nW599WXJz9Oy/TTAeKLz+PySBEePDxeznfA549zi/U1HjxSICv7wSMFsrIfPFIgK/vBIwWysh/Xe9zLdx++t73e9C7TL398c7J+IeB/n7//2Or15mU55L0qF4+U4cHD4+V8B3z+OLdYX+PBIwWysh88UiAr+8EjBbKyHzxSICv7cb3Hhe/wf2pfv5M7/zV/f8xP7z992sed5bfTm9hPwa/4l0fC8OCRAlnZDx4pkJX94JECWdkPHimQlf3gkQJZ2Q8eKZDVbd2PO8lwXq03wevPtJ+/5fheO/2Z/Uuexn9ZUh6pwoNHCmRlP3ikQFb2g0cKZGU/eKRAVvaDRwpkZT94pEBWt3U/rrzhX3nOfoFdQh1T1eZr+2+aVZuv7edx0wRy3vbj3fbnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXl+W79ob/7LfVjx9s+4TrXydoXtr+5v8eobfN1/aPkLGZoc3X9jezjNDb5mv7R8jYzNDma/ubWUbobfO1/SNkbGZo87X9zSwj9Lb52v4RMjYztPna/maWEXrbfG3/CBmbGdp8bX8zywi9bb62f4SMzQxtvra/mWWE3jZf2z9CxmaGi/n+4YZ/ftf89zevt83X9t80kTZf28/jpgnkvO3Hu+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08avLua79oZ/nudX44faPmGbr+3fPtk+V7b52v59Um0/tc3X9m+fbJ8r23xt/z6ptp/a5mv7t0+2z5VtvrZ/n1TbT23ztf3bJ9vnyjZf279Pqu2ntvna/u2T7XNlm6/t3yfV9lPbfG3/9sn2ubLN1/bvk2r7qW2+tn/7ZPtc2eZr+/dJtf3Uy/JdecN/+lsMP0zPtx83/pXzId+a899MyiOVePBIgazsB48UyMp+8EiBrOwHjxTIyn7wSIGs7AePFMjqtu7HlTf80zw9PeY/ybd++E/zHXLmKlxR8UgYHjxSICv7wSMFsrIfPFIgK/vBIwWysh88UiAr+8EjBbK6pftx4YZ//crHQebJg7f3n6XQcVYfcz75mPtCSB5JwoPHQcDj5eMa+PyRjwcePFIgK/vBIwWysh88UiAr+8EjBbKyH9d7zC/evD/8nP762/zmd+tz/tenuR/7d/aT5Kx6+frk4XJ3enz2pwx48Mgt4cEjBbKyHzxSICv7wSMFsrIfPFIgK/vBIwWysh88UiCrT/uRb1URIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwC0TmF+8ef9qmpavp2l+N8/zq/nD9PyHb+//fsscppevTx4ud6fHy7J8x2Pi8dkDwH4kCA8eKZCV/eCRAlnZDx4pkJX94JECWdkPHimQlf243GO94V/+/q55mv6c5unpg7f3nz16dLj9P/KXn39d7n315cmP0zL9dID44vO4PFKEBw+Pl/Md8Pnj3GJ9jQePFMjKfvBIgazsB48UyMp+8EiBrOzH9R738t2H722vN73L9Msf35ysXwj43+fvP7Z6vXlZDnmvysUjZXjw8Hg53wGfP84t1td48EiBrOwHjxTIyn7wSIGs7AePFMjKflzvceE7/J/a1+/kzn/N3x/z0/tPn/ZxZ/nt9Cb2U/Ar/uWRMDx4pEBW9oNHCmRlP3ikQFb2g0cKZGU/eKRAVvaDRwpkdVv3404ynFfrTfD6M+3nbzm+105/Zv+Sp/FflpRHqvDgkQJZ2Q8eKZCV/eCRAlnZDx4pkJX94JECWdkPHimQ1W3djytv+Fees19gl1DHVLX52v6bZtXma/t53DSBnLf9eLf9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr4VZuv7R9fICds87X9edr41WX5rr3hP/tt9eMH2z7h+tcJmpe2v/m/R+ht87X9I2RsZmjztf3NLCP0tvna/hEyNjO0+dr+ZpYRett8bf8IGZsZ2nxtfzPLCL1tvrZ/hIzNDG2+tr+ZZYTeNl/bP0LGZoY2X9vfzDJCb5uv7R8hYzNDm6/tb2YZobfN1/aPkLGZ4WK+f7jhn981//3N623ztf03TaTN1/bzuGkCOW/78W7787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787TxqzZf2z++QE7Y5mv787Txq4v5rr3hn+f51fihtk/Y5mv7t0+2z5VtvrZ/n1TbT23ztf3bJ9vnyjZf279Pqu2ntvna/u2T7XNlm6/t3yfV9lPbfG3/9sn2ubLN1/bvk2r7qW2+tn/7ZPtc2eZr+/dJtf3UNl/bv32yfa5s87X9+6Tafmqbr+3fPtk+V7b52v59Um0/9bJ8V97wn/4Www/T8+3HjX/lfMi35vw3k/JIJR48UiAr+8EjBbKyHzxSICv7wSMFsrIfPFIgK/vBIwWyuq37ceUN/zRPT4/5T/KtH/7TfIecuQpXVDwShgePFMjKfvBIgazsB48UyMp+8EiBrOwHjxTIyn7wSIGsbul+XLjhX7/ycZB58uDt/WcpdJzVx5xPPua+EJJHkvDgcRDwePm4Bj5/5OOBB48UyMp+8EiBrOwHjxTIyn7wSIGs7Mf1HvOLN+8PP6e//ja/+d36nP/1ae7H/p39JDmrXr4+ebjcnR6f/SkDHjxyS3jwSIGs7AePFMjKfvBIgazsB48UyMp+8EiBrOwHjxTI6tN+5FtVBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIHDLBOYXb96/mqbl62ma383z/Gr+MD3/4dv7v98yh+nl65OHy93p8bIs3/GYeHz2ALAfCcKDRwpkZT94pEBW9oNHCmRlP3ikQFb2g0cKZGU/LvdYb/iXv79rnqY/p3l6+uDt/WePHh1u/4/85edfl3tffXny47RMPx0gvvg8Lo8U4cHD4+V8B3z+OLdYX+PBIwWysh88UiAr+8EjBbKyHzxSICv7cb3HvXz34Xvb603vMv3yxzcn6xcC/vf5+4+tXm9elkPeq3LxSBkePDxeznfA549zi/U1HjxSICv7wSMFsrIfPFIgK/vBIwWysh/Xe1z4Dv+n9vU7ufNf8/fH/PT+06d93Fl+O72J/RT8in95JAwPHimQlf3gkQJZ2Q8eKZCV/eCRAlnZDx4pkJX94JECWd3W/biTDOfVehO8/kz7+VuO77XTn9m/5Gn8lyXlkSo8eKRAVvaDRwpkZT94pEBW9oNHCmRlP3ikQFb2g0cKZHVb9+PKG/6V5+wX2CXUMVVtvrb/plm1+dp+HjdNIOdtP95tf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542ftXma/vHF8gJ23xtf542fnVZvmtv+M9+W/34wbZPuP51gual7W/+7xF623xt/wgZmxnafG1/M8sIvW2+tn+EjM0Mbb62v5llhN42X9s/QsZmhjZf29/MMkJvm6/tHyFjM0Obr+1vZhmht83X9o+QsZmhzdf2N7OM0Nvma/tHyNjM0OZr+5tZRuht87X9I2RsZriY7x9u+Od3zX9/83rbfG3/TRNp87X9PG6aQM7bfrzb/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/KrN1/aPL5ATtvna/jxt/Opivmtv+Od5fjV+qO0Ttvna/u2T7XNlm6/t3yfV9lPbfG3/9sn2ubLN1/bvk2r7qW2+tn/7ZPtc2eZr+/dJtf3UNl/bv32yfa5s87X9+6Tafmqbr+3fPtk+V7b52v59Um0/tc3X9m+fbJ8r23xt/z6ptp/a5mv7t0+2z5VtvrZ/n1TbT70s35U3/Ke/xfDD9Hz7ceNfOR/yrTn/zaQ8UokHjxTIyn7wSIGs7AePFMjKfvBIgazsB48UyMp+8EiBrG7rflx5wz/N09Nj/pN864f/NN8hZ67CFRWPhOHBIwWysh88UiAr+8EjBbKyHzxSICv7wSMFsrIfPFIgq1u6Hxdu+NevfBxknjx4e/9ZCh1n9THnk4+5L4TkkSQ8eBwEPF4+roHPH/l44MEjBbKyHzxSICv7wSMFsrIfPFIgK/txvcf84s37w8/pr7/Nb363Pud/fZr7sX9nP0nOqpevTx4ud6fHZ3/KgAeP3BIePFIgK/vBIwWysh88UiAr+8EjBbKyHzxSICv7wSMFsvq0H/lWFQECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECXoo4LAAAEi5JREFUBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAjcMoH5xZv3r6Zp+Xqa5nfzPL+aP0zPf/j2/u+3zGF6+frk4XJ3erwsy3c8Jh6fPQDsR4Lw4JECWdkPHimQlf3gkQJZ2Q8eKZCV/eCRAlnZj8s91hv+5e/vmqfpz2menj54e//Zo0eH2/8jf/n51+XeV1+e/Dgt008HiC8+j8sjRXjw8Hg53wGfP84t1td48EiBrOwHjxTIyn7wSIGs7AePFMjKflzvcS/fffje9nrTu0y//PHNyfqFgP99/v5jq9ebl+WQ96pcPFKGBw+Pl/Md8Pnj3GJ9jQePFMjKfvBIgazsB48UyMp+8EiBrOzH9R4XvsP/qX39Tu781/z9MT+9//RpH3eW305vYj8Fv+JfHgnDg0cKZGU/eKRAVvaDRwpkZT94pEBW9oNHCmRlP3ikQFa3dT/uJMN5td4Erz/Tfv6W43vt9Gf2L3ka/2VJeaQKDx4pkJX94JECWdkPHimQlf3gkQJZ2Q8eKZCV/eCRAlnd1v248oZ/5Tn7BXYJdUxVm6/tv2lWbb62n8dNE8h5249325+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV+1+dr+8QVywjZf25+njV9dlu/aG/6z31Y/frDtE65/naB5afub/3uE3jZf2z9CxmaGNl/b38wyQm+br+0fIWMzQ5uv7W9mGaG3zdf2j5CxmaHN1/Y3s4zQ2+Zr+0fI2MzQ5mv7m1lG6G3ztf0jZGxmaPO1/c0sI/S2+dr+ETI2M7T52v5mlhF623xt/wgZmxku5vuHG/75XfPf37zeNl/bf9NE2nxtP4+bJpDzth/vtj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG79q87X94wvkhG2+tj9PG7+6mO/aG/55nl+NH2r7hG2+tn/7ZPtc2eZr+/dJtf3UNl/bv32yfa5s87X9+6Tafmqbr+3fPtk+V7b52v59Um0/tc3X9m+fbJ8r23xt/z6ptp/a5mv7t0+2z5VtvrZ/n1TbT23ztf3bJ9vnyjZf279Pqu2ntvna/u2T7XNlm6/t3yfV9lMvy3flDf/pbzH8MD3fftz4V86HfGvOfzMpj1TiwSMFsrIfPFIgK/vBIwWysh88UiAr+8EjBbKyHzxSIKvbuh9X3vBP8/T0mP8k3/rhP813yJmrcEXFI2F48EiBrOwHjxTIyn7wSIGs7AePFMjKfvBIgazsB48UyOqW7seFG/71Kx8HmScP3t5/lkLHWX3M+eRj7gsheSQJDx4HAY+Xj2vg80c+HnjwSIGs7AePFMjKfvBIgazsB48UyMp+XO8xv3jz/vBz+utv85vfrc/5X5/mfuzf2U+Ss+rl65OHy93p8dmfMuDBI7eEB48UyMp+8EiBrOwHjxTIyn7wSIGs7AePFMjKfvBIgaw+7Ue+VUWAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECt0xgfvHm/atpWr6epvndPM+v5g/T8x++vf/7LXOYXr4+ebjcnR4vy/Idj4nHZw8A+5EgPHikQFb2g0cKZGU/eKRAVvaDRwpkZT94pEBW9uNyj/WGf/n7u+Zp+nOap6cP3t5/9ujR4fb/yF9+/nW599WXJz9Oy/TTAeKLz+PySBEePDxeznfA549zi/U1HjxSICv7wSMFsrIfPFIgK/vBIwWysh/Xe9zLdx++t73e9C7TL398c7J+IeB/n7//2Or15mU55L0qF4+U4cHD4+V8B3z+OLdYX+PBIwWysh88UiAr+8EjBbKyHzxSICv7cb3Hhe/wf2pfv5M7/zV/f8xP7z992sed5bfTm9hPwa/4l0fC8OCRAlnZDx4pkJX94JECWdkPHimQlf3gkQJZ2Q8eKZDVbd2PO8lwXq03wevPtJ+/5fheO/2Z/Uuexn9ZUh6pwoNHCmRlP3ikQFb2g0cKZGU/eKRAVvaDRwpkZT94pEBWt3U/rrzhX3nOfoFdQh1T1eZr+2+aVZuv7edx0wRy3vbj3fbnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXbb62f3yBnLDN1/bnaeNXl+W79ob/7LfVjx9s+4TrXydoXtr+5v8eobfN1/aPkLGZoc3X9jezjNDb5mv7R8jYzNDma/ubWUbobfO1/SNkbGZo87X9zSwj9Lb52v4RMjYztPna/maWEXrbfG3/CBmbGdp8bX8zywi9bb62f4SMzQxtvra/mWWE3jZf2z9CxmaGi/n+4YZ/ftf89zevt83X9t80kTZf28/jpgnkvO3Hu+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08av2nxt//gCOWGbr+3P08avLua79oZ/nudX44faPmGbr+3fPtk+V7b52v59Um0/tc3X9m+fbJ8r23xt/z6ptp/a5mv7t0+2z5VtvrZ/n1TbT23ztf3bJ9vnyjZf279Pqu2ntvna/u2T7XNlm6/t3yfV9lPbfG3/9sn2ubLN1/bvk2r7qW2+tn/7ZPtc2eZr+/dJtf3Uy/JdecN/+lsMP0zPtx83/pXzId+a899MyiOVePBIgazsB48UyMp+8EiBrOwHjxTIyn7wSIGs7AePFMjqtu7HlTf80zw9PeY/ybd++E/zHXLmKlxR8UgYHjxSICv7wSMFsrIfPFIgK/vBIwWysh88UiAr+8EjBbK6pftx4YZ//crHQebJg7f3n6XQcVYfcz75mPtCSB5JwoPHQcDj5eMa+PyRjwcePFIgK/vBIwWysh88UiAr+8EjBbKyH9d7zC/evD/8nP762/zmd+tz/tenuR/7d/aT5Kx6+frk4XJ3enz2pwx48Mgt4cEjBbKyHzxSICv7wSMFsrIfPFIgK/vBIwWysh88UiCrT/uRb1URIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAwC0TmF+8ef9qmpavp2l+N8/zq/nD9PyHb+//fsscppevTx4ud6fHy7J8x2Pi8dkDwH4kCA8eKZCV/eCRAlnZDx4pkJX94JECWdkPHimQlf243GO94V/+/q55mv6c5unpg7f3nz16dLj9P/KXn39d7n315cmP0zL9dID44vO4PFKEBw+Pl/Md8Pnj3GJ9jQePFMjKfvBIgazsB48UyMp+8EiBrOzH9R738t2H722vN73L9Msf35ysXwj43+fvP7Z6vXlZDnmvysUjZXjw8Hg53wGfP84t1td48EiBrOwHjxTIyn7wSIGs7AePFMjKflzvceE7/J/a1+/kzn/N3x/z0/tPn/ZxZ/nt9Cb2U/Ar/uWRMDx4pEBW9oNHCmRlP3ikQFb2g0cKZGU/eKRAVvaDRwpkdVv3404ynFfrTfD6M+3nbzm+105/Zv+Sp/FflpRHqvDgkQJZ2Q8eKZCV/eCRAlnZDx4pkJX94JECWdkPHimQ1W3dj/8LPQ1dC7xo9zsAAAAASUVORK5CYII=);\n}\n\n.jsr-table-column-resize-bar {\n\tposition: absolute;\n\ttop: 0;\n\twidth: 5px;\n\theight: 100%;\n\tz-index: 10;\n\tcursor: ew-resize;\n\tdisplay: none;\n}\n\n.ditto-designer .jsr-table .jsr-table-column-tab {\n\tbackground: rgb(33,150,243);\n\tborder-radius: 3px 3px 0 0;\n\tposition: absolute;\n\tbottom: 100%;\n\theight: 16px;\n\tcolor: white;\n\topacity: 0;\n\ttext-align: center;\n  font-size: 16px;\n  line-height: 12px;\n\ttransition: opacity 0.2s;\n}\n\n.ditto-designer .jsr-table.jsr-column-tab-visible .jsr-table-column-tab {\n\topacity: 1;\n\tcursor: pointer;\n}\n\n.jsr-column-menu-item {\n\tpadding: 2px 6px;\n\tcursor: pointer;\n\tfont-size: 14px;\n}\n\n.jsr-column-menu-item:hover {\n\tbackground: #eee;\n}\n\n.jsr-table.active .jsr-table-column-resize-bar {\n\tdisplay: block;\n}\n\n.jsr-table.active .jsr-table-column-resize-bar:hover {\n\tbackground: rgba(0, 80, 255, 0.3);\n}\n\n.jsr-table.active .jsr-table-column-resize-bar-dragging {\n\tbackground: rgba(0,0,0,0.3);\n}\n\n.ditto-designer .header-panel.data {\n\tpadding: 0;\n}\n\n.jsr-data-section-accordion-header {\n  height: 2em;\n  line-height: 2em;\n  border-top: 1px solid #ccc;\n  padding: 0 10px;\n  font-weight: bold;\n  color: #666;\n  cursor: pointer;\n}\n\n.jsr-data-section-accordion-header:first-child {\n\tborder-top: none;\n}\n\n.jsr-accordion-icon {\n\ttransition: transform 250ms;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.jsr-accordion-header-open .jsr-accordion-icon {\n  transform: rotateZ(90deg);\n}\n\n.jsr-data-section-accordion-pane-body {\n\theight: 0;\n\toverflow: auto;\n\ttransition: height 300ms;\n}\n\n.ditto-designer .header-panel .jsr-padding {\n\tpadding: 15px;\n}\n\n.ditto-designer .btn.jsr-add-data-section {\n\tmargin-bottom: 5px;\n}\n\n/*\n.jsr-text p,\n.jsr-text ul,\n.jsr-text li {\n\tmargin: 0;\n\tpadding: 0;\n}\n*/\n\n.jsr-text ul {\n\tpadding-left: 0;\n}\n\n.jsr-text li {\n\tmargin-left: 1em;\n}\n\n.jsr-popup {\n\tposition: absolute;\n\tborder-radius: 6px;\n\tbackground: #fafafa;\n\tbox-shadow: 0 2px 6px rgba(0, 20, 40, 0.2);\n\tz-index: 9999;\n\tpadding: 0;\n\tbox-sizing: border-box;\n\tvisibility: hidden;\n\topacity: 0;\n\tmargin-top: -8px;\n\ttransition: margin-top 150ms, opacity 150ms;\n\toverflow: visible;\n}\n\n.jsr-popup-content {\n\toverflow: auto;\n\tborder-radius: 6px;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\n.jsr-popup-transitioning {\n\tvisibility: visible;\n}\n\n.jsr-popup-visible {\n\tvisibility: visible;\n\topacity: 1;\n\tmargin-top: 0;\n}\n\n.jsr-popup-arrow {\n\tposition: absolute;\n\tleft: 15px;\n\ttop: -7px;\n\twidth: 0;\n\theight: 0;\n\tborder-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid #ddd;\n}\n\n.jsr-popup-arrow::before {\n\tcontent: '';\n\tdisplay: block;\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\ttop: 1px;\n\tleft: -8px;\n\tborder-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid #fafafa;\n}\n\n.jsr-popup-placement-right .jsr-popup-arrow {\n\ttransform: rotate(-90deg);\n\ttop: 15px;\n\tleft: -12px;\n}\n\n.jsr-new-element-button {\n\tposition: absolute;\n\tleft: 3px;\n\ttop: 100px;\n\twidth: 28px;\n\theight: 28px;\n\tborder: 1px solid rgb(41,121,255);\n\tborder-radius: 50%;\n\tbackground: white;\n\ttext-align: center;\n\tfont-size: 20px;\n\tline-height: 25px;\n\tcolor: #888;\n\tfont-weight: 300;\n\ttransition: opacity 0.15s, top 200ms;\n\tcursor: pointer;\n\tbox-shadow: 0 1px 1px rgba(0, 10, 20, 0.2);\n\tz-index: 100;\n}\n\n.jsr-new-element-popup .jsr-popup-content {\n\tpadding: 5px 0;\n\tbackground: #fafafa;\n}\n\n.jsr-new-element-button:hover {\n\tcolor: black;\n}\n\n.ditto-designer .select2-arrow,\n.ditto-designer .select2-container .select2-choice .select2-arrow {\n\tbackground: none;\n\tborder: none;\n\twidth: 25px;\n\tborder-left: 1px solid #aaa;\n}\n\n.ditto-designer .select2-container .select2-arrow b,\n.ditto-designer .select2-container .select2-choice .select2-arrow b {\n  width: 6px;\n  height: 10px;\n\tbackground: url(" + __webpack_require__(51) + ") 0 0 no-repeat !important;\n  background-size: 6px !important;\n\ttransform: rotate(90deg);\n\topacity: 0.7;\n\tposition: relative;\n\ttop: 8px;\n\tleft: 8px;\n}\n\n.ditto-designer .select2-container .select2-choice {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #f9f8f9), color-stop(0.2, #fcfbfc), color-stop(1, #fff));\n\tbackground-image: linear-gradient(top, #fff 0%, #fcfbfc 80%, #f9f8f9 100%);\n\tbackground-size: 100%;\n\tbox-shadow: 0 2px 1px rgb(248, 248, 248);\n}\n\n.ditto-designer .select2-container .select2-choice > .select2-chosen {\n\tmargin-right: 34px;\n}\n\n.jsr-btn,\n.ditto-designer .jsr-btn {\n\tborder: 1px solid rgb(193, 184, 202);\n\tcolor: rgb(73, 62, 84);\n\tborder-radius: 4px;\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #f9f8f9), color-stop(0.2, #fcfbfc), color-stop(1, #fff));\n\tbackground-image: linear-gradient(top, #fff 0%, #fcfbfc 80%, #f9f8f9 100%);\n\tbackground-size: 100%;\n\tbox-shadow: 0 2px 1px rgba(0, 0, 0, 0.04);\n\theight: 28px;\n\tpadding: 0 10px;\n\tline-height: 26px;\n\ttransition: border-color 0.15s, box-shadow 0.15s;\n\tcursor: pointer;\n}\n\n.jsr-btn:hover {\n\tbox-shadow: 0 2px 1px rgba(0, 0, 0, 0.1);\n\tborder-color: rgb(165, 159, 174);\n\tcolor: rgb(47, 41, 54);\n}\n\n.jsr-btn:focus,\n.jsr-btn:active {\n\toutline: none;\n}\n\n.ditto-designer .select2-container.jsr-select2-error a.select2-choice {\n\tbox-shadow: 0 0 1px 2px orange;\n}\n\n.jsr-btn.btn-success {\n\tbackground: #5cb85c;\n\tborder-color: #5cb85c;\n\tcolor: white;\n}\n\n.jsr-select2-dropdown .select2-results {\n\tpadding: 0;\n\tmargin: 4px 0;\n}\n\n.jsr-select2-dropdown .select2-results .select2-highlighted {\n\tbackground: rgb(255,224,178);\n\tcolor: black;\n}\n\n.ditto-designer .preview-element.jsr-element-adding {\n\tbox-shadow: 0 0 30px rgba(243,156,18, 0);\n\ttransition: background 1s, box-shadow 1s, transform 0.3s;\n\tbackground-color: transparent;\n\ttransform: scale(1);\n}\n\n.ditto-designer .preview-element.jsr-element-added {\n\tbackground-color: rgba(243,156,18, 0.3);\n\tbox-shadow: 0 0 1px rgba(243,156,18, 1);\n\ttransform: scale(0.8);\n}\n\n.jsr-settings-panel .default-font-size {\n\tpadding-top: 5px;\n}\n\n.jsr-section-toolbar-item {\n\tmargin: 0 5px;\n}\n\n.jsr-section-highlight {\n\tposition: absolute;\n\tbox-shadow: 0 0 0 3px rgba(33,150,243,0.5);\n\tdisplay: none;\n\tborder-radius: 1px;\n}\n\n.jsr-toolbar.jsr-toolbar-docked.tool-container.tool-bottom .tool-item.jsr-section-toolbar-item button {\n\theight: 22px;\n\tfont-size: 13px;\n\tline-height: 19px;\n}\n\n.jsr-text.jsr-text-rotate--90 {\n\ttransform: rotate(-90deg);\n\ttransform-origin: 0 0;\n}\n\n.ditto-designer .preview-element .jsr-text.jsr-text-rotate--90 {\n\ttop: 100%;\n}\n\n.jsr-text.jsr-text-rotate-90 {\n\ttransform: rotate(90deg);\n\ttransform-origin: 0 0;\n}\n\n.ditto-designer .preview-element .jsr-text.jsr-text-rotate-90 {\n\tleft: 100%;\n}\n\n.jsr-designer-zoom {\n\tborder-radius: 5px;\n\tposition: absolute;\n\tz-index: 100;\n\ttop: 10px;\n\tright: 20px;\n\toverflow: hidden;\n\tbox-shadow: 0 1px 2px rgba(0,0,0,0.2);\n\topacity: 0.5;\n\ttransition: opacity 0.2s;\n\tuser-select: none;\n}\n\n.jsr-designer-zoom:hover {\n\topacity: 1;\n}\n\n.jsr-designer-zoom > div {\n\tdisplay: inline-block;\n\twidth: 28px;\n\theight: 24px;\n\tfont-size: 20px;\n\tfont-weight: bold;\n\tline-height: 24px;\n\ttext-align: center;\n\tcolor: #aaa;\n\tbackground: #f0f0f0;\n\ttransition: background 0.2s, color 0.2s;\n\tcursor: pointer;\n\tborder-right: 1px solid #ddd;\n}\n\n.jsr-designer-zoom > div:last-child {\n\tborder-right: none;\n}\n\n.jsr-designer-zoom > div:hover {\n\tcolor: black;\n\tbackground: white;\n}\n\n.jsr-zoom-min .jsr-designer-zoom .jsr-designer-zoom-out,\n.jsr-zoom-min .jsr-designer-zoom .jsr-designer-zoom-out:hover,\n.jsr-zoom-max .jsr-designer-zoom .jsr-designer-zoom-in,\n.jsr-zoom-max .jsr-designer-zoom .jsr-designer-zoom-in:hover {\n\tcursor: default;\n\tcolor: #aaa;\n\tbackground: #f0f0f0;\n}\n", ""]);

	// exports


/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA6CAMAAADr99t8AAAAP1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACzJYIvAAAAFHRSTlMAB4bLzYcR56uzioF2YTXd0VFEJue46nIAAACYSURBVEjH3dC7DsMwCIVhCODWaZLeeP9n7dCBwRY5ijw0/edPBwn6Vpb7yrRXubi7MKDCZSpcrsLlKnccKnOrO+KqQ25zzE2gs8N7OtjJnzg9pTPUHb776Lpb4yphrnQUS8MYUguk5o7SVkFbNlBNHaWQkoFKf1TJmT9BT0hRhRS9UhVdARUuVOJCZS4U4IwIcDPtt9mbkj4NnUQbZ+rXAwAAAABJRU5ErkJggg=="

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAIAAACRuyQOAAAAsUlEQVRIib3Vuw2DQBgDYCcMkiorJFIWYsTswApULIJokBCng/sf9rm29MmVH+PvD3OmZbaXizz7MJ/X2yolGRg35RmTRGHaEotpSETmTuIylxKdqUsKpiKJmFLSMSdJyhySmtmlDgyAYV2/HRi4XiPDTMsclLwMYpsCTESKMW4pzPikDOOQkoxVyjMmicK0JRbTkIjMncRlLiU6U5cUTEUSMaWkY06SlDkkNbNLHRgAG/eJadIiQQ4UAAAAAElFTkSuQmCC"

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJUSURBVHhe7ZoxqE5hGMc/kpKUJIsYJDIoKRYlWWyyKhZJidUgiyyKsskiWSwGRUnqDgwWA4NBGZTBYrCIJOH3v/d76nE6x/3Od6/uc/j/6tf5zrnvOed5//f93u+9534jY4wxxhhjjDHGGGOMMWZpWDbeLpSf461YrGuWZPl4aybEgfXEgfXEgfXEgfXkfwjsMF6Ze1kHLSvCSqzB96i6SoVWNbDrGHU91oEqVAxsP0ZNn3ELlqFaYCvxNUZN57EU1QK7iFHPK1yBpagU2E78jqrlB+7DclQJTMukZxi13MCSVAnsDEYdH3AtlqRCYJtRn4ZRx0ksS4XA7mPU8FQHKrPUgR3DuP833IGlmTawc6hJ+sDs3nSsR81Xcf9LWJ5pAlNY+bwZ3It9uYlxjTe4CsuTOz4JzbCy91BrqUk4hPncgzgIctHzcRpz+za14LyLW7GL1fgW45w7OBhyZ//ECVQY0fYJbsfbGKvzrI7dwk3Y5DJGu0+4EQdD7mQXzbBeYF5YajR1BfcV9ahmA4o9mNudxUGRO9fGccxhaXJeh21oxOntmNuHWphexZfp2HMs98f1fORONTmCWhvFz/UEtO0t1kQTf1dwoUbZLhwcuROZZlhaL23DPii4B5jvEV7DQZI7ETTD+oi7cVq0RnuIcb13qE/KQRKdkMEXjGOae/TIeDFQcI9Qv5DB0hZY7GuU6V9dJtEVmCbso7N75je6Ajs199I0aQvswnj7T+Ev1PXEX0bpyd8YYZVZcH89wnriwIwxxhhjjDHGGGOMMcaYITAa/QI2mvXxDLm/KAAAAABJRU5ErkJggg=="

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFjSURBVHhe7dnBKgVRAMbxISGKLEheQNnbYmMjLyArD+EJ7Gw9gEfBiiRlwdYj2NlY8J066nQbM/Np7syZ5v+rf6cw170fumoKAAAAAAAAAAAwCDPxbNt3PPvW+uubjScaYjATg5kYzNTVYF/qWu2rLbWk1tS2OlMvqs67Olc7al0tqk21qy7Vpxqs8C6ZdqKqLKsHNXndb88qfE2VYzV53WCkT/omfKCBA5VelxY+10T4Xul1reviT/IunnVe41nmNp513uI5NdP6x/W//vqtyOZ58i5pYjATg5kYzMRgJgYzMZiJwUwMZmIwE4OZGMzEYCYGMzGYicFMDGZiMBODmXIabCWeWctpsKr7jqvx7F1Og+3Fs8xRPBGFH9yjSm/Cpj2pOQUJY12osqHSrtS8Gq0FdajuVdlAZYW746dqQ43KhyobxCk8Ruf6ugUfXnAbOn/+Ob1LAgAAAAAAAABGpCh+ACzlWueLYilyAAAAAElFTkSuQmCC"

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACrSURBVHhe7dhBCsJAEADB6P//rAgRQsjBhklUqLrsbZg0bA67AAAAAAAAAJzstp4THuu5NTm/OG2X6WDbeUdLX2m/y8i33teTDwkWTV/Jvcn5xV/8w162i34r1tspu7iSkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWDR5KuoJ+roteR23tHSV9rvMvKtrmQkWDR9Jfcm5xe/tAsAAAAAAABAsCxPs28QMv4y8jcAAAAASUVORK5CYII="

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALZSURBVHhe7ZlNqE1RGIYPA0RhgomL8lMoA4XUHZjIgAkpMwMzmZKBiRLKQEood6JkYGhgZkBSMpAJBgbyM/EzoRQS3vfs9Wm173eOe85e+2fxPvW01l737HW/8+211t57nZ4QQgghhBBCCCGEEEIIIbJgViir8iuUXafy950dSjFDlLARqWNKpuozFUlj0wgbkToTxis7yKfwvyZOhhG3lf0K58ImiP9vZepcw4YF+A3OK6ojswPugyvhQ3gWDsOLbWzaStgzuLGouqyBm+AKuBh+ga/hAbgXfoCX4YNQfwH5GY+kCUsFgzKNuK3saejBNfUQvATvQybBO9/zFbwKyxci/kxn8IKK22JfwgXQg6PpKHwOvXPNN5CjbTNcBZeGcjvcD+P+4/M6gxdU3Ga+h1uhx0H4CXJU3YE34Xfo9UOZtN3wb8TndAYvqLiNSbgGl0GPc/A23APnwF3wI4z7MI/DU5DJ5/FFOOzxKD63M3hBcXpxinDaMAmDWAe3FdU+HGkcWXz0uAJ3wh/Q+j8JCafdMchReZ0NA/Bia51UQW2BTA4X/LVsAFzE2e8jyOTchTETkHfLI/2j6aSKLSmpgroHDxfVP1jCOLIeQ07FMhzBFyAX/zKpYktKiqD4pTmFy1jCuK7dCnWOqjJcx3inLJMituTUGdRCyH6ZpPOhzuTNlKSx5bBb8RnyzYBT8S0bwLC3hFrJIWHkDOT7J++cZHUoGyeXhN0IpbE8lI2TS8IMuwtyXWuF3BJmLApl4+SWsCWhbGrzcRq5Jay1RBm5Jay1xwkjt4RtCKX3etQIdW5Rp4Z3yHdFtb+XPwW5ppn8e3w8H5KksXU5YXwv5A8ek3A95MPqoP00D4ujiYs5MgzKrAKTdAI+gXGf42h4ba1TNShuW3Mn4ieM+6qi4bWNTZenZCqSxpbrk35r1DHCuoxGWNMoYUIIIYQQQgghhBBCCCGE+Afp9X4DLigLMKWpcLcAAAAASUVORK5CYII="

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC/SURBVHhe7dDRScRAFEDRYduxCZvYfmzCJmzCKmzCJnQe2cB+emF/XM6BRybJZAJ3AQAAAADAc/jZ83Is19eez2O5PvbMu5m3ebB975nn49x379x/zv1Z8+2Ys16P5bruOffOv8f7nrl/mMvtyh8JFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCQYAAAAAAP/BWr/WUBRP2F+3ZQAAAABJRU5ErkJggg=="

/***/ },
/* 58 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD/SURBVHhe7dy9SsNQGIDh6G3p6CK4er+66ugF2ZSki0Pxhfxw4HngI6ddDrxtU0pKJgAY2eN6HM7LPF/L8lA/87wvyzE8zfMxz+86R7vte32xXq9PbOlhPW7pb6Q99rhn1/2H/byfRbBIsEiwSLBIsEiwSLBIsEiwSLBIsEiwSLBIsEiwSLBIsEiwSLBIsEiw6IjLbGdzme1MgkWCAfBvt/9i3Yz2OPMtCYzMj+/IST8SLBIsOuIctsce9+y6v3dYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYJFgkWCRYtEew53k+l+Wpvud5W5ZjcDusQTjNALCFaboA9IQq3Z6FRIQAAAAASUVORK5CYII="

/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADESURBVHhe7djRCoJQEEVR7f//2RAUhAw6oXdGWOtFego3zDQ0AQAAAABAjXl73mHZnvt37J9HueXdXtuTHwkWEiwkWKhs6S/Ltb8B8/zxKpZ+B4KFykZyACPZgWAhwUKChcqW/vEOO95Q/9xnJzfYytLvQLBQ2UgOYCQ7ECwkWEiwUNnSv+oO+3KDrSz9DgQLlY3kAEayA8FCgoUEC5Ut/Sv/D1ud3GOWfgeChcpGcgAj2YFgIcFCgoUEAwAAAACAJ5imN2UXJ0QZabXOAAAAAElFTkSuQmCC"

/***/ },
/* 60 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAJtSURBVHhe7do7axRRGMbx9RLvIAgqKRQLFVFsRD+AlSJYSiohXQobG7+AIDZWfgArO2sL4wUFg2BhqqCIN5SQQohREAULfZ7Nu7AM7+zO7GaOc948P/hzssUMOcNhduYkHRERERERERERERERycIGG1P5a2NVv9A39AN9Rq/QffQcrQu8YGvRG3QJhedNfpy42naisLxJj9s82oOSaMs97KuN/bhydqz+ONRddHn1x1iKq6PXIPvRDPqAvGN7nUbheBNlVXDFPUPe8ew2CsebKKvqMPqNvHM8ReF4E2V1vEDeOd6hxm20MSffbSziw23jcrxgW20s0gorsc/Gosc2huLde1hVJ5F3/E+U7OE1JW+yrAo+VpTd8K+jkLzJsmEOoifIO5aPE9tREm15NTprYz+uqEPoHLqANqGiWTSFVrqfAiqujlHjHtlVlOOXVi3e5Ov2CJ1A64J3AUbtNbqGkt2//gdv4uP2BZ1CSbTlpn/Pxn5b0C7E56tjaNBK4j3tPHrZ/RRIcXX0GoavQ/w2XEDe8WwRce8sFG+irKrN6A7yzsFuolC8SbI6eNF4w/fOs4RC8SbJ6rqCvPOwRh85cn3w4ztlmeM2NiLXCzZo72uvjY3I9YKVbSLSNhsbkesFm7TR0+jOa64XbNpGzycbQ/C+1VgdRxF3WL3zfESheJNkVR1BfHf0zsFuoFC8SbJB+KB6Bt1CZSuLvUWN71y0+Z9RaALtRsN+T758X0Rz3U+BFFfFWrSMkm3vpOZNeJweoAMoLG/So8T/deV2T3JtuYeV+YP4FyH2HvEd8qGNIiIiIiIiIiIiIpKxTucfj/Wni+c/mFIAAAAASUVORK5CYII="

/***/ },
/* 62 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGtSURBVHhe7dqxLgVBFMbxS4KOTkWnoqIRnSfwBDrv42k8BxUVlY5GdCg4Z2c21s3ZlVXsfGP/v+TLjER1MnNmdu8uAAAAAAAAAAAARtq2fI7MrWVSq3lUsJ/HMWZdsIM8jnGXx8mwwkZayaOCLctGmjbjg2Wt+evbheUqTRsvlvc0nbcjS9Tk9yxFKW3Jrmh7vlnu07Qc1YL5Clt2k8eiairYdR6LqmlLTn6FqMWuJWr4JxYEzixRwdorR1GKWzK68fudzE/J4hQLdpjHLomG72pZYTT8Ht6nov7lfQ0BPwmjgvnJKUFtS0YX1mfLY5qWp1Yw+QurWsGihj/5O68hagWTvlKo8XddUcOP+loxSissWl1+u2dL9pB+JGqprzC5/qVUMNm3rF0qBdu07KTpD1L9S8mpJToh/fMBKSorLGr4/kj0lKY6VApWzYVVpWBVNHynUDB/BxY9dLPCevgjUfQDh+Rb1hIFW7f46dfm2LLsw/Jqaf/HP1SZrXNLdIUYyqVFQokVFl0hfiNzgS1RsL98ODfrX438k6Vo2w3FH50AAAAAAAAAAP/IYvEFL3RyrTGO1RcAAAAASUVORK5CYII="

/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGRSURBVHhe7dlPKwVxFIfxSyIpWdnYiKIsWCEbCxtvwtYbUBbeAhsb5TVY2shG2VrYWUuyoeRPFqT4njpTv27KPcPMvTPzfOrplMzUnGbm1r0tAAAAAAAAAADq70B9Jf3VkcrOdW9/KEO/T3SIhQWxsCAWFsTCglhYEAsLYmFBLCyIhQWxsCAWFsTCglhYEAsLYmFBLCyIhQVVeWFDPs2Dz8KVubB3n5lRn3mlx7efuzBlLuzFZ2bcZ17p8c8+C1fmwtofmzmfeU37NLV8JC99ZhZ95jGr0nfYuc9asQtMf5e8VgMqjx2VnmtB1dKxSi90U0WNqBuVneNK1da6Shf2qmZUxJ5Kz7Gtau1MpRd8p1bVb+zOOlTpsfZYj6lam1RvKr1w60RtqAk1rIxNuwO31K1K//9DLalGWFF2Z6ULiPSo1lSjTKn2D4FOOlXzqrHssdpVF+pT/bQk+yTcV8uqq/p89opBZS/x7EX+5Nn7ClVU1B1mj1Ev+Pfrq/L3YV3BwoJYGAAAAAAAAAAAVdBqfQO8ZWiqNQLJpgAAAABJRU5ErkJggg=="

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACCSURBVHhe7dkxCoAwEEXB6P3vrE2wMpAP0VWYabbOq3ZJAwAAAACAGlufqxx9Vlv9rsveJ5MECwkWEiwkGACM/PE0euzsmWGtCAkWEiwkWEgwABj58mlUegKNWCtCgoUECwkWEgwARv74a3TntTPKWhESLCRYSLCQYAAAAAAAlGjtBOKjBC35E9H/AAAAAElFTkSuQmCC"

/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACISURBVHhe7doxCsQwDEVBZ+9/56RxtSDIB9lOMdOojV5lQQYAAAAAAJxxzdnlnvNr2vb8zclLgoUECwkWEgwAKt2nUWXXybR8H8+KkGAhwUKChQQDgMqu0+hf16m0/fs9K0KChQQLCRYSDAAqK0+L0z/XLdnNsyIkWEiwkGAhwQAAAAAAOGKMB5aLBC2R5MVvAAAAAElFTkSuQmCC"

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB+SURBVHhe7doxDsAgDARBkv//OWloLXESxClmGtdsdxIDAAAAAAB6XPOe8szbbds773lZJFhIsJBgIcEAoHJ6Gq34Yj6ZRl0ECwkWEiwkGABU/jCNKjsnk2nURbCQYCHBQoIBQOXradT1wc406iJYSLCQYCHBAAAAAABoMcYLMqMELTXEbr4AAAAASUVORK5CYII="

/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAHWlUWHRDb21tZW50AAAAAABDcmVhdGVkIHdpdGggR0lNUGQuZQcAAACeSURBVGje7dQxDgFBGEDhl3WKVbmAQrOcgANTrFsoHECUlChoaGwiE8YqmFl5XzLV5P3JZJIfJEmSJEnSX6mAGjgCB2AODLvST4EzcA3OCRjn3hfA5kncnFXmPaNI3JxBTn0RDChbfHE/cvfzPnzAvsWAXeQudU8P2Ea+b/1meOoegBlwebEFJh3o4b6ulg97ePHhHk/dS5IkSZK+7gbL1InPZTbgVwAAAABJRU5ErkJggg=="

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(74);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./ditto-report-reset.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./ditto-report-reset.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".jsr-report, \n.jsr-report div, .jsr-report span, \n.jsr-report a, \n.jsr-report img, \n.jsr-report table, .jsr-report th, .jsr-report td,\n.jsr-report canvas, \n.jsr-report footer, .jsr-report header {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-size: 100%;\n    font-family: inherit;\n    vertical-align: baseline;\n}\n.jsr-report {\n    font-family: Roboto, Helvetica, sans-serif;\n}\n.jsr-report {\n    line-height: normal;\n}\n/* HTML5 display-role reset for older browsers */\n.jsr-report footer, .jsr-report header {\n    display: block;\n}\n.jsr-report table {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n.jsr-report th, .jsr-report td {\n    font-size: inherit;\n}", ""]);

	// exports


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.1.20160328
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */

	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /Version\/[\d\.]+.*Safari/.test(navigator.userAgent)
			, webkit_req_fs = view.webkitRequestFileSystem
			, req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			, fs_min_size = 0
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				/* // Take note W3C:
				var
				  uri = typeof file === "string" ? file : file.toURL()
				, revoker = function(evt) {
					// idealy DownloadFinishedEvent.data would be the URL requested
					if (evt.data === uri) {
						if (typeof file === "string") { // file is an object URL
							get_URL().revokeObjectURL(file);
						} else { // file is a File
							file.remove();
						}
					}
				}
				;
				view.addEventListener("downloadfinished", revoker);
				*/
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob(["\ufeff", blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, blob_changed = false
					, object_url
					, target_view
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if (target_view && is_safari && typeof FileReader !== "undefined") {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var base64Data = reader.result;
								target_view.location.href = "data:attachment/file" + base64Data.slice(base64Data.search(/[,;]/));
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (blob_changed || !object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (target_view) {
							target_view.location.href = object_url;
						} else {
							var new_tab = view.open(object_url, "_blank");
							if (new_tab === undefined && is_safari) {
								//Apple do not allow window.open, see http://bit.ly/1kZffRI
								view.location.href = object_url
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
					, abortable = function(func) {
						return function() {
							if (filesaver.readyState !== filesaver.DONE) {
								return func.apply(this, arguments);
							}
						};
					}
					, create_if_not_found = {create: true, exclusive: false}
					, slice
				;
				filesaver.readyState = filesaver.INIT;
				if (!name) {
					name = "download";
				}
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
				// Object and web filesystem URLs have a problem saving in Google Chrome when
				// viewed in a tab, so I force save with application/octet-stream
				// http://code.google.com/p/chromium/issues/detail?id=91158
				// Update: Google errantly closed 91158, I submitted it again:
				// https://code.google.com/p/chromium/issues/detail?id=389642
				if (view.chrome && type && type !== force_saveable_type) {
					slice = blob.slice || blob.webkitSlice;
					blob = slice.call(blob, 0, blob.size, force_saveable_type);
					blob_changed = true;
				}
				// Since I can't be sure that the guessed media type will trigger a download
				// in WebKit, I append .download to the filename.
				// https://bugs.webkit.org/show_bug.cgi?id=65440
				if (webkit_req_fs && name !== "download") {
					name += ".download";
				}
				if (type === force_saveable_type || webkit_req_fs) {
					target_view = view;
				}
				if (!req_fs) {
					fs_error();
					return;
				}
				fs_min_size += blob.size;
				req_fs(view.TEMPORARY, fs_min_size, abortable(function(fs) {
					fs.root.getDirectory("saved", create_if_not_found, abortable(function(dir) {
						var save = function() {
							dir.getFile(name, create_if_not_found, abortable(function(file) {
								file.createWriter(abortable(function(writer) {
									writer.onwriteend = function(event) {
										target_view.location.href = file.toURL();
										filesaver.readyState = filesaver.DONE;
										dispatch(filesaver, "writeend", event);
										revoke(file);
									};
									writer.onerror = function() {
										var error = writer.error;
										if (error.code !== error.ABORT_ERR) {
											fs_error();
										}
									};
									"writestart progress write abort".split(" ").forEach(function(event) {
										writer["on" + event] = filesaver["on" + event];
									});
									writer.write(blob);
									filesaver.abort = function() {
										writer.abort();
										filesaver.readyState = filesaver.DONE;
									};
									filesaver.readyState = filesaver.WRITING;
								}), fs_error);
							}), fs_error);
						};
						dir.getFile(name, {create: false}, abortable(function(file) {
							// delete file if it already exists
							file.remove();
							save();
						}), abortable(function(ex) {
							if (ex.code === ex.NOT_FOUND_ERR) {
								save();
							} else {
								fs_error();
							}
						}));
					}), fs_error);
				}), fs_error);
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name, no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name || "download");
			};
		}

		FS_proto.abort = function() {
			var filesaver = this;
			filesaver.readyState = filesaver.DONE;
			dispatch(filesaver, "abort");
		};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;

		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;

		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window

	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(76) !== null) && (__webpack_require__(77) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },
/* 76 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 77 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;

	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _ReportElement = __webpack_require__(2);

	__webpack_require__(79);

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	/** 
	 * @name ditto
	 * @namespace
	 */
	var ditto = __webpack_require__(12);


	module.exports = function (window, saveAs, $) {

	    ditto.window = window;

	    var moment = __webpack_require__(81);
	    var dimple = __webpack_require__(183);
	    var Parser = __webpack_require__(185).Parser;
	    __webpack_require__(186)($);
	    var SSF = __webpack_require__(187);
	    var accounting = __webpack_require__(188);
	    var jsep = __webpack_require__(189);
	    var jsPDF = __webpack_require__(190)(window, saveAs, ditto);
	    __webpack_require__(214)(jsPDF);
	    __webpack_require__(215)(jsPDF, $, ditto);
	    __webpack_require__(216)(window);
	    __webpack_require__(217)(window);
	    var ExcelBuilder = __webpack_require__(218);
	    var ExcelDrawings = __webpack_require__(269);
	    var ExcelDrawingsPicture = __webpack_require__(270);
	    var ExcelPositioning = __webpack_require__(275);
	    ditto.key = __webpack_require__(276)(window);
	    var QRCode = __webpack_require__(277)(window);
	    var Papa = __webpack_require__(278);
	    var textFit = __webpack_require__(279);
	    var Downloadify = __webpack_require__(280)(window);
	    var _ = __webpack_require__(3);
	    var showdown = __webpack_require__(282);
	    __webpack_require__(283)($);
	    __webpack_require__(284)(ditto, $);

	    var customFonts = {};
	    var extraFontReferences = {};
	    var viewerId = 0;
	    var DEFAULT_CHART_ANIMATION_MS = 2000;
	    var DEFAULT_DATE_PARSE_FORMAT = 'YYYY-MM-DD';

	    var AGGREGATE_NAMES = ['sum', 'average', 'min', 'max', 'count', 'median', 'countdistinct', 'sumdistinct'];
	    var AGGREGATE_REGEX = new RegExp('^(' + AGGREGATE_NAMES.join('|') + ')\\((.*)\\)$', 'i');
	    var UNQUOTED_AGGREGATE_FIELDNAME_REGEX = new RegExp('(' + AGGREGATE_NAMES.join('|') + ')\\((\\w*)\\)', 'gi');

	    var productName = /*PRODUCT_NAME ||*/'jsreports';

	    function requireOneOf(val, options, paramDesc) {
	        if (options.indexOf(val) < 0) {
	            throw new Error(paramDesc + ' must be one of: ', options.map(function (opt) {
	                return '"' + opt + '"';
	            }).join(', '));
	        }
	    }

	    function inferLibraryPath() {
	        var path = $('script[src*=ditto]').attr('src');
	        if (path) {
	            path = path.replace(/ditto[^\/]+$/gi, '');
	            if (path.length > 0 && path.substr(path.length - 1, 1) === '/') {
	                path = path.substr(0, path.length - 1);
	            }
	        }
	        return path;
	    }

	    /**
	     * @property libraryPath
	     * @memberof ditto
	     * @public
	     * The path to the ditto distribution on the server.  ditto uses this path to locate the /media and /fonts directories
	     * when needed.  ditto can function without a valid libraryPath, but some features will not be available, such as the default
	     * Roboto font in PDF output and IE9 file download support.
	     */
	    ditto.libraryPath = inferLibraryPath();

	    function registerDefaultFonts() {
	        ditto.registerFont('Roboto', ditto.libraryPath + '/fonts/Roboto-Regular.ttf');
	        ditto.registerFont('Roboto', 'bold', ditto.libraryPath + '/fonts/Roboto-Bold.ttf');
	        ditto.registerFont('Roboto', 'normal', 'italic', ditto.libraryPath + '/fonts/Roboto-Italic.ttf');
	        ditto.registerFont('Roboto', 'bold', 'italic', ditto.libraryPath + '/fonts/Roboto-BoldItalic.ttf');
	    }

	    ditto.data = function () {

	        function some(arr, fn) {
	            for (var i = 0; i < arr.length; i++) {
	                if (fn(arr[i])) {
	                    return true;
	                }
	            }
	            return false;
	        }

	        function assign(target) {
	            var to = Object(target);
	            for (var i = 1; i < arguments.length; i++) {
	                var nextSource = arguments[i];
	                if (nextSource === undefined || nextSource === null) {
	                    continue;
	                }
	                nextSource = Object(nextSource);
	                var keysArray = Object.keys(Object(nextSource));
	                for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	                    var nextKey = keysArray[nextIndex];
	                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                    if (desc !== undefined && desc.enumerable) {
	                        to[nextKey] = nextSource[nextKey];
	                    }
	                }
	            }
	            return to;
	        }

	        function baseCompareAscending(value, other) {
	            if (value !== other) {
	                var valIsNull = value === null,
	                    valIsUndef = value === undefined,
	                    valIsReflexive = value === value;

	                var othIsNull = other === null,
	                    othIsUndef = other === undefined,
	                    othIsReflexive = other === other;

	                if (value > other && !othIsNull || !valIsReflexive || valIsNull && !othIsUndef && othIsReflexive || valIsUndef && othIsReflexive) {
	                    return 1;
	                }
	                if (value < other && !valIsNull || !othIsReflexive || othIsNull && !valIsUndef && valIsReflexive || othIsUndef && valIsReflexive) {
	                    return -1;
	                }
	            }
	            return 0;
	        }

	        var sortBy = function sortBy(arr, accessor) {
	            arr.sort(function (a, b) {
	                return baseCompareAscending(accessor(a), accessor(b));
	            });
	            return arr;
	        };

	        var yieldRightSubList = function yieldRightSubList(sortedList, accessor) {
	            var r, datum, val, tmpVal, i;
	            if (sortedList.length > 0) {
	                val = accessor(datum = sortedList.pop());
	                r = [datum];
	                i = sortedList.length;
	                while (i--) {
	                    tmpVal = accessor(sortedList[i]);
	                    if (val <= tmpVal && val >= tmpVal) {
	                        r.unshift(sortedList.pop());
	                    } else {
	                        break;
	                    }
	                }
	            }
	            return r ? { r: r, val: val } : r;
	        };

	        /**
	         * From a sorted list, yield a subList where the accessor values are the same.
	         * @param  {Array<Object>} sortedList
	         * @param  {AccessorFunction} accessor
	         * @yield  {SubList}
	         * @returns {undefined}
	         */
	        var yieldRightSubList2 = regeneratorRuntime.mark(function yieldRightSubList2(sortedList, accessor) {
	            var i, r, _val, tmpVal;

	            return regeneratorRuntime.wrap(function yieldRightSubList2$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(sortedList.length === 1)) {
	                                _context.next = 5;
	                                break;
	                            }

	                            _context.next = 3;
	                            return { r: sortedList, val: accessor(sortedList[sortedList.length - 1]) };

	                        case 3:
	                            _context.next = 21;
	                            break;

	                        case 5:
	                            if (!(sortedList.length > 1)) {
	                                _context.next = 21;
	                                break;
	                            }

	                            i = sortedList.length, r = [sortedList[--i]], _val = accessor(r[0]);
	                            // for each subsequent value, we'll yield when there is a
	                            // new tmpVal that is not equal the current val

	                        case 7:
	                            if (!i--) {
	                                _context.next = 19;
	                                break;
	                            }

	                            tmpVal = accessor(sortedList[i]);

	                            if (!(_val <= tmpVal && _val >= tmpVal)) {
	                                _context.next = 13;
	                                break;
	                            }

	                            r.unshift(sortedList[i]);
	                            _context.next = 17;
	                            break;

	                        case 13:
	                            _context.next = 15;
	                            return { r: r, val: _val };

	                        case 15:
	                            r = [sortedList[i]];
	                            _val = tmpVal;

	                        case 17:
	                            _context.next = 7;
	                            break;

	                        case 19:
	                            _context.next = 21;
	                            return { r: r, val: _val };

	                        case 21:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, yieldRightSubList2, this);
	        });

	        function reduceRight(array, iteratee, accumulator, initFromArray) {
	            var length = array.length;
	            if (initFromArray && length) {
	                accumulator = array[--length];
	            }
	            while (length--) {
	                accumulator = iteratee(accumulator, array[length], length, array);
	            }
	            return accumulator;
	        }

	        /**
	         * Merge two lists into one
	         * @param {Array<Object>} aDatumsR
	         * @param {Array<Object>} bDatumsR
	         * @returns {Array<Object>}
	         */
	        function mergeLists2(aDatumsR, bDatumsR) {
	            return reduceRight(aDatumsR, function (previous, datum) {
	                return reduceRight(bDatumsR, function (prev, cDatum) {
	                    prev.unshift(assign({}, datum, cDatum));
	                    return prev;
	                }, []).concat(previous);
	            }, []);
	        }

	        var sortedMergeLeftOuterJoin = function sortedMergeLeftOuterJoin(a, aAccessor, b, bAccessor) {
	            if (a.length < 1 || b.length < 1) {
	                return a;
	            }
	            var aSorted = sortBy(a, aAccessor),
	                bSorted = sortBy(b, bAccessor),
	                aGenerator = yieldRightSubList2(aSorted, aAccessor),
	                bGenerator = yieldRightSubList2(bSorted, bAccessor);
	            var r = [],
	                aDatums = aGenerator.next().value,
	                bDatums = bGenerator.next().value;
	            while (aDatums && bDatums) {
	                if (aDatums.val > bDatums.val) {
	                    r = aDatums.r.concat(r);
	                    aDatums = aGenerator.next().value;
	                } else if (aDatums.val < bDatums.val) {
	                    bDatums = bGenerator.next().value;
	                } else {
	                    r = mergeLists2(aDatums.r, bDatums.r).concat(r);
	                    aDatums = aGenerator.next().value;
	                    bDatums = bGenerator.next().value;
	                }
	            }
	            while (aDatums) {
	                r = aDatums.r.concat(r);
	                aDatums = aGenerator.next().value;
	            }
	            return r;
	        };

	        // var sortedMergeLeftOuterJoin = function (a, aAccessor, b, bAccessor) {
	        //     if (a.length < 1 || b.length < 1) {
	        //         return [];
	        //     }
	        //     var rreduce = Array.reduceRight ? function(array, iteratee, acc) {
	        //         return array.reduceRight(iteratee, acc);
	        //     } : reduceRight;
	        //     var assign = Object.assign || assign;
	        //     a = sortBy(a, aAccessor);
	        //     b = sortBy(b, bAccessor);
	        //     var r = [],
	        //         aDatums = yieldRightSubList(a, aAccessor),
	        //         bDatums = yieldRightSubList(b, bAccessor);
	        //     while (aDatums && bDatums) {
	        //         if (aDatums.val > bDatums.val) {
	        //             r = aDatums.r.concat(r);
	        //             aDatums = yieldRightSubList(a, aAccessor);
	        //         } else if (aDatums.val < bDatums.val) {
	        //             bDatums = yieldRightSubList(b, bAccessor);
	        //         } else {
	        //             r = rreduce(aDatums.r, function (orevious, datum) {
	        //                 return rreduce(bDatums.r, function (prev, cDatum) {
	        //                     prev.unshift(assign({}, datum, cDatum));
	        //                     return prev;
	        //                 }, []).concat(orevious);
	        //             }, []).concat(r);
	        //             aDatums = yieldRightSubList(a, aAccessor);
	        //             bDatums = yieldRightSubList(b, bAccessor);
	        //         }
	        //     }
	        //     if (aDatums) {
	        //         r = aDatums.r.concat(r);
	        //     }
	        //     return a.concat(r);
	        // };

	        // const simpleLeftJoin = (left, leftKey, right, rightKey) => {
	        //     let out = [];
	        //     left.map(lRow => {
	        //         const lkey = lRow[leftKey];
	        //         const rRows = right.filter(r => r[rightKey] === lkey);
	        //         if (rRows.length) {
	        //             out = out.concat(rRows.map(rRow => ({ ...lRow, ...rRow })));
	        //         } else {
	        //             out.push({ ...lRow });
	        //         }
	        //     });
	        //     return out;
	        // }

	        var sortedMergeInnerJoin = function sortedMergeInnerJoin(a, aAccessor, b, bAccessor) {
	            if (a.length < 1 || b.length < 1) {
	                return [];
	            }
	            var rreduce = Array.reduceRight ? function (array, iteratee, acc) {
	                return array.reduceRight(iteratee, acc);
	            } : reduceRight;
	            var assign = Object.assign || assign;
	            a = sortBy(a, aAccessor);
	            b = sortBy(b, bAccessor);
	            var r = [],
	                aDatums = yieldRightSubList(a, aAccessor),
	                bDatums = yieldRightSubList(b, bAccessor);
	            while (aDatums && bDatums) {
	                if (aDatums.val > bDatums.val) {
	                    aDatums = yieldRightSubList(a, aAccessor);
	                } else if (aDatums.val < bDatums.val) {
	                    bDatums = yieldRightSubList(b, bAccessor);
	                } else {
	                    r = rreduce(aDatums.r, function (orevious, datum) {
	                        return rreduce(bDatums.r, function (prev, cDatum) {
	                            prev.unshift(assign({}, datum, cDatum));
	                            return prev;
	                        }, []).concat(orevious);
	                    }, []).concat(r);
	                    aDatums = yieldRightSubList(a, aAccessor);
	                    bDatums = yieldRightSubList(b, bAccessor);
	                }
	            }
	            return r;
	        };

	        var extTypes = {
	            'auto': 'text',
	            'string': 'text',
	            'int': 'number',
	            'float': 'number',
	            'boolean': 'boolean',
	            'date': 'date'
	        };

	        var getFieldTypeFromValue = function getFieldTypeFromValue(val) {
	            return (typeof val === 'undefined' ? 'undefined' : _typeof(val)).toLowerCase();
	        };

	        /* Fills knownFields array with list of fields found on record */
	        var inferSchemaFromRecord = function inferSchemaFromRecord(record, knownFields, knownFieldsByLowercaseName) {
	            Object.keys(record).forEach(function (fieldName) {
	                var fieldNameLower = fieldName.toLowerCase();
	                var val = record[fieldName];
	                var valueType = getFieldTypeFromValue(val);
	                var field = knownFieldsByLowercaseName[fieldNameLower];
	                if (field) {
	                    if (!!field.type && valueType !== field.type) {
	                        console.warn('Warning: Expected ' + field.type + ' value for field "' + fieldName + '", got ' + valueType + ' instead: ' + val);
	                    }
	                } else {
	                    field = {
	                        name: fieldName,
	                        type: valueType
	                    };
	                    knownFields.push(field);
	                    knownFieldsByLowercaseName[fieldNameLower] = field;
	                }
	                switch (field.type) {
	                    case 'object':
	                    /* falls through */
	                    case 'array':
	                        if (val) {
	                            field.schema = Object.assign(field.schema || {}, inferSchema(Array.isArray(val) ? val : [val]));
	                        }
	                        break;
	                }
	            });
	        };

	        /** Infer basic schema info from dataset (a raw array of data rows). */
	        var inferSchema = function inferSchema(dataset) {
	            if (!Array.isArray(dataset)) {
	                console.error('Error: Could not infer schema for dataset.  Expected array, got ' + (typeof dataset === 'undefined' ? 'undefined' : _typeof(dataset)) + '.');
	                return null;
	            }
	            var fields = [];
	            var fieldLookup = {};
	            dataset.forEach(function (rec) {
	                return inferSchemaFromRecord(rec, fields, fieldLookup);
	            });
	            return {
	                fields: fields
	            };
	        };

	        return {

	            inferSchema: inferSchema,

	            /** 
	             * Build a hash index into a dataset (for use in linking subreports)
	             * @private
	             */
	            buildIndexOn: function buildIndexOn(dataset, fieldId) {
	                var index = {};
	                for (var i = 0, len = dataset.length; i < len; i++) {
	                    var row = dataset[i];
	                    var key = row[fieldId];
	                    var bucket = index[key];
	                    if (!bucket) {
	                        index[key] = bucket = [];
	                    }
	                    bucket[bucket.length] = row;
	                }
	                return index;
	            },

	            loadDatasets: function loadDatasets(datasetDefs, datasets, schemas, schemasOnly, done) {
	                var timeout = ditto.dataSourceTimeout !== undefined ? ditto.dataSourceTimeout : 30;

	                var runPostProcess = function runPostProcess(fn, origData, requiredDatasets, dsDef) {
	                    try {
	                        if (requiredDatasets) {
	                            return fn.apply(dsDef, requiredDatasets);
	                        } else {
	                            return fn(origData, dsDef);
	                        }
	                    } catch (e) {
	                        e.message = 'Error while executing postProcess function for data source "' + dsDef.id + '":\n ' + e.message;
	                        throw e;
	                    }
	                    throw 'Unexpected result from postProcess';
	                };

	                var coerceDates = function coerceDates(data, schema) {
	                };

	                var loading = [],
	                    schemasLoading = 0,
	                    joins = [],
	                    withDependencies = [],
	                    isDone = false;
	                var loaded = function loaded(def, data) {
	                    if (def.format && def.format.toLowerCase() === "csv") {
	                        data = data.data;
	                    }
	                    if (def.postProcess) {
	                        data = runPostProcess(def.postProcess, data, null, def);
	                    }
	                    datasets[def.id.toLowerCase()] = data;
	                    var ix = loading.indexOf(def);
	                    loading.splice(ix, 1);
	                    setTimeout(checkProgress, 0);
	                };
	                var tryResolveDependencies = function tryResolveDependencies() {
	                    var resolved = 0;
	                    var unresolved = [];
	                    withDependencies.forEach(function (def) {
	                        if (!def.requires.find(function (dep) {
	                            return !datasets[dep.toLowerCase()];
	                        })) {
	                            var data = [];
	                            if (def.postProcess) {
	                                data = runPostProcess(def.postProcess, null, def.requires.map(function (dep) {
	                                    return datasets[dep.toLowerCase()];
	                                }), def);
	                            }
	                            datasets[def.id.toLowerCase()] = data;
	                            resolved++;
	                        } else {
	                            unresolved.push(def);
	                        }
	                    });
	                    withDependencies = unresolved;
	                };
	                datasetDefs.forEach(function (def) {
	                    var _this = this;

	                    if (!def.id) throw new Error('Dataset missing "id" property: ' + JSON.stringify(def));
	                    var idLower = def.id.toLowerCase();
	                    if (!datasets[idLower]) {
	                        if (def.join) {
	                            joins.push(def);
	                            return;
	                        }
	                        if (def.requires) {
	                            withDependencies.push(def);
	                            return;
	                        }
	                        /** Even if we only need schemas, if one is not provided we have to load the data to infer a schema */
	                        if (!schemasOnly || !def.schema && !def.schema_url) {
	                            if (def.data) {
	                                // "data" can be an async function that calls back with
	                                // the data when done
	                                if (typeof def.data === 'function') {
	                                    datasets[idLower] = -1;
	                                    loading.push(def);
	                                    def.data(function (data) {
	                                        loaded(def, data);
	                                    });
	                                } else {
	                                    loaded(def, def.data);
	                                }
	                            } else if (def.url) {
	                                datasets[idLower] = -1;
	                                loading.push(def);
	                                if (def.format && def.format.toLowerCase() === "csv") {
	                                    Papa.parse(def.url, {
	                                        download: true,
	                                        header: !!def.hasHeaderRow,
	                                        complete: loaded.bind(this, def),
	                                        error: function error() {
	                                            console.error('Error parsing CSV');
	                                        }
	                                    });
	                                } else {
	                                    $.getJSON(def.url, loaded.bind(this, def)).fail(function (d, status, err) {
	                                        throw new Error('Failed to load data source: ' + def.id + ' from ' + def.url + '.  Error was: ' + err);
	                                    });
	                                }
	                            } else if (def.extjsStore) {
	                                (function () {
	                                    var store = def.extjsStore;
	                                    var readStore = function readStore(store) {
	                                        return store.getData().items.map(function (rec) {
	                                            return rec.data;
	                                        });
	                                    };
	                                    if (store.isLoaded()) {
	                                        datasets[idLower] = readStore(store);
	                                    } else {
	                                        loading.push(def);
	                                        store.on('load', function () {
	                                            loaded(def, readStore(store));
	                                        }, _this, { single: true });
	                                        store.load();
	                                    }
	                                })();
	                            }
	                        }
	                        if (def.schema_url) {
	                            schemasLoading++;
	                            $.getJSON(def.schema_url, function (schema) {
	                                schemas[idLower] = schema;
	                                schemasLoading--;
	                                checkProgress();
	                            }).fail(function (d, status, err) {
	                                throw new Error('Failed to load schema for data source: ' + def.id + ' from ' + def.schema_url + '.  Error was: ' + err);
	                            });
	                        } else if (def.schema) {
	                            if (typeof def.schema === 'function') {
	                                schemasLoading++;
	                                def.schema(function (schema) {
	                                    schemas[idLower] = schema;
	                                    schemasLoading--;
	                                    checkProgress();
	                                });
	                            } else {
	                                schemas[idLower] = def.schema;
	                            }
	                        } else if (def.extjsStore) {
	                            var proxy = def.extjsStore.getProxy();
	                            if (!proxy) {
	                                throw new Error('Couldn\'t find proxy for ExtJS data store');
	                            }
	                            var model = proxy.getModel();
	                            if (!model) {
	                                throw new Error('Couldn\'t find model for ExtJS data store proxy');
	                            }
	                            var fields = model.getFields().map(function (field) {
	                                return {
	                                    name: field.getName(),
	                                    type: extTypes[field.type]
	                                };
	                            });
	                            schemas[idLower] = { fields: fields };
	                        }
	                    }
	                });
	                checkProgress();
	                if (timeout > 0) {
	                    (function () {
	                        var startTime = new Date();
	                        var timeoutMs = timeout * 1000;
	                        var timeoutInterval = setInterval(function () {
	                            if (new Date() - startTime > timeoutMs) {
	                                clearInterval(timeoutInterval);
	                                if (loading.length === 0) return;
	                                var failed = loading.map(function (ds) {
	                                    return ds.id || '[missing id]';
	                                }).join(', ');
	                                console.error('The following data source(s) failed to load within ' + timeout + ' seconds: ' + failed);
	                            }
	                        }, 1000);
	                    })();
	                }
	                function checkProgress() {
	                    if (isDone) return;
	                    if (loading.length === 0 && schemasLoading === 0) {
	                        tryResolveDependencies();
	                        Object.keys(datasets).forEach(function (dsIdLower) {
	                            var data = datasets[dsIdLower];
	                            // Wrap single root objects in array
	                            if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && !Array.isArray(data)) {
	                                datasets[dsIdLower] = [data];
	                            }
	                            if (!schemas[dsIdLower]) {
	                                schemas[dsIdLower] = inferSchema(datasets[dsIdLower]);
	                            }
	                        });
	                        processJoins(function () {
	                            // One more pass to resolve dependencies on joined datasets
	                            tryResolveDependencies();
	                            if (withDependencies.length > 0) {
	                                console.error('Error: the following data sources have unresolved dependencies: ' + withDependencies.map(function (ds) {
	                                    return ds.id;
	                                }).join(', '));
	                            }
	                            isDone = true;
	                            done();
	                        });
	                    }
	                }
	                function processJoins(callback) {
	                    if (!joins || joins.length === 0) return callback();
	                    joins.sort(function (a, b) {
	                        return (a.joinOrder || 0) - (b.joinOrder || 0);
	                    });
	                    joins.forEach(function (dsDef) {
	                        var joinDef = dsDef.join;
	                        ['left', 'right', 'leftKey', 'rightKey'].forEach(function (requiredProp) {
	                            if (!joinDef[requiredProp]) {
	                                throw new Error("Joined data source " + dsDef.id + " missing required property: " + requiredProp);
	                            }
	                        });
	                        var algo = joinDef.type === "left" ? sortedMergeLeftOuterJoin : sortedMergeInnerJoin,
	                            left = (datasets[joinDef.left] || []).slice(0),
	                            right = (datasets[joinDef.right] || []).slice(0),
	                            leftKey = joinDef.leftKey,
	                            rightKey = joinDef.rightKey,
	                            leftAccessor = function leftAccessor(row) {
	                            return row[leftKey] || null;
	                        },
	                            rightAccessor = function rightAccessor(row) {
	                            return row[rightKey] || null;
	                        };
	                        function requireField(targetDsID, fieldName, thisDs) {
	                            if (!_.some(schemas[targetDsID.toLowerCase()].fields, function (field) {
	                                return field.name === fieldName;
	                            })) {
	                                throw new Error("Data source " + targetDsID + " does not have field " + fieldName + " required by join data source " + thisDs.id);
	                            }
	                        }
	                        requireField(joinDef.left, leftKey, dsDef);
	                        requireField(joinDef.right, rightKey, dsDef);
	                        var newSchema = {
	                            fields: $.extend([], schemas[joinDef.left].fields)
	                        };
	                        schemas[dsDef.id.toLowerCase()] = newSchema;
	                        var leftFields = {};
	                        newSchema.fields.forEach(function (field, index) {
	                            leftFields[field.name.toLowerCase()] = index;
	                        });
	                        schemas[joinDef.right.toLowerCase()].fields.forEach(function (rightField) {
	                            var index = leftFields[rightField.name.toLowerCase()];
	                            if (typeof index !== "undefined") {
	                                newSchema.fields.splice(index, 1);
	                            }
	                            newSchema.fields.push($.extend({}, rightField));
	                        });
	                        if (!schemasOnly) {
	                            var data = algo(left, leftAccessor, right, rightAccessor);
	                            if (dsDef.postProcess) {
	                                data = runPostProcess(dsDef.postProcess, data, null, dsDef);
	                            }
	                            datasets[dsDef.id.toLowerCase()] = data;
	                        }
	                    });
	                    callback();
	                }
	            }

	        };
	    }();

	    ditto.merge(ditto, function () {

	        var BATCH_RENDER_INTERVAL_MS = 250,
	            BATCH_RENDER_MIN_ROWS = 5,
	            EXPORT_FORMATS = {
	            "pdf": {
	                defaultExtension: "pdf"
	            },
	            "xlsx": {
	                defaultExtension: "xlsx"
	            }
	        },
	            DEFAULT_DATE_FORMAT = "m/d/yyyy",
	            EXCEL_WIDTH_UNITS_PER_PX = 0.18,
	            EXCEL_ROW_HEIGHT_MULTIPLIER = 6;
	        var EXCEL_RESOLUTION_PX = 10;

	        var datasets = {},
	            schemas = {},
	            indices = {},
	            $events = $({});

	        function clear_datasets() {
	            datasets = {};
	            schemas = {};
	            indices = {};
	        }
	        var nextSectionInstanceId = 1;

	        var printError = typeof console.error === 'function' ? console.error.bind(console) : function () {};
	        var warn = typeof console.warn === 'function' ? console.warn.bind(console) : function () {};
	        if (/PhantomJS/.test(window.navigator.userAgent)) {
	            printError = warn = console.log.bind(console);
	        }

	        // placeholder translation fn
	        var t = function t(s, data) {
	            return s.replace(/\{(\w*)\}/gi, function (match, g1) {
	                return data[g1] || '';
	            });
	        };

	        var jsepEval = function () {
	            var binops = {
	                "+": function _(a, b) {
	                    return a + b;
	                },
	                "-": function _(a, b) {
	                    return a - b;
	                },
	                "*": function _(a, b) {
	                    return a * b;
	                },
	                "/": function _(a, b) {
	                    return a / b;
	                },
	                "%": function _(a, b) {
	                    return a % b;
	                }
	            };
	            var unops = {
	                "-": function _(a) {
	                    return -a;
	                },
	                "+": function _(a) {
	                    return +a;
	                },
	                "!": function _(a) {
	                    return !a;
	                }
	            };

	            var do_eval = function do_eval(node, ctx) {
	                switch (node.type) {
	                    case "BinaryExpression":
	                        return binops[node.operator](do_eval(node.left, ctx), do_eval(node.right, ctx));
	                    case "UnaryExpression":
	                        return unops[node.operator](do_eval(node.argument, ctx));
	                    case 'Identifier':
	                        return ctx[node.name];
	                    case "Literal":
	                        return node.value;
	                }
	            };

	            var jsepCache = {};

	            return function (expr, ctx) {
	                var cached = jsepCache[expr];
	                if (!cached) {
	                    cached = jsepCache[expr] = jsep(expr);
	                }
	                return do_eval(cached, ctx);
	            };
	        }();

	        /**
	         * Initial render only
	         */
	        function render_report(def, $target, forceHideToolbar) {
	            var _this2 = this;

	            this.$target = $target;
	            var target = $target[0];
	            if (!this.isSubreport) {
	                nextSectionInstanceId = 1;
	                this.allSubreportViewers = [];
	                if ($target.css('position') !== "absolute") {
	                    target.style.position = 'relative';
	                }
	                this.targetWidth = $target.width();
	                this.rowStack = [];
	            }
	            target.innerHTML = '';
	            this.$target.addClass("jsr-report jsr-style-root");
	            // if (!this.$target.hasClass("jsr-export-target")) {
	            //  this.$target.css("overflow", "auto");
	            // }
	            // If using ditto to render across windows, point to the target window
	            var targetDoc = $target[0].ownerDocument;
	            var targetWin = targetDoc.defaultView || targetDoc.parentWindow;
	            if (ditto.window !== targetWin) {
	                ditto.window = targetWin;
	            }

	            this.elementTypes = {};
	            /** Get map of custom element types for lookup by ID */
	            _.values(ditto.elements).concat(this.customElements).forEach(function (elementClass) {
	                if (typeof elementClass !== 'function') return;
	                var className = elementClass.name;
	                _this2.elementTypes[(elementClass.typeId || className).toLowerCase()] = elementClass;
	            });

	            this.def = def;
	            this.parser = new Parser();
	            this.compiled_calculations = {};
	            this.compiled_js_expressions = {};
	            // this.pending_height_adjustments = [];
	            this.pending_text_fits = [];
	            this.linked_data_index_cache = {};
	            this.elt_id_counter = 1;
	            this.excel_styles_by_elt_id = {};
	            if (typeof this.imageUrlPrefix === "undefined") {
	                this.imageUrlPrefix = this.def.imageUrlPrefix || "";
	            }
	            if (this.showToolbar && !forceHideToolbar) {
	                this.$toolbar_el = $('<div class="ditto-report-toolbar"></div>');
	                $target.append(this.$toolbar_el);
	                render_inputs.call(this, def, this.$toolbar_el);
	                $events.trigger("toolbarRendered", [this, this.$toolbar_el[0]]);
	            }
	            var details = Array.isArray(def.body) ? def.body : [def.body];
	            var dsIdLower = (details[0].data_source || '').toLowerCase();
	            this.active_schema = getDetailSchema.call(this, details[0]);
	            var reportData = datasets[dsIdLower];
	            details.forEach(function (detail) {
	                var detailDataId = (detail.data_source || '').toLowerCase();
	                var detailData = datasets[detailDataId];
	                if (typeof detailData === "undefined" || !detailData) {
	                    throw new Error('Missing dataset with ID "' + detailDataId + '" required by report');
	                }
	            });
	            this.detail_sort_fn = get_detail_sort_fn.call(this, def, reportData, this.active_schema);
	            this.show_detail = def.body.show_detail !== false;
	            if (!this.isSubreport) {
	                this.$target.append($('<div class="jsr-content-viewport"><div class="ditto-report-content"></div></div>'));
	                var toolbar_height = this.showToolbar && !forceHideToolbar ? this.$target.find(".ditto-report-toolbar").outerHeight() : 0;
	                this.$target.find(".jsr-content-viewport").height(this.$target.height() - toolbar_height).css("top", toolbar_height + "px");
	            }
	            if (def.defaultFont) {
	                var defaultFontCss = def.defaultFont.css || def.defaultFont;
	                this.$target.css('font-family', defaultFontCss);
	            }
	            if (def.defaultFontSize !== undefined) {
	                var fontSize = Number(def.defaultFontSize);
	                if (!isNaN(fontSize)) {
	                    this.$target.css('font-size', fontSize + 'pt');
	                }
	            }
	            refresh_report.call(this);
	        }

	        function getDetailSchema(dataSection) {
	            var schema = schemas[(dataSection.data_source || '').toLowerCase()];
	            if (dataSection.sublevels) {
	                dataSection.sublevels.forEach(function (sublevel) {
	                    if (sublevel.data_source !== '__parentgroup') {
	                        schema = schemas[sublevel.data_source.toLowerCase()];
	                    }
	                });
	            }
	            return schema;
	        }

	        function generate_section_instance_id() {
	            return nextSectionInstanceId++;
	        }

	        function get_excel_blob(workbook) {
	            return new Blob([ExcelBuilder.createFile(workbook, { type: "arraybuffer" })], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
	        }

	        function get_excel_data_uri(workbook) {
	            return 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + ExcelBuilder.createFile(workbook);
	        }

	        /** Opens the given data URI in a new browser tab/window, or the current one if that's not supported (IE) */
	        function open_data_uri(data_uri) {
	            var win = ditto.window.open(data_uri);
	            if (win || typeof safari === "undefined") return win;
	            ditto.window.document.location.href = data_uri;
	        }

	        function download_excel_file(workbook, filename) {
	            if (navigator && navigator.getUserMedia) {
	                if (ditto.window.URL === undefined || ditto.window.URL.createObjectURL === undefined) {
	                    return open_data_uri(get_excel_data_uri(workbook));
	                }
	            }
	            saveAs(get_excel_blob(workbook), filename);
	            if (typeof saveAs.unload === 'function') {
	                if (ditto.window.setTimeout) {
	                    ditto.window.setTimeout(saveAs.unload, 911);
	                }
	            }
	        }

	        function refresh_report() {
	            delete this.fontScaleFactor;
	            if (!this.isSubreport) {
	                show_mask.call(this);
	            }
	            ditto.window.setTimeout(refresh_report_internal.bind(this), 0);
	        }

	        /**
	         * Expand the target element width as needed to fit generated pivot columns
	         */
	        function adjust_template_for_target(data) {
	            if (this.def.body.pivot_enabled && this.def.body.pivot_expression) {
	                // var $content_div = this.$target.find(".ditto-report-content");
	                var default_width = this.targetWidth || this.contentDomEl.offsetWidth;
	                this.pivot = true;
	                var simple_pivot_field = get_schema_field_from_single_field_expression.call(this, this.def.body.pivot_expression);
	                if (simple_pivot_field) {
	                    this.pivot_field_name = simple_pivot_field.name;
	                }
	                this.pivot_cols = extract_pivot_columns.call(this, data, this.def.body.pivot_expression, this.def.body.pivot_column_bucket_type, this.def.body.pivot_column_sort_by);
	                var reserved_width_px = (this.def.body.pivot_area_right ? this.def.body.pivot_area_right - this.def.body.pivot_column_right : 0) * this.pixels_per_unit;
	                this.pivot_column_width = (Number(this.def.body.pivot_column_right) - Number(this.def.body.pivot_column_left)) * this.pixels_per_unit;
	                var new_width = default_width + this.pivot_column_width * (this.pivot_cols.length - 1) - reserved_width_px;
	                this.contentDomEl.style.width = new_width + 'px';
	                // Have to re-compute percentage/pixels now, because otherwise elements with an existing % width
	                // would stretch due to the new parent width.  Elements should stay the same pixel size, thereby
	                // getting a smaller percentage of the expanded parent width
	                this.pct_per_px = 100 / new_width;
	                // Remember the width increase ratio for later use by PDF renderer
	                this.pivot_width_expansion_ratio = Math.max(1, new_width / default_width);
	            } else {
	                this.pivot = false;
	            }
	            convert_horizontal_units.call(this);
	        }

	        function getOrCreateIndex(dsId, fieldName) {
	            var dsIdLower = dsId.toLowerCase();
	            var key = dsIdLower + '/' + fieldName;
	            var index = indices[key];
	            if (!index) {
	                var dataset = datasets[dsIdLower];
	                indices[key] = index = ditto.data.buildIndexOn(dataset, fieldName);
	            }
	            return index;
	        }

	        function refresh_report_internal() {
	            var me = this;
	            ditto.totalRefreshCount = (ditto.totalRefreshCount || 0) + 1;
	            var htmlDocument = ditto.window.document;
	            if (this.render_timeout) {
	                ditto.window.clearTimeout(me.render_timeout);
	            }
	            var $content_div;
	            if (this.isSubreport) {
	                $content_div = this.$target;
	            } else {
	                this.current_input_values = capture_input_values.call(this);
	                $content_div = this.$target.find(".ditto-report-content");
	                this.isDetachedRender = true;
	                this.detachedContentDiv = $content_div;
	                $content_div.detach();
	            }
	            // var $content_div = this.$target.find(".ditto-report-content");
	            var contentDomEl = $content_div[0];
	            this.contentDomEl = contentDomEl;
	            var default_width = this.targetWidth || contentDomEl.offsetWidth;
	            if (!this.isSubreport) {
	                contentDomEl.style.width = 'auto';
	                contentDomEl.innerHTML = '';
	            }
	            compute_margins_px.call(this, default_width);
	            var filters = JSON.parse(JSON.stringify(this.def.filters || []));

	            var details = Array.isArray(this.def.body) ? this.def.body : [this.def.body];

	            var firstDetailDsId = (details[0].data_source || '').toLowerCase();
	            var data = datasets[firstDetailDsId];
	            if (this.subreportFilter) {
	                // Always index when rendering into a linked subreport
	                var index = getOrCreateIndex(firstDetailDsId, this.subreportFilter.field);
	                data = index[this.subreportFilter.operand] || [];
	            }
	            data = apply_filters.call(this, filters, data);
	            if (this.active_schema) {
	                var dateFields = [];
	                this.active_schema.fields.filter(function (field) {
	                    if (field.type === 'date') {
	                        dateFields.push(field);
	                    }
	                });
	                if (dateFields.length > 0) {
	                    var dateVal, dateFieldSchema;
	                    for (var i = 0; i < data.length; i++) {
	                        var row = data[i];
	                        for (var j = 0; j < dateFields.length; j++) {
	                            var dateFieldSchema = dateFields[j];
	                            dateVal = row[dateFields.name];
	                            if (dateVal && typeof dateVal === 'string') {
	                                dateVal = moment(dateVal, dateFieldSchema.format || DEFAULT_DATE_FORMAT);
	                                row[dateFields.name] = dateVal;
	                            }
	                        }
	                    }
	                }
	            }
	            var report_summary_row = $.extend({}, data.length > 0 ? data[0] : {}, {
	                "___children___": data
	            });
	            adjust_template_for_target.call(this, data);

	            if (this.def.type === 'dashboard') {
	                return renderDashboard.call(this, report_summary_row);
	            }

	            var marginTopDomEl = htmlDocument.createElement('div');
	            marginTopDomEl.className = 'jsr-top-margin-placeholder';
	            marginTopDomEl.style.height = this.margins_px.top + 'px';
	            this.sectionOffset = this.margins_px.top;
	            this.sections = [];
	            contentDomEl.appendChild(marginTopDomEl);

	            // Render background if any, once only in HTML mode
	            if (this.def.background) {
	                var $bkgd = renderSection.call(this, this.def.background, $content_div, report_summary_row, false, 0);
	                if ($bkgd) {
	                    $bkgd.addClass('jsr-page-background');
	                    // For now, exclude the background section from any positioning / paging
	                    this.sections.pop();
	                }
	                // Jump back to top of report to render next section
	                this.sectionOffset = this.margins_px.top;
	            }

	            if (this.def.page_header && this.def.page_header.visible) {
	                var $page_header = renderSection.call(this, this.def.page_header, $content_div, report_summary_row, true, 0);
	                if ($page_header) {
	                    $page_header.addClass("jsr-page-header");
	                }
	            }
	            if (this.def.header && this.def.header.visible !== false) {
	                renderSection.call(this, this.def.header, $content_div, report_summary_row, false, 0);
	            }
	            var detailIx = 0;
	            var lastData = data;
	            var render_iterator = render_level.call(this, this.def, details[detailIx], 0, data, $content_div);
	            var renderFn = function renderFn() {
	                if (render_iterator && render_iterator.hasMore()) {
	                    try {
	                        render_iterator.renderBatch();
	                    } catch (e) {
	                        throw e;
	                    }
	                    me.render_timeout = ditto.window.setTimeout(renderFn, 0);
	                    fit_text_elements.call(me);
	                    return;
	                }
	                // Done with batch (detail)
	                if (detailIx < details.length - 1) {
	                    // More details to render - cue the next one
	                    var nextDetail = details[++detailIx];
	                    var nextDetailDsId = (nextDetail.data_source || '').toLowerCase();
	                    var nextDetailData = datasets[nextDetailDsId];
	                    if (nextDetail.filters) {
	                        // console.log('applying filters to 2nd+ detail');
	                        nextDetailData = apply_filters.call(this, nextDetail.filters, nextDetailData);
	                    }
	                    lastData = nextDetailData;
	                    render_iterator = render_level.call(me, me.def, nextDetail, 0, nextDetailData, $content_div);
	                    return me.render_timeout = ditto.window.setTimeout(renderFn, 0);
	                }
	                // Done with all details
	                if (lastData !== data) {
	                    // If data changed (multiple details), re-do summary row for footers to use last detail's data
	                    report_summary_row = $.extend({}, lastData.length > 0 ? lastData[0] : {}, {
	                        "___children___": lastData
	                    });
	                }
	                if (me.def.footer && me.def.footer.visible !== false) {
	                    renderSection.call(me, me.def.footer, $content_div, report_summary_row, false, 0);
	                }
	                if (me.def.page_footer && me.def.page_footer.visible) {
	                    var $page_footer = renderSection.call(me, me.def.page_footer, $content_div, report_summary_row, true, 0);
	                    if ($page_footer) {
	                        $page_footer.addClass("jsr-page-footer");
	                    }
	                }
	                fit_text_elements.call(me);
	                waitForSubreports.call(me);
	            };
	            me.render_timeout = ditto.window.setTimeout(renderFn, 0);
	        }

	        function renderDashboard(summaryDataRow) {
	            var _this3 = this;

	            var els = this.def.body.elements;
	            var deferredRenderList = [];
	            var $viewport = this.$target.find('.jsr-content-viewport');
	            var tileSpacingPx = 10;
	            var tileSpacingUnits = tileSpacingPx / this.pixels_per_unit;
	            var viewportWidthUnits = $viewport.width() / this.pixels_per_unit;
	            var tileWidth = (viewportWidthUnits - tileSpacingUnits * (els.length + 1)) / 5;
	            var tileHeight = tileWidth / 1.6;
	            var left = tileSpacingUnits;
	            var top = tileSpacingUnits;
	            els.forEach(function (el, index) {
	                el.left = 0;
	                el.top = 0;
	                el.width = tileWidth;
	                el.height = tileHeight;
	                if (el.type === 'barChartTile') {
	                    el.width = el.width * 2 + tileSpacingUnits;
	                    el.height = el.height * 2 + tileSpacingUnits;
	                }
	                var $tile = $('<div class="jsr-dashboard-tile jsr-tile-before-show"></div>');
	                $tile.css({
	                    position: 'absolute',
	                    width: el.width * _this3.pixels_per_unit + 'px',
	                    height: el.height * _this3.pixels_per_unit + 'px',
	                    left: left * _this3.pixels_per_unit + 'px',
	                    top: top * _this3.pixels_per_unit + 'px',
	                    background: 'white'
	                });
	                var rendered = render_element.call(_this3, el, summaryDataRow, deferredRenderList);
	                if (rendered) {
	                    if (!Array.isArray(rendered)) {
	                        rendered = [rendered];
	                    }
	                    rendered.forEach(function (renderedEl) {
	                        return $tile.append(renderedEl.domEl);
	                    });
	                }
	                $(_this3.contentDomEl).append($tile);
	                left += el.width + tileSpacingUnits;
	                if (index % 5 === 4) {
	                    top += el.height + tileSpacingUnits;
	                    left = tileSpacingUnits;
	                }
	            });
	            this.detachedContentDiv.css({
	                'background-color': '#eee',
	                width: $viewport.width() + 'px',
	                height: $viewport.height() + 'px'
	            }).addClass('jsr-dashboard');
	            $viewport.append(this.detachedContentDiv);
	            this.isDetachedRender = false;
	            deferredRenderList.forEach(do_deferred_render.bind(this));
	            renderDeferredCharts.call(this);
	            on_render_complete.call(this);
	            $viewport.find('.jsr-tile-before-show').each(function (index, el) {
	                setTimeout(function () {
	                    $(el).removeClass('jsr-tile-before-show');
	                }, index * 100);
	            });
	        }

	        function resize() {
	            if (this.isSubreport) return;
	            var $viewport = this.$target.find('.jsr-content-viewport');
	            if ($viewport.length === 0) return;
	            $viewport.height(this.$target.height() - parseFloat($viewport.css('top')) + 'px');
	        }

	        function waitForSubreports() {
	            if (!this.subreportsRendering) {
	                finishRender.call(this);
	            } else {
	                $(this).on('subreports_rendered', finishRender.bind(this));
	            }
	        }

	        function renderDeferredCharts() {
	            if (this.charts) {
	                for (var i = 0; i < this.charts.length; i++) {
	                    // Refresh to get correct bounds now that it's visible
	                    var chartInfo = this.charts[i];
	                    var animate = this.outputSupportsAnimation !== false && chartInfo.def.animate !== false;
	                    chartInfo.chart.draw(animate ? chartInfo.def.initialAnimationMs || DEFAULT_CHART_ANIMATION_MS : 0, false);
	                    wrapChartLabelText.call(this, chartInfo.$el, chartInfo.$el.data('xAxisLabelHeight'));
	                }
	            }
	            this.charts = [];
	        }

	        function finishRender() {
	            if (this.isSubreport) {
	                on_render_complete.call(this);
	                return;
	            }
	            var $viewport = this.$target.children('.jsr-content-viewport');
	            this.viewportDomEl = $viewport[0];

	            // IMPORTANT: We do a layout/measure pass here where we set all sections to position: relative
	            // (via CSS) in order to measure their heights, then set them back to absolute positioning

	            // const pageSections = Array.from(
	            //     this.detachedContentDiv[0].querySelectorAll('.jsr-page-header,.jsr-page-footer'));
	            // pageSections.forEach(printSection => {
	            //     var $textEls = $(printSection).find('.jsr-text');
	            //     for (var i = 0; i < $textEls.length; i++) {
	            //         var $textEl = $textEls.eq(i);
	            //         var text = $textEl.text();
	            //         $textEl.data('jsr-text-template', text);
	            //         $textEl.text(text.replace('{{JSR_PRINT_PAGE_NUMBER}}', '1')
	            //             .replace('{{JSR_PRINT_PAGE_COUNT}}', '1'));
	            //     }
	            // });

	            // Now attach in order to measure heights
	            $viewport.append(this.detachedContentDiv);
	            this.isDetachedRender = false;

	            $(this.contentDomEl).addClass('jsr-measure-sections');

	            // First do subreport moves
	            var subreportMoves = [];
	            var viewers = this.allSubreportViewers.concat([this]);
	            var movecount = 0;
	            for (var i = 0, len = viewers.length; i < len; i++) {
	                viewer = viewers[i];
	                sections = viewer.sections;
	                for (var j = 0, jlen = sections.length; j < jlen; j++) {
	                    var sec = sections[j];
	                    if (sec.subreports) {
	                        var subreportChanges = prevent_subreport_overlap.call(this, sec.subreports);
	                        if (subreportChanges) {
	                            subreportMoves[subreportMoves.length] = subreportChanges.moves;
	                        }
	                    }
	                }
	            }

	            // Do the moves in a second pass to batch updates separately from measurements
	            for (i = 0, len = subreportMoves.length; i < len; i++) {
	                var moveset = subreportMoves[i];
	                for (j = 0, movelen = moveset.length; j < movelen; j++) {
	                    var move = moveset[j];
	                    move.el.style.marginTop = String(move.top) + 'px';
	                    movecount++;
	                }
	            }

	            // While we have everything visible, draw any deferred charts
	            renderDeferredCharts.call(this);

	            // if (this.relative_x) {
	            // Need to fix element widths in px temporarily in order
	            // to measure sections
	            // }

	            // var start = new Date();
	            var heights = [];
	            var offsets = [];
	            var viewerHeights = [];
	            var sections;
	            var viewer;
	            var k = 0;
	            for (var i = 0, len = viewers.length; i < len; i++) {
	                viewer = viewers[i];
	                sections = viewer.sections;
	                var offset = 0;
	                if (sections.length > 0) {
	                    // First offset must account for top margin (use initial offsetTop of first section)
	                    // unless that first section is printonly or background, in which case use 2nd section
	                    var firstSection = sections[0];
	                    if (firstSection.printOnly || firstSection.isBackground) {
	                        if (sections.length > 1) {
	                            offset = sections[1].section.offsetTop;
	                        }
	                    } else {
	                        offset = firstSection.section.offsetTop;
	                    }
	                }
	                for (var j = 0, jlen = sections.length; j < jlen; j++) {
	                    var sec = sections[j];
	                    var height = sec.section.offsetHeight;
	                    heights[k] = height;
	                    offsets[k] = offset;
	                    k++;
	                    offset += height;
	                }
	                viewerHeights[i] = viewer.contentDomEl.offsetHeight;
	            }
	            this.detachedContentDiv.detach();
	            var k = 0;
	            var i, j, len, movelen;
	            for (i = 0, len = viewers.length; i < len; i++) {
	                viewer = viewers[i];
	                sections = viewer.sections;
	                for (var j = 0, jlen = sections.length; j < jlen; j++) {
	                    var secDom = sections[j].section;
	                    secDom.style.top = offsets[k] + 'px';
	                    secDom.style.height = heights[k] + 'px';
	                    k++;
	                }
	                viewer.contentDomEl.style.height = viewerHeights[i] + 'px';
	            }

	            $(this.contentDomEl).removeClass('jsr-measure-sections');
	            $viewport.append(this.detachedContentDiv);
	            if (this.enableVirtualRender) {
	                enterVRender.call(this);
	            }
	            on_render_complete.call(this);
	        }

	        function buildVRenderMap() {
	            this.vRenderPageHeight = this.viewportDomEl.offsetHeight;
	            var map = {};
	            for (var i = 0, len = this.sections.length; i < len; i++) {
	                var sec = this.sections[i];
	                addSectionToVMap.call(this, map, sec.section, 0, sec.subreports);
	            }
	            this.vRenderMap = map;
	        }

	        function enterVRender() {
	            buildVRenderMap.call(this);
	            pageOutAll.call(this);
	            this.vRenderPages = [];
	            var scrollTop = this.viewportDomEl.scrollTop;
	            vRenderPageIn.call(this, scrollTop);
	            this.vrenderScrollHandler = throttleFn(onVRenderScroll.bind(this), this.virtualRenderScrollDelayMs || 150, true);
	            $(this.viewportDomEl).on('scroll', this.vrenderScrollHandler);
	        }

	        function pageInAll() {
	            setDisplayOnAllVMap.call(this, 'block');
	        }

	        function pageOutAll() {
	            setDisplayOnAllVMap.call(this, 'none');
	        }

	        function setDisplayOnAllVMap(displayCss) {
	            var vmap = this.vRenderMap;
	            var keys = Object.keys(vmap);
	            for (var i = 0, len = keys.length; i < len; i++) {
	                var bucket = vmap[keys[i]];
	                for (var j = 0, blen = bucket.length; j < blen; j++) {
	                    bucket[j].section.style.display = displayCss;
	                }
	            }
	        }

	        /** 
	         * Build vrender map for (only leaf-level) descendant .jsr-sections 
	         * within a top-level section
	         * @private
	         */
	        function mapContainersInSection(sectionDomEl, sectionTop, rootVMap, childSubreports) {
	            for (var i = 0, len = childSubreports.length; i < len; i++) {
	                var subrep = childSubreports[i];
	                var subrepTop = sectionTop + subrep.offsetTop;
	                var subsections = subrep.childNodes;
	                for (var j = 0, jlen = subsections.length; j < jlen; j++) {
	                    addSectionToVMap(rootVMap, subsections[j], subrepTop);
	                }
	            }
	        }

	        function addSectionToVMap(map, sectionDomEl, containerTop, childSubreports) {
	            var top = containerTop + sectionDomEl.offsetTop;
	            var height = sectionDomEl.offsetHeight;
	            var pageStart = Math.floor(top / this.vRenderPageHeight);
	            var heightInPages = Math.floor(height / this.vRenderPageHeight);
	            var pageEnd = pageStart + heightInPages;
	            var containers = null;
	            if (childSubreports) {
	                mapContainersInSection(sectionDomEl, top, map, childSubreports);
	            }
	            for (var j = pageStart; j <= pageEnd; j++) {
	                var bucket = map[j];
	                if (!bucket) {
	                    map[j] = bucket = [];
	                }
	                bucket.push({
	                    start: pageStart,
	                    end: pageEnd,
	                    section: sectionDomEl
	                });
	            }
	        }

	        function throttleFn(fn, maxMs, postpone) {
	            var timeout;
	            var me = this;
	            var lastArgs;
	            var inprogress = false;
	            var queued = false;
	            function timer() {
	                timeout = null;
	                inprogress = true;
	                fn.apply(me, lastArgs);
	                inprogress = false;
	                // For long-running handlers, we don't want to
	                // queue up a bunch of timers so instead we just
	                // flag to run once when the current handler finishes
	                if (queued && !postpone) {
	                    queued = false;
	                    timeout = ditto.window.setTimeout(timer, 0);
	                }
	            }
	            return function () {
	                lastArgs = arguments;
	                if (timeout) {
	                    if (postpone) {
	                        ditto.window.clearTimeout(timeout);
	                    } else {
	                        return;
	                    }
	                }
	                if (inprogress) {
	                    queued = true;
	                    return;
	                }
	                timeout = ditto.window.setTimeout(timer, maxMs);
	            };
	        }

	        function onVRenderScroll() {
	            if (this.pageInTimeout) {
	                ditto.window.clearTimeout(this.pageInTimeout);
	            }
	            this.pageInTimeout = ditto.window.setTimeout(vRenderPageIn.bind(this, this.viewportDomEl.scrollTop), 0);
	        }

	        function vRenderPageIn(top) {
	            top = Math.min(top, this.contentDomEl.offsetHeight - this.viewportDomEl.offsetHeight);
	            this.pageInInProgress = true;
	            var targetPage = Math.floor(top / this.vRenderPageHeight);
	            var first = Math.max(0, targetPage - 1);
	            var last = targetPage + 1;
	            for (var i = 0, len = this.vRenderPages.length; i < len; i++) {
	                this.vRenderPages[i].style.display = 'none';
	            }
	            var pagedIn = [];
	            var lastPagedIn = pageInSectionMap.call(this, this.vRenderMap, this.viewportDomEl, pagedIn, first, last);
	            this.vRenderPages = pagedIn;
	            this.vrenderStart = first;
	            this.vrenderEnd = lastPagedIn;
	        }

	        function pageInSectionMap(map, parentDomEl, pagedIn, start, end) {
	            for (var i = start; i <= end; i++) {
	                var bucket = map[i];
	                if (bucket) {
	                    for (var j = 0, len = bucket.length; j < len; j++) {
	                        var entry = bucket[j];
	                        i = Math.max(i, entry.end);
	                        // if (entry.inner) {
	                        //     pageInContainers.call(this, entry.inner, entry.section, pagedIn, start, end);
	                        // }
	                        // parentDomEl.appendChild(entry.section);
	                        entry.section.style.display = 'block';
	                        pagedIn[pagedIn.length] = entry.section;
	                    }
	                }
	            }
	            // Return last paged-in page index, since we may overshoot the window
	            return i - 1;
	        }

	        function exitVRender() {
	            pageInAll.call(this);
	            $(this.viewportDomEl).off('scroll', this.vrenderScrollHandler);
	        }

	        // Adjust font size if requested for certain text elements, to fit containing box
	        function fit_text_elements() {
	            for (var i = 0; i < this.pending_text_fits.length; i++) {
	                var item_to_fit = this.pending_text_fits[i],
	                    $el = item_to_fit.el;
	                textFit($el, {
	                    multiLine: item_to_fit.multiLine,
	                    reProcess: false
	                });
	                $el.css("visibility", "visible");
	            }
	            this.pending_text_fits = [];
	        }

	        function on_render_complete() {
	            if (this.isSubreport) {} else {
	                hide_mask.call(this);
	            }
	            if (!this.isSubreport) {
	                $events.trigger("report_rendered");
	            }
	            $(this).trigger('report_rendered');
	        }

	        var getAllSections = function getAllSections(report) {
	            var details = Array.isArray(report.body) ? report.body : [report.body];
	            var sections = _.flatten(details.map(function (detail) {
	                return [detail].concat(_toConsumableArray(detail.extraSections || []));
	            }));
	            if (report.background) {
	                sections.push(report.background);
	            }
	            if (report.page_header) {
	                sections.push(report.page_header);
	            }
	            if (report.page_footer) {
	                sections.push(report.page_footer);
	            }
	            if (report.header) {
	                sections.push(report.header);
	            }
	            if (report.footer) {
	                sections.push(report.footer);
	            }
	            details.forEach(function (detail) {
	                if (detail.sublevels) {
	                    detail.sublevels.map(function (sublevel) {
	                        if (sublevel.header) {
	                            sections.push(sublevel.header);
	                        }
	                        if (sublevel.footer) {
	                            sections.push(sublevel.footer);
	                        }
	                    });
	                }
	            });
	            return sections;
	        };

	        var getAllElements = function getAllElements(report) {
	            return _.flatten(getAllSections(report).map(function (section) {
	                return section.elements || [];
	            }));
	        };

	        function convert_horizontal_units() {
	            var details = Array.isArray(this.def.body) ? this.def.body : [this.def.body],
	                sections = getAllSections(this.def),
	                firstDetail = details[0],
	                pixels_per_unit = this.pixels_per_unit,

	            pivot_col_left = firstDetail.pivot_column_left,
	                pivot_col_right = firstDetail.pivot_column_right;
	            var pivot_area_right = firstDetail.pivot_area_right || pivot_col_right;
	            var reserved_width = pivot_area_right - pivot_col_right;
	            var extra_pivot_width = this.pivot ? (this.pivot_cols.length - 1) * (pivot_col_right - pivot_col_left) - reserved_width : 0;
	            var y_scale_adjustment = this.def.yScaleAdjustment || 1;
	            sections.forEach(function (section) {
	                if (this.pivot && !this.def.adjustedForPivot) {
	                    section.pivot_els = [];
	                }
	                for (var i = section.elements.length - 1; i >= 0; i--) {
	                    var element = section.elements[i];
	                    if (!element.id) {
	                        element.id = "jsr-auto-id-" + this.elt_id_counter++;
	                    }
	                    if (this.pivot) {
	                        if (this.def.adjustedForPivot) {
	                            section.pivot_els.forEach(function (pivoted_el) {
	                                set_element_px_pos(pivoted_el, pixels_per_unit, y_scale_adjustment);
	                            });
	                        } else {
	                            // If element is entirely within pivot column, move it into special "pivot_els" collections
	                            var element_right = element.left + element.width;
	                            if (element.left >= pivot_col_left && element_right <= pivot_col_right) {
	                                element.in_pivot_column = true;
	                                section.pivot_els.push(element);
	                                section.elements.splice(i, 1);
	                            } else if (element_right > pivot_area_right) {
	                                if (element.left < pivot_col_left) {
	                                    // Element spans entire pivot area; keep left fixed and expand width to span 
	                                    // all pivot cols
	                                    element.width += extra_pivot_width;
	                                } else {
	                                    // Element starts in the pivot column and extends rightward past it --
	                                    // should move to the right with no stretching (anchored at right edge)
	                                    element.left += extra_pivot_width;
	                                }
	                            }
	                        }
	                    }
	                    set_element_px_pos(element, pixels_per_unit, y_scale_adjustment);
	                }
	            }.bind(this));
	            this.def.adjustedForPivot = true;
	        }

	        /** Set pixel position of element by multiplying unit position by pixels_per_unit */
	        function set_element_px_pos(element_def, pixels_per_unit, y_scale_adjustment) {
	            element_def.left_px = element_def.left * pixels_per_unit;
	            element_def.width_px = element_def.width * pixels_per_unit;
	            // NOTE y_scale_adjustment is for converting pre-1.2.9 definitions from pixel y-axis to page-units y-axis
	            element_def.top_px = element_def.top * y_scale_adjustment * pixels_per_unit;
	            element_def.height_px = element_def.height * y_scale_adjustment * pixels_per_unit;
	        }

	        function render_inputs(def, $toolbar_el) {
	            var me = this;
	            $toolbar_el.empty();
	            var $inputs_ctnr = $('<div class="jsr-report-inputs"><span class="jsr-filter-label"></span></div>');
	            $inputs_ctnr.find('.jsr-filter-label').text(t('Filter:'));
	            var inputs = def.inputs || [];
	            inputs.map(function (inputdef, index) {
	                inputdef.id = "jsr-input-" + index;
	                var $input = render_input_field.call(this, inputdef);
	                $inputs_ctnr.append($input);
	                load_input_options.call(me, inputdef, $input);
	            });
	            if (inputs.length === 0) {
	                $inputs_ctnr.find(".jsr-filter-label").hide();
	            }
	            var $btns = $('<div class="jsr-toolbar-buttons"></div>'),
	                $run_btn = $('<button class="jsr-btn ditto-inputs-run"></button>').text(t('Refresh'));
	            $btns.append($run_btn);
	            $run_btn.on("click", function () {
	                refresh_report.call(this);
	            }.bind(this));
	            var $exportDropdown = $(['<div class="dropdown jsr-save-dropdown-button">', '<button class="jsr-btn btn-default dropdown-toggle" type="button" id="saveMenuButton" data-toggle="dropdown">', t('Save'), '<span class="caret"></span>', '</button>', '<ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="saveMenuButton">', '<li role="presentation"><a role="menuitem" tabindex="-1" href="#" class="jsr-export-pdf">' + t('PDF') + '</a></li>', this.saveFormats.indexOf('xlsx') >= 0 ? '<li role="presentation"><a role="menuitem" tabindex="-1" href="#" class="jsr-export-xlsx">' + t('Excel') + '</a></li>' : '', '</ul>', '</div>'].join(''));
	            $exportDropdown.find("a.jsr-export-pdf").on('click', function (evt) {
	                if (this.preserveViewOnExport) {
	                    exportCurrentViewToPDF.call(this);
	                } else {
	                    renderAndExportPDF.call(this);
	                }
	            }.bind(this));
	            $exportDropdown.find("a.jsr-export-xlsx").on('click', function (evt) {
	                // vrendering doesn't matter here because we always use a separate export wrapper
	                export_xlsx.call(this);
	            }.bind(this));
	            $btns.append($exportDropdown);
	            // Note order is important, btns before inputs in HTML
	            $toolbar_el.append($btns);
	            $toolbar_el.append($inputs_ctnr);
	            $toolbar_el.append('<div style="clear:both"></div>');
	            $exportDropdown.find("button.dropdown-toggle").jsrDropdown();
	        }

	        function withVRenderDisabled(fn) {
	            if (this.vRenderActive) {
	                exitVRender.call(this);
	                fn.call(this);
	            } else {
	                fn.call(this);
	            }
	        }

	        function exportCurrentViewToPDF(filename, outputHandler, target) {
	            if (this.enableVirtualRender) {
	                exitVRender.call(this);
	                $events.one('pdf_exported', enterVRender.bind(this));
	            }
	            export_pdf.call(this, filename, outputHandler, target);
	        }

	        function renderAndExportPDF(filename, outputHandler, target) {
	            var me = this;
	            var $exportWrapper = create_export_wrapper.call(me),
	                $exportTarget = $exportWrapper.find(".jsr-export-target");
	            $events.one("report_rendered", function () {
	                delete this.renderingToPDF;
	                $events.one("pdf_exported", function () {
	                    $exportWrapper.remove();
	                });
	                // Wait a tick so clients can modify styles in rendering on report_rendered
	                setTimeout(function () {
	                    export_pdf.call(me, filename, outputHandler, target);
	                }, 0);
	            });
	            this.renderingToPDF = true;
	            render_report.call(me, me.def, $exportTarget);
	        }

	        function export_pdf(requestedFilename, outputHandler, target) {
	            var me = this,

	            page_width_pts = this.def.page.paper_size.inches[0] * (this.pivot_width_expansion_ratio || 1) * 72,
	                page_height_pts = this.def.page.paper_size.inches[1] * 72,
	                orientation = page_height_pts > page_width_pts ? 'p' : 'l',
	                doc = new jsPDF({
	                orientation: orientation,
	                unit: 'pt',
	                format: [page_width_pts, page_height_pts],
	                disableFontEmbedding: this.allowPDFFontEmbedding === false
	            });
	            var isIE9 = document.addEventListener && !window.requestAnimationFrame;
	            if (!isIE9 && ditto.libraryPath) {
	                registerDefaultFonts();
	            }
	            Object.keys(customFonts).forEach(function (fontKey) {
	                var font = customFonts[fontKey];
	                doc.registerEmbeddableFont(font.family, font.combinedStyle, font.url);
	            });
	            var referencedFonts = _.values(extraFontReferences);
	            referencedFonts.forEach(function (font) {
	                return ['Normal', 'Bold', 'Italic', 'BoldItalic'].forEach(function (style) {
	                    return doc.addFont(font.psName + (style === 'Normal' ? '' : '-' + style), font.name, style, 'StandardEncoding');
	                });
	            });

	            // var fontUrls = {};
	            // for (var sheet = 0; sheet < document.styleSheets.length; sheet++) {
	            //  var rules = document.styleSheets[sheet].cssRules || [];
	            //  for (var i = 0; i < rules.length; i++) {
	            //      var rule = rules[i];
	            //      if (rule instanceof CSSFontFaceRule && (rule.style.src.indexOf('truetype') > -1 
	            //          || rule.style.src.indexOf('ttf') > -1)) {
	            //          var parts = /url\(([^\)]*)\)/ig.exec(rule.style.src);
	            //          if (parts[1]) {
	            //              console.log('found font url', parts[1]);
	            //              fontUrls[rule.style.fontFamily] = parts[1];
	            //          }
	            //      }
	            //  }
	            // }

	            var usedFonts = {};
	            var $reportContent = this.$target.find(".ditto-report-content");
	            doc.fetchEmbeddableFonts(function () {
	                var availableFonts = {};
	                Object.keys(doc.getFontList()).forEach(function (fontName) {
	                    availableFonts[fontName.toLowerCase()] = true;
	                });
	                var availableCustomFonts = Object.keys(customFonts).map(function (fontKey) {
	                    return customFonts[fontKey].family;
	                }).filter(function (fontName) {
	                    return !!availableFonts[fontName.toLowerCase()];
	                });
	                var robotoAvailable = !!availableFonts['roboto'];
	                var fontOverrides = robotoAvailable ? { 'helvetica': 'Roboto', 'sans-serif': 'Roboto' } : {};
	                doc.fromHTML($reportContent[0], 0, 0, {
	                    // Settings
	                    width: this.$target.width(),
	                    elementHandlers: {}
	                }, {
	                    // Margins
	                    top: this.margins_px.top,
	                    bottom: this.margins_px.bottom,
	                    left: this.margins_px.left,
	                    right: this.margins_px.right
	                }, availableCustomFonts, referencedFonts, usedFonts, fontOverrides, function callback() {
	                    var filename = me.def.title + '.pdf';
	                    if (typeof requestedFilename !== "undefined" && requestedFilename !== null) {
	                        filename = requestedFilename;
	                    }
	                    if (outputHandler) {
	                        // If they requested to handle the output in JavaScript directly, call their callback
	                        outputHandler.call(this, doc.output("blob"));
	                    } else {
	                        // Otherwise, do our normal handling: attempt to download (if IE9, have to use Flash)
	                        if (isIE9 && ditto.libraryPath) {
	                            var $downloadify = $('<div class="jsr-pdf-manual-download">Your file is ready.  Click the button to open or save it.<div class="jsr-downloadify-button"></div></div>');
	                            $(document.body).append($('<div class="jsr-downloadify-download-mask"></div>'));
	                            $(document.body).append($downloadify);
	                            Downloadify.create($downloadify.find(".jsr-downloadify-button")[0], {
	                                filename: filename,
	                                data: function data() {
	                                    return doc.output();
	                                },
	                                onComplete: function onComplete() {
	                                    $downloadify.remove();
	                                    $(".jsr-downloadify-download-mask").remove();
	                                },
	                                onCancel: function onCancel() {
	                                    $downloadify.remove();
	                                    $(".jsr-downloadify-download-mask").remove();
	                                },
	                                onError: function onError() {
	                                    $downloadify.remove();
	                                    $(".jsr-downloadify-download-mask").remove();
	                                },
	                                swf: ditto.libraryPath + '/media/downloadify.swf',
	                                downloadImage: ditto.libraryPath + '/media/download.png',
	                                width: 100,
	                                height: 30,
	                                transparent: true,
	                                append: false
	                            });
	                        } else {
	                            if (target === "newwindow") {
	                                /** IE doesn't support opening data URIs or blobs in a new window */
	                                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                                    return doc.output('save', filename);
	                                }
	                                doc.output('dataurlnewwindow');
	                            } else if (target === "print") {
	                                /** IE doesn't support opening data URIs or blobs in a new window */
	                                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                                    return doc.output('save', filename);
	                                }
	                                doc.autoPrint();
	                                doc.output('dataurlnewwindow', {});
	                            } else {
	                                doc.output('save', filename);
	                            }
	                        }
	                    }
	                    $events.trigger("pdf_exported");
	                });
	            }.bind(this));
	        }

	        /**
	         * Render the report offscreen in HTML mode, then generate the Excel version
	         * based on that
	         */
	        function export_xlsx(requestedFilename, outputHandler, target) {
	            var me = this,
	                $origTarget = this.$target;
	            var $exportWrapper = create_export_wrapper.call(me),
	                $exportTarget = $exportWrapper.find(".jsr-export-target"),
	                orig_output_format = me.outputFormat;
	            me.outputFormat = "xlsx";
	            $events.one("report_rendered", function () {
	                force_load_all_images.call(me, $exportTarget, function () {
	                    convert_html_to_excel.call(me, $exportTarget);
	                    var workbook = generate_excel_workbook.call(me);
	                    var filename = requestedFilename || (me.def.title || t('Report')) + '.xlsx';
	                    if (outputHandler) {
	                        outputHandler.call(me, get_excel_blob.call(me, workbook));
	                    } else {
	                        if (target) {
	                            switch (target) {
	                                case 'newwindow':
	                                    /** IE doesn't support opening data URIs or blobs in a new window */
	                                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                                        download_excel_file.call(me, workbook, filename);
	                                    } else {
	                                        if (URL.createObjectURL) {
	                                            window.open(URL.createObjectURL(get_excel_blob(workbook)));
	                                        } else if (window.navigator.msSaveOrOpenBlob) {
	                                            window.navigator.msSaveOrOpenBlob(get_excel_blob(workbook), filename);
	                                        } else {
	                                            open_data_uri(get_excel_data_uri(workbook));
	                                        }
	                                    }
	                                    break;
	                                // case 'print':
	                                //     break;
	                                default:
	                                    throw new Error('Unsupported Excel export target: ' + target);
	                            }
	                        } else {
	                            download_excel_file.call(me, workbook, filename);
	                        }
	                    }
	                    $exportWrapper.remove();
	                    me.outputFormat = orig_output_format;
	                    me.$target = $origTarget;
	                });
	            });
	            render_report.call(me, me.def, $exportTarget);
	        }

	        function convert_html_to_excel(target) {
	            var content_el = target.find('.ditto-report-content');
	            var content_width = content_el.outerWidth();
	            var cols = this.excel_columns = get_excel_columns.call(this, get_x_extents.call(this, content_el), content_width);
	            var cols_by_x = {};
	            cols.forEach(function (col, ix) {
	                cols_by_x[col.x_px] = ix;
	            });
	            this.excel_data = [];
	            this.excel_drawings = null;
	            this.excel_blank_row = this.excel_columns.map(function () {
	                return "";
	            });
	            this.excel_workbook = ExcelBuilder.createWorkbook();
	            this.excel_stylesheet = this.excel_workbook.getStyleSheet();
	            this.excel_worksheet = this.excel_workbook.createWorksheet({ name: 'Sheet1' });
	            // Fill excel_data
	            var sections = $(target).find('div.jsr-section:not(.jsr-print-only-section)');
	            var worksheet = this.excel_worksheet;
	            var blank_row = this.excel_blank_row;
	            for (var i = 0; i < sections.length; i++) {
	                var section = sections.eq(i);
	                var row_offset = this.excel_data.length;
	                var section_rows = get_excel_rows.call(this, section);
	                var rows_by_y = {};
	                var rows = section_rows.map(function (row, index) {
	                    worksheet.setRowInstructions(row_offset + index, {
	                        height: row.height * EXCEL_ROW_HEIGHT_MULTIPLIER
	                    });
	                    var new_row = blank_row.slice(0);
	                    rows_by_y[row.y_px] = {
	                        index: index,
	                        row: new_row
	                    };
	                    return new_row;
	                });
	                // Convert elements into Excel cells
	                var elts = section.find('.jsr-element, .jsr-table th, .jsr-table td');
	                for (var j = 0; j < elts.length; j++) {
	                    var elt = elts.eq(j);
	                    var tagname = elt.prop('tagName').toLowerCase();
	                    // Ignore table itself because its cells will be handled individually
	                    if (elt.hasClass('jsr-table')) continue;
	                    var pos = elt.position();
	                    if (tagname === 'td' || tagname === 'th') {
	                        var tablePos = elt.closest('.jsr-table').position();
	                        pos.top += tablePos.top;
	                        pos.left += tablePos.left;
	                    }
	                    var roundedTop = Math.round(pos.top / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	                    var roundedLeft = Math.round(pos.left / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	                    var roundedRight = Math.round((pos.left + elt.outerWidth()) / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	                    var target_row_info = rows_by_y[roundedTop];
	                    var target_row_ix = target_row_info.index;
	                    var start_col_ix = cols_by_x[roundedLeft];
	                    var end_col_ix = cols_by_x[roundedRight] - 1;
	                    var target_row = target_row_info.row;
	                    var overlaps = false;
	                    for (var target_col_ix = start_col_ix; target_col_ix < end_col_ix; target_col_ix++) {
	                        if (target_row[target_col_ix]) {
	                            overlaps = true;
	                            break;
	                        }
	                    }
	                    if (end_col_ix > start_col_ix) {
	                        merge_cells.call(this, row_offset + target_row_ix, start_col_ix, end_col_ix);
	                    }
	                    if (!overlaps) {
	                        var def = elt.data('jsr-def');
	                        if (tagname === 'th' || tagname === 'td') {
	                            def = $.extend({
	                                id: 'table-cell-' + i + '-' + j,
	                                type: 'text'
	                            }, elt.data('jsr-cell-style'));
	                        }
	                        convert_element_to_excel.call(this, elt, def, target_row, row_offset + target_row_ix, start_col_ix, end_col_ix);
	                    }
	                }
	                this.excel_data = this.excel_data.concat(rows);
	            }
	        }

	        function generate_excel_workbook() {
	            var sheet = this.excel_worksheet;
	            // merge_all_empty_cells.call(this, this.excel_data);
	            sheet.setData(this.excel_data);
	            sheet.setColumns(this.excel_columns);
	            if (this.excel_drawings) {
	                this.excel_worksheet.addDrawings(this.excel_drawings);
	                this.excel_workbook.addDrawings(this.excel_drawings);
	            }
	            this.excel_workbook.setPrintArea(1, this.excel_columns.length);
	            sheet.setFitToPageWidth(true);
	            this.excel_workbook.addWorksheet(sheet);
	            return this.excel_workbook;
	        }

	        function merge_all_empty_cells(data) {
	            var colCount = this.excel_columns.length;
	            var tempVal;
	            for (var r = 0; r < data.length; r++) {
	                var row = this.excel_data[r];
	                var merge = null;
	                for (var c = 0, len = colCount; c < len; c++) {
	                    var cell = row[c];
	                    if (cell) {
	                        if (cell.metadata.align === 'right') {
	                            // Right-aligned
	                            if (merge) {
	                                if (merge.type === 'empty') {
	                                    // merge in any empty leftward cells
	                                    // have to move value into first merged cell or it will be lost
	                                    delete row[c];
	                                    merge_cells.call(this, r, merge.start, cell.metadata.endCol);
	                                    row[merge.start] = cell;
	                                } else {
	                                    // leftward cells non-empty, treat like left-aligned
	                                    merge_cells.call(this, r, merge.start, c - 1);
	                                }
	                                merge = null;
	                            } else {
	                                // Do the single-element merge for this right-aligned cell
	                                merge_cells.call(this, r, c, cell.metadata.endCol);
	                            }
	                        } else {
	                            // Left or any other align, close out any existing merge and start new
	                            if (merge) {
	                                merge_cells.call(this, r, merge.start, c - 1);
	                            }
	                            merge = { type: 'left', start: c };
	                        }
	                        c = cell.metadata.endCol;
	                    } else {
	                        // cell empty, start an empty merge span
	                        if (!merge) {
	                            merge = { type: 'empty', start: c };
	                        }
	                    }
	                }
	                // If line ended with no data, end any open merge
	                if (merge) {
	                    if (merge.type === 'empty') {
	                        tempVal = row[colCount - 1];
	                        delete row[colCount - 1];
	                    }
	                    merge_cells.call(this, r, merge.start, colCount - 1);
	                    if (merge.type === 'empty') {
	                        row[merge.start] = tempVal;
	                    }
	                }
	            }
	        }

	        function merge_cells(row, startcol, endcol) {
	            if (endcol <= startcol) return;
	            this.excel_worksheet.mergeCells(get_excel_cell_name.call(this, row + 1, startcol + 1), get_excel_cell_name.call(this, row + 1, endcol + 1));
	        }

	        function compute_margins_px(contentWidth) {
	            this.margins_px = {};
	            var units = this.def.page.units,
	                paper_width = this.def.page.paper_size[units][0],
	                preview_width = contentWidth || this.$target[0].offsetWidth,
	                pixels_per_unit = preview_width / paper_width;
	            this.pixels_per_unit = pixels_per_unit;
	            this.pct_per_px = 100 / preview_width;
	            ["left", "top", "right", "bottom"].map(function (side) {
	                this.margins_px[side] = Math.floor(Math.min(preview_width, this.def.page.margins[side] * pixels_per_unit));
	            }.bind(this));
	        }

	        function show_mask() {
	            if (!this.$mask) {
	                this.$mask = $(['<div class="jsr-report-mask">', '<div class="jsr-spinner">',
	                // '<div class="jsr-slice-clip">',
	                //     '<div class="jsr-slice"></div>',
	                // '</div>',
	                '</div>', '</div>'].join(''));
	                if (this.$target.css("position") !== "absolute") {
	                    this.$target.css("position", "relative");
	                }
	                this.$target.append(this.$mask);
	            }
	            this.origTargetOverflow = this.$target.css('overflow');
	            this.$target.css("overflow", "hidden");
	            this.$mask.show();
	        }

	        function hide_mask() {
	            if (this.$mask) {
	                this.$mask.hide();
	                this.$target.css("overflow", this.origTargetOverflow || "auto");
	            }
	        }

	        function render_input_field(inputdef) {
	            var $field;
	            var default_value = inputdef.default_value;
	            if (typeof default_value === "undefined") {
	                default_value = "";
	            }
	            var displayName = inputdef.displayName || inputdef.name;
	            switch (inputdef.type) {
	                case "text":
	                    $field = $('<div class="ditto-input ditto-input-text">' + displayName + ': <input type="text" value="' + default_value + '" /></div>');
	                    break;
	                case "number":
	                    $field = $('<div class="ditto-input ditto-input-number">' + displayName + ': <input type="text" value="' + default_value + '" /></div>');
	                    break;
	                case "date":
	                    $field = $('<div class="ditto-input ditto-input-date">' + displayName + ': <input type="text" value="' + default_value + '" /></div>');
	                    $field.find("input").datepicker({
	                        format: inputdef.dateFormat ? inputdef.dateFormat.toLowerCase() : "m/d/yy",
	                        autoclose: true
	                    });
	                    break;
	                case 'boolean':
	                    $field = $('<div class="ditto-input ditto-input-boolean"><label><input type="checkbox" checked="' + !!default_value + '" />' + displayName + '</label></div>');
	                    break;
	            }
	            $field.addClass("jsr-input-id-" + inputdef.id);
	            return $field;
	        }

	        /** If a list of options is provided for the input, initialize that drop-down now */
	        function load_input_options(inputDef, $inputWrap) {
	            if (inputDef.optionSource) {
	                var options = [];
	                if (Array.isArray(inputDef.optionSource)) {
	                    options = inputDef.optionSource;
	                } else if (typeof inputDef.optionSource === 'string') {
	                    // Treat as a data source ID
	                    // Expect it to be loaded because we look for optionSource when loading datasets initially
	                    options = datasets[inputDef.optionSource.toLowerCase()];
	                    if (typeof options === "undefined" || !options) {
	                        throw new Error('Missing dataset with ID ' + inputDef.optionSource + ' required by input ' + inputDef.name);
	                    }
	                    options = options;
	                } else {
	                    throw new Error('Unrecognized optionSource property for input ' + inputDef.name + '.  optionSource must be an array or valid data source ID string.');
	                }
	                if (inputDef.optionSourceField) {
	                    options = options.map(function (opt) {
	                        return opt[inputDef.optionSourceField];
	                    });
	                }
	                options = _.uniq(options).filter(function (opt) {
	                    return opt !== undefined && opt !== null;
	                });
	                options.sort();
	                var select2Config = {
	                    data: options.map(function (opt) {
	                        return { id: opt, text: opt };
	                    }),
	                    dropdownAutoWidth: true,
	                    dropdownCssClass: 'jsr-select2-dropdown',
	                    placeholder: 'Select an option',
	                    allowClear: true,
	                    multiple: !!inputDef.multiple
	                };
	                if (!inputDef.limitToList) {
	                    select2Config.createSearchChoice = function (term, data) {
	                        var lower = term.toLowerCase();
	                        if (data.filter(function (opt) {
	                            return opt.text.toLowerCase().localeCompare(lower) === 0;
	                        }).length === 0) {
	                            return { id: term, text: term };
	                        }
	                    };
	                }
	                var $field = $inputWrap.find('input');
	                $inputWrap.data({
	                    'input-field': $field,
	                    multiple: !!inputDef.multiple
	                });
	                $field.select2(select2Config).on('change', on_filter_dropdown_change.bind(this));
	            }
	        }

	        function on_filter_dropdown_change() {
	            refresh_report.call(this);
	        }

	        function capture_input_values() {
	            var $toolbar = this.$toolbar_el,
	                values_by_input_name = {};
	            if (this.showToolbar) {
	                this.def.inputs.forEach(function (input) {
	                    var $wrapper = $toolbar.find(".jsr-input-id-" + input.id);
	                    var $input = $wrapper.data('input-field') || $wrapper.find('input, select');
	                    var val = $input.val();
	                    var isMultiple = !!$wrapper.data('multiple');
	                    if (val && input.type === 'date') {
	                        val = moment(val, input.dateFormat || 'M/D/YY').format('YYYY-MM-DD');
	                    } else if (input.type === 'boolean') {
	                        val = $input.is(':checked');
	                    } else if (input.type === 'number') {
	                        val = Number(val);
	                        if (isNaN(val)) {
	                            val = null;
	                        }
	                    } else if (isMultiple) {
	                        val = val.split(',');
	                    }
	                    values_by_input_name[input.name.toLowerCase()] = val;
	                });
	            }
	            return values_by_input_name;
	        }

	        function apply_filters(filters, data) {
	            if (!data) return [];
	            if (filters.length === 0) return data;
	            var me = this,
	                date_operands = { "before": 1, "after": 1, "onorbefore": 1, "onorafter": 1 };
	            var actual_operands = filters.map(function (filterdef) {
	                var operand = filterdef.operand;
	                if (typeof operand === 'string') {
	                    if (operand.length > 2 && operand.substr(0, 1) === '[' && operand.substr(operand.length - 1, 1) === ']') {
	                        var expr_inner = operand.substr(1, operand.length - 2);
	                        if (expr_inner.length > 0 && expr_inner.substr(0, 1) === "?") {
	                            // Filter is matching against an input value, e.g. [?my_input]
	                            var possible_input_reference = operand.substr(2, operand.length - 3).toLowerCase();
	                            var matching_input_value = me.current_input_values[possible_input_reference];
	                            if (typeof matching_input_value !== "undefined") {
	                                return matching_input_value;
	                            } else {
	                                printError('Error: Couldn\'t find input named "' + possible_input_reference + '" referenced by filter; filter is ignored.');
	                                return '';
	                            }
	                        } else {
	                            switch (expr_inner.toLowerCase()) {
	                                case "=now()":
	                                    operand = moment().format();
	                                    break;
	                                case "=today()":
	                                    operand = moment().format("YYYY-MM-DD");
	                                    break;
	                            }
	                        }
	                    } else if (operand.length > 1 && operand.substr(0, 1) === '=') {
	                        // Expression
	                        operand = evalJSExpression.call(me, operand.substr(1), {});
	                    }
	                }
	                return operand;
	            });
	            return data.filter(function (row) {
	                for (var i = 0; i < filters.length; i++) {
	                    var match = false,
	                        filter = filters[i],
	                        fieldval = getFieldValue(row, filter.field),
	                        operand = actual_operands[i],
	                        operand_date_format = "YYYY-MM-DD",
	                        field_date_format = "YYYY-MM-DD";
	                    if (operand === '') {
	                        continue;
	                    }
	                    if (date_operands[filter.operator]) {
	                        var schema_field = this.active_schema && find_field_by_name(this.active_schema, filter.field);
	                        if (schema_field && schema_field.dateFormat) {
	                            field_date_format = schema_field.dateFormat;
	                        }
	                        var field_date = moment(fieldval, field_date_format).valueOf(),
	                            operand_date = moment(operand, operand_date_format).valueOf();
	                        switch (filter.operator) {
	                            case "before":
	                                match = field_date < operand_date;
	                                break;
	                            case "after":
	                                match = field_date > operand_date;
	                                break;
	                            case "onorbefore":
	                                match = field_date <= operand_date;
	                                break;
	                            case "onorafter":
	                                match = field_date >= operand_date;
	                                break;
	                        }
	                    } else {
	                        var operands = Array.isArray(operand) ? operand : [operand];
	                        match = matchesAny(filter.operator, operands, fieldval);
	                    }
	                    if (!match) {
	                        return false;
	                    }
	                }
	                return true;
	            }.bind(this));
	        }

	        function matchesAny(operator, operands, testValue) {
	            for (var i = 0; i < operands.length; i++) {
	                var operand = operands[i];
	                var left = void 0,
	                    right = void 0;
	                switch (operator) {
	                    case "is":
	                        if (testValue === operand) return true;
	                        break;
	                    case "isnot":
	                        if (testValue !== operand) return true;
	                        break;
	                    case "contains":
	                        if (String(testValue).toLowerCase().indexOf(String(operand).toLowerCase()) > -1) return true;
	                        break;
	                    case "doesnotcontain":
	                        if (String(testValue).toLowerCase().indexOf(String(operand).toLowerCase()) === -1) return true;
	                        break;
	                    case "gt":
	                        if (Number(testValue) > Number(operand)) return true;
	                        break;
	                    case "lt":
	                        if (Number(testValue) < Number(operand)) return true;
	                        break;
	                    case "gte":
	                        if (Number(testValue) >= Number(operand)) return true;
	                        break;
	                    case "lte":
	                        if (Number(testValue) <= Number(operand)) return true;
	                        break;
	                    case "before":
	                        left = moment(testValue, 'YYYY-MM-DD').valueOf();
	                        right = moment(operand, 'YYYY-MM-DD').valueOf();
	                        if (left < right) return true;
	                        break;
	                    case "after":
	                        left = moment(testValue, 'YYYY-MM-DD').valueOf();
	                        right = moment(operand, 'YYYY-MM-DD').valueOf();
	                        if (left > right) return true;
	                        break;
	                    case "onorbefore":
	                        left = moment(testValue, 'YYYY-MM-DD').valueOf();
	                        right = moment(operand, 'YYYY-MM-DD').valueOf();
	                        if (left <= right) return true;
	                        break;
	                    case "onorafter":
	                        left = moment(testValue, 'YYYY-MM-DD').valueOf();
	                        right = moment(operand, 'YYYY-MM-DD').valueOf();
	                        if (left >= right) return true;
	                        break;
	                }
	            }
	            return false;
	        }

	        function find_field_by_name(schema, fieldname) {
	            var needle_lower = fieldname.toLowerCase(),
	                match = $.grep(schema.fields, function (item, index) {
	                return item.name.toLowerCase().localeCompare(needle_lower) === 0;
	            });
	            return match.length > 0 ? match[0] : null;
	        }

	        function get_detail_sort_fn(report_def, data, schema) {
	            var details = Array.isArray(report_def.body) ? report_def.body : [report_def.body];
	            if (data && details[0].show_detail !== false && details[0].order_detail_by) {
	                var sort_field_name = details[0].order_detail_by,
	                    asc = details[0].order_detail_dir !== "desc";
	                return get_sort_fn.call(this, report_def, data, schema, sort_field_name, asc);
	            }
	            return null;
	        }

	        function get_sort_fn(report_def, data, schema, sort_field_name, asc) {
	            var schema_field = schema && find_field_by_name(schema, sort_field_name),
	                field_type = schema_field && schema_field.type;
	            if (!field_type && data.length > 0 && data[0].hasOwnProperty(sort_field_name)) {
	                field_type = _typeof(data[0][sort_field_name]);
	            }
	            if (!field_type) {
	                warn('Couldn\'t find requested sort field: ' + sort_field_name);
	                return null;
	            }
	            field_type = field_type.toLowerCase();
	            var extractSortKey = function extractSortKey(row, fieldname) {
	                var key = row[fieldname];
	                if (key === undefined) {
	                    var children = row['___children___'];
	                    if (children && children.length > 0) {
	                        key = children[0][fieldname];
	                    }
	                }
	                return key;
	            };
	            switch (field_type.toLowerCase()) {
	                case "number":
	                    if (asc) {
	                        return function (rowa, rowb) {
	                            var a = extractSortKey(rowa, sort_field_name);
	                            var b = extractSortKey(rowb, sort_field_name);
	                            var a_is_null = a === null;
	                            var b_is_null = b === null;
	                            return a_is_null ? b_is_null === null ? 0 : -1 : b_is_null ? 1 : a - b;
	                        };
	                    } else {
	                        return function (rowa, rowb) {
	                            var a = extractSortKey(rowa, sort_field_name);
	                            var b = extractSortKey(rowb, sort_field_name);
	                            var a_is_null = a === null;
	                            var b_is_null = b === null;
	                            return a_is_null ? b_is_null === null ? 0 : 1 : b_is_null ? -1 : b - a;
	                        };
	                    }
	                    break;
	                case "date":
	                    var date_format = "YYYY-MM-DD";
	                    if (schema_field && schema_field.dateFormat) {
	                        date_format = schema_field.dateFormat;
	                    }
	                    if (asc) {
	                        return function (rowa, rowb) {
	                            var date_a = rowa[sort_field_name],
	                                date_b = rowb[sort_field_name];
	                            return (date_a ? moment(date_a, date_format).valueOf() : 0) - (date_b ? moment(date_b, date_format).valueOf() : 0);
	                        };
	                    } else {
	                        return function (rowa, rowb) {
	                            var date_a = rowa[sort_field_name],
	                                date_b = rowb[sort_field_name];
	                            return (date_b ? moment(date_b, date_format).valueOf() : 0) - (date_a ? moment(date_a, date_format).valueOf() : 0);
	                        };
	                    }
	                    break;
	                case "boolean":
	                    if (asc) {
	                        return function (rowA, rowB) {
	                            var a = extractSortKey(rowA, sort_field_name) || false;
	                            var b = extractSortKey(rowB, sort_field_name) || false;
	                            return b ? a ? 0 : 1 : a ? -1 : 0;
	                        };
	                    } else {
	                        return function (rowA, rowB) {
	                            var a = extractSortKey(rowA, sort_field_name) || false;
	                            var b = extractSortKey(rowB, sort_field_name) || false;
	                            return a ? b ? 0 : 1 : b ? -1 : 0;
	                        };
	                    }
	                default:
	                    // alphanumeric case-insensitive
	                    if (asc) {
	                        return function (rowa, rowb) {
	                            var a = extractSortKey(rowa, sort_field_name) || "",
	                                b = extractSortKey(rowb, sort_field_name) || "";
	                            return a.toLowerCase().localeCompare(b.toLowerCase());
	                        };
	                    } else {
	                        return function (rowa, rowb) {
	                            var a = extractSortKey(rowa, sort_field_name) || "",
	                                b = extractSortKey(rowb, sort_field_name) || "";
	                            return b.toLowerCase().localeCompare(a.toLowerCase());
	                        };
	                    }
	            }
	            return null;
	        }

	        function render_level(report, detail, depth, data, $target, parentGroupRow) {
	            var me = this,
	                levels = detail.sublevels || [],
	                is_detail = depth >= levels.length,
	                level_def = is_detail ? detail : levels[depth],
	                grouping = level_def.group_by !== null && typeof level_def.group_by !== "undefined",
	                matching_rows;
	            if (!grouping && depth === levels.length - 1) {
	                is_detail = true;
	                level_def = detail;
	            }
	            if (is_detail) {
	                if (this.show_detail) {
	                    matching_rows = data;
	                    if (this.detail_sort_fn) {
	                        matching_rows.sort(this.detail_sort_fn);
	                    }
	                } else {
	                    matching_rows = [];
	                }
	            } else {
	                if (grouping) {
	                    matching_rows = group_rows.call(this, data, level_def.group_by, level_def, depth, report, parentGroupRow);
	                }
	                if (depth < detail.sublevels.length - 1) {
	                    var child_level = detail.sublevels[depth + 1];
	                    if (child_level.data_source !== "__parentgroup") {
	                        // Pull in external data source if one is specified
	                        // Rows will be ALL rows in the data source UNLESS a filter is applied
	                        // Have to do this ahead of time in order to set parent's ___children___ correctly
	                        // Overwrite the ___children___ given by group_rows with the new external data
	                        for (var rowix = 0; rowix < matching_rows.length; rowix++) {
	                            matching_rows[rowix]["___children___"] = get_linked_rows.call(this, child_level, depth + 1, matching_rows[rowix]);
	                        }
	                    }
	                }
	            }
	            var done = false,
	                childIterator = null,
	                nextOffset = 0,
	                _visibleBands = 0,
	                detailAlt = false,
	                i;
	            var bandsToRemoveIfEmpty = [];
	            var removeBands = function removeBands() {
	                // console.log('removing', bandsToRemoveIfEmpty.length, 'bands');
	                bandsToRemoveIfEmpty.map(function ($band) {
	                    return $band.remove();
	                });
	                bandsToRemoveIfEmpty = [];
	            };
	            // Now return an iterator with a function to process the next batch
	            return {
	                renderBatch: function renderBatch(startTime) {
	                    var start = startTime || new Date();
	                    if (childIterator && childIterator.hasMore()) {
	                        // complete rendering the child section
	                        childIterator.renderBatch(start);
	                        if (childIterator.hasMore()) {
	                            // yield
	                            return;
	                        } else {
	                            if (level_def.footer && level_def.footer.visible !== false) {
	                                var band = renderSection.call(me, level_def.footer, $target, matching_rows[i], false, i, depth);
	                                if (band) {
	                                    _visibleBands++;
	                                    if (level_def.footer.hideIfEmpty) {
	                                        bandsToRemoveIfEmpty.push(band);
	                                    }
	                                }
	                            }
	                            _visibleBands += childIterator.visibleBands();
	                            // console.log('child bands', childIterator.visibleBands());
	                            if (childIterator.visibleBands() === 0) {
	                                removeBands();
	                            }
	                        }
	                    }
	                    for (i = nextOffset; i < matching_rows.length; i++) {
	                        if (is_detail) {
	                            var _band = renderSection.call(me, level_def, $target, matching_rows[i], false, i, depth);
	                            if (_band) {
	                                _visibleBands++;
	                                if (detailAlt) {
	                                    _band.addClass('jsr-detail-alt');
	                                }
	                                detailAlt = !detailAlt;
	                            }
	                        } else {
	                            bandsToRemoveIfEmpty = [];
	                            if (level_def.header && level_def.header.visible !== false) {
	                                var _band2 = renderSection.call(me, level_def.header, $target, matching_rows[i], false, i, depth);
	                                if (_band2) {
	                                    _visibleBands++;
	                                    if (level_def.header.hideIfEmpty) {
	                                        bandsToRemoveIfEmpty.push(_band2);
	                                    }
	                                }
	                            }
	                            var childVisibleBands = 0;
	                            childIterator = render_level.call(me, report, detail, depth + 1, matching_rows[i]["___children___"], $target, matching_rows[i]);
	                            childIterator.renderBatch(start);
	                            if (childIterator.hasMore()) {
	                                nextOffset = i + 1;
	                                // yield
	                                return;
	                            } else {
	                                childVisibleBands = childIterator.visibleBands();
	                                childIterator = null;
	                            }
	                            // Finished rendering group
	                            if (level_def.footer && level_def.footer.visible !== false) {
	                                var _band3 = renderSection.call(me, level_def.footer, $target, matching_rows[i], false, i, depth);
	                                if (_band3) {
	                                    _visibleBands++;
	                                    if (level_def.footer.hideIfEmpty) {
	                                        bandsToRemoveIfEmpty.push(_band3);
	                                    }
	                                }
	                            }
	                            _visibleBands += childVisibleBands;
	                            // console.log('child bands', childVisibleBands);
	                            if (childVisibleBands === 0) {
	                                removeBands();
	                            }
	                        }
	                        if (i % BATCH_RENDER_MIN_ROWS === 0) {
	                            if (new Date() - start > BATCH_RENDER_INTERVAL_MS) {
	                                // yield
	                                nextOffset = i + 1;
	                                return;
	                            }
	                        }
	                    }
	                    // Processed all rows
	                    done = true;
	                },

	                hasMore: function hasMore() {
	                    return !done;
	                },

	                visibleBands: function visibleBands() {
	                    return _visibleBands;
	                }
	            };
	        }

	        function get_linked_rows(level_def, depth, parent_row) {
	            var all_child_data = datasets[(level_def.data_source || '').toLowerCase()];
	            if (!(level_def.where_child_field && level_def.where_parent_field)) {
	                return all_child_data;
	            }
	            var cache_key = String(level_def.data_source + "-" + depth),
	                buckets = this.linked_data_index_cache[cache_key],
	                parent_linked_value = parent_row[level_def.where_parent_field],
	                child_value_key = level_def.where_child_field || "";
	            if (typeof parent_linked_value === "undefined") {
	                parent_linked_value = "";
	            }
	            parent_linked_value = String(parent_linked_value).toLowerCase();
	            if (!buckets) {
	                buckets = {};
	                for (var i = 0; i < all_child_data.length; i++) {
	                    var row = all_child_data[i],
	                        child_linked_value = row[child_value_key];
	                    if (typeof child_linked_value === "undefined") {
	                        child_linked_value = "";
	                    }
	                    child_linked_value = String(child_linked_value).toLowerCase();
	                    var bucket = buckets[child_linked_value];
	                    if (!bucket) {
	                        bucket = [];
	                        buckets[child_linked_value] = bucket;
	                    }
	                    bucket.push(row);
	                }
	                this.linked_data_index_cache[cache_key] = buckets;
	            }
	            return buckets[parent_linked_value] || [];
	        }

	        function group_rows(data, group_by, level_def, depth, report_def, parentGroupRow) {
	            var me = this,
	                matching_rows = [],
	                groups_by_key = {};
	            /** Propagate grouped values downward through groups for reference in formulas */
	            var parentGroupedFields = parentGroupRow ? _.object(Object.keys(parentGroupRow).filter(function (key) {
	                return key.indexOf('___') !== 0;
	            }).map(function (key) {
	                return [key, parentGroupRow[key]];
	            })) : {};
	            data.map(function (row) {
	                if (group_by.indexOf('=') === 0) {
	                    group_by = eval_calculation.call(me, group_by, row, null);
	                }
	                var key = String(row[group_by]).toLowerCase();
	                var group = groups_by_key[key];
	                if (!group) {
	                    group = _extends({}, parentGroupedFields, row, { // Group summary row gets non-grouped values from first row for later lookup
	                        "___children___": [],
	                        "___level___": depth
	                    });
	                    group[group_by] = row[group_by];
	                    groups_by_key[key] = group;
	                    matching_rows.push(group);
	                }
	                group["___children___"].push(row);
	            });
	            // Sort groups
	            if (level_def && level_def.sort_by) {
	                var sort_field_name = level_def.sort_by,
	                    asc = level_def.sort_dir !== "desc";
	                // Pull up the sort field from the first child since we don't yet support grouping on multiple fields
	                if (sort_field_name !== group_by) {
	                    for (var i = 0; i < matching_rows.length; i++) {
	                        var grouped_row = matching_rows[i],
	                            group_children = grouped_row["___children___"];
	                        if (group_children.length > 0) {
	                            grouped_row[sort_field_name] = group_children[0][sort_field_name];
	                        } else {
	                            grouped_row[sort_field_name] = null;
	                        }
	                    }
	                }
	                var group_sort_fn = get_sort_fn.call(this, report_def, data, this.active_schema, level_def.sort_by, asc);
	                if (group_sort_fn) {
	                    matching_rows.sort(group_sort_fn);
	                }
	            }
	            return matching_rows;
	        }

	        /**
	         * Operates on the final detail data, extracting and sorting all unique pivot values
	         */
	        function extract_pivot_columns(data, pivot_expr, bucket_fn, sort_by) {
	            var pivot_cols = [],
	                pivot_keys = {},
	                pivot_datatype = get_pivot_column_datatype.call(this, pivot_expr) || "string";
	            for (var i = 0; i < data.length; i++) {
	                var row = data[i],
	                    pivot_val = evaluate_string.call(this, pivot_expr, row, pivot_datatype === "date" ? "YYYY-MM-DD" : null);
	                if (typeof pivot_val === "undefined") {
	                    pivot_val = "";
	                }
	                var key = String(pivot_val).toLowerCase();
	                key = apply_pivot_bucket_fn.call(this, key, bucket_fn);
	                if (!pivot_keys[key]) {
	                    pivot_keys[key] = true;
	                    pivot_cols.push({
	                        key: key,
	                        sample_value: row[this.pivot_field_name],
	                        sort_val: get_pivot_column_sort_val.call(this, pivot_val, pivot_datatype)
	                    });
	                }
	                row["___pivot_key___"] = key;
	            }
	            if (pivot_cols.length > 1) {
	                switch (pivot_datatype) {
	                    case "number":
	                        pivot_cols.sort(function (a, b) {
	                            return a.sort_val - b.sort_val;
	                        });
	                        break;
	                    default:
	                        pivot_cols.sort(function (a, b) {
	                            return (a.sort_val || "").localeCompare(b.sort_val || "");
	                        });
	                        break;
	                }
	            }
	            return pivot_cols;
	        }

	        function apply_pivot_bucket_fn(key, bucket_fn) {
	            switch (bucket_fn) {
	                case "year":
	                    return key.substr(0, 4);
	                case "month":
	                    return key.substr(0, 7);
	                case "day":
	                    return key.substr(0, 10);
	            }
	            return key;
	        }

	        function get_pivot_column_sort_val(val, datatype) {
	            if (datatype === "number") {
	                return Number(val);
	            }
	            return val;
	        }

	        function get_pivot_column_datatype(pivot_expr) {
	            var datatype = null,
	                format = null;
	            var schema_field = get_schema_field_from_single_field_expression.call(this, pivot_expr);
	            if (schema_field) {
	                datatype = schema_field.type.toLowerCase();
	            }
	            return datatype;
	        }

	        function get_schema_field_from_single_field_expression(expr) {
	            if (this.active_schema && expr.substr(0, 1) === "[" && expr.substr(expr.length - 1, 1) === "]") {
	                return find_field_by_name.call(this, this.active_schema, expr.substr(1, expr.length - 2));
	            }
	            return null;
	        }

	        /**
	         * Render a single section, e.g. a header, detail, or footer, 
	         * from a single row (or grouped summary row)
	         */
	        function renderSection(section_def, $target, row, isPageHeaderOrFooter, rowIndex, depth) {
	            depth = depth || 0;
	            var props = section_def;
	            if (props.conditionalRules && props.conditionalRules.length > 0) {
	                props = _.extend({}, props);
	                evaluateConditionalRules.call(this, props, row);
	            }
	            var visible = true;
	            var visProp = props.visible;
	            if (visProp === false) {
	                visible = false;
	            } else if (typeof visProp === "string" && visProp.length > 1 && visProp.substr(0, 1) === "=") {
	                visible = evaluate_property_expression_boolean.call(this, visProp, row, "visible", true);
	            }
	            if (!visible) return null;
	            var deferred_render = [],
	                height = 0,
	                htmlDocument = ditto.window.document,
	                y_scale_factor = (this.def.yScaleAdjustment || 1) * this.pixels_per_unit,

	            // pending_height_adjustments = this.pending_height_adjustments,
	            element_adjustments = [],
	                sectionId = generate_section_instance_id(),
	                section = htmlDocument.createElement('div'),
	                initialSectionHeight = props.height * y_scale_factor,
	                $section = $(section).data({
	                'jsr-id': sectionId,
	                'jsr-depth': depth
	            }),
	                sectionInfo = {
	                section: section,
	                adjs: element_adjustments
	            },
	                i,
	                elt;
	            var classes = ['jsr-section'];
	            if (props.cssClass) {
	                classes.push(props.cssClass);
	            }
	            section.className = classes.join(' ');
	            if (!props.shrinkToFit) {
	                section.style.minHeight = initialSectionHeight + 'px';
	            }
	            section.style.top = this.sectionOffset + 'px';
	            if (isPageHeaderOrFooter && !this.showPageHeaderAndFooter) {
	                $section.addClass("jsr-print-only-section").data("section-height", section_def.height * y_scale_factor);
	                sectionInfo.printOnly = true;
	            } else {
	                this.sectionOffset += initialSectionHeight;
	            }
	            var pagebreaks = [];
	            for (i = 0; i < section_def.elements.length; i++) {
	                elt = section_def.elements[i];
	                // Store page-break positions in a data string on the section element, for use by PDF renderer
	                if (elt.type === 'break') {
	                    var everyNth = elt.everyNth || 1;
	                    if (rowIndex % everyNth === everyNth - 1) {
	                        pagebreaks.push(elt.top * y_scale_factor);
	                    }
	                    continue;
	                }
	                var rendered = render_element.call(this, elt, row, deferred_render);
	                if (!rendered) continue;
	                if (!Array.isArray(rendered)) {
	                    rendered = [rendered];
	                }
	                // var newDomEl = $newelt[0];
	                for (var _j = 0, rl = rendered.length; _j < rl; _j++) {
	                    var newEl = rendered[_j];
	                    section.appendChild(newEl.domEl);
	                    var renderedDef = newEl.elt;
	                    if (renderedDef.type === "text" && renderedDef.wrap !== false || renderedDef.type === 'subreport' || renderedDef.type === 'table' || renderedDef["fit_content"] === "vertical") {
	                        if (renderedDef.type === 'subreport') {
	                            sectionInfo.subreports = (sectionInfo.subreports || []).concat([newEl.domEl]);
	                        }
	                        element_adjustments.push(newEl);
	                    }
	                }
	            }
	            if (pagebreaks.length > 0) {
	                $section.data('page-breaks', pagebreaks);
	            }
	            if (this.pivot) {
	                var pivot_children_by_key = null;
	                var rows_for_key;
	                if (row) {
	                    pivot_children_by_key = row["___pivot_children_by_key___"];
	                    if (!pivot_children_by_key && row["___children___"]) {
	                        // Create dictionary of pivoted rows by pivot key
	                        var all_children = row["___children___"];
	                        pivot_children_by_key = {};
	                        for (i = 0; i < all_children.length; i++) {
	                            var childrow = all_children[i],
	                                key = childrow["___pivot_key___"];
	                            rows_for_key = pivot_children_by_key[key];
	                            if (!rows_for_key) {
	                                rows_for_key = [];
	                                pivot_children_by_key[key] = rows_for_key;
	                            }
	                            rows_for_key.push(childrow);
	                        }
	                    }
	                }
	                if (!pivot_children_by_key) {
	                    pivot_children_by_key = {};
	                }
	                for (i = 0; i < this.pivot_cols.length; i++) {
	                    var pivot_col = this.pivot_cols[i],
	                        pivot_context = {
	                        column_key: pivot_col.key,
	                        pivot_field: this.pivot_field_name
	                    },
	                        pivot_children = pivot_children_by_key[pivot_col.key] || [],
	                        temp_row = {
	                        "___children___": pivot_children
	                    };
	                    temp_row[this.pivot_field_name] = pivot_col.sample_value;
	                    for (var j = 0; j < section_def.pivot_els.length; j++) {
	                        elt = section_def.pivot_els[j];
	                        var _rendered = render_element.call(this, elt, temp_row, deferred_render, i * this.pivot_column_width, pivot_context);
	                        if (!_rendered) continue;
	                        if (!Array.isArray(_rendered)) {
	                            _rendered = [_rendered];
	                        }
	                        _rendered.forEach(function (renderedEl) {
	                            section.appendChild(renderedEl.domEl);
	                            if (elt.type === "text" && elt.wrap !== false || elt["fit_content"] === "vertical") {
	                                element_adjustments.push(renderedEl);
	                            }
	                        });
	                    }
	                }
	            }
	            this.sections.push(sectionInfo);
	            this.contentDomEl.appendChild(section);
	            for (var i = 0, len = deferred_render.length; i < len; i++) {
	                do_deferred_render.call(this, deferred_render[i]);
	            }
	            if (section_def.extraSections) {
	                for (var _i = 0; _i < section_def.extraSections.length; _i++) {
	                    renderSection.call(this, section_def.extraSections[_i], $target, row, isPageHeaderOrFooter, rowIndex, depth);
	                }
	            }
	            if (props.repeatEachPage) {
	                $section.data({ 'jsr-repeat-each-page': true });
	            }
	            if (props.canBreak === false) {
	                $section.data('jsr-no-break', true);
	            }
	            return $section;
	        }

	        /**
	         * Find x extents of all elements on a rendered HTML report (visible or offscreen),
	         * in order to create columns in Excel
	         */
	        function get_x_extents(target) {
	            var usedXs = {};
	            var sections = $(target).find('div.jsr-section');
	            for (var i = 0; i < sections.length; i++) {
	                var elts = sections.eq(i).find('.jsr-element, .jsr-table td, .jsr-table th');
	                for (var j = 0; j < elts.length; j++) {
	                    var elt = elts.eq(j);
	                    if (elt.hasClass('jsr-table')) continue;
	                    var tagname = elt.prop('tagName').toLowerCase();
	                    var leftPx = elt.position().left;
	                    if (tagname === 'td' || tagname === 'th') {
	                        leftPx += elt.closest('.jsr-table').position().left;
	                    }
	                    var leftRounded = Math.round(leftPx / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	                    var rightRounded = Math.round((leftPx + elt.outerWidth()) / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	                    usedXs[leftRounded] = true;
	                    usedXs[rightRounded] = true;
	                }
	            }
	            return Object.keys(usedXs).map(function (str_num) {
	                return parseInt(str_num, 10);
	            }).sort(sort_numbers);
	        }

	        function get_excel_columns(x_extents, canvas_width) {
	            var col_dividers = x_extents;
	            // If there were no elements at the left edge, make explicit a leftmost column at zero
	            if (col_dividers[0] !== 0) {
	                col_dividers.splice(0, 0, 0);
	            }
	            var rounded_canvas_width = Math.ceil(canvas_width / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	            if (col_dividers[col_dividers.length - 1] < rounded_canvas_width) {
	                col_dividers.push(rounded_canvas_width);
	            }
	            return col_dividers.slice(0, col_dividers.length - 1).map(function (x, index) {
	                return {
	                    x_px: x,
	                    width: (col_dividers[index + 1] - x) * EXCEL_WIDTH_UNITS_PER_PX
	                };
	            });
	        }

	        function sort_numbers(a, b) {
	            return a - b;
	        }

	        function get_excel_rows(section) {
	            var rows = [];
	            var usedYs = {};
	            var elts = section.find('.jsr-element, .jsr-table td, .jsr-table th');
	            for (var j = 0; j < elts.length; j++) {
	                var elt = elts.eq(j);
	                if (elt.hasClass('jsr-table')) continue;
	                var tagname = elt.prop('tagName').toLowerCase();
	                var top = elt.position().top;
	                if (tagname === 'td' || tagname === 'th') {
	                    top += elt.closest('.jsr-table').position().top;
	                }
	                var roundedTop = Math.round(top / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	                var roundedBottom = Math.round((top + elt.outerHeight()) / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	                usedYs[roundedTop] = true;
	                usedYs[roundedBottom] = true;
	            }
	            var row_dividers = Object.keys(usedYs).map(function (str_num) {
	                return parseInt(str_num, 10);
	            }).sort(sort_numbers);
	            // Add top and bottom edges of section if not already present
	            if (row_dividers[0] !== 0) {
	                row_dividers.splice(0, 0, 0);
	            }
	            var section_height = Math.ceil(section.outerHeight() / EXCEL_RESOLUTION_PX) * EXCEL_RESOLUTION_PX;
	            if (row_dividers[row_dividers.length - 1] < section_height) {
	                row_dividers.push(section_height);
	            }
	            return row_dividers.slice(0, row_dividers.length - 1).map(function (y, index) {
	                return {
	                    y_px: y,
	                    height: (row_dividers[index + 1] - y) * EXCEL_WIDTH_UNITS_PER_PX
	                };
	            });
	        }

	        function getExpressionFunctions() {
	            var _this4 = this;

	            var me = this;
	            var builtIns = {
	                FORMAT: function FORMAT(val, formatStr) {
	                    return formatJSValue.call(_this4, val, formatStr);
	                },
	                DATE: function DATE(str, format) {
	                    if (!str) return new Date();
	                    var parsed = null;
	                    try {
	                        parsed = moment(str, format || DEFAULT_DATE_PARSE_FORMAT).toDate();
	                    } catch (e) {}
	                    return parsed;
	                },
	                TRANSLATE: function TRANSLATE(templateStr) {
	                    // Fall back to passed template if no translation found
	                    var translatedTemplate = templateStr;
	                    if (!this.translations) {
	                        translatedTemplate = this.translations[templateStr] || translatedTemplate;
	                    }
	                    var args = arguments;
	                    return translatedTemplate.replace(/{(\d+)}/gim, function (match, g1) {
	                        return args[Number(g1) + 1];
	                    });
	                },
	                FINDDATA: function FINDDATA(fieldName) {
	                    var val = scope[fieldName];
	                    if (typeof val !== 'undefined') return val;
	                    for (var i = this.rowStack.length - 1; i >= 0; i--) {
	                        val = this.rowStack[i][fieldName];
	                        if (val) return val;
	                    }
	                    return null;
	                },
	                /** Find a value in a data source column and return that row */
	                LOOKUP: function LOOKUP(targetValue, dataSourceId, fieldName, outputFieldName) {
	                    var table = datasets[(dataSourceId || '').toLowerCase()];
	                    if (!table) {
	                        console.warn('ERROR: Couldn\'t find data source "' + dataSourceId + '" referenced by LOOKUP formula');
	                    }
	                    // console.log(`searching for ${targetValue} in ${dataSourceId}.${fieldName}`);
	                    for (var i = 0; i < table.length; i++) {
	                        var row = table[i];
	                        var _val2 = row[fieldName];
	                        if (typeof _val2 !== 'undefined' && _val2 === targetValue) {
	                            // console.log(`found row matching ${fieldName}, returning`, row);
	                            // console.log('returning', (typeof outputFieldName !== 'undefined' ? 
	                            // row[outputFieldName] : row));
	                            return typeof outputFieldName !== 'undefined' ? row[outputFieldName] : row;
	                        }
	                    }
	                    return null;
	                },
	                EVAL: function EVAL(expr) {
	                    return evalJSExpression.call(me, expr, this);
	                },
	                CHILDROWS: function CHILDROWS() {
	                    var childRows = this['___children___'];
	                    return childRows || [];
	                }
	            };
	            AGGREGATE_NAMES.forEach(function (aggName) {
	                builtIns[aggName.toUpperCase()] = function (fieldName) {
	                    return compute_aggregate.call(_this4, aggName, fieldName, _this4.currentAggregateDomain);
	                };
	            });
	            return $.extend(builtIns, this.customFunctions || {});
	        }

	        /**
	         * Evaluates a JavaScript expression against a data row.  Used to evaluate
	         * dynamic element properties.
	         */
	        function evaluate_property_expression(expr, scope) {
	            var returnVal = undefined;
	            try {
	                returnVal = evalJSExpression.call(this, expr, scope);
	            } catch (e) {
	                console.error(e);
	            }
	            return returnVal;
	        }

	        function evaluate_property_expression_boolean(expr, scope, name, defaultVal) {
	            var val = defaultVal;
	            try {
	                val = Boolean(evaluate_property_expression.call(this, expr.substr(1), scope));
	            } catch (e) {
	                printError("Failed to evaluate expression for \"" + name + "\" property: " + expr + ", error was: " + e);
	            }
	            return val;
	        }

	        function evaluate_property_expression_string(expr, scope, name, defaultVal) {
	            var val = defaultVal;
	            try {
	                val = String(evaluate_property_expression.call(this, expr.substr(1), scope));
	            } catch (e) {
	                printError("Failed to evaluate expression for \"" + name + "\" property: " + expr + ", error was: " + e);
	            }
	            return val;
	        }

	        function evaluate_property_expression_number(expr, scope, name, defaultVal) {
	            var val = defaultVal;
	            try {
	                val = Number(evaluate_property_expression.call(this, expr.substr(1), scope));
	            } catch (e) {
	                printError("Failed to evaluate expression for \"" + name + "\" property: " + expr + ", error was: " + e);
	            }
	            return val;
	        }

	        /**
	         * When font scaling is enabled, figure out the scaling ratio, which is
	         * the ratio of (pixels per "inch" [logical report inch] / actual device ppi)
	         * Since we can't know actual device ppi, use the next best thing which is the
	         * standard 96
	         * (This scales fonts to fit the rendered page on screen)
	         */
	        function getFontScaleFactor() {
	            if (this.fontScaleFactor) return this.fontScaleFactor;
	            if (this.scaleFonts === false) {
	                this.fontScaleFactor = 1;
	                return this.fontScaleFactor;
	            }
	            var basePPI = 96;
	            var ppi = this.pixels_per_unit * (this.def.page.units === 'inches' ? 1 : 25.4);
	            return this.fontScaleFactor = ppi / basePPI;
	        }

	        /**
	         * Applies conditional rules, replacing existing property values
	         */
	        function evaluateConditionalRules(props, row) {
	            var _this5 = this;

	            var rules = props.conditionalRules;
	            var changed = false;
	            rules.forEach(function (rule) {
	                var matchedAll = true;
	                for (var i = 0; i < rule.conditions.length; i++) {
	                    var cond = rule.conditions[i];
	                    var matched = false;
	                    var fieldVal = void 0;
	                    var operand = cond.operand;
	                    if (typeof cond.field === 'string' && cond.field.substr(0, 1) === '=') {
	                        fieldVal = evaluate_property_expression.call(_this5, cond.field.substr(1), row);
	                    } else {
	                        fieldVal = getFieldValue(row, cond.field);
	                    }
	                    if (typeof operand === 'string' && operand.substr(0, 1) === '=') {
	                        operand = evaluate_property_expression.call(_this5, operand.substr(1), row);
	                    }
	                    // If we have a number-type data value and a string operand containing a number,
	                    // assume a numeric comparison is wanted
	                    if (typeof fieldVal === 'number' && typeof operand === 'string') {
	                        var parsedNum = Number(operand);
	                        if (!isNaN(parsedNum)) {
	                            operand = parsedNum;
	                        }
	                    }
	                    // console.log('condrule: test', cond.field, fieldVal, 
	                    //     typeof fieldVal, cond.operator, cond.operand,
	                    //     'matches?', matchesAny.call(this, cond.operator, [ cond.operand ], fieldVal));
	                    if (!matchesAny.call(_this5, cond.operator, [operand], fieldVal)) {
	                        matchedAll = false;
	                        // console.log(`[ ] cond rule did NOT match - tested value "${cond.field}": ${fieldVal} (${typeof fieldVal}) against "${cond.operator}" "${cond.operand}" (${typeof cond.operand})`);
	                        break;
	                    }
	                    // console.log(`[X] cond rule DID match - tested value "${cond.field}": ${fieldVal} (${typeof fieldVal}) against "${cond.operator}" "${cond.operand}" (${typeof cond.operand})`);
	                }
	                if (matchedAll) {
	                    // console.log(`rule matched all - applying effects ${JSON.stringify(rule.effects, null, 2)}`);
	                    // Apply effects
	                    rule.effects.forEach(function (effect) {
	                        var value = effect.value;
	                        if (typeof value === 'string' && value.substr(0, 1) === '=') {
	                            value = evaluate_property_expression.call(_this5, value.substr(1), row);
	                        }
	                        props[effect.property] = value;
	                        changed = true;
	                    });
	                }
	            });
	            if (changed) {
	                // Update width_px etc in case dimensions, position changed
	                set_element_px_pos.call(this, props, this.pixels_per_unit, this.def.yScaleAdjustment || 1);
	            }
	        }

	        function getStringPropertyValue(eltProps, propName, dataRow, defaultValue) {
	            var val = eltProps[propName];
	            if (typeof val === "string" && val.length > 1 && val.substr(0, 1) === "=") {
	                val = evaluate_property_expression_string.call(this, val, dataRow, propName, defaultValue);
	            }
	            return val;
	        }

	        function render_element(elt, row, deferred_render, left_offset, pivot_context) {
	            var _this6 = this;

	            var htmlDocument = ditto.window.document;
	            var $elt,
	                left_margin_px = this.margins_px.left;
	            var props = elt;
	            if (props.conditionalRules && props.conditionalRules.length > 0) {
	                props = _.extend({}, props);
	                evaluateConditionalRules.call(this, props, row);
	            }
	            var swapDimensions = false;
	            var visProp = props.visible;
	            if (visProp === false) {
	                return null;
	            } else if (typeof visProp === "string" && visProp.length > 1 && visProp.substr(0, 1) === "=") {
	                var visible = evaluate_property_expression_boolean.call(this, visProp, row, "visible", true);
	                if (!visible) {
	                    return null;
	                }
	            }
	            var elData = {
	                'jsr-def': props
	            };
	            var calcProps = ['left', 'top', 'width', 'height'];
	            for (var i = 0; i < calcProps.length; i++) {
	                var propKey = calcProps[i];
	                var prop = props[propKey];
	                if (typeof prop === 'string' && prop.length > 0 && prop[0] === '=') {
	                    // eval calculated position
	                    var propVal = evaluate_property_expression_number.call(this, prop, row, propKey, 0);
	                    props[propKey] = propVal;
	                    props[propKey + '_px'] = propVal * this.pixels_per_unit;
	                }
	            }
	            var leftPx = props.left_px;
	            var topPx = props.top_px;
	            if (props.type.indexOf("chart_") === 0) {
	                $elt = $("<div>").addClass("jsr-element jsr-chart");
	                $elt.width(props.width_px).height(props.height_px);
	                deferred_render.push({ fn: render_chart, args: [props, $elt, row] });
	            } else {
	                switch (props.type) {
	                    case "text":
	                        var textEl = htmlDocument.createElement('div');
	                        textEl.className = 'jsr-element jsr-text';
	                        $elt = $(textEl);
	                        var fontsize = 'inherit';
	                        if (props.fontsize) {
	                            if (this.scaleFonts === false) {
	                                fontsize = props.fontsize + 'pt';
	                            } else {
	                                var dFontsize = parseFloat(props.fontsize);
	                                fontsize = (dFontsize * getFontScaleFactor.call(this)).toFixed(2) + 'pt';
	                                elData['font-size'] = dFontsize;
	                            }
	                        }
	                        textEl.style.fontStyle = props.italic ? "italic" : "normal";
	                        textEl.style.textDecoration = props.underline ? "underline" : "none";
	                        textEl.style.textAlign = props.align || "left";
	                        textEl.style.fontSize = fontsize;
	                        textEl.style.fontFamily = props.font ? props.font.css : "inherit";
	                        if (props.font) {
	                            ditto.requireWebFont(props.font.name || props.font.css);
	                        }
	                        if (props.bold) {
	                            var bold = props.bold;
	                            if (typeof bold === "string" && bold.length > 1 && bold.substr(0, 1) === "=") {
	                                bold = evaluate_property_expression_boolean.call(this, bold, row, "bold", null);
	                            }
	                            textEl.style.fontWeight = bold ? "bold" : "normal";
	                        }
	                        if (props.text_color) {
	                            var textColor = getStringPropertyValue.call(this, props, 'text_color', row, null);
	                            if (textColor !== null) {
	                                textEl.style.color = textColor;
	                            }
	                        }
	                        if (props.background_color) {
	                            var backgroundColor = getStringPropertyValue.call(this, props, 'background_color', row, null);
	                            if (backgroundColor !== null) {
	                                textEl.style.backgroundColor = backgroundColor;
	                            }
	                        }
	                        textEl.style.whiteSpace = props.wrap === false ? 'nowrap' : 'pre-line';
	                        var rawText = evaluate_string.call(this, props.text, row, props.pattern || null, pivot_context);
	                        if (props.__hasPageNumber) {
	                            $elt.data('jsr-text-template', rawText);
	                            rawText = rawText.replace('{{JSR_PRINT_PAGE_NUMBER}}', '1').replace('{{JSR_PRINT_PAGE_COUNT}}', '1');
	                        }
	                        if (props.syntax === 'markdown') {
	                            $elt.html(markdownToHtml.call(this, rawText)).addClass('jsr-markdown');
	                        } else if (props.syntax === 'html') {
	                            $elt.html(rawText).addClass('jsr-html');
	                        } else {
	                            rawText = rawText.replace(/\\n/gim, '\n');
	                            textEl.appendChild(htmlDocument.createTextNode(rawText));
	                        }
	                        if (props.fit_text) {
	                            this.pending_text_fits.push({
	                                el: $elt,
	                                multiLine: props.wrap !== false
	                            });
	                            $elt.css("visibility", "hidden");
	                        }
	                        if (props.rotateDegrees) {
	                            $elt.addClass('jsr-text-rotate-' + props.rotateDegrees);
	                            $elt.data('jsr-text-rotate', props.rotateDegrees);
	                            if (props.rotateDegrees === 90) {
	                                leftPx += props.width_px;
	                                swapDimensions = true;
	                            } else if (props.rotateDegrees === -90) {
	                                topPx += props.height_px;
	                                swapDimensions = true;
	                            }
	                        }
	                        break;
	                    case "image":
	                        var url = evaluate_string.call(this, props.url || '', row, props.pattern || null, pivot_context);
	                        if (url.substr(0, 5) !== 'data:') {
	                            url = this.imageUrlPrefix + url;
	                        }
	                        var imgWrapEl = htmlDocument.createElement('div');
	                        imgWrapEl.className = 'jsr-element jsr-image';
	                        var imgEl = htmlDocument.createElement('img');
	                        imgEl.src = url;
	                        imgWrapEl.appendChild(imgEl);
	                        $elt = $(imgWrapEl)
	                        // .addClass("jsr-element jsr-image")
	                        .data("image-url", url);
	                        // .css("background-image", "url(" + url + ")");
	                        break;
	                    case "box":
	                        var boxEl = htmlDocument.createElement('div');
	                        boxEl.className = 'jsr-element jsr-box';
	                        boxEl.style.backgroundColor = getStringPropertyValue.call(this, props, 'background_color', row, 'transparent');
	                        boxEl.style.borderColor = getStringPropertyValue.call(this, props, 'border_color', row, 'transparent');
	                        boxEl.style.borderRadius = (props.corner_radius || 0) + "px";
	                        boxEl.style.borderStyle = "solid";
	                        var borderThicknessPts = 1;
	                        if (typeof props.borderThickness !== 'undefined') {
	                            borderThicknessPts = props.borderThickness;
	                        }
	                        boxEl.style.borderWidth = borderThicknessPts + 'pt';
	                        $elt = $(boxEl);
	                        break;
	                    case "barcode":
	                        $elt = $('<div class="jsr-element jsr-barcode"></div>');
	                        render_barcode.call(this, $elt, props, row, pivot_context);
	                        break;
	                    case 'break':
	                        // Do nothing; these are handled in render_section and not rendered
	                        return;
	                    case 'subreport':
	                        var subreportEl = htmlDocument.createElement('div');
	                        subreportEl.className = 'jsr-element jsr-subreport';
	                        subreportEl.style.marginTop = props.top_px + 'px';
	                        subreportEl.style.left = this.relative_x ? (left * this.pct_per_px).toFixed(2) + "%" : left + 'px';
	                        subreportEl.style.width = this.relative_x ? (props.width_px * this.pct_per_px).toFixed(2) + "%" : props.width_px + 'px';
	                        subreportEl.style.height = 'auto';
	                        $elt = $(subreportEl);
	                        deferred_render.push({ fn: renderSubreport.bind(this), args: [props, $elt, row] });
	                        break;
	                    case 'table':
	                        $elt = $('<div class="jsr-element jsr-table"></div>');
	                        $elt.css('min-height', props.height_px);
	                        render_table.call(this, $elt, props, row, pivot_context);
	                        break;
	                    default:
	                        var elClass = this.elementTypes[props.type.toLowerCase()];
	                        if (!elClass) {
	                            return console.error('Unrecognized element type:', props.type);
	                        }
	                        /** Eval all formula properties */
	                        var propKeys = Object.keys(elClass.propTypes);
	                        var props = Object.assign({}, props);
	                        var inst = new elClass(props);
	                        inst.getDataSource = getDataSourceForCustomElement.bind(this, row);
	                        for (var propKeyIx = 0; propKeyIx < propKeys.length; propKeyIx++) {
	                            var _propKey = propKeys[propKeyIx];
	                            var _propVal = inst.props[_propKey];
	                            if (typeof _propVal === 'string' && _propVal.indexOf('=') === 0) {
	                                var type = elClass.propTypes[_propKey];
	                                var evalFn = null;
	                                switch (type) {
	                                    case _ReportElement.PropTypes.number:
	                                        evalFn = evaluate_property_expression_number;
	                                        break;
	                                    case _ReportElement.PropTypes.string:
	                                        evalFn = evaluate_property_expression_string;
	                                        break;
	                                    case _ReportElement.PropTypes.boolean:
	                                        evalFn = evaluate_property_expression_boolean;
	                                        break;
	                                    default:
	                                        continue;
	                                }
	                                inst.props[_propKey] = evalFn.call(this, _propVal, row, _propKey, elClass.defaultProps[_propKey]);
	                            }
	                        }
	                        if (elClass.isComposite) {
	                            /** Composite element is replaced by its children */
	                            return inst.getChildElementDefinitions().map(function (childEl) {
	                                childEl.left += props.left;
	                                childEl.top += props.top;
	                                set_element_px_pos.call(_this6, childEl, _this6.pixels_per_unit, _this6.def.yScaleAdjustment || 1);
	                                return render_element.call(_this6, childEl, row, deferred_render, left_offset, pivot_context);
	                            });
	                        } else {
	                            $elt = $('<div class="jsr-element jsr-custom-element jsr-' + props.type + '"></div>');
	                            $elt.html(inst.getHtml());
	                        }
	                        break;
	                }
	            }
	            if (!$elt) {
	                throw new Error('Unrecognized element type: ' + props.type);
	            }
	            if (props.styles) {
	                $elt.addClass(props.styles);
	            }
	            $elt.data(elData);
	            var left = leftPx + left_margin_px + (left_offset || 0);
	            var domEl = $elt[0];
	            domEl.style.marginTop = topPx + 'px';
	            domEl.style.left = this.relative_x ? (left * this.pct_per_px).toFixed(2) + "%" : left + 'px';
	            var widthPx = props.width_px;
	            var heightPx = props.height_px;
	            if (swapDimensions) {
	                widthPx = props.height_px;
	                heightPx = props.width_px;
	            }
	            domEl.style.width = this.relative_x ? (widthPx * this.pct_per_px).toFixed(2) + "%" : widthPx + 'px';
	            if (props.type === 'table' || props.type === 'subreport') {
	                domEl.style.height = 'auto';
	            } else if (props.fit_content === "vertical") {
	                domEl.style.height = 'auto';
	                domEl.style.minHeight = heightPx + 'px';
	            } else {
	                domEl.style.height = heightPx + 'px';
	            }
	            if (props.zIndex) {
	                domEl.style.zIndex = Number(props.zIndex);
	            }
	            if (inst && inst.afterRender) {
	                inst.afterRender(domEl);
	                if (this.renderingToPDF && inst.convertToPDF) {
	                    // Note have to render to outer target here because contentDomEl is not attached
	                    // Replace initial rendering with primitive elements for PDF
	                    var primitiveElDefs = inst.convertToPDF(domEl);
	                    return primitiveElDefs.map(function (childEl) {
	                        childEl.left += props.left;
	                        childEl.top += props.top;
	                        set_element_px_pos.call(_this6, childEl, _this6.pixels_per_unit, _this6.def.yScaleAdjustment || 1);
	                        return render_element.call(_this6, childEl, row, deferred_render, left_offset, pivot_context);
	                    });
	                }
	            }
	            return {
	                domEl: domEl,
	                elt: props
	            };
	        }

	        function renderSubreport(eltDef, $elt, dataRow) {
	            if (!eltDef.report) return;
	            ditto.subreportcount = (ditto.subreportcount || 0) + 1;
	            var root = this.isSubreport ? this.root : this;
	            var subreportWidthCss = $elt[0].style.width;
	            var subreportWidthPx = parseFloat(subreportWidthCss);
	            if (subreportWidthCss.indexOf('%') > -1) {
	                subreportWidthPx /= this.pct_per_px;
	            }
	            var newViewer = {
	                isSubreport: true,
	                viewerId: ++viewerId,
	                depth: (this.isSubreport ? this.depth : 0) + 1,
	                root: root,
	                targetWidth: subreportWidthPx,
	                imageUrlPrefix: this.imageUrlPrefix,
	                translations: this.translations,
	                settings: this.settings,
	                rowStack: this.rowStack.concat([dataRow]),
	                customElements: this.customElements,
	                customFunctions: this.customFunctions
	            };
	            root.allSubreportViewers.push(newViewer);
	            if (eltDef.linkFields && dataRow) {
	                var filterValue = dataRow[eltDef.linkParentField];
	                if (typeof filterValue === 'undefined') {
	                    filterValue = '';
	                }
	                newViewer.subreportFilter = {
	                    field: eltDef.linkChildField,
	                    operand: filterValue,
	                    operator: 'is'
	                };
	            }
	            this.subreportsRendering = (this.subreportsRendering || 0) + 1;
	            $(newViewer).on('report_rendered', onSubreportRendered.bind(this));
	            render_report.call(newViewer, eltDef.report, $elt, true);
	        }

	        function onSubreportRendered() {
	            if (--this.subreportsRendering === 0) {
	                $(this).trigger('subreports_rendered');
	            }
	        }

	        // Convert a *1-based* row and cell index to A1, C3, etc.
	        function get_excel_cell_name(row_ix, col_ix) {
	            var dividend = col_ix,
	                col_alpha = "",
	                modulus;
	            while (dividend > 0) {
	                modulus = (dividend - 1) % 26;
	                col_alpha = String.fromCharCode(65 + modulus) + col_alpha;
	                dividend = Math.floor((dividend - modulus) / 26);
	            }
	            return col_alpha + String(row_ix);
	        }

	        function convert_element_to_excel(elt, elt_def, excel_row, excel_row_ix, excel_start_col_ix, excel_end_col_ix) {
	            var url, pic, picRef;
	            switch (elt_def.type) {
	                case "text":
	                    var excel_formatter = this.excel_styles_by_elt_id[elt_def.id];
	                    if (!excel_formatter) {
	                        var font_style = {
	                            bold: !!elt_def.bold,
	                            underline: !!elt_def.underline,
	                            italic: !!elt_def.italic
	                        };
	                        if (elt_def.fontsize) {
	                            font_style.size = elt_def.fontsize;
	                        }
	                        if (elt_def.font && elt_def.font.name) {
	                            font_style.fontName = elt_def.font.name;
	                        }
	                        if (elt_def.text_color) {
	                            font_style.color = elt_def.text_color.replace('#', '');
	                        }
	                        var format_cfg = {
	                            font: font_style,
	                            alignment: {
	                                wrapText: true,
	                                vertical: 'top'
	                            }
	                        };
	                        if (elt_def.pattern) {
	                            format_cfg.format = elt_def.pattern;
	                        }
	                        if (elt_def.align) {
	                            format_cfg.alignment.horizontal = elt_def.align;
	                        }
	                        excel_formatter = this.excel_stylesheet.createFormat(format_cfg);
	                        this.excel_styles_by_elt_id[elt_def.id] = excel_formatter;
	                    }
	                    excel_row[excel_start_col_ix] = {
	                        value: elt.text(),
	                        metadata: {
	                            style: excel_formatter.id,
	                            type: 'string',
	                            align: elt_def.align || null,
	                            endCol: excel_end_col_ix
	                        }
	                    };
	                    break;
	                case "image":
	                    if (!this.excel_drawings) {
	                        this.excel_drawings = new ExcelDrawings();
	                    }
	                    this.excelImageCount = (this.excelImageCount || 0) + 1;
	                    url = elt.data('image-url');
	                    var jpegDataUri = ditto.imageToDataUri(url);
	                    jpegDataUri = jpegDataUri.substr(jpegDataUri.indexOf(',') + 1);
	                    picRef = this.excel_workbook.addMedia('image', String(this.excelImageCount) + '.jpg', jpegDataUri);
	                    pic = new ExcelDrawingsPicture();
	                    // Adjust height to preserve aspect ratio by default, regardless of the element height
	                    var tmpImage = new Image();
	                    tmpImage.src = url;
	                    var naturalAspectRatio = tmpImage.width / tmpImage.height;
	                    pic.createAnchor('oneCellAnchor', {
	                        x: excel_start_col_ix,
	                        y: excel_row_ix,
	                        width: ExcelPositioning.pixelsToEMUs(elt_def.width_px), //* EXCEL_WIDTH_UNITS_PER_PX, // ditto.ExcelPositioning.pixelsToEMUs(elt.width_px),
	                        height: ExcelPositioning.pixelsToEMUs(elt_def.width_px / naturalAspectRatio) //elt.height_px * EXCEL_WIDTH_UNITS_PER_PX //ditto.ExcelPositioning.pixelsToEMUs(elt.height_px)
	                    });
	                    pic.setMedia(picRef);
	                    this.excel_drawings.addDrawing(pic);
	                    break;
	                case "box":
	                    break;
	                case "barcode":
	                    break;
	                case "chart_line":
	                /* falls through */
	                case "chart_bar":
	                /* falls through */
	                case "chart_pie":
	                    if (!this.excel_drawings) {
	                        this.excel_drawings = new ExcelDrawings();
	                    }
	                    this.excelImageCount = (this.excelImageCount || 0) + 1;
	                    var chartDataUri = ditto.svgToDataUri(elt.find('svg')[0], elt_def.width_px, elt_def.height_px, 'jpg');
	                    chartDataUri = chartDataUri.substr(chartDataUri.indexOf(',') + 1);
	                    picRef = this.excel_workbook.addMedia('image', String(this.excelImageCount) + '.jpg', chartDataUri);
	                    pic = new ExcelDrawingsPicture();
	                    pic.createAnchor('oneCellAnchor', {
	                        x: excel_start_col_ix,
	                        y: excel_row_ix,
	                        width: ExcelPositioning.pixelsToEMUs(elt_def.width_px),
	                        height: ExcelPositioning.pixelsToEMUs(elt_def.height_px)
	                    });
	                    pic.setMedia(picRef);
	                    this.excel_drawings.addDrawing(pic);
	                    break;
	                case "table":

	                    break;
	            }
	        }

	        function force_load_all_images($container, done) {
	            var loading = 0;
	            var uniqueSrcs = {};
	            function onImageDoneLoading() {
	                if (--loading === 0) {
	                    done.call(this);
	                }
	            }
	            var $imgs = $container.find('div.jsr-image');
	            if ($imgs.length > 0) {
	                $imgs.each(function (index, img) {
	                    var imgUrl = $(img).data("image-url");
	                    if (uniqueSrcs[imgUrl]) return;
	                    var tmpImage = new Image();
	                    tmpImage.onload = onImageDoneLoading;
	                    tmpImage.onerror = onImageDoneLoading;
	                    loading++;
	                    tmpImage.src = imgUrl;
	                    uniqueSrcs[imgUrl] = true;
	                });
	            } else {
	                done.call(this);
	            }
	        }

	        function render_barcode($elt, elt_def, row, pivot_context) {
	            var type = elt_def.barcode_type,
	                width = elt_def.width_px,
	                height = elt_def.height;
	            $elt.empty().removeClass("qrcode");
	            if (type === "QR") {
	                // QR code wants to be rendered directly into a <div>
	                var min_dimension = Math.min(width, height);
	                new QRCode($elt[0], {
	                    text: evaluate_string.call(this, elt_def.value, row, null, pivot_context),
	                    width: min_dimension,
	                    height: min_dimension
	                });
	                $elt.addClass("qrcode");
	            } else {
	                // JSBarcode expects an <img>
	                var $img = $('<img>');
	                $elt.append($img);
	                var val = evaluate_string.call(this, elt_def.value, row, null, pivot_context);
	                $img.JsBarcode(val, {
	                    format: type,
	                    displayValue: !!elt_def.show_value,
	                    fontSize: Math.max(12, Math.floor(height / 3))
	                }, function (is_valid) {
	                    if (!is_valid) {
	                        $img.remove();
	                        $elt.addClass("jsr-invalid-barcode");
	                        $elt.text(t("Data not valid for barcode format: {format}", { format: val }));
	                    }
	                });
	            }
	        }

	        function prevent_subreport_overlap(subreportDomEls) {
	            var count = subreportDomEls.length;
	            if (count < 2) return;
	            var posns = [];
	            var moved = {};
	            var lastOverlapsFound = 1;
	            var previousOverlapsFound = -1;
	            var defs = [];
	            for (var i = 0, len = subreportDomEls.length; i < len; i++) {
	                defs[defs.length] = $(subreportDomEls[i]).data('jsr-def');
	            }
	            while (lastOverlapsFound > 0 && lastOverlapsFound !== previousOverlapsFound) {
	                previousOverlapsFound = lastOverlapsFound;
	                lastOverlapsFound = 0;
	                for (var si = 0; si < count; si++) {
	                    for (var sj = 0; sj < count; sj++) {
	                        if (si !== sj) {
	                            var iEl = subreportDomEls[si];
	                            var jEl = subreportDomEls[sj];
	                            var iDef = defs[si];
	                            var jDef = defs[sj];
	                            var ipos = posns[si] || (posns[si] = get_element_pos(iEl, iDef));
	                            var jpos = posns[sj] || (posns[sj] = get_element_pos(jEl, jDef));
	                            if (!(ipos.left + ipos.width < jpos.left || jpos.left + jpos.width < ipos.left || ipos.top + ipos.height < jpos.top || jpos.top + jpos.height < ipos.top)) {
	                                // Overlap
	                                lastOverlapsFound++;
	                                if (iDef.top_px >= jDef.top_px) {
	                                    posns[si].top = jpos.top + jpos.height + 1;
	                                    moved[si] = true;
	                                } else {
	                                    posns[sj].top = ipos.top + ipos.height + 1;
	                                    moved[sj] = true;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            var movedIxes = Object.keys(moved);
	            var moves = [];
	            var maxBottom = 0;
	            for (var i = 0; i < movedIxes.length; i++) {
	                var ix = Number(movedIxes[i]);
	                moves.push({
	                    el: subreportDomEls[ix],
	                    top: posns[ix].top
	                });
	                maxBottom = Math.max(maxBottom, posns[ix].top + posns[ix].height);
	                // subreportDomEls[ix].style.top = String(posns[ix].top) + 'px';
	            }
	            return moves ? {
	                moves: moves,
	                maxBottom: maxBottom
	            } : null;
	        }

	        function get_element_pos(el, def) {
	            return {
	                top: def.top_px,
	                left: def.left_px,
	                width: el.offsetWidth,
	                height: el.offsetHeight
	            };
	        }

	        function formatJSValue(val, formatStr) {
	            var jsType = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	            switch (jsType.toLowerCase()) {
	                case "number":
	                    return format_number(val, formatStr);
	                case "object":
	                    if (val instanceof Date) {
	                        return format_date(val, formatStr);
	                    }
	                /** falls through */
	                default:
	                    return format_string_default(val);
	            }
	        }

	        /** Single-quote an unquoted fieldname inside an aggregate in an expression */
	        function replaceUnquotedFieldNames(expr) {
	            return expr.replace(UNQUOTED_AGGREGATE_FIELDNAME_REGEX, function (match, g1, g2) {
	                return g1 + '(\'' + g2 + '\')';
	            });
	        }

	        /** Evaluate an expression, e.g. "=2 * BillingRate", returning a string */
	        function eval_calculation(expr, row, format_str, rootData) {
	            var me = this;
	            expr = expr.substr(1);
	            var val = null;
	            try {
	                var evaluation_result = evalJSExpression.call(this, expr, row, rootData);
	                val = formatJSValue.call(this, evaluation_result, format_str);
	            } catch (e) {
	                var err = String(e);
	                if (err.indexOf("Error: ") === 0) {
	                    err = err.substring(7);
	                }
	                val = "ERROR: " + err;
	            }
	            return val;
	        }

	        function evalJSExpression(expr, scope, rootData) {
	            var compiled_fn = this.compiled_js_expressions[expr];
	            if (!this.expressionFunctions) {
	                this.expressionFunctions = getExpressionFunctions.call(this);
	            }
	            var keys = Object.keys(scope);
	            for (var i = 0; i < keys.length; i++) {
	                var key = keys[i];
	                var safeKey = key.replace(/\W+/g, '_');
	                if (key !== safeKey) {
	                    scope[safeKey] = scope[key];
	                }
	            }
	            this.currentAggregateDomain = scope['___children___'] || rootData || [];
	            var extendedScope = $.extend({
	                settings: this.settings || {},
	                _PARAMS: this.current_input_values || {}
	            }, this.current_input_values || {}, scope, this.expressionFunctions);
	            if (!compiled_fn) {
	                expr = replaceUnquotedFieldNames(expr);
	                compiled_fn = new Function("with (this) { return (" + expr + "); }");
	                this.compiled_js_expressions[expr] = compiled_fn;
	            }
	            return compiled_fn.call(extendedScope);
	        }

	        /** Extract a single field name or dot-separated subfield from a row */
	        function getFieldValue(row, fieldPath) {
	            // const parts = fieldPath.replace(/\[(\d+)\]/gi, '.$1').split('.');
	            var parts = fieldPath.split('.');
	            var len = parts.length;
	            var val = row;
	            var i = 0;
	            while (i < len && val) {
	                val = val[parts[i++]];
	            }
	            return val;
	        }

	        /**
	         * Evaluate a bracket-expression inside a text field
	         * e.g.
	         * 1. My name is [name]     <- inserts field "name" value into text
	         * 2. [=qty * price]        <- multiplies "qty" field * "price" field
	         * 3. [SUM(qty)]            <- compute group aggregate on field name
	         * 4. [SUM(qty * price)]    <- calculate expression and aggregate results over group
	         * 5. [PAGE_NUMBER]         <- built-in variables, some applicable only to certain sections
	         */
	        function eval_bracket_expression(format_str, entire_template, pivot_context, rootData, match, literal_open_bracket, literal_close_bracket, expr) {
	            if (literal_open_bracket) {
	                return '[';
	            }
	            if (literal_close_bracket) {
	                return ']';
	            }
	            // Look for structure of expression
	            if (expr.length === 0) return '';
	            var row = this.current_row,
	                is_calc = expr.charAt(0) === '=',

	            // grouped_rows = (pivot_context ? pivot_context.child_rows : (row ? row["___children___"] : null)),
	            grouped_rows = row ? row["___children___"] : null,
	                is_grouped = row && grouped_rows && typeof grouped_rows !== "undefined",
	                val = '',
	                i;
	            if (is_calc) {
	                // case 2
	                val = eval_calculation.call(this, expr, row, format_str, rootData);
	            } else {
	                var aggr_match = expr.match(AGGREGATE_REGEX);
	                if (aggr_match && aggr_match.length > 1) {
	                    var rowsToAggregate = grouped_rows;
	                    if (!is_grouped) {
	                        if (!row['___level___'] && rootData) {
	                            // Row is top-level, no grouping in effect -> promote to "over all" by default
	                            rowsToAggregate = rootData;
	                        } else {
	                            return t('ERROR: Aggregate not supported in detail section when grouping in effect');
	                        }
	                    }
	                    // case 4
	                    var aggr_fn = aggr_match[1].toLowerCase(),
	                        aggr_expr = aggr_match[2];
	                    try {
	                        val = compute_aggregate.call(this, aggr_fn, aggr_expr, rowsToAggregate);
	                        val = format_number(val, format_str);
	                    } catch (e) {
	                        val = String(e);
	                    }
	                } else if (expr.charAt(0) === '?') {
	                    var inputName = expr.substr(1);
	                    val = this.current_input_values[inputName.toLowerCase()];
	                } else {
	                    // Not a calc, not an aggregate, so: single fieldname/path in brackets
	                    val = getFieldValue(row, expr);
	                    if (typeof val === 'undefined') {
	                        if (is_grouped && grouped_rows.length > 0 && grouped_rows[0].hasOwnProperty(expr)) {
	                            // case 1 but look for value from first grouped row
	                            val = grouped_rows[0][expr];
	                        } else if (expr === "PAGE_NUMBER") {
	                            val = "{{JSR_PRINT_PAGE_NUMBER}}";
	                        } else if (expr === "PAGE_COUNT") {
	                            val = "{{JSR_PRINT_PAGE_COUNT}}";
	                        } else {
	                            if (this.active_schema && find_field_by_name(this.active_schema, expr)) {
	                                // Field exists in schema, treat as null
	                                return '';
	                            }
	                            return t("FIELD_NOT_FOUND: {field}", { field: expr });
	                        }
	                    }
	                    if (format_str && val && entire_template === "[" + expr + "]") {
	                        var schema_field,
	                            value_type,
	                            parse_date_format = DEFAULT_DATE_PARSE_FORMAT;
	                        if (this.active_schema && (schema_field = find_field_by_name(this.active_schema, expr))) {
	                            value_type = schema_field.type.toLowerCase();
	                            if (schema_field.dateFormat) {
	                                parse_date_format = schema_field.dateFormat;
	                            }
	                        } else {
	                            value_type = (typeof val === 'undefined' ? 'undefined' : _typeof(val)).toLowerCase();
	                        }
	                        switch (value_type) {
	                            case "number":
	                                val = format_number(val, format_str);
	                                break;
	                            case "date":
	                                val = format_date(moment(val, parse_date_format), format_str);
	                                break;
	                            default:
	                                val = format_string_default(val);
	                        }
	                    }
	                }
	            }
	            if (val === null) {
	                val = '';
	            }
	            return val;
	        }

	        function compute_aggregate(aggFn, aggExpr, rows) {
	            var is_single_fieldname = rows.length > 0 && rows[0].hasOwnProperty(aggExpr);
	            var sum;
	            var compiled_fn;
	            var raw_val;
	            var count;
	            var i;
	            var vals = void 0;
	            switch (aggFn) {
	                case "sum":
	                    sum = 0;
	                    if (is_single_fieldname) {
	                        for (i = 0; i < rows.length; i++) {
	                            sum += Number(rows[i][aggExpr]);
	                        }
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        for (i = 0; i < rows.length; i++) {
	                            sum += Number(compiled_fn.evaluate(rows[i]));
	                        }
	                    }
	                    return sum;
	                case "average":
	                    sum = 0;
	                    count = 0;
	                    if (is_single_fieldname) {
	                        for (i = 0; i < rows.length; i++) {
	                            raw_val = rows[i][aggExpr];
	                            if (raw_val !== null) {
	                                sum += Number(raw_val);
	                                count++;
	                            }
	                        }
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        for (i = 0; i < rows.length; i++) {
	                            sum += Number(compiled_fn.evaluate(rows[i]));
	                            count++;
	                        }
	                    }
	                    return sum / count;
	                case "min":
	                    var min = null;
	                    if (is_single_fieldname) {
	                        for (i = 0; i < rows.length; i++) {
	                            raw_val = rows[i][aggExpr];
	                            if (raw_val !== null) {
	                                min = min === null ? Number(raw_val) : Math.min(min, Number(raw_val));
	                            }
	                        }
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        for (i = 0; i < rows.length; i++) {
	                            val = Number(compiled_fn.evaluate(rows[i]));
	                            min = min === null ? val : Math.min(min, val);
	                        }
	                    }
	                    return min;
	                case "max":
	                    var max = null;
	                    if (is_single_fieldname) {
	                        for (i = 0; i < rows.length; i++) {
	                            raw_val = rows[i][aggExpr];
	                            if (raw_val !== null) {
	                                max = max === null ? Number(raw_val) : Math.max(max, Number(raw_val));
	                            }
	                        }
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        for (i = 0; i < rows.length; i++) {
	                            val = Number(compiled_fn.evaluate(rows[i]));
	                            max = max === null ? val : Math.max(max, val);
	                        }
	                    }
	                    return max;
	                case "count":
	                    count = 0;
	                    if (is_single_fieldname) {
	                        for (i = 0; i < rows.length; i++) {
	                            raw_val = rows[i][aggExpr];
	                            if (raw_val !== null) {
	                                count++;
	                            }
	                        }
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        for (i = 0; i < rows.length; i++) {
	                            if (Boolean(compiled_fn.evaluate(rows[i]))) {
	                                count++;
	                            }
	                        }
	                    }
	                    return count;
	                case "median":
	                    if (is_single_fieldname) {
	                        vals = rows.map(function (r) {
	                            return r[aggExpr] === null ? null : Number(r[aggExpr]);
	                        });
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        vals = rows.map(function (r) {
	                            return Number(compiled_fn.evaluate(r));
	                        });
	                    }
	                    vals = vals.filter(function (v) {
	                        return v !== null;
	                    });
	                    if (vals.length > 0) {
	                        var midIx = Math.floor(vals.length / 2);
	                        if (vals.length % 2) {
	                            // odd
	                            return vals[midIx];
	                        }
	                        // even
	                        return (vals[midIx - 1] + vals[midIx]) / 2;
	                    }
	                    return null; // empty set
	                case "countdistinct":
	                    count = 0;
	                    var seenObjs = [];
	                    var seenPrimitives = {};
	                    var isDistinct = function isDistinct(val) {
	                        if (val === null) return false;
	                        if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	                            if (val !== null && seenObjs.indexOf(val) < 0) {
	                                seenObjs.push(val);
	                                return true;
	                            }
	                        } else {
	                            var str = String(val);
	                            if (!seenPrimitives[str]) {
	                                seenPrimitives[str] = true;
	                                return true;
	                            }
	                        }
	                        return false;
	                    };
	                    if (is_single_fieldname) {
	                        for (i = 0; i < rows.length; i++) {
	                            raw_val = rows[i][aggExpr];
	                            if (isDistinct(raw_val)) {
	                                count++;
	                            }
	                        }
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        for (i = 0; i < rows.length; i++) {
	                            if (isDistinct(compiled_fn.evaluate(rows[i]))) {
	                                count++;
	                            }
	                        }
	                    }
	                    return count;
	                case "sumdistinct":
	                    if (is_single_fieldname) {
	                        vals = _.pluck(rows, aggExpr);
	                    } else {
	                        compiled_fn = this.compiled_calculations[aggExpr];
	                        if (!compiled_fn) {
	                            compiled_fn = this.parser.parse(aggExpr);
	                            this.compiled_calculations[aggExpr] = compiled_fn;
	                        }
	                        vals = rows.map(function (r) {
	                            return compiled_fn.evaluate(r);
	                        });
	                    }
	                    var distinct = _.uniq(vals);
	                    return distinct.reduce(function (total, val) {
	                        return total + (val || 0);
	                    }, 0);
	                default:
	                    return t('Unsupported aggregate function: {function}', { "function": aggFn });
	                    break;
	            }
	        }

	        function format_number(val, format_str) {
	            if (format_str) {
	                if (format_str === '#.##0,00') {
	                    return accounting.formatNumber(val, 2, '.', ',');
	                }
	                try {
	                    return SSF.format(format_str, val);
	                } catch (e) {
	                    return t('ERROR: Unsupported format: {format}', { format: format_str });
	                }
	            }
	            return accounting.formatNumber(val, 2);
	        }

	        function format_date(val, format_str) {
	            var jsDate = moment(val).toDate();
	            var timezoneOffset = jsDate.getTimezoneOffset() / (60 * 24);
	            var msDateObj = jsDate.getTime() / 86400000 + (25569 - timezoneOffset);
	            return SSF.format(format_str || DEFAULT_DATE_FORMAT, msDateObj);
	        }

	        function format_string_default(val) {
	            var valtype = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	            switch (valtype) {
	                case "string":
	                    return String(val);
	                case "number":
	                    return accounting.formatNumber(val, 2);
	                case "object":
	                /* falls through */
	                default:
	                    return String(val);
	            }
	        }

	        function evaluate_string(template, row, format_str, pivot_context, rootData) {
	            // [open bracket][optional group of non-bracket chars followed by openbracket-nonbracketchars*-closebracket][optional group of nonbracket chars][close bracket]
	            this.current_row = row;
	            return template.replace(/(\[\[)|(\]\])|\[([^\]]*)\]/gi, eval_bracket_expression.bind(this, format_str, template, pivot_context, rootData || null));
	        }

	        function parse_number(numberstr) {
	            if ((typeof numberstr === 'undefined' ? 'undefined' : _typeof(numberstr)).toLowerCase() === "string") {
	                return Number(numberstr.replace(/[^0-9\.]+/g, ""));
	            }
	            return Number(numberstr);
	        }

	        function render_chart(elt, $target, row) {
	            var me = this;
	            var animate = this.outputSupportsAnimation !== false && elt.animate !== false;
	            function chartError(msg) {
	                $target.empty().append($('<span class="jsr-chart-error">').text(msg));
	            }
	            // Display error if no value field specified
	            if (!elt.series || elt.series.length < 1 || !elt.series[0] || !elt.series[0].value_field) {
	                return chartError(t('Chart is missing value field'));
	            }
	            var chart_data;
	            // var chart_data_is_grouped = false;
	            if (!elt.data && !row['___children___']) {
	                return chartError('Chart must be placed in a group header or footer, or have a separate data source provided');
	            }
	            var dataSource = getDataSourceForElement.call(this, elt, row);
	            if (dataSource.error) {
	                return chartError(dataSource.error);
	            }
	            var chart_data = dataSource.data;
	            // var chart_data_is_grouped = dataSource.isGrouped;   

	            // If there's another grouping below this level, group the rows for the chart
	            // if (depth < this.def.body.sublevels.length - 1) {
	            //  var next_level_def = this.def.body.sublevels[depth + 1],
	            //      next_level_has_grouping = (next_level_def.group_by !== null && typeof(next_level_def.group_by) !== "undefined");
	            //  if (next_level_has_grouping) {
	            //      chart_data = group_rows.call(this, chart_data, next_level_def, depth + 1, this.def);
	            //      chart_data_is_grouped = true;
	            //  }
	            // }

	            // Re-group children, if specified
	            if (elt.groupBy) {
	                chart_data = group_rows.call(this, chart_data, elt.groupBy);
	            }

	            // ctx.fillStyle = "#FFFFFF";
	            // ctx.fillRect(0, 0, $target.width(), $target.height());
	            // Can't read dimensions from DOM because we are rendering detached
	            // In general, cannot read dimensions from DOM - must track widths & heights from root down
	            var widthPx = elt.width_px;
	            var heightPx = elt.height_px;
	            var value_field, label_field, value_is_aggregated, svg, myChart, data, colorField;
	            var chartType = elt.type.substr(6); // text following "chart_"
	            var valueFieldIsExpr = false;
	            var $renderTarget = $('<div class="jsr-chart-render-container"></div>').width(widthPx).height(heightPx);
	            $(document.body).append($renderTarget);
	            $target.addClass('jsr-chart-' + chartType);
	            switch (chartType) {
	                case "pie":
	                    value_field = elt.series[0].value_field;
	                    valueFieldIsExpr = value_field.indexOf('=') === 0;
	                    label_field = elt.series[0].label_field;
	                    colorField = elt.series[0].color_field || null;
	                    // value_is_aggregated = (chart_data_is_grouped && (typeof chart_data[0][value_field] === "undefined"));
	                    var colors = ["#4D4D4D", "#5DA5DA", "#FAA43A", "#60BD68", "#F17CB0", "#B2912F", "#B276B2", "#DECF3F", "#F15854"],
	                        generate_legend = elt.legend !== false;
	                    data = chart_data.map(function (r) {
	                        var chartrow = {};
	                        var val;
	                        // if (value_is_aggregated) {
	                        //  val = 0;
	                        //  var children = r["___children___"];
	                        //  for (var j = 0; j < children.length; j++) {
	                        //      val += parse_number(children[j][value_field]);
	                        //  }
	                        // } else {
	                        if (valueFieldIsExpr) {
	                            val = eval_calculation.call(me, value_field, r, null);
	                        } else {
	                            val = parse_number(r[value_field]);
	                        }
	                        // }
	                        chartrow[value_field] = val;
	                        // var slice = { 
	                        //  value: val, 
	                        //  color: colors[i++]
	                        // };
	                        if (label_field) {
	                            if (typeof r[label_field] === "undefined" && r["___children___"].length > 0) {
	                                chartrow[label_field] = r["___children"][0][label_field];
	                            } else {
	                                chartrow[label_field] = r[label_field];
	                            }
	                        }
	                        if (colorField) {
	                            chartrow[colorField] = r[colorField];
	                        }
	                        return chartrow;
	                    });
	                    svg = dimple.newSvg($renderTarget[0], widthPx, heightPx);
	                    myChart = new dimple.chart(svg, data);
	                    var legendWidth = generate_legend ? Math.max(0, Math.min(130, widthPx * 0.25)) : 0;
	                    myChart.setBounds(20, 20, Math.max(0, widthPx - legendWidth - 30), Math.max(heightPx - 40, 0));
	                    myChart.addMeasureAxis('p', value_field);
	                    var sliceCategoryField = label_field || value_field;
	                    myChart.addSeries(sliceCategoryField, dimple.plot.pie);
	                    if (colorField) {
	                        data.forEach(function (chrow) {
	                            myChart.assignColor(chrow[sliceCategoryField], chrow[colorField]);
	                        });
	                    }
	                    if (generate_legend) {
	                        myChart.addLegend(widthPx - legendWidth, 20, legendWidth, Math.max(heightPx - 40, 0), "left");
	                    }
	                    myChart.ease = 'bounce';
	                    myChart.draw(animate ? elt.initialAnimationMs || DEFAULT_CHART_ANIMATION_MS : 0);
	                    break;
	                case "line":
	                /* falls through */
	                case "bar":
	                    value_field = elt.series[0].value_field;
	                    valueFieldIsExpr = value_field.indexOf('=') === 0;
	                    label_field = elt.x_axis ? elt.x_axis.label_field : null;
	                    var y_axis_title = elt.y_axis && elt.y_axis.title ? elt.y_axis.title : value_field;
	                    // value_is_aggregated = (chart_data_is_grouped && (typeof chart_data[0][value_field] === "undefined"));
	                    var label_field_from_schema = label_field && this.active_schema && find_field_by_name(this.active_schema, label_field);
	                    var label_field_is_date = label_field_from_schema && label_field_from_schema.type && label_field_from_schema.type.toLowerCase() === 'date';
	                    var labels = [];
	                    // Label field can't come from within a group
	                    var value_is_string = chart_data.length > 0 && _typeof(chart_data[0][value_field]).toLowerCase() === "string";
	                    var data = chart_data.map(function (r, i) {
	                        var chartrow = {};
	                        var val;
	                        if (valueFieldIsExpr) {
	                            val = eval_calculation.call(me, value_field, r, null);
	                        } else {
	                            val = parse_number(r[value_field]);
	                        }
	                        if (label_field) {
	                            chartrow[label_field] = r[label_field];
	                        } else {
	                            chartrow['x'] = i + 1;
	                        }
	                        chartrow[value_field] = val;
	                        return chartrow;
	                    });
	                    svg = dimple.newSvg($renderTarget[0], widthPx, heightPx);
	                    myChart = new dimple.chart(svg, data);
	                    var topLegendHeight = 30;
	                    var xAxisLabelHeight = 40;
	                    if (elt.x_axis && typeof elt.x_axis.labelHeight !== 'undefined') {
	                        xAxisLabelHeight = Number(elt.x_axis.labelHeight) * this.pixels_per_unit;
	                    }
	                    myChart.setBounds(80, topLegendHeight, widthPx - 80, heightPx - topLegendHeight - xAxisLabelHeight);
	                    if (label_field_is_date) {
	                        myChart.addTimeAxis('x', label_field, undefined, '%Y-%m-%d');
	                    } else {
	                        var xAxis = myChart.addCategoryAxis("x", label_field || 'x');
	                        if (!label_field) {
	                            xAxis.title = '';
	                        }
	                    }
	                    var yAxis = myChart.addMeasureAxis("y", value_field);
	                    yAxis.title = y_axis_title;
	                    myChart.addSeries(null, elt.type === "chart_line" ? dimple.plot.line : dimple.plot.bar);
	                    myChart.addLegend(65, 10, widthPx - 80, 20, "right");
	                    $target.data('xAxisLabelHeight', xAxisLabelHeight);
	                    myChart.draw(animate ? elt.initialAnimationMs || DEFAULT_CHART_ANIMATION_MS : 0);
	                    wrapChartLabelText.call(this, $renderTarget, xAxisLabelHeight);
	                    break;
	            }
	            if (myChart) {
	                register_chart.call(this, myChart, elt, $target);
	            }
	            $target.append($renderTarget.find('svg'));
	            $renderTarget.remove();
	        }

	        function wrapChartLabelText($chartEl, width) {
	            $chartEl.find('.dimple-axis-x .tick text').each(function () {
	                var text = d3.select(this),
	                    words = text.text().split(/\s+/).reverse(),
	                    word,
	                    line = [],
	                    lineNumber = 0,
	                    lineHeight = 1.1,
	                    // ems
	                y = text.attr("y"),
	                    x = text.attr('x'),
	                    dy = parseFloat(text.attr("dy")),
	                    tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
	                while (word = words.pop()) {
	                    line.push(word);
	                    tspan.text(line.join(" "));
	                    if (tspan.node().getComputedTextLength() > width) {
	                        line.pop();
	                        tspan.text(line.join(" "));
	                        line = [word];
	                        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
	                    }
	                }
	            });
	        }

	        function register_chart(chart, def, $el) {
	            var root = this.root || this;
	            if (!root.charts) {
	                root.charts = [];
	            }
	            root.charts.push({
	                chart: chart,
	                def: def,
	                $el: $el
	            });
	        }

	        var findDataSourceById = function findDataSourceById(id, currentRow) {
	            var error = null;
	            var data = null;
	            if (Array.isArray(id)) {
	            } else if (typeof id === 'string') {
	                if (id === '__parentgroup') {
	                    if (currentRow['___children___']) {
	                        data = currentRow["___children___"];
	                    } else {
	                        data = [currentRow];
	                    }
	                }
	                // Look first for an array-valued property on the current row
	                else if (currentRow[id] && Array.isArray(currentRow[id])) {
	                        data = currentRow[id];
	                    } else {
	                        // Otherwise look for an outside data source by this id
	                        data = datasets[id.toLowerCase()];
	                        if (typeof data === "undefined" || !data) {
	                            error = t('Missing dataset with ID "{id}"', { id: id });
	                        }
	                    }
	            } else {
	                error = t('Invalid data supplied for element');
	            }
	            return {
	                data: data,
	                error: error
	            };
	        };

	        function getDataSourceForElement(elt, currentRow) {
	            var data = null;
	            var isGrouped = false;
	            var error = null;
	            var dataProp = elt.data || elt.dataSource;
	            if (dataProp) {
	                var _findDataSourceById = findDataSourceById(dataProp, currentRow);

	                data = _findDataSourceById.data;
	                error = _findDataSourceById.error;
	            } else {
	                // Use the child rows of the current grouping
	                // Display error if not in group section
	                if (currentRow['___children___']) {
	                    data = currentRow["___children___"];
	                } else {
	                    error = t('No data available - place element in a header or footer section, or specify a separate data source.');
	                }
	                // depth = row["___level___"],
	                // level_def = this.def.body.sublevels[depth],
	                // grouping = (level_def.group_by !== null && typeof(level_def.group_by) !== "undefined"),
	                isGrouped = false;
	            }
	            return {
	                data: data,
	                isGrouped: isGrouped,
	                error: error
	            };
	        }

	        function getDataSourceForCustomElement(currentRow, dataSourceId) {
	            var _findDataSourceById2 = findDataSourceById(dataSourceId, currentRow);

	            var data = _findDataSourceById2.data;
	            var error = _findDataSourceById2.error;

	            if (error) return null;
	            return data;
	        }

	        function render_table($elt, tableDef, row, pivot_context) {
	            var me = this;
	            var dataSource = getDataSourceForElement.call(this, tableDef, row);
	            if (dataSource.error) {
	                return $elt.text(dataSource.error);
	            }
	            var tableData = dataSource.data;
	            var $table = $('<table></table>');
	            var tableFontSize = null;
	            var ppi = this.pixels_per_unit * (this.def.page.units === 'inches' ? 1 : 25.4);
	            if (this.scaleFonts === false) {
	                ppi = 72;
	            }
	            if (tableDef.fontSize) {
	                $table.css('font-size', (tableDef.fontSize * ppi / 72).toFixed(2) + 'pt');
	            }
	            if (tableDef.groupBy) {
	                tableData = group_rows.call(this, tableData, tableDef.groupBy);
	            }
	            if (tableDef.hasHeader !== false) {
	                var $thead = $('<thead></thead>');
	                var $tr = $('<tr></tr>');
	                $thead.append($tr);
	                tableDef.columns.forEach(function (colDef) {
	                    $tr.append(render_table_cell.call(me, row, colDef.header || '', colDef, colDef.headerStyle, 'th', dataSource.data, tableDef));
	                });
	                $table.append($thead);
	            }
	            var $tbody = $('<tbody></tbody>');
	            $table.append($tbody);
	            render_table_rows.call(this, tableData, $tbody, tableDef);
	            if (tableDef.hasFooter !== false) {
	                var $tfoot = $('<tfoot></tfoot>');
	                var $tr = $('<tr></tr>');
	                $tfoot.append($tr);
	                tableDef.columns.forEach(function (colDef) {
	                    $tr.append(render_table_cell.call(me, row, colDef.footer || '', colDef, colDef.footerStyle, null, dataSource.data, tableDef));
	                });
	                $table.append($tfoot);
	            }
	            $elt.append($table);
	        }

	        function render_table_rows(dataRows, $tbody, tableDef) {
	            if (tableDef.sortBy) {
	                var sortBy = Array.isArray(tableDef.sortBy) ? tableDef.sortBy : [tableDef.sortBy];
	                for (var i = sortBy.length - 1; i >= 0; i--) {
	                    dataRows = _.sortBy(dataRows, sortBy[i]);
	                }
	            }
	            if (tableDef.sortDir && tableDef.sortDir === 'desc') {
	                dataRows = dataRows.reverse();
	            }
	            dataRows.forEach(function (dataRow) {
	                if (dataRow['___children___']) {
	                    // For grouped rows, render header and footer for group
	                    // Group header defaults to true
	                    if (tableDef.hasGroup0Header !== false) {
	                        var $tr = render_table_row.call(this, dataRow, $tbody, tableDef, 'group0Header');
	                        $tr.addClass('jsr-table-group-0-header');
	                    }
	                    render_table_rows.call(this, dataRow['___children___'], $tbody, tableDef);
	                    // Group footer defaults to false
	                    if (tableDef.hasGroup0Footer) {
	                        var $tr = render_table_row.call(this, dataRow, $tbody, tableDef, 'group0Footer');
	                        $tr.addClass('jsr-table-group-0-footer');
	                    }
	                    return;
	                }
	                // Render detail row
	                if (tableDef.hideRowWhenExpr) {
	                    var hide = jsepEval(tableDef.hideRowWhenExpr, dataRow);
	                    if (hide) return;
	                }
	                var $tr = render_table_row.call(this, dataRow, $tbody, tableDef, 'detail', dataRows);
	            }.bind(this));
	        }

	        function render_table_row(dataRow, $tbody, tableDef, rowName, allRows) {
	            var unicodeNbsp = ' ';
	            var me = this;
	            var styleName = rowName + 'Style';
	            var $tr = $('<tr></tr>');
	            tableDef.columns.forEach(function (colDef) {
	                $tr.append(render_table_cell.call(me, dataRow, colDef[rowName] || unicodeNbsp, colDef, colDef[styleName], null, allRows, tableDef));
	            });
	            $tbody.append($tr);
	            return $tr;
	        }

	        function markdownToHtml(mdText) {
	            // Don't allow HTML in Markdown (for now)
	            mdText = mdText.replace(/</gm, '&lt;').replace(/>/gm, '&gt;').replace(/\\n/gm, '<br>');
	            if (!this.markdownConverter) {
	                this.markdownConverter = new showdown.Converter({
	                    strikethrough: true
	                });
	            }
	            var textHtml = this.markdownConverter.makeHtml(mdText);
	            // if (textHtml.startsWith('<p>') && textHtml.endsWith('</p>')) {
	            //     textHtml = textHtml.substring(3, textHtml.length - 4);
	            // }
	            textHtml = textHtml.replace(/\n\<li\>/gim, '<li>');
	            textHtml = textHtml.replace(/\n\<\/ul\>/gim, '</ul>');
	            return textHtml;
	        }

	        var firstDefined = function firstDefined() {
	            for (var _len = arguments.length, vals = Array(_len), _key = 0; _key < _len; _key++) {
	                vals[_key] = arguments[_key];
	            }

	            return vals.find(function (v) {
	                return v !== undefined;
	            });
	        };

	        function render_table_cell(dataRow, cellDef, colDef, style, cellTag, allRows, tableProps) {
	            var _this7 = this;

	            var htmlDocument = ditto.window.document;
	            var align = colDef.align;
	            var backColor = null;
	            var foreColor = null;
	            var hasCellDef = (typeof cellDef === 'undefined' ? 'undefined' : _typeof(cellDef)) === 'object';
	            var props = hasCellDef ? cellDef : null;
	            if (props && props.conditionalRules && props.conditionalRules.length > 0) {
	                props = _.extend({}, props);
	                evaluateConditionalRules.call(this, props, dataRow);
	            }
	            var $td = $(htmlDocument.createElement(cellTag || 'td')).width(colDef.width || 'auto');
	            if (props) {
	                align = props.align || align;
	                if (props.backgroundColor) {
	                    $td.css('background-color', props.backgroundColor);
	                }
	                if (props.textColor) {
	                    $td.css('color', props.textColor);
	                }
	                if (props.italic) {
	                    $td.css('font-style', 'italic');
	                }
	                if (props.bold) {
	                    $td.css('font-weight', 'bold');
	                }
	                ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	                    var borderWidth = props['border' + side + 'Width'] || tableProps['cellBorder' + side + 'Width'];
	                    var borderColor = props['border' + side + 'Color'] || tableProps['cellBorder' + side + 'Color'];
	                    if (typeof borderWidth !== 'undefined') {
	                        var _$td$css;

	                        $td.css((_$td$css = {}, _defineProperty(_$td$css, 'border-' + side.toLowerCase() + '-width', borderWidth + 'pt'), _defineProperty(_$td$css, 'border-style', 'solid'), _$td$css));
	                    }
	                    if (typeof borderColor !== 'undefined') {
	                        $td.css('border-' + side.toLowerCase() + '-color', borderColor);
	                    }
	                    var padding = firstDefined(props['padding' + side], tableProps['cellPadding' + side]);
	                    if (padding !== undefined) {
	                        $td.css('padding-' + side.toLowerCase(), Number(padding) * _this7.pixels_per_unit + 'px');
	                    }
	                });
	                if (props.cssClass) {
	                    $td.addClass(props.cssClass);
	                }
	                var wrap = firstDefined(props['wrap'], tableProps['cellWrap']);
	                if (wrap === false) {
	                    $td.css({
	                        'white-space': 'pre',
	                        'overflow': 'hidden',
	                        'text-overflow': 'ellipsis'
	                    });
	                } else {
	                    $td.css({
	                        'white-space': 'pre-wrap'
	                    });
	                }
	            }
	            var textExpr = props ? props.text : cellDef;
	            var text = evaluate_string.call(this, textExpr || '', dataRow, style ? style.pattern : null, null, allRows);
	            var isMarkdown = props && props.syntax === 'markdown';
	            if (isMarkdown) {
	                $td.html(markdownToHtml.call(this, text)).addClass('jsr-markdown');
	            } else {
	                $td.text(text.replace(/\\n/gim, '<br>'));
	            }
	            if (align) {
	                $td.css('text-align', align);
	            }
	            $td.data('jsr-cell-style', {
	                align: align,
	                pattern: style ? style.pattern : null
	            });
	            return $td;
	        }

	        function do_deferred_render(deferred) {
	            deferred.fn.apply(this, deferred.args);
	        }

	        function require_properties(obj, property_names, location) {
	            property_names.forEach(function (requiredProperty) {
	                if (typeof obj[requiredProperty] === "undefined") {
	                    throw new Error("Missing required property \"" + requiredProperty + "\" in " + location);
	                }
	            });
	        }

	        /**
	         * Provide some feedback if the supplied report definition is in the wrong format
	         */
	        function validate_def(def) {
	            var type = (typeof def === 'undefined' ? 'undefined' : _typeof(def)).toLowerCase();
	            if (type === "string") {
	                try {
	                    def = JSON.parse(def);
	                } catch (e) {
	                    throw new Error("Error: failed to parse report definition string: " + e);
	                }
	            } else if (type !== "object") {
	                throw new Error("Error: expected report definition type to be object or string, got " + type + " instead");
	            }
	            ["page", "body"].forEach(function (requiredProp) {
	                if (!def.hasOwnProperty(requiredProp)) {
	                    throw new Error("Report definition object missing required property: " + requiredProp);
	                }
	            });
	            var cloned_def = $.extend(true, {}, def);
	            var allElements = getAllElements(cloned_def);
	            // Apply any provided element defaults to all template elements
	            if (def.elementDefaults) {
	                allElements.map(function (elt) {
	                    var eltType = elt.type.toLowerCase();
	                    if (def.elementDefaults[eltType]) {
	                        // Do this in two steps to modify existing element in-place
	                        var withDefaults = _.extend({}, def.elementDefaults[eltType], elt);
	                        _.extend(elt, withDefaults);
	                    }
	                });
	            }
	            allElements.map(function (elt) {
	                if (elt.type.toLowerCase() === 'text') {
	                    var text = elt.text || '';
	                    if (text.indexOf('PAGE_NUMBER') >= 0 || text.indexOf('PAGE_COUNT') >= 0) {
	                        elt.__hasPageNumber = true;
	                    }
	                }
	            });
	            // If version < 1.2.9 then y-axis values are in template pixels and need adjustment
	            // Unfortunately, since the original aspect ratio is not available, we have to make
	            // a guess.  If the report is opened in the designer and re-saved, from then on the
	            // correct aspect ratio will be preserved.
	            if (ditto.version_less_than(cloned_def.version, "1.2.9")) {
	                var guessed_template_y_pixels = 1000,
	                    units = cloned_def.page.units,
	                    paper_height = cloned_def.page.paper_size[units][1],
	                    y_units_per_pixel = paper_height / guessed_template_y_pixels;
	                cloned_def.yScaleAdjustment = y_units_per_pixel;
	            }
	            return cloned_def;
	        }

	        function create_export_wrapper() {
	            var htmlDocument = ditto.window.document;
	            var $exportWrapper = $('<div class="jsr-export-wrapper"><div class="jsr-export-target"></div></div>');
	            $exportWrapper.css({
	                position: "absolute",
	                top: 0,
	                left: 0,
	                width: "1px",
	                height: "1px",
	                overflow: "hidden"
	            });
	            $(htmlDocument.body).append($exportWrapper);
	            var $exportTarget = $exportWrapper.find(".jsr-export-target");
	            $exportTarget.css({
	                width: "1000px",
	                overflow: "visible"
	            });
	            return $exportWrapper;
	        }

	        /** Extract any referenced data sources from a report, including subreports */
	        function findDataSources(defNode, dsList) {
	            if (!dsList) dsList = [];
	            Object.keys(defNode).forEach(function (key) {
	                var val = defNode[key];
	                if (['data_source', 'data', 'dataSource', 'optionSource'].indexOf(key) >= 0 && val && typeof val === 'string' && val !== '__parentgroup') {
	                    dsList.push({
	                        id: val,
	                        required: key === 'data_source'
	                    });
	                }
	                if (val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	                    findDataSources(val, dsList);
	                }
	            });
	            return dsList;
	        }

	        /** Reduce a list of datasets to only those referenced by the report */
	        function onlyReferencedDatasets(datasets, def) {
	            var needed = {};
	            findDataSources(def).forEach(function (dsRef) {
	                needed[dsRef.id.toLowerCase()] = dsRef;
	            });
	            datasets.forEach(function (ds) {
	                if (!!ds.required) {
	                    needed[ds.id.toLowerCase()] = {
	                        id: ds.id,
	                        required: true
	                    };
	                }
	            });
	            // console.log('needed are', Object.keys(needed).join(', '));
	            var found = [];
	            var priorFoundCount = -1;
	            var requireDs = function requireDs(id) {
	                var lower = id.toLowerCase();
	                var alreadyReferenced = needed[lower];
	                if (alreadyReferenced) {
	                    alreadyReferenced.required = true;
	                } else {
	                    needed[lower] = {
	                        id: id,
	                        required: true
	                    };
	                }
	            };
	            // Expand to include data sources referenced by joins
	            while (Object.keys(needed).length > 0 && priorFoundCount !== found.length) {
	                priorFoundCount = found.length;
	                datasets.forEach(function (ds) {
	                    var idLower = (ds.id || '').toLowerCase();
	                    if (needed[idLower]) {
	                        // If join, work on a clone bc we may need to flag 'discardSources'
	                        var dsToPush = ds.join ? _extends({}, ds) : ds;
	                        delete needed[idLower];
	                        if (ds.join && ds.join.left && ds.join.right) {
	                            var sourcesReferencedElsewhere = needed[ds.join.left.toLowerCase()] || needed[ds.join.right.toLowerCase()];
	                            if (!sourcesReferencedElsewhere) {
	                                dsToPush.discardSources = true;
	                            }
	                            [ds.join.left, ds.join.right].map(requireDs);
	                        }
	                        if (ds.requires) {
	                            ds.requires.map(requireDs);
	                        }
	                        found.push(dsToPush);
	                    }
	                });
	            }
	            var missingIds = Object.keys(needed).filter(function (dsId) {
	                return needed[dsId].required;
	            });
	            if (missingIds.length > 0) {
	                throw new Error('Couldn\'t find required data source' + (missingIds.length > 1 ? '(s)' : '') + ': ' + missingIds.map(function (idLower) {
	                    return needed[idLower].id;
	                }).join(', '));
	            }
	            return found;
	        }

	        function validateDatasets(dsConfigs) {
	            if (!Array.isArray(dsConfigs)) {
	                throw new Error('Invalid datasets configuration: expected array, got ' + (typeof dsConfigs === 'undefined' ? 'undefined' : _typeof(dsConfigs)));
	            }
	            var requireOneOf = ['data', 'url', 'extjsStore', 'join', 'requires'];
	            dsConfigs.forEach(function (ds) {
	                if ((typeof ds === 'undefined' ? 'undefined' : _typeof(ds)) !== 'object') {
	                    throw new Error('Invalid dataset configuration: expected object, got ' + (typeof ds === 'undefined' ? 'undefined' : _typeof(ds)) + ': ' + String(ds));
	                }
	                ['id'].forEach(function (prop) {
	                    if (!ds[prop] || typeof ds[prop] !== 'string') {
	                        throw new Error('Invalid dataset configuration: missing required property "' + prop + '" of type "string"');
	                    }
	                });
	                if (!requireOneOf.find(function (required) {
	                    return !!ds[required];
	                })) {
	                    throw new Error('Invalid dataset configuration: dataset requires one of: ' + requireOneOf.map(function (s) {
	                        return '"' + s + '"';
	                    }).join(', '));
	                }
	            });
	        }

	        return (/** @lends ditto */{

	                /**
	                 * Render a report into an HTML element on the page.
	                 *
	                 * @param options {object} - Configuration object with the following options
	                 * @param options.report_def {object} - JavaScript object representing a ditto report definition, or a JSON string that can be parsed into such an object.
	                 * @param options.datasets {array} - JavaScript array defining the data sources that can be used by the report.
	                 *      Any data source referenced by the report definition must be present in this array.
	                 * @param options.target {DOMElement} - The target DOM element into which the report will be rendered
	                 * @param [options.showToolbar=true] {boolean} - Whether to show the report toolbar (default: true)
	                 * @param [options.imageUrlPrefix] {string} - Prefix to prepend to all image URLs in the report
	                 */
	                render: function render(cfg) {
	                    var viewer = Object.assign({}, ditto);
	                    require_properties.call(viewer, cfg, ["report_def", "datasets", "target"], productName + '.render');
	                    validateDatasets.call(viewer, cfg.datasets);
	                    viewer.imageUrlPrefix = cfg.imageUrlPrefix;
	                    viewer.def = validate_def.call(viewer, cfg.report_def);
	                    viewer.showToolbar = cfg.showToolbar !== false; // showToolbar defaults to true
	                    viewer.functions = cfg.functions || {};
	                    viewer.relative_x = !!cfg.autoResizeX; // this now defaults to FALSE
	                    viewer.scaleFonts = cfg.scaleFonts !== false; // scaleFonts defaults to true
	                    viewer.enableVirtualRender = !!cfg.enableVirtualRender;
	                    viewer.virtualRenderScrollDelayMs = cfg.virtualRenderScrollDelayMs || null;
	                    viewer.showPageHeaderAndFooter = !!cfg.showPageHeaderAndFooter;
	                    viewer.preserveViewOnExport = !!cfg.preserveViewOnExport; //(cfg.preserveViewOnExport !== false);
	                    viewer.settings = cfg;
	                    viewer.translations = cfg.translations || null;
	                    viewer.customElements = cfg.customElements || [];
	                    viewer.customFunctions = cfg.customFunctions || {};
	                    viewer.allowPDFFontEmbedding = cfg.allowPDFFontEmbedding;
	                    viewer.saveFormats = cfg.saveFormats || ['pdf', 'xlsx'];
	                    var $target = $(cfg.target);
	                    if ($target.length === 0) {
	                        throw new Error("Target element not found");
	                    }
	                    // Set this early here because we may need to handle a resize while datasets are loading
	                    viewer.$target = $target;
	                    clear_datasets.call(viewer);
	                    var neededDatasets = onlyReferencedDatasets.call(viewer, cfg.datasets, viewer.def);
	                    ditto.data.loadDatasets.call(viewer, neededDatasets, datasets, schemas, false, function () {
	                        render_report.call(viewer, viewer.def, $target);
	                    });
	                    return viewer;
	                },

	                /**
	                 * Export a report directly to file.
	                 *
	                 * @param {object} options - Configuration object with the following options
	                 * @param {object} options.report_def - Report definition object (or JSON string)
	                 * @param {array} options.datasets - Array of data source definitions available for the report
	                 * @param {string} options.format - Output format; one of "pdf", "xlsx"
	                 * @param {string} options.filename - The filename to use when downloading.  Defaults to the report title.
	                 * @param {object} [options.customFunctions] - The filename to use when downloading.  Defaults to the report title.
	                 * @param {string} [options.imageUrlPrefix] - Prefix to prepend to all image URLs in the report
	                 * @param {Function} [options.outputHandler] - Function that will receive the binary output data instead of downloading via the browser
	                 */
	                export: function _export(cfg) {
	                    var exporter = Object.assign({}, cfg.exportCurrentView ? this : ditto);
	                    require_properties.call(exporter, cfg, ["format", "datasets", "report_def"], productName + '.export');
	                    if (!EXPORT_FORMATS[cfg.format.toLowerCase()]) {
	                        throw new Error("Unrecognized format for ditto.export: " + cfg.format);
	                    }
	                    validateDatasets.call(exporter, cfg.datasets);
	                    exporter.outputSupportsAnimation = false;
	                    exporter.imageUrlPrefix = cfg.imageUrlPrefix;
	                    exporter.def = validate_def.call(exporter, cfg.report_def);
	                    exporter.showToolbar = true;
	                    exporter.functions = cfg.functions || {};
	                    exporter.translations = cfg.translations || null;
	                    exporter.customElements = cfg.customElements || [];
	                    exporter.customFunctions = cfg.customFunctions || {};
	                    exporter.settings = cfg;
	                    exporter.allowPDFFontEmbedding = cfg.allowPDFFontEmbedding;
	                    exporter.saveFormats = cfg.saveFormats || ['pdf', 'xlsx'];
	                    var requestedFormat = exporter.outputFormat = cfg.format.toLowerCase();
	                    // Have to render to HTML initially to load images with dynamic URLs
	                    if (requestedFormat === "xlsx") {
	                        // Default to HTML
	                        delete exporter.outputFormat;
	                    }
	                    exporter.relative_x = !!cfg.autoResizeX; // this now defaults to FALSE
	                    exporter.scaleFonts = cfg.scaleFonts !== false; // scaleFonts defaults to true
	                    // Render into one-pixel div with overflow hidden
	                    clear_datasets.call(exporter);
	                    var neededDatasets = onlyReferencedDatasets.call(exporter, cfg.datasets, exporter.def);
	                    ditto.data.loadDatasets.call(exporter, neededDatasets, datasets, schemas, false, function () {
	                        switch (requestedFormat) {
	                            case 'xlsx':
	                                export_xlsx.call(exporter, cfg.filename, cfg.outputHandler, cfg.target);
	                                break;
	                            case 'pdf':
	                                if (cfg.exportCurrentView) {
	                                    exportCurrentViewToPDF.call(exporter, cfg.filename, cfg.outputHandler, cfg.target);
	                                } else {
	                                    renderAndExportPDF.call(exporter, cfg.filename, cfg.outputHandler, cfg.target);
	                                }
	                                break;
	                            default:
	                                throw new Error('Unsupported export format: ' + cfg.format + '.  Supported formats are: pdf, xlsx');
	                        }
	                    });
	                },

	                /**
	                 * Return the currently edited report definition object.
	                 */
	                getReportDefinition: function getReportDefinition() {
	                    return this.def || null;
	                },

	                setReport: function setReport(report) {
	                    if (this === ditto) throw new Error('No viewer present - use ditto.render() to retrieve a viewer first');
	                    this.def = validate_def.call(this, report);
	                    if (this.showToolbar && this.$toolbar_el) {
	                        this.$toolbar_el.empty();
	                        render_inputs.call(this, this.def, this.$toolbar_el);
	                        $events.trigger("toolbarRendered", [this, this.$toolbar_el[0]]);
	                    }
	                    refresh_report.call(this);
	                },

	                /**
	                 * Return the current data sources, including any loaded data.
	                 */
	                getDatasets: function getDatasets() {
	                    var ds = [];
	                    Object.keys(datasets).forEach(function (dsid) {
	                        ds.push({
	                            id: dsid,
	                            schema: schemas[dsid],
	                            data: datasets[dsid]
	                        });
	                    });
	                    return ds;
	                },

	                /**
	                 * Return the current data source schemas.
	                 */
	                getSchemas: function getSchemas() {
	                    return $.extend({}, schemas);
	                },

	                on: function on() {
	                    $events.on.apply($events, arguments);
	                },

	                once: function once() {
	                    $events.one.apply($events, arguments);
	                },

	                /** 
	                 * Register a font face (a family, and optionally weight and style) for PDF font embedding.
	                 *
	                 * @param {string} family - The font family, e.g. Helvetica
	                 * @param {string} weight - The font weight, one of "normal" or "bold"
	                 * @param {string} style - The font style, one of "normal" or "italic"
	                 * @param {string} url - The url of the font's .ttf file
	                 */
	                registerFont: function registerFont(family, weight, style, url) {
	                    if (arguments.length === 2) {
	                        url = weight;
	                        weight = 'normal';
	                        style = 'normal';
	                    } else if (arguments.length === 3) {
	                        url = style;
	                        style = 'normal';
	                    }
	                    family = family;
	                    weight = weight.toLowerCase();
	                    style = style.toLowerCase();
	                    requireOneOf(weight, ['normal', 'bold'], 'Font weight');
	                    requireOneOf(style, ['normal', 'italic'], 'Font style');
	                    // Allowed modifiers are normal, italic, bold, bolditalic
	                    var modifier = 'normal';
	                    if (style === 'italic') {
	                        modifier = weight === 'bold' ? 'bolditalic' : 'italic';
	                    } else if (weight === 'bold') {
	                        modifier = 'bold';
	                    }
	                    var fontKey = family.toLowerCase() + '-' + modifier;
	                    if (!customFonts[fontKey]) {
	                        customFonts[fontKey] = {
	                            family: family,
	                            weight: weight,
	                            style: style,
	                            combinedStyle: modifier,
	                            url: url
	                        };
	                    }
	                },

	                /** 
	                 * Enable references to a font by font name in PDF without embedding the
	                 * font file.  WARNING: This will result in unpredictable results when the
	                 * PDF is viewed on systems that do not contain the named font.
	                 * Unless there is a good reason, you should use registerFont instead to
	                 * embed an actual font file in the resulting PDF.
	                 * @example
	                 * ditto.registerFontReference('Comic Sans');
	                 */
	                registerFontReference: function registerFontReference(family) {
	                    extraFontReferences[family.toLowerCase()] = {
	                        name: family,
	                        psName: family.replace(/\s/g, '')
	                    };
	                },

	                resize: resize

	            }
	        );
	    }());

	    return ditto;
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */

	!(function(global) {
	  "use strict";

	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var iteratorSymbol =
	    typeof Symbol === "function" && Symbol.iterator || "@@iterator";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };

	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }

	  function AsyncIterator(generator) {
	    // This invoke function is written in a style that assumes some
	    // calling function (or Promise) will handle exceptions.
	    function invoke(method, arg) {
	      var result = generator[method](arg);
	      var value = result.value;
	      return value instanceof AwaitArgument
	        ? Promise.resolve(value.arg).then(invokeNext, invokeThrow)
	        : Promise.resolve(value).then(function(unwrapped) {
	            // When a yielded Promise is resolved, its final value becomes
	            // the .value of the Promise<{value,done}> result for the
	            // current iteration. If the Promise is rejected, however, the
	            // result for this iteration will be rejected with the same
	            // reason. Note that rejections of yielded Promises are not
	            // thrown back into the generator function, as is the case
	            // when an awaited Promise is rejected. This difference in
	            // behavior between yield and await is important, because it
	            // allows the consumer to decide what to do with the yielded
	            // rejection (swallow it and continue, manually .throw it back
	            // into the generator, abandon iteration, whatever). With
	            // await, by contrast, there is no opportunity to examine the
	            // rejection reason outside the generator function, so the
	            // only option is to throw it from the await expression, and
	            // let the generator function handle the exception.
	            result.value = unwrapped;
	            return result;
	          });
	    }

	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }

	    var invokeNext = invoke.bind(generator, "next");
	    var invokeThrow = invoke.bind(generator, "throw");
	    var invokeReturn = invoke.bind(generator, "return");
	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return invoke(method, arg);
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : new Promise(function (resolve) {
	          resolve(callInvokeWithMethodAndArg());
	        });
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;

	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }

	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }

	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );

	          if (record.type === "throw") {
	            context.delegate = null;

	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }

	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;

	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }

	          context.delegate = null;
	        }

	        if (method === "next") {
	          context._sent = arg;

	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }

	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }

	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          var info = {
	            value: record.arg,
	            done: context.done
	          };

	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }

	      return ContinueSentinel;
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(80)))

/***/ },
/* 80 */
/***/ function(module, exports) {

	// shim for using process in browser

	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.13.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com

	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';

	    var hookCallback;

	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }

	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }

	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }

	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }

	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }

	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }

	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }

	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }

	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }

	        return a;
	    }

	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }

	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }

	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }

	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;

	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }

	            return false;
	        };
	    }

	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));

	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }

	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }

	        return m;
	    }

	    function isUndefined(input) {
	        return input === void 0;
	    }

	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];

	    function copyConfig(to, from) {
	        var i, prop, val;

	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }

	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }

	        return to;
	    }

	    var updateInProgress = false;

	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }

	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }

	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }

	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;

	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }

	        return value;
	    }

	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }

	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }

	    function deprecate(msg, fn) {
	        var firstTime = true;

	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }

	    var deprecations = {};

	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }

	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;

	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }

	    function isObject(input) {
	        return Object.prototype.toString.call(input) === '[object Object]';
	    }

	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }

	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        return res;
	    }

	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }

	    var keys;

	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }

	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;

	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }

	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;

	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }

	    function loadLocale(name) {
	        var oldLocale = null;
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(82)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }

	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }

	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }

	        return globalLocale._abbr;
	    }

	    function defineLocale (name, config) {
	        if (config !== null) {
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale');
	                config = mergeConfigs(locales[name]._config, config);
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    config = mergeConfigs(locales[config.parentLocale]._config, config);
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet');
	                }
	            }
	            locales[name] = new Locale(config);

	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);

	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }

	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale;
	            if (locales[name] != null) {
	                config = mergeConfigs(locales[name]._config, config);
	            }
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;

	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }

	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;

	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }

	        if (!key) {
	            return globalLocale;
	        }

	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }

	        return chooseLocale(key);
	    }

	    function locale_locales__listLocales() {
	        return keys(locales);
	    }

	    var aliases = {};

	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }

	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }

	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;

	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }

	        return normalizedInput;
	    }

	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }

	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }

	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }

	    // MOMENTS

	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }

	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }

	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

	    var formatFunctions = {};

	    var formatTokenFunctions = {};

	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }

	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }

	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;

	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }

	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }

	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }

	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

	        return formatFunctions[format](m);
	    }

	    function expandFormat(format, locale) {
	        var i = 5;

	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }

	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }

	        return format;
	    }

	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


	    var regexes = {};

	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }

	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }

	        return regexes[token](config._strict, config._locale);
	    }

	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }

	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }

	    var tokens = {};

	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }

	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }

	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }

	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;

	    var indexOf;

	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }

	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }

	    // FORMATTING

	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });

	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });

	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });

	    // ALIASES

	    addUnitAlias('month', 'M');

	    // PARSING

	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });

	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });

	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });

	    // LOCALES

	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }

	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }

	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;

	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }

	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }

	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function setMonth (mom, value) {
	        var dayOfMonth;

	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }

	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }

	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }

	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }

	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }

	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }

	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }

	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }

	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }

	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;

	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;

	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }

	            getParsingFlags(m).overflow = overflow;
	        }

	        return m;
	    }

	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;

	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];

	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];

	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;

	        if (match) {
	            getParsingFlags(config).iso = true;

	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }

	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);

	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }

	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }

	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );

	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);

	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }

	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));

	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }

	    // FORMATTING

	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });

	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });

	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

	    // ALIASES

	    addUnitAlias('year', 'y');

	    // PARSING

	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);

	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });

	    // HELPERS

	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }

	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }

	    // HOOKS

	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };

	    // MOMENTS

	    var getSetYear = makeGetSet('FullYear', true);

	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }

	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

	        return -fwdlw + fwd - 1;
	    }

	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;

	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }

	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }

	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;

	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }

	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }

	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }

	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }

	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }

	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;

	        if (config._d) {
	            return;
	        }

	        currentDate = currentDateArray(config);

	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }

	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }

	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }

	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }

	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }

	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }

	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }

	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }

	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;

	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;

	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);

	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }

	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};

	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }

	        config._a = [];
	        getParsingFlags(config).empty = true;

	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;

	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }

	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }

	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }

	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

	        configFromArray(config);
	        checkOverflow(config);
	    }


	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;

	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }

	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,

	            scoreToBeat,
	            i,
	            currentScore;

	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }

	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);

	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }

	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;

	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

	            getParsingFlags(tempConfig).score = currentScore;

	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }

	        extend(config, bestMoment || tempConfig);
	    }

	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }

	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });

	        configFromArray(config);
	    }

	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }

	        return res;
	    }

	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;

	        config._locale = config._locale || locale_locales__getLocale(config._l);

	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }

	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }

	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }

	        if (!valid__isValid(config)) {
	            config._d = null;
	        }

	        return config;
	    }

	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }

	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};

	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;

	        return createFromConfig(c);
	    }

	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }

	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             if (this.isValid() && other.isValid()) {
	                 return other < this ? this : other;
	             } else {
	                 return valid__createInvalid();
	             }
	         }
	     );

	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );

	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }

	    function min () {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isBefore', args);
	    }

	    function max () {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isAfter', args);
	    }

	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };

	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;

	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;

	        this._data = {};

	        this._locale = locale_locales__getLocale();

	        this._bubble();
	    }

	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }

	    // FORMATTING

	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }

	    offset('Z', ':');
	    offset('ZZ', '');

	    // PARSING

	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });

	    // HELPERS

	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;

	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);

	        return parts[0] === '+' ? minutes : -minutes;
	    }

	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }

	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }

	    // HOOKS

	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};

	    // MOMENTS

	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }

	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }

	            this.utcOffset(input, keepLocalTime);

	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }

	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }

	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;

	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }

	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(matchOffset, this._i));
	        }
	        return this;
	    }

	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;

	        return (this.utcOffset() - input) % 60 === 0;
	    }

	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }

	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }

	        var c = {};

	        copyConfig(c, this);
	        c = prepareConfig(c);

	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }

	        return this._isDSTShifted;
	    }

	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }

	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }

	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }

	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;

	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;

	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));

	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }

	        ret = new Duration(duration);

	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }

	        return ret;
	    }

	    create__createDuration.fn = Duration.prototype;

	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }

	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};

	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }

	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

	        return res;
	    }

	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }

	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }

	        return res;
	    }

	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }

	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }

	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }

	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);

	        if (!mom.isValid()) {
	            // No op
	            return;
	        }

	        updateOffset = updateOffset == null ? true : updateOffset;

	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }

	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');

	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';

	        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);

	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }

	    function clone () {
	        return new Moment(this);
	    }

	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }

	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }

	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }

	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }

	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }

	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }

	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;

	        if (!this.isValid()) {
	            return NaN;
	        }

	        that = cloneWithOffset(input, this);

	        if (!that.isValid()) {
	            return NaN;
	        }

	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	        units = normalizeUnits(units);

	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }

	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;

	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }

	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }

	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }

	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }

	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }

	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }

	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }

	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;

	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }

	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );

	    function localeData () {
	        return this._locale;
	    }

	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }

	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }

	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }

	        return this;
	    }

	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }

	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }

	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }

	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }

	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }

	    function toDate () {
	        return this._offset ? new Date(this.valueOf()) : this._d;
	    }

	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }

	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }

	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }

	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }

	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }

	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }

	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }

	    // FORMATTING

	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });

	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });

	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }

	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

	    // ALIASES

	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');

	    // PARSING

	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);

	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });

	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });

	    // MOMENTS

	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }

	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }

	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }

	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }

	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }

	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }

	    // FORMATTING

	    addFormatToken('Q', 0, 'Qo', 'quarter');

	    // ALIASES

	    addUnitAlias('quarter', 'Q');

	    // PARSING

	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });

	    // MOMENTS

	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }

	    // FORMATTING

	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

	    // ALIASES

	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');

	    // PARSING

	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);

	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });

	    // HELPERS

	    // LOCALES

	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }

	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };

	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }

	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }

	    // MOMENTS

	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    // FORMATTING

	    addFormatToken('D', ['DD', 2], 'Do', 'date');

	    // ALIASES

	    addUnitAlias('date', 'D');

	    // PARSING

	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });

	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });

	    // MOMENTS

	    var getSetDayOfMonth = makeGetSet('Date', true);

	    // FORMATTING

	    addFormatToken('d', 0, 'do', 'day');

	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });

	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });

	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });

	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');

	    // ALIASES

	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');

	    // PARSING

	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });

	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });

	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });

	    // HELPERS

	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }

	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }

	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }

	        return null;
	    }

	    // LOCALES

	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }

	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }

	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }

	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];

	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;

	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }

	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }

	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already

	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }

	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }

	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }

	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }

	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }

	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }


	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }

	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;

	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }

	    // FORMATTING

	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	    // ALIASES

	    addUnitAlias('dayOfYear', 'DDD');

	    // PARSING

	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });

	    // HELPERS

	    // MOMENTS

	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }

	    // FORMATTING

	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }

	    function kFormat() {
	        return this.hours() || 24;
	    }

	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);

	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });

	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });

	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }

	    meridiem('a', true);
	    meridiem('A', false);

	    // ALIASES

	    addUnitAlias('hour', 'h');

	    // PARSING

	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }

	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);

	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);

	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });

	    // LOCALES

	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }

	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }


	    // MOMENTS

	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);

	    // FORMATTING

	    addFormatToken('m', ['mm', 2], 0, 'minute');

	    // ALIASES

	    addUnitAlias('minute', 'm');

	    // PARSING

	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);

	    // MOMENTS

	    var getSetMinute = makeGetSet('Minutes', false);

	    // FORMATTING

	    addFormatToken('s', ['ss', 2], 0, 'second');

	    // ALIASES

	    addUnitAlias('second', 's');

	    // PARSING

	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);

	    // MOMENTS

	    var getSetSecond = makeGetSet('Seconds', false);

	    // FORMATTING

	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });

	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });

	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });


	    // ALIASES

	    addUnitAlias('millisecond', 'ms');

	    // PARSING

	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);

	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }

	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }

	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS

	    var getSetMillisecond = makeGetSet('Milliseconds', false);

	    // FORMATTING

	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');

	    // MOMENTS

	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }

	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }

	    var momentPrototype__proto = Moment.prototype;

	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = getSet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = getSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;

	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;

	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;

	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;

	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;

	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;

	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;

	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;

	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;

	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;

	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;

	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;

	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;

	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);

	    var momentPrototype = momentPrototype__proto;

	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }

	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }

	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };

	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }

	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };

	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];

	        if (format || !formatUpper) {
	            return format;
	        }

	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });

	        return this._longDateFormat[key];
	    }

	    var defaultInvalidDate = 'Invalid date';

	    function invalidDate () {
	        return this._invalidDate;
	    }

	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;

	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }

	    function preParsePostFormat (string) {
	        return string;
	    }

	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };

	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }

	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }

	    var prototype__proto = Locale.prototype;

	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;

	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto._months           = defaultLocaleMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto._monthsRegex      = defaultMonthsRegex;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;

	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;

	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;

	    prototype__proto._weekdaysRegex      = defaultWeekdaysRegex;
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto._weekdaysShortRegex = defaultWeekdaysShortRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto._weekdaysMinRegex   = defaultWeekdaysMinRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;

	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;

	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }

	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';

	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }

	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }

	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;

	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        }

	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;

	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }

	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }

	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }

	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }

	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }

	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }

	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }

	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });

	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);

	    var mathAbs = Math.abs;

	    function duration_abs__abs () {
	        var data           = this._data;

	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);

	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);

	        return this;
	    }

	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);

	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;

	        return duration._bubble();
	    }

	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }

	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }

	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }

	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;

	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }

	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;

	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;

	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;

	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;

	        days += absFloor(hours / 24);

	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        data.days   = days;
	        data.months = months;
	        data.years  = years;

	        return this;
	    }

	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }

	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }

	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;

	        units = normalizeUnits(units);

	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }

	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }

	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }

	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');

	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }

	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }

	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');

	    function weeks () {
	        return absFloor(this.days() / 7);
	    }

	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };

	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }

	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));

	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];

	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }

	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }

	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);

	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }

	        return locale.postformat(output);
	    }

	    var iso_string__abs = Math.abs;

	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;

	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;

	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;


	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();

	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }

	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }

	    var duration_prototype__proto = Duration.prototype;

	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;

	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;

	    // Side effect imports

	    // FORMATTING

	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');

	    // PARSING

	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });

	    // Side effect imports


	    utils_hooks__hooks.version = '2.13.0';

	    setHookCallback(local__createLocal);

	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.prototype             = momentPrototype;

	    var _moment = utils_hooks__hooks;

	    return _moment;

	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)(module)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 83,
		"./af.js": 83,
		"./ar": 84,
		"./ar-ma": 85,
		"./ar-ma.js": 85,
		"./ar-sa": 86,
		"./ar-sa.js": 86,
		"./ar-tn": 87,
		"./ar-tn.js": 87,
		"./ar.js": 84,
		"./az": 88,
		"./az.js": 88,
		"./be": 89,
		"./be.js": 89,
		"./bg": 90,
		"./bg.js": 90,
		"./bn": 91,
		"./bn.js": 91,
		"./bo": 92,
		"./bo.js": 92,
		"./br": 93,
		"./br.js": 93,
		"./bs": 94,
		"./bs.js": 94,
		"./ca": 95,
		"./ca.js": 95,
		"./cs": 96,
		"./cs.js": 96,
		"./cv": 97,
		"./cv.js": 97,
		"./cy": 98,
		"./cy.js": 98,
		"./da": 99,
		"./da.js": 99,
		"./de": 100,
		"./de-at": 101,
		"./de-at.js": 101,
		"./de.js": 100,
		"./dv": 102,
		"./dv.js": 102,
		"./el": 103,
		"./el.js": 103,
		"./en-au": 104,
		"./en-au.js": 104,
		"./en-ca": 105,
		"./en-ca.js": 105,
		"./en-gb": 106,
		"./en-gb.js": 106,
		"./en-ie": 107,
		"./en-ie.js": 107,
		"./en-nz": 108,
		"./en-nz.js": 108,
		"./eo": 109,
		"./eo.js": 109,
		"./es": 110,
		"./es.js": 110,
		"./et": 111,
		"./et.js": 111,
		"./eu": 112,
		"./eu.js": 112,
		"./fa": 113,
		"./fa.js": 113,
		"./fi": 114,
		"./fi.js": 114,
		"./fo": 115,
		"./fo.js": 115,
		"./fr": 116,
		"./fr-ca": 117,
		"./fr-ca.js": 117,
		"./fr-ch": 118,
		"./fr-ch.js": 118,
		"./fr.js": 116,
		"./fy": 119,
		"./fy.js": 119,
		"./gd": 120,
		"./gd.js": 120,
		"./gl": 121,
		"./gl.js": 121,
		"./he": 122,
		"./he.js": 122,
		"./hi": 123,
		"./hi.js": 123,
		"./hr": 124,
		"./hr.js": 124,
		"./hu": 125,
		"./hu.js": 125,
		"./hy-am": 126,
		"./hy-am.js": 126,
		"./id": 127,
		"./id.js": 127,
		"./is": 128,
		"./is.js": 128,
		"./it": 129,
		"./it.js": 129,
		"./ja": 130,
		"./ja.js": 130,
		"./jv": 131,
		"./jv.js": 131,
		"./ka": 132,
		"./ka.js": 132,
		"./kk": 133,
		"./kk.js": 133,
		"./km": 134,
		"./km.js": 134,
		"./ko": 135,
		"./ko.js": 135,
		"./ky": 136,
		"./ky.js": 136,
		"./lb": 137,
		"./lb.js": 137,
		"./lo": 138,
		"./lo.js": 138,
		"./lt": 139,
		"./lt.js": 139,
		"./lv": 140,
		"./lv.js": 140,
		"./me": 141,
		"./me.js": 141,
		"./mk": 142,
		"./mk.js": 142,
		"./ml": 143,
		"./ml.js": 143,
		"./mr": 144,
		"./mr.js": 144,
		"./ms": 145,
		"./ms-my": 146,
		"./ms-my.js": 146,
		"./ms.js": 145,
		"./my": 147,
		"./my.js": 147,
		"./nb": 148,
		"./nb.js": 148,
		"./ne": 149,
		"./ne.js": 149,
		"./nl": 150,
		"./nl.js": 150,
		"./nn": 151,
		"./nn.js": 151,
		"./pa-in": 152,
		"./pa-in.js": 152,
		"./pl": 153,
		"./pl.js": 153,
		"./pt": 154,
		"./pt-br": 155,
		"./pt-br.js": 155,
		"./pt.js": 154,
		"./ro": 156,
		"./ro.js": 156,
		"./ru": 157,
		"./ru.js": 157,
		"./se": 158,
		"./se.js": 158,
		"./si": 159,
		"./si.js": 159,
		"./sk": 160,
		"./sk.js": 160,
		"./sl": 161,
		"./sl.js": 161,
		"./sq": 162,
		"./sq.js": 162,
		"./sr": 163,
		"./sr-cyrl": 164,
		"./sr-cyrl.js": 164,
		"./sr.js": 163,
		"./ss": 165,
		"./ss.js": 165,
		"./sv": 166,
		"./sv.js": 166,
		"./sw": 167,
		"./sw.js": 167,
		"./ta": 168,
		"./ta.js": 168,
		"./te": 169,
		"./te.js": 169,
		"./th": 170,
		"./th.js": 170,
		"./tl-ph": 171,
		"./tl-ph.js": 171,
		"./tlh": 172,
		"./tlh.js": 172,
		"./tr": 173,
		"./tr.js": 173,
		"./tzl": 174,
		"./tzl.js": 174,
		"./tzm": 175,
		"./tzm-latn": 176,
		"./tzm-latn.js": 176,
		"./tzm.js": 175,
		"./uk": 177,
		"./uk.js": 177,
		"./uz": 178,
		"./uz.js": 178,
		"./vi": 179,
		"./vi.js": 179,
		"./x-pseudo": 180,
		"./x-pseudo.js": 180,
		"./zh-cn": 181,
		"./zh-cn.js": 181,
		"./zh-tw": 182,
		"./zh-tw.js": 182
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 82;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });

	    return af;

	}));

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];

	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ar;

	}));

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ar_ma;

	}));

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };

	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ar_sa;

	}));

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ar_tn;

	}));

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };

	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return az;

	}));

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }

	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return be;

	}));

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return bg;

	}));

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };

	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return bn;

	}));

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };

	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return bo;

	}));

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }

	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return br;

	}));

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }

	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return bs;

	}));

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ca;

	}));

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	        }
	    }

	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return cs;

	}));

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return cv;

	}));

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return cy;

	}));

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return da;

	}));

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }

	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return de;

	}));

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }

	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return de_at;

	}));

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dhivehi (dv)
	//! author : Jawish Hameed : https://github.com/jawish

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];

	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {

	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return dv;

	}));

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';

	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }


	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });

	    return el;

	}));

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : australian english (en-au)

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return en_au;

	}));

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });

	    return en_ca;

	}));

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return en_gb;

	}));

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish english (en-ie)
	//! author : Chris Cartlidge : https://github.com/chriscartlidge

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return en_ie;

	}));

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : New Zealand english (en-nz)

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return en_nz;

	}));

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return eo;

	}));

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return es;

	}));

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }

	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return et;

	}));

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return eu;

	}));

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };

	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return fa;

	}));

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }

	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fi;

	}));

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fo;

	}));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fr;

	}));

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });

	    return fr_ca;

	}));

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swiss french (fr)
	//! author : Gaspard Bucher : https://github.com/gaspard

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fr_ch;

	}));

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fy;

	}));

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain scottish gealic (gd)
	//! author : Jon Ashdown : https://github.com/jonashdown

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];

	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return gd;

	}));

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return gl;

	}));

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });

	    return he;

	}));

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };

	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return hi;

	}));

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }

	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return hr;

	}));

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }

	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return hu;

	}));

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return hy_am;

	}));

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return id;

	}));

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }

	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return is;

	}));

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return it;

	}));

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });

	    return ja;

	}));

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return jv;

	}));

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });

	    return ka;

	}));

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : kazakh (kk)
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };

	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return kk;

	}));

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return km;

	}));

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });

	    return ko;

	}));

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : kyrgyz (ky)
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';



	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };

	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ky;

	}));

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }

	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return lb;

	}));

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : lao (lo)
	//! author : Ryan Hart : https://github.com/ryanhart2

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });

	    return lo;

	}));

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_')
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return lt;

	}));

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }

	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return lv;

	}));

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };

	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',

	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return me;

	}));

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return mk;

	}));

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });

	    return ml;

	}));

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };

	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }

	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return mr;

	}));

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ms;

	}));

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ms_my;

	}));

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };

	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return my;

	}));

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return nb;

	}));

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };

	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ne;

	}));

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return nl;

	}));

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return nn;

	}));

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : punjabi india (pa-in)
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };

	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return pa_in;

	}));

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }

	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return pl;

	}));

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return pt;

	}));

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });

	    return pt_br;

	}));

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }

	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ro;

	}));

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        monthsRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|сент\.|февр\.|нояб\.|июнь|янв.|июль|дек.|авг.|апр.|марта|мар[.т]|окт.|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsShortRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|сент\.|февр\.|нояб\.|июнь|янв.|июль|дек.|авг.|апр.|марта|мар[.т]|окт.|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsStrictRegex: /^(сентябр[яь]|октябр[яь]|декабр[яь]|феврал[яь]|январ[яь]|апрел[яь]|августа?|ноябр[яь]|марта?|июн[яь]|июл[яь]|ма[яй])/i,
	        monthsShortStrictRegex: /^(нояб\.|февр\.|сент\.|июль|янв\.|июн[яь]|мар[.т]|авг\.|апр\.|окт\.|дек\.|ма[яй])/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ru;

	}));

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami (se)
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';



	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return se;

	}));

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });

	    return si;

	}));

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	        }
	    }

	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return sk;

	}));

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	        }
	    }

	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',

	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return sl;

	}));

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return sq;

	}));

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };

	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return sr;

	}));

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };

	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return sr_cyrl;

	}));

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati (ss)
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';



	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ss;

	}));

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return sv;

	}));

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swahili (sw)
	//! author : Fahad Kassim : https://github.com/fadsel

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return sw;

	}));

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };

	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ta;

	}));

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : telugu (te)
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return te;

	}));

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });

	    return th;

	}));

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return tl_ph;

	}));

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon (tlh)
	//! author : Dominika Kruk : https://github.com/amaranthrose

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'leS' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'waQ' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'nem' :
	    	time + ' pIq';
	        return time;
	    }

	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'Hu’' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'wen' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'ben' :
	    	time + ' ret';
	        return time;
	    }

	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }

	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	    	ten = Math.floor((number % 100) / 10),
	    	one = number % 10,
	    	word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }

	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return tlh;

	}));

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };

	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return tr;

	}));

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';



	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }

	    return tzl;

	}));

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return tzm;

	}));

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return tzm_latn;

	}));

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }

	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return uk;

	}));

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return uz;

	}));

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return vi;

	}));

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : pseudo (x-pseudo)
	//! author : Andrew Hood : https://github.com/andrewhood125

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return x_pseudo;

	}));

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return zh_cn;

	}));

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin

	;(function (global, factory) {
	    true ? factory(__webpack_require__(81)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';


	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1分鐘',
	            mm : '%d分鐘',
	            h : '1小時',
	            hh : '%d小時',
	            d : '1天',
	            dd : '%d天',
	            M : '1個月',
	            MM : '%d個月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });

	    return zh_tw;

	}));

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright: 2015 AlignAlytics
	// License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	// Source: /src/objects/begin.js

	// Wrap all application code in a self-executing function which handles optional AMD/CommonJS publishing
	(function (context, dimple) {
	    "use strict";

	    if (true) {
	        // CommonJS
	        module.exports = dimple(__webpack_require__(184));
	    } else {
	        if (typeof define === "function" && define.amd) {
	            // RequireJS | AMD
	            define(["d3"], function (d3) {
	                // publish dimple to the global namespace for backwards compatibility
	                // and define it as an AMD module
	                context.dimple = dimple(d3);
	                return context.dimple;
	            });
	        } else {
	            // No AMD, expect d3 to exist in the current context and publish
	            // dimple to the global namespace
	            if (!context.d3) {
	                if (console && console.warn) {
	                    console.warn("dimple requires d3 to run.  Are you missing a reference to the d3 library?");
	                } else {
	                    throw "dimple requires d3 to run.  Are you missing a reference to the d3 library?";
	                }
	            } else {
	                context.dimple = dimple(context.d3);
	            }
	        }
	    }

	}(this, function (d3) {
	    "use strict";

	    // Create the stub object
	    var dimple = {
	        version: "2.1.4",
	        plot: {},
	        aggregateMethod: {}
	    };
	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/axis/begin.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis
	    dimple.axis = function (chart, position, categoryFields, measure, timeField, autoRotateLabel) {

	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-chart
	        this.chart = chart;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-position
	        this.position = position;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-categoryFields
	        this.categoryFields = (timeField === null || timeField === undefined ? categoryFields : [].concat(timeField));
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-measure
	        this.measure = measure;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-timeField
	        this.timeField = timeField;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-floatingBarWidth
	        this.floatingBarWidth = 5;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-hidden
	        this.hidden = false;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-showPercent
	        this.showPercent = false;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-colors
	        this.colors = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-overrideMin
	        this.overrideMin = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-overrideMax
	        this.overrideMax = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-shapes
	        this.shapes = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-showGridlines
	        this.showGridlines = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-gridlineShapes
	        this.gridlineShapes = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-titleShape
	        this.titleShape = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-dateParseFormat
	        this.dateParseFormat = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-tickFormat
	        this.tickFormat = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-timePeriod
	        this.timePeriod = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-timeInterval
	        this.timeInterval = 1;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-useLog
	        this.useLog = false;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-logBase
	        this.logBase = 10;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-title
	        this.title = undefined;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-clamp
	        this.clamp = true;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-ticks
	        this.ticks = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-fontSize
	        this.fontSize = "10px";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-fontFamily
	        this.fontFamily = "sans-serif";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-autoRotateLabel
	        this.autoRotateLabel = (autoRotateLabel === null || autoRotateLabel === undefined ? true : autoRotateLabel);

	        // If this is a composite axis, store links to all slaves
	        this._slaves = [];
	        // The scale determined by the update method
	        this._scale = null;
	        // The minimum and maximum axis values
	        this._min = 0;
	        this._max = 0;
	        // Chart origin before and after an update.  This helps
	        // with transitions
	        this._previousOrigin = null;
	        this._origin = null;
	        // The order definition array
	        this._orderRules = [];
	        // The group order definition array
	        this._groupOrderRules = [];


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_draw.js
	        this._draw = null;


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_getAxisData.js
	        // Get all the datasets which may affect this axis
	        this._getAxisData = function () {
	            var i,
	                series,
	                returnData = [],
	                addChartData = false;
	            if (this.chart && this.chart.series) {
	                for (i = 0; i < this.chart.series.length; i += 1) {
	                    series = this.chart.series[i];
	                    // If the series is related to this axis
	                    if (series[this.position] === this) {
	                        // If the series has its own data set add it to the return array
	                        if (series.data && series.data.length > 0) {
	                            returnData = returnData.concat(series.data);
	                        } else {
	                            addChartData = true;
	                        }
	                    }
	                }
	                if (addChartData && this.chart.data) {
	                    returnData = returnData.concat(this.chart.data);
	                }
	            }
	            return returnData;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_getFontSize.js
	        this._getFontSize = function () {
	            var fontSize;
	            if (!this.fontSize || this.fontSize.toString().toLowerCase() === "auto") {
	                fontSize = (this.chart._heightPixels() / 35 > 10 ? this.chart._heightPixels() / 35 : 10) + "px";
	            } else if (!isNaN(this.fontSize)) {
	                fontSize = this.fontSize + "px";
	            } else {
	                fontSize = this.fontSize;
	            }
	            return fontSize;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_getFormat.js
	        this._getFormat = function () {
	            var returnFormat,
	                max,
	                min,
	                len,
	                chunks,
	                suffix,
	                dp;
	            if (this.tickFormat !== null && this.tickFormat !== undefined) {
	                if (this._hasTimeField()) {
	                    returnFormat = d3.time.format(this.tickFormat);
	                } else {
	                    returnFormat = d3.format(this.tickFormat);
	                }
	            } else if (this.showPercent) {
	                returnFormat = d3.format("%");
	            } else if (this.useLog && this.measure !== null) {
	                // With linear axes the range is used to apply uniform
	                // formatting but with a log axis it is based on each number
	                // independently
	                returnFormat = function (n) {
	                    var l = Math.floor(Math.abs(n), 0).toString().length,
	                        c = Math.min(Math.floor((l - 1) / 3), 4),
	                        s = "kmBT".substring(c - 1, c),
	                        d = (Math.round((n / Math.pow(1000, c)) * 10).toString().slice(-1) === "0" ? 0 : 1);
	                    return (n === 0 ? 0 : d3.format(",." + d + "f")(n / Math.pow(1000, c)) + s);
	                };
	            } else if (this.measure !== null) {
	                max = Math.floor(Math.abs(this._max), 0).toString();
	                min = Math.floor(Math.abs(this._min), 0).toString();
	                len = Math.max(min.length, max.length);
	                if (len > 3) {
	                    chunks = Math.min(Math.floor((len - 1) / 3), 4);
	                    suffix = "kmBT".substring(chunks - 1, chunks);
	                    dp = (len - chunks * 3 <= 1 ? 1 : 0);
	                    returnFormat = function (n) {
	                        return (n === 0 ? 0 : d3.format(",." + dp + "f")(n / Math.pow(1000, chunks)) + suffix);
	                    };
	                } else {
	                    dp = -Math.floor(Math.log(this._tick_step) / Math.LN10);
	                    returnFormat = d3.format(",." + dp + "f");
	                }
	            } else {
	                returnFormat = function (n) { return n; };
	            }
	            return returnFormat;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_getTimePeriod.js
	        this._getTimePeriod = function () {
	            // A javascript date object
	            var outPeriod = this.timePeriod,
	                maxPeriods = 30,
	                diff = this._max - this._min;
	            if (this._hasTimeField() && !this.timePeriod) {
	                // Calculate using millisecond values for speed.  Using the date range requires creating an array
	                // which in the case of seconds kills the browser.  All constants are straight sums of milliseconds
	                // except months taken as (86400000 * 365.25) / 12 = 2629800000
	                if (diff / 1000 <= maxPeriods) {
	                    outPeriod = d3.time.seconds;
	                } else if (diff / 60000 <= maxPeriods) {
	                    outPeriod = d3.time.minutes;
	                } else if (diff / 3600000 <= maxPeriods) {
	                    outPeriod = d3.time.hours;
	                } else if (diff / 86400000 <= maxPeriods) {
	                    outPeriod = d3.time.days;
	                } else if (diff / 604800000 <= maxPeriods) {
	                    outPeriod = d3.time.weeks;
	                } else if (diff / 2629800000 <= maxPeriods) {
	                    outPeriod = d3.time.months;
	                } else {
	                    outPeriod = d3.time.years;
	                }
	            }
	            // Return the date
	            return outPeriod;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/getTooltipText.js
	        this._getTooltipText = function (rows, d) {
	            if (this._hasTimeField()) {
	                if (d[this.position + "Field"][0]) {
	                    rows.push(this.timeField + ": " + this._getFormat()(d[this.position + "Field"][0]));
	                }
	            } else if (this._hasCategories()) {
	                // Add the categories
	                this.categoryFields.forEach(function (c, i) {
	                    if (c !== null && c !== undefined && d[this.position + "Field"][i]) {
	                        // If the category name and value match don't display the category name
	                        rows.push(c + (d[this.position + "Field"][i] !== c ? ": " + d[this.position + "Field"][i] : ""));
	                    }
	                }, this);
	            } else if (this._hasMeasure()) {
	                switch (this.position) {
	                case "x":
	                    rows.push(this.measure + ": " + this._getFormat()(d.width));
	                    break;
	                case "y":
	                    rows.push(this.measure + ": " + this._getFormat()(d.height));
	                    break;
	                case "p":
	                    rows.push(this.measure + ": " + this._getFormat()(d.angle) + " (" + (d3.format("%")(d.piePct)) + ")");
	                    break;
	                default:
	                    rows.push(this.measure + ": " + this._getFormat()(d[this.position + "Value"]));
	                    break;
	                }
	            }
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_getTopMaster.js
	        this._getTopMaster = function () {
	            // The highest level master
	            var topMaster = this;
	            if (this.master !== null && this.master !== undefined) {
	                topMaster = this.master._getTopMaster();
	            }
	            return topMaster;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_hasCategories.js
	        this._hasCategories = function () {
	            return (this.categoryFields !== null && this.categoryFields !== undefined && this.categoryFields.length > 0);
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_hasMeasure.js
	        this._hasMeasure = function () {
	            return (this.measure !== null && this.measure !== undefined);
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_hasTimeField.js
	        this._hasTimeField = function () {
	            return (this.timeField !== null && this.timeField !== undefined);
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_parseDate.js
	        this._parseDate = function (inDate) {
	            // A javascript date object
	            var outDate;
	            if (this.dateParseFormat === null || this.dateParseFormat === undefined) {
	                // Moved this into the condition so that using epoch time requires no data format to be set.
	                // For example 20131122 might be parsed as %Y%m%d not treated as epoch time.
	                if (!isNaN(inDate)) {
	                    // If inDate is a number, assume it's epoch time
	                    outDate = new Date(inDate);
	                } else {
	                    // If nothing has been explicity defined you are in the hands of the browser gods
	                    // may they smile upon you...
	                    outDate = Date.parse(inDate);
	                }
	            } else {
	                outDate = d3.time.format(this.dateParseFormat).parse(inDate);
	            }
	            // Return the date
	            return outDate;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/_update.js
	        this._update = function (refactor) {

	            var distinctCats = [],
	                ticks,
	                step,
	                remainder,
	                origin,
	                tickCount = this.ticks || 10,
	                getOrderedCategories = function (self, axPos, oppPos) {
	                    var category = self.categoryFields[0],
	                        axisData = self._getAxisData(),
	                        sortBy = category,
	                        desc = false,
	                        isDate = true,
	                        currentValue = null,
	                        i,
	                        definitions;
	                    // Check whether this field is a date
	                    for (i = 0; i < axisData.length; i += 1) {
	                        currentValue = self._parseDate(axisData[i][category]);
	                        if (currentValue !== null && currentValue !== undefined && isNaN(currentValue)) {
	                            isDate = false;
	                            break;
	                        }
	                    }
	                    if (!isDate) {
	                        // Find the first series which connects this axis to another
	                        self.chart.series.forEach(function (s) {
	                            if (s[axPos] === self && s[oppPos]._hasMeasure()) {
	                                sortBy = s[oppPos].measure;
	                                desc = true;
	                            }
	                        }, this);
	                    }
	                    definitions = self._orderRules.concat({ ordering : sortBy, desc : desc });
	                    return dimple._getOrderedList(axisData, category, definitions);
	                };

	            // If the axis is a percentage type axis the bounds must be between -1 and 1.  Sometimes
	            // binary rounding means it can fall outside that bound so tidy up here
	            this._min = (this.showPercent && this._min < -1 ? -1 : this._min);
	            this._max = (this.showPercent && this._max > 1 ? 1 : this._max);

	            // Override or round the min or max
	            this._min = (this.overrideMin !== null ? this.overrideMin : this._min);
	            this._max = (this.overrideMax !== null ? this.overrideMax : this._max);

	            // If this is an x axis
	            if (this.position === "x" && (this._scale === null || refactor)) {
	                if (this._hasTimeField()) {
	                    this._scale = d3.time.scale()
	                        // Previously used rangeRound which causes problems with the area chart (Issue #79)
	                        .range([this.chart._xPixels(), this.chart._xPixels() + this.chart._widthPixels()])
	                        .domain([this._min, this._max])
	                        .clamp(this.clamp);
	                } else if (this.useLog) {
	                    this._scale = d3.scale.log()
	                        .range([this.chart._xPixels(), this.chart._xPixels() + this.chart._widthPixels()])
	                        .domain([
	                            (this._min === 0 ? Math.pow(this.logBase, -1) : this._min),
	                            (this._max === 0 ? -1 * Math.pow(this.logBase, -1) : this._max)
	                        ])
	                        .clamp(this.clamp)
	                        .base(this.logBase)
	                        .nice();
	                } else if (this.measure === null || this.measure === undefined) {
	                    distinctCats = getOrderedCategories(this, "x", "y");
	                    // If there are any slaves process accordingly
	                    if (this._slaves !== null && this._slaves !== undefined) {
	                        this._slaves.forEach(function (slave) {
	                            distinctCats = distinctCats.concat(getOrderedCategories(slave, "x", "y"));
	                        }, this);
	                    }
	                    this._scale = d3.scale.ordinal()
	                        .rangePoints([this.chart._xPixels(), this.chart._xPixels() + this.chart._widthPixels()])
	                        .domain(distinctCats.concat([""]));
	                } else {
	                    this._scale = d3.scale.linear()
	                        .range([this.chart._xPixels(), this.chart._xPixels() + this.chart._widthPixels()])
	                        .domain([this._min, this._max])
	                        .clamp(this.clamp)
	                        .nice();
	                }
	                // If it's visible, orient it at the top or bottom if it's first or second respectively
	                if (!this.hidden) {
	                    switch (this.chart._axisIndex(this, "x")) {
	                    case 0:
	                        this._draw = d3.svg.axis()
	                            .orient("bottom")
	                            .scale(this._scale);
	                        if (this.ticks) {
	                            this._draw.ticks(tickCount);
	                        }
	                        break;
	                    case 1:
	                        this._draw = d3.svg.axis()
	                            .orient("top")
	                            .scale(this._scale);
	                        if (this.ticks) {
	                            this._draw.ticks(tickCount);
	                        }
	                        break;
	                    default:
	                        break;
	                    }
	                }
	            } else if (this.position === "y" && (this._scale === null || refactor)) {
	                if (this._hasTimeField()) {
	                    this._scale = d3.time.scale()
	                        // Previously used rangeRound which causes problems with the area chart (Issue #79)
	                        .range([this.chart._yPixels() + this.chart._heightPixels(), this.chart._yPixels()])
	                        .domain([this._min, this._max])
	                        .clamp(this.clamp);
	                } else if (this.useLog) {
	                    this._scale = d3.scale.log()
	                        .range([this.chart._yPixels() + this.chart._heightPixels(), this.chart._yPixels()])
	                        .domain([
	                            (this._min === 0 ? Math.pow(this.logBase, -1) : this._min),
	                            (this._max === 0 ? -1 * Math.pow(this.logBase, -1) : this._max)
	                        ])
	                        .clamp(this.clamp)
	                        .base(this.logBase)
	                        .nice();
	                } else if (this.measure === null || this.measure === undefined) {
	                    distinctCats = getOrderedCategories(this, "y", "x");
	                    // If there are any slaves process accordingly
	                    if (this._slaves !== null && this._slaves !== undefined) {
	                        this._slaves.forEach(function (slave) {
	                            distinctCats = distinctCats.concat(getOrderedCategories(slave, "y", "x"));
	                        }, this);
	                    }
	                    this._scale = d3.scale.ordinal()
	                        .rangePoints([this.chart._yPixels() + this.chart._heightPixels(), this.chart._yPixels()])
	                        .domain(distinctCats.concat([""]));
	                } else {
	                    this._scale = d3.scale.linear()
	                        .range([this.chart._yPixels() + this.chart._heightPixels(), this.chart._yPixels()])
	                        .domain([this._min, this._max])
	                        .clamp(this.clamp)
	                        .nice();
	                }
	                // if it's visible, orient it at the left or right if it's first or second respectively
	                if (!this.hidden) {
	                    switch (this.chart._axisIndex(this, "y")) {
	                    case 0:
	                        this._draw = d3.svg.axis()
	                            .orient("left")
	                            .scale(this._scale);
	                        if (this.ticks) {
	                            this._draw.ticks(tickCount);
	                        }
	                        break;
	                    case 1:
	                        this._draw = d3.svg.axis()
	                            .orient("right")
	                            .scale(this._scale);
	                        if (this.ticks) {
	                            this._draw.ticks(tickCount);
	                        }
	                        break;
	                    default:
	                        break;
	                    }
	                }
	            } else if (this.position.length > 0 && this.position[0] === "z" && this._scale === null) {
	                if (this.useLog) {
	                    this._scale = d3.scale.log()
	                        .range([this.chart._heightPixels() / 300, this.chart._heightPixels() / 10])
	                        .domain([
	                            (this._min === 0 ? Math.pow(this.logBase, -1) : this._min),
	                            (this._max === 0 ? -1 * Math.pow(this.logBase, -1) : this._max)
	                        ])
	                        .clamp(this.clamp)
	                        .base(this.logBase);
	                } else {
	                    this._scale = d3.scale.linear()
	                        .range([1, this.chart._heightPixels() / 10])
	                        .domain([this._min, this._max])
	                        .clamp(this.clamp);
	                }
	            } else if (this.position.length > 0 && this.position[0] === "p" && this._scale === null) {
	                if (this.useLog) {
	                    this._scale = d3.scale.log()
	                        .range([0, 360])
	                        .domain([
	                            (this._min === 0 ? Math.pow(this.logBase, -1) : this._min),
	                            (this._max === 0 ? -1 * Math.pow(this.logBase, -1) : this._max)
	                        ])
	                        .clamp(this.clamp)
	                        .base(this.logBase);
	                } else {
	                    this._scale = d3.scale.linear()
	                        .range([0, 360])
	                        .domain([this._min, this._max])
	                        .clamp(this.clamp);
	                }
	            } else if (this.position.length > 0 && this.position[0] === "c" && this._scale === null) {
	                this._scale = d3.scale.linear()
	                    .range([0, (this.colors === null || this.colors.length === 1 ? 1 : this.colors.length - 1)])
	                    .domain([this._min, this._max])
	                    .clamp(this.clamp);
	            }
	            // Apply this scale to all slaves as well
	            if (this._slaves !== null && this._slaves !== undefined && this._slaves.length > 0) {
	                this._slaves.forEach(function (slave) {
	                    slave._scale = this._scale;
	                }, this);
	            }
	            // Check that the axis ends on a labelled tick
	            if ((refactor === null || refactor === undefined || refactor === false) && !this._hasTimeField() && this._scale !== null && this._scale.ticks !== null && this._scale.ticks !== undefined && this._scale.ticks(tickCount).length > 0 && (this.position === "x" || this.position === "y")) {

	                // Get the ticks determined based on the specified split
	                ticks = this._scale.ticks(tickCount);
	                // Get the step between ticks
	                step = ticks[1] - ticks[0];
	                // Get the remainder
	                remainder = ((this._max - this._min) % step).toFixed(0);
	                // Store the tick step if needed to calculate _getFormat.
	                this._tick_step = step;

	                // If the remainder is not zero
	                if (remainder !== 0) {
	                    // Set the bounds
	                    this._max = Math.ceil(this._max / step) * step;
	                    this._min = Math.floor(this._min / step) * step;
	                    // Recursively call the method to recalculate the scale.  This shouldn't enter this block again.
	                    this._update(true);
	                }
	            }

	            // Populate the origin.  Previously this incorrectly looked up 0 on the axis which only works
	            // for measure axes leading to Issue #19.  This fix uses the first category value in cases where
	            // one is required.
	            if (distinctCats !== null && distinctCats !== undefined && distinctCats.length > 0) {
	                origin = this._scale.copy()(distinctCats[0]);
	            } else if (this._min > 0) {
	                origin = this._scale.copy()(this._min);
	            } else if (this._max < 0) {
	                origin = this._scale.copy()(this._max);
	            } else {
	                origin = this._scale.copy()(0);
	            }

	            if (this._origin !== origin) {
	                this._previousOrigin = (this._origin === null ? origin : this._origin);
	                this._origin = origin;
	            }

	            // Return axis for chaining
	            return this;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/addGroupOrderRule.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-addGroupOrderRule
	        this.addGroupOrderRule = function (ordering, desc) {
	            this._groupOrderRules.push({ ordering : ordering, desc : desc });
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/axis/methods/addOrderRule.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-addOrderRule
	        this.addOrderRule = function (ordering, desc) {
	            this._orderRules.push({ ordering : ordering, desc : desc });
	        };
	    };
	    // End dimple.axis


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/chart/begin.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart
	    dimple.chart = function (svg, data) {

	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-svg
	        this.svg = svg;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-x
	        this.x = "10%";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-y
	        this.y = "10%";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-width
	        this.width = "80%";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-height
	        this.height = "80%";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-data
	        this.data = data;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-noFormats
	        this.noFormats = false;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-axes
	        this.axes = [];
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-series
	        this.series = [];
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-legends
	        this.legends = [];
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-storyboard
	        this.storyboard = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-titleShape
	        this.titleShape = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-shapes
	        this.shapes = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-ease
	        this.ease = "cubic-in-out";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-staggerDraw
	        this.staggerDraw = false;

	        // The group within which to put all of this chart's objects
	        this._group = svg.append("g");
	        // The group within which to put tooltips.  This is not initialised here because
	        // the group would end up behind other chart contents in a multi chart output.  It will
	        // therefore be added and removed by the mouse enter/leave events
	        this._tooltipGroup = null;
	        // Colors assigned to chart contents.  E.g. a series value.
	        this._assignedColors = {};
	        // Classes assigned to series values
	        this._assignedClasses = {};
	        // The next colour index to use, this value is cycled around for all default colours
	        this._nextColor = 0;
	        // The next series class index to use, this value is cycled around for all default classes
	        this._nextClass = 0;

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_axisIndex.js
	        // Return the ordinal value of the passed axis.  If an orientation is passed, return the order for the 
	        // specific orientation, otherwise return the order from all axes.  Returns -1 if the passed axis isn't part of the collection
	        this._axisIndex = function (axis, orientation) {

	            var i = 0,
	                axisCount = 0,
	                index = -1;

	            for (i = 0; i < this.axes.length; i += 1) {
	                if (this.axes[i] === axis) {
	                    index = axisCount;
	                    break;
	                }
	                if (orientation === null || orientation === undefined || orientation[0] === this.axes[i].position[0]) {
	                    axisCount += 1;
	                }
	            }

	            return index;

	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_getAllData.js
	        // Mash together all of the datasets
	        this._getAllData = function () {
	            // The return array will include all data for chart as well as any series
	            var returnData = [];
	            // If there is data at the chart level
	            if (this.data !== null && this.data !== undefined && this.data.length > 0) {
	                returnData = returnData.concat(this.data);
	            }
	            // If there are series defined
	            if (this.series !== null && this.series !== undefined && this.series.length > 0) {
	                this.series.forEach(function (s) {
	                    if (s.data !== null && s.data !== undefined && s.data.length > 0) {
	                        returnData = returnData.concat(s.data);
	                    }
	                });
	            }
	            // Return the final dataset
	            return returnData;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_getData.js
	        // Create a dataset containing positioning information for every series
	        this._getData = function (data, cats, agg, order, stacked, x, y, z, p, c) {
	            // The data for this series
	            var returnData = [],
	                // Handle multiple category values by iterating the fields in the row and concatenate the values
	                // This is repeated for each axis using a small anon function
	                getField = function (axis, row) {
	                    var returnField = [];
	                    if (axis !== null) {
	                        if (axis._hasTimeField()) {
	                            returnField.push(axis._parseDate(row[axis.timeField]));
	                        } else if (axis._hasCategories()) {
	                            axis.categoryFields.forEach(function (cat) {
	                                returnField.push(row[cat]);
	                            }, this);
	                        }
	                    }
	                    return returnField;
	                },
	            // Catch a non-numeric value and re-calc as count
	                useCount = { x: false, y: false, z: false, p: false, c: false },
	            // If the elements are grouped a unique list of secondary category values will be required
	                secondaryElements = { x: [], y: [] },
	            // Get the x and y totals for percentages.  This cannot be done in the loop above as we need the data aggregated before we get an abs total.
	            // otherwise it will wrongly account for negatives and positives rolled together.
	                totals = { x: [], y: [], z: [], p: [] },
	                colorBounds = { min: null, max: null },
	                tot,
	                running = { x: [], y: [], z: [], p: [] },
	                addedCats = [],
	                catTotals = {},
	                grandTotals = { x: 0, y: 0, z: 0, p: 0 },
	                key,
	                storyCat = "",
	                orderedStoryboardArray = [],
	                seriesCat = [],
	                orderedSeriesArray = [],
	                xCat = "",
	                xSortArray = [],
	                yCat = "",
	                ySortArray = [],
	                pCat = "",
	                pSortArray = [],
	                rules = [],
	                sortedData = data,
	                groupRules = [];

	            if (this.storyboard && this.storyboard.categoryFields.length > 0) {
	                storyCat = this.storyboard.categoryFields[0];
	                orderedStoryboardArray = dimple._getOrderedList(sortedData, storyCat, this.storyboard._orderRules);
	            }

	            // Deal with mekkos
	            if (x && x._hasCategories() && x._hasMeasure()) {
	                xCat = x.categoryFields[0];
	                xSortArray = dimple._getOrderedList(sortedData, xCat, x._orderRules.concat([{ ordering : x.measure, desc : true }]));
	            }
	            if (y && y._hasCategories() && y._hasMeasure()) {
	                yCat = y.categoryFields[0];
	                ySortArray = dimple._getOrderedList(sortedData, yCat, y._orderRules.concat([{ ordering : y.measure, desc : true }]));
	            }
	            if (p && p._hasCategories() && p._hasMeasure()) {
	                pCat = p.categoryFields[0];
	                pSortArray = dimple._getOrderedList(sortedData, pCat, p._orderRules.concat([{ ordering : p.measure, desc : true }]));
	            }

	            if (sortedData.length > 0 && cats && cats.length > 0) {
	                // Concat is used here to break the reference to the parent array, if we don't do this, in a storyboarded chart,
	                // the series rules to grow and grow until the system grinds to a halt trying to deal with them all.
	                rules = [].concat(order);
	                seriesCat = [];
	                cats.forEach(function (cat) {
	                    if (sortedData[0][cat] !== undefined) {
	                        seriesCat.push(cat);
	                    }
	                }, this);
	                if (p && p._hasMeasure()) {
	                    rules.push({ ordering : p.measure, desc : true });
	                } else if (c && c._hasMeasure()) {
	                    rules.push({ ordering : c.measure, desc : true });
	                } else if (z && z._hasMeasure()) {
	                    rules.push({ ordering : z.measure, desc : true });
	                } else if (x && x._hasMeasure()) {
	                    rules.push({ ordering : x.measure, desc : true });
	                } else if (y && y._hasMeasure()) {
	                    rules.push({ ordering : y.measure, desc : true });
	                }
	                orderedSeriesArray = dimple._getOrderedList(sortedData, seriesCat, rules);
	            }

	            sortedData.sort(function (a, b) {
	                var returnValue = 0,
	                    categories,
	                    comp,
	                    p,
	                    q,
	                    aMatch,
	                    bMatch;
	                if (storyCat !== "") {
	                    returnValue = orderedStoryboardArray.indexOf(a[storyCat]) - orderedStoryboardArray.indexOf(b[storyCat]);
	                }
	                if (xCat !== "" && returnValue === 0) {
	                    returnValue = xSortArray.indexOf(a[xCat]) - xSortArray.indexOf(b[xCat]);
	                }
	                if (yCat !== "" && returnValue === 0) {
	                    returnValue = ySortArray.indexOf(a[yCat]) - ySortArray.indexOf(b[yCat]);
	                }
	                if (pCat !== "" && returnValue === 0) {
	                    returnValue = pSortArray.indexOf(a[pCat]) - ySortArray.indexOf(b[pCat]);
	                }
	                if (seriesCat && seriesCat.length > 0 && returnValue === 0) {
	                    categories = [].concat(seriesCat);
	                    returnValue = 0;
	                    for (p = 0; p < orderedSeriesArray.length; p += 1) {
	                        comp = [].concat(orderedSeriesArray[p]);
	                        aMatch = true;
	                        bMatch = true;
	                        for (q = 0; q < categories.length; q += 1) {
	                            aMatch = aMatch && (a[categories[q]] === comp[q]);
	                            bMatch = bMatch && (b[categories[q]] === comp[q]);
	                        }
	                        if (aMatch && bMatch) {
	                            returnValue = 0;
	                            break;
	                        } else if (aMatch) {
	                            returnValue = -1;
	                            break;
	                        } else if (bMatch) {
	                            returnValue = 1;
	                            break;
	                        }
	                    }
	                }
	                return returnValue;
	            });

	            // Iterate every row in the data to calculate the return values
	            sortedData.forEach(function (d) {
	                // Reset the index
	                var foundIndex = -1,
	                    xField = getField(x, d),
	                    yField = getField(y, d),
	                    zField = getField(z, d),
	                    pField = getField(p, d),
	                // Get the aggregate field using the other fields if necessary
	                    aggField = [],
	                    key,
	                    k,
	                    i,
	                    newRow,
	                    updateData;

	                if (!cats || cats.length === 0) {
	                    aggField = ["All"];
	                } else {
	                    // Iterate the category fields
	                    for (i = 0; i < cats.length; i += 1) {
	                        // Either add the value of the field or the name itself.  This allows users to add custom values, for example
	                        // Setting a particular color for a set of values can be done by using a non-existent final value and then coloring
	                        // by it
	                        if (d[cats[i]] === undefined) {
	                            aggField.push(cats[i]);
	                        } else {
	                            aggField.push(d[cats[i]]);
	                        }
	                    }
	                }

	                // Add a key
	                key = aggField.join("/") + "_" + xField.join("/") + "_" + yField.join("/") + "_" + pField.join("/") + "_" + zField.join("/");
	                // See if this field has already been added.
	                for (k = 0; k < returnData.length; k += 1) {
	                    if (returnData[k].key === key) {
	                        foundIndex = k;
	                        break;
	                    }
	                }
	                // If the field was not added, do so here
	                if (foundIndex === -1) {
	                    newRow = {
	                        key: key,
	                        aggField: aggField,
	                        xField: xField,
	                        xValue: null,
	                        xCount: 0,
	                        yField: yField,
	                        yValue: null,
	                        yCount: 0,
	                        pField: pField,
	                        pValue: null,
	                        pCount: 0,
	                        zField: zField,
	                        zValue: null,
	                        zCount: 0,
	                        cValue: 0,
	                        cCount: 0,
	                        x: 0,
	                        y: 0,
	                        xOffset: 0,
	                        yOffset: 0,
	                        width: 0,
	                        height: 0,
	                        cx: 0,
	                        cy: 0,
	                        xBound: 0,
	                        yBound: 0,
	                        xValueList: [],
	                        yValueList: [],
	                        zValueList: [],
	                        pValueList: [],
	                        cValueList: [],
	                        fill: {},
	                        stroke: {}
	                    };
	                    returnData.push(newRow);
	                    foundIndex = returnData.length - 1;
	                }

	                // Update the return data for the passed axis
	                updateData = function (axis, storyboard) {
	                    var passStoryCheck = true,
	                        lhs = { value: 0, count: 1 },
	                        rhs = { value: 0, count: 1 },
	                        selectStoryValue,
	                        compare = "",
	                        retRow;
	                    if (storyboard !== null) {
	                        selectStoryValue = storyboard.getFrameValue();
	                        storyboard.categoryFields.forEach(function (cat, m) {
	                            if (m > 0) {
	                                compare += "/";
	                            }
	                            compare += d[cat];
	                            passStoryCheck = (compare === selectStoryValue);
	                        }, this);
	                    }
	                    if (axis !== null && axis !== undefined) {
	                        if (passStoryCheck) {
	                            retRow = returnData[foundIndex];
	                            if (axis._hasMeasure() && d[axis.measure] !== null && d[axis.measure] !== undefined) {
	                                // Keep a distinct list of values to calculate a distinct count in the case of a non-numeric value being found
	                                if (retRow[axis.position + "ValueList"].indexOf(d[axis.measure]) === -1) {
	                                    retRow[axis.position + "ValueList"].push(d[axis.measure]);
	                                }
	                                // The code above is outside this check for non-numeric values because we might encounter one far down the list, and
	                                // want to have a record of all values so far.
	                                if (isNaN(parseFloat(d[axis.measure]))) {
	                                    useCount[axis.position] = true;
	                                }
	                                // Set the value using the aggregate function method
	                                lhs.value = retRow[axis.position + "Value"];
	                                lhs.count = retRow[axis.position + "Count"];
	                                rhs.value = d[axis.measure];
	                                retRow[axis.position + "Value"] = agg(lhs, rhs);
	                                retRow[axis.position + "Count"] += 1;
	                            }
	                        }
	                    }
	                };
	                // Update all the axes
	                updateData(x, this.storyboard);
	                updateData(y, this.storyboard);
	                updateData(z, this.storyboard);
	                updateData(p, this.storyboard);
	                updateData(c, this.storyboard);
	            }, this);
	            // Get secondary elements if necessary
	            if (x && x._hasCategories() && x.categoryFields.length > 1 && secondaryElements.x !== undefined) {
	                groupRules = [];
	                if (y._hasMeasure()) {
	                    groupRules.push({ ordering : y.measure, desc : true });
	                }
	                secondaryElements.x = dimple._getOrderedList(sortedData, x.categoryFields[1], x._groupOrderRules.concat(groupRules));
	            }
	            if (y && y._hasCategories() && y.categoryFields.length > 1 && secondaryElements.y !== undefined) {
	                groupRules = [];
	                if (x._hasMeasure()) {
	                    groupRules.push({ ordering : x.measure, desc : true });
	                }
	                secondaryElements.y = dimple._getOrderedList(sortedData, y.categoryFields[1], y._groupOrderRules.concat(groupRules));
	                secondaryElements.y.reverse();
	            }
	            returnData.forEach(function (ret) {
	                if (x !== null) {
	                    if (useCount.x === true) { ret.xValue = ret.xValueList.length; }
	                    tot = (totals.x[ret.xField.join("/")] || 0) + (y._hasMeasure() ? Math.abs(ret.yValue) : 0);
	                    totals.x[ret.xField.join("/")] = tot;
	                }
	                if (y !== null) {
	                    if (useCount.y === true) { ret.yValue = ret.yValueList.length; }
	                    tot = (totals.y[ret.yField.join("/")] || 0) + (x._hasMeasure() ? Math.abs(ret.xValue) : 0);
	                    totals.y[ret.yField.join("/")] = tot;
	                }
	                if (p !== null) {
	                    if (useCount.p === true) { ret.pValue = ret.pValueList.length; }
	                    tot = (totals.p[ret.pField.join("/")] || 0) + (p._hasMeasure() ? Math.abs(ret.pValue) : 0);
	                    totals.p[ret.pField.join("/")] = tot;
	                }
	                if (z !== null) {
	                    if (useCount.z === true) { ret.zValue = ret.zValueList.length; }
	                    tot = (totals.z[ret.zField.join("/")] || 0) + (z._hasMeasure() ? Math.abs(ret.zValue) : 0);
	                    totals.z[ret.zField.join("/")] = tot;
	                }
	                if (c !== null) {
	                    if (colorBounds.min === null || ret.cValue < colorBounds.min) { colorBounds.min = ret.cValue; }
	                    if (colorBounds.max === null || ret.cValue > colorBounds.max) { colorBounds.max = ret.cValue; }
	                }
	            }, this);
	            // Before calculating the positions we need to sort elements

	            // Set all the dimension properties of the data
	            for (key in totals.x) { if (totals.x.hasOwnProperty(key)) { grandTotals.x += totals.x[key]; } }
	            for (key in totals.y) { if (totals.y.hasOwnProperty(key)) { grandTotals.y += totals.y[key]; } }
	            for (key in totals.p) { if (totals.p.hasOwnProperty(key)) { grandTotals.p += totals.p[key]; } }
	            for (key in totals.z) { if (totals.z.hasOwnProperty(key)) { grandTotals.z += totals.z[key]; } }

	            returnData.forEach(function (ret) {
	                var baseColor,
	                    targetColor,
	                    scale,
	                    colorVal,
	                    floatingPortion,
	                    getAxisData = function (axis, opp, size) {
	                        var totalField,
	                            value,
	                            selectValue,
	                            pos,
	                            cumValue;
	                        if (axis !== null && axis !== undefined) {
	                            pos = axis.position;
	                            if (!axis._hasCategories()) {
	                                value = (axis.showPercent ? ret[pos + "Value"] / totals[opp][ret[opp + "Field"].join("/")] : ret[pos + "Value"]);
	                                totalField = ret[opp + "Field"].join("/") + (ret[pos + "Value"] >= 0);
	                                cumValue = running[pos][totalField] = ((running[pos][totalField] === null || running[pos][totalField] === undefined || pos === "z" || pos === "p") ? 0 : running[pos][totalField]) + value;
	                                selectValue = ret[pos + "Bound"] = ret["c" + pos] = (((pos === "x" || pos === "y") && stacked) ? cumValue : value);
	                                ret[size] = value;
	                                ret[pos] = selectValue - (((pos === "x" && value >= 0) || (pos === "y" && value <= 0)) ? value : 0);
	                            } else {
	                                if (axis._hasMeasure()) {
	                                    totalField = ret[axis.position + "Field"].join("/");
	                                    value = (axis.showPercent ? totals[axis.position][totalField] / grandTotals[axis.position] : totals[axis.position][totalField]);
	                                    if (addedCats.indexOf(totalField) === -1) {
	                                        catTotals[totalField] = value + (addedCats.length > 0 ? catTotals[addedCats[addedCats.length - 1]] : 0);
	                                        addedCats.push(totalField);
	                                    }
	                                    selectValue = ret[pos + "Bound"] = ret["c" + pos] = (((pos === "x" || pos === "y") && stacked) ? catTotals[totalField] : value);
	                                    ret[size] = value;
	                                    ret[pos] = selectValue - (((pos === "x" && value >= 0) || (pos === "y" && value <= 0)) ? value : 0);
	                                } else {
	                                    ret[pos] = ret["c" + pos] = ret[pos + "Field"][0];
	                                    ret[size] = 1;
	                                    if (secondaryElements[pos] !== undefined && secondaryElements[pos] !== null && secondaryElements[pos].length >= 2) {
	                                        ret[pos + "Offset"] = secondaryElements[pos].indexOf(ret[pos + "Field"][1]);
	                                        ret[size] = 1 / secondaryElements[pos].length;
	                                    }
	                                }
	                            }
	                        }
	                    };
	                getAxisData(x, "y", "width");
	                getAxisData(y, "x", "height");
	                getAxisData(z, "z", "r");
	                getAxisData(p, "p", "angle");

	                // If there is a color axis
	                if (c !== null && colorBounds.min !== null && colorBounds.max !== null) {
	                    // Handle matching min and max
	                    if (colorBounds.min === colorBounds.max) {
	                        colorBounds.min -= 0.5;
	                        colorBounds.max += 0.5;
	                    }
	                    // Limit the bounds of the color value to be within the range.  Users may override the axis bounds and this
	                    // allows a 2 color scale rather than blending if the min and max are set to 0 and 0.01 for example negative values
	                    // and zero value would be 1 color and positive another.
	                    colorBounds.min = (c.overrideMin || colorBounds.min);
	                    colorBounds.max = (c.overrideMax || colorBounds.max);
	                    ret.cValue = (ret.cValue > colorBounds.max ? colorBounds.max : (ret.cValue < colorBounds.min ? colorBounds.min : ret.cValue));
	                    // Calculate the factors for the calculations
	                    scale = d3.scale.linear().range([0, (c.colors === null || c.colors.length === 1 ? 1 : c.colors.length - 1)]).domain([colorBounds.min, colorBounds.max]);
	                    colorVal = scale(ret.cValue);
	                    floatingPortion = colorVal - Math.floor(colorVal);
	                    if (ret.cValue === colorBounds.max) {
	                        floatingPortion = 1;
	                    }
	                    // If there is a single color defined
	                    if (c.colors && c.colors.length === 1) {
	                        baseColor = d3.rgb(c.colors[0]);
	                        targetColor = d3.rgb(this.getColor(ret.aggField.slice(-1)[0]).fill);
	                    } else if (c.colors && c.colors.length > 1) {
	                        baseColor = d3.rgb(c.colors[Math.floor(colorVal)]);
	                        targetColor = d3.rgb(c.colors[Math.ceil(colorVal)]);
	                    } else {
	                        baseColor = d3.rgb("white");
	                        targetColor = d3.rgb(this.getColor(ret.aggField.slice(-1)[0]).fill);
	                    }
	                    // Calculate the correct grade of color
	                    baseColor.r = Math.floor(baseColor.r + (targetColor.r - baseColor.r) * floatingPortion);
	                    baseColor.g = Math.floor(baseColor.g + (targetColor.g - baseColor.g) * floatingPortion);
	                    baseColor.b = Math.floor(baseColor.b + (targetColor.b - baseColor.b) * floatingPortion);
	                    // Set the colors on the row
	                    ret.fill = baseColor.toString();
	                    ret.stroke = baseColor.darker(0.5).toString();
	                }

	            }, this);

	            return returnData;

	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_getDelay.js
	        this._getDelay = function (duration, chart, series) {
	            return function (d) {
	                var returnValue = 0;
	                if (series && chart.staggerDraw) {
	                    if (series.x._hasCategories()) {
	                        returnValue = (dimple._helpers.cx(d, chart, series) / chart._widthPixels()) * duration;
	                    } else if (series.y._hasCategories()) {
	                        returnValue = (1 - dimple._helpers.cy(d, chart, series) / chart._heightPixels()) * duration;
	                    }
	                }
	                return returnValue;
	            };
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_getSeriesData.js
	        // Create a dataset containing positioning information for every series
	        this._getSeriesData = function () {

	            // If there are series
	            if (this.series !== null && this.series !== undefined) {

	                // Iterate all the series
	                this.series.forEach(function (series) {

	                    // The data for this series
	                    var data = series.data || this.data || [],
	                        cats = [].concat(series.categoryFields || "All"),
	                        returnData = this._getData(data, cats, series.aggregate, series._orderRules, series._isStacked(), series.x, series.y, series.z, series.p, series.c),
	                        higherLevelData = [],
	                        i,
	                        j,
	                        aCats,
	                        aCatString,
	                        bCats,
	                        bCatString,
	                        pieDictionary = {},
	                        startAngle = (series.startAngle * (Math.PI / 180) || 0),
	                        endAngle = (series.endAngle || 360) * (Math.PI / 180);

	                    // If the startAngle is after the endAngle (e.g. 270deg -> 90deg becomes -90deg -> 90deg.
	                    if (startAngle > endAngle) {
	                        startAngle -= 2 * Math.PI;
	                    }

	                    // If there is a pie axis we need to run a second dataset because the x and y will be
	                    // at a higher level of aggregation than the rows, we want all the segments for a pie chart to
	                    // have the same x and y values
	                    if (series.p && cats.length > 0) {
	                        if (series.x && series.y) {
	                            cats.pop();
	                            higherLevelData = this._getData(data, ["__dimple_placeholder__"].concat(cats), series.aggregate, series._orderRules, series._isStacked(), series.x, series.y, series.z, series.p, series.c);
	                            for (i = 0; i < returnData.length; i += 1) {
	                                aCats = ["__dimple_placeholder__"].concat(returnData[i].aggField);
	                                aCats.pop();
	                                if (series.x && series.x._hasCategories()) {
	                                    aCats = aCats.concat(returnData[i].xField);
	                                }
	                                if (series.y && series.y._hasCategories()) {
	                                    aCats = aCats.concat(returnData[i].yField);
	                                }
	                                aCatString = aCats.join("|");
	                                for (j = 0; j < higherLevelData.length; j += 1) {
	                                    bCats = [].concat(higherLevelData[j].aggField);
	                                    if (series.x && series.x._hasCategories()) {
	                                        bCats = bCats.concat(higherLevelData[j].xField);
	                                    }
	                                    if (series.y && series.y._hasCategories()) {
	                                        bCats = bCats.concat(higherLevelData[j].yField);
	                                    }
	                                    bCatString = bCats.join("|");
	                                    if (aCatString === bCatString) {
	                                        returnData[i].xField = higherLevelData[j].xField;
	                                        returnData[i].xValue = higherLevelData[j].xValue;
	                                        returnData[i].xCount = higherLevelData[j].xCount;
	                                        returnData[i].yField = higherLevelData[j].yField;
	                                        returnData[i].yValue = higherLevelData[j].yValue;
	                                        returnData[i].yCount = higherLevelData[j].yCount;
	                                        returnData[i].zField = higherLevelData[j].zField;
	                                        returnData[i].zValue = higherLevelData[j].zValue;
	                                        returnData[i].zCount = higherLevelData[j].zCount;
	                                        returnData[i].x = higherLevelData[j].x;
	                                        returnData[i].y = higherLevelData[j].y;
	                                        returnData[i].r = higherLevelData[j].r;
	                                        returnData[i].xOffset = higherLevelData[j].xOffset;
	                                        returnData[i].yOffset = higherLevelData[j].yOffset;
	                                        returnData[i].width = higherLevelData[j].width;
	                                        returnData[i].height = higherLevelData[j].height;
	                                        returnData[i].cx = higherLevelData[j].cx;
	                                        returnData[i].cy = higherLevelData[j].cy;
	                                        returnData[i].xBound = higherLevelData[j].xBound;
	                                        returnData[i].yBound = higherLevelData[j].yBound;
	                                        returnData[i].xValueList = higherLevelData[j].xValueList;
	                                        returnData[i].yValueList = higherLevelData[j].yValueList;
	                                        returnData[i].zValueList = higherLevelData[j].zValueList;
	                                        returnData[i].cValueList = higherLevelData[j].cValueList;

	                                        // Add some specific pie properties
	                                        returnData[i].pieKey = higherLevelData[j].key;
	                                        returnData[i].value = returnData.pValue;

	                                        // Annoyingly we can't use the higher aggregate value here because if the series is averaged
	                                        // rather than summed it breaks the logic
	                                        if (!pieDictionary[higherLevelData[j].key]) {
	                                            pieDictionary[higherLevelData[j].key] = {
	                                                total: 0,
	                                                angle: startAngle
	                                            };
	                                        }
	                                        pieDictionary[higherLevelData[j].key].total += returnData[i].pValue;

	                                        break;
	                                    }
	                                }
	                            }
	                        } else {
	                            for (i = 0; i < returnData.length; i += 1) {
	                                // Add some specific pie properties
	                                returnData[i].pieKey = "All";
	                                returnData[i].value = returnData.pValue;

	                                // Annoyingly we can't use the higher aggregate value here because if the series is averaged
	                                // rather than summed it breaks the logic
	                                if (!pieDictionary[returnData[i].pieKey]) {
	                                    pieDictionary[returnData[i].pieKey] = {
	                                        total: 0,
	                                        angle: startAngle
	                                    };
	                                }
	                                pieDictionary[returnData[i].pieKey].total += returnData[i].pValue;
	                            }
	                        }

	                        // Loop again to calculate shares
	                        for (i = 0; i < returnData.length; i += 1) {
	                            returnData[i].piePct = (returnData[i].pValue / pieDictionary[returnData[i].pieKey].total);
	                            returnData[i].startAngle = pieDictionary[returnData[i].pieKey].angle;
	                            returnData[i].endAngle = returnData[i].startAngle + returnData[i].piePct * (endAngle - startAngle);
	                            pieDictionary[returnData[i].pieKey].angle = returnData[i].endAngle;
	                        }
	                    }

	                    // populate the data in the series
	                    series._positionData = returnData;

	                }, this);
	            }
	        };


	          // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/chart/methods/_handleTransition.js
	        this._handleTransition = function (input, duration, chart, series) {
	            var returnShape = null;
	            if (duration === 0) {
	                returnShape = input;
	            } else {
	                returnShape = input.transition()
	                    .duration(duration)
	                    .delay(chart._getDelay(duration, chart, series))
	                    .ease(chart.ease);
	            }
	            return returnShape;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_heightPixels.js
	        // Access the pixel value of the height of the plot area
	        this._heightPixels = function () {
	            return dimple._parseYPosition(this.height, this.svg.node());
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_registerEventHandlers.js
	        // Register events, handle standard d3 shape events
	        this._registerEventHandlers = function (series) {
	            if (series._eventHandlers !== null && series._eventHandlers.length > 0) {
	                series._eventHandlers.forEach(function (thisHandler) {
	                    var name,
	                        handler = function (d) {
	                            var e = new dimple.eventArgs();
	                            if (series.chart.storyboard !== null) {
	                                e.frameValue = series.chart.storyboard.getFrameValue();
	                            }
	                            e.seriesValue = d.aggField;
	                            e.xValue = d.x;
	                            e.yValue = d.y;
	                            e.zValue = d.z;
	                            e.pValue = d.p;
	                            e.colorValue = d.cValue;
	                            e.seriesShapes = series.shapes;
	                            e.selectedShape = d3.select(this);
	                            thisHandler.handler(e);
	                        };
	                    if (thisHandler.handler !== null && typeof (thisHandler.handler) === "function") {
	                        // Some classes work from markers rather than the shapes (line and area for example)
	                        // in these cases the events should be applied to the markers instead.  Issue #15
	                        if (series._markers !== null && series._markers !== undefined) {
	                            for (name in series._markers) {
	                                if (series._markers.hasOwnProperty(name)) {
	                                    series._markers[name].on(thisHandler.event, handler);
	                                }
	                            }
	                        } else {
	                            series.shapes.on(thisHandler.event, handler);
	                        }
	                    }
	                }, this);
	            }
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_widthPixels.js
	        // Access the pixel value of the width of the plot area
	        this._widthPixels = function () {
	            return dimple._parseXPosition(this.width, this.svg.node());
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_xPixels.js
	        // Access the pixel position of the x co-ordinate of the plot area
	        this._xPixels = function () {
	            return dimple._parseXPosition(this.x, this.svg.node());
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/_yPixels.js
	        // Access the pixel position of the y co-ordinate of the plot area
	        this._yPixels = function () {
	            return dimple._parseYPosition(this.y, this.svg.node());
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addAxis.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addAxis
	        this.addAxis  = function (position, categoryFields, measure, timeField) {
	            // The axis to return
	            var axis = null,
	                master = null;
	            // Convert the passed category fields to an array in case a single string is sent
	            if (categoryFields !== null && categoryFields !== undefined) {
	                categoryFields = [].concat(categoryFields);
	            }
	            // If this is a standard axis a position will have been passed as a string
	            if ((typeof position) === "string" || (position instanceof String)) {
	                // Create the axis object based on the passed parameters
	                axis = new dimple.axis(
	                    this,
	                    position,
	                    categoryFields,
	                    measure,
	                    timeField
	                );
	                // Add the axis to the array for the chart
	                this.axes.push(axis);

	            } else {
	                // In the case of a composite axis the position will contain another axis
	                // To make this code more readable reassign the position to a different variable
	                master = position;
	                // Construct the axis object
	                axis = new dimple.axis(
	                    this,
	                    master.position,
	                    categoryFields,
	                    measure,
	                    timeField
	                );
	                // Validate that the master and child axes are compatible
	                if (axis._hasMeasure() !== master._hasMeasure()) {
	                    throw "You have specified a composite axis where some but not all axes have a measure - this is not supported, all axes must be of the same type.";
	                } else if (axis._hasTimeField() !== master._hasTimeField()) {
	                    throw "You have specified a composite axis where some but not all axes have a time field - this is not supported, all axes must be of the same type.";
	                } else if ((axis.categoryFields === null || axis.categoryFields === undefined ? 0 : axis.categoryFields.length) !== (master.categoryFields === null || master.categoryFields === undefined ? 0 : master.categoryFields.length)) {
	                    throw "You have specified a composite axis where axes have differing numbers of category fields - this is not supported, all axes must be of the same type.";
	                }
	                // Do not add the axis to the chart's axes array, instead add it the master
	                master._slaves.push(axis);
	            }
	            // return the axis
	            return axis;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addCategoryAxis.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addCategoryAxis
	        this.addCategoryAxis = function (position, categoryFields) {
	            return this.addAxis(position, categoryFields, null);
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addColorAxis.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addColorAxis
	        this.addColorAxis = function (measure, colors) {
	            var colorAxis = this.addAxis("c", null, measure);
	            colorAxis.colors = (colors === null || colors === undefined ? null : [].concat(colors));
	            return colorAxis;
	        };


	        // Source: /src/objects/chart/methods/addLegend.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addLegend
	        this.addLegend = function (x, y, width, height, horizontalAlign, series) {
	            // Use all series by default
	            series = (series === null || series === undefined ? this.series : [].concat(series));
	            horizontalAlign = (horizontalAlign === null || horizontalAlign === undefined ? "left" : horizontalAlign);
	            // Create the legend
	            var legend = new dimple.legend(this, x, y, width, height, horizontalAlign, series);
	            // Add the legend to the array
	            this.legends.push(legend);
	            // Return the legend object
	            return legend;
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addLogAxis.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addLogAxis
	        this.addLogAxis = function (position, logField, logBase) {
	            var axis = this.addAxis(position, null, logField, null);
	            if (logBase !== null && logBase !== undefined) {
	                axis.logBase = logBase;
	            }
	            axis.useLog = true;
	            return axis;
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addMeasureAxis.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addMeasureAxis
	        this.addMeasureAxis = function (position, measure) {
	            return this.addAxis(position, null, measure);
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addPctAxis.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addPctAxis
	        this.addPctAxis = function (position, measure, categories) {
	            var pctAxis = null;
	            if (categories !== null && categories !== undefined) {
	                pctAxis = this.addAxis(position, categories, measure);
	            } else {
	                pctAxis = this.addMeasureAxis(position, measure);
	            }
	            pctAxis.showPercent = true;
	            return pctAxis;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addSeries.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addSeries
	        this.addSeries = function (categoryFields, plotFunction, axes) {
	            // Deal with no axes passed
	            if (axes === null || axes === undefined) { axes = this.axes; }
	            // Deal with no plot function
	            if (plotFunction === null || plotFunction === undefined) { plotFunction = dimple.plot.bubble; }
	            // Axis objects to be picked from the array
	            var xAxis = null,
	                yAxis = null,
	                zAxis = null,
	                colorAxis = null,
	                pieAxis = null,
	                series;
	            // Iterate the array and pull out the relevant axes
	            axes.forEach(function (axis) {
	                if (axis !== null && plotFunction.supportedAxes.indexOf(axis.position) > -1) {
	                    if (xAxis === null && axis.position[0] === "x") {
	                        xAxis = axis;
	                    } else if (yAxis === null && axis.position[0] === "y") {
	                        yAxis = axis;
	                    } else if (zAxis === null && axis.position[0] === "z") {
	                        zAxis = axis;
	                    } else if (colorAxis === null && axis.position[0] === "c") {
	                        colorAxis = axis;
	                    } else if (colorAxis === null && axis.position[0] === "p") {
	                        pieAxis = axis;
	                    }
	                }
	            }, this);
	            // Put single values into single value arrays
	            if (categoryFields) {
	                categoryFields = [].concat(categoryFields);
	            }
	            // Create a series object
	            series = new dimple.series(
	                this,
	                categoryFields,
	                xAxis,
	                yAxis,
	                zAxis,
	                colorAxis,
	                pieAxis,
	                plotFunction,
	                dimple.aggregateMethod.sum,
	                plotFunction.stacked
	            );
	            // Add the series to the chart's array
	            this.series.push(series);
	            // Return the series
	            return series;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/addTimeAxis.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-addTimeAxis
	        this.addTimeAxis = function (position, timeField, inputFormat, outputFormat) {
	            var axis = this.addAxis(position, null, null, timeField);
	            axis.tickFormat = outputFormat;
	            axis.dateParseFormat = inputFormat;
	            return axis;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/assignClass.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-assignClass
	        this.assignClass = function (tag, css) {
	            this._assignedClasses[tag] = css;
	            return this._assignedClasses[tag];
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/assignColor.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-assignColor
	        this.assignColor = function (tag, fill, stroke, opacity) {
	            this._assignedColors[tag] = new dimple.color(fill, stroke, opacity);
	            return this._assignedColors[tag];
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/customClassList.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-customClassList
	        this.customClassList = {
	            axisLine: 'dimple-custom-axis-line',
	            axisLabel: 'dimple-custom-axis-label',
	            axisTitle: 'dimple-custom-axis-title',
	            tooltipBox: 'dimple-custom-tooltip-box',
	            tooltipLabel: 'dimple-custom-tooltip-label',
	            lineMarker: 'dimple-custom-line-marker',
	            legendLabel: 'dimple-custom-legend-label',
	            legendKey: 'dimple-custom-legend-key',
	            areaSeries: 'dimple-custom-series-area',
	            barSeries: 'dimple-custom-series-bar',
	            bubbleSeries: 'dimple-custom-series-bubble',
	            lineSeries: 'dimple-custom-series-line',
	            pieSeries: 'dimple-custom-series-pie',
	            gridline: 'dimple-custom-gridline',
	            colorClasses: [
	                'dimple-custom-format-1',
	                'dimple-custom-format-2',
	                'dimple-custom-format-3',
	                'dimple-custom-format-4',
	                'dimple-custom-format-5',
	                'dimple-custom-format-6',
	                'dimple-custom-format-7',
	                'dimple-custom-format-8',
	                'dimple-custom-format-9',
	                'dimple-custom-format-10'
	            ]
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/defaultColors.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-defaultColors
	        this.defaultColors = [
	            new dimple.color("#80B1D3"), // Blue
	            new dimple.color("#FB8072"), // Red
	            new dimple.color("#FDB462"), // Orange
	            new dimple.color("#B3DE69"), // Green
	            new dimple.color("#FFED6F"), // Yellow
	            new dimple.color("#BC80BD"), // Purple
	            new dimple.color("#8DD3C7"), // Turquoise
	            new dimple.color("#CCEBC5"), // Pale Blue
	            new dimple.color("#FFFFB3"), // Pale Yellow
	            new dimple.color("#BEBADA"), // Lavender
	            new dimple.color("#FCCDE5"), // Pink
	            new dimple.color("#D9D9D9")  // Grey
	        ];
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/draw.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-draw
	        this.draw = function (duration, noDataChange) {
	            // Deal with optional parameter
	            duration = duration || 0;
	            // Catch the first x and y
	            var firstX = null,
	                firstY = null,
	                distinctCats,
	                xGridSet = false,
	                yGridSet = false,
	                chartX = this._xPixels(),
	                chartY = this._yPixels(),
	                chartWidth = this._widthPixels(),
	                chartHeight = this._heightPixels(),
	                linkedDimensions;

	            // Many of the draw methods use positioning data in each series.  Therefore we should
	            // decorate the series with it now
	            if (noDataChange === undefined || noDataChange === null || noDataChange === false) {
	                this._getSeriesData();
	            }

	            // Clear all scales, this is required to fix Issue #67
	            this.axes.forEach(function (axis) {
	                axis._scale = null;
	            }, this);

	            // Iterate the axes and calculate bounds, this is done within the chart because an
	            // axis' bounds are determined by other axes and the way that series tie them together
	            this.axes.forEach(function (axis) {
	                axis._min = 0;
	                axis._max = 0;
	                linkedDimensions = [];
	                // Check that the axis has a measure
	                if (axis._hasMeasure()) {
	                    // Is this axis linked to a series
	                    var linked = false;
	                    // Find any linked series
	                    this.series.forEach(function (series) {
	                        // if this axis is linked
	                        if (series._deepMatch(axis)) {
	                            // Get the bounds
	                            var bounds = series._axisBounds(axis.position);
	                            if (axis._min > bounds.min) { axis._min = bounds.min; }
	                            if (axis._max < bounds.max) { axis._max = bounds.max; }
	                            linked = true;
	                        }
	                    }, this);
	                    // If the axis is not linked, use the data bounds, this is unlikely to be used
	                    // in a real context, but when developing it is nice to see axes before any series have
	                    // been added.
	                    if (!linked) {
	                        this._getAllData().forEach(function (d) {
	                            if (axis._min > d[axis.measure]) { axis._min = d[axis.measure]; }
	                            if (axis._max < d[axis.measure]) { axis._max = d[axis.measure]; }
	                        }, this);
	                    }
	                } else if (axis._hasTimeField()) {
	                    // Parse the dates and assign the min and max
	                    axis._min = null;
	                    axis._max = null;
	                    // Create an array of dimensions for this axis
	                    this.series.forEach(function (series) {
	                        // if this axis is linked
	                        if (series._deepMatch(axis)
	                                && series[axis.position].timeField !== null
	                                && series[axis.position].timeField !== undefined
	                                && linkedDimensions.indexOf(series[axis.position].timeField) === -1) {
	                            linkedDimensions.push(series[axis.position].timeField);
	                        }
	                    }, this);
	                    // Iterate the data
	                    axis._getAxisData().forEach(function (d) {
	                        // Find any linked series
	                        linkedDimensions.forEach(function (dimension) {
	                            // Check it's timeField
	                            var dt = axis._parseDate(d[dimension]);
	                            if (axis._min === null || dt < axis._min) {
	                                axis._min = dt;
	                            }
	                            if (axis._max === null || dt > axis._max) {
	                                axis._max = dt;
	                            }
	                        }, this);
	                    }, this);
	                } else if (axis._hasCategories()) {
	                    // A category axis is just set to show the number of categories
	                    axis._min = 0;
	                    distinctCats = [];
	                    // Create an array of dimensions for this axis
	                    this.series.forEach(function (series) {
	                        // if this axis is linked
	                        if (series._deepMatch(axis)
	                                && series[axis.position].categoryFields[0] !== null
	                                && series[axis.position].categoryFields[0] !== undefined
	                                && linkedDimensions.indexOf(series[axis.position].categoryFields[0]) === -1) {
	                            linkedDimensions.push(series[axis.position].categoryFields[0]);
	                        }
	                    }, this);
	                    axis._getAxisData().forEach(function (d) {
	                        linkedDimensions.forEach(function (dimension) {
	                            if (distinctCats.indexOf(d[dimension]) === -1) {
	                                distinctCats.push(d[dimension]);
	                            }
	                        }, this);
	                    }, this);
	                    axis._max = distinctCats.length;
	                }
	                // Set the bounds on all slaves
	                if (axis._slaves !== null && axis._slaves !== undefined && axis._slaves.length > 0) {
	                    axis._slaves.forEach(function (slave) {
	                        slave._min = axis._min;
	                        slave._max = axis._max;
	                    }, this);
	                }
	                // Update the axis now we have all information set
	                axis._update();

	                // Record the index of the first x and first y axes
	                if (firstX === null && axis.position === "x") {
	                    firstX = axis;
	                } else if (firstY === null && axis.position === "y") {
	                    firstY = axis;
	                }
	            }, this);
	            // Iterate the axes again
	            this.axes.forEach(function (axis) {
	                // Don't animate axes on first draw
	                var firstDraw = false,
	                    transform = null,
	                    gridSize = 0,
	                    gridTransform = null,
	                    rotated = false,
	                    widest = 0,
	                    box = { l: null, t: null, r: null, b: null },
	                    titleX = 0,
	                    titleY = 0,
	                    rotate = "",
	                    chart = this,
	                    handleTrans = function (ob) {
	                        // Draw the axis
	                        // This code might seem unnecessary but even applying a duration of 0 to a transition will cause the code to execute after the
	                        // code below and precedence is important here.
	                        var returnObj;
	                        if (transform === null || duration === 0 || firstDraw) {
	                            returnObj = ob;
	                        } else {
	                            returnObj = chart._handleTransition(ob, duration, chart);
	                        }
	                        return returnObj;
	                    },
	                    transformLabels = function () {
	                        var t = d3.select(this).selectAll("text");
	                        if (!axis.measure && axis._max > 0) {
	                            if (axis.position === "x") {
	                                t.attr("x", (chartWidth / axis._max) / 2);
	                            } else if (axis.position === "y") {
	                                t.attr("y", -1 * (chartHeight / axis._max) / 2);
	                            }
	                        }
	                        if (axis.categoryFields && axis.categoryFields.length > 0) {
	                            // Off set the labels to counter the transform.  This will put the labels along the outside of the chart so they
	                            // don't interfere with the chart contents
	                            if (axis === firstX && (firstY.categoryFields === null || firstY.categoryFields.length === 0)) {
	                                t.attr("y", chartY + chartHeight - firstY._scale(0) + 9);
	                            }
	                            if (axis === firstY && (firstX.categoryFields === null || firstX.categoryFields.length === 0)) {
	                                t.attr("x", -1 * (firstX._scale(0) - chartX) - 9);
	                            }
	                        }
	                        return this;
	                    },
	                    appendClass = function (css) {
	                        return function () {
	                            var currentCss = d3.select(this).attr("class") || "";
	                            if (currentCss.indexOf(css) === -1) {
	                                currentCss += " " + css;
	                            }
	                            return currentCss.trim();
	                        };
	                    };

	                if (axis.gridlineShapes === null) {
	                    if (axis.showGridlines || (axis.showGridlines === null && !axis._hasCategories() && ((!xGridSet && axis.position === "x") || (!yGridSet && axis.position === "y")))) {
	                        // Add a group for the gridlines to allow css formatting
	                        axis.gridlineShapes = this._group.append("g").attr("class", "dimple-gridline");
	                        if (axis.position === "x") {
	                            xGridSet = true;
	                        } else {
	                            yGridSet = true;
	                        }
	                    }
	                } else {
	                    if (axis.position === "x") {
	                        xGridSet = true;
	                    } else {
	                        yGridSet = true;
	                    }
	                }
	                if (axis.shapes === null) {
	                    // Add a group for the axes to allow css formatting
	                    axis.shapes = this._group.append("g")
	                        .attr("class", "dimple-axis dimple-axis-" + axis.position)
	                        .each(function () {
	                            if (!chart.noFormats) {
	                                d3.select(this)
	                                    .style("font-family", axis.fontFamily)
	                                    .style("font-size", axis._getFontSize());
	                            }
	                        });
	                    firstDraw = true;
	                }
	                // If this is the first x and there is a y axis cross them at zero
	                if (axis === firstX && firstY !== null) {
	                    transform = "translate(0, " + (firstY.categoryFields === null || firstY.categoryFields.length === 0 ? firstY._scale(0) : chartY + chartHeight) + ")";
	                    gridTransform = "translate(0, " + (axis === firstX ? chartY + chartHeight : chartY) + ")";
	                    gridSize = -chartHeight;
	                } else if (axis === firstY && firstX !== null) {
	                    transform = "translate(" + (firstX.categoryFields === null || firstX.categoryFields.length === 0 ? firstX._scale(0) : chartX) + ", 0)";
	                    gridTransform = "translate(" + (axis === firstY ? chartX : chartX + chartWidth) + ", 0)";
	                    gridSize = -chartWidth;
	                } else if (axis.position === "x") {
	                    gridTransform = transform = "translate(0, " + (axis === firstX ? chartY + chartHeight : chartY) + ")";
	                    gridSize = -chartHeight;
	                } else if (axis.position === "y") {
	                    gridTransform = transform = "translate(" + (axis === firstY ? chartX : chartX + chartWidth) + ", 0)";
	                    gridSize = -chartWidth;
	                }
	                if (transform !== null && axis._draw !== null) {
	                    // Add a tick format
	                    if (axis._hasTimeField()) {
	                        handleTrans(axis.shapes)
	                            .call(axis._draw.ticks(axis._getTimePeriod(), axis.timeInterval).tickFormat(axis._getFormat()))
	                            .attr("transform", transform)
	                            .each(transformLabels);
	                    } else if (axis.useLog) {
	                        handleTrans(axis.shapes)
	                            .call(axis._draw.ticks(4, axis._getFormat()))
	                            .attr("transform", transform)
	                            .each(transformLabels);
	                    } else {
	                        handleTrans(axis.shapes)
	                            .call(axis._draw.tickFormat(axis._getFormat()))
	                            .attr("transform", transform)
	                            .each(transformLabels);
	                    }
	                    if (axis.gridlineShapes !== null) {
	                        handleTrans(axis.gridlineShapes)
	                            .call(axis._draw.tickSize(gridSize, 0, 0).tickFormat(""))
	                            .attr("transform", gridTransform);
	                    }
	                }
	                // Set some initial css values
	                handleTrans(axis.shapes.selectAll("text"))
	                    .attr("class", appendClass(chart.customClassList.axisLabel))
	                    .call(function() {
	                        if (!chart.noFormats) {
	                            this.style("font-family", axis.fontFamily)
	                                .style("font-size", axis._getFontSize());
	                        }
	                    });
	                handleTrans(axis.shapes.selectAll("path, line"))
	                    .attr("class", appendClass(chart.customClassList.axisLine))
	                    .call(function() {
	                        if (!chart.noFormats) {
	                            this.style("fill", "none")
	                                .style("stroke", "black")
	                                .style("shape-rendering", "crispEdges");
	                        }
	                    });
	                if (axis.gridlineShapes !== null) {
	                    handleTrans(axis.gridlineShapes.selectAll("line"))
	                        .attr("class", appendClass(chart.customClassList.gridline))
	                        .call(function() {
	                            if (!chart.noFormats) {
	                                this.style("fill", "none")
	                                    .style("stroke", "lightgray")
	                                    .style("opacity", 0.8);
	                            }
	                        });
	                }
	                // Rotate labels, this can only be done once the formats are set
	                if (axis.autoRotateLabel && (axis.measure === null || axis.measure === undefined)) {
	                    if (axis === firstX) {
	                        // If the gaps are narrower than the widest label display all labels horizontally
	                        widest = 0;
	                        axis.shapes.selectAll("text").each(function () {
	                            var w = this.getComputedTextLength();
	                            widest = (w > widest ? w : widest);
	                        });
	                        if (widest > chartWidth / axis.shapes.selectAll("text")[0].length) {
	                            rotated = true;
	                            axis.shapes.selectAll("text")
	                                .style("text-anchor", "start")
	                                .each(function () {
	                                    var rec = this.getBBox();
	                                    d3.select(this)
	                                        .attr("transform", "rotate(90," + rec.x + "," + (rec.y + (rec.height / 2)) + ") translate(-5, 0)");
	                                });
	                        } else {
	                            // For redraw operations we need to clear the transform
	                            rotated = false;
	                            axis.shapes.selectAll("text")
	                                .style("text-anchor", "middle")
	                                .attr("transform", "");
	                        }
	                    } else if (axis.position === "x") {
	                        // If the gaps are narrower than the widest label display all labels horizontally
	                        widest = 0;
	                        axis.shapes.selectAll("text")
	                            .each(function () {
	                                var w = this.getComputedTextLength();
	                                widest = (w > widest ? w : widest);
	                            });
	                        if (widest > chartWidth / axis.shapes.selectAll("text")[0].length) {
	                            rotated = true;
	                            axis.shapes.selectAll("text")
	                                .style("text-anchor", "end")
	                                .each(function () {
	                                    var rec = this.getBBox();
	                                    d3.select(this)
	                                        .attr("transform", "rotate(90," + (rec.x + rec.width) + "," + (rec.y + (rec.height / 2)) + ") translate(5, 0)");
	                                });
	                        } else {
	                            // For redraw operations we need to clear the transform
	                            rotated = false;
	                            axis.shapes.selectAll("text")
	                                .style("text-anchor", "middle")
	                                .attr("transform", "");
	                        }
	                    }
	                } else {
	                    rotated = false;
	                    axis.shapes.selectAll("text")
	                        .style("text-anchor", "middle")
	                        .attr("transform", "");
	                }
	                if (axis.titleShape !== null && axis.titleShape !== undefined) {
	                    axis.titleShape.remove();
	                }
	                // Get the bounds of the axis objects
	                axis.shapes.selectAll("text")
	                    .each(function () {
	                        var rec = this.getBBox();
	                        if (box.l === null ||  -9 - rec.width < box.l) {
	                            box.l = -9 - rec.width;
	                        }
	                        if (box.r === null || rec.x + rec.width > box.r) {
	                            box.r = rec.x + rec.width;
	                        }
	                        if (rotated) {
	                            if (box.t === null || rec.y + rec.height - rec.width < box.t) {
	                                box.t = rec.y + rec.height - rec.width;
	                            }
	                            if (box.b === null || rec.height + rec.width > box.b) {
	                                box.b = rec.height + rec.width;
	                            }
	                        } else {
	                            if (box.t === null || rec.y < box.t) {
	                                box.t = rec.y;
	                            }
	                            if (box.b === null || 9 + rec.height > box.b) {
	                                box.b = 9 + rec.height;
	                            }
	                        }
	                    });

	                if (axis.position === "x") {
	                    if (axis === firstX) {
	                        titleY = chartY + chartHeight + box.b + 5;
	                    } else {
	                        titleY = chartY + box.t - 10;
	                    }
	                    titleX = chartX + (chartWidth / 2);
	                } else if (axis.position === "y") {
	                    if (axis === firstY) {
	                        titleX = chartX + box.l - 10;
	                    } else {
	                        titleX = chartX + chartWidth + box.r + 20;
	                    }
	                    titleY = chartY + (chartHeight / 2);
	                    rotate = "rotate(270, " + titleX + ", " + titleY + ")";
	                }

	                // Add a title for the axis - NB check for null here, by default the title is undefined, in which case
	                // use the dimension name
	                if (!axis.hidden && (axis.position === "x" || axis.position === "y") && axis.title !== null) {
	                    axis.titleShape = this._group.append("text")
	                        .attr("class", "dimple-axis dimple-title " + chart.customClassList.axisTitle + " dimple-axis-" + axis.position);
	                    axis.titleShape
	                        .attr("x", titleX)
	                        .attr("y", titleY)
	                        .attr("text-anchor", "middle")
	                        .attr("transform", rotate)
	                        .text(axis.title !== undefined ? axis.title : (axis.categoryFields === null || axis.categoryFields === undefined || axis.categoryFields.length === 0 ? axis.measure : axis.categoryFields.join("/")))
	                        .each(function () {
	                            if (!chart.noFormats) {
	                                d3.select(this)
	                                    .style("font-family", axis.fontFamily)
	                                    .style("font-size", axis._getFontSize());
	                            }
	                        });

	                    // Offset Y position to baseline. This previously used dominant-baseline but this caused
	                    // browser inconsistency
	                    if (axis === firstX) {
	                        axis.titleShape.each(function () {
	                            d3.select(this).attr("y", titleY + this.getBBox().height / 1.65);
	                        });
	                    } else if (axis === firstY) {
	                        axis.titleShape.each(function () {
	                            d3.select(this).attr("x", titleX + this.getBBox().height / 1.65);
	                        });
	                    }
	                }
	               // }
	            }, this);

	            // Iterate the series
	            this.series.forEach(function (series) {
	                series.plot.draw(this, series, duration);
	                this._registerEventHandlers(series);
	            }, this);

	            // Iterate the legends
	            this.legends.forEach(function (legend) {
	                legend._draw();
	            }, this);

	            // If the chart has a storyboard
	            if (this.storyboard) {
	                this.storyboard._drawText();
	                if (this.storyboard.autoplay) {
	                    this.storyboard.startAnimation();
	                }
	            }

	            // Return the chart for chaining
	            return this;

	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/getClass.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-getClass
	        this.getClass = function (tag) {
	            // If no class is assigned, do so here
	            if (!this._assignedClasses[tag]) {
	                this._assignedClasses[tag] = this.customClassList.colorClasses[this._nextClass];
	                this._nextClass = (this._nextClass + 1) % this.customClassList.colorClasses.length;
	            }
	            // Return the class
	            return this._assignedClasses[tag];
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/getColor.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-getColor
	        this.getColor = function (tag) {
	            // If no color is assigned, do so here
	            if (this._assignedColors[tag] === null || this._assignedColors[tag] === undefined) {
	                this._assignedColors[tag] = this.defaultColors[this._nextColor];
	                this._nextColor = (this._nextColor + 1) % this.defaultColors.length;
	            }
	            // Return the color
	            return this._assignedColors[tag];
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/setBounds.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-setBounds
	        this.setBounds = function (x, y, width, height) {
	            // Store the passed parameters
	            this.x = x;
	            this.y = y;
	            this.width = width;
	            this.height = height;
	            // Access the pixel value of the x coordinate
	            this._xPixels = function () {
	                return dimple._parseXPosition(this.x, this.svg.node());
	            };
	            this.draw(0, true);
	            // Access the pixel value of the y coordinate
	            this._yPixels = function () {
	                return dimple._parseYPosition(this.y, this.svg.node());
	            };
	            // Access the pixel value of the width coordinate
	            this._widthPixels = function () {
	                return dimple._parseXPosition(this.width, this.svg.node());
	            };
	            // Access the pixel value of the width coordinate
	            this._heightPixels = function () {
	                return dimple._parseYPosition(this.height, this.svg.node());
	            };
	            // Refresh the axes to redraw them against the new bounds
	            // return the chart object for method chaining
	            return this;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/setMargins.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-setMargins
	        this.setMargins = function (left, top, right, bottom) {
	            // Set the bounds here, functions below will be used for access
	            this.x = left;
	            this.y = top;
	            this.width = 0;
	            this.height = 0;
	            // Access the pixel value of the x coordinate
	            this._xPixels = function () {
	                return dimple._parseXPosition(this.x, this.svg.node());
	            };
	            // Access the pixel value of the y coordinate
	            this._yPixels = function () {
	                return dimple._parseYPosition(this.y, this.svg.node());
	            };
	            // Access the pixel value of the width coordinate
	            this._widthPixels = function () {
	                return dimple._parentWidth(this.svg.node()) - this._xPixels() - dimple._parseXPosition(right, this.svg.node());
	            };
	            // Access the pixel value of the width coordinate
	            this._heightPixels = function () {
	                return dimple._parentHeight(this.svg.node()) - this._yPixels() - dimple._parseYPosition(bottom, this.svg.node());
	            };
	            // Refresh the axes to redraw them against the new bounds
	            this.draw(0, true);
	            // return the chart object for method chaining
	            return this;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/chart/methods/setStoryboard.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.chart#wiki-setStoryboard
	        this.setStoryboard = function (categoryFields, tickHandler) {
	            // Create and assign the storyboard
	            this.storyboard = new dimple.storyboard(this, categoryFields);
	            // Set the event handler
	            if (tickHandler !== null && tickHandler !== undefined) {
	                this.storyboard.onTick = tickHandler;
	            }
	            // Return the storyboard
	            return this.storyboard;
	        };

	    };
	    // End dimple.chart


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/color/begin.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.color
	    dimple.color = function (fill, stroke, opacity) {

	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.color#wiki-fill
	        this.fill = fill;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.color#wiki-stroke
	        this.stroke = (stroke === null || stroke === undefined ? d3.rgb(fill).darker(0.5).toString() : stroke);
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.color#wiki-opacity
	        this.opacity = (opacity === null || opacity === undefined ? 0.8 : opacity);

	    };
	    // End dimple.color


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/eventArgs/begin.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs
	    dimple.eventArgs = function () {

	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-seriesValue
	        this.seriesValue = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-xValue
	        this.xValue = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-yValue
	        this.yValue = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-zValue
	        this.zValue = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-pValue
	        this.pValue = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-colorValue
	        this.colorValue = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-frameValue
	        this.frameValue = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-seriesShapes
	        this.seriesShapes = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.eventArgs#wiki-selectedShape
	        this.selectedShape = null;

	    };
	    // End dimple.eventArgs


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/legend/begin.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend
	    dimple.legend = function (chart, x, y, width, height, horizontalAlign, series) {

	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-chart
	        this.chart = chart;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-series
	        this.series = series;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-x
	        this.x = x;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-y
	        this.y = y;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-width
	        this.width = width;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-height
	        this.height = height;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-horizontalAlign
	        this.horizontalAlign = horizontalAlign;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-shapes
	        this.shapes = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-fontSize
	        this.fontSize = "10px";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.legend#wiki-fontFamily
	        this.fontFamily = "sans-serif";

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_draw.js
	        // Render the legend
	        this._draw = function () {

	            // Create an array of distinct color elements from the series
	            var legendArray = this._getEntries(),
	                maxWidth = 0,
	                maxHeight = 0,
	                runningX = 0,
	                runningY = 0,
	                keyWidth = 15,
	                keyHeight = 9,
	                distanceBetweenKeyAndText = 5,
	                self = this,
	                theseShapes;

	            // If there is already a legend remove it
	            if (this.shapes) {
	                this.shapes.remove();
	            }

	            // Create an empty hidden group for every legend entry
	            // the selector here must not pick up any legend entries being removed by the
	            // transition above
	            theseShapes = this.chart._group
	                .selectAll(".dimple-dont-select-any")
	                .data(legendArray)
	                .enter()
	                .append("g")
	                .attr("class", function (d) {
	                    return "dimple-legend " + dimple._createClass(d.aggField);
	                })
	                .attr("opacity", 1);

	            // Add text into the group
	            theseShapes.append("text")
	                .attr("class", function (d) {
	                    return "dimple-legend dimple-legend-text " + dimple._createClass(d.aggField) + " " + self.chart.customClassList.legendLabel;
	                })
	                .text(function(d) {
	                    return d.key;
	                })
	                .call(function () {
	                    if (!self.chart.noFormats) {
	                        this.style("font-family", self.fontFamily)
	                            .style("font-size", self._getFontSize())
	                            .style("shape-rendering", "crispEdges");
	                    }
	                })
	                .each(function () {
	                    var b = this.getBBox();
	                    if (b.width > maxWidth) {
	                        maxWidth = b.width;
	                    }
	                    if (b.height > maxHeight) {
	                        maxHeight = b.height;
	                    }
	                });

	            // Add a rectangle into the group
	            theseShapes.append("rect")
	                .attr("class", function (d) {
	                    return "dimple-legend dimple-legend-key " + dimple._createClass(d.aggField);
	                })
	                .attr("height", keyHeight)
	                .attr("width",  keyWidth);

	            // Expand the bounds of the largest shape slightly.  This will be the size allocated to
	            // all elements
	            maxHeight = (maxHeight < keyHeight ? keyHeight : maxHeight) + self._getVerticalPadding();
	            maxWidth += keyWidth + self._getHorizontalPadding();

	            // Iterate the shapes and position them based on the alignment and size of the legend
	            theseShapes
	                .each(function (d) {
	                    if (runningX + maxWidth > self._widthPixels()) {
	                        runningX = 0;
	                        runningY += maxHeight;
	                    }
	                    if (runningY > self._heightPixels()) {
	                        d3.select(this).remove();
	                    } else {
	                        d3.select(this).select("text")
	                            .attr("x", (self.horizontalAlign === "left" ? self._xPixels() + keyWidth + distanceBetweenKeyAndText + runningX : self._xPixels() + (self._widthPixels() - runningX - maxWidth) + keyWidth + distanceBetweenKeyAndText))
	                            .attr("y", function () {
	                                // This was previously done with dominant-baseline but this is used
	                                // instead due to browser inconsistency.
	                                return self._yPixels() + runningY + this.getBBox().height / 1.65;
	                            })
	                            .attr("width", self._widthPixels())
	                            .attr("height", self._heightPixels());
	                        d3.select(this).select("rect")
	                            .attr("class", function (d) {
	                                return "dimple-legend dimple-legend-key " + dimple._createClass(d.aggField) + " " + self.chart.customClassList.legendKey + " " + d.css;
	                            })
	                            .attr("x", (self.horizontalAlign === "left" ? self._xPixels() + runningX : self._xPixels() + (self._widthPixels() - runningX - maxWidth)))
	                            .attr("y", self._yPixels() + runningY)
	                            .attr("height", keyHeight)
	                            .attr("width",  keyWidth)
	                            .call(function() {
	                                if (!self.chart.noFormats) {
	                                    this.style("fill", d.fill)
	                                        .style("stroke", d.stroke)
	                                        .style("opacity", d.opacity)
	                                        .style("shape-rendering", "crispEdges");
	                                }
	                            });
	                        runningX += maxWidth;
	                    }
	                });

	            // Assign them to the public property for modification by the user.
	            this.shapes = theseShapes;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_getEntries.js
	        // Get an array of elements to be displayed in the legend
	        this._getEntries = function () {
	            // Create an array of distinct series values
	            var entries = [];
	            // If there are some series
	            if (this.series) {
	                // Iterate all the associated series
	                this.series.forEach(function (series) {
	                    // Get the series data
	                    var data = series._positionData;
	                    // Iterate the aggregated data
	                    data.forEach(function (row) {
	                        // Check whether this element is new
	                        var index = -1,
	                            j,
	                            // Handle grouped plots (e.g. line and area where multiple points are coloured the same way
	                            field = ((series.plot.grouped && !series.x._hasCategories() && !series.y._hasCategories() && row.aggField.length < 2 ? "All" : row.aggField.slice(-1)[0]));
	                        for (j = 0; j < entries.length; j += 1) {
	                            if (entries[j].key === field) {
	                                index = j;
	                                break;
	                            }
	                        }
	                        if (index === -1 && series.chart._assignedColors[field]) {
	                            // If it's a new element create a new row in the return array
	                            entries.push({
	                                key: field,
	                                fill: series.chart._assignedColors[field].fill,
	                                stroke: series.chart._assignedColors[field].stroke,
	                                opacity: series.chart._assignedColors[field].opacity,
	                                css: series.chart._assignedClasses[field],
	                                series: series,
	                                aggField: row.aggField
	                            });
	                            index = entries.length - 1;
	                        }
	                    });
	                }, this);
	            }
	            return entries;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_getFontSize.js
	        this._getFontSize = function () {
	            var fontSize;
	            if (!this.fontSize || this.fontSize.toString().toLowerCase() === "auto") {
	                fontSize = (this.chart._heightPixels() / 35 > 10 ? this.chart._heightPixels() / 35 : 10) + "px";
	            } else if (!isNaN(this.fontSize)) {
	                fontSize = this.fontSize + "px";
	            } else {
	                fontSize = this.fontSize;
	            }
	            return fontSize;
	        };

	        // Copyright: 2015 PMSI-AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_getHorizontalPadding.js
	        this._getHorizontalPadding = function () {
	            var horizontalPadding;
	            if (isNaN(this.horizontalPadding)) {
	                horizontalPadding = 20;
	            } else {
	                horizontalPadding = this.horizontalPadding;
	            }
	            return horizontalPadding;
	        };

	        // Copyright: 2015 PMSI-AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_getVerticalPadding.js
	        this._getVerticalPadding = function () {
	            var verticalPadding;
	            if (isNaN(this.verticalPadding)) {
	                verticalPadding = 2;
	            } else {
	                verticalPadding = this.verticalPadding;
	            }
	            return verticalPadding;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_heightPixels.js
	        // Access the pixel value of the height of the legend area
	        this._heightPixels = function () {
	            return dimple._parseYPosition(this.height, this.chart.svg.node());
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_widthPixels.js
	        // Access the pixel value of the width of the legend area
	        this._widthPixels = function () {
	            return dimple._parseXPosition(this.width, this.chart.svg.node());
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_xPixels.js
	        // Access the pixel position of the x co-ordinate of the legend area
	        this._xPixels = function () {
	            return dimple._parseXPosition(this.x, this.chart.svg.node());
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/legend/methods/_yPixels.js
	        // Access the pixel position of the y co-ordinate of the legend area
	        this._yPixels = function () {
	            return dimple._parseYPosition(this.y, this.chart.svg.node());
	        };
	    };
	    // End dimple.legend


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/series/begin.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series
	    dimple.series = function (chart, categoryFields, xAxis, yAxis, zAxis, colorAxis, pieAxis, plotFunction, aggregateFunction, stacked) {

	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-chart
	        this.chart = chart;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-x
	        this.x = xAxis;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-y
	        this.y = yAxis;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-z
	        this.z = zAxis;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-c
	        this.c = colorAxis;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-p
	        this.p = pieAxis;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-plot
	        this.plot = plotFunction;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-categoryFields
	        this.categoryFields = categoryFields;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-aggregateFunction
	        this.aggregate = aggregateFunction;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-stacked
	        this.stacked = stacked;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-barGap
	        this.barGap = 0.2;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-clusterBarGap
	        this.clusterBarGap = 0.1;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-lineWeight
	        this.lineWeight = 2;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-lineMarkers
	        this.lineMarkers = false;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-afterDraw
	        this.afterDraw = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-interpolation
	        this.interpolation = "linear";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-fontSize
	        this.tooltipFontSize = "10px";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-fontFamily
	        this.tooltipFontFamily = "sans-serif";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.axis#wiki-radius
	        this.radius = "auto";

	        // Any event handlers joined to this series
	        this._eventHandlers = [];
	        // The series positioning information
	        this._positionData = [];
	        // The order definition array
	        this._orderRules = [];

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/_axisBounds.js
	        this._axisBounds = function (position) {
	            var bounds = { min: 0, max: 0 },
	                // The primary axis for this comparison
	                primaryAxis = null,
	                // The secondary axis for this comparison
	                secondaryAxis = null,
	                // The running totals of the categories
	                categoryTotals = [],
	                // The maximum index of category totals
	                catCount = 0,
	                measureName,
	                fieldName,
	                distinctCats,
	                aggData = this._positionData;

	            // If the primary axis is x the secondary is y and vice versa, a z axis has no secondary
	            if (position === "x") {
	                primaryAxis = this.x;
	                secondaryAxis = this.y;
	            } else if (position === "y") {
	                primaryAxis = this.y;
	                secondaryAxis = this.x;
	            } else if (position === "z") {
	                primaryAxis = this.z;
	            } else if (position === "p") {
	                primaryAxis = this.p;
	            } else if (position === "c") {
	                primaryAxis = this.c;
	            }

	            // If the corresponding axis is category axis
	            if (primaryAxis.showPercent) {
	                // Iterate the data
	                aggData.forEach(function (d) {
	                    if (d[primaryAxis.position + "Bound"] < bounds.min) {
	                        bounds.min = d[primaryAxis.position + "Bound"];
	                    }
	                    if (d[primaryAxis.position + "Bound"] > bounds.max) {
	                        bounds.max = d[primaryAxis.position + "Bound"];
	                    }
	                }, this);
	            } else if (secondaryAxis === null || secondaryAxis.categoryFields === null || secondaryAxis.categoryFields.length === 0) {
	                aggData.forEach(function (d) {
	                    // If the primary axis is stacked
	                    if (this._isStacked() && (primaryAxis.position === "x" || primaryAxis.position === "y")) {
	                        // We just need to push the bounds.  A stacked axis will always include 0 so I just need to push the min and max out from there
	                        if (d[primaryAxis.position + "Value"] < 0) {
	                            bounds.min = bounds.min + d[primaryAxis.position + "Value"];
	                        } else {
	                            bounds.max = bounds.max + d[primaryAxis.position + "Value"];
	                        }
	                    } else {
	                        // If it isn't stacked we need to catch the minimum and maximum values
	                        if (d[primaryAxis.position + "Value"] < bounds.min) {
	                            bounds.min = d[primaryAxis.position + "Value"];
	                        }
	                        if (d[primaryAxis.position + "Value"] > bounds.max) {
	                            bounds.max = d[primaryAxis.position + "Value"];
	                        }
	                    }
	                }, this);
	            } else {
	                // If this category value (or combination if multiple fields defined) is not already in the array of categories, add it.
	                measureName = primaryAxis.position + "Value";
	                fieldName = secondaryAxis.position + "Field";
	                // Get a list of distinct categories on the secondary axis
	                distinctCats = [];
	                aggData.forEach(function (d) {
	                    // Create a field for this row in the aggregated data
	                    var field = d[fieldName].join("/"),
	                        index = distinctCats.indexOf(field);
	                    if (index === -1) {
	                        distinctCats.push(field);
	                        index = distinctCats.length - 1;
	                    }
	                    // Get the index of the field
	                    if (categoryTotals[index] === undefined) {
	                        categoryTotals[index] = { min: 0, max: 0 };
	                        if (index >= catCount) {
	                            catCount = index + 1;
	                        }
	                    }
	                    // The secondary axis is a category axis, we need to account
	                    // for distribution across categories
	                    if (this.stacked) {
	                        if (d[measureName] < 0) {
	                            categoryTotals[index].min = categoryTotals[index].min + d[measureName];
	                        } else {
	                            categoryTotals[index].max = categoryTotals[index].max + d[measureName];
	                        }
	                    } else {
	                        // If it isn't stacked we need to catch the minimum and maximum values
	                        if (d[measureName] < categoryTotals[index].min) {
	                            categoryTotals[index].min = d[measureName];
	                        }
	                        if (d[measureName] > categoryTotals[index].max) {
	                            categoryTotals[index].max = d[measureName];
	                        }
	                    }
	                }, this);
	                categoryTotals.forEach(function (catTot) {
	                    if (catTot !== undefined) {
	                        if (catTot.min < bounds.min) {
	                            bounds.min = catTot.min;
	                        }
	                        if (catTot.max > bounds.max) {
	                            bounds.max = catTot.max;
	                        }
	                    }
	                }, this);
	            }
	            return bounds;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/_deepMatch.js
	        this._deepMatch = function (axis) {
	            // Return true if this series is dependant on the axis or any of its dependants
	            var match = false;
	            if (this[axis.position] === axis) {
	                match = true;
	            } else if (axis._slaves !== undefined && axis._slaves !== null && axis._slaves.length > 0) {
	                axis._slaves.forEach(function (slave) {
	                    match = (match || this._deepMatch(slave));
	                }, this);
	            }
	            return match;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/_dropLineOrigin.js
	        this._dropLineOrigin = function() {

	            // Get the origin co-ordinates for axis drop lines
	            var xIndex = 0,
	                yIndex = 0,
	                // This contains the drop line destinations
	                coord = {
	                    // The x co-ordinate for a y-axis drop line
	                    x: null,
	                    // The y co-ordinate for an x-axis drop line
	                    y: null
	                },
	                // The origin of the first axes
	                firstOrig = {
	                    x: null,
	                    y: null
	                };
	            // Get the first x and y first of all
	            this.chart.axes.forEach(function (axis) {
	                if (axis.position === "x" && firstOrig.x === null) {
	                    if (axis._hasTimeField()) {
	                        firstOrig.x = this.chart._xPixels();
	                    } else {
	                        firstOrig.x = axis._origin;
	                    }
	                } else if (axis.position === "y" && firstOrig.y === null) {
	                    if (axis._hasTimeField()) {
	                        firstOrig.y = this.chart._yPixels() + this.chart._heightPixels();
	                    } else {
	                        firstOrig.y = axis._origin;
	                    }
	                }
	            }, this);
	            // Get the axis position based on the axis index
	            this.chart.axes.forEach(function (axis) {
	                if (axis.position === "x" && !this.x.hidden) {
	                    if (this._deepMatch(axis)) {
	                        // Set the y co-ordinate for the x axis
	                        if (xIndex === 0) {
	                            coord.y = firstOrig.y;
	                        } else if (xIndex === 1) {
	                            coord.y = this.chart._yPixels();
	                        }
	                    }
	                    xIndex += 1;
	                } else if (axis.position === "y" && !this.y.hidden) {
	                    if (this._deepMatch(axis)) {
	                        // Set the x co-ordinate for the y axis 
	                        if (yIndex === 0) {
	                            coord.x = firstOrig.x;
	                        } else if (yIndex === 1) {
	                            coord.x = this.chart._xPixels() + this.chart._widthPixels();
	                        }
	                    }
	                    yIndex += 1;
	                }
	            }, this);

	            // Return the co-ordinate
	            return coord;
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/_getTooltipFontSize.js
	        this._getTooltipFontSize = function () {
	            var fontSize;
	            if (!this.tooltipFontSize || this.tooltipFontSize.toString().toLowerCase() === "auto") {
	                fontSize = (this.chart._heightPixels() / 35 > 10 ? this.chart._heightPixels() / 35 : 10) + "px";
	            } else if (!isNaN(this.tooltipFontSize)) {
	                fontSize = this.tooltipFontSize + "px";
	            } else {
	                fontSize = this.tooltipFontSize;
	            }
	            return fontSize;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/_isStacked.js
	        this._isStacked = function() {
	            return this.stacked && (this.x._hasCategories() || this.y._hasCategories());
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/addEventHandler.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-addEventHandler
	        this.addEventHandler = function (event, handler) {
	            this._eventHandlers.push({ event: event, handler: handler });
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/addOrderRule.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.series#wiki-addOrderRule
	        this.addOrderRule = function (ordering, desc) {
	            this._orderRules.push({ ordering : ordering, desc : desc });
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/series/methods/getTooltipText.js
	        this.getTooltipText = function (e) {
	            var rows = [];
	            // Add the series categories
	            if (this.categoryFields !== null && this.categoryFields !== undefined && this.categoryFields.length > 0) {
	                this.categoryFields.forEach(function (c, i) {
	                    if (c !== null && c !== undefined && e.aggField[i] !== null && e.aggField[i] !== undefined) {
	                        // If the category name and value match don't display the category name
	                        rows.push(c + (e.aggField[i] !== c ? ": " + e.aggField[i] : ""));
	                    }
	                }, this);
	            }


	            if (!this.p) {
	                if (this.x) {
	                    this.x._getTooltipText(rows, e);
	                }
	                if (this.y) {
	                    this.y._getTooltipText(rows, e);
	                }
	                if (this.z) {
	                    this.z._getTooltipText(rows, e);
	                }
	            } else {
	                if (this.x && this.x._hasCategories()) {
	                    this.x._getTooltipText(rows, e);
	                }
	                if (this.y && this.y._hasCategories()) {
	                    this.y._getTooltipText(rows, e);
	                }
	                if (this.z && this.z._hasCategories()) {
	                    this.z._getTooltipText(rows, e);
	                }
	                this.p._getTooltipText(rows, e);
	            }
	            if (this.c) {
	                this.c._getTooltipText(rows, e);
	            }
	            // Get distinct text rows to deal with cases where 2 axes have the same dimensionality
	            return rows.filter(function (elem, pos) { return rows.indexOf(elem) === pos; });
	        };
	    };
	    // End dimple.series


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/storyboard/begin.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard
	    dimple.storyboard = function (chart, categoryFields) {

	        // Handle an individual string as an array
	        if (categoryFields !== null && categoryFields !== undefined) {
	            categoryFields = [].concat(categoryFields);
	        }

	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-chart
	        this.chart = chart;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-categoryFields
	        this.categoryFields = categoryFields;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-autoplay
	        this.autoplay = true;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-frameDuration
	        this.frameDuration = 3000;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-storyLabel
	        this.storyLabel = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-onTick
	        this.onTick = null;
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-fontSize
	        this.fontSize = "10px";
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-fontFamily
	        this.fontFamily = "sans-serif";

	        // The current frame index
	        this._frame = 0;
	        // The animation interval
	        this._animationTimer = null;
	        // The category values
	        this._categories = [];
	        // The category values when the last cache happened
	        this._cachedCategoryFields = [];
	        // The rules for ordering the storyboard
	        this._orderRules = [];

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/drawText.js
	        this._drawText = function () {
	            if (!this.storyLabel) {
	                var chart = this.chart,
	                    self = this,
	                    xCount = 0;
	                // Check for a secondary x axis
	                this.chart.axes.forEach(function (a) {
	                    if (a.position === "x") {
	                        xCount += 1;
	                    }
	                }, this);
	                this.storyLabel = this.chart._group.append("text")
	                    .attr("class", "dimple-storyboard-label")
	                    .attr("opacity", 1)
	                    .attr("x", this.chart._xPixels() + this.chart._widthPixels() * 0.01)
	                    .attr("y", this.chart._yPixels() + (this.chart._heightPixels() / 35 > 10 ? this.chart._heightPixels() / 35 : 10) * (xCount > 1 ? 1.25 : -1))
	                    .call(function () {
	                        if (!chart.noFormats) {
	                            this.style("font-family", self.fontFamily)
	                                .style("font-size", self._getFontSize());
	                        }
	                    });
	            }
	            this.storyLabel
	                .text(this.categoryFields.join("\\") + ": " + this.getFrameValue());
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/_getCategories.js
	        this._getCategories = function() {
	            if (this._categoryFields !== this._cachedCategoryFields) {
	                // Clear the array
	                this._categories = [];
	                // Iterate every row in the data
	                this.chart._getAllData().forEach(function (d) {
	                    // Initialise the index of the categories array matching the current row
	                    var index = -1,
	                        field = "";
	                    // If this is a category axis handle multiple category values by iterating the fields in the row and concatonate the values
	                    if (this.categoryFields !== null) {
	                        this.categoryFields.forEach(function (cat, i) {
	                            if (i > 0) {
	                                field += "/";
	                            }
	                            field += d[cat];
	                        }, this);
	                        index = this._categories.indexOf(field);
	                        if (index === -1) {
	                            this._categories.push(field);
	                            index = this._categories.length - 1;
	                        }
	                    }
	                }, this);
	                // Mark this as cached
	                this._cachedCategoryFields = this._categoryFields;
	            }
	            // Return the array
	            return this._categories;
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/_getFontSize.js
	        this._getFontSize = function () {
	            var fontSize;
	            if (!this.fontSize || this.fontSize.toString().toLowerCase() === "auto") {
	                fontSize = (this.chart._heightPixels() / 35 > 10 ? this.chart._heightPixels() / 35 : 10) + "px";
	            } else if (!isNaN(this.fontSize)) {
	                fontSize = this.fontSize + "px";
	            } else {
	                fontSize = this.fontSize;
	            }
	            return fontSize;
	        };

	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/_goToFrameIndex.js
	        this._goToFrameIndex = function (index) {
	            this._frame = index % this._getCategories().length;
	            // Draw it with half duration, we want the effect of a 50% animation 50% pause.
	            this.chart.draw(this.frameDuration / 2);
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/addOrderRule.js
	        // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple.storyboard#wiki-addOrderRule
	        this.addOrderRule = function (ordering, desc) {
	            this._orderRules.push({ ordering : ordering, desc : desc });
	        };
	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/getFrameValue.js
	        this.getFrameValue = function () {
	            var returnValue = null;
	            if (this._frame >= 0 && this._getCategories().length > this._frame) {
	                returnValue = this._getCategories()[this._frame];
	            }
	            return returnValue;
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/goToFrame.js
	        this.goToFrame = function (frameText) {
	            if (this._getCategories().length > 0) {
	                var index = this._getCategories().indexOf(frameText);
	                this._goToFrameIndex(index);
	            }
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/pauseAnimation.js
	        this.pauseAnimation = function () {
	            if (this._animationTimer !== null) {
	                window.clearInterval(this._animationTimer);
	                this._animationTimer = null;
	            }
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/startAnimation.js
	        this.startAnimation = function () {
	            if (this._animationTimer === null) {
	                if (this.onTick !== null) { this.onTick(this.getFrameValue()); }
	                this._animationTimer = window.setInterval((function (storyboard) {
	                    return function () {
	                        storyboard._goToFrameIndex(storyboard._frame + 1);
	                        if (storyboard.onTick !== null) {
	                            storyboard.onTick(storyboard.getFrameValue());
	                        }
	                        storyboard._drawText(storyboard.frameDuration / 2);
	                    };
	                }(this)), this.frameDuration);
	            }
	        };


	        // Copyright: 2015 AlignAlytics
	        // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	        // Source: /src/objects/storyboard/methods/stopAnimation.js
	        this.stopAnimation = function () {
	            if (this._animationTimer !== null) {
	                window.clearInterval(this._animationTimer);
	                this._animationTimer = null;
	                this._frame = 0;
	            }
	        };


	    };
	    // End dimple.storyboard


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/aggregateMethod/avg.js
	    dimple.aggregateMethod.avg = function (lhs, rhs) {
	        lhs.value = (lhs.value === null || lhs.value === undefined ? 0 : parseFloat(lhs.value));
	        lhs.count = (lhs.count === null || lhs.count === undefined ? 1 : parseFloat(lhs.count));
	        rhs.value = (rhs.value === null || rhs.value === undefined ? 0 : parseFloat(rhs.value));
	        rhs.count = (rhs.count === null || rhs.count === undefined ? 1 : parseFloat(rhs.count));
	        return ((lhs.value * lhs.count) + (rhs.value * rhs.count)) / (lhs.count + rhs.count);
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/aggregateMethod/count.js
	    dimple.aggregateMethod.count = function (lhs, rhs) {
	        lhs.count = (lhs.count === null || lhs.count === undefined ? 0 : parseFloat(lhs.count));
	        rhs.count = (rhs.count === null || rhs.count === undefined ? 0 : parseFloat(rhs.count));
	        return lhs.count + rhs.count;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/aggregateMethod/max.js
	    dimple.aggregateMethod.max = function (lhs, rhs) {
	        lhs.value = (lhs.value === null || lhs.value === undefined ? 0 : parseFloat(lhs.value));
	        rhs.value = (rhs.value === null || rhs.value === undefined ? 0 : parseFloat(rhs.value));
	        return lhs.value > rhs.value ? lhs.value : rhs.value;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/aggregateMethod/min.js
	    dimple.aggregateMethod.min = function (lhs, rhs) {
	        return (lhs.value === null ? parseFloat(rhs.value) : (parseFloat(lhs.value) < parseFloat(rhs.value) ? parseFloat(lhs.value) : parseFloat(rhs.value)));
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/aggregateMethod/sum.js
	    dimple.aggregateMethod.sum = function (lhs, rhs) {
	        lhs.value = (lhs.value === null || lhs.value === undefined ? 0 : parseFloat(lhs.value));
	        rhs.value = (rhs.value === null || rhs.value === undefined ? 0 : parseFloat(rhs.value));
	        return lhs.value + rhs.value;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/plot/area.js
	    dimple.plot.area = {

	        // By default the values are stacked
	        stacked: true,

	        // This is a grouped plot meaning many points are treated as one series value
	        grouped: true,

	        // The axis positions affecting the area series
	        supportedAxes: ["x", "y", "c"],

	        // Draw the axis
	        draw: function (chart, series, duration) {
	            // Get the position data
	            var data = series._positionData,
	                areaData = [],
	                theseShapes = null,
	                className = "dimple-series-" + chart.series.indexOf(series),
	                firstAgg = (series.x._hasCategories() || series.y._hasCategories() ? 0 : 1),
	                interpolation,
	                graded = false,
	                i,
	                j,
	                k,
	                key,
	                keyString,
	                rowIndex,
	                updated,
	                removed,
	                orderedSeriesArray,
	                catPoints = {},
	                allPoints = [],
	                points,
	                finalPointArray = [],
	                basePoints,
	                basePoint,
	                cat,
	                catVal,
	                group,
	                p,
	                b,
	                l,
	                lastAngle,
	                catCoord,
	                valCoord,
	                onEnter = function () {
	                    return function (e, shape, chart, series) {
	                        d3.select(shape).style("opacity", 1);
	                        dimple._showPointTooltip(e, shape, chart, series);
	                    };
	                },
	                onLeave = function (lineData) {
	                    return function (e, shape, chart, series) {
	                        d3.select(shape).style("opacity", (series.lineMarkers || lineData.data.length < 2 ? dimple._helpers.opacity(e, chart, series) : 0));
	                        dimple._removeTooltip(e, shape, chart, series);
	                    };
	                },
	                drawMarkers = function (d, context) {
	                    dimple._drawMarkers(d, chart, series, duration, className, graded, onEnter(d), onLeave(d), context);
	                },
	                coord = function (position, datum) {
	                    var val;
	                    if (series.interpolation === "step" && series[position]._hasCategories()) {
	                        val = dimple._helpers[position](datum, chart, series) + (position === "y" ? dimple._helpers.height(datum, chart, series) : 0);
	                        if (series[position].categoryFields.length < 2) {
	                            val += (position === "y" ? 1 : -1) * dimple._helpers[position + "Gap"](chart, series);
	                        }
	                    } else {
	                        val = dimple._helpers["c" + position](datum, chart, series);
	                    }
	                    // Remove long decimals from the coordinates as this fills the dom up with noise and makes matching below less likely to work.  It
	                    // shouldn't really matter but positioning to < 0.1 pixel is pretty pointless anyway.  UPDATE: Turns out it isn't, see Issue #79.  points > pixels
	                    // causes multiple points to fall on the same co-ordinate which results in drawing problems.
	                    return parseFloat(val);
	                },
	                getArea = function (inter, originProperty) {
	                    return d3.svg.line()
	                        .x(function (d) { return (series.x._hasCategories() || !originProperty ? d.x : series.x[originProperty]); })
	                        .y(function (d) { return (series.y._hasCategories() || !originProperty ? d.y : series.y[originProperty]); })
	                        .interpolate(inter);
	                },
	                sortByVal = function (a, b) {
	                    return parseFloat(a) - parseFloat(b);
	                },
	                sortByX = function (a, b) {
	                    return parseFloat(a.x) - parseFloat(b.x);
	                },
	                addNextPoint = function (source, target, startAngle) {
	                    // Given a point we need to find the next point clockwise from the start angle
	                    var i,
	                        point = target[target.length - 1],
	                        thisAngle,
	                        bestAngleSoFar = 9999,
	                        returnPoint = point;
	                    for (i = 0; i < source.length; i += 1) {
	                        if (source[i].x !== point.x || source[i].y !== point.y) {
	                            // get the angle in degrees since start angle
	                            thisAngle = 180 - (Math.atan2(source[i].x - point.x, source[i].y - point.y) * (180 / Math.PI));
	                            if (thisAngle > startAngle && thisAngle < bestAngleSoFar) {
	                                returnPoint = source[i];
	                                bestAngleSoFar = thisAngle;
	                            }
	                        }
	                    }
	                    target.push(returnPoint);
	                    return bestAngleSoFar;
	                };

	            // Handle the special interpolation handling for step
	            interpolation =  (series.interpolation === "step" ? "step-after" : series.interpolation);

	            // Get the array of ordered values
	            orderedSeriesArray = dimple._getSeriesOrder(series.data || chart.data, series);

	            if (series.c && ((series.x._hasCategories() && series.y._hasMeasure()) || (series.y._hasCategories() && series.x._hasMeasure()))) {
	                graded = true;
	            }

	            // If there is a coordinate with categories get it here so we don't have to keep checking
	            if (series.x._hasCategories()) {
	                catCoord = "x";
	                valCoord = "y";
	            } else if (series.y._hasCategories()) {
	                catCoord = "y";
	                valCoord = "x";
	            }

	            // Create a set of area data grouped by the aggregation field
	            for (i = 0; i < data.length; i += 1) {
	                key = [];
	                rowIndex = -1;
	                // Skip the first category unless there is a category axis on x or y
	                for (k = firstAgg; k < data[i].aggField.length; k += 1) {
	                    key.push(data[i].aggField[k]);
	                }
	                // Find the corresponding row in the areaData
	                keyString = dimple._createClass(key);
	                for (k = 0; k < areaData.length; k += 1) {
	                    if (areaData[k].keyString === keyString) {
	                        rowIndex = k;
	                        break;
	                    }
	                }
	                // Add a row to the area data if none was found
	                if (rowIndex === -1) {
	                    rowIndex = areaData.length;
	                    areaData.push({
	                        key: key,
	                        keyString: keyString,
	                        color: "white",
	                        data: [],
	                        points: [],
	                        area: {},
	                        entry: {},
	                        exit: {},
	                        // Group refers to groupings along the category axis.  If there are groupings it will be recorded, otherwise all is used as a default
	                        group: (catCoord && data[i][catCoord + "Field"] && data[i][catCoord + "Field"].length >= 2 ? data[i][catCoord + "Field"][0] : "All")
	                    });
	                }
	                // Add this row to the relevant data
	                areaData[rowIndex].data.push(data[i]);
	            }

	            // Sort the area data itself based on the order series array - this matters for stacked areas and default color
	            // consistency with colors usually awarded in terms of prominence
	            if (orderedSeriesArray) {
	                areaData.sort(function (a, b) {
	                    return dimple._arrayIndexCompare(orderedSeriesArray, a.key, b.key);
	                });
	            }

	            // Create a set of area data grouped by the aggregation field
	            for (i = 0; i < areaData.length; i += 1) {
	                // Sort the points so that areas are connected in the correct order
	                areaData[i].data.sort(dimple._getSeriesSortPredicate(chart, series, orderedSeriesArray));
	                // Get points here, this is so that as well as drawing the line with them, we can also
	                // use them for the baseline
	                for (j = 0; j < areaData[i].data.length; j += 1) {
	                    areaData[i].points.push({
	                        x: coord("x", areaData[i].data[j]),
	                        y: coord("y", areaData[i].data[j])
	                    });
	                    // if there is a category axis, add the points to a distinct set.  Set these to use the origin value
	                    // this will be updated with the last value in each case as we build the areas
	                    if (catCoord) {
	                        if (!catPoints[areaData[i].group]) {
	                            catPoints[areaData[i].group] = {};
	                        }
	                        catPoints[areaData[i].group][areaData[i].points[areaData[i].points.length - 1][catCoord]] = series[valCoord]._origin;
	                    }
	                }
	                points = areaData[i].points;
	                // If this is a step interpolation we need to add in some extra points to the category axis
	                // This is a little tricky but we need to add a new point duplicating the last category value.  In order
	                // to place the point we need to calculate the gap between the last x and the penultimate x and apply that
	                // gap again.
	                if (series.interpolation === "step" && points.length > 1 && catCoord) {
	                    if (series.x._hasCategories()) {
	                        points.push({
	                            x : 2 * points[points.length - 1].x - points[points.length - 2].x,
	                            y : points[points.length - 1].y
	                        });
	                        catPoints[areaData[i].group][points[points.length - 1][catCoord]] = series[valCoord]._origin;
	                    } else if (series.y._hasCategories()) {
	                        points = [{
	                            x : points[0].x,
	                            y : 2 * points[0].y - points[1].y
	                        }].concat(points);
	                        catPoints[areaData[i].group][points[0][catCoord]] = series[valCoord]._origin;
	                        // The prepend above breaks the reference so it needs to be reapplied here.
	                        areaData[i].points = points;
	                    }
	                }
	            }

	            // catPoints needs to be lookup, but also accessed sequentially so we need to create an array of keys
	            for (cat in catPoints) {
	                if (catPoints.hasOwnProperty(cat)) {
	                    allPoints[cat] = [];
	                    for (catVal in catPoints[cat]) {
	                        if (catPoints[cat].hasOwnProperty(catVal)) {
	                            allPoints[cat].push(parseFloat(catVal));
	                        }
	                    }
	                    // Sort the points as integers
	                    allPoints[cat].sort(sortByVal);
	                }
	            }

	            // Create the areas
	            for (i = 0; i < areaData.length; i += 1) {
	                points = areaData[i].points;
	                group = areaData[i].group;
	                basePoints = [];
	                finalPointArray = [];
	                // If this should have colour gradients, add them
	                if (graded) {
	                    dimple._addGradient(areaData[i].key, "fill-area-gradient-" + areaData[i].keyString, (series.x._hasCategories() ? series.x : series.y), data, chart, duration, "fill");
	                }
	                // All points will only be populated if there is a category axis
	                if (allPoints[group] && allPoints[group].length > 0) {
	                    // Iterate the point array because we need to fill in zero points for missing ones, otherwise the areas
	                    // will cross where an upper area has no value and a lower value has a spike Issue #7
	                    for (j = 0, k = 0; j < allPoints[group].length; j += 1) {
	                        // We are only interested in points between the first and last point of this areas data (i.e. don't fill ends - important
	                        // for grouped area charts).  We have to use a strange criteria here.  If there are no group gaps on a grouped area
	                        // chart the end point of one series will clash with the start point of another, therefore we have to ignore fill-in's within
	                        // a couple of pixels of the start and end points
	                        if (allPoints[group][j] >= points[0][catCoord] && allPoints[group][j] <= points[points.length - 1][catCoord]) {
	                            // Get a base point, this needs to go on the base points array as well as filling in gaps in the point array.
	                            // Create a point using the coordinate on the category axis and the last recorded value
	                            // position from the dictionary
	                            basePoint = {};
	                            basePoint[catCoord] = allPoints[group][j];
	                            basePoint[valCoord] = catPoints[group][allPoints[group][j]];
	                            // add the base point
	                            basePoints.push(basePoint);
	                            // handle missing points
	                            if (points[k][catCoord] > allPoints[group][j]) {
	                                // If there is a missing point we need to in fill
	                                finalPointArray.push(basePoint);
	                            } else {
	                                // They must be the same
	                                finalPointArray.push(points[k]);
	                                // Use this to update the dictionary to the new value coordinate
	                                catPoints[areaData[i].group][allPoints[group][j]] = points[k][valCoord];
	                                k += 1;
	                            }
	                        }
	                    }
	                } else {
	                    // If there is no category axis we need to apply some custom logic.  In order to avoid
	                    // really jagged areas the default behaviour will be to draw from the left most point then rotate a line
	                    // clockwise until it hits another point and continue from each point until back to where we started.  This
	                    // means it will not connect every point, but it will contain every point:
	                    // E.g.
	                    //                     D
	                    //         C
	                    //      A      B     E
	                    //         F      G
	                    //      H
	                    //
	                    // Would draw A -> C -> D -> E -> G -> H -> A
	                    //
	                    // This may not be what everyone wants so if there is a series order specified we will just join
	                    // the points in that order instead.  This will not allow users to skip points and therefore not achieve
	                    // the default behaviour explicitly.
	                    if (series._orderRules && series._orderRules.length > 0) {
	                        finalPointArray = points.concat(points[0]);
	                    } else {
	                        // Find the leftmost point
	                        points = points.sort(sortByX);
	                        finalPointArray.push(points[0]);
	                        lastAngle = 0;
	                        // Iterate until the first and last points match
	                        do {
	                            lastAngle = addNextPoint(points, finalPointArray, lastAngle);
	                        } while (finalPointArray.length <= points.length && (finalPointArray[0].x !== finalPointArray[finalPointArray.length - 1].x || finalPointArray[0].y !== finalPointArray[finalPointArray.length - 1].y));
	                    }
	                }

	                // Reverse the base points so that they are in the correct order for the path
	                basePoints = basePoints.reverse();

	                // Get the points that this area will appear
	                p = getArea(interpolation, "_previousOrigin")(finalPointArray);
	                b = getArea((interpolation === "step-after" ? "step-before" : (interpolation === "step-before" ? "step-after" : interpolation)), "_previousOrigin")(basePoints);
	                l = getArea("linear", "_previousOrigin")(finalPointArray);
	                areaData[i].entry = p + (b && b.length > 0 ? "L" + b.substring(1) : "") + (l && l.length > 0 ? "L" + l.substring(1, l.indexOf("L")) : 0);

	                p = getArea(interpolation)(finalPointArray);
	                b = getArea(interpolation === "step-after" ? "step-before" : (interpolation === "step-before" ? "step-after" : interpolation))(basePoints);
	                l = getArea("linear")(finalPointArray);
	                areaData[i].update = p + (b && b.length > 0 ? "L" + b.substring(1) : "") + (l && l.length > 0 ? "L" + l.substring(1, l.indexOf("L")) : 0);

	                p = getArea(interpolation, "_origin")(finalPointArray);
	                b = getArea((interpolation === "step-after" ? "step-before" : (interpolation === "step-before" ? "step-after" : interpolation)), "_origin")(basePoints);
	                l = getArea("linear", "_origin")(finalPointArray);
	                areaData[i].exit = p + (b && b.length > 0 ? "L" + b.substring(1) : "") + (l && l.length > 0 ? "L" + l.substring(1, l.indexOf("L")) : 0);

	                // Add the color in this loop, it can't be done during initialisation of the row because
	                // the areas should be ordered first (to ensure standard distribution of colors
	                areaData[i].color = chart.getColor(areaData[i].key.length > 0 ? areaData[i].key[areaData[i].key.length - 1] : "All");
	                areaData[i].css = chart.getClass(areaData[i].key.length > 0 ? areaData[i].key[areaData[i].key.length - 1] : "All");
	            }

	            if (chart._tooltipGroup !== null && chart._tooltipGroup !== undefined) {
	                chart._tooltipGroup.remove();
	            }

	            if (series.shapes === null || series.shapes === undefined) {
	                theseShapes = chart._group.selectAll("." + className).data(areaData);
	            } else {
	                theseShapes = series.shapes.data(areaData, function (d) { return d.key; });
	            }

	            // Add
	            theseShapes
	                .enter()
	                .append("path")
	                .attr("id", function (d) { return dimple._createClass([d.key]); })
	                .attr("class", function (d) { return className + " dimple-line " + d.keyString + " " + chart.customClassList.areaSeries + " " + d.css; })
	                .attr("d", function (d) { return d.entry; })
	                .call(function () {
	                    // Apply formats optionally
	                    if (!chart.noFormats) {
	                        this.attr("opacity", function (d) { return (graded ? 1 : d.color.opacity); })
	                            .style("fill", function (d) { return (graded ? "url(#fill-area-gradient-" + d.keyString + ")" : d.color.fill); })
	                            .style("stroke", function (d) { return (graded ? "url(#stroke-area-gradient-" + d.keyString + ")" : d.color.stroke); })
	                            .style("stroke-width", series.lineWeight);
	                    }
	                })
	                .each(function (d) {
	                    // Pass line data to markers
	                    d.markerData = d.data;
	                    drawMarkers(d, this);
	                });

	            // Update
	            updated = chart._handleTransition(theseShapes, duration, chart)
	                .attr("d", function (d) { return d.update; })
	                .each(function (d) {
	                    // Pass line data to markers
	                    d.markerData = d.data;
	                    drawMarkers(d, this);
	                });

	            // Remove
	            removed = chart._handleTransition(theseShapes.exit(), duration, chart)
	                .attr("d", function (d) { return d.exit; })
	                .each(function (d) {
	                    // Using all data for the markers fails because there are no exits in the markers
	                    // only the whole line, therefore we need to clear the points here
	                    d.markerData = [];
	                    drawMarkers(d, this);
	                });

	            dimple._postDrawHandling(series, updated, removed, duration);

	            // Save the shapes to the series array
	            series.shapes = theseShapes;

	        }
	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/plot/bar.js
	    dimple.plot.bar = {

	        // By default the bar series is stacked if there are series categories
	        stacked: true,

	        // This is not a grouped plot meaning that one point is treated as one series value
	        grouped: false,

	        // The axes which will affect the bar chart - not z
	        supportedAxes: ["x", "y", "c"],

	        // Draw the chart
	        draw: function (chart, series, duration) {

	            var chartData = series._positionData,
	                theseShapes = null,
	                classes = ["dimple-series-" + chart.series.indexOf(series), "dimple-bar"],
	                updated,
	                removed,
	                xFloat = !series._isStacked() && series.x._hasMeasure(),
	                yFloat = !series._isStacked() && series.y._hasMeasure(),
	                cat = "none";

	            if (series.x._hasCategories() && series.y._hasCategories()) {
	                cat = "both";
	            } else if (series.x._hasCategories()) {
	                cat = "x";
	            } else if (series.y._hasCategories()) {
	                cat = "y";
	            }

	            if (chart._tooltipGroup !== null && chart._tooltipGroup !== undefined) {
	                chart._tooltipGroup.remove();
	            }

	            if (series.shapes === null || series.shapes === undefined) {
	                theseShapes = chart._group.selectAll("." + classes.join(".")).data(chartData);
	            } else {
	                theseShapes = series.shapes.data(chartData, function (d) { return d.key; });
	            }

	            // Add
	            theseShapes
	                .enter()
	                .append("rect")
	                .attr("id", function (d) { return dimple._createClass([d.key]); })
	                .attr("class", function (d) {
	                    var c = [];
	                    c = c.concat(d.aggField);
	                    c = c.concat(d.xField);
	                    c = c.concat(d.yField);
	                    return classes.join(" ") + " " + dimple._createClass(c) + " " + chart.customClassList.barSeries + " " + dimple._helpers.css(d, chart);
	                })
	                .attr("x", function (d) {
	                    var returnValue = series.x._previousOrigin;
	                    if (cat === "x") {
	                        returnValue = dimple._helpers.x(d, chart, series);
	                    } else if (cat === "both") {
	                        returnValue = dimple._helpers.cx(d, chart, series);
	                    }
	                    return returnValue;
	                })
	                .attr("y", function (d) {
	                    var returnValue = series.y._previousOrigin;
	                    if (cat === "y") {
	                        returnValue = dimple._helpers.y(d, chart, series);
	                    } else if (cat === "both") {
	                        returnValue = dimple._helpers.cy(d, chart, series);
	                    }
	                    return returnValue;
	                })
	                .attr("width", function (d) { return (cat === "x" ?  dimple._helpers.width(d, chart, series) : 0); })
	                .attr("height", function (d) { return (cat === "y" ?  dimple._helpers.height(d, chart, series) : 0); })
	                .on("mouseover", function (e) { dimple._showBarTooltip(e, this, chart, series); })
	                .on("mouseleave", function (e) { dimple._removeTooltip(e, this, chart, series); })
	                .call(function () {
	                    if (!chart.noFormats) {
	                        this.attr("opacity", function (d) { return dimple._helpers.opacity(d, chart, series); })
	                            .style("fill", function (d) { return dimple._helpers.fill(d, chart, series); })
	                            .style("stroke", function (d) { return dimple._helpers.stroke(d, chart, series); });
	                    }
	                });

	            // Update
	            updated = chart._handleTransition(theseShapes, duration, chart, series)
	                .attr("x", function (d) { return xFloat ? dimple._helpers.cx(d, chart, series) - series.x.floatingBarWidth / 2 : dimple._helpers.x(d, chart, series); })
	                .attr("y", function (d) { return yFloat ? dimple._helpers.cy(d, chart, series) - series.y.floatingBarWidth / 2 : dimple._helpers.y(d, chart, series); })
	                .attr("width", function (d) { return (xFloat ? series.x.floatingBarWidth : dimple._helpers.width(d, chart, series)); })
	                .attr("height", function (d) { return (yFloat ? series.y.floatingBarWidth : dimple._helpers.height(d, chart, series)); })
	                .call(function () {
	                    if (!chart.noFormats) {
	                        this.attr("fill", function (d) { return dimple._helpers.fill(d, chart, series); })
	                            .attr("stroke", function (d) { return dimple._helpers.stroke(d, chart, series); });
	                    }
	                });

	            // Remove
	            removed = chart._handleTransition(theseShapes.exit(), duration, chart, series)
	                .attr("x", function (d) {
	                    var returnValue = series.x._origin;
	                    if (cat === "x") {
	                        returnValue = dimple._helpers.x(d, chart, series);
	                    } else if (cat === "both") {
	                        returnValue = dimple._helpers.cx(d, chart, series);
	                    }
	                    return returnValue;
	                })
	                .attr("y", function (d) {
	                    var returnValue = series.y._origin;
	                    if (cat === "y") {
	                        returnValue = dimple._helpers.y(d, chart, series);
	                    } else if (cat === "both") {
	                        returnValue = dimple._helpers.cy(d, chart, series);
	                    }
	                    return returnValue;
	                })
	                .attr("width", function (d) { return (cat === "x" ?  dimple._helpers.width(d, chart, series) : 0); })
	                .attr("height", function (d) { return (cat === "y" ?  dimple._helpers.height(d, chart, series) : 0); });

	            dimple._postDrawHandling(series, updated, removed, duration);

	            // Save the shapes to the series array
	            series.shapes = theseShapes;
	        }
	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/plot/bubble.js
	    dimple.plot.bubble = {

	        // By default the bubble values are not stacked
	        stacked: false,

	        // This is not a grouped plot meaning that one point is treated as one series value
	        grouped: false,

	        // The axis positions affecting the bubble series
	        supportedAxes: ["x", "y", "z", "c"],

	        // Draw the axis
	        draw: function (chart, series, duration) {

	            var chartData = series._positionData,
	                theseShapes = null,
	                classes = ["dimple-series-" + chart.series.indexOf(series), "dimple-bubble"],
	                updated,
	                removed;

	            if (chart._tooltipGroup !== null && chart._tooltipGroup !== undefined) {
	                chart._tooltipGroup.remove();
	            }

	            if (series.shapes === null || series.shapes === undefined) {
	                theseShapes = chart._group.selectAll("." + classes.join(".")).data(chartData);
	            } else {
	                theseShapes = series.shapes.data(chartData, function (d) {
	                    return d.key;
	                });
	            }

	            // Add
	            theseShapes
	                .enter()
	                .append("circle")
	                .attr("id", function (d) { return dimple._createClass([d.key]); })
	                .attr("class", function (d) {
	                    var c = [];
	                    c = c.concat(d.aggField);
	                    c = c.concat(d.xField);
	                    c = c.concat(d.yField);
	                    c = c.concat(d.zField);
	                    return classes.join(" ") + " " + dimple._createClass(c) + " " + chart.customClassList.bubbleSeries + " " + dimple._helpers.css(d, chart);
	                })
	                .attr("cx", function (d) { return (series.x._hasCategories() ? dimple._helpers.cx(d, chart, series) : series.x._previousOrigin); })
	                .attr("cy", function (d) { return (series.y._hasCategories() ? dimple._helpers.cy(d, chart, series) : series.y._previousOrigin); })
	                .attr("r", 0)
	                .on("mouseover", function (e) { dimple._showPointTooltip(e, this, chart, series); })
	                .on("mouseleave", function (e) { dimple._removeTooltip(e, this, chart, series); })
	                .call(function () {
	                    if (!chart.noFormats) {
	                        this.attr("opacity", function (d) { return dimple._helpers.opacity(d, chart, series); })
	                            .style("fill", function (d) { return dimple._helpers.fill(d, chart, series); })
	                            .style("stroke", function (d) { return dimple._helpers.stroke(d, chart, series); });
	                    }
	                });

	            // Update
	            updated = chart._handleTransition(theseShapes, duration, chart, series)
	                .attr("cx", function (d) { return dimple._helpers.cx(d, chart, series); })
	                .attr("cy", function (d) { return dimple._helpers.cy(d, chart, series); })
	                .attr("r", function (d) { return dimple._helpers.r(d, chart, series); })
	                .call(function () {
	                    if (!chart.noFormats) {
	                        this.attr("fill", function (d) { return dimple._helpers.fill(d, chart, series); })
	                            .attr("stroke", function (d) { return dimple._helpers.stroke(d, chart, series); });
	                    }
	                });

	            // Remove
	            removed = chart._handleTransition(theseShapes.exit(), duration, chart, series)
	                .attr("r", 0)
	                .attr("cx", function (d) { return (series.x._hasCategories() ? dimple._helpers.cx(d, chart, series) : series.x._origin); })
	                .attr("cy", function (d) { return (series.y._hasCategories() ? dimple._helpers.cy(d, chart, series) : series.y._origin); });

	            dimple._postDrawHandling(series, updated, removed, duration);

	            // Save the shapes to the series array
	            series.shapes = theseShapes;
	        }
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/plot/line.js
	    dimple.plot.line = {

	        // By default the values are not stacked
	        stacked: false,

	        // This is a grouped plot meaning many points are treated as one series value
	        grouped: true,

	        // The axis positions affecting the line series
	        supportedAxes: ["x", "y", "c"],

	        // Draw the axis
	        draw: function (chart, series, duration) {
	            // Get the position data
	            var data = series._positionData,
	                lineData = [],
	                theseShapes = null,
	                className = "dimple-series-" + chart.series.indexOf(series),
	                firstAgg = (series.x._hasCategories() || series.y._hasCategories() ? 0 : 1),
	                interpolation,
	                graded = false,
	                i,
	                j,
	                k,
	                key,
	                keyString,
	                rowIndex,
	                updated,
	                removed,
	                orderedSeriesArray,
	                onEnter = function () {
	                    return function (e, shape, chart, series) {
	                        d3.select(shape).style("opacity", 1);
	                        dimple._showPointTooltip(e, shape, chart, series);
	                    };
	                },
	                onLeave = function (lineData) {
	                    return function (e, shape, chart, series) {
	                        d3.select(shape).style("opacity", (series.lineMarkers || lineData.data.length < 2 ? dimple._helpers.opacity(e, chart, series) : 0));
	                        dimple._removeTooltip(e, shape, chart, series);
	                    };
	                },
	                drawMarkers = function (d, context) {
	                    dimple._drawMarkers(d, chart, series, duration, className, graded, onEnter(d), onLeave(d), context);
	                },
	                coord = function (position, datum) {
	                    var val;
	                    if (series.interpolation === "step" && series[position]._hasCategories()) {
	                        series.barGap = 0;
	                        series.clusterBarGap = 0;
	                        val = dimple._helpers[position](datum, chart, series) + (position === "y" ? dimple._helpers.height(datum, chart, series) : 0);
	                    } else {
	                        val = dimple._helpers["c" + position](datum, chart, series);
	                    }
	                    // Remove long decimals from the coordinates as this fills the dom up with noise and makes matching below less likely to work.  It
	                    // shouldn't really matter but positioning to < 0.1 pixel is pretty pointless anyway.
	                    return parseFloat(val.toFixed(1));
	                },
	                getLine = function (inter, originProperty) {
	                    return d3.svg.line()
	                        .x(function (d) { return (series.x._hasCategories() || !originProperty ? d.x : series.x[originProperty]); })
	                        .y(function (d) { return (series.y._hasCategories() || !originProperty ? d.y : series.y[originProperty]); })
	                        .interpolate(inter);
	                };

	            // Handle the special interpolation handling for step
	            interpolation =  (series.interpolation === "step" ? "step-after" : series.interpolation);

	            // Get the array of ordered values
	            orderedSeriesArray = dimple._getSeriesOrder(series.data || chart.data, series);

	            if (series.c && ((series.x._hasCategories() && series.y._hasMeasure()) || (series.y._hasCategories() && series.x._hasMeasure()))) {
	                graded = true;
	            }

	            // Create a set of line data grouped by the aggregation field
	            for (i = 0; i < data.length; i += 1) {
	                key = [];
	                rowIndex = -1;
	                // Skip the first category unless there is a category axis on x or y
	                for (k = firstAgg; k < data[i].aggField.length; k += 1) {
	                    key.push(data[i].aggField[k]);
	                }
	                // Find the corresponding row in the lineData
	                keyString = dimple._createClass(key);
	                for (k = 0; k < lineData.length; k += 1) {
	                    if (lineData[k].keyString === keyString) {
	                        rowIndex = k;
	                        break;
	                    }
	                }
	                // Add a row to the line data if none was found
	                if (rowIndex === -1) {
	                    rowIndex = lineData.length;
	                    lineData.push({
	                        key: key,
	                        keyString: keyString,
	                        color: "white",
	                        data: [],
	                        markerData: [],
	                        points: [],
	                        line: {},
	                        entry: {},
	                        exit: {}
	                    });
	                }
	                // Add this row to the relevant data
	                lineData[rowIndex].data.push(data[i]);
	            }

	            // Sort the line data itself based on the order series array - this matters for stacked lines and default color
	            // consistency with colors usually awarded in terms of prominence
	            if (orderedSeriesArray) {
	                lineData.sort(function (a, b) {
	                    return dimple._arrayIndexCompare(orderedSeriesArray, a.key, b.key);
	                });
	            }

	            // Create a set of line data grouped by the aggregation field
	            for (i = 0; i < lineData.length; i += 1) {
	                // Sort the points so that lines are connected in the correct order
	                lineData[i].data.sort(dimple._getSeriesSortPredicate(chart, series, orderedSeriesArray));
	                // If this should have colour gradients, add them
	                if (graded) {
	                    dimple._addGradient(lineData[i].key, "fill-line-gradient-" + lineData[i].keyString, (series.x._hasCategories() ? series.x : series.y), data, chart, duration, "fill");
	                }

	                // Get points here, this is so that as well as drawing the line with them, we can also
	                // use them for the baseline
	                for (j = 0; j < lineData[i].data.length; j += 1) {
	                    lineData[i].points.push({
	                        x: coord("x", lineData[i].data[j]),
	                        y: coord("y", lineData[i].data[j])
	                    });
	                }
	                // If this is a step interpolation we need to add in some extra points to the category axis
	                // This is a little tricky but we need to add a new point duplicating the last category value.  In order
	                // to place the point we need to calculate the gap between the last x and the penultimate x and apply that
	                // gap again.
	                if (series.interpolation === "step" && lineData[i].points.length > 1) {
	                    if (series.x._hasCategories()) {
	                        lineData[i].points.push({
	                            x : 2 * lineData[i].points[lineData[i].points.length - 1].x - lineData[i].points[lineData[i].points.length - 2].x,
	                            y : lineData[i].points[lineData[i].points.length - 1].y
	                        });
	                    } else if (series.y._hasCategories()) {
	                        lineData[i].points = [{
	                            x : lineData[i].points[0].x,
	                            y : 2 * lineData[i].points[0].y - lineData[i].points[1].y
	                        }].concat(lineData[i].points);
	                    }
	                }

	                // Get the points that this line will appear
	                lineData[i].entry = getLine(interpolation, "_previousOrigin")(lineData[i].points);
	                lineData[i].update = getLine(interpolation)(lineData[i].points);
	                lineData[i].exit = getLine(interpolation, "_origin")(lineData[i].points);

	                // Add the color in this loop, it can't be done during initialisation of the row because
	                // the lines should be ordered first (to ensure standard distribution of colors
	                lineData[i].color = chart.getColor(lineData[i].key.length > 0 ? lineData[i].key[lineData[i].key.length - 1] : "All");
	                lineData[i].css = chart.getClass(lineData[i].key.length > 0 ? lineData[i].key[lineData[i].key.length - 1] : "All");
	            }

	            if (chart._tooltipGroup !== null && chart._tooltipGroup !== undefined) {
	                chart._tooltipGroup.remove();
	            }

	            if (series.shapes === null || series.shapes === undefined) {
	                theseShapes = chart._group.selectAll("." + className).data(lineData);
	            } else {
	                theseShapes = series.shapes.data(lineData, function (d) { return d.key; });
	            }

	            // Add
	            theseShapes
	                .enter()
	                .append("path")
	                .attr("id", function (d) { return dimple._createClass([d.key]); })
	                .attr("class", function (d) {
	                    return className + " dimple-line " + d.keyString + " " + chart.customClassList.lineSeries + " " + d.css;
	                })
	                .attr("d", function (d) {
	                    return d.entry;
	                })
	                .call(function () {
	                    // Apply formats optionally
	                    if (!chart.noFormats) {
	                        this.attr("opacity", function (d) { return (graded ? 1 : d.color.opacity); })
	                            .style("fill", "none")
	                            .style("stroke", function (d) { return (graded ? "url(#fill-line-gradient-" + d.keyString + ")" : d.color.stroke); })
	                            .style("stroke-width", series.lineWeight);
	                    }
	                })
	                .each(function (d) {
	                    // Pass line data to markers
	                    d.markerData = d.data;
	                    drawMarkers(d, this);
	                });

	            // Update
	            updated = chart._handleTransition(theseShapes, duration, chart)
	                .attr("d", function (d) { return d.update; })
	                .each(function (d) {
	                    // Pass line data to markers
	                    d.markerData = d.data;
	                    drawMarkers(d, this);
	                });

	            // Remove
	            removed = chart._handleTransition(theseShapes.exit(), duration, chart)
	                .attr("d", function (d) { return d.exit; })
	                .each(function (d) {
	                    // Using all data for the markers fails because there are no exits in the markers
	                    // only the whole line, therefore we need to clear the points here
	                    d.markerData = [];
	                    drawMarkers(d, this);
	                });

	            dimple._postDrawHandling(series, updated, removed, duration);

	            // Save the shapes to the series array
	            series.shapes = theseShapes;

	        }
	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/plot/pie.js
	    dimple.plot.pie = {
	        // By default the bar series is stacked if there are series categories
	        stacked: false,
	        // This is not a grouped plot meaning that one point is treated as one series value
	        grouped: false,
	        // The axes which will affect the bar chart - not z
	        supportedAxes: ["x", "y", "c", "z", "p"],

	        // Draw the chart
	        draw: function (chart, series, duration) {

	            var chartData = series._positionData,
	                theseShapes = null,
	                classes = ["dimple-series-" + chart.series.indexOf(series), "dimple-pie"],
	                updated,
	                removed,
	                getOuterBase = function (d) {
	                    var oR;
	                    if (series.x && series.y) {
	                        oR = dimple._helpers.r(d, chart, series);
	                    } else {
	                        oR = chart._widthPixels() < chart._heightPixels() ? chart._widthPixels() / 2 : chart._heightPixels() / 2;
	                    }
	                    return oR;
	                },
	                getOuterRadius = function (d) {
	                    var oR = getOuterBase(d);
	                    if (series.outerRadius) {
	                        oR = dimple._parsePosition(series.outerRadius, oR);
	                    }
	                    return Math.max(oR, 0);
	                },
	                getInnerRadius = function (d) {
	                    var iR = 0;
	                    if (series.innerRadius) {
	                        iR = dimple._parsePosition(series.innerRadius, getOuterBase(d));
	                    }
	                    return Math.max(iR, 0);
	                },
	                getArc = function (d) {
	                    // Calculate the radii of the circles
	                    var arc;
	                    // The actual arc
	                    arc = d3.svg.arc()
	                        .innerRadius(getInnerRadius(d))
	                        .outerRadius(getOuterRadius(d));
	                    // Return the value
	                    return arc(d);
	                },
	                arcTween = function (a) {
	                    a.innerRadius = getInnerRadius(a);
	                    a.outerRadius = getOuterRadius(a);
	                    var i = d3.interpolate(this._current, a),
	                        arc;
	                    // The actual arc
	                    arc = d3.svg.arc()
	                        .innerRadius(function (d) { return d.innerRadius; })
	                        .outerRadius(function (d) { return d.outerRadius; });
	                    this._current = i(0);
	                    return function(t) {
	                        return arc(i(t));
	                    };
	                },
	                getTransform = function (origin) {
	                    return function (d) {
	                        var xString,
	                            yString;
	                        if (series.x && series.y) {
	                            if (!origin || series.x._hasCategories()) {
	                                xString = dimple._helpers.cx(d, chart, series);
	                            } else {
	                                xString = series.x._previousOrigin;
	                            }
	                            if (!origin || series.y._hasCategories()) {
	                                yString = dimple._helpers.cy(d, chart, series);
	                            } else {
	                                yString = series.y._previousOrigin;
	                            }
	                        } else {
	                            xString = (chart._xPixels() + chart._widthPixels() / 2);
	                            yString = (chart._yPixels() + chart._heightPixels() / 2);
	                        }
	                        return "translate(" + xString + "," + yString + ")";
	                    };
	                };

	            // Clear tool tips
	            if (chart._tooltipGroup !== null && chart._tooltipGroup !== undefined) {
	                chart._tooltipGroup.remove();
	            }

	            if (series.shapes === null || series.shapes === undefined) {
	                theseShapes =  chart._group.selectAll("." + classes.join(".")).data(chartData);
	            } else {
	                theseShapes = series.shapes.data(chartData, function (d) { return d.key; });
	            }

	            // Add
	            theseShapes
	                .enter()
	                .append("path")
	                .attr("id", function (d) { return dimple._createClass([d.key]); })
	                .attr("class", function (d) {
	                    var c = [];
	                    c = c.concat(d.aggField);
	                    c = c.concat(d.pField);
	                    return classes.join(" ") + " " + dimple._createClass(c) + " " + chart.customClassList.pieSeries + " " + dimple._helpers.css(d, chart);
	                })
	                .attr("d", getArc)
	                .on("mouseover", function (e) { dimple._showBarTooltip(e, this, chart, series); })
	                .on("mouseleave", function (e) { dimple._removeTooltip(e, this, chart, series); })
	                .call(function () {
	                    if (!chart.noFormats) {
	                        this.attr("opacity", function (d) { return dimple._helpers.opacity(d, chart, series); })
	                            .style("fill", function (d) { return dimple._helpers.fill(d, chart, series); })
	                            .style("stroke", function (d) { return dimple._helpers.stroke(d, chart, series); });
	                    }
	                })
	                .attr("transform", getTransform(true))
	                .each(function (d) {
	                    this._current = d;
	                    d.innerRadius = getInnerRadius(d);
	                    d.outerRadius = getOuterRadius(d);
	                });

	            // Update
	            updated = chart._handleTransition(theseShapes, duration, chart, series)
	                .call(function () {
	                    if (duration && duration > 0) {
	                        this.attrTween("d", arcTween);
	                    } else {
	                        this.attr("d", getArc);
	                    }
	                    if (!chart.noFormats) {
	                        this.attr("fill", function (d) { return dimple._helpers.fill(d, chart, series); })
	                            .attr("stroke", function (d) { return dimple._helpers.stroke(d, chart, series); });
	                    }
	                })
	                .attr("transform", getTransform(false));

	            // Remove
	            removed = chart._handleTransition(theseShapes.exit(), duration, chart, series)
	                .attr("transform", getTransform(true))
	                .attr("d", getArc);

	            dimple._postDrawHandling(series, updated, removed, duration);

	            // Save the shapes to the series array
	            series.shapes = theseShapes;
	        }
	    };
	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_addGradient.js
	    dimple._addGradient = function (seriesValue, id, categoryAxis, data, chart, duration, colorProperty) {

	        var sArray = [].concat(seriesValue),
	            grad = chart._group.select("#" + id),
	            cats = [],
	            field = categoryAxis.position + "Field",
	            transition = true,
	            colors = [];

	        data.forEach(function (d) {
	            if (cats.indexOf(d[field]) === -1 && d.aggField.join("_") === sArray.join("_")) {
	                cats.push(d[field]);
	            }
	        }, this);

	        cats = cats.sort(function (a, b) { return categoryAxis._scale(a) - categoryAxis._scale(b); });

	        if (grad.node() === null) {
	            transition = false;
	            grad = chart._group.append("linearGradient")
	                .attr("id", dimple._createClass([id]))
	                .attr("gradientUnits", "userSpaceOnUse")
	                .attr("x1", (categoryAxis.position === "x" ? categoryAxis._scale(cats[0]) + ((chart._widthPixels() / cats.length) / 2) : 0))
	                .attr("y1", (categoryAxis.position === "y" ? categoryAxis._scale(cats[0]) - ((chart._heightPixels() / cats.length) / 2) : 0))
	                .attr("x2", (categoryAxis.position === "x" ? categoryAxis._scale(cats[cats.length - 1]) + ((chart._widthPixels() / cats.length) / 2) : 0))
	                .attr("y2", (categoryAxis.position === "y" ? categoryAxis._scale(cats[cats.length - 1]) - ((chart._heightPixels() / cats.length) / 2) : 0));
	        }

	        cats.forEach(function (cat, j) {

	            var row = {},
	                k = 0;

	            for (k = 0; k < data.length; k = k + 1) {
	                if (data[k].aggField.join("_") === sArray.join("_") && data[k][field].join("_") === cat.join("_")) {
	                    row = data[k];
	                    break;
	                }
	            }

	            colors.push({ offset: Math.round((j / (cats.length - 1)) * 100) + "%", color: row[colorProperty] });
	        }, this);

	        if (transition) {
	            chart._handleTransition(grad.selectAll("stop").data(colors), duration, chart)
	                .attr("offset", function(d) { return d.offset; })
	                .attr("stop-color", function(d) { return d.color; });
	        } else {
	            grad.selectAll("stop")
	                .data(colors)
	                .enter()
	                .append("stop")
	                .attr("offset", function(d) { return d.offset; })
	                .attr("stop-color", function(d) { return d.color; });
	        }
	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_arrayIndexCompare.js
	    dimple._arrayIndexCompare = function (array, a, b) {
	        // Find the element which comes first in the array
	        var returnValue,
	            p,
	            q,
	            aMatch,
	            bMatch,
	            rowArray;
	        for (p = 0; p < array.length; p += 1) {
	            aMatch = true;
	            bMatch = true;
	            rowArray = [].concat(array[p]);
	            for (q = 0; q < a.length; q += 1) {
	                aMatch = aMatch && (a[q] === rowArray[q]);
	            }
	            for (q = 0; q < b.length; q += 1) {
	                bMatch = bMatch && (b[q] === rowArray[q]);
	            }
	            if (aMatch && bMatch) {
	                returnValue = 0;
	                break;
	            } else if (aMatch) {
	                returnValue = -1;
	                break;
	            } else if (bMatch) {
	                returnValue = 1;
	                break;
	            }
	        }
	        return returnValue;
	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_createClass.js
	    dimple._createClass = function (stringArray) {
	        var i,
	            returnArray = [],
	            replacer;
	        replacer = function(s) {
	            var c = s.charCodeAt(0),
	                returnString = "-";
	            if (c >= 65 && c <= 90) {
	                returnString = s.toLowerCase();
	            }
	            return returnString;
	        };
	        if (stringArray.length > 0) {
	            for (i = 0; i < stringArray.length; i += 1) {
	                if (stringArray[i]) {
	                    /*jslint regexp: true */
	                    returnArray.push("dimple-" + stringArray[i].toString().replace(/[^a-z0-9]/g, replacer));
	                    /*jslint regexp: false */
	                }
	            }
	        } else {
	            returnArray = ["dimple-all"];
	        }
	        return returnArray.join(" ");
	    };
	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_drawMarkerBacks.js
	    dimple._drawMarkerBacks = function (lineDataRow, chart, series, duration, className, lineShape) {
	        var markerBacks,
	            markerBackClasses = ["dimple-marker-back", className, lineDataRow.keyString],
	            rem,
	            shapes;
	        if (series.lineMarkers) {
	            if (series._markerBacks === null || series._markerBacks === undefined || series._markerBacks[lineDataRow.keyString] === undefined) {
	                markerBacks = chart._group.selectAll("." + markerBackClasses.join(".")).data(lineDataRow.markerData);
	            } else {
	                markerBacks = series._markerBacks[lineDataRow.keyString].data(lineDataRow.markerData, function (d) { return d.key; });
	            }

	            // Add
	            if (lineShape.nextSibling && lineShape.nextSibling.id) {
	                shapes = markerBacks.enter().insert("circle", '#' + lineShape.nextSibling.id);
	            } else {
	                shapes = markerBacks.enter().append("circle");
	            }
	            shapes
	                .attr("id", function (d) { return dimple._createClass([d.key + " Marker Back"]); })
	                .attr("class", function (d) {
	                    var fields = [];
	                    if (series.x._hasCategories()) {
	                        fields = fields.concat(d.xField);
	                    }
	                    if (series.y._hasCategories()) {
	                        fields = fields.concat(d.yField);
	                    }
	                    return dimple._createClass(fields) + " " + markerBackClasses.join(" ");
	                })
	                .attr("cx", function (d) { return (series.x._hasCategories() ? dimple._helpers.cx(d, chart, series) : series.x._previousOrigin); })
	                .attr("cy", function (d) { return (series.y._hasCategories() ? dimple._helpers.cy(d, chart, series) : series.y._previousOrigin); })
	                .attr("r", 0)
	                .attr("fill", "white")
	                .attr("stroke", "none");

	            // Update
	            chart._handleTransition(markerBacks, duration, chart)
	                .attr("cx", function (d) { return dimple._helpers.cx(d, chart, series); })
	                .attr("cy", function (d) { return dimple._helpers.cy(d, chart, series); })
	                .attr("r", 2 + series.lineWeight);

	            // Remove
	            rem = chart._handleTransition(markerBacks.exit(), duration, chart)
	                .attr("cx", function (d) { return (series.x._hasCategories() ? dimple._helpers.cx(d, chart, series) : series.x._origin); })
	                .attr("cy", function (d) { return (series.y._hasCategories() ? dimple._helpers.cy(d, chart, series) : series.y._origin); })
	                .attr("r", 0);

	            // Run after transition methods
	            if (duration === 0) {
	                rem.remove();
	            } else {
	                rem.each("end", function () {
	                    d3.select(this).remove();
	                });
	            }

	            if (series._markerBacks === undefined || series._markerBacks === null) {
	                series._markerBacks = {};
	            }
	            series._markerBacks[lineDataRow.keyString] = markerBacks;
	        }
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_drawMarkers.js
	    dimple._drawMarkers = function (lineDataRow, chart, series, duration, className, useGradient, enterEventHandler, leaveEventHandler, lineShape) {
	        var markers,
	            markerClasses = ["dimple-marker", className, lineDataRow.keyString],
	            rem,
	            shapes;

	        // Deal with markers in the same way as main series to fix #28
	        if (series._markers === null || series._markers === undefined || series._markers[lineDataRow.keyString] === undefined) {
	            markers = chart._group.selectAll("." + markerClasses.join(".")).data(lineDataRow.markerData);
	        } else {
	            markers = series._markers[lineDataRow.keyString].data(lineDataRow.markerData, function (d) {
	                return d.key;
	            });
	        }
	        // Add
	        if (lineShape.nextSibling && lineShape.nextSibling.id) {
	            shapes = markers.enter().insert("circle", '#' + lineShape.nextSibling.id);
	        } else {
	            shapes = markers.enter().append("circle");
	        }
	        shapes
	            .attr("id", function (d) {
	                return dimple._createClass([d.key + " Marker"]);
	            })
	            .attr("class", function (d) {
	                var fields = [],
	                    css = chart.getClass(d.aggField.length > 0 ? d.aggField[d.aggField.length - 1] : "All");
	                if (series.x._hasCategories()) {
	                    fields = fields.concat(d.xField);
	                }
	                if (series.y._hasCategories()) {
	                    fields = fields.concat(d.yField);
	                }
	                return dimple._createClass(fields) + " " + markerClasses.join(" ") + " " + chart.customClassList.lineMarker + " " + css;
	            })
	            .on("mouseover", function (e) {
	                enterEventHandler(e, this, chart, series);
	            })
	            .on("mouseleave", function (e) {
	                leaveEventHandler(e, this, chart, series);
	            })
	            .attr("cx", function (d) {
	                return (series.x._hasCategories() ? dimple._helpers.cx(d, chart, series) : series.x._previousOrigin);
	            })
	            .attr("cy", function (d) {
	                return (series.y._hasCategories() ? dimple._helpers.cy(d, chart, series) : series.y._previousOrigin);
	            })
	            .attr("r", 0)
	            .attr("opacity", (series.lineMarkers || lineDataRow.data.length < 2 ? lineDataRow.color.opacity : 0))
	            .call(function () {
	                if (!chart.noFormats) {
	                    this.attr("fill", "white")
	                        .style("stroke-width", series.lineWeight)
	                        .attr("stroke", function (d) {
	                            return (useGradient ? dimple._helpers.fill(d, chart, series) : lineDataRow.color.stroke);
	                        });
	                }
	            });

	        // Update
	        chart._handleTransition(markers, duration, chart)
	            .attr("cx", function (d) { return dimple._helpers.cx(d, chart, series); })
	            .attr("cy", function (d) { return dimple._helpers.cy(d, chart, series); })
	            .attr("r", 2 + series.lineWeight)
	            .attr("opacity", (series.lineMarkers || lineDataRow.data.length < 2 ? lineDataRow.color.opacity : 0))
	            .call(function () {
	                if (!chart.noFormats) {
	                    this.attr("fill", "white")
	                        .style("stroke-width", series.lineWeight)
	                        .attr("stroke", function (d) {
	                            return (useGradient ? dimple._helpers.fill(d, chart, series) : lineDataRow.color.stroke);
	                        });
	                }
	            });

	        // Remove
	        rem = chart._handleTransition(markers.exit(), duration, chart)
	            .attr("cx", function (d) { return (series.x._hasCategories() ? dimple._helpers.cx(d, chart, series) : series.x._origin); })
	            .attr("cy", function (d) { return (series.y._hasCategories() ? dimple._helpers.cy(d, chart, series) : series.y._origin); })
	            .attr("r", 0);

	        // Run after transition methods
	        if (duration === 0) {
	            rem.remove();
	        } else {
	            rem.each("end", function () {
	                d3.select(this).remove();
	            });
	        }

	        if (series._markers === undefined || series._markers === null) {
	            series._markers = {};
	        }
	        series._markers[lineDataRow.keyString] = markers;

	        // Insert the backings before the markers
	        dimple._drawMarkerBacks(lineDataRow, chart, series, duration, className, lineShape);

	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/objects/chart/methods/_getOrderedList.js
	    dimple._getOrderedList = function (data, mainField, levelDefinitions) {
	        var rollupData,
	            sortStack = [],
	            finalArray = [],
	            mainArray = [].concat(mainField),
	            fields = [].concat(mainField),
	            defs = [];

	        // Force the level definitions into an array
	        if (levelDefinitions !== null && levelDefinitions !== undefined) {
	            defs = defs.concat(levelDefinitions);
	        }
	        // Add the base case
	        defs = defs.concat({ ordering: mainArray, desc: false });
	        // Exclude fields if this does not contain a function
	        defs.forEach(function (def) {
	            var field,
	                values = [],
	                tempFields = [];
	            if (typeof def.ordering === "function") {
	                if (data && data.length > 0) {
	                    for (field in data[0]) {
	                        if (data[0].hasOwnProperty(field) && fields.indexOf(field) === -1) {
	                            fields.push(field);
	                        }
	                    }
	                }
	            } else if (!(def.ordering instanceof Array)) {
	                fields.push(def.ordering);
	            } else {
	                // We now receive fields as an array or values as an array which is a bit of an oversight in the API
	                // We will therefore check the values of the array against the fields in the data
	                // Added fix for #101
	                for (field = 0; field < def.ordering.length; field += 1) {
	                    if (data && data.length > 0 && data[0].hasOwnProperty(def.ordering[field])) {
	                        tempFields.push(def.ordering[field]);
	                    }
	                    values.push(def.ordering[field]);
	                }
	                // If more than half of the values are fields we will assume that these are fields and not dimension values
	                if (tempFields.length > values.length / 2) {
	                    fields.concat(tempFields);
	                } else {
	                    def.values = values;
	                }
	            }
	        }, this);
	        rollupData = dimple._rollUp(data, mainArray, fields);
	        // If we go below the leaf stop recursing
	        if (defs.length >= 1) {
	            // Build a stack of compare methods
	            // Iterate each level definition
	            defs.forEach(function (def) {
	                // Draw ascending by default
	                var desc = (def.desc === null || def.desc === undefined ? false : def.desc),
	                    ordering = def.ordering,
	                    orderArray = [],
	                    sum = function (array) {
	                        var total = 0,
	                            i;
	                        for (i = 0; i < array.length; i += 1) {
	                            if (isNaN(array[i])) {
	                                total = undefined;
	                                break;
	                            } else {
	                                total += parseFloat(array[i]);
	                            }
	                        }
	                        return total;
	                    },
	                    compare = function (a, b) {
	                        var result = 0,
	                            sumA = sum(a),
	                            sumB = sum(b);
	                        if (!isNaN(sumA) && !isNaN(sumB)) {
	                            result = parseFloat(sumA) - parseFloat(sumB);
	                        } else if (!isNaN(Date.parse(a[0])) && !isNaN(Date.parse(b[0]))) {
	                            result = Date.parse(a[0]) - Date.parse(b[0]);
	                        } else if (a[0] < b[0]) {
	                            result = -1;
	                        } else if (a[0] > b[0]) {
	                            result = 1;
	                        }
	                        return result;
	                    };
	                // Handle the ordering based on the type set
	                if (typeof ordering === "function") {
	                    // Apply the sort predicate directly
	                    sortStack.push(function (a, b) {
	                        return (desc ? -1 : 1) * ordering(a, b);
	                    });
	                } else if (def.values && def.values.length > 0) {
	                    // The order list may be an array of arrays
	                    // combine the values with pipe delimiters.
	                    // The delimiter is irrelevant as long as it is consistent
	                    // with the sort predicate below
	                    def.values.forEach(function (d) {
	                        orderArray.push(([].concat(d)).join("|"));
	                    }, this);
	                    // Sort according to the axis position
	                    sortStack.push(function (a, b) {
	                        var aStr = "",
	                            bStr = "",
	                            aIx,
	                            bIx,
	                            i;
	                        for (i = 0; i < mainArray.length; i += 1) {
	                            if (i > 0) {
	                                aStr += "|";
	                                bStr += "|";
	                            }
	                            aStr += a[mainArray[i]];
	                            bStr += b[mainArray[i]];
	                        }
	                        // If the value is not found it should go to the end (if descending it
	                        // should go to the start so that it ends up at the back when reversed)
	                        aIx = orderArray.indexOf(aStr);
	                        bIx = orderArray.indexOf(bStr);
	                        aIx = (aIx < 0 ? (desc ? -1 : orderArray.length) : aIx);
	                        bIx = (bIx < 0 ? (desc ? -1 : orderArray.length) : bIx);
	                        return (desc ? -1 : 1) * (aIx - bIx);
	                    });
	                } else {
	                    ([].concat(def.ordering)).forEach(function (field) {
	                        // Sort the data
	                        sortStack.push(function (a, b) {
	                            // The result value
	                            var result = 0;
	                            // Find the field
	                            if (a[field] !== undefined && b[field] !== undefined) {
	                                // Compare just the first mapped value
	                                result = compare([].concat(a[field]), [].concat(b[field]));
	                            }
	                            return (desc ? -1 : 1) * result;
	                        });
	                    });
	                }
	            });
	            rollupData.sort(function (a, b) {
	                var compareIx = 0,
	                    result = 0;
	                while (compareIx < sortStack.length && result === 0) {
	                    result = sortStack[compareIx](a, b);
	                    compareIx += 1;
	                }
	                return result;
	            });
	            // Return a simple array if only one field is being returned.
	            // for multiple fields remove extra fields but leave objects
	            rollupData.forEach(function (d) {
	                var i,
	                    newRow = [];
	                if (mainArray.length === 1) {
	                    finalArray.push(d[mainArray[0]]);
	                } else {
	                    for (i = 0; i < mainArray.length; i += 1) {
	                        newRow.push(d[mainArray[i]]);
	                    }
	                    finalArray.push(newRow);
	                }
	            }, this);
	        }
	        // Return the ordered list
	        return finalArray;
	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_getSeriesOrder.js
	    dimple._getSeriesOrder = function (data, series) {
	        var rules = [].concat(series._orderRules),
	            cats = series.categoryFields,
	            returnValue = [];
	        if (cats !== null && cats !== undefined && cats.length > 0) {
	            if (series.c !== null && series.c !== undefined && series.c._hasMeasure()) {
	                rules.push({ ordering : series.c.measure, desc : true });
	            }
	            if (series.x._hasMeasure()) {
	                rules.push({ ordering : series.x.measure, desc : true });
	            }
	            if (series.y._hasMeasure()) {
	                rules.push({ ordering : series.y.measure, desc : true });
	            }
	            returnValue = dimple._getOrderedList(data, cats, rules);
	        }
	        return returnValue;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_getSeriesSortPredicate.js
	    dimple._getSeriesSortPredicate = function (chart, series, orderedArray) {
	        return function (a, b) {
	            var sortValue = 0;
	            // Modified to keep trying until a difference is found.  Previously these were else if statements
	            // Issue #71
	            if (series.x._hasCategories()) {
	                sortValue = (dimple._helpers.cx(a, chart, series) - dimple._helpers.cx(b, chart, series));
	            }
	            if (sortValue === 0 && series.y._hasCategories()) {
	                sortValue = (dimple._helpers.cy(a, chart, series) - dimple._helpers.cy(b, chart, series));
	            }
	            if (sortValue === 0 && orderedArray) {
	                sortValue = dimple._arrayIndexCompare(orderedArray, a.aggField, b.aggField);
	            }
	            return sortValue;
	        };
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_helpers.js
	    dimple._helpers = {

	        // Calculate the centre x position
	        cx: function (d, chart, series) {
	            var returnCx = 0;
	            if (series.x.measure !== null && series.x.measure !== undefined) {
	                returnCx = series.x._scale(d.cx);
	            } else if (series.x._hasCategories() && series.x.categoryFields.length >= 2) {
	                returnCx = series.x._scale(d.cx) + dimple._helpers.xGap(chart, series) + ((d.xOffset + 0.5) * (((chart._widthPixels() / series.x._max) - 2 * dimple._helpers.xGap(chart, series)) * d.width));
	            } else {
	                returnCx = series.x._scale(d.cx) + ((chart._widthPixels() / series.x._max) / 2);
	            }
	            return returnCx;
	        },

	        // Calculate the centre y position
	        cy: function (d, chart, series) {
	            var returnCy = 0;
	            if (series.y.measure !== null && series.y.measure !== undefined) {
	                returnCy = series.y._scale(d.cy);
	            } else if (series.y.categoryFields !== null && series.y.categoryFields !== undefined && series.y.categoryFields.length >= 2) {
	                returnCy = (series.y._scale(d.cy) - (chart._heightPixels() / series.y._max)) +  dimple._helpers.yGap(chart, series) + ((d.yOffset + 0.5) * (((chart._heightPixels() / series.y._max) - 2 * dimple._helpers.yGap(chart, series)) * d.height));
	            } else {
	                returnCy = series.y._scale(d.cy) - ((chart._heightPixels() / series.y._max) / 2);
	            }
	            return returnCy;
	        },

	        // Calculate the radius
	        r: function (d, chart, series) {
	            var returnR = 0,
	                scaleFactor = 1;
	            if (series.z === null || series.z === undefined) {
	                returnR = (!series.radius || series.radius === "auto" ? 5 : series.radius);
	            } else {
	                if (series.radius && series.radius !== "auto" && series.radius > 1) {
	                    scaleFactor = series.radius / series.z._scale(series.z._max);
	                }
	                if (series.z._hasMeasure()) {
	                    returnR = series.z._scale(d.r) * scaleFactor;
	                } else {
	                    returnR = series.z._scale(chart._heightPixels() / 100) * scaleFactor;
	                }
	            }
	            return returnR;
	        },

	        // Calculate the x gap for bar type charts
	        xGap: function (chart, series) {
	            var returnXGap = 0;
	            if ((series.x.measure === null || series.x.measure === undefined) && series.barGap > 0) {
	                returnXGap = ((chart._widthPixels() / series.x._max) * (series.barGap > 0.99 ? 0.99 : series.barGap)) / 2;
	            }
	            return returnXGap;
	        },

	        // Calculate the x gap for clusters within bar type charts
	        xClusterGap: function (d, chart, series) {
	            var returnXClusterGap = 0;
	            if (series.x.categoryFields !== null && series.x.categoryFields !== undefined && series.x.categoryFields.length >= 2 && series.clusterBarGap > 0 && !series.x._hasMeasure()) {
	                returnXClusterGap = (d.width * ((chart._widthPixels() / series.x._max) - (dimple._helpers.xGap(chart, series) * 2)) * (series.clusterBarGap > 0.99 ? 0.99 : series.clusterBarGap)) / 2;
	            }
	            return returnXClusterGap;
	        },

	        // Calculate the y gap for bar type charts
	        yGap: function (chart, series) {
	            var returnYGap = 0;
	            if ((series.y.measure === null || series.y.measure === undefined) && series.barGap > 0) {
	                returnYGap = ((chart._heightPixels() / series.y._max) * (series.barGap > 0.99 ? 0.99 : series.barGap)) / 2;
	            }
	            return returnYGap;
	        },

	        // Calculate the y gap for clusters within bar type charts
	        yClusterGap: function (d, chart, series) {
	            var returnYClusterGap = 0;
	            if (series.y.categoryFields !== null && series.y.categoryFields !== undefined && series.y.categoryFields.length >= 2 && series.clusterBarGap > 0 && !series.y._hasMeasure()) {
	                returnYClusterGap = (d.height * ((chart._heightPixels() / series.y._max) - (dimple._helpers.yGap(chart, series) * 2)) * (series.clusterBarGap > 0.99 ? 0.99 : series.clusterBarGap)) / 2;
	            }
	            return returnYClusterGap;
	        },

	        // Calculate the top left x position for bar type charts
	        x: function (d, chart, series) {
	            var returnX = 0;
	            if (series.x._hasTimeField()) {
	                returnX = series.x._scale(d.x) - (dimple._helpers.width(d, chart, series) / 2);
	            } else if (series.x.measure !== null && series.x.measure !== undefined) {
	                returnX = series.x._scale(d.x);
	            } else {
	                returnX = series.x._scale(d.x) + dimple._helpers.xGap(chart, series) + (d.xOffset * (dimple._helpers.width(d, chart, series) + 2 * dimple._helpers.xClusterGap(d, chart, series))) + dimple._helpers.xClusterGap(d, chart, series);
	            }
	            return returnX;
	        },

	        // Calculate the top left y position for bar type charts
	        y: function (d, chart, series) {
	            var returnY = 0;
	            if (series.y._hasTimeField()) {
	                returnY = series.y._scale(d.y) - (dimple._helpers.height(d, chart, series) / 2);
	            } else if (series.y.measure !== null && series.y.measure !== undefined) {
	                returnY = series.y._scale(d.y);
	            } else {
	                returnY = (series.y._scale(d.y) - (chart._heightPixels() / series.y._max)) + dimple._helpers.yGap(chart, series) + (d.yOffset * (dimple._helpers.height(d, chart, series) + 2 * dimple._helpers.yClusterGap(d, chart, series))) + dimple._helpers.yClusterGap(d, chart, series);
	            }
	            return returnY;
	        },

	        // Calculate the width for bar type charts
	        width: function (d, chart, series) {
	            var returnWidth = 0;
	            if (series.x.measure !== null && series.x.measure !== undefined) {
	                returnWidth = Math.abs(series.x._scale((d.x < 0 ? d.x - d.width : d.x + d.width)) - series.x._scale(d.x));
	            } else if (series.x._hasTimeField()) {
	                returnWidth = series.x.floatingBarWidth;
	            } else {
	                returnWidth = d.width * ((chart._widthPixels() / series.x._max) - (dimple._helpers.xGap(chart, series) * 2)) - (dimple._helpers.xClusterGap(d, chart, series) * 2);
	            }
	            return returnWidth;
	        },

	        // Calculate the height for bar type charts
	        height: function (d, chart, series) {
	            var returnHeight = 0;
	            if (series.y._hasTimeField()) {
	                returnHeight = series.y.floatingBarWidth;
	            } else if (series.y.measure !== null && series.y.measure !== undefined) {
	                returnHeight = Math.abs(series.y._scale(d.y) - series.y._scale((d.y <= 0 ? d.y + d.height : d.y - d.height)));
	            } else {
	                returnHeight = d.height * ((chart._heightPixels() / series.y._max) - (dimple._helpers.yGap(chart, series) * 2)) - (dimple._helpers.yClusterGap(d, chart, series) * 2);
	            }
	            return returnHeight;
	        },

	        // Calculate the opacity for series
	        opacity: function (d, chart, series) {
	            var returnOpacity = 0;
	            if (series.c !== null && series.c !== undefined) {
	                returnOpacity = d.opacity;
	            } else {
	                returnOpacity = chart.getColor(d.aggField.slice(-1)[0]).opacity;
	            }
	            return returnOpacity;
	        },

	        // Calculate the fill coloring for series
	        fill: function (d, chart, series) {
	            var returnFill = 0;
	            if (series.c !== null && series.c !== undefined) {
	                returnFill = d.fill;
	            } else {
	                returnFill = chart.getColor(d.aggField.slice(-1)[0]).fill;
	            }
	            return returnFill;
	        },

	        // Calculate the stroke coloring for series
	        stroke: function (d, chart, series) {
	            var stroke = 0;
	            if (series.c !== null && series.c !== undefined) {
	                stroke = d.stroke;
	            } else {
	                stroke = chart.getColor(d.aggField.slice(-1)[0]).stroke;
	            }
	            return stroke;
	        },

	        // Calculate the class for the series
	        css: function (d, chart) {
	            return chart.getClass(d.aggField.slice(-1)[0]);
	        }


	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_parentHeight.js
	    dimple._parentHeight = function (parent) {
	        // This one seems to work in Chrome - good old Chrome!
	        var returnValue = parent.offsetHeight;
	        // This does it for IE
	        if (returnValue <= 0 || returnValue === null || returnValue === undefined) {
	            returnValue = parent.clientHeight;
	        }
	        // FireFox is the hard one this time.  See this bug report:
	        // https://bugzilla.mozilla.org/show_bug.cgi?id=649285//
	        // It's dealt with by trying to recurse up the dom until we find something
	        // we can get a size for.  Usually the parent of the SVG.  It's a bit costly
	        // but I don't know of any other way.
	        if (returnValue <= 0 || returnValue === null || returnValue === undefined) {
	            if (parent.parentNode === null || parent.parentNode === undefined) {
	                // Give up - Recursion Exit Point
	                returnValue = 0;
	            } else {
	                // Get the size from the parent recursively
	                returnValue = dimple._parentHeight(parent.parentNode);
	            }
	        }
	        return returnValue;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_parentWidth.js
	    dimple._parentWidth = function (parent) {
	        // This one seems to work in Chrome - good old Chrome!
	        var returnValue = parent.offsetWidth;
	        // This does it for IE
	        if (!returnValue || returnValue < 0) {
	            returnValue = parent.clientWidth;
	        }
	        // FireFox is the hard one this time.  See this bug report:
	        // https://bugzilla.mozilla.org/show_bug.cgi?id=649285//
	        // It's dealt with by trying to recurse up the dom until we find something
	        // we can get a size for.  Usually the parent of the SVG.  It's a bit costly
	        // but I don't know of any other way.
	        if (!returnValue || returnValue < 0) {
	            if (!parent.parentNode) {
	                // Give up - Recursion Exit Point
	                returnValue = 0;
	            } else {
	                // Get the size from the parent recursively
	                returnValue = dimple._parentWidth(parent.parentNode);
	            }
	        }
	        return returnValue;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_parsePosition.js
	    dimple._parsePosition = function (value, maxValue) {
	        var returnValue = 0,
	            values;
	        if (value) {
	            values = value.toString().split(",");
	            values.forEach(function (v) {
	                if (v) {
	                    if (!isNaN(v)) {
	                        returnValue += parseFloat(v);
	                    } else if (v.slice(-1) === "%") {
	                        returnValue += maxValue * (parseFloat(v.slice(0, v.length - 1)) / 100);
	                    } else if (v.slice(-2) === "px") {
	                        returnValue += parseFloat(v.slice(0, v.length - 2));
	                    } else {
	                        returnValue = value;
	                    }
	                }
	            }, this);
	        }
	        // Take the position from the extremity if the value is negative
	        if (returnValue < 0) {
	            returnValue = maxValue + returnValue;
	        }
	        return returnValue;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_parseXPosition.js
	    dimple._parseXPosition = function (value, parent) {
	        return dimple._parsePosition(value, dimple._parentWidth(parent));
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_parseYPosition.js
	    dimple._parseYPosition = function (value, parent) {
	        return dimple._parsePosition(value, dimple._parentHeight(parent));
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_drawMarkers.js
	    dimple._postDrawHandling = function (series, updated, removed, duration) {
	        // Run after transition methods
	        if (duration === 0) {
	            updated.each(function (d, i) {
	                if (series.afterDraw !== null && series.afterDraw !== undefined) {
	                    series.afterDraw(this, d, i);
	                }
	            });
	            removed.remove();
	        } else {
	            updated.each("end", function (d, i) {
	                if (series.afterDraw !== null && series.afterDraw !== undefined) {
	                    series.afterDraw(this, d, i);
	                }
	            });
	            removed.each("end", function () {
	                d3.select(this).remove();
	            });
	        }
	    };
	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_removeTooltip.js
	    /*jslint unparam: true */
	    dimple._removeTooltip = function (e, shape, chart, series) {
	        if (chart._tooltipGroup) {
	            chart._tooltipGroup.remove();
	        }
	    };
	    /*jslint unparam: false */

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_rollUp.js
	    dimple._rollUp = function (data, fields, includeFields) {

	        var returnList = [];
	        // Put single values into single value arrays
	        if (fields !== null && fields !== undefined) {
	            fields = [].concat(fields);
	        } else {
	            fields = [];
	        }
	        // Iterate every row in the data
	        data.forEach(function (d) {
	            // The index of the corresponding row in the return list
	            var index = -1,
	                newRow = {},
	                match = true;
	            // Find the corresponding value in the return list
	            returnList.forEach(function (r, j) {
	                if (index === -1) {
	                    // Indicates a match
	                    match = true;
	                    // Iterate the passed fields and compare
	                    fields.forEach(function (f) {
	                        match = match && d[f] === r[f];
	                    }, this);
	                    // If this is a match get the index
	                    if (match) {
	                        index = j;
	                    }
	                }
	            }, this);
	            // Pick up the matched row, or add a new one
	            if (index !== -1) {
	                newRow = returnList[index];
	            } else {
	                // Iterate the passed fields and add to the new row
	                fields.forEach(function (f) {
	                    newRow[f] = d[f];
	                }, this);
	                returnList.push(newRow);
	                index = returnList.length - 1;
	            }
	            // Iterate all the fields in the data
	            includeFields.forEach(function (field) {
	                if (fields.indexOf(field) === -1) {
	                    if (newRow[field] === undefined) {
	                        newRow[field] = [];
	                    }
	                    newRow[field] = newRow[field].concat(d[field]);
	                }
	            }, this);
	            // Update the return list
	            returnList[index] = newRow;
	        }, this);
	        // Return the flattened list
	        return returnList;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_showBarTooltip.js
	    dimple._showBarTooltip = function (e, shape, chart, series) {

	        // The margin between the text and the box
	        var textMargin = 5,
	            // The margin between the ring and the popup
	            popupMargin = 10,
	           // The popup animation duration in ms
	            animDuration = 750,
	            // Collect some facts about the highlighted bar
	            selectedShape = d3.select(shape),
	            x = selectedShape.node().getBBox().x,
	            y = selectedShape.node().getBBox().y,
	            width = selectedShape.node().getBBox().width,
	            height = selectedShape.node().getBBox().height,
	            //transform = selectedShape.attr("transform"),
	            opacity = selectedShape.attr("opacity"),
	            fill = selectedShape.attr("fill"),
	            dropDest = series._dropLineOrigin(),
	            // Fade the popup stroke mixing the shape fill with 60% white
	            popupStrokeColor = d3.rgb(
	                d3.rgb(fill).r + 0.6 * (255 - d3.rgb(fill).r),
	                d3.rgb(fill).g + 0.6 * (255 - d3.rgb(fill).g),
	                d3.rgb(fill).b + 0.6 * (255 - d3.rgb(fill).b)
	            ),
	            // Fade the popup fill mixing the shape fill with 80% white
	            popupFillColor = d3.rgb(
	                d3.rgb(fill).r + 0.8 * (255 - d3.rgb(fill).r),
	                d3.rgb(fill).g + 0.8 * (255 - d3.rgb(fill).g),
	                d3.rgb(fill).b + 0.8 * (255 - d3.rgb(fill).b)
	            ),
	            t,
	            box,
	            tipText = series.getTooltipText(e),
	            // The running y value for the text elements
	            yRunning = 0,
	            // The maximum bounds of the text elements
	            w = 0,
	            h = 0,
	            // Values to shift the popup
	            translateX,
	            translateY,
	            transformer,
	            offset,
	            transformPoint = function (x, y) {
	                var matrix = selectedShape.node().getCTM(),
	                    position = chart.svg.node().createSVGPoint();
	                position.x = x || 0;
	                position.y = y || 0;
	                return position.matrixTransform(matrix);
	            };

	        if (chart._tooltipGroup !== null && chart._tooltipGroup !== undefined) {
	            chart._tooltipGroup.remove();
	        }
	        chart._tooltipGroup = chart.svg.append("g");

	        if (!series.p) {

	            offset = (series._isStacked() ? 1 : width / 2);

	            // Add a drop line to the x axis
	            if (!series.x._hasCategories() && dropDest.y !== null) {
	                chart._tooltipGroup.append("line")
	                    .attr("x1", (x < series.x._origin ? x + offset : x + width - offset))
	                    .attr("y1", (y < dropDest.y ? y + height : y))
	                    .attr("x2", (x < series.x._origin ? x + offset : x + width - offset))
	                    .attr("y2", (y < dropDest.y ? y + height : y))
	                    .style("fill", "none")
	                    .style("stroke", fill)
	                    .style("stroke-width", 2)
	                    .style("stroke-dasharray", ("3, 3"))
	                    .style("opacity", opacity)
	                    .transition()
	                    .delay(animDuration / 2)
	                    .duration(animDuration / 2)
	                    .ease("linear")
	                    // Added 1px offset to cater for svg issue where a transparent
	                    // group overlapping a line can sometimes hide it in some browsers
	                    // Issue #10
	                    .attr("y2", (y < dropDest.y ? dropDest.y - 1 : dropDest.y + 1));
	            }

	            offset = (series._isStacked() ? 1 : height / 2);

	            // Add a drop line to the y axis
	            if (!series.y._hasCategories() && dropDest.x !== null) {
	                chart._tooltipGroup.append("line")
	                    .attr("x1", (x < dropDest.x ? x + width : x))
	                    .attr("y1", (y < series.y._origin ? y + offset : y + height - offset))
	                    .attr("x2", (x < dropDest.x ? x + width : x))
	                    .attr("y2", (y < series.y._origin ? y + offset : y + height - offset))
	                    .style("fill", "none")
	                    .style("stroke", fill)
	                    .style("stroke-width", 2)
	                    .style("stroke-dasharray", ("3, 3"))
	                    .style("opacity", opacity)
	                    .transition()
	                    .delay(animDuration / 2)
	                    .duration(animDuration / 2)
	                    .ease("linear")
	                    // Added 1px offset to cater for svg issue where a transparent
	                    // group overlapping a line can sometimes hide it in some browsers
	                    // Issue #10
	                    .attr("x2", (x < dropDest.x ? dropDest.x - 1 : dropDest.x + 1));
	            }

	        }

	        // Add a group for text
	        t = chart._tooltipGroup.append("g");
	        // Create a box for the popup in the text group
	        box = t.append("rect")
	            .attr("class", "dimple-tooltip " + chart.customClassList.tooltipBox);

	        // Create a text object for every row in the popup
	        t.selectAll(".dimple-dont-select-any").data(tipText).enter()
	            .append("text")
	            .attr("class", "dimple-tooltip " + chart.customClassList.tooltipLabel)
	            .text(function (d) { return d; })
	            .style("font-family", series.tooltipFontFamily)
	            .style("font-size", series._getTooltipFontSize());

	        // Get the max height and width of the text items
	        t.each(function () {
	            w = (this.getBBox().width > w ? this.getBBox().width : w);
	            h = (this.getBBox().width > h ? this.getBBox().height : h);
	        });

	        // Position the text relative to the bar, the absolute positioning
	        // will be done by translating the group
	        t.selectAll("text")
	            .attr("x", 0)
	            .attr("y", function () {
	                // Increment the y position
	                yRunning += this.getBBox().height;
	                // Position the text at the centre point
	                return yRunning - (this.getBBox().height / 2);
	            });

	        // Draw the box with a margin around the text
	        box.attr("x", -textMargin)
	            .attr("y", -textMargin)
	            .attr("height", Math.floor(yRunning + textMargin) - 0.5)
	            .attr("width", w + 2 * textMargin)
	            .attr("rx", 5)
	            .attr("ry", 5)
	            .style("fill", popupFillColor)
	            .style("stroke", popupStrokeColor)
	            .style("stroke-width", 2)
	            .style("opacity", 0.95);

	        // Shift the popup around to avoid overlapping the svg edge
	        if (transformPoint(x + width + textMargin + popupMargin + w).x < parseFloat(chart.svg.node().getBBox().width)) {
	            // Draw centre right
	            translateX = (x + width + textMargin + popupMargin);
	            translateY = (y + (height / 2) - ((yRunning - (h - textMargin)) / 2));
	        } else if (transformPoint(x - (textMargin + popupMargin + w)).x > 0) {
	            // Draw centre left
	            translateX = (x - (textMargin + popupMargin + w));
	            translateY = (y + (height / 2) - ((yRunning - (h - textMargin)) / 2));
	        } else if (transformPoint(0, y + height + yRunning + popupMargin + textMargin).y < parseFloat(chart.svg.node().getBBox().height)) {
	            // Draw centre below
	            translateX = (x + (width / 2) - (2 * textMargin + w) / 2);
	            translateX = (translateX > 0 ? translateX : popupMargin);
	            translateX = (translateX + w < parseFloat(chart.svg.node().getBBox().width) ? translateX : parseFloat(chart.svg.node().getBBox().width) - w - popupMargin);
	            translateY = (y + height + 2 * textMargin);
	        } else {
	            // Draw centre above
	            translateX = (x + (width / 2) - (2 * textMargin + w) / 2);
	            translateX = (translateX > 0 ? translateX : popupMargin);
	            translateX = (translateX + w < parseFloat(chart.svg.node().getBBox().width) ? translateX : parseFloat(chart.svg.node().getBBox().width) - w - popupMargin);
	            translateY = (y - yRunning - (h - textMargin));
	        }
	        transformer = transformPoint(translateX, translateY);
	        t.attr("transform", "translate(" + transformer.x + " , " + transformer.y + ")");
	    };
	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/_showPointTooltip.js
	    dimple._showPointTooltip = function (e, shape, chart, series) {

	        // The margin between the text and the box
	        var textMargin = 5,
	        // The margin between the ring and the popup
	            popupMargin = 10,
	        // The popup animation duration in ms
	            animDuration = 750,
	        // Collect some facts about the highlighted bubble
	            selectedShape = d3.select(shape),
	            cx = parseFloat(selectedShape.attr("cx")),
	            cy = parseFloat(selectedShape.attr("cy")),
	            r = parseFloat(selectedShape.attr("r")),
	            opacity = dimple._helpers.opacity(e, chart, series),
	            fill = selectedShape.attr("stroke"),
	            dropDest = series._dropLineOrigin(),
	        // Fade the popup stroke mixing the shape fill with 60% white
	            popupStrokeColor = d3.rgb(
	                d3.rgb(fill).r + 0.6 * (255 - d3.rgb(fill).r),
	                d3.rgb(fill).g + 0.6 * (255 - d3.rgb(fill).g),
	                d3.rgb(fill).b + 0.6 * (255 - d3.rgb(fill).b)
	            ),
	        // Fade the popup fill mixing the shape fill with 80% white
	            popupFillColor = d3.rgb(
	                d3.rgb(fill).r + 0.8 * (255 - d3.rgb(fill).r),
	                d3.rgb(fill).g + 0.8 * (255 - d3.rgb(fill).g),
	                d3.rgb(fill).b + 0.8 * (255 - d3.rgb(fill).b)
	            ),
	        // The running y value for the text elements
	            y = 0,
	        // The maximum bounds of the text elements
	            w = 0,
	            h = 0,
	            t,
	            box,
	            tipText = series.getTooltipText(e),
	            translateX,
	            translateY;

	        if (chart._tooltipGroup !== null && chart._tooltipGroup !== undefined) {
	            chart._tooltipGroup.remove();
	        }
	        chart._tooltipGroup = chart.svg.append("g");

	        // Add a ring around the data point
	        chart._tooltipGroup.append("circle")
	            .attr("cx", cx)
	            .attr("cy", cy)
	            .attr("r", r)
	            .attr("opacity", 0)
	            .style("fill", "none")
	            .style("stroke", fill)
	            .style("stroke-width", 1)
	            .transition()
	            .duration(animDuration / 2)
	            .ease("linear")
	            .attr("opacity", 1)
	            .attr("r", r + series.lineWeight + 2)
	            .style("stroke-width", 2);

	        // Add a drop line to the x axis
	        if (dropDest.y !== null) {
	            chart._tooltipGroup.append("line")
	                .attr("x1", cx)
	                .attr("y1", (cy < dropDest.y ? cy + r + series.lineWeight + 2 : cy - r - series.lineWeight - 2))
	                .attr("x2", cx)
	                .attr("y2", (cy < dropDest.y ? cy + r + series.lineWeight + 2 : cy - r - series.lineWeight - 2))
	                .style("fill", "none")
	                .style("stroke", fill)
	                .style("stroke-width", 2)
	                .style("stroke-dasharray", ("3, 3"))
	                .style("opacity", opacity)
	                .transition()
	                .delay(animDuration / 2)
	                .duration(animDuration / 2)
	                .ease("linear")
	                // Added 1px offset to cater for svg issue where a transparent
	                // group overlapping a line can sometimes hide it in some browsers
	                // Issue #10
	                .attr("y2", (cy < dropDest.y ? dropDest.y - 1 : dropDest.y + 1));
	        }

	        // Add a drop line to the y axis
	        if (dropDest.x !== null) {
	            chart._tooltipGroup.append("line")
	                .attr("x1", (cx < dropDest.x ? cx + r + series.lineWeight + 2 : cx - r - series.lineWeight - 2))
	                .attr("y1", cy)
	                .attr("x2", (cx < dropDest.x ? cx + r + series.lineWeight + 2 : cx - r - series.lineWeight - 2))
	                .attr("y2", cy)
	                .style("fill", "none")
	                .style("stroke", fill)
	                .style("stroke-width", 2)
	                .style("stroke-dasharray", ("3, 3"))
	                .style("opacity", opacity)
	                .transition()
	                .delay(animDuration / 2)
	                .duration(animDuration / 2)
	                .ease("linear")
	                // Added 1px offset to cater for svg issue where a transparent
	                // group overlapping a line can sometimes hide it in some browsers
	                // Issue #10
	                .attr("x2", (cx < dropDest.x ? dropDest.x - 1 : dropDest.x + 1));
	        }

	        // Add a group for text
	        t = chart._tooltipGroup.append("g");
	        // Create a box for the popup in the text group
	        box = t.append("rect")
	            .attr("class", "dimple-tooltip");

	        // Create a text object for every row in the popup
	        t.selectAll(".dont-select-any").data(tipText).enter()
	            .append("text")
	            .attr("class", "dimple-tooltip")
	            .text(function (d) { return d; })
	            .style("font-family", series.tooltipFontFamily)
	            .style("font-size", series._getTooltipFontSize());

	        // Get the max height and width of the text items
	        t.each(function () {
	            w = (this.getBBox().width > w ? this.getBBox().width : w);
	            h = (this.getBBox().width > h ? this.getBBox().height : h);
	        });

	        // Position the text relative to the bubble, the absolute positioning
	        // will be done by translating the group
	        t.selectAll("text")
	            .attr("x", 0)
	            .attr("y", function () {
	                // Increment the y position
	                y += this.getBBox().height;
	                // Position the text at the centre point
	                return y - (this.getBBox().height / 2);
	            });

	        // Draw the box with a margin around the text
	        box.attr("x", -textMargin)
	            .attr("y", -textMargin)
	            .attr("height", Math.floor(y + textMargin) - 0.5)
	            .attr("width", w + 2 * textMargin)
	            .attr("rx", 5)
	            .attr("ry", 5)
	            .style("fill", popupFillColor)
	            .style("stroke", popupStrokeColor)
	            .style("stroke-width", 2)
	            .style("opacity", 0.95);

	        // Shift the popup around to avoid overlapping the svg edge
	        if (cx + r + textMargin + popupMargin + w < parseFloat(chart.svg.node().getBBox().width)) {
	            // Draw centre right
	            translateX = (cx + r + textMargin + popupMargin);
	            translateY = (cy - ((y - (h - textMargin)) / 2));
	        } else if (cx - r - (textMargin + popupMargin + w) > 0) {
	            // Draw centre left
	            translateX = (cx - r - (textMargin + popupMargin + w));
	            translateY = (cy - ((y - (h - textMargin)) / 2));
	        } else if (cy + r + y + popupMargin + textMargin < parseFloat(chart.svg.node().getBBox().height)) {
	            // Draw centre below
	            translateX = (cx - (2 * textMargin + w) / 2);
	            translateX = (translateX > 0 ? translateX : popupMargin);
	            translateX = (translateX + w < parseFloat(chart.svg.node().getBBox().width) ? translateX : parseFloat(chart.svg.node().getBBox().width) - w - popupMargin);
	            translateY = (cy + r + 2 * textMargin);
	        } else {
	            // Draw centre above
	            translateX = (cx - (2 * textMargin + w) / 2);
	            translateX = (translateX > 0 ? translateX : popupMargin);
	            translateX = (translateX + w < parseFloat(chart.svg.node().getBBox().width) ? translateX : parseFloat(chart.svg.node().getBBox().width) - w - popupMargin);
	            translateY = (cy - y - (h - textMargin));
	        }
	        t.attr("transform", "translate(" + translateX + " , " + translateY + ")");
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/filterData.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple#wiki-filterData
	    dimple.filterData = function (data, field, filterValues) {
	        var returnData = data;
	        if (field !== null && filterValues !== null) {
	            // Build an array from a single filter value or use the array
	            if (filterValues !== null && filterValues !== undefined) { filterValues = [].concat(filterValues); }
	            // The data to return
	            returnData = [];
	            // Iterate all the data
	            data.forEach(function (d) {
	                // If an invalid field is passed, just pass the data
	                if (d[field] === null) {
	                    returnData.push(d);
	                } else {
	                    if (filterValues.indexOf([].concat(d[field]).join("/")) > -1) {
	                        returnData.push(d);
	                    }
	                }
	            }, this);
	        }
	        // Return the filtered data
	        return returnData;
	    };


	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/getUniqueValues.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple#wiki-getUniqueValues
	    dimple.getUniqueValues = function (data, fields) {
	        var returnlist = [];
	        // Put single values into single value arrays
	        if (fields !== null && fields !== undefined) {
	            fields = [].concat(fields);
	            // Iterate every row in the data
	            data.forEach(function (d) {
	                // Handle multiple category values by iterating the fields in the row and concatonate the values
	                var field = "";
	                fields.forEach(function (f, i) {
	                    if (i > 0) {
	                        field += "/";
	                    }
	                    field += d[f];
	                }, this);
	                // If the field was not found, add it to the end of the categories array
	                if (returnlist.indexOf(field) === -1) {
	                    returnlist.push(field);
	                }
	            }, this);
	        }
	        return returnlist;
	    };

	    // Copyright: 2015 AlignAlytics
	    // License: "https://github.com/PMSI-AlignAlytics/dimple/blob/master/MIT-LICENSE.txt"
	    // Source: /src/methods/newSvg.js
	    // Help: http://github.com/PMSI-AlignAlytics/dimple/wiki/dimple#wiki-newSvg
	    dimple.newSvg = function (parentSelector, width, height) {
	        var selectedShape = null;
	        if (parentSelector === null || parentSelector === undefined) {
	            parentSelector = "body";
	        }
	        selectedShape = d3.select(parentSelector);
	        if (selectedShape.empty()) {
	            throw "The '" + parentSelector + "' selector did not match any elements.  Please prefix with '#' to select by id or '.' to select by class";
	        }
	        return selectedShape.append("svg").attr("width", width).attr("height", height);
	    };



	    return dimple;
	}));
	// End dimple

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }

	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;

	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;

	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;

	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();

	       case "c":
	        exponent = false;

	       case "d":
	        integer = true;
	        precision = 0;
	        break;

	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;

	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;

	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;

	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 Based on ndef.parser, by Raphael Graf(r@undefined.ch)
	 http://www.undefined.ch/mparser/index.html

	 Ported to JavaScript and modified by Matthew Crumley (email@matthewcrumley.com, http://silentmatt.com/)

	 You are free to use and modify this code in anyway you find useful. Please leave this comment in the code
	 to acknowledge its original source. If you feel like it, I enjoy hearing about projects that use my code,
	 but don't feel like you have to let me know or ask permission.
	*/

	//  Added by stlsmiths 6/13/2011
	//  re-define Array.indexOf, because IE doesn't know it ...
	//
	//  from http://stellapower.net/content/javascript-support-and-arrayindexof-ie
		if (!Array.indexOf) {
			Array.prototype.indexOf = function (obj, start) {
				for (var i = (start || 0); i < this.length; i++) {
					if (this[i] === obj) {
						return i;
					}
				}
				return -1;
			}
		}

	var Parser = (function (scope) {
		function object(o) {
			function F() {}
			F.prototype = o;
			return new F();
		}

		var TNUMBER = 0;
		var TOP1 = 1;
		var TOP2 = 2;
		var TVAR = 3;
		var TFUNCALL = 4;

		function Token(type_, index_, prio_, number_) {
			this.type_ = type_;
			this.index_ = index_ || 0;
			this.prio_ = prio_ || 0;
			this.number_ = (number_ !== undefined && number_ !== null) ? number_ : 0;
			this.toString = function () {
				switch (this.type_) {
				case TNUMBER:
					return this.number_;
				case TOP1:
				case TOP2:
				case TVAR:
					return this.index_;
				case TFUNCALL:
					return "CALL";
				default:
					return "Invalid Token";
				}
			};
		}

		function Expression(tokens, ops1, ops2, functions) {
			this.tokens = tokens;
			this.ops1 = ops1;
			this.ops2 = ops2;
			this.functions = functions;
		}

		// Based on http://www.json.org/json2.js
	    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	        escapable = /[\\\'\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
	        meta = {    // table of character substitutions
	            '\b': '\\b',
	            '\t': '\\t',
	            '\n': '\\n',
	            '\f': '\\f',
	            '\r': '\\r',
	            "'" : "\\'",
	            '\\': '\\\\'
	        };

		function escapeValue(v) {
			if (typeof v === "string") {
				escapable.lastIndex = 0;
		        return escapable.test(v) ?
		            "'" + v.replace(escapable, function (a) {
		                var c = meta[a];
		                return typeof c === 'string' ? c :
		                    '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
		            }) + "'" :
		            "'" + v + "'";
			}
			return v;
		}

		function hasValue(values, index) {
			var parts = index.split(/\./);
			var value = values;
			var part;
			while (part = parts.shift()) {
				if (!(part in value)) {
					return false;
				}
				value = value[part];
			}
			return true;
		}

		function getValue(values, index) {
			var parts = index.split(/\./);
			var value = values;
			var part;
			while (part = parts.shift()) {
				value = value[part];
			}
			return value;
		}

		Expression.prototype = {
			simplify: function (values) {
				values = values || {};
				var nstack = [];
				var newexpression = [];
				var n1;
				var n2;
				var f;
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TNUMBER) {
						nstack.push(item);
					}
					else if (type_ === TVAR && hasValue(values, item.index_)) {
						item = new Token(TNUMBER, 0, 0, getValue(values, item.index_));
						nstack.push(item);
					}
					else if (type_ === TOP2 && nstack.length > 1) {
						n2 = nstack.pop();
						n1 = nstack.pop();
						f = this.ops2[item.index_];
						item = new Token(TNUMBER, 0, 0, f(n1.number_, n2.number_));
						nstack.push(item);
					}
					else if (type_ === TOP1 && nstack.length > 0) {
						n1 = nstack.pop();
						f = this.ops1[item.index_];
						item = new Token(TNUMBER, 0, 0, f(n1.number_));
						nstack.push(item);
					}
					else {
						while (nstack.length > 0) {
							newexpression.push(nstack.shift());
						}
						newexpression.push(item);
					}
				}
				while (nstack.length > 0) {
					newexpression.push(nstack.shift());
				}

				return new Expression(newexpression, object(this.ops1), object(this.ops2), object(this.functions));
			},

			substitute: function (variable, expr) {
				if (!(expr instanceof Expression)) {
					expr = new Parser().parse(String(expr));
				}
				var newexpression = [];
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TVAR && item.index_ === variable) {
						for (var j = 0; j < expr.tokens.length; j++) {
							var expritem = expr.tokens[j];
							var replitem = new Token(expritem.type_, expritem.index_, expritem.prio_, expritem.number_);
							newexpression.push(replitem);
						}
					}
					else {
						newexpression.push(item);
					}
				}

				var ret = new Expression(newexpression, object(this.ops1), object(this.ops2), object(this.functions));
				return ret;
			},

			evaluate: function (values) {
				values = values || {};
				var nstack = [];
				var n1;
				var n2;
				var f;
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TNUMBER) {
						nstack.push(item.number_);
					}
					else if (type_ === TOP2) {
						n2 = nstack.pop();
						n1 = nstack.pop();
						f = this.ops2[item.index_];
						nstack.push(f(n1, n2));
					}
					else if (type_ === TVAR) {
						if (hasValue(values, item.index_)) {
							nstack.push(getValue(values, item.index_));
						}
						else if (hasValue(this.functions, item.index_)) {
							nstack.push(getValue(this.functions, item.index_));
						}
						else {
							throw new Error("undefined variable: " + item.index_);
						}
					}
					else if (type_ === TOP1) {
						n1 = nstack.pop();
						f = this.ops1[item.index_];
						nstack.push(f(n1));
					}
					else if (type_ === TFUNCALL) {
						n1 = nstack.pop();
						f = nstack.pop();
						if (f.apply && f.call) {
							if (Object.prototype.toString.call(n1) == "[object Array]") {
								nstack.push(f.apply(undefined, n1));
							}
							else {
								nstack.push(f.call(undefined, n1));
							}
						}
						else {
							throw new Error(f + " is not a function");
						}
					}
					else {
						throw new Error("invalid Expression");
					}
				}
				if (nstack.length > 1) {
					throw new Error("invalid Expression (parity)");
				}
				return nstack[0];
			},

			toString: function (toJS) {
				var nstack = [];
				var n1;
				var n2;
				var f;
				var L = this.tokens.length;
				var item;
				var i = 0;
				for (i = 0; i < L; i++) {
					item = this.tokens[i];
					var type_ = item.type_;
					if (type_ === TNUMBER) {
						nstack.push(escapeValue(item.number_));
					}
					else if (type_ === TOP2) {
						n2 = nstack.pop();
						n1 = nstack.pop();
						f = item.index_;
						if (toJS && f == "^") {
							nstack.push("Math.pow(" + n1 + "," + n2 + ")");
						}
						else {
							nstack.push("(" + n1 + f + n2 + ")");
						}
					}
					else if (type_ === TVAR) {
						nstack.push(item.index_);
					}
					else if (type_ === TOP1) {
						n1 = nstack.pop();
						f = item.index_;
						if (f === "-") {
							nstack.push("(" + f + n1 + ")");
						}
						else {
							nstack.push(f + "(" + n1 + ")");
						}
					}
					else if (type_ === TFUNCALL) {
						n1 = nstack.pop();
						f = nstack.pop();
						nstack.push(f + "(" + n1 + ")");
					}
					else {
						throw new Error("invalid Expression");
					}
				}
				if (nstack.length > 1) {
					throw new Error("invalid Expression (parity)");
				}
				return nstack[0];
			},

			variables: function () {
				var L = this.tokens.length;
				var vars = [];
				for (var i = 0; i < L; i++) {
					var item = this.tokens[i];
					if (item.type_ === TVAR && (vars.indexOf(item.index_) == -1)) {
						vars.push(item.index_);
					}
				}

				return vars;
			},

			toJSFunction: function (param, variables) {
				var f = new Function(param, "with(Parser.values) { return " + this.simplify(variables).toString(true) + "; }");
				return f;
			}
		};

		function add(a, b) {
			return Number(a) + Number(b);
		}
		function sub(a, b) {
			return a - b;
		}
		function mul(a, b) {
			return a * b;
		}
		function div(a, b) {
			return a / b;
		}
		function mod(a, b) {
			return a % b;
		}
		function concat(a, b) {
			return "" + a + b;
		}
		function equal(a, b) {
			return a == b;
		}
		function notEqual(a, b) {
			return a != b;
		}
		function greaterThan(a, b) {
			return a > b;
		}
		function lessThan(a, b) {
			return a < b;
		}
		function greaterThanEqual(a, b) {
			return a >= b;
		}
		function lessThanEqual(a, b) {
			return a <= b;
		}
		function andOperator(a, b) {
			return Boolean(a && b);
		}
		function orOperator(a, b) {
			return Boolean(a || b);
		}
		function sinh(a) {
			return Math.sinh ? Math.sinh(a) : ((Math.exp(a) - Math.exp(-a)) / 2);
		}
		function cosh(a) {
			return Math.cosh ? Math.cosh(a) : ((Math.exp(a) + Math.exp(-a)) / 2);
		}
		function tanh(a) {
			if (Math.tanh) return Math.tanh(a);
			if(a === Infinity) return 1;
			if(a === -Infinity) return -1;
			return (Math.exp(a) - Math.exp(-a)) / (Math.exp(a) + Math.exp(-a));
		}
		function asinh(a) {
			if (Math.asinh) return Math.asinh(a);
			if(a === -Infinity) return a;
			return Math.log(a + Math.sqrt(a * a + 1));
		}
		function acosh(a) {
			return Math.acosh ? Math.acosh(a) : Math.log(a + Math.sqrt(a * a - 1));
		}
		function atanh(a) {
			return Math.atanh ? Math.atanh(a) : (Math.log((1+a)/(1-a)) / 2);
		}
		function log10(a) {
		      return Math.log(a) * Math.LOG10E;
		}
		function neg(a) {
			return -a;
		}
		function trunc(a) {
			if(Math.trunc) return Math.trunc(a);
			else return a < 0 ? Math.ceil(a) : Math.floor(a);
		}
		function random(a) {
			return Math.random() * (a || 1);
		}
		function fac(a) { //a!
			a = Math.floor(a);
			var b = a;
			while (a > 1) {
				b = b * (--a);
			}
			return b;
		}

		function hypot() {
			if(Math.hypot) return Math.hypot.apply(this, arguments);
			var y = 0;
			var length = arguments.length;
			for (var i = 0; i < length; i++) {
				if (arguments[i] === Infinity || arguments[i] === -Infinity) {
					return Infinity;
				}
				y += arguments[i] * arguments[i];
			}
			return Math.sqrt(y);
		}

		function condition(cond, yep, nope) {
			return cond ? yep : nope;
		}

		function append(a, b) {
			if (Object.prototype.toString.call(a) != "[object Array]") {
				return [a, b];
			}
			a = a.slice();
			a.push(b);
			return a;
		}

		function Parser() {
			this.success = false;
			this.errormsg = "";
			this.expression = "";

			this.pos = 0;

			this.tokennumber = 0;
			this.tokenprio = 0;
			this.tokenindex = 0;
			this.tmpprio = 0;

			this.ops1 = {
				"sin": Math.sin,
				"cos": Math.cos,
				"tan": Math.tan,
				"asin": Math.asin,
				"acos": Math.acos,
				"atan": Math.atan,
				"sinh": sinh,
				"cosh": cosh,
				"tanh": tanh,
				"asinh": asinh,
				"acosh": acosh,
				"atanh": atanh,
				"sqrt": Math.sqrt,
				"log": Math.log,
				"lg" : log10,
				"log10" : log10,
				"abs": Math.abs,
				"ceil": Math.ceil,
				"floor": Math.floor,
				"round": Math.round,
				"trunc": trunc,
				"-": neg,
				"exp": Math.exp
			};

			this.ops2 = {
				"+": add,
				"-": sub,
				"*": mul,
				"/": div,
				"%": mod,
				"^": Math.pow,
				",": append,
				"||": concat,
				"==": equal,
				"!=": notEqual,
				">": greaterThan,
				"<": lessThan,
				">=": greaterThanEqual,
				"<=": lessThanEqual,
				"and": andOperator,
				"or": orOperator
			};

			this.functions = {
				"random": random,
				"fac": fac,
				"min": Math.min,
				"max": Math.max,
				"hypot": hypot,
				"pyt": hypot, // backward compat
				"pow": Math.pow,
				"atan2": Math.atan2,
				"if": condition
			};

			this.consts = {
				"E": Math.E,
				"PI": Math.PI
			};
		}

		Parser.parse = function (expr) {
			return new Parser().parse(expr);
		};

		Parser.evaluate = function (expr, variables) {
			return Parser.parse(expr).evaluate(variables);
		};

		Parser.Expression = Expression;

		Parser.values = {
			sin: Math.sin,
			cos: Math.cos,
			tan: Math.tan,
			asin: Math.asin,
			acos: Math.acos,
			atan: Math.atan,
			sinh: sinh,
			cosh: cosh,
			tanh: tanh,
			asinh: asinh,
			acosh: acosh,
			atanh: atanh,
			sqrt: Math.sqrt,
			log: Math.log,
			lg: log10,
			log10: log10,
			abs: Math.abs,
			ceil: Math.ceil,
			floor: Math.floor,
			round: Math.round,
			trunc: trunc,
			random: random,
			fac: fac,
			exp: Math.exp,
			min: Math.min,
			max: Math.max,
			hypot: hypot,
			pyt: hypot, // backward compat
			pow: Math.pow,
			atan2: Math.atan2,
			"if": condition,
			E: Math.E,
			PI: Math.PI
		};

		var PRIMARY      = 1 << 0;
		var OPERATOR     = 1 << 1;
		var FUNCTION     = 1 << 2;
		var LPAREN       = 1 << 3;
		var RPAREN       = 1 << 4;
		var COMMA        = 1 << 5;
		var SIGN         = 1 << 6;
		var CALL         = 1 << 7;
		var NULLARY_CALL = 1 << 8;

		Parser.prototype = {
			parse: function (expr) {
				this.errormsg = "";
				this.success = true;
				var operstack = [];
				var tokenstack = [];
				this.tmpprio = 0;
				var expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
				var noperators = 0;
				this.expression = expr;
				this.pos = 0;

				while (this.pos < this.expression.length) {
					if (this.isOperator()) {
						if (this.isSign() && (expected & SIGN)) {
							if (this.isNegativeSign()) {
								this.tokenprio = 2;
								this.tokenindex = "-";
								noperators++;
								this.addfunc(tokenstack, operstack, TOP1);
							}
							expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
						}
						else if (this.isComment()) {

						}
						else {
							if ((expected & OPERATOR) === 0) {
								this.error_parsing(this.pos, "unexpected operator");
							}
							noperators += 2;
							this.addfunc(tokenstack, operstack, TOP2);
							expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
						}
					}
					else if (this.isNumber()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected number");
						}
						var token = new Token(TNUMBER, 0, 0, this.tokennumber);
						tokenstack.push(token);

						expected = (OPERATOR | RPAREN | COMMA);
					}
					else if (this.isString()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected string");
						}
						var token = new Token(TNUMBER, 0, 0, this.tokennumber);
						tokenstack.push(token);

						expected = (OPERATOR | RPAREN | COMMA);
					}
					else if (this.isLeftParenth()) {
						if ((expected & LPAREN) === 0) {
							this.error_parsing(this.pos, "unexpected \"(\"");
						}

						if (expected & CALL) {
							noperators += 2;
							this.tokenprio = -2;
							this.tokenindex = -1;
							this.addfunc(tokenstack, operstack, TFUNCALL);
						}

						expected = (PRIMARY | LPAREN | FUNCTION | SIGN | NULLARY_CALL);
					}
					else if (this.isRightParenth()) {
					    if (expected & NULLARY_CALL) {
							var token = new Token(TNUMBER, 0, 0, []);
							tokenstack.push(token);
						}
						else if ((expected & RPAREN) === 0) {
							this.error_parsing(this.pos, "unexpected \")\"");
						}

						expected = (OPERATOR | RPAREN | COMMA | LPAREN | CALL);
					}
					else if (this.isComma()) {
						if ((expected & COMMA) === 0) {
							this.error_parsing(this.pos, "unexpected \",\"");
						}
						this.addfunc(tokenstack, operstack, TOP2);
						noperators += 2;
						expected = (PRIMARY | LPAREN | FUNCTION | SIGN);
					}
					else if (this.isConst()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected constant");
						}
						var consttoken = new Token(TNUMBER, 0, 0, this.tokennumber);
						tokenstack.push(consttoken);
						expected = (OPERATOR | RPAREN | COMMA);
					}
					else if (this.isOp2()) {
						if ((expected & FUNCTION) === 0) {
							this.error_parsing(this.pos, "unexpected function");
						}
						this.addfunc(tokenstack, operstack, TOP2);
						noperators += 2;
						expected = (LPAREN);
					}
					else if (this.isOp1()) {
						if ((expected & FUNCTION) === 0) {
							this.error_parsing(this.pos, "unexpected function");
						}
						this.addfunc(tokenstack, operstack, TOP1);
						noperators++;
						expected = (LPAREN);
					}
					else if (this.isVar()) {
						if ((expected & PRIMARY) === 0) {
							this.error_parsing(this.pos, "unexpected variable");
						}
						var vartoken = new Token(TVAR, this.tokenindex, 0, 0);
						tokenstack.push(vartoken);

						expected = (OPERATOR | RPAREN | COMMA | LPAREN | CALL);
					}
					else if (this.isWhite()) {
					}
					else {
						if (this.errormsg === "") {
							this.error_parsing(this.pos, "unknown character");
						}
						else {
							this.error_parsing(this.pos, this.errormsg);
						}
					}
				}
				if (this.tmpprio < 0 || this.tmpprio >= 10) {
					this.error_parsing(this.pos, "unmatched \"()\"");
				}
				while (operstack.length > 0) {
					var tmp = operstack.pop();
					tokenstack.push(tmp);
				}
				if (noperators + 1 !== tokenstack.length) {
					//print(noperators + 1);
					//print(tokenstack);
					this.error_parsing(this.pos, "parity");
				}

				return new Expression(tokenstack, object(this.ops1), object(this.ops2), object(this.functions));
			},

			evaluate: function (expr, variables) {
				return this.parse(expr).evaluate(variables);
			},

			error_parsing: function (column, msg) {
				this.success = false;
				this.errormsg = "parse error [column " + (column) + "]: " + msg;
				this.column = column;
				throw new Error(this.errormsg);
			},

	//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\

			addfunc: function (tokenstack, operstack, type_) {
				var operator = new Token(type_, this.tokenindex, this.tokenprio + this.tmpprio, 0);
				while (operstack.length > 0) {
					if (operator.prio_ <= operstack[operstack.length - 1].prio_) {
						tokenstack.push(operstack.pop());
					}
					else {
						break;
					}
				}
				operstack.push(operator);
			},

			isNumber: function () {
				var r = false;
				var str = "";
				while (this.pos < this.expression.length) {
					var code = this.expression.charCodeAt(this.pos);
					if ((code >= 48 && code <= 57) || code === 46) {
						str += this.expression.charAt(this.pos);
						this.pos++;
						this.tokennumber = parseFloat(str);
						r = true;
					}
					else {
						break;
					}
				}
				return r;
			},

			// Ported from the yajjl JSON parser at http://code.google.com/p/yajjl/
			unescape: function(v, pos) {
				var buffer = [];
				var escaping = false;

				for (var i = 0; i < v.length; i++) {
					var c = v.charAt(i);

					if (escaping) {
						switch (c) {
						case "'":
							buffer.push("'");
							break;
						case '\\':
							buffer.push('\\');
							break;
						case '/':
							buffer.push('/');
							break;
						case 'b':
							buffer.push('\b');
							break;
						case 'f':
							buffer.push('\f');
							break;
						case 'n':
							buffer.push('\n');
							break;
						case 'r':
							buffer.push('\r');
							break;
						case 't':
							buffer.push('\t');
							break;
						case 'u':
							// interpret the following 4 characters as the hex of the unicode code point
							var codePoint = parseInt(v.substring(i + 1, i + 5), 16);
							buffer.push(String.fromCharCode(codePoint));
							i += 4;
							break;
						default:
							throw this.error_parsing(pos + i, "Illegal escape sequence: '\\" + c + "'");
						}
						escaping = false;
					} else {
						if (c == '\\') {
							escaping = true;
						} else {
							buffer.push(c);
						}
					}
				}

				return buffer.join('');
			},

			isString: function () {
				var r = false;
				var str = "";
				var startpos = this.pos;
				if (this.pos < this.expression.length && this.expression.charAt(this.pos) == "'") {
					this.pos++;
					while (this.pos < this.expression.length) {
						var code = this.expression.charAt(this.pos);
						if (code != "'" || str.slice(-1) == "\\") {
							str += this.expression.charAt(this.pos);
							this.pos++;
						}
						else {
							this.pos++;
							this.tokennumber = this.unescape(str, startpos);
							r = true;
							break;
						}
					}
				}
				return r;
			},

			isConst: function () {
				var str;
				for (var i in this.consts) {
					if (true) {
						var L = i.length;
						str = this.expression.substr(this.pos, L);
						if (i === str) {
							this.tokennumber = this.consts[i];
							this.pos += L;
							return true;
						}
					}
				}
				return false;
			},

			isOperator: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 43) { // +
					this.tokenprio = 2;
					this.tokenindex = "+";
				}
				else if (code === 45) { // -
					this.tokenprio = 2;
					this.tokenindex = "-";
				}
				else if (code === 62) { // >
					if (this.expression.charCodeAt(this.pos + 1) === 61) {
						this.pos++;
						this.tokenprio = 1;
						this.tokenindex = ">=";
					} else {
						this.tokenprio = 1;
						this.tokenindex = ">";
					}
				}
				else if (code === 60) { // <
					if (this.expression.charCodeAt(this.pos + 1) === 61) {
						this.pos++;
						this.tokenprio = 1;
						this.tokenindex = "<=";
					} else {
						this.tokenprio = 1;
						this.tokenindex = "<";
					}
				}
				else if (code === 124) { // |
					if (this.expression.charCodeAt(this.pos + 1) === 124) {
						this.pos++;
						this.tokenprio = 1;
						this.tokenindex = "||";
					}
					else {
						return false;
					}
				}
				else if (code === 61) { // =
					if (this.expression.charCodeAt(this.pos + 1) === 61) {
						this.pos++;
						this.tokenprio = 1;
						this.tokenindex = "==";
					}
					else {
						return false;
					}
				}
				else if (code === 33) { // !
					if (this.expression.charCodeAt(this.pos + 1) === 61) {
						this.pos++;
						this.tokenprio = 1;
						this.tokenindex = "!=";
					}
					else {
						return false;
					}
				}
				else if (code === 97) { // a
					if (this.expression.charCodeAt(this.pos + 1) === 110 && this.expression.charCodeAt(this.pos + 2) === 100) { // n && d
						this.pos++;
						this.pos++;
						this.tokenprio = 0;
						this.tokenindex = "and";
					}
					else {
						return false;
					}
				}
				else if (code === 111) { // o
					if (this.expression.charCodeAt(this.pos + 1) === 114) { // r
						this.pos++;
						this.tokenprio = 0;
						this.tokenindex = "or";
					}
					else {
						return false;
					}
				}
				else if (code === 42 || code === 8729 || code === 8226) { // * or ∙ or •
					this.tokenprio = 3;
					this.tokenindex = "*";
				}
				else if (code === 47) { // /
					this.tokenprio = 4;
					this.tokenindex = "/";
				}
				else if (code === 37) { // %
					this.tokenprio = 4;
					this.tokenindex = "%";
				}
				else if (code === 94) { // ^
					this.tokenprio = 5;
					this.tokenindex = "^";
				}
				else {
					return false;
				}
				this.pos++;
				return true;
			},

			isSign: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 45 || code === 43) { // -
					return true;
				}
				return false;
			},

			isPositiveSign: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 43) { // +
					return true;
				}
				return false;
			},

			isNegativeSign: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 45) { // -
					return true;
				}
				return false;
			},

			isLeftParenth: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 40) { // (
					this.pos++;
					this.tmpprio += 10;
					return true;
				}
				return false;
			},

			isRightParenth: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 41) { // )
					this.pos++;
					this.tmpprio -= 10;
					return true;
				}
				return false;
			},

			isComma: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 44) { // ,
					this.pos++;
					this.tokenprio = -1;
					this.tokenindex = ",";
					return true;
				}
				return false;
			},

			isWhite: function () {
				var code = this.expression.charCodeAt(this.pos);
				if (code === 32 || code === 9 || code === 10 || code === 13) {
					this.pos++;
					return true;
				}
				return false;
			},

			isOp1: function () {
				var str = "";
				for (var i = this.pos; i < this.expression.length; i++) {
					var c = this.expression.charAt(i);
					if (c.toUpperCase() === c.toLowerCase()) {
						if (i === this.pos || (c != '_' && (c < '0' || c > '9'))) {
							break;
						}
					}
					str += c;
				}
				if (str.length > 0 && (str in this.ops1)) {
					this.tokenindex = str;
					this.tokenprio = 5;
					this.pos += str.length;
					return true;
				}
				return false;
			},

			isOp2: function () {
				var str = "";
				for (var i = this.pos; i < this.expression.length; i++) {
					var c = this.expression.charAt(i);
					if (c.toUpperCase() === c.toLowerCase()) {
						if (i === this.pos || (c != '_' && (c < '0' || c > '9'))) {
							break;
						}
					}
					str += c;
				}
				if (str.length > 0 && (str in this.ops2)) {
					this.tokenindex = str;
					this.tokenprio = 5;
					this.pos += str.length;
					return true;
				}
				return false;
			},

			isVar: function () {
				var str = "";
				for (var i = this.pos; i < this.expression.length; i++) {
					var c = this.expression.charAt(i);
					if (c.toUpperCase() === c.toLowerCase()) {
						if (i === this.pos || (c != '_' && c != '.' && (c < '0' || c > '9'))) {
							break;
						}
					}
					str += c;
				}
				if (str.length > 0) {
					this.tokenindex = str;
					this.tokenprio = 4;
					this.pos += str.length;
					return true;
				}
				return false;
			},

			isComment: function () {
				var code = this.expression.charCodeAt(this.pos - 1);
				if (code === 47 && this.expression.charCodeAt(this.pos) === 42) {
					this.pos = this.expression.indexOf("*/", this.pos) + 2;
					if (this.pos === 1) {
						this.pos = this.expression.length;
					}
					return true;
				}
				return false;
			}
		};

		scope.Parser = Parser;
		return Parser
	})( false ? {} : exports);

/***/ },
/* 186 */
/***/ function(module, exports) {

	/* ============================================================
	 * bootstrap-dropdown.js v2.3.2
	 * http://getbootstrap.com/2.3.2/javascript.html#dropdowns
	 * ============================================================
	 * Copyright 2013 Twitter, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ============================================================ */

	module.exports = function($) {
	(function () {

	  "use strict"; // jshint ;_;


	 /* DROPDOWN CLASS DEFINITION
	  * ========================= */

	  var toggle = '[data-toggle=dropdown]'
	    , Dropdown = function (element) {
	        var $el = $(element).on('click.dropdown.data-api', this.toggle)
	        $('html').on('click.dropdown.data-api', function () {
	          $el.parent().removeClass('open')
	        })
	      }

	  Dropdown.prototype = {

	    constructor: Dropdown

	  , toggle: function (e) {
	      var $this = $(this)
	        , $parent
	        , isActive

	      if ($this.is('.disabled, :disabled')) return

	      $parent = getParent($this)

	      isActive = $parent.hasClass('open')

	      clearMenus()

	      if (!isActive) {
	        if ('ontouchstart' in document.documentElement) {
	          // if mobile we we use a backdrop because click events don't delegate
	          $('<div class="dropdown-backdrop"/>').insertBefore($(this)).on('click', clearMenus)
	        }
	        $parent.toggleClass('open')
	      }

	      $this.focus()

	      return false
	    }

	  , keydown: function (e) {
	      var $this
	        , $items
	        , $active
	        , $parent
	        , isActive
	        , index

	      if (!/(38|40|27)/.test(e.keyCode)) return

	      $this = $(this)

	      e.preventDefault()
	      e.stopPropagation()

	      if ($this.is('.disabled, :disabled')) return

	      $parent = getParent($this)

	      isActive = $parent.hasClass('open')

	      if (!isActive || (isActive && e.keyCode == 27)) {
	        if (e.which == 27) $parent.find(toggle).focus()
	        return $this.click()
	      }

	      $items = $('[role=menu] li:not(.divider):visible a', $parent)

	      if (!$items.length) return

	      index = $items.index($items.filter(':focus'))

	      if (e.keyCode == 38 && index > 0) index--                                        // up
	      if (e.keyCode == 40 && index < $items.length - 1) index++                        // down
	      if (!~index) index = 0

	      $items
	        .eq(index)
	        .focus()
	    }

	  }

	  function clearMenus() {
	    $('.dropdown-backdrop').remove()
	    $(toggle).each(function () {
	      getParent($(this)).removeClass('open')
	    })
	  }

	  function getParent($this) {
	    var selector = $this.attr('data-target')
	      , $parent

	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') //strip for ie7
	    }

	    $parent = selector && $(selector)

	    if (!$parent || !$parent.length) $parent = $this.parent()

	    return $parent
	  }


	  /* DROPDOWN PLUGIN DEFINITION
	   * ========================== */

	  var old = $.fn.dropdown

	  $.fn.jsrDropdown = function (option) {
	    return this.each(function () {
	      var $this = $(this)
	        , data = $this.data('dropdown')
	      if (!data) $this.data('dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }

	  $.fn.jsrDropdown.Constructor = Dropdown


	 /* DROPDOWN NO CONFLICT
	  * ==================== */

	  $.fn.jsrDropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }


	  /* APPLY TO STANDARD DROPDOWN ELEMENTS
	   * =================================== */

	  // $(document)
	  //   .on('click.dropdown.data-api', clearMenus)
	  //   .on('click.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	  //   .on('click.dropdown.data-api'  , toggle, Dropdown.prototype.toggle)
	  //   .on('keydown.dropdown.data-api', toggle + ', [role=menu]' , Dropdown.prototype.keydown)

	}());
	};

/***/ },
/* 187 */
/***/ function(module, exports) {

	/* ssf.js (C) 2013-2014 SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	var SSF = {};
	var make_ssf = function make_ssf(SSF){
	SSF.version = '0.8.2';
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	function isgeneral(s, i) { return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	/* Options */
	var opts_fmt = [
	  ["date1904", 0],
	  ["output", ""],
	  ["WTF", false]
	];
	function fixopts(o){
	  for(var y = 0; y != opts_fmt.length; ++y) if(o[opts_fmt[y][0]]===undefined) o[opts_fmt[y][0]]=opts_fmt[y][1];
	}
	SSF.opts = opts_fmt;
	var table_fmt = {
	  0:  'General',
	  1:  '0',
	  2:  '0.00',
	  3:  '#,##0',
	  4:  '#,##0.00',
	  9:  '0%',
	  10: '0.00%',
	  11: '0.00E+00',
	  12: '# ?/?',
	  13: '# ??/??',
	  14: 'm/d/yy',
	  15: 'd-mmm-yy',
	  16: 'd-mmm',
	  17: 'mmm-yy',
	  18: 'h:mm AM/PM',
	  19: 'h:mm:ss AM/PM',
	  20: 'h:mm',
	  21: 'h:mm:ss',
	  22: 'm/d/yy h:mm',
	  37: '#,##0 ;(#,##0)',
	  38: '#,##0 ;[Red](#,##0)',
	  39: '#,##0.00;(#,##0.00)',
	  40: '#,##0.00;[Red](#,##0.00)',
	  45: 'mm:ss',
	  46: '[h]:mm:ss',
	  47: 'mmss.0',
	  48: '##0.0E+0',
	  49: '@',
	  56: '"上午/下午 "hh"時"mm"分"ss"秒 "',
	  65535: 'General'
	};
	var days = [
	  ['Sun', 'Sunday'],
	  ['Mon', 'Monday'],
	  ['Tue', 'Tuesday'],
	  ['Wed', 'Wednesday'],
	  ['Thu', 'Thursday'],
	  ['Fri', 'Friday'],
	  ['Sat', 'Saturday']
	];
	var months = [
	  ['J', 'Jan', 'January'],
	  ['F', 'Feb', 'February'],
	  ['M', 'Mar', 'March'],
	  ['A', 'Apr', 'April'],
	  ['M', 'May', 'May'],
	  ['J', 'Jun', 'June'],
	  ['J', 'Jul', 'July'],
	  ['A', 'Aug', 'August'],
	  ['S', 'Sep', 'September'],
	  ['O', 'Oct', 'October'],
	  ['N', 'Nov', 'November'],
	  ['D', 'Dec', 'December']
	];
	function frac(x, D, mixed) {
	  var sgn = x < 0 ? -1 : 1;
	  var B = x * sgn;
	  var P_2 = 0, P_1 = 1, P = 0;
	  var Q_2 = 1, Q_1 = 0, Q = 0;
	  var A = Math.floor(B);
	  while(Q_1 < D) {
	    A = Math.floor(B);
	    P = A * P_1 + P_2;
	    Q = A * Q_1 + Q_2;
	    if((B - A) < 0.0000000005) break;
	    B = 1 / (B - A);
	    P_2 = P_1; P_1 = P;
	    Q_2 = Q_1; Q_1 = Q;
	  }
	  if(Q > D) { Q = Q_1; P = P_1; }
	  if(Q > D) { Q = Q_2; P = P_2; }
	  if(!mixed) return [0, sgn * P, Q];
	  if(Q===0) throw "Unexpected state: "+P+" "+P_1+" "+P_2+" "+Q+" "+Q_1+" "+Q_2;
	  var q = Math.floor(sgn * P/Q);
	  return [q, sgn*P - q*Q, Q];
	}
	function general_fmt_int(v, opts) { return ""+v; }
	SSF._general_int = general_fmt_int;
	var general_fmt_num = (function make_general_fmt_num() {
	var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/;
	function gfn2(v) {
	  var w = (v<0?12:11);
	  var o = gfn5(v.toFixed(12)); if(o.length <= w) return o;
	  o = v.toPrecision(10); if(o.length <= w) return o;
	  return v.toExponential(5);
	}
	function gfn3(v) {
	  var o = v.toFixed(11).replace(gnr1,".$1");
	  if(o.length > (v<0?12:11)) o = v.toPrecision(6);
	  return o;
	}
	function gfn4(o) {
	  for(var i = 0; i != o.length; ++i) if((o.charCodeAt(i) | 0x20) === 101) return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");
	  return o;
	}
	function gfn5(o) {
	  //for(var i = 0; i != o.length; ++i) if(o.charCodeAt(i) === 46) return o.replace(gnr2,"").replace(gnr1,".$1");
	  //return o;
	  return o.indexOf(".") > -1 ? o.replace(gnr2,"").replace(gnr1,".$1") : o;
	}
	return function general_fmt_num(v, opts) {
	  var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	  if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
	  else if(Math.abs(V) <= 9) o = gfn2(v);
	  else if(V === 10) o = v.toFixed(10).substr(0,12);
	  else o = gfn3(v);
	  return gfn5(gfn4(o));
	};})();
	SSF._general_num = general_fmt_num;
	function general_fmt(v, opts) {
	  switch(typeof v) {
	    case 'string': return v;
	    case 'boolean': return v ? "TRUE" : "FALSE";
	    case 'number': return (v|0) === v ? general_fmt_int(v, opts) : general_fmt_num(v, opts);
	  }
	  throw new Error("unsupported value in General format: " + v);
	}
	SSF._general = general_fmt;
	function fix_hijri(date, o) { return 0; }
	function parse_date_code(v,opts,b2) {
	  if(v > 2958465 || v < 0) return null;
	  var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
	  var dout=[];
	  var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
	  if(Math.abs(out.u) < 1e-6) out.u = 0;
	  fixopts(opts != null ? opts : (opts=[]));
	  if(opts.date1904) date += 1462;
	  if(out.u > 0.999) {
	    out.u = 0;
	    if(++time == 86400) { time = 0; ++date; }
	  }
	  if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
	  else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
	  else {
	    if(date > 60) --date;
	    /* 1 = Jan 1 1900 */
	    var d = new Date(1900,0,1);
	    d.setDate(d.getDate() + date - 1);
	    dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
	    dow = d.getDay();
	    if(date < 60) dow = (dow + 6) % 7;
	    if(b2) dow = fix_hijri(d, dout);
	  }
	  out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
	  out.S = time % 60; time = Math.floor(time / 60);
	  out.M = time % 60; time = Math.floor(time / 60);
	  out.H = time;
	  out.q = dow;
	  return out;
	}
	SSF.parse_date_code = parse_date_code;
	/*jshint -W086 */
	function write_date(type, fmt, val, ss0) {
	  var o="", ss=0, tt=0, y = val.y, out, outl = 0;
	  switch(type) {
	    case 98: /* 'b' buddhist year */
	      y = val.y + 543;
	      /* falls through */
	    case 121: /* 'y' year */
	    switch(fmt.length) {
	      case 1: case 2: out = y % 100; outl = 2; break;
	      default: out = y % 10000; outl = 4; break;
	    } break;
	    case 109: /* 'm' month */
	    switch(fmt.length) {
	      case 1: case 2: out = val.m; outl = fmt.length; break;
	      case 3: return months[val.m-1][1];
	      case 5: return months[val.m-1][0];
	      default: return months[val.m-1][2];
	    } break;
	    case 100: /* 'd' day */
	    switch(fmt.length) {
	      case 1: case 2: out = val.d; outl = fmt.length; break;
	      case 3: return days[val.q][0];
	      default: return days[val.q][1];
	    } break;
	    case 104: /* 'h' 12-hour */
	    switch(fmt.length) {
	      case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
	      default: throw 'bad hour format: ' + fmt;
	    } break;
	    case 72: /* 'H' 24-hour */
	    switch(fmt.length) {
	      case 1: case 2: out = val.H; outl = fmt.length; break;
	      default: throw 'bad hour format: ' + fmt;
	    } break;
	    case 77: /* 'M' minutes */
	    switch(fmt.length) {
	      case 1: case 2: out = val.M; outl = fmt.length; break;
	      default: throw 'bad minute format: ' + fmt;
	    } break;
	    case 115: /* 's' seconds */
	    if(val.u === 0) switch(fmt) {
	      case 's': case 'ss': return pad0(val.S, fmt.length);
	      case '.0': case '.00': case '.000':
	    }
	    switch(fmt) {
	      case 's': case 'ss': case '.0': case '.00': case '.000':
	        if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
	        else tt = ss0 === 1 ? 10 : 1;
	        ss = Math.round((tt)*(val.S + val.u));
	        if(ss >= 60*tt) ss = 0;
	        if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
	        o = pad0(ss,2 + ss0);
	        if(fmt === 'ss') return o.substr(0,2);
	        return "." + o.substr(2,fmt.length-1);
	      default: throw 'bad second format: ' + fmt;
	    }
	    case 90: /* 'Z' absolute time */
	    switch(fmt) {
	      case '[h]': case '[hh]': out = val.D*24+val.H; break;
	      case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
	      case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
	      default: throw 'bad abstime format: ' + fmt;
	    } outl = fmt.length === 3 ? 1 : 2; break;
	    case 101: /* 'e' era */
	      out = y; outl = 1;
	  }
	  if(outl > 0) return pad0(out, outl); else return "";
	}
	/*jshint +W086 */
	function commaify(s) {
	  if(s.length <= 3) return s;
	  var j = (s.length % 3), o = s.substr(0,j);
	  for(; j!=s.length; j+=3) o+=(o.length > 0 ? "," : "") + s.substr(j,3);
	  return o;
	}
	var write_num = (function make_write_num(){
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
	  var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	  return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_cm(type, fmt, val){
	  var idx = fmt.length - 1;
	  while(fmt.charCodeAt(idx-1) === 44) --idx;
	  return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_exp(fmt, val){
	  var o;
	  var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	  if(fmt.match(/^#+0.0E\+0$/)) {
	    var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
	    var ee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E)%period;
	    if(ee < 0) ee += period;
	    o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
	    if(o.indexOf("e") === -1) {
	      var fakee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E);
	      if(o.indexOf(".") === -1) o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
	      else o += "E+" + (fakee - ee);
	      while(o.substr(0,2) === "0.") {
	        o = o[0] + o.substr(2,period) + "." + o.substr(2+period);
	        o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
	      }
	      o = o.replace(/\+-/,"-");
	    }
	    o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	  } else o = val.toExponential(idx);
	  if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o[o.length-1];
	  if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	  return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
	  var den = parseInt(r[4]), rr = Math.round(aval * den), base = Math.floor(rr/den);
	  var myn = (rr - base*den), myd = den;
	  return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
	  return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.(0+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
	  var o = "", cc;
	  for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
	    case 35: break;
	    case 63: o+= " "; break;
	    case 48: o+= "0"; break;
	    default: o+= String.fromCharCode(cc);
	  }
	  return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) { return Math.round((val-Math.floor(val))*Math.pow(10,d)); }
	function flr(val) { if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0)); return ""+Math.floor(val); }
	function write_num_flt(type, fmt, val) {
	  if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
	    var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
	    if(val >= 0) return write_num_flt('n', ffmt, val);
	    return '(' + write_num_flt('n', ffmt, -val) + ')';
	  }
	  if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
	  if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
	  if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
	  if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt[1]==' '?2:1),val);
	  var o, oo;
	  var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	  if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
	  if(fmt.match(/^[#?]+$/)) {
	    o = pad0r(val,0); if(o === "0") o = "";
	    return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	  }
	  if((r = fmt.match(frac1)) !== null) return write_num_f1(r, aval, sign);
	  if(fmt.match(/^#+0+$/) !== null) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
	  if((r = fmt.match(dec1)) !== null) {
	    o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+r[1]).replace(/\.$/,"."+r[1]).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", r[1].length-$1.length); });
	    return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	  }
	  fmt = fmt.replace(/^#+([0.])/, "$1");
	  if((r = fmt.match(/^(0*)\.(#*)$/)) !== null) {
	    return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	  }
	  if((r = fmt.match(/^#,##0(\.?)$/)) !== null) return sign + commaify(pad0r(aval,0));
	  if((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) {
	    return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val))) + "." + pad0(dec(val, r[1].length),r[1].length);
	  }
	  if((r = fmt.match(/^#,#*,#0/)) !== null) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
	  if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) {
	    o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
	    ri = 0;
	    return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o[ri++]:x==='0'?'0':"";}));
	  }
	  if(fmt.match(phone) !== null) {
	    o = write_num_flt(type, "##########", val);
	    return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	  }
	  var oa = "";
	  if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
	    ri = Math.min(r[4].length,7);
	    ff = frac(aval, Math.pow(10,ri)-1, false);
	    o = "" + sign;
	    oa = write_num("n", r[1], ff[1]);
	    if(oa[oa.length-1] == " ") oa = oa.substr(0,oa.length-1) + "0";
	    o += oa + r[2] + "/" + r[3];
	    oa = rpad_(ff[2],ri);
	    if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
	    o += oa;
	    return o;
	  }
	  if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
	    ri = Math.min(Math.max(r[1].length, r[4].length),7);
	    ff = frac(aval, Math.pow(10,ri)-1, true);
	    return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	  }
	  if((r = fmt.match(/^[#0?]+$/)) !== null) {
	    o = pad0r(val, 0);
	    if(fmt.length <= o.length) return o;
	    return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	  }
	  if((r = fmt.match(/^([#0?]+)\.([#0]+)$/)) !== null) {
	    o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
	    ri = o.indexOf(".");
	    var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
	    return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	  }
	  if((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) {
	    ri = dec(val, r[1].length);
	    return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
	  }
	  switch(fmt) {
	    case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
	    default:
	  }
	  throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
	  var idx = fmt.length - 1;
	  while(fmt.charCodeAt(idx-1) === 44) --idx;
	  return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
	  var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
	  return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
	  var o;
	  var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
	  if(fmt.match(/^#+0.0E\+0$/)) {
	    var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
	    var ee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E)%period;
	    if(ee < 0) ee += period;
	    o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
	    if(!o.match(/[Ee]/)) {
	      var fakee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E);
	      if(o.indexOf(".") === -1) o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
	      else o += "E+" + (fakee - ee);
	      o = o.replace(/\+-/,"-");
	    }
	    o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
	  } else o = val.toExponential(idx);
	  if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o[o.length-1];
	  if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
	  return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
	  if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
	    var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
	    if(val >= 0) return write_num_int('n', ffmt, val);
	    return '(' + write_num_int('n', ffmt, -val) + ')';
	  }
	  if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
	  if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
	  if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
	  if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt[1]==' '?2:1),val);
	  var o;
	  var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
	  if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
	  if(fmt.match(/^[#?]+$/)) {
	    o = (""+val); if(val === 0) o = "";
	    return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
	  }
	  if((r = fmt.match(frac1)) !== null) return write_num_f2(r, aval, sign);
	  if(fmt.match(/^#+0+$/) !== null) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
	  if((r = fmt.match(dec1)) !== null) {
	    o = (""+val).replace(/^([^\.]+)$/,"$1."+r[1]).replace(/\.$/,"."+r[1]).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", r[1].length-$1.length); });
	    return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
	  }
	  fmt = fmt.replace(/^#+([0.])/, "$1");
	  if((r = fmt.match(/^(0*)\.(#*)$/)) !== null) {
	    return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
	  }
	  if((r = fmt.match(/^#,##0(\.?)$/)) !== null) return sign + commaify((""+aval));
	  if((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) {
	    return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
	  }
	  if((r = fmt.match(/^#,#*,#0/)) !== null) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
	  if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) {
	    o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
	    ri = 0;
	    return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o[ri++]:x==='0'?'0':"";}));
	  }
	  if(fmt.match(phone) !== null) {
	    o = write_num_int(type, "##########", val);
	    return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
	  }
	  var oa = "";
	  if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
	    ri = Math.min(r[4].length,7);
	    ff = frac(aval, Math.pow(10,ri)-1, false);
	    o = "" + sign;
	    oa = write_num("n", r[1], ff[1]);
	    if(oa[oa.length-1] == " ") oa = oa.substr(0,oa.length-1) + "0";
	    o += oa + r[2] + "/" + r[3];
	    oa = rpad_(ff[2],ri);
	    if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
	    o += oa;
	    return o;
	  }
	  if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
	    ri = Math.min(Math.max(r[1].length, r[4].length),7);
	    ff = frac(aval, Math.pow(10,ri)-1, true);
	    return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
	  }
	  if((r = fmt.match(/^[#0?]+$/)) !== null) {
	    o = "" + val;
	    if(fmt.length <= o.length) return o;
	    return hashq(fmt.substr(0,fmt.length-o.length)) + o;
	  }
	  if((r = fmt.match(/^([#0]+)\.([#0]+)$/)) !== null) {
	    o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
	    ri = o.indexOf(".");
	    var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
	    return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
	  }
	  if((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) {
	    return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
	  }
	  switch(fmt) {
	    case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
	    default:
	  }
	  throw new Error("unsupported format |" + fmt + "|");
	}
	return function write_num(type, fmt, val) {
	  return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	};})();
	function split_fmt(fmt) {
	  var out = [];
	  var in_str = false, cc;
	  for(var i = 0, j = 0; i < fmt.length; ++i) switch((cc=fmt.charCodeAt(i))) {
	    case 34: /* '"' */
	      in_str = !in_str; break;
	    case 95: case 42: case 92: /* '_' '*' '\\' */
	      ++i; break;
	    case 59: /* ';' */
	      out[out.length] = fmt.substr(j,i-j);
	      j = i+1;
	  }
	  out[out.length] = fmt.substr(j);
	  if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
	  return out;
	}
	SSF._split = split_fmt;
	var abstime = /\[[HhMmSs]*\]/;
	function eval_fmt(fmt, v, opts, flen) {
	  var out = [], o = "", i = 0, c = "", lst='t', q, dt, j, cc;
	  var hr='H';
	  /* Tokenize */
	  while(i < fmt.length) {
	    switch((c = fmt[i])) {
	      case 'G': /* General */
	        if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
	        out[out.length] = {t:'G', v:'General'}; i+=7; break;
	      case '"': /* Literal text */
	        for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
	        out[out.length] = {t:'t', v:o}; ++i; break;
	      case '\\': var w = fmt[++i], t = (w === "(" || w === ")") ? w : 't';
	        out[out.length] = {t:t, v:w}; ++i; break;
	      case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
	      case '@': /* Text Placeholder */
	        out[out.length] = {t:'T', v:v}; ++i; break;
	      case 'B': case 'b':
	        if(fmt[i+1] === "1" || fmt[i+1] === "2") {
	          if(dt==null) { dt=parse_date_code(v, opts, fmt[i+1] === "2"); if(dt==null) return ""; }
	          out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
	        }
	        /* falls through */
	      case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
	        c = c.toLowerCase();
	        /* falls through */
	      case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
	        if(v < 0) return "";
	        if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
	        o = c; while(++i<fmt.length && fmt[i].toLowerCase() === c) o+=c;
	        if(c === 'm' && lst.toLowerCase() === 'h') c = 'M'; /* m = minute */
	        if(c === 'h') c = hr;
	        out[out.length] = {t:c, v:o}; lst = c; break;
	      case 'A':
	        q={t:c, v:"A"};
	        if(dt==null) dt=parse_date_code(v, opts);
	        if(fmt.substr(i, 3) === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
	        else if(fmt.substr(i,5) === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
	        else { q.t = "t"; ++i; }
	        if(dt==null && q.t === 'T') return "";
	        out[out.length] = q; lst = c; break;
	      case '[':
	        o = c;
	        while(fmt[i++] !== ']' && i < fmt.length) o += fmt[i];
	        if(o.substr(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
	        if(o.match(abstime)) {
	          if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
	          out[out.length] = {t:'Z', v:o.toLowerCase()};
	        } else { o=""; }
	        break;
	      /* Numbers */
	      case '.':
	        if(dt != null) {
	          o = c; while((c=fmt[++i]) === "0") o += c;
	          out[out.length] = {t:'s', v:o}; break;
	        }
	        /* falls through */
	      case '0': case '#':
	        o = c; while("0#?.,E+-%".indexOf(c=fmt[++i]) > -1 || c=='\\' && fmt[i+1] == "-" && "0#".indexOf(fmt[i+2])>-1) o += c;
	        out[out.length] = {t:'n', v:o}; break;
	      case '?':
	        o = c; while(fmt[++i] === c) o+=c;
	        q={t:c, v:o}; out[out.length] = q; lst = c; break;
	      case '*': ++i; if(fmt[i] == ' ' || fmt[i] == '*') ++i; break; // **
	      case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
	      case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
	        o = c; while("0123456789".indexOf(fmt[++i]) > -1) o+=fmt[i];
	        out[out.length] = {t:'D', v:o}; break;
	      case ' ': out[out.length] = {t:c, v:c}; ++i; break;
	      default:
	        if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxz".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
	        out[out.length] = {t:'t', v:c}; ++i; break;
	    }
	  }
	  var bt = 0, ss0 = 0, ssm;
	  for(i=out.length-1, lst='t'; i >= 0; --i) {
	    switch(out[i].t) {
	      case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
	      case 's':
	        if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
	        if(bt < 3) bt = 3;
	      /* falls through */
	      case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
	      case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
	      case 'X': if(out[i].v === "B2");
	        break;
	      case 'Z':
	        if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
	        if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
	        if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
	    }
	  }
	  switch(bt) {
	    case 0: break;
	    case 1:
	      if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
	      if(dt.S >=  60) { dt.S = 0; ++dt.M; }
	      if(dt.M >=  60) { dt.M = 0; ++dt.H; }
	      break;
	    case 2:
	      if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
	      if(dt.S >=  60) { dt.S = 0; ++dt.M; }
	      break;
	  }
	  /* replace fields */
	  var nstr = "", jj;
	  for(i=0; i < out.length; ++i) {
	    switch(out[i].t) {
	      case 't': case 'T': case ' ': case 'D': break;
	      case 'X': out[i] = undefined; break;
	      case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	        out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
	        out[i].t = 't'; break;
	      case 'n': case '(': case '?':
	        jj = i+1;
	        while(out[jj] != null && (
	          (c=out[jj].t) === "?" || c === "D" ||
	          (c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/') ||
	          out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') ||
	          c === 't' && (out[jj].v === '/' || '$€'.indexOf(out[jj].v) > -1 || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?')
	        )) {
	          out[i].v += out[jj].v;
	          out[jj] = undefined; ++jj;
	        }
	        nstr += out[i].v;
	        i = jj-1; break;
	      case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
	    }
	  }
	  var vv = "", myv, ostr;
	  if(nstr.length > 0) {
	    myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v); /* '-' */
	    ostr = write_num(nstr.charCodeAt(0) === 40 ? '(' : 'n', nstr, myv); /* '(' */
	    jj=ostr.length-1;
	    var decpt = out.length;
	    for(i=0; i < out.length; ++i) if(out[i] != null && out[i].v.indexOf(".") > -1) { decpt = i; break; }
	    var lasti=out.length;
	    if(decpt === out.length && ostr.indexOf("E") === -1) {
	      for(i=out.length-1; i>= 0;--i) {
	        if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
	        if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
	        else if(jj < 0) out[i].v = "";
	        else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
	        out[i].t = 't';
	        lasti = i;
	      }
	      if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
	    }
	    else if(decpt !== out.length && ostr.indexOf("E") === -1) {
	      jj = ostr.indexOf(".")-1;
	      for(i=decpt; i>= 0; --i) {
	        if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
	        j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
	        vv = out[i].v.substr(j+1);
	        for(; j>=0; --j) {
	          if(jj>=0 && (out[i].v[j] === "0" || out[i].v[j] === "#")) vv = ostr[jj--] + vv;
	        }
	        out[i].v = vv;
	        out[i].t = 't';
	        lasti = i;
	      }
	      if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
	      jj = ostr.indexOf(".")+1;
	      for(i=decpt; i<out.length; ++i) {
	        if(out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt ) continue;
	        j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
	        vv = out[i].v.substr(0,j);
	        for(; j<out[i].v.length; ++j) {
	          if(jj<ostr.length) vv += ostr[jj++];
	        }
	        out[i].v = vv;
	        out[i].t = 't';
	        lasti = i;
	      }
	    }
	  }
	  for(i=0; i<out.length; ++i) if(out[i] != null && 'n(?'.indexOf(out[i].t)>-1) {
	    myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
	    out[i].v = write_num(out[i].t, out[i].v, myv);
	    out[i].t = 't';
	  }
	  var retval = "";
	  for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
	  return retval;
	}
	SSF._eval = eval_fmt;
	var cfregex = /\[[=<>]/;
	var cfregex2 = /\[([=<>]*)(-?\d+\.?\d*)\]/;
	function chkcond(v, rr) {
	  if(rr == null) return false;
	  var thresh = parseFloat(rr[2]);
	  switch(rr[1]) {
	    case "=":  if(v == thresh) return true; break;
	    case ">":  if(v >  thresh) return true; break;
	    case "<":  if(v <  thresh) return true; break;
	    case "<>": if(v != thresh) return true; break;
	    case ">=": if(v >= thresh) return true; break;
	    case "<=": if(v <= thresh) return true; break;
	  }
	  return false;
	}
	function choose_fmt(f, v) {
	  var fmt = split_fmt(f);
	  var l = fmt.length, lat = fmt[l-1].indexOf("@");
	  if(l<4 && lat>-1) --l;
	  if(fmt.length > 4) throw "cannot find right format for |" + fmt + "|";
	  if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
	  switch(fmt.length) {
	    case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
	    case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
	    case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
	    case 4: break;
	  }
	  var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
	  if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
	  if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
	    var m1 = fmt[0].match(cfregex2);
	    var m2 = fmt[1].match(cfregex2);
	    return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
	  }
	  return [l, ff];
	}
	function format(fmt,v,o) {
	  fixopts(o != null ? o : (o=[]));
	  var sfmt = "";
	  switch(typeof fmt) {
	    case "string": sfmt = fmt; break;
	    case "number": sfmt = (o.table != null ? o.table : table_fmt)[fmt]; break;
	  }
	  if(isgeneral(sfmt,0)) return general_fmt(v, o);
	  var f = choose_fmt(sfmt, v);
	  if(isgeneral(f[1])) return general_fmt(v, o);
	  if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
	  else if(v === "" || v == null) return "";
	  return eval_fmt(f[1], v, o, f[0]);
	}
	SSF._table = table_fmt;
	SSF.load = function load_entry(fmt, idx) { table_fmt[idx] = fmt; };
	SSF.format = format;
	SSF.get_table = function get_table() { return table_fmt; };
	SSF.load_table = function load_table(tbl) { for(var i=0; i!=0x0188; ++i) if(tbl[i] !== undefined) SSF.load(tbl[i], i); };
	};
	make_ssf(SSF);
	if(typeof module !== 'undefined' && typeof DO_NOT_EXPORT_SSF === 'undefined') module.exports = SSF;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */

	(function(root, undefined) {

		/* --- Setup --- */

		// Create the local library object, to be exported or referenced globally later
		var lib = {};

		// Current version
		lib.version = '0.4.1';


		/* --- Exposed settings --- */

		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};


		/* --- Internal Helper Methods --- */

		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;

		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}

		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}

		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}

		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}

		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;

			if (!obj) return results;

			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}

		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}


		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;

			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();

			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {

				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};

			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {

				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};

			}
			// Otherwise, assume format was fine:
			return format;
		}


		/* --- API Methods --- */

		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}

			// Fails silently (need decent errors):
			value = value || 0;

			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;

			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;

			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);

			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};


		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);

			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};


		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}

			// Clean up number:
			number = unformat(number);

			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),

				// Clean up precision
				usePrecision = checkPrecision(opts.precision),

				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;

			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};


		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}

			// Clean up number:
			number = unformat(number);

			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),

				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),

				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};


		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];

			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),

				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),

				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

				// Store value for the length of the longest string in the column:
				maxLength = 0,

				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);

						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});

			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};


		/* --- Module Definition --- */

		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);

			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}

		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//     JavaScript Expression Parser (JSEP) <%= version %>
	//     JSEP may be freely distributed under the MIT License
	//     http://jsep.from.so/

	/*global module: true, exports: true, console: true */
	(function (root) {
	    'use strict';
	    // Node Types
	    // ----------
	    
	    // This is the full set of types that any JSEP node can be.
	    // Store them here to save space when minified
	    var COMPOUND = 'Compound',
	        IDENTIFIER = 'Identifier',
	        MEMBER_EXP = 'MemberExpression',
	        LITERAL = 'Literal',
	        THIS_EXP = 'ThisExpression',
	        CALL_EXP = 'CallExpression',
	        UNARY_EXP = 'UnaryExpression',
	        BINARY_EXP = 'BinaryExpression',
	        LOGICAL_EXP = 'LogicalExpression',
	        CONDITIONAL_EXP = 'ConditionalExpression',
	        ARRAY_EXP = 'ArrayExpression',

	        PERIOD_CODE = 46, // '.'
	        COMMA_CODE  = 44, // ','
	        SQUOTE_CODE = 39, // single quote
	        DQUOTE_CODE = 34, // double quotes
	        OPAREN_CODE = 40, // (
	        CPAREN_CODE = 41, // )
	        OBRACK_CODE = 91, // [
	        CBRACK_CODE = 93, // ]
	        QUMARK_CODE = 63, // ?
	        SEMCOL_CODE = 59, // ;
	        COLON_CODE  = 58, // :

	        throwError = function(message, index) {
	            var error = new Error(message + ' at character ' + index);
	            error.index = index;
	            error.description = message;
	            throw error;
	        },

	    // Operations
	    // ----------
	    
	    // Set `t` to `true` to save space (when minified, not gzipped)
	        t = true,
	    // Use a quickly-accessible map to store all of the unary operators
	    // Values are set to `true` (it really doesn't matter)
	        unary_ops = {'-': t, '!': t, '~': t, '+': t},
	    // Also use a map for the binary operations but set their values to their
	    // binary precedence for quick reference:
	    // see [Order of operations](http://en.wikipedia.org/wiki/Order_of_operations#Programming_language)
	        binary_ops = {
	            '||': 1, '&&': 2, '|': 3,  '^': 4,  '&': 5,
	            '==': 6, '!=': 6, '===': 6, '!==': 6,
	            '<': 7,  '>': 7,  '<=': 7,  '>=': 7, 
	            '<<':8,  '>>': 8, '>>>': 8,
	            '+': 9, '-': 9,
	            '*': 10, '/': 10, '%': 10
	        },
	    // Get return the longest key length of any object
	        getMaxKeyLen = function(obj) {
	            var max_len = 0, len;
	            for(var key in obj) {
	                if((len = key.length) > max_len && obj.hasOwnProperty(key)) {
	                    max_len = len;
	                }
	            }
	            return max_len;
	        },
	        max_unop_len = getMaxKeyLen(unary_ops),
	        max_binop_len = getMaxKeyLen(binary_ops),
	    // Literals
	    // ----------
	    // Store the values to return for the various literals we may encounter
	        literals = {
	            'true': true,
	            'false': false,
	            'null': null
	        },
	    // Except for `this`, which is special. This could be changed to something like `'self'` as well
	        this_str = 'this',
	    // Returns the precedence of a binary operator or `0` if it isn't a binary operator
	        binaryPrecedence = function(op_val) {
	            return binary_ops[op_val] || 0;
	        },
	    // Utility function (gets called from multiple places)
	    // Also note that `a && b` and `a || b` are *logical* expressions, not binary expressions
	        createBinaryExpression = function (operator, left, right) {
	            var type = (operator === '||' || operator === '&&') ? LOGICAL_EXP : BINARY_EXP;
	            return {
	                type: type,
	                operator: operator,
	                left: left,
	                right: right
	            };
	        },
	        // `ch` is a character code in the next three functions
	        isDecimalDigit = function(ch) {
	            return (ch >= 48 && ch <= 57); // 0...9
	        },
	        isIdentifierStart = function(ch) {
	            return (ch === 36) || (ch === 95) || // `$` and `_`
	                    (ch >= 65 && ch <= 90) || // A...Z
	                    (ch >= 97 && ch <= 122); // a...z
	        },
	        isIdentifierPart = function(ch) {
	            return (ch === 36) || (ch === 95) || // `$` and `_`
	                    (ch >= 65 && ch <= 90) || // A...Z
	                    (ch >= 97 && ch <= 122) || // a...z
	                    (ch >= 48 && ch <= 57); // 0...9
	        },

	        // Parsing
	        // -------
	        // `expr` is a string with the passed in expression
	        jsep = function(expr) {
	            // `index` stores the character number we are currently at while `length` is a constant
	            // All of the gobbles below will modify `index` as we move along
	            var index = 0,
	                charAtFunc = expr.charAt,
	                charCodeAtFunc = expr.charCodeAt,
	                exprI = function(i) { return charAtFunc.call(expr, i); },
	                exprICode = function(i) { return charCodeAtFunc.call(expr, i); },
	                length = expr.length,

	                // Push `index` up to the next non-space character
	                gobbleSpaces = function() {
	                    var ch = exprICode(index);
	                    // space or tab
	                    while(ch === 32 || ch === 9) {
	                        ch = exprICode(++index);
	                    }
	                },
	                
	                // The main parsing function. Much of this code is dedicated to ternary expressions
	                gobbleExpression = function() {
	                    var test = gobbleBinaryExpression(),
	                        consequent, alternate;
	                    gobbleSpaces();
	                    if(exprICode(index) === QUMARK_CODE) {
	                        // Ternary expression: test ? consequent : alternate
	                        index++;
	                        consequent = gobbleExpression();
	                        if(!consequent) {
	                            throwError('Expected expression', index);
	                        }
	                        gobbleSpaces();
	                        if(exprICode(index) === COLON_CODE) {
	                            index++;
	                            alternate = gobbleExpression();
	                            if(!alternate) {
	                                throwError('Expected expression', index);
	                            }
	                            return {
	                                type: CONDITIONAL_EXP,
	                                test: test,
	                                consequent: consequent,
	                                alternate: alternate
	                            };
	                        } else {
	                            throwError('Expected :', index);
	                        }
	                    } else {
	                        return test;
	                    }
	                },

	                // Search for the operation portion of the string (e.g. `+`, `===`)
	                // Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
	                // and move down from 3 to 2 to 1 character until a matching binary operation is found
	                // then, return that binary operation
	                gobbleBinaryOp = function() {
	                    gobbleSpaces();
	                    var biop, to_check = expr.substr(index, max_binop_len), tc_len = to_check.length;
	                    while(tc_len > 0) {
	                        if(binary_ops.hasOwnProperty(to_check)) {
	                            index += tc_len;
	                            return to_check;
	                        }
	                        to_check = to_check.substr(0, --tc_len);
	                    }
	                    return false;
	                },

	                // This function is responsible for gobbling an individual expression,
	                // e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
	                gobbleBinaryExpression = function() {
	                    var ch_i, node, biop, prec, stack, biop_info, left, right, i;

	                    // First, try to get the leftmost thing
	                    // Then, check to see if there's a binary operator operating on that leftmost thing
	                    left = gobbleToken();
	                    biop = gobbleBinaryOp();

	                    // If there wasn't a binary operator, just return the leftmost node
	                    if(!biop) {
	                        return left;
	                    }

	                    // Otherwise, we need to start a stack to properly place the binary operations in their
	                    // precedence structure
	                    biop_info = { value: biop, prec: binaryPrecedence(biop)};

	                    right = gobbleToken();
	                    if(!right) {
	                        throwError("Expected expression after " + biop, index);
	                    }
	                    stack = [left, biop_info, right];

	                    // Properly deal with precedence using [recursive descent](http://www.engr.mun.ca/~theo/Misc/exp_parsing.htm)
	                    while((biop = gobbleBinaryOp())) {
	                        prec = binaryPrecedence(biop);

	                        if(prec === 0) {
	                            break;
	                        }
	                        biop_info = { value: biop, prec: prec };

	                        // Reduce: make a binary expression from the three topmost entries.
	                        while ((stack.length > 2) && (prec <= stack[stack.length - 2].prec)) {
	                            right = stack.pop();
	                            biop = stack.pop().value;
	                            left = stack.pop();
	                            node = createBinaryExpression(biop, left, right);
	                            stack.push(node);
	                        }

	                        node = gobbleToken();
	                        if(!node) {
	                            throwError("Expected expression after " + biop, index);
	                        }
	                        stack.push(biop_info, node);
	                    }

	                    i = stack.length - 1;
	                    node = stack[i];
	                    while(i > 1) {
	                        node = createBinaryExpression(stack[i - 1].value, stack[i - 2], node); 
	                        i -= 2;
	                    }
	                    return node;
	                },

	                // An individual part of a binary expression:
	                // e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
	                gobbleToken = function() {
	                    var ch, to_check, tc_len;
	                    
	                    gobbleSpaces();
	                    ch = exprICode(index);

	                    if(isDecimalDigit(ch) || ch === PERIOD_CODE) {
	                        // Char code 46 is a dot `.` which can start off a numeric literal
	                        return gobbleNumericLiteral();
	                    } else if(ch === SQUOTE_CODE || ch === DQUOTE_CODE) {
	                        // Single or double quotes
	                        return gobbleStringLiteral();
	                    } else if(isIdentifierStart(ch) || ch === OPAREN_CODE) { // open parenthesis
	                        // `foo`, `bar.baz`
	                        return gobbleVariable();
	                    } else if (ch === OBRACK_CODE) {
	                        return gobbleArray();
	                    } else {
	                        to_check = expr.substr(index, max_unop_len);
	                        tc_len = to_check.length;
	                        while(tc_len > 0) {
	                            if(unary_ops.hasOwnProperty(to_check)) {
	                                index += tc_len;
	                                return {
	                                    type: UNARY_EXP,
	                                    operator: to_check,
	                                    argument: gobbleToken(),
	                                    prefix: true
	                                };
	                            }
	                            to_check = to_check.substr(0, --tc_len);
	                        }
	                        
	                        return false;
	                    }
	                },
	                // Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
	                // keep track of everything in the numeric literal and then calling `parseFloat` on that string
	                gobbleNumericLiteral = function() {
	                    var number = '', ch, chCode;
	                    while(isDecimalDigit(exprICode(index))) {
	                        number += exprI(index++);
	                    }

	                    if(exprICode(index) === PERIOD_CODE) { // can start with a decimal marker
	                        number += exprI(index++);

	                        while(isDecimalDigit(exprICode(index))) {
	                            number += exprI(index++);
	                        }
	                    }
	                    
	                    ch = exprI(index);
	                    if(ch === 'e' || ch === 'E') { // exponent marker
	                        number += exprI(index++);
	                        ch = exprI(index);
	                        if(ch === '+' || ch === '-') { // exponent sign
	                            number += exprI(index++);
	                        }
	                        while(isDecimalDigit(exprICode(index))) { //exponent itself
	                            number += exprI(index++);
	                        }
	                        if(!isDecimalDigit(exprICode(index-1)) ) {
	                            throwError('Expected exponent (' + number + exprI(index) + ')', index);
	                        }
	                    }
	                    

	                    chCode = exprICode(index);
	                    // Check to make sure this isn't a variable name that start with a number (123abc)
	                    if(isIdentifierStart(chCode)) {
	                        throwError('Variable names cannot start with a number (' +
	                                    number + exprI(index) + ')', index);
	                    } else if(chCode === PERIOD_CODE) {
	                        throwError('Unexpected period', index);
	                    }

	                    return {
	                        type: LITERAL,
	                        value: parseFloat(number),
	                        raw: number
	                    };
	                },

	                // Parses a string literal, staring with single or double quotes with basic support for escape codes
	                // e.g. `"hello world"`, `'this is\nJSEP'`
	                gobbleStringLiteral = function() {
	                    var str = '', quote = exprI(index++), closed = false, ch;

	                    while(index < length) {
	                        ch = exprI(index++);
	                        if(ch === quote) {
	                            closed = true;
	                            break;
	                        } else if(ch === '\\') {
	                            // Check for all of the common escape codes
	                            ch = exprI(index++);
	                            switch(ch) {
	                                case 'n': str += '\n'; break;
	                                case 'r': str += '\r'; break;
	                                case 't': str += '\t'; break;
	                                case 'b': str += '\b'; break;
	                                case 'f': str += '\f'; break;
	                                case 'v': str += '\x0B'; break;
	                                case '\\': str += '\\'; break;
	                            }
	                        } else {
	                            str += ch;
	                        }
	                    }

	                    if(!closed) {
	                        throwError('Unclosed quote after "'+str+'"', index);
	                    }

	                    return {
	                        type: LITERAL,
	                        value: str,
	                        raw: quote + str + quote
	                    };
	                },
	                
	                // Gobbles only identifiers
	                // e.g.: `foo`, `_value`, `$x1`
	                // Also, this function checks if that identifier is a literal:
	                // (e.g. `true`, `false`, `null`) or `this`
	                gobbleIdentifier = function() {
	                    var ch = exprICode(index), start = index, identifier;

	                    if(isIdentifierStart(ch)) {
	                        index++;
	                    } else {
	                        throwError('Unexpected ' + exprI(index), index);
	                    }

	                    while(index < length) {
	                        ch = exprICode(index);
	                        if(isIdentifierPart(ch)) {
	                            index++;
	                        } else {
	                            break;
	                        }
	                    }
	                    identifier = expr.slice(start, index);

	                    if(literals.hasOwnProperty(identifier)) {
	                        return {
	                            type: LITERAL,
	                            value: literals[identifier],
	                            raw: identifier
	                        };
	                    } else if(identifier === this_str) {
	                        return { type: THIS_EXP };
	                    } else {
	                        return {
	                            type: IDENTIFIER,
	                            name: identifier
	                        };
	                    }
	                },

	                // Gobbles a list of arguments within the context of a function call
	                // or array literal. This function also assumes that the opening character
	                // `(` or `[` has already been gobbled, and gobbles expressions and commas
	                // until the terminator character `)` or `]` is encountered.
	                // e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
	                gobbleArguments = function(termination) {
	                    var ch_i, args = [], node;
	                    while(index < length) {
	                        gobbleSpaces();
	                        ch_i = exprICode(index);
	                        if(ch_i === termination) { // done parsing
	                            index++;
	                            break;
	                        } else if (ch_i === COMMA_CODE) { // between expressions
	                            index++;
	                        } else {
	                            node = gobbleExpression();
	                            if(!node || node.type === COMPOUND) {
	                                throwError('Expected comma', index);
	                            }
	                            args.push(node);
	                        }
	                    }
	                    return args;
	                },

	                // Gobble a non-literal variable name. This variable name may include properties
	                // e.g. `foo`, `bar.baz`, `foo['bar'].baz`
	                // It also gobbles function calls:
	                // e.g. `Math.acos(obj.angle)`
	                gobbleVariable = function() {
	                    var ch_i, node;
	                    ch_i = exprICode(index);
	                        
	                    if(ch_i === OPAREN_CODE) {
	                        node = gobbleGroup();
	                    } else {
	                        node = gobbleIdentifier();
	                    }
	                    gobbleSpaces();
	                    ch_i = exprICode(index);
	                    while(ch_i === PERIOD_CODE || ch_i === OBRACK_CODE || ch_i === OPAREN_CODE) {
	                        index++;
	                        if(ch_i === PERIOD_CODE) {
	                            gobbleSpaces();
	                            node = {
	                                type: MEMBER_EXP,
	                                computed: false,
	                                object: node,
	                                property: gobbleIdentifier()
	                            };
	                        } else if(ch_i === OBRACK_CODE) {
	                            node = {
	                                type: MEMBER_EXP,
	                                computed: true,
	                                object: node,
	                                property: gobbleExpression()
	                            };
	                            gobbleSpaces();
	                            ch_i = exprICode(index);
	                            if(ch_i !== CBRACK_CODE) {
	                                throwError('Unclosed [', index);
	                            }
	                            index++;
	                        } else if(ch_i === OPAREN_CODE) {
	                            // A function call is being made; gobble all the arguments
	                            node = {
	                                type: CALL_EXP,
	                                'arguments': gobbleArguments(CPAREN_CODE),
	                                callee: node
	                            };
	                        }
	                        gobbleSpaces();
	                        ch_i = exprICode(index);
	                    }
	                    return node;
	                },

	                // Responsible for parsing a group of things within parentheses `()`
	                // This function assumes that it needs to gobble the opening parenthesis
	                // and then tries to gobble everything within that parenthesis, assuming
	                // that the next thing it should see is the close parenthesis. If not,
	                // then the expression probably doesn't have a `)`
	                gobbleGroup = function() {
	                    index++;
	                    var node = gobbleExpression();
	                    gobbleSpaces();
	                    if(exprICode(index) === CPAREN_CODE) {
	                        index++;
	                        return node;
	                    } else {
	                        throwError('Unclosed (', index);
	                    }
	                },

	                // Responsible for parsing Array literals `[1, 2, 3]`
	                // This function assumes that it needs to gobble the opening bracket
	                // and then tries to gobble the expressions as arguments.
	                gobbleArray = function() {
	                    index++;
	                    return {
	                        type: ARRAY_EXP,
	                        elements: gobbleArguments(CBRACK_CODE)
	                    };
	                },

	                nodes = [], ch_i, node;
	                
	            while(index < length) {
	                ch_i = exprICode(index);

	                // Expressions can be separated by semicolons, commas, or just inferred without any
	                // separators
	                if(ch_i === SEMCOL_CODE || ch_i === COMMA_CODE) {
	                    index++; // ignore separators
	                } else {
	                    // Try to gobble each expression individually
	                    if((node = gobbleExpression())) {
	                        nodes.push(node);
	                    // If we weren't able to find a binary expression and are out of room, then
	                    // the expression passed in probably has too much
	                    } else if(index < length) {
	                        throwError('Unexpected "' + exprI(index) + '"', index);
	                    }
	                }
	            }

	            // If there's only one expression just try returning the expression
	            if(nodes.length === 1) {
	                return nodes[0];
	            } else {
	                return {
	                    type: COMPOUND,
	                    body: nodes
	                };
	            }
	        };

	    // To be filled in by the template
	    jsep.version = '<%= version %>';
	    jsep.toString = function() { return 'JavaScript Expression Parser (JSEP) v' + jsep.version; };

	    /**
	     * @method jsep.addUnaryOp
	     * @param {string} op_name The name of the unary op to add
	     * @return jsep
	     */
	    jsep.addUnaryOp = function(op_name) {
	        unary_ops[op_name] = t; return this;
	    };

	    /**
	     * @method jsep.addBinaryOp
	     * @param {string} op_name The name of the binary op to add
	     * @param {number} precedence The precedence of the binary op (can be a float)
	     * @return jsep
	     */
	    jsep.addBinaryOp = function(op_name, precedence) {
	        max_binop_len = Math.max(op_name.length, max_binop_len);
	        binary_ops[op_name] = precedence;
	        return this;
	    };

	    /**
	     * @method jsep.removeUnaryOp
	     * @param {string} op_name The name of the unary op to remove
	     * @return jsep
	     */
	    jsep.removeUnaryOp = function(op_name) {
	        delete unary_ops[op_name];
	        if(op_name.length === max_unop_len) {
	            max_unop_len = getMaxKeyLen(unary_ops);
	        }
	        return this;
	    };

	    /**
	     * @method jsep.removeBinaryOp
	     * @param {string} op_name The name of the binary op to remove
	     * @return jsep
	     */
	    jsep.removeBinaryOp = function(op_name) {
	        delete binary_ops[op_name];
	        if(op_name.length === max_binop_len) {
	            max_binop_len = getMaxKeyLen(binary_ops);
	        }
	        return this;
	    };

	    // In desktop environments, have a way to restore the old value for `jsep`
	    if (false) {
	        var old_jsep = root.jsep;
	        // The star of the show! It's a function!
	        root.jsep = jsep;
	        // And a courteous function willing to move out of the way for other similarly-named objects!
	        jsep.noConflict = function() {
	            if(root.jsep === jsep) {
	                root.jsep = old_jsep;
	            }
	            return jsep;
	        };
	    } else {
	        // In Node.JS environments
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = jsep;
	        } else {
	            exports.parse = jsep;
	        }
	    }
	}(this));

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Buffer) {/** @preserve
	 * jsPDF - PDF Document creation from JavaScript
	 * Version 1.0.203-git Built on 2014-07-22T04:20
	 *                           CommitID ed1c917abb
	 *
	 * Copyright (c) 2010-2014 James Hall, https://github.com/MrRio/jsPDF
	 *               2010 Aaron Spike, https://github.com/acspike
	 *               2012 Willow Systems Corporation, willow-systems.com
	 *               2012 Pablo Hess, https://github.com/pablohess
	 *               2012 Florian Jenett, https://github.com/fjenett
	 *               2013 Warren Weckesser, https://github.com/warrenweckesser
	 *               2013 Youssef Beddad, https://github.com/lifof
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2013 Stefan Slonevskiy, https://github.com/stefslon
	 *               2013 Jeremy Morel, https://github.com/jmorel
	 *               2013 Christoph Hartmann, https://github.com/chris-rock
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Makes, https://github.com/dollaruw
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * Contributor(s):
	 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
	 *    kim3er, mfo, alnorth,
	 */

	var PDFFont = __webpack_require__(195);

	/**
	 * Creates new jsPDF document object instance.
	 *
	 * @class
	 * @param orientation One of "portrait" or "landscape" (or shortcuts "p" (Default), "l")
	 * @param unit        Measurement unit to be used when coordinates are specified.
	 *                    One of "pt" (points), "mm" (Default), "cm", "in"
	 * @param format      One of 'pageFormats' as shown below, default: a4
	 * @returns {jsPDF}
	 * @name jsPDF
	 */

	module.exports = function(window, saveAs, jsreports) {

	var jsPDF = (function(global) {
	  'use strict';
	  var pdfVersion = '1.3',
	    pageFormats = { // Size in pt of various paper formats
	      'a0'  : [2383.94, 3370.39], 'a1'  : [1683.78, 2383.94],
	      'a2'  : [1190.55, 1683.78], 'a3'  : [ 841.89, 1190.55],
	      'a4'  : [ 595.28,  841.89], 'a5'  : [ 419.53,  595.28],
	      'a6'  : [ 297.64,  419.53], 'a7'  : [ 209.76,  297.64],
	      'a8'  : [ 147.40,  209.76], 'a9'  : [ 104.88,  147.40],
	      'a10' : [  73.70,  104.88], 'b0'  : [2834.65, 4008.19],
	      'b1'  : [2004.09, 2834.65], 'b2'  : [1417.32, 2004.09],
	      'b3'  : [1000.63, 1417.32], 'b4'  : [ 708.66, 1000.63],
	      'b5'  : [ 498.90,  708.66], 'b6'  : [ 354.33,  498.90],
	      'b7'  : [ 249.45,  354.33], 'b8'  : [ 175.75,  249.45],
	      'b9'  : [ 124.72,  175.75], 'b10' : [  87.87,  124.72],
	      'c0'  : [2599.37, 3676.54], 'c1'  : [1836.85, 2599.37],
	      'c2'  : [1298.27, 1836.85], 'c3'  : [ 918.43, 1298.27],
	      'c4'  : [ 649.13,  918.43], 'c5'  : [ 459.21,  649.13],
	      'c6'  : [ 323.15,  459.21], 'c7'  : [ 229.61,  323.15],
	      'c8'  : [ 161.57,  229.61], 'c9'  : [ 113.39,  161.57],
	      'c10' : [  79.37,  113.39], 'dl'  : [ 311.81,  623.62],
	      'letter'            : [612,   792],
	      'government-letter' : [576,   756],
	      'legal'             : [612,  1008],
	      'junior-legal'      : [576,   360],
	      'ledger'            : [1224,  792],
	      'tabloid'           : [792,  1224],
	      'credit-card'       : [153,   243]
	    };

	    var fontsWarnedAbout = {};

	  /**
	   * jsPDF's Internal PubSub Implementation.
	   * See mrrio.github.io/jsPDF/doc/symbols/PubSub.html
	   * Backward compatible rewritten on 2014 by
	   * Diego Casorran, https://github.com/diegocr
	   *
	   * @class
	   * @name PubSub
	   */
	  function PubSub(context) {
	    var topics = {};

	    this.subscribe = function(topic, callback, once) {
	      if(typeof callback !== 'function') {
	        return false;
	      }

	      if(!topics.hasOwnProperty(topic)) {
	        topics[topic] = {};
	      }

	      var id = Math.random().toString(35);
	      topics[topic][id] = [callback,!!once];

	      return id;
	    };

	    this.unsubscribe = function(token) {
	      for(var topic in topics) {
	        if(topics[topic][token]) {
	          delete topics[topic][token];
	          return true;
	        }
	      }
	      return false;
	    };

	    this.publish = function(topic) {
	      if(topics.hasOwnProperty(topic)) {
	        var args = Array.prototype.slice.call(arguments, 1), idr = [];

	        for(var id in topics[topic]) {
	          var sub = topics[topic][id];
	          try {
	            sub[0].apply(context, args);
	          } catch(ex) {
	            if(global.console) {
	              console.error('jsPDF PubSub Error', ex.message, ex);
	            }
	          }
	          if(sub[1]) idr.push(id);
	        }
	        if(idr.length) idr.forEach(this.unsubscribe);
	      }
	    };
	  }

	  /**
	   * @constructor
	   * @private
	   */
	  function jsPDF(orientation, unit, format, compressPdf) {
	    var options = {};

	    if (typeof orientation === 'object') {
	      options = orientation;

	      orientation = options.orientation;
	      unit = options.unit || unit;
	      format = options.format || format;
	      compressPdf = options.compress || options.compressPdf || compressPdf;
	    }

	    // Default options
	    unit        = unit || 'mm';
	    format      = format || 'a4';
	    orientation = ('' + (orientation || 'P')).toLowerCase();

	    var format_as_string = ('' + format).toLowerCase(),
	      compress = !!compressPdf && typeof Uint8Array === 'function',
	      textColor            = options.textColor  || '0 g',
	      drawColor            = options.drawColor  || '0 G',
	      activeFontSize       = options.fontSize   || 16,
	      lineHeightProportion = options.lineHeight || 1.15,
	      lineWidth            = options.lineWidth  || 0.200025, // 2mm
	      objectNumber =  2,  // 'n' Current object number
	      outToPages   = !1,  // switches where out() prints. outToPages true = push to pages obj. outToPages false = doc builder content
	      offsets      = [],  // List of offsets. Activated and reset by buildDocument(). Pupulated by various calls buildDocument makes.
	      fonts        = {},  // collection of font objects, where key is fontKey - a dynamically created label for a given font.
	      fontmap      = {},  // mapping structure fontName > fontStyle > font key - performance layer. See addFont()
	      activeFontKey,      // will be string representing the KEY of the font as combination of fontName + fontStyle
	      k,                  // Scale factor
	      tmp,
	      unloadedFonts = [],
	      page = 0,
	      pages = [],
	      content = [],
	      lineCapID = 0,
	      lineJoinID = 0,
	      content_length = 0,
	      pageWidth,
	      pageHeight,
	      documentProperties = {
	        'title'    : '',
	        'subject'  : '',
	        'author'   : '',
	        'keywords' : '',
	        'creator'  : ''
	      },
	      API = {},
	      events = new PubSub(API),

	    /////////////////////
	    // Private functions
	    /////////////////////
	    f2 = function(number) {
	      return number.toFixed(2); // Ie, %.2f
	    },
	    f3 = function(number) {
	      return number.toFixed(3); // Ie, %.3f
	    },
	    padd2 = function(number) {
	      return ('0' + parseInt(number)).slice(-2);
	    },
	    out = function(string) {
	      if (outToPages) {
	        /* set by beginPage */
	        pages[page].push(string);
	      } else {
	        // +1 for '\n' that will be used to join 'content'
	        content_length += string.length + 1;
	        content.push(string);
	      }
	    },
	    newObject = function() {
	      // Begin a new object
	      objectNumber++;
	      offsets[objectNumber] = content_length;
	      out(objectNumber + ' 0 obj');
	      return objectNumber;
	    },
	    putStream = function(str) {
	      out('stream');
	      out(str);
	      out('endstream');
	    },
	    putPages = function() {
	      var n,p,arr,i,deflater,adler32,wPt = pageWidth * k, hPt = pageHeight * k, adler32cs;

	      adler32cs = global.adler32cs || jsPDF.adler32cs;
	      if (compress && typeof adler32cs === 'undefined') {
	        compress = false;
	      }

	      // outToPages = false as set in endDocument(). out() writes to content.

	      for (n = 1; n <= page; n++) {
	        newObject();
	        out('<</Type /Page');
	        out('/Parent 1 0 R');
	        out('/Resources 2 0 R');
	        out('/Contents ' + (objectNumber + 1) + ' 0 R>>');
	        out('endobj');

	        // Page content
	        p = pages[n].join('\n');
	        newObject();
	        if (compress) {
	          arr = [];
	          i = p.length;
	          while(i--) {
	            arr[i] = p.charCodeAt(i);
	          }
	          adler32 = adler32cs.from(p);
	          deflater = new Deflater(6);
	          deflater.append(new Uint8Array(arr));
	          p = deflater.flush();
	          arr = new Uint8Array(p.length + 6);
	          arr.set(new Uint8Array([120, 156])),
	          arr.set(p, 2);
	          arr.set(new Uint8Array([adler32 & 0xFF, (adler32 >> 8) & 0xFF, (adler32 >> 16) & 0xFF, (adler32 >> 24) & 0xFF]), p.length+2);
	          p = String.fromCharCode.apply(null, arr);
	          out('<</Length ' + p.length + ' /Filter [/FlateDecode]>>');
	        } else {
	          out('<</Length ' + p.length + '>>');
	        }
	        putStream(p);
	        out('endobj');
	      }
	      offsets[1] = content_length;
	      out('1 0 obj');
	      out('<</Type /Pages');
	      var kids = '/Kids [';
	      for (i = 0; i < page; i++) {
	        kids += (3 + 2 * i) + ' 0 R ';
	      }
	      out(kids + ']');
	      out('/Count ' + page);
	      out('/MediaBox [0 0 ' + f2(wPt) + ' ' + f2(hPt) + ']');
	      out('>>');
	      out('endobj');
	    },
	    getPdfDictionaryEntry = function(key, val) {
	      var line = '/' + key + ' ';
	      if (Array.isArray(val)) {
	        line += '[' + val.join(' ') + ']';
	      } else if (typeof val === 'string' && ['FontFile2', 'FontDescriptor', 'ToUnicode'].indexOf(key) < 0) {
	        line += '/' + val;
	      } else {
	        line += val;
	      }
	      return line;
	    },
	    putFont = function(font) {
	      var descriptorObjNum;
	      if (font.embedded && font.pdfkitFont) {
	        var embed = font.pdfkitFont.getEmbedInfoTTF();
	        if (isNaN(embed.dictionary.FirstChar)) return;
	        // Font stream
	          var streamObjNum = newObject();
	          var fontfile = embed.fontfile;
	          if (!Buffer.isBuffer(fontfile)) {
	            fontfile = new Buffer(fontfile + '\n', 'binary');
	          }
	          // var deflater = new Deflater(6);
	          // deflater.append(fontfile);
	          // var compressedFontfile = deflater.flush();
	          out('<<');
	          out('/Length ' + fontfile.length);
	          out('/Length1 ' + fontfile.length);
	          out('>>')
	          putStream(API.arrayBufferToBinaryString(fontfile));
	          out('endobj');

	        // Font descriptor
	        descriptorObjNum = newObject();
	        out('<<');
	          embed.descriptor['FontFile2'] = String(streamObjNum) + ' 0 R';
	        Object.keys(embed.descriptor).forEach(function(descriptorKey) {
	          out(getPdfDictionaryEntry(descriptorKey, embed.descriptor[descriptorKey]));
	        });
	        out('>>');
	        out('endobj');
	        // cmap
	        var cmapObjNum = newObject();
	        out('<<');
	        out('/Length ' + embed.cmap.length);
	        out('>>')
	        out('stream');
	        out(embed.cmap);
	        out('endstream');
	        out('endobj');
	        // Font
	        font.objectNumber = newObject();
	        out('<<');
	        embed.dictionary['FontDescriptor'] = String(descriptorObjNum) + ' 0 R';
	        embed.dictionary['ToUnicode'] = String(cmapObjNum) + ' 0 R';
	        Object.keys(embed.dictionary).forEach(function(dictKey) {
	          out(getPdfDictionaryEntry(dictKey, embed.dictionary[dictKey]));
	        });
	        out('>>');
	        out('endobj');
	      } else {
	        font.objectNumber = newObject();
	        out('<<');
	        out('/Type /Font');
	        out('/BaseFont /' + font.PostScriptName);
	        if (typeof font.encoding === 'string') {
	          out('/Encoding /' + font.encoding);
	        }
	        out('/Subtype/' + (font.subType || 'Type1') + '>>');
	        out('endobj');
	      }
	    },
	    putFonts = function() {
	      for (var fontKey in fonts) {
	        if (fonts.hasOwnProperty(fontKey)) {
	          putFont(fonts[fontKey]);
	        }
	      }
	    },
	    putXobjectDict = function() {
	      // Loop through images, or other data objects
	      events.publish('putXobjectDict');
	    },
	    putResourceDictionary = function() {
	      out('/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]');
	      out('/Font <<');

	      // Do this for each font, the '1' bit is the index of the font
	      for (var fontKey in fonts) {
	        if (fonts.hasOwnProperty(fontKey)) {
	          var font = fonts[fontKey];
	          if (font.objectNumber) {
	            out('/' + fontKey + ' ' + fonts[fontKey].objectNumber + ' 0 R');
	          }
	        }
	      }
	      out('>>');
	      out('/XObject <<');
	      putXobjectDict();
	      out('>>');
	    },
	    putResources = function() {
	      putFonts();
	      events.publish('putResources');
	      // Resource dictionary
	      offsets[2] = content_length;
	      out('2 0 obj');
	      out('<<');
	      putResourceDictionary();
	      out('>>');
	      out('endobj');
	      events.publish('postPutResources');
	    },
	    addToFontDictionary = function(fontKey, fontName, fontStyle) {
	      // this is mapping structure for quick font key lookup.
	      // returns the KEY of the font (ex: "F1") for a given
	      // pair of font name and type (ex: "Arial". "Italic")
	      if (!fontmap.hasOwnProperty(fontName)) {
	        fontmap[fontName] = {};
	      }
	      fontmap[fontName][fontStyle] = fontKey;
	    },
	    /**
	     * FontObject describes a particular font as member of an instnace of jsPDF
	     *
	     * It's a collection of properties like 'id' (to be used in PDF stream),
	     * 'fontName' (font's family name), 'fontStyle' (font's style variant label)
	     *
	     * @class
	     * @public
	     * @property id {String} PDF-document-instance-specific label assinged to the font.
	     * @property PostScriptName {String} PDF specification full name for the font
	     * @property encoding {Object} Encoding_name-to-Font_metrics_object mapping.
	     * @name FontObject
	     */
	    addFont = function(PostScriptName, fontName, fontStyle, encoding) {
	      var fontKey = 'F' + (Object.keys(fonts).length + 1).toString(10),
	      // This is FontObject
	      font = fonts[fontKey] = {
	        'id'             : fontKey,
	        'PostScriptName' : PostScriptName,
	        'fontName'       : fontName,
	        'fontStyle'      : fontStyle,
	        'encoding'       : encoding,
	        'metadata'       : {}
	      };
	      addToFontDictionary(fontKey, fontName, fontStyle);
	      events.publish('addFont', font);
	      return fontKey;
	    },
	    bin2String = function(array) {
	      var result = "";
	      for (var i = 0; i < array.length; i++) {
	        result += String.fromCharCode(array[i]);
	      }
	      return result;
	    },
	    arrayBufferToString = function(arrayBuffer) {
	      return String.fromCharCode.apply(null, new Uint16Array(arrayBuffer));
	    },
	    registerEmbeddableFont = function(fontName, fontStyle, url) {
	      unloadedFonts.push({ fontName: fontName, fontStyle: fontStyle, url: url });
	    },
	    fetchEmbeddableFonts = function(done) {
	      var loading = 0;
	      function loadFromUrl(url, callback) {
	        var request = new XMLHttpRequest();
	        request.open('get', url, true);
	        request.responseType = 'arraybuffer';
	        request.onload = function() {
	          if (request.status !== 200 && request.status !== 0) {
	              return callback('Font could not be loaded: ' + request.statusText);
	          }
	          return callback(null, new Uint8Array(request.response));
	        };
	        request.onerror = function(e) { };
	        loading++;
	        request.send();
	      }
	      function onFontLoaded(pendingFontEntry, err, fontArrayBuffer) {
	        --loading;
	        if (err) {
	          // fontEntry.usable = false;
	          return (loading <= 0 ? done() : null);
	        }
	        var psName = pendingFontEntry.fontName.replace(/\s/g, '#20');
	        var fontKey = addFont(psName, pendingFontEntry.fontName, pendingFontEntry.fontStyle, 'Unicode');
	        var fontEntry = fonts[fontKey];
	        fontEntry.pdfkitFont = new PDFFont(this, fontArrayBuffer, pendingFontEntry.fontName, fontKey);
	        fontEntry.embedded = true;
	        fontEntry.url = pendingFontEntry.url;
	        // fontEntry.usable = true;
	        fontEntry.subType = 'TrueType';
	        fontEntry.metrics = {}; //font.metrics;
	        fontEntry.metadata = { Unicode: { widths: { 0:1, fof: 1}, kerning: {} }};
	        if (loading <= 0) {
	          events.publish('addFonts', { fonts : fonts, dictionary : fontmap });
	          done();
	        }
	      }
	      unloadedFonts.forEach(function(fontEntry) {
	        // console.log('loading', fontEntry.url, fontEntry);
	        loadFromUrl(fontEntry.url, onFontLoaded.bind(this, fontEntry));
	      }.bind(this));
	      unloadedFonts = [];
	      if (loading === 0) {
	        done();
	      }
	    },
	    embedNecessaryFonts = function(usedFontKeys) {
	    },
	    // embedFont = function(fontName, fontStyle, url, done) {
	    //  // console.log("attempt to add webfont", fontName, url);
	    //  var font = new Font();
	    //  font.onload = function() {
	    //    var fontKey = addFont(fontName, fontName, fontStyle, 'StandardEncoding');
	    //    var fontEntry = fonts[fontKey];
	    //    fontEntry.embedded = true;
	    //    fontEntry.binary = bin2String(font.data);
	    //    fontEntry.metrics = font.metrics;
	    //    // console.log('added embedded font with key', fontKey);
	    //    done();
	    //  };
	    //  font.src = url;
	    // },
	    addFonts = function() {

	      var HELVETICA     = "helvetica",
	        TIMES         = "times",
	        COURIER       = "courier",
	        NORMAL        = "normal",
	        BOLD          = "bold",
	        ITALIC        = "italic",
	        BOLD_ITALIC   = "bolditalic",
	        encoding      = 'StandardEncoding',
	        standardFonts = [
	          ['Helvetica', HELVETICA, NORMAL],
	          ['Helvetica-Bold', HELVETICA, BOLD],
	          ['Helvetica-Oblique', HELVETICA, ITALIC],
	          ['Helvetica-BoldOblique', HELVETICA, BOLD_ITALIC],
	          ['Courier', COURIER, NORMAL],
	          ['Courier-Bold', COURIER, BOLD],
	          ['Courier-Oblique', COURIER, ITALIC],
	          ['Courier-BoldOblique', COURIER, BOLD_ITALIC],
	          ['Times-Roman', TIMES, NORMAL],
	          ['Times-Bold', TIMES, BOLD],
	          ['Times-Italic', TIMES, ITALIC],
	          ['Times-BoldItalic', TIMES, BOLD_ITALIC]
	        ];

	      for (var i = 0, l = standardFonts.length; i < l; i++) {
	        var fontKey = addFont(
	            standardFonts[i][0],
	            standardFonts[i][1],
	            standardFonts[i][2],
	            encoding);

	        // adding aliases for standard fonts, this time matching the capitalization
	        var parts = standardFonts[i][0].split('-');
	        addToFontDictionary(fontKey, parts[0], parts[1] || '');
	      }
	      events.publish('addFonts', { fonts : fonts, dictionary : fontmap });
	    },
	    SAFE = function __safeCall(fn) {
	      fn.foo = function __safeCallWrapper() {
	        try {
	          return fn.apply(this, arguments);
	        } catch (e) {
	          var stack = e.stack || '';
	          if(~stack.indexOf(' at ')) stack = stack.split(" at ")[1];
	          var m = "Error in function " + stack.split("\n")[0].split('<')[0] + ": " + e.message;
	          if(global.console) {
	            global.console.error(m, e);
	            if(global.alert) alert(m);
	          } else {
	            throw new Error(m);
	          }
	        }
	      };
	      fn.foo.bar = fn;
	      return fn.foo;
	    },
	    to8bitStream = function(text, flags) {
	    /**
	     * PDF 1.3 spec:
	     * "For text strings encoded in Unicode, the first two bytes must be 254 followed by
	     * 255, representing the Unicode byte order marker, U+FEFF. (This sequence conflicts
	     * with the PDFDocEncoding character sequence thorn ydieresis, which is unlikely
	     * to be a meaningful beginning of a word or phrase.) The remainder of the
	     * string consists of Unicode character codes, according to the UTF-16 encoding
	     * specified in the Unicode standard, version 2.0. Commonly used Unicode values
	     * are represented as 2 bytes per character, with the high-order byte appearing first
	     * in the string."
	     *
	     * In other words, if there are chars in a string with char code above 255, we
	     * recode the string to UCS2 BE - string doubles in length and BOM is prepended.
	     *
	     * HOWEVER!
	     * Actual *content* (body) text (as opposed to strings used in document properties etc)
	     * does NOT expect BOM. There, it is treated as a literal GID (Glyph ID)
	     *
	     * Because of Adobe's focus on "you subset your fonts!" you are not supposed to have
	     * a font that maps directly Unicode (UCS2 / UTF16BE) code to font GID, but you could
	     * fudge it with "Identity-H" encoding and custom CIDtoGID map that mimics Unicode
	     * code page. There, however, all characters in the stream are treated as GIDs,
	     * including BOM, which is the reason we need to skip BOM in content text (i.e. that
	     * that is tied to a font).
	     *
	     * To signal this "special" PDFEscape / to8bitStream handling mode,
	     * API.text() function sets (unless you overwrite it with manual values
	     * given to API.text(.., flags) )
	     * flags.autoencode = true
	     * flags.noBOM = true
	     *
	     * ===================================================================================
	     * `flags` properties relied upon:
	     *   .sourceEncoding = string with encoding label.
	     *                     "Unicode" by default. = encoding of the incoming text.
	     *                     pass some non-existing encoding name
	     *                     (ex: 'Do not touch my strings! I know what I am doing.')
	     *                     to make encoding code skip the encoding step.
	     *   .outputEncoding = Either valid PDF encoding name
	     *                     (must be supported by jsPDF font metrics, otherwise no encoding)
	     *                     or a JS object, where key = sourceCharCode, value = outputCharCode
	     *                     missing keys will be treated as: sourceCharCode === outputCharCode
	     *   .noBOM
	     *       See comment higher above for explanation for why this is important
	     *   .autoencode
	     *       See comment higher above for explanation for why this is important
	     */

	      var i,l,sourceEncoding,encodingBlock,outputEncoding,newtext,isUnicode,ch,bch;

	      flags = flags || {};
	      sourceEncoding = flags.sourceEncoding || 'Unicode';
	      outputEncoding = flags.outputEncoding;

	      // This 'encoding' section relies on font metrics format
	      // attached to font objects by, among others,
	      // "Willow Systems' standard_font_metrics plugin"
	      // see jspdf.plugin.standard_font_metrics.js for format
	      // of the font.metadata.encoding Object.
	      // It should be something like
	      //   .encoding = {'codePages':['WinANSI....'], 'WinANSI...':{code:code, ...}}
	      //   .widths = {0:width, code:width, ..., 'fof':divisor}
	      //   .kerning = {code:{previous_char_code:shift, ..., 'fof':-divisor},...}
	      if ((flags.autoencode || outputEncoding) &&
	        fonts[activeFontKey].metadata &&
	        fonts[activeFontKey].metadata[sourceEncoding] &&
	        fonts[activeFontKey].metadata[sourceEncoding].encoding) {
	        encodingBlock = fonts[activeFontKey].metadata[sourceEncoding].encoding;

	        // each font has default encoding. Some have it clearly defined.
	        if (!outputEncoding && fonts[activeFontKey].encoding) {
	          outputEncoding = fonts[activeFontKey].encoding;
	        }

	        // Hmmm, the above did not work? Let's try again, in different place.
	        if (!outputEncoding && encodingBlock.codePages) {
	          outputEncoding = encodingBlock.codePages[0]; // let's say, first one is the default
	        }

	        if (typeof outputEncoding === 'string') {
	          outputEncoding = encodingBlock[outputEncoding];
	        }
	        // we want output encoding to be a JS Object, where
	        // key = sourceEncoding's character code and
	        // value = outputEncoding's character code.
	        if (outputEncoding) {
	          isUnicode = false;
	          newtext = [];
	          for (i = 0, l = text.length; i < l; i++) {
	            ch = outputEncoding[text.charCodeAt(i)];
	            if (ch) {
	              newtext.push(
	                String.fromCharCode(ch));
	            } else {
	              newtext.push(
	                text[i]);
	            }

	            // since we are looping over chars anyway, might as well
	            // check for residual unicodeness
	            if (newtext[i].charCodeAt(0) >> 8) {
	              /* more than 255 */
	              isUnicode = true;
	            }
	          }
	          text = newtext.join('');
	        }
	      }

	      i = text.length;
	      // isUnicode may be set to false above. Hence the triple-equal to undefined
	      while (isUnicode === undefined && i !== 0) {
	        if (text.charCodeAt(i - 1) >> 8) {
	          /* more than 255 */
	          isUnicode = true;
	        }
	        i--;
	      }
	      if (!isUnicode) {
	        return text;
	      }

	      newtext = flags.noBOM ? [] : [254, 255];
	      for (i = 0, l = text.length; i < l; i++) {
	        ch = text.charCodeAt(i);
	        bch = ch >> 8; // divide by 256
	        if (bch >> 8) {
	          /* something left after dividing by 256 second time */
	          throw new Error("Character at position " + i + " of string '"
	            + text + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
	        }
	        newtext.push(bch);
	        newtext.push(ch - (bch << 8));
	      }
	      return String.fromCharCode.apply(undefined, newtext);
	    },
	    pdfEscape = function(text, flags) {
	      /**
	       * Replace '/', '(', and ')' with pdf-safe versions
	       *
	       * Doing to8bitStream does NOT make this PDF display unicode text. For that
	       * we also need to reference a unicode font and embed it - royal pain in the rear.
	       *
	       * There is still a benefit to to8bitStream - PDF simply cannot handle 16bit chars,
	       * which JavaScript Strings are happy to provide. So, while we still cannot display
	       * 2-byte characters property, at least CONDITIONALLY converting (entire string containing)
	       * 16bit chars to (USC-2-BE) 2-bytes per char + BOM streams we ensure that entire PDF
	       * is still parseable.
	       * This will allow immediate support for unicode in document properties strings.
	       */
	      return to8bitStream(text, flags).replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
	    },
	    putInfo = function() {
	      out('/Producer (jsreports ' + jsreports.version + ')');
	      for(var key in documentProperties) {
	        if(documentProperties.hasOwnProperty(key) && documentProperties[key]) {
	          out('/'+key.substr(0,1).toUpperCase() + key.substr(1)
	            +' (' + pdfEscape(documentProperties[key]) + ')');
	        }
	      }
	      var created = new Date();
	      out(['/CreationDate (D:',
	          created.getFullYear(),
	          padd2(created.getMonth() + 1),
	          padd2(created.getDate()),
	          padd2(created.getHours()),
	          padd2(created.getMinutes()),
	          padd2(created.getSeconds()), ')'].join(''));
	    },
	    putCatalog = function() {
	      out('/Type /Catalog');
	      out('/Pages 1 0 R');
	      out('/OpenAction [3 0 R /FitH null]');
	      out('/PageLayout /OneColumn');
	      events.publish('putCatalog');
	    },
	    putTrailer = function() {
	      out('/Size ' + (objectNumber + 1));
	      out('/Root ' + objectNumber + ' 0 R');
	      out('/Info ' + (objectNumber - 1) + ' 0 R');
	    },
	    beginPage = function() {
	      page++;
	      // Do dimension stuff
	      outToPages = true;
	      pages[page] = [];
	    },
	    _addPage = function() {
	      beginPage();
	      // Set line width
	      out(f2(lineWidth * k) + ' w');
	      // Set draw color
	      out(drawColor);
	      // resurrecting non-default line caps, joins
	      if (lineCapID !== 0) {
	        out(lineCapID + ' J');
	      }
	      if (lineJoinID !== 0) {
	        out(lineJoinID + ' j');
	      }
	      events.publish('addPage', { pageNumber : page });
	    },
	    /**
	     * Returns a document-specific font key - a label assigned to a
	     * font name + font type combination at the time the font was added
	     * to the font inventory.
	     *
	     * Font key is used as label for the desired font for a block of text
	     * to be added to the PDF document stream.
	     * @private
	     * @function
	     * @param fontName {String} can be undefined on "falthy" to indicate "use current"
	     * @param fontStyle {String} can be undefined on "falthy" to indicate "use current"
	     * @returns {String} Font key.
	     */
	    getFont = function(fontName, fontStyle) {
	      var key;

	      fontName  = fontName  !== undefined ? fontName  : fonts[activeFontKey].fontName;
	      fontStyle = fontStyle !== undefined ? fontStyle : fonts[activeFontKey].fontStyle;

	      try {
	       // get a string like 'F3' - the KEY corresponding to the font + type combination.
	        key = fontmap[fontName][fontStyle];
	      } catch (e) {}

	      if (!key) {
	        if (!fontsWarnedAbout[key]) {
	          console.warn('Couldn\'t find font', fontName, fontStyle, '; falling back to Helvetica');
	          fontsWarnedAbout[key] = true;
	        }
	        return fontmap['Helvetica'][fontStyle] || fontmap['Helvetica'][''];
	      }
	      return key;
	    },
	    buildDocument = function() {

	      outToPages = false; // switches out() to content
	      objectNumber = 2;
	      content = [];
	      offsets = [];

	      // putHeader()
	      out('%PDF-' + pdfVersion);

	      putPages();

	      putResources();

	      // Info
	      newObject();
	      out('<<');
	      putInfo();
	      out('>>');
	      out('endobj');

	      // Catalog
	      newObject();
	      out('<<');
	      putCatalog();
	      out('>>');
	      out('endobj');

	      // Cross-ref
	      var o = content_length, i, p = "0000000000";
	      out('xref');
	      out('0 ' + (objectNumber + 1));
	      out(p+' 65535 f ');
	      for (i = 1; i <= objectNumber; i++) {
	        out((p + offsets[i]).slice(-10) + ' 00000 n ');
	      }
	      // Trailer
	      out('trailer');
	      out('<<');
	      putTrailer();
	      out('>>');
	      out('startxref');
	      out(o);
	      out('%%EOF');

	      outToPages = true;

	      return content.join('\n');
	    },
	    getStyle = function(style) {
	      // see path-painting operators in PDF spec
	      var op = 'S'; // stroke
	      if (style === 'F') {
	        op = 'f'; // fill
	      } else if (style === 'FD' || style === 'DF') {
	        op = 'B'; // both
	      } else if (style === 'f' || style === 'f*' || style === 'B' || style === 'B*') {
	        /*
	        Allow direct use of these PDF path-painting operators:
	        - f fill using nonzero winding number rule
	        - f*  fill using even-odd rule
	        - B fill then stroke with fill using non-zero winding number rule
	        - B*  fill then stroke with fill using even-odd rule
	        */
	        op = style;
	      }
	      return op;
	    },
	    getArrayBuffer = function() {
	      var data = buildDocument(), len = data.length,
	        ab = new ArrayBuffer(len), u8 = new Uint8Array(ab);

	      while(len--) u8[len] = data.charCodeAt(len);
	      return ab;
	    },
	    getBlob = function() {
	      return new Blob([getArrayBuffer()], { type : "application/pdf;charset=utf-8" });
	    },
	    /**
	     * Generates the PDF document.
	     *
	     * If `type` argument is undefined, output is raw body of resulting PDF returned as a string.
	     *
	     * @param {String} type A string identifying one of the possible output types.
	     * @param {Object} options An object providing some additional signalling to PDF generator.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name output
	     */
	    output = SAFE(function(type, options) {
	      var datauri = ('' + type).substr(0,6) === 'dataur'
	        ? 'data:application/pdf;base64,'+btoa(buildDocument()):0;

	      switch (type) {
	        case undefined:
	          return buildDocument();
	        case 'save':
	          if (navigator.getUserMedia) {
	            if (global.URL === undefined
	            || global.URL.createObjectURL === undefined) {
	              return API.output('dataurlnewwindow');
	            }
	          }
	          saveAs(getBlob(), options);
	          if(typeof saveAs.unload === 'function') {
	            if(global.setTimeout) {
	              setTimeout(saveAs.unload,911);
	            }
	          }
	          break;
	        case 'arraybuffer':
	          return getArrayBuffer();
	        case 'blob':
	          return getBlob();
	        case 'bloburi':
	        case 'bloburl':
	          // User is responsible of calling revokeObjectURL
	          return global.URL && global.URL.createObjectURL(getBlob()) || void 0;
	        case 'datauristring':
	        case 'dataurlstring':
	          return datauri;
	        case 'dataurlnewwindow':
	          var nW = global.open(datauri);
	          if (nW || typeof safari === "undefined") return nW;
	          /* pass through */
	        case 'datauri':
	        case 'dataurl':
	          return global.document.location.href = datauri;
	        default:
	          throw new Error('Output type "' + type + '" is not supported.');
	      }
	    });

	    switch (unit) {
	      case 'pt':  k = 1;          break;
	      case 'mm':  k = 72 / 25.4;  break;
	      case 'cm':  k = 72 / 2.54;  break;
	      case 'in':  k = 72;         break;
	      case 'px':  k = 96 / 72;    break;
	      case 'pc':  k = 12;         break;
	      case 'em':  k = 12;         break;
	      case 'ex':  k = 6;          break;
	      default:
	        throw ('Invalid unit: ' + unit);
	    }

	    // Dimensions are stored as user units and converted to points on output
	    if (pageFormats.hasOwnProperty(format_as_string)) {
	      pageHeight = pageFormats[format_as_string][1] / k;
	      pageWidth = pageFormats[format_as_string][0] / k;
	    } else {
	      try {
	        pageHeight = format[1];
	        pageWidth = format[0];
	      } catch (err) {
	        throw new Error('Invalid format: ' + format);
	      }
	    }

	    if (orientation === 'p' || orientation === 'portrait') {
	      orientation = 'p';
	      if (pageWidth > pageHeight) {
	        tmp = pageWidth;
	        pageWidth = pageHeight;
	        pageHeight = tmp;
	      }
	    } else if (orientation === 'l' || orientation === 'landscape') {
	      orientation = 'l';
	      if (pageHeight > pageWidth) {
	        tmp = pageWidth;
	        pageWidth = pageHeight;
	        pageHeight = tmp;
	      }
	    } else {
	      throw('Invalid orientation: ' + orientation);
	    }

	    //---------------------------------------
	    // Public API

	    /**
	     * Object exposing internal API to plugins
	     * @public
	     */
	    API.internal = {
	      'pdfEscape' : pdfEscape,
	      'getStyle' : getStyle,
	      /**
	       * Returns {FontObject} describing a particular font.
	       * @public
	       * @function
	       * @param fontName {String} (Optional) Font's family name
	       * @param fontStyle {String} (Optional) Font's style variation name (Example:"Italic")
	       * @returns {FontObject}
	       */
	      'getFont' : function() {
	        return fonts[getFont.apply(API, arguments)];
	      },
	      'getFontSize' : function() {
	        return activeFontSize;
	      },
	      'getLineHeight' : function() {
	        return activeFontSize * lineHeightProportion;
	      },
	      'write' : function(string1 /*, string2, string3, etc */) {
	        out(arguments.length === 1 ? string1 : Array.prototype.join.call(arguments, ' '));
	      },
	      'getCoordinateString' : function(value) {
	        return f2(value * k);
	      },
	      'getVerticalCoordinateString' : function(value) {
	        return f2((pageHeight - value) * k);
	      },
	      'collections' : {},
	      'newObject' : newObject,
	      'putStream' : putStream,
	      'events' : events,
	      // ratio that you use in multiplication of a given "size" number to arrive to 'point'
	      // units of measurement.
	      // scaleFactor is set at initialization of the document and calculated against the stated
	      // default measurement units for the document.
	      // If default is "mm", k is the number that will turn number in 'mm' into 'points' number.
	      // through multiplication.
	      'scaleFactor' : k,
	      'pageSize' : {
	        'width' : pageWidth,
	        'height' : pageHeight
	      },
	      'output' : function(type, options) {
	        return output(type, options);
	      },
	      'getNumberOfPages' : function() {
	        return pages.length - 1;
	      },
	      'pages' : pages
	    };

	    /**
	     * Adds (and transfers the focus to) new page to the PDF document.
	     * @function
	     * @returns {jsPDF}
	     *
	     * @methodOf jsPDF#
	     * @name addPage
	     */
	    API.addPage = function() {
	      _addPage();
	      return this;
	    };

	    /**
	     * Adds text to page. Supports adding multiline text when 'text' argument is an Array of Strings.
	     *
	     * @function
	     * @param {String|Array} text String or array of strings to be added to the page. Each line is shifted one line down per font, spacing settings declared before this call.
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Object} flags Collection of settings signalling how the text must be encoded. Defaults are sane. If you think you want to pass some flags, you likely can read the source.
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name text
	     */
	    API.text = function(text, x, y, flags, angle) {
	      /**
	       * Inserts something like this into PDF
	       *   BT
	       *    /F1 16 Tf  % Font name + size
	       *    16 TL % How many units down for next line in multiline text
	       *    0 g % color
	       *    28.35 813.54 Td % position
	       *    (line one) Tj
	       *    T* (line two) Tj
	       *    T* (line three) Tj
	       *   ET
	       */
	      function ESC(s) {
	        s = s.split("\t").join(Array(options.TabLen||9).join(" "));
	        return pdfEscape(s, flags);
	      }

	      // Pre-August-2012 the order of arguments was function(x, y, text, flags)
	      // in effort to make all calls have similar signature like
	      //   function(data, coordinates... , miscellaneous)
	      // this method had its args flipped.
	      // code below allows backward compatibility with old arg order.
	      if (typeof text === 'number') {
	        tmp = y;
	        y = x;
	        x = text;
	        text = tmp;
	      }

	      // If there are any newlines in text, we assume
	      // the user wanted to print multiple lines, so break the
	      // text up into an array.  If the text is already an array,
	      // we assume the user knows what they are doing.
	      if (typeof text === 'string' && text.match(/[\n\r]/)) {
	        text = text.split(/\r\n|\r|\n/g);
	      }
	      if (typeof flags === 'number') {
	        angle = flags;
	        flags = null;
	      }
	      var xtra = '',mode = 'Td';
	      if (angle) {
	        angle *= (Math.PI / 180);
	        var c = Math.cos(angle),
	        s = Math.sin(angle);
	        xtra = [f2(c), f2(s), f2(s * -1), f2(c), ''].join(" ");
	        mode = 'Tm';
	      }
	      flags = flags || {};
	      if (!('noBOM' in flags))
	        flags.noBOM = true;
	      if (!('autoencode' in flags))
	        flags.autoencode = true;

	      var rawtext = text;
	      if (typeof text === 'string') {
	        text = ESC(text);
	      } else if (text instanceof Array) {
	        // we don't want to destroy  original text array, so cloning it
	        var sa = text.concat(), da = [], len = sa.length;
	        // we do array.join('text that must not be PDFescaped")
	        // thus, pdfEscape each component separately
	        while (len--) {
	          da.push(ESC(sa.shift()));
	        }
	        text = da.join(") Tj\nT* (");
	      } else {
	        throw new Error('Type of text must be string or Array. "' + text + '" is not recognized.');
	      }
	      // Using "'" ("go next line and render text" mark) would save space but would complicate our rendering code, templates

	      // BT .. ET does NOT have default settings for Tf. You must state that explicitely every time for BT .. ET
	      // if you want text transformation matrix (+ multiline) to work reliably (which reads sizes of things from font declarations)
	      // Thus, there is NO useful, *reliable* concept of "default" font for a page.
	      // The fact that "default" (reuse font used before) font worked before in basic cases is an accident
	      // - readers dealing smartly with brokenness of jsPDF's markup.

	      var font = fonts[activeFontKey];
	      out(
	        'BT\n/' +
	        activeFontKey + ' ' + activeFontSize + ' Tf\n' +     // font face, style, size
	        (activeFontSize * lineHeightProportion) + ' TL\n' +  // line spacing
	        textColor +
	        '\n' + xtra + f2(x * k) + ' ' + f2((pageHeight - y) * k) + ' ' + mode
	      );
	      if (font && font.pdfkitFont) {
	        font.pdfkitFont.use(rawtext);
	        var encoded = font.pdfkitFont.encode(rawtext);
	        encoded = ((function() {
	          var m, ref, results;
	          results = [];
	          for (var i = m = 0, ref = encoded.length; m < ref; i = m += 1) {
	            results.push(encoded.charCodeAt(i).toString(16));
	          }
	          return results;
	        })()).join('');
	        out('<' + encoded + '> Tj');
	      } else {
	        out('(' + text + ') Tj');
	      }
	      out('ET');
	      return this;
	    };

	    API.encodeText = function(text, fontKey) {
	      var font = fonts[fontKey];
	      if (font && font.pdfkitFont) {
	        font.pdfkitFont.use(text);
	        var encoded = font.pdfkitFont.encode(text);
	        encoded = ((function() {
	          var m, ref, results;
	          results = [];
	          for (var i = m = 0, ref = encoded.length; m < ref; i = m += 1) {
	            results.push(encoded.charCodeAt(i).toString(16));
	          }
	          return results;
	        })()).join('');
	        return encoded;
	      }
	      return text;
	    }

	    API.line = function(x1, y1, x2, y2) {
	      return this.lines([[x2 - x1, y2 - y1]], x1, y1);
	    };

	    /**
	     * Adds series of curves (straight lines or cubic bezier curves) to canvas, starting at `x`, `y` coordinates.
	     * All data points in `lines` are relative to last line origin.
	     * `x`, `y` become x1,y1 for first line / curve in the set.
	     * For lines you only need to specify [x2, y2] - (ending point) vector against x1, y1 starting point.
	     * For bezier curves you need to specify [x2,y2,x3,y3,x4,y4] - vectors to control points 1, 2, ending point. All vectors are against the start of the curve - x1,y1.
	     *
	     * @example .lines([[2,2],[-2,2],[1,1,2,2,3,3],[2,1]], 212,110, 10) // line, line, bezier curve, line
	     * @param {Array} lines Array of *vector* shifts as pairs (lines) or sextets (cubic bezier curves).
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} scale (Defaults to [1.0,1.0]) x,y Scaling factor for all vectors. Elements can be any floating number Sub-one makes drawing smaller. Over-one grows the drawing. Negative flips the direction.
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @param {Boolean} closed If true, the path is closed with a straight line from the end of the last curve to the starting point.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name lines
	     */
	    API.lines = function(lines, x, y, scale, style, closed) {
	      var scalex,scaley,i,l,leg,x2,y2,x3,y3,x4,y4;

	      // Pre-August-2012 the order of arguments was function(x, y, lines, scale, style)
	      // in effort to make all calls have similar signature like
	      //   function(content, coordinateX, coordinateY , miscellaneous)
	      // this method had its args flipped.
	      // code below allows backward compatibility with old arg order.
	      if (typeof lines === 'number') {
	        tmp = y;
	        y = x;
	        x = lines;
	        lines = tmp;
	      }

	      scale = scale || [1, 1];

	      // starting point
	      out(f3(x * k) + ' ' + f3((pageHeight - y) * k) + ' m ');

	      scalex = scale[0];
	      scaley = scale[1];
	      l = lines.length;
	      //, x2, y2 // bezier only. In page default measurement "units", *after* scaling
	      //, x3, y3 // bezier only. In page default measurement "units", *after* scaling
	      // ending point for all, lines and bezier. . In page default measurement "units", *after* scaling
	      x4 = x; // last / ending point = starting point for first item.
	      y4 = y; // last / ending point = starting point for first item.

	      for (i = 0; i < l; i++) {
	        leg = lines[i];
	        if (leg.length === 2) {
	          // simple line
	          x4 = leg[0] * scalex + x4; // here last x4 was prior ending point
	          y4 = leg[1] * scaley + y4; // here last y4 was prior ending point
	          out(f3(x4 * k) + ' ' + f3((pageHeight - y4) * k) + ' l');
	        } else {
	          // bezier curve
	          x2 = leg[0] * scalex + x4; // here last x4 is prior ending point
	          y2 = leg[1] * scaley + y4; // here last y4 is prior ending point
	          x3 = leg[2] * scalex + x4; // here last x4 is prior ending point
	          y3 = leg[3] * scaley + y4; // here last y4 is prior ending point
	          x4 = leg[4] * scalex + x4; // here last x4 was prior ending point
	          y4 = leg[5] * scaley + y4; // here last y4 was prior ending point
	          out(
	            f3(x2 * k) + ' ' +
	            f3((pageHeight - y2) * k) + ' ' +
	            f3(x3 * k) + ' ' +
	            f3((pageHeight - y3) * k) + ' ' +
	            f3(x4 * k) + ' ' +
	            f3((pageHeight - y4) * k) + ' c');
	        }
	      }

	      if (closed) {
	        out(' h');
	      }

	      // stroking / filling / both the path
	      if (style !== null) {
	        out(getStyle(style));
	      }
	      return this;
	    };

	    /**
	     * Adds a rectangle to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} w Width (in units declared at inception of PDF document)
	     * @param {Number} h Height (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name rect
	     */
	    API.rect = function(x, y, w, h, style) {
	      var op = getStyle(style);
	      out([
	          f2(x * k),
	          f2((pageHeight - y) * k),
	          f2(w * k),
	          f2(-h * k),
	          're'
	        ].join(' '));

	      if (style !== null) {
	        out(getStyle(style));
	      }

	      return this;
	    };

	    /**
	     * Adds a triangle to PDF
	     *
	     * @param {Number} x1 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y1 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} x2 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y2 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} x3 Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y3 Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name triangle
	     */
	    API.triangle = function(x1, y1, x2, y2, x3, y3, style) {
	      this.lines(
	        [
	          [x2 - x1, y2 - y1], // vector to point 2
	          [x3 - x2, y3 - y2], // vector to point 3
	          [x1 - x3, y1 - y3]// closing vector back to point 1
	        ],
	        x1,
	        y1, // start of path
	        [1, 1],
	        style,
	        true);
	      return this;
	    };

	    /**
	     * Adds a rectangle with rounded corners to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} w Width (in units declared at inception of PDF document)
	     * @param {Number} h Height (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name roundedRect
	     */
	    API.roundedRect = function(x, y, w, h, rx, ry, style) {
	      var MyArc = 4 / 3 * (Math.SQRT2 - 1);
	      this.lines(
	        [
	          [(w - 2 * rx), 0],
	          [(rx * MyArc), 0, rx, ry - (ry * MyArc), rx, ry],
	          [0, (h - 2 * ry)],
	          [0, (ry * MyArc),  - (rx * MyArc), ry, -rx, ry],
	          [(-w + 2 * rx), 0],
	          [ - (rx * MyArc), 0, -rx,  - (ry * MyArc), -rx, -ry],
	          [0, (-h + 2 * ry)],
	          [0,  - (ry * MyArc), (rx * MyArc), -ry, rx, -ry]
	        ],
	        x + rx,
	        y, // start of path
	        [1, 1],
	        style);
	      return this;
	    };

	    /**
	     * Adds an ellipse to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} rx Radius along x axis (in units declared at inception of PDF document)
	     * @param {Number} rx Radius along y axis (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name ellipse
	     */
	    API.ellipse = function(x, y, rx, ry, style) {
	      var lx = 4 / 3 * (Math.SQRT2 - 1) * rx,
	        ly = 4 / 3 * (Math.SQRT2 - 1) * ry;

	      out([
	          f2((x + rx) * k),
	          f2((pageHeight - y) * k),
	          'm',
	          f2((x + rx) * k),
	          f2((pageHeight - (y - ly)) * k),
	          f2((x + lx) * k),
	          f2((pageHeight - (y - ry)) * k),
	          f2(x * k),
	          f2((pageHeight - (y - ry)) * k),
	          'c'
	        ].join(' '));
	      out([
	          f2((x - lx) * k),
	          f2((pageHeight - (y - ry)) * k),
	          f2((x - rx) * k),
	          f2((pageHeight - (y - ly)) * k),
	          f2((x - rx) * k),
	          f2((pageHeight - y) * k),
	          'c'
	        ].join(' '));
	      out([
	          f2((x - rx) * k),
	          f2((pageHeight - (y + ly)) * k),
	          f2((x - lx) * k),
	          f2((pageHeight - (y + ry)) * k),
	          f2(x * k),
	          f2((pageHeight - (y + ry)) * k),
	          'c'
	        ].join(' '));
	      out([
	          f2((x + lx) * k),
	          f2((pageHeight - (y + ry)) * k),
	          f2((x + rx) * k),
	          f2((pageHeight - (y + ly)) * k),
	          f2((x + rx) * k),
	          f2((pageHeight - y) * k),
	          'c'
	        ].join(' '));

	      if (style !== null) {
	        out(getStyle(style));
	      }

	      return this;
	    };

	    /**
	     * Adds an circle to PDF
	     *
	     * @param {Number} x Coordinate (in units declared at inception of PDF document) against left edge of the page
	     * @param {Number} y Coordinate (in units declared at inception of PDF document) against upper edge of the page
	     * @param {Number} r Radius (in units declared at inception of PDF document)
	     * @param {String} style A string specifying the painting style or null.  Valid styles include: 'S' [default] - stroke, 'F' - fill,  and 'DF' (or 'FD') -  fill then stroke. A null value postpones setting the style so that a shape may be composed using multiple method calls. The last drawing method call used to define the shape should not have a null style argument.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name circle
	     */
	    API.circle = function(x, y, r, style) {
	      return this.ellipse(x, y, r, r, style);
	    };

	    /**
	     * Adds a properties to the PDF document
	     *
	     * @param {Object} A property_name-to-property_value object structure.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setProperties
	     */
	    API.setProperties = function(properties) {
	      // copying only those properties we can render.
	      for (var property in documentProperties) {
	        if (documentProperties.hasOwnProperty(property) && properties[property]) {
	          documentProperties[property] = properties[property];
	        }
	      }
	      return this;
	    };

	    /**
	     * Sets font size for upcoming text elements.
	     *
	     * @param {Number} size Font size in points.
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFontSize
	     */
	    API.setFontSize = function(size) {
	      activeFontSize = size;
	      return this;
	    };

	    /**
	     * Sets text font face, variant for upcoming text elements.
	     * See output of jsPDF.getFontList() for possible font names, styles.
	     *
	     * @param {String} fontName Font name or family. Example: "times"
	     * @param {String} fontStyle Font style or variant. Example: "italic"
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFont
	     */
	    API.setFont = function(fontName, fontStyle) {
	      activeFontKey = getFont(fontName, fontStyle);
	      // if font is not found, the above line blows up and we never go further
	      return this;
	    };

	    /**
	     * Switches font style or variant for upcoming text elements,
	     * while keeping the font face or family same.
	     * See output of jsPDF.getFontList() for possible font names, styles.
	     *
	     * @param {String} style Font style or variant. Example: "italic"
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFontStyle
	     */
	    API.setFontStyle = API.setFontType = function(style) {
	      activeFontKey = getFont(undefined, style);
	      // if font is not found, the above line blows up and we never go further
	      return this;
	    };

	    /**
	     * Returns an object - a tree of fontName to fontStyle relationships available to
	     * active PDF document.
	     *
	     * @public
	     * @function
	     * @returns {Object} Like {'times':['normal', 'italic', ... ], 'arial':['normal', 'bold', ... ], ... }
	     * @methodOf jsPDF#
	     * @name getFontList
	     */
	    API.getFontList = function() {
	      var list = {},fontName,fontStyle,tmp;

	      for (fontName in fontmap) {
	        if (fontmap.hasOwnProperty(fontName)) {
	          list[fontName] = tmp = [];
	          for (fontStyle in fontmap[fontName]) {
	            if (fontmap[fontName].hasOwnProperty(fontStyle)) {
	              tmp.push(fontStyle);
	            }
	          }
	        }
	      }

	      return list;
	    };

	    /**
	     * Sets line width for upcoming lines.
	     *
	     * @param {Number} width Line width (in units declared at inception of PDF document)
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineWidth
	     */
	    API.setLineWidth = function(width) {
	      out((width * k).toFixed(2) + ' w');
	      return this;
	    };

	    /**
	     * Sets the stroke color for upcoming elements.
	     *
	     * Depending on the number of arguments given, Gray, RGB, or CMYK
	     * color space is implied.
	     *
	     * When only ch1 is given, "Gray" color space is implied and it
	     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
	     * if values are communicated as String types, or in range from 0 (black)
	     * to 255 (white) if communicated as Number type.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
	     * value must be in the range from 0.00 (minimum intensity) to to 1.00
	     * (max intensity) if values are communicated as String types, or
	     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
	     * as Number types.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
	     * value must be a in the range from 0.00 (0% concentration) to to
	     * 1.00 (100% concentration)
	     *
	     * Because JavaScript treats fixed point numbers badly (rounds to
	     * floating point nearest to binary representation) it is highly advised to
	     * communicate the fractional numbers as String types, not JavaScript Number type.
	     *
	     * @param {Number|String} ch1 Color channel value
	     * @param {Number|String} ch2 Color channel value
	     * @param {Number|String} ch3 Color channel value
	     * @param {Number|String} ch4 Color channel value
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setDrawColor
	     */
	    API.setDrawColor = function(ch1, ch2, ch3, ch4) {
	      var color;
	      if (ch2 === undefined || (ch4 === undefined && ch1 === ch2 === ch3)) {
	        // Gray color space.
	        if (typeof ch1 === 'string') {
	          color = ch1 + ' G';
	        } else {
	          color = f2(ch1 / 255) + ' G';
	        }
	      } else if (ch4 === undefined) {
	        // RGB
	        if (typeof ch1 === 'string') {
	          color = [ch1, ch2, ch3, 'RG'].join(' ');
	        } else {
	          color = [f2(ch1 / 255), f2(ch2 / 255), f2(ch3 / 255), 'RG'].join(' ');
	        }
	      } else {
	        // CMYK
	        if (typeof ch1 === 'string') {
	          color = [ch1, ch2, ch3, ch4, 'K'].join(' ');
	        } else {
	          color = [f2(ch1), f2(ch2), f2(ch3), f2(ch4), 'K'].join(' ');
	        }
	      }

	      out(color);
	      return this;
	    };

	    /**
	     * Sets the fill color for upcoming elements.
	     *
	     * Depending on the number of arguments given, Gray, RGB, or CMYK
	     * color space is implied.
	     *
	     * When only ch1 is given, "Gray" color space is implied and it
	     * must be a value in the range from 0.00 (solid black) to to 1.00 (white)
	     * if values are communicated as String types, or in range from 0 (black)
	     * to 255 (white) if communicated as Number type.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When only ch1,ch2,ch3 are given, "RGB" color space is implied and each
	     * value must be in the range from 0.00 (minimum intensity) to to 1.00
	     * (max intensity) if values are communicated as String types, or
	     * from 0 (min intensity) to to 255 (max intensity) if values are communicated
	     * as Number types.
	     * The RGB-like 0-255 range is provided for backward compatibility.
	     *
	     * When ch1,ch2,ch3,ch4 are given, "CMYK" color space is implied and each
	     * value must be a in the range from 0.00 (0% concentration) to to
	     * 1.00 (100% concentration)
	     *
	     * Because JavaScript treats fixed point numbers badly (rounds to
	     * floating point nearest to binary representation) it is highly advised to
	     * communicate the fractional numbers as String types, not JavaScript Number type.
	     *
	     * @param {Number|String} ch1 Color channel value
	     * @param {Number|String} ch2 Color channel value
	     * @param {Number|String} ch3 Color channel value
	     * @param {Number|String} ch4 Color channel value
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setFillColor
	     */
	    API.setFillColor = function(ch1, ch2, ch3, ch4) {
	      var color;

	      if (ch2 === undefined || (ch4 === undefined && ch1 === ch2 === ch3)) {
	        // Gray color space.
	        if (typeof ch1 === 'string') {
	          color = ch1 + ' g';
	        } else {
	          color = f2(ch1 / 255) + ' g';
	        }
	      } else if (ch4 === undefined) {
	        // RGB
	        if (typeof ch1 === 'string') {
	          color = [ch1, ch2, ch3, 'rg'].join(' ');
	        } else {
	          color = [f2(ch1 / 255), f2(ch2 / 255), f2(ch3 / 255), 'rg'].join(' ');
	        }
	      } else {
	        // CMYK
	        if (typeof ch1 === 'string') {
	          color = [ch1, ch2, ch3, ch4, 'k'].join(' ');
	        } else {
	          color = [f2(ch1), f2(ch2), f2(ch3), f2(ch4), 'k'].join(' ');
	        }
	      }

	      out(color);
	      return this;
	    };

	    /**
	     * Sets the text color for upcoming elements.
	     * If only one, first argument is given,
	     * treats the value as gray-scale color value.
	     *
	     * @param {Number} r Red channel color value in range 0-255 or {String} r color value in hexadecimal, example: '#FFFFFF'
	     * @param {Number} g Green channel color value in range 0-255
	     * @param {Number} b Blue channel color value in range 0-255
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setTextColor
	     */
	    API.setTextColor = function(r, g, b) {
	      if ((typeof r === 'string') && /^#[0-9A-Fa-f]{6}$/.test(r)) {
	        var hex = parseInt(r.substr(1), 16);
	        r = (hex >> 16) & 255;
	        g = (hex >> 8) & 255;
	        b = (hex & 255);
	      }

	      if ((r === 0 && g === 0 && b === 0) || (typeof g === 'undefined')) {
	        textColor = f3(r / 255) + ' g';
	      } else {
	        textColor = [f3(r / 255), f3(g / 255), f3(b / 255), 'rg'].join(' ');
	      }
	      return this;
	    };

	    /**
	     * Is an Object providing a mapping from human-readable to
	     * integer flag values designating the varieties of line cap
	     * and join styles.
	     *
	     * @returns {Object}
	     * @fieldOf jsPDF#
	     * @name CapJoinStyles
	     */
	    API.CapJoinStyles = {
	      0 : 0,
	      'butt' : 0,
	      'but' : 0,
	      'miter' : 0,
	      1 : 1,
	      'round' : 1,
	      'rounded' : 1,
	      'circle' : 1,
	      2 : 2,
	      'projecting' : 2,
	      'project' : 2,
	      'square' : 2,
	      'bevel' : 2
	    };

	    /**
	     * Sets the line cap styles
	     * See {jsPDF.CapJoinStyles} for variants
	     *
	     * @param {String|Number} style A string or number identifying the type of line cap
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineCap
	     */
	    API.setLineCap = function(style) {
	      var id = this.CapJoinStyles[style];
	      if (id === undefined) {
	        throw new Error("Line cap style of '" + style + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
	      }
	      lineCapID = id;
	      out(id + ' J');

	      return this;
	    };

	    /**
	     * Sets the line join styles
	     * See {jsPDF.CapJoinStyles} for variants
	     *
	     * @param {String|Number} style A string or number identifying the type of line join
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name setLineJoin
	     */
	    API.setLineJoin = function(style) {
	      var id = this.CapJoinStyles[style];
	      if (id === undefined) {
	        throw new Error("Line join style of '" + style + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
	      }
	      lineJoinID = id;
	      out(id + ' j');

	      return this;
	    };

	    // Output is both an internal (for plugins) and external function
	    API.output = output;

	    API.registerEmbeddableFont = registerEmbeddableFont;
	    API.addFont = addFont;
	    API.fetchEmbeddableFonts = fetchEmbeddableFonts;
	    // API.embedFont = embedFont;

	    /**
	     * Saves as PDF document. An alias of jsPDF.output('save', 'filename.pdf')
	     * @param  {String} filename The filename including extension.
	     *
	     * @function
	     * @returns {jsPDF}
	     * @methodOf jsPDF#
	     * @name save
	     */
	    API.save = function(filename) {
	      API.output('save', filename);
	    };

	    // applying plugins (more methods) ON TOP of built-in API.
	    // this is intentional as we allow plugins to override
	    // built-ins
	    for (var plugin in jsPDF.API) {
	      if (jsPDF.API.hasOwnProperty(plugin)) {
	        if (plugin === 'events' && jsPDF.API.events.length) {
	          (function(events, newEvents) {

	            // jsPDF.API.events is a JS Array of Arrays
	            // where each Array is a pair of event name, handler
	            // Events were added by plugins to the jsPDF instantiator.
	            // These are always added to the new instance and some ran
	            // during instantiation.
	            var eventname,handler_and_args,i;

	            for (i = newEvents.length - 1; i !== -1; i--) {
	              // subscribe takes 3 args: 'topic', function, runonce_flag
	              // if undefined, runonce is false.
	              // users can attach callback directly,
	              // or they can attach an array with [callback, runonce_flag]
	              // that's what the "apply" magic is for below.
	              eventname = newEvents[i][0];
	              handler_and_args = newEvents[i][1];
	              events.subscribe.apply(
	                events,
	                [eventname].concat(
	                  typeof handler_and_args === 'function' ?
	                    [handler_and_args] : handler_and_args));
	            }
	          }(events, jsPDF.API.events));
	        } else {
	          API[plugin] = jsPDF.API[plugin];
	        }
	      }
	    }

	    //////////////////////////////////////////////////////
	    // continuing initialization of jsPDF Document object
	    //////////////////////////////////////////////////////
	    // Add the first page automatically
	    addFonts();
	    activeFontKey = 'F1';
	    _addPage();

	    events.publish('initialized');
	    return API;
	  }

	  /**
	   * jsPDF.API is a STATIC property of jsPDF class.
	   * jsPDF.API is an object you can add methods and properties to.
	   * The methods / properties you add will show up in new jsPDF objects.
	   *
	   * One property is prepopulated. It is the 'events' Object. Plugin authors can add topics,
	   * callbacks to this object. These will be reassigned to all new instances of jsPDF.
	   * Examples:
	   * jsPDF.API.events['initialized'] = function(){ 'this' is API object }
	   * jsPDF.API.events['addFont'] = function(added_font_object){ 'this' is API object }
	   *
	   * @static
	   * @public
	   * @memberOf jsPDF
	   * @name API
	   *
	   * @example
	   * jsPDF.API.mymethod = function(){
	   *   // 'this' will be ref to internal API object. see jsPDF source
	   *   // , so you can refer to built-in methods like so:
	   *   //     this.line(....)
	   *   //     this.text(....)
	   * }
	   * var pdfdoc = new jsPDF()
	   * pdfdoc.mymethod() // <- !!!!!!
	   */
	  jsPDF.API = {events:[]};
	  jsPDF.version = "1.0.203-debug 2014-07-22T04:20:diegocr";
	  jsPDF.saveAs = saveAs;

	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return jsPDF;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (module && module.exports) {
	    module.exports = jsPDF;
	  } else {
	    global.jsPDF = jsPDF;
	  }
	  return jsPDF;
	}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this));
	/**
	 * jsPDF addHTML PlugIn
	 * Copyright (c) 2014 Diego Casorran
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */

	(function (jsPDFAPI) {
	  'use strict';

	  /**
	   * Renders an HTML element to canvas object which added as an image to the PDF
	   *
	   * This PlugIn requires html2canvas: https://github.com/niklasvh/html2canvas
	   *            OR rasterizeHTML: https://github.com/cburgmer/rasterizeHTML.js
	   *
	   * @public
	   * @function
	   * @param element {Mixed} HTML Element, or anything supported by html2canvas.
	   * @param x {Number} starting X coordinate in jsPDF instance's declared units.
	   * @param y {Number} starting Y coordinate in jsPDF instance's declared units.
	   * @param options {Object} Additional options, check the code below.
	   * @param callback {Function} to call when the rendering has finished.
	   *
	   * NOTE: Every parameter is optional except 'element' and 'callback', in such
	   *       case the image is positioned at 0x0 covering the whole PDF document
	   *       size. Ie, to easily take screenshoots of webpages saving them to PDF.
	   */
	  jsPDFAPI.addHTML = function (element, x, y, options, callback) {
	    'use strict';

	    if(typeof html2canvas === 'undefined' && typeof rasterizeHTML === 'undefined')
	      throw new Error('You need either '
	        +'https://github.com/niklasvh/html2canvas'
	        +' or https://github.com/cburgmer/rasterizeHTML.js');

	    if(typeof x !== 'number') {
	      options = x;
	      callback = y;
	    }

	    if(typeof options === 'function') {
	      callback = options;
	      options = null;
	    }

	    var I = this.internal, K = I.scaleFactor, W = I.pageSize.width, H = I.pageSize.height;

	    options = options || {};
	    options.onrendered = function(obj) {
	      x = parseInt(x) || 0;
	      y = parseInt(y) || 0;
	      var dim = options.dim || {};
	      var h = dim.h || 0;
	      var w = dim.w || Math.min(W,obj.width/K) - x;

	      var format = 'JPEG';
	      if(options.format)
	        format = options.format;

	      if(obj.height > H && options.pagesplit) {
	        var crop = function() {
	          var cy = 0;
	          while(1) {
	            var canvas = document.createElement('canvas');
	            canvas.width = Math.min(W*K,obj.width);
	            canvas.height = Math.min(H*K,obj.height-cy);
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(obj,0,cy,obj.width,canvas.height,0,0,canvas.width,canvas.height);
	            var args = [canvas, x,cy?0:y,canvas.width/K,canvas.height/K, format,null,'SLOW'];
	            this.addImage.apply(this, args);
	            cy += canvas.height;
	            if(cy >= obj.height) break;
	            this.addPage();
	          }
	          callback(w,cy,null,args);
	        }.bind(this);
	        if(obj.nodeName === 'CANVAS') {
	          var img = new Image();
	          img.onload = crop;
	          img.src = obj.toDataURL("image/png");
	          obj = img;
	        } else {
	          crop();
	        }
	      } else {
	        var alias = Math.random().toString(35);
	        var args = [obj, x,y,w,h, format,alias,'SLOW'];

	        this.addImage.apply(this, args);

	        callback(w,h,alias,args);
	      }
	    }.bind(this);

	    if(typeof html2canvas !== 'undefined' && !options.rstz) {
	      return html2canvas(element, options);
	    }

	    if(typeof rasterizeHTML !== 'undefined') {
	      var meth = 'drawDocument';
	      if(typeof element === 'string') {
	        meth = /^http/.test(element) ? 'drawURL' : 'drawHTML';
	      }
	      options.width = options.width || (W*K);
	      return rasterizeHTML[meth](element, void 0, options).then(function(r) {
	        options.onrendered(r.image);
	      }, function(e) {
	        callback(null,e);
	      });
	    }

	    return null;
	  };
	})(jsPDF.API);
	/** @preserve
	 * jsPDF addImage plugin
	 * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
	 *               2013 Chris Dowling, https://github.com/gingerchris
	 *               2013 Trinh Ho, https://github.com/ineedfat
	 *               2013 Edwin Alejandro Perez, https://github.com/eaparango
	 *               2013 Norah Smith, https://github.com/burnburnrocket
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 James Robb, https://github.com/jamesbrobb
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */

	;(function(jsPDFAPI) {
	  'use strict'

	  var namespace = 'addImage_',
	    supported_image_types = ['jpeg', 'jpg', 'png'];

	  // Image functionality ported from pdf.js
	  var putImage = function(img) {

	    var objectNumber = this.internal.newObject()
	    , out = this.internal.write
	    , putStream = this.internal.putStream

	    img['n'] = objectNumber

	    out('<</Type /XObject')
	    out('/Subtype /Image')
	    out('/Width ' + img['w'])
	    out('/Height ' + img['h'])
	    if (img['cs'] === this.color_spaces.INDEXED) {
	      out('/ColorSpace [/Indexed /DeviceRGB '
	          // if an indexed png defines more than one colour with transparency, we've created a smask
	          + (img['pal'].length / 3 - 1) + ' ' + ('smask' in img ? objectNumber + 2 : objectNumber + 1)
	          + ' 0 R]');
	    } else {
	      out('/ColorSpace /' + img['cs']);
	      if (img['cs'] === this.color_spaces.DEVICE_CMYK) {
	        out('/Decode [1 0 1 0 1 0 1 0]');
	      }
	    }
	    out('/BitsPerComponent ' + img['bpc']);
	    if ('f' in img) {
	      out('/Filter /' + img['f']);
	    }
	    if ('dp' in img) {
	      out('/DecodeParms <<' + img['dp'] + '>>');
	    }
	    if ('trns' in img && img['trns'].constructor == Array) {
	      var trns = '',
	        i = 0,
	        len = img['trns'].length;
	      for (; i < len; i++)
	        trns += (img['trns'][i] + ' ' + img['trns'][i] + ' ');
	      out('/Mask [' + trns + ']');
	    }
	    if ('smask' in img) {
	      out('/SMask ' + (objectNumber + 1) + ' 0 R');
	    }
	    out('/Length ' + img['data'].length + '>>');

	    putStream(img['data']);

	    out('endobj');

	    // Soft mask
	    if ('smask' in img) {
	      var dp = '/Predictor 15 /Colors 1 /BitsPerComponent ' + img['bpc'] + ' /Columns ' + img['w'];
	      var smask = {'w': img['w'], 'h': img['h'], 'cs': 'DeviceGray', 'bpc': img['bpc'], 'dp': dp, 'data': img['smask']};
	      if ('f' in img)
	        smask.f = img['f'];
	      putImage.call(this, smask);
	    }

	      //Palette
	    if (img['cs'] === this.color_spaces.INDEXED) {

	      this.internal.newObject();
	      //out('<< /Filter / ' + img['f'] +' /Length ' + img['pal'].length + '>>');
	      //putStream(zlib.compress(img['pal']));
	      out('<< /Length ' + img['pal'].length + '>>');
	      putStream(this.arrayBufferToBinaryString(new Uint8Array(img['pal'])));
	      out('endobj');
	    }
	  }
	  , putResourcesCallback = function() {
	    var images = this.internal.collections[namespace + 'images']
	    for ( var i in images ) {
	      putImage.call(this, images[i])
	    }
	  }
	  , putXObjectsDictCallback = function(){
	    var images = this.internal.collections[namespace + 'images']
	    , out = this.internal.write
	    , image
	    for (var i in images) {
	      image = images[i]
	      out(
	        '/I' + image['i']
	        , image['n']
	        , '0'
	        , 'R'
	      )
	    }
	  }
	  , checkCompressValue = function(value) {
	    if(value && typeof value === 'string')
	      value = value.toUpperCase();
	    return value in jsPDFAPI.image_compression ? value : jsPDFAPI.image_compression.NONE;
	  }
	  , getImages = function() {
	    var images = this.internal.collections[namespace + 'images'];
	    //first run, so initialise stuff
	    if(!images) {
	      this.internal.collections[namespace + 'images'] = images = {};
	      this.internal.events.subscribe('putResources', putResourcesCallback);
	      this.internal.events.subscribe('putXobjectDict', putXObjectsDictCallback);
	    }

	    return images;
	  }
	  , getImageIndex = function(images) {
	    var imageIndex = 0;

	    if (images){
	      // this is NOT the first time this method is ran on this instance of jsPDF object.
	      imageIndex = Object.keys ?
	      Object.keys(images).length :
	      (function(o){
	        var i = 0
	        for (var e in o){if(o.hasOwnProperty(e)){ i++ }}
	        return i
	      })(images)
	    }

	    return imageIndex;
	  }
	  , notDefined = function(value) {
	    return typeof value === 'undefined' || value === null;
	  }
	  , generateAliasFromData = function(data) {
	    return undefined;
	  }
	  , doesNotSupportImageType = function(type) {
	    return supported_image_types.indexOf(type) === -1;
	  }
	  , processMethodNotEnabled = function(type) {
	    return typeof jsPDFAPI['process' + type.toUpperCase()] !== 'function';
	  }
	  , isDOMElement = function(object) {
	    return typeof object === 'object' && object.nodeType === 1;
	  }
	  , createDataURIFromElement = function(element, format) {

	    //if element is an image which uses data url defintion, just return the dataurl
	    if (element.nodeName === 'IMG' && element.hasAttribute('src')) {
	      var src = ''+element.getAttribute('src');
	      if (src.indexOf('data:image/') === 0) return src;

	      // only if the user doesn't care about a format
	      if (!format && /\.png(?:[?#].*)?$/i.test(src)) format = 'png';
	    }

	    if(element.nodeName === 'CANVAS') {
	      var canvas = element;
	    } else {
	      var canvas = document.createElement('canvas');
	      canvas.width = element.clientWidth || element.width;
	      canvas.height = element.clientHeight || element.height;

	      var ctx = canvas.getContext('2d');
	      if (!ctx) {
	        throw ('addImage requires canvas to be supported by browser.');
	      }
	      ctx.drawImage(element, 0, 0, canvas.width, canvas.height);
	    }

	    return canvas.toDataURL((''+format).toLowerCase() == 'png' ? 'image/png' : 'image/jpeg');
	  }
	  ,checkImagesForAlias = function(imageData, images) {
	    var cached_info;
	    if(images) {
	      for(var e in images) {
	        if(imageData === images[e].alias) {
	          cached_info = images[e];
	          break;
	        }
	      }
	    }
	    return cached_info;
	  }
	  ,determineWidthAndHeight = function(w, h, info) {
	    if (!w && !h) {
	      w = -96;
	      h = -96;
	    }
	    if (w < 0) {
	      w = (-1) * info['w'] * 72 / w / this.internal.scaleFactor;
	    }
	    if (h < 0) {
	      h = (-1) * info['h'] * 72 / h / this.internal.scaleFactor;
	    }
	    if (w === 0) {
	      w = h * info['w'] / info['h'];
	    }
	    if (h === 0) {
	      h = w * info['h'] / info['w'];
	    }

	    return [w, h];
	  }
	  , writeImageToPDF = function(x, y, w, h, info, index, images) {
	    var dims = determineWidthAndHeight.call(this, w, h, info),
	      coord = this.internal.getCoordinateString,
	      vcoord = this.internal.getVerticalCoordinateString;

	    w = dims[0];
	    h = dims[1];

	    images[index] = info;

	    this.internal.write(
	      'q'
	      , coord(w)
	      , '0 0'
	      , coord(h) // TODO: check if this should be shifted by vcoord
	      , coord(x)
	      , vcoord(y + h)
	      , 'cm /I'+info['i']
	      , 'Do Q'
	    )
	  };

	  /**
	   * COLOR SPACES
	   */
	  jsPDFAPI.color_spaces = {
	    DEVICE_RGB:'DeviceRGB',
	    DEVICE_GRAY:'DeviceGray',
	    DEVICE_CMYK:'DeviceCMYK',
	    CAL_GREY:'CalGray',
	    CAL_RGB:'CalRGB',
	    LAB:'Lab',
	    ICC_BASED:'ICCBased',
	    INDEXED:'Indexed',
	    PATTERN:'Pattern',
	    SEPERATION:'Seperation',
	    DEVICE_N:'DeviceN'
	  };

	  /**
	   * DECODE METHODS
	   */
	  jsPDFAPI.decode = {
	    DCT_DECODE:'DCTDecode',
	    FLATE_DECODE:'FlateDecode',
	    LZW_DECODE:'LZWDecode',
	    JPX_DECODE:'JPXDecode',
	    JBIG2_DECODE:'JBIG2Decode',
	    ASCII85_DECODE:'ASCII85Decode',
	    ASCII_HEX_DECODE:'ASCIIHexDecode',
	    RUN_LENGTH_DECODE:'RunLengthDecode',
	    CCITT_FAX_DECODE:'CCITTFaxDecode'
	  };

	  /**
	   * IMAGE COMPRESSION TYPES
	   */
	  jsPDFAPI.image_compression = {
	    NONE: 'NONE',
	    FAST: 'FAST',
	    MEDIUM: 'MEDIUM',
	    SLOW: 'SLOW'
	  };

	  jsPDFAPI.isString = function(object) {
	    return typeof object === 'string';
	  };

	  /**
	   * Strips out and returns info from a valid base64 data URI
	   * @param {String[dataURI]} a valid data URI of format 'data:[<MIME-type>][;base64],<data>'
	   * @returns an Array containing the following
	   * [0] the complete data URI
	   * [1] <MIME-type>
	   * [2] format - the second part of the mime-type i.e 'png' in 'image/png'
	   * [4] <data>
	   */
	  jsPDFAPI.extractInfoFromBase64DataURI = function(dataURI) {
	    return /^data:([\w]+?\/([\w]+?));base64,(.+?)$/g.exec(dataURI);
	  };

	  /**
	   * Check to see if ArrayBuffer is supported
	   */
	  jsPDFAPI.supportsArrayBuffer = function() {
	    return typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
	  };

	  /**
	   * Tests supplied object to determine if ArrayBuffer
	   * @param {Object[object]}
	   */
	  jsPDFAPI.isArrayBuffer = function(object) {
	    if(!this.supportsArrayBuffer())
	          return false;
	    return object instanceof ArrayBuffer;
	  };

	  /**
	   * Tests supplied object to determine if it implements the ArrayBufferView (TypedArray) interface
	   * @param {Object[object]}
	   */
	  jsPDFAPI.isArrayBufferView = function(object) {
	    if(!this.supportsArrayBuffer())
	          return false;
	    if(typeof Uint32Array === 'undefined')
	      return false;
	    return (object instanceof Int8Array ||
	        object instanceof Uint8Array ||
	        (typeof Uint8ClampedArray !== 'undefined' && object instanceof Uint8ClampedArray) ||
	        object instanceof Int16Array ||
	        object instanceof Uint16Array ||
	        object instanceof Int32Array ||
	        object instanceof Uint32Array ||
	        object instanceof Float32Array ||
	        object instanceof Float64Array );
	  };

	  /**
	   * Exactly what it says on the tin
	   */
	  jsPDFAPI.binaryStringToUint8Array = function(binary_string) {
	    /*
	     * not sure how efficient this will be will bigger files. Is there a native method?
	     */
	    var len = binary_string.length;
	      var bytes = new Uint8Array( len );
	      for (var i = 0; i < len; i++) {
	          bytes[i] = binary_string.charCodeAt(i);
	      }
	      return bytes;
	  };

	  /**
	   * @see this discussion
	   * http://stackoverflow.com/questions/6965107/converting-between-strings-and-arraybuffers
	   *
	   * As stated, i imagine the method below is highly inefficent for large files.
	   *
	   * Also of note from Mozilla,
	   *
	   * "However, this is slow and error-prone, due to the need for multiple conversions (especially if the binary data is not actually byte-format data, but, for example, 32-bit integers or floats)."
	   *
	   * https://developer.mozilla.org/en-US/Add-ons/Code_snippets/StringView
	   *
	   * Although i'm strugglig to see how StringView solves this issue? Doesn't appear to be a direct method for conversion?
	   *
	   * Async method using Blob and FileReader could be best, but i'm not sure how to fit it into the flow?
	   */
	  jsPDFAPI.arrayBufferToBinaryString = function(buffer) {
			if(this.isArrayBuffer(buffer))
	      buffer = new Uint8Array(buffer);

	    var binary_string = '';
	    var len = buffer.byteLength || buffer.length;
	    for (var i = 0; i < len; i++) {
	      binary_string += String.fromCharCode(buffer[i]);
	    }
	    return binary_string;
	    /*
	     * Another solution is the method below - convert array buffer straight to base64 and then use atob
	     */
	    //return atob(this.arrayBufferToBase64(buffer));
	  };

	  /**
	   * Converts an ArrayBuffer directly to base64
	   *
	   * Taken from here
	   *
	   * http://jsperf.com/encoding-xhr-image-data/31
	   *
	   * Need to test if this is a better solution for larger files
	   *
	   */
	  jsPDFAPI.arrayBufferToBase64 = function(arrayBuffer) {
	    var base64    = ''
	    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

	    var bytes         = new Uint8Array(arrayBuffer)
	    var byteLength    = bytes.byteLength
	    var byteRemainder = byteLength % 3
	    var mainLength    = byteLength - byteRemainder

	    var a, b, c, d
	    var chunk

	    // Main loop deals with bytes in chunks of 3
	    for (var i = 0; i < mainLength; i = i + 3) {
	      // Combine the three bytes into a single integer
	      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

	      // Use bitmasks to extract 6-bit segments from the triplet
	      a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
	      b = (chunk & 258048)   >> 12 // 258048   = (2^6 - 1) << 12
	      c = (chunk & 4032)     >>  6 // 4032     = (2^6 - 1) << 6
	      d = chunk & 63               // 63       = 2^6 - 1

	      // Convert the raw binary segments to the appropriate ASCII encoding
	      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
	    }

	    // Deal with the remaining bytes and padding
	    if (byteRemainder == 1) {
	      chunk = bytes[mainLength]

	      a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

	      // Set the 4 least significant bits to zero
	      b = (chunk & 3)   << 4 // 3   = 2^2 - 1

	      base64 += encodings[a] + encodings[b] + '=='
	    } else if (byteRemainder == 2) {
	      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

	      a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
	      b = (chunk & 1008)  >>  4 // 1008  = (2^6 - 1) << 4

	      // Set the 2 least significant bits to zero
	      c = (chunk & 15)    <<  2 // 15    = 2^4 - 1

	      base64 += encodings[a] + encodings[b] + encodings[c] + '='
	    }

	    return base64
	  };

	  jsPDFAPI.createImageInfo = function(data, wd, ht, cs, bpc, f, imageIndex, alias, dp, trns, pal, smask) {
	    var info = {
	        alias:alias,
	        w : wd,
	        h : ht,
	        cs : cs,
	        bpc : bpc,
	        i : imageIndex,
	        data : data
	        // n: objectNumber will be added by putImage code
	      };

	    if(f) info.f = f;
	    if(dp) info.dp = dp;
	    if(trns) info.trns = trns;
	    if(pal) info.pal = pal;
	    if(smask) info.smask = smask;

	    return info;
	  };

	  jsPDFAPI.addImage = function(imageData, format, x, y, w, h, alias, compression) {
	    'use strict'

	    if(typeof format === 'number') {
	      var tmp = alias;
	      alias = h;
	      h = w;
	      w = y;
	      y = x;
	      x = format;
	      format = tmp;
	    }

	    var images = getImages.call(this),//initalises internals and events on first run
	      dataAsBinaryString;

	    compression = checkCompressValue(compression);

	    if(notDefined(alias))
	      alias = generateAliasFromData(imageData);

	    if(isDOMElement(imageData))
	      imageData = createDataURIFromElement(imageData, format);

	    if(this.isString(imageData)) {

	      var base64Info = this.extractInfoFromBase64DataURI(imageData);

	      if(base64Info) {

	        format = base64Info[2];
	        imageData = atob(base64Info[3]);//convert to binary string

	      } else {

	        if (imageData.charCodeAt(0) === 0x89 &&
	            imageData.charCodeAt(1) === 0x50 &&
	            imageData.charCodeAt(2) === 0x4e &&
	            imageData.charCodeAt(3) === 0x47  )  format = 'png';
	      }
	    }
	    format = (format || 'JPEG').toLowerCase();

	    if(doesNotSupportImageType(format))
	      throw new Error('addImage currently only supports formats ' + supported_image_types + ', not \''+format+'\'');

	    if(processMethodNotEnabled(format))
	      throw new Error('please ensure that the plugin for \''+format+'\' support is added');

	    /*
	     * need to test if it's more efficent to convert all binary strings
	     * to TypedArray - or should we just leave and process as string?
	     */
	    if(this.supportsArrayBuffer()) {
	      dataAsBinaryString = imageData;
	      imageData = this.binaryStringToUint8Array(imageData);
	    }

	    var imageIndex = getImageIndex(images),
	      info = checkImagesForAlias(dataAsBinaryString || imageData, images);

	    if(!info)
	      info = this['process' + format.toUpperCase()](imageData, imageIndex, alias, compression, dataAsBinaryString);

	    if(!info)
	      throw new Error('An unkwown error occurred whilst processing the image');

	    writeImageToPDF.call(this, x, y, w, h, info, imageIndex, images);

	    return this
	  };

	  /**
	   * JPEG SUPPORT
	   **/

	  //takes a string imgData containing the raw bytes of
	  //a jpeg image and returns [width, height]
	  //Algorithm from: http://www.64lines.com/jpeg-width-height
	  var getJpegSize = function(imgData) {
	    'use strict'
	    var width, height, numcomponents;
	    // Verify we have a valid jpeg header 0xff,0xd8,0xff,0xe0,?,?,'J','F','I','F',0x00
	    if (!imgData.charCodeAt(0) === 0xff ||
	      !imgData.charCodeAt(1) === 0xd8 ||
	      !imgData.charCodeAt(2) === 0xff ||
	      !imgData.charCodeAt(3) === 0xe0 ||
	      !imgData.charCodeAt(6) === 'J'.charCodeAt(0) ||
	      !imgData.charCodeAt(7) === 'F'.charCodeAt(0) ||
	      !imgData.charCodeAt(8) === 'I'.charCodeAt(0) ||
	      !imgData.charCodeAt(9) === 'F'.charCodeAt(0) ||
	      !imgData.charCodeAt(10) === 0x00) {
	        throw new Error('getJpegSize requires a binary string jpeg file')
	    }
	    var blockLength = imgData.charCodeAt(4)*256 + imgData.charCodeAt(5);
	    var i = 4, len = imgData.length;
	    while ( i < len ) {
	      i += blockLength;
	      if (imgData.charCodeAt(i) !== 0xff) {
	        throw new Error('getJpegSize could not find the size of the image');
	      }
	      if (imgData.charCodeAt(i+1) === 0xc0 || //(SOF) Huffman  - Baseline DCT
	          imgData.charCodeAt(i+1) === 0xc1 || //(SOF) Huffman  - Extended sequential DCT
	          imgData.charCodeAt(i+1) === 0xc2 || // Progressive DCT (SOF2)
	          imgData.charCodeAt(i+1) === 0xc3 || // Spatial (sequential) lossless (SOF3)
	          imgData.charCodeAt(i+1) === 0xc4 || // Differential sequential DCT (SOF5)
	          imgData.charCodeAt(i+1) === 0xc5 || // Differential progressive DCT (SOF6)
	          imgData.charCodeAt(i+1) === 0xc6 || // Differential spatial (SOF7)
	          imgData.charCodeAt(i+1) === 0xc7) {
	        height = imgData.charCodeAt(i+5)*256 + imgData.charCodeAt(i+6);
	        width = imgData.charCodeAt(i+7)*256 + imgData.charCodeAt(i+8);
	                numcomponents = imgData.charCodeAt(i+9);
	        return [width, height, numcomponents];
	      } else {
	        i += 2;
	        blockLength = imgData.charCodeAt(i)*256 + imgData.charCodeAt(i+1)
	      }
	    }
	  }
	  , getJpegSizeFromBytes = function(data) {

	    var hdr = (data[0] << 8) | data[1];

	    if(hdr !== 0xFFD8)
	      throw new Error('Supplied data is not a JPEG');

	    var len = data.length,
	      block = (data[4] << 8) + data[5],
	      pos = 4,
	      bytes, width, height, numcomponents;

	    while(pos < len) {
	      pos += block;
	      bytes = readBytes(data, pos);
	      block = (bytes[2] << 8) + bytes[3];
	      if((bytes[1] === 0xC0 || bytes[1] === 0xC2) && bytes[0] === 0xFF && block > 7) {
	        bytes = readBytes(data, pos + 5);
	        width = (bytes[2] << 8) + bytes[3];
	        height = (bytes[0] << 8) + bytes[1];
	                numcomponents = bytes[4];
	        return {width:width, height:height, numcomponents: numcomponents};
	      }

	      pos+=2;
	    }

	    throw new Error('getJpegSizeFromBytes could not find the size of the image');
	  }
	  , readBytes = function(data, offset) {
	    return data.subarray(offset, offset+ 5);
	  };

	  jsPDFAPI.processJPEG = function(data, index, alias, compression, dataAsBinaryString) {
	    'use strict'
	    var colorSpace = this.color_spaces.DEVICE_RGB,
	      filter = this.decode.DCT_DECODE,
	      bpc = 8,
	      dims;

	    if(this.isString(data)) {
	      dims = getJpegSize(data);
	      return this.createImageInfo(data, dims[0], dims[1], dims[3] == 1 ? this.color_spaces.DEVICE_GRAY:colorSpace, bpc, filter, index, alias);
	    }

	    if(this.isArrayBuffer(data))
	      data = new Uint8Array(data);

	    if(this.isArrayBufferView(data)) {

	      dims = getJpegSizeFromBytes(data);

	      // if we already have a stored binary string rep use that
	      data = dataAsBinaryString || this.arrayBufferToBinaryString(data);

	      return this.createImageInfo(data, dims.width, dims.height, dims.numcomponents == 1 ? this.color_spaces.DEVICE_GRAY:colorSpace, bpc, filter, index, alias);
	    }

	    return null;
	  };

	  jsPDFAPI.processJPG = function(/*data, index, alias, compression, dataAsBinaryString*/) {
	    return this.processJPEG.apply(this, arguments);
	  }

	})(jsPDF.API);
	(function (jsPDFAPI) {
	  'use strict';

	  jsPDFAPI.autoPrint = function () {
	    'use strict'
	    var refAutoPrintTag;

	    this.internal.events.subscribe('postPutResources', function () {
	      refAutoPrintTag = this.internal.newObject()
	        this.internal.write("<< /S/Named /Type/Action /N/Print >>", "endobj");
	    });

	    this.internal.events.subscribe("putCatalog", function () {
	      this.internal.write("/OpenAction " + refAutoPrintTag + " 0" + " R");
	    });
	    return this;
	  };
	})(jsPDF.API);
	/** ====================================================================
	 * jsPDF Cell plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 *               2013 Lee Driscoll, https://github.com/lsdriscoll
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 James Hall, james@parall.ax
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */

	(function (jsPDFAPI) {
	    'use strict';
	    /*jslint browser:true */
	    /*global document: false, jsPDF */

	    var fontName,
	        fontSize,
	        fontStyle,
	        padding = 3,
	        margin = 13,
	        headerFunction,
	        lastCellPos = { x: undefined, y: undefined, w: undefined, h: undefined, ln: undefined },
	        pages = 1,
	        setLastCellPosition = function (x, y, w, h, ln) {
	            lastCellPos = { 'x': x, 'y': y, 'w': w, 'h': h, 'ln': ln };
	        },
	        getLastCellPosition = function () {
	            return lastCellPos;
	        },
	        NO_MARGINS = {left:0, top:0, bottom: 0};

	    jsPDFAPI.setHeaderFunction = function (func) {
	        headerFunction = func;
	    };

	    jsPDFAPI.getTextDimensions = function (txt) {
	        fontName = this.internal.getFont().fontName;
	        fontSize = this.table_font_size || this.internal.getFontSize();
	        fontStyle = this.internal.getFont().fontStyle;
	        // 1 pixel = 0.264583 mm and 1 mm = 72/25.4 point
	        var px2pt = 0.264583 * 72 / 25.4,
	            dimensions,
	            text;

	        text = document.createElement('font');
	        text.id = "jsPDFCell";
	        text.style.fontStyle = fontStyle;
	        text.style.fontName = fontName;
	        text.style.fontSize = fontSize + 'pt';
	        text.innerText = txt;

	        document.body.appendChild(text);

	        dimensions = { w: (text.offsetWidth + 1) * px2pt, h: (text.offsetHeight + 1) * px2pt};

	        document.body.removeChild(text);

	        return dimensions;
	    };

	    jsPDFAPI.cellAddPage = function () {
	        var margins = this.margins || NO_MARGINS;

	        this.addPage();

	        setLastCellPosition(margins.left, margins.top, undefined, undefined);
	        //setLastCellPosition(undefined, undefined, undefined, undefined, undefined);
	        pages += 1;
	    };

	    jsPDFAPI.cellInitialize = function () {
	        lastCellPos = { x: undefined, y: undefined, w: undefined, h: undefined, ln: undefined };
	        pages = 1;
	    };

	    jsPDFAPI.cell = function (x, y, w, h, txt, ln, align) {
	        var curCell = getLastCellPosition();

	        // If this is not the first cell, we must change its position
	        if (curCell.ln !== undefined) {
	            if (curCell.ln === ln) {
	                //Same line
	                x = curCell.x + curCell.w;
	                y = curCell.y;
	            } else {
	                //New line
	                var margins = this.margins || NO_MARGINS;
	                if ((curCell.y + curCell.h + h + margin) >= this.internal.pageSize.height - margins.bottom) {
	                    this.cellAddPage();
	                    if (this.printHeaders && this.tableHeaderRow) {
	                        this.printHeaderRow(ln, true);
	                    }
	                }
	                //We ignore the passed y: the lines may have diferent heights
	                y = (getLastCellPosition().y + getLastCellPosition().h);

	            }
	        }

	        if (txt[0] !== undefined) {
	            if (this.printingHeaderRow) {
	                this.rect(x, y, w, h, 'FD');
	            } else {
	                this.rect(x, y, w, h);
	            }
	            if (align === 'right') {
	                if (txt instanceof Array) {
	                    for(var i = 0; i<txt.length; i++) {
	                        var currentLine = txt[i];
	                        var textSize = this.getStringUnitWidth(currentLine) * this.internal.getFontSize();
	                        this.text(currentLine, x + w - textSize - padding, y + this.internal.getLineHeight()*(i+1));
	                    }
	                }
	            } else {
	                this.text(txt, x + padding, y + this.internal.getLineHeight());
	            }
	        }
	        setLastCellPosition(x, y, w, h, ln);
	        return this;
	    };

	    /**
	     * Return the maximum value from an array
	     * @param array
	     * @param comparisonFn
	     * @returns {*}
	     */
	    jsPDFAPI.arrayMax = function (array, comparisonFn) {
	        var max = array[0],
	            i,
	            ln,
	            item;

	        for (i = 0, ln = array.length; i < ln; i += 1) {
	            item = array[i];

	            if (comparisonFn) {
	                if (comparisonFn(max, item) === -1) {
	                    max = item;
	                }
	            } else {
	                if (item > max) {
	                    max = item;
	                }
	            }
	        }

	        return max;
	    };

	    /**
	     * Create a table from a set of data.
	     * @param {Integer} [x] : left-position for top-left corner of table
	     * @param {Integer} [y] top-position for top-left corner of table
	     * @param {Object[]} [data] As array of objects containing key-value pairs corresponding to a row of data.
	     * @param {String[]} [headers] Omit or null to auto-generate headers at a performance cost

	     * @param {Object} [config.printHeaders] True to print column headers at the top of every page
	     * @param {Object} [config.autoSize] True to dynamically set the column widths to match the widest cell value
	     * @param {Object} [config.margins] margin values for left, top, bottom, and width
	     * @param {Object} [config.fontSize] Integer fontSize to use (optional)
	     */

	    jsPDFAPI.table = function (x,y, data, headers, config) {
	        if (!data) {
	            throw 'No data for PDF table';
	        }

	        var headerNames = [],
	            headerPrompts = [],
	            header,
	            i,
	            ln,
	            cln,
	            columnMatrix = {},
	            columnWidths = {},
	            columnData,
	            column,
	            columnMinWidths = [],
	            j,
	            tableHeaderConfigs = [],
	            model,
	            jln,
	            func,

	        //set up defaults. If a value is provided in config, defaults will be overwritten:
	           autoSize        = false,
	           printHeaders    = true,
	           fontSize        = 12,
	           margins         = NO_MARGINS;

	           margins.width = this.internal.pageSize.width;

	        if (config) {
	        //override config defaults if the user has specified non-default behavior:
	            if(config.autoSize === true) {
	                autoSize = true;
	            }
	            if(config.printHeaders === false) {
	                printHeaders = false;
	            }
	            if(config.fontSize){
	                fontSize = config.fontSize;
	            }
	            if(config.margins){
	                margins = config.margins;
	            }
	        }

	        /**
	         * @property {Number} lnMod
	         * Keep track of the current line number modifier used when creating cells
	         */
	        this.lnMod = 0;
	        lastCellPos = { x: undefined, y: undefined, w: undefined, h: undefined, ln: undefined },
	        pages = 1;

	        this.printHeaders = printHeaders;
	        this.margins = margins;
	        this.setFontSize(fontSize);
	        this.table_font_size = fontSize;

	        // Set header values
	        if (headers === undefined || (headers === null)) {
	            // No headers defined so we derive from data
	            headerNames = Object.keys(data[0]);

	        } else if (headers[0] && (typeof headers[0] !== 'string')) {
	            var px2pt = 0.264583 * 72 / 25.4;

	            // Split header configs into names and prompts
	            for (i = 0, ln = headers.length; i < ln; i += 1) {
	                header = headers[i];
	                headerNames.push(header.name);
	                headerPrompts.push(header.prompt);
	                columnWidths[header.name] = header.width *px2pt;
	            }

	        } else {
	            headerNames = headers;
	        }

	        if (autoSize) {
	            // Create a matrix of columns e.g., {column_title: [row1_Record, row2_Record]}
	            func = function (rec) {
	                return rec[header];
	            };

	            for (i = 0, ln = headerNames.length; i < ln; i += 1) {
	                header = headerNames[i];

	                columnMatrix[header] = data.map(
	                    func
	                );

	                // get header width
	                columnMinWidths.push(this.getTextDimensions(headerPrompts[i] || header).w);
	                column = columnMatrix[header];

	                // get cell widths
	                for (j = 0, cln = column.length; j < cln; j += 1) {
	                    columnData = column[j];
	                    columnMinWidths.push(this.getTextDimensions(columnData).w);
	                }

	                // get final column width
	                columnWidths[header] = jsPDFAPI.arrayMax(columnMinWidths);
	            }
	        }

	        // -- Construct the table

	        if (printHeaders) {
	            var lineHeight = this.calculateLineHeight(headerNames, columnWidths, headerPrompts.length?headerPrompts:headerNames);

	            // Construct the header row
	            for (i = 0, ln = headerNames.length; i < ln; i += 1) {
	                header = headerNames[i];
	                tableHeaderConfigs.push([x, y, columnWidths[header], lineHeight, String(headerPrompts.length ? headerPrompts[i] : header)]);
	            }

	            // Store the table header config
	            this.setTableHeaderRow(tableHeaderConfigs);

	            // Print the header for the start of the table
	            this.printHeaderRow(1, false);
	        }

	        // Construct the data rows
	        for (i = 0, ln = data.length; i < ln; i += 1) {
	            var lineHeight;
	            model = data[i];
	            lineHeight = this.calculateLineHeight(headerNames, columnWidths, model);

	            for (j = 0, jln = headerNames.length; j < jln; j += 1) {
	                header = headerNames[j];
	                this.cell(x, y, columnWidths[header], lineHeight, model[header], i + 2, header.align);
	            }
	        }
	        this.lastCellPos = lastCellPos;
	        this.table_x = x;
	        this.table_y = y;
	        return this;
	    };
	    /**
	     * Calculate the height for containing the highest column
	     * @param {String[]} headerNames is the header, used as keys to the data
	     * @param {Integer[]} columnWidths is size of each column
	     * @param {Object[]} model is the line of data we want to calculate the height of
	     */
	    jsPDFAPI.calculateLineHeight = function (headerNames, columnWidths, model) {
	        var header, lineHeight = 0;
	        for (var j = 0; j < headerNames.length; j++) {
	            header = headerNames[j];
	            model[header] = this.splitTextToSize(String(model[header]), columnWidths[header] - padding);
	            var h = this.internal.getLineHeight() * model[header].length + padding;
	            if (h > lineHeight)
	                lineHeight = h;
	        }
	        return lineHeight;
	    };

	    /**
	     * Store the config for outputting a table header
	     * @param {Object[]} config
	     * An array of cell configs that would define a header row: Each config matches the config used by jsPDFAPI.cell
	     * except the ln parameter is excluded
	     */
	    jsPDFAPI.setTableHeaderRow = function (config) {
	        this.tableHeaderRow = config;
	    };

	    /**
	     * Output the store header row
	     * @param lineNumber The line number to output the header at
	     */
	    jsPDFAPI.printHeaderRow = function (lineNumber, new_page) {
	        if (!this.tableHeaderRow) {
	            throw 'Property tableHeaderRow does not exist.';
	        }

	        var tableHeaderCell,
	            tmpArray,
	            i,
	            ln;

	        this.printingHeaderRow = true;
	        if (headerFunction !== undefined) {
	            var position = headerFunction(this, pages);
	            setLastCellPosition(position[0], position[1], position[2], position[3], -1);
	        }
	        this.setFontStyle('bold');
	        var tempHeaderConf = [];
	        for (i = 0, ln = this.tableHeaderRow.length; i < ln; i += 1) {
	            this.setFillColor(200,200,200);

	            tableHeaderCell = this.tableHeaderRow[i];
	            if (new_page) {
	                tableHeaderCell[1] = this.margins && this.margins.top || 0;
	                tempHeaderConf.push(tableHeaderCell);
	            }
	            tmpArray = [].concat(tableHeaderCell);
	            this.cell.apply(this, tmpArray.concat(lineNumber));
	        }
	        if (tempHeaderConf.length > 0){
	            this.setTableHeaderRow(tempHeaderConf);
	        }
	        this.setFontStyle('normal');
	        this.printingHeaderRow = false;
	    };

	})(jsPDF.API);
	/** ==================================================================== 
	 * jsPDF JavaScript plugin
	 * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */

	/*global jsPDF */

	(function (jsPDFAPI) {
	    'use strict';
	    var jsNamesObj, jsJsObj, text;
	    jsPDFAPI.addJS = function (txt) {
	        text = txt;
	        this.internal.events.subscribe(
	            'postPutResources',
	            function (txt) {
	                jsNamesObj = this.internal.newObject();
	                this.internal.write('<< /Names [(EmbeddedJS) ' + (jsNamesObj + 1) + ' 0 R] >>', 'endobj');
	                jsJsObj = this.internal.newObject();
	                this.internal.write('<< /S /JavaScript /JS (', text, ') >>', 'endobj');
	            }
	        );
	        this.internal.events.subscribe(
	            'putCatalog',
	            function () {
	                if (jsNamesObj !== undefined && jsJsObj !== undefined) {
	                    this.internal.write('/Names <</JavaScript ' + jsNamesObj + ' 0 R>>');
	                }
	            }
	        );
	        return this;
	    };
	}(jsPDF.API));
	/**@preserve
	 *  ==================================================================== 
	 * jsPDF PNG PlugIn
	 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */

	(function(jsPDFAPI) {
	'use strict'
	  
	  /*
	   * @see http://www.w3.org/TR/PNG-Chunks.html
	   * 
	   Color    Allowed      Interpretation
	   Type     Bit Depths
	     
	     0       1,2,4,8,16  Each pixel is a grayscale sample.
	     
	     2       8,16        Each pixel is an R,G,B triple.
	     
	     3       1,2,4,8     Each pixel is a palette index;
	                         a PLTE chunk must appear.
	     
	     4       8,16        Each pixel is a grayscale sample,
	                         followed by an alpha sample.
	     
	     6       8,16        Each pixel is an R,G,B triple,
	                         followed by an alpha sample.
	  */
	  
	  /*
	   * PNG filter method types
	   * 
	   * @see http://www.w3.org/TR/PNG-Filters.html
	   * @see http://www.libpng.org/pub/png/book/chapter09.html
	   * 
	   * This is what the value 'Predictor' in decode params relates to
	   * 
	   * 15 is "optimal prediction", which means the prediction algorithm can change from line to line.
	   * In that case, you actually have to read the first byte off each line for the prediction algorthim (which should be 0-4, corresponding to PDF 10-14) and select the appropriate unprediction algorithm based on that byte.
	   *
	     0       None
	     1       Sub
	     2       Up
	     3       Average
	     4       Paeth
	   */
	  
	  var doesNotHavePngJS = function() {
	    return typeof PNG !== 'function' || typeof FlateStream !== 'function';
	  }
	  , canCompress = function(value) {
	    return value !== jsPDFAPI.image_compression.NONE && hasCompressionJS();
	  }
	  , hasCompressionJS = function() {
	    var inst = typeof Deflater === 'function';
	    if(!inst)
	      throw new Error("requires deflate.js for compression")
	    return inst;
	  }
	  , compressBytes = function(bytes, lineLength, colorsPerPixel, compression) {
	    
	    var level = 5,
	      filter_method = filterUp;
	    
	    switch(compression) {
	    
	      case jsPDFAPI.image_compression.FAST:
	        
	        level = 3;
	        filter_method = filterSub;
	        break;
	        
	      case jsPDFAPI.image_compression.MEDIUM:
	        
	        level = 6;
	        filter_method = filterAverage;
	        break;
	        
	      case jsPDFAPI.image_compression.SLOW:
	        
	        level = 9;
	        filter_method = filterPaeth;//uses to sum to choose best filter for each line
	        break;
	    }
	    
	    bytes = applyPngFilterMethod(bytes, lineLength, colorsPerPixel, filter_method);
	    
	    var header = new Uint8Array(createZlibHeader(level));
	    var checksum = adler32(bytes);
	    
	    var deflate = new Deflater(level);
	    var a = deflate.append(bytes);
	    var cBytes = deflate.flush();
	    
	    var len = header.length + a.length + cBytes.length;
	    
	    var cmpd = new Uint8Array(len + 4);
	    cmpd.set(header);
	    cmpd.set(a, header.length);
	    cmpd.set(cBytes, header.length + a.length);
	    
	    cmpd[len++] = (checksum >>> 24) & 0xff;
	    cmpd[len++] = (checksum >>> 16) & 0xff;
	    cmpd[len++] = (checksum >>> 8) & 0xff;
	    cmpd[len++] = checksum & 0xff;
	    
	    return jsPDFAPI.arrayBufferToBinaryString(cmpd);
	  }
	  , createZlibHeader = function(bytes, level){
	    /*
	     * @see http://www.ietf.org/rfc/rfc1950.txt for zlib header 
	     */
	    var cm = 8;
	        var cinfo = Math.LOG2E * Math.log(0x8000) - 8;
	        var cmf = (cinfo << 4) | cm;
	        
	        var hdr = cmf << 8;
	        var flevel = Math.min(3, ((level - 1) & 0xff) >> 1);
	        
	        hdr |= (flevel << 6);
	        hdr |= 0;//FDICT
	        hdr += 31 - (hdr % 31);
	        
	        return [cmf, (hdr & 0xff) & 0xff];
	  }
	  , adler32 = function(array, param) {
	    var adler = 1;
	      var s1 = adler & 0xffff,
	          s2 = (adler >>> 16) & 0xffff;
	      var len = array.length;
	      var tlen;
	      var i = 0;

	      while (len > 0) {
	        tlen = len > param ? param : len;
	        len -= tlen;
	        do {
	          s1 += array[i++];
	          s2 += s1;
	        } while (--tlen);

	        s1 %= 65521;
	        s2 %= 65521;
	      }

	      return ((s2 << 16) | s1) >>> 0;
	  }
	  , applyPngFilterMethod = function(bytes, lineLength, colorsPerPixel, filter_method) {
	    var lines = bytes.length / lineLength,
	      result = new Uint8Array(bytes.length + lines),
	      filter_methods = getFilterMethods(),
	      i = 0, line, prevLine, offset;
	    
	    for(; i < lines; i++) {
	      offset = i * lineLength;
	      line = bytes.subarray(offset, offset + lineLength);
	      
	      if(filter_method) {
	        result.set(filter_method(line, colorsPerPixel, prevLine), offset + i);
	        
	      }else{
	      
	        var j = 0,
	          len = filter_methods.length,
	          results = [];
	        
	        for(; j < len; j++)
	          results[j] = filter_methods[j](line, colorsPerPixel, prevLine);
	        
	        var ind = getIndexOfSmallestSum(results.concat());
	        
	        result.set(results[ind], offset + i);
	      }
	      
	      prevLine = line;
	    }
	    
	    return result;
	  }
	  , filterNone = function(line, colorsPerPixel, prevLine) {
	    /*var result = new Uint8Array(line.length + 1);
	    result[0] = 0;
	    result.set(line, 1);*/
	    
	    var result = Array.apply([], line);
	    result.unshift(0);

	    return result;
	  }
	  , filterSub = function(line, colorsPerPixel, prevLine) {
	    var result = [],
	      i = 0,
	      len = line.length,
	      left;
	    
	    result[0] = 1;
	    
	    for(; i < len; i++) {
	      left = line[i - colorsPerPixel] || 0;
	      result[i + 1] = (line[i] - left + 0x0100) & 0xff;
	    }
	    
	    return result;
	  }
	  , filterUp = function(line, colorsPerPixel, prevLine) {
	    var result = [],
	      i = 0,
	      len = line.length,
	      up;
	    
	    result[0] = 2;
	    
	    for(; i < len; i++) {
	      up = prevLine && prevLine[i] || 0;
	      result[i + 1] = (line[i] - up + 0x0100) & 0xff;
	    }
	    
	    return result;
	  }
	  , filterAverage = function(line, colorsPerPixel, prevLine) {
	    var result = [],
	      i = 0,
	      len = line.length,
	      left,
	      up;
	  
	    result[0] = 3;
	    
	    for(; i < len; i++) {
	      left = line[i - colorsPerPixel] || 0;
	      up = prevLine && prevLine[i] || 0;
	      result[i + 1] = (line[i] + 0x0100 - ((left + up) >>> 1)) & 0xff;
	    }
	    
	    return result;
	  }
	  , filterPaeth = function(line, colorsPerPixel, prevLine) {
	    var result = [],
	      i = 0,
	      len = line.length,
	      left,
	      up,
	      upLeft,
	      paeth;
	    
	    result[0] = 4;
	    
	    for(; i < len; i++) {
	      left = line[i - colorsPerPixel] || 0;
	      up = prevLine && prevLine[i] || 0;
	      upLeft = prevLine && prevLine[i - colorsPerPixel] || 0;
	      paeth = paethPredictor(left, up, upLeft);
	      result[i + 1] = (line[i] - paeth + 0x0100) & 0xff;
	    }
	    
	    return result;
	  }
	  ,paethPredictor = function(left, up, upLeft) {

	    var p = left + up - upLeft,
	          pLeft = Math.abs(p - left),
	          pUp = Math.abs(p - up),
	          pUpLeft = Math.abs(p - upLeft);
	    
	    return (pLeft <= pUp && pLeft <= pUpLeft) ? left : (pUp <= pUpLeft) ? up : upLeft;
	  }
	  , getFilterMethods = function() {
	    return [filterNone, filterSub, filterUp, filterAverage, filterPaeth];
	  }
	  ,getIndexOfSmallestSum = function(arrays) {
	    var i = 0,
	      len = arrays.length,
	      sum, min, ind;
	    
	    while(i < len) {
	      sum = absSum(arrays[i].slice(1));
	      
	      if(sum < min || !min) {
	        min = sum;
	        ind = i;
	      }
	      
	      i++;
	    }
	    
	    return ind;
	  }
	  , absSum = function(array) {
	    var i = 0,
	      len = array.length,
	      sum = 0;
	  
	    while(i < len)
	      sum += Math.abs(array[i++]);
	      
	    return sum;
	  }
	  , logImg = function(img) {
	  };
	  
	  
	  
	  
	  jsPDFAPI.processPNG = function(imageData, imageIndex, alias, compression, dataAsBinaryString) {
	    'use strict'
	    
	    var colorSpace = this.color_spaces.DEVICE_RGB,
	      decode = this.decode.FLATE_DECODE,
	      bpc = 8,
	      img, dp, trns,
	      colors, pal, smask;
	    
	  /*  if(this.isString(imageData)) {
	      
	    }*/
	    
	    if(this.isArrayBuffer(imageData))
	      imageData = new Uint8Array(imageData);
	    
	    if(this.isArrayBufferView(imageData)) {
	      
	      if(doesNotHavePngJS())
	        throw new Error("PNG support requires png.js and zlib.js");
	        
	      img = new PNG(imageData);
	      imageData = img.imgData;
	      bpc = img.bits;
	      colorSpace = img.colorSpace;
	      colors = img.colors;
	      
	      //logImg(img);
	      
	      /*
	       * colorType 6 - Each pixel is an R,G,B triple, followed by an alpha sample.
	       * 
	       * colorType 4 - Each pixel is a grayscale sample, followed by an alpha sample.
	       * 
	       * Extract alpha to create two separate images, using the alpha as a sMask
	       */
	      if([4,6].indexOf(img.colorType) !== -1) {
	        
	        /*
	         * processes 8 bit RGBA and grayscale + alpha images
	         */
	        if(img.bits === 8) {
	        
	          var pixelsArrayType = window['Uint' + img.pixelBitlength + 'Array'],
	            pixels = new pixelsArrayType(img.decodePixels().buffer),
	            len = pixels.length,
	            imgData = new Uint8Array(len * img.colors),
	            alphaData = new Uint8Array(len),
	            pDiff = img.pixelBitlength - img.bits,
	            i = 0, n = 0, pixel, pbl;
	        
	          for(; i < len; i++) {
	            pixel = pixels[i];
	            pbl = 0;
	            
	            while(pbl < pDiff) {
	              
	              imgData[n++] = ( pixel >>> pbl ) & 0xff;
	              pbl = pbl + img.bits;
	            }
	            
	            alphaData[i] = ( pixel >>> pbl ) & 0xff;
	          }
	        }
	        
	        /*
	         * processes 16 bit RGBA and grayscale + alpha images
	         */
	        if(img.bits === 16) {
	          
	          var pixels = new Uint32Array(img.decodePixels().buffer),
	            len = pixels.length,
	            imgData = new Uint8Array((len * (32 / img.pixelBitlength) ) * img.colors),
	            alphaData = new Uint8Array(len * (32 / img.pixelBitlength) ),
	            hasColors = img.colors > 1,
	            i = 0, n = 0, a = 0, pixel;
	          
	          while(i < len) {
	            pixel = pixels[i++];
	            
	            imgData[n++] = (pixel >>> 0) & 0xFF;
	            
	            if(hasColors) {
	              imgData[n++] = (pixel >>> 16) & 0xFF;
	              
	              pixel = pixels[i++];
	              imgData[n++] = (pixel >>> 0) & 0xFF;
	            }
	            
	            alphaData[a++] = (pixel >>> 16) & 0xFF;
	          }
	          
	          bpc = 8;
	        }
	        
	        if(canCompress(compression)) {
	                    
	          imageData = compressBytes(imgData, img.width * img.colors, img.colors, compression);
	          smask = compressBytes(alphaData, img.width, 1, compression);
	          
	        }else{
	          
	          imageData = imgData;
	          smask = alphaData;
	          decode = null;
	        }
	      }
	      
	      /*
	       * Indexed png. Each pixel is a palette index.
	       */
	      if(img.colorType === 3) {
	        
	        colorSpace = this.color_spaces.INDEXED;
	        pal = img.palette;
	        
	        if(img.transparency.indexed) {
	          
	          var trans = img.transparency.indexed;
	          
	          var total = 0,
	            i = 0,
	            len = trans.length;

	          for(; i<len; ++i)
	              total += trans[i];
	          
	          total = total / 255;
	          
	          /*
	           * a single color is specified as 100% transparent (0),
	           * so we set trns to use a /Mask with that index
	           */
	          if(total === len - 1 && trans.indexOf(0) !== -1) {
	            trns = [trans.indexOf(0)];
	          
	          /*
	           * there's more than one colour within the palette that specifies
	           * a transparency value less than 255, so we unroll the pixels to create an image sMask
	           */
	          }else if(total !== len){
	            
	            var pixels = img.decodePixels(),
	              alphaData = new Uint8Array(pixels.length),
	              i = 0,
	              len = pixels.length;
	            
	            for(; i < len; i++)
	              alphaData[i] = trans[pixels[i]];
	            
	            smask = compressBytes(alphaData, img.width, 1);
	          }
	        }
	      }
	      
	      if(decode === this.decode.FLATE_DECODE)
	        dp = '/Predictor 15 /Colors '+ colors +' /BitsPerComponent '+ bpc +' /Columns '+ img.width;
	      else
	        //remove 'Predictor' as it applies to the type of png filter applied to its IDAT - we only apply with compression
	        dp = '/Colors '+ colors +' /BitsPerComponent '+ bpc +' /Columns '+ img.width;
	      
	      if(this.isArrayBuffer(imageData) || this.isArrayBufferView(imageData))
	        imageData = this.arrayBufferToBinaryString(imageData);
	      
	      if(smask && this.isArrayBuffer(smask) || this.isArrayBufferView(smask))
	        smask = this.arrayBufferToBinaryString(smask);
	      
	      return this.createImageInfo(imageData, img.width, img.height, colorSpace,
	                    bpc, decode, imageIndex, alias, dp, trns, pal, smask);
	    }
	    
	    throw new Error("Unsupported PNG image data, try using JPEG instead.");
	  }

	})(jsPDF.API)
	/** @preserve
	jsPDF Silly SVG plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	*/
	/**
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */

	;(function(jsPDFAPI) {
	'use strict'

	/**
	Parses SVG XML and converts only some of the SVG elements into
	PDF elements.

	Supports:
	 paths

	@public
	@function
	@param
	@returns {Type}
	*/
	jsPDFAPI.addSVG = function(svgtext, x, y, w, h) {
	  // 'this' is _jsPDF object returned when jsPDF is inited (new jsPDF())

	  var undef

	  if (x === undef || y === undef) {
	    throw new Error("addSVG needs values for 'x' and 'y'");
	  }

	    function InjectCSS(cssbody, document) {
	        var styletag = document.createElement('style');
	        styletag.type = 'text/css';
	        if (styletag.styleSheet) {
	          // ie
	            styletag.styleSheet.cssText = cssbody;
	        } else {
	          // others
	            styletag.appendChild(document.createTextNode(cssbody));
	        }
	        document.getElementsByTagName("head")[0].appendChild(styletag);
	    }

	  function createWorkerNode(document){

	    var frameID = 'childframe' // Date.now().toString() + '_' + (Math.random() * 100).toString()
	    , frame = document.createElement('iframe')

	    InjectCSS(
	      '.jsPDF_sillysvg_iframe {display:none;position:absolute;}'
	      , document
	    )

	    frame.name = frameID
	    frame.setAttribute("width", 0)
	    frame.setAttribute("height", 0)
	    frame.setAttribute("frameborder", "0")
	    frame.setAttribute("scrolling", "no")
	    frame.setAttribute("seamless", "seamless")
	    frame.setAttribute("class", "jsPDF_sillysvg_iframe")
	    
	    document.body.appendChild(frame)

	    return frame
	  }

	  function attachSVGToWorkerNode(svgtext, frame){
	    var framedoc = ( frame.contentWindow || frame.contentDocument ).document
	    framedoc.write(svgtext)
	    framedoc.close()
	    return framedoc.getElementsByTagName('svg')[0]
	  }

	  function convertPathToPDFLinesArgs(path){
	    'use strict'
	    // we will use 'lines' method call. it needs:
	    // - starting coordinate pair
	    // - array of arrays of vector shifts (2-len for line, 6 len for bezier)
	    // - scale array [horizontal, vertical] ratios
	    // - style (stroke, fill, both)

	    var x = parseFloat(path[1])
	    , y = parseFloat(path[2])
	    , vectors = []
	    , position = 3
	    , len = path.length

	    while (position < len){
	      if (path[position] === 'c'){
	        vectors.push([
	          parseFloat(path[position + 1])
	          , parseFloat(path[position + 2])
	          , parseFloat(path[position + 3])
	          , parseFloat(path[position + 4])
	          , parseFloat(path[position + 5])
	          , parseFloat(path[position + 6])
	        ])
	        position += 7
	      } else if (path[position] === 'l') {
	        vectors.push([
	          parseFloat(path[position + 1])
	          , parseFloat(path[position + 2])
	        ])
	        position += 3
	      } else {
	        position += 1
	      }
	    }
	    return [x,y,vectors]
	  }

	  var workernode = createWorkerNode(document)
	  , svgnode = attachSVGToWorkerNode(svgtext, workernode)
	  , scale = [1,1]
	  , svgw = parseFloat(svgnode.getAttribute('width'))
	  , svgh = parseFloat(svgnode.getAttribute('height'))

	  if (svgw && svgh) {
	    // setting both w and h makes image stretch to size.
	    // this may distort the image, but fits your demanded size
	    if (w && h) {
	      scale = [w / svgw, h / svgh]
	    } 
	    // if only one is set, that value is set as max and SVG 
	    // is scaled proportionately.
	    else if (w) {
	      scale = [w / svgw, w / svgw]
	    } else if (h) {
	      scale = [h / svgh, h / svgh]
	    }
	  }

	  var i, l, tmp
	  , linesargs
	  , items = svgnode.childNodes
	  for (i = 0, l = items.length; i < l; i++) {
	    tmp = items[i]
	    if (tmp.tagName && tmp.tagName.toUpperCase() === 'PATH') {
	      linesargs = convertPathToPDFLinesArgs( tmp.getAttribute("d").split(' ') )
	      // path start x coordinate
	      linesargs[0] = linesargs[0] * scale[0] + x // where x is upper left X of image
	      // path start y coordinate
	      linesargs[1] = linesargs[1] * scale[1] + y // where y is upper left Y of image
	      // the rest of lines are vectors. these will adjust with scale value auto.
	      this.lines.call(
	        this
	        , linesargs[2] // lines
	        , linesargs[0] // starting x
	        , linesargs[1] // starting y
	        , scale
	      )
	    }
	  }

	  // clean up
	  // workernode.parentNode.removeChild(workernode)

	  return this
	}

	})(jsPDF.API);
	/** @preserve
	 * jsPDF split_text_to_size plugin - MIT license.
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Diego Casorran, https://github.com/diegocr
	 */
	/**
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */

	;(function(API) {
	'use strict'

	/**
	Returns an array of length matching length of the 'word' string, with each
	cell ocupied by the width of the char in that position.

	@function
	@param word {String}
	@param widths {Object}
	@param kerning {Object}
	@returns {Array}
	*/
	var getCharWidthsArray = API.getCharWidthsArray = function(text, options) {
	  if (!options) {
	    options = {}
	  }
	  var font = this.internal.getFont();
	  if (font && font.pdfkitFont) {
	    font.pdfkitFont.use(text);
	    var pf = font.pdfkitFont.font;
	    var widths = [];
	    var scale = 1 / 1000; // For whatever reason, jspdf wants these widths at 1pt size
	    for (var i = 0, len = text.length; i < len; i++) {
	      widths.push((pf.widthOfGlyph(pf.characterToGlyph(text.charCodeAt(i))) || 0) * scale);
	    }
	    return widths;
	  }

	  var fontToMeasure = this.internal.getFont();
	  if (!fontToMeasure.metadata.Unicode) {
	    fontToMeasure = this.internal.getFont('Helvetica', fontToMeasure.fontStyle);
	  }

	  var widths = options.widths ? options.widths : fontToMeasure.metadata.Unicode.widths
	  , widthsFractionOf = widths.fof ? widths.fof : 1
	  , kerning = options.kerning ? options.kerning : fontToMeasure.metadata.Unicode.kerning
	  , kerningFractionOf = kerning.fof ? kerning.fof : 1

	  var i, l
	  , char_code
	  , prior_char_code = 0 // for kerning
	  , default_char_width = widths[0] || widthsFractionOf
	  , output = []

	  for (i = 0, l = text.length; i < l; i++) {
	    char_code = text.charCodeAt(i)
	    output.push(
	      ( widths[char_code] || default_char_width ) / widthsFractionOf +
	      ( kerning[char_code] && kerning[char_code][prior_char_code] || 0 ) / kerningFractionOf
	    )
	    prior_char_code = char_code
	  }
	  return output
	}
	var getArraySum = function(array){
	  var i = array.length
	  , output = 0
	  while(i){
	    ;i--;
	    output += array[i]
	  }
	  return output
	}
	/**
	Returns a widths of string in a given font, if the font size is set as 1 point.

	In other words, this is "proportional" value. For 1 unit of font size, the length
	of the string will be that much.

	Multiply by font size to get actual width in *points*
	Then divide by 72 to get inches or divide by (72/25.6) to get 'mm' etc.

	@public
	@function
	@param
	@returns {Type}
	*/
	var getStringUnitWidth = API.getStringUnitWidth = function(text, options) {
	  return getArraySum(getCharWidthsArray.call(this, text, options))
	}

	/**
	returns array of lines
	*/
	var splitLongWord = function(word, widths_array, firstLineMaxLen, maxLen){
	  var answer = []

	  // 1st, chop off the piece that can fit on the hanging line.
	  var i = 0
	  , l = word.length
	  , workingLen = 0
	  while (i !== l && workingLen + widths_array[i] < firstLineMaxLen){
	    workingLen += widths_array[i]
	    ;i++;
	  }
	  // this is first line.
	  answer.push(word.slice(0, i))

	  // 2nd. Split the rest into maxLen pieces.
	  var startOfLine = i
	  workingLen = 0
	  while (i !== l){
	    if (workingLen + widths_array[i] > maxLen) {
	      answer.push(word.slice(startOfLine, i))
	      workingLen = 0
	      startOfLine = i
	    }
	    workingLen += widths_array[i]
	    ;i++;
	  }
	  if (startOfLine !== i) {
	    answer.push(word.slice(startOfLine, i))
	  }

	  return answer
	}

	// Note, all sizing inputs for this function must be in "font measurement units"
	// By default, for PDF, it's "point".
	var splitParagraphIntoLines = function(text, maxlen, options){
	  // at this time works only on Western scripts, ones with space char
	  // separating the words. Feel free to expand.

	  if (!options) {
	    options = {}
	  }

	  var line = []
	  , lines = [line]
	  , line_length = options.textIndent || 0
	  , separator_length = 0
	  , current_word_length = 0
	  , word
	  , widths_array
	  , words = text.split(' ')
	  , spaceCharWidth = getCharWidthsArray.call(this, ' ', options)[0]
	  , i, l, tmp, lineIndent

	  if(options.lineIndent === -1) {
	    lineIndent = words[0].length +2;
	  } else {
	    lineIndent = options.lineIndent || 0;
	  }
	  if(lineIndent) {
	    var pad = Array(lineIndent).join(" "), wrds = [];
	    words.map(function(wrd) {
	      wrd = wrd.split(/\s*\n/);
	      if(wrd.length > 1) {
	        wrds = wrds.concat(wrd.map(function(wrd, idx) {
	          return (idx && wrd.length ? "\n":"") + wrd;
	        }));
	      } else {
	        wrds.push(wrd[0]);
	      }
	    });
	    words = wrds;
	    lineIndent = getStringUnitWidth(pad, options);
	  }

	  for (i = 0, l = words.length; i < l; i++) {
	    var force = 0;

	    word = words[i]
	    if(lineIndent && word[0] == "\n") {
	      word = word.substr(1);
	      force = 1;
	    }
	    widths_array = getCharWidthsArray.call(this, word, options)
	    current_word_length = getArraySum(widths_array)

	    if (line_length + separator_length + current_word_length > maxlen || force) {
	      if (current_word_length > maxlen) {
	        // this happens when you have space-less long URLs for example.
	        // we just chop these to size. We do NOT insert hiphens
	        tmp = splitLongWord(word, widths_array, maxlen - (line_length + separator_length), maxlen)
	        // first line we add to existing line object
	        line.push(tmp.shift()) // it's ok to have extra space indicator there
	        // last line we make into new line object
	        line = [tmp.pop()]
	        // lines in the middle we apped to lines object as whole lines
	        while(tmp.length){
	          lines.push([tmp.shift()]) // single fragment occupies whole line
	        }
	        current_word_length = getArraySum( widths_array.slice(word.length - line[0].length) )
	      } else {
	        // just put it on a new line
	        line = [word]
	      }

	      // now we attach new line to lines
	      lines.push(line)
	      line_length = current_word_length + lineIndent
	      separator_length = spaceCharWidth

	    } else {
	      line.push(word)

	      line_length += separator_length + current_word_length
	      separator_length = spaceCharWidth
	    }
	  }

	  if(lineIndent) {
	    var postProcess = function(ln, idx) {
	      return (idx ? pad : '') + ln.join(" ");
	    };
	  } else {
	    var postProcess = function(ln) { return ln.join(" ")};
	  }

	  return lines.map(postProcess);
	}

	/**
	Splits a given string into an array of strings. Uses 'size' value
	(in measurement units declared as default for the jsPDF instance)
	and the font's "widths" and "Kerning" tables, where availabe, to
	determine display length of a given string for a given font.

	We use character's 100% of unit size (height) as width when Width
	table or other default width is not available.

	@public
	@function
	@param text {String} Unencoded, regular JavaScript (Unicode, UTF-16 / UCS-2) string.
	@param size {Number} Nominal number, measured in units default to this instance of jsPDF.
	@param options {Object} Optional flags needed for chopper to do the right thing.
	@returns {Array} with strings chopped to size.
	*/
	API.splitTextToSize = function(text, maxlen, options) {
	  'use strict'

	  if (!options) {
	    options = {}
	  }

	  var fsize = options.fontSize || this.internal.getFontSize()
	  , newOptions = (function(options){
	    var widths = {0:1}
	    , kerning = {}

	    if (!options.widths || !options.kerning) {
	      var f = this.internal.getFont(options.fontName, options.fontStyle)
	      , encoding = 'Unicode'
	      // NOT UTF8, NOT UTF16BE/LE, NOT UCS2BE/LE
	      // Actual JavaScript-native String's 16bit char codes used.
	      // no multi-byte logic here

	      if (f.metadata[encoding]) {
	        return {
	          widths: f.metadata[encoding].widths || widths
	          , kerning: f.metadata[encoding].kerning || kerning
	        }
	      }
	    } else {
	      return  {
	        widths: options.widths
	        , kerning: options.kerning
	      }
	    }

	    // then use default values
	    return  {
	      widths: widths
	      , kerning: kerning
	    }
	  }).call(this, options)

	  // first we split on end-of-line chars
	  var paragraphs
	  if(Array.isArray(text)) {
	    paragraphs = text;
	  } else {
	    paragraphs = text.split(/\r?\n/);
	  }

	  // now we convert size (max length of line) into "font size units"
	  // at present time, the "font size unit" is always 'point'
	  // 'proportional' means, "in proportion to font size"
	  var fontUnit_maxLen = 1.0 * this.internal.scaleFactor * maxlen / fsize
	  // at this time, fsize is always in "points" regardless of the default measurement unit of the doc.
	  // this may change in the future?
	  // until then, proportional_maxlen is likely to be in 'points'

	  // If first line is to be indented (shorter or longer) than maxLen
	  // we indicate that by using CSS-style "text-indent" option.
	  // here it's in font units too (which is likely 'points')
	  // it can be negative (which makes the first line longer than maxLen)
	  newOptions.textIndent = options.textIndent ?
	    options.textIndent * 1.0 * this.internal.scaleFactor / fsize :
	    0
	  newOptions.lineIndent = options.lineIndent;

	  var i, l
	  , output = []
	  for (i = 0, l = paragraphs.length; i < l; i++) {
	    output = output.concat(
	      splitParagraphIntoLines.call(
	        this
	        , paragraphs[i]
	        , fontUnit_maxLen
	        , newOptions
	      )
	    )
	  }

	  return output
	}

	})(jsPDF.API);
	/** @preserve 
	jsPDF standard_fonts_metrics plugin
	Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	MIT license.
	*/
	/**
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */

	;(function(API) {
	'use strict'

	/*
	# reference (Python) versions of 'compress' and 'uncompress'
	# only 'uncompress' function is featured lower as JavaScript
	# if you want to unit test "roundtrip", just transcribe the reference
	# 'compress' function from Python into JavaScript

	def compress(data):

	  keys =   '0123456789abcdef'
	  values = 'klmnopqrstuvwxyz'
	  mapping = dict(zip(keys, values))
	  vals = []
	  for key in data.keys():
	    value = data[key]
	    try:
	      keystring = hex(key)[2:]
	      keystring = keystring[:-1] + mapping[keystring[-1:]]
	    except:
	      keystring = key.join(["'","'"])
	      #print('Keystring is %s' % keystring)

	    try:
	      if value < 0:
	        valuestring = hex(value)[3:]
	        numberprefix = '-'
	      else:
	        valuestring = hex(value)[2:]
	        numberprefix = ''
	      valuestring = numberprefix + valuestring[:-1] + mapping[valuestring[-1:]]
	    except:
	      if type(value) == dict:
	        valuestring = compress(value)
	      else:
	        raise Exception("Don't know what to do with value type %s" % type(value))

	    vals.append(keystring+valuestring)
	  
	  return '{' + ''.join(vals) + '}'

	def uncompress(data):

	  decoded = '0123456789abcdef'
	  encoded = 'klmnopqrstuvwxyz'
	  mapping = dict(zip(encoded, decoded))

	  sign = +1
	  stringmode = False
	  stringparts = []

	  output = {}

	  activeobject = output
	  parentchain = []

	  keyparts = ''
	  valueparts = ''

	  key = None

	  ending = set(encoded)

	  i = 1
	  l = len(data) - 1 # stripping starting, ending {}
	  while i != l: # stripping {}
	    # -, {, }, ' are special.

	    ch = data[i]
	    i += 1

	    if ch == "'":
	      if stringmode:
	        # end of string mode
	        stringmode = False
	        key = ''.join(stringparts)
	      else:
	        # start of string mode
	        stringmode = True
	        stringparts = []
	    elif stringmode == True:
	      #print("Adding %s to stringpart" % ch)
	      stringparts.append(ch)

	    elif ch == '{':
	      # start of object
	      parentchain.append( [activeobject, key] )
	      activeobject = {}
	      key = None
	      #DEBUG = True
	    elif ch == '}':
	      # end of object
	      parent, key = parentchain.pop()
	      parent[key] = activeobject
	      key = None
	      activeobject = parent
	      #DEBUG = False

	    elif ch == '-':
	      sign = -1
	    else:
	      # must be number
	      if key == None:
	        #debug("In Key. It is '%s', ch is '%s'" % (keyparts, ch))
	        if ch in ending:
	          #debug("End of key")
	          keyparts += mapping[ch]
	          key = int(keyparts, 16) * sign
	          sign = +1
	          keyparts = ''
	        else:
	          keyparts += ch
	      else:
	        #debug("In value. It is '%s', ch is '%s'" % (valueparts, ch))
	        if ch in ending:
	          #debug("End of value")
	          valueparts += mapping[ch]
	          activeobject[key] = int(valueparts, 16) * sign
	          sign = +1
	          key = None
	          valueparts = ''
	        else:
	          valueparts += ch

	      #debug(activeobject)

	  return output

	*/

	/**
	Uncompresses data compressed into custom, base16-like format. 
	@public
	@function
	@param
	@returns {Type}
	*/
	var uncompress = function(data){

	  var decoded = '0123456789abcdef'
	  , encoded = 'klmnopqrstuvwxyz'
	  , mapping = {}

	  for (var i = 0; i < encoded.length; i++){
	    mapping[encoded[i]] = decoded[i]
	  }

	  var undef
	  , output = {}
	  , sign = 1
	  , stringparts // undef. will be [] in string mode
	  
	  , activeobject = output
	  , parentchain = []
	  , parent_key_pair
	  , keyparts = ''
	  , valueparts = ''
	  , key // undef. will be Truthy when Key is resolved.
	  , datalen = data.length - 1 // stripping ending }
	  , ch

	  i = 1 // stripping starting {
	  
	  while (i != datalen){
	    // - { } ' are special.

	    ch = data[i]
	    i += 1

	    if (ch == "'"){
	      if (stringparts){
	        // end of string mode
	        key = stringparts.join('')
	        stringparts = undef       
	      } else {
	        // start of string mode
	        stringparts = []        
	      }
	    } else if (stringparts){
	      stringparts.push(ch)
	    } else if (ch == '{'){
	      // start of object
	      parentchain.push( [activeobject, key] )
	      activeobject = {}
	      key = undef
	    } else if (ch == '}'){
	      // end of object
	      parent_key_pair = parentchain.pop()
	      parent_key_pair[0][parent_key_pair[1]] = activeobject
	      key = undef
	      activeobject = parent_key_pair[0]
	    } else if (ch == '-'){
	      sign = -1
	    } else {
	      // must be number
	      if (key === undef) {
	        if (mapping.hasOwnProperty(ch)){
	          keyparts += mapping[ch]
	          key = parseInt(keyparts, 16) * sign
	          sign = +1
	          keyparts = ''
	        } else {
	          keyparts += ch
	        }
	      } else {
	        if (mapping.hasOwnProperty(ch)){
	          valueparts += mapping[ch]
	          activeobject[key] = parseInt(valueparts, 16) * sign
	          sign = +1
	          key = undef
	          valueparts = ''
	        } else {
	          valueparts += ch          
	        }
	      }
	    }
	  } // end while

	  return output
	}

	// encoding = 'Unicode' 
	// NOT UTF8, NOT UTF16BE/LE, NOT UCS2BE/LE. NO clever BOM behavior
	// Actual 16bit char codes used.
	// no multi-byte logic here

	// Unicode characters to WinAnsiEncoding:
	// {402: 131, 8211: 150, 8212: 151, 8216: 145, 8217: 146, 8218: 130, 8220: 147, 8221: 148, 8222: 132, 8224: 134, 8225: 135, 8226: 149, 8230: 133, 8364: 128, 8240:137, 8249: 139, 8250: 155, 710: 136, 8482: 153, 338: 140, 339: 156, 732: 152, 352: 138, 353: 154, 376: 159, 381: 142, 382: 158}
	// as you can see, all Unicode chars are outside of 0-255 range. No char code conflicts.
	// this means that you can give Win cp1252 encoded strings to jsPDF for rendering directly
	// as well as give strings with some (supported by these fonts) Unicode characters and 
	// these will be mapped to win cp1252 
	// for example, you can send char code (cp1252) 0x80 or (unicode) 0x20AC, getting "Euro" glyph displayed in both cases.

	var encodingBlock = {
	  'codePages': ['WinAnsiEncoding']
	  , 'WinAnsiEncoding': uncompress("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
	}
	, encodings = {'Unicode':{
	  'Courier': encodingBlock
	  , 'Courier-Bold': encodingBlock
	  , 'Courier-BoldOblique': encodingBlock
	  , 'Courier-Oblique': encodingBlock
	  , 'Helvetica': encodingBlock
	  , 'Helvetica-Bold': encodingBlock
	  , 'Helvetica-BoldOblique': encodingBlock
	  , 'Helvetica-Oblique': encodingBlock
	  , 'Times-Roman': encodingBlock
	  , 'Times-Bold': encodingBlock
	  , 'Times-BoldItalic': encodingBlock
	  , 'Times-Italic': encodingBlock
	//  , 'Symbol'
	//  , 'ZapfDingbats'
	}}
	/** 
	Resources:
	Font metrics data is reprocessed derivative of contents of
	"Font Metrics for PDF Core 14 Fonts" package, which exhibits the following copyright and license:

	Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated. All Rights Reserved.

	This file and the 14 PostScript(R) AFM files it accompanies may be used,
	copied, and distributed for any purpose and without charge, with or without
	modification, provided that all copyright notices are retained; that the AFM
	files are not distributed without this file; that all modifications to this
	file or any of the AFM files are prominently noted in the modified file(s);
	and that this paragraph is not modified. Adobe Systems has no responsibility
	or obligation to support the use of the AFM files.

	*/
	, fontMetrics = {'Unicode':{
	  // all sizing numbers are n/fontMetricsFractionOf = one font size unit
	  // this means that if fontMetricsFractionOf = 1000, and letter A's width is 476, it's
	  // width is 476/1000 or 47.6% of its height (regardless of font size)
	  // At this time this value applies to "widths" and "kerning" numbers.

	  // char code 0 represents "default" (average) width - use it for chars missing in this table.
	  // key 'fof' represents the "fontMetricsFractionOf" value

	  'Courier-Oblique': uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}")
	  , 'Times-BoldItalic': uncompress("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}")
	  , 'Helvetica-Bold': uncompress("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}")
	  , 'Courier': uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}")
	  , 'Courier-BoldOblique': uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}")
	  , 'Times-Bold': uncompress("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}")
	  //, 'Symbol': uncompress("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}")
	  , 'Helvetica': uncompress("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
	  , 'Helvetica-BoldOblique': uncompress("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}")
	  //, 'ZapfDingbats': uncompress("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}")
	  , 'Courier-Bold': uncompress("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}")
	  , 'Times-Italic': uncompress("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}")
	  , 'Times-Roman': uncompress("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}")
	  , 'Helvetica-Oblique': uncompress("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
	}};

	// console.log('helvetica metrics are', fontMetrics.Unicode.Helvetica);

	/*
	This event handler is fired when a new jsPDF object is initialized
	This event handler appends metrics data to standard fonts within
	that jsPDF instance. The metrics are mapped over Unicode character
	codes, NOT CIDs or other codes matching the StandardEncoding table of the
	standard PDF fonts.
	Future:
	Also included is the encoding maping table, converting Unicode (UCS-2, UTF-16)
	char codes to StandardEncoding character codes. The encoding table is to be used
	somewhere around "pdfEscape" call.
	*/

	API.events.push([ 
	  'addFonts'
	  ,function(fontManagementObjects) {
	    // console.log('addfonts listener');
	    // fontManagementObjects is {
	    //  'fonts':font_ID-keyed hash of font objects
	    //  , 'dictionary': lookup object, linking ["FontFamily"]['Style'] to font ID
	    //}
	    var font
	    , fontID
	    , metrics
	    , unicode_section
	    , encoding = 'Unicode'
	    , encodingBlock

	    for (fontID in fontManagementObjects.fonts){
	      if (fontManagementObjects.fonts.hasOwnProperty(fontID)) {
	        font = fontManagementObjects.fonts[fontID]

	        // // we only ship 'Unicode' mappings and metrics. No need for loop.
	        // // still, leaving this for the future.

	        // for (encoding in fontMetrics){
	        //  if (fontMetrics.hasOwnProperty(encoding)) {

	            metrics = fontMetrics[encoding][font.PostScriptName]
	            if (metrics) {
	              if (font.metadata[encoding]) {
	                unicode_section = font.metadata[encoding]
	              } else {
	                unicode_section = font.metadata[encoding] = {}
	              }

	              unicode_section.widths = metrics.widths
	              unicode_section.kerning = metrics.kerning
	            }
	        //  }
	        // }
	        // for (encoding in encodings){
	        //  if (encodings.hasOwnProperty(encoding)) {
	            encodingBlock = encodings[encoding][font.PostScriptName]
	            if (encodingBlock) {
	              if (font.metadata[encoding]) {
	                unicode_section = font.metadata[encoding]
	              } else {
	                unicode_section = font.metadata[encoding] = {}
	              }

	              unicode_section.encoding = encodingBlock
	              if (encodingBlock.codePages && encodingBlock.codePages.length) {
	                font.encoding = encodingBlock.codePages[0]
	              }
	            }
	        //  }
	        // }
	      }
	    }
	  }
	]) // end of adding event handler

	})(jsPDF.API);
	/** ==================================================================== 
	 * jsPDF total_pages plugin
	 * Copyright (c) 2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */

	(function(jsPDFAPI) {
	'use strict';

	jsPDFAPI.putTotalPages = function(pageExpression, replacement) {
	  'use strict';
	  if (!replacement) {
	    replacement = this.internal.getNumberOfPages();
	  }
	    var replaceExpression = new RegExp(pageExpression, 'g');
	    for (var n = 1; n <= this.internal.getNumberOfPages(); n++) {
	        for (var i = 0; i < this.internal.pages[n].length; i++) {
	            this.internal.pages[n][i] = this.internal.pages[n][i].replace(replaceExpression, replacement);
	        }
	    }
	  return this;
	};

	})(jsPDF.API);
	/* Blob.js
	 * A Blob implementation.
	 * 2014-07-01
	 * 
	 * By Eli Grey, http://eligrey.com
	 * By Devin Samarin, https://github.com/eboyjr
	 * License: X11/MIT
	 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
	 */

	/*global self, unescape */
	/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
	  plusplus: true */

	/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */

	(function (view) {
	  "use strict";

	  view.URL = view.URL || view.webkitURL;

	  if (view.Blob && view.URL) {
	    try {
	      new Blob;
	      return;
	    } catch (e) {}
	  }

	  // Internally we use a BlobBuilder implementation to base Blob off of
	  // in order to support older browsers that only have BlobBuilder
	  var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view) {
	    var
	        get_class = function(object) {
	        return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
	      }
	      , FakeBlobBuilder = function BlobBuilder() {
	        this.data = [];
	      }
	      , FakeBlob = function Blob(data, type, encoding) {
	        this.data = data;
	        this.size = data.length;
	        this.type = type;
	        this.encoding = encoding;
	      }
	      , FBB_proto = FakeBlobBuilder.prototype
	      , FB_proto = FakeBlob.prototype
	      , FileReaderSync = view.FileReaderSync
	      , FileException = function(type) {
	        this.code = this[this.name = type];
	      }
	      , file_ex_codes = (
	          "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR "
	        + "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR"
	      ).split(" ")
	      , file_ex_code = file_ex_codes.length
	      , real_URL = view.URL || view.webkitURL || view
	      , real_create_object_URL = real_URL.createObjectURL
	      , real_revoke_object_URL = real_URL.revokeObjectURL
	      , URL = real_URL
	      , btoa = view.btoa
	      , atob = view.atob
	      
	      , ArrayBuffer = view.ArrayBuffer
	      , Uint8Array = view.Uint8Array
	    ;
	    FakeBlob.fake = FB_proto.fake = true;
	    while (file_ex_code--) {
	      FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
	    }
	    if (!real_URL.createObjectURL) {
	      URL = view.URL = {};
	    }
	    URL.createObjectURL = function(blob) {
	      var
	          type = blob.type
	        , data_URI_header
	      ;
	      if (type === null) {
	        type = "application/octet-stream";
	      }
	      if (blob instanceof FakeBlob) {
	        data_URI_header = "data:" + type;
	        if (blob.encoding === "base64") {
	          return data_URI_header + ";base64," + blob.data;
	        } else if (blob.encoding === "URI") {
	          return data_URI_header + "," + decodeURIComponent(blob.data);
	        } if (btoa) {
	          return data_URI_header + ";base64," + btoa(blob.data);
	        } else {
	          return data_URI_header + "," + encodeURIComponent(blob.data);
	        }
	      } else if (real_create_object_URL) {
	        return real_create_object_URL.call(real_URL, blob);
	      }
	    };
	    URL.revokeObjectURL = function(object_URL) {
	      if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
	        real_revoke_object_URL.call(real_URL, object_URL);
	      }
	    };
	    FBB_proto.append = function(data/*, endings*/) {
	      var bb = this.data;
	      // decode data to a binary string
	      if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
	        var
	            str = ""
	          , buf = new Uint8Array(data)
	          , i = 0
	          , buf_len = buf.length
	        ;
	        for (; i < buf_len; i++) {
	          str += String.fromCharCode(buf[i]);
	        }
	        bb.push(str);
	      } else if (get_class(data) === "Blob" || get_class(data) === "File") {
	        if (FileReaderSync) {
	          var fr = new FileReaderSync;
	          bb.push(fr.readAsBinaryString(data));
	        } else {
	          // async FileReader won't work as BlobBuilder is sync
	          throw new FileException("NOT_READABLE_ERR");
	        }
	      } else if (data instanceof FakeBlob) {
	        if (data.encoding === "base64" && atob) {
	          bb.push(atob(data.data));
	        } else if (data.encoding === "URI") {
	          bb.push(decodeURIComponent(data.data));
	        } else if (data.encoding === "raw") {
	          bb.push(data.data);
	        }
	      } else {
	        if (typeof data !== "string") {
	          data += ""; // convert unsupported types to strings
	        }
	        // decode UTF-16 to binary string
	        bb.push(unescape(encodeURIComponent(data)));
	      }
	    };
	    FBB_proto.getBlob = function(type) {
	      if (!arguments.length) {
	        type = null;
	      }
	      return new FakeBlob(this.data.join(""), type, "raw");
	    };
	    FBB_proto.toString = function() {
	      return "[object BlobBuilder]";
	    };
	    FB_proto.slice = function(start, end, type) {
	      var args = arguments.length;
	      if (args < 3) {
	        type = null;
	      }
	      return new FakeBlob(
	          this.data.slice(start, args > 1 ? end : this.data.length)
	        , type
	        , this.encoding
	      );
	    };
	    FB_proto.toString = function() {
	      return "[object Blob]";
	    };
	    FB_proto.close = function() {
	      this.size = 0;
	      delete this.data;
	    };
	    return FakeBlobBuilder;
	  }(view));

	  view.Blob = function(blobParts, options) {
	    var type = options ? (options.type || "") : "";
	    var builder = new BlobBuilder();
	    if (blobParts) {
	      for (var i = 0, len = blobParts.length; i < len; i++) {
	        builder.append(blobParts[i]);
	      }
	    }
	    return builder.getBlob(type);
	  };
	}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this));
	/*
	 * Copyright (c) 2012 chick307 <chick307@gmail.com>
	 *
	 * Licensed under the MIT License.
	 * http://opensource.org/licenses/mit-license
	 */

	void function(global, callback) {
	  // if (typeof module === 'object') {
	  //  module.exports = callback();
	  // } else if (0 === 'function') {
	  //  define(callback);
	  // } else {
	  //  global.adler32cs = callback();
	  // }
	}(jsPDF, function() {
	  var _hasArrayBuffer = typeof ArrayBuffer === 'function' &&
	    typeof Uint8Array === 'function';

	  var _Buffer = null, _isBuffer = (function() {
	    if (!_hasArrayBuffer)
	      return function _isBuffer() { return false };

	    try {
	      var buffer = __webpack_require__(191);
	      if (typeof buffer.Buffer === 'function')
	        _Buffer = buffer.Buffer;
	    } catch (error) {}

	    return function _isBuffer(value) {
	      return value instanceof ArrayBuffer ||
	        _Buffer !== null && value instanceof _Buffer;
	    };
	  }());

	  var _utf8ToBinary = (function() {
	    if (_Buffer !== null) {
	      return function _utf8ToBinary(utf8String) {
	        return new _Buffer(utf8String, 'utf8').toString('binary');
	      };
	    } else {
	      return function _utf8ToBinary(utf8String) {
	        return unescape(encodeURIComponent(utf8String));
	      };
	    }
	  }());

	  var MOD = 65521;

	  var _update = function _update(checksum, binaryString) {
	    var a = checksum & 0xFFFF, b = checksum >>> 16;
	    for (var i = 0, length = binaryString.length; i < length; i++) {
	      a = (a + (binaryString.charCodeAt(i) & 0xFF)) % MOD;
	      b = (b + a) % MOD;
	    }
	    return (b << 16 | a) >>> 0;
	  };

	  var _updateUint8Array = function _updateUint8Array(checksum, uint8Array) {
	    var a = checksum & 0xFFFF, b = checksum >>> 16;
	    for (var i = 0, length = uint8Array.length, x; i < length; i++) {
	      a = (a + uint8Array[i]) % MOD;
	      b = (b + a) % MOD;
	    }
	    return (b << 16 | a) >>> 0
	  };

	  var exports = {};

	  var Adler32 = exports.Adler32 = (function() {
	    var ctor = function Adler32(checksum) {
	      if (!(this instanceof ctor)) {
	        throw new TypeError(
	          'Constructor cannot called be as a function.');
	      }
	      if (!isFinite(checksum = checksum == null ? 1 : +checksum)) {
	        throw new Error(
	          'First arguments needs to be a finite number.');
	      }
	      this.checksum = checksum >>> 0;
	    };

	    var proto = ctor.prototype = {};
	    proto.constructor = ctor;

	    ctor.from = function(from) {
	      from.prototype = proto;
	      return from;
	    }(function from(binaryString) {
	      if (!(this instanceof ctor)) {
	        throw new TypeError(
	          'Constructor cannot called be as a function.');
	      }
	      if (binaryString == null)
	        throw new Error('First argument needs to be a string.');
	      this.checksum = _update(1, binaryString.toString());
	    });

	    ctor.fromUtf8 = function(fromUtf8) {
	      fromUtf8.prototype = proto;
	      return fromUtf8;
	    }(function fromUtf8(utf8String) {
	      if (!(this instanceof ctor)) {
	        throw new TypeError(
	          'Constructor cannot called be as a function.');
	      }
	      if (utf8String == null)
	        throw new Error('First argument needs to be a string.');
	      var binaryString = _utf8ToBinary(utf8String.toString());
	      this.checksum = _update(1, binaryString);
	    });

	    if (_hasArrayBuffer) {
	      ctor.fromBuffer = function(fromBuffer) {
	        fromBuffer.prototype = proto;
	        return fromBuffer;
	      }(function fromBuffer(buffer) {
	        if (!(this instanceof ctor)) {
	          throw new TypeError(
	            'Constructor cannot called be as a function.');
	        }
	        if (!_isBuffer(buffer))
	          throw new Error('First argument needs to be ArrayBuffer.');
	        var array = new Uint8Array(buffer);
	        return this.checksum = _updateUint8Array(1, array);
	      });
	    }

	    proto.update = function update(binaryString) {
	      if (binaryString == null)
	        throw new Error('First argument needs to be a string.');
	      binaryString = binaryString.toString();
	      return this.checksum = _update(this.checksum, binaryString);
	    };

	    proto.updateUtf8 = function updateUtf8(utf8String) {
	      if (utf8String == null)
	        throw new Error('First argument needs to be a string.');
	      var binaryString = _utf8ToBinary(utf8String.toString());
	      return this.checksum = _update(this.checksum, binaryString);
	    };

	    if (_hasArrayBuffer) {
	      proto.updateBuffer = function updateBuffer(buffer) {
	        if (!_isBuffer(buffer))
	          throw new Error('First argument needs to be ArrayBuffer.');
	        var array = new Uint8Array(buffer);
	        return this.checksum = _updateUint8Array(this.checksum, array);
	      };
	    }

	    proto.clone = function clone() {
	      return new Adler32(this.checksum);
	    };

	    return ctor;
	  }());

	  exports.from = function from(binaryString) {
	    if (binaryString == null)
	      throw new Error('First argument needs to be a string.');
	    return _update(1, binaryString.toString());
	  };

	  exports.fromUtf8 = function fromUtf8(utf8String) {
	    if (utf8String == null)
	      throw new Error('First argument needs to be a string.');
	    var binaryString = _utf8ToBinary(utf8String.toString());
	    return _update(1, binaryString);
	  };

	  if (_hasArrayBuffer) {
	    exports.fromBuffer = function fromBuffer(buffer) {
	      if (!_isBuffer(buffer))
	        throw new Error('First argument need to be ArrayBuffer.');
	      var array = new Uint8Array(buffer);
	      return _updateUint8Array(1, array);
	    };
	  }

	  return exports;
	});
	/*
	 Deflate.js - https://github.com/gildas-lormeau/zip.js
	 Copyright (c) 2013 Gildas Lormeau. All rights reserved.

	 Redistribution and use in source and binary forms, with or without
	 modification, are permitted provided that the following conditions are met:

	 1. Redistributions of source code must retain the above copyright notice,
	 this list of conditions and the following disclaimer.

	 2. Redistributions in binary form must reproduce the above copyright 
	 notice, this list of conditions and the following disclaimer in 
	 the documentation and/or other materials provided with the distribution.

	 3. The names of the authors may not be used to endorse or promote products
	 derived from this software without specific prior written permission.

	 THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
	 INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
	 FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
	 INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
	 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
	 OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
	 LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	 NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	 EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */

	/*
	 * This program is based on JZlib 1.0.2 ymnk, JCraft,Inc.
	 * JZlib is based on zlib-1.1.3, so all credit should go authors
	 * Jean-loup Gailly(jloup@gzip.org) and Mark Adler(madler@alumni.caltech.edu)
	 * and contributors of zlib.
	 */

	var Deflater = (function(obj) {

	  // Global

	  var MAX_BITS = 15;
	  var D_CODES = 30;
	  var BL_CODES = 19;

	  var LENGTH_CODES = 29;
	  var LITERALS = 256;
	  var L_CODES = (LITERALS + 1 + LENGTH_CODES);
	  var HEAP_SIZE = (2 * L_CODES + 1);

	  var END_BLOCK = 256;

	  // Bit length codes must not exceed MAX_BL_BITS bits
	  var MAX_BL_BITS = 7;

	  // repeat previous bit length 3-6 times (2 bits of repeat count)
	  var REP_3_6 = 16;

	  // repeat a zero length 3-10 times (3 bits of repeat count)
	  var REPZ_3_10 = 17;

	  // repeat a zero length 11-138 times (7 bits of repeat count)
	  var REPZ_11_138 = 18;

	  // The lengths of the bit length codes are sent in order of decreasing
	  // probability, to avoid transmitting the lengths for unused bit
	  // length codes.

	  var Buf_size = 8 * 2;

	  // JZlib version : "1.0.2"
	  var Z_DEFAULT_COMPRESSION = -1;

	  // compression strategy
	  var Z_FILTERED = 1;
	  var Z_HUFFMAN_ONLY = 2;
	  var Z_DEFAULT_STRATEGY = 0;

	  var Z_NO_FLUSH = 0;
	  var Z_PARTIAL_FLUSH = 1;
	  var Z_FULL_FLUSH = 3;
	  var Z_FINISH = 4;

	  var Z_OK = 0;
	  var Z_STREAM_END = 1;
	  var Z_NEED_DICT = 2;
	  var Z_STREAM_ERROR = -2;
	  var Z_DATA_ERROR = -3;
	  var Z_BUF_ERROR = -5;

	  // Tree

	  // see definition of array dist_code below
	  var _dist_code = [ 0, 1, 2, 3, 4, 4, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10,
	      10, 10, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12,
	      12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13,
	      13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14,
	      14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14,
	      14, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15,
	      15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 0, 0, 16, 17, 18, 18, 19, 19,
	      20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	      24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26,
	      26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27,
	      27, 27, 27, 27, 27, 27, 27, 27, 27, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28,
	      28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 29,
	      29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29,
	      29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29 ];

	  function Tree() {
	    var that = this;

	    // dyn_tree; // the dynamic tree
	    // max_code; // largest code with non zero frequency
	    // stat_desc; // the corresponding static tree

	    // Compute the optimal bit lengths for a tree and update the total bit
	    // length
	    // for the current block.
	    // IN assertion: the fields freq and dad are set, heap[heap_max] and
	    // above are the tree nodes sorted by increasing frequency.
	    // OUT assertions: the field len is set to the optimal bit length, the
	    // array bl_count contains the frequencies for each bit length.
	    // The length opt_len is updated; static_len is also updated if stree is
	    // not null.
	    function gen_bitlen(s) {
	      var tree = that.dyn_tree;
	      var stree = that.stat_desc.static_tree;
	      var extra = that.stat_desc.extra_bits;
	      var base = that.stat_desc.extra_base;
	      var max_length = that.stat_desc.max_length;
	      var h; // heap index
	      var n, m; // iterate over the tree elements
	      var bits; // bit length
	      var xbits; // extra bits
	      var f; // frequency
	      var overflow = 0; // number of elements with bit length too large

	      for (bits = 0; bits <= MAX_BITS; bits++)
	        s.bl_count[bits] = 0;

	      // In a first pass, compute the optimal bit lengths (which may
	      // overflow in the case of the bit length tree).
	      tree[s.heap[s.heap_max] * 2 + 1] = 0; // root of the heap

	      for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	        n = s.heap[h];
	        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
	        if (bits > max_length) {
	          bits = max_length;
	          overflow++;
	        }
	        tree[n * 2 + 1] = bits;
	        // We overwrite tree[n*2+1] which is no longer needed

	        if (n > that.max_code)
	          continue; // not a leaf node

	        s.bl_count[bits]++;
	        xbits = 0;
	        if (n >= base)
	          xbits = extra[n - base];
	        f = tree[n * 2];
	        s.opt_len += f * (bits + xbits);
	        if (stree)
	          s.static_len += f * (stree[n * 2 + 1] + xbits);
	      }
	      if (overflow === 0)
	        return;

	      // This happens for example on obj2 and pic of the Calgary corpus
	      // Find the first bit length which could increase:
	      do {
	        bits = max_length - 1;
	        while (s.bl_count[bits] === 0)
	          bits--;
	        s.bl_count[bits]--; // move one leaf down the tree
	        s.bl_count[bits + 1] += 2; // move one overflow item as its brother
	        s.bl_count[max_length]--;
	        // The brother of the overflow item also moves one step up,
	        // but this does not affect bl_count[max_length]
	        overflow -= 2;
	      } while (overflow > 0);

	      for (bits = max_length; bits !== 0; bits--) {
	        n = s.bl_count[bits];
	        while (n !== 0) {
	          m = s.heap[--h];
	          if (m > that.max_code)
	            continue;
	          if (tree[m * 2 + 1] != bits) {
	            s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];
	            tree[m * 2 + 1] = bits;
	          }
	          n--;
	        }
	      }
	    }

	    // Reverse the first len bits of a code, using straightforward code (a
	    // faster
	    // method would use a table)
	    // IN assertion: 1 <= len <= 15
	    function bi_reverse(code, // the value to invert
	    len // its bit length
	    ) {
	      var res = 0;
	      do {
	        res |= code & 1;
	        code >>>= 1;
	        res <<= 1;
	      } while (--len > 0);
	      return res >>> 1;
	    }

	    // Generate the codes for a given tree and bit counts (which need not be
	    // optimal).
	    // IN assertion: the array bl_count contains the bit length statistics for
	    // the given tree and the field len is set for all tree elements.
	    // OUT assertion: the field code is set for all tree elements of non
	    // zero code length.
	    function gen_codes(tree, // the tree to decorate
	    max_code, // largest code with non zero frequency
	    bl_count // number of codes at each bit length
	    ) {
	      var next_code = []; // next code value for each
	      // bit length
	      var code = 0; // running code value
	      var bits; // bit index
	      var n; // code index
	      var len;

	      // The distribution counts are first used to generate the code values
	      // without bit reversal.
	      for (bits = 1; bits <= MAX_BITS; bits++) {
	        next_code[bits] = code = ((code + bl_count[bits - 1]) << 1);
	      }

	      // Check that the bit counts in bl_count are consistent. The last code
	      // must be all ones.
	      // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	      // "inconsistent bit counts");
	      // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

	      for (n = 0; n <= max_code; n++) {
	        len = tree[n * 2 + 1];
	        if (len === 0)
	          continue;
	        // Now reverse the bits
	        tree[n * 2] = bi_reverse(next_code[len]++, len);
	      }
	    }

	    // Construct one Huffman tree and assigns the code bit strings and lengths.
	    // Update the total bit length for the current block.
	    // IN assertion: the field freq is set for all tree elements.
	    // OUT assertions: the fields len and code are set to the optimal bit length
	    // and corresponding code. The length opt_len is updated; static_len is
	    // also updated if stree is not null. The field max_code is set.
	    that.build_tree = function(s) {
	      var tree = that.dyn_tree;
	      var stree = that.stat_desc.static_tree;
	      var elems = that.stat_desc.elems;
	      var n, m; // iterate over heap elements
	      var max_code = -1; // largest code with non zero frequency
	      var node; // new node being created

	      // Construct the initial heap, with least frequent element in
	      // heap[1]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	      // heap[0] is not used.
	      s.heap_len = 0;
	      s.heap_max = HEAP_SIZE;

	      for (n = 0; n < elems; n++) {
	        if (tree[n * 2] !== 0) {
	          s.heap[++s.heap_len] = max_code = n;
	          s.depth[n] = 0;
	        } else {
	          tree[n * 2 + 1] = 0;
	        }
	      }

	      // The pkzip format requires that at least one distance code exists,
	      // and that at least one bit should be sent even if there is only one
	      // possible code. So to avoid special checks later on we force at least
	      // two codes of non zero frequency.
	      while (s.heap_len < 2) {
	        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
	        tree[node * 2] = 1;
	        s.depth[node] = 0;
	        s.opt_len--;
	        if (stree)
	          s.static_len -= stree[node * 2 + 1];
	        // node is 0 or 1 so it does not have extra bits
	      }
	      that.max_code = max_code;

	      // The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	      // establish sub-heaps of increasing lengths:

	      for (n = Math.floor(s.heap_len / 2); n >= 1; n--)
	        s.pqdownheap(tree, n);

	      // Construct the Huffman tree by repeatedly combining the least two
	      // frequent nodes.

	      node = elems; // next internal node of the tree
	      do {
	        // n = node of least frequency
	        n = s.heap[1];
	        s.heap[1] = s.heap[s.heap_len--];
	        s.pqdownheap(tree, 1);
	        m = s.heap[1]; // m = node of next least frequency

	        s.heap[--s.heap_max] = n; // keep the nodes sorted by frequency
	        s.heap[--s.heap_max] = m;

	        // Create a new node father of n and m
	        tree[node * 2] = (tree[n * 2] + tree[m * 2]);
	        s.depth[node] = Math.max(s.depth[n], s.depth[m]) + 1;
	        tree[n * 2 + 1] = tree[m * 2 + 1] = node;

	        // and insert the new node in the heap
	        s.heap[1] = node++;
	        s.pqdownheap(tree, 1);
	      } while (s.heap_len >= 2);

	      s.heap[--s.heap_max] = s.heap[1];

	      // At this point, the fields freq and dad are set. We can now
	      // generate the bit lengths.

	      gen_bitlen(s);

	      // The field len is now set, we can generate the bit codes
	      gen_codes(tree, that.max_code, s.bl_count);
	    };

	  }

	  Tree._length_code = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16,
	      16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20,
	      20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
	      22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	      24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25,
	      25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26,
	      26, 26, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 28 ];

	  Tree.base_length = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 0 ];

	  Tree.base_dist = [ 0, 1, 2, 3, 4, 6, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024, 1536, 2048, 3072, 4096, 6144, 8192, 12288, 16384,
	      24576 ];

	  // Mapping from a distance to a distance code. dist is the distance - 1 and
	  // must not have side effects. _dist_code[256] and _dist_code[257] are never
	  // used.
	  Tree.d_code = function(dist) {
	    return ((dist) < 256 ? _dist_code[dist] : _dist_code[256 + ((dist) >>> 7)]);
	  };

	  // extra bits for each length code
	  Tree.extra_lbits = [ 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0 ];

	  // extra bits for each distance code
	  Tree.extra_dbits = [ 0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13 ];

	  // extra bits for each bit length code
	  Tree.extra_blbits = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7 ];

	  Tree.bl_order = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];

	  // StaticTree

	  function StaticTree(static_tree, extra_bits, extra_base, elems, max_length) {
	    var that = this;
	    that.static_tree = static_tree;
	    that.extra_bits = extra_bits;
	    that.extra_base = extra_base;
	    that.elems = elems;
	    that.max_length = max_length;
	  }

	  StaticTree.static_ltree = [ 12, 8, 140, 8, 76, 8, 204, 8, 44, 8, 172, 8, 108, 8, 236, 8, 28, 8, 156, 8, 92, 8, 220, 8, 60, 8, 188, 8, 124, 8, 252, 8, 2, 8,
	      130, 8, 66, 8, 194, 8, 34, 8, 162, 8, 98, 8, 226, 8, 18, 8, 146, 8, 82, 8, 210, 8, 50, 8, 178, 8, 114, 8, 242, 8, 10, 8, 138, 8, 74, 8, 202, 8, 42,
	      8, 170, 8, 106, 8, 234, 8, 26, 8, 154, 8, 90, 8, 218, 8, 58, 8, 186, 8, 122, 8, 250, 8, 6, 8, 134, 8, 70, 8, 198, 8, 38, 8, 166, 8, 102, 8, 230, 8,
	      22, 8, 150, 8, 86, 8, 214, 8, 54, 8, 182, 8, 118, 8, 246, 8, 14, 8, 142, 8, 78, 8, 206, 8, 46, 8, 174, 8, 110, 8, 238, 8, 30, 8, 158, 8, 94, 8,
	      222, 8, 62, 8, 190, 8, 126, 8, 254, 8, 1, 8, 129, 8, 65, 8, 193, 8, 33, 8, 161, 8, 97, 8, 225, 8, 17, 8, 145, 8, 81, 8, 209, 8, 49, 8, 177, 8, 113,
	      8, 241, 8, 9, 8, 137, 8, 73, 8, 201, 8, 41, 8, 169, 8, 105, 8, 233, 8, 25, 8, 153, 8, 89, 8, 217, 8, 57, 8, 185, 8, 121, 8, 249, 8, 5, 8, 133, 8,
	      69, 8, 197, 8, 37, 8, 165, 8, 101, 8, 229, 8, 21, 8, 149, 8, 85, 8, 213, 8, 53, 8, 181, 8, 117, 8, 245, 8, 13, 8, 141, 8, 77, 8, 205, 8, 45, 8,
	      173, 8, 109, 8, 237, 8, 29, 8, 157, 8, 93, 8, 221, 8, 61, 8, 189, 8, 125, 8, 253, 8, 19, 9, 275, 9, 147, 9, 403, 9, 83, 9, 339, 9, 211, 9, 467, 9,
	      51, 9, 307, 9, 179, 9, 435, 9, 115, 9, 371, 9, 243, 9, 499, 9, 11, 9, 267, 9, 139, 9, 395, 9, 75, 9, 331, 9, 203, 9, 459, 9, 43, 9, 299, 9, 171, 9,
	      427, 9, 107, 9, 363, 9, 235, 9, 491, 9, 27, 9, 283, 9, 155, 9, 411, 9, 91, 9, 347, 9, 219, 9, 475, 9, 59, 9, 315, 9, 187, 9, 443, 9, 123, 9, 379,
	      9, 251, 9, 507, 9, 7, 9, 263, 9, 135, 9, 391, 9, 71, 9, 327, 9, 199, 9, 455, 9, 39, 9, 295, 9, 167, 9, 423, 9, 103, 9, 359, 9, 231, 9, 487, 9, 23,
	      9, 279, 9, 151, 9, 407, 9, 87, 9, 343, 9, 215, 9, 471, 9, 55, 9, 311, 9, 183, 9, 439, 9, 119, 9, 375, 9, 247, 9, 503, 9, 15, 9, 271, 9, 143, 9,
	      399, 9, 79, 9, 335, 9, 207, 9, 463, 9, 47, 9, 303, 9, 175, 9, 431, 9, 111, 9, 367, 9, 239, 9, 495, 9, 31, 9, 287, 9, 159, 9, 415, 9, 95, 9, 351, 9,
	      223, 9, 479, 9, 63, 9, 319, 9, 191, 9, 447, 9, 127, 9, 383, 9, 255, 9, 511, 9, 0, 7, 64, 7, 32, 7, 96, 7, 16, 7, 80, 7, 48, 7, 112, 7, 8, 7, 72, 7,
	      40, 7, 104, 7, 24, 7, 88, 7, 56, 7, 120, 7, 4, 7, 68, 7, 36, 7, 100, 7, 20, 7, 84, 7, 52, 7, 116, 7, 3, 8, 131, 8, 67, 8, 195, 8, 35, 8, 163, 8,
	      99, 8, 227, 8 ];

	  StaticTree.static_dtree = [ 0, 5, 16, 5, 8, 5, 24, 5, 4, 5, 20, 5, 12, 5, 28, 5, 2, 5, 18, 5, 10, 5, 26, 5, 6, 5, 22, 5, 14, 5, 30, 5, 1, 5, 17, 5, 9, 5,
	      25, 5, 5, 5, 21, 5, 13, 5, 29, 5, 3, 5, 19, 5, 11, 5, 27, 5, 7, 5, 23, 5 ];

	  StaticTree.static_l_desc = new StaticTree(StaticTree.static_ltree, Tree.extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);

	  StaticTree.static_d_desc = new StaticTree(StaticTree.static_dtree, Tree.extra_dbits, 0, D_CODES, MAX_BITS);

	  StaticTree.static_bl_desc = new StaticTree(null, Tree.extra_blbits, 0, BL_CODES, MAX_BL_BITS);

	  // Deflate

	  var MAX_MEM_LEVEL = 9;
	  var DEF_MEM_LEVEL = 8;

	  function Config(good_length, max_lazy, nice_length, max_chain, func) {
	    var that = this;
	    that.good_length = good_length;
	    that.max_lazy = max_lazy;
	    that.nice_length = nice_length;
	    that.max_chain = max_chain;
	    that.func = func;
	  }

	  var STORED = 0;
	  var FAST = 1;
	  var SLOW = 2;
	  var config_table = [ new Config(0, 0, 0, 0, STORED), new Config(4, 4, 8, 4, FAST), new Config(4, 5, 16, 8, FAST), new Config(4, 6, 32, 32, FAST),
	      new Config(4, 4, 16, 16, SLOW), new Config(8, 16, 32, 32, SLOW), new Config(8, 16, 128, 128, SLOW), new Config(8, 32, 128, 256, SLOW),
	      new Config(32, 128, 258, 1024, SLOW), new Config(32, 258, 258, 4096, SLOW) ];

	  var z_errmsg = [ "need dictionary", // Z_NEED_DICT
	  // 2
	  "stream end", // Z_STREAM_END 1
	  "", // Z_OK 0
	  "", // Z_ERRNO (-1)
	  "stream error", // Z_STREAM_ERROR (-2)
	  "data error", // Z_DATA_ERROR (-3)
	  "", // Z_MEM_ERROR (-4)
	  "buffer error", // Z_BUF_ERROR (-5)
	  "",// Z_VERSION_ERROR (-6)
	  "" ];

	  // block not completed, need more input or more output
	  var NeedMore = 0;

	  // block flush performed
	  var BlockDone = 1;

	  // finish started, need only more output at next deflate
	  var FinishStarted = 2;

	  // finish done, accept no more input or output
	  var FinishDone = 3;

	  // preset dictionary flag in zlib header
	  var PRESET_DICT = 0x20;

	  var INIT_STATE = 42;
	  var BUSY_STATE = 113;
	  var FINISH_STATE = 666;

	  // The deflate compression method
	  var Z_DEFLATED = 8;

	  var STORED_BLOCK = 0;
	  var STATIC_TREES = 1;
	  var DYN_TREES = 2;

	  var MIN_MATCH = 3;
	  var MAX_MATCH = 258;
	  var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

	  function smaller(tree, n, m, depth) {
	    var tn2 = tree[n * 2];
	    var tm2 = tree[m * 2];
	    return (tn2 < tm2 || (tn2 == tm2 && depth[n] <= depth[m]));
	  }

	  function Deflate() {

	    var that = this;
	    var strm; // pointer back to this zlib stream
	    var status; // as the name implies
	    // pending_buf; // output still pending
	    var pending_buf_size; // size of pending_buf
	    // pending_out; // next pending byte to output to the stream
	    // pending; // nb of bytes in the pending buffer
	    var method; // STORED (for zip only) or DEFLATED
	    var last_flush; // value of flush param for previous deflate call

	    var w_size; // LZ77 window size (32K by default)
	    var w_bits; // log2(w_size) (8..16)
	    var w_mask; // w_size - 1

	    var window;
	    // Sliding window. Input bytes are read into the second half of the window,
	    // and move to the first half later to keep a dictionary of at least wSize
	    // bytes. With this organization, matches are limited to a distance of
	    // wSize-MAX_MATCH bytes, but this ensures that IO is always
	    // performed with a length multiple of the block size. Also, it limits
	    // the window size to 64K, which is quite useful on MSDOS.
	    // To do: use the user input buffer as sliding window.

	    var window_size;
	    // Actual size of window: 2*wSize, except when the user input buffer
	    // is directly used as sliding window.

	    var prev;
	    // Link to older string with same hash index. To limit the size of this
	    // array to 64K, this link is maintained only for the last 32K strings.
	    // An index in this array is thus a window index modulo 32K.

	    var head; // Heads of the hash chains or NIL.

	    var ins_h; // hash index of string to be inserted
	    var hash_size; // number of elements in hash table
	    var hash_bits; // log2(hash_size)
	    var hash_mask; // hash_size-1

	    // Number of bits by which ins_h must be shifted at each input
	    // step. It must be such that after MIN_MATCH steps, the oldest
	    // byte no longer takes part in the hash key, that is:
	    // hash_shift * MIN_MATCH >= hash_bits
	    var hash_shift;

	    // Window position at the beginning of the current output block. Gets
	    // negative when the window is moved backwards.

	    var block_start;

	    var match_length; // length of best match
	    var prev_match; // previous match
	    var match_available; // set if previous match exists
	    var strstart; // start of string to insert
	    var match_start; // start of matching string
	    var lookahead; // number of valid bytes ahead in window

	    // Length of the best match at previous step. Matches not greater than this
	    // are discarded. This is used in the lazy match evaluation.
	    var prev_length;

	    // To speed up deflation, hash chains are never searched beyond this
	    // length. A higher limit improves compression ratio but degrades the speed.
	    var max_chain_length;

	    // Attempt to find a better match only when the current match is strictly
	    // smaller than this value. This mechanism is used only for compression
	    // levels >= 4.
	    var max_lazy_match;

	    // Insert new strings in the hash table only if the match length is not
	    // greater than this length. This saves time but degrades compression.
	    // max_insert_length is used only for compression levels <= 3.

	    var level; // compression level (1..9)
	    var strategy; // favor or force Huffman coding

	    // Use a faster search when the previous match is longer than this
	    var good_match;

	    // Stop searching when current match exceeds this
	    var nice_match;

	    var dyn_ltree; // literal and length tree
	    var dyn_dtree; // distance tree
	    var bl_tree; // Huffman tree for bit lengths

	    var l_desc = new Tree(); // desc for literal tree
	    var d_desc = new Tree(); // desc for distance tree
	    var bl_desc = new Tree(); // desc for bit length tree

	    // that.heap_len; // number of elements in the heap
	    // that.heap_max; // element of largest frequency
	    // The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	    // The same heap array is used to build all trees.

	    // Depth of each subtree used as tie breaker for trees of equal frequency
	    that.depth = [];

	    var l_buf; // index for literals or lengths */

	    // Size of match buffer for literals/lengths. There are 4 reasons for
	    // limiting lit_bufsize to 64K:
	    // - frequencies can be kept in 16 bit counters
	    // - if compression is not successful for the first block, all input
	    // data is still in the window so we can still emit a stored block even
	    // when input comes from standard input. (This can also be done for
	    // all blocks if lit_bufsize is not greater than 32K.)
	    // - if compression is not successful for a file smaller than 64K, we can
	    // even emit a stored file instead of a stored block (saving 5 bytes).
	    // This is applicable only for zip (not gzip or zlib).
	    // - creating new Huffman trees less frequently may not provide fast
	    // adaptation to changes in the input data statistics. (Take for
	    // example a binary file with poorly compressible code followed by
	    // a highly compressible string table.) Smaller buffer sizes give
	    // fast adaptation but have of course the overhead of transmitting
	    // trees more frequently.
	    // - I can't count above 4
	    var lit_bufsize;

	    var last_lit; // running index in l_buf

	    // Buffer for distances. To simplify the code, d_buf and l_buf have
	    // the same number of elements. To use different lengths, an extra flag
	    // array would be necessary.

	    var d_buf; // index of pendig_buf

	    // that.opt_len; // bit length of current block with optimal trees
	    // that.static_len; // bit length of current block with static trees
	    var matches; // number of string matches in current block
	    var last_eob_len; // bit length of EOB code for last block

	    // Output buffer. bits are inserted starting at the bottom (least
	    // significant bits).
	    var bi_buf;

	    // Number of valid bits in bi_buf. All bits above the last valid bit
	    // are always zero.
	    var bi_valid;

	    // number of codes at each bit length for an optimal tree
	    that.bl_count = [];

	    // heap used to build the Huffman trees
	    that.heap = [];

	    dyn_ltree = [];
	    dyn_dtree = [];
	    bl_tree = [];

	    function lm_init() {
	      var i;
	      window_size = 2 * w_size;

	      head[hash_size - 1] = 0;
	      for (i = 0; i < hash_size - 1; i++) {
	        head[i] = 0;
	      }

	      // Set the default configuration parameters:
	      max_lazy_match = config_table[level].max_lazy;
	      good_match = config_table[level].good_length;
	      nice_match = config_table[level].nice_length;
	      max_chain_length = config_table[level].max_chain;

	      strstart = 0;
	      block_start = 0;
	      lookahead = 0;
	      match_length = prev_length = MIN_MATCH - 1;
	      match_available = 0;
	      ins_h = 0;
	    }

	    function init_block() {
	      var i;
	      // Initialize the trees.
	      for (i = 0; i < L_CODES; i++)
	        dyn_ltree[i * 2] = 0;
	      for (i = 0; i < D_CODES; i++)
	        dyn_dtree[i * 2] = 0;
	      for (i = 0; i < BL_CODES; i++)
	        bl_tree[i * 2] = 0;

	      dyn_ltree[END_BLOCK * 2] = 1;
	      that.opt_len = that.static_len = 0;
	      last_lit = matches = 0;
	    }

	    // Initialize the tree data structures for a new zlib stream.
	    function tr_init() {

	      l_desc.dyn_tree = dyn_ltree;
	      l_desc.stat_desc = StaticTree.static_l_desc;

	      d_desc.dyn_tree = dyn_dtree;
	      d_desc.stat_desc = StaticTree.static_d_desc;

	      bl_desc.dyn_tree = bl_tree;
	      bl_desc.stat_desc = StaticTree.static_bl_desc;

	      bi_buf = 0;
	      bi_valid = 0;
	      last_eob_len = 8; // enough lookahead for inflate

	      // Initialize the first block of the first file:
	      init_block();
	    }

	    // Restore the heap property by moving down the tree starting at node k,
	    // exchanging a node with the smallest of its two sons if necessary,
	    // stopping
	    // when the heap property is re-established (each father smaller than its
	    // two sons).
	    that.pqdownheap = function(tree, // the tree to restore
	    k // node to move down
	    ) {
	      var heap = that.heap;
	      var v = heap[k];
	      var j = k << 1; // left son of k
	      while (j <= that.heap_len) {
	        // Set j to the smallest of the two sons:
	        if (j < that.heap_len && smaller(tree, heap[j + 1], heap[j], that.depth)) {
	          j++;
	        }
	        // Exit if v is smaller than both sons
	        if (smaller(tree, v, heap[j], that.depth))
	          break;

	        // Exchange v with the smallest son
	        heap[k] = heap[j];
	        k = j;
	        // And continue down the tree, setting j to the left son of k
	        j <<= 1;
	      }
	      heap[k] = v;
	    };

	    // Scan a literal or distance tree to determine the frequencies of the codes
	    // in the bit length tree.
	    function scan_tree(tree,// the tree to be scanned
	    max_code // and its largest code of non zero frequency
	    ) {
	      var n; // iterates over all tree elements
	      var prevlen = -1; // last emitted length
	      var curlen; // length of current code
	      var nextlen = tree[0 * 2 + 1]; // length of next code
	      var count = 0; // repeat count of the current code
	      var max_count = 7; // max repeat count
	      var min_count = 4; // min repeat count

	      if (nextlen === 0) {
	        max_count = 138;
	        min_count = 3;
	      }
	      tree[(max_code + 1) * 2 + 1] = 0xffff; // guard

	      for (n = 0; n <= max_code; n++) {
	        curlen = nextlen;
	        nextlen = tree[(n + 1) * 2 + 1];
	        if (++count < max_count && curlen == nextlen) {
	          continue;
	        } else if (count < min_count) {
	          bl_tree[curlen * 2] += count;
	        } else if (curlen !== 0) {
	          if (curlen != prevlen)
	            bl_tree[curlen * 2]++;
	          bl_tree[REP_3_6 * 2]++;
	        } else if (count <= 10) {
	          bl_tree[REPZ_3_10 * 2]++;
	        } else {
	          bl_tree[REPZ_11_138 * 2]++;
	        }
	        count = 0;
	        prevlen = curlen;
	        if (nextlen === 0) {
	          max_count = 138;
	          min_count = 3;
	        } else if (curlen == nextlen) {
	          max_count = 6;
	          min_count = 3;
	        } else {
	          max_count = 7;
	          min_count = 4;
	        }
	      }
	    }

	    // Construct the Huffman tree for the bit lengths and return the index in
	    // bl_order of the last bit length code to send.
	    function build_bl_tree() {
	      var max_blindex; // index of last bit length code of non zero freq

	      // Determine the bit length frequencies for literal and distance trees
	      scan_tree(dyn_ltree, l_desc.max_code);
	      scan_tree(dyn_dtree, d_desc.max_code);

	      // Build the bit length tree:
	      bl_desc.build_tree(that);
	      // opt_len now includes the length of the tree representations, except
	      // the lengths of the bit lengths codes and the 5+5+4 bits for the
	      // counts.

	      // Determine the number of bit length codes to send. The pkzip format
	      // requires that at least 4 bit length codes be sent. (appnote.txt says
	      // 3 but the actual value used is 4.)
	      for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	        if (bl_tree[Tree.bl_order[max_blindex] * 2 + 1] !== 0)
	          break;
	      }
	      // Update opt_len to include the bit length tree and counts
	      that.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;

	      return max_blindex;
	    }

	    // Output a byte on the stream.
	    // IN assertion: there is enough room in pending_buf.
	    function put_byte(p) {
	      that.pending_buf[that.pending++] = p;
	    }

	    function put_short(w) {
	      put_byte(w & 0xff);
	      put_byte((w >>> 8) & 0xff);
	    }

	    function putShortMSB(b) {
	      put_byte((b >> 8) & 0xff);
	      put_byte((b & 0xff) & 0xff);
	    }

	    function send_bits(value, length) {
	      var val, len = length;
	      if (bi_valid > Buf_size - len) {
	        val = value;
	        // bi_buf |= (val << bi_valid);
	        bi_buf |= ((val << bi_valid) & 0xffff);
	        put_short(bi_buf);
	        bi_buf = val >>> (Buf_size - bi_valid);
	        bi_valid += len - Buf_size;
	      } else {
	        // bi_buf |= (value) << bi_valid;
	        bi_buf |= (((value) << bi_valid) & 0xffff);
	        bi_valid += len;
	      }
	    }

	    function send_code(c, tree) {
	      var c2 = c * 2;
	      send_bits(tree[c2] & 0xffff, tree[c2 + 1] & 0xffff);
	    }

	    // Send a literal or distance tree in compressed form, using the codes in
	    // bl_tree.
	    function send_tree(tree,// the tree to be sent
	    max_code // and its largest code of non zero frequency
	    ) {
	      var n; // iterates over all tree elements
	      var prevlen = -1; // last emitted length
	      var curlen; // length of current code
	      var nextlen = tree[0 * 2 + 1]; // length of next code
	      var count = 0; // repeat count of the current code
	      var max_count = 7; // max repeat count
	      var min_count = 4; // min repeat count

	      if (nextlen === 0) {
	        max_count = 138;
	        min_count = 3;
	      }

	      for (n = 0; n <= max_code; n++) {
	        curlen = nextlen;
	        nextlen = tree[(n + 1) * 2 + 1];
	        if (++count < max_count && curlen == nextlen) {
	          continue;
	        } else if (count < min_count) {
	          do {
	            send_code(curlen, bl_tree);
	          } while (--count !== 0);
	        } else if (curlen !== 0) {
	          if (curlen != prevlen) {
	            send_code(curlen, bl_tree);
	            count--;
	          }
	          send_code(REP_3_6, bl_tree);
	          send_bits(count - 3, 2);
	        } else if (count <= 10) {
	          send_code(REPZ_3_10, bl_tree);
	          send_bits(count - 3, 3);
	        } else {
	          send_code(REPZ_11_138, bl_tree);
	          send_bits(count - 11, 7);
	        }
	        count = 0;
	        prevlen = curlen;
	        if (nextlen === 0) {
	          max_count = 138;
	          min_count = 3;
	        } else if (curlen == nextlen) {
	          max_count = 6;
	          min_count = 3;
	        } else {
	          max_count = 7;
	          min_count = 4;
	        }
	      }
	    }

	    // Send the header for a block using dynamic Huffman trees: the counts, the
	    // lengths of the bit length codes, the literal tree and the distance tree.
	    // IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	    function send_all_trees(lcodes, dcodes, blcodes) {
	      var rank; // index in bl_order

	      send_bits(lcodes - 257, 5); // not +255 as stated in appnote.txt
	      send_bits(dcodes - 1, 5);
	      send_bits(blcodes - 4, 4); // not -3 as stated in appnote.txt
	      for (rank = 0; rank < blcodes; rank++) {
	        send_bits(bl_tree[Tree.bl_order[rank] * 2 + 1], 3);
	      }
	      send_tree(dyn_ltree, lcodes - 1); // literal tree
	      send_tree(dyn_dtree, dcodes - 1); // distance tree
	    }

	    // Flush the bit buffer, keeping at most 7 bits in it.
	    function bi_flush() {
	      if (bi_valid == 16) {
	        put_short(bi_buf);
	        bi_buf = 0;
	        bi_valid = 0;
	      } else if (bi_valid >= 8) {
	        put_byte(bi_buf & 0xff);
	        bi_buf >>>= 8;
	        bi_valid -= 8;
	      }
	    }

	    // Send one empty static block to give enough lookahead for inflate.
	    // This takes 10 bits, of which 7 may remain in the bit buffer.
	    // The current inflate code requires 9 bits of lookahead. If the
	    // last two codes for the previous block (real code plus EOB) were coded
	    // on 5 bits or less, inflate may have only 5+3 bits of lookahead to decode
	    // the last real code. In this case we send two empty static blocks instead
	    // of one. (There are no problems if the previous block is stored or fixed.)
	    // To simplify the code, we assume the worst case of last real code encoded
	    // on one bit only.
	    function _tr_align() {
	      send_bits(STATIC_TREES << 1, 3);
	      send_code(END_BLOCK, StaticTree.static_ltree);

	      bi_flush();

	      // Of the 10 bits for the empty block, we have already sent
	      // (10 - bi_valid) bits. The lookahead for the last real code (before
	      // the EOB of the previous block) was thus at least one plus the length
	      // of the EOB plus what we have just sent of the empty static block.
	      if (1 + last_eob_len + 10 - bi_valid < 9) {
	        send_bits(STATIC_TREES << 1, 3);
	        send_code(END_BLOCK, StaticTree.static_ltree);
	        bi_flush();
	      }
	      last_eob_len = 7;
	    }

	    // Save the match info and tally the frequency counts. Return true if
	    // the current block must be flushed.
	    function _tr_tally(dist, // distance of matched string
	    lc // match length-MIN_MATCH or unmatched char (if dist==0)
	    ) {
	      var out_length, in_length, dcode;
	      that.pending_buf[d_buf + last_lit * 2] = (dist >>> 8) & 0xff;
	      that.pending_buf[d_buf + last_lit * 2 + 1] = dist & 0xff;

	      that.pending_buf[l_buf + last_lit] = lc & 0xff;
	      last_lit++;

	      if (dist === 0) {
	        // lc is the unmatched char
	        dyn_ltree[lc * 2]++;
	      } else {
	        matches++;
	        // Here, lc is the match length - MIN_MATCH
	        dist--; // dist = match distance - 1
	        dyn_ltree[(Tree._length_code[lc] + LITERALS + 1) * 2]++;
	        dyn_dtree[Tree.d_code(dist) * 2]++;
	      }

	      if ((last_lit & 0x1fff) === 0 && level > 2) {
	        // Compute an upper bound for the compressed length
	        out_length = last_lit * 8;
	        in_length = strstart - block_start;
	        for (dcode = 0; dcode < D_CODES; dcode++) {
	          out_length += dyn_dtree[dcode * 2] * (5 + Tree.extra_dbits[dcode]);
	        }
	        out_length >>>= 3;
	        if ((matches < Math.floor(last_lit / 2)) && out_length < Math.floor(in_length / 2))
	          return true;
	      }

	      return (last_lit == lit_bufsize - 1);
	      // We avoid equality with lit_bufsize because of wraparound at 64K
	      // on 16 bit machines and because stored blocks are restricted to
	      // 64K-1 bytes.
	    }

	    // Send the block data compressed using the given Huffman trees
	    function compress_block(ltree, dtree) {
	      var dist; // distance of matched string
	      var lc; // match length or unmatched char (if dist === 0)
	      var lx = 0; // running index in l_buf
	      var code; // the code to send
	      var extra; // number of extra bits to send

	      if (last_lit !== 0) {
	        do {
	          dist = ((that.pending_buf[d_buf + lx * 2] << 8) & 0xff00) | (that.pending_buf[d_buf + lx * 2 + 1] & 0xff);
	          lc = (that.pending_buf[l_buf + lx]) & 0xff;
	          lx++;

	          if (dist === 0) {
	            send_code(lc, ltree); // send a literal byte
	          } else {
	            // Here, lc is the match length - MIN_MATCH
	            code = Tree._length_code[lc];

	            send_code(code + LITERALS + 1, ltree); // send the length
	            // code
	            extra = Tree.extra_lbits[code];
	            if (extra !== 0) {
	              lc -= Tree.base_length[code];
	              send_bits(lc, extra); // send the extra length bits
	            }
	            dist--; // dist is now the match distance - 1
	            code = Tree.d_code(dist);

	            send_code(code, dtree); // send the distance code
	            extra = Tree.extra_dbits[code];
	            if (extra !== 0) {
	              dist -= Tree.base_dist[code];
	              send_bits(dist, extra); // send the extra distance bits
	            }
	          } // literal or match pair ?

	          // Check that the overlay between pending_buf and d_buf+l_buf is
	          // ok:
	        } while (lx < last_lit);
	      }

	      send_code(END_BLOCK, ltree);
	      last_eob_len = ltree[END_BLOCK * 2 + 1];
	    }

	    // Flush the bit buffer and align the output on a byte boundary
	    function bi_windup() {
	      if (bi_valid > 8) {
	        put_short(bi_buf);
	      } else if (bi_valid > 0) {
	        put_byte(bi_buf & 0xff);
	      }
	      bi_buf = 0;
	      bi_valid = 0;
	    }

	    // Copy a stored block, storing first the length and its
	    // one's complement if requested.
	    function copy_block(buf, // the input data
	    len, // its length
	    header // true if block header must be written
	    ) {
	      bi_windup(); // align on byte boundary
	      last_eob_len = 8; // enough lookahead for inflate

	      if (header) {
	        put_short(len);
	        put_short(~len);
	      }

	      that.pending_buf.set(window.subarray(buf, buf + len), that.pending);
	      that.pending += len;
	    }

	    // Send a stored block
	    function _tr_stored_block(buf, // input block
	    stored_len, // length of input block
	    eof // true if this is the last block for a file
	    ) {
	      send_bits((STORED_BLOCK << 1) + (eof ? 1 : 0), 3); // send block type
	      copy_block(buf, stored_len, true); // with header
	    }

	    // Determine the best encoding for the current block: dynamic trees, static
	    // trees or store, and output the encoded block to the zip file.
	    function _tr_flush_block(buf, // input block, or NULL if too old
	    stored_len, // length of input block
	    eof // true if this is the last block for a file
	    ) {
	      var opt_lenb, static_lenb;// opt_len and static_len in bytes
	      var max_blindex = 0; // index of last bit length code of non zero freq

	      // Build the Huffman trees unless a stored block is forced
	      if (level > 0) {
	        // Construct the literal and distance trees
	        l_desc.build_tree(that);

	        d_desc.build_tree(that);

	        // At this point, opt_len and static_len are the total bit lengths
	        // of
	        // the compressed block data, excluding the tree representations.

	        // Build the bit length tree for the above two trees, and get the
	        // index
	        // in bl_order of the last bit length code to send.
	        max_blindex = build_bl_tree();

	        // Determine the best encoding. Compute first the block length in
	        // bytes
	        opt_lenb = (that.opt_len + 3 + 7) >>> 3;
	        static_lenb = (that.static_len + 3 + 7) >>> 3;

	        if (static_lenb <= opt_lenb)
	          opt_lenb = static_lenb;
	      } else {
	        opt_lenb = static_lenb = stored_len + 5; // force a stored block
	      }

	      if ((stored_len + 4 <= opt_lenb) && buf != -1) {
	        // 4: two words for the lengths
	        // The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	        // Otherwise we can't have processed more than WSIZE input bytes
	        // since
	        // the last block flush, because compression would have been
	        // successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	        // transform a block into a stored block.
	        _tr_stored_block(buf, stored_len, eof);
	      } else if (static_lenb == opt_lenb) {
	        send_bits((STATIC_TREES << 1) + (eof ? 1 : 0), 3);
	        compress_block(StaticTree.static_ltree, StaticTree.static_dtree);
	      } else {
	        send_bits((DYN_TREES << 1) + (eof ? 1 : 0), 3);
	        send_all_trees(l_desc.max_code + 1, d_desc.max_code + 1, max_blindex + 1);
	        compress_block(dyn_ltree, dyn_dtree);
	      }

	      // The above check is made mod 2^32, for files larger than 512 MB
	      // and uLong implemented on 32 bits.

	      init_block();

	      if (eof) {
	        bi_windup();
	      }
	    }

	    function flush_block_only(eof) {
	      _tr_flush_block(block_start >= 0 ? block_start : -1, strstart - block_start, eof);
	      block_start = strstart;
	      strm.flush_pending();
	    }

	    // Fill the window when the lookahead becomes insufficient.
	    // Updates strstart and lookahead.
	    //
	    // IN assertion: lookahead < MIN_LOOKAHEAD
	    // OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	    // At least one byte has been read, or avail_in === 0; reads are
	    // performed for at least two bytes (required for the zip translate_eol
	    // option -- not supported here).
	    function fill_window() {
	      var n, m;
	      var p;
	      var more; // Amount of free space at the end of the window.

	      do {
	        more = (window_size - lookahead - strstart);

	        // Deal with !@#$% 64K limit:
	        if (more === 0 && strstart === 0 && lookahead === 0) {
	          more = w_size;
	        } else if (more == -1) {
	          // Very unlikely, but possible on 16 bit machine if strstart ==
	          // 0
	          // and lookahead == 1 (input done one byte at time)
	          more--;

	          // If the window is almost full and there is insufficient
	          // lookahead,
	          // move the upper half to the lower one to make room in the
	          // upper half.
	        } else if (strstart >= w_size + w_size - MIN_LOOKAHEAD) {
	          window.set(window.subarray(w_size, w_size + w_size), 0);

	          match_start -= w_size;
	          strstart -= w_size; // we now have strstart >= MAX_DIST
	          block_start -= w_size;

	          // Slide the hash table (could be avoided with 32 bit values
	          // at the expense of memory usage). We slide even when level ==
	          // 0
	          // to keep the hash table consistent if we switch back to level
	          // > 0
	          // later. (Using level 0 permanently is not an optimal usage of
	          // zlib, so we don't care about this pathological case.)

	          n = hash_size;
	          p = n;
	          do {
	            m = (head[--p] & 0xffff);
	            head[p] = (m >= w_size ? m - w_size : 0);
	          } while (--n !== 0);

	          n = w_size;
	          p = n;
	          do {
	            m = (prev[--p] & 0xffff);
	            prev[p] = (m >= w_size ? m - w_size : 0);
	            // If n is not on any hash chain, prev[n] is garbage but
	            // its value will never be used.
	          } while (--n !== 0);
	          more += w_size;
	        }

	        if (strm.avail_in === 0)
	          return;

	        // If there was no sliding:
	        // strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	        // more == window_size - lookahead - strstart
	        // => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	        // => more >= window_size - 2*WSIZE + 2
	        // In the BIG_MEM or MMAP case (not yet supported),
	        // window_size == input_size + MIN_LOOKAHEAD &&
	        // strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	        // Otherwise, window_size == 2*WSIZE so more >= 2.
	        // If there was sliding, more >= WSIZE. So in all cases, more >= 2.

	        n = strm.read_buf(window, strstart + lookahead, more);
	        lookahead += n;

	        // Initialize the hash value now that we have some input:
	        if (lookahead >= MIN_MATCH) {
	          ins_h = window[strstart] & 0xff;
	          ins_h = (((ins_h) << hash_shift) ^ (window[strstart + 1] & 0xff)) & hash_mask;
	        }
	        // If the whole input has less than MIN_MATCH bytes, ins_h is
	        // garbage,
	        // but this is not important since only literal bytes will be
	        // emitted.
	      } while (lookahead < MIN_LOOKAHEAD && strm.avail_in !== 0);
	    }

	    // Copy without compression as much as possible from the input stream,
	    // return
	    // the current block state.
	    // This function does not insert new strings in the dictionary since
	    // uncompressible data is probably not useful. This function is used
	    // only for the level=0 compression option.
	    // NOTE: this function should be optimized to avoid extra copying from
	    // window to pending_buf.
	    function deflate_stored(flush) {
	      // Stored blocks are limited to 0xffff bytes, pending_buf is limited
	      // to pending_buf_size, and each stored block has a 5 byte header:

	      var max_block_size = 0xffff;
	      var max_start;

	      if (max_block_size > pending_buf_size - 5) {
	        max_block_size = pending_buf_size - 5;
	      }

	      // Copy as much as possible from input to output:
	      while (true) {
	        // Fill the window as much as possible:
	        if (lookahead <= 1) {
	          fill_window();
	          if (lookahead === 0 && flush == Z_NO_FLUSH)
	            return NeedMore;
	          if (lookahead === 0)
	            break; // flush the current block
	        }

	        strstart += lookahead;
	        lookahead = 0;

	        // Emit a stored block if pending_buf will be full:
	        max_start = block_start + max_block_size;
	        if (strstart === 0 || strstart >= max_start) {
	          // strstart === 0 is possible when wraparound on 16-bit machine
	          lookahead = (strstart - max_start);
	          strstart = max_start;

	          flush_block_only(false);
	          if (strm.avail_out === 0)
	            return NeedMore;

	        }

	        // Flush if we may have to slide, otherwise block_start may become
	        // negative and the data will be gone:
	        if (strstart - block_start >= w_size - MIN_LOOKAHEAD) {
	          flush_block_only(false);
	          if (strm.avail_out === 0)
	            return NeedMore;
	        }
	      }

	      flush_block_only(flush == Z_FINISH);
	      if (strm.avail_out === 0)
	        return (flush == Z_FINISH) ? FinishStarted : NeedMore;

	      return flush == Z_FINISH ? FinishDone : BlockDone;
	    }

	    function longest_match(cur_match) {
	      var chain_length = max_chain_length; // max hash chain length
	      var scan = strstart; // current string
	      var match; // matched string
	      var len; // length of current match
	      var best_len = prev_length; // best match length so far
	      var limit = strstart > (w_size - MIN_LOOKAHEAD) ? strstart - (w_size - MIN_LOOKAHEAD) : 0;
	      var _nice_match = nice_match;

	      // Stop when cur_match becomes <= limit. To simplify the code,
	      // we prevent matches with the string of window index 0.

	      var wmask = w_mask;

	      var strend = strstart + MAX_MATCH;
	      var scan_end1 = window[scan + best_len - 1];
	      var scan_end = window[scan + best_len];

	      // The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of
	      // 16.
	      // It is easy to get rid of this optimization if necessary.

	      // Do not waste too much time if we already have a good match:
	      if (prev_length >= good_match) {
	        chain_length >>= 2;
	      }

	      // Do not look for matches beyond the end of the input. This is
	      // necessary
	      // to make deflate deterministic.
	      if (_nice_match > lookahead)
	        _nice_match = lookahead;

	      do {
	        match = cur_match;

	        // Skip to next match if the match length cannot increase
	        // or if the match length is less than 2:
	        if (window[match + best_len] != scan_end || window[match + best_len - 1] != scan_end1 || window[match] != window[scan]
	            || window[++match] != window[scan + 1])
	          continue;

	        // The check at best_len-1 can be removed because it will be made
	        // again later. (This heuristic is not always a win.)
	        // It is not necessary to compare scan[2] and match[2] since they
	        // are always equal when the other bytes match, given that
	        // the hash keys are equal and that HASH_BITS >= 8.
	        scan += 2;
	        match++;

	        // We check for insufficient lookahead only every 8th comparison;
	        // the 256th check will be made at strstart+258.
	        do {
	        } while (window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match]
	            && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match]
	            && window[++scan] == window[++match] && window[++scan] == window[++match] && scan < strend);

	        len = MAX_MATCH - (strend - scan);
	        scan = strend - MAX_MATCH;

	        if (len > best_len) {
	          match_start = cur_match;
	          best_len = len;
	          if (len >= _nice_match)
	            break;
	          scan_end1 = window[scan + best_len - 1];
	          scan_end = window[scan + best_len];
	        }

	      } while ((cur_match = (prev[cur_match & wmask] & 0xffff)) > limit && --chain_length !== 0);

	      if (best_len <= lookahead)
	        return best_len;
	      return lookahead;
	    }

	    // Compress as much as possible from the input stream, return the current
	    // block state.
	    // This function does not perform lazy evaluation of matches and inserts
	    // new strings in the dictionary only for unmatched strings or for short
	    // matches. It is used only for the fast compression options.
	    function deflate_fast(flush) {
	      // short hash_head = 0; // head of the hash chain
	      var hash_head = 0; // head of the hash chain
	      var bflush; // set if current block must be flushed

	      while (true) {
	        // Make sure that we always have enough lookahead, except
	        // at the end of the input file. We need MAX_MATCH bytes
	        // for the next match, plus MIN_MATCH bytes to insert the
	        // string following the next match.
	        if (lookahead < MIN_LOOKAHEAD) {
	          fill_window();
	          if (lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH) {
	            return NeedMore;
	          }
	          if (lookahead === 0)
	            break; // flush the current block
	        }

	        // Insert the string window[strstart .. strstart+2] in the
	        // dictionary, and set hash_head to the head of the hash chain:
	        if (lookahead >= MIN_MATCH) {
	          ins_h = (((ins_h) << hash_shift) ^ (window[(strstart) + (MIN_MATCH - 1)] & 0xff)) & hash_mask;

	          // prev[strstart&w_mask]=hash_head=head[ins_h];
	          hash_head = (head[ins_h] & 0xffff);
	          prev[strstart & w_mask] = head[ins_h];
	          head[ins_h] = strstart;
	        }

	        // Find the longest match, discarding those <= prev_length.
	        // At this point we have always match_length < MIN_MATCH

	        if (hash_head !== 0 && ((strstart - hash_head) & 0xffff) <= w_size - MIN_LOOKAHEAD) {
	          // To simplify the code, we prevent matches with the string
	          // of window index 0 (in particular we have to avoid a match
	          // of the string with itself at the start of the input file).
	          if (strategy != Z_HUFFMAN_ONLY) {
	            match_length = longest_match(hash_head);
	          }
	          // longest_match() sets match_start
	        }
	        if (match_length >= MIN_MATCH) {
	          // check_match(strstart, match_start, match_length);

	          bflush = _tr_tally(strstart - match_start, match_length - MIN_MATCH);

	          lookahead -= match_length;

	          // Insert new strings in the hash table only if the match length
	          // is not too large. This saves time but degrades compression.
	          if (match_length <= max_lazy_match && lookahead >= MIN_MATCH) {
	            match_length--; // string at strstart already in hash table
	            do {
	              strstart++;

	              ins_h = ((ins_h << hash_shift) ^ (window[(strstart) + (MIN_MATCH - 1)] & 0xff)) & hash_mask;
	              // prev[strstart&w_mask]=hash_head=head[ins_h];
	              hash_head = (head[ins_h] & 0xffff);
	              prev[strstart & w_mask] = head[ins_h];
	              head[ins_h] = strstart;

	              // strstart never exceeds WSIZE-MAX_MATCH, so there are
	              // always MIN_MATCH bytes ahead.
	            } while (--match_length !== 0);
	            strstart++;
	          } else {
	            strstart += match_length;
	            match_length = 0;
	            ins_h = window[strstart] & 0xff;

	            ins_h = (((ins_h) << hash_shift) ^ (window[strstart + 1] & 0xff)) & hash_mask;
	            // If lookahead < MIN_MATCH, ins_h is garbage, but it does
	            // not
	            // matter since it will be recomputed at next deflate call.
	          }
	        } else {
	          // No match, output a literal byte

	          bflush = _tr_tally(0, window[strstart] & 0xff);
	          lookahead--;
	          strstart++;
	        }
	        if (bflush) {

	          flush_block_only(false);
	          if (strm.avail_out === 0)
	            return NeedMore;
	        }
	      }

	      flush_block_only(flush == Z_FINISH);
	      if (strm.avail_out === 0) {
	        if (flush == Z_FINISH)
	          return FinishStarted;
	        else
	          return NeedMore;
	      }
	      return flush == Z_FINISH ? FinishDone : BlockDone;
	    }

	    // Same as above, but achieves better compression. We use a lazy
	    // evaluation for matches: a match is finally adopted only if there is
	    // no better match at the next window position.
	    function deflate_slow(flush) {
	      // short hash_head = 0; // head of hash chain
	      var hash_head = 0; // head of hash chain
	      var bflush; // set if current block must be flushed
	      var max_insert;

	      // Process the input block.
	      while (true) {
	        // Make sure that we always have enough lookahead, except
	        // at the end of the input file. We need MAX_MATCH bytes
	        // for the next match, plus MIN_MATCH bytes to insert the
	        // string following the next match.

	        if (lookahead < MIN_LOOKAHEAD) {
	          fill_window();
	          if (lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH) {
	            return NeedMore;
	          }
	          if (lookahead === 0)
	            break; // flush the current block
	        }

	        // Insert the string window[strstart .. strstart+2] in the
	        // dictionary, and set hash_head to the head of the hash chain:

	        if (lookahead >= MIN_MATCH) {
	          ins_h = (((ins_h) << hash_shift) ^ (window[(strstart) + (MIN_MATCH - 1)] & 0xff)) & hash_mask;
	          // prev[strstart&w_mask]=hash_head=head[ins_h];
	          hash_head = (head[ins_h] & 0xffff);
	          prev[strstart & w_mask] = head[ins_h];
	          head[ins_h] = strstart;
	        }

	        // Find the longest match, discarding those <= prev_length.
	        prev_length = match_length;
	        prev_match = match_start;
	        match_length = MIN_MATCH - 1;

	        if (hash_head !== 0 && prev_length < max_lazy_match && ((strstart - hash_head) & 0xffff) <= w_size - MIN_LOOKAHEAD) {
	          // To simplify the code, we prevent matches with the string
	          // of window index 0 (in particular we have to avoid a match
	          // of the string with itself at the start of the input file).

	          if (strategy != Z_HUFFMAN_ONLY) {
	            match_length = longest_match(hash_head);
	          }
	          // longest_match() sets match_start

	          if (match_length <= 5 && (strategy == Z_FILTERED || (match_length == MIN_MATCH && strstart - match_start > 4096))) {

	            // If prev_match is also MIN_MATCH, match_start is garbage
	            // but we will ignore the current match anyway.
	            match_length = MIN_MATCH - 1;
	          }
	        }

	        // If there was a match at the previous step and the current
	        // match is not better, output the previous match:
	        if (prev_length >= MIN_MATCH && match_length <= prev_length) {
	          max_insert = strstart + lookahead - MIN_MATCH;
	          // Do not insert strings in hash table beyond this.

	          // check_match(strstart-1, prev_match, prev_length);

	          bflush = _tr_tally(strstart - 1 - prev_match, prev_length - MIN_MATCH);

	          // Insert in hash table all strings up to the end of the match.
	          // strstart-1 and strstart are already inserted. If there is not
	          // enough lookahead, the last two strings are not inserted in
	          // the hash table.
	          lookahead -= prev_length - 1;
	          prev_length -= 2;
	          do {
	            if (++strstart <= max_insert) {
	              ins_h = (((ins_h) << hash_shift) ^ (window[(strstart) + (MIN_MATCH - 1)] & 0xff)) & hash_mask;
	              // prev[strstart&w_mask]=hash_head=head[ins_h];
	              hash_head = (head[ins_h] & 0xffff);
	              prev[strstart & w_mask] = head[ins_h];
	              head[ins_h] = strstart;
	            }
	          } while (--prev_length !== 0);
	          match_available = 0;
	          match_length = MIN_MATCH - 1;
	          strstart++;

	          if (bflush) {
	            flush_block_only(false);
	            if (strm.avail_out === 0)
	              return NeedMore;
	          }
	        } else if (match_available !== 0) {

	          // If there was no match at the previous position, output a
	          // single literal. If there was a match but the current match
	          // is longer, truncate the previous match to a single literal.

	          bflush = _tr_tally(0, window[strstart - 1] & 0xff);

	          if (bflush) {
	            flush_block_only(false);
	          }
	          strstart++;
	          lookahead--;
	          if (strm.avail_out === 0)
	            return NeedMore;
	        } else {
	          // There is no previous match to compare with, wait for
	          // the next step to decide.

	          match_available = 1;
	          strstart++;
	          lookahead--;
	        }
	      }

	      if (match_available !== 0) {
	        bflush = _tr_tally(0, window[strstart - 1] & 0xff);
	        match_available = 0;
	      }
	      flush_block_only(flush == Z_FINISH);

	      if (strm.avail_out === 0) {
	        if (flush == Z_FINISH)
	          return FinishStarted;
	        else
	          return NeedMore;
	      }

	      return flush == Z_FINISH ? FinishDone : BlockDone;
	    }

	    function deflateReset(strm) {
	      strm.total_in = strm.total_out = 0;
	      strm.msg = null; //
	      
	      that.pending = 0;
	      that.pending_out = 0;

	      status = BUSY_STATE;

	      last_flush = Z_NO_FLUSH;

	      tr_init();
	      lm_init();
	      return Z_OK;
	    }

	    that.deflateInit = function(strm, _level, bits, _method, memLevel, _strategy) {
	      if (!_method)
	        _method = Z_DEFLATED;
	      if (!memLevel)
	        memLevel = DEF_MEM_LEVEL;
	      if (!_strategy)
	        _strategy = Z_DEFAULT_STRATEGY;

	      // byte[] my_version=ZLIB_VERSION;

	      //
	      // if (!version || version[0] != my_version[0]
	      // || stream_size != sizeof(z_stream)) {
	      // return Z_VERSION_ERROR;
	      // }

	      strm.msg = null;

	      if (_level == Z_DEFAULT_COMPRESSION)
	        _level = 6;

	      if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || _method != Z_DEFLATED || bits < 9 || bits > 15 || _level < 0 || _level > 9 || _strategy < 0
	          || _strategy > Z_HUFFMAN_ONLY) {
	        return Z_STREAM_ERROR;
	      }

	      strm.dstate = that;

	      w_bits = bits;
	      w_size = 1 << w_bits;
	      w_mask = w_size - 1;

	      hash_bits = memLevel + 7;
	      hash_size = 1 << hash_bits;
	      hash_mask = hash_size - 1;
	      hash_shift = Math.floor((hash_bits + MIN_MATCH - 1) / MIN_MATCH);

	      window = new Uint8Array(w_size * 2);
	      prev = [];
	      head = [];

	      lit_bufsize = 1 << (memLevel + 6); // 16K elements by default

	      // We overlay pending_buf and d_buf+l_buf. This works since the average
	      // output size for (length,distance) codes is <= 24 bits.
	      that.pending_buf = new Uint8Array(lit_bufsize * 4);
	      pending_buf_size = lit_bufsize * 4;

	      d_buf = Math.floor(lit_bufsize / 2);
	      l_buf = (1 + 2) * lit_bufsize;

	      level = _level;

	      strategy = _strategy;
	      method = _method & 0xff;

	      return deflateReset(strm);
	    };

	    that.deflateEnd = function() {
	      if (status != INIT_STATE && status != BUSY_STATE && status != FINISH_STATE) {
	        return Z_STREAM_ERROR;
	      }
	      // Deallocate in reverse order of allocations:
	      that.pending_buf = null;
	      head = null;
	      prev = null;
	      window = null;
	      // free
	      that.dstate = null;
	      return status == BUSY_STATE ? Z_DATA_ERROR : Z_OK;
	    };

	    that.deflateParams = function(strm, _level, _strategy) {
	      var err = Z_OK;

	      if (_level == Z_DEFAULT_COMPRESSION) {
	        _level = 6;
	      }
	      if (_level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY) {
	        return Z_STREAM_ERROR;
	      }

	      if (config_table[level].func != config_table[_level].func && strm.total_in !== 0) {
	        // Flush the last buffer:
	        err = strm.deflate(Z_PARTIAL_FLUSH);
	      }

	      if (level != _level) {
	        level = _level;
	        max_lazy_match = config_table[level].max_lazy;
	        good_match = config_table[level].good_length;
	        nice_match = config_table[level].nice_length;
	        max_chain_length = config_table[level].max_chain;
	      }
	      strategy = _strategy;
	      return err;
	    };

	    that.deflateSetDictionary = function(strm, dictionary, dictLength) {
	      var length = dictLength;
	      var n, index = 0;

	      if (!dictionary || status != INIT_STATE)
	        return Z_STREAM_ERROR;

	      if (length < MIN_MATCH)
	        return Z_OK;
	      if (length > w_size - MIN_LOOKAHEAD) {
	        length = w_size - MIN_LOOKAHEAD;
	        index = dictLength - length; // use the tail of the dictionary
	      }
	      window.set(dictionary.subarray(index, index + length), 0);

	      strstart = length;
	      block_start = length;

	      // Insert all strings in the hash table (except for the last two bytes).
	      // s->lookahead stays null, so s->ins_h will be recomputed at the next
	      // call of fill_window.

	      ins_h = window[0] & 0xff;
	      ins_h = (((ins_h) << hash_shift) ^ (window[1] & 0xff)) & hash_mask;

	      for (n = 0; n <= length - MIN_MATCH; n++) {
	        ins_h = (((ins_h) << hash_shift) ^ (window[(n) + (MIN_MATCH - 1)] & 0xff)) & hash_mask;
	        prev[n & w_mask] = head[ins_h];
	        head[ins_h] = n;
	      }
	      return Z_OK;
	    };

	    that.deflate = function(_strm, flush) {
	      var i, header, level_flags, old_flush, bstate;

	      if (flush > Z_FINISH || flush < 0) {
	        return Z_STREAM_ERROR;
	      }

	      if (!_strm.next_out || (!_strm.next_in && _strm.avail_in !== 0) || (status == FINISH_STATE && flush != Z_FINISH)) {
	        _strm.msg = z_errmsg[Z_NEED_DICT - (Z_STREAM_ERROR)];
	        return Z_STREAM_ERROR;
	      }
	      if (_strm.avail_out === 0) {
	        _strm.msg = z_errmsg[Z_NEED_DICT - (Z_BUF_ERROR)];
	        return Z_BUF_ERROR;
	      }

	      strm = _strm; // just in case
	      old_flush = last_flush;
	      last_flush = flush;

	      // Write the zlib header
	      if (status == INIT_STATE) {
	        header = (Z_DEFLATED + ((w_bits - 8) << 4)) << 8;
	        level_flags = ((level - 1) & 0xff) >> 1;

	        if (level_flags > 3)
	          level_flags = 3;
	        header |= (level_flags << 6);
	        if (strstart !== 0)
	          header |= PRESET_DICT;
	        header += 31 - (header % 31);

	        status = BUSY_STATE;
	        putShortMSB(header);
	      }

	      // Flush as much pending output as possible
	      if (that.pending !== 0) {
	        strm.flush_pending();
	        if (strm.avail_out === 0) {
	          // console.log(" avail_out==0");
	          // Since avail_out is 0, deflate will be called again with
	          // more output space, but possibly with both pending and
	          // avail_in equal to zero. There won't be anything to do,
	          // but this is not an error situation so make sure we
	          // return OK instead of BUF_ERROR at next call of deflate:
	          last_flush = -1;
	          return Z_OK;
	        }

	        // Make sure there is something to do and avoid duplicate
	        // consecutive
	        // flushes. For repeated and useless calls with Z_FINISH, we keep
	        // returning Z_STREAM_END instead of Z_BUFF_ERROR.
	      } else if (strm.avail_in === 0 && flush <= old_flush && flush != Z_FINISH) {
	        strm.msg = z_errmsg[Z_NEED_DICT - (Z_BUF_ERROR)];
	        return Z_BUF_ERROR;
	      }

	      // User must not provide more input after the first FINISH:
	      if (status == FINISH_STATE && strm.avail_in !== 0) {
	        _strm.msg = z_errmsg[Z_NEED_DICT - (Z_BUF_ERROR)];
	        return Z_BUF_ERROR;
	      }

	      // Start a new block or continue the current one.
	      if (strm.avail_in !== 0 || lookahead !== 0 || (flush != Z_NO_FLUSH && status != FINISH_STATE)) {
	        bstate = -1;
	        switch (config_table[level].func) {
	        case STORED:
	          bstate = deflate_stored(flush);
	          break;
	        case FAST:
	          bstate = deflate_fast(flush);
	          break;
	        case SLOW:
	          bstate = deflate_slow(flush);
	          break;
	        default:
	        }

	        if (bstate == FinishStarted || bstate == FinishDone) {
	          status = FINISH_STATE;
	        }
	        if (bstate == NeedMore || bstate == FinishStarted) {
	          if (strm.avail_out === 0) {
	            last_flush = -1; // avoid BUF_ERROR next call, see above
	          }
	          return Z_OK;
	          // If flush != Z_NO_FLUSH && avail_out === 0, the next call
	          // of deflate should use the same flush parameter to make sure
	          // that the flush is complete. So we don't have to output an
	          // empty block here, this will be done at next call. This also
	          // ensures that for a very small output buffer, we emit at most
	          // one empty block.
	        }

	        if (bstate == BlockDone) {
	          if (flush == Z_PARTIAL_FLUSH) {
	            _tr_align();
	          } else { // FULL_FLUSH or SYNC_FLUSH
	            _tr_stored_block(0, 0, false);
	            // For a full flush, this empty block will be recognized
	            // as a special marker by inflate_sync().
	            if (flush == Z_FULL_FLUSH) {
	              // state.head[s.hash_size-1]=0;
	              for (i = 0; i < hash_size/*-1*/; i++)
	                // forget history
	                head[i] = 0;
	            }
	          }
	          strm.flush_pending();
	          if (strm.avail_out === 0) {
	            last_flush = -1; // avoid BUF_ERROR at next call, see above
	            return Z_OK;
	          }
	        }
	      }

	      if (flush != Z_FINISH)
	        return Z_OK;
	      return Z_STREAM_END;
	    };
	  }

	  // ZStream

	  function ZStream() {
	    var that = this;
	    that.next_in_index = 0;
	    that.next_out_index = 0;
	    // that.next_in; // next input byte
	    that.avail_in = 0; // number of bytes available at next_in
	    that.total_in = 0; // total nb of input bytes read so far
	    // that.next_out; // next output byte should be put there
	    that.avail_out = 0; // remaining free space at next_out
	    that.total_out = 0; // total nb of bytes output so far
	    // that.msg;
	    // that.dstate;
	  }

	  ZStream.prototype = {
	    deflateInit : function(level, bits) {
	      var that = this;
	      that.dstate = new Deflate();
	      if (!bits)
	        bits = MAX_BITS;
	      return that.dstate.deflateInit(that, level, bits);
	    },

	    deflate : function(flush) {
	      var that = this;
	      if (!that.dstate) {
	        return Z_STREAM_ERROR;
	      }
	      return that.dstate.deflate(that, flush);
	    },

	    deflateEnd : function() {
	      var that = this;
	      if (!that.dstate)
	        return Z_STREAM_ERROR;
	      var ret = that.dstate.deflateEnd();
	      that.dstate = null;
	      return ret;
	    },

	    deflateParams : function(level, strategy) {
	      var that = this;
	      if (!that.dstate)
	        return Z_STREAM_ERROR;
	      return that.dstate.deflateParams(that, level, strategy);
	    },

	    deflateSetDictionary : function(dictionary, dictLength) {
	      var that = this;
	      if (!that.dstate)
	        return Z_STREAM_ERROR;
	      return that.dstate.deflateSetDictionary(that, dictionary, dictLength);
	    },

	    // Read a new buffer from the current input stream, update the
	    // total number of bytes read. All deflate() input goes through
	    // this function so some applications may wish to modify it to avoid
	    // allocating a large strm->next_in buffer and copying from it.
	    // (See also flush_pending()).
	    read_buf : function(buf, start, size) {
	      var that = this;
	      var len = that.avail_in;
	      if (len > size)
	        len = size;
	      if (len === 0)
	        return 0;
	      that.avail_in -= len;
	      buf.set(that.next_in.subarray(that.next_in_index, that.next_in_index + len), start);
	      that.next_in_index += len;
	      that.total_in += len;
	      return len;
	    },

	    // Flush as much pending output as possible. All deflate() output goes
	    // through this function so some applications may wish to modify it
	    // to avoid allocating a large strm->next_out buffer and copying into it.
	    // (See also read_buf()).
	    flush_pending : function() {
	      var that = this;
	      var len = that.dstate.pending;

	      if (len > that.avail_out)
	        len = that.avail_out;
	      if (len === 0)
	        return;

	      // if (that.dstate.pending_buf.length <= that.dstate.pending_out || that.next_out.length <= that.next_out_index
	      // || that.dstate.pending_buf.length < (that.dstate.pending_out + len) || that.next_out.length < (that.next_out_index +
	      // len)) {
	      // console.log(that.dstate.pending_buf.length + ", " + that.dstate.pending_out + ", " + that.next_out.length + ", " +
	      // that.next_out_index + ", " + len);
	      // console.log("avail_out=" + that.avail_out);
	      // }

	      that.next_out.set(that.dstate.pending_buf.subarray(that.dstate.pending_out, that.dstate.pending_out + len), that.next_out_index);

	      that.next_out_index += len;
	      that.dstate.pending_out += len;
	      that.total_out += len;
	      that.avail_out -= len;
	      that.dstate.pending -= len;
	      if (that.dstate.pending === 0) {
	        that.dstate.pending_out = 0;
	      }
	    }
	  };

	  // Deflater

	  return function Deflater(level) {
	    var that = this;
	    var z = new ZStream();
	    var bufsize = 512;
	    var flush = Z_NO_FLUSH;
	    var buf = new Uint8Array(bufsize);

	    if (typeof level == "undefined")
	      level = Z_DEFAULT_COMPRESSION;
	    z.deflateInit(level);
	    z.next_out = buf;

	    that.append = function(data, onprogress) {
	      var err, buffers = [], lastIndex = 0, bufferIndex = 0, bufferSize = 0, array;
	      if (!data.length)
	        return;
	      z.next_in_index = 0;
	      z.next_in = data;
	      z.avail_in = data.length;
	      do {
	        z.next_out_index = 0;
	        z.avail_out = bufsize;
	        err = z.deflate(flush);
	        if (err != Z_OK)
	          throw "deflating: " + z.msg;
	        if (z.next_out_index)
	          if (z.next_out_index == bufsize)
	            buffers.push(new Uint8Array(buf));
	          else
	            buffers.push(new Uint8Array(buf.subarray(0, z.next_out_index)));
	        bufferSize += z.next_out_index;
	        if (onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex) {
	          onprogress(z.next_in_index);
	          lastIndex = z.next_in_index;
	        }
	      } while (z.avail_in > 0 || z.avail_out === 0);
	      array = new Uint8Array(bufferSize);
	      buffers.forEach(function(chunk) {
	        array.set(chunk, bufferIndex);
	        bufferIndex += chunk.length;
	      });
	      return array;
	    };
	    that.flush = function() {
	      var err, buffers = [], bufferIndex = 0, bufferSize = 0, array;
	      do {
	        z.next_out_index = 0;
	        z.avail_out = bufsize;
	        err = z.deflate(Z_FINISH);
	        if (err != Z_STREAM_END && err != Z_OK)
	          throw "deflating: " + z.msg;
	        if (bufsize - z.avail_out > 0)
	          buffers.push(new Uint8Array(buf.subarray(0, z.next_out_index)));
	        bufferSize += z.next_out_index;
	      } while (z.avail_in > 0 || z.avail_out === 0);
	      z.deflateEnd();
	      array = new Uint8Array(bufferSize);
	      buffers.forEach(function(chunk) {
	        array.set(chunk, bufferIndex);
	        bufferIndex += chunk.length;
	      });
	      return array;
	    };
	  };
	})(this);
	// Generated by CoffeeScript 1.4.0

	/*
	# PNG.js
	# Copyright (c) 2011 Devon Govett
	# MIT LICENSE
	# 
	# Permission is hereby granted, free of charge, to any person obtaining a copy of this 
	# software and associated documentation files (the "Software"), to deal in the Software 
	# without restriction, including without limitation the rights to use, copy, modify, merge, 
	# publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons 
	# to whom the Software is furnished to do so, subject to the following conditions:
	# 
	# The above copyright notice and this permission notice shall be included in all copies or 
	# substantial portions of the Software.
	# 
	# THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING 
	# BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND 
	# NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, 
	# DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
	# OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	*/


	(function(global) {
	  var PNG;

	  PNG = (function() {
	    var APNG_BLEND_OP_OVER, APNG_BLEND_OP_SOURCE, APNG_DISPOSE_OP_BACKGROUND, APNG_DISPOSE_OP_NONE, APNG_DISPOSE_OP_PREVIOUS, makeImage, scratchCanvas, scratchCtx;

	    PNG.load = function(url, canvas, callback) {
	      var xhr,
	        _this = this;
	      if (typeof canvas === 'function') {
	        callback = canvas;
	      }
	      xhr = new XMLHttpRequest;
	      xhr.open("GET", url, true);
	      xhr.responseType = "arraybuffer";
	      xhr.onload = function() {
	        var data, png;
	        data = new Uint8Array(xhr.response || xhr.mozResponseArrayBuffer);
	        png = new PNG(data);
	        if (typeof (canvas != null ? canvas.getContext : void 0) === 'function') {
	          png.render(canvas);
	        }
	        return typeof callback === "function" ? callback(png) : void 0;
	      };
	      return xhr.send(null);
	    };

	    APNG_DISPOSE_OP_NONE = 0;

	    APNG_DISPOSE_OP_BACKGROUND = 1;

	    APNG_DISPOSE_OP_PREVIOUS = 2;

	    APNG_BLEND_OP_SOURCE = 0;

	    APNG_BLEND_OP_OVER = 1;

	    function PNG(data) {
	      var chunkSize, colors, palLen, delayDen, delayNum, frame, i, index, key, section, palShort, text, _i, _j, _ref;
	      this.data = data;
	      this.pos = 8;
	      this.palette = [];
	      this.imgData = [];
	      this.transparency = {};
	      this.animation = null;
	      this.text = {};
	      frame = null;
	      while (true) {
	        chunkSize = this.readUInt32();
	        section = ((function() {
	          var _i, _results;
	          _results = [];
	          for (i = _i = 0; _i < 4; i = ++_i) {
	            _results.push(String.fromCharCode(this.data[this.pos++]));
	          }
	          return _results;
	        }).call(this)).join('');
	        switch (section) {
	          case 'IHDR':
	            this.width = this.readUInt32();
	            this.height = this.readUInt32();
	            this.bits = this.data[this.pos++];
	            this.colorType = this.data[this.pos++];
	            this.compressionMethod = this.data[this.pos++];
	            this.filterMethod = this.data[this.pos++];
	            this.interlaceMethod = this.data[this.pos++];
	            break;
	          case 'acTL':
	            this.animation = {
	              numFrames: this.readUInt32(),
	              numPlays: this.readUInt32() || Infinity,
	              frames: []
	            };
	            break;
	          case 'PLTE':
	            this.palette = this.read(chunkSize);
	            break;
	          case 'fcTL':
	            if (frame) {
	              this.animation.frames.push(frame);
	            }
	            this.pos += 4;
	            frame = {
	              width: this.readUInt32(),
	              height: this.readUInt32(),
	              xOffset: this.readUInt32(),
	              yOffset: this.readUInt32()
	            };
	            delayNum = this.readUInt16();
	            delayDen = this.readUInt16() || 100;
	            frame.delay = 1000 * delayNum / delayDen;
	            frame.disposeOp = this.data[this.pos++];
	            frame.blendOp = this.data[this.pos++];
	            frame.data = [];
	            break;
	          case 'IDAT':
	          case 'fdAT':
	            if (section === 'fdAT') {
	              this.pos += 4;
	              chunkSize -= 4;
	            }
	            data = (frame != null ? frame.data : void 0) || this.imgData;
	            for (i = _i = 0; 0 <= chunkSize ? _i < chunkSize : _i > chunkSize; i = 0 <= chunkSize ? ++_i : --_i) {
	              data.push(this.data[this.pos++]);
	            }
	            break;
	          case 'tRNS':
	            this.transparency = {};
	            switch (this.colorType) {
	              case 3:
	              palLen = this.palette.length/3;
	                this.transparency.indexed = this.read(chunkSize);
	                if(this.transparency.indexed.length > palLen)
	                  throw new Error('More transparent colors than palette size');
	                /*
	                 * According to the PNG spec trns should be increased to the same size as palette if shorter
	                 */
	                //palShort = 255 - this.transparency.indexed.length;
	                palShort = palLen - this.transparency.indexed.length;
	                if (palShort > 0) {
	                  for (i = _j = 0; 0 <= palShort ? _j < palShort : _j > palShort; i = 0 <= palShort ? ++_j : --_j) {
	                    this.transparency.indexed.push(255);
	                  }
	                }
	                break;
	              case 0:
	                this.transparency.grayscale = this.read(chunkSize)[0];
	                break;
	              case 2:
	                this.transparency.rgb = this.read(chunkSize);
	            }
	            break;
	          case 'tEXt':
	            text = this.read(chunkSize);
	            index = text.indexOf(0);
	            key = String.fromCharCode.apply(String, text.slice(0, index));
	            this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
	            break;
	          case 'IEND':
	            if (frame) {
	              this.animation.frames.push(frame);
	            }
	            this.colors = (function() {
	              switch (this.colorType) {
	                case 0:
	                case 3:
	                case 4:
	                  return 1;
	                case 2:
	                case 6:
	                  return 3;
	              }
	            }).call(this);
	            this.hasAlphaChannel = (_ref = this.colorType) === 4 || _ref === 6;
	            colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
	            this.pixelBitlength = this.bits * colors;
	            this.colorSpace = (function() {
	              switch (this.colors) {
	                case 1:
	                  return 'DeviceGray';
	                case 3:
	                  return 'DeviceRGB';
	              }
	            }).call(this);
	            this.imgData = new Uint8Array(this.imgData);
	            return;
	          default:
	            this.pos += chunkSize;
	        }
	        this.pos += 4;
	        if (this.pos > this.data.length) {
	          throw new Error("Incomplete or corrupt PNG file");
	        }
	      }
	      return;
	    }

	    PNG.prototype.read = function(bytes) {
	      var i, _i, _results;
	      _results = [];
	      for (i = _i = 0; 0 <= bytes ? _i < bytes : _i > bytes; i = 0 <= bytes ? ++_i : --_i) {
	        _results.push(this.data[this.pos++]);
	      }
	      return _results;
	    };

	    PNG.prototype.readUInt32 = function() {
	      var b1, b2, b3, b4;
	      b1 = this.data[this.pos++] << 24;
	      b2 = this.data[this.pos++] << 16;
	      b3 = this.data[this.pos++] << 8;
	      b4 = this.data[this.pos++];
	      return b1 | b2 | b3 | b4;
	    };

	    PNG.prototype.readUInt16 = function() {
	      var b1, b2;
	      b1 = this.data[this.pos++] << 8;
	      b2 = this.data[this.pos++];
	      return b1 | b2;
	    };

	    PNG.prototype.decodePixels = function(data) {
	      var abyte, c, col, i, left, length, p, pa, paeth, pb, pc, pixelBytes, pixels, pos, row, scanlineLength, upper, upperLeft, _i, _j, _k, _l, _m;
	      if (data == null) {
	        data = this.imgData;
	      }
	      if (data.length === 0) {
	        return new Uint8Array(0);
	      }
	      data = new FlateStream(data);
	      data = data.getBytes();
	      pixelBytes = this.pixelBitlength / 8;
	      scanlineLength = pixelBytes * this.width;
	      pixels = new Uint8Array(scanlineLength * this.height);
	      length = data.length;
	      row = 0;
	      pos = 0;
	      c = 0;
	      while (pos < length) {
	        switch (data[pos++]) {
	          case 0:
	            for (i = _i = 0; _i < scanlineLength; i = _i += 1) {
	              pixels[c++] = data[pos++];
	            }
	            break;
	          case 1:
	            for (i = _j = 0; _j < scanlineLength; i = _j += 1) {
	              abyte = data[pos++];
	              left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	              pixels[c++] = (abyte + left) % 256;
	            }
	            break;
	          case 2:
	            for (i = _k = 0; _k < scanlineLength; i = _k += 1) {
	              abyte = data[pos++];
	              col = (i - (i % pixelBytes)) / pixelBytes;
	              upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	              pixels[c++] = (upper + abyte) % 256;
	            }
	            break;
	          case 3:
	            for (i = _l = 0; _l < scanlineLength; i = _l += 1) {
	              abyte = data[pos++];
	              col = (i - (i % pixelBytes)) / pixelBytes;
	              left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	              upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	              pixels[c++] = (abyte + Math.floor((left + upper) / 2)) % 256;
	            }
	            break;
	          case 4:
	            for (i = _m = 0; _m < scanlineLength; i = _m += 1) {
	              abyte = data[pos++];
	              col = (i - (i % pixelBytes)) / pixelBytes;
	              left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	              if (row === 0) {
	                upper = upperLeft = 0;
	              } else {
	                upper = pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	                upperLeft = col && pixels[(row - 1) * scanlineLength + (col - 1) * pixelBytes + (i % pixelBytes)];
	              }
	              p = left + upper - upperLeft;
	              pa = Math.abs(p - left);
	              pb = Math.abs(p - upper);
	              pc = Math.abs(p - upperLeft);
	              if (pa <= pb && pa <= pc) {
	                paeth = left;
	              } else if (pb <= pc) {
	                paeth = upper;
	              } else {
	                paeth = upperLeft;
	              }
	              pixels[c++] = (abyte + paeth) % 256;
	            }
	            break;
	          default:
	            throw new Error("Invalid filter algorithm: " + data[pos - 1]);
	        }
	        row++;
	      }
	      return pixels;
	    };

	    PNG.prototype.decodePalette = function() {
	      var c, i, length, palette, pos, ret, transparency, _i, _ref, _ref1;
	      palette = this.palette;
	      transparency = this.transparency.indexed || [];
	      ret = new Uint8Array((transparency.length || 0) + palette.length);
	      pos = 0;
	      length = palette.length;
	      c = 0;
	      for (i = _i = 0, _ref = palette.length; _i < _ref; i = _i += 3) {
	        ret[pos++] = palette[i];
	        ret[pos++] = palette[i + 1];
	        ret[pos++] = palette[i + 2];
	        ret[pos++] = (_ref1 = transparency[c++]) != null ? _ref1 : 255;
	      }
	      return ret;
	    };

	    PNG.prototype.copyToImageData = function(imageData, pixels) {
	      var alpha, colors, data, i, input, j, k, length, palette, v, _ref;
	      colors = this.colors;
	      palette = null;
	      alpha = this.hasAlphaChannel;
	      if (this.palette.length) {
	        palette = (_ref = this._decodedPalette) != null ? _ref : this._decodedPalette = this.decodePalette();
	        colors = 4;
	        alpha = true;
	      }
	      data = imageData.data || imageData;
	      length = data.length;
	      input = palette || pixels;
	      i = j = 0;
	      if (colors === 1) {
	        while (i < length) {
	          k = palette ? pixels[i / 4] * 4 : j;
	          v = input[k++];
	          data[i++] = v;
	          data[i++] = v;
	          data[i++] = v;
	          data[i++] = alpha ? input[k++] : 255;
	          j = k;
	        }
	      } else {
	        while (i < length) {
	          k = palette ? pixels[i / 4] * 4 : j;
	          data[i++] = input[k++];
	          data[i++] = input[k++];
	          data[i++] = input[k++];
	          data[i++] = alpha ? input[k++] : 255;
	          j = k;
	        }
	      }
	    };

	    PNG.prototype.decode = function() {
	      var ret;
	      ret = new Uint8Array(this.width * this.height * 4);
	      this.copyToImageData(ret, this.decodePixels());
	      return ret;
	    };

	    try {
	        scratchCanvas = global.document.createElement('canvas');
	        scratchCtx = scratchCanvas.getContext('2d');
	    } catch(e) {
	        return -1;
	    }

	    makeImage = function(imageData) {
	      var img;
	      scratchCtx.width = imageData.width;
	      scratchCtx.height = imageData.height;
	      scratchCtx.clearRect(0, 0, imageData.width, imageData.height);
	      scratchCtx.putImageData(imageData, 0, 0);
	      img = new Image;
	      img.src = scratchCanvas.toDataURL();
	      return img;
	    };

	    PNG.prototype.decodeFrames = function(ctx) {
	      var frame, i, imageData, pixels, _i, _len, _ref, _results;
	      if (!this.animation) {
	        return;
	      }
	      _ref = this.animation.frames;
	      _results = [];
	      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
	        frame = _ref[i];
	        imageData = ctx.createImageData(frame.width, frame.height);
	        pixels = this.decodePixels(new Uint8Array(frame.data));
	        this.copyToImageData(imageData, pixels);
	        frame.imageData = imageData;
	        _results.push(frame.image = makeImage(imageData));
	      }
	      return _results;
	    };

	    PNG.prototype.renderFrame = function(ctx, number) {
	      var frame, frames, prev;
	      frames = this.animation.frames;
	      frame = frames[number];
	      prev = frames[number - 1];
	      if (number === 0) {
	        ctx.clearRect(0, 0, this.width, this.height);
	      }
	      if ((prev != null ? prev.disposeOp : void 0) === APNG_DISPOSE_OP_BACKGROUND) {
	        ctx.clearRect(prev.xOffset, prev.yOffset, prev.width, prev.height);
	      } else if ((prev != null ? prev.disposeOp : void 0) === APNG_DISPOSE_OP_PREVIOUS) {
	        ctx.putImageData(prev.imageData, prev.xOffset, prev.yOffset);
	      }
	      if (frame.blendOp === APNG_BLEND_OP_SOURCE) {
	        ctx.clearRect(frame.xOffset, frame.yOffset, frame.width, frame.height);
	      }
	      return ctx.drawImage(frame.image, frame.xOffset, frame.yOffset);
	    };

	    PNG.prototype.animate = function(ctx) {
	      var doFrame, frameNumber, frames, numFrames, numPlays, _ref,
	        _this = this;
	      frameNumber = 0;
	      _ref = this.animation, numFrames = _ref.numFrames, frames = _ref.frames, numPlays = _ref.numPlays;
	      return (doFrame = function() {
	        var f, frame;
	        f = frameNumber++ % numFrames;
	        frame = frames[f];
	        _this.renderFrame(ctx, f);
	        if (numFrames > 1 && frameNumber / numFrames < numPlays) {
	          return _this.animation._timeout = setTimeout(doFrame, frame.delay);
	        }
	      })();
	    };

	    PNG.prototype.stopAnimation = function() {
	      var _ref;
	      return clearTimeout((_ref = this.animation) != null ? _ref._timeout : void 0);
	    };

	    PNG.prototype.render = function(canvas) {
	      var ctx, data;
	      if (canvas._png) {
	        canvas._png.stopAnimation();
	      }
	      canvas._png = this;
	      canvas.width = this.width;
	      canvas.height = this.height;
	      ctx = canvas.getContext("2d");
	      if (this.animation) {
	        this.decodeFrames(ctx);
	        return this.animate(ctx);
	      } else {
	        data = ctx.createImageData(this.width, this.height);
	        this.copyToImageData(data, this.decodePixels());
	        return ctx.putImageData(data, 0, 0);
	      }
	    };

	    return PNG;

	  })();

	  global.PNG = PNG;

	})(typeof window !== "undefined" && window || this);
	/*
	 * Extracted from pdf.js
	 * https://github.com/andreasgal/pdf.js
	 *
	 * Copyright (c) 2011 Mozilla Foundation
	 *
	 * Contributors: Andreas Gal <gal@mozilla.com>
	 *               Chris G Jones <cjones@mozilla.com>
	 *               Shaon Barman <shaon.barman@gmail.com>
	 *               Vivien Nicolas <21@vingtetun.org>
	 *               Justin D'Arcangelo <justindarc@gmail.com>
	 *               Yury Delendik
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a
	 * copy of this software and associated documentation files (the "Software"),
	 * to deal in the Software without restriction, including without limitation
	 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
	 * and/or sell copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
	 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
	 * DEALINGS IN THE SOFTWARE.
	 */

	var DecodeStream = (function() {
	  function constructor() {
	    this.pos = 0;
	    this.bufferLength = 0;
	    this.eof = false;
	    this.buffer = null;
	  }

	  constructor.prototype = {
	    ensureBuffer: function decodestream_ensureBuffer(requested) {
	      var buffer = this.buffer;
	      var current = buffer ? buffer.byteLength : 0;
	      if (requested < current)
	        return buffer;
	      var size = 512;
	      while (size < requested)
	        size <<= 1;
	      var buffer2 = new Uint8Array(size);
	      for (var i = 0; i < current; ++i)
	        buffer2[i] = buffer[i];
	      return this.buffer = buffer2;
	    },
	    getByte: function decodestream_getByte() {
	      var pos = this.pos;
	      while (this.bufferLength <= pos) {
	        if (this.eof)
	          return null;
	        this.readBlock();
	      }
	      return this.buffer[this.pos++];
	    },
	    getBytes: function decodestream_getBytes(length) {
	      var pos = this.pos;

	      if (length) {
	        this.ensureBuffer(pos + length);
	        var end = pos + length;

	        while (!this.eof && this.bufferLength < end)
	          this.readBlock();

	        var bufEnd = this.bufferLength;
	        if (end > bufEnd)
	          end = bufEnd;
	      } else {
	        while (!this.eof)
	          this.readBlock();

	        var end = this.bufferLength;
	      }

	      this.pos = end;
	      return this.buffer.subarray(pos, end);
	    },
	    lookChar: function decodestream_lookChar() {
	      var pos = this.pos;
	      while (this.bufferLength <= pos) {
	        if (this.eof)
	          return null;
	        this.readBlock();
	      }
	      return String.fromCharCode(this.buffer[this.pos]);
	    },
	    getChar: function decodestream_getChar() {
	      var pos = this.pos;
	      while (this.bufferLength <= pos) {
	        if (this.eof)
	          return null;
	        this.readBlock();
	      }
	      return String.fromCharCode(this.buffer[this.pos++]);
	    },
	    makeSubStream: function decodestream_makeSubstream(start, length, dict) {
	      var end = start + length;
	      while (this.bufferLength <= end && !this.eof)
	        this.readBlock();
	      return new Stream(this.buffer, start, length, dict);
	    },
	    skip: function decodestream_skip(n) {
	      if (!n)
	        n = 1;
	      this.pos += n;
	    },
	    reset: function decodestream_reset() {
	      this.pos = 0;
	    }
	  };

	  return constructor;
	})();

	var FlateStream = (function() {
	  if (typeof Uint32Array === 'undefined') {
	    return undefined;
	  }
	  var codeLenCodeMap = new Uint32Array([
	    16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15
	  ]);

	  var lengthDecode = new Uint32Array([
	    0x00003, 0x00004, 0x00005, 0x00006, 0x00007, 0x00008, 0x00009, 0x0000a,
	    0x1000b, 0x1000d, 0x1000f, 0x10011, 0x20013, 0x20017, 0x2001b, 0x2001f,
	    0x30023, 0x3002b, 0x30033, 0x3003b, 0x40043, 0x40053, 0x40063, 0x40073,
	    0x50083, 0x500a3, 0x500c3, 0x500e3, 0x00102, 0x00102, 0x00102
	  ]);

	  var distDecode = new Uint32Array([
	    0x00001, 0x00002, 0x00003, 0x00004, 0x10005, 0x10007, 0x20009, 0x2000d,
	    0x30011, 0x30019, 0x40021, 0x40031, 0x50041, 0x50061, 0x60081, 0x600c1,
	    0x70101, 0x70181, 0x80201, 0x80301, 0x90401, 0x90601, 0xa0801, 0xa0c01,
	    0xb1001, 0xb1801, 0xc2001, 0xc3001, 0xd4001, 0xd6001
	  ]);

	  var fixedLitCodeTab = [new Uint32Array([
	    0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c0,
	    0x70108, 0x80060, 0x80020, 0x900a0, 0x80000, 0x80080, 0x80040, 0x900e0,
	    0x70104, 0x80058, 0x80018, 0x90090, 0x70114, 0x80078, 0x80038, 0x900d0,
	    0x7010c, 0x80068, 0x80028, 0x900b0, 0x80008, 0x80088, 0x80048, 0x900f0,
	    0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c8,
	    0x7010a, 0x80064, 0x80024, 0x900a8, 0x80004, 0x80084, 0x80044, 0x900e8,
	    0x70106, 0x8005c, 0x8001c, 0x90098, 0x70116, 0x8007c, 0x8003c, 0x900d8,
	    0x7010e, 0x8006c, 0x8002c, 0x900b8, 0x8000c, 0x8008c, 0x8004c, 0x900f8,
	    0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c4,
	    0x70109, 0x80062, 0x80022, 0x900a4, 0x80002, 0x80082, 0x80042, 0x900e4,
	    0x70105, 0x8005a, 0x8001a, 0x90094, 0x70115, 0x8007a, 0x8003a, 0x900d4,
	    0x7010d, 0x8006a, 0x8002a, 0x900b4, 0x8000a, 0x8008a, 0x8004a, 0x900f4,
	    0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cc,
	    0x7010b, 0x80066, 0x80026, 0x900ac, 0x80006, 0x80086, 0x80046, 0x900ec,
	    0x70107, 0x8005e, 0x8001e, 0x9009c, 0x70117, 0x8007e, 0x8003e, 0x900dc,
	    0x7010f, 0x8006e, 0x8002e, 0x900bc, 0x8000e, 0x8008e, 0x8004e, 0x900fc,
	    0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c2,
	    0x70108, 0x80061, 0x80021, 0x900a2, 0x80001, 0x80081, 0x80041, 0x900e2,
	    0x70104, 0x80059, 0x80019, 0x90092, 0x70114, 0x80079, 0x80039, 0x900d2,
	    0x7010c, 0x80069, 0x80029, 0x900b2, 0x80009, 0x80089, 0x80049, 0x900f2,
	    0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900ca,
	    0x7010a, 0x80065, 0x80025, 0x900aa, 0x80005, 0x80085, 0x80045, 0x900ea,
	    0x70106, 0x8005d, 0x8001d, 0x9009a, 0x70116, 0x8007d, 0x8003d, 0x900da,
	    0x7010e, 0x8006d, 0x8002d, 0x900ba, 0x8000d, 0x8008d, 0x8004d, 0x900fa,
	    0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c6,
	    0x70109, 0x80063, 0x80023, 0x900a6, 0x80003, 0x80083, 0x80043, 0x900e6,
	    0x70105, 0x8005b, 0x8001b, 0x90096, 0x70115, 0x8007b, 0x8003b, 0x900d6,
	    0x7010d, 0x8006b, 0x8002b, 0x900b6, 0x8000b, 0x8008b, 0x8004b, 0x900f6,
	    0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900ce,
	    0x7010b, 0x80067, 0x80027, 0x900ae, 0x80007, 0x80087, 0x80047, 0x900ee,
	    0x70107, 0x8005f, 0x8001f, 0x9009e, 0x70117, 0x8007f, 0x8003f, 0x900de,
	    0x7010f, 0x8006f, 0x8002f, 0x900be, 0x8000f, 0x8008f, 0x8004f, 0x900fe,
	    0x70100, 0x80050, 0x80010, 0x80118, 0x70110, 0x80070, 0x80030, 0x900c1,
	    0x70108, 0x80060, 0x80020, 0x900a1, 0x80000, 0x80080, 0x80040, 0x900e1,
	    0x70104, 0x80058, 0x80018, 0x90091, 0x70114, 0x80078, 0x80038, 0x900d1,
	    0x7010c, 0x80068, 0x80028, 0x900b1, 0x80008, 0x80088, 0x80048, 0x900f1,
	    0x70102, 0x80054, 0x80014, 0x8011c, 0x70112, 0x80074, 0x80034, 0x900c9,
	    0x7010a, 0x80064, 0x80024, 0x900a9, 0x80004, 0x80084, 0x80044, 0x900e9,
	    0x70106, 0x8005c, 0x8001c, 0x90099, 0x70116, 0x8007c, 0x8003c, 0x900d9,
	    0x7010e, 0x8006c, 0x8002c, 0x900b9, 0x8000c, 0x8008c, 0x8004c, 0x900f9,
	    0x70101, 0x80052, 0x80012, 0x8011a, 0x70111, 0x80072, 0x80032, 0x900c5,
	    0x70109, 0x80062, 0x80022, 0x900a5, 0x80002, 0x80082, 0x80042, 0x900e5,
	    0x70105, 0x8005a, 0x8001a, 0x90095, 0x70115, 0x8007a, 0x8003a, 0x900d5,
	    0x7010d, 0x8006a, 0x8002a, 0x900b5, 0x8000a, 0x8008a, 0x8004a, 0x900f5,
	    0x70103, 0x80056, 0x80016, 0x8011e, 0x70113, 0x80076, 0x80036, 0x900cd,
	    0x7010b, 0x80066, 0x80026, 0x900ad, 0x80006, 0x80086, 0x80046, 0x900ed,
	    0x70107, 0x8005e, 0x8001e, 0x9009d, 0x70117, 0x8007e, 0x8003e, 0x900dd,
	    0x7010f, 0x8006e, 0x8002e, 0x900bd, 0x8000e, 0x8008e, 0x8004e, 0x900fd,
	    0x70100, 0x80051, 0x80011, 0x80119, 0x70110, 0x80071, 0x80031, 0x900c3,
	    0x70108, 0x80061, 0x80021, 0x900a3, 0x80001, 0x80081, 0x80041, 0x900e3,
	    0x70104, 0x80059, 0x80019, 0x90093, 0x70114, 0x80079, 0x80039, 0x900d3,
	    0x7010c, 0x80069, 0x80029, 0x900b3, 0x80009, 0x80089, 0x80049, 0x900f3,
	    0x70102, 0x80055, 0x80015, 0x8011d, 0x70112, 0x80075, 0x80035, 0x900cb,
	    0x7010a, 0x80065, 0x80025, 0x900ab, 0x80005, 0x80085, 0x80045, 0x900eb,
	    0x70106, 0x8005d, 0x8001d, 0x9009b, 0x70116, 0x8007d, 0x8003d, 0x900db,
	    0x7010e, 0x8006d, 0x8002d, 0x900bb, 0x8000d, 0x8008d, 0x8004d, 0x900fb,
	    0x70101, 0x80053, 0x80013, 0x8011b, 0x70111, 0x80073, 0x80033, 0x900c7,
	    0x70109, 0x80063, 0x80023, 0x900a7, 0x80003, 0x80083, 0x80043, 0x900e7,
	    0x70105, 0x8005b, 0x8001b, 0x90097, 0x70115, 0x8007b, 0x8003b, 0x900d7,
	    0x7010d, 0x8006b, 0x8002b, 0x900b7, 0x8000b, 0x8008b, 0x8004b, 0x900f7,
	    0x70103, 0x80057, 0x80017, 0x8011f, 0x70113, 0x80077, 0x80037, 0x900cf,
	    0x7010b, 0x80067, 0x80027, 0x900af, 0x80007, 0x80087, 0x80047, 0x900ef,
	    0x70107, 0x8005f, 0x8001f, 0x9009f, 0x70117, 0x8007f, 0x8003f, 0x900df,
	    0x7010f, 0x8006f, 0x8002f, 0x900bf, 0x8000f, 0x8008f, 0x8004f, 0x900ff
	  ]), 9];

	  var fixedDistCodeTab = [new Uint32Array([
	    0x50000, 0x50010, 0x50008, 0x50018, 0x50004, 0x50014, 0x5000c, 0x5001c,
	    0x50002, 0x50012, 0x5000a, 0x5001a, 0x50006, 0x50016, 0x5000e, 0x00000,
	    0x50001, 0x50011, 0x50009, 0x50019, 0x50005, 0x50015, 0x5000d, 0x5001d,
	    0x50003, 0x50013, 0x5000b, 0x5001b, 0x50007, 0x50017, 0x5000f, 0x00000
	  ]), 5];
	  
	  function error(e) {
	      throw new Error(e)
	  }

	  function constructor(bytes) {
	    //var bytes = stream.getBytes();
	    var bytesPos = 0;

	    var cmf = bytes[bytesPos++];
	    var flg = bytes[bytesPos++];
	    if (cmf == -1 || flg == -1)
	      error('Invalid header in flate stream');
	    if ((cmf & 0x0f) != 0x08)
	      error('Unknown compression method in flate stream');
	    if ((((cmf << 8) + flg) % 31) != 0)
	      error('Bad FCHECK in flate stream');
	    if (flg & 0x20)
	      error('FDICT bit set in flate stream');

	    this.bytes = bytes;
	    this.bytesPos = bytesPos;

	    this.codeSize = 0;
	    this.codeBuf = 0;

	    DecodeStream.call(this);
	  }

	  constructor.prototype = Object.create(DecodeStream.prototype);

	  constructor.prototype.getBits = function(bits) {
	    var codeSize = this.codeSize;
	    var codeBuf = this.codeBuf;
	    var bytes = this.bytes;
	    var bytesPos = this.bytesPos;

	    var b;
	    while (codeSize < bits) {
	      if (typeof (b = bytes[bytesPos++]) == 'undefined')
	        error('Bad encoding in flate stream');
	      codeBuf |= b << codeSize;
	      codeSize += 8;
	    }
	    b = codeBuf & ((1 << bits) - 1);
	    this.codeBuf = codeBuf >> bits;
	    this.codeSize = codeSize -= bits;
	    this.bytesPos = bytesPos;
	    return b;
	  };

	  constructor.prototype.getCode = function(table) {
	    var codes = table[0];
	    var maxLen = table[1];
	    var codeSize = this.codeSize;
	    var codeBuf = this.codeBuf;
	    var bytes = this.bytes;
	    var bytesPos = this.bytesPos;

	    while (codeSize < maxLen) {
	      var b;
	      if (typeof (b = bytes[bytesPos++]) == 'undefined')
	        error('Bad encoding in flate stream');
	      codeBuf |= (b << codeSize);
	      codeSize += 8;
	    }
	    var code = codes[codeBuf & ((1 << maxLen) - 1)];
	    var codeLen = code >> 16;
	    var codeVal = code & 0xffff;
	    if (codeSize == 0 || codeSize < codeLen || codeLen == 0)
	      error('Bad encoding in flate stream');
	    this.codeBuf = (codeBuf >> codeLen);
	    this.codeSize = (codeSize - codeLen);
	    this.bytesPos = bytesPos;
	    return codeVal;
	  };

	  constructor.prototype.generateHuffmanTable = function(lengths) {
	    var n = lengths.length;

	    // find max code length
	    var maxLen = 0;
	    for (var i = 0; i < n; ++i) {
	      if (lengths[i] > maxLen)
	        maxLen = lengths[i];
	    }

	    // build the table
	    var size = 1 << maxLen;
	    var codes = new Uint32Array(size);
	    for (var len = 1, code = 0, skip = 2;
	         len <= maxLen;
	         ++len, code <<= 1, skip <<= 1) {
	      for (var val = 0; val < n; ++val) {
	        if (lengths[val] == len) {
	          // bit-reverse the code
	          var code2 = 0;
	          var t = code;
	          for (var i = 0; i < len; ++i) {
	            code2 = (code2 << 1) | (t & 1);
	            t >>= 1;
	          }

	          // fill the table entries
	          for (var i = code2; i < size; i += skip)
	            codes[i] = (len << 16) | val;

	          ++code;
	        }
	      }
	    }

	    return [codes, maxLen];
	  };

	  constructor.prototype.readBlock = function() {
	    function repeat(stream, array, len, offset, what) {
	      var repeat = stream.getBits(len) + offset;
	      while (repeat-- > 0)
	        array[i++] = what;
	    }

	    // read block header
	    var hdr = this.getBits(3);
	    if (hdr & 1)
	      this.eof = true;
	    hdr >>= 1;

	    if (hdr == 0) { // uncompressed block
	      var bytes = this.bytes;
	      var bytesPos = this.bytesPos;
	      var b;

	      if (typeof (b = bytes[bytesPos++]) == 'undefined')
	        error('Bad block header in flate stream');
	      var blockLen = b;
	      if (typeof (b = bytes[bytesPos++]) == 'undefined')
	        error('Bad block header in flate stream');
	      blockLen |= (b << 8);
	      if (typeof (b = bytes[bytesPos++]) == 'undefined')
	        error('Bad block header in flate stream');
	      var check = b;
	      if (typeof (b = bytes[bytesPos++]) == 'undefined')
	        error('Bad block header in flate stream');
	      check |= (b << 8);
	      if (check != (~blockLen & 0xffff))
	        error('Bad uncompressed block length in flate stream');

	      this.codeBuf = 0;
	      this.codeSize = 0;

	      var bufferLength = this.bufferLength;
	      var buffer = this.ensureBuffer(bufferLength + blockLen);
	      var end = bufferLength + blockLen;
	      this.bufferLength = end;
	      for (var n = bufferLength; n < end; ++n) {
	        if (typeof (b = bytes[bytesPos++]) == 'undefined') {
	          this.eof = true;
	          break;
	        }
	        buffer[n] = b;
	      }
	      this.bytesPos = bytesPos;
	      return;
	    }

	    var litCodeTable;
	    var distCodeTable;
	    if (hdr == 1) { // compressed block, fixed codes
	      litCodeTable = fixedLitCodeTab;
	      distCodeTable = fixedDistCodeTab;
	    } else if (hdr == 2) { // compressed block, dynamic codes
	      var numLitCodes = this.getBits(5) + 257;
	      var numDistCodes = this.getBits(5) + 1;
	      var numCodeLenCodes = this.getBits(4) + 4;

	      // build the code lengths code table
	      var codeLenCodeLengths = Array(codeLenCodeMap.length);
	      var i = 0;
	      while (i < numCodeLenCodes)
	        codeLenCodeLengths[codeLenCodeMap[i++]] = this.getBits(3);
	      var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);

	      // build the literal and distance code tables
	      var len = 0;
	      var i = 0;
	      var codes = numLitCodes + numDistCodes;
	      var codeLengths = new Array(codes);
	      while (i < codes) {
	        var code = this.getCode(codeLenCodeTab);
	        if (code == 16) {
	          repeat(this, codeLengths, 2, 3, len);
	        } else if (code == 17) {
	          repeat(this, codeLengths, 3, 3, len = 0);
	        } else if (code == 18) {
	          repeat(this, codeLengths, 7, 11, len = 0);
	        } else {
	          codeLengths[i++] = len = code;
	        }
	      }

	      litCodeTable =
	        this.generateHuffmanTable(codeLengths.slice(0, numLitCodes));
	      distCodeTable =
	        this.generateHuffmanTable(codeLengths.slice(numLitCodes, codes));
	    } else {
	      error('Unknown block type in flate stream');
	    }

	    var buffer = this.buffer;
	    var limit = buffer ? buffer.length : 0;
	    var pos = this.bufferLength;
	    while (true) {
	      var code1 = this.getCode(litCodeTable);
	      if (code1 < 256) {
	        if (pos + 1 >= limit) {
	          buffer = this.ensureBuffer(pos + 1);
	          limit = buffer.length;
	        }
	        buffer[pos++] = code1;
	        continue;
	      }
	      if (code1 == 256) {
	        this.bufferLength = pos;
	        return;
	      }
	      code1 -= 257;
	      code1 = lengthDecode[code1];
	      var code2 = code1 >> 16;
	      if (code2 > 0)
	        code2 = this.getBits(code2);
	      var len = (code1 & 0xffff) + code2;
	      code1 = this.getCode(distCodeTable);
	      code1 = distDecode[code1];
	      code2 = code1 >> 16;
	      if (code2 > 0)
	        code2 = this.getBits(code2);
	      var dist = (code1 & 0xffff) + code2;
	      if (pos + len >= limit) {
	        buffer = this.ensureBuffer(pos + len);
	        limit = buffer.length;
	      }
	      for (var k = 0; k < len; ++k, ++pos)
	        buffer[pos] = buffer[pos - dist];
	    }
	  };

	  return constructor;
	})();/**
	 * JavaScript Polyfill functions for jsPDF
	 * Collected from public resources by
	 * https://github.com/diegocr
	 */

	(function (global) {
	  var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

	  if (typeof global.btoa === 'undefined') {
	    global.btoa = function(data) {
	      //  discuss at: http://phpjs.org/functions/base64_encode/
	      // original by: Tyler Akins (http://rumkin.com)
	      // improved by: Bayron Guevara
	      // improved by: Thunder.m
	      // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	      // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	      // improved by: Rafal Kukawski (http://kukawski.pl)
	      // bugfixed by: Pellentesque Malesuada
	      //   example 1: base64_encode('Kevin van Zonneveld');
	      //   returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='

	      var o1,o2,o3,h1,h2,h3,h4,bits,i = 0,ac = 0,enc = '',tmp_arr = [];

	      if (!data) {
	        return data;
	      }

	      do { // pack three octets into four hexets
	        o1 = data.charCodeAt(i++);
	        o2 = data.charCodeAt(i++);
	        o3 = data.charCodeAt(i++);

	        bits = o1 << 16 | o2 << 8 | o3;

	        h1 = bits >> 18 & 0x3f;
	        h2 = bits >> 12 & 0x3f;
	        h3 = bits >> 6 & 0x3f;
	        h4 = bits & 0x3f;

	        // use hexets to index into b64, and append result to encoded string
	        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	      } while (i < data.length);

	      enc = tmp_arr.join('');

	      var r = data.length % 3;

	      return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
	    };
	  }

	  if (typeof global.atob === 'undefined') {
	    global.atob = function(data) {
	      //  discuss at: http://phpjs.org/functions/base64_decode/
	      // original by: Tyler Akins (http://rumkin.com)
	      // improved by: Thunder.m
	      // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	      // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	      //    input by: Aman Gupta
	      //    input by: Brett Zamir (http://brett-zamir.me)
	      // bugfixed by: Onno Marsman
	      // bugfixed by: Pellentesque Malesuada
	      // bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	      //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
	      //   returns 1: 'Kevin van Zonneveld'

	      var o1,o2,o3,h1,h2,h3,h4,bits,i = 0,ac = 0,dec = '',tmp_arr = [];

	      if (!data) {
	        return data;
	      }

	      data += '';

	      do { // unpack four hexets into three octets using index points in b64
	        h1 = b64.indexOf(data.charAt(i++));
	        h2 = b64.indexOf(data.charAt(i++));
	        h3 = b64.indexOf(data.charAt(i++));
	        h4 = b64.indexOf(data.charAt(i++));

	        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

	        o1 = bits >> 16 & 0xff;
	        o2 = bits >> 8 & 0xff;
	        o3 = bits & 0xff;

	        if (h3 == 64) {
	          tmp_arr[ac++] = String.fromCharCode(o1);
	        } else if (h4 == 64) {
	          tmp_arr[ac++] = String.fromCharCode(o1, o2);
	        } else {
	          tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
	        }
	      } while (i < data.length);

	      dec = tmp_arr.join('');

	      return dec;
	    };
	  }

	  if (!Array.prototype.map) {
	    Array.prototype.map = function(fun /*, thisArg */) {
	      if (this === void 0 || this === null || typeof fun !== "function")
	        throw new TypeError();

	      var t = Object(this), len = t.length >>> 0, res = new Array(len);
	      var thisArg = arguments.length > 1 ? arguments[1] : void 0;
	      for (var i = 0; i < len; i++) {
	        // NOTE: Absolute correctness would demand Object.defineProperty
	        //       be used.  But this method is fairly new, and failure is
	        //       possible only if Object.prototype or Array.prototype
	        //       has a property |i| (very unlikely), so use a less-correct
	        //       but more portable alternative.
	        if (i in t)
	          res[i] = fun.call(thisArg, t[i], i, t);
	      }

	      return res;
	    };
	  }


	  if(!Array.isArray) {
	    Array.isArray = function(arg) {
	      return Object.prototype.toString.call(arg) === '[object Array]';
	    };
	  }

	  if (!Array.prototype.forEach) {
	    Array.prototype.forEach = function(fun, thisArg) {
	      "use strict";

	      if (this === void 0 || this === null || typeof fun !== "function")
	        throw new TypeError();

	      var t = Object(this), len = t.length >>> 0;
	      for (var i = 0; i < len; i++) {
	        if (i in t)
	          fun.call(thisArg, t[i], i, t);
	      }
	    };
	  }

	  if (!Object.keys) {
	    Object.keys = (function () {
	      'use strict';

	      var hasOwnProperty = Object.prototype.hasOwnProperty,
	        hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
	        dontEnums = ['toString','toLocaleString','valueOf','hasOwnProperty',
	          'isPrototypeOf','propertyIsEnumerable','constructor'],
	        dontEnumsLength = dontEnums.length;

	      return function (obj) {
	        if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
	          throw new TypeError();
	        }
	        var result = [], prop, i;

	        for (prop in obj) {
	          if (hasOwnProperty.call(obj, prop)) {
	            result.push(prop);
	          }
	        }

	        if (hasDontEnumBug) {
	          for (i = 0; i < dontEnumsLength; i++) {
	            if (hasOwnProperty.call(obj, dontEnums[i])) {
	              result.push(dontEnums[i]);
	            }
	          }
	        }
	        return result;
	      };
	    }());
	  }

	  if (!String.prototype.trim) {
	    String.prototype.trim = function () {
	      return this.replace(/^\s+|\s+$/g, '');
	    };
	  }
	  if (!String.prototype.trimLeft) {
	    String.prototype.trimLeft = function() {
	      return this.replace(/^\s+/g, "");
	    };
	  }
	  if (!String.prototype.trimRight) {
	    String.prototype.trimRight = function() {
	      return this.replace(/\s+$/g, "");
	    };
	  }

	})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this);

	return jsPDF;

	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191).Buffer))

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */

	'use strict'

	var base64 = __webpack_require__(192)
	var ieee754 = __webpack_require__(193)
	var isArray = __webpack_require__(194)

	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	Buffer.poolSize = 8192 // not used by this implementation

	var rootParent = {}

	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
	 *     on objects.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.

	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()

	function typedArraySupport () {
	  function Bar () {}
	  try {
	    var arr = new Uint8Array(1)
	    arr.foo = function () { return 42 }
	    arr.constructor = Bar
	    return arr.foo() === 42 && // typed array instances can be augmented
	        arr.constructor === Bar && // constructor can be set
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}

	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}

	/**
	 * Class: Buffer
	 * =============
	 *
	 * The Buffer constructor returns instances of `Uint8Array` that are augmented
	 * with function properties for all the node `Buffer` API functions. We use
	 * `Uint8Array` so that square bracket notation works as expected -- it returns
	 * a single octet.
	 *
	 * By augmenting the instances, we can avoid modifying the `Uint8Array`
	 * prototype.
	 */
	function Buffer (arg) {
	  if (!(this instanceof Buffer)) {
	    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
	    if (arguments.length > 1) return new Buffer(arg, arguments[1])
	    return new Buffer(arg)
	  }

	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    this.length = 0
	    this.parent = undefined
	  }

	  // Common case.
	  if (typeof arg === 'number') {
	    return fromNumber(this, arg)
	  }

	  // Slightly less common case.
	  if (typeof arg === 'string') {
	    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
	  }

	  // Unusual.
	  return fromObject(this, arg)
	}

	function fromNumber (that, length) {
	  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < length; i++) {
	      that[i] = 0
	    }
	  }
	  return that
	}

	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'

	  // Assumption: byteLength() return value is always < kMaxLength.
	  var length = byteLength(string, encoding) | 0
	  that = allocate(that, length)

	  that.write(string, encoding)
	  return that
	}

	function fromObject (that, object) {
	  if (Buffer.isBuffer(object)) return fromBuffer(that, object)

	  if (isArray(object)) return fromArray(that, object)

	  if (object == null) {
	    throw new TypeError('must start with number, buffer, array or string')
	  }

	  if (typeof ArrayBuffer !== 'undefined') {
	    if (object.buffer instanceof ArrayBuffer) {
	      return fromTypedArray(that, object)
	    }
	    if (object instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, object)
	    }
	  }

	  if (object.length) return fromArrayLike(that, object)

	  return fromJsonObject(that, object)
	}

	function fromBuffer (that, buffer) {
	  var length = checked(buffer.length) | 0
	  that = allocate(that, length)
	  buffer.copy(that, 0, 0, length)
	  return that
	}

	function fromArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	// Duplicate of fromArray() to keep fromArray() monomorphic.
	function fromTypedArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  // Truncating the elements is probably not what people expect from typed
	  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
	  // of the old Buffer constructor.
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	function fromArrayBuffer (that, array) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    array.byteLength
	    that = Buffer._augment(new Uint8Array(array))
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromTypedArray(that, new Uint8Array(array))
	  }
	  return that
	}

	function fromArrayLike (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
	// Returns a zero-length buffer for inputs that don't conform to the spec.
	function fromJsonObject (that, object) {
	  var array
	  var length = 0

	  if (object.type === 'Buffer' && isArray(object.data)) {
	    array = object.data
	    length = checked(array.length) | 0
	  }
	  that = allocate(that, length)

	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	} else {
	  // pre-set for values that may exist in the future
	  Buffer.prototype.length = undefined
	  Buffer.prototype.parent = undefined
	}

	function allocate (that, length) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = Buffer._augment(new Uint8Array(length))
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that.length = length
	    that._isBuffer = true
	  }

	  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
	  if (fromPool) that.parent = rootParent

	  return that
	}

	function checked (length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}

	function SlowBuffer (subject, encoding) {
	  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)

	  var buf = new Buffer(subject, encoding)
	  delete buf.parent
	  return buf
	}

	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}

	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }

	  if (a === b) return 0

	  var x = a.length
	  var y = b.length

	  var i = 0
	  var len = Math.min(x, y)
	  while (i < len) {
	    if (a[i] !== b[i]) break

	    ++i
	  }

	  if (i !== len) {
	    x = a[i]
	    y = b[i]
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}

	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')

	  if (list.length === 0) {
	    return new Buffer(0)
	  }

	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length
	    }
	  }

	  var buf = new Buffer(length)
	  var pos = 0
	  for (i = 0; i < list.length; i++) {
	    var item = list[i]
	    item.copy(buf, pos)
	    pos += item.length
	  }
	  return buf
	}

	function byteLength (string, encoding) {
	  if (typeof string !== 'string') string = '' + string

	  var len = string.length
	  if (len === 0) return 0

	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength

	function slowToString (encoding, start, end) {
	  var loweredCase = false

	  start = start | 0
	  end = end === undefined || end === Infinity ? this.length : end | 0

	  if (!encoding) encoding = 'utf8'
	  if (start < 0) start = 0
	  if (end > this.length) end = this.length
	  if (end <= start) return ''

	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)

	      case 'ascii':
	        return asciiSlice(this, start, end)

	      case 'binary':
	        return binarySlice(this, start, end)

	      case 'base64':
	        return base64Slice(this, start, end)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}

	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}

	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}

	Buffer.prototype.compare = function compare (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return 0
	  return Buffer.compare(this, b)
	}

	Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
	  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
	  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
	  byteOffset >>= 0

	  if (this.length === 0) return -1
	  if (byteOffset >= this.length) return -1

	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)

	  if (typeof val === 'string') {
	    if (val.length === 0) return -1 // special case: looking for empty string always fails
	    return String.prototype.indexOf.call(this, val, byteOffset)
	  }
	  if (Buffer.isBuffer(val)) {
	    return arrayIndexOf(this, val, byteOffset)
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
	    }
	    return arrayIndexOf(this, [ val ], byteOffset)
	  }

	  function arrayIndexOf (arr, val, byteOffset) {
	    var foundIndex = -1
	    for (var i = 0; byteOffset + i < arr.length; i++) {
	      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
	      } else {
	        foundIndex = -1
	      }
	    }
	    return -1
	  }

	  throw new TypeError('val must be string, number or Buffer')
	}

	// `get` is deprecated
	Buffer.prototype.get = function get (offset) {
	  return this.readUInt8(offset)
	}

	// `set` is deprecated
	Buffer.prototype.set = function set (v, offset) {
	  return this.writeUInt8(v, offset)
	}

	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }

	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string')

	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) throw new Error('Invalid hex string')
	    buf[offset + i] = parsed
	  }
	  return i
	}

	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}

	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}

	function binaryWrite (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}

	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}

	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}

	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    var swap = encoding
	    encoding = offset
	    offset = length | 0
	    length = swap
	  }

	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining

	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('attempt to write outside buffer bounds')
	  }

	  if (!encoding) encoding = 'utf8'

	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)

	      case 'ascii':
	        return asciiWrite(this, string, offset, length)

	      case 'binary':
	        return binaryWrite(this, string, offset, length)

	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}

	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}

	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []

	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1

	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint

	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }

	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }

	    res.push(codePoint)
	    i += bytesPerSequence
	  }

	  return decodeCodePointsArray(res)
	}

	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000

	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }

	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}

	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}

	function binarySlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}

	function hexSlice (buf, start, end) {
	  var len = buf.length

	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len

	  var out = ''
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i])
	  }
	  return out
	}

	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}

	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end

	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }

	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }

	  if (end < start) end = start

	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = Buffer._augment(this.subarray(start, end))
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start]
	    }
	  }

	  if (newBuf.length) newBuf.parent = this.parent || this

	  return newBuf
	}

	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}

	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }

	  return val
	}

	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }

	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }

	  return val
	}

	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}

	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}

	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}

	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}

	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}

	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}

	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}

	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}

	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}

	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}

	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}

	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}

	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	}

	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)

	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}

	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}

	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = 0
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	  if (offset < 0) throw new RangeError('index out of range')
	}

	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}

	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}

	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}

	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}

	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start

	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0

	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')

	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }

	  var len = end - start
	  var i

	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    target._set(this.subarray(start, start + len), targetStart)
	  }

	  return len
	}

	// fill(value, start=0, end=buffer.length)
	Buffer.prototype.fill = function fill (value, start, end) {
	  if (!value) value = 0
	  if (!start) start = 0
	  if (!end) end = this.length

	  if (end < start) throw new RangeError('end < start')

	  // Fill 0 bytes; we're done
	  if (end === start) return
	  if (this.length === 0) return

	  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
	  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')

	  var i
	  if (typeof value === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = value
	    }
	  } else {
	    var bytes = utf8ToBytes(value.toString())
	    var len = bytes.length
	    for (i = start; i < end; i++) {
	      this[i] = bytes[i % len]
	    }
	  }

	  return this
	}

	/**
	 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
	 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
	 */
	Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
	  if (typeof Uint8Array !== 'undefined') {
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      return (new Buffer(this)).buffer
	    } else {
	      var buf = new Uint8Array(this.length)
	      for (var i = 0, len = buf.length; i < len; i += 1) {
	        buf[i] = this[i]
	      }
	      return buf.buffer
	    }
	  } else {
	    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
	  }
	}

	// HELPER FUNCTIONS
	// ================

	var BP = Buffer.prototype

	/**
	 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
	 */
	Buffer._augment = function _augment (arr) {
	  arr.constructor = Buffer
	  arr._isBuffer = true

	  // save reference to original Uint8Array set method before overwriting
	  arr._set = arr.set

	  // deprecated
	  arr.get = BP.get
	  arr.set = BP.set

	  arr.write = BP.write
	  arr.toString = BP.toString
	  arr.toLocaleString = BP.toString
	  arr.toJSON = BP.toJSON
	  arr.equals = BP.equals
	  arr.compare = BP.compare
	  arr.indexOf = BP.indexOf
	  arr.copy = BP.copy
	  arr.slice = BP.slice
	  arr.readUIntLE = BP.readUIntLE
	  arr.readUIntBE = BP.readUIntBE
	  arr.readUInt8 = BP.readUInt8
	  arr.readUInt16LE = BP.readUInt16LE
	  arr.readUInt16BE = BP.readUInt16BE
	  arr.readUInt32LE = BP.readUInt32LE
	  arr.readUInt32BE = BP.readUInt32BE
	  arr.readIntLE = BP.readIntLE
	  arr.readIntBE = BP.readIntBE
	  arr.readInt8 = BP.readInt8
	  arr.readInt16LE = BP.readInt16LE
	  arr.readInt16BE = BP.readInt16BE
	  arr.readInt32LE = BP.readInt32LE
	  arr.readInt32BE = BP.readInt32BE
	  arr.readFloatLE = BP.readFloatLE
	  arr.readFloatBE = BP.readFloatBE
	  arr.readDoubleLE = BP.readDoubleLE
	  arr.readDoubleBE = BP.readDoubleBE
	  arr.writeUInt8 = BP.writeUInt8
	  arr.writeUIntLE = BP.writeUIntLE
	  arr.writeUIntBE = BP.writeUIntBE
	  arr.writeUInt16LE = BP.writeUInt16LE
	  arr.writeUInt16BE = BP.writeUInt16BE
	  arr.writeUInt32LE = BP.writeUInt32LE
	  arr.writeUInt32BE = BP.writeUInt32BE
	  arr.writeIntLE = BP.writeIntLE
	  arr.writeIntBE = BP.writeIntBE
	  arr.writeInt8 = BP.writeInt8
	  arr.writeInt16LE = BP.writeInt16LE
	  arr.writeInt16BE = BP.writeInt16BE
	  arr.writeInt32LE = BP.writeInt32LE
	  arr.writeInt32BE = BP.writeInt32BE
	  arr.writeFloatLE = BP.writeFloatLE
	  arr.writeFloatBE = BP.writeFloatBE
	  arr.writeDoubleLE = BP.writeDoubleLE
	  arr.writeDoubleBE = BP.writeDoubleBE
	  arr.fill = BP.fill
	  arr.inspect = BP.inspect
	  arr.toArrayBuffer = BP.toArrayBuffer

	  return arr
	}

	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}

	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}

	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}

	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []

	  for (var i = 0; i < length; i++) {
	    codePoint = string.charCodeAt(i)

	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }

	        // valid lead
	        leadSurrogate = codePoint

	        continue
	      }

	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }

	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }

	    leadSurrogate = null

	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }

	  return bytes
	}

	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}

	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break

	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }

	  return byteArray
	}

	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}

	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191).Buffer, (function() { return this; }())))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

	;(function (exports) {
		'use strict';

	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array

		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)

		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}

		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr

			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}

			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)

			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length

			var L = 0

			function push (v) {
				arr[L++] = v
			}

			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}

			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}

			return arr
		}

		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length

			function encode (num) {
				return lookup.charAt(num)
			}

			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}

			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}

			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}

			return output
		}

		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ },
/* 193 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]

	  i += d

	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}

	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

	  value = Math.abs(value)

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }

	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 194 */
/***/ function(module, exports) {

	var toString = {}.toString;

	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.10.0

	/*
	PDFFont - embeds fonts in PDF documents
	By Devon Govett
	 */

	(function() {
	  var AFMFont, PDFFont, Subset, TTFFont, fs;

	  TTFFont = __webpack_require__(196);

	  AFMFont = __webpack_require__(212);

	  Subset = __webpack_require__(213);

	  // fs = require('fs');

	  PDFFont = (function() {
	    var STANDARD_FONTS, toUnicodeCmap;

	    function PDFFont(document, src, family, id) {
	      this.document = document;
	      this.id = id;
	      if (typeof src === 'string') {
	        if (src in STANDARD_FONTS) {
	          this.isAFM = true;
	          this.font = new AFMFont(STANDARD_FONTS[src]());
	          this.registerAFM(src);
	          return;
	        } else if (/\.(ttf|ttc)$/i.test(src)) {
	          this.font = TTFFont.open(src, family);
	        } else if (/\.dfont$/i.test(src)) {
	          this.font = TTFFont.fromDFont(src, family);
	        } else {
	          throw new Error('Not a supported font format or standard PDF font.');
	        }
	      } else if (Buffer.isBuffer(src)) {
	        this.font = TTFFont.fromBuffer(src, family);
	      } else if (src instanceof Uint8Array) {
	        this.font = TTFFont.fromBuffer(new Buffer(src), family);
	      } else if (src instanceof ArrayBuffer) {
	        this.font = TTFFont.fromBuffer(new Buffer(new Uint8Array(src)), family);
	      } else {
	        throw new Error('Not a supported font format or standard PDF font.');
	      }
	      this.subset = new Subset(this.font);
	      this.registerTTF();
	    }

	    STANDARD_FONTS = {
	      // "Courier": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Courier.afm", 'utf8');
	      // },
	      // "Courier-Bold": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Courier-Bold.afm", 'utf8');
	      // },
	      // "Courier-Oblique": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Courier-Oblique.afm", 'utf8');
	      // },
	      // "Courier-BoldOblique": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Courier-BoldOblique.afm", 'utf8');
	      // },
	      // "Helvetica": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Helvetica.afm", 'utf8');
	      // },
	      // "Helvetica-Bold": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Helvetica-Bold.afm", 'utf8');
	      // },
	      // "Helvetica-Oblique": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Helvetica-Oblique.afm", 'utf8');
	      // },
	      // "Helvetica-BoldOblique": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Helvetica-BoldOblique.afm", 'utf8');
	      // },
	      // "Times-Roman": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Times-Roman.afm", 'utf8');
	      // },
	      // "Times-Bold": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Times-Bold.afm", 'utf8');
	      // },
	      // "Times-Italic": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Times-Italic.afm", 'utf8');
	      // },
	      // "Times-BoldItalic": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Times-BoldItalic.afm", 'utf8');
	      // },
	      // "Symbol": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/Symbol.afm", 'utf8');
	      // },
	      // "ZapfDingbats": function() {
	      //   return fs.readFileSync(__dirname + "/font/data/ZapfDingbats.afm", 'utf8');
	      // }
	    };

	    PDFFont.prototype.use = function(characters) {
	      var ref;
	      return (ref = this.subset) != null ? ref.use(characters) : void 0;
	    };

	    PDFFont.prototype.embed = function() {
	      if (this.embedded || (this.dictionary == null)) {
	        return;
	      }
	      if (this.isAFM) {
	        this.embedAFM();
	      } else {
	        this.embedTTF();
	      }
	      return this.embedded = true;
	    };

	    PDFFont.prototype.encode = function(text) {
	      var ref;
	      if (this.isAFM) {
	        return this.font.encodeText(text);
	      } else {
	        return ((ref = this.subset) != null ? ref.encodeText(text) : void 0) || text;
	      }
	    };

	    PDFFont.prototype.ref = function() {
	      return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
	    };

	    PDFFont.prototype.registerTTF = function() {
	      var e, hi, low, raw, ref;
	      this.name = this.font.name.postscriptName;
	      this.scaleFactor = 1000.0 / this.font.head.unitsPerEm;
	      this.bbox = (function() {
	        var j, len, ref, results;
	        ref = this.font.bbox;
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          e = ref[j];
	          results.push(Math.round(e * this.scaleFactor));
	        }
	        return results;
	      }).call(this);
	      this.stemV = 0;
	      if (this.font.post.exists) {
	        raw = this.font.post.italic_angle;
	        hi = raw >> 16;
	        low = raw & 0xFF;
	        if (hi & 0x8000 !== 0) {
	          hi = -((hi ^ 0xFFFF) + 1);
	        }
	        this.italicAngle = +(hi + "." + low);
	      } else {
	        this.italicAngle = 0;
	      }
	      this.ascender = Math.round(this.font.ascender * this.scaleFactor);
	      this.decender = Math.round(this.font.decender * this.scaleFactor);
	      this.lineGap = Math.round(this.font.lineGap * this.scaleFactor);
	      this.capHeight = (this.font.os2.exists && this.font.os2.capHeight) || this.ascender;
	      this.xHeight = (this.font.os2.exists && this.font.os2.xHeight) || 0;
	      this.familyClass = (this.font.os2.exists && this.font.os2.familyClass || 0) >> 8;
	      this.isSerif = (ref = this.familyClass) === 1 || ref === 2 || ref === 3 || ref === 4 || ref === 5 || ref === 7;
	      this.isScript = this.familyClass === 10;
	      this.flags = 0;
	      if (this.font.post.isFixedPitch) {
	        this.flags |= 1 << 0;
	      }
	      if (this.isSerif) {
	        this.flags |= 1 << 1;
	      }
	      if (this.isScript) {
	        this.flags |= 1 << 3;
	      }
	      if (this.italicAngle !== 0) {
	        this.flags |= 1 << 6;
	      }
	      this.flags |= 1 << 5;
	      if (!this.font.cmap.unicode) {
	        throw new Error('No unicode cmap for font');
	      }
	    };

	    PDFFont.prototype.embedTTF = function() {
	      var charWidths, cmap, code, data, descriptor, firstChar, fontfile, glyph;
	      data = this.subset.encode();
	      fontfile = this.document.ref();
	      fontfile.write(data);
	      fontfile.data.Length1 = fontfile.uncompressedLength;
	      fontfile.end();
	      descriptor = this.document.ref({
	        Type: 'FontDescriptor',
	        FontName: this.subset.postscriptName,
	        FontFile2: fontfile,
	        FontBBox: this.bbox,
	        Flags: this.flags,
	        StemV: this.stemV,
	        ItalicAngle: this.italicAngle,
	        Ascent: this.ascender,
	        Descent: this.decender,
	        CapHeight: this.capHeight,
	        XHeight: this.xHeight
	      });
	      descriptor.end();
	      firstChar = +Object.keys(this.subset.cmap)[0];
	      charWidths = (function() {
	        var ref, results;
	        ref = this.subset.cmap;
	        results = [];
	        for (code in ref) {
	          glyph = ref[code];
	          results.push(Math.round(this.font.widthOfGlyph(glyph)));
	        }
	        return results;
	      }).call(this);
	      cmap = this.document.ref();
	      cmap.end(toUnicodeCmap(this.subset.subset));
	      this.dictionary.data = {
	        Type: 'Font',
	        BaseFont: this.subset.postscriptName,
	        Subtype: 'TrueType',
	        FontDescriptor: descriptor,
	        FirstChar: firstChar,
	        LastChar: firstChar + charWidths.length - 1,
	        Widths: charWidths,
	        Encoding: 'MacRomanEncoding',
	        ToUnicode: cmap
	      };
	      return this.dictionary.end();
	    };

	    PDFFont.prototype.getEmbedInfoTTF = function() {
	      var data = this.subset.encode();
	      var charWidths = (function() {
	        var ref, results;
	        ref = this.subset.cmap;
	        results = [];
	        for (code in ref) {
	          glyph = ref[code];
	          results.push(Math.round(this.font.widthOfGlyph(glyph)));
	        }
	        return results;
	      }).call(this);
	      var firstChar = +Object.keys(this.subset.cmap)[0];
	      return {
	        fontfile: data,
	        descriptor: {
	          Type: 'FontDescriptor',
	          FontName: this.subset.postscriptName,
	          FontBBox: this.bbox,
	          Flags: this.flags,
	          StemV: this.stemV,
	          ItalicAngle: this.italicAngle,
	          Ascent: this.ascender,
	          Descent: this.decender,
	          CapHeight: this.capHeight,
	          XHeight: this.xHeight
	        },
	        firstChar: firstChar,
	        charWidths: charWidths,
	        cmap: toUnicodeCmap(this.subset.subset),
	        dictionary: {
	          Type: 'Font',
	          BaseFont: this.subset.postscriptName,
	          Subtype: 'TrueType',
	          FirstChar: firstChar,
	          LastChar: firstChar + charWidths.length - 1,
	          Widths: charWidths,
	          Encoding: 'MacRomanEncoding'
	        }
	      };
	    };

	    toUnicodeCmap = function(map) {
	      var code, codes, j, len, range, unicode, unicodeMap;
	      unicodeMap = '/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<00><ff>\nendcodespacerange';
	      codes = Object.keys(map).sort(function(a, b) {
	        return a - b;
	      });
	      range = [];
	      for (j = 0, len = codes.length; j < len; j++) {
	        code = codes[j];
	        if (range.length >= 100) {
	          unicodeMap += "\n" + range.length + " beginbfchar\n" + (range.join('\n')) + "\nendbfchar";
	          range = [];
	        }
	        unicode = ('0000' + map[code].toString(16)).slice(-4);
	        code = (+code).toString(16);
	        range.push("<" + code + "><" + unicode + ">");
	      }
	      if (range.length) {
	        unicodeMap += "\n" + range.length + " beginbfchar\n" + (range.join('\n')) + "\nendbfchar\n";
	      }
	      return unicodeMap += 'endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend';
	    };

	    PDFFont.prototype.registerAFM = function(name) {
	      var ref;
	      this.name = name;
	      return ref = this.font, this.ascender = ref.ascender, this.decender = ref.decender, this.bbox = ref.bbox, this.lineGap = ref.lineGap, ref;
	    };

	    PDFFont.prototype.embedAFM = function() {
	      this.dictionary.data = {
	        Type: 'Font',
	        BaseFont: this.name,
	        Subtype: 'Type1',
	        Encoding: 'WinAnsiEncoding'
	      };
	      return this.dictionary.end();
	    };

	    PDFFont.prototype.widthOfString = function(str, size) {
	      var charCode, i, j, ref, scale, width;
	      str = '' + str;
	      width = 0;
	      for (i = j = 0, ref = str.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        charCode = str.charCodeAt(i);
	        width += this.font.widthOfGlyph(this.font.characterToGlyph(charCode)) || 0;
	      }
	      scale = size / 1000;
	      return width * scale;
	    };

	    PDFFont.prototype.lineHeight = function(size, includeGap) {
	      var gap;
	      if (includeGap == null) {
	        includeGap = false;
	      }
	      gap = includeGap ? this.lineGap : 0;
	      return (this.ascender + gap - this.decender) / 1000 * size;
	    };

	    return PDFFont;

	  })();

	  module.exports = PDFFont;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191).Buffer))

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var CmapTable, DFont, Data, Directory, GlyfTable, HeadTable, HheaTable, HmtxTable, LocaTable, MaxpTable, NameTable, OS2Table, PostTable, TTFFont, fs;

	  // fs = require('fs');

	  Data = __webpack_require__(197);

	  DFont = __webpack_require__(198);

	  Directory = __webpack_require__(199);

	  NameTable = __webpack_require__(200);

	  HeadTable = __webpack_require__(203);

	  CmapTable = __webpack_require__(204);

	  HmtxTable = __webpack_require__(205);

	  HheaTable = __webpack_require__(206);

	  MaxpTable = __webpack_require__(207);

	  PostTable = __webpack_require__(208);

	  OS2Table = __webpack_require__(209);

	  LocaTable = __webpack_require__(210);

	  GlyfTable = __webpack_require__(211);

	  TTFFont = (function() {
	    // TTFFont.open = function(filename, name) {
	    //   var contents;
	    //   contents = fs.readFileSync(filename);
	    //   return new TTFFont(contents, name);
	    // };

	    TTFFont.fromDFont = function(filename, family) {
	      var dfont;
	      dfont = DFont.open(filename);
	      return new TTFFont(dfont.getNamedFont(family));
	    };

	    TTFFont.fromBuffer = function(buffer, family) {
	      var dfont, e, error, ttf;
	      try {
	        ttf = new TTFFont(buffer, family);
	        if (!(ttf.head.exists && ttf.name.exists && ttf.cmap.exists)) {
	          dfont = new DFont(buffer);
	          ttf = new TTFFont(dfont.getNamedFont(family));
	          if (!(ttf.head.exists && ttf.name.exists && ttf.cmap.exists)) {
	            throw new Error('Invalid TTF file in DFont');
	          }
	        }
	        return ttf;
	      } catch (error) {
	        e = error;
	        throw new Error('Unknown font format in buffer: ' + e.message);
	      }
	    };

	    function TTFFont(rawData, name) {
	      var data, i, j, k, len, numFonts, offset, offsets, ref, version;
	      this.rawData = rawData;
	      data = this.contents = new Data(this.rawData);
	      if (data.readString(4) === 'ttcf') {
	        if (!name) {
	          throw new Error("Must specify a font name for TTC files.");
	        }
	        version = data.readInt();
	        numFonts = data.readInt();
	        offsets = [];
	        for (i = j = 0, ref = numFonts; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	          offsets[i] = data.readInt();
	        }
	        for (i = k = 0, len = offsets.length; k < len; i = ++k) {
	          offset = offsets[i];
	          data.pos = offset;
	          this.parse();
	          if (this.name.postscriptName === name) {
	            return;
	          }
	        }
	        throw new Error("Font " + name + " not found in TTC file.");
	      } else {
	        data.pos = 0;
	        this.parse();
	      }
	    }

	    TTFFont.prototype.parse = function() {
	      this.directory = new Directory(this.contents);
	      this.head = new HeadTable(this);
	      this.name = new NameTable(this);
	      this.cmap = new CmapTable(this);
	      this.hhea = new HheaTable(this);
	      this.maxp = new MaxpTable(this);
	      this.hmtx = new HmtxTable(this);
	      this.post = new PostTable(this);
	      this.os2 = new OS2Table(this);
	      this.loca = new LocaTable(this);
	      this.glyf = new GlyfTable(this);
	      this.ascender = (this.os2.exists && this.os2.ascender) || this.hhea.ascender;
	      this.decender = (this.os2.exists && this.os2.decender) || this.hhea.decender;
	      this.lineGap = (this.os2.exists && this.os2.lineGap) || this.hhea.lineGap;
	      return this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
	    };

	    TTFFont.prototype.characterToGlyph = function(character) {
	      var ref;
	      return ((ref = this.cmap.unicode) != null ? ref.codeMap[character] : void 0) || 0;
	    };

	    TTFFont.prototype.widthOfGlyph = function(glyph) {
	      var scale;
	      scale = 1000.0 / this.head.unitsPerEm;
	      return this.hmtx.forGlyph(glyph).advance * scale;
	    };

	    return TTFFont;

	  })();

	  module.exports = TTFFont;

	}).call(this);


/***/ },
/* 197 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data;

	  Data = (function() {
	    function Data(data) {
	      this.data = data != null ? data : [];
	      this.pos = 0;
	      this.length = this.data.length;
	    }

	    Data.prototype.readByte = function() {
	      return this.data[this.pos++];
	    };

	    Data.prototype.writeByte = function(_byte) {
	      return this.data[this.pos++] = _byte;
	    };

	    Data.prototype.byteAt = function(index) {
	      return this.data[index];
	    };

	    Data.prototype.readBool = function() {
	      return !!this.readByte();
	    };

	    Data.prototype.writeBool = function(val) {
	      return this.writeByte(val ? 1 : 0);
	    };

	    Data.prototype.readUInt32 = function() {
	      var b1, b2, b3, b4;
	      b1 = this.readByte() * 0x1000000;
	      b2 = this.readByte() << 16;
	      b3 = this.readByte() << 8;
	      b4 = this.readByte();
	      return b1 + b2 + b3 + b4;
	    };

	    Data.prototype.writeUInt32 = function(val) {
	      this.writeByte((val >>> 24) & 0xff);
	      this.writeByte((val >> 16) & 0xff);
	      this.writeByte((val >> 8) & 0xff);
	      return this.writeByte(val & 0xff);
	    };

	    Data.prototype.readInt32 = function() {
	      var _int;
	      _int = this.readUInt32();
	      if (_int >= 0x80000000) {
	        return _int - 0x100000000;
	      } else {
	        return _int;
	      }
	    };

	    Data.prototype.writeInt32 = function(val) {
	      if (val < 0) {
	        val += 0x100000000;
	      }
	      return this.writeUInt32(val);
	    };

	    Data.prototype.readUInt16 = function() {
	      var b1, b2;
	      b1 = this.readByte() << 8;
	      b2 = this.readByte();
	      return b1 | b2;
	    };

	    Data.prototype.writeUInt16 = function(val) {
	      this.writeByte((val >> 8) & 0xff);
	      return this.writeByte(val & 0xff);
	    };

	    Data.prototype.readInt16 = function() {
	      var _int;
	      _int = this.readUInt16();
	      if (_int >= 0x8000) {
	        return _int - 0x10000;
	      } else {
	        return _int;
	      }
	    };

	    Data.prototype.writeInt16 = function(val) {
	      if (val < 0) {
	        val += 0x10000;
	      }
	      return this.writeUInt16(val);
	    };

	    Data.prototype.readString = function(length) {
	      var i, j, ref, ret;
	      ret = [];
	      for (i = j = 0, ref = length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        ret[i] = String.fromCharCode(this.readByte());
	      }
	      return ret.join('');
	    };

	    Data.prototype.writeString = function(val) {
	      var i, j, ref, results;
	      results = [];
	      for (i = j = 0, ref = val.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        results.push(this.writeByte(val.charCodeAt(i)));
	      }
	      return results;
	    };

	    Data.prototype.stringAt = function(pos, length) {
	      this.pos = pos;
	      return this.readString(length);
	    };

	    Data.prototype.readShort = function() {
	      return this.readInt16();
	    };

	    Data.prototype.writeShort = function(val) {
	      return this.writeInt16(val);
	    };

	    Data.prototype.readLongLong = function() {
	      var b1, b2, b3, b4, b5, b6, b7, b8;
	      b1 = this.readByte();
	      b2 = this.readByte();
	      b3 = this.readByte();
	      b4 = this.readByte();
	      b5 = this.readByte();
	      b6 = this.readByte();
	      b7 = this.readByte();
	      b8 = this.readByte();
	      if (b1 & 0x80) {
	        return ((b1 ^ 0xff) * 0x100000000000000 + (b2 ^ 0xff) * 0x1000000000000 + (b3 ^ 0xff) * 0x10000000000 + (b4 ^ 0xff) * 0x100000000 + (b5 ^ 0xff) * 0x1000000 + (b6 ^ 0xff) * 0x10000 + (b7 ^ 0xff) * 0x100 + (b8 ^ 0xff) + 1) * -1;
	      }
	      return b1 * 0x100000000000000 + b2 * 0x1000000000000 + b3 * 0x10000000000 + b4 * 0x100000000 + b5 * 0x1000000 + b6 * 0x10000 + b7 * 0x100 + b8;
	    };

	    Data.prototype.writeLongLong = function(val) {
	      var high, low;
	      high = Math.floor(val / 0x100000000);
	      low = val & 0xffffffff;
	      this.writeByte((high >> 24) & 0xff);
	      this.writeByte((high >> 16) & 0xff);
	      this.writeByte((high >> 8) & 0xff);
	      this.writeByte(high & 0xff);
	      this.writeByte((low >> 24) & 0xff);
	      this.writeByte((low >> 16) & 0xff);
	      this.writeByte((low >> 8) & 0xff);
	      return this.writeByte(low & 0xff);
	    };

	    Data.prototype.readInt = function() {
	      return this.readInt32();
	    };

	    Data.prototype.writeInt = function(val) {
	      return this.writeInt32(val);
	    };

	    Data.prototype.slice = function(start, end) {
	      return this.data.slice(start, end);
	    };

	    Data.prototype.read = function(bytes) {
	      var buf, i, j, ref;
	      buf = [];
	      for (i = j = 0, ref = bytes; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        buf.push(this.readByte());
	      }
	      return buf;
	    };

	    Data.prototype.write = function(bytes) {
	      var _byte, j, len, results;
	      results = [];
	      for (j = 0, len = bytes.length; j < len; j++) {
	        _byte = bytes[j];
	        results.push(this.writeByte(_byte));
	      }
	      return results;
	    };

	    return Data;

	  })();

	  module.exports = Data;

	}).call(this);


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var DFont, Data, Directory, NameTable, fs;

	  // fs = require('fs');

	  Data = __webpack_require__(197);

	  Directory = __webpack_require__(199);

	  NameTable = __webpack_require__(200);

	  DFont = (function() {
	    // DFont.open = function(filename) {
	    //   var contents;
	    //   contents = fs.readFileSync(filename);
	    //   return new DFont(contents);
	    // };

	    function DFont(contents) {
	      this.contents = new Data(contents);
	      this.parse(this.contents);
	    }

	    DFont.prototype.parse = function(data) {
	      var attr, b2, b3, b4, dataLength, dataOffset, dataOfs, entry, font, handle, i, id, j, k, l, len, length, mapLength, mapOffset, maxIndex, maxTypeIndex, name, nameListOffset, nameOfs, p, pos, ref, ref1, refListOffset, type, typeListOffset;
	      dataOffset = data.readInt();
	      mapOffset = data.readInt();
	      dataLength = data.readInt();
	      mapLength = data.readInt();
	      this.map = {};
	      data.pos = mapOffset + 24;
	      typeListOffset = data.readShort() + mapOffset;
	      nameListOffset = data.readShort() + mapOffset;
	      data.pos = typeListOffset;
	      maxIndex = data.readShort();
	      for (i = k = 0, ref = maxIndex; k <= ref; i = k += 1) {
	        type = data.readString(4);
	        maxTypeIndex = data.readShort();
	        refListOffset = data.readShort();
	        this.map[type] = {
	          list: [],
	          named: {}
	        };
	        pos = data.pos;
	        data.pos = typeListOffset + refListOffset;
	        for (j = l = 0, ref1 = maxTypeIndex; l <= ref1; j = l += 1) {
	          id = data.readShort();
	          nameOfs = data.readShort();
	          attr = data.readByte();
	          b2 = data.readByte() << 16;
	          b3 = data.readByte() << 8;
	          b4 = data.readByte();
	          dataOfs = dataOffset + (0 | b2 | b3 | b4);
	          handle = data.readUInt32();
	          entry = {
	            id: id,
	            attributes: attr,
	            offset: dataOfs,
	            handle: handle
	          };
	          p = data.pos;
	          if (nameOfs !== -1 && (nameListOffset + nameOfs < mapOffset + mapLength)) {
	            data.pos = nameListOffset + nameOfs;
	            len = data.readByte();
	            entry.name = data.readString(len);
	          } else if (type === 'sfnt') {
	            data.pos = entry.offset;
	            length = data.readUInt32();
	            font = {};
	            font.contents = new Data(data.slice(data.pos, data.pos + length));
	            font.directory = new Directory(font.contents);
	            name = new NameTable(font);
	            entry.name = name.fontName[0].raw;
	          }
	          data.pos = p;
	          this.map[type].list.push(entry);
	          if (entry.name) {
	            this.map[type].named[entry.name] = entry;
	          }
	        }
	        data.pos = pos;
	      }
	    };

	    DFont.prototype.getNamedFont = function(name) {
	      var data, entry, length, pos, ref, ret;
	      data = this.contents;
	      pos = data.pos;
	      entry = (ref = this.map.sfnt) != null ? ref.named[name] : void 0;
	      if (!entry) {
	        throw new Error("Font " + name + " not found in DFont file.");
	      }
	      data.pos = entry.offset;
	      length = data.readUInt32();
	      ret = data.slice(data.pos, data.pos + length);
	      data.pos = pos;
	      return ret;
	    };

	    return DFont;

	  })();

	  module.exports = DFont;

	}).call(this);


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, Directory,
	    slice = [].slice;

	  Data = __webpack_require__(197);

	  Directory = (function() {
	    var checksum;

	    function Directory(data) {
	      var entry, i, j, ref;
	      this.scalarType = data.readInt();
	      this.tableCount = data.readShort();
	      this.searchRange = data.readShort();
	      this.entrySelector = data.readShort();
	      this.rangeShift = data.readShort();
	      this.tables = {};
	      for (i = j = 0, ref = this.tableCount; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        entry = {
	          tag: data.readString(4),
	          checksum: data.readInt(),
	          offset: data.readInt(),
	          length: data.readInt()
	        };
	        this.tables[entry.tag] = entry;
	      }
	    }

	    Directory.prototype.encode = function(tables) {
	      var adjustment, directory, directoryLength, entrySelector, headOffset, log2, offset, rangeShift, searchRange, sum, table, tableCount, tableData, tag;
	      tableCount = Object.keys(tables).length;
	      log2 = Math.log(2);
	      searchRange = Math.floor(Math.log(tableCount) / log2) * 16;
	      entrySelector = Math.floor(searchRange / log2);
	      rangeShift = tableCount * 16 - searchRange;
	      directory = new Data;
	      directory.writeInt(this.scalarType);
	      directory.writeShort(tableCount);
	      directory.writeShort(searchRange);
	      directory.writeShort(entrySelector);
	      directory.writeShort(rangeShift);
	      directoryLength = tableCount * 16;
	      offset = directory.pos + directoryLength;
	      headOffset = null;
	      tableData = [];
	      for (tag in tables) {
	        table = tables[tag];
	        directory.writeString(tag);
	        directory.writeInt(checksum(table));
	        directory.writeInt(offset);
	        directory.writeInt(table.length);
	        tableData = tableData.concat(table);
	        if (tag === 'head') {
	          headOffset = offset;
	        }
	        offset += table.length;
	        while (offset % 4) {
	          tableData.push(0);
	          offset++;
	        }
	      }
	      directory.write(tableData);
	      sum = checksum(directory.data);
	      adjustment = 0xB1B0AFBA - sum;
	      directory.pos = headOffset + 8;
	      directory.writeUInt32(adjustment);
	      return new Buffer(directory.data);
	    };

	    checksum = function(data) {
	      var i, j, ref, sum, tmp;
	      data = slice.call(data);
	      while (data.length % 4) {
	        data.push(0);
	      }
	      tmp = new Data(data);
	      sum = 0;
	      for (i = j = 0, ref = data.length; j < ref; i = j += 4) {
	        sum += tmp.readUInt32();
	      }
	      return sum & 0xFFFFFFFF;
	    };

	    return Directory;

	  })();

	  module.exports = Directory;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191).Buffer))

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, NameEntry, NameTable, Table, utils,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  utils = __webpack_require__(202);

	  NameTable = (function(superClass) {
	    var subsetTag;

	    extend(NameTable, superClass);

	    function NameTable() {
	      return NameTable.__super__.constructor.apply(this, arguments);
	    }

	    NameTable.prototype.tag = 'name';

	    NameTable.prototype.parse = function(data) {
	      var count, entries, entry, format, i, j, k, len, name, name1, ref, stringOffset, strings, text;
	      data.pos = this.offset;
	      format = data.readShort();
	      count = data.readShort();
	      stringOffset = data.readShort();
	      entries = [];
	      for (i = j = 0, ref = count; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        entries.push({
	          platformID: data.readShort(),
	          encodingID: data.readShort(),
	          languageID: data.readShort(),
	          nameID: data.readShort(),
	          length: data.readShort(),
	          offset: this.offset + stringOffset + data.readShort()
	        });
	      }
	      strings = {};
	      for (i = k = 0, len = entries.length; k < len; i = ++k) {
	        entry = entries[i];
	        data.pos = entry.offset;
	        text = data.readString(entry.length);
	        name = new NameEntry(text, entry);
	        if (strings[name1 = entry.nameID] == null) {
	          strings[name1] = [];
	        }
	        strings[entry.nameID].push(name);
	      }
	      this.strings = strings;
	      this.copyright = strings[0];
	      this.fontFamily = strings[1];
	      this.fontSubfamily = strings[2];
	      this.uniqueSubfamily = strings[3];
	      this.fontName = strings[4];
	      this.version = strings[5];
	      this.postscriptName = strings[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
	      this.trademark = strings[7];
	      this.manufacturer = strings[8];
	      this.designer = strings[9];
	      this.description = strings[10];
	      this.vendorUrl = strings[11];
	      this.designerUrl = strings[12];
	      this.license = strings[13];
	      this.licenseUrl = strings[14];
	      this.preferredFamily = strings[15];
	      this.preferredSubfamily = strings[17];
	      this.compatibleFull = strings[18];
	      return this.sampleText = strings[19];
	    };

	    subsetTag = "AAAAAA";

	    NameTable.prototype.encode = function() {
	      var id, j, len, list, nameID, nameTable, postscriptName, ref, strCount, strTable, string, strings, table, val;
	      strings = {};
	      ref = this.strings;
	      for (id in ref) {
	        val = ref[id];
	        strings[id] = val;
	      }
	      postscriptName = new NameEntry(subsetTag + "+" + this.postscriptName, {
	        platformID: 1,
	        encodingID: 0,
	        languageID: 0
	      });
	      strings[6] = [postscriptName];
	      subsetTag = utils.successorOf(subsetTag);
	      strCount = 0;
	      for (id in strings) {
	        list = strings[id];
	        if (list != null) {
	          strCount += list.length;
	        }
	      }
	      table = new Data;
	      strTable = new Data;
	      table.writeShort(0);
	      table.writeShort(strCount);
	      table.writeShort(6 + 12 * strCount);
	      for (nameID in strings) {
	        list = strings[nameID];
	        if (list != null) {
	          for (j = 0, len = list.length; j < len; j++) {
	            string = list[j];
	            table.writeShort(string.platformID);
	            table.writeShort(string.encodingID);
	            table.writeShort(string.languageID);
	            table.writeShort(nameID);
	            table.writeShort(string.length);
	            table.writeShort(strTable.pos);
	            strTable.writeString(string.raw);
	          }
	        }
	      }
	      return nameTable = {
	        postscriptName: postscriptName.raw,
	        table: table.data.concat(strTable.data)
	      };
	    };

	    return NameTable;

	  })(Table);

	  module.exports = NameTable;

	  NameEntry = (function() {
	    function NameEntry(raw, entry) {
	      this.raw = raw;
	      this.length = this.raw.length;
	      this.platformID = entry.platformID;
	      this.encodingID = entry.encodingID;
	      this.languageID = entry.languageID;
	    }

	    return NameEntry;

	  })();

	}).call(this);


/***/ },
/* 201 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Table;

	  Table = (function() {
	    function Table(file) {
	      var info;
	      this.file = file;
	      info = this.file.directory.tables[this.tag];
	      this.exists = !!info;
	      if (info) {
	        this.offset = info.offset, this.length = info.length;
	        this.parse(this.file.contents);
	      }
	    }

	    Table.prototype.parse = function() {};

	    Table.prototype.encode = function() {};

	    Table.prototype.raw = function() {
	      if (!this.exists) {
	        return null;
	      }
	      this.file.contents.pos = this.offset;
	      return this.file.contents.read(this.length);
	    };

	    return Table;

	  })();

	  module.exports = Table;

	}).call(this);


/***/ },
/* 202 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.10.0

	/*
	 * An implementation of Ruby's string.succ method.
	 * By Devon Govett
	 *
	 * Returns the successor to str. The successor is calculated by incrementing characters starting 
	 * from the rightmost alphanumeric (or the rightmost character if there are no alphanumerics) in the
	 * string. Incrementing a digit always results in another digit, and incrementing a letter results in
	 * another letter of the same case.
	 *
	 * If the increment generates a carry, the character to the left of it is incremented. This 
	 * process repeats until there is no carry, adding an additional character if necessary.
	 *
	 * succ("abcd")      == "abce"
	 * succ("THX1138")   == "THX1139"
	 * succ("<<koala>>") == "<<koalb>>"
	 * succ("1999zzz")   == "2000aaa"
	 * succ("ZZZ9999")   == "AAAA0000"
	 */

	(function() {
	  exports.successorOf = function(input) {
	    var added, alphabet, carry, i, index, isUpperCase, last, length, next, result;
	    alphabet = 'abcdefghijklmnopqrstuvwxyz';
	    length = alphabet.length;
	    result = input;
	    i = input.length;
	    while (i >= 0) {
	      last = input.charAt(--i);
	      if (isNaN(last)) {
	        index = alphabet.indexOf(last.toLowerCase());
	        if (index === -1) {
	          next = last;
	          carry = true;
	        } else {
	          next = alphabet.charAt((index + 1) % length);
	          isUpperCase = last === last.toUpperCase();
	          if (isUpperCase) {
	            next = next.toUpperCase();
	          }
	          carry = index + 1 >= length;
	          if (carry && i === 0) {
	            added = isUpperCase ? 'A' : 'a';
	            result = added + next + result.slice(1);
	            break;
	          }
	        }
	      } else {
	        next = +last + 1;
	        carry = next > 9;
	        if (carry) {
	          next = 0;
	        }
	        if (carry && i === 0) {
	          result = '1' + next + result.slice(1);
	          break;
	        }
	      }
	      result = result.slice(0, i) + next + result.slice(i + 1);
	      if (!carry) {
	        break;
	      }
	    }
	    return result;
	  };

	  exports.invert = function(object) {
	    var key, ret, val;
	    ret = {};
	    for (key in object) {
	      val = object[key];
	      ret[val] = key;
	    }
	    return ret;
	  };

	}).call(this);


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, HeadTable, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  HeadTable = (function(superClass) {
	    extend(HeadTable, superClass);

	    function HeadTable() {
	      return HeadTable.__super__.constructor.apply(this, arguments);
	    }

	    HeadTable.prototype.tag = 'head';

	    HeadTable.prototype.parse = function(data) {
	      data.pos = this.offset;
	      this.version = data.readInt();
	      this.revision = data.readInt();
	      this.checkSumAdjustment = data.readInt();
	      this.magicNumber = data.readInt();
	      this.flags = data.readShort();
	      this.unitsPerEm = data.readShort();
	      this.created = data.readLongLong();
	      this.modified = data.readLongLong();
	      this.xMin = data.readShort();
	      this.yMin = data.readShort();
	      this.xMax = data.readShort();
	      this.yMax = data.readShort();
	      this.macStyle = data.readShort();
	      this.lowestRecPPEM = data.readShort();
	      this.fontDirectionHint = data.readShort();
	      this.indexToLocFormat = data.readShort();
	      return this.glyphDataFormat = data.readShort();
	    };

	    HeadTable.prototype.encode = function(loca) {
	      var table;
	      table = new Data;
	      table.writeInt(this.version);
	      table.writeInt(this.revision);
	      table.writeInt(this.checkSumAdjustment);
	      table.writeInt(this.magicNumber);
	      table.writeShort(this.flags);
	      table.writeShort(this.unitsPerEm);
	      table.writeLongLong(this.created);
	      table.writeLongLong(this.modified);
	      table.writeShort(this.xMin);
	      table.writeShort(this.yMin);
	      table.writeShort(this.xMax);
	      table.writeShort(this.yMax);
	      table.writeShort(this.macStyle);
	      table.writeShort(this.lowestRecPPEM);
	      table.writeShort(this.fontDirectionHint);
	      table.writeShort(loca.type);
	      table.writeShort(this.glyphDataFormat);
	      return table.data;
	    };

	    return HeadTable;

	  })(Table);

	  module.exports = HeadTable;

	}).call(this);


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var CmapEntry, CmapTable, Data, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  CmapTable = (function(superClass) {
	    extend(CmapTable, superClass);

	    function CmapTable() {
	      return CmapTable.__super__.constructor.apply(this, arguments);
	    }

	    CmapTable.prototype.tag = 'cmap';

	    CmapTable.prototype.parse = function(data) {
	      var entry, i, j, ref, tableCount;
	      data.pos = this.offset;
	      this.version = data.readUInt16();
	      tableCount = data.readUInt16();
	      this.tables = [];
	      this.unicode = null;
	      for (i = j = 0, ref = tableCount; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        entry = new CmapEntry(data, this.offset);
	        this.tables.push(entry);
	        if (entry.isUnicode) {
	          if (this.unicode == null) {
	            this.unicode = entry;
	          }
	        }
	      }
	      return true;
	    };

	    CmapTable.encode = function(charmap, encoding) {
	      var result, table;
	      if (encoding == null) {
	        encoding = 'macroman';
	      }
	      result = CmapEntry.encode(charmap, encoding);
	      table = new Data;
	      table.writeUInt16(0);
	      table.writeUInt16(1);
	      result.table = table.data.concat(result.subtable);
	      return result;
	    };

	    return CmapTable;

	  })(Table);

	  CmapEntry = (function() {
	    function CmapEntry(data, offset) {
	      var code, count, endCode, glyphId, glyphIds, i, idDelta, idRangeOffset, index, j, k, l, len, ref, ref1, saveOffset, segCount, segCountX2, start, startCode, tail;
	      this.platformID = data.readUInt16();
	      this.encodingID = data.readShort();
	      this.offset = offset + data.readInt();
	      saveOffset = data.pos;
	      data.pos = this.offset;
	      this.format = data.readUInt16();
	      this.length = data.readUInt16();
	      this.language = data.readUInt16();
	      this.isUnicode = (this.platformID === 3 && this.encodingID === 1 && this.format === 4) || this.platformID === 0 && this.format === 4;
	      this.codeMap = {};
	      switch (this.format) {
	        case 0:
	          for (i = j = 0; j < 256; i = ++j) {
	            this.codeMap[i] = data.readByte();
	          }
	          break;
	        case 4:
	          segCountX2 = data.readUInt16();
	          segCount = segCountX2 / 2;
	          data.pos += 6;
	          endCode = (function() {
	            var k, ref, results;
	            results = [];
	            for (i = k = 0, ref = segCount; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	              results.push(data.readUInt16());
	            }
	            return results;
	          })();
	          data.pos += 2;
	          startCode = (function() {
	            var k, ref, results;
	            results = [];
	            for (i = k = 0, ref = segCount; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	              results.push(data.readUInt16());
	            }
	            return results;
	          })();
	          idDelta = (function() {
	            var k, ref, results;
	            results = [];
	            for (i = k = 0, ref = segCount; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	              results.push(data.readUInt16());
	            }
	            return results;
	          })();
	          idRangeOffset = (function() {
	            var k, ref, results;
	            results = [];
	            for (i = k = 0, ref = segCount; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	              results.push(data.readUInt16());
	            }
	            return results;
	          })();
	          count = (this.length - data.pos + this.offset) / 2;
	          glyphIds = (function() {
	            var k, ref, results;
	            results = [];
	            for (i = k = 0, ref = count; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
	              results.push(data.readUInt16());
	            }
	            return results;
	          })();
	          for (i = k = 0, len = endCode.length; k < len; i = ++k) {
	            tail = endCode[i];
	            start = startCode[i];
	            for (code = l = ref = start, ref1 = tail; ref <= ref1 ? l <= ref1 : l >= ref1; code = ref <= ref1 ? ++l : --l) {
	              if (idRangeOffset[i] === 0) {
	                glyphId = code + idDelta[i];
	              } else {
	                index = idRangeOffset[i] / 2 + (code - start) - (segCount - i);
	                glyphId = glyphIds[index] || 0;
	                if (glyphId !== 0) {
	                  glyphId += idDelta[i];
	                }
	              }
	              this.codeMap[code] = glyphId & 0xFFFF;
	            }
	          }
	      }
	      data.pos = saveOffset;
	    }

	    CmapEntry.encode = function(charmap, encoding) {
	      var charMap, code, codeMap, codes, delta, deltas, diff, endCode, endCodes, entrySelector, glyphIDs, i, id, indexes, j, k, l, last, len, len1, len2, len3, len4, len5, len6, len7, m, map, n, name, nextID, o, offset, old, p, q, r, rangeOffsets, rangeShift, ref, ref1, result, searchRange, segCount, segCountX2, startCode, startCodes, startGlyph, subtable;
	      subtable = new Data;
	      codes = Object.keys(charmap).sort(function(a, b) {
	        return a - b;
	      });
	      switch (encoding) {
	        case 'macroman':
	          id = 0;
	          indexes = (function() {
	            var j, results;
	            results = [];
	            for (i = j = 0; j < 256; i = ++j) {
	              results.push(0);
	            }
	            return results;
	          })();
	          map = {
	            0: 0
	          };
	          codeMap = {};
	          for (j = 0, len = codes.length; j < len; j++) {
	            code = codes[j];
	            if (map[name = charmap[code]] == null) {
	              map[name] = ++id;
	            }
	            codeMap[code] = {
	              old: charmap[code],
	              "new": map[charmap[code]]
	            };
	            indexes[code] = map[charmap[code]];
	          }
	          subtable.writeUInt16(1);
	          subtable.writeUInt16(0);
	          subtable.writeUInt32(12);
	          subtable.writeUInt16(0);
	          subtable.writeUInt16(262);
	          subtable.writeUInt16(0);
	          subtable.write(indexes);
	          return result = {
	            charMap: codeMap,
	            subtable: subtable.data,
	            maxGlyphID: id + 1
	          };
	        case 'unicode':
	          startCodes = [];
	          endCodes = [];
	          nextID = 0;
	          map = {};
	          charMap = {};
	          last = diff = null;
	          for (k = 0, len1 = codes.length; k < len1; k++) {
	            code = codes[k];
	            old = charmap[code];
	            if (map[old] == null) {
	              map[old] = ++nextID;
	            }
	            charMap[code] = {
	              old: old,
	              "new": map[old]
	            };
	            delta = map[old] - code;
	            if ((last == null) || delta !== diff) {
	              if (last) {
	                endCodes.push(last);
	              }
	              startCodes.push(code);
	              diff = delta;
	            }
	            last = code;
	          }
	          if (last) {
	            endCodes.push(last);
	          }
	          endCodes.push(0xFFFF);
	          startCodes.push(0xFFFF);
	          segCount = startCodes.length;
	          segCountX2 = segCount * 2;
	          searchRange = 2 * Math.pow(Math.log(segCount) / Math.LN2, 2);
	          entrySelector = Math.log(searchRange / 2) / Math.LN2;
	          rangeShift = 2 * segCount - searchRange;
	          deltas = [];
	          rangeOffsets = [];
	          glyphIDs = [];
	          for (i = l = 0, len2 = startCodes.length; l < len2; i = ++l) {
	            startCode = startCodes[i];
	            endCode = endCodes[i];
	            if (startCode === 0xFFFF) {
	              deltas.push(0);
	              rangeOffsets.push(0);
	              break;
	            }
	            startGlyph = charMap[startCode]["new"];
	            if (startCode - startGlyph >= 0x8000) {
	              deltas.push(0);
	              rangeOffsets.push(2 * (glyphIDs.length + segCount - i));
	              for (code = m = ref = startCode, ref1 = endCode; ref <= ref1 ? m <= ref1 : m >= ref1; code = ref <= ref1 ? ++m : --m) {
	                glyphIDs.push(charMap[code]["new"]);
	              }
	            } else {
	              deltas.push(startGlyph - startCode);
	              rangeOffsets.push(0);
	            }
	          }
	          subtable.writeUInt16(3);
	          subtable.writeUInt16(1);
	          subtable.writeUInt32(12);
	          subtable.writeUInt16(4);
	          subtable.writeUInt16(16 + segCount * 8 + glyphIDs.length * 2);
	          subtable.writeUInt16(0);
	          subtable.writeUInt16(segCountX2);
	          subtable.writeUInt16(searchRange);
	          subtable.writeUInt16(entrySelector);
	          subtable.writeUInt16(rangeShift);
	          for (n = 0, len3 = endCodes.length; n < len3; n++) {
	            code = endCodes[n];
	            subtable.writeUInt16(code);
	          }
	          subtable.writeUInt16(0);
	          for (o = 0, len4 = startCodes.length; o < len4; o++) {
	            code = startCodes[o];
	            subtable.writeUInt16(code);
	          }
	          for (p = 0, len5 = deltas.length; p < len5; p++) {
	            delta = deltas[p];
	            subtable.writeUInt16(delta);
	          }
	          for (q = 0, len6 = rangeOffsets.length; q < len6; q++) {
	            offset = rangeOffsets[q];
	            subtable.writeUInt16(offset);
	          }
	          for (r = 0, len7 = glyphIDs.length; r < len7; r++) {
	            id = glyphIDs[r];
	            subtable.writeUInt16(id);
	          }
	          return result = {
	            charMap: charMap,
	            subtable: subtable.data,
	            maxGlyphID: nextID + 1
	          };
	      }
	    };

	    return CmapEntry;

	  })();

	  module.exports = CmapTable;

	}).call(this);


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, HmtxTable, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  HmtxTable = (function(superClass) {
	    extend(HmtxTable, superClass);

	    function HmtxTable() {
	      return HmtxTable.__super__.constructor.apply(this, arguments);
	    }

	    HmtxTable.prototype.tag = 'hmtx';

	    HmtxTable.prototype.parse = function(data) {
	      var i, j, k, last, lsbCount, m, ref, ref1, results;
	      data.pos = this.offset;
	      this.metrics = [];
	      for (i = j = 0, ref = this.file.hhea.numberOfMetrics; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        this.metrics.push({
	          advance: data.readUInt16(),
	          lsb: data.readInt16()
	        });
	      }
	      lsbCount = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics;
	      this.leftSideBearings = (function() {
	        var k, ref1, results;
	        results = [];
	        for (i = k = 0, ref1 = lsbCount; 0 <= ref1 ? k < ref1 : k > ref1; i = 0 <= ref1 ? ++k : --k) {
	          results.push(data.readInt16());
	        }
	        return results;
	      })();
	      this.widths = (function() {
	        var k, len, ref1, results;
	        ref1 = this.metrics;
	        results = [];
	        for (k = 0, len = ref1.length; k < len; k++) {
	          m = ref1[k];
	          results.push(m.advance);
	        }
	        return results;
	      }).call(this);
	      last = this.widths[this.widths.length - 1];
	      results = [];
	      for (i = k = 0, ref1 = lsbCount; 0 <= ref1 ? k < ref1 : k > ref1; i = 0 <= ref1 ? ++k : --k) {
	        results.push(this.widths.push(last));
	      }
	      return results;
	    };

	    HmtxTable.prototype.forGlyph = function(id) {
	      var metrics;
	      if (id in this.metrics) {
	        return this.metrics[id];
	      }
	      return metrics = {
	        advance: this.metrics[this.metrics.length - 1].advance,
	        lsb: this.leftSideBearings[id - this.metrics.length]
	      };
	    };

	    HmtxTable.prototype.encode = function(mapping) {
	      var id, j, len, metric, table;
	      table = new Data;
	      for (j = 0, len = mapping.length; j < len; j++) {
	        id = mapping[j];
	        metric = this.forGlyph(id);
	        table.writeUInt16(metric.advance);
	        table.writeUInt16(metric.lsb);
	      }
	      return table.data;
	    };

	    return HmtxTable;

	  })(Table);

	  module.exports = HmtxTable;

	}).call(this);


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, HheaTable, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  HheaTable = (function(superClass) {
	    extend(HheaTable, superClass);

	    function HheaTable() {
	      return HheaTable.__super__.constructor.apply(this, arguments);
	    }

	    HheaTable.prototype.tag = 'hhea';

	    HheaTable.prototype.parse = function(data) {
	      data.pos = this.offset;
	      this.version = data.readInt();
	      this.ascender = data.readShort();
	      this.decender = data.readShort();
	      this.lineGap = data.readShort();
	      this.advanceWidthMax = data.readShort();
	      this.minLeftSideBearing = data.readShort();
	      this.minRightSideBearing = data.readShort();
	      this.xMaxExtent = data.readShort();
	      this.caretSlopeRise = data.readShort();
	      this.caretSlopeRun = data.readShort();
	      this.caretOffset = data.readShort();
	      data.pos += 4 * 2;
	      this.metricDataFormat = data.readShort();
	      return this.numberOfMetrics = data.readUInt16();
	    };

	    HheaTable.prototype.encode = function(ids) {
	      var i, j, ref, table;
	      table = new Data;
	      table.writeInt(this.version);
	      table.writeShort(this.ascender);
	      table.writeShort(this.decender);
	      table.writeShort(this.lineGap);
	      table.writeShort(this.advanceWidthMax);
	      table.writeShort(this.minLeftSideBearing);
	      table.writeShort(this.minRightSideBearing);
	      table.writeShort(this.xMaxExtent);
	      table.writeShort(this.caretSlopeRise);
	      table.writeShort(this.caretSlopeRun);
	      table.writeShort(this.caretOffset);
	      for (i = j = 0, ref = 4 * 2; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        table.writeByte(0);
	      }
	      table.writeShort(this.metricDataFormat);
	      table.writeUInt16(ids.length);
	      return table.data;
	    };

	    return HheaTable;

	  })(Table);

	  module.exports = HheaTable;

	}).call(this);


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, MaxpTable, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  MaxpTable = (function(superClass) {
	    extend(MaxpTable, superClass);

	    function MaxpTable() {
	      return MaxpTable.__super__.constructor.apply(this, arguments);
	    }

	    MaxpTable.prototype.tag = 'maxp';

	    MaxpTable.prototype.parse = function(data) {
	      data.pos = this.offset;
	      this.version = data.readInt();
	      this.numGlyphs = data.readUInt16();
	      this.maxPoints = data.readUInt16();
	      this.maxContours = data.readUInt16();
	      this.maxCompositePoints = data.readUInt16();
	      this.maxComponentContours = data.readUInt16();
	      this.maxZones = data.readUInt16();
	      this.maxTwilightPoints = data.readUInt16();
	      this.maxStorage = data.readUInt16();
	      this.maxFunctionDefs = data.readUInt16();
	      this.maxInstructionDefs = data.readUInt16();
	      this.maxStackElements = data.readUInt16();
	      this.maxSizeOfInstructions = data.readUInt16();
	      this.maxComponentElements = data.readUInt16();
	      return this.maxComponentDepth = data.readUInt16();
	    };

	    MaxpTable.prototype.encode = function(ids) {
	      var table;
	      table = new Data;
	      table.writeInt(this.version);
	      table.writeUInt16(ids.length);
	      table.writeUInt16(this.maxPoints);
	      table.writeUInt16(this.maxContours);
	      table.writeUInt16(this.maxCompositePoints);
	      table.writeUInt16(this.maxComponentContours);
	      table.writeUInt16(this.maxZones);
	      table.writeUInt16(this.maxTwilightPoints);
	      table.writeUInt16(this.maxStorage);
	      table.writeUInt16(this.maxFunctionDefs);
	      table.writeUInt16(this.maxInstructionDefs);
	      table.writeUInt16(this.maxStackElements);
	      table.writeUInt16(this.maxSizeOfInstructions);
	      table.writeUInt16(this.maxComponentElements);
	      table.writeUInt16(this.maxComponentDepth);
	      return table.data;
	    };

	    return MaxpTable;

	  })(Table);

	  module.exports = MaxpTable;

	}).call(this);


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, PostTable, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  PostTable = (function(superClass) {
	    var POSTSCRIPT_GLYPHS;

	    extend(PostTable, superClass);

	    function PostTable() {
	      return PostTable.__super__.constructor.apply(this, arguments);
	    }

	    PostTable.prototype.tag = 'post';

	    PostTable.prototype.parse = function(data) {
	      var i, j, length, numberOfGlyphs, ref, results;
	      data.pos = this.offset;
	      this.format = data.readInt();
	      this.italicAngle = data.readInt();
	      this.underlinePosition = data.readShort();
	      this.underlineThickness = data.readShort();
	      this.isFixedPitch = data.readInt();
	      this.minMemType42 = data.readInt();
	      this.maxMemType42 = data.readInt();
	      this.minMemType1 = data.readInt();
	      this.maxMemType1 = data.readInt();
	      switch (this.format) {
	        case 0x00010000:
	          break;
	        case 0x00020000:
	          numberOfGlyphs = data.readUInt16();
	          this.glyphNameIndex = [];
	          for (i = j = 0, ref = numberOfGlyphs; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	            this.glyphNameIndex.push(data.readUInt16());
	          }
	          this.names = [];
	          results = [];
	          while (data.pos < this.offset + this.length) {
	            length = data.readByte();
	            results.push(this.names.push(data.readString(length)));
	          }
	          return results;
	          break;
	        case 0x00025000:
	          numberOfGlyphs = data.readUInt16();
	          return this.offsets = data.read(numberOfGlyphs);
	        case 0x00030000:
	          break;
	        case 0x00040000:
	          return this.map = (function() {
	            var k, ref1, results1;
	            results1 = [];
	            for (i = k = 0, ref1 = this.file.maxp.numGlyphs; 0 <= ref1 ? k < ref1 : k > ref1; i = 0 <= ref1 ? ++k : --k) {
	              results1.push(data.readUInt32());
	            }
	            return results1;
	          }).call(this);
	      }
	    };

	    PostTable.prototype.glyphFor = function(code) {
	      var index;
	      switch (this.format) {
	        case 0x00010000:
	          return POSTSCRIPT_GLYPHS[code] || '.notdef';
	        case 0x00020000:
	          index = this.glyphNameIndex[code];
	          if (index <= 257) {
	            return POSTSCRIPT_GLYPHS[index];
	          } else {
	            return this.names[index - 258] || '.notdef';
	          }
	          break;
	        case 0x00025000:
	          return POSTSCRIPT_GLYPHS[code + this.offsets[code]] || '.notdef';
	        case 0x00030000:
	          return '.notdef';
	        case 0x00040000:
	          return this.map[code] || 0xFFFF;
	      }
	    };

	    PostTable.prototype.encode = function(mapping) {
	      var id, index, indexes, j, k, l, len, len1, len2, position, post, raw, string, strings, table;
	      if (!this.exists) {
	        return null;
	      }
	      raw = this.raw();
	      if (this.format === 0x00030000) {
	        return raw;
	      }
	      table = new Data(raw.slice(0, 32));
	      table.writeUInt32(0x00020000);
	      table.pos = 32;
	      indexes = [];
	      strings = [];
	      for (j = 0, len = mapping.length; j < len; j++) {
	        id = mapping[j];
	        post = this.glyphFor(id);
	        position = POSTSCRIPT_GLYPHS.indexOf(post);
	        if (position !== -1) {
	          indexes.push(position);
	        } else {
	          indexes.push(257 + strings.length);
	          strings.push(post);
	        }
	      }
	      table.writeUInt16(Object.keys(mapping).length);
	      for (k = 0, len1 = indexes.length; k < len1; k++) {
	        index = indexes[k];
	        table.writeUInt16(index);
	      }
	      for (l = 0, len2 = strings.length; l < len2; l++) {
	        string = strings[l];
	        table.writeByte(string.length);
	        table.writeString(string);
	      }
	      return table.data;
	    };

	    POSTSCRIPT_GLYPHS = '.notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent\nampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash\nzero one two three four five six seven eight nine colon semicolon less equal greater\nquestion at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z\nbracketleft backslash bracketright asciicircum underscore grave\na b c d e f g h i j k l m n o p q r s t u v w x y z\nbraceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis\nUdieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave\necircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve\nocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent\nsterling section bullet paragraph germandbls registered copyright trademark acute\ndieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu\npartialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash\nquestiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft\nguillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash\nquotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis\nfraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered\nquotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis\nEgrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute\nUcircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla\nhungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth\neth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior\nonehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla\nCacute cacute Ccaron ccaron dcroat'.split(/\s+/g);

	    return PostTable;

	  })(Table);

	  module.exports = PostTable;

	}).call(this);


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var OS2Table, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  OS2Table = (function(superClass) {
	    extend(OS2Table, superClass);

	    function OS2Table() {
	      return OS2Table.__super__.constructor.apply(this, arguments);
	    }

	    OS2Table.prototype.tag = 'OS/2';

	    OS2Table.prototype.parse = function(data) {
	      var i;
	      data.pos = this.offset;
	      this.version = data.readUInt16();
	      this.averageCharWidth = data.readShort();
	      this.weightClass = data.readUInt16();
	      this.widthClass = data.readUInt16();
	      this.type = data.readShort();
	      this.ySubscriptXSize = data.readShort();
	      this.ySubscriptYSize = data.readShort();
	      this.ySubscriptXOffset = data.readShort();
	      this.ySubscriptYOffset = data.readShort();
	      this.ySuperscriptXSize = data.readShort();
	      this.ySuperscriptYSize = data.readShort();
	      this.ySuperscriptXOffset = data.readShort();
	      this.ySuperscriptYOffset = data.readShort();
	      this.yStrikeoutSize = data.readShort();
	      this.yStrikeoutPosition = data.readShort();
	      this.familyClass = data.readShort();
	      this.panose = (function() {
	        var j, results;
	        results = [];
	        for (i = j = 0; j < 10; i = ++j) {
	          results.push(data.readByte());
	        }
	        return results;
	      })();
	      this.charRange = (function() {
	        var j, results;
	        results = [];
	        for (i = j = 0; j < 4; i = ++j) {
	          results.push(data.readInt());
	        }
	        return results;
	      })();
	      this.vendorID = data.readString(4);
	      this.selection = data.readShort();
	      this.firstCharIndex = data.readShort();
	      this.lastCharIndex = data.readShort();
	      if (this.version > 0) {
	        this.ascent = data.readShort();
	        this.descent = data.readShort();
	        this.lineGap = data.readShort();
	        this.winAscent = data.readShort();
	        this.winDescent = data.readShort();
	        this.codePageRange = (function() {
	          var j, results;
	          results = [];
	          for (i = j = 0; j < 2; i = ++j) {
	            results.push(data.readInt());
	          }
	          return results;
	        })();
	        if (this.version > 1) {
	          this.xHeight = data.readShort();
	          this.capHeight = data.readShort();
	          this.defaultChar = data.readShort();
	          this.breakChar = data.readShort();
	          return this.maxContext = data.readShort();
	        }
	      }
	    };

	    OS2Table.prototype.encode = function() {
	      return this.raw();
	    };

	    return OS2Table;

	  })(Table);

	  module.exports = OS2Table;

	}).call(this);


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var Data, LocaTable, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  LocaTable = (function(superClass) {
	    extend(LocaTable, superClass);

	    function LocaTable() {
	      return LocaTable.__super__.constructor.apply(this, arguments);
	    }

	    LocaTable.prototype.tag = 'loca';

	    LocaTable.prototype.parse = function(data) {
	      var format, i;
	      data.pos = this.offset;
	      format = this.file.head.indexToLocFormat;
	      if (format === 0) {
	        return this.offsets = (function() {
	          var j, ref, results;
	          results = [];
	          for (i = j = 0, ref = this.length; j < ref; i = j += 2) {
	            results.push(data.readUInt16() * 2);
	          }
	          return results;
	        }).call(this);
	      } else {
	        return this.offsets = (function() {
	          var j, ref, results;
	          results = [];
	          for (i = j = 0, ref = this.length; j < ref; i = j += 4) {
	            results.push(data.readUInt32());
	          }
	          return results;
	        }).call(this);
	      }
	    };

	    LocaTable.prototype.indexOf = function(id) {
	      return this.offsets[id];
	    };

	    LocaTable.prototype.lengthOf = function(id) {
	      return this.offsets[id + 1] - this.offsets[id];
	    };

	    LocaTable.prototype.encode = function(offsets) {
	      var j, k, l, len, len1, len2, o, offset, ref, ret, table;
	      table = new Data;
	      for (j = 0, len = offsets.length; j < len; j++) {
	        offset = offsets[j];
	        if (!(offset > 0xFFFF)) {
	          continue;
	        }
	        ref = this.offsets;
	        for (k = 0, len1 = ref.length; k < len1; k++) {
	          o = ref[k];
	          table.writeUInt32(o);
	        }
	        return ret = {
	          format: 1,
	          table: table.data
	        };
	      }
	      for (l = 0, len2 = offsets.length; l < len2; l++) {
	        o = offsets[l];
	        table.writeUInt16(o / 2);
	      }
	      return ret = {
	        format: 0,
	        table: table.data
	      };
	    };

	    return LocaTable;

	  })(Table);

	  module.exports = LocaTable;

	}).call(this);


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var CompoundGlyph, Data, GlyfTable, SimpleGlyph, Table,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty,
	    slice = [].slice;

	  Table = __webpack_require__(201);

	  Data = __webpack_require__(197);

	  GlyfTable = (function(superClass) {
	    extend(GlyfTable, superClass);

	    function GlyfTable() {
	      return GlyfTable.__super__.constructor.apply(this, arguments);
	    }

	    GlyfTable.prototype.tag = 'glyf';

	    GlyfTable.prototype.parse = function(data) {
	      return this.cache = {};
	    };

	    GlyfTable.prototype.glyphFor = function(id) {
	      var data, index, length, loca, numberOfContours, raw, xMax, xMin, yMax, yMin;
	      if (id in this.cache) {
	        return this.cache[id];
	      }
	      loca = this.file.loca;
	      data = this.file.contents;
	      index = loca.indexOf(id);
	      length = loca.lengthOf(id);
	      if (length === 0) {
	        return this.cache[id] = null;
	      }
	      data.pos = this.offset + index;
	      raw = new Data(data.read(length));
	      numberOfContours = raw.readShort();
	      xMin = raw.readShort();
	      yMin = raw.readShort();
	      xMax = raw.readShort();
	      yMax = raw.readShort();
	      if (numberOfContours === -1) {
	        this.cache[id] = new CompoundGlyph(raw, xMin, yMin, xMax, yMax);
	      } else {
	        this.cache[id] = new SimpleGlyph(raw, numberOfContours, xMin, yMin, xMax, yMax);
	      }
	      return this.cache[id];
	    };

	    GlyfTable.prototype.encode = function(glyphs, mapping, old2new) {
	      var glyph, id, j, len, offsets, table;
	      table = [];
	      offsets = [];
	      for (j = 0, len = mapping.length; j < len; j++) {
	        id = mapping[j];
	        glyph = glyphs[id];
	        offsets.push(table.length);
	        if (glyph) {
	          table = table.concat(glyph.encode(old2new));
	        }
	      }
	      offsets.push(table.length);
	      return {
	        table: table,
	        offsets: offsets
	      };
	    };

	    return GlyfTable;

	  })(Table);

	  SimpleGlyph = (function() {
	    function SimpleGlyph(raw1, numberOfContours1, xMin1, yMin1, xMax1, yMax1) {
	      this.raw = raw1;
	      this.numberOfContours = numberOfContours1;
	      this.xMin = xMin1;
	      this.yMin = yMin1;
	      this.xMax = xMax1;
	      this.yMax = yMax1;
	      this.compound = false;
	    }

	    SimpleGlyph.prototype.encode = function() {
	      return this.raw.data;
	    };

	    return SimpleGlyph;

	  })();

	  CompoundGlyph = (function() {
	    var ARG_1_AND_2_ARE_WORDS, MORE_COMPONENTS, WE_HAVE_AN_X_AND_Y_SCALE, WE_HAVE_A_SCALE, WE_HAVE_A_TWO_BY_TWO, WE_HAVE_INSTRUCTIONS;

	    ARG_1_AND_2_ARE_WORDS = 0x0001;

	    WE_HAVE_A_SCALE = 0x0008;

	    MORE_COMPONENTS = 0x0020;

	    WE_HAVE_AN_X_AND_Y_SCALE = 0x0040;

	    WE_HAVE_A_TWO_BY_TWO = 0x0080;

	    WE_HAVE_INSTRUCTIONS = 0x0100;

	    function CompoundGlyph(raw1, xMin1, yMin1, xMax1, yMax1) {
	      var data, flags;
	      this.raw = raw1;
	      this.xMin = xMin1;
	      this.yMin = yMin1;
	      this.xMax = xMax1;
	      this.yMax = yMax1;
	      this.compound = true;
	      this.glyphIDs = [];
	      this.glyphOffsets = [];
	      data = this.raw;
	      while (true) {
	        flags = data.readShort();
	        this.glyphOffsets.push(data.pos);
	        this.glyphIDs.push(data.readShort());
	        if (!(flags & MORE_COMPONENTS)) {
	          break;
	        }
	        if (flags & ARG_1_AND_2_ARE_WORDS) {
	          data.pos += 4;
	        } else {
	          data.pos += 2;
	        }
	        if (flags & WE_HAVE_A_TWO_BY_TWO) {
	          data.pos += 8;
	        } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
	          data.pos += 4;
	        } else if (flags & WE_HAVE_A_SCALE) {
	          data.pos += 2;
	        }
	      }
	    }

	    CompoundGlyph.prototype.encode = function(mapping) {
	      var i, id, j, len, ref, result;
	      result = new Data(slice.call(this.raw.data));
	      ref = this.glyphIDs;
	      for (i = j = 0, len = ref.length; j < len; i = ++j) {
	        id = ref[i];
	        result.pos = this.glyphOffsets[i];
	        result.writeShort(mapping[id]);
	      }
	      return result.data;
	    };

	    return CompoundGlyph;

	  })();

	  module.exports = GlyfTable;

	}).call(this);


/***/ },
/* 212 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var AFMFont, fs;

	  // fs = require('fs');

	  AFMFont = (function() {
	    var WIN_ANSI_MAP, characters;

	    // AFMFont.open = function(filename) {
	    //   return new AFMFont(fs.readFileSync(filename, 'utf8'));
	    // };

	    function AFMFont(contents) {
	      var e, i;
	      this.contents = contents;
	      this.attributes = {};
	      this.glyphWidths = {};
	      this.boundingBoxes = {};
	      this.parse();
	      this.charWidths = (function() {
	        var j, results;
	        results = [];
	        for (i = j = 0; j <= 255; i = ++j) {
	          results.push(this.glyphWidths[characters[i]]);
	        }
	        return results;
	      }).call(this);
	      this.bbox = (function() {
	        var j, len, ref, results;
	        ref = this.attributes['FontBBox'].split(/\s+/);
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          e = ref[j];
	          results.push(+e);
	        }
	        return results;
	      }).call(this);
	      this.ascender = +(this.attributes['Ascender'] || 0);
	      this.decender = +(this.attributes['Descender'] || 0);
	      this.lineGap = (this.bbox[3] - this.bbox[1]) - (this.ascender - this.decender);
	    }

	    AFMFont.prototype.parse = function() {
	      var a, j, key, len, line, match, name, ref, section, value;
	      section = '';
	      ref = this.contents.split('\n');
	      for (j = 0, len = ref.length; j < len; j++) {
	        line = ref[j];
	        if (match = line.match(/^Start(\w+)/)) {
	          section = match[1];
	          continue;
	        } else if (match = line.match(/^End(\w+)/)) {
	          section = '';
	          continue;
	        }
	        switch (section) {
	          case 'FontMetrics':
	            match = line.match(/(^\w+)\s+(.*)/);
	            key = match[1];
	            value = match[2];
	            if (a = this.attributes[key]) {
	              if (!Array.isArray(a)) {
	                a = this.attributes[key] = [a];
	              }
	              a.push(value);
	            } else {
	              this.attributes[key] = value;
	            }
	            break;
	          case 'CharMetrics':
	            if (!/^CH?\s/.test(line)) {
	              continue;
	            }
	            name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
	            this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
	        }
	      }
	    };

	    WIN_ANSI_MAP = {
	      402: 131,
	      8211: 150,
	      8212: 151,
	      8216: 145,
	      8217: 146,
	      8218: 130,
	      8220: 147,
	      8221: 148,
	      8222: 132,
	      8224: 134,
	      8225: 135,
	      8226: 149,
	      8230: 133,
	      8364: 128,
	      8240: 137,
	      8249: 139,
	      8250: 155,
	      710: 136,
	      8482: 153,
	      338: 140,
	      339: 156,
	      732: 152,
	      352: 138,
	      353: 154,
	      376: 159,
	      381: 142,
	      382: 158
	    };

	    AFMFont.prototype.encodeText = function(text) {
	      var chr, i, j, ref, str;
	      str = '';
	      for (i = j = 0, ref = text.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        chr = text.charCodeAt(i);
	        chr = WIN_ANSI_MAP[chr] || chr;
	        str += String.fromCharCode(chr);
	      }
	      return str;
	    };

	    AFMFont.prototype.characterToGlyph = function(character) {
	      return characters[WIN_ANSI_MAP[character] || character];
	    };

	    AFMFont.prototype.widthOfGlyph = function(glyph) {
	      return this.glyphWidths[glyph];
	    };

	    characters = '.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis'.split(/\s+/);

	    return AFMFont;

	  })();

	  module.exports = AFMFont;

	}).call(this);


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	(function() {
	  var CmapTable, Subset, utils,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	  CmapTable = __webpack_require__(204);

	  utils = __webpack_require__(202);

	  Subset = (function() {
	    function Subset(font) {
	      this.font = font;
	      this.subset = {};
	      this.unicodes = {};
	      this.next = 33;
	    }

	    Subset.prototype.use = function(character) {
	      var i, j, ref;
	      if (typeof character === 'string') {
	        for (i = j = 0, ref = character.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	          this.use(character.charCodeAt(i));
	        }
	        return;
	      }
	      if (!this.unicodes[character]) {
	        this.subset[this.next] = character;
	        return this.unicodes[character] = this.next++;
	      }
	    };

	    Subset.prototype.encodeText = function(text) {
	      var chr, i, j, ref, str;
	      str = '';
	      for (i = j = 0, ref = text.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        chr = this.unicodes[text.charCodeAt(i)];
	        str += String.fromCharCode(chr);
	      }
	      return str;
	    };

	    Subset.prototype.generateCmap = function() {
	      var mapping, ref, roman, unicode, unicodeCmap;
	      unicodeCmap = this.font.cmap.tables[0].codeMap;
	      mapping = {};
	      ref = this.subset;
	      for (roman in ref) {
	        unicode = ref[roman];
	        mapping[roman] = unicodeCmap[unicode];
	      }
	      return mapping;
	    };

	    Subset.prototype.glyphIDs = function() {
	      var ref, ret, roman, unicode, unicodeCmap, val;
	      unicodeCmap = this.font.cmap.tables[0].codeMap;
	      ret = [0];
	      ref = this.subset;
	      for (roman in ref) {
	        unicode = ref[roman];
	        val = unicodeCmap[unicode];
	        if ((val != null) && indexOf.call(ret, val) < 0) {
	          ret.push(val);
	        }
	      }
	      return ret.sort();
	    };

	    Subset.prototype.glyphsFor = function(glyphIDs) {
	      var additionalIDs, glyph, glyphs, id, j, len, ref;
	      glyphs = {};
	      for (j = 0, len = glyphIDs.length; j < len; j++) {
	        id = glyphIDs[j];
	        glyphs[id] = this.font.glyf.glyphFor(id);
	      }
	      additionalIDs = [];
	      for (id in glyphs) {
	        glyph = glyphs[id];
	        if (glyph != null ? glyph.compound : void 0) {
	          additionalIDs.push.apply(additionalIDs, glyph.glyphIDs);
	        }
	      }
	      if (additionalIDs.length > 0) {
	        ref = this.glyphsFor(additionalIDs);
	        for (id in ref) {
	          glyph = ref[id];
	          glyphs[id] = glyph;
	        }
	      }
	      return glyphs;
	    };

	    Subset.prototype.encode = function() {
	      var cmap, code, glyf, glyphs, id, ids, loca, name, new2old, newIDs, nextGlyphID, old2new, oldID, oldIDs, ref, ref1, tables;
	      cmap = CmapTable.encode(this.generateCmap(), 'unicode');
	      glyphs = this.glyphsFor(this.glyphIDs());
	      old2new = {
	        0: 0
	      };
	      ref = cmap.charMap;
	      for (code in ref) {
	        ids = ref[code];
	        old2new[ids.old] = ids["new"];
	      }
	      nextGlyphID = cmap.maxGlyphID;
	      for (oldID in glyphs) {
	        if (!(oldID in old2new)) {
	          old2new[oldID] = nextGlyphID++;
	        }
	      }
	      new2old = utils.invert(old2new);
	      newIDs = Object.keys(new2old).sort(function(a, b) {
	        return a - b;
	      });
	      oldIDs = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = newIDs.length; j < len; j++) {
	          id = newIDs[j];
	          results.push(new2old[id]);
	        }
	        return results;
	      })();
	      glyf = this.font.glyf.encode(glyphs, oldIDs, old2new);
	      loca = this.font.loca.encode(glyf.offsets);
	      name = this.font.name.encode();
	      this.postscriptName = name.postscriptName;
	      this.cmap = {};
	      ref1 = cmap.charMap;
	      for (code in ref1) {
	        ids = ref1[code];
	        this.cmap[code] = ids.old;
	      }
	      tables = {
	        cmap: cmap.table,
	        glyf: glyf.table,
	        loca: loca.table,
	        hmtx: this.font.hmtx.encode(oldIDs),
	        hhea: this.font.hhea.encode(oldIDs),
	        maxp: this.font.maxp.encode(oldIDs),
	        post: this.font.post.encode(oldIDs),
	        name: name.table,
	        head: this.font.head.encode(loca)
	      };
	      if (this.font.os2.exists) {
	        tables['OS/2'] = this.font.os2.raw();
	      }
	      return this.font.directory.encode(tables);
	    };

	    return Subset;

	  })();

	  module.exports = Subset;

	}).call(this);


/***/ },
/* 214 */
/***/ function(module, exports) {

	module.exports = function(jsPDF) {

	(function (jsPDFAPI) {
		'use strict';

		jsPDFAPI.autoPrint = function () {
			'use strict'
			var refAutoPrintTag;

			this.internal.events.subscribe('postPutResources', function () {
				refAutoPrintTag = this.internal.newObject()
					this.internal.write("<< /S/Named /Type/Action /N/Print >>", "endobj");
			});

			this.internal.events.subscribe("putCatalog", function () {
				this.internal.write("/OpenAction " + refAutoPrintTag + " 0" + " R");
			});
			return this;
		};
	})(jsPDF.API);

	};

/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/** @preserve
	 * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
	 * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
	 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
	 *               2014 Diego Casorran, https://github.com/diegocr
	 *               2014 Daniel Husar, https://github.com/danielhusar
	 *               2014 Wolfgang Gassler, https://github.com/woolfg
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
	 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
	 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 * ====================================================================
	 */
	module.exports = function (jsPDF, $, ditto) {

	    (function (jsPDFAPI) {
	        var clone,
	            DrillForContent,
	            FontNameDB,
	            FontStyleMap,
	            TextAlignMap,
	            FontWeightMap,
	            FloatMap,
	            ClearMap,
	            GetCSS,
	            PurgeWhiteSpace,
	            Renderer,
	            ResolveFont,
	            ResolveUnitedNumber,
	            UnitedNumberMap,
	            elementHandledElsewhere,
	            images,
	            loadImgs,
	            checkForFooter,
	            process,
	            tableToJson,
	            pageHeader,
	            pageFooter,
	            pageHeaderHeight = 0,
	            pageFooterHeight = 0,
	            pageBackground,
	            CssLengthToPx,
	            fontOverrides = {},
	            usedFontKeys = {},
	            repeatingHeaderStack = [],
	            lastDepth = 0;
	        var allAsciiRegEx = /^[\000-\177]*$/;
	        clone = function () {
	            return function (obj) {
	                Clone.prototype = obj;
	                return new Clone();
	            };

	            function Clone() {}
	        }();
	        PurgeWhiteSpace = function PurgeWhiteSpace(array) {
	            var fragment, i, l, lTrimmed, r, rTrimmed, trailingSpace;
	            i = 0;
	            l = array.length;
	            fragment = void 0;
	            lTrimmed = false;
	            rTrimmed = false;
	            while (!lTrimmed && i !== l) {
	                fragment = array[i] = array[i].trimLeft();
	                if (fragment) {
	                    lTrimmed = true;
	                }
	                i++;
	            }
	            i = l - 1;
	            while (l && !rTrimmed && i !== -1) {
	                fragment = array[i] = array[i].trimRight();
	                if (fragment) {
	                    rTrimmed = true;
	                }
	                i--;
	            }
	            r = /\s+$/g;
	            trailingSpace = true;
	            i = 0;
	            while (i !== l) {
	                fragment = array[i].replace(/\s+/g, " ");
	                if (trailingSpace) {
	                    fragment = fragment.trimLeft();
	                }
	                if (fragment) {
	                    trailingSpace = r.test(fragment);
	                }
	                array[i] = fragment;
	                i++;
	            }
	            return array;
	        };
	        Renderer = function Renderer(pdf, x, y, settings) {
	            this.pdf = pdf;
	            this.x = x;
	            this.y = y;
	            this.settings = settings;
	            //list of functions which are called after each element-rendering process
	            this.watchFunctions = [];
	            this.usedImagesBySrc = {};
	            this.init();
	            return this;
	        };
	        ResolveFont = function ResolveFont(css_font_family_string) {
	            var name, part, parts;
	            name = void 0;
	            parts = css_font_family_string.split(',');
	            part = parts.shift();
	            while (!name && part) {
	                var key = part.trim().toLowerCase().replace(/["']/g, '');
	                name = FontNameDB[key];
	                part = parts.shift();
	            }
	            return fontOverrides[name] || name;
	        };
	        CssLengthToPx = function CssLengthToPx(cssStr) {
	            if (cssStr.indexOf("em") > -1 && !isNaN(Number(cssStr.replace("em", "")))) {
	                cssStr = Number(cssStr.replace("em", "")) * 18.719 + "px";
	            }
	            if (cssStr.indexOf("pt") > -1 && !isNaN(Number(cssStr.replace("pt", "")))) {
	                cssStr = Number(cssStr.replace("pt", "")) * 1.333 + "px";
	            }
	            return cssStr;
	        };
	        ResolveUnitedNumber = function ResolveUnitedNumber(css_line_height_string) {
	            css_line_height_string = CssLengthToPx(css_line_height_string);

	            //IE8 issues
	            css_line_height_string = css_line_height_string === "auto" ? "0px" : css_line_height_string;

	            var normal, undef, value;
	            undef = void 0;
	            normal = 16.00;
	            value = UnitedNumberMap[css_line_height_string];
	            if (value) {
	                return value;
	            }
	            value = {
	                "xx-small": 9,
	                "x-small": 11,
	                small: 13,
	                medium: 16,
	                large: 19,
	                "x-large": 23,
	                "xx-large": 28,
	                auto: 0
	            }[{
	                css_line_height_string: css_line_height_string
	            }];

	            if (value !== undef) {
	                return UnitedNumberMap[css_line_height_string] = value / normal;
	            }
	            if (value = parseFloat(css_line_height_string)) {
	                return UnitedNumberMap[css_line_height_string] = value / normal;
	            }
	            value = css_line_height_string.match(/([\d\.]+)(px)/);
	            if (value && value.length === 3) {
	                return UnitedNumberMap[css_line_height_string] = parseFloat(value[1]) / normal;
	            }
	            return UnitedNumberMap[css_line_height_string] = 1;
	        };
	        GetCSS = function GetCSS(element) {
	            var css, tmp, computedCSSElement;
	            computedCSSElement = function (el) {
	                var compCSS;
	                compCSS = function (el) {
	                    if (document.defaultView && document.defaultView.getComputedStyle) {
	                        return document.defaultView.getComputedStyle(el, null);
	                    } else if (el.currentStyle) {
	                        return el.currentStyle;
	                    } else {
	                        return el.style;
	                    }
	                }(el);
	                return function (prop) {
	                    prop = prop.replace(/-\D/g, function (match) {
	                        return match.charAt(1).toUpperCase();
	                    });
	                    return compCSS[prop];
	                };
	            }(element);
	            css = {};
	            tmp = void 0;
	            css["font-family"] = ResolveFont(computedCSSElement("font-family")) || "times";
	            css["font-style"] = FontStyleMap[computedCSSElement("font-style")] || "normal";
	            css["text-align"] = TextAlignMap[computedCSSElement("text-align")] || "left";
	            tmp = FontWeightMap[computedCSSElement("font-weight")] || "normal";
	            if (tmp === "bold") {
	                if (css["font-style"] === "normal") {
	                    css["font-style"] = tmp;
	                } else {
	                    css["font-style"] = tmp + css["font-style"];
	                }
	            }
	            css["font-size"] = ResolveUnitedNumber(computedCSSElement("font-size")) || 1;
	            var lineHeightCSS = computedCSSElement("line-height");
	            css["line-height"] = lineHeightCSS === 'normal' ? 1.2 : ResolveUnitedNumber(lineHeightCSS);
	            css["display"] = computedCSSElement("display") === "inline" ? "inline" : "block";
	            if (css["display"] === "block") {
	                css["margin-top"] = ResolveUnitedNumber(computedCSSElement("margin-top")) || 0;
	                css["margin-bottom"] = ResolveUnitedNumber(computedCSSElement("margin-bottom")) || 0;
	                css["padding-top"] = ResolveUnitedNumber(computedCSSElement("padding-top")) || 0;
	                css["padding-bottom"] = ResolveUnitedNumber(computedCSSElement("padding-bottom")) || 0;
	                css["margin-left"] = ResolveUnitedNumber(computedCSSElement("margin-left")) || 0;
	                css["margin-right"] = ResolveUnitedNumber(computedCSSElement("margin-right")) || 0;
	                css["padding-left"] = ResolveUnitedNumber(computedCSSElement("padding-left")) || 0;
	                css["padding-right"] = ResolveUnitedNumber(computedCSSElement("padding-right")) || 0;
	            }
	            //float and clearing of floats
	            css["float"] = FloatMap[computedCSSElement("cssFloat")] || "none";
	            css["clear"] = ClearMap[computedCSSElement("clear")] || "none";
	            css['text-decoration'] = computedCSSElement('text-decoration');
	            css['background-color'] = computedCSSElement('background-color');
	            css['color'] = computedCSSElement('color');
	            css['white-space'] = computedCSSElement('white-space');
	            return css;
	        };
	        elementHandledElsewhere = function elementHandledElsewhere(element, renderer, elementHandlers) {
	            var handlers, i, isHandledElsewhere, l, t;
	            isHandledElsewhere = false;
	            i = void 0;
	            l = void 0;
	            t = void 0;
	            handlers = elementHandlers["#" + element.id];
	            if (handlers) {
	                if (typeof handlers === "function") {
	                    isHandledElsewhere = handlers(element, renderer);
	                } else {
	                    i = 0;
	                    l = handlers.length;
	                    while (!isHandledElsewhere && i !== l) {
	                        isHandledElsewhere = handlers[i](element, renderer);
	                        i++;
	                    }
	                }
	            }
	            handlers = elementHandlers[element.nodeName];
	            if (!isHandledElsewhere && handlers) {
	                if (typeof handlers === "function") {
	                    isHandledElsewhere = handlers(element, renderer);
	                } else {
	                    i = 0;
	                    l = handlers.length;
	                    while (!isHandledElsewhere && i !== l) {
	                        isHandledElsewhere = handlers[i](element, renderer);
	                        i++;
	                    }
	                }
	            }
	            return isHandledElsewhere;
	        };
	        tableToJson = function tableToJson(table, renderer) {
	            var data, headers, i, j, rowData, tableRow, table_obj, table_with, cell, l;
	            data = [];
	            headers = [];
	            i = 0;
	            l = table.rows[0].cells.length;
	            table_with = table.clientWidth;
	            while (i < l) {
	                cell = table.rows[0].cells[i];
	                headers[i] = {
	                    name: cell.textContent.toLowerCase().replace(/\s+/g, ''),
	                    prompt: cell.textContent.replace(/\r?\n/g, ''),
	                    width: cell.clientWidth / table_with * renderer.pdf.internal.pageSize.width
	                };
	                i++;
	            }
	            i = 1;
	            while (i < table.rows.length) {
	                tableRow = table.rows[i];
	                rowData = {};
	                j = 0;
	                while (j < tableRow.cells.length) {
	                    rowData[headers[j].name] = tableRow.cells[j].textContent.replace(/\r?\n/g, '');
	                    j++;
	                }
	                data.push(rowData);
	                i++;
	            }
	            return table_obj = {
	                rows: data,
	                headers: headers
	            };
	        };
	        var SkipNode = {
	            SCRIPT: 1,
	            STYLE: 1,
	            NOSCRIPT: 1,
	            OBJECT: 1,
	            EMBED: 1,
	            SELECT: 1
	        };
	        var listCount = 1;

	        function hexToRgb(hex) {
	            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	            return result ? {
	                r: parseInt(result[1], 16),
	                g: parseInt(result[2], 16),
	                b: parseInt(result[3], 16)
	            } : null;
	        }

	        function extractCSSColorRGB(cssColorText) {
	            if (!cssColorText) {
	                return null;
	            }
	            if (cssColorText.indexOf("rgb") >= 0) {
	                var rgb_values = cssColorText.match(/^rgb(a)?\((\d+),\s*(\d+),\s*(\d+)(,\s*(\d+))?\)$/);
	                // Ignore transparency for now
	                if (rgb_values[1] === "a") {
	                    if (parseInt(rgb_values[6], 10) === 0) {
	                        return null;
	                    }
	                }
	                return {
	                    r: parseInt(rgb_values[2], 10),
	                    g: parseInt(rgb_values[3], 10),
	                    b: parseInt(rgb_values[4], 10)
	                };
	            }
	            return hexToRgb(cssColorText);
	        }

	        function RenderElement(cn, renderer, elementHandlers, offsetTopPx, offsetLeftPx) {
	            offsetTopPx = offsetTopPx || 0;
	            offsetLeftPx = offsetLeftPx || 0;
	            if ((typeof cn === 'undefined' ? 'undefined' : _typeof(cn)) === "object") {

	                //execute all watcher functions to e.g. reset floating
	                renderer.executeWatchFunctions(cn);

	                // /*** HEADER rendering **/
	                // if (cn.nodeType === 1 && cn.nodeName === 'HEADER') {
	                //     var header = cn;
	                //     //store old top margin
	                //     var oldMarginTop = renderer.pdf.margins_doc.top;
	                //     //subscribe for new page event and render header first on every page
	                //     renderer.pdf.internal.events.subscribe('addPage', function(pageInfo) {
	                //         //set current y position to old margin
	                //         renderer.y = oldMarginTop;
	                //         //render all child nodes of the header element
	                //         DrillForContent(header, renderer, elementHandlers);
	                //         //set margin to old margin + rendered header + 10 space to prevent overlapping
	                //         //important for other plugins (e.g. table) to start rendering at correct position after header
	                //         renderer.pdf.margins_doc.top = renderer.y + 10;
	                //         renderer.y += 10;
	                //     }, false);
	                // }

	                if (cn.nodeType === 8 && cn.nodeName === "#comment") {
	                    // if (~cn.textContent.indexOf("ADD_PAGE")) {
	                    //     renderer.pdf.addPage();
	                    //     renderer.y = renderer.pdf.margins_doc.top;
	                    // }

	                } else if (cn.nodeType === 1 && !SkipNode[cn.nodeName]) {
	                    /*** IMAGE RENDERING ***/
	                    if (cn.className.indexOf("jsr-image") > -1) {
	                        var src = $(cn).data("image-url");
	                        if (images[src]) {
	                            var imagesCSS = GetCSS(cn),
	                                img = images[src],
	                                $img = $(cn),
	                                imgPos = {
	                                top: offsetTopPx + cn.offsetTop - renderer.offsetInSectionPx,
	                                left: offsetLeftPx + cn.offsetLeft
	                            };
	                            var imageX = imgPos.left * renderer.settings.x_scale_factor;
	                            // set image width to defined width, height to keep natural aspect ratio, limited
	                            // to defined height (will scale down beyond that)
	                            var outImageHeight = Math.min($img.height() * renderer.settings.x_scale_factor, img.height / img.width * $img.width() * renderer.settings.x_scale_factor);

	                            if (renderer.usedImagesBySrc[src]) {
	                                // we've already added this image to the PDF; reference it by alias
	                                renderer.pdf.addImage(images[src], imageX, (renderer.y + imgPos.top) * renderer.settings.x_scale_factor, $img.width() * renderer.settings.x_scale_factor, outImageHeight, src);
	                            } else {
	                                renderer.pdf.addImage(images[src], imageX, (renderer.y + imgPos.top) * renderer.settings.x_scale_factor, $img.width() * renderer.settings.x_scale_factor, outImageHeight);
	                                renderer.usedImagesBySrc[src] = true;
	                            }
	                        }
	                    } else {
	                        if (!elementHandledElsewhere(cn, renderer, elementHandlers)) {
	                            var $cn = $(cn);
	                            // if ($cn.hasClass("jsr-text")) {
	                            //     renderText.call(this, $cn, renderer, { top: offsetTopPx, left: offsetLeftPx });
	                            if ($cn.hasClass('jsr-page-header') || $cn.hasClass("jsr-page-footer") || $cn.hasClass("jsr-page-background")) {
	                                // DO NOTHING - prevent drill-down into this
	                            } else if ($cn.hasClass("jsr-section")) {
	                                renderSection.call(this, $cn, renderer, elementHandlers);
	                            } else if ($(cn).hasClass("jsr-chart")) {
	                                // Charts (new)
	                                var svgDomEl = $(cn).find('svg')[0],
	                                    pos = {
	                                    top: offsetTopPx + cn.offsetTop - renderer.offsetInSectionPx,
	                                    left: offsetLeftPx + cn.offsetLeft
	                                },
	                                    x = pos.left * renderer.settings.x_scale_factor,
	                                    y = (renderer.y + pos.top) * renderer.settings.x_scale_factor,
	                                    width = $(cn).width() * renderer.settings.x_scale_factor,
	                                    height = $(cn).height() * renderer.settings.x_scale_factor,
	                                    imgData = ditto.svgToDataUri(svgDomEl, $(cn).width(), $(cn).height(), 'jpg');
	                                renderer.pdf.addImage(imgData, 'jpeg', x, y, width, height);
	                            } else if ($(cn).hasClass("jsr-box")) {
	                                var $boxEl = $(cn),
	                                    pos = {
	                                    top: offsetTopPx + cn.offsetTop - renderer.offsetInSectionPx,
	                                    left: offsetLeftPx + cn.offsetLeft
	                                },
	                                    x = pos.left * renderer.settings.x_scale_factor,
	                                    y = (renderer.y + pos.top) * renderer.settings.x_scale_factor,
	                                    width = $boxEl.outerWidth() * renderer.settings.x_scale_factor,
	                                    height = $boxEl.outerHeight() * renderer.settings.x_scale_factor,
	                                    borderColor = extractCSSColorRGB($boxEl.css("border-color")),
	                                    backColor = extractCSSColorRGB($boxEl.css("background-color")) || { r: 255, g: 255, b: 255 };
	                                if (borderColor) {
	                                    renderer.pdf.setDrawColor(borderColor.r, borderColor.g, borderColor.b);
	                                }
	                                var borderThicknessStr = $boxEl.css("border-width") || '1pt';
	                                var borderThicknessPts = parseFloat(borderThicknessStr);
	                                if (borderThicknessStr.indexOf('pt') < 0) {
	                                    // Assume px if not pt
	                                    borderThicknessPts *= renderer.settings.x_scale_factor;
	                                }
	                                renderer.pdf.setLineWidth(borderThicknessPts);
	                                renderer.pdf.setFillColor(backColor.r, backColor.g, backColor.b);
	                                var cssRadius = $boxEl.css("border-radius"),
	                                    radiusPx = 0;
	                                if (cssRadius) {
	                                    radiusPx = parseInt(cssRadius, 10);
	                                }
	                                if (radiusPx > 0) {
	                                    var radiusPdfUnits = radiusPx * renderer.settings.x_scale_factor;
	                                    radiusPdfUnits = Math.min(radiusPdfUnits, Math.min(width / 2, height / 2));
	                                    renderer.pdf.roundedRect(x, y, width, height, radiusPdfUnits, radiusPdfUnits, borderColor ? 'FD' : 'F');
	                                } else {
	                                    renderer.pdf.rect(x, y, width, height, borderColor ? 'FD' : 'F');
	                                }
	                            } else if ($(cn).hasClass("jsr-barcode")) {
	                                var pos = {
	                                    top: offsetTopPx + cn.offsetTop - renderer.offsetInSectionPx,
	                                    left: offsetLeftPx + cn.offsetLeft
	                                },
	                                    x = pos.left * renderer.settings.x_scale_factor,
	                                    y = (renderer.y + pos.top) * renderer.settings.x_scale_factor,
	                                    $img = $(cn).find("img"),
	                                    width = $img.width() * renderer.settings.x_scale_factor,
	                                    height = $img.height() * renderer.settings.x_scale_factor,
	                                    src = $img.attr('src');
	                                if (src) {
	                                    var tmpImage = new Image();
	                                    tmpImage.src = src;
	                                    var naturalWidth = tmpImage.width;
	                                    var naturalHeight = tmpImage.height;
	                                    var canvas = document.createElement("canvas");
	                                    document.body.appendChild(canvas);
	                                    canvas.width = naturalWidth;
	                                    canvas.height = naturalHeight;
	                                    var context = canvas.getContext("2d");
	                                    context.fillStyle = "rgb(255,255,255)";
	                                    context.fillRect(0, 0, naturalWidth, naturalHeight);
	                                    context.drawImage($img[0], 0, 0, naturalWidth, naturalHeight);
	                                    var imgData = canvas.toDataURL('image/jpeg');
	                                    if (imgData) {
	                                        if (imgData === "data:,") {
	                                            imgData = src;
	                                        }
	                                        var format = imgData.indexOf('image/png') >= 0 ? 'png' : 'jpeg';
	                                        renderer.pdf.addImage(imgData, format, x, y, width, height);
	                                    }
	                                    $(canvas).remove();
	                                }
	                            } else {
	                                DrillForContent(cn, renderer, elementHandlers);
	                            }
	                        }
	                    }
	                } else if (cn.nodeType === 3) {
	                    var value = cn.nodeValue;
	                    if (cn.nodeValue && cn.parentNode.nodeName === "LI") {
	                        if (cn.parentNode.parentNode.nodeName === "OL") {
	                            value = listCount++ + '. ' + value;
	                        } else {
	                            var fontPx = fragmentCSS["font-size"] * 16;
	                            var radius = 2;
	                            if (fontPx > 20) {
	                                radius = 3;
	                            }
	                            cb = function cb(x, y) {
	                                this.pdf.circle(x, y, radius, 'FD');
	                            };
	                        }
	                    }
	                    renderer.addText(value, fragmentCSS);
	                } else if (typeof cn === "string") {
	                    renderer.addText(cn, fragmentCSS);
	                }
	            }
	        };

	        DrillForContent = function DrillForContent(element, renderer, elementHandlers) {
	            var cn, cns, fragmentCSS, i, isBlock, l, px2pt, table2json, cb;
	            cns = element.childNodes;
	            cn = void 0;
	            fragmentCSS = GetCSS(element);
	            isBlock = fragmentCSS.display === "block";
	            // if (isBlock) {
	            //     renderer.setBlockBoundary();
	            //     renderer.setBlockStyle(fragmentCSS);
	            // }
	            px2pt = 0.264583 * 72 / 25.4;
	            i = 0;
	            l = cns.length;
	            while (i < l) {
	                RenderElement(cns[i], renderer, elementHandlers);
	                i++;
	            }

	            // if (isBlock) {
	            //     return renderer.setBlockBoundary(cb);
	            // }
	        };
	        images = {};
	        loadImgs = function loadImgs(element, renderer, elementHandlers, cb) {
	            var imgs = $("img, div.jsr-image", element).toArray(),
	                l = imgs.length,
	                x = 0;
	            var tdBackgroundImageUrls = [];

	            var $tds = $('td', element);
	            for (var i = 0; i < $tds.length; i++) {
	                var backgroundImage = getTableCellBackgroundImage($tds.eq(i));
	                if (backgroundImage) {
	                    tdBackgroundImageUrls.push(backgroundImage);
	                }
	            }

	            function done() {
	                renderer.pdf.internal.events.publish('imagesLoaded');
	                cb();
	            }

	            function loadImage(url, width, height) {
	                if (!url) return;
	                var img = new Image();
	                ++x;
	                img.crossOrigin = '';
	                img.onerror = img.onload = function () {
	                    try {
	                        if (img.complete) {
	                            //to support data urls in images, set width and height
	                            //as those values are not recognized automatically
	                            if (img.src.indexOf('data:image/') === 0) {
	                                img.width = width || img.width || 0;
	                                img.height = height || img.height || 0;
	                            }
	                            //if valid image add to known images array
	                            if (img.width + img.height) {

	                                var tmpImage = new Image();
	                                tmpImage.src = img.src;
	                                var naturalWidth = tmpImage.width || img.width;
	                                var naturalHeight = tmpImage.height || img.height;
	                                // Hard-limit max size of image to 3x pixel size of target area
	                                // To prevent massive images from blowing out PDF file size
	                                if (width && height) {
	                                    var maxWidth = width * 3;
	                                    var maxHeight = height * 3;
	                                    if (naturalWidth > maxWidth || naturalHeight > maxHeight) {
	                                        var shrinkRatio = Math.min(maxWidth / naturalWidth, maxHeight / naturalHeight);
	                                        // console.log('limiting max image res from', naturalWidth, naturalHeight, width, height);
	                                        naturalWidth *= shrinkRatio;
	                                        naturalHeight *= shrinkRatio;
	                                    }
	                                }

	                                // console.log('natural dimensions (limited)', naturalWidth, naturalHeight);
	                                var canvas = document.createElement("canvas");
	                                document.body.appendChild(canvas);
	                                canvas.width = naturalWidth;
	                                canvas.height = naturalHeight;
	                                var context = canvas.getContext("2d");
	                                context.fillStyle = "rgb(255,255,255)";
	                                context.fillRect(0, 0, naturalWidth, naturalHeight);
	                                context.drawImage(img, 0, 0, naturalWidth, naturalHeight);
	                                tmpImage.src = canvas.toDataURL('image/jpeg');
	                                // console.log('data uri length is', tmpImage.src.length);
	                                tmpImage.width = naturalWidth;
	                                tmpImage.height = naturalHeight;
	                                $(canvas).remove();

	                                images[url] = images[url] || tmpImage;
	                            }
	                        }
	                    } catch (e) {
	                        console.warn(e);
	                    }
	                    if (! --x) {
	                        done();
	                    }
	                };
	                img.src = url;
	            }
	            while (l--) {
	                var imgEl = imgs[l];
	                var $imgEl = $(imgEl);
	                // Ignore <img> tags found within div.jsr-image (those are handled separately in this loop)
	                if ($imgEl.parent('.jsr-image').length) {
	                    continue;
	                }
	                var src = imgEl.tagName.toLowerCase() === "img" ? imgEl.getAttribute("src") : $(imgEl).data("image-url");
	                loadImage(src, $imgEl.width(), $imgEl.height());
	            }
	            tdBackgroundImageUrls.forEach(function (src) {
	                return loadImage(src);
	            });
	            return x || done();
	        };

	        function extractTableCells(tableDomEl, offsetTop, offsetLeft, renderer) {
	            var _this = this;

	            var $table = $(tableDomEl);
	            var tablePositionPx = {
	                left: offsetLeft + tableDomEl.offsetLeft,
	                top: offsetTop + tableDomEl.offsetTop
	            };
	            var cells = [];
	            var rowOffsetPx = 0;
	            $table.find('tr').each(function (ix, tr) {
	                var rowHeightPx = 0;
	                var rowCells = [];
	                $(tr).find('td,th').each(function (ix, cell) {
	                    var $cell = $(cell);
	                    var styles = GetCSS(cell);
	                    // console.log('cell padding', styles['padding-top'], styles['padding-right'], styles['padding-bottom'], styles['padding-left']);

	                    // Must re-flow and measure cell content to increase row height to fit if necessary
	                    var block = layoutText.call(_this, $cell, renderer);
	                    var cellHeight = Math.max(block.heightPx, $cell.outerHeight());
	                    rowHeightPx = Math.max(rowHeightPx, cellHeight);
	                    block.leftPx += tablePositionPx.left; // No need to fix topPx since it's not used

	                    // increase cell height taking padding into consideration

	                    rowCells.push({
	                        isTableCell: true,
	                        tablePositionPx: tablePositionPx,
	                        top: tablePositionPx.top + rowOffsetPx, // rel to section
	                        $el: $cell,
	                        laidOutText: block
	                    });
	                });
	                rowOffsetPx += rowHeightPx;
	                // Fill in row bottom px on all cells in the previous row
	                for (var i = 0; i < rowCells.length; i++) {
	                    var cell = rowCells[i];
	                    cell.bottom = tablePositionPx.top + rowOffsetPx; // rel to section
	                    cells.push(cell);
	                }
	            });
	            return {
	                cells: cells,
	                bottomEdge: tablePositionPx.top + rowOffsetPx
	            };
	        }

	        function extractSubreportChildElements(subreportDomEl, offsetTop, offsetLeft, renderer) {
	            var subreportTop = offsetTop + subreportDomEl.offsetTop - renderer.offsetInSectionPx;
	            var subreportLeft = offsetLeft + subreportDomEl.offsetLeft;
	            var $subreport = $(subreportDomEl);
	            var $sections = $subreport.children('.jsr-section');
	            var allElts = [];
	            var breaks = [];
	            var sectionTop = 0;
	            // var height = 0;
	            for (var i = 0, secLen = $sections.length; i < secLen; i++) {
	                var $section = $sections.eq(i);
	                var section = $section[0];
	                var sectionInfo = extractElementsWithinSection($section, subreportTop + sectionTop, subreportLeft, renderer);
	                allElts = allElts.concat(sectionInfo.elts);
	                breaks = breaks.concat(sectionInfo.breaks);
	                sectionTop += sectionInfo.height;
	            }
	            return {
	                breaks: breaks,
	                elts: allElts,
	                bottomEdge: subreportDomEl.offsetTop + sectionTop
	            };
	        }

	        /**
	         * Finds all leaf-level elements anywhere in the section, along with their net offset to $section,
	         * plus a list of page breaks within any child sections, also relative to the root $section.
	         * Breaks tables up into individual cell "elements", and flattens nested subreports into
	         * collections of leaf-level elements.
	         */
	        function extractElementsWithinSection($section, offsetTop, offsetLeft, renderer) {
	            var breaks = $section.data('page-breaks') || [];
	            for (var i = 0, len = breaks.length; i < len; i++) {
	                breaks[i] += offsetTop;
	            }
	            var allElts = [];
	            var $childElts = $section.children('.jsr-element:not(.jsr-table,.jsr-subreport)');
	            var sectionHeight = $section[0].offsetHeight;
	            for (var i = 0, len = $childElts.length; i < len; i++) {
	                var el = $childElts[i];
	                var $el = $(el);
	                var globalTop = offsetTop + el.offsetTop;
	                var height = $el.outerHeight();
	                var elInfo = {
	                    top: globalTop,
	                    offsetLeft: offsetLeft,
	                    offsetTop: offsetTop,
	                    $el: $el
	                };
	                if (el.className.indexOf('jsr-text') >= 0) {
	                    var textBlock = layoutText.call(this, $el, renderer);
	                    height = textBlock.heightPx;
	                    textBlock.topPts += offsetTop * renderer.settings.x_scale_factor;
	                    textBlock.leftPx += offsetLeft || 0;
	                    elInfo.isText = true;
	                    elInfo.textBlock = textBlock;
	                }
	                var globalBottom = globalTop + height;
	                sectionHeight = Math.max(sectionHeight, el.offsetTop + height);
	                elInfo.bottom = globalBottom;
	                allElts[allElts.length] = elInfo;
	            }
	            $section.children('.jsr-table').each(function () {
	                var tableInfo = extractTableCells.call(null, this, offsetTop, offsetLeft, renderer);
	                allElts = allElts.concat(tableInfo.cells);
	                sectionHeight = Math.max(sectionHeight, tableInfo.bottomEdge - offsetTop);
	            });
	            var subreports = $section.children('.jsr-subreport');
	            for (var i = 0, subreportLen = subreports.length; i < subreportLen; i++) {
	                var subsectionInfo = extractSubreportChildElements.call(null, subreports[i], offsetTop, offsetLeft, renderer);
	                allElts = allElts.concat(subsectionInfo.elts);
	                breaks = breaks.concat(subsectionInfo.breaks);
	                sectionHeight = Math.max(sectionHeight, subsectionInfo.bottomEdge);
	            }
	            return {
	                breaks: breaks,
	                elts: allElts,
	                height: sectionHeight
	            };
	        }

	        function pageBreak(renderer, elementHandlers) {
	            var _this2 = this;

	            if (pageFooter) {
	                renderer.y = renderer.settings.y_height_pixels - renderer.pdf.margins_doc.bottom - pageFooterHeight;
	                renderSection.call(this, pageFooter, renderer, elementHandlers, true);
	            }
	            // add page
	            renderer.pdf.addPage();
	            renderer.pageNumber++;
	            renderer.y = renderer.pdf.margins_doc.top;
	            if (pageBackground) {
	                renderSection.call(this, $(pageBackground), renderer, elementHandlers, true);
	            }
	            renderer.y = renderer.pdf.margins_doc.top;
	            // print next page header
	            if (pageHeader) {
	                renderSection.call(this, pageHeader, renderer, elementHandlers, true);
	                // renderer.y += pageHeaderHeight;
	            }
	            repeatingHeaderStack.forEach(function (header) {
	                renderSection.call(_this2, header.$section, renderer, elementHandlers, true);
	            });
	        }

	        function renderSection($section, renderer, elementHandlers, skipHeaderTracking) {
	            renderer.current_section_height = $section.height();
	            renderer.offsetInSectionPx = 0;
	            var allChildInfo = extractElementsWithinSection.call(this, $section, 0, 0, renderer);
	            var allElts = allChildInfo.elts;
	            var breaks = allChildInfo.breaks;
	            var isHeader = $section.hasClass('jsr-page-header');
	            var isFooter = $section.hasClass('jsr-page-footer');
	            var backgroundColor = extractCSSColorRGB($section.css('background-color'));
	            var isBackground = $section.hasClass('jsr-page-background');
	            var canBreak = !$section.data('jsr-no-break');
	            var depth = $section.data('jsr-depth') || 0;
	            var scaleFactor = renderer.settings.x_scale_factor;
	            if (!skipHeaderTracking) {
	                if (depth < lastDepth) {
	                    // Remove any repeating headers below new depth
	                    repeatingHeaderStack = repeatingHeaderStack.filter(function (header) {
	                        return header.depth < depth;
	                    });
	                }
	                lastDepth = depth;
	                var repeatEachPage = !!$section.data('jsr-repeat-each-page');
	                if (repeatEachPage) {
	                    repeatingHeaderStack.push({
	                        depth: depth,
	                        $section: $section
	                    });
	                    repeatingHeaderStack.sort(function (a, b) {
	                        return a.depth - b.depth;
	                    });
	                }
	            }
	            var canWrap = !(isHeader || isFooter || isBackground);
	            allElts.sort(function (a, b) {
	                return a.top - b.top;
	            });
	            breaks.sort(function (a, b) {
	                return a - b;
	            });
	            // startY and endY are always within [0..sectionHeight)
	            var startY = 0;
	            var endY;
	            var sectionHeight = allChildInfo.height;
	            var printableAreaBottom = renderer.settings.y_height_pixels - renderer.pdf.margins_doc.bottom - (isFooter || isBackground ? 0 : pageFooterHeight);
	            var iters = 0;
	            // If we don't have room and can't break the section, insert a page break now
	            if (renderer.y + sectionHeight > printableAreaBottom && !canBreak) {
	                pageBreak(renderer, elementHandlers);
	            }
	            while (startY < sectionHeight) {
	                endY = sectionHeight;
	                // all these calculations are in pixels
	                var wouldBeSectionBottom = renderer.y + (endY - startY);
	                // set endY to the max we can fit on the current page
	                if (printableAreaBottom < wouldBeSectionBottom) {
	                    endY = startY + (printableAreaBottom - renderer.y);
	                }
	                // if a defined page break exists before the end of this page, break there instead
	                if (breaks.length > 0 && breaks[0] < endY) {
	                    endY = breaks.shift();
	                }
	                // About to render at least part of this section between startY and endY
	                if (backgroundColor) {
	                    var leftPts = renderer.pdf.margins_doc.left * scaleFactor;
	                    var width = renderer.pdf.internal.pageSize.width - leftPts - renderer.pdf.margins_doc.right * scaleFactor;
	                    renderer.pdf.setFillColor(backgroundColor.r, backgroundColor.g, backgroundColor.b);
	                    renderer.pdf.rect(leftPts, renderer.y * scaleFactor, width, (endY - startY) * scaleFactor, 'F');
	                }
	                var nextStartY = endY;
	                var batch = [];
	                while (allElts.length > 0) {
	                    var eltInfo = allElts[0];
	                    if (eltInfo.top >= endY) {
	                        break;
	                    }
	                    if (eltInfo.bottom <= endY || eltInfo.mustPrint) {
	                        // will draw elt; remove from list
	                        batch.push(eltInfo);
	                        allElts.shift();
	                    } else if (eltInfo.isText /* TODO don't split if "splittable(?)" prop is set false on elt */) {
	                            var _ret = function () {
	                                // This text block would span a page break - see if we can split it into two blocks
	                                var linesOnThisPage = [];
	                                var paddingTopPx = eltInfo.textBlock.paddingTopPx;
	                                var firstLineTopPx = eltInfo.top + paddingTopPx;
	                                var lastLineBottomPx = firstLineTopPx;
	                                var lines = eltInfo.textBlock.lines;
	                                var lineHeightPx = eltInfo.textBlock.lineHeightPx;
	                                var lineIx = 0;
	                                while (lineIx < lines.length) {
	                                    var line = lines[lineIx];
	                                    var thisLineBottomPx = firstLineTopPx + line.topPx + lineHeightPx;
	                                    if (thisLineBottomPx < endY) {
	                                        linesOnThisPage.push(line);
	                                        lastLineBottomPx = thisLineBottomPx;
	                                    } else {
	                                        break;
	                                    }
	                                    lineIx++;
	                                }
	                                if (linesOnThisPage.length > 0) {
	                                    var remainingLineCount = lines.length - linesOnThisPage.length;
	                                    if (remainingLineCount > 0) {
	                                        // Move the remaining lines into a new elt and append it to allElts
	                                        var newEltInfo = _extends({}, eltInfo, {
	                                            mustPrint: true,
	                                            top: endY,
	                                            textBlock: _extends({}, eltInfo.textBlock, {
	                                                topPx: lastLineBottomPx,
	                                                topPts: lastLineBottomPx * renderer.settings.x_scale_factor,
	                                                paddingTopPx: 0,
	                                                heightPx: eltInfo.textBlock.heightPx - (lastLineBottomPx - firstLineTopPx),
	                                                lines: eltInfo.textBlock.lines.slice(lineIx).map(function (line, ix) {
	                                                    return _extends({}, line, {
	                                                        topPx: line.topPx - lastLineBottomPx
	                                                    });
	                                                })
	                                            })
	                                        });
	                                        allElts.push(newEltInfo);
	                                    }
	                                    // Put partial top block on this page
	                                    eltInfo.textBlock.lines = linesOnThisPage;
	                                    batch.push(eltInfo);
	                                    allElts.shift();
	                                } else {
	                                    // Couldn't split; move to next page
	                                    eltInfo.mustPrint = true;
	                                    nextStartY = eltInfo.top;
	                                    return 'break';
	                                }
	                            }();

	                            if (_ret === 'break') break;
	                        } else {
	                        // the first element we encounter with its bottom outside the printable range is shifted to the next page;
	                        // we must print it in the next pass regardless of whether it fits
	                        eltInfo.mustPrint = true;
	                        nextStartY = eltInfo.top;
	                        break;
	                    }
	                }
	                batch.sort(function (a, b) {
	                    // -1 = a beneath b
	                    var aEl = a.$el[0];
	                    var bEl = b.$el[0];
	                    var aZIndex = Number(aEl.style.zIndex) || 0;
	                    var bZIndex = Number(bEl.style.zIndex) || 0;
	                    if (aZIndex > bZIndex) {
	                        return 1;
	                    } else if (bZIndex > aZIndex) {
	                        return -1;
	                    } else {
	                        // Same zIndex: put boxes beneath other elements
	                        var aBox = aEl.className.indexOf('jsr-box') >= 0; //.hasClass('jsr-box');
	                        var bBox = bEl.className.indexOf('jsr-box') >= 0; //.hasClass('jsr-box');
	                        return aBox ? bBox ? 1 : -1 : 1;
	                    }
	                });
	                batch.forEach(function (eltInfo) {
	                    if (eltInfo.isTableCell) {
	                        renderTableCell(eltInfo, renderer, eltInfo.tablePositionPx);
	                    } else if (eltInfo.isText) {
	                        renderLaidOutText.call(this, eltInfo.textBlock, renderer);
	                    } else {
	                        RenderElement(eltInfo.$el[0], renderer, elementHandlers, eltInfo.offsetTop, eltInfo.offsetLeft);
	                    }
	                });
	                renderer.y += endY - startY;
	                if (!canWrap) break;
	                if (endY < sectionHeight) {
	                    pageBreak(renderer, elementHandlers);
	                    renderer.offsetInSectionPx = nextStartY;
	                }
	                startY = nextStartY;
	            }
	        }

	        function renderTableCell(cellInfo, renderer, tablePositionPx) {
	            var $cell = cellInfo.$el;
	            var cellPos = $cell.position();
	            cellPos.left += tablePositionPx.left;
	            cellPos.right = cellPos.left + $cell.outerWidth();
	            var cellTop = cellInfo.top - renderer.offsetInSectionPx;
	            cellInfo.laidOutText.topPts = cellInfo.top * renderer.settings.x_scale_factor;
	            var cellBottom = cellInfo.bottom - renderer.offsetInSectionPx;
	            renderTableCellBorder.call(this, cellInfo, renderer, 'top', cellTop, cellPos.left, cellPos.right);
	            renderTableCellBorder.call(this, cellInfo, renderer, 'bottom', cellBottom, cellPos.left, cellPos.right);
	            renderTableCellBorder.call(this, cellInfo, renderer, 'left', cellPos.left, cellTop, cellBottom);
	            renderTableCellBorder.call(this, cellInfo, renderer, 'right', cellPos.right, cellTop, cellBottom);
	            var backgroundImage = getTableCellBackgroundImage($cell);
	            if (backgroundImage) {
	                var backgroundLeftPx = 0;
	                var backgroundTopPx = 0;
	                var backgroundPos = $cell.css('background-position');
	                if (backgroundPos) {
	                    var _posParts = backgroundPos.split(' ');
	                    if (_posParts.length === 1) {
	                        backgroundTopPx = backgroundLeftPx = parseFloat(_posParts[0]);
	                    } else if (_posParts.length === 2) {
	                        backgroundLeftPx = parseFloat(_posParts[0]);
	                        backgroundTopPx = parseFloat(_posParts[1]);
	                    }
	                }
	                var backgroundWidthPx = 0;
	                var backgroundHeightPx = 0;
	                var backgroundSize = $cell.css('background-size');
	                if (backgroundSize) {
	                    var sizeParts = backgroundSize.split(' ');
	                    if (sizeParts.length === 1) {
	                        backgroundWidthPx = backgroundHeightPx = parseFloat(sizeParts[0]);
	                    } else if (posParts.length === 2) {
	                        backgroundWidthPx = parseFloat(sizeParts[0]);
	                        backgroundHeightPx = parseFloat(sizeParts[1]);
	                    }
	                }
	                if (images[backgroundImage]) {
	                    var img = images[backgroundImage];
	                    var imageLeftPts = (cellPos.left + backgroundLeftPx) * renderer.settings.x_scale_factor;
	                    var imageTopPts = (renderer.y + cellTop + backgroundTopPx) * renderer.settings.x_scale_factor;
	                    var outImageHeightPts = Math.min(backgroundHeightPx * renderer.settings.x_scale_factor, img.height / img.width * backgroundWidthPx * renderer.settings.x_scale_factor);
	                    if (renderer.usedImagesBySrc[backgroundImage]) {
	                        // we've already added this image to the PDF; reference it by alias
	                        renderer.pdf.addImage(img, imageLeftPts, imageTopPts, backgroundWidthPx * renderer.settings.x_scale_factor, outImageHeightPts, backgroundImage);
	                    } else {
	                        renderer.pdf.addImage(img, imageLeftPts, imageTopPts, backgroundWidthPx * renderer.settings.x_scale_factor, outImageHeightPts);
	                        renderer.usedImagesBySrc[backgroundImage] = true;
	                    }
	                }
	            }
	            renderLaidOutText.call(this, cellInfo.laidOutText, renderer);
	        }

	        function getTableCellBackgroundImage($td) {
	            var backgroundImage = $td.css('background-image');
	            if (backgroundImage) {
	                var matches = /^url\(['"]?([^'"\)]*)['"]?\)$/i.exec(backgroundImage);
	                if (matches && matches.length > 1) {
	                    return matches[1];
	                }
	            }
	            return null;
	        }

	        function renderTableCellBorder(cellInfo, renderer, borderName, pos, extent0, extent1) {
	            var $cell = cellInfo.$el;
	            var thickness = parseFloat($cell.css('border-' + borderName + '-width') || '0');
	            var color = extractCSSColorRGB($cell.css('border-' + borderName + '-color')) || { r: 0, g: 0, b: 0 };
	            if (!thickness || !color || color === 'transparent') return;
	            thickness *= renderer.settings.x_scale_factor;
	            pos -= thickness / 2;
	            renderer.pdf.setFillColor(color.r, color.g, color.b);
	            if (borderName === 'top' || borderName == 'bottom') {
	                renderer.pdf.rect(extent0 * renderer.settings.x_scale_factor, (renderer.y + pos) * renderer.settings.x_scale_factor, (extent1 - extent0) * renderer.settings.x_scale_factor, thickness * renderer.settings.x_scale_factor, "F");
	            } else {
	                renderer.pdf.rect(pos * renderer.settings.x_scale_factor, (renderer.y + extent0) * renderer.settings.x_scale_factor, thickness * renderer.settings.x_scale_factor, (extent1 - extent0) * renderer.settings.x_scale_factor, "F");
	            }
	        }

	        function getTextNodes(domEl, isListItem) {
	            var textNodes = [];
	            // Only look at element nodes
	            if (domEl.nodeType !== 1) return textNodes;
	            if (domEl.tagName.toLowerCase() === 'li') {
	                isListItem = true;
	            }
	            for (var i = 0; i < domEl.childNodes.length; i++) {
	                var child = domEl.childNodes[i];
	                if (child.nodeType === 3) {
	                    textNodes.push({
	                        text: child.textContent,
	                        css: GetCSS(domEl),
	                        node: child,
	                        isListItem: isListItem,
	                        isFirst: i === 0
	                    });
	                } else {
	                    textNodes.push.apply(textNodes, getTextNodes(child, isListItem));
	                }
	            }
	            return textNodes;
	        }

	        /** 
	         * From HTML element, re-layout text for PDF, returning a set of lines
	         * with some metadata, each line consisting of a set of chunks each
	         * with its own formatting
	         */
	        function layoutText($elem, renderer, offsetPx) {
	            var isMarkdown = $elem.hasClass('jsr-markdown');
	            var isHtml = $elem.hasClass('jsr-html');
	            var domEl = $elem[0];
	            var blockCSS = GetCSS(domEl);
	            // The * 16 here is a weirdness due to the ResolveUnitedNumber function we inherited
	            // from this plugin; it returns px / 16
	            var paddingTopPx = (blockCSS['padding-top'] || 0) * 16;
	            var paddingLeftPx = (blockCSS['padding-left'] || 0) * 16;
	            var paddingRightPx = (blockCSS['padding-right'] || 0) * 16;
	            var paddingBottomPx = (blockCSS['padding-bottom'] || 0) * 16;
	            var blockPos = {
	                top: domEl.offsetTop,
	                left: domEl.offsetLeft
	            };
	            var defaultFontSize = 12;
	            var blockAlign = blockCSS['text-align'] || 'left';
	            var wrap = blockCSS['white-space'] !== 'nowrap';
	            var blockWidth = $elem.width();
	            var lines = [];
	            //    ^ edit: this is handled by the section renderer, may not be necessary 
	            //      unless sections are really big
	            var textNodes = getTextNodes($elem[0]);
	            var rotate = $elem.data('jsr-text-rotate') || 0;
	            if ($elem.data('jsr-text-template')) {
	                textNodes.forEach(function (node) {
	                    node.text = $elem.data('jsr-text-template').replace(/{{JSR_PRINT_PAGE_NUMBER}}/g, String(renderer.pageNumber)).replace(/{{JSR_PRINT_PAGE_COUNT}}/g, '###jsPDFVarTotalPages###');
	                });
	            }
	            if (offsetPx) {
	                blockPos.left += offsetPx.left;
	                blockPos.top += offsetPx.top;
	            }
	            var fontsize = $elem.data('font-size') || blockCSS["font-size"] * defaultFontSize;
	            var fontRatio = fontsize / (blockCSS["font-size"] * defaultFontSize);
	            renderer.pdf.setFont(blockCSS["font-family"], blockCSS["font-style"]);
	            renderer.pdf.setFontSize(fontsize);

	            var blockTopPts = blockPos.top * renderer.settings.x_scale_factor;
	            var text_baseline_y = blockTopPts + fontsize,
	                lineHeight = blockCSS['line-height'] * fontsize,
	                lineHeightPx = lineHeight / renderer.settings.x_scale_factor;

	            var lineOffsetPts = (lineHeight - fontsize) / 2.0;
	            var lineCount = 0;

	            blockCSS['font-size'] = fontsize / 12; // splitFragment... uses 12 * fontsize as effective fontsize
	            var fontKey = renderer.pdf.internal.getFont().id;
	            usedFontKeys[fontKey] = true;

	            var lineTopPx = 0;
	            var lineWidthPts = 0;
	            var chunks = [];

	            var blockWidthPts = blockWidth * renderer.settings.x_scale_factor;
	            for (var i = 0, n = textNodes.length; i < n; i++) {
	                var node = textNodes[i];
	                var nodeCSS = node.css;
	                var nodeText = node.text;
	                var leftIndentPts = 0;
	                if (node.isListItem) {
	                    leftIndentPts = lineHeight;
	                    if (node.isFirst) {
	                        lineWidthPts += leftIndentPts;
	                        // Add text chunk for bullet
	                        // Bullet gets same font but override bold/italic to just bold
	                        var bulletCSS = _extends({}, nodeCSS, {
	                            'font-style': 'bold'
	                        });
	                        chunks.push({ style: bulletCSS, text: '•', leftPts: 0,
	                            widthPts: leftIndentPts });
	                    }
	                }
	                // Must set font here for jspdf to measure correctly
	                renderer.pdf.setFont(nodeCSS["font-family"], nodeCSS["font-style"]);
	                if (isMarkdown) {
	                    // Handle literal linebreaks inside single text node
	                    nodeText = nodeText.replace(/[ \t]*\n[ \t]*/g, '\n');
	                }
	                var multiLineChunk = nodeText.split('\n');
	                for (var j = 0, m = wrap ? multiLineChunk.length : 1; j < m; j++) {
	                    var subChunkLine = multiLineChunk[j];
	                    var textForMeasurement = subChunkLine.replace(/###jsPDFVarTotalPages###/g, '99');
	                    var textWidthPts = renderer.pdf.getStringUnitWidth(textForMeasurement) * fontsize / renderer.pdf.internal.scaleFactor;
	                    if (lineWidthPts + textWidthPts > blockWidthPts) {
	                        var wrappedParts = renderer.pdf.splitTextToSize(subChunkLine, blockWidthPts, {
	                            fontName: blockCSS['font-family'],
	                            fontStyle: nodeCSS['font-style'],
	                            fontSize: fontsize,
	                            textIndent: lineWidthPts // first line offset into block
	                        });
	                        if (!wrap) {
	                            wrappedParts = wrappedParts.slice(0, 1);
	                        }
	                        // Each wrappedPart is on a separate line, starting with the end of 
	                        // the current line
	                        for (var k = 0; k < wrappedParts.length; k++) {
	                            var wrappedPart = wrappedParts[k];
	                            var wrappedPartWidthPts = renderer.pdf.getStringUnitWidth(wrappedPart) * fontsize / renderer.pdf.internal.scaleFactor;
	                            chunks.push({ style: nodeCSS, text: wrappedParts[k], leftPts: lineWidthPts,
	                                widthPts: wrappedPartWidthPts });
	                            lineWidthPts += wrappedPartWidthPts;
	                            if (k < wrappedParts.length - 1) {
	                                lines.push({ topPx: lineTopPx, chunks: chunks, widthPts: lineWidthPts });
	                                lineTopPx += lineHeightPx;
	                                chunks = [];
	                                lineWidthPts = leftIndentPts;
	                            }
	                        }
	                    } else {
	                        chunks.push({ style: nodeCSS, text: subChunkLine, leftPts: lineWidthPts,
	                            widthPts: textWidthPts });
	                        lineWidthPts += textWidthPts;
	                    }
	                    /** Push hard line break after each sub-chunk line except last */
	                    if (j < m - 1) {
	                        lines.push({ topPx: lineTopPx, chunks: chunks, widthPts: lineWidthPts });
	                        lineTopPx += lineHeightPx;
	                        chunks = [];
	                        lineWidthPts = leftIndentPts;
	                    }
	                }
	            }
	            lines.push({ topPx: lineTopPx, chunks: chunks, widthPts: lineWidthPts });

	            var outerBlockWidth = blockWidth + paddingLeftPx + paddingRightPx;
	            var outerBlockWidthPts = outerBlockWidth * renderer.settings.x_scale_factor;

	            var block = {
	                topPx: blockPos.top,
	                topPts: blockTopPts,
	                leftPx: blockPos.left,
	                widthPx: outerBlockWidth,
	                widthPts: outerBlockWidthPts,
	                heightPx: lineTopPx + lineHeightPx + paddingTopPx + paddingBottomPx, // lineTopPx is last line top
	                align: blockAlign,
	                lines: lines,
	                lineHeightPts: lineHeight,
	                lineHeightPx: lineHeightPx,
	                lineOffsetPts: lineOffsetPts,
	                fontSize: fontsize,
	                fontKey: fontKey,
	                blockCSS: blockCSS,
	                posPx: blockPos,
	                paddingTopPx: paddingTopPx,
	                paddingLeftPx: paddingLeftPx,
	                paddingRightPx: paddingRightPx,
	                paddingBottomPx: paddingBottomPx,
	                fontRatio: fontRatio,
	                allowMixedFontSizes: isHtml,
	                rotate: rotate
	            };
	            return block;
	        }

	        /** 
	         * Primary text rendering function; relies on pre-laid-out text block which is done
	         * in a separate step in order to measure height before rendering 
	         */
	        function renderLaidOutText(block, renderer) {
	            // Must adjust block top if we moved into a new page since the layout
	            var blockTopPts = block.topPts + (renderer.y - renderer.offsetInSectionPx) * renderer.settings.x_scale_factor;
	            var blockCSS = block.blockCSS;
	            var lines = block.lines;

	            var blockTextColor = blockCSS['color'];
	            var blockBackColor = blockCSS['background-color'];
	            var blockLeftPts = block.leftPx * renderer.settings.x_scale_factor;
	            var paddingTopPts = block.paddingTopPx * renderer.settings.x_scale_factor;
	            var paddingLeftPts = block.paddingLeftPx * renderer.settings.x_scale_factor;
	            var paddingRightPts = block.paddingRightPx * renderer.settings.x_scale_factor;
	            var paddingBottomPts = block.paddingBottomPx * renderer.settings.x_scale_factor;


	            setColors.call(this, renderer, blockLeftPts, blockTopPts, block.widthPx * renderer.settings.x_scale_factor, block.heightPx * renderer.settings.x_scale_factor, blockTextColor, blockBackColor);

	            var firstLineBaseline = blockTopPts + block.lineOffsetPts + paddingTopPts + block.fontSize;
	            for (var l = 0, lc = lines.length; l < lc; l++) {
	                var line = lines[l];
	                var leftPts = paddingLeftPts;
	                if (block.align === 'right') {
	                    leftPts = block.widthPts - paddingRightPts - line.widthPts;
	                } else if (block.align === 'center') {
	                    leftPts = (block.widthPts - paddingRightPts - paddingLeftPts - line.widthPts) / 2;
	                }
	                for (var c = 0, cc = line.chunks.length; c < cc; c++) {
	                    var chunk = line.chunks[c];
	                    renderer.pdf.setFont(chunk.style["font-family"], chunk.style["font-style"]);
	                    var fontSize = block.fontSize;
	                    if (block.allowMixedFontSizes && chunk.style['font-size']) {
	                        fontSize = block.fontRatio * chunk.style['font-size'] * fontSize;
	                    }
	                    renderer.pdf.setFontSize(fontSize);
	                    var chunkLeftPts = blockLeftPts + leftPts + chunk.leftPts;
	                    var chunkBaselinePts = firstLineBaseline + l * block.lineHeightPts;
	                    var chunkTextColor = chunk.style['color'];
	                    var chunkBackColor = chunk.style['background-color'];
	                    if (chunkBackColor === blockBackColor) {
	                        chunkBackColor = null;
	                    }
	                    setColors.call(this, renderer, chunkLeftPts, chunkBaselinePts - block.fontSize - block.lineOffsetPts, chunk.widthPts, block.lineHeightPts, chunkTextColor, chunkBackColor);
	                    if (block.rotate) {
	                        if (block.rotate === -90) {
	                            renderer.pdf.text(chunk.text, chunkLeftPts + block.lineHeightPts, chunkBaselinePts - block.lineHeightPts, null, -block.rotate);
	                        } else if (block.rotate === 90) {
	                            renderer.pdf.text(chunk.text, chunkLeftPts - block.lineHeightPts, chunkBaselinePts - block.lineHeightPts, null, -block.rotate);
	                        }
	                    } else {
	                        renderer.pdf.text(chunk.text, chunkLeftPts, chunkBaselinePts);
	                    }
	                    if (chunk.style['text-decoration'] === 'line-through') {
	                        var strikethroughPos = chunkBaselinePts - 0.3 * block.fontSize;
	                        renderer.pdf.line(chunkLeftPts, strikethroughPos, chunkLeftPts + chunk.widthPts, strikethroughPos);
	                    } else if (chunk.style['text-decoration'] === 'underline') {
	                        var underlinePos = chunkBaselinePts + 0.1 * block.lineHeightPts;
	                        renderer.pdf.line(chunkLeftPts, underlinePos, chunkLeftPts + chunk.widthPts, underlinePos);
	                    }
	                }
	            }
	        }

	        function setColors(renderer, left, top, width, height, textColorCSS, backColorCSS) {
	            var textColor = extractCSSColorRGB(textColorCSS) || { r: 0, g: 0, b: 0 };;
	            var backColor = extractCSSColorRGB(backColorCSS);
	            if (backColor) {
	                renderer.pdf.setFillColor(backColor.r, backColor.g, backColor.b);
	                renderer.pdf.rect(left, top, width, height, "F");
	            }
	            renderer.pdf.setTextColor(textColor.r, textColor.g, textColor.b);
	        }

	        function getPixelCssDistance(cssPropText, renderer) {
	            if (cssPropText.indexOf('%') >= 0) {
	                return parseFloat(cssPropText) / 100 * renderer.settings.width;
	            }
	            return parseFloat(cssPropText);
	        }
	        process = function process(pdf, element, x, y, settings, callback) {
	            usedFontKeys = {};
	            if (!element) return false;
	            if (typeof element !== "string" && !element.parentNode) element = '' + element.innerHTML;
	            if (typeof element === "string") {
	                element = function (element) {
	                    var $frame, $hiddendiv, framename, visuallyhidden;
	                    framename = "jsPDFhtmlText" + Date.now().toString() + (Math.random() * 1000).toFixed(0);
	                    visuallyhidden = "position: absolute !important;" + "clip: rect(1px 1px 1px 1px); /* IE6, IE7 */" + "clip: rect(1px, 1px, 1px, 1px);" + "padding:0 !important;" + "border:0 !important;" + "height: 1px !important;" + "width: 1px !important; " + "top:auto;" + "left:-100px;" + "overflow: hidden;";
	                    $hiddendiv = document.createElement('div');
	                    $hiddendiv.style.cssText = visuallyhidden;
	                    $hiddendiv.innerHTML = "<iframe style=\"height:1px;width:1px\" name=\"" + framename + "\" />";
	                    document.body.appendChild($hiddendiv);
	                    $frame = window.frames[framename];
	                    $frame.document.body.innerHTML = element;
	                    return $frame.document.body;
	                }(element.replace(/<\/?script[^>]*?>/gi, ''));
	            }
	            var r = new Renderer(pdf, x, y, settings);
	            r.offsetInSectionPx = 0;
	            // r.rootElement = element;
	            callback = callback || function () {};

	            settings.x_scale_factor = r.pdf.internal.pageSize.width / r.settings.width;
	            settings.y_height_pixels = r.pdf.internal.pageSize.height / settings.x_scale_factor;

	            var clonePageHeaderOrFooter = function clonePageHeaderOrFooter($section) {
	                var parent = $section.parent();
	                var $clonedSection = $section.clone(true).css({
	                    display: 'block',
	                    left: '-10000px'
	                });
	                $clonedSection.find('.jsr-text').each(function (index, domEl) {
	                    var $el = $(domEl);
	                    var template = $el.data('jsr-text-template');
	                    if (template) {
	                        $el.text(template.replace(/{{JSR_PRINT_PAGE_COUNT}}/g, '###jsPDFVarTotalPages###'));
	                    }
	                });
	                parent.append($clonedSection);
	                return $clonedSection;
	            };

	            // Find page header and footer if any
	            pageHeader = $(".jsr-section.jsr-page-header", element);
	            if (pageHeader.length > 0) {
	                pageHeader = clonePageHeaderOrFooter(pageHeader);
	                pageHeaderHeight = pageHeader.data("section-height") || pageHeader.height();
	            } else {
	                pageHeader = null;
	            }
	            pageFooter = $(".jsr-section.jsr-page-footer", element);
	            if (pageFooter.length > 0) {
	                pageFooter = clonePageHeaderOrFooter(pageFooter);
	                pageFooterHeight = pageFooter.data("section-height") || pageFooter.height();
	            } else {
	                pageFooter = null;
	            }
	            pageBackground = $(".jsr-section.jsr-page-background", element);
	            pageBackground = pageBackground.length > 0 ? pageBackground[0] : null;
	            r.pageNumber = 1;

	            // 1. load images
	            // 2. prepare optional footer elements
	            // 3. render content
	            var me = this;
	            loadImgs.call(me, element, r, settings.elementHandlers, function () {

	                // Begin rendering report content
	                r.offset = { left: 0, top: 0 };

	                delete r.current_section_height;

	                if (pageBackground) {
	                    DrillForContent.call(this, pageBackground, r, settings.elementHandlers);
	                }

	                // print first page header
	                if (pageHeader) {
	                    renderSection.call(this, pageHeader, r, settings.elementHandlers);
	                }
	                DrillForContent.call(this, element, r, settings.elementHandlers);
	                // print last page footer
	                if (pageFooter) {
	                    r.y = r.settings.y_height_pixels - r.pdf.margins_doc.bottom - pageFooterHeight;
	                    renderSection.call(this, pageFooter, r, settings.elementHandlers);
	                }
	                r.pdf.internal.events.publish('htmlRenderingFinished');
	                if (pageHeader || pageFooter) {
	                    if (pageHeader) {
	                        $(pageHeader).remove();
	                    }
	                    if (pageFooter) {
	                        $(pageFooter).remove();
	                    }
	                }
	                Object.keys(usedFontKeys).forEach(function (fontKey) {
	                    var encoded = r.pdf.encodeText('###jsPDFVarTotalPages###', fontKey);
	                    var replacement = r.pdf.encodeText(String(r.pdf.internal.getNumberOfPages()), fontKey);
	                    r.pdf.putTotalPages.call(r.pdf, encoded, replacement);
	                });
	                callback(r.dispose());
	            });
	            return { x: r.x, y: r.y };
	        };
	        Renderer.prototype.init = function () {
	            this.paragraph = {
	                text: [],
	                style: []
	            };
	            // return this.pdf.internal.write("q");
	            return;
	        };
	        Renderer.prototype.dispose = function () {
	            // this.pdf.internal.write("Q");
	            return {
	                x: this.x,
	                y: this.y
	            };
	        };

	        //Checks if we have to execute some watcher functions
	        //e.g. to end text floating around an image
	        Renderer.prototype.executeWatchFunctions = function (el) {
	            var ret = false;
	            var narray = [];
	            if (this.watchFunctions.length > 0) {
	                for (var i = 0; i < this.watchFunctions.length; ++i) {
	                    if (this.watchFunctions[i](el) === true) {
	                        ret = true;
	                    } else {
	                        narray.push(this.watchFunctions[i]);
	                    }
	                }
	                this.watchFunctions = narray;
	            }
	            return ret;
	        };

	        // Renderer.prototype.splitFragmentsIntoLines = function(fragments, styles, overrideAvailWidth) {
	        //     var currentLineLength,
	        //         defaultFontSize,
	        //         ff,
	        //         fontMetrics,
	        //         fontMetricsCache,
	        //         fragment,
	        //         fragmentChopped,
	        //         fragmentLength,
	        //         fragmentSpecificMetrics,
	        //         fs,
	        //         k,
	        //         line,
	        //         lines,
	        //         maxLineLength,
	        //         style;
	        //     defaultFontSize = 12;
	        //     k = this.pdf.internal.scaleFactor;
	        //     fontMetricsCache = {};
	        //     ff = void 0;
	        //     fs = void 0;
	        //     fontMetrics = void 0;
	        //     fragment = void 0;
	        //     style = void 0;
	        //     fragmentSpecificMetrics = void 0;
	        //     fragmentLength = void 0;
	        //     fragmentChopped = void 0;
	        //     line = [];
	        //     lines = [line];
	        //     currentLineLength = 0;
	        //     maxLineLength = overrideAvailWidth || this.settings.width;
	        //     while (fragments.length) {
	        //         fragment = fragments.shift();
	        //         style = styles.shift();
	        //         if (fragment) {
	        //             ff = style["font-family"];
	        //             fs = style["font-style"];
	        //             fontMetrics = fontMetricsCache[ff + fs];
	        //             if (!fontMetrics) {
	        //                 fontMetrics = this.pdf.internal.getFont(ff, fs).metadata.Unicode;
	        //                 fontMetricsCache[ff + fs] = fontMetrics;
	        //             }
	        //             if (!fontMetrics) {
	        //                 fontMetrics = this.pdf.internal.getFont('helvetica', 'normal').metadata.Unicode;
	        //             }
	        //             fragmentSpecificMetrics = {
	        //                 widths: fontMetrics.widths,
	        //                 kerning: fontMetrics.kerning,
	        //                 fontSize: style["font-size"] * defaultFontSize,
	        //                 textIndent: currentLineLength
	        //             };
	        //             fragmentLength = this.pdf.getStringUnitWidth(fragment, fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k;
	        //             if (currentLineLength + fragmentLength > maxLineLength) {
	        //                 fragmentChopped = this.pdf.splitTextToSize(fragment, maxLineLength, fragmentSpecificMetrics);
	        //                 line.push([fragmentChopped.shift(), style]);
	        //                 while (fragmentChopped.length) {
	        //                     line = [
	        //                         [fragmentChopped.shift(), style]
	        //                     ];
	        //                     lines.push(line);
	        //                 }
	        //                 currentLineLength = this.pdf.getStringUnitWidth(line[0][0], fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k;
	        //             } else {
	        //                 line.push([fragment, style]);
	        //                 currentLineLength += fragmentLength;
	        //             }
	        //         }
	        //     }

	        //     //if text alignment was set, set margin/indent of each line
	        //     if (style['text-align'] !== undefined && (style['text-align'] === 'center' || style['text-align'] === 'right' || style['text-align'] === 'justify')) {
	        //         for (var i = 0; i < lines.length; ++i) {
	        //             if (lines[i].length === 0) continue;
	        //             var length = this.pdf.getStringUnitWidth(lines[i][0][0], fragmentSpecificMetrics) * fragmentSpecificMetrics.fontSize / k;
	        //             //if there is more than on line we have to clone the style object as all lines hold a reference on this object
	        //             if (i > 0) {
	        //                 lines[i][0][1] = clone(lines[i][0][1]);
	        //             }
	        //             var space = (maxLineLength - length);

	        //             if (style['text-align'] === 'right') {
	        //                 lines[i][0][1]['margin-left'] = space;
	        //                 //if alignment is not right, it has to be center so split the space to the left and the right
	        //             } else if (style['text-align'] === 'center') {
	        //                 lines[i][0][1]['margin-left'] = space / 2;
	        //                 //if justify was set, calculate the word spacing and define in by using the css property
	        //             } else if (style['text-align'] === 'justify') {
	        //                 var countSpaces = lines[i][0][0].split(' ').length - 1;
	        //                 lines[i][0][1]['word-spacing'] = space / countSpaces;
	        //                 //ignore the last line in justify mode
	        //                 if (i === (lines.length - 1)) {
	        //                     lines[i][0][1]['word-spacing'] = 0;
	        //                 }
	        //             }
	        //         }
	        //     }

	        //     return lines;
	        // };
	        // Renderer.prototype.RenderTextFragment = function(text, style) {
	        //     var defaultFontSize,
	        //         font,
	        //         maxLineHeight;

	        //     maxLineHeight = 0;
	        //     defaultFontSize = 12;

	        //     if (this.pdf.internal.pageSize.height - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize()) {
	        //         this.pdf.internal.write("ET", "Q");
	        //         this.pdf.addPage();
	        //         this.y = this.pdf.margins_doc.top;
	        //         this.pdf.internal.write("q", "BT", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
	        //         //move cursor by one line on new page
	        //         maxLineHeight = Math.max(maxLineHeight, style["line-height"], style["font-size"]);
	        //         this.pdf.internal.write(0, (-1 * defaultFontSize * maxLineHeight).toFixed(2), "Td");
	        //     }

	        //     font = this.pdf.internal.getFont(style["font-family"], style["font-style"]);

	        //     //set the word spacing for e.g. justify style
	        //     if (style['word-spacing'] !== undefined && style['word-spacing'] > 0) {
	        //         this.pdf.internal.write(style['word-spacing'].toFixed(2), "Tw");
	        //     }

	        //     this.pdf.internal.write("/" + font.id, (defaultFontSize * style["font-size"]).toFixed(2), "Tf", "(" + this.pdf.internal.pdfEscape(text) + ") Tj");

	        //     //set the word spacing back to neutral => 0
	        //     if (style['word-spacing'] !== undefined) {
	        //         this.pdf.internal.write(0, "Tw");
	        //     }
	        // };

	        // Renderer.prototype.renderParagraph = function(cb) {
	        //     var blockstyle,
	        //         defaultFontSize,
	        //         fontToUnitRatio,
	        //         fragments,
	        //         i,
	        //         l,
	        //         line,
	        //         lines,
	        //         maxLineHeight,
	        //         out,
	        //         paragraphspacing_after,
	        //         paragraphspacing_before,
	        //         priorblockstype,
	        //         styles,
	        //         fontSize;
	        //     fragments = PurgeWhiteSpace(this.paragraph.text);
	        //     styles = this.paragraph.style;
	        //     blockstyle = this.paragraph.blockstyle;
	        //     priorblockstype = this.paragraph.blockstyle || {};
	        //     this.paragraph = {
	        //         text: [],
	        //         style: [],
	        //         blockstyle: {},
	        //         priorblockstyle: blockstyle
	        //     };
	        //     if (!fragments.join("").trim()) {
	        //         return;
	        //     }
	        //     lines = this.splitFragmentsIntoLines(fragments, styles);
	        //     line = void 0;
	        //     maxLineHeight = void 0;
	        //     defaultFontSize = 12;
	        //     fontToUnitRatio = defaultFontSize / this.pdf.internal.scaleFactor;
	        //     paragraphspacing_before = (Math.max((blockstyle["margin-top"] || 0) - (priorblockstype["margin-bottom"] || 0), 0) + (blockstyle["padding-top"] || 0)) * fontToUnitRatio;
	        //     paragraphspacing_after = ((blockstyle["margin-bottom"] || 0) + (blockstyle["padding-bottom"] || 0)) * fontToUnitRatio;
	        //     out = this.pdf.internal.write;
	        //     i = void 0;
	        //     l = void 0;
	        //     this.y += paragraphspacing_before;
	        //     out("q", "BT", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");

	        //     //stores the current indent of cursor position
	        //     var currentIndent = 0;

	        //     while (lines.length) {
	        //         line = lines.shift();
	        //         maxLineHeight = 0;
	        //         i = 0;
	        //         l = line.length;
	        //         while (i !== l) {
	        //             if (line[i][0].trim()) {
	        //                 maxLineHeight = Math.max(maxLineHeight, line[i][1]["line-height"], line[i][1]["font-size"]);
	        //                 fontSize = line[i][1]["font-size"] * 7;
	        //             }
	        //             i++;
	        //         }
	        //         //if we have to move the cursor to adapt the indent
	        //         var indentMove = 0;
	        //         //if a margin was added (by e.g. a text-alignment), move the cursor
	        //         if (line[0][1]["margin-left"] !== undefined && line[0][1]["margin-left"] > 0) {
	        //             wantedIndent = this.pdf.internal.getCoordinateString(line[0][1]["margin-left"]);
	        //             indentMove = wantedIndent - currentIndent;
	        //             currentIndent = wantedIndent;
	        //         }
	        //         //move the cursor
	        //         out(indentMove, (-1 * defaultFontSize * maxLineHeight).toFixed(2), "Td");
	        //         i = 0;
	        //         l = line.length;
	        //         while (i !== l) {
	        //             if (line[i][0]) {
	        //                 this.RenderTextFragment(line[i][0], line[i][1]);
	        //             }
	        //             i++;
	        //         }
	        //         this.y += maxLineHeight * fontToUnitRatio;

	        //         //if some watcher function was executed sucessful, so e.g. margin and widths were changed,
	        //         //reset line drawing and calculate position and lines again
	        //         //e.g. to stop text floating around an image
	        //         if (this.executeWatchFunctions(line[0][1]) && lines.length > 0) {
	        //             var localFragments = [];
	        //             var localStyles = [];
	        //             //create fragement array of 
	        //             lines.forEach(function(localLine) {
	        //                 var i = 0;
	        //                 var l = localLine.length;
	        //                 while (i !== l) {
	        //                     if (localLine[i][0]) {
	        //                         localFragments.push(localLine[i][0] + ' ');
	        //                         localStyles.push(localLine[i][1]);
	        //                     }
	        //                     ++i;
	        //                 }
	        //             });
	        //             //split lines again due to possible coordinate changes
	        //             lines = this.splitFragmentsIntoLines(PurgeWhiteSpace(localFragments), localStyles);
	        //             //reposition the current cursor
	        //             out("ET", "Q");
	        //             out("q", "BT", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
	        //         }

	        //     }
	        //     if (cb && typeof cb === "function") {
	        //         cb.call(this, this.x - 9, this.y - fontSize / 2);
	        //     }
	        //     out("ET", "Q");
	        //     return this.y += paragraphspacing_after;
	        // };
	        // Renderer.prototype.setBlockBoundary = function(cb) {
	        //     return this.renderParagraph(cb);
	        // };
	        // Renderer.prototype.setBlockStyle = function(css) {
	        //     return this.paragraph.blockstyle = css;
	        // };
	        // Renderer.prototype.addText = function(text, css) {
	        //     this.paragraph.text.push(text);
	        //     return this.paragraph.style.push(css);
	        // };
	        FontNameDB = {
	            helvetica: "helvetica",
	            "sans-serif": "helvetica",
	            "times new roman": "times",
	            serif: "times",
	            times: "times",
	            monospace: "courier",
	            courier: "courier"
	        };
	        FontWeightMap = {
	            100: "normal",
	            200: "normal",
	            300: "normal",
	            400: "normal",
	            500: "bold",
	            600: "bold",
	            700: "bold",
	            800: "bold",
	            900: "bold",
	            normal: "normal",
	            bold: "bold",
	            bolder: "bold",
	            lighter: "normal"
	        };
	        FontStyleMap = {
	            normal: "normal",
	            italic: "italic",
	            oblique: "italic"
	        };
	        TextAlignMap = {
	            left: "left",
	            right: "right",
	            center: "center",
	            justify: "justify"
	        };
	        FloatMap = {
	            none: 'none',
	            right: 'right',
	            left: 'left'
	        };
	        ClearMap = {
	            none: 'none',
	            both: 'both'
	        };
	        UnitedNumberMap = {
	            normal: 1
	        };
	        /**
	         * Converts HTML-formatted text into formatted PDF text.
	         *
	         * Notes:
	         * 2012-07-18
	         * Plugin relies on having browser, DOM around. The HTML is pushed into dom and traversed.
	         * Plugin relies on jQuery for CSS extraction.
	         * Targeting HTML output from Markdown templating, which is a very simple
	         * markup - div, span, em, strong, p. No br-based paragraph separation supported explicitly (but still may work.)
	         * Images, tables are NOT supported.
	         *
	         * @public
	         * @function
	         * @param HTML {String or DOM Element} HTML-formatted text, or pointer to DOM element that is to be rendered into PDF.
	         * @param x {Number} starting X coordinate in jsPDF instance's declared units.
	         * @param y {Number} starting Y coordinate in jsPDF instance's declared units.
	         * @param settings {Object} Additional / optional variables controlling parsing, rendering.
	         * @returns {Object} jsPDF instance
	         */
	        jsPDFAPI.fromHTML = function (HTML, x, y, settings, margins, customFonts, referencedFonts, usedFonts, fontFamilyOverrides, callback) {
	            "use strict";

	            this.margins_doc = margins || {
	                top: 0,
	                bottom: 0,
	                left: 0,
	                right: 0
	            };
	            if (!settings) settings = {};
	            if (!settings.elementHandlers) settings.elementHandlers = {};
	            // settings.defaultFontFamily = defaultFontFamily;
	            fontOverrides = fontFamilyOverrides || {};
	            customFonts.forEach(function (fontFamily) {
	                FontNameDB[fontFamily.toLowerCase()] = fontFamily;
	            });
	            referencedFonts.forEach(function (font) {
	                FontNameDB[font.name.toLowerCase()] = font.name;
	            });

	            return process.call(this, this, HTML, isNaN(x) ? 4 : x, this.margins_doc.top, settings, callback);
	        };
	    })(jsPDF.API);
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A class to parse color values
	 * @author Stoyan Stefanov <sstoo@gmail.com>
	 * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
	 * @license Use it if you like it
	 */

	module.exports = function(window) {

	(function ( global ) {
	 
	    function RGBColor(color_string)
	    {
	        this.ok = false;

	        // strip any leading #
	        if (color_string.charAt(0) == '#') { // remove # if any
	            color_string = color_string.substr(1,6);
	        }

	        color_string = color_string.replace(/ /g,'');
	        color_string = color_string.toLowerCase();

	        // before getting into regexps, try simple matches
	        // and overwrite the input
	        var simple_colors = {
	            aliceblue: 'f0f8ff',
	            antiquewhite: 'faebd7',
	            aqua: '00ffff',
	            aquamarine: '7fffd4',
	            azure: 'f0ffff',
	            beige: 'f5f5dc',
	            bisque: 'ffe4c4',
	            black: '000000',
	            blanchedalmond: 'ffebcd',
	            blue: '0000ff',
	            blueviolet: '8a2be2',
	            brown: 'a52a2a',
	            burlywood: 'deb887',
	            cadetblue: '5f9ea0',
	            chartreuse: '7fff00',
	            chocolate: 'd2691e',
	            coral: 'ff7f50',
	            cornflowerblue: '6495ed',
	            cornsilk: 'fff8dc',
	            crimson: 'dc143c',
	            cyan: '00ffff',
	            darkblue: '00008b',
	            darkcyan: '008b8b',
	            darkgoldenrod: 'b8860b',
	            darkgray: 'a9a9a9',
	            darkgreen: '006400',
	            darkkhaki: 'bdb76b',
	            darkmagenta: '8b008b',
	            darkolivegreen: '556b2f',
	            darkorange: 'ff8c00',
	            darkorchid: '9932cc',
	            darkred: '8b0000',
	            darksalmon: 'e9967a',
	            darkseagreen: '8fbc8f',
	            darkslateblue: '483d8b',
	            darkslategray: '2f4f4f',
	            darkturquoise: '00ced1',
	            darkviolet: '9400d3',
	            deeppink: 'ff1493',
	            deepskyblue: '00bfff',
	            dimgray: '696969',
	            dodgerblue: '1e90ff',
	            feldspar: 'd19275',
	            firebrick: 'b22222',
	            floralwhite: 'fffaf0',
	            forestgreen: '228b22',
	            fuchsia: 'ff00ff',
	            gainsboro: 'dcdcdc',
	            ghostwhite: 'f8f8ff',
	            gold: 'ffd700',
	            goldenrod: 'daa520',
	            gray: '808080',
	            green: '008000',
	            greenyellow: 'adff2f',
	            honeydew: 'f0fff0',
	            hotpink: 'ff69b4',
	            indianred : 'cd5c5c',
	            indigo : '4b0082',
	            ivory: 'fffff0',
	            khaki: 'f0e68c',
	            lavender: 'e6e6fa',
	            lavenderblush: 'fff0f5',
	            lawngreen: '7cfc00',
	            lemonchiffon: 'fffacd',
	            lightblue: 'add8e6',
	            lightcoral: 'f08080',
	            lightcyan: 'e0ffff',
	            lightgoldenrodyellow: 'fafad2',
	            lightgrey: 'd3d3d3',
	            lightgreen: '90ee90',
	            lightpink: 'ffb6c1',
	            lightsalmon: 'ffa07a',
	            lightseagreen: '20b2aa',
	            lightskyblue: '87cefa',
	            lightslateblue: '8470ff',
	            lightslategray: '778899',
	            lightsteelblue: 'b0c4de',
	            lightyellow: 'ffffe0',
	            lime: '00ff00',
	            limegreen: '32cd32',
	            linen: 'faf0e6',
	            magenta: 'ff00ff',
	            maroon: '800000',
	            mediumaquamarine: '66cdaa',
	            mediumblue: '0000cd',
	            mediumorchid: 'ba55d3',
	            mediumpurple: '9370d8',
	            mediumseagreen: '3cb371',
	            mediumslateblue: '7b68ee',
	            mediumspringgreen: '00fa9a',
	            mediumturquoise: '48d1cc',
	            mediumvioletred: 'c71585',
	            midnightblue: '191970',
	            mintcream: 'f5fffa',
	            mistyrose: 'ffe4e1',
	            moccasin: 'ffe4b5',
	            navajowhite: 'ffdead',
	            navy: '000080',
	            oldlace: 'fdf5e6',
	            olive: '808000',
	            olivedrab: '6b8e23',
	            orange: 'ffa500',
	            orangered: 'ff4500',
	            orchid: 'da70d6',
	            palegoldenrod: 'eee8aa',
	            palegreen: '98fb98',
	            paleturquoise: 'afeeee',
	            palevioletred: 'd87093',
	            papayawhip: 'ffefd5',
	            peachpuff: 'ffdab9',
	            peru: 'cd853f',
	            pink: 'ffc0cb',
	            plum: 'dda0dd',
	            powderblue: 'b0e0e6',
	            purple: '800080',
	            red: 'ff0000',
	            rosybrown: 'bc8f8f',
	            royalblue: '4169e1',
	            saddlebrown: '8b4513',
	            salmon: 'fa8072',
	            sandybrown: 'f4a460',
	            seagreen: '2e8b57',
	            seashell: 'fff5ee',
	            sienna: 'a0522d',
	            silver: 'c0c0c0',
	            skyblue: '87ceeb',
	            slateblue: '6a5acd',
	            slategray: '708090',
	            snow: 'fffafa',
	            springgreen: '00ff7f',
	            steelblue: '4682b4',
	            tan: 'd2b48c',
	            teal: '008080',
	            thistle: 'd8bfd8',
	            tomato: 'ff6347',
	            turquoise: '40e0d0',
	            violet: 'ee82ee',
	            violetred: 'd02090',
	            wheat: 'f5deb3',
	            white: 'ffffff',
	            whitesmoke: 'f5f5f5',
	            yellow: 'ffff00',
	            yellowgreen: '9acd32'
	        };
	        for (var key in simple_colors) {
	            if (color_string == key) {
	                color_string = simple_colors[key];
	            }
	        }
	        // emd of simple type-in colors

	        // array of color definition objects
	        var color_defs = [
	            {
	                re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
	                example: ['rgb(123, 234, 45)', 'rgb(255,234,245)'],
	                process: function (bits){
	                    return [
	                        parseInt(bits[1]),
	                        parseInt(bits[2]),
	                        parseInt(bits[3])
	                    ];
	                }
	            },
	            {
	                re: /^(\w{2})(\w{2})(\w{2})$/,
	                example: ['#00ff00', '336699'],
	                process: function (bits){
	                    return [
	                        parseInt(bits[1], 16),
	                        parseInt(bits[2], 16),
	                        parseInt(bits[3], 16)
	                    ];
	                }
	            },
	            {
	                re: /^(\w{1})(\w{1})(\w{1})$/,
	                example: ['#fb0', 'f0f'],
	                process: function (bits){
	                    return [
	                        parseInt(bits[1] + bits[1], 16),
	                        parseInt(bits[2] + bits[2], 16),
	                        parseInt(bits[3] + bits[3], 16)
	                    ];
	                }
	            }
	        ];

	        // search through the definitions to find a match
	        for (var i = 0; i < color_defs.length; i++) {
	            var re = color_defs[i].re;
	            var processor = color_defs[i].process;
	            var bits = re.exec(color_string);
	            if (bits) {
	                channels = processor(bits);
	                this.r = channels[0];
	                this.g = channels[1];
	                this.b = channels[2];
	                this.ok = true;
	            }

	        }

	        // validate/cleanup values
	        this.r = (this.r < 0 || isNaN(this.r)) ? 0 : ((this.r > 255) ? 255 : this.r);
	        this.g = (this.g < 0 || isNaN(this.g)) ? 0 : ((this.g > 255) ? 255 : this.g);
	        this.b = (this.b < 0 || isNaN(this.b)) ? 0 : ((this.b > 255) ? 255 : this.b);

	        // some getters
	        this.toRGB = function () {
	            return 'rgb(' + this.r + ', ' + this.g + ', ' + this.b + ')';
	        }
	        this.toHex = function () {
	            var r = this.r.toString(16);
	            var g = this.g.toString(16);
	            var b = this.b.toString(16);
	            if (r.length == 1) r = '0' + r;
	            if (g.length == 1) g = '0' + g;
	            if (b.length == 1) b = '0' + b;
	            return '#' + r + g + b;
	        }

	        // help
	        this.getHelpXML = function () {

	            var examples = new Array();
	            // add regexps
	            for (var i = 0; i < color_defs.length; i++) {
	                var example = color_defs[i].example;
	                for (var j = 0; j < example.length; j++) {
	                    examples[examples.length] = example[j];
	                }
	            }
	            // add type-in colors
	            for (var sc in simple_colors) {
	                examples[examples.length] = sc;
	            }

	            var xml = document.createElement('ul');
	            xml.setAttribute('id', 'rgbcolor-examples');
	            for (var i = 0; i < examples.length; i++) {
	                try {
	                    var list_item = document.createElement('li');
	                    var list_color = new RGBColor(examples[i]);
	                    var example_div = document.createElement('div');
	                    example_div.style.cssText =
	                            'margin: 3px; '
	                            + 'border: 1px solid black; '
	                            + 'background:' + list_color.toHex() + '; '
	                            + 'color:' + list_color.toHex()
	                    ;
	                    example_div.appendChild(document.createTextNode('test'));
	                    var list_item_value = document.createTextNode(
	                        ' ' + examples[i] + ' -> ' + list_color.toRGB() + ' -> ' + list_color.toHex()
	                    );
	                    list_item.appendChild(example_div);
	                    list_item.appendChild(list_item_value);
	                    xml.appendChild(list_item);

	                } catch(e){}
	            }
	            return xml;

	        }

	    }

	    // export as AMD...
	    if ( true ) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return RGBColor; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }

	    // ...or as browserify
	    else if ( typeof module !== 'undefined' && module.exports ) {
	        module.exports = RGBColor;
	    }

	    global.RGBColor = RGBColor;

	}(window));
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {/*
	 * canvg.js - Javascript SVG parser and renderer on Canvas
	 * MIT Licensed
	 * Gabe Lerner (gabelerner@gmail.com)
	 * http://code.google.com/p/canvg/
	 *
	 * Requires: rgbcolor.js - http://www.phpied.com/rgb-color-parser-in-javascript/
	 */
	 module.exports = function(window) {

	 (function ( global, factory ) {

	    'use strict';

	    // // export as AMD...
	    // if ( typeof define !== 'undefined' && define.amd ) {
	    //     define('canvgModule', [ 'rgbcolor', 'stackblur' ], factory );
	    // }

	    // // ...or as browserify
	    // else if ( typeof module !== 'undefined' && module.exports ) {
	    //     module.exports = factory( require( 'rgbcolor' ), require( 'stackblur' ) );
	    // }

	    global.canvg = factory( global.RGBColor, global.stackBlur );

	}( typeof window !== 'undefined' ? window : this, function ( RGBColor, stackBlur ) {
	 
	    // canvg(target, s)
	    // empty parameters: replace all 'svg' elements on page with 'canvas' elements
	    // target: canvas element or the id of a canvas element
	    // s: svg string, url to svg file, or xml document
	    // opts: optional hash of options
	    //       ignoreMouse: true => ignore mouse events
	    //       ignoreAnimation: true => ignore animations
	    //       ignoreDimensions: true => does not try to resize canvas
	    //       ignoreClear: true => does not clear canvas
	    //       offsetX: int => draws at a x offset
	    //       offsetY: int => draws at a y offset
	    //       scaleWidth: int => scales horizontally to width
	    //       scaleHeight: int => scales vertically to height
	    //       renderCallback: function => will call the function after the first render is completed
	    //       forceRedraw: function => will call the function on every frame, if it returns true, will redraw
	    var canvg = function (target, s, opts) {
	        // no parameters
	        var htmlDocument = window.document;
	        if (target == null && s == null && opts == null) {
	            var svgTags = htmlDocument.querySelectorAll('svg');
	            for (var i=0; i<svgTags.length; i++) {
	                var svgTag = svgTags[i];
	                var c = htmlDocument.createElement('canvas');
	                c.width = svgTag.clientWidth;
	                c.height = svgTag.clientHeight;
	                svgTag.parentNode.insertBefore(c, svgTag);
	                svgTag.parentNode.removeChild(svgTag);
	                var div = htmlDocument.createElement('div');
	                div.appendChild(svgTag);
	                canvg(c, div.innerHTML);
	            }
	            return;
	        }

	        if (typeof target == 'string') {
	            target = htmlDocument.getElementById(target);
	        }

	        // store class on canvas
	        if (target.svg != null) target.svg.stop();
	        var svg = build(opts || {});
	        // on i.e. 8 for flash canvas, we can't assign the property so check for it
	        if (!(target.childNodes.length == 1 && target.childNodes[0].nodeName == 'OBJECT')) target.svg = svg;

	        var ctx = target.getContext('2d');
	        if (typeof(s.documentElement) != 'undefined') {
	            // load from xml doc
	            svg.loadXmlDoc(ctx, s);
	        }
	        else if (s.substr(0,1) == '<') {
	            // load from xml string
	            svg.loadXml(ctx, s);
	        }
	        else {
	            // load from url
	            svg.load(ctx, s);
	        }
	    }

	    // see https://developer.mozilla.org/en-US/docs/Web/API/Element.matches
	    var matchesSelector;
	    var Element = window.Element;
	    if (typeof(Element.prototype.matches) != 'undefined') {
	        matchesSelector = function(node, selector) {
	            return node.matches(selector);
	        };
	    } else if (typeof(Element.prototype.webkitMatchesSelector) != 'undefined') {
	        matchesSelector = function(node, selector) {
	            return node.webkitMatchesSelector(selector);
	        };
	    } else if (typeof(Element.prototype.mozMatchesSelector) != 'undefined') {
	        matchesSelector = function(node, selector) {
	            return node.mozMatchesSelector(selector);
	        };
	    } else if (typeof(Element.prototype.msMatchesSelector) != 'undefined') {
	        matchesSelector = function(node, selector) {
	            return node.msMatchesSelector(selector);
	        };
	    } else if (typeof(Element.prototype.oMatchesSelector) != 'undefined') {
	        matchesSelector = function(node, selector) {
	            return node.oMatchesSelector(selector);
	        };
	    } else {
	        // requires Sizzle: https://github.com/jquery/sizzle/wiki/Sizzle-Documentation
	        // or jQuery: http://jquery.com/download/
	        // or Zepto: http://zeptojs.com/#
	        // without it, this is a ReferenceError

	        if (typeof jQuery === 'function' || typeof Zepto === 'function') {
	            matchesSelector = function (node, selector) {
	                return $(node).is(selector);
	            };
	        }

	        if (typeof matchesSelector === 'undefined') {
	            matchesSelector = Sizzle.matchesSelector;
	        }
	    }

	    // slightly modified version of https://github.com/keeganstreet/specificity/blob/master/specificity.js
	    var attributeRegex = /(\[[^\]]+\])/g;
	    var idRegex = /(#[^\s\+>~\.\[:]+)/g;
	    var classRegex = /(\.[^\s\+>~\.\[:]+)/g;
	    var pseudoElementRegex = /(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi;
	    var pseudoClassWithBracketsRegex = /(:[\w-]+\([^\)]*\))/gi;
	    var pseudoClassRegex = /(:[^\s\+>~\.\[:]+)/g;
	    var elementRegex = /([^\s\+>~\.\[:]+)/g;
	    function getSelectorSpecificity(selector) {
	        var typeCount = [0, 0, 0];
	        var findMatch = function(regex, type) {
	            var matches = selector.match(regex);
	            if (matches == null) {
	                return;
	            }
	            typeCount[type] += matches.length;
	            selector = selector.replace(regex, ' ');
	        };

	        selector = selector.replace(/:not\(([^\)]*)\)/g, '     $1 ');
	        selector = selector.replace(/{[^]*/gm, ' ');
	        findMatch(attributeRegex, 1);
	        findMatch(idRegex, 0);
	        findMatch(classRegex, 1);
	        findMatch(pseudoElementRegex, 2);
	        findMatch(pseudoClassWithBracketsRegex, 1);
	        findMatch(pseudoClassRegex, 1);
	        selector = selector.replace(/[\*\s\+>~]/g, ' ');
	        selector = selector.replace(/[#\.]/g, ' ');
	        findMatch(elementRegex, 2);
	        return typeCount.join('');
	    }

	    function build(opts) {
	        var svg = { opts: opts };

	        svg.FRAMERATE = 30;
	        svg.MAX_VIRTUAL_PIXELS = 30000;

	        svg.log = function(msg) {};
	        if (svg.opts['log'] == true && typeof(console) != 'undefined') {
	            svg.log = function(msg) { console.log(msg); };
	        };

	        // globals
	        svg.init = function(ctx) {
	            var uniqueId = 0;
	            svg.UniqueId = function () { uniqueId++; return 'canvg' + uniqueId; };
	            svg.Definitions = {};
	            svg.Styles = {};
	            svg.StylesSpecificity = {};
	            svg.Animations = [];
	            svg.Images = [];
	            svg.ctx = ctx;
	            svg.ViewPort = new (function () {
	                this.viewPorts = [];
	                this.Clear = function() { this.viewPorts = []; }
	                this.SetCurrent = function(width, height) { this.viewPorts.push({ width: width, height: height }); }
	                this.RemoveCurrent = function() { this.viewPorts.pop(); }
	                this.Current = function() { return this.viewPorts[this.viewPorts.length - 1]; }
	                this.width = function() { return this.Current().width; }
	                this.height = function() { return this.Current().height; }
	                this.ComputeSize = function(d) {
	                    if (d != null && typeof(d) == 'number') return d;
	                    if (d == 'x') return this.width();
	                    if (d == 'y') return this.height();
	                    return Math.sqrt(Math.pow(this.width(), 2) + Math.pow(this.height(), 2)) / Math.sqrt(2);
	                }
	            });
	        }
	        svg.init();

	        // images loaded
	        svg.ImagesLoaded = function() {
	            for (var i=0; i<svg.Images.length; i++) {
	                if (!svg.Images[i].loaded) return false;
	            }
	            return true;
	        }

	        // trim
	        svg.trim = function(s) { return s.replace(/^\s+|\s+$/g, ''); }

	        // compress spaces
	        svg.compressSpaces = function(s) { return s.replace(/[\s\r\t\n]+/gm,' '); }

	        // ajax
	        svg.ajax = function(url) {
	            var AJAX;
	            if(window.XMLHttpRequest){AJAX=new XMLHttpRequest();}
	            else{AJAX=new ActiveXObject('Microsoft.XMLHTTP');}
	            if(AJAX){
	               AJAX.open('GET',url,false);
	               AJAX.send(null);
	               return AJAX.responseText;
	            }
	            return null;
	        }

	        // parse xml
	        svg.parseXml = function(xml) {
	            if (typeof(Windows) != 'undefined' && typeof(Windows.Data) != 'undefined' && typeof(Windows.Data.Xml) != 'undefined') {
	                var xmlDoc = new Windows.Data.Xml.Dom.XmlDocument();
	                var settings = new Windows.Data.Xml.Dom.XmlLoadSettings();
	                settings.prohibitDtd = false;
	                xmlDoc.loadXml(xml, settings);
	                return xmlDoc;
	            }
	            else if (window.DOMParser)
	            {
	                var parser = new DOMParser();
	                return parser.parseFromString(xml, 'text/xml');
	            }
	            else
	            {
	                xml = xml.replace(/<!DOCTYPE svg[^>]*>/, '');
	                var xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
	                xmlDoc.async = 'false';
	                xmlDoc.loadXML(xml);
	                return xmlDoc;
	            }
	        }

	        svg.Property = function(name, value) {
	            this.name = name;
	            this.value = value;
	        }
	            svg.Property.prototype.getValue = function() {
	                return this.value;
	            }

	            svg.Property.prototype.hasValue = function() {
	                return (this.value != null && this.value !== '');
	            }

	            // return the numerical value of the property
	            svg.Property.prototype.numValue = function() {
	                if (!this.hasValue()) return 0;

	                var n = parseFloat(this.value);
	                if ((this.value + '').match(/%$/)) {
	                    n = n / 100.0;
	                }
	                return n;
	            }

	            svg.Property.prototype.valueOrDefault = function(def) {
	                if (this.hasValue()) return this.value;
	                return def;
	            }

	            svg.Property.prototype.numValueOrDefault = function(def) {
	                if (this.hasValue()) return this.numValue();
	                return def;
	            }

	            // color extensions
	                // augment the current color value with the opacity
	                svg.Property.prototype.addOpacity = function(opacityProp) {
	                    var newValue = this.value;
	                    if (opacityProp.value != null && opacityProp.value != '' && typeof(this.value)=='string') { // can only add opacity to colors, not patterns
	                        var color = new RGBColor(this.value);
	                        if (color.ok) {
	                            newValue = 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + opacityProp.numValue() + ')';
	                        }
	                    }
	                    return new svg.Property(this.name, newValue);
	                }

	            // definition extensions
	                // get the definition from the definitions table
	                svg.Property.prototype.getDefinition = function() {
	                    var name = this.value.match(/#([^\)'"]+)/);
	                    if (name) { name = name[1]; }
	                    if (!name) { name = this.value; }
	                    return svg.Definitions[name];
	                }

	                svg.Property.prototype.isUrlDefinition = function() {
	                    return this.value.indexOf('url(') == 0
	                }

	                svg.Property.prototype.getFillStyleDefinition = function(e, opacityProp) {
	                    var def = this.getDefinition();

	                    // gradient
	                    if (def != null && def.createGradient) {
	                        return def.createGradient(svg.ctx, e, opacityProp);
	                    }

	                    // pattern
	                    if (def != null && def.createPattern) {
	                        if (def.getHrefAttribute().hasValue()) {
	                            var pt = def.attribute('patternTransform');
	                            def = def.getHrefAttribute().getDefinition();
	                            if (pt.hasValue()) { def.attribute('patternTransform', true).value = pt.value; }
	                        }
	                        return def.createPattern(svg.ctx, e);
	                    }

	                    return null;
	                }

	            // length extensions
	                svg.Property.prototype.getDPI = function(viewPort) {
	                    return 96.0; // TODO: compute?
	                }

	                svg.Property.prototype.getEM = function(viewPort) {
	                    var em = 12;

	                    var fontSize = new svg.Property('fontSize', svg.Font.Parse(svg.ctx.font).fontSize);
	                    if (fontSize.hasValue()) em = fontSize.toPixels(viewPort);

	                    return em;
	                }

	                svg.Property.prototype.getUnits = function() {
	                    var s = this.value+'';
	                    return s.replace(/[0-9\.\-]/g,'');
	                }

	                // get the length as pixels
	                svg.Property.prototype.toPixels = function(viewPort, processPercent) {
	                    if (!this.hasValue()) return 0;
	                    var s = this.value+'';
	                    if (s.match(/em$/)) return this.numValue() * this.getEM(viewPort);
	                    if (s.match(/ex$/)) return this.numValue() * this.getEM(viewPort) / 2.0;
	                    if (s.match(/px$/)) return this.numValue();
	                    if (s.match(/pt$/)) return this.numValue() * this.getDPI(viewPort) * (1.0 / 72.0);
	                    if (s.match(/pc$/)) return this.numValue() * 15;
	                    if (s.match(/cm$/)) return this.numValue() * this.getDPI(viewPort) / 2.54;
	                    if (s.match(/mm$/)) return this.numValue() * this.getDPI(viewPort) / 25.4;
	                    if (s.match(/in$/)) return this.numValue() * this.getDPI(viewPort);
	                    if (s.match(/%$/)) return this.numValue() * svg.ViewPort.ComputeSize(viewPort);
	                    var n = this.numValue();
	                    if (processPercent && n < 1.0) return n * svg.ViewPort.ComputeSize(viewPort);
	                    return n;
	                }

	            // time extensions
	                // get the time as milliseconds
	                svg.Property.prototype.toMilliseconds = function() {
	                    if (!this.hasValue()) return 0;
	                    var s = this.value+'';
	                    if (s.match(/s$/)) return this.numValue() * 1000;
	                    if (s.match(/ms$/)) return this.numValue();
	                    return this.numValue();
	                }

	            // angle extensions
	                // get the angle as radians
	                svg.Property.prototype.toRadians = function() {
	                    if (!this.hasValue()) return 0;
	                    var s = this.value+'';
	                    if (s.match(/deg$/)) return this.numValue() * (Math.PI / 180.0);
	                    if (s.match(/grad$/)) return this.numValue() * (Math.PI / 200.0);
	                    if (s.match(/rad$/)) return this.numValue();
	                    return this.numValue() * (Math.PI / 180.0);
	                }

	            // text extensions
	                // get the text baseline
	                var textBaselineMapping = {
	                    'baseline': 'alphabetic',
	                    'before-edge': 'top',
	                    'text-before-edge': 'top',
	                    'middle': 'middle',
	                    'central': 'middle',
	                    'after-edge': 'bottom',
	                    'text-after-edge': 'bottom',
	                    'ideographic': 'ideographic',
	                    'alphabetic': 'alphabetic',
	                    'hanging': 'hanging',
	                    'mathematical': 'alphabetic'
	                };
	                svg.Property.prototype.toTextBaseline = function () {
	                    if (!this.hasValue()) return null;
	                    return textBaselineMapping[this.value];
	                }

	        // fonts
	        svg.Font = new (function() {
	            this.Styles = 'normal|italic|oblique|inherit';
	            this.Variants = 'normal|small-caps|inherit';
	            this.Weights = 'normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit';

	            this.CreateFont = function(fontStyle, fontVariant, fontWeight, fontSize, fontFamily, inherit) {
	                var f = inherit != null ? this.Parse(inherit) : this.CreateFont('', '', '', '', '', svg.ctx.font);
	                return {
	                    fontFamily: fontFamily || f.fontFamily,
	                    fontSize: fontSize || f.fontSize,
	                    fontStyle: fontStyle || f.fontStyle,
	                    fontWeight: fontWeight || f.fontWeight,
	                    fontVariant: fontVariant || f.fontVariant,
	                    toString: function () { return [this.fontStyle, this.fontVariant, this.fontWeight, this.fontSize, this.fontFamily].join(' ') }
	                }
	            }

	            var that = this;
	            this.Parse = function(s) {
	                var f = {};
	                var d = svg.trim(svg.compressSpaces(s || '')).split(' ');
	                var set = { fontSize: false, fontStyle: false, fontWeight: false, fontVariant: false }
	                var ff = '';
	                for (var i=0; i<d.length; i++) {
	                    if (!set.fontStyle && that.Styles.indexOf(d[i]) != -1) { if (d[i] != 'inherit') f.fontStyle = d[i]; set.fontStyle = true; }
	                    else if (!set.fontVariant && that.Variants.indexOf(d[i]) != -1) { if (d[i] != 'inherit') f.fontVariant = d[i]; set.fontStyle = set.fontVariant = true;  }
	                    else if (!set.fontWeight && that.Weights.indexOf(d[i]) != -1) { if (d[i] != 'inherit') f.fontWeight = d[i]; set.fontStyle = set.fontVariant = set.fontWeight = true; }
	                    else if (!set.fontSize) { if (d[i] != 'inherit') f.fontSize = d[i].split('/')[0]; set.fontStyle = set.fontVariant = set.fontWeight = set.fontSize = true; }
	                    else { if (d[i] != 'inherit') ff += d[i]; }
	                } if (ff != '') f.fontFamily = ff;
	                return f;
	            }
	        });

	        // points and paths
	        svg.ToNumberArray = function(s) {
	            var a = svg.trim(svg.compressSpaces((s || '').replace(/,/g, ' '))).split(' ');
	            for (var i=0; i<a.length; i++) {
	                a[i] = parseFloat(a[i]);
	            }
	            return a;
	        }
	        svg.Point = function(x, y) {
	            this.x = x;
	            this.y = y;
	        }
	            svg.Point.prototype.angleTo = function(p) {
	                return Math.atan2(p.y - this.y, p.x - this.x);
	            }

	            svg.Point.prototype.applyTransform = function(v) {
	                var xp = this.x * v[0] + this.y * v[2] + v[4];
	                var yp = this.x * v[1] + this.y * v[3] + v[5];
	                this.x = xp;
	                this.y = yp;
	            }

	        svg.CreatePoint = function(s) {
	            var a = svg.ToNumberArray(s);
	            return new svg.Point(a[0], a[1]);
	        }
	        svg.CreatePath = function(s) {
	            var a = svg.ToNumberArray(s);
	            var path = [];
	            for (var i=0; i<a.length; i+=2) {
	                path.push(new svg.Point(a[i], a[i+1]));
	            }
	            return path;
	        }

	        // bounding box
	        svg.BoundingBox = function(x1, y1, x2, y2) { // pass in initial points if you want
	            this.x1 = Number.NaN;
	            this.y1 = Number.NaN;
	            this.x2 = Number.NaN;
	            this.y2 = Number.NaN;

	            this.x = function() { return this.x1; }
	            this.y = function() { return this.y1; }
	            this.width = function() { return this.x2 - this.x1; }
	            this.height = function() { return this.y2 - this.y1; }

	            this.addPoint = function(x, y) {
	                if (x != null) {
	                    if (isNaN(this.x1) || isNaN(this.x2)) {
	                        this.x1 = x;
	                        this.x2 = x;
	                    }
	                    if (x < this.x1) this.x1 = x;
	                    if (x > this.x2) this.x2 = x;
	                }

	                if (y != null) {
	                    if (isNaN(this.y1) || isNaN(this.y2)) {
	                        this.y1 = y;
	                        this.y2 = y;
	                    }
	                    if (y < this.y1) this.y1 = y;
	                    if (y > this.y2) this.y2 = y;
	                }
	            }
	            this.addX = function(x) { this.addPoint(x, null); }
	            this.addY = function(y) { this.addPoint(null, y); }

	            this.addBoundingBox = function(bb) {
	                this.addPoint(bb.x1, bb.y1);
	                this.addPoint(bb.x2, bb.y2);
	            }

	            this.addQuadraticCurve = function(p0x, p0y, p1x, p1y, p2x, p2y) {
	                var cp1x = p0x + 2/3 * (p1x - p0x); // CP1 = QP0 + 2/3 *(QP1-QP0)
	                var cp1y = p0y + 2/3 * (p1y - p0y); // CP1 = QP0 + 2/3 *(QP1-QP0)
	                var cp2x = cp1x + 1/3 * (p2x - p0x); // CP2 = CP1 + 1/3 *(QP2-QP0)
	                var cp2y = cp1y + 1/3 * (p2y - p0y); // CP2 = CP1 + 1/3 *(QP2-QP0)
	                this.addBezierCurve(p0x, p0y, cp1x, cp2x, cp1y, cp2y, p2x, p2y);
	            }

	            this.addBezierCurve = function(p0x, p0y, p1x, p1y, p2x, p2y, p3x, p3y) {
	                // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	                var p0 = [p0x, p0y], p1 = [p1x, p1y], p2 = [p2x, p2y], p3 = [p3x, p3y];
	                this.addPoint(p0[0], p0[1]);
	                this.addPoint(p3[0], p3[1]);

	                for (i=0; i<=1; i++) {
	                    var f = function(t) {
	                        return Math.pow(1-t, 3) * p0[i]
	                        + 3 * Math.pow(1-t, 2) * t * p1[i]
	                        + 3 * (1-t) * Math.pow(t, 2) * p2[i]
	                        + Math.pow(t, 3) * p3[i];
	                    }

	                    var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	                    var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	                    var c = 3 * p1[i] - 3 * p0[i];

	                    if (a == 0) {
	                        if (b == 0) continue;
	                        var t = -c / b;
	                        if (0 < t && t < 1) {
	                            if (i == 0) this.addX(f(t));
	                            if (i == 1) this.addY(f(t));
	                        }
	                        continue;
	                    }

	                    var b2ac = Math.pow(b, 2) - 4 * c * a;
	                    if (b2ac < 0) continue;
	                    var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
	                    if (0 < t1 && t1 < 1) {
	                        if (i == 0) this.addX(f(t1));
	                        if (i == 1) this.addY(f(t1));
	                    }
	                    var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
	                    if (0 < t2 && t2 < 1) {
	                        if (i == 0) this.addX(f(t2));
	                        if (i == 1) this.addY(f(t2));
	                    }
	                }
	            }

	            this.isPointInBox = function(x, y) {
	                return (this.x1 <= x && x <= this.x2 && this.y1 <= y && y <= this.y2);
	            }

	            this.addPoint(x1, y1);
	            this.addPoint(x2, y2);
	        }

	        // transforms
	        svg.Transform = function(v) {
	            var that = this;
	            this.Type = {}

	            // translate
	            this.Type.translate = function(s) {
	                this.p = svg.CreatePoint(s);
	                this.apply = function(ctx) {
	                    ctx.translate(this.p.x || 0.0, this.p.y || 0.0);
	                }
	                this.unapply = function(ctx) {
	                    ctx.translate(-1.0 * this.p.x || 0.0, -1.0 * this.p.y || 0.0);
	                }
	                this.applyToPoint = function(p) {
	                    p.applyTransform([1, 0, 0, 1, this.p.x || 0.0, this.p.y || 0.0]);
	                }
	            }

	            // rotate
	            this.Type.rotate = function(s) {
	                var a = svg.ToNumberArray(s);
	                this.angle = new svg.Property('angle', a[0]);
	                this.cx = a[1] || 0;
	                this.cy = a[2] || 0;
	                this.apply = function(ctx) {
	                    ctx.translate(this.cx, this.cy);
	                    ctx.rotate(this.angle.toRadians());
	                    ctx.translate(-this.cx, -this.cy);
	                }
	                this.unapply = function(ctx) {
	                    ctx.translate(this.cx, this.cy);
	                    ctx.rotate(-1.0 * this.angle.toRadians());
	                    ctx.translate(-this.cx, -this.cy);
	                }
	                this.applyToPoint = function(p) {
	                    var a = this.angle.toRadians();
	                    p.applyTransform([1, 0, 0, 1, this.p.x || 0.0, this.p.y || 0.0]);
	                    p.applyTransform([Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a), 0, 0]);
	                    p.applyTransform([1, 0, 0, 1, -this.p.x || 0.0, -this.p.y || 0.0]);
	                }
	            }

	            this.Type.scale = function(s) {
	                this.p = svg.CreatePoint(s);
	                this.apply = function(ctx) {
	                    ctx.scale(this.p.x || 1.0, this.p.y || this.p.x || 1.0);
	                }
	                this.unapply = function(ctx) {
	                    ctx.scale(1.0 / this.p.x || 1.0, 1.0 / this.p.y || this.p.x || 1.0);
	                }
	                this.applyToPoint = function(p) {
	                    p.applyTransform([this.p.x || 0.0, 0, 0, this.p.y || 0.0, 0, 0]);
	                }
	            }

	            this.Type.matrix = function(s) {
	                this.m = svg.ToNumberArray(s);
	                this.apply = function(ctx) {
	                    ctx.transform(this.m[0], this.m[1], this.m[2], this.m[3], this.m[4], this.m[5]);
	                }
	                this.unapply = function(ctx) {
	                    var a = this.m[0];
	                    var b = this.m[2];
	                    var c = this.m[4];
	                    var d = this.m[1];
	                    var e = this.m[3];
	                    var f = this.m[5];
	                    var g = 0.0;
	                    var h = 0.0;
	                    var i = 1.0;
	                    var det = 1 / (a*(e*i-f*h)-b*(d*i-f*g)+c*(d*h-e*g));
	                    ctx.transform(
	                        det*(e*i-f*h),
	                        det*(f*g-d*i),
	                        det*(c*h-b*i),
	                        det*(a*i-c*g),
	                        det*(b*f-c*e),
	                        det*(c*d-a*f)
	                    );
	                }
	                this.applyToPoint = function(p) {
	                    p.applyTransform(this.m);
	                }
	            }

	            this.Type.SkewBase = function(s) {
	                this.base = that.Type.matrix;
	                this.base(s);
	                this.angle = new svg.Property('angle', s);
	            }
	            this.Type.SkewBase.prototype = new this.Type.matrix;

	            this.Type.skewX = function(s) {
	                this.base = that.Type.SkewBase;
	                this.base(s);
	                this.m = [1, 0, Math.tan(this.angle.toRadians()), 1, 0, 0];
	            }
	            this.Type.skewX.prototype = new this.Type.SkewBase;

	            this.Type.skewY = function(s) {
	                this.base = that.Type.SkewBase;
	                this.base(s);
	                this.m = [1, Math.tan(this.angle.toRadians()), 0, 1, 0, 0];
	            }
	            this.Type.skewY.prototype = new this.Type.SkewBase;

	            this.transforms = [];

	            this.apply = function(ctx) {
	                for (var i=0; i<this.transforms.length; i++) {
	                    this.transforms[i].apply(ctx);
	                }
	            }

	            this.unapply = function(ctx) {
	                for (var i=this.transforms.length-1; i>=0; i--) {
	                    this.transforms[i].unapply(ctx);
	                }
	            }

	            this.applyToPoint = function(p) {
	                for (var i=0; i<this.transforms.length; i++) {
	                    this.transforms[i].applyToPoint(p);
	                }
	            }

	            var data = svg.trim(svg.compressSpaces(v)).replace(/\)([a-zA-Z])/g, ') $1').replace(/\)(\s?,\s?)/g,') ').split(/\s(?=[a-z])/);
	            for (var i=0; i<data.length; i++) {
	                var type = svg.trim(data[i].split('(')[0]);
	                var s = data[i].split('(')[1].replace(')','');
	                var transform = new this.Type[type](s);
	                transform.type = type;
	                this.transforms.push(transform);
	            }
	        }

	        // aspect ratio
	        svg.AspectRatio = function(ctx, aspectRatio, width, desiredWidth, height, desiredHeight, minX, minY, refX, refY) {
	            // aspect ratio - http://www.w3.org/TR/SVG/coords.html#PreserveAspectRatioAttribute
	            aspectRatio = svg.compressSpaces(aspectRatio);
	            aspectRatio = aspectRatio.replace(/^defer\s/,''); // ignore defer
	            var align = aspectRatio.split(' ')[0] || 'xMidYMid';
	            var meetOrSlice = aspectRatio.split(' ')[1] || 'meet';

	            // calculate scale
	            var scaleX = width / desiredWidth;
	            var scaleY = height / desiredHeight;
	            var scaleMin = Math.min(scaleX, scaleY);
	            var scaleMax = Math.max(scaleX, scaleY);
	            if (meetOrSlice == 'meet') { desiredWidth *= scaleMin; desiredHeight *= scaleMin; }
	            if (meetOrSlice == 'slice') { desiredWidth *= scaleMax; desiredHeight *= scaleMax; }

	            refX = new svg.Property('refX', refX);
	            refY = new svg.Property('refY', refY);
	            if (refX.hasValue() && refY.hasValue()) {
	                ctx.translate(-scaleMin * refX.toPixels('x'), -scaleMin * refY.toPixels('y'));
	            }
	            else {
	                // align
	                if (align.match(/^xMid/) && ((meetOrSlice == 'meet' && scaleMin == scaleY) || (meetOrSlice == 'slice' && scaleMax == scaleY))) ctx.translate(width / 2.0 - desiredWidth / 2.0, 0);
	                if (align.match(/YMid$/) && ((meetOrSlice == 'meet' && scaleMin == scaleX) || (meetOrSlice == 'slice' && scaleMax == scaleX))) ctx.translate(0, height / 2.0 - desiredHeight / 2.0);
	                if (align.match(/^xMax/) && ((meetOrSlice == 'meet' && scaleMin == scaleY) || (meetOrSlice == 'slice' && scaleMax == scaleY))) ctx.translate(width - desiredWidth, 0);
	                if (align.match(/YMax$/) && ((meetOrSlice == 'meet' && scaleMin == scaleX) || (meetOrSlice == 'slice' && scaleMax == scaleX))) ctx.translate(0, height - desiredHeight);
	            }

	            // scale
	            if (align == 'none') ctx.scale(scaleX, scaleY);
	            else if (meetOrSlice == 'meet') ctx.scale(scaleMin, scaleMin);
	            else if (meetOrSlice == 'slice') ctx.scale(scaleMax, scaleMax);

	            // translate
	            ctx.translate(minX == null ? 0 : -minX, minY == null ? 0 : -minY);
	        }

	        // elements
	        svg.Element = {}

	        svg.EmptyProperty = new svg.Property('EMPTY', '');

	        svg.Element.ElementBase = function(node) {
	            this.attributes = {};
	            this.styles = {};
	            this.stylesSpecificity = {};
	            this.children = [];

	            // get or create attribute
	            this.attribute = function(name, createIfNotExists) {
	                var a = this.attributes[name];
	                if (a != null) return a;

	                if (createIfNotExists == true) { a = new svg.Property(name, ''); this.attributes[name] = a; }
	                return a || svg.EmptyProperty;
	            }

	            this.getHrefAttribute = function() {
	                for (var a in this.attributes) {
	                    if (a == 'href' || a.match(/:href$/)) {
	                        return this.attributes[a];
	                    }
	                }
	                return svg.EmptyProperty;
	            }

	            // get or create style, crawls up node tree
	            this.style = function(name, createIfNotExists, skipAncestors) {
	                var s = this.styles[name];
	                if (s != null) return s;

	                var a = this.attribute(name);
	                if (a != null && a.hasValue()) {
	                    this.styles[name] = a; // move up to me to cache
	                    return a;
	                }

	                if (skipAncestors != true) {
	                    var p = this.parent;
	                    if (p != null) {
	                        var ps = p.style(name);
	                        if (ps != null && ps.hasValue()) {
	                            return ps;
	                        }
	                    }
	                }

	                if (createIfNotExists == true) { s = new svg.Property(name, ''); this.styles[name] = s; }
	                return s || svg.EmptyProperty;
	            }

	            // base render
	            this.render = function(ctx) {
	                // don't render display=none
	                if (this.style('display').value == 'none') return;

	                // don't render visibility=hidden
	                if (this.style('visibility').value == 'hidden') return;

	                ctx.save();
	                if (this.style('mask').hasValue()) { // mask
	                    var mask = this.style('mask').getDefinition();
	                    if (mask != null) mask.apply(ctx, this);
	                }
	                else if (this.style('filter').hasValue()) { // filter
	                    var filter = this.style('filter').getDefinition();
	                    if (filter != null) filter.apply(ctx, this);
	                }
	                else {
	                    this.setContext(ctx);
	                    this.renderChildren(ctx);
	                    this.clearContext(ctx);
	                }
	                ctx.restore();
	            }

	            // base set context
	            this.setContext = function(ctx) {
	                // OVERRIDE ME!
	            }

	            // base clear context
	            this.clearContext = function(ctx) {
	                // OVERRIDE ME!
	            }

	            // base render children
	            this.renderChildren = function(ctx) {
	                for (var i=0; i<this.children.length; i++) {
	                    this.children[i].render(ctx);
	                }
	            }

	            this.addChild = function(childNode, create) {
	                var child = childNode;
	                if (create) child = svg.CreateElement(childNode);
	                child.parent = this;
	                if (child.type != 'title') { this.children.push(child); }
	            }
	            
	            this.addStylesFromStyleDefinition = function () {
	                // add styles
	                for (var selector in svg.Styles) {
	                    if (selector[0] != '@' && matchesSelector(node, selector)) {
	                        var styles = svg.Styles[selector];
	                        var specificity = svg.StylesSpecificity[selector];
	                        if (styles != null) {
	                            for (var name in styles) {
	                                var existingSpecificity = this.stylesSpecificity[name];
	                                if (typeof(existingSpecificity) == 'undefined') {
	                                    existingSpecificity = '000';
	                                }
	                                if (specificity > existingSpecificity) {
	                                    this.styles[name] = styles[name];
	                                    this.stylesSpecificity[name] = specificity;
	                                }
	                            }
	                        }
	                    }
	                }
	            };

	            if (node != null && node.nodeType == 1) { //ELEMENT_NODE
	                // add attributes
	                for (var i=0; i<node.attributes.length; i++) {
	                    var attribute = node.attributes[i];
	                    this.attributes[attribute.nodeName] = new svg.Property(attribute.nodeName, attribute.value);
	                }
	                
	                this.addStylesFromStyleDefinition();

	                // add inline styles
	                if (this.attribute('style').hasValue()) {
	                    var styles = this.attribute('style').value.split(';');
	                    for (var i=0; i<styles.length; i++) {
	                        if (svg.trim(styles[i]) != '') {
	                            var style = styles[i].split(':');
	                            var name = svg.trim(style[0]);
	                            var value = svg.trim(style[1]);
	                            this.styles[name] = new svg.Property(name, value);
	                        }
	                    }
	                }

	                // add id
	                if (this.attribute('id').hasValue()) {
	                    if (svg.Definitions[this.attribute('id').value] == null) {
	                        svg.Definitions[this.attribute('id').value] = this;
	                    }
	                }

	                // add children
	                for (var i=0; i<node.childNodes.length; i++) {
	                    var childNode = node.childNodes[i];
	                    if (childNode.nodeType == 1) this.addChild(childNode, true); //ELEMENT_NODE
	                    if (this.captureTextNodes && (childNode.nodeType == 3 || childNode.nodeType == 4)) {
	                        var text = childNode.value || childNode.text || childNode.textContent || '';
	                        if (svg.compressSpaces(text) != '') {
	                            this.addChild(new svg.Element.tspan(childNode), false); // TEXT_NODE
	                        }
	                    }
	                }
	            }
	        }

	        svg.Element.RenderedElementBase = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.setContext = function(ctx) {
	                // fill
	                if (this.style('fill').isUrlDefinition()) {
	                    var fs = this.style('fill').getFillStyleDefinition(this, this.style('fill-opacity'));
	                    if (fs != null) ctx.fillStyle = fs;
	                }
	                else if (this.style('fill').hasValue()) {
	                    var fillStyle = this.style('fill');
	                    if (fillStyle.value == 'currentColor') fillStyle.value = this.style('color').value;
	                    if (fillStyle.value != 'inherit') ctx.fillStyle = (fillStyle.value == 'none' ? 'rgba(0,0,0,0)' : fillStyle.value);
	                }
	                if (this.style('fill-opacity').hasValue()) {
	                    var fillStyle = new svg.Property('fill', ctx.fillStyle);
	                    fillStyle = fillStyle.addOpacity(this.style('fill-opacity'));
	                    ctx.fillStyle = fillStyle.value;
	                }

	                // stroke
	                if (this.style('stroke').isUrlDefinition()) {
	                    var fs = this.style('stroke').getFillStyleDefinition(this, this.style('stroke-opacity'));
	                    if (fs != null) ctx.strokeStyle = fs;
	                }
	                else if (this.style('stroke').hasValue()) {
	                    var strokeStyle = this.style('stroke');
	                    if (strokeStyle.value == 'currentColor') strokeStyle.value = this.style('color').value;
	                    if (strokeStyle.value != 'inherit') ctx.strokeStyle = (strokeStyle.value == 'none' ? 'rgba(0,0,0,0)' : strokeStyle.value);
	                }
	                if (this.style('stroke-opacity').hasValue()) {
	                    var strokeStyle = new svg.Property('stroke', ctx.strokeStyle);
	                    strokeStyle = strokeStyle.addOpacity(this.style('stroke-opacity'));
	                    ctx.strokeStyle = strokeStyle.value;
	                }
	                if (this.style('stroke-width').hasValue()) {
	                    var newLineWidth = this.style('stroke-width').toPixels();
	                    ctx.lineWidth = newLineWidth == 0 ? 0.001 : newLineWidth; // browsers don't respect 0
	                }
	                if (this.style('stroke-linecap').hasValue()) ctx.lineCap = this.style('stroke-linecap').value;
	                if (this.style('stroke-linejoin').hasValue()) ctx.lineJoin = this.style('stroke-linejoin').value;
	                if (this.style('stroke-miterlimit').hasValue()) ctx.miterLimit = this.style('stroke-miterlimit').value;
	                if (this.style('stroke-dasharray').hasValue() && this.style('stroke-dasharray').value != 'none') {
	                    var gaps = svg.ToNumberArray(this.style('stroke-dasharray').value);
	                    if (typeof(ctx.setLineDash) != 'undefined') { ctx.setLineDash(gaps); }
	                    else if (typeof(ctx.webkitLineDash) != 'undefined') { ctx.webkitLineDash = gaps; }
	                    else if (typeof(ctx.mozDash) != 'undefined' && !(gaps.length==1 && gaps[0]==0)) { ctx.mozDash = gaps; }

	                    var offset = this.style('stroke-dashoffset').numValueOrDefault(1);
	                    if (typeof(ctx.lineDashOffset) != 'undefined') { ctx.lineDashOffset = offset; }
	                    else if (typeof(ctx.webkitLineDashOffset) != 'undefined') { ctx.webkitLineDashOffset = offset; }
	                    else if (typeof(ctx.mozDashOffset) != 'undefined') { ctx.mozDashOffset = offset; }
	                }

	                // font
	                if (typeof(ctx.font) != 'undefined') {
	                    ctx.font = svg.Font.CreateFont(
	                        this.style('font-style').value,
	                        this.style('font-variant').value,
	                        this.style('font-weight').value,
	                        this.style('font-size').hasValue() ? this.style('font-size').toPixels() + 'px' : '',
	                        this.style('font-family').value).toString();
	                }

	                // transform
	                if (this.style('transform', false, true).hasValue()) {
	                    var transform = new svg.Transform(this.style('transform', false, true).value);
	                    transform.apply(ctx);
	                }

	                // clip
	                if (this.style('clip-path', false, true).hasValue()) {
	                    var clip = this.style('clip-path', false, true).getDefinition();
	                    if (clip != null) clip.apply(ctx);
	                }

	                // opacity
	                if (this.style('opacity').hasValue()) {
	                    ctx.globalAlpha = this.style('opacity').numValue();
	                }
	            }
	        }
	        svg.Element.RenderedElementBase.prototype = new svg.Element.ElementBase;

	        svg.Element.PathElementBase = function(node) {
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            this.path = function(ctx) {
	                if (ctx != null) ctx.beginPath();
	                return new svg.BoundingBox();
	            }

	            this.renderChildren = function(ctx) {
	                this.path(ctx);
	                svg.Mouse.checkPath(this, ctx);
	                if (ctx.fillStyle != '') {
	                    if (this.style('fill-rule').valueOrDefault('inherit') != 'inherit') { ctx.fill(this.style('fill-rule').value); }
	                    else { ctx.fill(); }
	                }
	                if (ctx.strokeStyle != '') ctx.stroke();

	                var markers = this.getMarkers();
	                if (markers != null) {
	                    if (this.style('marker-start').isUrlDefinition()) {
	                        var marker = this.style('marker-start').getDefinition();
	                        marker.render(ctx, markers[0][0], markers[0][1]);
	                    }
	                    if (this.style('marker-mid').isUrlDefinition()) {
	                        var marker = this.style('marker-mid').getDefinition();
	                        for (var i=1;i<markers.length-1;i++) {
	                            marker.render(ctx, markers[i][0], markers[i][1]);
	                        }
	                    }
	                    if (this.style('marker-end').isUrlDefinition()) {
	                        var marker = this.style('marker-end').getDefinition();
	                        marker.render(ctx, markers[markers.length-1][0], markers[markers.length-1][1]);
	                    }
	                }
	            }

	            this.getBoundingBox = function() {
	                return this.path();
	            }

	            this.getMarkers = function() {
	                return null;
	            }
	        }
	        svg.Element.PathElementBase.prototype = new svg.Element.RenderedElementBase;

	        // svg element
	        svg.Element.svg = function(node) {
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            this.baseClearContext = this.clearContext;
	            this.clearContext = function(ctx) {
	                this.baseClearContext(ctx);
	                svg.ViewPort.RemoveCurrent();
	            }

	            this.baseSetContext = this.setContext;
	            this.setContext = function(ctx) {
	                // initial values and defaults
	                ctx.strokeStyle = 'rgba(0,0,0,0)';
	                ctx.lineCap = 'butt';
	                ctx.lineJoin = 'miter';
	                ctx.miterLimit = 4;
	                if (typeof(ctx.font) != 'undefined' && typeof(window.getComputedStyle) != 'undefined') {
	                    ctx.font = window.getComputedStyle(ctx.canvas).getPropertyValue('font');
	                }

	                this.baseSetContext(ctx);

	                // create new view port
	                if (!this.attribute('x').hasValue()) this.attribute('x', true).value = 0;
	                if (!this.attribute('y').hasValue()) this.attribute('y', true).value = 0;
	                ctx.translate(this.attribute('x').toPixels('x'), this.attribute('y').toPixels('y'));

	                var width = svg.ViewPort.width();
	                var height = svg.ViewPort.height();

	                if (!this.attribute('width').hasValue()) this.attribute('width', true).value = '100%';
	                if (!this.attribute('height').hasValue()) this.attribute('height', true).value = '100%';
	                if (typeof(this.root) == 'undefined') {
	                    width = this.attribute('width').toPixels('x');
	                    height = this.attribute('height').toPixels('y');

	                    var x = 0;
	                    var y = 0;
	                    if (this.attribute('refX').hasValue() && this.attribute('refY').hasValue()) {
	                        x = -this.attribute('refX').toPixels('x');
	                        y = -this.attribute('refY').toPixels('y');
	                    }

	                    if (this.attribute('overflow').valueOrDefault('hidden') != 'visible') {
	                        ctx.beginPath();
	                        ctx.moveTo(x, y);
	                        ctx.lineTo(width, y);
	                        ctx.lineTo(width, height);
	                        ctx.lineTo(x, height);
	                        ctx.closePath();
	                        ctx.clip();
	                    }
	                }
	                svg.ViewPort.SetCurrent(width, height);

	                // viewbox
	                if (this.attribute('viewBox').hasValue()) {
	                    var viewBox = svg.ToNumberArray(this.attribute('viewBox').value);
	                    var minX = viewBox[0];
	                    var minY = viewBox[1];
	                    width = viewBox[2];
	                    height = viewBox[3];

	                    svg.AspectRatio(ctx,
	                                    this.attribute('preserveAspectRatio').value,
	                                    svg.ViewPort.width(),
	                                    width,
	                                    svg.ViewPort.height(),
	                                    height,
	                                    minX,
	                                    minY,
	                                    this.attribute('refX').value,
	                                    this.attribute('refY').value);

	                    svg.ViewPort.RemoveCurrent();
	                    svg.ViewPort.SetCurrent(viewBox[2], viewBox[3]);
	                }
	            }
	        }
	        svg.Element.svg.prototype = new svg.Element.RenderedElementBase;

	        // rect element
	        svg.Element.rect = function(node) {
	            this.base = svg.Element.PathElementBase;
	            this.base(node);

	            this.path = function(ctx) {
	                var x = this.attribute('x').toPixels('x');
	                var y = this.attribute('y').toPixels('y');
	                var width = this.attribute('width').toPixels('x');
	                var height = this.attribute('height').toPixels('y');
	                var rx = this.attribute('rx').toPixels('x');
	                var ry = this.attribute('ry').toPixels('y');
	                if (this.attribute('rx').hasValue() && !this.attribute('ry').hasValue()) ry = rx;
	                if (this.attribute('ry').hasValue() && !this.attribute('rx').hasValue()) rx = ry;
	                rx = Math.min(rx, width / 2.0);
	                ry = Math.min(ry, height / 2.0);
	                if (ctx != null) {
	                    ctx.beginPath();
	                    ctx.moveTo(x + rx, y);
	                    ctx.lineTo(x + width - rx, y);
	                    ctx.quadraticCurveTo(x + width, y, x + width, y + ry)
	                    ctx.lineTo(x + width, y + height - ry);
	                    ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height)
	                    ctx.lineTo(x + rx, y + height);
	                    ctx.quadraticCurveTo(x, y + height, x, y + height - ry)
	                    ctx.lineTo(x, y + ry);
	                    ctx.quadraticCurveTo(x, y, x + rx, y)
	                    ctx.closePath();
	                }

	                return new svg.BoundingBox(x, y, x + width, y + height);
	            }
	        }
	        svg.Element.rect.prototype = new svg.Element.PathElementBase;

	        // circle element
	        svg.Element.circle = function(node) {
	            this.base = svg.Element.PathElementBase;
	            this.base(node);

	            this.path = function(ctx) {
	                var cx = this.attribute('cx').toPixels('x');
	                var cy = this.attribute('cy').toPixels('y');
	                var r = this.attribute('r').toPixels();

	                if (ctx != null) {
	                    ctx.beginPath();
	                    ctx.arc(cx, cy, r, 0, Math.PI * 2, true);
	                    ctx.closePath();
	                }

	                return new svg.BoundingBox(cx - r, cy - r, cx + r, cy + r);
	            }
	        }
	        svg.Element.circle.prototype = new svg.Element.PathElementBase;

	        // ellipse element
	        svg.Element.ellipse = function(node) {
	            this.base = svg.Element.PathElementBase;
	            this.base(node);

	            this.path = function(ctx) {
	                var KAPPA = 4 * ((Math.sqrt(2) - 1) / 3);
	                var rx = this.attribute('rx').toPixels('x');
	                var ry = this.attribute('ry').toPixels('y');
	                var cx = this.attribute('cx').toPixels('x');
	                var cy = this.attribute('cy').toPixels('y');

	                if (ctx != null) {
	                    ctx.beginPath();
	                    ctx.moveTo(cx, cy - ry);
	                    ctx.bezierCurveTo(cx + (KAPPA * rx), cy - ry,  cx + rx, cy - (KAPPA * ry), cx + rx, cy);
	                    ctx.bezierCurveTo(cx + rx, cy + (KAPPA * ry), cx + (KAPPA * rx), cy + ry, cx, cy + ry);
	                    ctx.bezierCurveTo(cx - (KAPPA * rx), cy + ry, cx - rx, cy + (KAPPA * ry), cx - rx, cy);
	                    ctx.bezierCurveTo(cx - rx, cy - (KAPPA * ry), cx - (KAPPA * rx), cy - ry, cx, cy - ry);
	                    ctx.closePath();
	                }

	                return new svg.BoundingBox(cx - rx, cy - ry, cx + rx, cy + ry);
	            }
	        }
	        svg.Element.ellipse.prototype = new svg.Element.PathElementBase;

	        // line element
	        svg.Element.line = function(node) {
	            this.base = svg.Element.PathElementBase;
	            this.base(node);

	            this.getPoints = function() {
	                return [
	                    new svg.Point(this.attribute('x1').toPixels('x'), this.attribute('y1').toPixels('y')),
	                    new svg.Point(this.attribute('x2').toPixels('x'), this.attribute('y2').toPixels('y'))];
	            }

	            this.path = function(ctx) {
	                var points = this.getPoints();

	                if (ctx != null) {
	                    ctx.beginPath();
	                    ctx.moveTo(points[0].x, points[0].y);
	                    ctx.lineTo(points[1].x, points[1].y);
	                }

	                return new svg.BoundingBox(points[0].x, points[0].y, points[1].x, points[1].y);
	            }

	            this.getMarkers = function() {
	                var points = this.getPoints();
	                var a = points[0].angleTo(points[1]);
	                return [[points[0], a], [points[1], a]];
	            }
	        }
	        svg.Element.line.prototype = new svg.Element.PathElementBase;

	        // polyline element
	        svg.Element.polyline = function(node) {
	            this.base = svg.Element.PathElementBase;
	            this.base(node);

	            this.points = svg.CreatePath(this.attribute('points').value);
	            this.path = function(ctx) {
	                var bb = new svg.BoundingBox(this.points[0].x, this.points[0].y);
	                if (ctx != null) {
	                    ctx.beginPath();
	                    ctx.moveTo(this.points[0].x, this.points[0].y);
	                }
	                for (var i=1; i<this.points.length; i++) {
	                    bb.addPoint(this.points[i].x, this.points[i].y);
	                    if (ctx != null) ctx.lineTo(this.points[i].x, this.points[i].y);
	                }
	                return bb;
	            }

	            this.getMarkers = function() {
	                var markers = [];
	                for (var i=0; i<this.points.length - 1; i++) {
	                    markers.push([this.points[i], this.points[i].angleTo(this.points[i+1])]);
	                }
	                markers.push([this.points[this.points.length-1], markers[markers.length-1][1]]);
	                return markers;
	            }
	        }
	        svg.Element.polyline.prototype = new svg.Element.PathElementBase;

	        // polygon element
	        svg.Element.polygon = function(node) {
	            this.base = svg.Element.polyline;
	            this.base(node);

	            this.basePath = this.path;
	            this.path = function(ctx) {
	                var bb = this.basePath(ctx);
	                if (ctx != null) {
	                    ctx.lineTo(this.points[0].x, this.points[0].y);
	                    ctx.closePath();
	                }
	                return bb;
	            }
	        }
	        svg.Element.polygon.prototype = new svg.Element.polyline;

	        // path element
	        svg.Element.path = function(node) {
	            this.base = svg.Element.PathElementBase;
	            this.base(node);

	            var d = this.attribute('d').value;
	            d = d.replace(/,/gm,' '); // get rid of all commas
	            // As the end of a match can also be the start of the next match, we need to run this replace twice.
	            for(var i=0; i<2; i++)
	                d = d.replace(/([MmZzLlHhVvCcSsQqTtAa])([^\s])/gm,'$1 $2'); // suffix commands with spaces
	            d = d.replace(/([^\s])([MmZzLlHhVvCcSsQqTtAa])/gm,'$1 $2'); // prefix commands with spaces
	            d = d.replace(/([0-9])([+\-])/gm,'$1 $2'); // separate digits on +- signs
	            // Again, we need to run this twice to find all occurances
	            for(var i=0; i<2; i++)
	                d = d.replace(/(\.[0-9]*)(\.)/gm,'$1 $2'); // separate digits when they start with a comma
	            d = d.replace(/([Aa](\s+[0-9]+){3})\s+([01])\s*([01])/gm,'$1 $3 $4 '); // shorthand elliptical arc path syntax
	            d = svg.compressSpaces(d); // compress multiple spaces
	            d = svg.trim(d);
	            this.PathParser = new (function(d) {
	                this.tokens = d.split(' ');

	                this.reset = function() {
	                    this.i = -1;
	                    this.command = '';
	                    this.previousCommand = '';
	                    this.start = new svg.Point(0, 0);
	                    this.control = new svg.Point(0, 0);
	                    this.current = new svg.Point(0, 0);
	                    this.points = [];
	                    this.angles = [];
	                }

	                this.isEnd = function() {
	                    return this.i >= this.tokens.length - 1;
	                }

	                this.isCommandOrEnd = function() {
	                    if (this.isEnd()) return true;
	                    return this.tokens[this.i + 1].match(/^[A-Za-z]$/) != null;
	                }

	                this.isRelativeCommand = function() {
	                    switch(this.command)
	                    {
	                        case 'm':
	                        case 'l':
	                        case 'h':
	                        case 'v':
	                        case 'c':
	                        case 's':
	                        case 'q':
	                        case 't':
	                        case 'a':
	                        case 'z':
	                            return true;
	                            break;
	                    }
	                    return false;
	                }

	                this.getToken = function() {
	                    this.i++;
	                    return this.tokens[this.i];
	                }

	                this.getScalar = function() {
	                    return parseFloat(this.getToken());
	                }

	                this.nextCommand = function() {
	                    this.previousCommand = this.command;
	                    this.command = this.getToken();
	                }

	                this.getPoint = function() {
	                    var p = new svg.Point(this.getScalar(), this.getScalar());
	                    return this.makeAbsolute(p);
	                }

	                this.getAsControlPoint = function() {
	                    var p = this.getPoint();
	                    this.control = p;
	                    return p;
	                }

	                this.getAsCurrentPoint = function() {
	                    var p = this.getPoint();
	                    this.current = p;
	                    return p;
	                }

	                this.getReflectedControlPoint = function() {
	                    if (this.previousCommand.toLowerCase() != 'c' &&
	                        this.previousCommand.toLowerCase() != 's' &&
	                        this.previousCommand.toLowerCase() != 'q' &&
	                        this.previousCommand.toLowerCase() != 't' ){
	                        return this.current;
	                    }

	                    // reflect point
	                    var p = new svg.Point(2 * this.current.x - this.control.x, 2 * this.current.y - this.control.y);
	                    return p;
	                }

	                this.makeAbsolute = function(p) {
	                    if (this.isRelativeCommand()) {
	                        p.x += this.current.x;
	                        p.y += this.current.y;
	                    }
	                    return p;
	                }

	                this.addMarker = function(p, from, priorTo) {
	                    // if the last angle isn't filled in because we didn't have this point yet ...
	                    if (priorTo != null && this.angles.length > 0 && this.angles[this.angles.length-1] == null) {
	                        this.angles[this.angles.length-1] = this.points[this.points.length-1].angleTo(priorTo);
	                    }
	                    this.addMarkerAngle(p, from == null ? null : from.angleTo(p));
	                }

	                this.addMarkerAngle = function(p, a) {
	                    this.points.push(p);
	                    this.angles.push(a);
	                }

	                this.getMarkerPoints = function() { return this.points; }
	                this.getMarkerAngles = function() {
	                    for (var i=0; i<this.angles.length; i++) {
	                        if (this.angles[i] == null) {
	                            for (var j=i+1; j<this.angles.length; j++) {
	                                if (this.angles[j] != null) {
	                                    this.angles[i] = this.angles[j];
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                    return this.angles;
	                }
	            })(d);

	            this.path = function(ctx) {
	                var pp = this.PathParser;
	                pp.reset();

	                var bb = new svg.BoundingBox();
	                if (ctx != null) ctx.beginPath();
	                while (!pp.isEnd()) {
	                    pp.nextCommand();
	                    switch (pp.command) {
	                    case 'M':
	                    case 'm':
	                        var p = pp.getAsCurrentPoint();
	                        pp.addMarker(p);
	                        bb.addPoint(p.x, p.y);
	                        if (ctx != null) ctx.moveTo(p.x, p.y);
	                        pp.start = pp.current;
	                        while (!pp.isCommandOrEnd()) {
	                            var p = pp.getAsCurrentPoint();
	                            pp.addMarker(p, pp.start);
	                            bb.addPoint(p.x, p.y);
	                            if (ctx != null) ctx.lineTo(p.x, p.y);
	                        }
	                        break;
	                    case 'L':
	                    case 'l':
	                        while (!pp.isCommandOrEnd()) {
	                            var c = pp.current;
	                            var p = pp.getAsCurrentPoint();
	                            pp.addMarker(p, c);
	                            bb.addPoint(p.x, p.y);
	                            if (ctx != null) ctx.lineTo(p.x, p.y);
	                        }
	                        break;
	                    case 'H':
	                    case 'h':
	                        while (!pp.isCommandOrEnd()) {
	                            var newP = new svg.Point((pp.isRelativeCommand() ? pp.current.x : 0) + pp.getScalar(), pp.current.y);
	                            pp.addMarker(newP, pp.current);
	                            pp.current = newP;
	                            bb.addPoint(pp.current.x, pp.current.y);
	                            if (ctx != null) ctx.lineTo(pp.current.x, pp.current.y);
	                        }
	                        break;
	                    case 'V':
	                    case 'v':
	                        while (!pp.isCommandOrEnd()) {
	                            var newP = new svg.Point(pp.current.x, (pp.isRelativeCommand() ? pp.current.y : 0) + pp.getScalar());
	                            pp.addMarker(newP, pp.current);
	                            pp.current = newP;
	                            bb.addPoint(pp.current.x, pp.current.y);
	                            if (ctx != null) ctx.lineTo(pp.current.x, pp.current.y);
	                        }
	                        break;
	                    case 'C':
	                    case 'c':
	                        while (!pp.isCommandOrEnd()) {
	                            var curr = pp.current;
	                            var p1 = pp.getPoint();
	                            var cntrl = pp.getAsControlPoint();
	                            var cp = pp.getAsCurrentPoint();
	                            pp.addMarker(cp, cntrl, p1);
	                            bb.addBezierCurve(curr.x, curr.y, p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
	                            if (ctx != null) ctx.bezierCurveTo(p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
	                        }
	                        break;
	                    case 'S':
	                    case 's':
	                        while (!pp.isCommandOrEnd()) {
	                            var curr = pp.current;
	                            var p1 = pp.getReflectedControlPoint();
	                            var cntrl = pp.getAsControlPoint();
	                            var cp = pp.getAsCurrentPoint();
	                            pp.addMarker(cp, cntrl, p1);
	                            bb.addBezierCurve(curr.x, curr.y, p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
	                            if (ctx != null) ctx.bezierCurveTo(p1.x, p1.y, cntrl.x, cntrl.y, cp.x, cp.y);
	                        }
	                        break;
	                    case 'Q':
	                    case 'q':
	                        while (!pp.isCommandOrEnd()) {
	                            var curr = pp.current;
	                            var cntrl = pp.getAsControlPoint();
	                            var cp = pp.getAsCurrentPoint();
	                            pp.addMarker(cp, cntrl, cntrl);
	                            bb.addQuadraticCurve(curr.x, curr.y, cntrl.x, cntrl.y, cp.x, cp.y);
	                            if (ctx != null) ctx.quadraticCurveTo(cntrl.x, cntrl.y, cp.x, cp.y);
	                        }
	                        break;
	                    case 'T':
	                    case 't':
	                        while (!pp.isCommandOrEnd()) {
	                            var curr = pp.current;
	                            var cntrl = pp.getReflectedControlPoint();
	                            pp.control = cntrl;
	                            var cp = pp.getAsCurrentPoint();
	                            pp.addMarker(cp, cntrl, cntrl);
	                            bb.addQuadraticCurve(curr.x, curr.y, cntrl.x, cntrl.y, cp.x, cp.y);
	                            if (ctx != null) ctx.quadraticCurveTo(cntrl.x, cntrl.y, cp.x, cp.y);
	                        }
	                        break;
	                    case 'A':
	                    case 'a':
	                        while (!pp.isCommandOrEnd()) {
	                            var curr = pp.current;
	                            var rx = pp.getScalar();
	                            var ry = pp.getScalar();
	                            var xAxisRotation = pp.getScalar() * (Math.PI / 180.0);
	                            var largeArcFlag = pp.getScalar();
	                            var sweepFlag = pp.getScalar();
	                            var cp = pp.getAsCurrentPoint();

	                            // Conversion from endpoint to center parameterization
	                            // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	                            // x1', y1'
	                            var currp = new svg.Point(
	                                Math.cos(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.sin(xAxisRotation) * (curr.y - cp.y) / 2.0,
	                                -Math.sin(xAxisRotation) * (curr.x - cp.x) / 2.0 + Math.cos(xAxisRotation) * (curr.y - cp.y) / 2.0
	                            );
	                            // adjust radii
	                            var l = Math.pow(currp.x,2)/Math.pow(rx,2)+Math.pow(currp.y,2)/Math.pow(ry,2);
	                            if (l > 1) {
	                                rx *= Math.sqrt(l);
	                                ry *= Math.sqrt(l);
	                            }
	                            // cx', cy'
	                            var s = (largeArcFlag == sweepFlag ? -1 : 1) * Math.sqrt(
	                                ((Math.pow(rx,2)*Math.pow(ry,2))-(Math.pow(rx,2)*Math.pow(currp.y,2))-(Math.pow(ry,2)*Math.pow(currp.x,2))) /
	                                (Math.pow(rx,2)*Math.pow(currp.y,2)+Math.pow(ry,2)*Math.pow(currp.x,2))
	                            );
	                            if (isNaN(s)) s = 0;
	                            var cpp = new svg.Point(s * rx * currp.y / ry, s * -ry * currp.x / rx);
	                            // cx, cy
	                            var centp = new svg.Point(
	                                (curr.x + cp.x) / 2.0 + Math.cos(xAxisRotation) * cpp.x - Math.sin(xAxisRotation) * cpp.y,
	                                (curr.y + cp.y) / 2.0 + Math.sin(xAxisRotation) * cpp.x + Math.cos(xAxisRotation) * cpp.y
	                            );
	                            // vector magnitude
	                            var m = function(v) { return Math.sqrt(Math.pow(v[0],2) + Math.pow(v[1],2)); }
	                            // ratio between two vectors
	                            var r = function(u, v) { return (u[0]*v[0]+u[1]*v[1]) / (m(u)*m(v)) }
	                            // angle between two vectors
	                            var a = function(u, v) { return (u[0]*v[1] < u[1]*v[0] ? -1 : 1) * Math.acos(r(u,v)); }
	                            // initial angle
	                            var a1 = a([1,0], [(currp.x-cpp.x)/rx,(currp.y-cpp.y)/ry]);
	                            // angle delta
	                            var u = [(currp.x-cpp.x)/rx,(currp.y-cpp.y)/ry];
	                            var v = [(-currp.x-cpp.x)/rx,(-currp.y-cpp.y)/ry];
	                            var ad = a(u, v);
	                            if (r(u,v) <= -1) ad = Math.PI;
	                            if (r(u,v) >= 1) ad = 0;

	                            // for markers
	                            var dir = 1 - sweepFlag ? 1.0 : -1.0;
	                            var ah = a1 + dir * (ad / 2.0);
	                            var halfWay = new svg.Point(
	                                centp.x + rx * Math.cos(ah),
	                                centp.y + ry * Math.sin(ah)
	                            );
	                            pp.addMarkerAngle(halfWay, ah - dir * Math.PI / 2);
	                            pp.addMarkerAngle(cp, ah - dir * Math.PI);

	                            bb.addPoint(cp.x, cp.y); // TODO: this is too naive, make it better
	                            if (ctx != null) {
	                                var r = rx > ry ? rx : ry;
	                                var sx = rx > ry ? 1 : rx / ry;
	                                var sy = rx > ry ? ry / rx : 1;

	                                ctx.translate(centp.x, centp.y);
	                                ctx.rotate(xAxisRotation);
	                                ctx.scale(sx, sy);
	                                ctx.arc(0, 0, r, a1, a1 + ad, 1 - sweepFlag);
	                                ctx.scale(1/sx, 1/sy);
	                                ctx.rotate(-xAxisRotation);
	                                ctx.translate(-centp.x, -centp.y);
	                            }
	                        }
	                        break;
	                    case 'Z':
	                    case 'z':
	                        if (ctx != null) ctx.closePath();
	                        pp.current = pp.start;
	                    }
	                }

	                return bb;
	            }

	            this.getMarkers = function() {
	                var points = this.PathParser.getMarkerPoints();
	                var angles = this.PathParser.getMarkerAngles();

	                var markers = [];
	                for (var i=0; i<points.length; i++) {
	                    markers.push([points[i], angles[i]]);
	                }
	                return markers;
	            }
	        }
	        svg.Element.path.prototype = new svg.Element.PathElementBase;

	        // pattern element
	        svg.Element.pattern = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.createPattern = function(ctx, element) {
	                var width = this.attribute('width').toPixels('x', true);
	                var height = this.attribute('height').toPixels('y', true);

	                // render me using a temporary svg element
	                var tempSvg = new svg.Element.svg();
	                tempSvg.attributes['viewBox'] = new svg.Property('viewBox', this.attribute('viewBox').value);
	                tempSvg.attributes['width'] = new svg.Property('width', width + 'px');
	                tempSvg.attributes['height'] = new svg.Property('height', height + 'px');
	                tempSvg.attributes['transform'] = new svg.Property('transform', this.attribute('patternTransform').value);
	                tempSvg.children = this.children;

	                var c = document.createElement('canvas');
	                c.width = width;
	                c.height = height;
	                var cctx = c.getContext('2d');
	                if (this.attribute('x').hasValue() && this.attribute('y').hasValue()) {
	                    cctx.translate(this.attribute('x').toPixels('x', true), this.attribute('y').toPixels('y', true));
	                }
	                // render 3x3 grid so when we transform there's no white space on edges
	                for (var x=-1; x<=1; x++) {
	                    for (var y=-1; y<=1; y++) {
	                        cctx.save();
	                        tempSvg.attributes['x'] = new svg.Property('x', x * c.width);
	                        tempSvg.attributes['y'] = new svg.Property('y', y * c.height);
	                        tempSvg.render(cctx);
	                        cctx.restore();
	                    }
	                }
	                var pattern = ctx.createPattern(c, 'repeat');
	                return pattern;
	            }
	        }
	        svg.Element.pattern.prototype = new svg.Element.ElementBase;

	        // marker element
	        svg.Element.marker = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.baseRender = this.render;
	            this.render = function(ctx, point, angle) {
	                ctx.translate(point.x, point.y);
	                if (this.attribute('orient').valueOrDefault('auto') == 'auto') ctx.rotate(angle);
	                if (this.attribute('markerUnits').valueOrDefault('strokeWidth') == 'strokeWidth') ctx.scale(ctx.lineWidth, ctx.lineWidth);
	                ctx.save();

	                // render me using a temporary svg element
	                var tempSvg = new svg.Element.svg();
	                tempSvg.attributes['viewBox'] = new svg.Property('viewBox', this.attribute('viewBox').value);
	                tempSvg.attributes['refX'] = new svg.Property('refX', this.attribute('refX').value);
	                tempSvg.attributes['refY'] = new svg.Property('refY', this.attribute('refY').value);
	                tempSvg.attributes['width'] = new svg.Property('width', this.attribute('markerWidth').value);
	                tempSvg.attributes['height'] = new svg.Property('height', this.attribute('markerHeight').value);
	                tempSvg.attributes['fill'] = new svg.Property('fill', this.attribute('fill').valueOrDefault('black'));
	                tempSvg.attributes['stroke'] = new svg.Property('stroke', this.attribute('stroke').valueOrDefault('none'));
	                tempSvg.children = this.children;
	                tempSvg.render(ctx);

	                ctx.restore();
	                if (this.attribute('markerUnits').valueOrDefault('strokeWidth') == 'strokeWidth') ctx.scale(1/ctx.lineWidth, 1/ctx.lineWidth);
	                if (this.attribute('orient').valueOrDefault('auto') == 'auto') ctx.rotate(-angle);
	                ctx.translate(-point.x, -point.y);
	            }
	        }
	        svg.Element.marker.prototype = new svg.Element.ElementBase;

	        // definitions element
	        svg.Element.defs = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.render = function(ctx) {
	                // NOOP
	            }
	        }
	        svg.Element.defs.prototype = new svg.Element.ElementBase;

	        // base for gradients
	        svg.Element.GradientBase = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.stops = [];
	            for (var i=0; i<this.children.length; i++) {
	                var child = this.children[i];
	                if (child.type == 'stop') this.stops.push(child);
	            }

	            this.getGradient = function() {
	                // OVERRIDE ME!
	            }
	            
	            this.gradientUnits = function () {
	                return this.attribute('gradientUnits').valueOrDefault('objectBoundingBox');
	            }
	            
	            this.attributesToInherit = ['gradientUnits'];
	            
	            this.inheritStopContainer = function (stopsContainer) {
	                for (var i=0; i<this.attributesToInherit.length; i++) {
	                    var attributeToInherit = this.attributesToInherit[i];
	                    if (!this.attribute(attributeToInherit).hasValue() && stopsContainer.attribute(attributeToInherit).hasValue()) {
	                        this.attribute(attributeToInherit, true).value = stopsContainer.attribute(attributeToInherit).value;
	                    }
	                }
	            }

	            this.createGradient = function(ctx, element, parentOpacityProp) {
	                var stopsContainer = this;
	                if (this.getHrefAttribute().hasValue()) {
	                    stopsContainer = this.getHrefAttribute().getDefinition();
	                    this.inheritStopContainer(stopsContainer);
	                }

	                var addParentOpacity = function (color) {
	                    if (parentOpacityProp.hasValue()) {
	                        var p = new svg.Property('color', color);
	                        return p.addOpacity(parentOpacityProp).value;
	                    }
	                    return color;
	                };

	                var g = this.getGradient(ctx, element);
	                if (g == null) return addParentOpacity(stopsContainer.stops[stopsContainer.stops.length - 1].color);
	                for (var i=0; i<stopsContainer.stops.length; i++) {
	                    g.addColorStop(stopsContainer.stops[i].offset, addParentOpacity(stopsContainer.stops[i].color));
	                }

	                if (this.attribute('gradientTransform').hasValue()) {
	                    // render as transformed pattern on temporary canvas
	                    var rootView = svg.ViewPort.viewPorts[0];

	                    var rect = new svg.Element.rect();
	                    rect.attributes['x'] = new svg.Property('x', -svg.MAX_VIRTUAL_PIXELS/3.0);
	                    rect.attributes['y'] = new svg.Property('y', -svg.MAX_VIRTUAL_PIXELS/3.0);
	                    rect.attributes['width'] = new svg.Property('width', svg.MAX_VIRTUAL_PIXELS);
	                    rect.attributes['height'] = new svg.Property('height', svg.MAX_VIRTUAL_PIXELS);

	                    var group = new svg.Element.g();
	                    group.attributes['transform'] = new svg.Property('transform', this.attribute('gradientTransform').value);
	                    group.children = [ rect ];

	                    var tempSvg = new svg.Element.svg();
	                    tempSvg.attributes['x'] = new svg.Property('x', 0);
	                    tempSvg.attributes['y'] = new svg.Property('y', 0);
	                    tempSvg.attributes['width'] = new svg.Property('width', rootView.width);
	                    tempSvg.attributes['height'] = new svg.Property('height', rootView.height);
	                    tempSvg.children = [ group ];

	                    var c = document.createElement('canvas');
	                    c.width = rootView.width;
	                    c.height = rootView.height;
	                    var tempCtx = c.getContext('2d');
	                    tempCtx.fillStyle = g;
	                    tempSvg.render(tempCtx);
	                    return tempCtx.createPattern(c, 'no-repeat');
	                }

	                return g;
	            }
	        }
	        svg.Element.GradientBase.prototype = new svg.Element.ElementBase;

	        // linear gradient element
	        svg.Element.linearGradient = function(node) {
	            this.base = svg.Element.GradientBase;
	            this.base(node);
	            
	            this.attributesToInherit.push('x1');
	            this.attributesToInherit.push('y1');
	            this.attributesToInherit.push('x2');
	            this.attributesToInherit.push('y2');

	            this.getGradient = function(ctx, element) {
	                var bb = this.gradientUnits() == 'objectBoundingBox' ? element.getBoundingBox() : null;

	                if (!this.attribute('x1').hasValue()
	                 && !this.attribute('y1').hasValue()
	                 && !this.attribute('x2').hasValue()
	                 && !this.attribute('y2').hasValue()) {
	                    this.attribute('x1', true).value = 0;
	                    this.attribute('y1', true).value = 0;
	                    this.attribute('x2', true).value = 1;
	                    this.attribute('y2', true).value = 0;
	                 }

	                var x1 = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.x() + bb.width() * this.attribute('x1').numValue()
	                    : this.attribute('x1').toPixels('x'));
	                var y1 = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.y() + bb.height() * this.attribute('y1').numValue()
	                    : this.attribute('y1').toPixels('y'));
	                var x2 = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.x() + bb.width() * this.attribute('x2').numValue()
	                    : this.attribute('x2').toPixels('x'));
	                var y2 = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.y() + bb.height() * this.attribute('y2').numValue()
	                    : this.attribute('y2').toPixels('y'));

	                if (x1 == x2 && y1 == y2) return null;
	                return ctx.createLinearGradient(x1, y1, x2, y2);
	            }
	        }
	        svg.Element.linearGradient.prototype = new svg.Element.GradientBase;

	        // radial gradient element
	        svg.Element.radialGradient = function(node) {
	            this.base = svg.Element.GradientBase;
	            this.base(node);
	            
	            this.attributesToInherit.push('cx');
	            this.attributesToInherit.push('cy');
	            this.attributesToInherit.push('r');
	            this.attributesToInherit.push('fx');
	            this.attributesToInherit.push('fy');

	            this.getGradient = function(ctx, element) {
	                var bb = element.getBoundingBox();

	                if (!this.attribute('cx').hasValue()) this.attribute('cx', true).value = '50%';
	                if (!this.attribute('cy').hasValue()) this.attribute('cy', true).value = '50%';
	                if (!this.attribute('r').hasValue()) this.attribute('r', true).value = '50%';

	                var cx = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.x() + bb.width() * this.attribute('cx').numValue()
	                    : this.attribute('cx').toPixels('x'));
	                var cy = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.y() + bb.height() * this.attribute('cy').numValue()
	                    : this.attribute('cy').toPixels('y'));

	                var fx = cx;
	                var fy = cy;
	                if (this.attribute('fx').hasValue()) {
	                    fx = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.x() + bb.width() * this.attribute('fx').numValue()
	                    : this.attribute('fx').toPixels('x'));
	                }
	                if (this.attribute('fy').hasValue()) {
	                    fy = (this.gradientUnits() == 'objectBoundingBox'
	                    ? bb.y() + bb.height() * this.attribute('fy').numValue()
	                    : this.attribute('fy').toPixels('y'));
	                }

	                var r = (this.gradientUnits() == 'objectBoundingBox'
	                    ? (bb.width() + bb.height()) / 2.0 * this.attribute('r').numValue()
	                    : this.attribute('r').toPixels());

	                return ctx.createRadialGradient(fx, fy, 0, cx, cy, r);
	            }
	        }
	        svg.Element.radialGradient.prototype = new svg.Element.GradientBase;

	        // gradient stop element
	        svg.Element.stop = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.offset = this.attribute('offset').numValue();
	            if (this.offset < 0) this.offset = 0;
	            if (this.offset > 1) this.offset = 1;

	            var stopColor = this.style('stop-color', true);
	            if (stopColor.value === '') stopColor.value = '#000';
	            if (this.style('stop-opacity').hasValue()) stopColor = stopColor.addOpacity(this.style('stop-opacity'));
	            this.color = stopColor.value;
	        }
	        svg.Element.stop.prototype = new svg.Element.ElementBase;

	        // animation base element
	        svg.Element.AnimateBase = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            svg.Animations.push(this);

	            this.duration = 0.0;
	            this.begin = this.attribute('begin').toMilliseconds();
	            this.maxDuration = this.begin + this.attribute('dur').toMilliseconds();

	            this.getProperty = function() {
	                var attributeType = this.attribute('attributeType').value;
	                var attributeName = this.attribute('attributeName').value;

	                if (attributeType == 'CSS') {
	                    return this.parent.style(attributeName, true);
	                }
	                return this.parent.attribute(attributeName, true);
	            };

	            this.initialValue = null;
	            this.initialUnits = '';
	            this.removed = false;

	            this.calcValue = function() {
	                // OVERRIDE ME!
	                return '';
	            }

	            this.update = function(delta) {
	                // set initial value
	                if (this.initialValue == null) {
	                    this.initialValue = this.getProperty().value;
	                    this.initialUnits = this.getProperty().getUnits();
	                }

	                // if we're past the end time
	                if (this.duration > this.maxDuration) {
	                    // loop for indefinitely repeating animations
	                    if (this.attribute('repeatCount').value == 'indefinite'
	                     || this.attribute('repeatDur').value == 'indefinite') {
	                        this.duration = 0.0
	                    }
	                    else if (this.attribute('fill').valueOrDefault('remove') == 'freeze' && !this.frozen) {
	                        this.frozen = true;
	                        this.parent.animationFrozen = true;
	                        this.parent.animationFrozenValue = this.getProperty().value;
	                    }
	                    else if (this.attribute('fill').valueOrDefault('remove') == 'remove' && !this.removed) {
	                        this.removed = true;
	                        this.getProperty().value = this.parent.animationFrozen ? this.parent.animationFrozenValue : this.initialValue;
	                        return true;
	                    }
	                    return false;
	                }
	                this.duration = this.duration + delta;

	                // if we're past the begin time
	                var updated = false;
	                if (this.begin < this.duration) {
	                    var newValue = this.calcValue(); // tween

	                    if (this.attribute('type').hasValue()) {
	                        // for transform, etc.
	                        var type = this.attribute('type').value;
	                        newValue = type + '(' + newValue + ')';
	                    }

	                    this.getProperty().value = newValue;
	                    updated = true;
	                }

	                return updated;
	            }

	            this.from = this.attribute('from');
	            this.to = this.attribute('to');
	            this.values = this.attribute('values');
	            if (this.values.hasValue()) this.values.value = this.values.value.split(';');

	            // fraction of duration we've covered
	            this.progress = function() {
	                var ret = { progress: (this.duration - this.begin) / (this.maxDuration - this.begin) };
	                if (this.values.hasValue()) {
	                    var p = ret.progress * (this.values.value.length - 1);
	                    var lb = Math.floor(p), ub = Math.ceil(p);
	                    ret.from = new svg.Property('from', parseFloat(this.values.value[lb]));
	                    ret.to = new svg.Property('to', parseFloat(this.values.value[ub]));
	                    ret.progress = (p - lb) / (ub - lb);
	                }
	                else {
	                    ret.from = this.from;
	                    ret.to = this.to;
	                }
	                return ret;
	            }
	        }
	        svg.Element.AnimateBase.prototype = new svg.Element.ElementBase;

	        // animate element
	        svg.Element.animate = function(node) {
	            this.base = svg.Element.AnimateBase;
	            this.base(node);

	            this.calcValue = function() {
	                var p = this.progress();

	                // tween value linearly
	                var newValue = p.from.numValue() + (p.to.numValue() - p.from.numValue()) * p.progress;
	                return newValue + this.initialUnits;
	            };
	        }
	        svg.Element.animate.prototype = new svg.Element.AnimateBase;

	        // animate color element
	        svg.Element.animateColor = function(node) {
	            this.base = svg.Element.AnimateBase;
	            this.base(node);

	            this.calcValue = function() {
	                var p = this.progress();
	                var from = new RGBColor(p.from.value);
	                var to = new RGBColor(p.to.value);

	                if (from.ok && to.ok) {
	                    // tween color linearly
	                    var r = from.r + (to.r - from.r) * p.progress;
	                    var g = from.g + (to.g - from.g) * p.progress;
	                    var b = from.b + (to.b - from.b) * p.progress;
	                    return 'rgb('+parseInt(r,10)+','+parseInt(g,10)+','+parseInt(b,10)+')';
	                }
	                return this.attribute('from').value;
	            };
	        }
	        svg.Element.animateColor.prototype = new svg.Element.AnimateBase;

	        // animate transform element
	        svg.Element.animateTransform = function(node) {
	            this.base = svg.Element.AnimateBase;
	            this.base(node);

	            this.calcValue = function() {
	                var p = this.progress();

	                // tween value linearly
	                var from = svg.ToNumberArray(p.from.value);
	                var to = svg.ToNumberArray(p.to.value);
	                var newValue = '';
	                for (var i=0; i<from.length; i++) {
	                    newValue += from[i] + (to[i] - from[i]) * p.progress + ' ';
	                }
	                return newValue;
	            };
	        }
	        svg.Element.animateTransform.prototype = new svg.Element.animate;

	        // font element
	        svg.Element.font = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.horizAdvX = this.attribute('horiz-adv-x').numValue();

	            this.isRTL = false;
	            this.isArabic = false;
	            this.fontFace = null;
	            this.missingGlyph = null;
	            this.glyphs = [];
	            for (var i=0; i<this.children.length; i++) {
	                var child = this.children[i];
	                if (child.type == 'font-face') {
	                    this.fontFace = child;
	                    if (child.style('font-family').hasValue()) {
	                        svg.Definitions[child.style('font-family').value] = this;
	                    }
	                }
	                else if (child.type == 'missing-glyph') this.missingGlyph = child;
	                else if (child.type == 'glyph') {
	                    if (child.arabicForm != '') {
	                        this.isRTL = true;
	                        this.isArabic = true;
	                        if (typeof(this.glyphs[child.unicode]) == 'undefined') this.glyphs[child.unicode] = [];
	                        this.glyphs[child.unicode][child.arabicForm] = child;
	                    }
	                    else {
	                        this.glyphs[child.unicode] = child;
	                    }
	                }
	            }
	        }
	        svg.Element.font.prototype = new svg.Element.ElementBase;

	        // font-face element
	        svg.Element.fontface = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.ascent = this.attribute('ascent').value;
	            this.descent = this.attribute('descent').value;
	            this.unitsPerEm = this.attribute('units-per-em').numValue();
	        }
	        svg.Element.fontface.prototype = new svg.Element.ElementBase;

	        // missing-glyph element
	        svg.Element.missingglyph = function(node) {
	            this.base = svg.Element.path;
	            this.base(node);

	            this.horizAdvX = 0;
	        }
	        svg.Element.missingglyph.prototype = new svg.Element.path;

	        // glyph element
	        svg.Element.glyph = function(node) {
	            this.base = svg.Element.path;
	            this.base(node);

	            this.horizAdvX = this.attribute('horiz-adv-x').numValue();
	            this.unicode = this.attribute('unicode').value;
	            this.arabicForm = this.attribute('arabic-form').value;
	        }
	        svg.Element.glyph.prototype = new svg.Element.path;

	        // text element
	        svg.Element.text = function(node) {
	            this.captureTextNodes = true;
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            this.baseSetContext = this.setContext;
	            this.setContext = function(ctx) {
	                this.baseSetContext(ctx);

	                var textBaseline = this.style('dominant-baseline').toTextBaseline();
	                if (textBaseline == null) textBaseline = this.style('alignment-baseline').toTextBaseline();
	                if (textBaseline != null) ctx.textBaseline = textBaseline;
	            }

	            this.getBoundingBox = function () {
	                var x = this.attribute('x').toPixels('x');
	                var y = this.attribute('y').toPixels('y');
	                var fontSize = this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);
	                return new svg.BoundingBox(x, y - fontSize, x + Math.floor(fontSize * 2.0 / 3.0) * this.children[0].getText().length, y);
	            }

	            this.renderChildren = function(ctx) {
	                this.x = this.attribute('x').toPixels('x');
	                this.y = this.attribute('y').toPixels('y');
	                if (this.attribute('dx').hasValue()) this.x += this.attribute('dx').toPixels('x');
	                if (this.attribute('dy').hasValue()) this.y += this.attribute('dy').toPixels('y');
	                this.x += this.getAnchorDelta(ctx, this, 0);
	                for (var i=0; i<this.children.length; i++) {
	                    this.renderChild(ctx, this, i);
	                }
	            }

	            this.getAnchorDelta = function (ctx, parent, startI) {
	                var textAnchor = this.style('text-anchor').valueOrDefault('start');
	                if (textAnchor != 'start') {
	                    var width = 0;
	                    for (var i=startI; i<parent.children.length; i++) {
	                        var child = parent.children[i];
	                        if (i > startI && child.attribute('x').hasValue()) break; // new group
	                        width += child.measureTextRecursive(ctx);
	                    }
	                    return -1 * (textAnchor == 'end' ? width : width / 2.0);
	                }
	                return 0;
	            }

	            this.renderChild = function(ctx, parent, i) {
	                var child = parent.children[i];
	                if (child.attribute('x').hasValue()) {
	                    child.x = child.attribute('x').toPixels('x') + parent.getAnchorDelta(ctx, parent, i);
	                    if (child.attribute('dx').hasValue()) child.x += child.attribute('dx').toPixels('x');
	                }
	                else {
	                    if (child.attribute('dx').hasValue()) parent.x += child.attribute('dx').toPixels('x');
	                    child.x = parent.x;
	                }
	                parent.x = child.x + child.measureText(ctx);

	                if (child.attribute('y').hasValue()) {
	                    child.y = child.attribute('y').toPixels('y');
	                    if (child.attribute('dy').hasValue()) child.y += child.attribute('dy').toPixels('y');
	                }
	                else {
	                    if (child.attribute('dy').hasValue()) parent.y += child.attribute('dy').toPixels('y');
	                    child.y = parent.y;
	                }
	                parent.y = child.y;

	                child.render(ctx);

	                for (var i=0; i<child.children.length; i++) {
	                    parent.renderChild(ctx, child, i);
	                }
	            }
	        }
	        svg.Element.text.prototype = new svg.Element.RenderedElementBase;

	        // text base
	        svg.Element.TextElementBase = function(node) {
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            this.getGlyph = function(font, text, i) {
	                var c = text[i];
	                var glyph = null;
	                if (font.isArabic) {
	                    var arabicForm = 'isolated';
	                    if ((i==0 || text[i-1]==' ') && i<text.length-2 && text[i+1]!=' ') arabicForm = 'terminal';
	                    if (i>0 && text[i-1]!=' ' && i<text.length-2 && text[i+1]!=' ') arabicForm = 'medial';
	                    if (i>0 && text[i-1]!=' ' && (i == text.length-1 || text[i+1]==' ')) arabicForm = 'initial';
	                    if (typeof(font.glyphs[c]) != 'undefined') {
	                        glyph = font.glyphs[c][arabicForm];
	                        if (glyph == null && font.glyphs[c].type == 'glyph') glyph = font.glyphs[c];
	                    }
	                }
	                else {
	                    glyph = font.glyphs[c];
	                }
	                if (glyph == null) glyph = font.missingGlyph;
	                return glyph;
	            }

	            this.renderChildren = function(ctx) {
	                var customFont = this.parent.style('font-family').getDefinition();
	                if (customFont != null) {
	                    var fontSize = this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);
	                    var fontStyle = this.parent.style('font-style').valueOrDefault(svg.Font.Parse(svg.ctx.font).fontStyle);
	                    var text = this.getText();
	                    if (customFont.isRTL) text = text.split("").reverse().join("");

	                    var dx = svg.ToNumberArray(this.parent.attribute('dx').value);
	                    for (var i=0; i<text.length; i++) {
	                        var glyph = this.getGlyph(customFont, text, i);
	                        var scale = fontSize / customFont.fontFace.unitsPerEm;
	                        ctx.translate(this.x, this.y);
	                        ctx.scale(scale, -scale);
	                        var lw = ctx.lineWidth;
	                        ctx.lineWidth = ctx.lineWidth * customFont.fontFace.unitsPerEm / fontSize;
	                        if (fontStyle == 'italic') ctx.transform(1, 0, .4, 1, 0, 0);
	                        glyph.render(ctx);
	                        if (fontStyle == 'italic') ctx.transform(1, 0, -.4, 1, 0, 0);
	                        ctx.lineWidth = lw;
	                        ctx.scale(1/scale, -1/scale);
	                        ctx.translate(-this.x, -this.y);

	                        this.x += fontSize * (glyph.horizAdvX || customFont.horizAdvX) / customFont.fontFace.unitsPerEm;
	                        if (typeof(dx[i]) != 'undefined' && !isNaN(dx[i])) {
	                            this.x += dx[i];
	                        }
	                    }
	                    return;
	                }

	                if (ctx.fillStyle != '') ctx.fillText(svg.compressSpaces(this.getText()), this.x, this.y);
	                if (ctx.strokeStyle != '') ctx.strokeText(svg.compressSpaces(this.getText()), this.x, this.y);
	            }

	            this.getText = function() {
	                // OVERRIDE ME
	            }

	            this.measureTextRecursive = function(ctx) {
	                var width = this.measureText(ctx);
	                for (var i=0; i<this.children.length; i++) {
	                    width += this.children[i].measureTextRecursive(ctx);
	                }
	                return width;
	            }

	            this.measureText = function(ctx) {
	                var customFont = this.parent.style('font-family').getDefinition();
	                if (customFont != null) {
	                    var fontSize = this.parent.style('font-size').numValueOrDefault(svg.Font.Parse(svg.ctx.font).fontSize);
	                    var measure = 0;
	                    var text = this.getText();
	                    if (customFont.isRTL) text = text.split("").reverse().join("");
	                    var dx = svg.ToNumberArray(this.parent.attribute('dx').value);
	                    for (var i=0; i<text.length; i++) {
	                        var glyph = this.getGlyph(customFont, text, i);
	                        measure += (glyph.horizAdvX || customFont.horizAdvX) * fontSize / customFont.fontFace.unitsPerEm;
	                        if (typeof(dx[i]) != 'undefined' && !isNaN(dx[i])) {
	                            measure += dx[i];
	                        }
	                    }
	                    return measure;
	                }

	                var textToMeasure = svg.compressSpaces(this.getText());
	                if (!ctx.measureText) return textToMeasure.length * 10;

	                ctx.save();
	                this.setContext(ctx);
	                var width = ctx.measureText(textToMeasure).width;
	                ctx.restore();
	                return width;
	            }
	        }
	        svg.Element.TextElementBase.prototype = new svg.Element.RenderedElementBase;

	        // tspan
	        svg.Element.tspan = function(node) {
	            this.captureTextNodes = true;
	            this.base = svg.Element.TextElementBase;
	            this.base(node);

	            this.text = svg.compressSpaces(node.value || node.text || node.textContent || '');
	            this.getText = function() {
	                // if this node has children, then they own the text
	                if (this.children.length > 0) { return ''; }
	                return this.text;
	            }
	        }
	        svg.Element.tspan.prototype = new svg.Element.TextElementBase;

	        // tref
	        svg.Element.tref = function(node) {
	            this.base = svg.Element.TextElementBase;
	            this.base(node);

	            this.getText = function() {
	                var element = this.getHrefAttribute().getDefinition();
	                if (element != null) return element.children[0].getText();
	            }
	        }
	        svg.Element.tref.prototype = new svg.Element.TextElementBase;

	        // a element
	        svg.Element.a = function(node) {
	            this.base = svg.Element.TextElementBase;
	            this.base(node);

	            this.hasText = node.childNodes.length > 0;
	            for (var i=0; i<node.childNodes.length; i++) {
	                if (node.childNodes[i].nodeType != 3) this.hasText = false;
	            }

	            // this might contain text
	            this.text = this.hasText ? node.childNodes[0].value : '';
	            this.getText = function() {
	                return this.text;
	            }

	            this.baseRenderChildren = this.renderChildren;
	            this.renderChildren = function(ctx) {
	                if (this.hasText) {
	                    // render as text element
	                    this.baseRenderChildren(ctx);
	                    var fontSize = new svg.Property('fontSize', svg.Font.Parse(svg.ctx.font).fontSize);
	                    svg.Mouse.checkBoundingBox(this, new svg.BoundingBox(this.x, this.y - fontSize.toPixels('y'), this.x + this.measureText(ctx), this.y));
	                }
	                else if (this.children.length > 0) {
	                    // render as temporary group
	                    var g = new svg.Element.g();
	                    g.children = this.children;
	                    g.parent = this;
	                    g.render(ctx);
	                }
	            }

	            this.onclick = function() {
	                window.open(this.getHrefAttribute().value);
	            }

	            this.onmousemove = function() {
	                svg.ctx.canvas.style.cursor = 'pointer';
	            }
	        }
	        svg.Element.a.prototype = new svg.Element.TextElementBase;

	        // image element
	        svg.Element.image = function(node) {
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            var href = this.getHrefAttribute().value;
	            if (href == '') { return; }
	            var isSvg = href.match(/\.svg$/)

	            svg.Images.push(this);
	            this.loaded = false;
	            if (!isSvg) {
	                this.img = document.createElement('img');
	                if (svg.opts['useCORS'] == true) { this.img.crossOrigin = 'Anonymous'; }
	                var self = this;
	                this.img.onload = function() { self.loaded = true; }
	                this.img.onerror = function() { svg.log('ERROR: image "' + href + '" not found'); self.loaded = true; }
	                this.img.src = href;
	            }
	            else {
	                this.img = svg.ajax(href);
	                this.loaded = true;
	            }

	            this.renderChildren = function(ctx) {
	                var x = this.attribute('x').toPixels('x');
	                var y = this.attribute('y').toPixels('y');

	                var width = this.attribute('width').toPixels('x');
	                var height = this.attribute('height').toPixels('y');
	                if (width == 0 || height == 0) return;

	                ctx.save();
	                if (isSvg) {
	                    ctx.drawSvg(this.img, x, y, width, height);
	                }
	                else {
	                    ctx.translate(x, y);
	                    svg.AspectRatio(ctx,
	                                    this.attribute('preserveAspectRatio').value,
	                                    width,
	                                    this.img.width,
	                                    height,
	                                    this.img.height,
	                                    0,
	                                    0);
	                    ctx.drawImage(this.img, 0, 0);
	                }
	                ctx.restore();
	            }

	            this.getBoundingBox = function() {
	                var x = this.attribute('x').toPixels('x');
	                var y = this.attribute('y').toPixels('y');
	                var width = this.attribute('width').toPixels('x');
	                var height = this.attribute('height').toPixels('y');
	                return new svg.BoundingBox(x, y, x + width, y + height);
	            }
	        }
	        svg.Element.image.prototype = new svg.Element.RenderedElementBase;

	        // group element
	        svg.Element.g = function(node) {
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            this.getBoundingBox = function() {
	                var bb = new svg.BoundingBox();
	                for (var i=0; i<this.children.length; i++) {
	                    bb.addBoundingBox(this.children[i].getBoundingBox());
	                }
	                return bb;
	            };
	        }
	        svg.Element.g.prototype = new svg.Element.RenderedElementBase;

	        // symbol element
	        svg.Element.symbol = function(node) {
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            this.render = function(ctx) {
	                // NO RENDER
	            };
	        }
	        svg.Element.symbol.prototype = new svg.Element.RenderedElementBase;

	        // style element
	        svg.Element.style = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            // text, or spaces then CDATA
	            var css = ''
	            for (var i=0; i<node.childNodes.length; i++) {
	              css += node.childNodes[i].data;
	            }
	            css = css.replace(/(\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, ''); // remove comments
	            css = svg.compressSpaces(css); // replace whitespace
	            var cssDefs = css.split('}');
	            for (var i=0; i<cssDefs.length; i++) {
	                if (svg.trim(cssDefs[i]) != '') {
	                    var cssDef = cssDefs[i].split('{');
	                    var cssClasses = cssDef[0].split(',');
	                    var cssProps = cssDef[1].split(';');
	                    for (var j=0; j<cssClasses.length; j++) {
	                        var cssClass = svg.trim(cssClasses[j]);
	                        if (cssClass != '') {
	                            var props = svg.Styles[cssClass] || {};
	                            for (var k=0; k<cssProps.length; k++) {
	                                var prop = cssProps[k].indexOf(':');
	                                var name = cssProps[k].substr(0, prop);
	                                var value = cssProps[k].substr(prop + 1, cssProps[k].length - prop);
	                                if (name != null && value != null) {
	                                    props[svg.trim(name)] = new svg.Property(svg.trim(name), svg.trim(value));
	                                }
	                            }
	                            svg.Styles[cssClass] = props;
	                            svg.StylesSpecificity[cssClass] = getSelectorSpecificity(cssClass);
	                            if (cssClass == '@font-face') {
	                                var fontFamily = props['font-family'].value.replace(/"/g,'');
	                                var srcs = props['src'].value.split(',');
	                                for (var s=0; s<srcs.length; s++) {
	                                    if (srcs[s].indexOf('format("svg")') > 0) {
	                                        var urlStart = srcs[s].indexOf('url');
	                                        var urlEnd = srcs[s].indexOf(')', urlStart);
	                                        var url = srcs[s].substr(urlStart + 5, urlEnd - urlStart - 6);
	                                        var doc = svg.parseXml(svg.ajax(url));
	                                        var fonts = doc.getElementsByTagName('font');
	                                        for (var f=0; f<fonts.length; f++) {
	                                            var font = svg.CreateElement(fonts[f]);
	                                            svg.Definitions[fontFamily] = font;
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        svg.Element.style.prototype = new svg.Element.ElementBase;

	        // use element
	        svg.Element.use = function(node) {
	            this.base = svg.Element.RenderedElementBase;
	            this.base(node);

	            this.baseSetContext = this.setContext;
	            this.setContext = function(ctx) {
	                this.baseSetContext(ctx);
	                if (this.attribute('x').hasValue()) ctx.translate(this.attribute('x').toPixels('x'), 0);
	                if (this.attribute('y').hasValue()) ctx.translate(0, this.attribute('y').toPixels('y'));
	            }

	            var element = this.getHrefAttribute().getDefinition();

	            this.path = function(ctx) {
	                if (element != null) element.path(ctx);
	            }

	            this.getBoundingBox = function() {
	                if (element != null) return element.getBoundingBox();
	            }

	            this.renderChildren = function(ctx) {
	                if (element != null) {
	                    var tempSvg = element;
	                    if (element.type == 'symbol') {
	                        // render me using a temporary svg element in symbol cases (http://www.w3.org/TR/SVG/struct.html#UseElement)
	                        tempSvg = new svg.Element.svg();
	                        tempSvg.type = 'svg';
	                        tempSvg.attributes['viewBox'] = new svg.Property('viewBox', element.attribute('viewBox').value);
	                        tempSvg.attributes['preserveAspectRatio'] = new svg.Property('preserveAspectRatio', element.attribute('preserveAspectRatio').value);
	                        tempSvg.attributes['overflow'] = new svg.Property('overflow', element.attribute('overflow').value);
	                        tempSvg.children = element.children;
	                    }
	                    if (tempSvg.type == 'svg') {
	                        // if symbol or svg, inherit width/height from me
	                        if (this.attribute('width').hasValue()) tempSvg.attributes['width'] = new svg.Property('width', this.attribute('width').value);
	                        if (this.attribute('height').hasValue()) tempSvg.attributes['height'] = new svg.Property('height', this.attribute('height').value);
	                    }
	                    var oldParent = tempSvg.parent;
	                    tempSvg.parent = null;
	                    tempSvg.render(ctx);
	                    tempSvg.parent = oldParent;
	                }
	            }
	        }
	        svg.Element.use.prototype = new svg.Element.RenderedElementBase;

	        // mask element
	        svg.Element.mask = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.apply = function(ctx, element) {
	                // render as temp svg
	                var x = this.attribute('x').toPixels('x');
	                var y = this.attribute('y').toPixels('y');
	                var width = this.attribute('width').toPixels('x');
	                var height = this.attribute('height').toPixels('y');

	                if (width == 0 && height == 0) {
	                    var bb = new svg.BoundingBox();
	                    for (var i=0; i<this.children.length; i++) {
	                        bb.addBoundingBox(this.children[i].getBoundingBox());
	                    }
	                    var x = Math.floor(bb.x1);
	                    var y = Math.floor(bb.y1);
	                    var width = Math.floor(bb.width());
	                    var height = Math.floor(bb.height());
	                }

	                // temporarily remove mask to avoid recursion
	                var mask = element.attribute('mask').value;
	                element.attribute('mask').value = '';

	                    var cMask = document.createElement('canvas');
	                    cMask.width = x + width;
	                    cMask.height = y + height;
	                    var maskCtx = cMask.getContext('2d');
	                    this.renderChildren(maskCtx);

	                    var c = document.createElement('canvas');
	                    c.width = x + width;
	                    c.height = y + height;
	                    var tempCtx = c.getContext('2d');
	                    element.render(tempCtx);
	                    tempCtx.globalCompositeOperation = 'destination-in';
	                    tempCtx.fillStyle = maskCtx.createPattern(cMask, 'no-repeat');
	                    tempCtx.fillRect(0, 0, x + width, y + height);

	                    ctx.fillStyle = tempCtx.createPattern(c, 'no-repeat');
	                    ctx.fillRect(0, 0, x + width, y + height);

	                // reassign mask
	                element.attribute('mask').value = mask;
	            }

	            this.render = function(ctx) {
	                // NO RENDER
	            }
	        }
	        svg.Element.mask.prototype = new svg.Element.ElementBase;

	        // clip element
	        svg.Element.clipPath = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.apply = function(ctx) {
	                var oldBeginPath = CanvasRenderingContext2D.prototype.beginPath;
	                CanvasRenderingContext2D.prototype.beginPath = function () { };

	                var oldClosePath = CanvasRenderingContext2D.prototype.closePath;
	                CanvasRenderingContext2D.prototype.closePath = function () { };

	                oldBeginPath.call(ctx);
	                for (var i=0; i<this.children.length; i++) {
	                    var child = this.children[i];
	                    if (typeof(child.path) != 'undefined') {
	                        var transform = null;
	                        if (child.style('transform', false, true).hasValue()) {
	                            transform = new svg.Transform(child.style('transform', false, true).value);
	                            transform.apply(ctx);
	                        }
	                        child.path(ctx);
	                        CanvasRenderingContext2D.prototype.closePath = oldClosePath;
	                        if (transform) { transform.unapply(ctx); }
	                    }
	                }
	                oldClosePath.call(ctx);
	                ctx.clip();

	                CanvasRenderingContext2D.prototype.beginPath = oldBeginPath;
	                CanvasRenderingContext2D.prototype.closePath = oldClosePath;
	            }

	            this.render = function(ctx) {
	                // NO RENDER
	            }
	        }
	        svg.Element.clipPath.prototype = new svg.Element.ElementBase;

	        // filters
	        svg.Element.filter = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.apply = function(ctx, element) {
	                // render as temp svg
	                var bb = element.getBoundingBox();
	                var x = Math.floor(bb.x1);
	                var y = Math.floor(bb.y1);
	                var width = Math.floor(bb.width());
	                var height = Math.floor(bb.height());

	                // temporarily remove filter to avoid recursion
	                var filter = element.style('filter').value;
	                element.style('filter').value = '';

	                var px = 0, py = 0;
	                for (var i=0; i<this.children.length; i++) {
	                    var efd = this.children[i].extraFilterDistance || 0;
	                    px = Math.max(px, efd);
	                    py = Math.max(py, efd);
	                }

	                var c = document.createElement('canvas');
	                c.width = width + 2*px;
	                c.height = height + 2*py;
	                var tempCtx = c.getContext('2d');
	                tempCtx.translate(-x + px, -y + py);
	                element.render(tempCtx);

	                // apply filters
	                for (var i=0; i<this.children.length; i++) {
	                    if (typeof(this.children[i].apply) === 'function') {
	                        this.children[i].apply(tempCtx, 0, 0, width + 2*px, height + 2*py);
	                    }
	                }

	                // render on me
	                ctx.drawImage(c, 0, 0, width + 2*px, height + 2*py, x - px, y - py, width + 2*px, height + 2*py);

	                // reassign filter
	                element.style('filter', true).value = filter;
	            }

	            this.render = function(ctx) {
	                // NO RENDER
	            }
	        }
	        svg.Element.filter.prototype = new svg.Element.ElementBase;

	        svg.Element.feMorphology = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.apply = function(ctx, x, y, width, height) {
	            }
	        }
	        svg.Element.feMorphology.prototype = new svg.Element.ElementBase;

	        svg.Element.feComposite = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.apply = function(ctx, x, y, width, height) {
	            }
	        }
	        svg.Element.feComposite.prototype = new svg.Element.ElementBase;

	        svg.Element.feColorMatrix = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            var matrix = svg.ToNumberArray(this.attribute('values').value);
	            switch (this.attribute('type').valueOrDefault('matrix')) { // http://www.w3.org/TR/SVG/filters.html#feColorMatrixElement
	                case 'saturate':
	                    var s = matrix[0];
	                    matrix = [0.213+0.787*s,0.715-0.715*s,0.072-0.072*s,0,0,
	                              0.213-0.213*s,0.715+0.285*s,0.072-0.072*s,0,0,
	                              0.213-0.213*s,0.715-0.715*s,0.072+0.928*s,0,0,
	                              0,0,0,1,0,
	                              0,0,0,0,1];
	                    break;
	                case 'hueRotate':
	                    var a = matrix[0] * Math.PI / 180.0;
	                    var c = function (m1,m2,m3) { return m1 + Math.cos(a)*m2 + Math.sin(a)*m3; };
	                    matrix = [c(0.213,0.787,-0.213),c(0.715,-0.715,-0.715),c(0.072,-0.072,0.928),0,0,
	                              c(0.213,-0.213,0.143),c(0.715,0.285,0.140),c(0.072,-0.072,-0.283),0,0,
	                              c(0.213,-0.213,-0.787),c(0.715,-0.715,0.715),c(0.072,0.928,0.072),0,0,
	                              0,0,0,1,0,
	                              0,0,0,0,1];
	                    break;
	                case 'luminanceToAlpha':
	                    matrix = [0,0,0,0,0,
	                              0,0,0,0,0,
	                              0,0,0,0,0,
	                              0.2125,0.7154,0.0721,0,0,
	                              0,0,0,0,1];
	                    break;
	            }

	            function imGet(img, x, y, width, height, rgba) {
	                return img[y*width*4 + x*4 + rgba];
	            }

	            function imSet(img, x, y, width, height, rgba, val) {
	                img[y*width*4 + x*4 + rgba] = val;
	            }

	            function m(i, v) {
	                var mi = matrix[i];
	                return mi * (mi < 0 ? v - 255 : v);
	            }

	            this.apply = function(ctx, x, y, width, height) {
	                // assuming x==0 && y==0 for now
	                var srcData = ctx.getImageData(0, 0, width, height);
	                for (var y = 0; y < height; y++) {
	                    for (var x = 0; x < width; x++) {
	                        var r = imGet(srcData.data, x, y, width, height, 0);
	                        var g = imGet(srcData.data, x, y, width, height, 1);
	                        var b = imGet(srcData.data, x, y, width, height, 2);
	                        var a = imGet(srcData.data, x, y, width, height, 3);
	                        imSet(srcData.data, x, y, width, height, 0, m(0,r)+m(1,g)+m(2,b)+m(3,a)+m(4,1));
	                        imSet(srcData.data, x, y, width, height, 1, m(5,r)+m(6,g)+m(7,b)+m(8,a)+m(9,1));
	                        imSet(srcData.data, x, y, width, height, 2, m(10,r)+m(11,g)+m(12,b)+m(13,a)+m(14,1));
	                        imSet(srcData.data, x, y, width, height, 3, m(15,r)+m(16,g)+m(17,b)+m(18,a)+m(19,1));
	                    }
	                }
	                ctx.clearRect(0, 0, width, height);
	                ctx.putImageData(srcData, 0, 0);
	            }
	        }
	        svg.Element.feColorMatrix.prototype = new svg.Element.ElementBase;

	        svg.Element.feGaussianBlur = function(node) {
	            this.base = svg.Element.ElementBase;
	            this.base(node);

	            this.blurRadius = Math.floor(this.attribute('stdDeviation').numValue());
	            this.extraFilterDistance = this.blurRadius;

	            this.apply = function(ctx, x, y, width, height) {
	                if (typeof(stackBlur.canvasRGBA) == 'undefined') {
	                    svg.log('ERROR: StackBlur.js must be included for blur to work');
	                    return;
	                }

	                // StackBlur requires canvas be on document
	                ctx.canvas.id = svg.UniqueId();
	                ctx.canvas.style.display = 'none';
	                document.body.appendChild(ctx.canvas);
	                stackBlur.canvasRGBA(ctx.canvas.id, x, y, width, height, this.blurRadius);
	                document.body.removeChild(ctx.canvas);
	            }
	        }
	        svg.Element.feGaussianBlur.prototype = new svg.Element.ElementBase;

	        // title element, do nothing
	        svg.Element.title = function(node) {
	        }
	        svg.Element.title.prototype = new svg.Element.ElementBase;

	        // desc element, do nothing
	        svg.Element.desc = function(node) {
	        }
	        svg.Element.desc.prototype = new svg.Element.ElementBase;

	        svg.Element.MISSING = function(node) {
	            svg.log('ERROR: Element \'' + node.nodeName + '\' not yet implemented.');
	        }
	        svg.Element.MISSING.prototype = new svg.Element.ElementBase;

	        // element factory
	        svg.CreateElement = function(node) {
	            var className = node.nodeName.replace(/^[^:]+:/,''); // remove namespace
	            className = className.replace(/\-/g,''); // remove dashes
	            var e = null;
	            if (typeof(svg.Element[className]) != 'undefined') {
	                e = new svg.Element[className](node);
	            }
	            else {
	                e = new svg.Element.MISSING(node);
	            }

	            e.type = node.nodeName;
	            return e;
	        }

	        // load from url
	        svg.load = function(ctx, url) {
	            svg.loadXml(ctx, svg.ajax(url));
	        }

	        // load from xml
	        svg.loadXml = function(ctx, xml) {
	            svg.loadXmlDoc(ctx, svg.parseXml(xml));
	        }

	        svg.loadXmlDoc = function(ctx, dom) {
	            svg.init(ctx);

	            var mapXY = function(p) {
	                var e = ctx.canvas;
	                while (e) {
	                    p.x -= e.offsetLeft;
	                    p.y -= e.offsetTop;
	                    e = e.offsetParent;
	                }
	                if (window.scrollX) p.x += window.scrollX;
	                if (window.scrollY) p.y += window.scrollY;
	                return p;
	            }

	            // bind mouse
	            if (svg.opts['ignoreMouse'] != true) {
	                ctx.canvas.onclick = function(e) {
	                    var p = mapXY(new svg.Point(e != null ? e.clientX : event.clientX, e != null ? e.clientY : event.clientY));
	                    svg.Mouse.onclick(p.x, p.y);
	                };
	                ctx.canvas.onmousemove = function(e) {
	                    var p = mapXY(new svg.Point(e != null ? e.clientX : event.clientX, e != null ? e.clientY : event.clientY));
	                    svg.Mouse.onmousemove(p.x, p.y);
	                };
	            }

	            var e = svg.CreateElement(dom.documentElement);
	            e.root = true;
	            e.addStylesFromStyleDefinition();

	            // render loop
	            var isFirstRender = true;
	            var draw = function() {
	                svg.ViewPort.Clear();
	                if (ctx.canvas.parentNode) svg.ViewPort.SetCurrent(ctx.canvas.parentNode.clientWidth, ctx.canvas.parentNode.clientHeight);

	                if (svg.opts['ignoreDimensions'] != true) {
	                    // set canvas size
	                    if (e.style('width').hasValue()) {
	                        ctx.canvas.width = e.style('width').toPixels('x');
	                        ctx.canvas.style.width = ctx.canvas.width + 'px';
	                    }
	                    if (e.style('height').hasValue()) {
	                        ctx.canvas.height = e.style('height').toPixels('y');
	                        ctx.canvas.style.height = ctx.canvas.height + 'px';
	                    }
	                }
	                var cWidth = ctx.canvas.clientWidth || ctx.canvas.width;
	                var cHeight = ctx.canvas.clientHeight || ctx.canvas.height;
	                if (svg.opts['ignoreDimensions'] == true && e.style('width').hasValue() && e.style('height').hasValue()) {
	                    cWidth = e.style('width').toPixels('x');
	                    cHeight = e.style('height').toPixels('y');
	                }
	                svg.ViewPort.SetCurrent(cWidth, cHeight);

	                if (svg.opts['offsetX'] != null) e.attribute('x', true).value = svg.opts['offsetX'];
	                if (svg.opts['offsetY'] != null) e.attribute('y', true).value = svg.opts['offsetY'];
	                if (svg.opts['scaleWidth'] != null || svg.opts['scaleHeight'] != null) {
	                    var xRatio = null, yRatio = null, viewBox = svg.ToNumberArray(e.attribute('viewBox').value);

	                    if (svg.opts['scaleWidth'] != null) {
	                        if (e.attribute('width').hasValue()) xRatio = e.attribute('width').toPixels('x') / svg.opts['scaleWidth'];
	                        else if (!isNaN(viewBox[2])) xRatio = viewBox[2] / svg.opts['scaleWidth'];
	                    }

	                    if (svg.opts['scaleHeight'] != null) {
	                        if (e.attribute('height').hasValue()) yRatio = e.attribute('height').toPixels('y') / svg.opts['scaleHeight'];
	                        else if (!isNaN(viewBox[3])) yRatio = viewBox[3] / svg.opts['scaleHeight'];
	                    }

	                    if (xRatio == null) { xRatio = yRatio; }
	                    if (yRatio == null) { yRatio = xRatio; }

	                    e.attribute('width', true).value = svg.opts['scaleWidth'];
	                    e.attribute('height', true).value = svg.opts['scaleHeight'];
	                    e.style('transform', true, true).value += ' scale('+(1.0/xRatio)+','+(1.0/yRatio)+')';
	                }

	                // clear and render
	                if (svg.opts['ignoreClear'] != true) {
	                    ctx.clearRect(0, 0, cWidth, cHeight);
	                }
	                e.render(ctx);
	                if (isFirstRender) {
	                    isFirstRender = false;
	                    if (typeof(svg.opts['renderCallback']) == 'function') svg.opts['renderCallback'](dom);
	                }
	            }

	            var waitingForImages = true;
	            if (svg.ImagesLoaded()) {
	                waitingForImages = false;
	                draw();
	            }
	            svg.intervalID = setInterval(function() {
	                var needUpdate = false;

	                if (waitingForImages && svg.ImagesLoaded()) {
	                    waitingForImages = false;
	                    needUpdate = true;
	                }

	                // need update from mouse events?
	                if (svg.opts['ignoreMouse'] != true) {
	                    needUpdate = needUpdate | svg.Mouse.hasEvents();
	                }

	                // need update from animations?
	                if (svg.opts['ignoreAnimation'] != true) {
	                    for (var i=0; i<svg.Animations.length; i++) {
	                        needUpdate = needUpdate | svg.Animations[i].update(1000 / svg.FRAMERATE);
	                    }
	                }

	                // need update from redraw?
	                if (typeof(svg.opts['forceRedraw']) == 'function') {
	                    if (svg.opts['forceRedraw']() == true) needUpdate = true;
	                }

	                // render if needed
	                if (needUpdate) {
	                    draw();
	                    svg.Mouse.runEvents(); // run and clear our events
	                }
	            }, 1000 / svg.FRAMERATE);
	        }

	        svg.stop = function() {
	            if (svg.intervalID) {
	                clearInterval(svg.intervalID);
	            }
	        }

	        svg.Mouse = new (function() {
	            this.events = [];
	            this.hasEvents = function() { return this.events.length != 0; }

	            this.onclick = function(x, y) {
	                this.events.push({ type: 'onclick', x: x, y: y,
	                    run: function(e) { if (e.onclick) e.onclick(); }
	                });
	            }

	            this.onmousemove = function(x, y) {
	                this.events.push({ type: 'onmousemove', x: x, y: y,
	                    run: function(e) { if (e.onmousemove) e.onmousemove(); }
	                });
	            }

	            this.eventElements = [];

	            this.checkPath = function(element, ctx) {
	                for (var i=0; i<this.events.length; i++) {
	                    var e = this.events[i];
	                    if (ctx.isPointInPath && ctx.isPointInPath(e.x, e.y)) this.eventElements[i] = element;
	                }
	            }

	            this.checkBoundingBox = function(element, bb) {
	                for (var i=0; i<this.events.length; i++) {
	                    var e = this.events[i];
	                    if (bb.isPointInBox(e.x, e.y)) this.eventElements[i] = element;
	                }
	            }

	            this.runEvents = function() {
	                svg.ctx.canvas.style.cursor = '';

	                for (var i=0; i<this.events.length; i++) {
	                    var e = this.events[i];
	                    var element = this.eventElements[i];
	                    while (element) {
	                        e.run(element);
	                        element = element.parent;
	                    }
	                }

	                // done running, clear
	                this.events = [];
	                this.eventElements = [];
	            }
	        });

	        return svg;
	    };

	    if (typeof(CanvasRenderingContext2D) != 'undefined') {
	        CanvasRenderingContext2D.prototype.drawSvg = function(s, dx, dy, dw, dh) {
	            canvg(this.canvas, s, {
	                ignoreMouse: true,
	                ignoreAnimation: true,
	                ignoreDimensions: true,
	                ignoreClear: true,
	                offsetX: dx,
	                offsetY: dy,
	                scaleWidth: dw,
	                scaleHeight: dh
	            });
	        }
	    }

	    return canvg;

	}));

	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(13)))

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__,
	    __webpack_require__(3),
	    __webpack_require__(219),
	    __webpack_require__(228)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, _, Workbook, JSZip) {
	    
	    /**
	     * @name Excel
	     * @public
	     * @author Stephen Liberty
	     * @requires underscore
	     * @requires Excel/Workbook
	     * @requires JSZIP
	     * @exports excel-builder
	     */
	    var Factory = {
	        /**
	         * Creates a new workbook.
	         */
	        createWorkbook: function () {
	            return new Workbook();
	        },
	        
	        /**
	         * Turns a workbook into a downloadable file. 
	         * @param {Excel/Workbook} workbook The workbook that is being converted
	         * @param {Object} options
	         * @param {Boolean} options.base64 Whether to 'return' the generated file as a base64 string
	         * @param {Function} options.success The callback function to run after workbook creation is successful.
	         * @param {Function} options.error The callback function to run if there is an error creating the workbook.
	         * @param {String} options.requireJsPath (Optional) The path to requirejs. Will use the id 'requirejs' to look up the script if not specified.
	         */
	        createFileAsync: function (workbook, options) {
	            
	            
	            workbook.generateFilesAsync({
	                success: function (files) {
	                    
	                    var worker = new Worker(__webpack_require__(268));
	                    worker.addEventListener('message', function(event, data) {
	                        if(event.data.status == 'done') {
	                            options.success(event.data.data);
	                        }
	                    });
	                    worker.postMessage({
	                        files: files,
	                        ziplib: __webpack_require__(228),
	                        base64: (!options || options.base64 !== false)
	                    });
	                },
	                error: function () {
	                    options.error();
	                }
	            });
	        },
	        
	        /**
	         * Turns a workbook into a downloadable file.
	         * @param {Excel/Workbook} workbook The workbook that is being converted
	         * @param {Object} options - options to modify how the zip is created. See http://stuk.github.io/jszip/#doc_generate_options
	         */
	        createFile: function (workbook, options) {
	            var zip = new JSZip();
	            var files = workbook.generateFiles();
	            _.each(files, function (content, path) {
	                path = path.substr(1);
	                if(path.indexOf('.xml') !== -1 || path.indexOf('.rel') !== -1) {
	                    zip.file(path, content, {base64: false});
	                } else {
	                    zip.file(path, content, {base64: true, binary: true});
	                }
	            })
	            return zip.generate(_.defaults(options || {}, {
	                type: "base64"
	            }));
	        }
	    }
	    
	    
	    return Factory;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @module Excel/Workbook
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__,
	    __webpack_require__(3), 
	    __webpack_require__(221), 
	    __webpack_require__(223), 
	    __webpack_require__(224),
	    __webpack_require__(226),
	    __webpack_require__(225),
	    __webpack_require__(220),
	    __webpack_require__(222)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (require, _, util, StyleSheet, Worksheet, SharedStrings, RelationshipManager, Paths, XMLDOM) {
	    "use strict";
	    var Workbook = function (config) {
	        this.worksheets = [];
	        this.tables = [];
	        this.drawings = [];
	        this.media = {};
	        this.initialize(config);
	    };
	    _.extend(Workbook.prototype, {

	        initialize: function () {
	            this.id = _.uniqueId('Workbook');
	            this.styleSheet = new StyleSheet();
	            this.sharedStrings = new SharedStrings();
	            this.relations = new RelationshipManager();
	            this.relations.addRelation(this.styleSheet, 'stylesheet');
	            this.relations.addRelation(this.sharedStrings, 'sharedStrings');
	        },

	        createWorksheet: function (config) {
	            config = config || {};
	            _.defaults(config, {
	                name: 'Sheet '.concat(this.worksheets.length + 1)
	            });
	            return new Worksheet(config);
	        },
	        
	        getStyleSheet: function () {
	            return this.styleSheet;
	        },

	        addTable: function (table) {
	            this.tables.push(table);
	        },
	                
	        addDrawings: function (drawings) {
	            this.drawings.push(drawings);
	        },
	        
	        addMedia: function (type, fileName, fileData, contentType) {
	            var fileNamePieces = fileName.split('.');
	            var extension = fileNamePieces[fileNamePieces.length - 1];
	            if(!contentType) {
	                switch(extension.toLowerCase()) {
	                    case 'jpeg':
	                    case 'jpg':
	                        contentType = "image/jpeg";
	                        break;
	                    case 'png': 
	                        contentType = "image/png";
	                        break;
	                    case 'gif': 
	                        contentType = "image/gif";
	                        break;
	                    default: 
	                        contentType = null;
	                        break;
	                }
	            }
	            if(!this.media[fileName]) {
	                this.media[fileName] = {
	                    id: fileName,
	                    data: fileData,
	                    fileName: fileName,
	                    contentType: contentType,
	                    extension: extension
	                };
	            }
	            return this.media[fileName];
	        },
	        
	        addWorksheet: function (worksheet) {
	            this.relations.addRelation(worksheet, 'worksheet');
	            worksheet.setSharedStringCollection(this.sharedStrings);
	            this.worksheets.push(worksheet);
	        },

	        createContentTypes: function () {
	            var doc = util.createXmlDoc(util.schemas.contentTypes, 'Types');
	            var types = doc.documentElement;
	            var i, l;
	            
	            types.appendChild(util.createElement(doc, 'Default', [
	                ['Extension', "rels"],
	                ['ContentType', "application/vnd.openxmlformats-package.relationships+xml"]
	            ]));
	            types.appendChild(util.createElement(doc, 'Default', [
	                ['Extension', "xml"],
	                ['ContentType', "application/xml"]
	            ]));
	            
	            var extensions = {};
	            for(var filename in this.media) {
	                if(this.media.hasOwnProperty(filename)) {
	                    extensions[this.media[filename].extension] = this.media[filename].contentType;
	                }
	            }
	            for(var extension in extensions) {
	                if(extensions.hasOwnProperty(extension)) {
	                    types.appendChild(util.createElement(doc, 'Default', [
	                        ['Extension', extension],
	                        ['ContentType', extensions[extension]]
	                    ]));
	                }
	            }
	            
	            types.appendChild(util.createElement(doc, 'Override', [
	                ['PartName', "/xl/workbook.xml"],
	                ['ContentType', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"]
	            ]));
	            types.appendChild(util.createElement(doc, 'Override', [
	                ['PartName', "/xl/sharedStrings.xml"],
	                ['ContentType', "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"]
	            ]));
	            types.appendChild(util.createElement(doc, 'Override', [
	                ['PartName', "/xl/styles.xml"],
	                ['ContentType', "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"]
	            ]));

	            for(i = 0, l = this.worksheets.length; i < l; i++) {
	                types.appendChild(util.createElement(doc, 'Override', [
	                    ['PartName', "/xl/worksheets/sheet" + (i + 1) + ".xml"],
	                    ['ContentType', "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"]
	                ]));
	            }
	            for(i = 0, l = this.tables.length; i < l; i++) {
	                types.appendChild(util.createElement(doc, 'Override', [
	                    ['PartName', "/xl/tables/table" + (i + 1) + ".xml"],
	                    ['ContentType', "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"]
	                ]));
	            }
	            
	            for(i = 0, l = this.drawings.length; i < l; i++) {
	                types.appendChild(util.createElement(doc, 'Override', [
	                    ['PartName', '/xl/drawings/drawing' + (i + 1) + '.xml'],
	                    ['ContentType', 'application/vnd.openxmlformats-officedocument.drawing+xml']
	                ]));
	            }
	            
	            return doc;
	        },

	        /** Added by jsreports */
	        setPrintArea: function(startCol, endCol) {
	            this.printArea = {
	                startCol: startCol,
	                endCol: endCol
	            };
	        },        

	        toXML: function () {
	            var doc = util.createXmlDoc(util.schemas.spreadsheetml, 'workbook');
	            var wb = doc.documentElement;
	            wb.setAttribute('xmlns:r', util.schemas.relationships);

	            var maxWorksheetNameLength = 31;
	            var sheets = util.createElement(doc, 'sheets');
	            for(var i = 0, l = this.worksheets.length; i < l; i++) {
	                var sheet = doc.createElement('sheet');
	                // Microsoft Excel (2007, 2013) do not allow worksheet names longer than 31 characters
	                // if the worksheet name is longer, Excel displays an "Excel found unreadable content..." popup when opening the file
	                if(console != null && this.worksheets[i].name.length > maxWorksheetNameLength) {
	                    // console.log('Microsoft Excel requires work sheet names to be less than ' + (maxWorksheetNameLength+1) +
	                    //         ' characters long, work sheet name "' + this.worksheets[i].name +
	                    //         '" is ' + this.worksheets[i].name.length + ' characters long');
	                }
	                sheet.setAttribute('name', this.worksheets[i].name);
	                sheet.setAttribute('sheetId', i + 1);
	                sheet.setAttribute('r:id', this.relations.getRelationshipId(this.worksheets[i]));
	                sheets.appendChild(sheet);
	            }
	            wb.appendChild(sheets);

	            /** Added by jsreports */
	            if (this.printArea) {
	                var definedNames = doc.createElement('definedNames');
	                var definedName = doc.createElement('definedName');
	                definedName.setAttribute('localSheetId', '0');
	                definedName.setAttribute('name', '_xlnm.Print_Area');
	                definedName.appendChild(doc.createTextNode('Sheet1!$' 
	                    + util.positionToLetterRef(this.printArea.startCol, '') 
	                    + ':$' + util.positionToLetterRef(this.printArea.endCol, '')));
	                definedNames.appendChild(definedName);
	                wb.appendChild(definedNames);
	            }
	                        
	            return doc;
	        },

	        createWorkbookRelationship: function () {
	            var doc = util.createXmlDoc(util.schemas.relationshipPackage, 'Relationships');
	            var relationships = doc.documentElement;
	            relationships.appendChild(util.createElement(doc, 'Relationship', [
	                ['Id', 'rId1'],
	                ['Type', util.schemas.officeDocument],
	                ['Target', 'xl/workbook.xml']
	                ]));
	            return doc;
	        },
	        
	        _generateCorePaths: function (files) {
	            var i, l;
	            Paths[this.styleSheet.id] = 'styles.xml';
	            Paths[this.sharedStrings.id] = 'sharedStrings.xml';
	            Paths[this.id] = '/xl/workbook.xml';
	            
	            for(i = 0, l = this.tables.length; i < l; i++) {
	                files['/xl/tables/table' + (i + 1) + '.xml'] = this.tables[i].toXML();
	                Paths[this.tables[i].id] = '/xl/tables/table' + (i + 1) + '.xml';
	            }
	            
	            for(var fileName in this.media) {
	                if(this.media.hasOwnProperty(fileName)) {
	                    var media = this.media[fileName];
	                    files['/xl/media/' + fileName] = media.data;
	                    Paths[fileName] = '/xl/media/' + fileName;
	                }
	            }
	            
	            for(i = 0, l = this.drawings.length; i < l; i++) {
	                files['/xl/drawings/drawing' + (i + 1) + '.xml'] = this.drawings[i].toXML();
	                Paths[this.drawings[i].id] = '/xl/drawings/drawing' + (i + 1) + '.xml';
	                files['/xl/drawings/_rels/drawing' + (i + 1) + '.xml.rels'] = this.drawings[i].relations.toXML();
	            }
	            
	            
	        },
	        
	        _prepareFilesForPackaging: function (files) {
	            
	            _.extend(files, {
	                '/[Content_Types].xml': this.createContentTypes(),
	                '/_rels/.rels': this.createWorkbookRelationship(),
	                '/xl/styles.xml': this.styleSheet.toXML(),
	                '/xl/workbook.xml': this.toXML(),
	                '/xl/sharedStrings.xml': this.sharedStrings.toXML(),
	                '/xl/_rels/workbook.xml.rels': this.relations.toXML()
	            });

	            _.each(files, function (value, key) {
	                if(key.indexOf('.xml') !== -1 || key.indexOf('.rels') !== -1) {
	                    if (value instanceof XMLDOM){
	                        files[key] = value.toString();
	                    } else {
	                        files[key] = value.xml || new window.XMLSerializer().serializeToString(value);
	                    }
	                    var content = files[key].replace(/xmlns=""/g, '');
	                    content = content.replace(/NS[\d]+:/g, '');
	                    content = content.replace(/xmlns:NS[\d]+=""/g, '');
	                    files[key] = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + "\n" + content;
	                }
	            });
	        },
	        
	        generateFilesAsync: function (options) {
	            var requireJsPath = options.requireJsPath;
	            var self = this;
	            if(!options.requireJsPath) {
	                requireJsPath = document.getElementById('requirejs') ? document.getElementById('requirejs').src : '';
	            }
	            if(!requireJsPath) {
	                throw "Please add 'requirejs' to the script that includes requirejs, or specify the path as an argument";
	            }
	            var files = {},
	                doneCount = this.worksheets.length,
	                stringsCollectedCount = this.worksheets.length,
	                workers = [];
	            
	            var result = {
	                status: "Not Started",
	                terminate: function () {
	                    for(var i = 0; i < workers.length; i++) {
	                        workers[i].terminate();
	                    }
	                }
	            };
	            this._generateCorePaths(files);
	            
	            var done = function () {
	                if(--doneCount === 0) {
	                    self._prepareFilesForPackaging(files);
	                    for(var i = 0; i < workers.length; i++) {
	                        workers[i].terminate();
	                    }
	                    options.success(files);
	                }
	            };
	            var stringsCollected = function () {
	                if(--stringsCollectedCount === 0) {
	                    for(var i = 0; i < workers.length; i++) {
	                        workers[i].postMessage({
	                            instruction: 'export',
	                            sharedStrings: self.sharedStrings.exportData()
	                        });
	                    }
	                }
	            };
	            
	            
	            var worksheetWorker = function (worksheetIndex) {
	                return {
	                    error: function () {
	                        for(var i = 0; i < workers.length; i++) {
	                            workers[i].terminate();
	                        }
	                        //message, filename, lineno
	                        options.error.apply(this, arguments);
	                    },
	                    stringsCollected: function () {
	                        stringsCollected();
	                    },
	                    finished: function (data) {
	                        files['/xl/worksheets/sheet' + (worksheetIndex + 1) + '.xml'] = {xml: data};
	                        Paths[self.worksheets[worksheetIndex].id] = 'worksheets/sheet' + (worksheetIndex + 1) + '.xml';
	                        files['/xl/worksheets/_rels/sheet' + (worksheetIndex + 1) + '.xml.rels'] = self.worksheets[worksheetIndex].relations.toXML();
	                        done();
	                    }
	                };
	            };
	            
	            for(var i = 0, l = this.worksheets.length; i < l; i++) {
	                workers.push(
	                    this._createWorker(requireJsPath, i, worksheetWorker(i))
	                );
	            }
	            
	            return result;
	        },
	                
	        _createWorker: function (requireJsPath, worksheetIndex, callbacks) {
	            var worker = new window.Worker(__webpack_require__(227));
	            var self = this;
	            worker.addEventListener('error', callbacks.error);
	            worker.addEventListener('message', function(event) {
	//                console.log("Called back by the worker!\n", event.data);
	                switch(event.data.status) {
	                    case "ready":
	                        worker.postMessage({
	                            instruction: 'start',
	                            data: self.worksheets[worksheetIndex].exportData()
	                        });
	                        break;
	                    case "sharedStrings":
	                        for(var i = 0; i < event.data.data.length; i++) {
	                            self.sharedStrings.addString(event.data.data[i]);
	                        }
	                        callbacks.stringsCollected();
	                        break;
	                    case "finished":
	                        callbacks.finished(event.data.data);
	                        break;
	                }
	            }, false);
	            worker.postMessage({
	                instruction: 'setup',
	                config: {
	                    paths: {
	                        underscore: __webpack_require__(3).slice(0, -3)
	                    },
	                    shim: {
	                        'underscore': {
	                            exports: '_'
	                        }
	                    }
	                },
	                requireJsPath: requireJsPath
	            });
	            return worker;
	        },
	        
	        generateFiles: function () {
	            var files = {};
	            this._generateCorePaths(files);
	            
	            
	            for(var i = 0, l = this.worksheets.length; i < l; i++) {
	                files['/xl/worksheets/sheet' + (i + 1) + '.xml'] = this.worksheets[i].toXML();
	                Paths[this.worksheets[i].id] = 'worksheets/sheet' + (i + 1) + '.xml';
	                files['/xl/worksheets/_rels/sheet' + (i + 1) + '.xml.rels'] = this.worksheets[i].relations.toXML();
	            }
	            
	            this._prepareFilesForPackaging(files);

	            return files;
	        }
	    });
	    return Workbook;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This is mostly a global spot where all of the relationship managers can get and set
	 * path information from/to. 
	 * @module Excel/Paths
	 */
	!(module.exports = {});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @module Excel/util
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(222)], __WEBPACK_AMD_DEFINE_RESULT__ = function (XMLDOM) {
	    "use strict";
	    var util = {
	        
	        _idSpaces: {},
	        
	        /**
	         * Returns a number based on a namespace. So, running with 'Picture' will return 1. Run again, you will get 2. Run with 'Foo', you'll get 1.
	         * @param {String} space
	         * @returns {Number}
	         */
	        uniqueId: function (space) {
	            if(!this._idSpaces[space]) {
	                this._idSpaces[space] = 1;
	            }
	            return this._idSpaces[space]++;
	        },
	        
	        /**
	         * Attempts to create an XML document. Due to limitations in web workers, 
	         * it may return a 'fake' xml document created from the XMLDOM.js file. 
	         * 
	         * Takes a namespace to start the xml file in, as well as the root element
	         * of the xml file. 
	         * 
	         * @param {type} ns
	         * @param {type} base
	         * @returns {ActiveXObject|@exp;document@pro;implementation@call;createDocument|@new;XMLDOM}
	         */
	        createXmlDoc: function (ns, base) {
	            if(typeof document === 'undefined') {
	                return new XMLDOM(ns || null, base, null);
	            }
	            if(document.implementation && document.implementation.createDocument) {
	                return document.implementation.createDocument(ns || null, base, null);
	            } else if (window.ActiveXObject) {
	                var doc = new window.ActiveXObject( "Microsoft.XMLDOM" );
	                var rootNode = doc.createElement(base);
	                rootNode.setAttribute('xmlns', ns);
	                doc.appendChild(rootNode);
	                return doc;
	            }
	            throw "No xml document generator";
	        },
	        
	        /**
	         * Creates an xml node (element). Used to simplify some calls, as IE is
	         * very particular about namespaces and such. 
	         * 
	         * @param {XMLDOM} doc An xml document (actual DOM or fake DOM, not a string)
	         * @param {type} name The name of the element
	         * @param {type} attributes
	         * @returns {XML Node}
	         */
	        createElement: function (doc, name, attributes) {
	            var el = doc.createElement(name);
	            var ie = !el.setAttributeNS;
	            attributes = attributes || [];
	            var i = attributes.length;
	            while (i--) {
	                if(!ie && attributes[i][0].indexOf('xmlns') !== -1) {
	                    el.setAttributeNS("http://www.w3.org/2000/xmlns/", attributes[i][0], attributes[i][1]);
	                } else {
	                    el.setAttribute(attributes[i][0], attributes[i][1]);
	                }
	            }
	            return el;
	        },
	        
	        LETTER_REFS: {},
		
	        positionToLetterRef: function (x, y) {
	            var digit = 1, index, num = x, string = "", alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	            if(this.LETTER_REFS[x]) {
	                return this.LETTER_REFS[x].concat(y);
	            }
	            while (num > 0) {
	                num -= Math.pow(26, digit -1);
	                index = num % Math.pow(26, digit);
	                num -= index;
	                index = index / Math.pow(26, digit - 1);
	                string = alphabet.charAt(index) + string;
	                digit += 1;
	            }
	            this.LETTER_REFS[x] = string;
	            return string.concat(y);
	        },
			
	        schemas: {
	            'worksheet': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet',
	            'sharedStrings': "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
	            'stylesheet': "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
	            'relationships': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
	            'relationshipPackage': "http://schemas.openxmlformats.org/package/2006/relationships",
	            'contentTypes': "http://schemas.openxmlformats.org/package/2006/content-types",
	            'spreadsheetml': "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
	            'markupCompat': "http://schemas.openxmlformats.org/markup-compatibility/2006",
	            'x14ac': "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
	            'officeDocument': "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	            'package': "http://schemas.openxmlformats.org/package/2006/relationships",
	            'table': "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table",
	            'spreadsheetDrawing': 'http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing',
	            'drawing': 'http://schemas.openxmlformats.org/drawingml/2006/main',
	            'drawingRelationship': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing',
	            'image': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/image',
	            'chart': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart'
	        }
	    };
		
	    return util;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_) {
	    'use strict';
	    var XMLDOM = function (ns, rootNodeName) {
	        this.documentElement = this.createElement(rootNodeName);
	        this.documentElement.setAttribute('xmlns', ns);
	    };
	    
	    _.extend(XMLDOM.prototype, {
	        createElement: function (name) {
	            return new XMLDOM.XMLNode({
	                nodeName: name
	            });
	        },
	        createTextNode: function (text) {
	            return new XMLDOM.TextNode(text);
	        },
	        toString: function () {
	            return this.documentElement.toString();
	        }
	    });
	    
	    XMLDOM.Node = function () {};
	    XMLDOM.Node.Create = function (config) {
	        switch(config.type) {
	            case "XML":
	                return new XMLDOM.XMLNode(config);
	            case "TEXT":
	                return new XMLDOM.TextNode(config.nodeValue);
	        }
	    };
	    
	    XMLDOM.TextNode = function (text) {
	        this.nodeValue = text;
	    };
	     _.extend(XMLDOM.TextNode.prototype, {
	         toJSON: function () {
	             return {
	                 nodeValue: this.nodeValue,
	                 type: 'TEXT'
	             };
	         },
	        toString: function () {
	            return _.escape(this.nodeValue);
	        }
	     });
	    
	    XMLDOM.XMLNode = function (config) {
	        this.nodeName = config.nodeName;
	        this.children = [];
	        this.nodeValue = config.nodeValue || "";
	        this.attributes = {};
	        
	        if(config.children) {
	            for(var i = 0; i < config.children.length; i++) {
	                this.appendChild(XMLDOM.Node.Create(config.children[i]));
	            }
	        }
	        
	        if(config.attributes) {
	            for(var attr in config.attributes) {
	                if(config.attributes.hasOwnProperty(attr)) {
	                    this.setAttribute(attr, config.attributes[attr]);
	                }
	            }
	        }
	    };
	    _.extend(XMLDOM.XMLNode.prototype, {
	        
	        toString: function () {
	            var string = "<" + this.nodeName;
	            var attrs = [];
	            for(var attr in this.attributes) {
	                if(this.attributes.hasOwnProperty(attr)) {
	                    attrs.push(attr + "=\""+_.escape(this.attributes[attr])+"\"");
	                }
	            }
	            if (attrs.length > 0){
	                string+= " " + attrs.join(" ");
	            }

	            var childContent = "";
	            for(var i = 0, l = this.children.length; i < l; i++) {
	                childContent += this.children[i].toString();
	            }

	            if (childContent){
	                string +=  ">" + childContent + "</" + this.nodeName + ">";
	            } else {
	                string += "/>";
	            }

	            return string;
	        },
	        
	        toJSON: function () {
	            var children = [];
	            for(var i = 0, l = this.children.length; i < l; i++) {
	                children.push(this.children[i].toJSON());
	            }
	            return {
	                nodeName: this.nodeName,
	                children: children,
	                nodeValue: this.nodeValue,
	                attributes: this.attributes,
	                type: "XML"
	            };
	        },
	        
	        setAttribute: function (name, val) {
	            if(val === null) {
	                delete this.attributes[name];
	                delete this[name];
	                return;
	            }
	            this.attributes[name] = val;
	            this[name] = val;
	        },
	        setAttributeNS: function (ns, name, val) {
	            this.setAttribute(name, val);
	        },
	        appendChild: function (child) {
	            this.children.push(child);
	            this.firstChild = this.children[0];
	        },
	        cloneNode: function () {
	            return new XMLDOM.XMLNode(this.toJSON());
	        }
	    });
	    
	    return XMLDOM;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @module Excel/StyleSheet
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util) {
	    "use strict";
	    var StyleSheet = function () {
	        this.id = _.uniqueId('StyleSheet');
	        this.cellStyles = [{
	            name:"Normal", 
	            xfId:"0", 
	            builtinId:"0"
	        }];
	        this.defaultTableStyle = false;
	        this.differentialStyles = [{}];
	        this.masterCellFormats = [{
	            numFmtId: 0, 
	            fontId: 0, 
	            fillId: 0, 
	            borderId: 0, 
	            xfid: 0
	        }];
	        this.masterCellStyles = [{
	            numFmtId: 0, 
	            fontId: 0, 
	            fillId: 0, 
	            borderId: 0
	        }];
	        this.fonts = [{}];
	        this.numberFormatters = [];
	        this.fills = [{}, {
	            type: 'pattern', 
	            patternType: 'gray125', 
	            fgColor: 'FF333333', 
	            bgColor: 'FF333333'
	        }];
	        this.borders = [{
	            top: {},
	            left: {},
	            right: {},
	            bottom: {},
	            diagonal: {}
	        }];
	        this.tableStyles = [];
	    };
	    _.extend(StyleSheet.prototype, {
	        createSimpleFormatter: function (type) {
	            var sid = this.masterCellFormats.length;
	            var style = {
	                id: sid
	            };
	            switch(type) {
	                case 'date':
	                    style.numFmtId = 14;
	                    break;
	            }
	            this.masterCellFormats.push(style);
	            return style;
	        },

	        createFill: function (fillInstructions) {
	            var id = this.fills.length;
	            var fill = fillInstructions;
	            fill.id = id;
	            this.fills.push(fill);
	            return fill;
	        },

	        createNumberFormatter: function (formatInstructions) {
	            var id = this.numberFormatters.length + 100;
	            var format = {
	                id: id,
	                formatCode: formatInstructions
	            };
	            this.numberFormatters.push(format);
	            return format;
	        },

	        /**
	        * alignment: {
	        *  horizontal: http://www.schemacentral.com/sc/ooxml/t-ssml_ST_HorizontalAlignment.html
	        *  vertical: http://www.schemacentral.com/sc/ooxml/t-ssml_ST_VerticalAlignment.html
	        *  @param {Object} styleInstructions
	        */
	        createFormat: function (styleInstructions) {
	            var sid = this.masterCellFormats.length;
	            var style = {
	                id: sid
	            };
	            if(styleInstructions.font && _.isObject(styleInstructions.font)) {
	                style.fontId = this.createFontStyle(styleInstructions.font).id;
	            } else if(styleInstructions.font) {
	                if(_.isNaN(parseInt(styleInstructions.font, 10))) {
	                    throw "Passing a non-numeric font id is not supported";
	                }
	                style.fontId = styleInstructions.font;
	            }

	            if (styleInstructions.format && _.isString(styleInstructions.format)) {
	                style.numFmtId = this.createNumberFormatter(styleInstructions.format).id;
	            } else if(styleInstructions.format) {
	                if(_.isNaN(parseInt(styleInstructions.format, 10))) {
	                    throw "Invalid number formatter id";
	                }
	                style.numFmtId = styleInstructions.format;
	            }

	            if (styleInstructions.border && _.isObject(styleInstructions.border)) {
	                style.borderId = this.createBorderFormatter(styleInstructions.border).id;
	            } else if (styleInstructions.border) {
	                if(_.isNaN(parseInt(styleInstructions.border, 10))) {
	                    throw "Passing a non-numeric border id is not supported";
	                }
	                style.borderId = styleInstructions.border;
	            }

	            if (styleInstructions.fill && _.isObject(styleInstructions.fill)) {
	                style.fillId = this.createFill(styleInstructions.fill).id;
	            } else if (styleInstructions.fill) {
	                if(_.isNaN(parseInt(styleInstructions.fill, 10))) {
	                    throw "Passing a non-numeric fill id is not supported";
	                }
	                style.fillId = styleInstructions.fill;
	            }

	            if (styleInstructions.alignment && _.isObject(styleInstructions.alignment)) {
	                style.alignment = _.pick(
	                    styleInstructions.alignment,
	                    'horizontal',
	                    'justifyLastLine',
	                    'readingOrder',
	                    'relativeIndent',
	                    'shrinkToFit',
	                    'textRotation',
	                    'vertical',
	                    'wrapText'
	                    );
	            }

	            this.masterCellFormats.push(style);
	            return style;
	        },
	        
	        createDifferentialStyle: function (styleInstructions) {
	            var id = this.differentialStyles.length;
	            var style = {
	                id: id
	            };
	            if(styleInstructions.font && _.isObject(styleInstructions.font)) {
	                style.font = styleInstructions.font;
	            }
	            if (styleInstructions.border && _.isObject(styleInstructions.border)) {
	                style.border = _.defaults(styleInstructions.border, {
	                    top: {},
	                    left: {},
	                    right: {},
	                    bottom: {},
	                    diagonal: {}
			});
	            }
	            if (styleInstructions.fill && _.isObject(styleInstructions.fill)) {
	                style.fill = styleInstructions.fill;
	            }
	            if (styleInstructions.alignment && _.isObject(styleInstructions.alignment)) {
	                style.alignment = styleInstructions.alignment;
	            }
	            if (styleInstructions.format && _.isString(styleInstructions.format)) {
	                style.numFmt = styleInstructions.format;
	            }
	            this.differentialStyles[id] = style;
	            return style;
	        },
	        
	        /**
	         * Should be an object containing keys that match with one of the keys from this list:
	         * http://www.schemacentral.com/sc/ooxml/t-ssml_ST_TableStyleType.html
	         * 
	         * The value should be a reference to a differential format (dxf)
	         * @param {Object} instructions
	         */
	        createTableStyle: function (instructions) {
	            this.tableStyles.push(instructions);
	        },
	        
	        /**
	        * All params optional
	        * Expects: {
	        * top: {},
	        * left: {},
	        * right: {},
	        * bottom: {},
	        * diagonal: {},
	        * outline: boolean,
	        * diagonalUp: boolean,
	        * diagonalDown: boolean
	        * }
	        * Each border should follow:
	        * {
	        * style: styleString, http://www.schemacentral.com/sc/ooxml/t-ssml_ST_BorderStyle.html
	        * color: ARBG color (requires the A, so for example FF006666)
	        * }
	        * @param {Object} border
	        */
	        createBorderFormatter: function (border) {
	            _.defaults(border, {
	                top: {},
	                left: {},
	                right: {},
	                bottom: {},
	                diagonal: {},
	                id: this.borders.length
	            });
	            this.borders.push(border);
	            return border;
	        },

	        /**
	        * Supported font styles:
	        * bold
	        * italic
	        * underline (single, double, singleAccounting, doubleAccounting)
	        * size
	        * color
	        * fontName
	        * strike (strikethrough)
	        * outline (does this actually do anything?)
	        * shadow (does this actually do anything?)
	        * superscript
	        * subscript
	        *
	        * Color is a future goal - at the moment it's looking a bit complicated
	        * @param {Object} instructions
	        */
	        createFontStyle: function (instructions) {
	            var fontId = this.fonts.length;
	            var fontStyle = {
	                id: fontId
	            };
	            if(instructions.bold) {
	                fontStyle.bold = true;
	            }
	            if(instructions.italic) {
	                fontStyle.italic = true;
	            }
	            if(instructions.superscript) {
	                fontStyle.vertAlign = 'superscript';
	            }
	            if(instructions.subscript) {
	                fontStyle.vertAlign = 'subscript';
	            }
	            if(instructions.underline) {
	                if(_.indexOf([
	                    'double',
	                    'singleAccounting',
	                    'doubleAccounting'
	                    ], instructions.underline) !== -1) {
	                    fontStyle.underline = instructions.underline;
	                } else {
	                    fontStyle.underline = true;
	                }
	            }
	            if(instructions.strike) {
	                fontStyle.strike = true;
	            }
	            if(instructions.outline) {
	                fontStyle.outline = true;
	            }
	            if(instructions.shadow) {
	                fontStyle.shadow = true;
	            }
	            if(instructions.size) {
	                fontStyle.size = instructions.size;
	            }
	            if(instructions.color) {
	                fontStyle.color = instructions.color;
	            }
	            if(instructions.fontName) {
	                fontStyle.fontName = instructions.fontName;
	            }
	            this.fonts.push(fontStyle);
	            return fontStyle;
	        },

	        exportBorders: function (doc) {
	            var borders = doc.createElement('borders');
	            borders.setAttribute('count', this.borders.length);
	            
	            for(var i = 0, l = this.borders.length; i < l; i++) {
	                borders.appendChild(this.exportBorder(doc, this.borders[i]));
	            }
	            return borders;
	        },

	        exportBorder: function (doc, data) {
	            var border = doc.createElement('border');
	            var self = this;
	            var borderGenerator = function (name) {
	                var b = doc.createElement(name);
	                if(data[name].style) {
	                    b.setAttribute('style', data[name].style);
	                }
	                if(data[name].color) {
	                    b.appendChild(self.exportColor(doc, data[name].color));
	                }
	                return b;
	            };
	            border.appendChild(borderGenerator('left'));
	            border.appendChild(borderGenerator('right'));
	            border.appendChild(borderGenerator('top'));
	            border.appendChild(borderGenerator('bottom'));
	            border.appendChild(borderGenerator('diagonal'));
	            return border;
	        },

	        exportColor: function (doc, color) {
	            var colorEl = doc.createElement('color');
	            if(_.isString(color)) {
	                colorEl.setAttribute('rgb', color);
	                return colorEl;
	            }

	            if (!_.isUndefined(color.tint)) { 
	                colorEl.setAttribute('tint', color.tint);
	            }
	            if (!_.isUndefined(color.auto)) { 
	                colorEl.setAttribute('auto', !!color.auto);
	            }
	            if (!_.isUndefined(color.theme)) { 
	                colorEl.setAttribute('theme', color.theme);
	            }

	            return colorEl;
	        },

	        exportMasterCellFormats: function (doc) {
	            var cellFormats = util.createElement(doc, 'cellXfs', [
	                ['count', this.masterCellFormats.length]
	                ]);
	            for(var i = 0, l = this.masterCellFormats.length; i < l; i++) {
	                var mformat = this.masterCellFormats[i];
	                cellFormats.appendChild(this.exportCellFormatElement(doc, mformat));
	            }
	            return cellFormats;
	        },

	        exportMasterCellStyles: function (doc) {
	            var records = util.createElement(doc, 'cellStyleXfs', [
	                ['count', this.masterCellStyles.length]
	                ]);
	            for(var i = 0, l = this.masterCellStyles.length; i < l; i++) {
	                var mstyle = this.masterCellStyles[i];
	                records.appendChild(this.exportCellFormatElement(doc, mstyle));
	            }
	            return records;
	        },

	        exportCellFormatElement: function (doc, styleInstructions) {
	            var xf = doc.createElement('xf');
	            var allowed = ['applyAlignment', 'applyBorder', 'applyFill', 'applyFont', 'applyNumberFormat', 
	            'applyProtection', 'borderId', 'fillId', 'fontId', 'numFmtId', 'pivotButton', 'quotePrefix', 'xfId'];
	            var attributes = _.filter(_.keys(styleInstructions), function (key) {
	                if(_.indexOf(allowed, key) !== -1) {
	                    return true;
	                }
	            });
	            if(styleInstructions.alignment) {
	                var alignmentData = styleInstructions.alignment;
	                xf.appendChild(this.exportAlignment(doc, alignmentData));
	            }
	            var a = attributes.length;
	            while(a--) {
	                xf.setAttribute(attributes[a], styleInstructions[attributes[a]]);
	            }
	            if (styleInstructions.fillId) {
	                xf.setAttribute('applyFill', '1');
	            }
	            if (styleInstructions.fontId) {
	                xf.setAttribute('applyFont', '1');
	            }
	            if (styleInstructions.borderId) {
	                xf.setAttribute('applyBorder', '1');
	            }
	            if (styleInstructions.alignment) {
	                xf.setAttribute('applyAlignment', '1');
	            }
	            if (styleInstructions.numFmtId) {
	                xf.setAttribute('applyNumberFormat', '1');
	            }
	            return xf;
	        },
	        
	        exportAlignment: function (doc, alignmentData) {
	            var alignment = doc.createElement('alignment');
	            var keys = _.keys(alignmentData);
	            for(var i = 0, l = keys.length; i < l; i++) {
	                alignment.setAttribute(keys[i], alignmentData[keys[i]]);
	            }
	            return alignment;
	        },
	        
	        exportFonts: function (doc) {
	            var fonts = doc.createElement('fonts');
	            fonts.setAttribute('count', this.fonts.length);
	            for(var i = 0, l = this.fonts.length; i < l; i++) {
	                var fd = this.fonts[i];
	                fonts.appendChild(this.exportFont(doc, fd));
	            }
	            return fonts;
	        },
	        
	        exportFont: function (doc, fd) {
	            var font = doc.createElement('font');
	            if(fd.size) {
	                var size = doc.createElement('sz');
	                size.setAttribute('val', fd.size);
	                font.appendChild(size);
	            }

	            if(fd.fontName) {
	                var fontName = doc.createElement('name');
	                fontName.setAttribute('val', fd.fontName);
	                font.appendChild(fontName);
	            }

	            if(fd.bold) {
	                font.appendChild(doc.createElement('b'));
	            }
	            if(fd.italic) {
	                font.appendChild(doc.createElement('i'));
	            }
	            if(fd.vertAlign) {
	                var vertAlign = doc.createElement('vertAlign');
	                vertAlign.setAttribute('val', fd.vertAlign);
	                font.appendChild(vertAlign);
	            }
	            if(fd.underline) { 
	                var u = doc.createElement('u');
	                if(fd.underline !== true) {
	                    u.setAttribute('val', fd.underline);
	                }
	                font.appendChild(u); 
	            }
	            if(fd.strike) {
	                font.appendChild(doc.createElement('strike'));
	            }
	            if(fd.shadow) {
	                font.appendChild(doc.createElement('shadow'));
	            }
	            if(fd.outline) {
	                font.appendChild(doc.createElement('outline'));
	            }
	            if(fd.color) {
	                font.appendChild(this.exportColor(doc, fd.color));
	            }
	            return font;
	        },

	        exportFills: function (doc) {
	            var fills = doc.createElement('fills');
	            fills.setAttribute('count', this.fills.length);
	            for(var i = 0, l = this.fills.length; i < l; i++) {
	                var fd = this.fills[i];
	                fills.appendChild(this.exportFill(doc, fd));
	            }
	            return fills;
	        },
	        
	        exportFill: function (doc, fd) {
	            var fillDef;
	            var fill = doc.createElement('fill');
	            if (fd.type === 'pattern') {
	                fillDef = this.exportPatternFill(doc, fd);
	                fill.appendChild(fillDef);
	            } else if (fd.type === 'gradient') {
	                fillDef = this.exportGradientFill(doc, fd);
	                fill.appendChild(fillDef);
	            }
	            return fill;
	        },
	        
	        exportGradientFill: function (doc, data) {
	            var fillDef = doc.createElement('gradientFill');
	            if(data.degree) {
	                fillDef.setAttribute('degree', data.degree);
	            } else if (data.left) {
	                fillDef.setAttribute('left', data.left);
	                fillDef.setAttribute('right', data.right);
	                fillDef.setAttribute('top', data.top);
	                fillDef.setAttribute('bottom', data.bottom);
	            }
	            var start = doc.createElement('stop');
	            start.setAttribute('position', data.start.pureAt || 0);
	            var startColor = doc.createElement('color');
	            if (typeof data.start === 'string' || data.start.color) {
	                startColor.setAttribute('rgb', data.start.color || data.start);
	            } else if (typeof data.start.theme) {
	                startColor.setAttribute('theme', data.start.theme);
	            }
	            
	            var end = doc.createElement('stop');
	            var endColor = doc.createElement('color');
	            end.setAttribute('position', data.end.pureAt || 1);
	            if (typeof data.start === 'string' || data.end.color) {
	                endColor.setAttribute('rgb', data.end.color || data.end);
	            } else if (typeof data.end.theme) {
	                endColor.setAttribute('theme', data.end.theme);
	            }
	            start.appendChild(startColor);
	            end.appendChild(endColor);
	            fillDef.appendChild(start);
	            fillDef.appendChild(end);
	            return fillDef;
	        },
	        
	        /**
	        * Pattern types: http://www.schemacentral.com/sc/ooxml/t-ssml_ST_PatternType.html
	        * @param {XMLDoc} doc
	        * @param {Object} data
	        */
	        exportPatternFill: function (doc, data) {
	            var fillDef = util.createElement(doc, 'patternFill', [
	                ['patternType', data.patternType]
	                ]);
	            if(!data.bgColor) {
	                data.bgColor = 'FFFFFFFF';
	            }
	            if(!data.fgColor) {
	                data.fgColor = 'FFFFFFFF';
	            }

	            var bgColor = doc.createElement('bgColor');
	            if(_.isString(data.bgColor)) {
	                bgColor.setAttribute('rgb', data.bgColor);
	            } else {
	                if(data.bgColor.theme) {
	                    bgColor.setAttribute('theme', data.bgColor.theme);
	                } else {
	                    bgColor.setAttribute('rgb', data.bgColor.rbg);
	                }
	            }

	            var fgColor = doc.createElement('fgColor');
	            if(_.isString(data.fgColor)) {
	                fgColor.setAttribute('rgb', data.fgColor);
	            } else {
	                if(data.fgColor.theme) {
	                    fgColor.setAttribute('theme', data.fgColor.theme);
	                } else {
	                    fgColor.setAttribute('rgb', data.fgColor.rbg);
	                }
	            }
	            fillDef.appendChild(fgColor);
	            fillDef.appendChild(bgColor);
	            return fillDef;
	        },

	        exportNumberFormatters: function (doc) {
	            var formatters = doc.createElement('numFmts');
	            formatters.setAttribute('count', this.numberFormatters.length);
	            for(var i = 0, l = this.numberFormatters.length; i < l; i++) {
	                var fd = this.numberFormatters[i];
	                formatters.appendChild(this.exportNumberFormatter(doc, fd));
	            }
	            return formatters;
	        },
	        
	        exportNumberFormatter: function (doc, fd) {
	            var numFmt = doc.createElement('numFmt');
	            numFmt.setAttribute('numFmtId', fd.id);
	            numFmt.setAttribute('formatCode', fd.formatCode);
	            return numFmt;
	        },

	        exportCellStyles: function (doc) {
	            var cellStyles = doc.createElement('cellStyles');
	            cellStyles.setAttribute('count', this.cellStyles.length);

	            for(var i = 0, l = this.cellStyles.length; i < l; i++) {
	                var style = this.cellStyles[i];
	                delete style.id; //Remove internal id
	                var record = util.createElement(doc, 'cellStyle');
	                cellStyles.appendChild(record);
	                var attributes = _.keys(style);
	                var a = attributes.length;
	                while(a--) {
	                    record.setAttribute(attributes[a], style[attributes[a]]);
	                }
	            }

	            return cellStyles;
	        },

	        exportDifferentialStyles: function (doc) {
	            var dxfs = doc.createElement('dxfs');
	            dxfs.setAttribute('count', this.differentialStyles.length);

	            for(var i = 0, l = this.differentialStyles.length; i < l; i++) {
	                var style = this.differentialStyles[i];
	                dxfs.appendChild(this.exportDFX(doc, style));
	            }

	            return dxfs;
	        },
	        
	        exportDFX: function (doc, style) {
	            var dxf = doc.createElement('dxf');
	            if(style.font) {
	                dxf.appendChild(this.exportFont(doc, style.font));
	            }
	            if(style.fill) {
	                dxf.appendChild(this.exportFill(doc, style.fill));
	            }
		    if(style.border) {
	                dxf.appendChild(this.exportBorder(doc, style.border));
	            }
	            if(style.numFmt) {
	                dxf.appendChild(this.exportNumberFormatter(doc, style.numFmt));
	            }
	            if(style.alignment) {
	                dxf.appendChild(this.exportAlignment(doc, style.alignment));
	            }
	            return dxf;
	        },
	        
	        exportTableStyles: function (doc) {
	            var tableStyles = doc.createElement('tableStyles');
	            tableStyles.setAttribute('count', this.tableStyles.length);
	            if(this.defaultTableStyle) {
	                tableStyles.setAttribute('defaultTableStyle', this.defaultTableStyle);
	            }
	            for(var i = 0, l = this.tableStyles.length; i < l; i++) {
	                tableStyles.appendChild(this.exportTableStyle(doc, this.tableStyles[i]));
	            }
	            return tableStyles;
	        },
	        
	        exportTableStyle: function (doc, style) {
	            var tableStyle = doc.createElement('tableStyle');
	            tableStyle.setAttribute('name', style.name);
	            tableStyle.setAttribute('pivot', 0);
	            var i = 0;
	            
	            _.each(style, function (value, key) {
	                if(key === 'name') {return;}
	                i++;
	                var styleEl = doc.createElement('tableStyleElement');
	                styleEl.setAttribute('type', key);
	                styleEl.setAttribute('dxfId', value);
	                tableStyle.appendChild(styleEl);
	            });
	            tableStyle.setAttribute('count', i);
	            return tableStyle;
	        },
	        
	        toXML: function () {
	            var doc = util.createXmlDoc(util.schemas.spreadsheetml, 'styleSheet');
	            var styleSheet = doc.documentElement;
	            styleSheet.appendChild(this.exportNumberFormatters(doc));
	            styleSheet.appendChild(this.exportFonts(doc));
	            styleSheet.appendChild(this.exportFills(doc));
	            styleSheet.appendChild(this.exportBorders(doc));
	            styleSheet.appendChild(this.exportMasterCellStyles(doc));
	            styleSheet.appendChild(this.exportMasterCellFormats(doc));
	            styleSheet.appendChild(this.exportCellStyles(doc));
	            styleSheet.appendChild(this.exportDifferentialStyles(doc));
	            if(this.tableStyles.length) {
	                styleSheet.appendChild(this.exportTableStyles(doc));
	            }
	            return doc;
	        }
	    });
	    return StyleSheet;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * This module represents an excel worksheet in its basic form - no tables, charts, etc. Its purpose is 
	 * to hold data, the data's link to how it should be styled, and any links to other outside resources.
	 * 
	 * @module Excel/Worksheet
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(221), __webpack_require__(225)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util, RelationshipManager) {
	    "use strict";
	    /**
	     * @constructor
	     */
	    var Worksheet = function (config) {
	        this.relations = null;
	        this.columnFormats = [];
	        this.data = [];
	        this.mergedCells = [];
	        this.columns = [];
	        this._headers = [];
	        this._footers = [];
	        this._tables = [];
	        this._drawings = [];
	        this._rowInstructions = {};
	        this._freezePane = {};
	        this.initialize(config);
	    };
	    _.extend(Worksheet.prototype, {
	        
	        initialize: function (config) {
	            config = config || {};
	            this.name = config.name;
	            this.id = _.uniqueId('Worksheet');
	            this._timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
	            if(config.columns) {
	                this.setColumns(config.columns);
	            }
	            
	            this.relations = new RelationshipManager();
	        },
	        
	        /**
	         * Returns an object that can be consumed by a WorksheetExportWorker
	         * @returns {Object}
	         */
	        exportData: function () {
	            return {
	                relations: this.relations.exportData(),
	                columnFormats: this.columnFormats,
	                data: this.data,
	                columns: this.columns,
	                mergedCells: this.mergedCells,
	                _headers: this._headers,
	                _footers: this._footers,
	                _tables: this._tables,
	                _rowInstructions: this._rowInstructions,
	                _freezePane: this._freezePane,
	                name: this.name,
	                id: this.id
	            };
	        },
	        
	        /**
	         * Imports data - to be used while inside of a WorksheetExportWorker.
	         * @param {Object} data
	         */
	        importData: function (data) {
	            this.relations.importData(data.relations);
	            delete data.relations;
	            _.extend(this, data);
	        },
	        
	        setSharedStringCollection: function (stringCollection) {
	            this.sharedStrings = stringCollection;
	        },
	        
	        addTable: function (table) {
	            this._tables.push(table);
	            this.relations.addRelation(table, 'table');
	        },
	                
	        addDrawings: function (table) {
	            this._drawings.push(table);
	            this.relations.addRelation(table, 'drawingRelationship');
	        },

	        setRowInstructions: function (rowIndex, instructions) {
	            this._rowInstructions[rowIndex] = instructions;
	        },
	        
	        /**
	        * Expects an array length of three.
	        * 
	        * @see Excel/Worksheet compilePageDetailPiece 
	        * @see <a href='/cookbook/addingHeadersAndFooters.html'>Adding headers and footers to a worksheet</a>
	        * 
	        * @param {Array} headers [left, center, right]
	        */
	        setHeader: function (headers) {
	            if(!_.isArray(headers)) {
	                throw "Invalid argument type - setHeader expects an array of three instructions";
	            }
	            this._headers = headers;
	        },
	        
	        /**
	        * Expects an array length of three.
	        * 
	        * @see Excel/Worksheet compilePageDetailPiece 
	        * @see <a href='/cookbook/addingHeadersAndFooters.html'>Adding headers and footers to a worksheet</a>
	        * 
	        * @param {Array} footers [left, center, right]
	        */
	        setFooter: function (footers) {
	            if(!_.isArray(footers)) {
	                throw "Invalid argument type - setFooter expects an array of three instructions";
	            }
	            this._footers = footers;
	        },
	        
	        /**
	         * Turns page header/footer details into the proper format for Excel.
	         * @param {type} data
	         * @returns {String}
	         */
	        compilePageDetailPackage: function (data) {
	            data = data || "";
	            return [
	            "&L", this.compilePageDetailPiece(data[0] || ""),
	            "&C", this.compilePageDetailPiece(data[1] || ""),
	            "&R", this.compilePageDetailPiece(data[2] || "")
	            ].join('');
	        },
	    
	        /**
	         * Turns instructions on page header/footer details into something
	         * usable by Excel.
	         * 
	         * @param {type} data
	         * @returns {String|@exp;_@call;reduce}
	         */
	        compilePageDetailPiece: function (data) {
	            if(_.isString(data)) {
	                return '&"-,Regular"'.concat(data);
	            }
	            if(_.isObject(data) && !_.isArray(data)) { 
	                var string = "";
	                if(data.font || data.bold) {
	                    var weighting = data.bold ? "Bold" : "Regular";
	                    string += '&"' + (data.font || '-');
	                    string += ',' + weighting + '"';
	                } else {
	                    string += '&"-,Regular"';
	                }
	                if(data.underline) {
	                    string += "&U";
	                }
	                if(data.fontSize) {
	                    string += "&"+data.fontSize;
	                }
	                string += data.text;
	                
	                return string;
	            }
	            
	            if(_.isArray(data)) {
	                var self = this;
	                return _.reduce(data, function (m, v) {
	                    return m.concat(self.compilePageDetailPiece(v));
	                }, "");
	            }
	        },
	        
	        /**
	         * Creates the header node. 
	         * 
	         * @todo implement the ability to do even/odd headers
	         * @param {XML Doc} doc
	         * @returns {XML Node}
	         */
	        exportHeader: function (doc) {
	            var oddHeader = doc.createElement('oddHeader');
	            oddHeader.appendChild(doc.createTextNode(this.compilePageDetailPackage(this._headers)));
	            return oddHeader;
	        },
	    
	        /**
	         * Creates the footer node.
	         * 
	         * @todo implement the ability to do even/odd footers
	         * @param {XML Doc} doc
	         * @returns {XML Node}
	         */    
	        exportFooter: function (doc) {
	            var oddFooter = doc.createElement('oddFooter');
	            oddFooter.appendChild(doc.createTextNode(this.compilePageDetailPackage(this._footers)));
	            return oddFooter;
	        },
	        
	        /**
	         * This creates some nodes ahead of time, which cuts down on generation time due to 
	         * most cell definitions being essentially the same, but having multiple nodes that need
	         * to be created. Cloning takes less time than creation.
	         * 
	         * @private
	         * @param {XML Doc} doc
	         * @returns {_L8.Anonym$0._buildCache.Anonym$2}
	         */
	        _buildCache: function (doc) {
	            var numberNode = doc.createElement('c');
	            var value = doc.createElement('v');
	            value.appendChild(doc.createTextNode("--temp--"));
	            numberNode.appendChild(value);
	            
	            var formulaNode = doc.createElement('c');
	            var formulaValue = doc.createElement('f');
	            formulaValue.appendChild(doc.createTextNode("--temp--"));
	            formulaNode.appendChild(formulaValue);
	            
	            var stringNode = doc.createElement('c');
	            stringNode.setAttribute('t', 's');
	            var stringValue = doc.createElement('v');
	            stringValue.appendChild(doc.createTextNode("--temp--"));
	            stringNode.appendChild(stringValue);
	            
	            
	            return {
	                number: numberNode,
	                date: numberNode,
	                string: stringNode,
	                formula: formulaNode
	            };
	        },
	        
	        /**
	         * Runs through the XML document and grabs all of the strings that will
	         * be sent to the 'shared strings' document. 
	         * 
	         * @returns {Array}
	         */
	        collectSharedStrings: function () {
	            var data = this.data;
	            var maxX = 0;
	            var strings = {};
	            for(var row = 0, l = data.length; row < l; row++) {
	                var dataRow = data[row];
	                var cellCount = dataRow.length;
	                maxX = cellCount > maxX ? cellCount : maxX;
	                for(var c = 0; c < cellCount; c++) {
	                    var cellValue = dataRow[c];
	                    var metadata = cellValue && cellValue.metadata || {};
	                    if (cellValue && typeof cellValue === 'object') {
	                        cellValue = cellValue.value;
	                    }
	                    
	                    if(!metadata.type) {
	                        if(typeof cellValue === 'number') {
	                            metadata.type = 'number';
	                        }
	                    }
	                    if(metadata.type === "text" || !metadata.type) {
	                        if(typeof strings[cellValue] === 'undefined') {
	                            strings[cellValue] = true;
	                        }
	                    }
	                }
	            }
	            return _.keys(strings);
	        },
	        
	        /** added by jsreports */        
	        setFitToPageWidth: function(fit) {
	            this.fitToPageWidth = !!fit;
	        },
	                
	        toXML: function () {
	            var data = this.data;
	            var columns = this.columns || [];
	            var doc = util.createXmlDoc(util.schemas.spreadsheetml, 'worksheet');
	            var worksheet = doc.documentElement;
	            var i, l, row;
	            worksheet.setAttribute('xmlns:r', util.schemas.relationships);
	            worksheet.setAttribute('xmlns:mc', util.schemas.markupCompat);

	            /** added by jsreports */        
	            if (this.fitToPageWidth) {
	                var sheetPr = doc.createElement('sheetPr');
	                sheetPr.setAttribute('enableFormatConditionsCalculation', '0');
	                var pageSetUpPr = doc.createElement('pageSetUpPr');
	                pageSetUpPr.setAttribute('fitToPage', '1');
	                sheetPr.appendChild(pageSetUpPr);
	                worksheet.appendChild(sheetPr);
	            }
	            
	            var maxX = 0;
	            var sheetData = util.createElement(doc, 'sheetData');
	            
	            var cellCache = this._buildCache(doc);
	            
	            for(row = 0, l = data.length; row < l; row++) {
	                var dataRow = data[row];
	                var cellCount = dataRow.length;
	                maxX = cellCount > maxX ? cellCount : maxX;
	                var rowNode = doc.createElement('row');
	                
	                for(var c = 0; c < cellCount; c++) {
	                    columns[c] = columns[c] || {};
	                    var cellValue = dataRow[c];
	                    var cell, metadata = cellValue && cellValue.metadata || {};

	                    if (cellValue && typeof cellValue === 'object') {
	                        cellValue = cellValue.value;
	                    }
	            
	                    if(!metadata.type) {
	                        if(typeof cellValue === 'number') {
	                            metadata.type = 'number';
	                        }
	                    }

	                    switch(metadata.type) {
	                        case "number":
	                            cell = cellCache.number.cloneNode(true);
	                            cell.firstChild.firstChild.nodeValue = cellValue;
	                            break;
	                        case "date":
	                            cell = cellCache.date.cloneNode(true);
	                            cell.firstChild.firstChild.nodeValue = 25569.0 + ((cellValue - this._timezoneOffset)  / (60 * 60 * 24 * 1000));
	                            break;
	                        case "formula":
	                            cell = cellCache.formula.cloneNode(true);
	                            cell.firstChild.firstChild.nodeValue = cellValue;
	                            break;
	                        case "text":
	                            /*falls through*/
	                        default:
	                            var id;
	                            if(typeof this.sharedStrings.strings[cellValue] !== 'undefined') {
	                                id = this.sharedStrings.strings[cellValue];
	                            } else {
	                                id = this.sharedStrings.addString(cellValue);
	                            }
	                            cell = cellCache.string.cloneNode(true);
	                            cell.firstChild.firstChild.nodeValue = id;
	                            break;
	                    }
	                    if(metadata.style) {
	                        cell.setAttribute('s', metadata.style);
	                    } else if (this._rowInstructions[row] && this._rowInstructions[row].style !== undefined) {
	                        cell.setAttribute('s', this._rowInstructions[row].style);
	                    }
	                    cell.setAttribute('r', util.positionToLetterRef(c + 1, row + 1));
	                    rowNode.appendChild(cell);
	                }
	                rowNode.setAttribute('r', row + 1);

	                if (this._rowInstructions[row]) {
	                    var rowInst = this._rowInstructions[row];

	                    if (rowInst.height !== undefined) {
	                        rowNode.setAttribute('customHeight', '1');
	                        rowNode.setAttribute('ht', rowInst.height);
	                    }

	                    if (rowInst.style !== undefined) {
	                      rowNode.setAttribute('customFormat', '1');
	                      rowNode.setAttribute('s', rowInst.style);
	                    }
	                }

	                sheetData.appendChild(rowNode);
	            } 
	            
	            if(maxX !== 0) {
	                worksheet.appendChild(util.createElement(doc, 'dimension', [
	                    ['ref',  util.positionToLetterRef(1, 1) + ':' + util.positionToLetterRef(maxX, data.length)]
	                ]));
	            } else {
	                worksheet.appendChild(util.createElement(doc, 'dimension', [
	                    ['ref',  util.positionToLetterRef(1, 1)]
	                ]));
	            }

	            //added freeze pane
	            if (this._freezePane.cell) {
	                worksheet.appendChild(this.exportPane(doc));
	            }

	            if(this.columns.length) {
	                worksheet.appendChild(this.exportColumns(doc));
	            }
	            worksheet.appendChild(sheetData);

	            // 'mergeCells' should be written before 'headerFoot' and 'drawing' due to issue
	            // with Microsoft Excel (2007, 2013)
	            if (this.mergedCells.length > 0) {
	                var mergeCells = doc.createElement('mergeCells');
	                for (i = 0, l = this.mergedCells.length; i < l; i++) {
	                    var mergeCell = doc.createElement('mergeCell');
	                    mergeCell.setAttribute('ref', this.mergedCells[i][0] + ':' + this.mergedCells[i][1]);
	                    mergeCells.appendChild(mergeCell);
	                }
	                worksheet.appendChild(mergeCells);
	            }
	            
	            this.exportPageSettings(doc, worksheet);
	            
	            if(this._headers.length > 0 || this._footers.length > 0) {
	                var headerFooter = doc.createElement('headerFooter');
	                if(this._headers.length > 0) {
	                    headerFooter.appendChild(this.exportHeader(doc));
	                }
	                if(this._footers.length > 0) {
	                    headerFooter.appendChild(this.exportFooter(doc));
	                }
	                worksheet.appendChild(headerFooter);
	            }
	            
	            if(this._tables.length > 0) {
	                var tables = doc.createElement('tableParts');
	                tables.setAttribute('count', this._tables.length);
	                for(i = 0, l = this._tables.length; i < l; i++) {
	                    var table = doc.createElement('tablePart');
	                    table.setAttribute('r:id', this.relations.getRelationshipId(this._tables[i]));
	                    tables.appendChild(table);
	                }
	                worksheet.appendChild(tables);
	            }

	            /** Added by jsreports */
	            if (this.fitToPageWidth) {
	                //<pageSetup scale="29" fitToHeight="0" orientation="portrait" horizontalDpi="0" verticalDpi="0"/>
	                var pageSetup = doc.createElement('pageSetup');
	                pageSetup.setAttribute('fitToHeight', '0');
	                pageSetup.setAttribute('fitToWidth', '1');
	                worksheet.appendChild(pageSetup);
	            }

	            // the 'drawing' element should be written last, after 'headerFooter', 'mergeCells', etc. due
	            // to issue with Microsoft Excel (2007, 2013)
	            for(i = 0, l = this._drawings.length; i < l; i++) {
	                var drawing = doc.createElement('drawing');
	                drawing.setAttribute('r:id', this.relations.getRelationshipId(this._drawings[i]));
	                worksheet.appendChild(drawing);
	            }
	            return doc;
	        },
	        
	        /**
	         * 
	         * @param {XML Doc} doc
	         * @returns {XML Node}
	         */
	        exportColumns: function (doc) {
	            var cols = util.createElement(doc, 'cols');
	            for(var i = 0, l = this.columns.length; i < l; i++) {
	                var cd = this.columns[i];
	                var col = util.createElement(doc, 'col', [
	                    ['min', cd.min || i + 1],
	                    ['max', cd.max || i + 1]
	                ]);
	                if (cd.hidden) {
	                    col.setAttribute('hidden', 1);
	                }
	                if(cd.bestFit) {
	                    col.setAttribute('bestFit', 1);
	                }
	                if(cd.customWidth || cd.width) {
	                    col.setAttribute('customWidth', 1);
	                }
	                if(cd.width) {
	                    col.setAttribute('width', cd.width);
	                } else {
	                    col.setAttribute('width', 9.140625);
	                }
	                
	                cols.appendChild(col);
	            }
	            return cols;
	        },
	        
	        /**
	         * Added frozen pane
	         * @param {XML Node} doc
	         * @returns {XML Node}
	         */
	        exportPane: function (doc) {
	            var sheetViews = doc.createElement('sheetViews'),
	                sheetView = doc.createElement('sheetView'),
	                pane = doc.createElement('pane');

	            sheetView.setAttribute('workbookViewId', 0);
	            pane.setAttribute('xSplit', this._freezePane.xSplit);
	            pane.setAttribute('ySplit', this._freezePane.ySplit);
	            pane.setAttribute('topLeftCell', this._freezePane.cell);
	            pane.setAttribute('activePane', 'bottomRight');
	            pane.setAttribute('state', 'frozen');

	            sheetView.appendChild(pane);
	            sheetViews.appendChild(sheetView);
	            return sheetViews;
	        },

	        /**
	         * Sets the page settings on a worksheet node.
	         * 
	         * @param {XML Doc} doc
	         * @param {XML Node} worksheet
	         * @returns {undefined}
	         */
	        exportPageSettings: function (doc, worksheet) {
	            
	            if(this._orientation) {
	                worksheet.appendChild(util.createElement(doc, 'pageSetup', [
	                    ['orientation', this._orientation]
	                ]));
	            }
	        },
	    
	        /**
	         * http://www.schemacentral.com/sc/ooxml/t-ssml_ST_Orientation.html
	         * 
	         * Can be one of 'portrait' or 'landscape'.
	         * 
	         * @param {String} orientation
	         * @returns {undefined}
	         */
	        setPageOrientation: function (orientation) {
	            this._orientation = orientation;
	        },
	        
	        /**
	         * Expects an array of column definitions. Each column definition needs to have a width assigned to it. 
	         * 
	         * @param {Array} columns
	         */
	        setColumns: function (columns) {
	            this.columns = columns;
	        },
	        
	        /**
	         * Expects an array of data to be translated into cells. 
	         * 
	         * @param {Array} data Two dimensional array - [ [A1, A2], [B1, B2] ]
	         * @see <a href='/cookbook/addingDataToAWorksheet.html'>Adding data to a worksheet</a>
	         */
	        setData: function (data) {
	            this.data = data;
	        },

	        /**
	         * Merge cells in given range
	         *
	         * @param cell1 - A1, A2...
	         * @param cell2 - A2, A3...
	         */
	        mergeCells: function(cell1, cell2) {
	            this.mergedCells.push([cell1, cell2]);
	        },
	        
	        /**
	         * Added froze pane
	         * @param column - column number: 0, 1, 2 ...
	         * @param row - row number: 0, 1, 2 ...
	         * @param cell - 'A1'
	         */
	        freezePane: function(column, row, cell) {
	            this._freezePane = {xSplit: column, ySplit: row, cell: cell};
	        },

	        /**
	         * Expects an array containing an object full of column format definitions.
	         * http://msdn.microsoft.com/en-us/library/documentformat.openxml.spreadsheet.column.aspx
	         * bestFit
	         * collapsed
	         * customWidth
	         * hidden
	         * max
	         * min
	         * outlineLevel 
	         * phonetic
	         * style
	         * width
	         * @param {Array} columnFormats
	         */
	        setColumnFormats: function (columnFormats) {
	            this.columnFormats = columnFormats;
	        }
	    });
	    return Worksheet;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @module Excel/RelationshipManager
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(221), __webpack_require__(220)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util, Paths) {
	    "use strict";
	    var RelationshipManager = function () {
	        this.relations = {};
	        this.lastId = 1;
	    };
	    
	    _.uniqueId('rId'); //priming
	    
	    _.extend(RelationshipManager.prototype, {
	        
	        importData: function (data) {
	            this.relations = data.relations;
	            this.lastId = data.lastId;
	        },
	        exportData: function () {
	            return {
	                relations: this.relations,
	                lastId: this.lastId
	            };
	        },
	        
	        addRelation: function (object, type) {
	            this.relations[object.id] = {
	                id: _.uniqueId('rId'),
	                schema: util.schemas[type]
	            };
	            return this.relations[object.id].id;
	        },
	        
	        getRelationshipId: function (object) {
	            return this.relations[object.id] ? this.relations[object.id].id : null;
	        },
			
	        toXML: function () {
	            var doc = util.createXmlDoc(util.schemas.relationshipPackage, 'Relationships');
	            var relationships = doc.documentElement;
	            
	            _.each(this.relations, function (data, id) {
	                var relationship = util.createElement(doc, 'Relationship', [
	                    ['Id', data.id],
	                    ['Type', data.schema],
	                    ['Target', Paths[id]]
	                ]);
	                relationships.appendChild(relationship);
	            });
	            return doc;
	        }
	    });
	    
	    return RelationshipManager;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @module Excel/SharedStrings
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util) {
	    "use strict";
	    var sharedStrings = function () {
	        this.strings = {};
	        this.stringArray = [];
	        this.id = _.uniqueId('SharedStrings');
	    };
	    _.extend(sharedStrings.prototype, {
	        /**
	         * Adds a string to the shared string file, and returns the ID of the 
	         * string which can be used to reference it in worksheets.
	         * 
	         * @param string {String}
	         * @return int
	         */
	        addString: function (string) {
	            this.strings[string] = this.stringArray.length;
	            this.stringArray[this.stringArray.length] = string;
	            return this.strings[string];
	        },
	        
	        exportData: function () {
	            return this.strings;
	        },
	        
	        toXML: function () {
	            var doc = util.createXmlDoc(util.schemas.spreadsheetml, 'sst');
	            var sharedStringTable = doc.documentElement;
	            this.stringArray.reverse();
	            var l = this.stringArray.length;
	            sharedStringTable.setAttribute('count', l);
	            sharedStringTable.setAttribute('uniqueCount', l);
	            
	            var template = doc.createElement('si');
	            var templateValue = doc.createElement('t');
	            templateValue.appendChild(doc.createTextNode('--placeholder--'));
	            template.appendChild(templateValue);
	            var strings = this.stringArray;
	            
	            while (l--) {
	                var clone = template.cloneNode(true);
	                clone.firstChild.firstChild.nodeValue = strings[l];
	                sharedStringTable.appendChild(clone);
	            }
	            
	            return doc;
	        }
	    });
	    return sharedStrings;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var requireConfig;
	var worksheet;
	console = {
	    log: postMessage
	};
	start = function(data) {
	    var Worksheet = __webpack_require__(224);
	    // require(['Worksheet'], function(Worksheet) {
	        worksheet = new Worksheet();
	        worksheet.importData(data);
	        postMessage({status: 'sharedStrings', data: worksheet.collectSharedStrings()});
	        
	    // });
	};

	onmessage = function(event) {
	    var data = event.data;
	    if (typeof data == 'object') {
	        switch (data.instruction) {
	            case "setup":
	                requireConfig = data.config;
	                importScripts(data.requireJsPath);
	                ;;
	                postMessage({status: "ready"});
	                break;
	            case "start": 
	                start(data.data);
	                break;
	            case "export":
	                worksheet.setSharedStringCollection({
	                    strings: data.sharedStrings
	                });
	                postMessage({status: "finished", data: worksheet.toXML().toString()});
	                break;
	        }
	    }
	};





/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var base64 = __webpack_require__(229);

	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");

	   base64zip = zip.generate();

	**/

	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZip(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) return new JSZip(data, options);

	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};

	    this.comment = null;

	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(230);
	JSZip.prototype.load = __webpack_require__(259);
	JSZip.support = __webpack_require__(231);
	JSZip.defaults = __webpack_require__(254);

	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZip.utils = __webpack_require__(267);

	JSZip.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZip.compressions = __webpack_require__(233);
	module.exports = JSZip;


/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;

	    while (i < input.length) {

	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);

	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;

	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }

	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

	    }

	    return output;
	};

	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;

	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

	    while (i < input.length) {

	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));

	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;

	        output = output + String.fromCharCode(chr1);

	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }

	    }

	    return output;

	};


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(231);
	var utils = __webpack_require__(232);
	var crc32 = __webpack_require__(252);
	var signature = __webpack_require__(253);
	var defaults = __webpack_require__(254);
	var base64 = __webpack_require__(229);
	var compressions = __webpack_require__(233);
	var CompressedObject = __webpack_require__(255);
	var nodeBuffer = __webpack_require__(251);
	var utf8 = __webpack_require__(256);
	var StringWriter = __webpack_require__(257);
	var Uint8ArrayWriter = __webpack_require__(258);

	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;

	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};

	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};

	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }

	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	    this.unixPermissions = options.unixPermissions;
	    this.dosPermissions = options.dosPermissions;

	    this._data = data;
	    this.options = options;

	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};

	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};

	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};

	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = utils.extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();

	    return o;
	};

	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;

	    o = prepareFileAttrs(o);

	    if (typeof o.unixPermissions === "string") {
	        o.unixPermissions = parseInt(o.unixPermissions, 8);
	    }

	    // UNX_IFDIR  0040000 see zipinfo.c
	    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
	        o.dir = true;
	    }
	    // Bit 4    Directory
	    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
	        o.dir = true;
	    }

	    if (o.dir) {
	        name = forceTrailingSlash(name);
	    }

	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }

	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	        dataType = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;

	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }

	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }

	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};

	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};


	/**
	 * Returns the path with a slash at the end.
	 * @private
	 * @param {String} path the path to check.
	 * @return {String} the path with a trailing slash.
	 */
	var forceTrailingSlash = function(path) {
	    // Check the name ends with a /
	    if (path.slice(-1) != "/") {
	        path += "/"; // IE doesn't like substr(-1)
	    }
	    return path;
	};
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;

	    name = forceTrailingSlash(name);

	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};

	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @param {Object} compressionOptions the options to use when compressing.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression, compressionOptions) {
	    var result = new CompressedObject(),
	        content;

	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;

	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content), compressionOptions);
	    }

	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;

	    return result;
	};




	/**
	 * Generate the UNIX part of the external file attributes.
	 * @param {Object} unixPermissions the unix permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
	 *
	 * TTTTsstrwxrwxrwx0000000000ADVSHR
	 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
	 *     ^^^_________________________ setuid, setgid, sticky
	 *        ^^^^^^^^^________________ permissions
	 *                 ^^^^^^^^^^______ not used ?
	 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
	 */
	var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

	    var result = unixPermissions;
	    if (!unixPermissions) {
	        // I can't use octal values in strict mode, hence the hexa.
	        //  040775 => 0x41fd
	        // 0100664 => 0x81b4
	        result = isDir ? 0x41fd : 0x81b4;
	    }

	    return (result & 0xFFFF) << 16;
	};

	/**
	 * Generate the DOS part of the external file attributes.
	 * @param {Object} dosPermissions the dos permissions or null.
	 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
	 * @return {Number} a 32 bit integer.
	 *
	 * Bit 0     Read-Only
	 * Bit 1     Hidden
	 * Bit 2     System
	 * Bit 3     Volume Label
	 * Bit 4     Directory
	 * Bit 5     Archive
	 */
	var generateDosExternalFileAttr = function (dosPermissions, isDir) {

	    // the dir flag is already set for compatibility

	    return (dosPermissions || 0)  & 0x3F;
	};

	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
	 * @param {Function} encodeFileName the function to encode the file name / comment.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset, platform, encodeFileName) {
	    var data = compressedObject.compressedContent,
	        useCustomEncoding = encodeFileName !== utf8.utf8encode,
	        encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        encodedComment = utils.transformTo("string", encodeFileName(comment)),
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;


	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }

	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }

	    var extFileAttr = 0;
	    var versionMadeBy = 0;
	    if (dir) {
	        // dos or unix, we set the dos dir flag
	        extFileAttr |= 0x00010;
	    }
	    if(platform === "UNIX") {
	        versionMadeBy = 0x031E; // UNIX, version 3.0
	        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
	    } else { // DOS or other, fallback to DOS
	        versionMadeBy = 0x0014; // DOS, version 2.0
	        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
	    }

	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;

	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();

	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(encodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;

	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }

	    if(useUTF8ForComment) {

	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(encodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;

	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }

	    var header = "";

	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += !useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(encodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);


	    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    decToHex(versionMadeBy, 2) +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(encodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    "\x00\x00" +
	    // external file attributes
	    decToHex(extFileAttr, 4) +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    encodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    encodedComment;

	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};


	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },

	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, utils.extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },

	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },

	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }

	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }

	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);

	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },

	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }

	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }

	        return this;
	    },

	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = utils.extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            compressionOptions : null,
	            type: "base64",
	            platform: "DOS",
	            comment: null,
	            mimeType: 'application/zip',
	            encodeFileName: utf8.utf8encode
	        });

	        utils.checkSupport(options.type);

	        // accept nodejs `process.platform`
	        if(
	          options.platform === 'darwin' ||
	          options.platform === 'freebsd' ||
	          options.platform === 'linux' ||
	          options.platform === 'sunos'
	        ) {
	          options.platform = "UNIX";
	        }
	        if (options.platform === 'win32') {
	          options.platform = "DOS";
	        }

	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            encodedComment = utils.transformTo("string", options.encodeFileName(options.comment || this.comment || ""));

	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];

	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};

	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression, compressionOptions);

	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength, options.platform, options.encodeFileName);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }

	        var dirEnd = "";

	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(encodedComment.length, 2) +
	        // .ZIP file comment
	        encodedComment;


	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }

	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }

	        writer.append(dirEnd);

	        var zip = writer.finalize();



	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip), options.mimeType);
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }

	    },

	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },

	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },

	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";

	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191).Buffer))

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(231);
	var compressions = __webpack_require__(233);
	var nodeBuffer = __webpack_require__(251);
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer, mimeType) {
	    exports.checkSupport("blob");
		mimeType = mimeType || 'application/zip';

	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: mimeType
	        });
	    }
	    catch (e) {

	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob(mimeType);
	        }
	        catch (e) {

	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }


	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}

	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}

	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }

	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}

	exports.applyFromCharCode = arrayLikeToString;


	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}

	// a matrix containing functions to transform everything into everything.
	var transform = {};

	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};

	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};

	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};

	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};

	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};

	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};

	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};

	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};

	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};

	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	exports.extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};



/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content, compressionOptions) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = __webpack_require__(234);


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

	var pako = __webpack_require__(235);
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";

	exports.magic = "\x08\x00";
	exports.compress = function(input, compressionOptions) {
	    return pako.deflateRaw(input, {
	        level : compressionOptions.level || -1 // default compression
	    });
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';

	var assign    = __webpack_require__(236).assign;

	var deflate   = __webpack_require__(237);
	var inflate   = __webpack_require__(245);
	var constants = __webpack_require__(249);

	var pako = {};

	assign(pako, deflate, inflate, constants);

	module.exports = pako;


/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';


	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');


	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }

	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }

	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }

	  return obj;
	};


	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};


	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;

	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }

	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }

	    return result;
	  }
	};

	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};


	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};

	exports.setTyped(TYPED_OK);


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';


	var zlib_deflate = __webpack_require__(238);
	var utils        = __webpack_require__(236);
	var strings      = __webpack_require__(243);
	var msg          = __webpack_require__(242);
	var ZStream      = __webpack_require__(244);

	var toString = Object.prototype.toString;

	/* Public constants ==========================================================*/
	/* ===========================================================================*/

	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;

	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;

	var Z_DEFAULT_COMPRESSION = -1;

	var Z_DEFAULT_STRATEGY    = 0;

	var Z_DEFLATED  = 8;

	/* ===========================================================================*/


	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/

	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overriden.
	 **/

	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/

	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/

	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/


	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);

	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});

	  var opt = this.options;

	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }

	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }

	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data

	  this.strm = new ZStream();
	  this.strm.avail_out = 0;

	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );

	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }

	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }

	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }

	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }

	    this._dict_set = true;
	  }
	}

	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;

	  if (this.ended) { return false; }

	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }

	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;

	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }

	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }

	  return true;
	};


	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};


	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};


	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);

	  deflator.push(input, true);

	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg; }

	  return deflator.result;
	}


	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}


	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}


	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var utils   = __webpack_require__(236);
	var trees   = __webpack_require__(239);
	var adler32 = __webpack_require__(240);
	var crc32   = __webpack_require__(241);
	var msg     = __webpack_require__(242);

	/* Public constants ==========================================================*/
	/* ===========================================================================*/


	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;


	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;


	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;


	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;

	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;


	/* The deflate compression method */
	var Z_DEFLATED  = 8;

	/*============================================================================*/


	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;


	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */

	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

	var PRESET_DICT = 0x20;

	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;

	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}

	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}

	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;

	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }

	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}


	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}


	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}


	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}


	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;

	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }

	  strm.avail_in -= len;

	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }

	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }

	  strm.next_in += len;
	  strm.total_in += len;

	  return len;
	}


	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

	  var _win = s.window; // shortcut

	  var wmask = s.w_mask;
	  var prev  = s.prev;

	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */

	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];

	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;

	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */

	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }

	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");

	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);

	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;

	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}


	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;

	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

	  do {
	    more = s.window_size - s.lookahead - s.strstart;

	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}


	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;

	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */

	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);

	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);

	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }

	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;

	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];

	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */

	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}

	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;

	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }

	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {

	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }

	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }

	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");

	    s.strstart += s.lookahead;
	    s.lookahead = 0;

	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;

	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/


	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }

	  s.insert = 0;

	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }

	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }

	  return BS_NEED_MORE;
	}

	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */

	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }

	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }

	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

	      s.lookahead -= s.match_length;

	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}

	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */

	  var max_insert;

	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }

	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }

	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;

	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */

	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */

	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;

	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }

	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }

	  return BS_BLOCK_DONE;
	}


	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */

	  var _win = s.window;

	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }

	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }

	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}

	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */

	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }

	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}

	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}

	var configuration_table;

	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];


	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;

	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);

	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;

	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}


	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */

	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */

	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */

	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */

	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */

	  this.head = null;   /* Heads of the hash chains or NIL. */

	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */

	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */

	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */

	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */

	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */

	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */

	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */

	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/

	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */

	  this.nice_match = 0; /* Stop searching when current match exceeds this */

	              /* used by trees.c: */

	  /* Didn't use ct_data typedef below to suppress compiler warning */

	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);

	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */

	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */

	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);

	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */

	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */

	  this.l_buf = 0;          /* buffer index for literals or lengths */

	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */

	  this.last_lit = 0;      /* running index in l_buf */

	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */

	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */


	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */

	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}


	function deflateResetKeep(strm) {
	  var s;

	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }

	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;

	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;

	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}


	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}


	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}


	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;

	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }

	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }

	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }


	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }


	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */

	  var s = new DeflateState();

	  strm.state = s;
	  s.strm = strm;

	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;

	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);

	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */

	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

	  s.pending_buf_size = s.lit_bufsize * 4;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);

	  s.d_buf = s.lit_bufsize >> 1;
	  s.l_buf = (1 + 2) * s.lit_bufsize;

	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;

	  return deflateReset(strm);
	}

	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}


	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only

	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }

	  s = strm.state;

	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }

	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;

	  /* Write the header */
	  if (s.status === INIT_STATE) {

	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;

	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);

	      s.status = BUSY_STATE;
	      putShortMSB(s, header);

	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }

	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */

	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;

	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);

	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;

	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);

	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif

	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }

	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }

	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }

	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));

	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);

	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}

	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }

	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }

	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}

	function deflateEnd(strm) {
	  var status;

	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }

	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }

	  strm.state = null;

	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}


	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;

	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;

	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }

	  s = strm.state;
	  wrap = s.wrap;

	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }

	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }

	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

	      s.prev[str & s.w_mask] = s.head[s.ins_h];

	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}


	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';

	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';


	var utils = __webpack_require__(236);

	/* Public constants ==========================================================*/
	/* ===========================================================================*/


	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;

	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;

	/*============================================================================*/


	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

	// From zutil.h

	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */

	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */

	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */

	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */

	var LITERALS      = 256;
	/* number of literal bytes 0..255 */

	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */

	var D_CODES       = 30;
	/* number of distance codes */

	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */

	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */

	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */

	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */


	/* ===========================================================================
	 * Constants
	 */

	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */

	var END_BLOCK   = 256;
	/* end of block literal code */

	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */

	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */

	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */

	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */

	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */

	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */

	// We pre-fill arrays with 0 to avoid uninitialized gaps

	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */

	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */

	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */

	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */

	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */

	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */


	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */

	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}


	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;


	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}



	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}


	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}


	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}


	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}


	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}


	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;

	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}


	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */

	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }

	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */

	    if (n > max_code) { continue; } /* not a leaf node */

	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }

	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */

	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);

	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}


	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */

	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}


	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */

	  // do check in _tr_init()
	  //if (static_init_done) return;

	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/

	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;

	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }

	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);

	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }

	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

	  //static_init_done = true;
	}


	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */

	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}


	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}

	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */

	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}

	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}

	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;

	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}


	// inlined manually
	// var SMALLEST = 1;

	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */

	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;

	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");

	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */

	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");

	    } while (lx < s.last_lit);
	  }

	  send_code(s, END_BLOCK, ltree);
	}


	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */

	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;

	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;

	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }

	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;

	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;

	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/

	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;

	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);

	  } while (s.heap_len >= 2);

	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);

	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}


	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */

	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */

	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

	    if (++count < max_count && curlen === nextlen) {
	      continue;

	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;

	    } else if (curlen !== 0) {

	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }

	    count = 0;
	    prevlen = curlen;

	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;

	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;

	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}


	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */

	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */

	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }

	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

	    if (++count < max_count && curlen === nextlen) {
	      continue;

	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);

	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);

	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }

	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;

	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;

	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}


	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */

	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */

	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));

	  return max_blindex;
	}


	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */

	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}


	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;

	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }

	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }

	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}


	var static_init_done = false;

	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{

	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }

	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

	  s.bi_buf = 0;
	  s.bi_valid = 0;

	  /* Initialize the first block of the first file: */
	  init_block(s);
	}


	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}


	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}


	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */

	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {

	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }

	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));

	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */

	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);

	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;

	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));

	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }

	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */

	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);

	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);

	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);

	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}

	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;

	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;

	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }

	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility

	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif

	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}

	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ },
/* 240 */
/***/ function(module, exports) {

	'use strict';

	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.

	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;

	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;

	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);

	    s1 %= 65521;
	    s2 %= 65521;
	  }

	  return (s1 | (s2 << 16)) |0;
	}


	module.exports = adler32;


/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';

	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.


	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];

	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }

	  return table;
	}

	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();


	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;

	  crc ^= -1;

	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }

	  return (crc ^ (-1)); // >>> 0;
	}


	module.exports = crc32;


/***/ },
/* 242 */
/***/ function(module, exports) {

	'use strict';

	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';


	var utils = __webpack_require__(236);


	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safary
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;

	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }

	  // allocate buffer
	  buf = new utils.Buf8(buf_len);

	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }

	  return buf;
	};

	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }

	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}


	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};


	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};


	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;

	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);

	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }

	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }

	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }

	  return buf2binstring(utf16buf, out);
	};


	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;

	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }

	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

	  // Fuckup - very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }

	  // If we came to start of buffer - that means vuffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }

	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ },
/* 244 */
/***/ function(module, exports) {

	'use strict';


	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}

	module.exports = ZStream;


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';


	var zlib_inflate = __webpack_require__(246);
	var utils        = __webpack_require__(236);
	var strings      = __webpack_require__(243);
	var c            = __webpack_require__(249);
	var msg          = __webpack_require__(242);
	var ZStream      = __webpack_require__(244);
	var GZheader     = __webpack_require__(250);

	var toString = Object.prototype.toString;

	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/

	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overriden.
	 **/

	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/

	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/

	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/


	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);

	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});

	  var opt = this.options;

	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }

	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }

	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }

	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data

	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;

	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );

	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }

	  this.header = new GZheader();

	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	}

	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	  var dict;

	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;

	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }

	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;

	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }

	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

	    if (status === c.Z_NEED_DICT && dictionary) {
	      // Convert data if needed
	      if (typeof dictionary === 'string') {
	        dict = strings.string2buf(dictionary);
	      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
	        dict = new Uint8Array(dictionary);
	      } else {
	        dict = dictionary;
	      }

	      status = zlib_inflate.inflateSetDictionary(this.strm, dict);

	    }

	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }

	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }

	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

	        if (this.options.to === 'string') {

	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);

	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

	          this.onData(utf8str);

	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }

	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }

	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }

	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }

	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }

	  return true;
	};


	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};


	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 alligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};


	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);

	  inflator.push(input, true);

	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg; }

	  return inflator.result;
	}


	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}


	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/


	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';


	var utils         = __webpack_require__(236);
	var adler32       = __webpack_require__(240);
	var crc32         = __webpack_require__(241);
	var inflate_fast  = __webpack_require__(247);
	var inflate_table = __webpack_require__(248);

	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;

	/* Public constants ==========================================================*/
	/* ===========================================================================*/


	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;


	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;

	/* The deflate compression method */
	var Z_DEFLATED  = 8;


	/* STATES ====================================================================*/
	/* ===========================================================================*/


	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

	/* ===========================================================================*/



	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;


	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}


	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  this.head = null;           /* where to save gzip header information */

	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */

	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */

	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */

	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */

	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */

	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */

	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */

	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}

	function inflateResetKeep(strm) {
	  var state;

	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}

	function inflateReset(strm) {
	  var state;

	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);

	}

	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;

	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;

	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }

	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }

	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}

	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;

	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */

	  state = new InflateState();

	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}

	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}


	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;

	var lenfix, distfix; // We have no pointers in JS, so keep tables separate

	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;

	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);

	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }

	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }

	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

	    /* do this just once */
	    virgin = false;
	  }

	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}


	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.

	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;

	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;

	    state.window = new utils.Buf8(state.wsize);
	  }

	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}

	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;

	  var n; // temporary var for NEED_BITS

	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }

	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---

	  _in = have;
	  _out = left;
	  ret = Z_OK;

	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//

	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);

	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//

	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;

	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;

	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;

	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }

	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }

	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }

	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;

	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;

	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }

	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;

	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---

	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;

	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;

	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;

	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;

	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }

	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */

	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---

	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}

	function inflateEnd(strm) {

	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }

	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}

	function inflateGetHeader(strm, head) {
	  var state;

	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}

	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;

	  var state;
	  var dictid;
	  var ret;

	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;

	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }

	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}

	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';

	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ },
/* 247 */
/***/ function(module, exports) {

	'use strict';

	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.

	   Entry assumptions:

	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8

	   On return, state.mode is one of:

	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data

	   Notes:

	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.

	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;


	  var input, output; // JS specific, because we have no pointers

	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;


	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */

	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }

	    here = lcode[hold & lmask];

	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];

	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;

	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }

	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }

	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }

	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);

	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;

	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';


	var utils = __webpack_require__(236);

	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;

	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];

	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];

	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];

	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];

	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */

	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;

	  var here_bits, here_op, here_val;

	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.

	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.

	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.

	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */

	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }

	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;


	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;

	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }

	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }

	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }

	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }

	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.

	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.

	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.

	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.

	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */

	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;

	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;

	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }

	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */

	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }

	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }

	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);

	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }

	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }

	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }

	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */

	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }

	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }

	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }

	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }

	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';


	module.exports = {

	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,

	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,

	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,


	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,

	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,

	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';


	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications

	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //

	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}

	module.exports = GZheader;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	module.exports = function(data, encoding){
	    return new Buffer(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(191).Buffer))

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var utils = __webpack_require__(232);

	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];

	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }

	    var isArray = utils.getTypeOf(input) !== "string";

	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;

	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }

	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ },
/* 254 */
/***/ function(module, exports) {

	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.compressionOptions = null;
	exports.comment = null;
	exports.unixPermissions = null;
	exports.dosPermissions = null;


/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}

	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var utils = __webpack_require__(232);
	var support = __webpack_require__(231);
	var nodeBuffer = __webpack_require__(251);

	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */

	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }

	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }

	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }

	    return buf;
	};

	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;

	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }

	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }

	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }

	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};

	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;

	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);

	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }

	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }

	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }

	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }

	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};


	// That's all for the pako functions.


	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }

	    return string2buf(str);
	};


	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }

	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");

	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var utils = __webpack_require__(232);

	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};

	module.exports = StringWriter;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var utils = __webpack_require__(232);

	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};

	module.exports = Uint8ArrayWriter;


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var base64 = __webpack_require__(229);
	var utf8 = __webpack_require__(256);
	var utils = __webpack_require__(232);
	var ZipEntries = __webpack_require__(260);
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = utils.extend(options || {}, {
	        base64: false,
	        checkCRC32: false,
	        optimizedBinaryString : false,
	        createFolders: false,
	        decodeFileName: utf8.utf8decode
	    });
	    if (options.base64) {
	        data = base64.decode(data);
	    }

	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileNameStr, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileCommentStr.length ? input.fileCommentStr : null,
	            unixPermissions : input.unixPermissions,
	            dosPermissions : input.dosPermissions,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }

	    return this;
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(261);
	var NodeBufferReader = __webpack_require__(263);
	var Uint8ArrayReader = __webpack_require__(264);
	var ArrayReader = __webpack_require__(265);
	var utils = __webpack_require__(232);
	var sig = __webpack_require__(253);
	var ZipEntry = __webpack_require__(266);
	var support = __webpack_require__(231);
	var jszipProto = __webpack_require__(230);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Check if the given signature is at the given index.
	     * @param {number} askedIndex the index to check.
	     * @param {string} expectedSignature the signature to expect.
	     * @return {boolean} true if the signature is here, false otherwise.
	     */
	    isSignature: function(askedIndex, expectedSignature) {
	        var currentIndex = this.reader.index;
	        this.reader.setIndex(askedIndex);
	        var signature = this.reader.readString(4);
	        var result = signature === expectedSignature;
	        this.reader.setIndex(currentIndex);
	        return result;
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);

	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        var zipComment = this.reader.readData(this.zipCommentLength);
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded unless specified otherwise.
	        var decodeContent = utils.transformTo(decodeParamType, zipComment);
	        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);

	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	            file.processAttributes();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;

	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }

	        if (this.centralDirRecords !== this.files.length) {
	            if (this.centralDirRecords !== 0 && this.files.length === 0) {
	                // We expected some records but couldn't find ANY.
	                // This is really suspicious, as if something went wrong.
	                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
	            } else {
	                // We found some records but not all.
	                // Something is wrong but we got something for the user: no error here.
	                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
	            }
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset < 0) {
	            // Check if the content is a truncated zip or complete garbage.
	            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
	            // extractible zip for example) but it can give a good hint.
	            // If an ajax request was used without responseType, we will also
	            // get unreadable data.
	            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

	            if (isGarbage) {
	                throw new Error("Can't find end of central directory : is this a zip file ? " +
	                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
	            } else {
	                throw new Error("Corrupted zip : can't find end of central directory");
	            }
	        }
	        this.reader.setIndex(offset);
	        var endOfCentralDirOffset = offset;
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();


	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;

	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */

	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset < 0) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();

	            // now the zip64 EOCD record
	            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
	                // console.warn("ZIP64 end of central directory not where expected.");
	                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
	                    throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
	                }
	            }
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }

	        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
	        if (this.zip64) {
	            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
	            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
	        }

	        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

	        if (extraBytes > 0) {
	            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
	            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
	                // The offsets seem wrong, but we have something at the specified offset.
	                // So… we keep it.
	            } else {
	                // the offset is wrong, update the "zero" of the reader
	                // this happens if data has been prepended (crx files for example)
	                this.reader.zero = extraBytes;
	            }
	        } else if (extraBytes < 0) {
	            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        utils.checkSupport(type);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else if (support.uint8array) {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        } else if (support.array) {
	            this.reader = new ArrayReader(utils.transformTo("array", data));
	        } else {
	            throw new Error("Unexpected error: unsupported type '" + type + "'");
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(262);
	var utils = __webpack_require__(232);

	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(this.zero + i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig) - this.zero;
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(232);

	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	    this.zero = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < this.zero + newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var Uint8ArrayReader = __webpack_require__(264);

	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	    this.zero = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();

	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayReader = __webpack_require__(265);

	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	        this.zero = 0;
	    }
	}
	Uint8ArrayReader.prototype = new ArrayReader();
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(262);

	function ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	        this.zero = 0;

	        for(var i = 0; i < this.data.length; i++) {
	            data[i] = data[i] & 0xFF;
	        }
	    }
	}
	ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	ArrayReader.prototype.byteAt = function(i) {
	    return this.data[this.zero + i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i - this.zero;
	        }
	    }

	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        return [];
	    }
	    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = ArrayReader;


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(261);
	var utils = __webpack_require__(232);
	var CompressedObject = __webpack_require__(255);
	var jszipProto = __webpack_require__(230);
	var support = __webpack_require__(231);

	var MADE_BY_DOS = 0x00;
	var MADE_BY_UNIX = 0x03;

	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);

	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {

	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);

	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }

	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;

	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readData(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);

	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }

	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " +  utils.transformTo("string", this.fileName) + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);

	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },

	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readInt(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);

	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }

	        this.fileName = reader.readData(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readData(this.fileCommentLength);
	    },

	    /**
	     * Parse the external file attributes and get the unix/dos permissions.
	     */
	    processAttributes: function () {
	        this.unixPermissions = null;
	        this.dosPermissions = null;
	        var madeBy = this.versionMadeBy >> 8;

	        // Check if we have the DOS directory flag set.
	        // We look for it in the DOS and UNIX permissions
	        // but some unknown platform could set it as a compatibility flag.
	        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

	        if(madeBy === MADE_BY_DOS) {
	            // first 6 bits (0 to 5)
	            this.dosPermissions = this.externalFileAttributes & 0x3F;
	        }

	        if(madeBy === MADE_BY_UNIX) {
	            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
	            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
	        }

	        // fail safe : if the name ends with a / it probably means a folder
	        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
	            this.dir = true;
	        }
	    },

	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {

	        if (!this.extraFields[0x0001]) {
	            return;
	        }

	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);

	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;

	        this.extraFields = this.extraFields || {};

	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);

	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        var decodeParamType = support.uint8array ? "uint8array" : "array";
	        if (this.useUTF8()) {
	            this.fileNameStr = jszipProto.utf8decode(this.fileName);
	            this.fileCommentStr = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileNameStr = upath;
	            } else {
	                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
	                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
	            }

	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileCommentStr = ucomment;
	            } else {
	                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
	                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
	            }
	        }
	    },

	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);

	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }

	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }

	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },

	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);

	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }

	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }

	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(232);

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};

	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;

	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;


	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};

	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};



/***/ },
/* 268 */
/***/ function(module, exports) {

	

	onmessage = function(event) {
	    if (!event.data || !event.data.ziplib) { return; }
	    
	    importScripts(event.data.ziplib);
	    
	    var zip = new JSZip();
	    var files = event.data.files;
	    for(var path in files) {
	        var content = files[path];
	        path = path.substr(1);
	        zip.file(path, content, {base64: false});
	    };
	    postMessage({
	        base64: !!event.data.base64
	    });
	    postMessage({
	        status: 'done',
	        data: zip.generate({
	            base64: !!event.data.base64
	        })
	    });
	};





/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @module Excel/Drawings
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(225), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, RelationshipManager, util) {
	    "use strict";
	    var Drawings = function () {
	        this.drawings = [];
	        this.relations = new RelationshipManager();
	        this.id = _.uniqueId('Drawings');
	    };
	    
	    _.extend(Drawings.prototype, {
	        /**
	         * Adds a drawing (more likely a subclass of a Drawing) to the 'Drawings' for a particular worksheet.
	         * 
	         * @param {Drawing} drawing
	         * @returns {undefined}
	         */
	        addDrawing: function (drawing) {
	            this.drawings.push(drawing);
	        },
	        getCount: function () {
	            return this.drawings.length;
	        },
	        toXML: function () {
	            var doc = util.createXmlDoc(util.schemas.spreadsheetDrawing, 'xdr:wsDr');
	            var drawings = doc.documentElement;

	            /** Changed by jsreports */
	            // Fix IE drawings bug, per https://github.com/stephenjelfs/excel-builder.js/commit/f42b74352e002bdc29c01d5a38ce193fb7c65c86
	            //drawings.setAttribute('xmlns:xdr', util.schemas.spreadsheetDrawing);
	            drawings.setAttribute('xmlns:a', util.schemas.drawing);
	            drawings.setAttribute('xmlns:r', util.schemas.relationships); 
	            
	            for(var i = 0, l = this.drawings.length; i < l; i++) {
	                
	                var rId = this.relations.getRelationshipId(this.drawings[i].getMediaData());
	                if(!rId) {
	                    rId = this.relations.addRelation(this.drawings[i].getMediaData(), this.drawings[i].getMediaType()); //chart
	                }
	                this.drawings[i].setRelationshipId(rId);
	                drawings.appendChild(this.drawings[i].toXML(doc));
	            }
	            return doc;
	        }
	    });
	    
	    return Drawings;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(271), __webpack_require__(3), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function (Drawing, _, util) {
	    "use strict";
	    var Picture = function () {
	        this.media = null;
	        this.id = _.uniqueId('Picture');
	        this.pictureId = util.uniqueId('Picture');
	        this.fill = {};
	        this.mediaData = null;
	    };
	    //
	    Picture.prototype = new Drawing();
	    
	    _.extend(Picture.prototype, {
	        setMedia: function (mediaRef) {
	            this.mediaData = mediaRef;
	        },
	        setDescription: function (description) {
	            this.description = description;
	        },
	        setFillType: function (type) {
	            this.fill.type = type;
	        },
	        setFillConfig: function (config) {
	            _.extend(this.fill, config);
	        },
	        getMediaType: function () {
	            return 'image';
	        },
	        getMediaData: function () {
	            return this.mediaData;
	        },
	        setRelationshipId: function (rId) {
	            this.mediaData.rId = rId;
	        },
	        toXML: function (xmlDoc) {
	            var pictureNode = util.createElement(xmlDoc, 'xdr:pic');
	            
	            var nonVisibleProperties = util.createElement(xmlDoc, 'xdr:nvPicPr');
	            
	            var nameProperties = util.createElement(xmlDoc, 'xdr:cNvPr', [
	                ['id', this.pictureId],
	                ['name', this.mediaData.fileName],
	                ['descr', this.description || ""]
	            ]);
	            nonVisibleProperties.appendChild(nameProperties);
	            var nvPicProperties = util.createElement(xmlDoc, 'xdr:cNvPicPr');
	            nvPicProperties.appendChild(util.createElement(xmlDoc, 'a:picLocks', [
	                ['noChangeAspect', '1'],
	                ['noChangeArrowheads', '1']
	            ]));
	            nonVisibleProperties.appendChild(nvPicProperties);
	            pictureNode.appendChild(nonVisibleProperties);
	            var pictureFill = util.createElement(xmlDoc, 'xdr:blipFill');
	            pictureFill.appendChild(util.createElement(xmlDoc, 'a:blip', [
	                ['xmlns:r', util.schemas.relationships],
	                ['r:embed', this.mediaData.rId]
	            ]));
	            pictureFill.appendChild(util.createElement(xmlDoc, 'a:srcRect'));
	            var stretch = util.createElement(xmlDoc, 'a:stretch');
	            stretch.appendChild(util.createElement(xmlDoc, 'a:fillRect'));
	            pictureFill.appendChild(stretch);
	            pictureNode.appendChild(pictureFill);
	            
	            var shapeProperties = util.createElement(xmlDoc, 'xdr:spPr', [
	                ['bwMode', 'auto']
	            ]);
	            
	            var transform2d = util.createElement(xmlDoc, 'a:xfrm');
	            shapeProperties.appendChild(transform2d);
	            
	            var presetGeometry = util.createElement(xmlDoc, 'a:prstGeom', [
	                ['prst', 'rect']
	            ]);
	            shapeProperties.appendChild(presetGeometry);
	            
	            
	            
	            pictureNode.appendChild(shapeProperties);
	//            <xdr:spPr bwMode="auto">
	//                <a:xfrm>
	//                    <a:off x="1" y="1"/>
	//                    <a:ext cx="1640253" cy="1885949"/>
	//                </a:xfrm>
	//                <a:prstGeom prst="rect">
	//                    <a:avLst/>
	//                </a:prstGeom>
	//                <a:noFill/>
	//                <a:extLst>
	//                    <a:ext uri="{909E8E84-426E-40DD-AFC4-6F175D3DCCD1}">
	//                        <a14:hiddenFill xmlns:a14="http://schemas.microsoft.com/office/drawing/2010/main">
	//                            <a:solidFill>
	//                                <a:srgbClr val="FFFFFF"/>
	//                            </a:solidFill>
	//                        </a14:hiddenFill>
	//                    </a:ext>
	//                </a:extLst>
	//            </xdr:spPr>
	//            
	            return this.anchor.toXML(xmlDoc, pictureNode);
	        }
	    });
	    return Picture;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * This is mostly a global spot where all of the relationship managers can get and set
	 * path information from/to. 
	 * @module Excel/Drawing
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	    __webpack_require__(3), __webpack_require__(272), __webpack_require__(273), __webpack_require__(274)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, AbsoluteAnchor, OneCellAnchor, TwoCellAnchor) {
	    "use strict";
	    /**
	     * @constructor
	     */
	    var Drawing = function () {
	        this.id = _.uniqueId('Drawing');
	    };
	    
	    _.extend(Drawing.prototype, {
	        /**
	         * 
	         * @param {String} type Can be 'absoluteAnchor', 'oneCellAnchor', or 'twoCellAnchor'. 
	         * @param {Object} config Shorthand - pass the created anchor coords that can normally be used to construct it.
	         * @returns {Anchor}
	         */
	        createAnchor: function (type, config) {
	            config = config || {};
	            config.drawing = this;
	            switch(type) {
	                case 'absoluteAnchor': 
	                    this.anchor = new AbsoluteAnchor(config);
	                    break;
	                case 'oneCellAnchor':
	                    this.anchor = new OneCellAnchor(config);
	                    break;
	                case 'twoCellAnchor':
	                    this.anchor = new TwoCellAnchor(config);
	                    break;
	            }
	            return this.anchor;
	        }
	    });
	    
	    return Drawing;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util) {
	    "use strict";
	    /**
	     * 
	     * @param {Object} config
	     * @param {Number} config.x X offset in EMU's
	     * @param {Number} config.y Y offset in EMU's
	     * @param {Number} config.width Width in EMU's
	     * @param {Number} config.height Height in EMU's
	     * @constructor
	     */
	    var AbsoluteAnchor = function (config) {
	        this.x = null;
	        this.y = null;
	        this.width = null;
	        this.height = null;
	        if(config) {
	            this.setPos(config.x, config.y);
	            this.setDimensions(config.width, config.height);
	        }
	    };
	    _.extend(AbsoluteAnchor.prototype, {
	        /**
	         * Sets the X and Y offsets.
	         * 
	         * @param {Number} x
	         * @param {Number} y
	         * @returns {undefined}
	         */
	        setPos: function (x, y) {
	            this.x = x;
	            this.y = y;
	        },
	        /**
	         * Sets the width and height of the image.
	         * 
	         * @param {Number} width
	         * @param {Number} height
	         * @returns {undefined}
	         */
	        setDimensions: function (width, height) {
	            this.width = width;
	            this.height = height;
	        },
	        toXML: function (xmlDoc, content) {
	            var root = util.createElement(xmlDoc, 'xdr:absoluteAnchor');
	            var pos = util.createElement(xmlDoc, 'xdr:pos');
	            pos.setAttribute('x', this.x);
	            pos.setAttribute('y', this.y);
	            root.appendChild(pos);
	            
	            var dimensions = util.createElement(xmlDoc, 'xdr:ext');
	            dimensions.setAttribute('cx', this.width);
	            dimensions.setAttribute('cy', this.height);
	            root.appendChild(dimensions);
	            
	            root.appendChild(content);
	            
	            root.appendChild(util.createElement(xmlDoc, 'xdr:clientData'));
	            return root;
	        }
	    });
	    return AbsoluteAnchor;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util) {
	    "use strict";
	    /**
	     * 
	     * @param {Object} config
	     * @param {Number} config.x The cell column number that the top left of the picture will start in
	     * @param {Number} config.y The cell row number that the top left of the picture will start in
	     * @param {Number} config.width Width in EMU's
	     * @param {Number} config.height Height in EMU's
	     * @constructor
	     */
	    var OneCellAnchor = function (config) {
	        this.x = null;
	        this.y = null;
	        this.xOff = null;
	        this.yOff = null;
	        this.width = null;
	        this.height = null;
	        if(config) {
	            this.setPos(config.x, config.y, config.xOff, config.yOff);
	            this.setDimensions(config.width, config.height);
	        }
	    };
	    _.extend(OneCellAnchor.prototype, {
	        setPos: function (x, y, xOff, yOff) {
	            this.x = x;
	            this.y = y;
	            if(xOff !== undefined) {
	                this.xOff = xOff;
	            }
	            if(yOff !== undefined) {
	                this.yOff = yOff;
	            }
	        },
	        setDimensions: function (width, height) {
	            this.width = width;
	            this.height = height;
	        },
	        toXML: function (xmlDoc, content) {
	            var root = util.createElement(xmlDoc, 'xdr:oneCellAnchor');
	            var from = util.createElement(xmlDoc, 'xdr:from');
	            var fromCol = util.createElement(xmlDoc, 'xdr:col');
	            fromCol.appendChild(xmlDoc.createTextNode(this.x));
	            var fromColOff = util.createElement(xmlDoc, 'xdr:colOff');
	            fromColOff.appendChild(xmlDoc.createTextNode(this.xOff || 0));
	            var fromRow = util.createElement(xmlDoc, 'xdr:row');
	            fromRow.appendChild(xmlDoc.createTextNode(this.y));
	            var fromRowOff = util.createElement(xmlDoc, 'xdr:rowOff');
	            fromRowOff.appendChild(xmlDoc.createTextNode(this.yOff || 0));
	            from.appendChild(fromCol);
	            from.appendChild(fromColOff);
	            from.appendChild(fromRow);
	            from.appendChild(fromRowOff);
	            
	            root.appendChild(from);
	            
	            var dimensions = util.createElement(xmlDoc, 'xdr:ext');
	            dimensions.setAttribute('cx', this.width);
	            dimensions.setAttribute('cy', this.height);
	            root.appendChild(dimensions);
	            
	            root.appendChild(content);
	            
	            root.appendChild(util.createElement(xmlDoc, 'xdr:clientData'));
	            return root;
	        }
	    });
	    return OneCellAnchor;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(221)], __WEBPACK_AMD_DEFINE_RESULT__ = function (_, util) {
	    'use strict';
	    var TwoCellAnchor = function (config) {
	        this.from = {xOff: 0, yOff: 0};
	        this.to = {xOff: 0, yOff: 0};
	        if(config) {
	            this.setFrom(config.from.x, config.from.y, config.to.xOff, config.to.yOff);
	            this.setTo(config.to.x, config.to.y, config.to.xOff, config.to.yOff);
	        }
	    };
	    _.extend(TwoCellAnchor.prototype, {
	        setFrom: function (x, y, xOff, yOff) {
	            this.from.x = x; 
	            this.from.y = y;
	            if(xOff !== undefined) {
	                this.from.xOff = xOff;
	            }
	            if(yOff !== undefined) {
	                this.from.yOff = xOff;
	            }
	        },
	        setTo: function (x, y, xOff, yOff) {
	            this.to.x = x; 
	            this.to.y = y;
	            if(xOff !== undefined) {
	                this.to.xOff = xOff;
	            }
	            if(yOff !== undefined) {
	                this.to.yOff = xOff;
	            }
	        },
	        toXML: function (xmlDoc, content) {
	            var root = util.createElement(xmlDoc, 'xdr:twoCellAnchor');
	            
	            var from = util.createElement(xmlDoc, 'xdr:from');
	            var fromCol = util.createElement(xmlDoc, 'xdr:col');
	            fromCol.appendChild(xmlDoc.createTextNode(this.from.x));
	            var fromColOff = util.createElement(xmlDoc, 'xdr:colOff');
	            fromColOff.appendChild(xmlDoc.createTextNode(this.from.xOff));
	            var fromRow = util.createElement(xmlDoc, 'xdr:row');
	            fromRow.appendChild(xmlDoc.createTextNode(this.from.y));
	            var fromRowOff = util.createElement(xmlDoc, 'xdr:rowOff');
	            fromRowOff.appendChild(xmlDoc.createTextNode(this.from.yOff));
	            
	            from.appendChild(fromCol);
	            from.appendChild(fromColOff);
	            from.appendChild(fromRow);
	            from.appendChild(fromRowOff);
	            
	            var to = util.createElement(xmlDoc, 'xdr:to');
	            var toCol = util.createElement(xmlDoc, 'xdr:col');
	            toCol.appendChild(xmlDoc.createTextNode(this.to.x));
	            var toColOff = util.createElement(xmlDoc, 'xdr:colOff');
	            toColOff.appendChild(xmlDoc.createTextNode(this.from.xOff));
	            var toRow = util.createElement(xmlDoc, 'xdr:row');
	            toRow.appendChild(xmlDoc.createTextNode(this.to.y));
	            var toRowOff = util.createElement(xmlDoc, 'xdr:rowOff');
	            toRowOff.appendChild(xmlDoc.createTextNode(this.from.yOff));
	            
	            to.appendChild(toCol);
	            to.appendChild(toColOff);
	            to.appendChild(toRow);
	            to.appendChild(toRowOff);
	            
	            
	            root.appendChild(from);
	            root.appendChild(to);
	            
	            root.appendChild(content);
	            
	            root.appendChild(util.createElement(xmlDoc, 'xdr:clientData'));
	            return root;
	        }
	    });
	    return TwoCellAnchor;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    "use strict";
	    return {
	        /**
	         * Converts pixel sizes to 'EMU's, which is what Open XML uses. 
	         * 
	         * @todo clean this up. Code borrowed from http://polymathprogrammer.com/2009/10/22/english-metric-units-and-open-xml/,
	         * but not sure that it's going to be as accurate as it needs to be.
	         * 
	         * @param int pixels
	         * @returns int
	         */
	        pixelsToEMUs: function (pixels) {
	            return Math.round(pixels * 914400 / 96);
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 276 */
/***/ function(module, exports) {

	//     keymaster.js
	//     (c) 2011-2013 Thomas Fuchs
	//     keymaster.js may be freely distributed under the MIT license.

	module.exports = function(window) {

	return (function(global) {
	  var 
	    k,
	    _handlers = {},
	    _mods = { 16: false, 18: false, 17: false, 91: false },
	    _scope = 'all',
	    // modifier keys
	    _MODIFIERS = {
	      '⇧': 16, shift: 16,
	      '⌥': 18, alt: 18, option: 18,
	      '⌃': 17, ctrl: 17, control: 17,
	      '⌘': 91, command: 91
	    },
	    // special keys
	    _MAP = {
	      backspace: 8, tab: 9, clear: 12,
	      enter: 13, 'return': 13,
	      esc: 27, escape: 27, space: 32,
	      left: 37, up: 38,
	      right: 39, down: 40,
	      del: 46, 'delete': 46,
	      home: 36, end: 35,
	      pageup: 33, pagedown: 34,
	      ',': 188, '.': 190, '/': 191,
	      '`': 192, '-': 189, '=': 187,
	      ';': 186, '\'': 222,
	      '[': 219, ']': 221, '\\': 220
	    },
	    code = function(x){
	      return _MAP[x] || x.toUpperCase().charCodeAt(0);
	    },
	    _downKeys = [];

	  for(k=1;k<20;k++) _MAP['f'+k] = 111+k;

	  // IE doesn't support Array#indexOf, so have a simple replacement
	  function index(array, item){
	    var i = array.length;
	    while(i--) if(array[i]===item) return i;
	    return -1;
	  }

	  // for comparing mods before unassignment
	  function compareArray(a1, a2) {
	    if (a1.length != a2.length) return false;
	    for (var i = 0; i < a1.length; i++) {
	        if (a1[i] !== a2[i]) return false;
	    }
	    return true;
	  }

	  var modifierMap = {
	      16:'shiftKey',
	      18:'altKey',
	      17:'ctrlKey',
	      91:'metaKey'
	  };
	  function updateModifierKey(event) {
	      for(k in _mods) _mods[k] = event[modifierMap[k]];
	  };

	  // handle keydown event
	  function dispatch(event) {
	    var key, handler, k, i, modifiersMatch, scope;
	    key = event.keyCode;

	    if (index(_downKeys, key) == -1) {
	        _downKeys.push(key);
	    }

	    // if a modifier key, set the key.<modifierkeyname> property to true and return
	    if(key == 93 || key == 224) key = 91; // right command on webkit, command on Gecko
	    if(key in _mods) {
	      _mods[key] = true;
	      // 'assignKey' from inside this closure is exported to window.key
	      for(k in _MODIFIERS) if(_MODIFIERS[k] == key) assignKey[k] = true;
	      return;
	    }
	    updateModifierKey(event);

	    // see if we need to ignore the keypress (filter() can can be overridden)
	    // by default ignore key presses if a select, textarea, or input is focused
	    if(!assignKey.filter.call(this, event)) return;

	    // abort if no potentially matching shortcuts found
	    if (!(key in _handlers)) return;

	    scope = getScope();

	    // for each potential shortcut
	    for (i = 0; i < _handlers[key].length; i++) {
	      handler = _handlers[key][i];

	      // see if it's in the current scope
	      if(handler.scope == scope || handler.scope == 'all'){
	        // check if modifiers match if any
	        modifiersMatch = handler.mods.length > 0;
	        for(k in _mods)
	          if((!_mods[k] && index(handler.mods, +k) > -1) ||
	            (_mods[k] && index(handler.mods, +k) == -1)) modifiersMatch = false;
	        // call the handler and stop the event if neccessary
	        if((handler.mods.length == 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91]) || modifiersMatch){
	          if(handler.method(event, handler)===false){
	            if(event.preventDefault) event.preventDefault();
	              else event.returnValue = false;
	            if(event.stopPropagation) event.stopPropagation();
	            if(event.cancelBubble) event.cancelBubble = true;
	          }
	        }
	      }
	    }
	  };

	  // unset modifier keys on keyup
	  function clearModifier(event){
	    var key = event.keyCode, k,
	        i = index(_downKeys, key);

	    // remove key from _downKeys
	    if (i >= 0) {
	        _downKeys.splice(i, 1);
	    }

	    if(key == 93 || key == 224) key = 91;
	    if(key in _mods) {
	      _mods[key] = false;
	      for(k in _MODIFIERS) if(_MODIFIERS[k] == key) assignKey[k] = false;
	    }
	  };

	  function resetModifiers() {
	    for(k in _mods) _mods[k] = false;
	    for(k in _MODIFIERS) assignKey[k] = false;
	  };

	  // parse and assign shortcut
	  function assignKey(key, scope, method){
	    var keys, mods;
	    keys = getKeys(key);
	    if (method === undefined) {
	      method = scope;
	      scope = 'all';
	    }

	    // for each shortcut
	    for (var i = 0; i < keys.length; i++) {
	      // set modifier keys if any
	      mods = [];
	      key = keys[i].split('+');
	      if (key.length > 1){
	        mods = getMods(key);
	        key = [key[key.length-1]];
	      }
	      // convert to keycode and...
	      key = key[0]
	      key = code(key);
	      // ...store handler
	      if (!(key in _handlers)) _handlers[key] = [];
	      _handlers[key].push({ shortcut: keys[i], scope: scope, method: method, key: keys[i], mods: mods });
	    }
	  };

	  // unbind all handlers for given key in current scope
	  function unbindKey(key, scope) {
	    var multipleKeys, keys,
	      mods = [],
	      i, j, obj;

	    multipleKeys = getKeys(key);

	    for (j = 0; j < multipleKeys.length; j++) {
	      keys = multipleKeys[j].split('+');

	      if (keys.length > 1) {
	        mods = getMods(keys);
	      }

	      key = keys[keys.length - 1];
	      key = code(key);

	      if (scope === undefined) {
	        scope = getScope();
	      }
	      if (!_handlers[key]) {
	        return;
	      }
	      for (i = 0; i < _handlers[key].length; i++) {
	        obj = _handlers[key][i];
	        // only clear handlers if correct scope and mods match
	        if (obj.scope === scope && compareArray(obj.mods, mods)) {
	          _handlers[key][i] = {};
	        }
	      }
	    }
	  };

	  // Returns true if the key with code 'keyCode' is currently down
	  // Converts strings into key codes.
	  function isPressed(keyCode) {
	      if (typeof(keyCode)=='string') {
	        keyCode = code(keyCode);
	      }
	      return index(_downKeys, keyCode) != -1;
	  }

	  function getPressedKeyCodes() {
	      return _downKeys.slice(0);
	  }

	  function filter(event){
	    var tagName = (event.target || event.srcElement).tagName;
	    // ignore keypressed in any elements that support keyboard data input
	    return !(tagName == 'INPUT' || tagName == 'SELECT' || tagName == 'TEXTAREA');
	  }

	  // initialize key.<modifier> to false
	  for(k in _MODIFIERS) assignKey[k] = false;

	  // set current scope (default 'all')
	  function setScope(scope){ _scope = scope || 'all' };
	  function getScope(){ return _scope || 'all' };

	  // delete all handlers for a given scope
	  function deleteScope(scope){
	    var key, handlers, i;

	    for (key in _handlers) {
	      handlers = _handlers[key];
	      for (i = 0; i < handlers.length; ) {
	        if (handlers[i].scope === scope) handlers.splice(i, 1);
	        else i++;
	      }
	    }
	  };

	  // abstract key logic for assign and unassign
	  function getKeys(key) {
	    var keys;
	    key = key.replace(/\s/g, '');
	    keys = key.split(',');
	    if ((keys[keys.length - 1]) == '') {
	      keys[keys.length - 2] += ',';
	    }
	    return keys;
	  }

	  // abstract mods logic for assign and unassign
	  function getMods(key) {
	    var mods = key.slice(0, key.length - 1);
	    for (var mi = 0; mi < mods.length; mi++)
	    mods[mi] = _MODIFIERS[mods[mi]];
	    return mods;
	  }

	  // cross-browser events
	  function addEvent(object, event, method) {
	    if (object.addEventListener)
	      object.addEventListener(event, method, false);
	    else if(object.attachEvent)
	      object.attachEvent('on'+event, function(){ method(window.event) });
	  };

	  var htmlDocument = window.document;

	  // set the handlers globally on document
	  addEvent(htmlDocument, 'keydown', function(event) { dispatch(event) }); // Passing _scope to a callback to ensure it remains the same by execution. Fixes #48
	  addEvent(htmlDocument, 'keyup', clearModifier);

	  // reset modifiers to false whenever the window is (re)focused.
	  addEvent(window, 'focus', resetModifiers);

	  // store previously defined key
	  var previousKey = global.key;

	  // restore previously defined key and return reference to our key object
	  function noConflict() {
	    var k = global.key;
	    global.key = previousKey;
	    return k;
	  }

	  // set window.key and window.key.set/get/deleteScope, and the default filter
	  global.key = assignKey;
	  global.key.setScope = setScope;
	  global.key.getScope = getScope;
	  global.key.deleteScope = deleteScope;
	  global.key.filter = filter;
	  global.key.isPressed = isPressed;
	  global.key.getPressedKeyCodes = getPressedKeyCodes;
	  global.key.noConflict = noConflict;
	  global.key.unbind = unbindKey;

	  //if(typeof module !== 'undefined') module.exports = assignKey;
	  return assignKey;

	})(this);

	};

/***/ },
/* 277 */
/***/ function(module, exports) {

	/**
	 * @fileoverview
	 * - Using the 'QRCode for Javascript library'
	 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
	 * - this library has no dependencies.
	 * 
	 * @author davidshimjs
	 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
	 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
	 */
	module.exports = function(window) {

		var QRCode;
		var htmlDocument = window.document;

		//---------------------------------------------------------------------
		// QRCode for JavaScript
		//
		// Copyright (c) 2009 Kazuhiko Arase
		//
		// URL: http://www.d-project.com/
		//
		// Licensed under the MIT license:
		//   http://www.opensource.org/licenses/mit-license.php
		//
		// The word "QR Code" is registered trademark of 
		// DENSO WAVE INCORPORATED
		//   http://www.denso-wave.com/qrcode/faqpatent-e.html
		//
		//---------------------------------------------------------------------
		function QR8bitByte(data) {
			this.mode = QRMode.MODE_8BIT_BYTE;
			this.data = data;
			this.parsedData = [];

			// Added to support UTF-8 Characters
			for (var i = 0, l = this.data.length; i < l; i++) {
				var byteArray = [];
				var code = this.data.charCodeAt(i);

				if (code > 0x10000) {
					byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
					byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
					byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
					byteArray[3] = 0x80 | (code & 0x3F);
				} else if (code > 0x800) {
					byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
					byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
					byteArray[2] = 0x80 | (code & 0x3F);
				} else if (code > 0x80) {
					byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
					byteArray[1] = 0x80 | (code & 0x3F);
				} else {
					byteArray[0] = code;
				}

				this.parsedData.push(byteArray);
			}

			this.parsedData = Array.prototype.concat.apply([], this.parsedData);

			if (this.parsedData.length != this.data.length) {
				this.parsedData.unshift(191);
				this.parsedData.unshift(187);
				this.parsedData.unshift(239);
			}
		}

		QR8bitByte.prototype = {
			getLength: function (buffer) {
				return this.parsedData.length;
			},
			write: function (buffer) {
				for (var i = 0, l = this.parsedData.length; i < l; i++) {
					buffer.put(this.parsedData[i], 8);
				}
			}
		};

		function QRCodeModel(typeNumber, errorCorrectLevel) {
			this.typeNumber = typeNumber;
			this.errorCorrectLevel = errorCorrectLevel;
			this.modules = null;
			this.moduleCount = 0;
			this.dataCache = null;
			this.dataList = [];
		}

		QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
		return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
		this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
		if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
		this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
		return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
		return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
		this.modules[r][6]=(r%2==0);}
		for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
		this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
		for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
		for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
		for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
		this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
		var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
		this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
		row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
		var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
		if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
		+buffer.getLengthInBits()
		+">"
		+totalDataCount*8
		+")");}
		if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
		while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
		while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
		buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
		buffer.put(QRCodeModel.PAD1,8);}
		return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
		offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
		var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
		var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
		for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
		return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
		return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
		return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
		return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
		return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
		for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
		if(r==0&&c==0){continue;}
		if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
		if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
		for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
		for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
		for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
		var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
		var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
		return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
		while(n>=256){n-=255;}
		return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
		for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
		for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
		function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
		var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
		this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
		QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
		return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
		var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
		for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
		return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
		QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
		var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
		return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
		QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
		if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
		this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
		
		function _isSupportCanvas() {
			return typeof CanvasRenderingContext2D != "undefined";
		}
		
		// android 2.x doesn't support Data-URI spec
		function _getAndroid() {
			var android = false;
			var sAgent = navigator.userAgent;
			
			if (/android/i.test(sAgent)) { // android
				android = true;
				var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
				
				if (aMat && aMat[1]) {
					android = parseFloat(aMat[1]);
				}
			}
			
			return android;
		}
		
		var svgDrawer = (function() {

			var Drawing = function (el, htOption) {
				this._el = el;
				this._htOption = htOption;
			};

			Drawing.prototype.draw = function (oQRCode) {
				var _htOption = this._htOption;
				var _el = this._el;
				var nCount = oQRCode.getModuleCount();
				var nWidth = Math.floor(_htOption.width / nCount);
				var nHeight = Math.floor(_htOption.height / nCount);

				this.clear();

				function makeSVG(tag, attrs) {
					var el = htmlDocument.createElementNS('http://www.w3.org/2000/svg', tag);
					for (var k in attrs)
						if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
					return el;
				}

				var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
				svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
				_el.appendChild(svg);

				svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
				svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

				for (var row = 0; row < nCount; row++) {
					for (var col = 0; col < nCount; col++) {
						if (oQRCode.isDark(row, col)) {
							var child = makeSVG("use", {"x": String(row), "y": String(col)});
							child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
							svg.appendChild(child);
						}
					}
				}
			};
			Drawing.prototype.clear = function () {
				while (this._el.hasChildNodes())
					this._el.removeChild(this._el.lastChild);
			};
			return Drawing;
		})();

		var useSVG = htmlDocument.documentElement.tagName.toLowerCase() === "svg";

		// Drawing in DOM by using Table tag
		var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
			var Drawing = function (el, htOption) {
				this._el = el;
				this._htOption = htOption;
			};
				
			/**
			 * Draw the QRCode
			 * 
			 * @param {QRCode} oQRCode
			 */
			Drawing.prototype.draw = function (oQRCode) {
	            var _htOption = this._htOption;
	            var _el = this._el;
				var nCount = oQRCode.getModuleCount();
				var nWidth = Math.floor(_htOption.width / nCount);
				var nHeight = Math.floor(_htOption.height / nCount);
				var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
				
				for (var row = 0; row < nCount; row++) {
					aHTML.push('<tr>');
					
					for (var col = 0; col < nCount; col++) {
						aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
					}
					
					aHTML.push('</tr>');
				}
				
				aHTML.push('</table>');
				_el.innerHTML = aHTML.join('');
				
				// Fix the margin values as real size.
				var elTable = _el.childNodes[0];
				var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
				var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
				
				if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
					elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
				}
			};
			
			/**
			 * Clear the QRCode
			 */
			Drawing.prototype.clear = function () {
				this._el.innerHTML = '';
			};
			
			return Drawing;
		})() : (function () { // Drawing in Canvas
			function _onMakeImage() {
				this._elImage.src = this._elCanvas.toDataURL("image/png");
				this._elImage.style.display = "block";
				this._elCanvas.style.display = "none";			
			}
			
			// Android 2.1 bug workaround
			// http://code.google.com/p/android/issues/detail?id=5141
			if (this._android && this._android <= 2.1) {
		    	var factor = 1 / window.devicePixelRatio;
		        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
		    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
		    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
			        	for (var i = arguments.length - 1; i >= 1; i--) {
			            	arguments[i] = arguments[i] * factor;
			        	}
		    		} else if (typeof dw == "undefined") {
		    			arguments[1] *= factor;
		    			arguments[2] *= factor;
		    			arguments[3] *= factor;
		    			arguments[4] *= factor;
		    		}
		    		
		        	drawImage.apply(this, arguments); 
		    	};
			}
			
			/**
			 * Check whether the user's browser supports Data URI or not
			 * 
			 * @private
			 * @param {Function} fSuccess Occurs if it supports Data URI
			 * @param {Function} fFail Occurs if it doesn't support Data URI
			 */
			function _safeSetDataURI(fSuccess, fFail) {
	            var self = this;
	            self._fFail = fFail;
	            self._fSuccess = fSuccess;

	            // Check it just once
	            if (self._bSupportDataURI === null) {
	                var el = htmlDocument.createElement("img");
	                var fOnError = function() {
	                    self._bSupportDataURI = false;

	                    if (self._fFail) {
	                        self._fFail.call(self);
	                    }
	                };
	                var fOnSuccess = function() {
	                    self._bSupportDataURI = true;

	                    if (self._fSuccess) {
	                        self._fSuccess.call(self);
	                    }
	                };

	                el.onabort = fOnError;
	                el.onerror = fOnError;
	                el.onload = fOnSuccess;
	                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
	                return;
	            } else if (self._bSupportDataURI === true && self._fSuccess) {
	                self._fSuccess.call(self);
	            } else if (self._bSupportDataURI === false && self._fFail) {
	                self._fFail.call(self);
	            }
			};
			
			/**
			 * Drawing QRCode by using canvas
			 * 
			 * @constructor
			 * @param {HTMLElement} el
			 * @param {Object} htOption QRCode Options 
			 */
			var Drawing = function (el, htOption) {
	    		this._bIsPainted = false;
	    		this._android = _getAndroid();
			
				this._htOption = htOption;
				this._elCanvas = htmlDocument.createElement("canvas");
				this._elCanvas.width = htOption.width;
				this._elCanvas.height = htOption.height;
				el.appendChild(this._elCanvas);
				this._el = el;
				this._oContext = this._elCanvas.getContext("2d");
				this._bIsPainted = false;
				this._elImage = htmlDocument.createElement("img");
				this._elImage.alt = "Scan me!";
				this._elImage.style.display = "none";
				this._el.appendChild(this._elImage);
				this._bSupportDataURI = null;
			};
				
			/**
			 * Draw the QRCode
			 * 
			 * @param {QRCode} oQRCode 
			 */
			Drawing.prototype.draw = function (oQRCode) {
	            var _elImage = this._elImage;
	            var _oContext = this._oContext;
	            var _htOption = this._htOption;
	            
				var nCount = oQRCode.getModuleCount();
				var nWidth = _htOption.width / nCount;
				var nHeight = _htOption.height / nCount;
				var nRoundedWidth = Math.round(nWidth);
				var nRoundedHeight = Math.round(nHeight);

				_elImage.style.display = "none";
				this.clear();
				
				for (var row = 0; row < nCount; row++) {
					for (var col = 0; col < nCount; col++) {
						var bIsDark = oQRCode.isDark(row, col);
						var nLeft = col * nWidth;
						var nTop = row * nHeight;
						_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
						_oContext.lineWidth = 1;
						_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
						_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
						
						// 안티 앨리어싱 방지 처리
						_oContext.strokeRect(
							Math.floor(nLeft) + 0.5,
							Math.floor(nTop) + 0.5,
							nRoundedWidth,
							nRoundedHeight
						);
						
						_oContext.strokeRect(
							Math.ceil(nLeft) - 0.5,
							Math.ceil(nTop) - 0.5,
							nRoundedWidth,
							nRoundedHeight
						);
					}
				}
				
				this._bIsPainted = true;
			};
				
			/**
			 * Make the image from Canvas if the browser supports Data URI.
			 */
			Drawing.prototype.makeImage = function () {
				if (this._bIsPainted) {
					_safeSetDataURI.call(this, _onMakeImage);
				}
			};
				
			/**
			 * Return whether the QRCode is painted or not
			 * 
			 * @return {Boolean}
			 */
			Drawing.prototype.isPainted = function () {
				return this._bIsPainted;
			};
			
			/**
			 * Clear the QRCode
			 */
			Drawing.prototype.clear = function () {
				this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
				this._bIsPainted = false;
			};
			
			/**
			 * @private
			 * @param {Number} nNumber
			 */
			Drawing.prototype.round = function (nNumber) {
				if (!nNumber) {
					return nNumber;
				}
				
				return Math.floor(nNumber * 1000) / 1000;
			};
			
			return Drawing;
		})();
		
		/**
		 * Get the type by string length
		 * 
		 * @private
		 * @param {String} sText
		 * @param {Number} nCorrectLevel
		 * @return {Number} type
		 */
		function _getTypeNumber(sText, nCorrectLevel) {			
			var nType = 1;
			var length = _getUTF8Length(sText);
			
			for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
				var nLimit = 0;
				
				switch (nCorrectLevel) {
					case QRErrorCorrectLevel.L :
						nLimit = QRCodeLimitLength[i][0];
						break;
					case QRErrorCorrectLevel.M :
						nLimit = QRCodeLimitLength[i][1];
						break;
					case QRErrorCorrectLevel.Q :
						nLimit = QRCodeLimitLength[i][2];
						break;
					case QRErrorCorrectLevel.H :
						nLimit = QRCodeLimitLength[i][3];
						break;
				}
				
				if (length <= nLimit) {
					break;
				} else {
					nType++;
				}
			}
			
			if (nType > QRCodeLimitLength.length) {
				throw new Error("Too long data");
			}
			
			return nType;
		}

		function _getUTF8Length(sText) {
			var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
			return replacedText.length + (replacedText.length != sText ? 3 : 0);
		}
		
		/**
		 * @class QRCode
		 * @constructor
		 * @example 
		 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
		 *
		 * @example
		 * var oQRCode = new QRCode("test", {
		 *    text : "http://naver.com",
		 *    width : 128,
		 *    height : 128
		 * });
		 * 
		 * oQRCode.clear(); // Clear the QRCode.
		 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
		 *
		 * @param {HTMLElement|String} el target element or 'id' attribute of element.
		 * @param {Object|String} vOption
		 * @param {String} vOption.text QRCode link data
		 * @param {Number} [vOption.width=256]
		 * @param {Number} [vOption.height=256]
		 * @param {String} [vOption.colorDark="#000000"]
		 * @param {String} [vOption.colorLight="#ffffff"]
		 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
		 */
		QRCode = function (el, vOption) {
			this._htOption = {
				width : 256, 
				height : 256,
				typeNumber : 4,
				colorDark : "#000000",
				colorLight : "#ffffff",
				correctLevel : QRErrorCorrectLevel.H
			};
			
			if (typeof vOption === 'string') {
				vOption	= {
					text : vOption
				};
			}
			
			// Overwrites options
			if (vOption) {
				for (var i in vOption) {
					this._htOption[i] = vOption[i];
				}
			}
			
			if (typeof el == "string") {
				el = htmlDocument.getElementById(el);
			}

			if (this._htOption.useSVG) {
				Drawing = svgDrawer;
			}
			
			this._android = _getAndroid();
			this._el = el;
			this._oQRCode = null;
			this._oDrawing = new Drawing(this._el, this._htOption);
			
			if (this._htOption.text) {
				this.makeCode(this._htOption.text);	
			}
		};
		
		/**
		 * Make the QRCode
		 * 
		 * @param {String} sText link data
		 */
		QRCode.prototype.makeCode = function (sText) {
			this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
			this._oQRCode.addData(sText);
			this._oQRCode.make();
			this._el.title = sText;
			this._oDrawing.draw(this._oQRCode);			
			this.makeImage();
		};
		
		/**
		 * Make the Image from Canvas element
		 * - It occurs automatically
		 * - Android below 3 doesn't support Data-URI spec.
		 * 
		 * @private
		 */
		QRCode.prototype.makeImage = function () {
			if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
				this._oDrawing.makeImage();
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		QRCode.prototype.clear = function () {
			this._oDrawing.clear();
		};
		
		/**
		 * @name QRCode.CorrectLevel
		 */
		QRCode.CorrectLevel = QRErrorCorrectLevel;

		return QRCode;

	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Papa Parse
		v4.1.2
		https://github.com/mholt/PapaParse
	*/
	(function(global)
	{
		"use strict";

		var IS_WORKER = !global.document && !!global.postMessage,
			IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
			LOADED_SYNC = false, AUTO_SCRIPT_PATH;
		var workers = {}, workerIdCounter = 0;

		var Papa = {};

		Papa.parse = CsvToJson;
		Papa.unparse = JsonToCsv;

		Papa.RECORD_SEP = String.fromCharCode(30);
		Papa.UNIT_SEP = String.fromCharCode(31);
		Papa.BYTE_ORDER_MARK = "\ufeff";
		Papa.BAD_DELIMITERS = ["\r", "\n", "\"", Papa.BYTE_ORDER_MARK];
		Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
		Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously

		// Configurable chunk sizes for local and remote files, respectively
		Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
		Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
		Papa.DefaultDelimiter = ",";			// Used if not specified and detection fails

		// Exposed for testing and development only
		Papa.Parser = Parser;
		Papa.ParserHandle = ParserHandle;
		Papa.NetworkStreamer = NetworkStreamer;
		Papa.FileStreamer = FileStreamer;
		Papa.StringStreamer = StringStreamer;

		if (typeof module !== 'undefined' && module.exports)
		{
			// Export to Node...
			module.exports = Papa;
		}
		else if (isFunction(global.define) && global.define.amd)
		{
			// Wireup with RequireJS
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return Papa; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else
		{
			// ...or as browser global
			global.Papa = Papa;
		}

		if (global.jQuery)
		{
			var $ = global.jQuery;
			$.fn.parse = function(options)
			{
				var config = options.config || {};
				var queue = [];

				this.each(function(idx)
				{
					var supported = $(this).prop('tagName').toUpperCase() == "INPUT"
									&& $(this).attr('type').toLowerCase() == "file"
									&& global.FileReader;

					if (!supported || !this.files || this.files.length == 0)
						return true;	// continue to next input element

					for (var i = 0; i < this.files.length; i++)
					{
						queue.push({
							file: this.files[i],
							inputElem: this,
							instanceConfig: $.extend({}, config)
						});
					}
				});

				parseNextFile();	// begin parsing
				return this;		// maintains chainability


				function parseNextFile()
				{
					if (queue.length == 0)
					{
						if (isFunction(options.complete))
							options.complete();
						return;
					}

					var f = queue[0];

					if (isFunction(options.before))
					{
						var returned = options.before(f.file, f.inputElem);

						if (typeof returned === 'object')
						{
							if (returned.action == "abort")
							{
								error("AbortError", f.file, f.inputElem, returned.reason);
								return;	// Aborts all queued files immediately
							}
							else if (returned.action == "skip")
							{
								fileComplete();	// parse the next file in the queue, if any
								return;
							}
							else if (typeof returned.config === 'object')
								f.instanceConfig = $.extend(f.instanceConfig, returned.config);
						}
						else if (returned == "skip")
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
					}

					// Wrap up the user's complete callback, if any, so that ours also gets executed
					var userCompleteFunc = f.instanceConfig.complete;
					f.instanceConfig.complete = function(results)
					{
						if (isFunction(userCompleteFunc))
							userCompleteFunc(results, f.file, f.inputElem);
						fileComplete();
					};

					Papa.parse(f.file, f.instanceConfig);
				}

				function error(name, file, elem, reason)
				{
					if (isFunction(options.error))
						options.error({name: name}, file, elem, reason);
				}

				function fileComplete()
				{
					queue.splice(0, 1);
					parseNextFile();
				}
			}
		}


		if (IS_PAPA_WORKER)
		{
			global.onmessage = workerThreadReceivedMessage;
		}
		else if (Papa.WORKERS_SUPPORTED)
		{
			AUTO_SCRIPT_PATH = getScriptPath();

			// Check if the script was loaded synchronously
			if (!document.body)
			{
				// Body doesn't exist yet, must be synchronous
				LOADED_SYNC = true;
			}
			else
			{
				document.addEventListener('DOMContentLoaded', function () {
					LOADED_SYNC = true;
				}, true);
			}
		}




		function CsvToJson(_input, _config)
		{
			_config = _config || {};

			if (_config.worker && Papa.WORKERS_SUPPORTED)
			{
				var w = newWorker();

				w.userStep = _config.step;
				w.userChunk = _config.chunk;
				w.userComplete = _config.complete;
				w.userError = _config.error;

				_config.step = isFunction(_config.step);
				_config.chunk = isFunction(_config.chunk);
				_config.complete = isFunction(_config.complete);
				_config.error = isFunction(_config.error);
				delete _config.worker;	// prevent infinite loop

				w.postMessage({
					input: _input,
					config: _config,
					workerId: w.id
				});

				return;
			}

			var streamer = null;
			if (typeof _input === 'string')
			{
				if (_config.download)
					streamer = new NetworkStreamer(_config);
				else
					streamer = new StringStreamer(_config);
			}
			else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
				streamer = new FileStreamer(_config);

			return streamer.stream(_input);
		}






		function JsonToCsv(_input, _config)
		{
			var _output = "";
			var _fields = [];

			// Default configuration

			/** whether to surround every datum with quotes */
			var _quotes = false;

			/** delimiting character */
			var _delimiter = ",";

			/** newline character(s) */
			var _newline = "\r\n";

			unpackConfig();

			if (typeof _input === 'string')
				_input = JSON.parse(_input);

			if (_input instanceof Array)
			{
				if (!_input.length || _input[0] instanceof Array)
					return serialize(null, _input);
				else if (typeof _input[0] === 'object')
					return serialize(objectKeys(_input[0]), _input);
			}
			else if (typeof _input === 'object')
			{
				if (typeof _input.data === 'string')
					_input.data = JSON.parse(_input.data);

				if (_input.data instanceof Array)
				{
					if (!_input.fields)
						_input.fields = _input.data[0] instanceof Array
										? _input.fields
										: objectKeys(_input.data[0]);

					if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
						_input.data = [_input.data];	// handles input like [1,2,3] or ["asdf"]
				}

				return serialize(_input.fields || [], _input.data || []);
			}

			// Default (any valid paths should return before this)
			throw "exception: Unable to serialize unrecognized input";


			function unpackConfig()
			{
				if (typeof _config !== 'object')
					return;

				if (typeof _config.delimiter === 'string'
					&& _config.delimiter.length == 1
					&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) == -1)
				{
					_delimiter = _config.delimiter;
				}

				if (typeof _config.quotes === 'boolean'
					|| _config.quotes instanceof Array)
					_quotes = _config.quotes;

				if (typeof _config.newline === 'string')
					_newline = _config.newline;
			}


			/** Turns an object's keys into an array */
			function objectKeys(obj)
			{
				if (typeof obj !== 'object')
					return [];
				var keys = [];
				for (var key in obj)
					keys.push(key);
				return keys;
			}

			/** The double for loop that iterates the data and writes out a CSV string including header row */
			function serialize(fields, data)
			{
				var csv = "";

				if (typeof fields === 'string')
					fields = JSON.parse(fields);
				if (typeof data === 'string')
					data = JSON.parse(data);

				var hasHeader = fields instanceof Array && fields.length > 0;
				var dataKeyedByField = !(data[0] instanceof Array);

				// If there a header row, write it first
				if (hasHeader)
				{
					for (var i = 0; i < fields.length; i++)
					{
						if (i > 0)
							csv += _delimiter;
						csv += safe(fields[i], i);
					}
					if (data.length > 0)
						csv += _newline;
				}

				// Then write out the data
				for (var row = 0; row < data.length; row++)
				{
					var maxCol = hasHeader ? fields.length : data[row].length;

					for (var col = 0; col < maxCol; col++)
					{
						if (col > 0)
							csv += _delimiter;
						var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
						csv += safe(data[row][colIdx], col);
					}

					if (row < data.length - 1)
						csv += _newline;
				}

				return csv;
			}

			/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
			function safe(str, col)
			{
				if (typeof str === "undefined" || str === null)
					return "";

				str = str.toString().replace(/"/g, '""');

				var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
								|| (_quotes instanceof Array && _quotes[col])
								|| hasAny(str, Papa.BAD_DELIMITERS)
								|| str.indexOf(_delimiter) > -1
								|| str.charAt(0) == ' '
								|| str.charAt(str.length - 1) == ' ';

				return needsQuotes ? '"' + str + '"' : str;
			}

			function hasAny(str, substrings)
			{
				for (var i = 0; i < substrings.length; i++)
					if (str.indexOf(substrings[i]) > -1)
						return true;
				return false;
			}
		}

		/** ChunkStreamer is the base prototype for various streamer implementations. */
		function ChunkStreamer(config)
		{
			this._handle = null;
			this._paused = false;
			this._finished = false;
			this._input = null;
			this._baseIndex = 0;
			this._partialLine = "";
			this._rowCount = 0;
			this._start = 0;
			this._nextChunk = null;
			this.isFirstChunk = true;
			this._completeResults = {
				data: [],
				errors: [],
				meta: {}
			};
			replaceConfig.call(this, config);

			this.parseChunk = function(chunk)
			{
				// First chunk pre-processing
				if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
				{
					var modifiedChunk = this._config.beforeFirstChunk(chunk);
					if (modifiedChunk !== undefined)
						chunk = modifiedChunk;
				}
				this.isFirstChunk = false;

				// Rejoin the line we likely just split in two by chunking the file
				var aggregate = this._partialLine + chunk;
				this._partialLine = "";

				var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);
				
				if (this._handle.paused() || this._handle.aborted())
					return;
				
				var lastIndex = results.meta.cursor;
				
				if (!this._finished)
				{
					this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
					this._baseIndex = lastIndex;
				}

				if (results && results.data)
					this._rowCount += results.data.length;

				var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);

				if (IS_PAPA_WORKER)
				{
					global.postMessage({
						results: results,
						workerId: Papa.WORKER_ID,
						finished: finishedIncludingPreview
					});
				}
				else if (isFunction(this._config.chunk))
				{
					this._config.chunk(results, this._handle);
					if (this._paused)
						return;
					results = undefined;
					this._completeResults = undefined;
				}

				if (!this._config.step && !this._config.chunk) {
					this._completeResults.data = this._completeResults.data.concat(results.data);
					this._completeResults.errors = this._completeResults.errors.concat(results.errors);
					this._completeResults.meta = results.meta;
				}

				if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
					this._config.complete(this._completeResults);

				if (!finishedIncludingPreview && (!results || !results.meta.paused))
					this._nextChunk();

				return results;
			};

			this._sendError = function(error)
			{
				if (isFunction(this._config.error))
					this._config.error(error);
				else if (IS_PAPA_WORKER && this._config.error)
				{
					global.postMessage({
						workerId: Papa.WORKER_ID,
						error: error,
						finished: false
					});
				}
			};

			function replaceConfig(config)
			{
				// Deep-copy the config so we can edit it
				var configCopy = copy(config);
				configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
				if (!config.step && !config.chunk)
					configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
				this._handle = new ParserHandle(configCopy);
				this._handle.streamer = this;
				this._config = configCopy;	// persist the copy to the caller
			}
		}


		function NetworkStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.RemoteChunkSize;
			ChunkStreamer.call(this, config);

			var xhr;

			if (IS_WORKER)
			{
				this._nextChunk = function()
				{
					this._readChunk();
					this._chunkLoaded();
				};
			}
			else
			{
				this._nextChunk = function()
				{
					this._readChunk();
				};
			}

			this.stream = function(url)
			{
				this._input = url;
				this._nextChunk();	// Starts streaming
			};

			this._readChunk = function()
			{
				if (this._finished)
				{
					this._chunkLoaded();
					return;
				}

				xhr = new XMLHttpRequest();
				
				if (!IS_WORKER)
				{
					xhr.onload = bindFunction(this._chunkLoaded, this);
					xhr.onerror = bindFunction(this._chunkError, this);
				}

				xhr.open("GET", this._input, !IS_WORKER);
				
				if (this._config.chunkSize)
				{
					var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
					xhr.setRequestHeader("Range", "bytes="+this._start+"-"+end);
					xhr.setRequestHeader("If-None-Match", "webkit-no-cache"); // https://bugs.webkit.org/show_bug.cgi?id=82672
				}

				try {
					xhr.send();
				}
				catch (err) {
					this._chunkError(err.message);
				}

				if (IS_WORKER && xhr.status == 0)
					this._chunkError();
				else
					this._start += this._config.chunkSize;
			}

			this._chunkLoaded = function()
			{
				if (xhr.readyState != 4)
					return;

				if (xhr.status < 200 || xhr.status >= 400)
				{
					this._chunkError();
					return;
				}

				this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
				this.parseChunk(xhr.responseText);
			}

			this._chunkError = function(errorMessage)
			{
				var errorText = xhr.statusText || errorMessage;
				this._sendError(errorText);
			}

			function getFileSize(xhr)
			{
				var contentRange = xhr.getResponseHeader("Content-Range");
				return parseInt(contentRange.substr(contentRange.lastIndexOf("/") + 1));
			}
		}
		NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
		NetworkStreamer.prototype.constructor = NetworkStreamer;


		function FileStreamer(config)
		{
			config = config || {};
			if (!config.chunkSize)
				config.chunkSize = Papa.LocalChunkSize;
			ChunkStreamer.call(this, config);

			var reader, slice;

			// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
			// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
			var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105

			this.stream = function(file)
			{
				this._input = file;
				slice = file.slice || file.webkitSlice || file.mozSlice;

				if (usingAsyncReader)
				{
					reader = new FileReader();		// Preferred method of reading files, even in workers
					reader.onload = bindFunction(this._chunkLoaded, this);
					reader.onerror = bindFunction(this._chunkError, this);
				}
				else
					reader = new FileReaderSync();	// Hack for running in a web worker in Firefox

				this._nextChunk();	// Starts streaming
			};

			this._nextChunk = function()
			{
				if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
					this._readChunk();
			}

			this._readChunk = function()
			{
				var input = this._input;
				if (this._config.chunkSize)
				{
					var end = Math.min(this._start + this._config.chunkSize, this._input.size);
					input = slice.call(input, this._start, end);
				}
				var txt = reader.readAsText(input, this._config.encoding);
				if (!usingAsyncReader)
					this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
			}

			this._chunkLoaded = function(event)
			{
				// Very important to increment start each time before handling results
				this._start += this._config.chunkSize;
				this._finished = !this._config.chunkSize || this._start >= this._input.size;
				this.parseChunk(event.target.result);
			}

			this._chunkError = function()
			{
				this._sendError(reader.error);
			}

		}
		FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
		FileStreamer.prototype.constructor = FileStreamer;


		function StringStreamer(config)
		{
			config = config || {};
			ChunkStreamer.call(this, config);

			var string;
			var remaining;
			this.stream = function(s)
			{
				string = s;
				remaining = s;
				return this._nextChunk();
			}
			this._nextChunk = function()
			{
				if (this._finished) return;
				var size = this._config.chunkSize;
				var chunk = size ? remaining.substr(0, size) : remaining;
				remaining = size ? remaining.substr(size) : '';
				this._finished = !remaining;
				return this.parseChunk(chunk);
			}
		}
		StringStreamer.prototype = Object.create(StringStreamer.prototype);
		StringStreamer.prototype.constructor = StringStreamer;



		// Use one ParserHandle per entire CSV file or string
		function ParserHandle(_config)
		{
			// One goal is to minimize the use of regular expressions...
			var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;

			var self = this;
			var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
			var _input;				// The input being parsed
			var _parser;			// The core parser being used
			var _paused = false;	// Whether we are paused or not
			var _aborted = false;   // Whether the parser has aborted or not
			var _delimiterError;	// Temporary state between delimiter detection and processing results
			var _fields = [];		// Fields are from the header row of the input, if there is one
			var _results = {		// The last results returned from the parser
				data: [],
				errors: [],
				meta: {}
			};

			if (isFunction(_config.step))
			{
				var userStep = _config.step;
				_config.step = function(results)
				{
					_results = results;

					if (needsHeaderRow())
						processResults();
					else	// only call user's step function after header row
					{
						processResults();

						// It's possbile that this line was empty and there's no row here after all
						if (_results.data.length == 0)
							return;

						_stepCounter += results.data.length;
						if (_config.preview && _stepCounter > _config.preview)
							_parser.abort();
						else
							userStep(_results, self);
					}
				};
			}

			/**
			 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
			 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
			 * when an input comes in multiple chunks, like from a file.
			 */
			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				if (!_config.newline)
					_config.newline = guessLineEndings(input);

				_delimiterError = false;
				if (!_config.delimiter)
				{
					var delimGuess = guessDelimiter(input);
					if (delimGuess.successful)
						_config.delimiter = delimGuess.bestDelimiter;
					else
					{
						_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
						_config.delimiter = Papa.DefaultDelimiter;
					}
					_results.meta.delimiter = _config.delimiter;
				}

				var parserConfig = copy(_config);
				if (_config.preview && _config.header)
					parserConfig.preview++;	// to compensate for header row

				_input = input;
				_parser = new Parser(parserConfig);
				_results = _parser.parse(_input, baseIndex, ignoreLastRow);
				processResults();
				return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
			};

			this.paused = function()
			{
				return _paused;
			};

			this.pause = function()
			{
				_paused = true;
				_parser.abort();
				_input = _input.substr(_parser.getCharIndex());
			};

			this.resume = function()
			{
				_paused = false;
				self.streamer.parseChunk(_input);
			};

			this.aborted = function () {
				return _aborted;
			}

			this.abort = function()
			{
				_aborted = true;
				_parser.abort();
				_results.meta.aborted = true;
				if (isFunction(_config.complete))
					_config.complete(_results);
				_input = "";
			};

			function processResults()
			{
				if (_results && _delimiterError)
				{
					addError("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '"+Papa.DefaultDelimiter+"'");
					_delimiterError = false;
				}

				if (_config.skipEmptyLines)
				{
					for (var i = 0; i < _results.data.length; i++)
						if (_results.data[i].length == 1 && _results.data[i][0] == "")
							_results.data.splice(i--, 1);
				}

				if (needsHeaderRow())
					fillHeaderFields();

				return applyHeaderAndDynamicTyping();
			}

			function needsHeaderRow()
			{
				return _config.header && _fields.length == 0;
			}

			function fillHeaderFields()
			{
				if (!_results)
					return;
				for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
					for (var j = 0; j < _results.data[i].length; j++)
						_fields.push(_results.data[i][j]);
				_results.data.splice(0, 1);
			}

			function applyHeaderAndDynamicTyping()
			{
				if (!_results || (!_config.header && !_config.dynamicTyping))
					return _results;

				for (var i = 0; i < _results.data.length; i++)
				{
					var row = {};

					for (var j = 0; j < _results.data[i].length; j++)
					{
						if (_config.dynamicTyping)
						{
							var value = _results.data[i][j];
							if (value == "true" || value == "TRUE")
								_results.data[i][j] = true;
							else if (value == "false" || value == "FALSE")
								_results.data[i][j] = false;
							else
								_results.data[i][j] = tryParseFloat(value);
						}

						if (_config.header)
						{
							if (j >= _fields.length)
							{
								if (!row["__parsed_extra"])
									row["__parsed_extra"] = [];
								row["__parsed_extra"].push(_results.data[i][j]);
							}
							else
								row[_fields[j]] = _results.data[i][j];
						}
					}

					if (_config.header)
					{
						_results.data[i] = row;
						if (j > _fields.length)
							addError("FieldMismatch", "TooManyFields", "Too many fields: expected " + _fields.length + " fields but parsed " + j, i);
						else if (j < _fields.length)
							addError("FieldMismatch", "TooFewFields", "Too few fields: expected " + _fields.length + " fields but parsed " + j, i);
					}
				}

				if (_config.header && _results.meta)
					_results.meta.fields = _fields;
				return _results;
			}

			function guessDelimiter(input)
			{
				var delimChoices = [",", "\t", "|", ";", Papa.RECORD_SEP, Papa.UNIT_SEP];
				var bestDelim, bestDelta, fieldCountPrevRow;

				for (var i = 0; i < delimChoices.length; i++)
				{
					var delim = delimChoices[i];
					var delta = 0, avgFieldCount = 0;
					fieldCountPrevRow = undefined;

					var preview = new Parser({
						delimiter: delim,
						preview: 10
					}).parse(input);

					for (var j = 0; j < preview.data.length; j++)
					{
						var fieldCount = preview.data[j].length;
						avgFieldCount += fieldCount;

						if (typeof fieldCountPrevRow === 'undefined')
						{
							fieldCountPrevRow = fieldCount;
							continue;
						}
						else if (fieldCount > 1)
						{
							delta += Math.abs(fieldCount - fieldCountPrevRow);
							fieldCountPrevRow = fieldCount;
						}
					}

					if (preview.data.length > 0)
						avgFieldCount /= preview.data.length;

					if ((typeof bestDelta === 'undefined' || delta < bestDelta)
						&& avgFieldCount > 1.99)
					{
						bestDelta = delta;
						bestDelim = delim;
					}
				}

				_config.delimiter = bestDelim;

				return {
					successful: !!bestDelim,
					bestDelimiter: bestDelim
				}
			}

			function guessLineEndings(input)
			{
				input = input.substr(0, 1024*1024);	// max length 1 MB

				var r = input.split('\r');

				if (r.length == 1)
					return '\n';

				var numWithN = 0;
				for (var i = 0; i < r.length; i++)
				{
					if (r[i][0] == '\n')
						numWithN++;
				}

				return numWithN >= r.length / 2 ? '\r\n' : '\r';
			}

			function tryParseFloat(val)
			{
				var isNumber = FLOAT.test(val);
				return isNumber ? parseFloat(val) : val;
			}

			function addError(type, code, msg, row)
			{
				_results.errors.push({
					type: type,
					code: code,
					message: msg,
					row: row
				});
			}
		}





		/** The core parser implements speedy and correct CSV parsing */
		function Parser(config)
		{
			// Unpack the config object
			config = config || {};
			var delim = config.delimiter;
			var newline = config.newline;
			var comments = config.comments;
			var step = config.step;
			var preview = config.preview;
			var fastMode = config.fastMode;

			// Delimiter must be valid
			if (typeof delim !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
				delim = ",";

			// Comment character must be valid
			if (comments === delim)
				throw "Comment character same as delimiter";
			else if (comments === true)
				comments = "#";
			else if (typeof comments !== 'string'
				|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
				comments = false;

			// Newline must be valid: \r, \n, or \r\n
			if (newline != '\n' && newline != '\r' && newline != '\r\n')
				newline = '\n';

			// We're gonna need these at the Parser scope
			var cursor = 0;
			var aborted = false;

			this.parse = function(input, baseIndex, ignoreLastRow)
			{
				// For some reason, in Chrome, this speeds things up (!?)
				if (typeof input !== 'string')
					throw "Input must be a string";

				// We don't need to compute some of these every time parse() is called,
				// but having them in a more local scope seems to perform better
				var inputLen = input.length,
					delimLen = delim.length,
					newlineLen = newline.length,
					commentsLen = comments.length;
				var stepIsFunction = typeof step === 'function';

				// Establish starting state
				cursor = 0;
				var data = [], errors = [], row = [], lastCursor = 0;

				if (!input)
					return returnable();

				if (fastMode || (fastMode !== false && input.indexOf('"') === -1))
				{
					var rows = input.split(newline);
					for (var i = 0; i < rows.length; i++)
					{
						var row = rows[i];
						cursor += row.length;
						if (i !== rows.length - 1)
							cursor += newline.length;
						else if (ignoreLastRow)
							return returnable();
						if (comments && row.substr(0, commentsLen) == comments)
							continue;
						if (stepIsFunction)
						{
							data = [];
							pushRow(row.split(delim));
							doStep();
							if (aborted)
								return returnable();
						}
						else
							pushRow(row.split(delim));
						if (preview && i >= preview)
						{
							data = data.slice(0, preview);
							return returnable(true);
						}
					}
					return returnable();
				}

				var nextDelim = input.indexOf(delim, cursor);
				var nextNewline = input.indexOf(newline, cursor);

				// Parser loop
				for (;;)
				{
					// Field has opening quote
					if (input[cursor] == '"')
					{
						// Start our search for the closing quote where the cursor is
						var quoteSearch = cursor;

						// Skip the opening quote
						cursor++;

						for (;;)
						{
							// Find closing quote
							var quoteSearch = input.indexOf('"', quoteSearch+1);

							if (quoteSearch === -1)
							{
								if (!ignoreLastRow) {
									// No closing quote... what a pity
									errors.push({
										type: "Quotes",
										code: "MissingQuotes",
										message: "Quoted field unterminated",
										row: data.length,	// row has yet to be inserted
										index: cursor
									});
								}
								return finish();
							}

							if (quoteSearch === inputLen-1)
							{
								// Closing quote at EOF
								var value = input.substring(cursor, quoteSearch).replace(/""/g, '"');
								return finish(value);
							}

							// If this quote is escaped, it's part of the data; skip it
							if (input[quoteSearch+1] == '"')
							{
								quoteSearch++;
								continue;
							}

							if (input[quoteSearch+1] == delim)
							{
								// Closing quote followed by delimiter
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								cursor = quoteSearch + 1 + delimLen;
								nextDelim = input.indexOf(delim, cursor);
								nextNewline = input.indexOf(newline, cursor);
								break;
							}

							if (input.substr(quoteSearch+1, newlineLen) === newline)
							{
								// Closing quote followed by newline
								row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
								saveRow(quoteSearch + 1 + newlineLen);
								nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field

								if (stepIsFunction)
								{
									doStep();
									if (aborted)
										return returnable();
								}
								
								if (preview && data.length >= preview)
									return returnable(true);

								break;
							}
						}

						continue;
					}

					// Comment found at start of new line
					if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
					{
						if (nextNewline == -1)	// Comment ends at EOF
							return returnable();
						cursor = nextNewline + newlineLen;
						nextNewline = input.indexOf(newline, cursor);
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}

					// Next delimiter comes before next newline, so we've reached end of field
					if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
					{
						row.push(input.substring(cursor, nextDelim));
						cursor = nextDelim + delimLen;
						nextDelim = input.indexOf(delim, cursor);
						continue;
					}

					// End of row
					if (nextNewline !== -1)
					{
						row.push(input.substring(cursor, nextNewline));
						saveRow(nextNewline + newlineLen);

						if (stepIsFunction)
						{
							doStep();
							if (aborted)
								return returnable();
						}

						if (preview && data.length >= preview)
							return returnable(true);

						continue;
					}

					break;
				}


				return finish();


				function pushRow(row)
				{
					data.push(row);
					lastCursor = cursor;
				}

				/**
				 * Appends the remaining input from cursor to the end into
				 * row, saves the row, calls step, and returns the results.
				 */
				function finish(value)
				{
					if (ignoreLastRow)
						return returnable();
					if (typeof value === 'undefined')
						value = input.substr(cursor);
					row.push(value);
					cursor = inputLen;	// important in case parsing is paused
					pushRow(row);
					if (stepIsFunction)
						doStep();
					return returnable();
				}

				/**
				 * Appends the current row to the results. It sets the cursor
				 * to newCursor and finds the nextNewline. The caller should
				 * take care to execute user's step function and check for
				 * preview and end parsing if necessary.
				 */
				function saveRow(newCursor)
				{
					cursor = newCursor;
					pushRow(row);
					row = [];
					nextNewline = input.indexOf(newline, cursor);
				}

				/** Returns an object with the results, errors, and meta. */
				function returnable(stopped)
				{
					return {
						data: data,
						errors: errors,
						meta: {
							delimiter: delim,
							linebreak: newline,
							aborted: aborted,
							truncated: !!stopped,
							cursor: lastCursor + (baseIndex || 0)
						}
					};
				}

				/** Executes the user's step function and resets data & errors. */
				function doStep()
				{
					step(returnable());
					data = [], errors = [];
				}
			};

			/** Sets the abort flag */
			this.abort = function()
			{
				aborted = true;
			};

			/** Gets the cursor position */
			this.getCharIndex = function()
			{
				return cursor;
			};
		}


		// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
		// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
		function getScriptPath()
		{
			var scripts = document.getElementsByTagName('script');
			return scripts.length ? scripts[scripts.length - 1].src : '';
		}

		function newWorker()
		{
			if (!Papa.WORKERS_SUPPORTED)
				return false;
			if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
				throw new Error(
					'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
					'You need to set Papa.SCRIPT_PATH manually.'
				);
			var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
			// Append "papaworker" to the search string to tell papaparse that this is our worker.
			workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
			var w = new global.Worker(workerUrl);
			w.onmessage = mainThreadReceivedMessage;
			w.id = workerIdCounter++;
			workers[w.id] = w;
			return w;
		}

		/** Callback when main thread receives a message */
		function mainThreadReceivedMessage(e)
		{
			var msg = e.data;
			var worker = workers[msg.workerId];
			var aborted = false;

			if (msg.error)
				worker.userError(msg.error, msg.file);
			else if (msg.results && msg.results.data)
			{
				var abort = function() {
					aborted = true;
					completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
				};

				var handle = {
					abort: abort,
					pause: notImplemented,
					resume: notImplemented
				};

				if (isFunction(worker.userStep))
				{
					for (var i = 0; i < msg.results.data.length; i++)
					{
						worker.userStep({
							data: [msg.results.data[i]],
							errors: msg.results.errors,
							meta: msg.results.meta
						}, handle);
						if (aborted)
							break;
					}
					delete msg.results;	// free memory ASAP
				}
				else if (isFunction(worker.userChunk))
				{
					worker.userChunk(msg.results, handle, msg.file);
					delete msg.results;
				}
			}

			if (msg.finished && !aborted)
				completeWorker(msg.workerId, msg.results);
		}

		function completeWorker(workerId, results) {
			var worker = workers[workerId];
			if (isFunction(worker.userComplete))
				worker.userComplete(results);
			worker.terminate();
			delete workers[workerId];
		}

		function notImplemented() {
			throw "Not implemented.";
		}

		/** Callback when worker thread receives a message */
		function workerThreadReceivedMessage(e)
		{
			var msg = e.data;

			if (typeof Papa.WORKER_ID === 'undefined' && msg)
				Papa.WORKER_ID = msg.workerId;

			if (typeof msg.input === 'string')
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: Papa.parse(msg.input, msg.config),
					finished: true
				});
			}
			else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
			{
				var results = Papa.parse(msg.input, msg.config);
				if (results)
					global.postMessage({
						workerId: Papa.WORKER_ID,
						results: results,
						finished: true
					});
			}
		}

		/** Makes a deep copy of an array or object (mostly) */
		function copy(obj)
		{
			if (typeof obj !== 'object')
				return obj;
			var cpy = obj instanceof Array ? [] : {};
			for (var key in obj)
				cpy[key] = copy(obj[key]);
			return cpy;
		}

		function bindFunction(f, self)
		{
			return function() { f.apply(self, arguments); };
		}

		function isFunction(func)
		{
			return typeof func === 'function';
		}
	})(typeof window !== 'undefined' ? window : this);


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/**
	 * textFit v2.1.1
	 * Previously known as jQuery.textFit
	 * 11/2014 by STRML (strml.github.com)
	 * MIT License
	 * 
	 * To use: textFit(document.getElementById('target-div'), options);
	 * 
	 * Will make the *text* content inside a container scale to fit the container
	 * The container is required to have a set width and height
	 * Uses binary search to fit text with minimal layout calls.
	 * Version 2.0 does not use jQuery.
	 */
	/*global define:true, document:true, window:true, HTMLElement:true*/

	(function(root, factory) {
	  "use strict";

	  // UMD shim
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === "object") {
	    // Node/CommonJS
	    module.exports = factory();
	  } else {
	    // Browser
	    root.textFit = factory();
	  }

	}(typeof global === "object" ? global : this, function () {
	  "use strict";

	  return function textFit(els, options) {
	    var settings = {
	      alignVert: false, // if true, textFit will align vertically using css tables
	      alignHoriz: false, // if true, textFit will set text-align: center
	      multiLine: false, // if true, textFit will not set white-space: no-wrap
	      detectMultiLine: true, // disable to turn off automatic multi-line sensing
	      minFontSize: 6,
	      maxFontSize: 80,
	      reProcess: true, // if true, textFit will re-process already-fit nodes. Set to 'false' for better performance
	      widthOnly: false, // if true, textFit will fit text to element width, regardless of text height
	      suppressErrors: false // if true, will not print errors to console
	    };

	    // Extend options.
	    for(var key in options){
	      if(options.hasOwnProperty(key)){
	        settings[key] = options[key];
	      }
	    }

	    // Convert jQuery objects into arrays
	    if (typeof els.toArray === "function") {
	      els = els.toArray();
	    }

	    // Support passing a single el
	    var elType = Object.prototype.toString.call(els);
	    if (elType !== '[object Array]' && elType !== '[object NodeList]'){
	      els = [els];
	    }

	    for(var i = 0; i < els.length; i++){
	      processItem(els[i]);
	    }

	    function processItem(el){

	      if (!isElement(el) || (!settings.reProcess && el.getAttribute('textFitted'))) {
	        return false;
	      }

	      // Set textFitted attribute so we know this was processed.
	      if(!settings.reProcess){
	        el.setAttribute('textFitted', 1);
	      }

	      var innerSpan, originalHeight, originalHTML, originalWidth;
	      var low, mid, high;

	      // Get element data.
	      originalHTML = el.innerHTML;
	      originalWidth = innerWidth(el);
	      originalHeight = innerHeight(el);

	      // Don't process if we can't find box dimensions
	      if (!originalWidth || (!settings.widthOnly && !originalHeight)) {
	        // Show an error, if we can.
	        if (window.console && !settings.suppressErrors) {
	          if(!settings.widthOnly)
	            console.info('Set a static height and width on the target element ' + el.outerHTML +
	              ' before using textFit!');
	          else
	            console.info('Set a static width on the target element ' + el.outerHTML +
	              ' before using textFit!');
	        }
	        return false;
	      }

	      // Add textFitted span inside this container.
	      if (originalHTML.indexOf('textFitted') === -1) {
	        innerSpan = document.createElement('span');
	        innerSpan.className = 'textFitted';
	        // Inline block ensure it takes on the size of its contents, even if they are enclosed
	        // in other tags like <p>
	        innerSpan.style['display'] = 'inline-block';
	        innerSpan.innerHTML = originalHTML;
	        el.innerHTML = '';
	        el.appendChild(innerSpan);
	      } else {
	        // Reprocessing.
	        innerSpan = el.querySelector('span.textFitted');
	        // Remove vertical align if we're reprocessing.
	        if (hasClass(innerSpan, 'textFitAlignVert')){
	          innerSpan.className = innerSpan.className.replace('textFitAlignVert', '');
	          innerSpan.style['height'] = '';
	        }
	      }

	      // Prepare & set alignment
	      if (settings.alignHoriz) {
	        el.style['text-align'] = 'center';
	        innerSpan.style['text-align'] = 'center';
	      }

	      // Check if this string is multiple lines
	      // Not guaranteed to always work if you use wonky line-heights
	      var multiLine = settings.multiLine;
	      if (settings.detectMultiLine && !multiLine &&
	          innerSpan.offsetHeight >= parseInt(window.getComputedStyle(innerSpan)['font-size'], 10) * 2){
	        multiLine = true;
	      }

	      // If we're not treating this as a multiline string, don't let it wrap.
	      if (!multiLine) {
	        el.style['white-space'] = 'nowrap';
	      }

	      low = settings.minFontSize + 1;
	      high = settings.maxFontSize + 1;

	      // Binary search for best fit
	      while ( low <= high) {
	        mid = parseInt((low + high) / 2, 10);
	        innerSpan.style.fontSize = mid + 'px';
	        if(innerSpan.offsetWidth <= originalWidth && (settings.widthOnly || innerSpan.offsetHeight <= originalHeight)){
	          low = mid + 1;
	        } else {
	          high = mid - 1;
	        }
	      }
	      // Sub 1 at the very end, this is closer to what we wanted.
	      innerSpan.style.fontSize = (mid - 1) + 'px';

	      // Our height is finalized. If we are aligning vertically, set that up.
	      if (settings.alignVert) {
	        addStyleSheet();
	        var height = innerSpan.offsetHeight;
	        if (window.getComputedStyle(el)['position'] === "static"){
	          el.style['position'] = 'relative';
	        }
	        if (!hasClass(innerSpan, "textFitAlignVert")){
	          innerSpan.className = innerSpan.className + " textFitAlignVert";
	        }
	        innerSpan.style['height'] = height + "px";
	      }
	        
	    }

	    // Calculate height without padding.
	    function innerHeight(el){
	      var style = window.getComputedStyle(el, null);
	      return el.clientHeight -
	        parseInt(style.getPropertyValue('padding-top'), 10) -
	        parseInt(style.getPropertyValue('padding-bottom'), 10);
	    }

	    // Calculate width without padding.
	    function innerWidth(el){
	      var style = window.getComputedStyle(el, null);
	      return el.clientWidth -
	        parseInt(style.getPropertyValue('padding-left'), 10) -
	        parseInt(style.getPropertyValue('padding-right'), 10);
	    }

	    //Returns true if it is a DOM element    
	    function isElement(o){
	      return (
	        typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
	        o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
	      );
	    }

	    function hasClass(element, cls) {
	      return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	    }

	    // Better than a stylesheet dependency
	    function addStyleSheet() {
	      if (document.getElementById("textFitStyleSheet")) return;
	      var style = [
	        ".textFitAlignVert{",
	          "position: absolute;",
	          "top: 0; right: 0; bottom: 0; left: 0;",
	          "margin: auto;",
	        "}"].join("");

	      var css = document.createElement("style");
	      css.type = "text/css";
	      css.id = "textFitStyleSheet";
	      css.innerHTML = style;
	      document.body.appendChild(css);
	    }
	  };
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Downloadify 0.2 (c) 2009 by Douglas Neiner. Licensed under the MIT license */
	/* See http://github.com/dcneiner/Downloadify for license and more info */
	module.exports = function(window) {
	var swfobject = __webpack_require__(281)(window);
	var Downloadify={queue:{},uid:new Date().getTime(),getTextForSave:function(a){var b=Downloadify.queue[a];if(b)return b.getData();return""},getFileNameForSave:function(a){var b=Downloadify.queue[a];if(b)return b.getFilename();return""},getDataTypeForSave:function(a){var b=Downloadify.queue[a];if(b)return b.getDataType();return""},saveComplete:function(a){var b=Downloadify.queue[a];if(b)b.complete();return true},saveCancel:function(a){var b=Downloadify.queue[a];if(b)b.cancel();return true},saveError:function(a){var b=Downloadify.queue[a];if(b)b.error();return true},addToQueue:function(a){Downloadify.queue[a.queue_name]=a},getUID:function(a){if(a.id=="")a.id='downloadify_'+Downloadify.uid++;return a.id}};Downloadify.create=function(a,b){var c=(typeof(a)=="string"?document.getElementById(a):a);return new Downloadify.Container(c,b)};Downloadify.Container=function(d,e){var f=this;f.el=d;f.enabled=true;f.dataCallback=null;f.filenameCallback=null;f.data=null;f.filename=null;var g=function(){f.options=e;if(!f.options.append)f.el.innerHTML="";f.flashContainer=document.createElement('span');f.el.appendChild(f.flashContainer);f.queue_name=Downloadify.getUID(f.flashContainer);if(typeof(f.options.filename)==="function")f.filenameCallback=f.options.filename;else if(f.options.filename)f.filename=f.options.filename;if(typeof(f.options.data)==="function")f.dataCallback=f.options.data;else if(f.options.data)f.data=f.options.data;var a={queue_name:f.queue_name,width:f.options.width,height:f.options.height};var b={allowScriptAccess:'always'};var c={id:f.flashContainer.id,name:f.flashContainer.id};if(f.options.enabled===false)f.enabled=false;if(f.options.transparent===true)b.wmode="transparent";if(f.options.downloadImage)a.downloadImage=f.options.downloadImage;swfobject.embedSWF(f.options.swf,f.flashContainer.id,f.options.width,f.options.height,"10",null,a,b,c);Downloadify.addToQueue(f)};f.enable=function(){var a=document.getElementById(f.flashContainer.id);a.setEnabled(true);f.enabled=true};f.disable=function(){var a=document.getElementById(f.flashContainer.id);a.setEnabled(false);f.enabled=false};f.getData=function(){if(!f.enabled)return"";if(f.dataCallback)return f.dataCallback();else if(f.data)return f.data;else return""};f.getFilename=function(){if(f.filenameCallback)return f.filenameCallback();else if(f.filename)return f.filename;else return""};f.getDataType=function(){if(f.options.dataType)return f.options.dataType;return"string"};f.complete=function(){if(typeof(f.options.onComplete)==="function")f.options.onComplete()};f.cancel=function(){if(typeof(f.options.onCancel)==="function")f.options.onCancel()};f.error=function(){if(typeof(f.options.onError)==="function")f.options.onError()};g()};Downloadify.defaultOptions={swf:'media/downloadify.swf',downloadImage:'images/download.png',width:100,height:30,transparent:true,append:false,dataType:"string"};if(typeof(jQuery)!="undefined"){(function($){$.fn.downloadify=function(b){return this.each(function(){b=$.extend({},Downloadify.defaultOptions,b);var a=Downloadify.create(this,b);$(this).data('Downloadify',a)})}})(jQuery)};if(typeof(MooTools)!='undefined'){Element.implement({downloadify:function(a){a=$merge(Downloadify.defaultOptions,a);return this.store('Downloadify',Downloadify.create(this,a))}})};
	return Downloadify;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ },
/* 281 */
/***/ function(module, exports) {

	/*	SWFObject v2.2 <http://code.google.com/p/swfobject/> 
		is released under the MIT License <http://www.opensource.org/licenses/mit-license.php> 
	*/
	module.exports = function(window) {
	var swfobject=function(){var D="undefined",r="object",S="Shockwave Flash",W="ShockwaveFlash.ShockwaveFlash",q="application/x-shockwave-flash",R="SWFObjectExprInst",x="onreadystatechange",O=window,j=document,t=navigator,T=false,U=[h],o=[],N=[],I=[],l,Q,E,B,J=false,a=false,n,G,m=true,M=function(){var aa=typeof j.getElementById!=D&&typeof j.getElementsByTagName!=D&&typeof j.createElement!=D,ah=t.userAgent.toLowerCase(),Y=t.platform.toLowerCase(),ae=Y?/win/.test(Y):/win/.test(ah),ac=Y?/mac/.test(Y):/mac/.test(ah),af=/webkit/.test(ah)?parseFloat(ah.replace(/^.*webkit\/(\d+(\.\d+)?).*$/,"$1")):false,X=!+"\v1",ag=[0,0,0],ab=null;if(typeof t.plugins!=D&&typeof t.plugins[S]==r){ab=t.plugins[S].description;if(ab&&!(typeof t.mimeTypes!=D&&t.mimeTypes[q]&&!t.mimeTypes[q].enabledPlugin)){T=true;X=false;ab=ab.replace(/^.*\s+(\S+\s+\S+$)/,"$1");ag[0]=parseInt(ab.replace(/^(.*)\..*$/,"$1"),10);ag[1]=parseInt(ab.replace(/^.*\.(.*)\s.*$/,"$1"),10);ag[2]=/[a-zA-Z]/.test(ab)?parseInt(ab.replace(/^.*[a-zA-Z]+(.*)$/,"$1"),10):0}}else{if(typeof O.ActiveXObject!=D){try{var ad=new ActiveXObject(W);if(ad){ab=ad.GetVariable("$version");if(ab){X=true;ab=ab.split(" ")[1].split(",");ag=[parseInt(ab[0],10),parseInt(ab[1],10),parseInt(ab[2],10)]}}}catch(Z){}}}return{w3:aa,pv:ag,wk:af,ie:X,win:ae,mac:ac}}(),k=function(){if(!M.w3){return}if((typeof j.readyState!=D&&j.readyState=="complete")||(typeof j.readyState==D&&(j.getElementsByTagName("body")[0]||j.body))){f()}if(!J){if(typeof j.addEventListener!=D){j.addEventListener("DOMContentLoaded",f,false)}if(M.ie&&M.win){j.attachEvent(x,function(){if(j.readyState=="complete"){j.detachEvent(x,arguments.callee);f()}});if(O==top){(function(){if(J){return}try{j.documentElement.doScroll("left")}catch(X){setTimeout(arguments.callee,0);return}f()})()}}if(M.wk){(function(){if(J){return}if(!/loaded|complete/.test(j.readyState)){setTimeout(arguments.callee,0);return}f()})()}s(f)}}();function f(){if(J){return}try{var Z=j.getElementsByTagName("body")[0].appendChild(C("span"));Z.parentNode.removeChild(Z)}catch(aa){return}J=true;var X=U.length;for(var Y=0;Y<X;Y++){U[Y]()}}function K(X){if(J){X()}else{U[U.length]=X}}function s(Y){if(typeof O.addEventListener!=D){O.addEventListener("load",Y,false)}else{if(typeof j.addEventListener!=D){j.addEventListener("load",Y,false)}else{if(typeof O.attachEvent!=D){i(O,"onload",Y)}else{if(typeof O.onload=="function"){var X=O.onload;O.onload=function(){X();Y()}}else{O.onload=Y}}}}}function h(){if(T){V()}else{H()}}function V(){var X=j.getElementsByTagName("body")[0];var aa=C(r);aa.setAttribute("type",q);var Z=X.appendChild(aa);if(Z){var Y=0;(function(){if(typeof Z.GetVariable!=D){var ab=Z.GetVariable("$version");if(ab){ab=ab.split(" ")[1].split(",");M.pv=[parseInt(ab[0],10),parseInt(ab[1],10),parseInt(ab[2],10)]}}else{if(Y<10){Y++;setTimeout(arguments.callee,10);return}}X.removeChild(aa);Z=null;H()})()}else{H()}}function H(){var ag=o.length;if(ag>0){for(var af=0;af<ag;af++){var Y=o[af].id;var ab=o[af].callbackFn;var aa={success:false,id:Y};if(M.pv[0]>0){var ae=c(Y);if(ae){if(F(o[af].swfVersion)&&!(M.wk&&M.wk<312)){w(Y,true);if(ab){aa.success=true;aa.ref=z(Y);ab(aa)}}else{if(o[af].expressInstall&&A()){var ai={};ai.data=o[af].expressInstall;ai.width=ae.getAttribute("width")||"0";ai.height=ae.getAttribute("height")||"0";if(ae.getAttribute("class")){ai.styleclass=ae.getAttribute("class")}if(ae.getAttribute("align")){ai.align=ae.getAttribute("align")}var ah={};var X=ae.getElementsByTagName("param");var ac=X.length;for(var ad=0;ad<ac;ad++){if(X[ad].getAttribute("name").toLowerCase()!="movie"){ah[X[ad].getAttribute("name")]=X[ad].getAttribute("value")}}P(ai,ah,Y,ab)}else{p(ae);if(ab){ab(aa)}}}}}else{w(Y,true);if(ab){var Z=z(Y);if(Z&&typeof Z.SetVariable!=D){aa.success=true;aa.ref=Z}ab(aa)}}}}}function z(aa){var X=null;var Y=c(aa);if(Y&&Y.nodeName=="OBJECT"){if(typeof Y.SetVariable!=D){X=Y}else{var Z=Y.getElementsByTagName(r)[0];if(Z){X=Z}}}return X}function A(){return !a&&F("6.0.65")&&(M.win||M.mac)&&!(M.wk&&M.wk<312)}function P(aa,ab,X,Z){a=true;E=Z||null;B={success:false,id:X};var ae=c(X);if(ae){if(ae.nodeName=="OBJECT"){l=g(ae);Q=null}else{l=ae;Q=X}aa.id=R;if(typeof aa.width==D||(!/%$/.test(aa.width)&&parseInt(aa.width,10)<310)){aa.width="310"}if(typeof aa.height==D||(!/%$/.test(aa.height)&&parseInt(aa.height,10)<137)){aa.height="137"}j.title=j.title.slice(0,47)+" - Flash Player Installation";var ad=M.ie&&M.win?"ActiveX":"PlugIn",ac="MMredirectURL="+O.location.toString().replace(/&/g,"%26")+"&MMplayerType="+ad+"&MMdoctitle="+j.title;if(typeof ab.flashvars!=D){ab.flashvars+="&"+ac}else{ab.flashvars=ac}if(M.ie&&M.win&&ae.readyState!=4){var Y=C("div");X+="SWFObjectNew";Y.setAttribute("id",X);ae.parentNode.insertBefore(Y,ae);ae.style.display="none";(function(){if(ae.readyState==4){ae.parentNode.removeChild(ae)}else{setTimeout(arguments.callee,10)}})()}u(aa,ab,X)}}function p(Y){if(M.ie&&M.win&&Y.readyState!=4){var X=C("div");Y.parentNode.insertBefore(X,Y);X.parentNode.replaceChild(g(Y),X);Y.style.display="none";(function(){if(Y.readyState==4){Y.parentNode.removeChild(Y)}else{setTimeout(arguments.callee,10)}})()}else{Y.parentNode.replaceChild(g(Y),Y)}}function g(ab){var aa=C("div");if(M.win&&M.ie){aa.innerHTML=ab.innerHTML}else{var Y=ab.getElementsByTagName(r)[0];if(Y){var ad=Y.childNodes;if(ad){var X=ad.length;for(var Z=0;Z<X;Z++){if(!(ad[Z].nodeType==1&&ad[Z].nodeName=="PARAM")&&!(ad[Z].nodeType==8)){aa.appendChild(ad[Z].cloneNode(true))}}}}}return aa}function u(ai,ag,Y){var X,aa=c(Y);if(M.wk&&M.wk<312){return X}if(aa){if(typeof ai.id==D){ai.id=Y}if(M.ie&&M.win){var ah="";for(var ae in ai){if(ai[ae]!=Object.prototype[ae]){if(ae.toLowerCase()=="data"){ag.movie=ai[ae]}else{if(ae.toLowerCase()=="styleclass"){ah+=' class="'+ai[ae]+'"'}else{if(ae.toLowerCase()!="classid"){ah+=" "+ae+'="'+ai[ae]+'"'}}}}}var af="";for(var ad in ag){if(ag[ad]!=Object.prototype[ad]){af+='<param name="'+ad+'" value="'+ag[ad]+'" />'}}aa.outerHTML='<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"'+ah+">"+af+"</object>";N[N.length]=ai.id;X=c(ai.id)}else{var Z=C(r);Z.setAttribute("type",q);for(var ac in ai){if(ai[ac]!=Object.prototype[ac]){if(ac.toLowerCase()=="styleclass"){Z.setAttribute("class",ai[ac])}else{if(ac.toLowerCase()!="classid"){Z.setAttribute(ac,ai[ac])}}}}for(var ab in ag){if(ag[ab]!=Object.prototype[ab]&&ab.toLowerCase()!="movie"){e(Z,ab,ag[ab])}}aa.parentNode.replaceChild(Z,aa);X=Z}}return X}function e(Z,X,Y){var aa=C("param");aa.setAttribute("name",X);aa.setAttribute("value",Y);Z.appendChild(aa)}function y(Y){var X=c(Y);if(X&&X.nodeName=="OBJECT"){if(M.ie&&M.win){X.style.display="none";(function(){if(X.readyState==4){b(Y)}else{setTimeout(arguments.callee,10)}})()}else{X.parentNode.removeChild(X)}}}function b(Z){var Y=c(Z);if(Y){for(var X in Y){if(typeof Y[X]=="function"){Y[X]=null}}Y.parentNode.removeChild(Y)}}function c(Z){var X=null;try{X=j.getElementById(Z)}catch(Y){}return X}function C(X){return j.createElement(X)}function i(Z,X,Y){Z.attachEvent(X,Y);I[I.length]=[Z,X,Y]}function F(Z){var Y=M.pv,X=Z.split(".");X[0]=parseInt(X[0],10);X[1]=parseInt(X[1],10)||0;X[2]=parseInt(X[2],10)||0;return(Y[0]>X[0]||(Y[0]==X[0]&&Y[1]>X[1])||(Y[0]==X[0]&&Y[1]==X[1]&&Y[2]>=X[2]))?true:false}function v(ac,Y,ad,ab){if(M.ie&&M.mac){return}var aa=j.getElementsByTagName("head")[0];if(!aa){return}var X=(ad&&typeof ad=="string")?ad:"screen";if(ab){n=null;G=null}if(!n||G!=X){var Z=C("style");Z.setAttribute("type","text/css");Z.setAttribute("media",X);n=aa.appendChild(Z);if(M.ie&&M.win&&typeof j.styleSheets!=D&&j.styleSheets.length>0){n=j.styleSheets[j.styleSheets.length-1]}G=X}if(M.ie&&M.win){if(n&&typeof n.addRule==r){n.addRule(ac,Y)}}else{if(n&&typeof j.createTextNode!=D){n.appendChild(j.createTextNode(ac+" {"+Y+"}"))}}}function w(Z,X){if(!m){return}var Y=X?"visible":"hidden";if(J&&c(Z)){c(Z).style.visibility=Y}else{v("#"+Z,"visibility:"+Y)}}function L(Y){var Z=/[\\\"<>\.;]/;var X=Z.exec(Y)!=null;return X&&typeof encodeURIComponent!=D?encodeURIComponent(Y):Y}var d=function(){if(M.ie&&M.win){window.attachEvent("onunload",function(){var ac=I.length;for(var ab=0;ab<ac;ab++){I[ab][0].detachEvent(I[ab][1],I[ab][2])}var Z=N.length;for(var aa=0;aa<Z;aa++){y(N[aa])}for(var Y in M){M[Y]=null}M=null;for(var X in swfobject){swfobject[X]=null}swfobject=null})}}();return{registerObject:function(ab,X,aa,Z){if(M.w3&&ab&&X){var Y={};Y.id=ab;Y.swfVersion=X;Y.expressInstall=aa;Y.callbackFn=Z;o[o.length]=Y;w(ab,false)}else{if(Z){Z({success:false,id:ab})}}},getObjectById:function(X){if(M.w3){return z(X)}},embedSWF:function(ab,ah,ae,ag,Y,aa,Z,ad,af,ac){var X={success:false,id:ah};if(M.w3&&!(M.wk&&M.wk<312)&&ab&&ah&&ae&&ag&&Y){w(ah,false);K(function(){ae+="";ag+="";var aj={};if(af&&typeof af===r){for(var al in af){aj[al]=af[al]}}aj.data=ab;aj.width=ae;aj.height=ag;var am={};if(ad&&typeof ad===r){for(var ak in ad){am[ak]=ad[ak]}}if(Z&&typeof Z===r){for(var ai in Z){if(typeof am.flashvars!=D){am.flashvars+="&"+ai+"="+Z[ai]}else{am.flashvars=ai+"="+Z[ai]}}}if(F(Y)){var an=u(aj,am,ah);if(aj.id==ah){w(ah,true)}X.success=true;X.ref=an}else{if(aa&&A()){aj.data=aa;P(aj,am,ah,ac);return}else{w(ah,true)}}if(ac){ac(X)}})}else{if(ac){ac(X)}}},switchOffAutoHideShow:function(){m=false},ua:M,getFlashPlayerVersion:function(){return{major:M.pv[0],minor:M.pv[1],release:M.pv[2]}},hasFlashPlayerVersion:F,createSWF:function(Z,Y,X){if(M.w3){return u(Z,Y,X)}else{return undefined}},showExpressInstall:function(Z,aa,X,Y){if(M.w3&&A()){P(Z,aa,X,Y)}},removeSWF:function(X){if(M.w3){y(X)}},createCSS:function(aa,Z,Y,X){if(M.w3){v(aa,Z,Y,X)}},addDomLoadEvent:K,addLoadEvent:s,getQueryParamValue:function(aa){var Z=j.location.search||j.location.hash;if(Z){if(/\?/.test(Z)){Z=Z.split("?")[1]}if(aa==null){return L(Z)}var Y=Z.split("&");for(var X=0;X<Y.length;X++){if(Y[X].substring(0,Y[X].indexOf("="))==aa){return L(Y[X].substring((Y[X].indexOf("=")+1)))}}}return""},expressInstallCallback:function(){if(a){var X=c(R);if(X&&l){X.parentNode.replaceChild(l,X);if(Q){w(Q,true);if(M.ie&&M.win){l.style.display="block"}}if(E){E(B)}}a=false}}}}();
	return swfobject;
	};

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;/*! showdown 21-06-2016 */
	(function(){
	/**
	 * Created by Tivie on 13-07-2015.
	 */

	function getDefaultOpts(simple) {
	  'use strict';

	  var defaultOptions = {
	    omitExtraWLInCodeBlocks: {
	      default: false,
	      describe: 'Omit the default extra whiteline added to code blocks',
	      type: 'boolean'
	    },
	    noHeaderId: {
	      default: false,
	      describe: 'Turn on/off generated header id',
	      type: 'boolean'
	    },
	    prefixHeaderId: {
	      default: false,
	      describe: 'Specify a prefix to generated header ids',
	      type: 'string'
	    },
	    headerLevelStart: {
	      default: false,
	      describe: 'The header blocks level start',
	      type: 'integer'
	    },
	    parseImgDimensions: {
	      default: false,
	      describe: 'Turn on/off image dimension parsing',
	      type: 'boolean'
	    },
	    simplifiedAutoLink: {
	      default: false,
	      describe: 'Turn on/off GFM autolink style',
	      type: 'boolean'
	    },
	    literalMidWordUnderscores: {
	      default: false,
	      describe: 'Parse midword underscores as literal underscores',
	      type: 'boolean'
	    },
	    strikethrough: {
	      default: false,
	      describe: 'Turn on/off strikethrough support',
	      type: 'boolean'
	    },
	    tables: {
	      default: false,
	      describe: 'Turn on/off tables support',
	      type: 'boolean'
	    },
	    tablesHeaderId: {
	      default: false,
	      describe: 'Add an id to table headers',
	      type: 'boolean'
	    },
	    ghCodeBlocks: {
	      default: true,
	      describe: 'Turn on/off GFM fenced code blocks support',
	      type: 'boolean'
	    },
	    tasklists: {
	      default: false,
	      describe: 'Turn on/off GFM tasklist support',
	      type: 'boolean'
	    },
	    smoothLivePreview: {
	      default: false,
	      describe: 'Prevents weird effects in live previews due to incomplete input',
	      type: 'boolean'
	    },
	    smartIndentationFix: {
	      default: false,
	      description: 'Tries to smartly fix identation in es6 strings',
	      type: 'boolean'
	    }
	  };
	  if (simple === false) {
	    return JSON.parse(JSON.stringify(defaultOptions));
	  }
	  var ret = {};
	  for (var opt in defaultOptions) {
	    if (defaultOptions.hasOwnProperty(opt)) {
	      ret[opt] = defaultOptions[opt].default;
	    }
	  }
	  return ret;
	}

	/**
	 * Created by Tivie on 06-01-2015.
	 */

	// Private properties
	var showdown = {},
	    parsers = {},
	    extensions = {},
	    globalOptions = getDefaultOpts(true),
	    flavor = {
	      github: {
	        omitExtraWLInCodeBlocks:   true,
	        prefixHeaderId:            'user-content-',
	        simplifiedAutoLink:        true,
	        literalMidWordUnderscores: true,
	        strikethrough:             true,
	        tables:                    true,
	        tablesHeaderId:            true,
	        ghCodeBlocks:              true,
	        tasklists:                 true
	      },
	      vanilla: getDefaultOpts(true)
	    };

	/**
	 * helper namespace
	 * @type {{}}
	 */
	showdown.helper = {};

	/**
	 * TODO LEGACY SUPPORT CODE
	 * @type {{}}
	 */
	showdown.extensions = {};

	/**
	 * Set a global option
	 * @static
	 * @param {string} key
	 * @param {*} value
	 * @returns {showdown}
	 */
	showdown.setOption = function (key, value) {
	  'use strict';
	  globalOptions[key] = value;
	  return this;
	};

	/**
	 * Get a global option
	 * @static
	 * @param {string} key
	 * @returns {*}
	 */
	showdown.getOption = function (key) {
	  'use strict';
	  return globalOptions[key];
	};

	/**
	 * Get the global options
	 * @static
	 * @returns {{}}
	 */
	showdown.getOptions = function () {
	  'use strict';
	  return globalOptions;
	};

	/**
	 * Reset global options to the default values
	 * @static
	 */
	showdown.resetOptions = function () {
	  'use strict';
	  globalOptions = getDefaultOpts(true);
	};

	/**
	 * Set the flavor showdown should use as default
	 * @param {string} name
	 */
	showdown.setFlavor = function (name) {
	  'use strict';
	  if (flavor.hasOwnProperty(name)) {
	    var preset = flavor[name];
	    for (var option in preset) {
	      if (preset.hasOwnProperty(option)) {
	        globalOptions[option] = preset[option];
	      }
	    }
	  }
	};

	/**
	 * Get the default options
	 * @static
	 * @param {boolean} [simple=true]
	 * @returns {{}}
	 */
	showdown.getDefaultOptions = function (simple) {
	  'use strict';
	  return getDefaultOpts(simple);
	};

	/**
	 * Get or set a subParser
	 *
	 * subParser(name)       - Get a registered subParser
	 * subParser(name, func) - Register a subParser
	 * @static
	 * @param {string} name
	 * @param {function} [func]
	 * @returns {*}
	 */
	showdown.subParser = function (name, func) {
	  'use strict';
	  if (showdown.helper.isString(name)) {
	    if (typeof func !== 'undefined') {
	      parsers[name] = func;
	    } else {
	      if (parsers.hasOwnProperty(name)) {
	        return parsers[name];
	      } else {
	        throw Error('SubParser named ' + name + ' not registered!');
	      }
	    }
	  }
	};

	/**
	 * Gets or registers an extension
	 * @static
	 * @param {string} name
	 * @param {object|function=} ext
	 * @returns {*}
	 */
	showdown.extension = function (name, ext) {
	  'use strict';

	  if (!showdown.helper.isString(name)) {
	    throw Error('Extension \'name\' must be a string');
	  }

	  name = showdown.helper.stdExtName(name);

	  // Getter
	  if (showdown.helper.isUndefined(ext)) {
	    if (!extensions.hasOwnProperty(name)) {
	      throw Error('Extension named ' + name + ' is not registered!');
	    }
	    return extensions[name];

	    // Setter
	  } else {
	    // Expand extension if it's wrapped in a function
	    if (typeof ext === 'function') {
	      ext = ext();
	    }

	    // Ensure extension is an array
	    if (!showdown.helper.isArray(ext)) {
	      ext = [ext];
	    }

	    var validExtension = validate(ext, name);

	    if (validExtension.valid) {
	      extensions[name] = ext;
	    } else {
	      throw Error(validExtension.error);
	    }
	  }
	};

	/**
	 * Gets all extensions registered
	 * @returns {{}}
	 */
	showdown.getAllExtensions = function () {
	  'use strict';
	  return extensions;
	};

	/**
	 * Remove an extension
	 * @param {string} name
	 */
	showdown.removeExtension = function (name) {
	  'use strict';
	  delete extensions[name];
	};

	/**
	 * Removes all extensions
	 */
	showdown.resetExtensions = function () {
	  'use strict';
	  extensions = {};
	};

	/**
	 * Validate extension
	 * @param {array} extension
	 * @param {string} name
	 * @returns {{valid: boolean, error: string}}
	 */
	function validate(extension, name) {
	  'use strict';

	  var errMsg = (name) ? 'Error in ' + name + ' extension->' : 'Error in unnamed extension',
	    ret = {
	      valid: true,
	      error: ''
	    };

	  if (!showdown.helper.isArray(extension)) {
	    extension = [extension];
	  }

	  for (var i = 0; i < extension.length; ++i) {
	    var baseMsg = errMsg + ' sub-extension ' + i + ': ',
	        ext = extension[i];
	    if (typeof ext !== 'object') {
	      ret.valid = false;
	      ret.error = baseMsg + 'must be an object, but ' + typeof ext + ' given';
	      return ret;
	    }

	    if (!showdown.helper.isString(ext.type)) {
	      ret.valid = false;
	      ret.error = baseMsg + 'property "type" must be a string, but ' + typeof ext.type + ' given';
	      return ret;
	    }

	    var type = ext.type = ext.type.toLowerCase();

	    // normalize extension type
	    if (type === 'language') {
	      type = ext.type = 'lang';
	    }

	    if (type === 'html') {
	      type = ext.type = 'output';
	    }

	    if (type !== 'lang' && type !== 'output' && type !== 'listener') {
	      ret.valid = false;
	      ret.error = baseMsg + 'type ' + type + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"';
	      return ret;
	    }

	    if (type === 'listener') {
	      if (showdown.helper.isUndefined(ext.listeners)) {
	        ret.valid = false;
	        ret.error = baseMsg + '. Extensions of type "listener" must have a property called "listeners"';
	        return ret;
	      }
	    } else {
	      if (showdown.helper.isUndefined(ext.filter) && showdown.helper.isUndefined(ext.regex)) {
	        ret.valid = false;
	        ret.error = baseMsg + type + ' extensions must define either a "regex" property or a "filter" method';
	        return ret;
	      }
	    }

	    if (ext.listeners) {
	      if (typeof ext.listeners !== 'object') {
	        ret.valid = false;
	        ret.error = baseMsg + '"listeners" property must be an object but ' + typeof ext.listeners + ' given';
	        return ret;
	      }
	      for (var ln in ext.listeners) {
	        if (ext.listeners.hasOwnProperty(ln)) {
	          if (typeof ext.listeners[ln] !== 'function') {
	            ret.valid = false;
	            ret.error = baseMsg + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + ln +
	              ' must be a function but ' + typeof ext.listeners[ln] + ' given';
	            return ret;
	          }
	        }
	      }
	    }

	    if (ext.filter) {
	      if (typeof ext.filter !== 'function') {
	        ret.valid = false;
	        ret.error = baseMsg + '"filter" must be a function, but ' + typeof ext.filter + ' given';
	        return ret;
	      }
	    } else if (ext.regex) {
	      if (showdown.helper.isString(ext.regex)) {
	        ext.regex = new RegExp(ext.regex, 'g');
	      }
	      if (!ext.regex instanceof RegExp) {
	        ret.valid = false;
	        ret.error = baseMsg + '"regex" property must either be a string or a RegExp object, but ' + typeof ext.regex + ' given';
	        return ret;
	      }
	      if (showdown.helper.isUndefined(ext.replace)) {
	        ret.valid = false;
	        ret.error = baseMsg + '"regex" extensions must implement a replace string or function';
	        return ret;
	      }
	    }
	  }
	  return ret;
	}

	/**
	 * Validate extension
	 * @param {object} ext
	 * @returns {boolean}
	 */
	showdown.validateExtension = function (ext) {
	  'use strict';

	  var validateExtension = validate(ext, null);
	  if (!validateExtension.valid) {
	    console.warn(validateExtension.error);
	    return false;
	  }
	  return true;
	};

	/**
	 * showdownjs helper functions
	 */

	if (!showdown.hasOwnProperty('helper')) {
	  showdown.helper = {};
	}

	/**
	 * Check if var is string
	 * @static
	 * @param {string} a
	 * @returns {boolean}
	 */
	showdown.helper.isString = function isString(a) {
	  'use strict';
	  return (typeof a === 'string' || a instanceof String);
	};

	/**
	 * Check if var is a function
	 * @static
	 * @param {string} a
	 * @returns {boolean}
	 */
	showdown.helper.isFunction = function isFunction(a) {
	  'use strict';
	  var getType = {};
	  return a && getType.toString.call(a) === '[object Function]';
	};

	/**
	 * ForEach helper function
	 * @static
	 * @param {*} obj
	 * @param {function} callback
	 */
	showdown.helper.forEach = function forEach(obj, callback) {
	  'use strict';
	  if (typeof obj.forEach === 'function') {
	    obj.forEach(callback);
	  } else {
	    for (var i = 0; i < obj.length; i++) {
	      callback(obj[i], i, obj);
	    }
	  }
	};

	/**
	 * isArray helper function
	 * @static
	 * @param {*} a
	 * @returns {boolean}
	 */
	showdown.helper.isArray = function isArray(a) {
	  'use strict';
	  return a.constructor === Array;
	};

	/**
	 * Check if value is undefined
	 * @static
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 */
	showdown.helper.isUndefined = function isUndefined(value) {
	  'use strict';
	  return typeof value === 'undefined';
	};

	/**
	 * Standardidize extension name
	 * @static
	 * @param {string} s extension name
	 * @returns {string}
	 */
	showdown.helper.stdExtName = function (s) {
	  'use strict';
	  return s.replace(/[_-]||\s/g, '').toLowerCase();
	};

	function escapeCharactersCallback(wholeMatch, m1) {
	  'use strict';
	  var charCodeToEscape = m1.charCodeAt(0);
	  return '~E' + charCodeToEscape + 'E';
	}

	/**
	 * Callback used to escape characters when passing through String.replace
	 * @static
	 * @param {string} wholeMatch
	 * @param {string} m1
	 * @returns {string}
	 */
	showdown.helper.escapeCharactersCallback = escapeCharactersCallback;

	/**
	 * Escape characters in a string
	 * @static
	 * @param {string} text
	 * @param {string} charsToEscape
	 * @param {boolean} afterBackslash
	 * @returns {XML|string|void|*}
	 */
	showdown.helper.escapeCharacters = function escapeCharacters(text, charsToEscape, afterBackslash) {
	  'use strict';
	  // First we have to escape the escape characters so that
	  // we can build a character class out of them
	  var regexString = '([' + charsToEscape.replace(/([\[\]\\])/g, '\\$1') + '])';

	  if (afterBackslash) {
	    regexString = '\\\\' + regexString;
	  }

	  var regex = new RegExp(regexString, 'g');
	  text = text.replace(regex, escapeCharactersCallback);

	  return text;
	};

	var rgxFindMatchPos = function (str, left, right, flags) {
	  'use strict';
	  var f = flags || '',
	    g = f.indexOf('g') > -1,
	    x = new RegExp(left + '|' + right, 'g' + f.replace(/g/g, '')),
	    l = new RegExp(left, f.replace(/g/g, '')),
	    pos = [],
	    t, s, m, start, end;

	  do {
	    t = 0;
	    while ((m = x.exec(str))) {
	      if (l.test(m[0])) {
	        if (!(t++)) {
	          s = x.lastIndex;
	          start = s - m[0].length;
	        }
	      } else if (t) {
	        if (!--t) {
	          end = m.index + m[0].length;
	          var obj = {
	            left: {start: start, end: s},
	            match: {start: s, end: m.index},
	            right: {start: m.index, end: end},
	            wholeMatch: {start: start, end: end}
	          };
	          pos.push(obj);
	          if (!g) {
	            return pos;
	          }
	        }
	      }
	    }
	  } while (t && (x.lastIndex = s));

	  return pos;
	};

	/**
	 * matchRecursiveRegExp
	 *
	 * (c) 2007 Steven Levithan <stevenlevithan.com>
	 * MIT License
	 *
	 * Accepts a string to search, a left and right format delimiter
	 * as regex patterns, and optional regex flags. Returns an array
	 * of matches, allowing nested instances of left/right delimiters.
	 * Use the "g" flag to return all matches, otherwise only the
	 * first is returned. Be careful to ensure that the left and
	 * right format delimiters produce mutually exclusive matches.
	 * Backreferences are not supported within the right delimiter
	 * due to how it is internally combined with the left delimiter.
	 * When matching strings whose format delimiters are unbalanced
	 * to the left or right, the output is intentionally as a
	 * conventional regex library with recursion support would
	 * produce, e.g. "<<x>" and "<x>>" both produce ["x"] when using
	 * "<" and ">" as the delimiters (both strings contain a single,
	 * balanced instance of "<x>").
	 *
	 * examples:
	 * matchRecursiveRegExp("test", "\\(", "\\)")
	 * returns: []
	 * matchRecursiveRegExp("<t<<e>><s>>t<>", "<", ">", "g")
	 * returns: ["t<<e>><s>", ""]
	 * matchRecursiveRegExp("<div id=\"x\">test</div>", "<div\\b[^>]*>", "</div>", "gi")
	 * returns: ["test"]
	 */
	showdown.helper.matchRecursiveRegExp = function (str, left, right, flags) {
	  'use strict';

	  var matchPos = rgxFindMatchPos (str, left, right, flags),
	    results = [];

	  for (var i = 0; i < matchPos.length; ++i) {
	    results.push([
	      str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
	      str.slice(matchPos[i].match.start, matchPos[i].match.end),
	      str.slice(matchPos[i].left.start, matchPos[i].left.end),
	      str.slice(matchPos[i].right.start, matchPos[i].right.end)
	    ]);
	  }
	  return results;
	};

	/**
	 *
	 * @param {string} str
	 * @param {string|function} replacement
	 * @param {string} left
	 * @param {string} right
	 * @param {string} flags
	 * @returns {string}
	 */
	showdown.helper.replaceRecursiveRegExp = function (str, replacement, left, right, flags) {
	  'use strict';

	  if (!showdown.helper.isFunction(replacement)) {
	    var repStr = replacement;
	    replacement = function () {
	      return repStr;
	    };
	  }

	  var matchPos = rgxFindMatchPos(str, left, right, flags),
	      finalStr = str,
	      lng = matchPos.length;

	  if (lng > 0) {
	    var bits = [];
	    if (matchPos[0].wholeMatch.start !== 0) {
	      bits.push(str.slice(0, matchPos[0].wholeMatch.start));
	    }
	    for (var i = 0; i < lng; ++i) {
	      bits.push(
	        replacement(
	          str.slice(matchPos[i].wholeMatch.start, matchPos[i].wholeMatch.end),
	          str.slice(matchPos[i].match.start, matchPos[i].match.end),
	          str.slice(matchPos[i].left.start, matchPos[i].left.end),
	          str.slice(matchPos[i].right.start, matchPos[i].right.end)
	        )
	      );
	      if (i < lng - 1) {
	        bits.push(str.slice(matchPos[i].wholeMatch.end, matchPos[i + 1].wholeMatch.start));
	      }
	    }
	    if (matchPos[lng - 1].wholeMatch.end < str.length) {
	      bits.push(str.slice(matchPos[lng - 1].wholeMatch.end));
	    }
	    finalStr = bits.join('');
	  }
	  return finalStr;
	};

	/**
	 * POLYFILLS
	 */
	if (showdown.helper.isUndefined(console)) {
	  console = {
	    warn: function (msg) {
	      'use strict';
	      alert(msg);
	    },
	    log: function (msg) {
	      'use strict';
	      alert(msg);
	    },
	    error: function (msg) {
	      'use strict';
	      throw msg;
	    }
	  };
	}

	/**
	 * Created by Estevao on 31-05-2015.
	 */

	/**
	 * Showdown Converter class
	 * @class
	 * @param {object} [converterOptions]
	 * @returns {Converter}
	 */
	showdown.Converter = function (converterOptions) {
	  'use strict';

	  var
	      /**
	       * Options used by this converter
	       * @private
	       * @type {{}}
	       */
	      options = {},

	      /**
	       * Language extensions used by this converter
	       * @private
	       * @type {Array}
	       */
	      langExtensions = [],

	      /**
	       * Output modifiers extensions used by this converter
	       * @private
	       * @type {Array}
	       */
	      outputModifiers = [],

	      /**
	       * Event listeners
	       * @private
	       * @type {{}}
	       */
	      listeners = {};

	  _constructor();

	  /**
	   * Converter constructor
	   * @private
	   */
	  function _constructor() {
	    converterOptions = converterOptions || {};

	    for (var gOpt in globalOptions) {
	      if (globalOptions.hasOwnProperty(gOpt)) {
	        options[gOpt] = globalOptions[gOpt];
	      }
	    }

	    // Merge options
	    if (typeof converterOptions === 'object') {
	      for (var opt in converterOptions) {
	        if (converterOptions.hasOwnProperty(opt)) {
	          options[opt] = converterOptions[opt];
	        }
	      }
	    } else {
	      throw Error('Converter expects the passed parameter to be an object, but ' + typeof converterOptions +
	      ' was passed instead.');
	    }

	    if (options.extensions) {
	      showdown.helper.forEach(options.extensions, _parseExtension);
	    }
	  }

	  /**
	   * Parse extension
	   * @param {*} ext
	   * @param {string} [name='']
	   * @private
	   */
	  function _parseExtension(ext, name) {

	    name = name || null;
	    // If it's a string, the extension was previously loaded
	    if (showdown.helper.isString(ext)) {
	      ext = showdown.helper.stdExtName(ext);
	      name = ext;

	      // LEGACY_SUPPORT CODE
	      if (showdown.extensions[ext]) {
	        console.warn('DEPRECATION WARNING: ' + ext + ' is an old extension that uses a deprecated loading method.' +
	          'Please inform the developer that the extension should be updated!');
	        legacyExtensionLoading(showdown.extensions[ext], ext);
	        return;
	      // END LEGACY SUPPORT CODE

	      } else if (!showdown.helper.isUndefined(extensions[ext])) {
	        ext = extensions[ext];

	      } else {
	        throw Error('Extension "' + ext + '" could not be loaded. It was either not found or is not a valid extension.');
	      }
	    }

	    if (typeof ext === 'function') {
	      ext = ext();
	    }

	    if (!showdown.helper.isArray(ext)) {
	      ext = [ext];
	    }

	    var validExt = validate(ext, name);
	    if (!validExt.valid) {
	      throw Error(validExt.error);
	    }

	    for (var i = 0; i < ext.length; ++i) {
	      switch (ext[i].type) {

	        case 'lang':
	          langExtensions.push(ext[i]);
	          break;

	        case 'output':
	          outputModifiers.push(ext[i]);
	          break;
	      }
	      if (ext[i].hasOwnProperty(listeners)) {
	        for (var ln in ext[i].listeners) {
	          if (ext[i].listeners.hasOwnProperty(ln)) {
	            listen(ln, ext[i].listeners[ln]);
	          }
	        }
	      }
	    }

	  }

	  /**
	   * LEGACY_SUPPORT
	   * @param {*} ext
	   * @param {string} name
	   */
	  function legacyExtensionLoading(ext, name) {
	    if (typeof ext === 'function') {
	      ext = ext(new showdown.Converter());
	    }
	    if (!showdown.helper.isArray(ext)) {
	      ext = [ext];
	    }
	    var valid = validate(ext, name);

	    if (!valid.valid) {
	      throw Error(valid.error);
	    }

	    for (var i = 0; i < ext.length; ++i) {
	      switch (ext[i].type) {
	        case 'lang':
	          langExtensions.push(ext[i]);
	          break;
	        case 'output':
	          outputModifiers.push(ext[i]);
	          break;
	        default:// should never reach here
	          throw Error('Extension loader error: Type unrecognized!!!');
	      }
	    }
	  }

	  /**
	   * Listen to an event
	   * @param {string} name
	   * @param {function} callback
	   */
	  function listen(name, callback) {
	    if (!showdown.helper.isString(name)) {
	      throw Error('Invalid argument in converter.listen() method: name must be a string, but ' + typeof name + ' given');
	    }

	    if (typeof callback !== 'function') {
	      throw Error('Invalid argument in converter.listen() method: callback must be a function, but ' + typeof callback + ' given');
	    }

	    if (!listeners.hasOwnProperty(name)) {
	      listeners[name] = [];
	    }
	    listeners[name].push(callback);
	  }

	  function rTrimInputText(text) {
	    var rsp = text.match(/^\s*/)[0].length,
	        rgx = new RegExp('^\\s{0,' + rsp + '}', 'gm');
	    return text.replace(rgx, '');
	  }

	  /**
	   * Dispatch an event
	   * @private
	   * @param {string} evtName Event name
	   * @param {string} text Text
	   * @param {{}} options Converter Options
	   * @param {{}} globals
	   * @returns {string}
	   */
	  this._dispatch = function dispatch (evtName, text, options, globals) {
	    if (listeners.hasOwnProperty(evtName)) {
	      for (var ei = 0; ei < listeners[evtName].length; ++ei) {
	        var nText = listeners[evtName][ei](evtName, text, this, options, globals);
	        if (nText && typeof nText !== 'undefined') {
	          text = nText;
	        }
	      }
	    }
	    return text;
	  };

	  /**
	   * Listen to an event
	   * @param {string} name
	   * @param {function} callback
	   * @returns {showdown.Converter}
	   */
	  this.listen = function (name, callback) {
	    listen(name, callback);
	    return this;
	  };

	  /**
	   * Converts a markdown string into HTML
	   * @param {string} text
	   * @returns {*}
	   */
	  this.makeHtml = function (text) {
	    //check if text is not falsy
	    if (!text) {
	      return text;
	    }

	    var globals = {
	      gHtmlBlocks:     [],
	      gHtmlMdBlocks:   [],
	      gHtmlSpans:      [],
	      gUrls:           {},
	      gTitles:         {},
	      gDimensions:     {},
	      gListLevel:      0,
	      hashLinkCounts:  {},
	      langExtensions:  langExtensions,
	      outputModifiers: outputModifiers,
	      converter:       this,
	      ghCodeBlocks:    []
	    };

	    // attacklab: Replace ~ with ~T
	    // This lets us use tilde as an escape char to avoid md5 hashes
	    // The choice of character is arbitrary; anything that isn't
	    // magic in Markdown will work.
	    text = text.replace(/~/g, '~T');

	    // attacklab: Replace $ with ~D
	    // RegExp interprets $ as a special character
	    // when it's in a replacement string
	    text = text.replace(/\$/g, '~D');

	    // Standardize line endings
	    text = text.replace(/\r\n/g, '\n'); // DOS to Unix
	    text = text.replace(/\r/g, '\n'); // Mac to Unix

	    if (options.smartIndentationFix) {
	      text = rTrimInputText(text);
	    }

	    // Make sure text begins and ends with a couple of newlines:
	    text = '\n\n' + text + '\n\n';

	    // detab
	    text = showdown.subParser('detab')(text, options, globals);

	    // stripBlankLines
	    text = showdown.subParser('stripBlankLines')(text, options, globals);

	    //run languageExtensions
	    showdown.helper.forEach(langExtensions, function (ext) {
	      text = showdown.subParser('runExtension')(ext, text, options, globals);
	    });

	    // run the sub parsers
	    text = showdown.subParser('hashPreCodeTags')(text, options, globals);
	    text = showdown.subParser('githubCodeBlocks')(text, options, globals);
	    text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
	    text = showdown.subParser('hashHTMLSpans')(text, options, globals);
	    text = showdown.subParser('stripLinkDefinitions')(text, options, globals);
	    text = showdown.subParser('blockGamut')(text, options, globals);
	    text = showdown.subParser('unhashHTMLSpans')(text, options, globals);
	    text = showdown.subParser('unescapeSpecialChars')(text, options, globals);

	    // attacklab: Restore dollar signs
	    text = text.replace(/~D/g, '$$');

	    // attacklab: Restore tildes
	    text = text.replace(/~T/g, '~');

	    // Run output modifiers
	    showdown.helper.forEach(outputModifiers, function (ext) {
	      text = showdown.subParser('runExtension')(ext, text, options, globals);
	    });

	    return text;
	  };

	  /**
	   * Set an option of this Converter instance
	   * @param {string} key
	   * @param {*} value
	   */
	  this.setOption = function (key, value) {
	    options[key] = value;
	  };

	  /**
	   * Get the option of this Converter instance
	   * @param {string} key
	   * @returns {*}
	   */
	  this.getOption = function (key) {
	    return options[key];
	  };

	  /**
	   * Get the options of this Converter instance
	   * @returns {{}}
	   */
	  this.getOptions = function () {
	    return options;
	  };

	  /**
	   * Add extension to THIS converter
	   * @param {{}} extension
	   * @param {string} [name=null]
	   */
	  this.addExtension = function (extension, name) {
	    name = name || null;
	    _parseExtension(extension, name);
	  };

	  /**
	   * Use a global registered extension with THIS converter
	   * @param {string} extensionName Name of the previously registered extension
	   */
	  this.useExtension = function (extensionName) {
	    _parseExtension(extensionName);
	  };

	  /**
	   * Set the flavor THIS converter should use
	   * @param {string} name
	   */
	  this.setFlavor = function (name) {
	    if (flavor.hasOwnProperty(name)) {
	      var preset = flavor[name];
	      for (var option in preset) {
	        if (preset.hasOwnProperty(option)) {
	          options[option] = preset[option];
	        }
	      }
	    }
	  };

	  /**
	   * Remove an extension from THIS converter.
	   * Note: This is a costly operation. It's better to initialize a new converter
	   * and specify the extensions you wish to use
	   * @param {Array} extension
	   */
	  this.removeExtension = function (extension) {
	    if (!showdown.helper.isArray(extension)) {
	      extension = [extension];
	    }
	    for (var a = 0; a < extension.length; ++a) {
	      var ext = extension[a];
	      for (var i = 0; i < langExtensions.length; ++i) {
	        if (langExtensions[i] === ext) {
	          langExtensions[i].splice(i, 1);
	        }
	      }
	      for (var ii = 0; ii < outputModifiers.length; ++i) {
	        if (outputModifiers[ii] === ext) {
	          outputModifiers[ii].splice(i, 1);
	        }
	      }
	    }
	  };

	  /**
	   * Get all extension of THIS converter
	   * @returns {{language: Array, output: Array}}
	   */
	  this.getAllExtensions = function () {
	    return {
	      language: langExtensions,
	      output: outputModifiers
	    };
	  };
	};

	/**
	 * Turn Markdown link shortcuts into XHTML <a> tags.
	 */
	showdown.subParser('anchors', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('anchors.before', text, options, globals);

	  var writeAnchorTag = function (wholeMatch, m1, m2, m3, m4, m5, m6, m7) {
	    if (showdown.helper.isUndefined(m7)) {
	      m7 = '';
	    }
	    wholeMatch = m1;
	    var linkText = m2,
	        linkId = m3.toLowerCase(),
	        url = m4,
	        title = m7;

	    if (!url) {
	      if (!linkId) {
	        // lower-case and turn embedded newlines into spaces
	        linkId = linkText.toLowerCase().replace(/ ?\n/g, ' ');
	      }
	      url = '#' + linkId;

	      if (!showdown.helper.isUndefined(globals.gUrls[linkId])) {
	        url = globals.gUrls[linkId];
	        if (!showdown.helper.isUndefined(globals.gTitles[linkId])) {
	          title = globals.gTitles[linkId];
	        }
	      } else {
	        if (wholeMatch.search(/\(\s*\)$/m) > -1) {
	          // Special case for explicit empty url
	          url = '';
	        } else {
	          return wholeMatch;
	        }
	      }
	    }

	    url = showdown.helper.escapeCharacters(url, '*_', false);
	    var result = '<a href="' + url + '"';

	    if (title !== '' && title !== null) {
	      title = title.replace(/"/g, '&quot;');
	      title = showdown.helper.escapeCharacters(title, '*_', false);
	      result += ' title="' + title + '"';
	    }

	    result += '>' + linkText + '</a>';

	    return result;
	  };

	  // First, handle reference-style links: [link text] [id]
	  /*
	   text = text.replace(/
	   (							// wrap whole match in $1
	   \[
	   (
	   (?:
	   \[[^\]]*\]		// allow brackets nested one level
	   |
	   [^\[]			// or anything else
	   )*
	   )
	   \]

	   [ ]?					// one optional space
	   (?:\n[ ]*)?				// one optional newline followed by spaces

	   \[
	   (.*?)					// id = $3
	   \]
	   )()()()()					// pad remaining backreferences
	   /g,_DoAnchors_callback);
	   */
	  text = text.replace(/(\[((?:\[[^\]]*]|[^\[\]])*)][ ]?(?:\n[ ]*)?\[(.*?)])()()()()/g, writeAnchorTag);

	  //
	  // Next, inline-style links: [link text](url "optional title")
	  //

	  /*
	   text = text.replace(/
	   (						// wrap whole match in $1
	   \[
	   (
	   (?:
	   \[[^\]]*\]	// allow brackets nested one level
	   |
	   [^\[\]]			// or anything else
	   )
	   )
	   \]
	   \(						// literal paren
	   [ \t]*
	   ()						// no id, so leave $3 empty
	   <?(.*?)>?				// href = $4
	   [ \t]*
	   (						// $5
	   (['"])				// quote char = $6
	   (.*?)				// Title = $7
	   \6					// matching quote
	   [ \t]*				// ignore any spaces/tabs between closing quote and )
	   )?						// title is optional
	   \)
	   )
	   /g,writeAnchorTag);
	   */
	  text = text.replace(/(\[((?:\[[^\]]*]|[^\[\]])*)]\([ \t]*()<?(.*?(?:\(.*?\).*?)?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g,
	                      writeAnchorTag);

	  //
	  // Last, handle reference-style shortcuts: [link text]
	  // These must come last in case you've also got [link test][1]
	  // or [link test](/foo)
	  //

	  /*
	   text = text.replace(/
	   (                // wrap whole match in $1
	   \[
	   ([^\[\]]+)       // link text = $2; can't contain '[' or ']'
	   \]
	   )()()()()()      // pad rest of backreferences
	   /g, writeAnchorTag);
	   */
	  text = text.replace(/(\[([^\[\]]+)])()()()()()/g, writeAnchorTag);

	  text = globals.converter._dispatch('anchors.after', text, options, globals);
	  return text;
	});

	showdown.subParser('autoLinks', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('autoLinks.before', text, options, globals);

	  var simpleURLRegex  = /\b(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+)(?=\s|$)(?!["<>])/gi,
	      delimUrlRegex   = /<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)>/gi,
	      simpleMailRegex = /(?:^|[ \n\t])([A-Za-z0-9!#$%&'*+-/=?^_`\{|}~\.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?:$|[ \n\t])/gi,
	      delimMailRegex  = /<(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi;

	  text = text.replace(delimUrlRegex, '<a href=\"$1\">$1</a>');
	  text = text.replace(delimMailRegex, replaceMail);
	  //simpleURLRegex  = /\b(((https?|ftp|dict):\/\/|www\.)[-.+~:?#@!$&'()*,;=[\]\w]+)\b/gi,
	  // Email addresses: <address@domain.foo>

	  if (options.simplifiedAutoLink) {
	    text = text.replace(simpleURLRegex, '<a href=\"$1\">$1</a>');
	    text = text.replace(simpleMailRegex, replaceMail);
	  }

	  function replaceMail(wholeMatch, m1) {
	    var unescapedStr = showdown.subParser('unescapeSpecialChars')(m1);
	    return showdown.subParser('encodeEmailAddress')(unescapedStr);
	  }

	  text = globals.converter._dispatch('autoLinks.after', text, options, globals);

	  return text;
	});

	/**
	 * These are all the transformations that form block-level
	 * tags like paragraphs, headers, and list items.
	 */
	showdown.subParser('blockGamut', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('blockGamut.before', text, options, globals);

	  // we parse blockquotes first so that we can have headings and hrs
	  // inside blockquotes
	  text = showdown.subParser('blockQuotes')(text, options, globals);
	  text = showdown.subParser('headers')(text, options, globals);

	  // Do Horizontal Rules:
	  var key = showdown.subParser('hashBlock')('<hr />', options, globals);
	  text = text.replace(/^[ ]{0,2}([ ]?\*[ ]?){3,}[ \t]*$/gm, key);
	  text = text.replace(/^[ ]{0,2}([ ]?\-[ ]?){3,}[ \t]*$/gm, key);
	  text = text.replace(/^[ ]{0,2}([ ]?_[ ]?){3,}[ \t]*$/gm, key);

	  text = showdown.subParser('lists')(text, options, globals);
	  text = showdown.subParser('codeBlocks')(text, options, globals);
	  text = showdown.subParser('tables')(text, options, globals);

	  // We already ran _HashHTMLBlocks() before, in Markdown(), but that
	  // was to escape raw HTML in the original Markdown source. This time,
	  // we're escaping the markup we've just created, so that we don't wrap
	  // <p> tags around block-level tags.
	  text = showdown.subParser('hashHTMLBlocks')(text, options, globals);
	  text = showdown.subParser('paragraphs')(text, options, globals);

	  text = globals.converter._dispatch('blockGamut.after', text, options, globals);

	  return text;
	});

	showdown.subParser('blockQuotes', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('blockQuotes.before', text, options, globals);
	  /*
	   text = text.replace(/
	   (								// Wrap whole match in $1
	   (
	   ^[ \t]*>[ \t]?			// '>' at the start of a line
	   .+\n					// rest of the first line
	   (.+\n)*					// subsequent consecutive lines
	   \n*						// blanks
	   )+
	   )
	   /gm, function(){...});
	   */

	  text = text.replace(/((^[ \t]{0,3}>[ \t]?.+\n(.+\n)*\n*)+)/gm, function (wholeMatch, m1) {
	    var bq = m1;

	    // attacklab: hack around Konqueror 3.5.4 bug:
	    // "----------bug".replace(/^-/g,"") == "bug"
	    bq = bq.replace(/^[ \t]*>[ \t]?/gm, '~0'); // trim one level of quoting

	    // attacklab: clean up hack
	    bq = bq.replace(/~0/g, '');

	    bq = bq.replace(/^[ \t]+$/gm, ''); // trim whitespace-only lines
	    bq = showdown.subParser('githubCodeBlocks')(bq, options, globals);
	    bq = showdown.subParser('blockGamut')(bq, options, globals); // recurse

	    bq = bq.replace(/(^|\n)/g, '$1  ');
	    // These leading spaces screw with <pre> content, so we need to fix that:
	    bq = bq.replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function (wholeMatch, m1) {
	      var pre = m1;
	      // attacklab: hack around Konqueror 3.5.4 bug:
	      pre = pre.replace(/^  /mg, '~0');
	      pre = pre.replace(/~0/g, '');
	      return pre;
	    });

	    return showdown.subParser('hashBlock')('<blockquote>\n' + bq + '\n</blockquote>', options, globals);
	  });

	  text = globals.converter._dispatch('blockQuotes.after', text, options, globals);
	  return text;
	});

	/**
	 * Process Markdown `<pre><code>` blocks.
	 */
	showdown.subParser('codeBlocks', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('codeBlocks.before', text, options, globals);
	  /*
	   text = text.replace(text,
	   /(?:\n\n|^)
	   (								// $1 = the code block -- one or more lines, starting with a space/tab
	   (?:
	   (?:[ ]{4}|\t)			// Lines must start with a tab or a tab-width of spaces - attacklab: g_tab_width
	   .*\n+
	   )+
	   )
	   (\n*[ ]{0,3}[^ \t\n]|(?=~0))	// attacklab: g_tab_width
	   /g,function(){...});
	   */

	  // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
	  text += '~0';

	  var pattern = /(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=~0))/g;
	  text = text.replace(pattern, function (wholeMatch, m1, m2) {
	    var codeblock = m1,
	        nextChar = m2,
	        end = '\n';

	    codeblock = showdown.subParser('outdent')(codeblock);
	    codeblock = showdown.subParser('encodeCode')(codeblock);
	    codeblock = showdown.subParser('detab')(codeblock);
	    codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
	    codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing newlines

	    if (options.omitExtraWLInCodeBlocks) {
	      end = '';
	    }

	    codeblock = '<pre><code>' + codeblock + end + '</code></pre>';

	    return showdown.subParser('hashBlock')(codeblock, options, globals) + nextChar;
	  });

	  // attacklab: strip sentinel
	  text = text.replace(/~0/, '');

	  text = globals.converter._dispatch('codeBlocks.after', text, options, globals);
	  return text;
	});

	/**
	 *
	 *   *  Backtick quotes are used for <code></code> spans.
	 *
	 *   *  You can use multiple backticks as the delimiters if you want to
	 *     include literal backticks in the code span. So, this input:
	 *
	 *         Just type ``foo `bar` baz`` at the prompt.
	 *
	 *       Will translate to:
	 *
	 *         <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
	 *
	 *    There's no arbitrary limit to the number of backticks you
	 *    can use as delimters. If you need three consecutive backticks
	 *    in your code, use four for delimiters, etc.
	 *
	 *  *  You can use spaces to get literal backticks at the edges:
	 *
	 *         ... type `` `bar` `` ...
	 *
	 *       Turns to:
	 *
	 *         ... type <code>`bar`</code> ...
	 */
	showdown.subParser('codeSpans', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('codeSpans.before', text, options, globals);

	  /*
	   text = text.replace(/
	   (^|[^\\])					// Character before opening ` can't be a backslash
	   (`+)						// $2 = Opening run of `
	   (							// $3 = The code block
	   [^\r]*?
	   [^`]					// attacklab: work around lack of lookbehind
	   )
	   \2							// Matching closer
	   (?!`)
	   /gm, function(){...});
	   */

	  if (typeof(text) === 'undefined') {
	    text = '';
	  }
	  text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm,
	    function (wholeMatch, m1, m2, m3) {
	      var c = m3;
	      c = c.replace(/^([ \t]*)/g, '');	// leading whitespace
	      c = c.replace(/[ \t]*$/g, '');	// trailing whitespace
	      c = showdown.subParser('encodeCode')(c);
	      return m1 + '<code>' + c + '</code>';
	    }
	  );

	  text = globals.converter._dispatch('codeSpans.after', text, options, globals);
	  return text;
	});

	/**
	 * Convert all tabs to spaces
	 */
	showdown.subParser('detab', function (text) {
	  'use strict';

	  // expand first n-1 tabs
	  text = text.replace(/\t(?=\t)/g, '    '); // g_tab_width

	  // replace the nth with two sentinels
	  text = text.replace(/\t/g, '~A~B');

	  // use the sentinel to anchor our regex so it doesn't explode
	  text = text.replace(/~B(.+?)~A/g, function (wholeMatch, m1) {
	    var leadingText = m1,
	        numSpaces = 4 - leadingText.length % 4;  // g_tab_width

	    // there *must* be a better way to do this:
	    for (var i = 0; i < numSpaces; i++) {
	      leadingText += ' ';
	    }

	    return leadingText;
	  });

	  // clean up sentinels
	  text = text.replace(/~A/g, '    ');  // g_tab_width
	  text = text.replace(/~B/g, '');

	  return text;

	});

	/**
	 * Smart processing for ampersands and angle brackets that need to be encoded.
	 */
	showdown.subParser('encodeAmpsAndAngles', function (text) {
	  'use strict';
	  // Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
	  // http://bumppo.net/projects/amputator/
	  text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, '&amp;');

	  // Encode naked <'s
	  text = text.replace(/<(?![a-z\/?\$!])/gi, '&lt;');

	  return text;
	});

	/**
	 * Returns the string, with after processing the following backslash escape sequences.
	 *
	 * attacklab: The polite way to do this is with the new escapeCharacters() function:
	 *
	 *    text = escapeCharacters(text,"\\",true);
	 *    text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
	 *
	 * ...but we're sidestepping its use of the (slow) RegExp constructor
	 * as an optimization for Firefox.  This function gets called a LOT.
	 */
	showdown.subParser('encodeBackslashEscapes', function (text) {
	  'use strict';
	  text = text.replace(/\\(\\)/g, showdown.helper.escapeCharactersCallback);
	  text = text.replace(/\\([`*_{}\[\]()>#+-.!])/g, showdown.helper.escapeCharactersCallback);
	  return text;
	});

	/**
	 * Encode/escape certain characters inside Markdown code runs.
	 * The point is that in code, these characters are literals,
	 * and lose their special Markdown meanings.
	 */
	showdown.subParser('encodeCode', function (text) {
	  'use strict';

	  // Encode all ampersands; HTML entities are not
	  // entities within a Markdown code span.
	  text = text.replace(/&/g, '&amp;');

	  // Do the angle bracket song and dance:
	  text = text.replace(/</g, '&lt;');
	  text = text.replace(/>/g, '&gt;');

	  // Now, escape characters that are magic in Markdown:
	  text = showdown.helper.escapeCharacters(text, '*_{}[]\\', false);

	  // jj the line above breaks this:
	  //---
	  //* Item
	  //   1. Subitem
	  //            special char: *
	  // ---

	  return text;
	});

	/**
	 *  Input: an email address, e.g. "foo@example.com"
	 *
	 *  Output: the email address as a mailto link, with each character
	 *    of the address encoded as either a decimal or hex entity, in
	 *    the hopes of foiling most address harvesting spam bots. E.g.:
	 *
	 *    <a href="&#x6D;&#97;&#105;&#108;&#x74;&#111;:&#102;&#111;&#111;&#64;&#101;
	 *       x&#x61;&#109;&#x70;&#108;&#x65;&#x2E;&#99;&#111;&#109;">&#102;&#111;&#111;
	 *       &#64;&#101;x&#x61;&#109;&#x70;&#108;&#x65;&#x2E;&#99;&#111;&#109;</a>
	 *
	 *  Based on a filter by Matthew Wickline, posted to the BBEdit-Talk
	 *  mailing list: <http://tinyurl.com/yu7ue>
	 *
	 */
	showdown.subParser('encodeEmailAddress', function (addr) {
	  'use strict';

	  var encode = [
	    function (ch) {
	      return '&#' + ch.charCodeAt(0) + ';';
	    },
	    function (ch) {
	      return '&#x' + ch.charCodeAt(0).toString(16) + ';';
	    },
	    function (ch) {
	      return ch;
	    }
	  ];

	  addr = 'mailto:' + addr;

	  addr = addr.replace(/./g, function (ch) {
	    if (ch === '@') {
	      // this *must* be encoded. I insist.
	      ch = encode[Math.floor(Math.random() * 2)](ch);
	    } else if (ch !== ':') {
	      // leave ':' alone (to spot mailto: later)
	      var r = Math.random();
	      // roughly 10% raw, 45% hex, 45% dec
	      ch = (
	        r > 0.9 ? encode[2](ch) : r > 0.45 ? encode[1](ch) : encode[0](ch)
	      );
	    }
	    return ch;
	  });

	  addr = '<a href="' + addr + '">' + addr + '</a>';
	  addr = addr.replace(/">.+:/g, '">'); // strip the mailto: from the visible part

	  return addr;
	});

	/**
	 * Within tags -- meaning between < and > -- encode [\ ` * _] so they
	 * don't conflict with their use in Markdown for code, italics and strong.
	 */
	showdown.subParser('escapeSpecialCharsWithinTagAttributes', function (text) {
	  'use strict';

	  // Build a regex to find HTML tags and comments.  See Friedl's
	  // "Mastering Regular Expressions", 2nd Ed., pp. 200-201.
	  var regex = /(<[a-z\/!$]("[^"]*"|'[^']*'|[^'">])*>|<!(--.*?--\s*)+>)/gi;

	  text = text.replace(regex, function (wholeMatch) {
	    var tag = wholeMatch.replace(/(.)<\/?code>(?=.)/g, '$1`');
	    tag = showdown.helper.escapeCharacters(tag, '\\`*_', false);
	    return tag;
	  });

	  return text;
	});

	/**
	 * Handle github codeblocks prior to running HashHTML so that
	 * HTML contained within the codeblock gets escaped properly
	 * Example:
	 * ```ruby
	 *     def hello_world(x)
	 *       puts "Hello, #{x}"
	 *     end
	 * ```
	 */
	showdown.subParser('githubCodeBlocks', function (text, options, globals) {
	  'use strict';

	  // early exit if option is not enabled
	  if (!options.ghCodeBlocks) {
	    return text;
	  }

	  text = globals.converter._dispatch('githubCodeBlocks.before', text, options, globals);

	  text += '~0';

	  text = text.replace(/(?:^|\n)```(.*)\n([\s\S]*?)\n```/g, function (wholeMatch, language, codeblock) {
	    var end = (options.omitExtraWLInCodeBlocks) ? '' : '\n';

	    // First parse the github code block
	    codeblock = showdown.subParser('encodeCode')(codeblock);
	    codeblock = showdown.subParser('detab')(codeblock);
	    codeblock = codeblock.replace(/^\n+/g, ''); // trim leading newlines
	    codeblock = codeblock.replace(/\n+$/g, ''); // trim trailing whitespace

	    codeblock = '<pre><code' + (language ? ' class="' + language + ' language-' + language + '"' : '') + '>' + codeblock + end + '</code></pre>';

	    codeblock = showdown.subParser('hashBlock')(codeblock, options, globals);

	    // Since GHCodeblocks can be false positives, we need to
	    // store the primitive text and the parsed text in a global var,
	    // and then return a token
	    return '\n\n~G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: codeblock}) - 1) + 'G\n\n';
	  });

	  // attacklab: strip sentinel
	  text = text.replace(/~0/, '');

	  return globals.converter._dispatch('githubCodeBlocks.after', text, options, globals);
	});

	showdown.subParser('hashBlock', function (text, options, globals) {
	  'use strict';
	  text = text.replace(/(^\n+|\n+$)/g, '');
	  return '\n\n~K' + (globals.gHtmlBlocks.push(text) - 1) + 'K\n\n';
	});

	showdown.subParser('hashElement', function (text, options, globals) {
	  'use strict';

	  return function (wholeMatch, m1) {
	    var blockText = m1;

	    // Undo double lines
	    blockText = blockText.replace(/\n\n/g, '\n');
	    blockText = blockText.replace(/^\n/, '');

	    // strip trailing blank lines
	    blockText = blockText.replace(/\n+$/g, '');

	    // Replace the element text with a marker ("~KxK" where x is its key)
	    blockText = '\n\n~K' + (globals.gHtmlBlocks.push(blockText) - 1) + 'K\n\n';

	    return blockText;
	  };
	});

	showdown.subParser('hashHTMLBlocks', function (text, options, globals) {
	  'use strict';

	  var blockTags = [
	      'pre',
	      'div',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'blockquote',
	      'table',
	      'dl',
	      'ol',
	      'ul',
	      'script',
	      'noscript',
	      'form',
	      'fieldset',
	      'iframe',
	      'math',
	      'style',
	      'section',
	      'header',
	      'footer',
	      'nav',
	      'article',
	      'aside',
	      'address',
	      'audio',
	      'canvas',
	      'figure',
	      'hgroup',
	      'output',
	      'video',
	      'p'
	    ],
	    repFunc = function (wholeMatch, match, left, right) {
	      var txt = wholeMatch;
	      // check if this html element is marked as markdown
	      // if so, it's contents should be parsed as markdown
	      if (left.search(/\bmarkdown\b/) !== -1) {
	        txt = left + globals.converter.makeHtml(match) + right;
	      }
	      return '\n\n~K' + (globals.gHtmlBlocks.push(txt) - 1) + 'K\n\n';
	    };

	  for (var i = 0; i < blockTags.length; ++i) {
	    text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '^(?: |\\t){0,3}<' + blockTags[i] + '\\b[^>]*>', '</' + blockTags[i] + '>', 'gim');
	  }

	  // HR SPECIAL CASE
	  text = text.replace(/(\n[ ]{0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g,
	    showdown.subParser('hashElement')(text, options, globals));

	  // Special case for standalone HTML comments:
	  text = text.replace(/(<!(--[^\r]*?--\s*)+>[ \t]*(?=\n{2,}))/g,
	    showdown.subParser('hashElement')(text, options, globals));

	  // PHP and ASP-style processor instructions (<?...?> and <%...%>)
	  text = text.replace(/(?:\n\n)([ ]{0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g,
	    showdown.subParser('hashElement')(text, options, globals));

	  return text;
	});

	/**
	 * Hash span elements that should not be parsed as markdown
	 */
	showdown.subParser('hashHTMLSpans', function (text, config, globals) {
	  'use strict';

	  var matches = showdown.helper.matchRecursiveRegExp(text, '<code\\b[^>]*>', '</code>', 'gi');

	  for (var i = 0; i < matches.length; ++i) {
	    text = text.replace(matches[i][0], '~L' + (globals.gHtmlSpans.push(matches[i][0]) - 1) + 'L');
	  }
	  return text;
	});

	/**
	 * Unhash HTML spans
	 */
	showdown.subParser('unhashHTMLSpans', function (text, config, globals) {
	  'use strict';

	  for (var i = 0; i < globals.gHtmlSpans.length; ++i) {
	    text = text.replace('~L' + i + 'L', globals.gHtmlSpans[i]);
	  }

	  return text;
	});

	/**
	 * Hash span elements that should not be parsed as markdown
	 */
	showdown.subParser('hashPreCodeTags', function (text, config, globals) {
	  'use strict';

	  var repFunc = function (wholeMatch, match, left, right) {
	    // encode html entities
	    var codeblock = left + showdown.subParser('encodeCode')(match) + right;
	    return '\n\n~G' + (globals.ghCodeBlocks.push({text: wholeMatch, codeblock: codeblock}) - 1) + 'G\n\n';
	  };

	  text = showdown.helper.replaceRecursiveRegExp(text, repFunc, '^(?: |\\t){0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>', '^(?: |\\t){0,3}</code>\\s*</pre>', 'gim');
	  return text;
	});

	showdown.subParser('headers', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('headers.before', text, options, globals);

	  var prefixHeader = options.prefixHeaderId,
	      headerLevelStart = (isNaN(parseInt(options.headerLevelStart))) ? 1 : parseInt(options.headerLevelStart),

	  // Set text-style headers:
	  //	Header 1
	  //	========
	  //
	  //	Header 2
	  //	--------
	  //
	      setextRegexH1 = (options.smoothLivePreview) ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm,
	      setextRegexH2 = (options.smoothLivePreview) ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;

	  text = text.replace(setextRegexH1, function (wholeMatch, m1) {

	    var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
	        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m1) + '"',
	        hLevel = headerLevelStart,
	        hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
	    return showdown.subParser('hashBlock')(hashBlock, options, globals);
	  });

	  text = text.replace(setextRegexH2, function (matchFound, m1) {
	    var spanGamut = showdown.subParser('spanGamut')(m1, options, globals),
	        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m1) + '"',
	        hLevel = headerLevelStart + 1,
	      hashBlock = '<h' + hLevel + hID + '>' + spanGamut + '</h' + hLevel + '>';
	    return showdown.subParser('hashBlock')(hashBlock, options, globals);
	  });

	  // atx-style headers:
	  //  # Header 1
	  //  ## Header 2
	  //  ## Header 2 with closing hashes ##
	  //  ...
	  //  ###### Header 6
	  //
	  text = text.replace(/^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm, function (wholeMatch, m1, m2) {
	    var span = showdown.subParser('spanGamut')(m2, options, globals),
	        hID = (options.noHeaderId) ? '' : ' id="' + headerId(m2) + '"',
	        hLevel = headerLevelStart - 1 + m1.length,
	        header = '<h' + hLevel + hID + '>' + span + '</h' + hLevel + '>';

	    return showdown.subParser('hashBlock')(header, options, globals);
	  });

	  function headerId(m) {
	    var title, escapedId = m.replace(/[^\w]/g, '').toLowerCase();

	    if (globals.hashLinkCounts[escapedId]) {
	      title = escapedId + '-' + (globals.hashLinkCounts[escapedId]++);
	    } else {
	      title = escapedId;
	      globals.hashLinkCounts[escapedId] = 1;
	    }

	    // Prefix id to prevent causing inadvertent pre-existing style matches.
	    if (prefixHeader === true) {
	      prefixHeader = 'section';
	    }

	    if (showdown.helper.isString(prefixHeader)) {
	      return prefixHeader + title;
	    }
	    return title;
	  }

	  text = globals.converter._dispatch('headers.after', text, options, globals);
	  return text;
	});

	/**
	 * Turn Markdown image shortcuts into <img> tags.
	 */
	showdown.subParser('images', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('images.before', text, options, globals);

	  var inlineRegExp    = /!\[(.*?)]\s?\([ \t]*()<?(\S+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(['"])(.*?)\6[ \t]*)?\)/g,
	      referenceRegExp = /!\[([^\]]*?)] ?(?:\n *)?\[(.*?)]()()()()()/g;

	  function writeImageTag (wholeMatch, altText, linkId, url, width, height, m5, title) {

	    var gUrls   = globals.gUrls,
	        gTitles = globals.gTitles,
	        gDims   = globals.gDimensions;

	    linkId = linkId.toLowerCase();

	    if (!title) {
	      title = '';
	    }

	    if (url === '' || url === null) {
	      if (linkId === '' || linkId === null) {
	        // lower-case and turn embedded newlines into spaces
	        linkId = altText.toLowerCase().replace(/ ?\n/g, ' ');
	      }
	      url = '#' + linkId;

	      if (!showdown.helper.isUndefined(gUrls[linkId])) {
	        url = gUrls[linkId];
	        if (!showdown.helper.isUndefined(gTitles[linkId])) {
	          title = gTitles[linkId];
	        }
	        if (!showdown.helper.isUndefined(gDims[linkId])) {
	          width = gDims[linkId].width;
	          height = gDims[linkId].height;
	        }
	      } else {
	        return wholeMatch;
	      }
	    }

	    altText = altText.replace(/"/g, '&quot;');
	    altText = showdown.helper.escapeCharacters(altText, '*_', false);
	    url = showdown.helper.escapeCharacters(url, '*_', false);
	    var result = '<img src="' + url + '" alt="' + altText + '"';

	    if (title) {
	      title = title.replace(/"/g, '&quot;');
	      title = showdown.helper.escapeCharacters(title, '*_', false);
	      result += ' title="' + title + '"';
	    }

	    if (width && height) {
	      width  = (width === '*') ? 'auto' : width;
	      height = (height === '*') ? 'auto' : height;

	      result += ' width="' + width + '"';
	      result += ' height="' + height + '"';
	    }

	    result += ' />';

	    return result;
	  }

	  // First, handle reference-style labeled images: ![alt text][id]
	  text = text.replace(referenceRegExp, writeImageTag);

	  // Next, handle inline images:  ![alt text](url =<width>x<height> "optional title")
	  text = text.replace(inlineRegExp, writeImageTag);

	  text = globals.converter._dispatch('images.after', text, options, globals);
	  return text;
	});

	showdown.subParser('italicsAndBold', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('italicsAndBold.before', text, options, globals);

	  if (options.literalMidWordUnderscores) {
	    //underscores
	    // Since we are consuming a \s character, we need to add it
	    text = text.replace(/(^|\s|>|\b)__(?=\S)([^]+?)__(?=\b|<|\s|$)/gm, '$1<strong>$2</strong>');
	    text = text.replace(/(^|\s|>|\b)_(?=\S)([^]+?)_(?=\b|<|\s|$)/gm, '$1<em>$2</em>');
	    //asterisks
	    text = text.replace(/(\*\*)(?=\S)([^\r]*?\S[*]*)\1/g, '<strong>$2</strong>');
	    text = text.replace(/(\*)(?=\S)([^\r]*?\S)\1/g, '<em>$2</em>');

	  } else {
	    // <strong> must go first:
	    text = text.replace(/(\*\*|__)(?=\S)([^\r]*?\S[*_]*)\1/g, '<strong>$2</strong>');
	    text = text.replace(/(\*|_)(?=\S)([^\r]*?\S)\1/g, '<em>$2</em>');
	  }

	  text = globals.converter._dispatch('italicsAndBold.after', text, options, globals);
	  return text;
	});

	/**
	 * Form HTML ordered (numbered) and unordered (bulleted) lists.
	 */
	showdown.subParser('lists', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('lists.before', text, options, globals);
	  /**
	   * Process the contents of a single ordered or unordered list, splitting it
	   * into individual list items.
	   * @param {string} listStr
	   * @param {boolean} trimTrailing
	   * @returns {string}
	   */
	  function processListItems (listStr, trimTrailing) {
	    // The $g_list_level global keeps track of when we're inside a list.
	    // Each time we enter a list, we increment it; when we leave a list,
	    // we decrement. If it's zero, we're not in a list anymore.
	    //
	    // We do this because when we're not inside a list, we want to treat
	    // something like this:
	    //
	    //    I recommend upgrading to version
	    //    8. Oops, now this line is treated
	    //    as a sub-list.
	    //
	    // As a single paragraph, despite the fact that the second line starts
	    // with a digit-period-space sequence.
	    //
	    // Whereas when we're inside a list (or sub-list), that line will be
	    // treated as the start of a sub-list. What a kludge, huh? This is
	    // an aspect of Markdown's syntax that's hard to parse perfectly
	    // without resorting to mind-reading. Perhaps the solution is to
	    // change the syntax rules such that sub-lists must start with a
	    // starting cardinal number; e.g. "1." or "a.".
	    globals.gListLevel++;

	    // trim trailing blank lines:
	    listStr = listStr.replace(/\n{2,}$/, '\n');

	    // attacklab: add sentinel to emulate \z
	    listStr += '~0';

	    var rgx = /(\n)?(^[ \t]*)([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(~0|\2([*+-]|\d+[.])[ \t]+))/gm,
	        isParagraphed = (/\n[ \t]*\n(?!~0)/.test(listStr));

	    listStr = listStr.replace(rgx, function (wholeMatch, m1, m2, m3, m4, taskbtn, checked) {
	      checked = (checked && checked.trim() !== '');
	      var item = showdown.subParser('outdent')(m4, options, globals),
	          bulletStyle = '';

	      // Support for github tasklists
	      if (taskbtn && options.tasklists) {
	        bulletStyle = ' class="task-list-item" style="list-style-type: none;"';
	        item = item.replace(/^[ \t]*\[(x|X| )?]/m, function () {
	          var otp = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
	          if (checked) {
	            otp += ' checked';
	          }
	          otp += '>';
	          return otp;
	        });
	      }
	      // m1 - Leading line or
	      // Has a double return (multi paragraph) or
	      // Has sublist
	      if (m1 || (item.search(/\n{2,}/) > -1)) {
	        item = showdown.subParser('githubCodeBlocks')(item, options, globals);
	        item = showdown.subParser('blockGamut')(item, options, globals);
	      } else {
	        // Recursion for sub-lists:
	        item = showdown.subParser('lists')(item, options, globals);
	        item = item.replace(/\n$/, ''); // chomp(item)
	        if (isParagraphed) {
	          item = showdown.subParser('paragraphs')(item, options, globals);
	        } else {
	          item = showdown.subParser('spanGamut')(item, options, globals);
	        }
	      }
	      item =  '\n<li' + bulletStyle + '>' + item + '</li>\n';
	      return item;
	    });

	    // attacklab: strip sentinel
	    listStr = listStr.replace(/~0/g, '');

	    globals.gListLevel--;

	    if (trimTrailing) {
	      listStr = listStr.replace(/\s+$/, '');
	    }

	    return listStr;
	  }

	  /**
	   * Check and parse consecutive lists (better fix for issue #142)
	   * @param {string} list
	   * @param {string} listType
	   * @param {boolean} trimTrailing
	   * @returns {string}
	   */
	  function parseConsecutiveLists(list, listType, trimTrailing) {
	    // check if we caught 2 or more consecutive lists by mistake
	    // we use the counterRgx, meaning if listType is UL we look for UL and vice versa
	    var counterRxg = (listType === 'ul') ? /^ {0,2}\d+\.[ \t]/gm : /^ {0,2}[*+-][ \t]/gm,
	      subLists = [],
	      result = '';

	    if (list.search(counterRxg) !== -1) {
	      (function parseCL(txt) {
	        var pos = txt.search(counterRxg);
	        if (pos !== -1) {
	          // slice
	          result += '\n\n<' + listType + '>' + processListItems(txt.slice(0, pos), !!trimTrailing) + '</' + listType + '>\n\n';

	          // invert counterType and listType
	          listType = (listType === 'ul') ? 'ol' : 'ul';
	          counterRxg = (listType === 'ul') ? /^ {0,2}\d+\.[ \t]/gm : /^ {0,2}[*+-][ \t]/gm;

	          //recurse
	          parseCL(txt.slice(pos));
	        } else {
	          result += '\n\n<' + listType + '>' + processListItems(txt, !!trimTrailing) + '</' + listType + '>\n\n';
	        }
	      })(list);
	      for (var i = 0; i < subLists.length; ++i) {

	      }
	    } else {
	      result = '\n\n<' + listType + '>' + processListItems(list, !!trimTrailing) + '</' + listType + '>\n\n';
	    }

	    return result;
	  }

	  // attacklab: add sentinel to hack around khtml/safari bug:
	  // http://bugs.webkit.org/show_bug.cgi?id=11231
	  text += '~0';

	  // Re-usable pattern to match any entire ul or ol list:
	  var wholeList = /^(([ ]{0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(~0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm;

	  if (globals.gListLevel) {
	    text = text.replace(wholeList, function (wholeMatch, list, m2) {
	      var listType = (m2.search(/[*+-]/g) > -1) ? 'ul' : 'ol';
	      return parseConsecutiveLists(list, listType, true);
	    });
	  } else {
	    wholeList = /(\n\n|^\n?)(([ ]{0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(~0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm;
	    //wholeList = /(\n\n|^\n?)( {0,3}([*+-]|\d+\.)[ \t]+[\s\S]+?)(?=(~0)|(\n\n(?!\t| {2,}| {0,3}([*+-]|\d+\.)[ \t])))/g;
	    text = text.replace(wholeList, function (wholeMatch, m1, list, m3) {

	      var listType = (m3.search(/[*+-]/g) > -1) ? 'ul' : 'ol';
	      return parseConsecutiveLists(list, listType);
	    });
	  }

	  // attacklab: strip sentinel
	  text = text.replace(/~0/, '');

	  text = globals.converter._dispatch('lists.after', text, options, globals);
	  return text;
	});

	/**
	 * Remove one level of line-leading tabs or spaces
	 */
	showdown.subParser('outdent', function (text) {
	  'use strict';

	  // attacklab: hack around Konqueror 3.5.4 bug:
	  // "----------bug".replace(/^-/g,"") == "bug"
	  text = text.replace(/^(\t|[ ]{1,4})/gm, '~0'); // attacklab: g_tab_width

	  // attacklab: clean up hack
	  text = text.replace(/~0/g, '');

	  return text;
	});

	/**
	 *
	 */
	showdown.subParser('paragraphs', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('paragraphs.before', text, options, globals);
	  // Strip leading and trailing lines:
	  text = text.replace(/^\n+/g, '');
	  text = text.replace(/\n+$/g, '');

	  var grafs = text.split(/\n{2,}/g),
	      grafsOut = [],
	      end = grafs.length; // Wrap <p> tags

	  for (var i = 0; i < end; i++) {
	    var str = grafs[i];
	    // if this is an HTML marker, copy it
	    if (str.search(/~(K|G)(\d+)\1/g) >= 0) {
	      grafsOut.push(str);
	    } else {
	      str = showdown.subParser('spanGamut')(str, options, globals);
	      str = str.replace(/^([ \t]*)/g, '<p>');
	      str += '</p>';
	      grafsOut.push(str);
	    }
	  }

	  /** Unhashify HTML blocks */
	  end = grafsOut.length;
	  for (i = 0; i < end; i++) {
	    var blockText = '',
	        grafsOutIt = grafsOut[i],
	        codeFlag = false;
	    // if this is a marker for an html block...
	    while (grafsOutIt.search(/~(K|G)(\d+)\1/) >= 0) {
	      var delim = RegExp.$1,
	          num   = RegExp.$2;

	      if (delim === 'K') {
	        blockText = globals.gHtmlBlocks[num];
	      } else {
	        // we need to check if ghBlock is a false positive
	        if (codeFlag) {
	          // use encoded version of all text
	          blockText = showdown.subParser('encodeCode')(globals.ghCodeBlocks[num].text);
	        } else {
	          blockText = globals.ghCodeBlocks[num].codeblock;
	        }
	      }
	      blockText = blockText.replace(/\$/g, '$$$$'); // Escape any dollar signs

	      grafsOutIt = grafsOutIt.replace(/(\n\n)?~(K|G)\d+\2(\n\n)?/, blockText);
	      // Check if grafsOutIt is a pre->code
	      if (/^<pre\b[^>]*>\s*<code\b[^>]*>/.test(grafsOutIt)) {
	        codeFlag = true;
	      }
	    }
	    grafsOut[i] = grafsOutIt;
	  }
	  text = grafsOut.join('\n\n');
	  // Strip leading and trailing lines:
	  text = text.replace(/^\n+/g, '');
	  text = text.replace(/\n+$/g, '');
	  return globals.converter._dispatch('paragraphs.after', text, options, globals);
	});

	/**
	 * Run extension
	 */
	showdown.subParser('runExtension', function (ext, text, options, globals) {
	  'use strict';

	  if (ext.filter) {
	    text = ext.filter(text, globals.converter, options);

	  } else if (ext.regex) {
	    var re = ext.regex;
	    if (!re instanceof RegExp) {
	      re = new RegExp(re, 'g');
	    }
	    text = text.replace(re, ext.replace);
	  }

	  return text;
	});

	/**
	 * These are all the transformations that occur *within* block-level
	 * tags like paragraphs, headers, and list items.
	 */
	showdown.subParser('spanGamut', function (text, options, globals) {
	  'use strict';

	  text = globals.converter._dispatch('spanGamut.before', text, options, globals);
	  text = showdown.subParser('codeSpans')(text, options, globals);
	  text = showdown.subParser('escapeSpecialCharsWithinTagAttributes')(text, options, globals);
	  text = showdown.subParser('encodeBackslashEscapes')(text, options, globals);

	  // Process anchor and image tags. Images must come first,
	  // because ![foo][f] looks like an anchor.
	  text = showdown.subParser('images')(text, options, globals);
	  text = showdown.subParser('anchors')(text, options, globals);

	  // Make links out of things like `<http://example.com/>`
	  // Must come after _DoAnchors(), because you can use < and >
	  // delimiters in inline links like [this](<url>).
	  text = showdown.subParser('autoLinks')(text, options, globals);
	  text = showdown.subParser('encodeAmpsAndAngles')(text, options, globals);
	  text = showdown.subParser('italicsAndBold')(text, options, globals);
	  text = showdown.subParser('strikethrough')(text, options, globals);

	  // Do hard breaks:
	  text = text.replace(/  +\n/g, ' <br />\n');

	  text = globals.converter._dispatch('spanGamut.after', text, options, globals);
	  return text;
	});

	showdown.subParser('strikethrough', function (text, options, globals) {
	  'use strict';

	  if (options.strikethrough) {
	    text = globals.converter._dispatch('strikethrough.before', text, options, globals);
	    text = text.replace(/(?:~T){2}([\s\S]+?)(?:~T){2}/g, '<del>$1</del>');
	    text = globals.converter._dispatch('strikethrough.after', text, options, globals);
	  }

	  return text;
	});

	/**
	 * Strip any lines consisting only of spaces and tabs.
	 * This makes subsequent regexs easier to write, because we can
	 * match consecutive blank lines with /\n+/ instead of something
	 * contorted like /[ \t]*\n+/
	 */
	showdown.subParser('stripBlankLines', function (text) {
	  'use strict';
	  return text.replace(/^[ \t]+$/mg, '');
	});

	/**
	 * Strips link definitions from text, stores the URLs and titles in
	 * hash references.
	 * Link defs are in the form: ^[id]: url "optional title"
	 *
	 * ^[ ]{0,3}\[(.+)\]: // id = $1  attacklab: g_tab_width - 1
	 * [ \t]*
	 * \n?                  // maybe *one* newline
	 * [ \t]*
	 * <?(\S+?)>?          // url = $2
	 * [ \t]*
	 * \n?                // maybe one newline
	 * [ \t]*
	 * (?:
	 * (\n*)              // any lines skipped = $3 attacklab: lookbehind removed
	 * ["(]
	 * (.+?)              // title = $4
	 * [")]
	 * [ \t]*
	 * )?                 // title is optional
	 * (?:\n+|$)
	 * /gm,
	 * function(){...});
	 *
	 */
	showdown.subParser('stripLinkDefinitions', function (text, options, globals) {
	  'use strict';

	  var regex = /^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?(\S+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=~0))/gm;

	  // attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
	  text += '~0';

	  text = text.replace(regex, function (wholeMatch, linkId, url, width, height, blankLines, title) {
	    linkId = linkId.toLowerCase();
	    globals.gUrls[linkId] = showdown.subParser('encodeAmpsAndAngles')(url);  // Link IDs are case-insensitive

	    if (blankLines) {
	      // Oops, found blank lines, so it's not a title.
	      // Put back the parenthetical statement we stole.
	      return blankLines + title;

	    } else {
	      if (title) {
	        globals.gTitles[linkId] = title.replace(/"|'/g, '&quot;');
	      }
	      if (options.parseImgDimensions && width && height) {
	        globals.gDimensions[linkId] = {
	          width:  width,
	          height: height
	        };
	      }
	    }
	    // Completely remove the definition from the text
	    return '';
	  });

	  // attacklab: strip sentinel
	  text = text.replace(/~0/, '');

	  return text;
	});

	showdown.subParser('tables', function (text, options, globals) {
	  'use strict';

	  if (!options.tables) {
	    return text;
	  }

	  var tableRgx = /^[ \t]{0,3}\|?.+\|.+\n[ \t]{0,3}\|?[ \t]*:?[ \t]*(?:-|=){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:-|=){2,}[^]+?(?:\n\n|~0)/gm;

	  function parseStyles(sLine) {
	    if (/^:[ \t]*--*$/.test(sLine)) {
	      return ' style="text-align:left;"';
	    } else if (/^--*[ \t]*:[ \t]*$/.test(sLine)) {
	      return ' style="text-align:right;"';
	    } else if (/^:[ \t]*--*[ \t]*:$/.test(sLine)) {
	      return ' style="text-align:center;"';
	    } else {
	      return '';
	    }
	  }

	  function parseHeaders(header, style) {
	    var id = '';
	    header = header.trim();
	    if (options.tableHeaderId) {
	      id = ' id="' + header.replace(/ /g, '_').toLowerCase() + '"';
	    }
	    header = showdown.subParser('spanGamut')(header, options, globals);

	    return '<th' + id + style + '>' + header + '</th>\n';
	  }

	  function parseCells(cell, style) {
	    var subText = showdown.subParser('spanGamut')(cell, options, globals);
	    return '<td' + style + '>' + subText + '</td>\n';
	  }

	  function buildTable(headers, cells) {
	    var tb = '<table>\n<thead>\n<tr>\n',
	        tblLgn = headers.length;

	    for (var i = 0; i < tblLgn; ++i) {
	      tb += headers[i];
	    }
	    tb += '</tr>\n</thead>\n<tbody>\n';

	    for (i = 0; i < cells.length; ++i) {
	      tb += '<tr>\n';
	      for (var ii = 0; ii < tblLgn; ++ii) {
	        tb += cells[i][ii];
	      }
	      tb += '</tr>\n';
	    }
	    tb += '</tbody>\n</table>\n';
	    return tb;
	  }

	  text = globals.converter._dispatch('tables.before', text, options, globals);

	  text = text.replace(tableRgx, function (rawTable) {

	    var i, tableLines = rawTable.split('\n');

	    // strip wrong first and last column if wrapped tables are used
	    for (i = 0; i < tableLines.length; ++i) {
	      if (/^[ \t]{0,3}\|/.test(tableLines[i])) {
	        tableLines[i] = tableLines[i].replace(/^[ \t]{0,3}\|/, '');
	      }
	      if (/\|[ \t]*$/.test(tableLines[i])) {
	        tableLines[i] = tableLines[i].replace(/\|[ \t]*$/, '');
	      }
	    }

	    var rawHeaders = tableLines[0].split('|').map(function (s) { return s.trim();}),
	        rawStyles = tableLines[1].split('|').map(function (s) { return s.trim();}),
	        rawCells = [],
	        headers = [],
	        styles = [],
	        cells = [];

	    tableLines.shift();
	    tableLines.shift();

	    for (i = 0; i < tableLines.length; ++i) {
	      if (tableLines[i].trim() === '') {
	        continue;
	      }
	      rawCells.push(
	        tableLines[i]
	          .split('|')
	          .map(function (s) {
	            return s.trim();
	          })
	      );
	    }

	    if (rawHeaders.length < rawStyles.length) {
	      return rawTable;
	    }

	    for (i = 0; i < rawStyles.length; ++i) {
	      styles.push(parseStyles(rawStyles[i]));
	    }

	    for (i = 0; i < rawHeaders.length; ++i) {
	      if (showdown.helper.isUndefined(styles[i])) {
	        styles[i] = '';
	      }
	      headers.push(parseHeaders(rawHeaders[i], styles[i]));
	    }

	    for (i = 0; i < rawCells.length; ++i) {
	      var row = [];
	      for (var ii = 0; ii < headers.length; ++ii) {
	        if (showdown.helper.isUndefined(rawCells[i][ii])) {

	        }
	        row.push(parseCells(rawCells[i][ii], styles[ii]));
	      }
	      cells.push(row);
	    }

	    return buildTable(headers, cells);
	  });

	  text = globals.converter._dispatch('tables.after', text, options, globals);

	  return text;
	});

	/**
	 * Swap back in all the special characters we've hidden.
	 */
	showdown.subParser('unescapeSpecialChars', function (text) {
	  'use strict';

	  text = text.replace(/~E(\d+)E/g, function (wholeMatch, m1) {
	    var charCodeToReplace = parseInt(m1);
	    return String.fromCharCode(charCodeToReplace);
	  });
	  return text;
	});

	var root = this;

	// CommonJS/nodeJS Loader
	if (typeof module !== 'undefined' && module.exports) {
	  module.exports = showdown;

	// AMD Loader
	} else if (true) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    'use strict';
	    return showdown;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

	// Regular Browser loader
	} else {
	  root.showdown = showdown;
	}
	}).call(this);

	//# sourceMappingURL=showdown.js.map


/***/ },
/* 283 */
/***/ function(module, exports) {

	/*
	Copyright 2012 Igor Vaynberg

	Version: 3.4.5 Timestamp: Mon Nov  4 08:22:42 PST 2013

	This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
	General Public License version 2 (the "GPL License"). You may choose either license to govern your
	use of this software only upon the condition that you accept all of the terms of either the Apache
	License or the GPL License.

	You may obtain a copy of the Apache License and the GPL License at:

	    http://www.apache.org/licenses/LICENSE-2.0
	    http://www.gnu.org/licenses/gpl-2.0.html

	Unless required by applicable law or agreed to in writing, software distributed under the
	Apache License or the GPL Licesnse is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
	the specific language governing permissions and limitations under the Apache License and the GPL License.
	*/
	module.exports = function(jQuery) {
	    
	(function ($) {
	    if(typeof $.fn.each2 == "undefined") {
	        $.extend($.fn, {
	            /*
	            * 4-10 times faster .each replacement
	            * use it carefully, as it overrides jQuery context of element on each iteration
	            */
	            each2 : function (c) {
	                var j = $([0]), i = -1, l = this.length;
	                while (
	                    ++i < l
	                    && (j.context = j[0] = this[i])
	                    && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
	                );
	                return this;
	            }
	        });
	    }
	})(jQuery);

	(function ($, undefined) {
	    "use strict";
	    /*global document, window, jQuery, console */

	    if (window.Select2 !== undefined) {
	        return;
	    }

	    var KEY, AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
	        lastMousePosition={x:0,y:0}, $document, scrollBarDimensions,

	    KEY = {
	        TAB: 9,
	        ENTER: 13,
	        ESC: 27,
	        SPACE: 32,
	        LEFT: 37,
	        UP: 38,
	        RIGHT: 39,
	        DOWN: 40,
	        SHIFT: 16,
	        CTRL: 17,
	        ALT: 18,
	        PAGE_UP: 33,
	        PAGE_DOWN: 34,
	        HOME: 36,
	        END: 35,
	        BACKSPACE: 8,
	        DELETE: 46,
	        isArrow: function (k) {
	            k = k.which ? k.which : k;
	            switch (k) {
	            case KEY.LEFT:
	            case KEY.RIGHT:
	            case KEY.UP:
	            case KEY.DOWN:
	                return true;
	            }
	            return false;
	        },
	        isControl: function (e) {
	            var k = e.which;
	            switch (k) {
	            case KEY.SHIFT:
	            case KEY.CTRL:
	            case KEY.ALT:
	                return true;
	            }

	            if (e.metaKey) return true;

	            return false;
	        },
	        isFunctionKey: function (k) {
	            k = k.which ? k.which : k;
	            return k >= 112 && k <= 123;
	        }
	    },
	    MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",

	    DIACRITICS = {"\u24B6":"A","\uFF21":"A","\u00C0":"A","\u00C1":"A","\u00C2":"A","\u1EA6":"A","\u1EA4":"A","\u1EAA":"A","\u1EA8":"A","\u00C3":"A","\u0100":"A","\u0102":"A","\u1EB0":"A","\u1EAE":"A","\u1EB4":"A","\u1EB2":"A","\u0226":"A","\u01E0":"A","\u00C4":"A","\u01DE":"A","\u1EA2":"A","\u00C5":"A","\u01FA":"A","\u01CD":"A","\u0200":"A","\u0202":"A","\u1EA0":"A","\u1EAC":"A","\u1EB6":"A","\u1E00":"A","\u0104":"A","\u023A":"A","\u2C6F":"A","\uA732":"AA","\u00C6":"AE","\u01FC":"AE","\u01E2":"AE","\uA734":"AO","\uA736":"AU","\uA738":"AV","\uA73A":"AV","\uA73C":"AY","\u24B7":"B","\uFF22":"B","\u1E02":"B","\u1E04":"B","\u1E06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24B8":"C","\uFF23":"C","\u0106":"C","\u0108":"C","\u010A":"C","\u010C":"C","\u00C7":"C","\u1E08":"C","\u0187":"C","\u023B":"C","\uA73E":"C","\u24B9":"D","\uFF24":"D","\u1E0A":"D","\u010E":"D","\u1E0C":"D","\u1E10":"D","\u1E12":"D","\u1E0E":"D","\u0110":"D","\u018B":"D","\u018A":"D","\u0189":"D","\uA779":"D","\u01F1":"DZ","\u01C4":"DZ","\u01F2":"Dz","\u01C5":"Dz","\u24BA":"E","\uFF25":"E","\u00C8":"E","\u00C9":"E","\u00CA":"E","\u1EC0":"E","\u1EBE":"E","\u1EC4":"E","\u1EC2":"E","\u1EBC":"E","\u0112":"E","\u1E14":"E","\u1E16":"E","\u0114":"E","\u0116":"E","\u00CB":"E","\u1EBA":"E","\u011A":"E","\u0204":"E","\u0206":"E","\u1EB8":"E","\u1EC6":"E","\u0228":"E","\u1E1C":"E","\u0118":"E","\u1E18":"E","\u1E1A":"E","\u0190":"E","\u018E":"E","\u24BB":"F","\uFF26":"F","\u1E1E":"F","\u0191":"F","\uA77B":"F","\u24BC":"G","\uFF27":"G","\u01F4":"G","\u011C":"G","\u1E20":"G","\u011E":"G","\u0120":"G","\u01E6":"G","\u0122":"G","\u01E4":"G","\u0193":"G","\uA7A0":"G","\uA77D":"G","\uA77E":"G","\u24BD":"H","\uFF28":"H","\u0124":"H","\u1E22":"H","\u1E26":"H","\u021E":"H","\u1E24":"H","\u1E28":"H","\u1E2A":"H","\u0126":"H","\u2C67":"H","\u2C75":"H","\uA78D":"H","\u24BE":"I","\uFF29":"I","\u00CC":"I","\u00CD":"I","\u00CE":"I","\u0128":"I","\u012A":"I","\u012C":"I","\u0130":"I","\u00CF":"I","\u1E2E":"I","\u1EC8":"I","\u01CF":"I","\u0208":"I","\u020A":"I","\u1ECA":"I","\u012E":"I","\u1E2C":"I","\u0197":"I","\u24BF":"J","\uFF2A":"J","\u0134":"J","\u0248":"J","\u24C0":"K","\uFF2B":"K","\u1E30":"K","\u01E8":"K","\u1E32":"K","\u0136":"K","\u1E34":"K","\u0198":"K","\u2C69":"K","\uA740":"K","\uA742":"K","\uA744":"K","\uA7A2":"K","\u24C1":"L","\uFF2C":"L","\u013F":"L","\u0139":"L","\u013D":"L","\u1E36":"L","\u1E38":"L","\u013B":"L","\u1E3C":"L","\u1E3A":"L","\u0141":"L","\u023D":"L","\u2C62":"L","\u2C60":"L","\uA748":"L","\uA746":"L","\uA780":"L","\u01C7":"LJ","\u01C8":"Lj","\u24C2":"M","\uFF2D":"M","\u1E3E":"M","\u1E40":"M","\u1E42":"M","\u2C6E":"M","\u019C":"M","\u24C3":"N","\uFF2E":"N","\u01F8":"N","\u0143":"N","\u00D1":"N","\u1E44":"N","\u0147":"N","\u1E46":"N","\u0145":"N","\u1E4A":"N","\u1E48":"N","\u0220":"N","\u019D":"N","\uA790":"N","\uA7A4":"N","\u01CA":"NJ","\u01CB":"Nj","\u24C4":"O","\uFF2F":"O","\u00D2":"O","\u00D3":"O","\u00D4":"O","\u1ED2":"O","\u1ED0":"O","\u1ED6":"O","\u1ED4":"O","\u00D5":"O","\u1E4C":"O","\u022C":"O","\u1E4E":"O","\u014C":"O","\u1E50":"O","\u1E52":"O","\u014E":"O","\u022E":"O","\u0230":"O","\u00D6":"O","\u022A":"O","\u1ECE":"O","\u0150":"O","\u01D1":"O","\u020C":"O","\u020E":"O","\u01A0":"O","\u1EDC":"O","\u1EDA":"O","\u1EE0":"O","\u1EDE":"O","\u1EE2":"O","\u1ECC":"O","\u1ED8":"O","\u01EA":"O","\u01EC":"O","\u00D8":"O","\u01FE":"O","\u0186":"O","\u019F":"O","\uA74A":"O","\uA74C":"O","\u01A2":"OI","\uA74E":"OO","\u0222":"OU","\u24C5":"P","\uFF30":"P","\u1E54":"P","\u1E56":"P","\u01A4":"P","\u2C63":"P","\uA750":"P","\uA752":"P","\uA754":"P","\u24C6":"Q","\uFF31":"Q","\uA756":"Q","\uA758":"Q","\u024A":"Q","\u24C7":"R","\uFF32":"R","\u0154":"R","\u1E58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1E5A":"R","\u1E5C":"R","\u0156":"R","\u1E5E":"R","\u024C":"R","\u2C64":"R","\uA75A":"R","\uA7A6":"R","\uA782":"R","\u24C8":"S","\uFF33":"S","\u1E9E":"S","\u015A":"S","\u1E64":"S","\u015C":"S","\u1E60":"S","\u0160":"S","\u1E66":"S","\u1E62":"S","\u1E68":"S","\u0218":"S","\u015E":"S","\u2C7E":"S","\uA7A8":"S","\uA784":"S","\u24C9":"T","\uFF34":"T","\u1E6A":"T","\u0164":"T","\u1E6C":"T","\u021A":"T","\u0162":"T","\u1E70":"T","\u1E6E":"T","\u0166":"T","\u01AC":"T","\u01AE":"T","\u023E":"T","\uA786":"T","\uA728":"TZ","\u24CA":"U","\uFF35":"U","\u00D9":"U","\u00DA":"U","\u00DB":"U","\u0168":"U","\u1E78":"U","\u016A":"U","\u1E7A":"U","\u016C":"U","\u00DC":"U","\u01DB":"U","\u01D7":"U","\u01D5":"U","\u01D9":"U","\u1EE6":"U","\u016E":"U","\u0170":"U","\u01D3":"U","\u0214":"U","\u0216":"U","\u01AF":"U","\u1EEA":"U","\u1EE8":"U","\u1EEE":"U","\u1EEC":"U","\u1EF0":"U","\u1EE4":"U","\u1E72":"U","\u0172":"U","\u1E76":"U","\u1E74":"U","\u0244":"U","\u24CB":"V","\uFF36":"V","\u1E7C":"V","\u1E7E":"V","\u01B2":"V","\uA75E":"V","\u0245":"V","\uA760":"VY","\u24CC":"W","\uFF37":"W","\u1E80":"W","\u1E82":"W","\u0174":"W","\u1E86":"W","\u1E84":"W","\u1E88":"W","\u2C72":"W","\u24CD":"X","\uFF38":"X","\u1E8A":"X","\u1E8C":"X","\u24CE":"Y","\uFF39":"Y","\u1EF2":"Y","\u00DD":"Y","\u0176":"Y","\u1EF8":"Y","\u0232":"Y","\u1E8E":"Y","\u0178":"Y","\u1EF6":"Y","\u1EF4":"Y","\u01B3":"Y","\u024E":"Y","\u1EFE":"Y","\u24CF":"Z","\uFF3A":"Z","\u0179":"Z","\u1E90":"Z","\u017B":"Z","\u017D":"Z","\u1E92":"Z","\u1E94":"Z","\u01B5":"Z","\u0224":"Z","\u2C7F":"Z","\u2C6B":"Z","\uA762":"Z","\u24D0":"a","\uFF41":"a","\u1E9A":"a","\u00E0":"a","\u00E1":"a","\u00E2":"a","\u1EA7":"a","\u1EA5":"a","\u1EAB":"a","\u1EA9":"a","\u00E3":"a","\u0101":"a","\u0103":"a","\u1EB1":"a","\u1EAF":"a","\u1EB5":"a","\u1EB3":"a","\u0227":"a","\u01E1":"a","\u00E4":"a","\u01DF":"a","\u1EA3":"a","\u00E5":"a","\u01FB":"a","\u01CE":"a","\u0201":"a","\u0203":"a","\u1EA1":"a","\u1EAD":"a","\u1EB7":"a","\u1E01":"a","\u0105":"a","\u2C65":"a","\u0250":"a","\uA733":"aa","\u00E6":"ae","\u01FD":"ae","\u01E3":"ae","\uA735":"ao","\uA737":"au","\uA739":"av","\uA73B":"av","\uA73D":"ay","\u24D1":"b","\uFF42":"b","\u1E03":"b","\u1E05":"b","\u1E07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24D2":"c","\uFF43":"c","\u0107":"c","\u0109":"c","\u010B":"c","\u010D":"c","\u00E7":"c","\u1E09":"c","\u0188":"c","\u023C":"c","\uA73F":"c","\u2184":"c","\u24D3":"d","\uFF44":"d","\u1E0B":"d","\u010F":"d","\u1E0D":"d","\u1E11":"d","\u1E13":"d","\u1E0F":"d","\u0111":"d","\u018C":"d","\u0256":"d","\u0257":"d","\uA77A":"d","\u01F3":"dz","\u01C6":"dz","\u24D4":"e","\uFF45":"e","\u00E8":"e","\u00E9":"e","\u00EA":"e","\u1EC1":"e","\u1EBF":"e","\u1EC5":"e","\u1EC3":"e","\u1EBD":"e","\u0113":"e","\u1E15":"e","\u1E17":"e","\u0115":"e","\u0117":"e","\u00EB":"e","\u1EBB":"e","\u011B":"e","\u0205":"e","\u0207":"e","\u1EB9":"e","\u1EC7":"e","\u0229":"e","\u1E1D":"e","\u0119":"e","\u1E19":"e","\u1E1B":"e","\u0247":"e","\u025B":"e","\u01DD":"e","\u24D5":"f","\uFF46":"f","\u1E1F":"f","\u0192":"f","\uA77C":"f","\u24D6":"g","\uFF47":"g","\u01F5":"g","\u011D":"g","\u1E21":"g","\u011F":"g","\u0121":"g","\u01E7":"g","\u0123":"g","\u01E5":"g","\u0260":"g","\uA7A1":"g","\u1D79":"g","\uA77F":"g","\u24D7":"h","\uFF48":"h","\u0125":"h","\u1E23":"h","\u1E27":"h","\u021F":"h","\u1E25":"h","\u1E29":"h","\u1E2B":"h","\u1E96":"h","\u0127":"h","\u2C68":"h","\u2C76":"h","\u0265":"h","\u0195":"hv","\u24D8":"i","\uFF49":"i","\u00EC":"i","\u00ED":"i","\u00EE":"i","\u0129":"i","\u012B":"i","\u012D":"i","\u00EF":"i","\u1E2F":"i","\u1EC9":"i","\u01D0":"i","\u0209":"i","\u020B":"i","\u1ECB":"i","\u012F":"i","\u1E2D":"i","\u0268":"i","\u0131":"i","\u24D9":"j","\uFF4A":"j","\u0135":"j","\u01F0":"j","\u0249":"j","\u24DA":"k","\uFF4B":"k","\u1E31":"k","\u01E9":"k","\u1E33":"k","\u0137":"k","\u1E35":"k","\u0199":"k","\u2C6A":"k","\uA741":"k","\uA743":"k","\uA745":"k","\uA7A3":"k","\u24DB":"l","\uFF4C":"l","\u0140":"l","\u013A":"l","\u013E":"l","\u1E37":"l","\u1E39":"l","\u013C":"l","\u1E3D":"l","\u1E3B":"l","\u017F":"l","\u0142":"l","\u019A":"l","\u026B":"l","\u2C61":"l","\uA749":"l","\uA781":"l","\uA747":"l","\u01C9":"lj","\u24DC":"m","\uFF4D":"m","\u1E3F":"m","\u1E41":"m","\u1E43":"m","\u0271":"m","\u026F":"m","\u24DD":"n","\uFF4E":"n","\u01F9":"n","\u0144":"n","\u00F1":"n","\u1E45":"n","\u0148":"n","\u1E47":"n","\u0146":"n","\u1E4B":"n","\u1E49":"n","\u019E":"n","\u0272":"n","\u0149":"n","\uA791":"n","\uA7A5":"n","\u01CC":"nj","\u24DE":"o","\uFF4F":"o","\u00F2":"o","\u00F3":"o","\u00F4":"o","\u1ED3":"o","\u1ED1":"o","\u1ED7":"o","\u1ED5":"o","\u00F5":"o","\u1E4D":"o","\u022D":"o","\u1E4F":"o","\u014D":"o","\u1E51":"o","\u1E53":"o","\u014F":"o","\u022F":"o","\u0231":"o","\u00F6":"o","\u022B":"o","\u1ECF":"o","\u0151":"o","\u01D2":"o","\u020D":"o","\u020F":"o","\u01A1":"o","\u1EDD":"o","\u1EDB":"o","\u1EE1":"o","\u1EDF":"o","\u1EE3":"o","\u1ECD":"o","\u1ED9":"o","\u01EB":"o","\u01ED":"o","\u00F8":"o","\u01FF":"o","\u0254":"o","\uA74B":"o","\uA74D":"o","\u0275":"o","\u01A3":"oi","\u0223":"ou","\uA74F":"oo","\u24DF":"p","\uFF50":"p","\u1E55":"p","\u1E57":"p","\u01A5":"p","\u1D7D":"p","\uA751":"p","\uA753":"p","\uA755":"p","\u24E0":"q","\uFF51":"q","\u024B":"q","\uA757":"q","\uA759":"q","\u24E1":"r","\uFF52":"r","\u0155":"r","\u1E59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1E5B":"r","\u1E5D":"r","\u0157":"r","\u1E5F":"r","\u024D":"r","\u027D":"r","\uA75B":"r","\uA7A7":"r","\uA783":"r","\u24E2":"s","\uFF53":"s","\u00DF":"s","\u015B":"s","\u1E65":"s","\u015D":"s","\u1E61":"s","\u0161":"s","\u1E67":"s","\u1E63":"s","\u1E69":"s","\u0219":"s","\u015F":"s","\u023F":"s","\uA7A9":"s","\uA785":"s","\u1E9B":"s","\u24E3":"t","\uFF54":"t","\u1E6B":"t","\u1E97":"t","\u0165":"t","\u1E6D":"t","\u021B":"t","\u0163":"t","\u1E71":"t","\u1E6F":"t","\u0167":"t","\u01AD":"t","\u0288":"t","\u2C66":"t","\uA787":"t","\uA729":"tz","\u24E4":"u","\uFF55":"u","\u00F9":"u","\u00FA":"u","\u00FB":"u","\u0169":"u","\u1E79":"u","\u016B":"u","\u1E7B":"u","\u016D":"u","\u00FC":"u","\u01DC":"u","\u01D8":"u","\u01D6":"u","\u01DA":"u","\u1EE7":"u","\u016F":"u","\u0171":"u","\u01D4":"u","\u0215":"u","\u0217":"u","\u01B0":"u","\u1EEB":"u","\u1EE9":"u","\u1EEF":"u","\u1EED":"u","\u1EF1":"u","\u1EE5":"u","\u1E73":"u","\u0173":"u","\u1E77":"u","\u1E75":"u","\u0289":"u","\u24E5":"v","\uFF56":"v","\u1E7D":"v","\u1E7F":"v","\u028B":"v","\uA75F":"v","\u028C":"v","\uA761":"vy","\u24E6":"w","\uFF57":"w","\u1E81":"w","\u1E83":"w","\u0175":"w","\u1E87":"w","\u1E85":"w","\u1E98":"w","\u1E89":"w","\u2C73":"w","\u24E7":"x","\uFF58":"x","\u1E8B":"x","\u1E8D":"x","\u24E8":"y","\uFF59":"y","\u1EF3":"y","\u00FD":"y","\u0177":"y","\u1EF9":"y","\u0233":"y","\u1E8F":"y","\u00FF":"y","\u1EF7":"y","\u1E99":"y","\u1EF5":"y","\u01B4":"y","\u024F":"y","\u1EFF":"y","\u24E9":"z","\uFF5A":"z","\u017A":"z","\u1E91":"z","\u017C":"z","\u017E":"z","\u1E93":"z","\u1E95":"z","\u01B6":"z","\u0225":"z","\u0240":"z","\u2C6C":"z","\uA763":"z"};

	    $document = $(document);

	    nextUid=(function() { var counter=1; return function() { return counter++; }; }());


	    function stripDiacritics(str) {
	        var ret, i, l, c;

	        if (!str || str.length < 1) return str;

	        ret = "";
	        for (i = 0, l = str.length; i < l; i++) {
	            c = str.charAt(i);
	            ret += DIACRITICS[c] || c;
	        }
	        return ret;
	    }

	    function indexOf(value, array) {
	        var i = 0, l = array.length;
	        for (; i < l; i = i + 1) {
	            if (equal(value, array[i])) return i;
	        }
	        return -1;
	    }

	    function measureScrollbar () {
	        var $template = $( MEASURE_SCROLLBAR_TEMPLATE );
	        $template.appendTo('body');

	        var dim = {
	            width: $template.width() - $template[0].clientWidth,
	            height: $template.height() - $template[0].clientHeight
	        };
	        $template.remove();

	        return dim;
	    }

	    /**
	     * Compares equality of a and b
	     * @param a
	     * @param b
	     */
	    function equal(a, b) {
	        if (a === b) return true;
	        if (a === undefined || b === undefined) return false;
	        if (a === null || b === null) return false;
	        // Check whether 'a' or 'b' is a string (primitive or object).
	        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
	        if (a.constructor === String) return a+'' === b+''; // a+'' - in case 'a' is a String object
	        if (b.constructor === String) return b+'' === a+''; // b+'' - in case 'b' is a String object
	        return false;
	    }

	    /**
	     * Splits the string into an array of values, trimming each value. An empty array is returned for nulls or empty
	     * strings
	     * @param string
	     * @param separator
	     */
	    function splitVal(string, separator) {
	        var val, i, l;
	        if (string === null || string.length < 1) return [];
	        val = string.split(separator);
	        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = $.trim(val[i]);
	        return val;
	    }

	    function getSideBorderPadding(element) {
	        return element.outerWidth(false) - element.width();
	    }

	    function installKeyUpChangeEvent(element) {
	        var key="keyup-change-value";
	        element.on("keydown", function () {
	            if ($.data(element, key) === undefined) {
	                $.data(element, key, element.val());
	            }
	        });
	        element.on("keyup", function () {
	            var val= $.data(element, key);
	            if (val !== undefined && element.val() !== val) {
	                $.removeData(element, key);
	                element.trigger("keyup-change");
	            }
	        });
	    }

	    $document.on("mousemove", function (e) {
	        lastMousePosition.x = e.pageX;
	        lastMousePosition.y = e.pageY;
	    });

	    /**
	     * filters mouse events so an event is fired only if the mouse moved.
	     *
	     * filters out mouse events that occur when mouse is stationary but
	     * the elements under the pointer are scrolled.
	     */
	    function installFilteredMouseMove(element) {
	        element.on("mousemove", function (e) {
	            var lastpos = lastMousePosition;
	            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
	                $(e.target).trigger("mousemove-filtered", e);
	            }
	        });
	    }

	    /**
	     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
	     * within the last quietMillis milliseconds.
	     *
	     * @param quietMillis number of milliseconds to wait before invoking fn
	     * @param fn function to be debounced
	     * @param ctx object to be used as this reference within fn
	     * @return debounced version of fn
	     */
	    function debounce(quietMillis, fn, ctx) {
	        ctx = ctx || undefined;
	        var timeout;
	        return function () {
	            var args = arguments;
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function() {
	                fn.apply(ctx, args);
	            }, quietMillis);
	        };
	    }

	    /**
	     * A simple implementation of a thunk
	     * @param formula function used to lazily initialize the thunk
	     * @return {Function}
	     */
	    function thunk(formula) {
	        var evaluated = false,
	            value;
	        return function() {
	            if (evaluated === false) { value = formula(); evaluated = true; }
	            return value;
	        };
	    };

	    function installDebouncedScroll(threshold, element) {
	        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
	        element.on("scroll", function (e) {
	            if (indexOf(e.target, element.get()) >= 0) notify(e);
	        });
	    }

	    function focus($el) {
	        if ($el[0] === document.activeElement) return;

	        /* set the focus in a 0 timeout - that way the focus is set after the processing
	            of the current event has finished - which seems like the only reliable way
	            to set focus */
	        window.setTimeout(function() {
	            var el=$el[0], pos=$el.val().length, range;

	            $el.focus();

	            /* make sure el received focus so we do not error out when trying to manipulate the caret.
	                sometimes modals or others listeners may steal it after its set */
	            if ($el.is(":visible") && el === document.activeElement) {

	                /* after the focus is set move the caret to the end, necessary when we val()
	                    just before setting focus */
	                if(el.setSelectionRange)
	                {
	                    el.setSelectionRange(pos, pos);
	                }
	                else if (el.createTextRange) {
	                    range = el.createTextRange();
	                    range.collapse(false);
	                    range.select();
	                }
	            }
	        }, 0);
	    }

	    function getCursorInfo(el) {
	        el = $(el)[0];
	        var offset = 0;
	        var length = 0;
	        if ('selectionStart' in el) {
	            offset = el.selectionStart;
	            length = el.selectionEnd - offset;
	        } else if ('selection' in document) {
	            el.focus();
	            var sel = document.selection.createRange();
	            length = document.selection.createRange().text.length;
	            sel.moveStart('character', -el.value.length);
	            offset = sel.text.length - length;
	        }
	        return { offset: offset, length: length };
	    }

	    function killEvent(event) {
	        event.preventDefault();
	        event.stopPropagation();
	    }
	    function killEventImmediately(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	    }

	    function measureTextWidth(e) {
	        if (!sizer){
	            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
	            sizer = $(document.createElement("div")).css({
	                position: "absolute",
	                left: "-10000px",
	                top: "-10000px",
	                display: "none",
	                fontSize: style.fontSize,
	                fontFamily: style.fontFamily,
	                fontStyle: style.fontStyle,
	                fontWeight: style.fontWeight,
	                letterSpacing: style.letterSpacing,
	                textTransform: style.textTransform,
	                whiteSpace: "nowrap"
	            });
	            sizer.attr("class","select2-sizer");
	            $("body").append(sizer);
	        }
	        sizer.text(e.val());
	        return sizer.width();
	    }

	    function syncCssClasses(dest, src, adapter) {
	        var classes, replacements = [], adapted;

	        classes = dest.attr("class");
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	            $(classes.split(" ")).each2(function() {
	                if (this.indexOf("select2-") === 0) {
	                    replacements.push(this);
	                }
	            });
	        }
	        classes = src.attr("class");
	        if (classes) {
	            classes = '' + classes; // for IE which returns object
	            $(classes.split(" ")).each2(function() {
	                if (this.indexOf("select2-") !== 0) {
	                    adapted = adapter(this);
	                    if (adapted) {
	                        replacements.push(adapted);
	                    }
	                }
	            });
	        }
	        dest.attr("class", replacements.join(" "));
	    }


	    function markMatch(text, term, markup, escapeMarkup) {
	        var match=stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
	            tl=term.length;

	        if (match<0) {
	            markup.push(escapeMarkup(text));
	            return;
	        }

	        markup.push(escapeMarkup(text.substring(0, match)));
	        markup.push("<span class='select2-match'>");
	        markup.push(escapeMarkup(text.substring(match, match + tl)));
	        markup.push("</span>");
	        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
	    }

	    function defaultEscapeMarkup(markup) {
	        var replace_map = {
	            '\\': '&#92;',
	            '&': '&amp;',
	            '<': '&lt;',
	            '>': '&gt;',
	            '"': '&quot;',
	            "'": '&#39;',
	            "/": '&#47;'
	        };

	        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	            return replace_map[match];
	        });
	    }

	    /**
	     * Produces an ajax-based query function
	     *
	     * @param options object containing configuration paramters
	     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
	     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
	     * @param options.url url for the data
	     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
	     * @param options.dataType request data type: ajax, jsonp, other datatatypes supported by jQuery's $.ajax function or the transport function if specified
	     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
	     * @param options.results a function(remoteData, pageNumber) that converts data returned form the remote request to the format expected by Select2.
	     *      The expected format is an object containing the following keys:
	     *      results array of objects that will be used as choices
	     *      more (optional) boolean indicating whether there are more results available
	     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
	     */
	    function ajax(options) {
	        var timeout, // current scheduled but not yet executed request
	            handler = null,
	            quietMillis = options.quietMillis || 100,
	            ajaxUrl = options.url,
	            self = this;

	        return function (query) {
	            window.clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                var data = options.data, // ajax data function
	                    url = ajaxUrl, // ajax url string or function
	                    transport = options.transport || $.fn.select2.ajaxDefaults.transport,
	                    // deprecated - to be removed in 4.0  - use params instead
	                    deprecated = {
	                        type: options.type || 'GET', // set type of request (GET or POST)
	                        cache: options.cache || false,
	                        jsonpCallback: options.jsonpCallback||undefined,
	                        dataType: options.dataType||"json"
	                    },
	                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);

	                data = data ? data.call(self, query.term, query.page, query.context) : null;
	                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;

	                if (handler) { handler.abort(); }

	                if (options.params) {
	                    if ($.isFunction(options.params)) {
	                        $.extend(params, options.params.call(self));
	                    } else {
	                        $.extend(params, options.params);
	                    }
	                }

	                $.extend(params, {
	                    url: url,
	                    dataType: options.dataType,
	                    data: data,
	                    success: function (data) {
	                        var results = options.results(data, query.page);
	                        query.callback(results);
	                    }
	                });
	                handler = transport.call(self, params);
	            }, quietMillis);
	        };
	    }

	    /**
	     * Produces a query function that works with a local array
	     *
	     * @param options object containing configuration parameters. The options parameter can either be an array or an
	     * object.
	     *
	     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
	     *
	     * If the object form is used ti is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
	     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
	     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
	     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
	     * the text.
	     */
	    function local(options) {
	        var data = options, // data elements
	            dataText,
	            tmp,
	            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search

	         if ($.isArray(data)) {
	            tmp = data;
	            data = { results: tmp };
	        }

	         if ($.isFunction(data) === false) {
	            tmp = data;
	            data = function() { return tmp; };
	        }

	        var dataItem = data();
	        if (dataItem.text) {
	            text = dataItem.text;
	            // if text is not a function we assume it to be a key name
	            if (!$.isFunction(text)) {
	                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
	                text = function (item) { return item[dataText]; };
	            }
	        }

	        return function (query) {
	            var t = query.term, filtered = { results: [] }, process;
	            if (t === "") {
	                query.callback(data());
	                return;
	            }

	            process = function(datum, collection) {
	                var group, attr;
	                datum = datum[0];
	                if (datum.children) {
	                    group = {};
	                    for (attr in datum) {
	                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
	                    }
	                    group.children=[];
	                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
	                    if (group.children.length || query.matcher(t, text(group), datum)) {
	                        collection.push(group);
	                    }
	                } else {
	                    if (query.matcher(t, text(datum), datum)) {
	                        collection.push(datum);
	                    }
	                }
	            };

	            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
	            query.callback(filtered);
	        };
	    }

	    function tags(data) {
	        var isFunc = $.isFunction(data);
	        return function (query) {
	            var t = query.term, filtered = {results: []};
	            $(isFunc ? data() : data).each(function () {
	                var isObject = this.text !== undefined,
	                    text = isObject ? this.text : this;
	                if (t === "" || query.matcher(t, text)) {
	                    filtered.results.push(isObject ? this : {id: this, text: this});
	                }
	            });
	            query.callback(filtered);
	        };
	    }

	    /**
	     * Checks if the formatter function should be used.
	     *
	     * Throws an error if it is not a function. Returns true if it should be used,
	     * false if no formatting should be performed.
	     *
	     * @param formatter
	     */
	    function checkFormatter(formatter, formatterName) {
	        if ($.isFunction(formatter)) return true;
	        if (!formatter) return false;
	        throw new Error(formatterName +" must be a function or a falsy value");
	    }

	    function evaluate(val) {
	        return $.isFunction(val) ? val() : val;
	    }

	    function countResults(results) {
	        var count = 0;
	        $.each(results, function(i, item) {
	            if (item.children) {
	                count += countResults(item.children);
	            } else {
	                count++;
	            }
	        });
	        return count;
	    }

	    /**
	     * Default tokenizer. This function uses breaks the input on substring match of any string from the
	     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
	     * two options have to be defined in order for the tokenizer to work.
	     *
	     * @param input text user has typed so far or pasted into the search field
	     * @param selection currently selected choices
	     * @param selectCallback function(choice) callback tho add the choice to selection
	     * @param opts select2's opts
	     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
	     */
	    function defaultTokenizer(input, selection, selectCallback, opts) {
	        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
	            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
	            token, // token
	            index, // position at which the separator was found
	            i, l, // looping variables
	            separator; // the matched separator

	        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;

	        while (true) {
	            index = -1;

	            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
	                separator = opts.tokenSeparators[i];
	                index = input.indexOf(separator);
	                if (index >= 0) break;
	            }

	            if (index < 0) break; // did not find any token separator in the input string, bail

	            token = input.substring(0, index);
	            input = input.substring(index + separator.length);

	            if (token.length > 0) {
	                token = opts.createSearchChoice.call(this, token, selection);
	                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
	                    dupe = false;
	                    for (i = 0, l = selection.length; i < l; i++) {
	                        if (equal(opts.id(token), opts.id(selection[i]))) {
	                            dupe = true; break;
	                        }
	                    }

	                    if (!dupe) selectCallback(token);
	                }
	            }
	        }

	        if (original!==input) return input;
	    }

	    /**
	     * Creates a new class
	     *
	     * @param superClass
	     * @param methods
	     */
	    function clazz(SuperClass, methods) {
	        var constructor = function () {};
	        constructor.prototype = new SuperClass;
	        constructor.prototype.constructor = constructor;
	        constructor.prototype.parent = SuperClass.prototype;
	        constructor.prototype = $.extend(constructor.prototype, methods);
	        return constructor;
	    }

	    AbstractSelect2 = clazz(Object, {

	        // abstract
	        bind: function (func) {
	            var self = this;
	            return function () {
	                func.apply(self, arguments);
	            };
	        },

	        // abstract
	        init: function (opts) {
	            var results, search, resultsSelector = ".select2-results";

	            // prepare options
	            this.opts = opts = this.prepareOpts(opts);

	            this.id=opts.id;

	            // destroy if called on an existing component
	            if (opts.element.data("select2") !== undefined &&
	                opts.element.data("select2") !== null) {
	                opts.element.data("select2").destroy();
	            }

	            this.container = this.createContainer();

	            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
	            this.containerSelector="#"+this.containerId.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
	            this.container.attr("id", this.containerId);

	            // cache the body so future lookups are cheap
	            this.body = thunk(function() { return opts.element.closest("body"); });

	            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);

	            this.container.attr("style", opts.element.attr("style"));
	            this.container.css(evaluate(opts.containerCss));
	            this.container.addClass(evaluate(opts.containerCssClass));

	            this.elementTabIndex = this.opts.element.attr("tabindex");

	            // swap container for the element
	            this.opts.element
	                .data("select2", this)
	                .attr("tabindex", "-1")
	                .before(this.container)
	                .on("click.select2", killEvent); // do not leak click events

	            this.container.data("select2", this);

	            this.dropdown = this.container.find(".select2-drop");

	            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);

	            this.dropdown.addClass(evaluate(opts.dropdownCssClass));
	            this.dropdown.data("select2", this);
	            this.dropdown.on("click", killEvent);

	            this.results = results = this.container.find(resultsSelector);
	            this.search = search = this.container.find("input.select2-input");

	            this.queryCount = 0;
	            this.resultsPage = 0;
	            this.context = null;

	            // initialize the container
	            this.initContainer();

	            this.container.on("click", killEvent);

	            installFilteredMouseMove(this.results);
	            this.dropdown.on("mousemove-filtered touchstart touchmove touchend", resultsSelector, this.bind(this.highlightUnderEvent));

	            installDebouncedScroll(80, this.results);
	            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));

	            // do not propagate change event from the search field out of the component
	            $(this.container).on("change", ".select2-input", function(e) {e.stopPropagation();});
	            $(this.dropdown).on("change", ".select2-input", function(e) {e.stopPropagation();});

	            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
	            if ($.fn.mousewheel) {
	                results.mousewheel(function (e, delta, deltaX, deltaY) {
	                    var top = results.scrollTop();
	                    if (deltaY > 0 && top - deltaY <= 0) {
	                        results.scrollTop(0);
	                        killEvent(e);
	                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
	                        results.scrollTop(results.get(0).scrollHeight - results.height());
	                        killEvent(e);
	                    }
	                });
	            }

	            installKeyUpChangeEvent(search);
	            search.on("keyup-change input paste", this.bind(this.updateResults));
	            search.on("focus", function () { search.addClass("select2-focused"); });
	            search.on("blur", function () { search.removeClass("select2-focused");});

	            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
	                if ($(e.target).closest(".select2-result-selectable").length > 0) {
	                    this.highlightUnderEvent(e);
	                    this.selectHighlighted(e);
	                }
	            }));

	            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
	            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
	            // dom it will trigger the popup close, which is not what we want
	            this.dropdown.on("click mouseup mousedown", function (e) { e.stopPropagation(); });

	            if ($.isFunction(this.opts.initSelection)) {
	                // initialize selection based on the current value of the source element
	                this.initSelection();

	                // if the user has provided a function that can set selection based on the value of the source element
	                // we monitor the change event on the element and trigger it, allowing for two way synchronization
	                this.monitorSource();
	            }

	            if (opts.maximumInputLength !== null) {
	                this.search.attr("maxlength", opts.maximumInputLength);
	            }

	            var disabled = opts.element.prop("disabled");
	            if (disabled === undefined) disabled = false;
	            this.enable(!disabled);

	            var readonly = opts.element.prop("readonly");
	            if (readonly === undefined) readonly = false;
	            this.readonly(readonly);

	            // Calculate size of scrollbar
	            scrollBarDimensions = scrollBarDimensions || measureScrollbar();

	            this.autofocus = opts.element.prop("autofocus");
	            opts.element.prop("autofocus", false);
	            if (this.autofocus) this.focus();

	            this.nextSearchTerm = undefined;
	        },

	        // abstract
	        destroy: function () {
	            var element=this.opts.element, select2 = element.data("select2");

	            this.close();

	            if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }

	            if (select2 !== undefined) {
	                select2.container.remove();
	                select2.dropdown.remove();
	                element
	                    .removeClass("select2-offscreen")
	                    .removeData("select2")
	                    .off(".select2")
	                    .prop("autofocus", this.autofocus || false);
	                if (this.elementTabIndex) {
	                    element.attr({tabindex: this.elementTabIndex});
	                } else {
	                    element.removeAttr("tabindex");
	                }
	                element.show();
	            }
	        },

	        // abstract
	        optionToData: function(element) {
	            if (element.is("option")) {
	                return {
	                    id:element.prop("value"),
	                    text:element.text(),
	                    element: element.get(),
	                    css: element.attr("class"),
	                    disabled: element.prop("disabled"),
	                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
	                };
	            } else if (element.is("optgroup")) {
	                return {
	                    text:element.attr("label"),
	                    children:[],
	                    element: element.get(),
	                    css: element.attr("class")
	                };
	            }
	        },

	        // abstract
	        prepareOpts: function (opts) {
	            var element, select, idKey, ajaxUrl, self = this;

	            element = opts.element;

	            if (element.get(0).tagName.toLowerCase() === "select") {
	                this.select = select = opts.element;
	            }

	            if (select) {
	                // these options are not allowed when attached to a select because they are picked up off the element itself
	                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
	                    if (this in opts) {
	                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
	                    }
	                });
	            }

	            opts = $.extend({}, {
	                populateResults: function(container, results, query) {
	                    var populate, id=this.opts.id;

	                    populate=function(results, container, depth) {

	                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;

	                        results = opts.sortResults(results, container, query);

	                        for (i = 0, l = results.length; i < l; i = i + 1) {

	                            result=results[i];

	                            disabled = (result.disabled === true);
	                            selectable = (!disabled) && (id(result) !== undefined);

	                            compound=result.children && result.children.length > 0;

	                            node=$("<li></li>");
	                            node.addClass("select2-results-dept-"+depth);
	                            node.addClass("select2-result");
	                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
	                            if (disabled) { node.addClass("select2-disabled"); }
	                            if (compound) { node.addClass("select2-result-with-children"); }
	                            node.addClass(self.opts.formatResultCssClass(result));

	                            label=$(document.createElement("div"));
	                            label.addClass("select2-result-label");

	                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
	                            if (formatted!==undefined) {
	                                label.html(formatted);
	                            }

	                            node.append(label);

	                            if (compound) {

	                                innerContainer=$("<ul></ul>");
	                                innerContainer.addClass("select2-result-sub");
	                                populate(result.children, innerContainer, depth+1);
	                                node.append(innerContainer);
	                            }

	                            node.data("select2-data", result);
	                            container.append(node);
	                        }
	                    };

	                    populate(results, container, 0);
	                }
	            }, $.fn.select2.defaults, opts);

	            if (typeof(opts.id) !== "function") {
	                idKey = opts.id;
	                opts.id = function (e) { return e[idKey]; };
	            }

	            if ($.isArray(opts.element.data("select2Tags"))) {
	                if ("tags" in opts) {
	                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
	                }
	                opts.tags=opts.element.data("select2Tags");
	            }

	            if (select) {
	                opts.query = this.bind(function (query) {
	                    var data = { results: [], more: false },
	                        term = query.term,
	                        children, placeholderOption, process;

	                    process=function(element, collection) {
	                        var group;
	                        if (element.is("option")) {
	                            if (query.matcher(term, element.text(), element)) {
	                                collection.push(self.optionToData(element));
	                            }
	                        } else if (element.is("optgroup")) {
	                            group=self.optionToData(element);
	                            element.children().each2(function(i, elm) { process(elm, group.children); });
	                            if (group.children.length>0) {
	                                collection.push(group);
	                            }
	                        }
	                    };

	                    children=element.children();

	                    // ignore the placeholder option if there is one
	                    if (this.getPlaceholder() !== undefined && children.length > 0) {
	                        placeholderOption = this.getPlaceholderOption();
	                        if (placeholderOption) {
	                            children=children.not(placeholderOption);
	                        }
	                    }

	                    children.each2(function(i, elm) { process(elm, data.results); });

	                    query.callback(data);
	                });
	                // this is needed because inside val() we construct choices from options and there id is hardcoded
	                opts.id=function(e) { return e.id; };
	                opts.formatResultCssClass = function(data) { return data.css; };
	            } else {
	                if (!("query" in opts)) {

	                    if ("ajax" in opts) {
	                        ajaxUrl = opts.element.data("ajax-url");
	                        if (ajaxUrl && ajaxUrl.length > 0) {
	                            opts.ajax.url = ajaxUrl;
	                        }
	                        opts.query = ajax.call(opts.element, opts.ajax);
	                    } else if ("data" in opts) {
	                        opts.query = local(opts.data);
	                    } else if ("tags" in opts) {
	                        opts.query = tags(opts.tags);
	                        if (opts.createSearchChoice === undefined) {
	                            opts.createSearchChoice = function (term) { return {id: $.trim(term), text: $.trim(term)}; };
	                        }
	                        if (opts.initSelection === undefined) {
	                            opts.initSelection = function (element, callback) {
	                                var data = [];
	                                $(splitVal(element.val(), opts.separator)).each(function () {
	                                    var obj = { id: this, text: this },
	                                        tags = opts.tags;
	                                    if ($.isFunction(tags)) tags=tags();
	                                    $(tags).each(function() { if (equal(this.id, obj.id)) { obj = this; return false; } });
	                                    data.push(obj);
	                                });

	                                callback(data);
	                            };
	                        }
	                    }
	                }
	            }
	            if (typeof(opts.query) !== "function") {
	                throw "query function not defined for Select2 " + opts.element.attr("id");
	            }

	            return opts;
	        },

	        /**
	         * Monitor the original element for changes and update select2 accordingly
	         */
	        // abstract
	        monitorSource: function () {
	            var el = this.opts.element, sync, observer;

	            el.on("change.select2", this.bind(function (e) {
	                if (this.opts.element.data("select2-change-triggered") !== true) {
	                    this.initSelection();
	                }
	            }));

	            sync = this.bind(function () {

	                // sync enabled state
	                var disabled = el.prop("disabled");
	                if (disabled === undefined) disabled = false;
	                this.enable(!disabled);

	                var readonly = el.prop("readonly");
	                if (readonly === undefined) readonly = false;
	                this.readonly(readonly);

	                syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
	                this.container.addClass(evaluate(this.opts.containerCssClass));

	                syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
	                this.dropdown.addClass(evaluate(this.opts.dropdownCssClass));

	            });

	            // IE8-10
	            el.on("propertychange.select2", sync);

	            // hold onto a reference of the callback to work around a chromium bug
	            if (this.mutationCallback === undefined) {
	                this.mutationCallback = function (mutations) {
	                    mutations.forEach(sync);
	                }
	            }

	            // safari, chrome, firefox, IE11
	            observer = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;
	            if (observer !== undefined) {
	                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
	                this.propertyObserver = new observer(this.mutationCallback);
	                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
	            }
	        },

	        // abstract
	        triggerSelect: function(data) {
	            var evt = $.Event("select2-selecting", { val: this.id(data), object: data });
	            this.opts.element.trigger(evt);
	            return !evt.isDefaultPrevented();
	        },

	        /**
	         * Triggers the change event on the source element
	         */
	        // abstract
	        triggerChange: function (details) {

	            details = details || {};
	            details= $.extend({}, details, { type: "change", val: this.val() });
	            // prevents recursive triggering
	            this.opts.element.data("select2-change-triggered", true);
	            this.opts.element.trigger(details);
	            this.opts.element.data("select2-change-triggered", false);

	            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
	            // so here we trigger the click event manually
	            this.opts.element.click();

	            // ValidationEngine ignorea the change event and listens instead to blur
	            // so here we trigger the blur event manually if so desired
	            if (this.opts.blurOnChange)
	                this.opts.element.blur();
	        },

	        //abstract
	        isInterfaceEnabled: function()
	        {
	            return this.enabledInterface === true;
	        },

	        // abstract
	        enableInterface: function() {
	            var enabled = this._enabled && !this._readonly,
	                disabled = !enabled;

	            if (enabled === this.enabledInterface) return false;

	            this.container.toggleClass("select2-container-disabled", disabled);
	            this.close();
	            this.enabledInterface = enabled;

	            return true;
	        },

	        // abstract
	        enable: function(enabled) {
	            if (enabled === undefined) enabled = true;
	            if (this._enabled === enabled) return;
	            this._enabled = enabled;

	            this.opts.element.prop("disabled", !enabled);
	            this.enableInterface();
	        },

	        // abstract
	        disable: function() {
	            this.enable(false);
	        },

	        // abstract
	        readonly: function(enabled) {
	            if (enabled === undefined) enabled = false;
	            if (this._readonly === enabled) return false;
	            this._readonly = enabled;

	            this.opts.element.prop("readonly", enabled);
	            this.enableInterface();
	            return true;
	        },

	        // abstract
	        opened: function () {
	            return this.container.hasClass("select2-dropdown-open");
	        },

	        // abstract
	        positionDropdown: function() {
	            var $dropdown = this.dropdown,
	                offset = this.container.offset(),
	                height = this.container.outerHeight(false),
	                width = this.container.outerWidth(false),
	                dropHeight = $dropdown.outerHeight(false),
	                $window = $(window),
	                windowWidth = $window.width(),
	                windowHeight = $window.height(),
	                viewPortRight = $window.scrollLeft() + windowWidth,
	                viewportBottom = $window.scrollTop() + windowHeight,
	                dropTop = offset.top + height,
	                dropLeft = offset.left,
	                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
	                enoughRoomAbove = (offset.top - dropHeight) >= this.body().scrollTop(),
	                dropWidth = $dropdown.outerWidth(false),
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight,
	                aboveNow = $dropdown.hasClass("select2-drop-above"),
	                bodyOffset,
	                above,
	                changeDirection,
	                css,
	                resultsListNode;

	            // always prefer the current above/below alignment, unless there is not enough room
	            if (aboveNow) {
	                above = true;
	                if (!enoughRoomAbove && enoughRoomBelow) {
	                    changeDirection = true;
	                    above = false;
	                }
	            } else {
	                above = false;
	                if (!enoughRoomBelow && enoughRoomAbove) {
	                    changeDirection = true;
	                    above = true;
	                }
	            }

	            //if we are changing direction we need to get positions when dropdown is hidden;
	            if (changeDirection) {
	                $dropdown.hide();
	                offset = this.container.offset();
	                height = this.container.outerHeight(false);
	                width = this.container.outerWidth(false);
	                dropHeight = $dropdown.outerHeight(false);
	                viewPortRight = $window.scrollLeft() + windowWidth;
	                viewportBottom = $window.scrollTop() + windowHeight;
	                dropTop = offset.top + height;
	                dropLeft = offset.left;
	                dropWidth = $dropdown.outerWidth(false);
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
	                $dropdown.show();
	            }

	            if (this.opts.dropdownAutoWidth) {
	                resultsListNode = $('.select2-results', $dropdown)[0];
	                $dropdown.addClass('select2-drop-auto-width');
	                $dropdown.css('width', '');
	                // Add scrollbar width to dropdown if vertical scrollbar is present
	                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
	                dropWidth > width ? width = dropWidth : dropWidth = width;
	                enoughRoomOnRight = dropLeft + dropWidth <= viewPortRight;
	            }
	            else {
	                this.container.removeClass('select2-drop-auto-width');
	            }

	            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
	            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body().scrollTop(), "enough?", enoughRoomAbove);

	            // fix positioning when body has an offset and is not position: static
	            if (this.body().css('position') !== 'static') {
	                bodyOffset = this.body().offset();
	                dropTop -= bodyOffset.top;
	                dropLeft -= bodyOffset.left;
	            }

	            if (!enoughRoomOnRight) {
	               dropLeft = offset.left + width - dropWidth;
	            }

	            css =  {
	                left: dropLeft,
	                width: width
	            };

	            if (above) {
	                css.bottom = windowHeight - offset.top;
	                css.top = 'auto';
	                this.container.addClass("select2-drop-above");
	                $dropdown.addClass("select2-drop-above");
	            }
	            else {
	                css.top = dropTop;
	                css.bottom = 'auto';
	                this.container.removeClass("select2-drop-above");
	                $dropdown.removeClass("select2-drop-above");
	            }
	            css = $.extend(css, evaluate(this.opts.dropdownCss));

	            $dropdown.css(css);
	        },

	        // abstract
	        shouldOpen: function() {
	            var event;

	            if (this.opened()) return false;

	            if (this._enabled === false || this._readonly === true) return false;

	            event = $.Event("select2-opening");
	            this.opts.element.trigger(event);
	            return !event.isDefaultPrevented();
	        },

	        // abstract
	        clearDropdownAlignmentPreference: function() {
	            // clear the classes used to figure out the preference of where the dropdown should be opened
	            this.container.removeClass("select2-drop-above");
	            this.dropdown.removeClass("select2-drop-above");
	        },

	        /**
	         * Opens the dropdown
	         *
	         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
	         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
	         */
	        // abstract
	        open: function () {

	            if (!this.shouldOpen()) return false;

	            this.opening();

	            return true;
	        },

	        /**
	         * Performs the opening of the dropdown
	         */
	        // abstract
	        opening: function() {
	            var cid = this.containerId,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid,
	                mask;

	            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");

	            this.clearDropdownAlignmentPreference();

	            if(this.dropdown[0] !== this.body().children().last()[0]) {
	                this.dropdown.detach().appendTo(this.body());
	            }

	            // create the dropdown mask if doesnt already exist
	            mask = $("#select2-drop-mask");
	            if (mask.length == 0) {
	                mask = $(document.createElement("div"));
	                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
	                mask.hide();
	                mask.appendTo(this.body());
	                mask.on("mousedown touchstart click", function (e) {
	                    var dropdown = $("#select2-drop"), self;
	                    if (dropdown.length > 0) {
	                        self=dropdown.data("select2");
	                        if (self.opts.selectOnBlur) {
	                            self.selectHighlighted({noFocus: true});
	                        }
	                        self.close({focus:true});
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                });
	            }

	            // ensure the mask is always right before the dropdown
	            if (this.dropdown.prev()[0] !== mask[0]) {
	                this.dropdown.before(mask);
	            }

	            // move the global id to the correct dropdown
	            $("#select2-drop").removeAttr("id");
	            this.dropdown.attr("id", "select2-drop");

	            // show the elements
	            mask.show();

	            this.positionDropdown();
	            this.dropdown.show();
	            this.positionDropdown();

	            this.dropdown.addClass("select2-drop-active");

	            // attach listeners to events that can change the position of the container and thus require
	            // the position of the dropdown to be updated as well so it does not come unglued from the container
	            var that = this;
	            this.container.parents().add(window).each(function () {
	                $(this).on(resize+" "+scroll+" "+orient, function (e) {
	                    that.positionDropdown();
	                });
	            });


	        },

	        // abstract
	        close: function () {
	            if (!this.opened()) return;

	            var cid = this.containerId,
	                scroll = "scroll." + cid,
	                resize = "resize."+cid,
	                orient = "orientationchange."+cid;

	            // unbind event listeners
	            this.container.parents().add(window).each(function () { $(this).off(scroll).off(resize).off(orient); });

	            this.clearDropdownAlignmentPreference();

	            $("#select2-drop-mask").hide();
	            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
	            this.dropdown.hide();
	            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
	            this.results.empty();


	            this.clearSearch();
	            this.search.removeClass("select2-active");
	            this.opts.element.trigger($.Event("select2-close"));
	        },

	        /**
	         * Opens control, sets input value, and updates results.
	         */
	        // abstract
	        externalSearch: function (term) {
	            this.open();
	            this.search.val(term);
	            this.updateResults(false);
	        },

	        // abstract
	        clearSearch: function () {

	        },

	        //abstract
	        getMaximumSelectionSize: function() {
	            return evaluate(this.opts.maximumSelectionSize);
	        },

	        // abstract
	        ensureHighlightVisible: function () {
	            var results = this.results, children, index, child, hb, rb, y, more;

	            index = this.highlight();

	            if (index < 0) return;

	            if (index == 0) {

	                // if the first element is highlighted scroll all the way to the top,
	                // that way any unselectable headers above it will also be scrolled
	                // into view

	                results.scrollTop(0);
	                return;
	            }

	            children = this.findHighlightableChoices().find('.select2-result-label');

	            child = $(children[index]);

	            hb = child.offset().top + child.outerHeight(true);

	            // if this is the last child lets also make sure select2-more-results is visible
	            if (index === children.length - 1) {
	                more = results.find("li.select2-more-results");
	                if (more.length > 0) {
	                    hb = more.offset().top + more.outerHeight(true);
	                }
	            }

	            rb = results.offset().top + results.outerHeight(true);
	            if (hb > rb) {
	                results.scrollTop(results.scrollTop() + (hb - rb));
	            }
	            y = child.offset().top - results.offset().top;

	            // make sure the top of the element is visible
	            if (y < 0 && child.css('display') != 'none' ) {
	                results.scrollTop(results.scrollTop() + y); // y is negative
	            }
	        },

	        // abstract
	        findHighlightableChoices: function() {
	            return this.results.find(".select2-result-selectable:not(.select2-disabled, .select2-selected)");
	        },

	        // abstract
	        moveHighlight: function (delta) {
	            var choices = this.findHighlightableChoices(),
	                index = this.highlight();

	            while (index > -1 && index < choices.length) {
	                index += delta;
	                var choice = $(choices[index]);
	                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
	                    this.highlight(index);
	                    break;
	                }
	            }
	        },

	        // abstract
	        highlight: function (index) {
	            var choices = this.findHighlightableChoices(),
	                choice,
	                data;

	            if (arguments.length === 0) {
	                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
	            }

	            if (index >= choices.length) index = choices.length - 1;
	            if (index < 0) index = 0;

	            this.removeHighlight();

	            choice = $(choices[index]);
	            choice.addClass("select2-highlighted");

	            this.ensureHighlightVisible();

	            data = choice.data("select2-data");
	            if (data) {
	                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
	            }
	        },

	        removeHighlight: function() {
	            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
	        },

	        // abstract
	        countSelectableResults: function() {
	            return this.findHighlightableChoices().length;
	        },

	        // abstract
	        highlightUnderEvent: function (event) {
	            var el = $(event.target).closest(".select2-result-selectable");
	            if (el.length > 0 && !el.is(".select2-highlighted")) {
	                var choices = this.findHighlightableChoices();
	                this.highlight(choices.index(el));
	            } else if (el.length == 0) {
	                // if we are over an unselectable item remove all highlights
	                this.removeHighlight();
	            }
	        },

	        // abstract
	        loadMoreIfNeeded: function () {
	            var results = this.results,
	                more = results.find("li.select2-more-results"),
	                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
	                page = this.resultsPage + 1,
	                self=this,
	                term=this.search.val(),
	                context=this.context;

	            if (more.length === 0) return;
	            below = more.offset().top - results.offset().top - results.height();

	            if (below <= this.opts.loadMorePadding) {
	                more.addClass("select2-active");
	                this.opts.query({
	                        element: this.opts.element,
	                        term: term,
	                        page: page,
	                        context: context,
	                        matcher: this.opts.matcher,
	                        callback: this.bind(function (data) {

	                    // ignore a response if the select2 has been closed before it was received
	                    if (!self.opened()) return;


	                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
	                    self.postprocessResults(data, false, false);

	                    if (data.more===true) {
	                        more.detach().appendTo(results).text(self.opts.formatLoadMore(page+1));
	                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                    } else {
	                        more.remove();
	                    }
	                    self.positionDropdown();
	                    self.resultsPage = page;
	                    self.context = data.context;
	                    this.opts.element.trigger({ type: "select2-loaded", items: data });
	                })});
	            }
	        },

	        /**
	         * Default tokenizer function which does nothing
	         */
	        tokenize: function() {

	        },

	        /**
	         * @param initial whether or not this is the call to this method right after the dropdown has been opened
	         */
	        // abstract
	        updateResults: function (initial) {
	            var search = this.search,
	                results = this.results,
	                opts = this.opts,
	                data,
	                self = this,
	                input,
	                term = search.val(),
	                lastTerm = $.data(this.container, "select2-last-term"),
	                // sequence number used to drop out-of-order responses
	                queryNumber;

	            // prevent duplicate queries against the same term
	            if (initial !== true && lastTerm && equal(term, lastTerm)) return;

	            $.data(this.container, "select2-last-term", term);

	            // if the search is currently hidden we do not alter the results
	            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
	                return;
	            }

	            function postRender() {
	                search.removeClass("select2-active");
	                self.positionDropdown();
	            }

	            function render(html) {
	                results.html(html);
	                postRender();
	            }

	            queryNumber = ++this.queryCount;

	            var maxSelSize = this.getMaximumSelectionSize();
	            if (maxSelSize >=1) {
	                data = this.data();
	                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
	                    render("<li class='select2-selection-limit'>" + opts.formatSelectionTooBig(maxSelSize) + "</li>");
	                    return;
	                }
	            }

	            if (search.val().length < opts.minimumInputLength) {
	                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
	                    render("<li class='select2-no-results'>" + opts.formatInputTooShort(search.val(), opts.minimumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                if (initial && this.showSearch) this.showSearch(true);
	                return;
	            }

	            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
	                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
	                    render("<li class='select2-no-results'>" + opts.formatInputTooLong(search.val(), opts.maximumInputLength) + "</li>");
	                } else {
	                    render("");
	                }
	                return;
	            }

	            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
	                render("<li class='select2-searching'>" + opts.formatSearching() + "</li>");
	            }

	            search.addClass("select2-active");

	            this.removeHighlight();

	            // give the tokenizer a chance to pre-process the input
	            input = this.tokenize();
	            if (input != undefined && input != null) {
	                search.val(input);
	            }

	            this.resultsPage = 1;

	            opts.query({
	                element: opts.element,
	                    term: search.val(),
	                    page: this.resultsPage,
	                    context: null,
	                    matcher: opts.matcher,
	                    callback: this.bind(function (data) {
	                var def; // default choice

	                // ignore old responses
	                if (queryNumber != this.queryCount) {
	                  return;
	                }

	                // ignore a response if the select2 has been closed before it was received
	                if (!this.opened()) {
	                    this.search.removeClass("select2-active");
	                    return;
	                }

	                // save context, if any
	                this.context = (data.context===undefined) ? null : data.context;
	                // create a default choice and prepend it to the list
	                if (this.opts.createSearchChoice && search.val() !== "") {
	                    def = this.opts.createSearchChoice.call(self, search.val(), data.results);
	                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
	                        if ($(data.results).filter(
	                            function () {
	                                return equal(self.id(this), self.id(def));
	                            }).length === 0) {
	                            data.results.unshift(def);
	                        }
	                    }
	                }

	                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
	                    render("<li class='select2-no-results'>" + opts.formatNoMatches(search.val()) + "</li>");
	                    return;
	                }

	                results.empty();
	                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});

	                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
	                    results.append("<li class='select2-more-results'>" + self.opts.escapeMarkup(opts.formatLoadMore(this.resultsPage)) + "</li>");
	                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
	                }

	                this.postprocessResults(data, initial);

	                postRender();

	                this.opts.element.trigger({ type: "select2-loaded", items: data });
	            })});
	        },

	        // abstract
	        cancel: function () {
	            this.close();
	        },

	        // abstract
	        blur: function () {
	            // if selectOnBlur == true, select the currently highlighted option
	            if (this.opts.selectOnBlur)
	                this.selectHighlighted({noFocus: true});

	            this.close();
	            this.container.removeClass("select2-container-active");
	            // synonymous to .is(':focus'), which is available in jquery >= 1.6
	            if (this.search[0] === document.activeElement) { this.search.blur(); }
	            this.clearSearch();
	            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	        },

	        // abstract
	        focusSearch: function () {
	            focus(this.search);
	        },

	        // abstract
	        selectHighlighted: function (options) {
	            var index=this.highlight(),
	                highlighted=this.results.find(".select2-highlighted"),
	                data = highlighted.closest('.select2-result').data("select2-data");

	            if (data) {
	                this.highlight(index);
	                this.onSelect(data, options);
	            } else if (options && options.noFocus) {
	                this.close();
	            }
	        },

	        // abstract
	        getPlaceholder: function () {
	            var placeholderOption;
	            return this.opts.element.attr("placeholder") ||
	                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
	                this.opts.element.data("placeholder") ||
	                this.opts.placeholder ||
	                ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
	        },

	        // abstract
	        getPlaceholderOption: function() {
	            if (this.select) {
	                var firstOption = this.select.children('option').first();
	                if (this.opts.placeholderOption !== undefined ) {
	                    //Determine the placeholder option based on the specified placeholderOption setting
	                    return (this.opts.placeholderOption === "first" && firstOption) ||
	                           (typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select));
	                } else if (firstOption.text() === "" && firstOption.val() === "") {
	                    //No explicit placeholder option specified, use the first if it's blank
	                    return firstOption;
	                }
	            }
	        },

	        /**
	         * Get the desired width for the container element.  This is
	         * derived first from option `width` passed to select2, then
	         * the inline 'style' on the original element, and finally
	         * falls back to the jQuery calculated element width.
	         */
	        // abstract
	        initContainerWidth: function () {
	            function resolveContainerWidth() {
	                var style, attrs, matches, i, l, attr;

	                if (this.opts.width === "off") {
	                    return null;
	                } else if (this.opts.width === "element"){
	                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
	                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
	                    // check if there is inline style on the element that contains width
	                    style = this.opts.element.attr('style');
	                    if (style !== undefined) {
	                        attrs = style.split(';');
	                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
	                            attr = attrs[i].replace(/\s/g, '');
	                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
	                            if (matches !== null && matches.length >= 1)
	                                return matches[1];
	                        }
	                    }

	                    if (this.opts.width === "resolve") {
	                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
	                        // when attached to input type=hidden or elements hidden via css
	                        style = this.opts.element.css('width');
	                        if (style.indexOf("%") > 0) return style;

	                        // finally, fallback on the calculated width of the element
	                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
	                    }

	                    return null;
	                } else if ($.isFunction(this.opts.width)) {
	                    return this.opts.width();
	                } else {
	                    return this.opts.width;
	               }
	            };

	            var width = resolveContainerWidth.call(this);
	            if (width !== null) {
	                this.container.css("width", width);
	            }
	        }
	    });

	    SingleSelect2 = clazz(AbstractSelect2, {

	        // single

	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container"
	            }).html([
	                "<a href='javascript:void(0)' onclick='return false;' class='select2-choice' tabindex='-1'>",
	                "   <span class='select2-chosen'>&nbsp;</span><abbr class='select2-search-choice-close'></abbr>",
	                "   <span class='select2-arrow'><b></b></span>",
	                "</a>",
	                "<input class='select2-focusser select2-offscreen' type='text'/>",
	                "<div class='select2-drop select2-display-none'>",
	                "   <div class='select2-search'>",
	                "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'/>",
	                "   </div>",
	                "   <ul class='select2-results'>",
	                "   </ul>",
	                "</div>"].join(""));
	            return container;
	        },

	        // single
	        enableInterface: function() {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.focusser.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },

	        // single
	        opening: function () {
	            var el, range, len;

	            if (this.opts.minimumResultsForSearch >= 0) {
	                this.showSearch(true);
	            }

	            this.parent.opening.apply(this, arguments);

	            if (this.showSearchInput !== false) {
	                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
	                // all other browsers handle this just fine

	                this.search.val(this.focusser.val());
	            }
	            this.search.focus();
	            // move the cursor to the end after focussing, otherwise it will be at the beginning and
	            // new text will appear *before* focusser.val()
	            el = this.search.get(0);
	            if (el.createTextRange) {
	                range = el.createTextRange();
	                range.collapse(false);
	                range.select();
	            } else if (el.setSelectionRange) {
	                len = this.search.val().length;
	                el.setSelectionRange(len, len);
	            }

	            // initializes search's value with nextSearchTerm (if defined by user)
	            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
	            if(this.search.val() === "") {
	                if(this.nextSearchTerm != undefined){
	                    this.search.val(this.nextSearchTerm);
	                    this.search.select();
	                }
	            }

	            this.focusser.prop("disabled", true).val("");
	            this.updateResults(true);
	            this.opts.element.trigger($.Event("select2-open"));
	        },

	        // single
	        close: function (params) {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);

	            params = params || {focus: true};
	            this.focusser.removeAttr("disabled");

	            if (params.focus) {
	                this.focusser.focus();
	            }
	        },

	        // single
	        focus: function () {
	            if (this.opened()) {
	                this.close();
	            } else {
	                this.focusser.removeAttr("disabled");
	                this.focusser.focus();
	            }
	        },

	        // single
	        isFocused: function () {
	            return this.container.hasClass("select2-container-active");
	        },

	        // single
	        cancel: function () {
	            this.parent.cancel.apply(this, arguments);
	            this.focusser.removeAttr("disabled");
	            this.focusser.focus();
	        },

	        // single
	        destroy: function() {
	            $("label[for='" + this.focusser.attr('id') + "']")
	                .attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	        },

	        // single
	        initContainer: function () {

	            var selection,
	                container = this.container,
	                dropdown = this.dropdown;

	            if (this.opts.minimumResultsForSearch < 0) {
	                this.showSearch(false);
	            } else {
	                this.showSearch(true);
	            }

	            this.selection = selection = container.find(".select2-choice");

	            this.focusser = container.find(".select2-focusser");

	            // rewrite labels from original element to focusser
	            this.focusser.attr("id", "s2id_autogen"+nextUid());

	            $("label[for='" + this.opts.element.attr("id") + "']")
	                .attr('for', this.focusser.attr('id'));

	            this.focusser.attr("tabindex", this.elementTabIndex);

	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;

	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                    return;
	                }

	                switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                        this.selectHighlighted({noFocus: true});
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                }
	            }));

	            this.search.on("blur", this.bind(function(e) {
	                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
	                // without this the search field loses focus which is annoying
	                if (document.activeElement === this.body().get(0)) {
	                    window.setTimeout(this.bind(function() {
	                        this.search.focus();
	                    }), 0);
	                }
	            }));

	            this.focusser.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;

	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	                    return;
	                }

	                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
	                    killEvent(e);
	                    return;
	                }

	                if (e.which == KEY.DOWN || e.which == KEY.UP
	                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {

	                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;

	                    this.open();
	                    killEvent(e);
	                    return;
	                }

	                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
	                    if (this.opts.allowClear) {
	                        this.clear();
	                    }
	                    killEvent(e);
	                    return;
	                }
	            }));


	            installKeyUpChangeEvent(this.focusser);
	            this.focusser.on("keyup-change input", this.bind(function(e) {
	                if (this.opts.minimumResultsForSearch >= 0) {
	                    e.stopPropagation();
	                    if (this.opened()) return;
	                    this.open();
	                }
	            }));

	            selection.on("mousedown", "abbr", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	                this.clear();
	                killEventImmediately(e);
	                this.close();
	                this.selection.focus();
	            }));

	            selection.on("mousedown", this.bind(function (e) {

	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }

	                if (this.opened()) {
	                    this.close();
	                } else if (this.isInterfaceEnabled()) {
	                    this.open();
	                }

	                killEvent(e);
	            }));

	            dropdown.on("mousedown", this.bind(function() { this.search.focus(); }));

	            selection.on("focus", this.bind(function(e) {
	                killEvent(e);
	            }));

	            this.focusser.on("focus", this.bind(function(){
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            })).on("blur", this.bind(function() {
	                if (!this.opened()) {
	                    this.container.removeClass("select2-container-active");
	                    this.opts.element.trigger($.Event("select2-blur"));
	                }
	            }));
	            this.search.on("focus", this.bind(function(){
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	            }));

	            this.initContainerWidth();
	            this.opts.element.addClass("select2-offscreen");
	            this.setPlaceholder();

	        },

	        // single
	        clear: function(triggerChange) {
	            var data=this.selection.data("select2-data");
	            if (data) { // guard against queued quick consecutive clicks
	                var evt = $.Event("select2-clearing");
	                this.opts.element.trigger(evt);
	                if (evt.isDefaultPrevented()) {
	                    return;
	                }
	                var placeholderOption = this.getPlaceholderOption();
	                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
	                this.selection.find(".select2-chosen").empty();
	                this.selection.removeData("select2-data");
	                this.setPlaceholder();

	                if (triggerChange !== false){
	                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	                    this.triggerChange({removed:data});
	                }
	            }
	        },

	        /**
	         * Sets selection based on source element's value
	         */
	        // single
	        initSelection: function () {
	            var selected;
	            if (this.isPlaceholderOptionSelected()) {
	                this.updateSelection(null);
	                this.close();
	                this.setPlaceholder();
	            } else {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(selected){
	                    if (selected !== undefined && selected !== null) {
	                        self.updateSelection(selected);
	                        self.close();
	                        self.setPlaceholder();
	                    }
	                });
	            }
	        },

	        isPlaceholderOptionSelected: function() {
	            var placeholderOption;
	            if (!this.getPlaceholder()) return false; // no placeholder specified so no option should be considered
	            return ((placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected"))
	                || (this.opts.element.val() === "")
	                || (this.opts.element.val() === undefined)
	                || (this.opts.element.val() === null);
	        },

	        // single
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self=this;

	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install the selection initializer
	                opts.initSelection = function (element, callback) {
	                    var selected = element.find("option").filter(function() { return this.selected });
	                    // a single select box always has a value, no need to null check 'selected'
	                    callback(self.optionToData(selected));
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var id = element.val();
	                    //search in data by id, storing the actual matching item
	                    var match = null;
	                    opts.query({
	                        matcher: function(term, text, el){
	                            var is_match = equal(id, opts.id(el));
	                            if (is_match) {
	                                match = el;
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function() {
	                            callback(match);
	                        }
	                    });
	                };
	            }

	            return opts;
	        },

	        // single
	        getPlaceholder: function() {
	            // if a placeholder is specified on a single select without a valid placeholder option ignore it
	            if (this.select) {
	                if (this.getPlaceholderOption() === undefined) {
	                    return undefined;
	                }
	            }

	            return this.parent.getPlaceholder.apply(this, arguments);
	        },

	        // single
	        setPlaceholder: function () {
	            var placeholder = this.getPlaceholder();

	            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {

	                // check for a placeholder option if attached to a select
	                if (this.select && this.getPlaceholderOption() === undefined) return;

	                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));

	                this.selection.addClass("select2-default");

	                this.container.removeClass("select2-allowclear");
	            }
	        },

	        // single
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var selected = 0, self = this, showSearchInput = true;

	            // find the selected element in the result list

	            this.findHighlightableChoices().each2(function (i, elm) {
	                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
	                    selected = i;
	                    return false;
	                }
	            });

	            // and highlight it
	            if (noHighlightUpdate !== false) {
	                if (initial === true && selected >= 0) {
	                    this.highlight(selected);
	                } else {
	                    this.highlight(0);
	                }
	            }

	            // hide the search box if this is the first we got the results and there are enough of them for search

	            if (initial === true) {
	                var min = this.opts.minimumResultsForSearch;
	                if (min >= 0) {
	                    this.showSearch(countResults(data.results) >= min);
	                }
	            }
	        },

	        // single
	        showSearch: function(showSearchInput) {
	            if (this.showSearchInput === showSearchInput) return;

	            this.showSearchInput = showSearchInput;

	            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
	            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
	            //add "select2-with-searchbox" to the container if search box is shown
	            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
	        },

	        // single
	        onSelect: function (data, options) {

	            if (!this.triggerSelect(data)) { return; }

	            var old = this.opts.element.val(),
	                oldData = this.data();

	            this.opts.element.val(this.id(data));
	            this.updateSelection(data);

	            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });

	            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
	            this.close();

	            if (!options || !options.noFocus)
	                this.focusser.focus();

	            if (!equal(old, this.id(data))) { this.triggerChange({added:data,removed:oldData}); }
	        },

	        // single
	        updateSelection: function (data) {

	            var container=this.selection.find(".select2-chosen"), formatted, cssClass;

	            this.selection.data("select2-data", data);

	            container.empty();
	            if (data !== null) {
	                formatted=this.opts.formatSelection(data, container, this.opts.escapeMarkup);
	            }
	            if (formatted !== undefined) {
	                container.append(formatted);
	            }
	            cssClass=this.opts.formatSelectionCssClass(data, container);
	            if (cssClass !== undefined) {
	                container.addClass(cssClass);
	            }

	            this.selection.removeClass("select2-default");

	            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
	                this.container.addClass("select2-allowclear");
	            }
	        },

	        // single
	        val: function () {
	            var val,
	                triggerChange = false,
	                data = null,
	                self = this,
	                oldData = this.data();

	            if (arguments.length === 0) {
	                return this.opts.element.val();
	            }

	            val = arguments[0];

	            if (arguments.length > 1) {
	                triggerChange = arguments[1];
	            }

	            if (this.select) {
	                this.select
	                    .val(val)
	                    .find("option").filter(function() { return this.selected }).each2(function (i, elm) {
	                        data = self.optionToData(elm);
	                        return false;
	                    });
	                this.updateSelection(data);
	                this.setPlaceholder();
	                if (triggerChange) {
	                    this.triggerChange({added: data, removed:oldData});
	                }
	            } else {
	                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	                if (!val && val !== 0) {
	                    this.clear(triggerChange);
	                    return;
	                }
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("cannot call val() if initSelection() is not defined");
	                }
	                this.opts.element.val(val);
	                this.opts.initSelection(this.opts.element, function(data){
	                    self.opts.element.val(!data ? "" : self.id(data));
	                    self.updateSelection(data);
	                    self.setPlaceholder();
	                    if (triggerChange) {
	                        self.triggerChange({added: data, removed:oldData});
	                    }
	                });
	            }
	        },

	        // single
	        clearSearch: function () {
	            this.search.val("");
	            this.focusser.val("");
	        },

	        // single
	        data: function(value) {
	            var data,
	                triggerChange = false;

	            if (arguments.length === 0) {
	                data = this.selection.data("select2-data");
	                if (data == undefined) data = null;
	                return data;
	            } else {
	                if (arguments.length > 1) {
	                    triggerChange = arguments[1];
	                }
	                if (!value) {
	                    this.clear(triggerChange);
	                } else {
	                    data = this.data();
	                    this.opts.element.val(!value ? "" : this.id(value));
	                    this.updateSelection(value);
	                    if (triggerChange) {
	                        this.triggerChange({added: value, removed:data});
	                    }
	                }
	            }
	        }
	    });

	    MultiSelect2 = clazz(AbstractSelect2, {

	        // multi
	        createContainer: function () {
	            var container = $(document.createElement("div")).attr({
	                "class": "select2-container select2-container-multi"
	            }).html([
	                "<ul class='select2-choices'>",
	                "  <li class='select2-search-field'>",
	                "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>",
	                "  </li>",
	                "</ul>",
	                "<div class='select2-drop select2-drop-multi select2-display-none'>",
	                "   <ul class='select2-results'>",
	                "   </ul>",
	                "</div>"].join(""));
	            return container;
	        },

	        // multi
	        prepareOpts: function () {
	            var opts = this.parent.prepareOpts.apply(this, arguments),
	                self=this;


	            if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                // install sthe selection initializer
	                opts.initSelection = function (element, callback) {

	                    var data = [];

	                    element.find("option").filter(function() { return this.selected }).each2(function (i, elm) {
	                        data.push(self.optionToData(elm));
	                    });
	                    callback(data);
	                };
	            } else if ("data" in opts) {
	                // install default initSelection when applied to hidden input and data is local
	                opts.initSelection = opts.initSelection || function (element, callback) {
	                    var ids = splitVal(element.val(), opts.separator);
	                    //search in data by array of ids, storing matching items in a list
	                    var matches = [];
	                    opts.query({
	                        matcher: function(term, text, el){
	                            var is_match = $.grep(ids, function(id) {
	                                return equal(id, opts.id(el));
	                            }).length;
	                            if (is_match) {
	                                matches.push(el);
	                            }
	                            return is_match;
	                        },
	                        callback: !$.isFunction(callback) ? $.noop : function() {
	                            // reorder matches based on the order they appear in the ids array because right now
	                            // they are in the order in which they appear in data array
	                            var ordered = [];
	                            for (var i = 0; i < ids.length; i++) {
	                                var id = ids[i];
	                                for (var j = 0; j < matches.length; j++) {
	                                    var match = matches[j];
	                                    if (equal(id, opts.id(match))) {
	                                        ordered.push(match);
	                                        matches.splice(j, 1);
	                                        break;
	                                    }
	                                }
	                            }
	                            callback(ordered);
	                        }
	                    });
	                };
	            }

	            return opts;
	        },

	        // multi
	        selectChoice: function (choice) {

	            var selected = this.container.find(".select2-search-choice-focus");
	            if (selected.length && choice && choice[0] == selected[0]) {

	            } else {
	                if (selected.length) {
	                    this.opts.element.trigger("choice-deselected", selected);
	                }
	                selected.removeClass("select2-search-choice-focus");
	                if (choice && choice.length) {
	                    this.close();
	                    choice.addClass("select2-search-choice-focus");
	                    this.opts.element.trigger("choice-selected", choice);
	                }
	            }
	        },

	        // multi
	        destroy: function() {
	            $("label[for='" + this.search.attr('id') + "']")
	                .attr('for', this.opts.element.attr("id"));
	            this.parent.destroy.apply(this, arguments);
	        },

	        // multi
	        initContainer: function () {

	            var selector = ".select2-choices", selection;

	            this.searchContainer = this.container.find(".select2-search-field");
	            this.selection = selection = this.container.find(selector);

	            var _this = this;
	            this.selection.on("click", ".select2-search-choice:not(.select2-locked)", function (e) {
	                //killEvent(e);
	                _this.search[0].focus();
	                _this.selectChoice($(this));
	            });

	            // rewrite labels from original element to focusser
	            this.search.attr("id", "s2id_autogen"+nextUid());
	            $("label[for='" + this.opts.element.attr("id") + "']")
	                .attr('for', this.search.attr('id'));

	            this.search.on("input paste", this.bind(function() {
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.opened()) {
	                    this.open();
	                }
	            }));

	            this.search.attr("tabindex", this.elementTabIndex);

	            this.keydowns = 0;
	            this.search.on("keydown", this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;

	                ++this.keydowns;
	                var selected = selection.find(".select2-search-choice-focus");
	                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
	                var next = selected.next(".select2-search-choice:not(.select2-locked)");
	                var pos = getCursorInfo(this.search);

	                if (selected.length &&
	                    (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
	                    var selectedChoice = selected;
	                    if (e.which == KEY.LEFT && prev.length) {
	                        selectedChoice = prev;
	                    }
	                    else if (e.which == KEY.RIGHT) {
	                        selectedChoice = next.length ? next : null;
	                    }
	                    else if (e.which === KEY.BACKSPACE) {
	                        this.unselect(selected.first());
	                        this.search.width(10);
	                        selectedChoice = prev.length ? prev : next;
	                    } else if (e.which == KEY.DELETE) {
	                        this.unselect(selected.first());
	                        this.search.width(10);
	                        selectedChoice = next.length ? next : null;
	                    } else if (e.which == KEY.ENTER) {
	                        selectedChoice = null;
	                    }

	                    this.selectChoice(selectedChoice);
	                    killEvent(e);
	                    if (!selectedChoice || !selectedChoice.length) {
	                        this.open();
	                    }
	                    return;
	                } else if (((e.which === KEY.BACKSPACE && this.keydowns == 1)
	                    || e.which == KEY.LEFT) && (pos.offset == 0 && !pos.length)) {

	                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
	                    killEvent(e);
	                    return;
	                } else {
	                    this.selectChoice(null);
	                }

	                if (this.opened()) {
	                    switch (e.which) {
	                    case KEY.UP:
	                    case KEY.DOWN:
	                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
	                        killEvent(e);
	                        return;
	                    case KEY.ENTER:
	                        this.selectHighlighted();
	                        killEvent(e);
	                        return;
	                    case KEY.TAB:
	                        this.selectHighlighted({noFocus:true});
	                        this.close();
	                        return;
	                    case KEY.ESC:
	                        this.cancel(e);
	                        killEvent(e);
	                        return;
	                    }
	                }

	                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
	                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
	                    return;
	                }

	                if (e.which === KEY.ENTER) {
	                    if (this.opts.openOnEnter === false) {
	                        return;
	                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
	                        return;
	                    }
	                }

	                this.open();

	                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
	                    // prevent the page from scrolling
	                    killEvent(e);
	                }

	                if (e.which === KEY.ENTER) {
	                    // prevent form from being submitted
	                    killEvent(e);
	                }

	            }));

	            this.search.on("keyup", this.bind(function (e) {
	                this.keydowns = 0;
	                this.resizeSearch();
	            })
	            );

	            this.search.on("blur", this.bind(function(e) {
	                this.container.removeClass("select2-container-active");
	                this.search.removeClass("select2-focused");
	                this.selectChoice(null);
	                if (!this.opened()) this.clearSearch();
	                e.stopImmediatePropagation();
	                this.opts.element.trigger($.Event("select2-blur"));
	            }));

	            this.container.on("click", selector, this.bind(function (e) {
	                if (!this.isInterfaceEnabled()) return;
	                if ($(e.target).closest(".select2-search-choice").length > 0) {
	                    // clicked inside a select2 search choice, do not open
	                    return;
	                }
	                this.selectChoice(null);
	                this.clearPlaceholder();
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.open();
	                this.focusSearch();
	                e.preventDefault();
	            }));

	            this.container.on("focus", selector, this.bind(function () {
	                if (!this.isInterfaceEnabled()) return;
	                if (!this.container.hasClass("select2-container-active")) {
	                    this.opts.element.trigger($.Event("select2-focus"));
	                }
	                this.container.addClass("select2-container-active");
	                this.dropdown.addClass("select2-drop-active");
	                this.clearPlaceholder();
	            }));

	            this.initContainerWidth();
	            this.opts.element.addClass("select2-offscreen");

	            // set the placeholder if necessary
	            this.clearSearch();
	        },

	        // multi
	        enableInterface: function() {
	            if (this.parent.enableInterface.apply(this, arguments)) {
	                this.search.prop("disabled", !this.isInterfaceEnabled());
	            }
	        },

	        // multi
	        initSelection: function () {
	            var data;
	            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
	                this.updateSelection([]);
	                this.close();
	                // set the placeholder if necessary
	                this.clearSearch();
	            }
	            if (this.select || this.opts.element.val() !== "") {
	                var self = this;
	                this.opts.initSelection.call(null, this.opts.element, function(data){
	                    if (data !== undefined && data !== null) {
	                        self.updateSelection(data);
	                        self.close();
	                        // set the placeholder if necessary
	                        self.clearSearch();
	                    }
	                });
	            }
	        },

	        // multi
	        clearSearch: function () {
	            var placeholder = this.getPlaceholder(),
	                maxWidth = this.getMaxSearchWidth();

	            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
	                this.search.val(placeholder).addClass("select2-default");
	                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
	                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
	                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
	            } else {
	                this.search.val("").width(10);
	            }
	        },

	        // multi
	        clearPlaceholder: function () {
	            if (this.search.hasClass("select2-default")) {
	                this.search.val("").removeClass("select2-default");
	            }
	        },

	        // multi
	        opening: function () {
	            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
	            this.resizeSearch();

	            this.parent.opening.apply(this, arguments);

	            this.focusSearch();

	            this.updateResults(true);
	            this.search.focus();
	            this.opts.element.trigger($.Event("select2-open"));
	        },

	        // multi
	        close: function () {
	            if (!this.opened()) return;
	            this.parent.close.apply(this, arguments);
	        },

	        // multi
	        focus: function () {
	            this.close();
	            this.search.focus();
	        },

	        // multi
	        isFocused: function () {
	            return this.search.hasClass("select2-focused");
	        },

	        // multi
	        updateSelection: function (data) {
	            var ids = [], filtered = [], self = this;

	            // filter out duplicates
	            $(data).each(function () {
	                if (indexOf(self.id(this), ids) < 0) {
	                    ids.push(self.id(this));
	                    filtered.push(this);
	                }
	            });
	            data = filtered;

	            this.selection.find(".select2-search-choice").remove();
	            $(data).each(function () {
	                self.addSelectedChoice(this);
	            });
	            self.postprocessResults();
	        },

	        // multi
	        tokenize: function() {
	            var input = this.search.val();
	            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
	            if (input != null && input != undefined) {
	                this.search.val(input);
	                if (input.length > 0) {
	                    this.open();
	                }
	            }

	        },

	        // multi
	        onSelect: function (data, options) {

	            if (!this.triggerSelect(data)) { return; }

	            this.addSelectedChoice(data);

	            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });

	            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect===true);

	            if (this.opts.closeOnSelect) {
	                this.close();
	                this.search.width(10);
	            } else {
	                if (this.countSelectableResults()>0) {
	                    this.search.width(10);
	                    this.resizeSearch();
	                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
	                        // if we reached max selection size repaint the results so choices
	                        // are replaced with the max selection reached message
	                        this.updateResults(true);
	                    }
	                    this.positionDropdown();
	                } else {
	                    // if nothing left to select close
	                    this.close();
	                    this.search.width(10);
	                }
	            }

	            // since its not possible to select an element that has already been
	            // added we do not need to check if this is a new element before firing change
	            this.triggerChange({ added: data });

	            if (!options || !options.noFocus)
	                this.focusSearch();
	        },

	        // multi
	        cancel: function () {
	            this.close();
	            this.focusSearch();
	        },

	        addSelectedChoice: function (data) {
	            var enableChoice = !data.locked,
	                enabledItem = $(
	                    "<li class='select2-search-choice'>" +
	                    "    <div></div>" +
	                    "    <a href='#' onclick='return false;' class='select2-search-choice-close' tabindex='-1'></a>" +
	                    "</li>"),
	                disabledItem = $(
	                    "<li class='select2-search-choice select2-locked'>" +
	                    "<div></div>" +
	                    "</li>");
	            var choice = enableChoice ? enabledItem : disabledItem,
	                id = this.id(data),
	                val = this.getVal(),
	                formatted,
	                cssClass;

	            formatted=this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
	            if (formatted != undefined) {
	                choice.find("div").replaceWith("<div>"+formatted+"</div>");
	            }
	            cssClass=this.opts.formatSelectionCssClass(data, choice.find("div"));
	            if (cssClass != undefined) {
	                choice.addClass(cssClass);
	            }

	            if(enableChoice){
	              choice.find(".select2-search-choice-close")
	                  .on("mousedown", killEvent)
	                  .on("click dblclick", this.bind(function (e) {
	                  if (!this.isInterfaceEnabled()) return;

	                  $(e.target).closest(".select2-search-choice").fadeOut('fast', this.bind(function(){
	                      this.unselect($(e.target));
	                      this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
	                      this.close();
	                      this.focusSearch();
	                  })).dequeue();
	                  killEvent(e);
	              })).on("focus", this.bind(function () {
	                  if (!this.isInterfaceEnabled()) return;
	                  this.container.addClass("select2-container-active");
	                  this.dropdown.addClass("select2-drop-active");
	              }));
	            }

	            choice.data("select2-data", data);
	            choice.insertBefore(this.searchContainer);

	            val.push(id);
	            this.setVal(val);
	        },

	        // multi
	        unselect: function (selected) {
	            var val = this.getVal(),
	                data,
	                index;
	            selected = selected.closest(".select2-search-choice");

	            if (selected.length === 0) {
	                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
	            }

	            data = selected.data("select2-data");

	            if (!data) {
	                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
	                // and invoked on an element already removed
	                return;
	            }

	            while((index = indexOf(this.id(data), val)) >= 0) {
	                val.splice(index, 1);
	                this.setVal(val);
	                if (this.select) this.postprocessResults();
	            }

	            var evt = $.Event("select2-removing");
	            evt.val = this.id(data);
	            evt.choice = data;
	            this.opts.element.trigger(evt);

	            if (evt.isDefaultPrevented()) {
	                return;
	            }

	            selected.remove();

	            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
	            this.triggerChange({ removed: data });
	        },

	        // multi
	        postprocessResults: function (data, initial, noHighlightUpdate) {
	            var val = this.getVal(),
	                choices = this.results.find(".select2-result"),
	                compound = this.results.find(".select2-result-with-children"),
	                self = this;

	            choices.each2(function (i, choice) {
	                var id = self.id(choice.data("select2-data"));
	                if (indexOf(id, val) >= 0) {
	                    choice.addClass("select2-selected");
	                    // mark all children of the selected parent as selected
	                    choice.find(".select2-result-selectable").addClass("select2-selected");
	                }
	            });

	            compound.each2(function(i, choice) {
	                // hide an optgroup if it doesnt have any selectable children
	                if (!choice.is('.select2-result-selectable')
	                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
	                    choice.addClass("select2-selected");
	                }
	            });

	            if (this.highlight() == -1 && noHighlightUpdate !== false){
	                self.highlight(0);
	            }

	            //If all results are chosen render formatNoMAtches
	            if(!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0){
	                if(!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
	                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
	                        this.results.append("<li class='select2-no-results'>" + self.opts.formatNoMatches(self.search.val()) + "</li>");
	                    }
	                }
	            }

	        },

	        // multi
	        getMaxSearchWidth: function() {
	            return this.selection.width() - getSideBorderPadding(this.search);
	        },

	        // multi
	        resizeSearch: function () {
	            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
	                sideBorderPadding = getSideBorderPadding(this.search);

	            minimumWidth = measureTextWidth(this.search) + 10;

	            left = this.search.offset().left;

	            maxWidth = this.selection.width();
	            containerLeft = this.selection.offset().left;

	            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;

	            if (searchWidth < minimumWidth) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }

	            if (searchWidth < 40) {
	                searchWidth = maxWidth - sideBorderPadding;
	            }

	            if (searchWidth <= 0) {
	              searchWidth = minimumWidth;
	            }

	            this.search.width(Math.floor(searchWidth));
	        },

	        // multi
	        getVal: function () {
	            var val;
	            if (this.select) {
	                val = this.select.val();
	                return val === null ? [] : val;
	            } else {
	                val = this.opts.element.val();
	                return splitVal(val, this.opts.separator);
	            }
	        },

	        // multi
	        setVal: function (val) {
	            var unique;
	            if (this.select) {
	                this.select.val(val);
	            } else {
	                unique = [];
	                // filter out duplicates
	                $(val).each(function () {
	                    if (indexOf(this, unique) < 0) unique.push(this);
	                });
	                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
	            }
	        },

	        // multi
	        buildChangeDetails: function (old, current) {
	            var current = current.slice(0),
	                old = old.slice(0);

	            // remove intersection from each array
	            for (var i = 0; i < current.length; i++) {
	                for (var j = 0; j < old.length; j++) {
	                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
	                        current.splice(i, 1);
	                        if(i>0){
	                            i--;
	                        }
	                        old.splice(j, 1);
	                        j--;
	                    }
	                }
	            }

	            return {added: current, removed: old};
	        },


	        // multi
	        val: function (val, triggerChange) {
	            var oldData, self=this;

	            if (arguments.length === 0) {
	                return this.getVal();
	            }

	            oldData=this.data();
	            if (!oldData.length) oldData=[];

	            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
	            if (!val && val !== 0) {
	                this.opts.element.val("");
	                this.updateSelection([]);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange({added: this.data(), removed: oldData});
	                }
	                return;
	            }

	            // val is a list of ids
	            this.setVal(val);

	            if (this.select) {
	                this.opts.initSelection(this.select, this.bind(this.updateSelection));
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
	                }
	            } else {
	                if (this.opts.initSelection === undefined) {
	                    throw new Error("val() cannot be called if initSelection() is not defined");
	                }

	                this.opts.initSelection(this.opts.element, function(data){
	                    var ids=$.map(data, self.id);
	                    self.setVal(ids);
	                    self.updateSelection(data);
	                    self.clearSearch();
	                    if (triggerChange) {
	                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
	                    }
	                });
	            }
	            this.clearSearch();
	        },

	        // multi
	        onSortStart: function() {
	            if (this.select) {
	                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
	            }

	            // collapse search field into 0 width so its container can be collapsed as well
	            this.search.width(0);
	            // hide the container
	            this.searchContainer.hide();
	        },

	        // multi
	        onSortEnd:function() {

	            var val=[], self=this;

	            // show search and move it to the end of the list
	            this.searchContainer.show();
	            // make sure the search container is the last item in the list
	            this.searchContainer.appendTo(this.searchContainer.parent());
	            // since we collapsed the width in dragStarted, we resize it here
	            this.resizeSearch();

	            // update selection
	            this.selection.find(".select2-search-choice").each(function() {
	                val.push(self.opts.id($(this).data("select2-data")));
	            });
	            this.setVal(val);
	            this.triggerChange();
	        },

	        // multi
	        data: function(values, triggerChange) {
	            var self=this, ids, old;
	            if (arguments.length === 0) {
	                 return this.selection
	                     .find(".select2-search-choice")
	                     .map(function() { return $(this).data("select2-data"); })
	                     .get();
	            } else {
	                old = this.data();
	                if (!values) { values = []; }
	                ids = $.map(values, function(e) { return self.opts.id(e); });
	                this.setVal(ids);
	                this.updateSelection(values);
	                this.clearSearch();
	                if (triggerChange) {
	                    this.triggerChange(this.buildChangeDetails(old, this.data()));
	                }
	            }
	        }
	    });

	    $.fn.select2 = function () {

	        var args = Array.prototype.slice.call(arguments, 0),
	            opts,
	            select2,
	            method, value, multiple,
	            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
	            valueMethods = ["opened", "isFocused", "container", "dropdown"],
	            propertyMethods = ["val", "data"],
	            methodsMap = { search: "externalSearch" };

	        this.each(function () {
	            if (args.length === 0 || typeof(args[0]) === "object") {
	                opts = args.length === 0 ? {} : $.extend({}, args[0]);
	                opts.element = $(this);

	                if (opts.element.get(0).tagName.toLowerCase() === "select") {
	                    multiple = opts.element.prop("multiple");
	                } else {
	                    multiple = opts.multiple || false;
	                    if ("tags" in opts) {opts.multiple = multiple = true;}
	                }

	                select2 = multiple ? new MultiSelect2() : new SingleSelect2();
	                select2.init(opts);
	            } else if (typeof(args[0]) === "string") {

	                if (indexOf(args[0], allowedMethods) < 0) {
	                    throw "Unknown method: " + args[0];
	                }

	                value = undefined;
	                select2 = $(this).data("select2");
	                if (select2 === undefined) return;

	                method=args[0];

	                if (method === "container") {
	                    value = select2.container;
	                } else if (method === "dropdown") {
	                    value = select2.dropdown;
	                } else {
	                    if (methodsMap[method]) method = methodsMap[method];

	                    value = select2[method].apply(select2, args.slice(1));
	                }
	                if (indexOf(args[0], valueMethods) >= 0
	                    || (indexOf(args[0], propertyMethods) && args.length == 1)) {
	                    return false; // abort the iteration, ready to return first matched value
	                }
	            } else {
	                throw "Invalid arguments to select2 plugin: " + args;
	            }
	        });
	        return (value === undefined) ? this : value;
	    };

	    // plugin defaults, accessible to users
	    $.fn.select2.defaults = {
	        width: "copy",
	        loadMorePadding: 0,
	        closeOnSelect: true,
	        openOnEnter: true,
	        containerCss: {},
	        dropdownCss: {},
	        containerCssClass: "",
	        dropdownCssClass: "",
	        formatResult: function(result, container, query, escapeMarkup) {
	            var markup=[];
	            markMatch(result.text, query.term, markup, escapeMarkup);
	            return markup.join("");
	        },
	        formatSelection: function (data, container, escapeMarkup) {
	            return data ? escapeMarkup(data.text) : undefined;
	        },
	        sortResults: function (results, container, query) {
	            return results;
	        },
	        formatResultCssClass: function(data) {return undefined;},
	        formatSelectionCssClass: function(data, container) {return undefined;},
	        formatNoMatches: function () { return "No matches found"; },
	        formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " more character" + (n == 1? "" : "s"); },
	        formatInputTooLong: function (input, max) { var n = input.length - max; return "Please delete " + n + " character" + (n == 1? "" : "s"); },
	        formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
	        formatLoadMore: function (pageNumber) { return "Loading more results..."; },
	        formatSearching: function () { return "Searching..."; },
	        minimumResultsForSearch: 0,
	        minimumInputLength: 0,
	        maximumInputLength: null,
	        maximumSelectionSize: 0,
	        id: function (e) { return e.id; },
	        matcher: function(term, text) {
	            return stripDiacritics(''+text).toUpperCase().indexOf(stripDiacritics(''+term).toUpperCase()) >= 0;
	        },
	        separator: ",",
	        tokenSeparators: [],
	        tokenizer: defaultTokenizer,
	        escapeMarkup: defaultEscapeMarkup,
	        blurOnChange: false,
	        selectOnBlur: false,
	        adaptContainerCssClass: function(c) { return c; },
	        adaptDropdownCssClass: function(c) { return null; },
	        nextSearchTerm: function(selectedObject, currentSearchTerm) { return undefined; }
	    };

	    $.fn.select2.ajaxDefaults = {
	        transport: $.ajax,
	        params: {
	            type: "GET",
	            cache: false,
	            dataType: "json"
	        }
	    };

	    // exports
	    // window.Select2 = {
	    //     query: {
	    //         ajax: ajax,
	    //         local: local,
	    //         tags: tags
	    //     }, util: {
	    //         debounce: debounce,
	    //         markMatch: markMatch,
	    //         escapeMarkup: defaultEscapeMarkup,
	    //         stripDiacritics: stripDiacritics
	    //     }, "class": {
	    //         "abstract": AbstractSelect2,
	    //         "single": SingleSelect2,
	    //         "multi": MultiSelect2
	    //     }
	    // };

	}(jQuery));
	};

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(jsreports, $) {
		jsreports.barcode = {};
		jsreports.barcode.CODE39 = __webpack_require__(285);
		jsreports.barcode.CODE128 = __webpack_require__(286);
		jsreports.barcode.CODE128B = function(string) {
			return new jsreports.barcode.CODE128(string, "B");
		}
		jsreports.barcode.CODE128C = function(string) {
			return new jsreports.barcode.CODE128(string, "C");
		};
		jsreports.barcode.EAN = __webpack_require__(287);
		jsreports.barcode.UPC = function(UPCnumber){
			this.ean = new jsreports.barcode.EAN("0"+UPCnumber);
			this.valid = function(){
				return this.ean.valid();
			}
			this.encoded = function(){
				return this.ean.encoded();
			}
		};
		jsreports.barcode.pharmacode = __webpack_require__(288);
		jsreports.barcode.ITF = __webpack_require__(289);
		jsreports.barcode.ITF14 = __webpack_require__(290);

		var JsBarcode = function(image, content, options, validFunction) {
			
			var merge = function(m1, m2) {
				var newMerge = {};
				for (var k in m1) {
					newMerge[k] = m1[k];
				}
				for (var k in m2) {
					newMerge[k] = m2[k];
				}
				return newMerge;
			};

			//This tries to call the valid function only if it's specified. Otherwise nothing happens
			var validFunctionIfExist = function(valid){
			    if(validFunction){
			        validFunction(valid);
			    }
			};
		
			//Merge the user options with the default
			options = merge(JsBarcode.defaults, options);

			//Create the canvas where the barcode will be drawn on
			// Check if the given image is already a canvas
			var canvas = image;

			// check if it is a jQuery object
			if (image.jquery) {
				// get the DOM element of the object
				canvas = image.get(0);
			}

			// check if DOM element is a canvas, otherwise it will be probably an image so create a canvas
			if (!(canvas instanceof HTMLCanvasElement)) {
				canvas = document.createElement('canvas');
			}

			//Abort if the browser does not support HTML5canvas
			if (!canvas.getContext) {
				return image;
			}
			
			var encoder = new jsreports.barcode[options.format](content);
			
			//Abort if the barcode format does not support the content
			if(!encoder.valid()){
			    validFunctionIfExist(false);
				return this;
			}
			
			//Encode the content
			var binary = encoder.encoded();
			
			var _drawBarcodeText = function (text) {
						var x, y;

						y = options.height;

						ctx.font = options.fontSize + "px "+options.font;
						ctx.textBaseline = "bottom";
						ctx.textBaseline = 'top';

						if(options.textAlign == "left"){
							x = options.quite;
							ctx.textAlign = 'left';
						}
						else if(options.textAlign == "right"){
							x = canvas.width - options.quite;
							ctx.textAlign = 'right';
						}
						else{ //All other center
							x = canvas.width / 2;
							ctx.textAlign = 'center';
						}

						ctx.fillText(text, x, y);
					}
			
			//Get the canvas context
			var ctx	= canvas.getContext("2d");
			
			//Set the width and height of the barcode
			canvas.width = binary.length*options.width+2*options.quite;
			canvas.height = options.height + (options.displayValue ? options.fontSize : 0);
			
			//Paint the canvas
			ctx.clearRect(0,0,canvas.width,canvas.height);
			if(options.backgroundColor){
				ctx.fillStyle = options.backgroundColor;
				ctx.fillRect(0,0,canvas.width,canvas.height);
			}
			
			//Creates the barcode out of the encoded binary
			ctx.fillStyle = options.lineColor;
			for(var i=0;i<binary.length;i++){
				var x = i*options.width+options.quite;
				if(binary[i] == "1"){
					ctx.fillRect(x,0,options.width,options.height);
				}			
			}
			
			if(options.displayValue){
				_drawBarcodeText(content);
			}
			
			//Grab the dataUri from the canvas
			uri = canvas.toDataURL('image/png');

			// check if given image is a jQuery object
			if (image.jquery) {
				// check if DOM element of jQuery selection is not a canvas, so assume that it is an image
				if (!(image.get(0) instanceof HTMLCanvasElement)) {
					 //Put the data uri into the image
				 	image.attr("src", uri);
				}
			} else if (!(image instanceof HTMLCanvasElement)) {
				// There is no jQuery object so just check if the given image was a canvas, if not set the source attr
				image.setAttribute("src", uri);
			}


			validFunctionIfExist(true);

		};
		
		JsBarcode.defaults = {
			width:	2,
			height:	100,
			quite: 10,
			format:	"CODE128",
			displayValue: false,
			font:"Monospaced",
			textAlign:"center",
			fontSize: 12,
			backgroundColor:"",
			lineColor:"#000"
		};

		// if (window.jQuery) {
			$.fn.JsBarcode = function(content, options,validFunction){
				JsBarcode(this, content, options,validFunction);
				return this;
			};
		// }
	};

/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports = function(string){

		var code39 = [
	 [0,"0","101000111011101"]
	,[1,"1","111010001010111"]
	,[2,"2","101110001010111"]
	,[3,"3","111011100010101"]
	,[4,"4","101000111010111"]
	,[5,"5","111010001110101"]
	,[6,"6","101110001110101"]
	,[7,"7","101000101110111"]
	,[8,"8","111010001011101"]
	,[9,"9","101110001011101"]
	,[10,"A","111010100010111"]
	,[11,"B","101110100010111"]
	,[12,"C","111011101000101"]
	,[13,"D","101011100010111"]
	,[14,"E","111010111000101"]
	,[15,"F","101110111000101"]
	,[16,"G","101010001110111"]
	,[17,"H","111010100011101"]
	,[18,"I","101110100011101"]
	,[19,"J","101011100011101"]
	,[20,"K","111010101000111"]
	,[21,"L","101110101000111"]
	,[22,"M","111011101010001"]
	,[23,"N","101011101000111"]
	,[24,"O","111010111010001"]
	,[25,"P","101110111010001"]
	,[26,"Q","101010111000111"]
	,[27,"R","111010101110001"]
	,[28,"S","101110101110001"]
	,[29,"T","101011101110001"]
	,[30,"U","111000101010111"]
	,[31,"V","100011101010111"]
	,[32,"W","111000111010101"]
	,[33,"X","100010111010111"]
	,[34,"Y","111000101110101"]
	,[35,"Z","100011101110101"]
	,[36,"-","100010101110111"]
	,[37,".","111000101011101"]
	,[38," ","100011101011101"]
	,[39,"$","100010001000101"]
	,[40,"/","100010001010001"]
	,[41,"+","100010100010001"]
	,[42,"%","101000100010001"]];

		this.valid = valid;

		//The public encoding function
		this.encoded = function(){
			if(valid(string)){
				return encode(string);
			}
			else{
				return "";
			}
		}

		//This regexp is used for validation
		var regexp = /^[0-9A-Z\-\.\ \$\/\+\%]+$/;

		//Use the regexp variable for validation
		function valid(){
			if(string.search(regexp)==-1){
				return false;
			}
			return true;
		}

		//Encode the characters
		function encode(string){
			var result = "";
			result += "1000101110111010";
			for(var i=0;i<string.length;i++){
				result+=encodingByChar(string[i])+"0";
			}
			result += "1000101110111010";
			return result;
		}
		
		//Get the encoded data of a character
		function encodingByChar(character){
			for(var i=0;i<code39.length;i++){
				if(code39[i][1]==character){
					return code39[i][2];
				}
			}
			return "";
		}
	};


/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = function(string, code) {
		code = code || "B";

		this.string128 = string+"";
		
		this.valid = valid;

		//The public encoding function
		this.encoded = function(){
			if(valid(string)){
				return calculate["code128" + code](string);
			}
			else{
				return "";
			}
		}

		//Data for each character, the last characters will not be encoded but are used for error correction
		var code128b = [
		[" ","11011001100",0],
		["!","11001101100",1],
		["\"","11001100110",2],
		["#","10010011000",3],
		["$","10010001100",4],
		["%","10001001100",5],
		["&","10011001000",6],
		["'","10011000100",7],
		["(","10001100100",8],
		[")","11001001000",9],
		["*","11001000100",10],
		["+","11000100100",11],
		[",","10110011100",12],
		["-","10011011100",13],
		[".","10011001110",14],
		["/","10111001100",15],
		["0","10011101100",16],
		["1","10011100110",17],
		["2","11001110010",18],
		["3","11001011100",19],
		["4","11001001110",20],
		["5","11011100100",21],
		["6","11001110100",22],
		["7","11101101110",23],
		["8","11101001100",24],
		["9","11100101100",25],
		[":","11100100110",26],
		[";","11101100100",27],
		["<","11100110100",28],
		["=","11100110010",29],
		[">","11011011000",30],
		["?","11011000110",31],
		["@","11000110110",32],
		["A","10100011000",33],
		["B","10001011000",34],
		["C","10001000110",35],
		["D","10110001000",36],
		["E","10001101000",37],
		["F","10001100010",38],
		["G","11010001000",39],
		["H","11000101000",40],
		["I","11000100010",41],
		["J","10110111000",42],
		["K","10110001110",43],
		["L","10001101110",44],
		["M","10111011000",45],
		["N","10111000110",46],
		["O","10001110110",47],
		["P","11101110110",48],
		["Q","11010001110",49],
		["R","11000101110",50],
		["S","11011101000",51],
		["T","11011100010",52],
		["U","11011101110",53],
		["V","11101011000",54],
		["W","11101000110",55],
		["X","11100010110",56],
		["Y","11101101000",57],
		["Z","11101100010",58],
		["[","11100011010",59],
		["\\","11101111010",60],
		["]","11001000010",61],
		["^","11110001010",62],
		["_","10100110000",63],
		["`","10100001100",64],
		["a","10010110000",65],
		["b","10010000110",66],
		["c","10000101100",67],
		["d","10000100110",68],
		["e","10110010000",69],
		["f","10110000100",70],
		["g","10011010000",71],
		["h","10011000010",72],
		["i","10000110100",73],
		["j","10000110010",74],
		["k","11000010010",75],
		["l","11001010000",76],
		["m","11110111010",77],
		["n","11000010100",78],
		["o","10001111010",79],
		["p","10100111100",80],
		["q","10010111100",81],
		["r","10010011110",82],
		["s","10111100100",83],
		["t","10011110100",84],
		["u","10011110010",85],
		["v","11110100100",86],
		["w","11110010100",87],
		["x","11110010010",88],
		["y","11011011110",89],
		["z","11011110110",90],
		["{","11110110110",91],
		["|","10101111000",92],
		["}","10100011110",93],
		["~","10001011110",94],
		[String.fromCharCode(127),"10111101000",95],
		[String.fromCharCode(128),"10111100010",96],
		[String.fromCharCode(129),"11110101000",97],
		[String.fromCharCode(130),"11110100010",98],
		[String.fromCharCode(131),"10111011110",99],
		[String.fromCharCode(132),"10111101110",100],
		[String.fromCharCode(133),"11101011110",101],
		[String.fromCharCode(134),"11110101110",102],
		//Start codes
		[String.fromCharCode(135),"11010000100",103],
		[String.fromCharCode(136),"11010010000",104],
		[String.fromCharCode(137),"11010011100",105]];

		//The end bits
		var endBin = "1100011101011";

		//This regexp is used for validation
		var regexp = /^[!-~ ]+$/;

		//Use the regexp variable for validation
		function valid(){
			if(string.search(regexp)==-1){
				return false;
			}
			return true;
		}

		//The encoder function that return a complete binary string. Data need to be validated before sent to this function
		//This is general calculate function, which is called by code specific calculate functions
		function calculateCode128(string, encodeFn, startCode, checksumFn){
			var result = "";

			//Add the start bits
			result += encodingById(startCode);

			//Add the encoded bits
			result += encodeFn(string);

			//Add the checksum
			result += encodingById(checksumFn(string, startCode));

			//Add the end bits
			result += endBin;
			
			return result;
		}
		
		//Code specific calculate functions
		var calculate = {
			code128B: function(string){
				return calculateCode128(string, encodeB, 104, checksumB);
			},
			code128C: function(string){
				string = string.replace(/ /g, "");
				return calculateCode128(string, encodeC, 105, checksumC);
			}
		}

		//Encode the characters (128 B)
		function encodeB(string){
			var result = "";
			for(var i=0;i<string.length;i++){
				result+=encodingByChar(string[i]);
			}
			return result;
		}
		
		//Encode the characters (128 C)
		function encodeC(string){
			var result = "";
			for(var i=0;i<string.length;i+=2){
				result+=encodingById(parseInt(string.substr(i, 2)));
			}
			return result;
		}

		//Calculate the checksum (128 B)
		function checksumB(string, startCode){
			var sum = 0;
			for(var i=0;i<string.length;i++){
				sum += weightByCharacter(string[i])*(i+1);
			}
			return (sum+startCode) % 103;
		}
		
		//Calculate the checksum (128 C)
		function checksumC(string, startCode){
			var sum = 0;
			var w = 1;
			for(var i=0;i<string.length;i+=2){
				sum += parseInt(string.substr(i, 2))*(w);
				w++;
			}
			return (sum+startCode) % 103;
		}

		//Get the encoded data by the id of the character
		function encodingById(id){
			for(var i=0;i<code128b.length;i++){
				if(code128b[i][2]==id){
					return code128b[i][1];
				}
			}
			return "";
		}

		//Get the id (weight) of a character
		function weightByCharacter(character){
			for(var i=0;i<code128b.length;i++){
				if(code128b[i][0]==character){
					return code128b[i][2];
				}
			}
			return 0;
		}

		//Get the encoded data of a character
		function encodingByChar(character){
			for(var i=0;i<code128b.length;i++){
				if(code128b[i][0]==character){
					return code128b[i][1];
				}
			}
			return "";
		}
	};


/***/ },
/* 287 */
/***/ function(module, exports) {

	module.exports = function(EANnumber){

		this.EANnumber = EANnumber+"";

		this.valid = function(){
			return valid(this.EANnumber);
		};
		
		this.encoded = function (){
			if(valid(this.EANnumber)){
				return createUPC(this.EANnumber);
			}
			return "";
		}

		//The L (left) type of encoding
		var Lbinary = {
		0: "0001101",
		1: "0011001",
		2: "0010011",
		3: "0111101",
		4: "0100011",
		5: "0110001",
		6: "0101111",
		7: "0111011",
		8: "0110111",
		9: "0001011"}

		//The G type of encoding
		var Gbinary = {
		0: "0100111",
		1: "0110011",
		2: "0011011",
		3: "0100001",
		4: "0011101",
		5: "0111001",
		6: "0000101",
		7: "0010001",
		8: "0001001",
		9: "0010111"}

		//The R (right) type of encoding
		var Rbinary = {
		0: "1110010",
		1: "1100110",
		2: "1101100",
		3: "1000010",
		4: "1011100",
		5: "1001110",
		6: "1010000",
		7: "1000100",
		8: "1001000",
		9: "1110100"}

		//The left side structure in EAN-13
		var EANstruct = {
		0: "LLLLLL",
		1: "LLGLGG",
		2: "LLGGLG",
		3: "LLGGGL",
		4: "LGLLGG",
		5: "LGGLLG",
		6: "LGGGLL",
		7: "LGLGLG",
		8: "LGLGGL",
		9: "LGGLGL"}

		//The start bits
		var startBin = "101";
		//The end bits
		var endBin = "101";
		//The middle bits
		var middleBin = "01010";
		
		//Regexp to test if the EAN code is correct formated
		var regexp = /^[0-9]{13}$/;

		//Create the binary representation of the EAN code
		//number needs to be a string
		function createUPC(number){
			//Create the return variable
			var result = "";

			//Get the first digit (for later determination of the encoding type)
			var firstDigit = number[0];
			
			//Get the number to be encoded on the left side of the EAN code
			var leftSide = number.substr(1,7);
			
			//Get the number to be encoded on the right side of the EAN code
			var rightSide = number.substr(7,6);
			
			
			//Add the start bits
			result += startBin;
			
			//Add the left side
			result += encode(leftSide,EANstruct[firstDigit]);
			
			//Add the middle bits
			result += middleBin;
			
			//Add the right side
			result += encode(rightSide,"RRRRRR");
			
			//Add the end bits
			result += endBin;
			
			return result;
		}

		//Convert a numberarray to the representing 
		function encode(number,struct){	
			//Create the variable that should be returned at the end of the function
			var result = "";
			
			//Loop all the numbers
			for(var i = 0;i<number.length;i++){
				//Using the L, G or R encoding and add it to the returning variable
				if(struct[i]=="L"){
					result += Lbinary[number[i]];
				}
				else if(struct[i]=="G"){
					result += Gbinary[number[i]];
				}
				else if(struct[i]=="R"){
					result += Rbinary[number[i]];
				}
			}
			return result;
		}

		//Calulate the checksum digit
		function checksum(number){
			var result = 0;
			
			for(var i=0;i<12;i+=2){result+=parseInt(number[i])}
			for(var i=1;i<12;i+=2){result+=parseInt(number[i])*3}

			return (10 - (result % 10)) % 10;
		}

		function valid(number){
			if(number.search(regexp)==-1){
				return false;
			}
			else{
				return number[12] == checksum(number);
			}
		}
	};


/***/ },
/* 288 */
/***/ function(module, exports) {

	module.exports = function(number){
	    //Ensure that the input is inturpreted as a number
	    this.number = parseInt(number);

	    function recursiveEncoding(code,state){
	        //End condition
	        if(code.length == 0) return "";

	        var generated;
	        var nextState = false;
	        var nZeros = zeros(code);
	        if(nZeros == 0){
	            generated = state ? "001" : "00111";
	            nextState = state;
	        }
	        else{
	            generated = "001".repeat(nZeros - (state ? 1 : 0));
	            generated += "00111";
	        }
	        return recursiveEncoding(code.substr(0,code.length - nZeros - 1),nextState) + generated;
	    };

	    this.encoded = function(){
	        if(this.valid(this.number)){
	            return recursiveEncoding(this.number.toString(2),true).substr(2);
	        }
	        return "";
	    };

	    this.valid = function(){
	        return this.number >= 3 && this.number <= 131070;
	    };

	    //A help function to calculate the zeros at the end of a string (the code)
	    var zeros = function(code){
	        var i = code.length - 1;
	        var zeros = 0;
	        while(code[i]=="0" || i<0){
	            zeros++;
	            i--;
	        }
	        return zeros;
	    };

	    //http://stackoverflow.com/a/202627
	    String.prototype.repeat = function( num )
	    {
	        return new Array( num + 1 ).join( this );
	    }
	};


/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports = function(ITFNumber){

		this.ITFNumber = ITFNumber+"";

		this.valid = function(){
			return valid(this.ITFNumber);
		};
		
		this.encoded = function (){
			if(valid(this.ITFNumber)){
				return encode(this.ITFNumber);
			}
			return "";
		}

		//The structure for the all digits, 1 is wide and 0 is narrow
		var digitStructure = {
		 "0":"00110"
		,"1":"10001"
		,"2":"01001"
		,"3":"11000"
		,"4":"00101"
		,"5":"10100"
		,"6":"01100"
		,"7":"00011"
		,"8":"10010"
		,"9":"01010"}

		//The start bits
		var startBin = "1010";
		//The end bits
		var endBin = "11101";
		
		//Regexp for a valid Inter25 code
		var regexp = /^([0-9][0-9])+$/;

		//Convert a numberarray to the representing 
		function encode(number){	
			//Create the variable that should be returned at the end of the function
			var result = "";
			
			//Always add the same start bits
			result += startBin;	
			
			//Calculate all the digit pairs
			for(var i=0;i<number.length;i+=2){
				result += calculatePair(number.substr(i,2));
			}
			
			//Always add the same end bits
			result += endBin;
			
			return result;
		}
		
		//Calculate the data of a number pair
		function calculatePair(twoNumbers){
			var result = "";
			
			var number1Struct = digitStructure[twoNumbers[0]];
			var number2Struct = digitStructure[twoNumbers[1]];
			
			//Take every second bit and add to the result
			for(var i=0;i<5;i++){
				result += (number1Struct[i]=="1") ? "111" : "1";
				result += (number2Struct[i]=="1") ? "000" : "0";
			}
			return result;
		}

	  function valid(number){
			return number.search(regexp)!==-1;
		}
	};



/***/ },
/* 290 */
/***/ function(module, exports) {

	module.exports = function(ITF14number){

		this.ITF14number = ITF14number+"";

		this.valid = function(){
			return valid(this.ITF14number);
		};
		
		this.encoded = function (){
			if(valid(this.ITF14number)){
				return encode(this.ITF14number);
			}
			return "";
		}

		//The structure for the all digits, 1 is wide and 0 is narrow
		var digitStructure = {
		 "0":"00110"
		,"1":"10001"
		,"2":"01001"
		,"3":"11000"
		,"4":"00101"
		,"5":"10100"
		,"6":"01100"
		,"7":"00011"
		,"8":"10010"
		,"9":"01010"}

		//The start bits
		var startBin = "1010";
		//The end bits
		var endBin = "11101";
		
		//Regexp for a valid ITF14 code
		var regexp = /^[0-9]{13,14}$/;

		//Convert a numberarray to the representing 
		function encode(number){	
			//Create the variable that should be returned at the end of the function
			var result = "";
			
			//If checksum is not already calculated, do it
			if(number.length == 13){
				number += checksum(number);
			}
			
			//Always add the same start bits
			result += startBin;	
			
			//Calculate all the digit pairs
			for(var i=0;i<14;i+=2){
				result += calculatePair(number.substr(i,2));
			}
			
			//Always add the same end bits
			result += endBin;
			
			return result;
		}
		
		//Calculate the data of a number pair
		function calculatePair(twoNumbers){
			var result = "";
			
			var number1Struct = digitStructure[twoNumbers[0]];
			var number2Struct = digitStructure[twoNumbers[1]];
			
			//Take every second bit and add to the result
			for(var i=0;i<5;i++){
				result += (number1Struct[i]=="1") ? "111" : "1";
				result += (number2Struct[i]=="1") ? "000" : "0";
			}
			return result;
		}

		//Calulate the checksum digit
		function checksum(numberString){
			var result = 0;
			
			for(var i=0;i<13;i++){result+=parseInt(numberString[i])}

			return result % 10;
		}

		function valid(number){
			if(number.search(regexp)==-1){
				return false;
			}
			//Check checksum if it is already calculated
			else if(number.length==14){
				return number[13] == checksum(number);
			}
			return true;
		}
	};


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
	                                                                                                                                                                                                                                                                               * Ditto 1.4.122
	                                                                                                                                                                                                                                                                               * Copyright (c) 2017 Ditto
	                                                                                                                                                                                                                                                                               * http://dittojs.com
	                                                                                                                                                                                                                                                                               */

	/**
	 * Do not call directly.  Use <code>ditto.createReport()</code> to get a new ReportBuilder.
	 * @class ReportBuilder
	 * @classdesc Provides an API for programmatic construction of report definitions.  Use <code>ditto.createReport()</code>
	 * to get a new ReportBuilder, as shown in the example below.
	 *
	 * @example
	 * // Create a new report definition
	 * var reportDef = ditto.createReport()
	 *  .data("time")
	 *  .groupBy("Client_ID")
	 *    .header()
	 *      .text("Group header text")
	 *    .footer()
	 *      .text("Group footer")
	 *  .detail()
	 *    .text("Detail with [data]")
	 *  .input('Client', 'text')
	 *  .filterBy('Client_name', 'contains', '[?Client]')
	 *  .done();
	 * 
	 * // Render the report
	 * ditto.render({
	 *   report_def: reportDef,
	 *   datasets: myDataSets,  // defined elsewhere
	 *   target: $('#myDiv')
	 * });
	 */

	var _ElementUtils = __webpack_require__(5);

	var _ElementUtils2 = _interopRequireDefault(_ElementUtils);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = function (ditto) {

	    ditto.ReportBuilder = function () {
	        var nextReportId = 1;
	        var version = "1.4.122";
	        return function (opts) {
	            if (!ditto.defaultReport) {
	                throw new Error('Missing Ditto base library - did you include all required files?');
	            }
	            this.def = ditto.merge({}, ditto.defaultReport, opts);
	            delete this.def.header;
	            delete this.def.footer;
	            delete this.def.default_format;
	            // delete this.def.page_header;
	            // delete this.def.page_footer;
	            this.def.id = "jsr-auto-id-" + String(nextReportId++);
	            this.lastSection = this.def.body;
	            this.lastLevel = null;
	            this.def.version = version;
	            this.nextControlId = 1;
	            if (this.def.name) {
	                this.def.title = this.def.name;
	            }
	        };
	    }();

	    var getDefaultDataSection = function getDefaultDataSection() {
	        return JSON.parse(JSON.stringify(ditto.defaultReport.body));
	    };

	    ditto.merge(ditto.ReportBuilder.prototype, function () {

	        var nextControlId = 1;

	        function getDefaultSectionHeight() {
	            return getInchesInReportUnits.call(this, 1);
	        }

	        function getInchesInReportUnits(inches) {
	            return this.def.page.units === "mm" ? 25.4 * inches : inches;
	        }

	        function getNextControlId() {
	            return 'jsr-auto-id-' + String(this.nextControlId++);
	        }

	        function defineSection(height, opts) {
	            this.lastSection = ditto.merge({
	                visible: true,
	                height: height || getDefaultSectionHeight.call(this),
	                elements: []
	            }, opts);
	            return this.lastSection;
	        }

	        function requireColumns() {
	            if (!this.def.columns) {
	                this.def.columns = { count: 1, spacing: 0 };
	            }
	        }

	        var api = /** @lends ReportBuilder.prototype */{

	            /**
	             * Begins a data section in the report using the specified data source ID.
	             * When called multiple times, adds additional data sections below the first,
	             * each allowing nested grouping within its own data source via subsequent
	             * calls to groupBy, header, footer, detail, etc.
	             * This should be one of the first methods you call when using the
	             * report builder API to define a report.
	             * @param {string} dataSourceId - The ID of the data source; must match a defined data source ID
	             *   when the report runs
	             * @memberof ReportBuilder
	             * @instance
	             */
	            data: function data(dsId) {
	                var dataSection = this.def.body;
	                if (this.currentDataSection) {
	                    // Already used the first body, add another
	                    if (!Array.isArray(this.def.body)) {
	                        this.def.body = [this.def.body];
	                    }
	                    dataSection = getDefaultDataSection();
	                    this.def.body.push(dataSection);
	                }
	                dataSection.data_source = dsId;
	                this.currentDataSection = dataSection;
	                return this;
	            },

	            /**
	             * Add a header to the current level.  By default, the level is the report itself;
	             * if [groupBy]{@link ReportBuilder#groupBy} has been called, then the header will be added to the most recent
	             * grouping level.
	             * @param {number} height - The height of the header, in report units (inches or mm).
	             * @memberof ReportBuilder
	             * @instance
	             */
	            header: function header(height, opts) {
	                var targetLevel = this.lastLevel || this.def;
	                targetLevel.header = defineSection.call(this, height, opts);
	                return this;
	            },

	            /**
	             * Add a footer to the current level.  By default, the level is the report itself;
	             * if [groupBy]{@link ReportBuilder#groupBy} has been called, then the footer will be added to the most recent
	             * grouping level.
	             * @param {number} height - The height of the footer, in report units (inches or mm).
	             * @memberof ReportBuilder
	             * @instance
	             */
	            footer: function footer(height, opts) {
	                var targetLevel = this.lastLevel || this.def;
	                targetLevel.footer = defineSection.call(this, height, opts);
	                return this;
	            },

	            /**
	             * Add a page header to the report.
	             * @param {number} height - The height of the header, in report units (inches or mm).
	             * @memberof ReportBuilder
	             * @instance
	             */
	            pageHeader: function pageHeader(height, opts) {
	                this.def.page_header = defineSection.call(this, height, opts);
	                return this;
	            },

	            /**
	             * Add a column header to the report.
	             * @param {number} height - The height of the header, in report units (inches or mm).
	             * @memberof ReportBuilder
	             * @instance
	             */
	            columnHeader: function columnHeader(height, opts) {
	                requireColumns.call(this);
	                this.def.columns.header = defineSection.call(this, height, opts);
	                return this;
	            },

	            /**
	             * Add a column header to the report.
	             * @param {number} height - The height of the header, in report units (inches or mm).
	             * @memberof ReportBuilder
	             * @instance
	             */
	            columnFooter: function columnFooter(height, opts) {
	                requireColumns.call(this);
	                this.def.columns.footer = defineSection.call(this, height, opts);
	                return this;
	            },

	            /**
	             * Add a page footer to the report.
	             * @param {number} height - The height of the footer, in report units (inches or mm).
	             * @memberof ReportBuilder
	             * @instance
	             */
	            pageFooter: function pageFooter(height, opts) {
	                this.def.page_footer = defineSection.call(this, height, opts);
	                return this;
	            },

	            /**
	             * Add a page background to the report.  The page background can contain the same
	             * kinds of elements as other sections.  The background is rendered once on each
	             * page in PDF mode and once at the top of the report in HTML mode.
	             * @memberof ReportBuilder
	             * @instance
	             */
	            background: function background(opts) {
	                this.def.background = defineSection.call(this, null, opts);
	                return this;
	            },

	            /**
	             * Set page dimensions for the report.
	             * @param {number} width - The width of the page, in report units (inches or mm).
	             * @param {number} height - The height of the page, in report units (inches or mm).
	             * @param {string} units - The report units ('in' or 'mm'), defaults to inches
	             * @example
	             * // Set the report to 8.5 x 11 inches (US letter size)
	             * ditto.createReport()
	             *   .setPage(8.5, 11, "inches")
	             * @memberof ReportBuilder
	             * @instance
	             */
	            page: function page(width, height, units) {
	                if (typeof units === "undefined" || units === "in") {
	                    units = "inches";
	                }
	                if (units !== "mm" && units !== "inches") {
	                    throw new Error('Allowed units are: "inches", "mm"');
	                }
	                this.def.page.units = units;
	                this.def.page.paper_size = {};
	                this.def.page.paper_size[units] = [width, height];
	                return this;
	            },

	            /**
	             * Set the page margins for the report.  Margins will use the units defined
	             * for the report in setPage, or inches if setPage is not called.
	             * If only one argument is supplied, it will be used for all four margins.
	             * @param {number} top - The top margin height, in report units (inches or mm).
	             * @param {number} right - The right margin width, in report units.
	             * @param {number} bottom - The bottom margin height, in report units.
	             * @param {number} left - The left margin width, in report units.
	             * @memberof ReportBuilder
	             * @instance
	             */
	            margins: function margins(top, right, bottom, left) {
	                if (arguments.length === 1) {
	                    right = bottom = left = top;
	                }
	                this.def.page.margins = {
	                    top: top,
	                    right: right,
	                    bottom: bottom,
	                    left: left
	                };
	                return this;
	            },

	            /**
	             * Add a user input to the report.  Inputs appear in the report viewer toolbar
	             * and allow you to filter the report by user-provided values.  To filter by
	             * an input value, see [addFilter]{@link ReportBuilder#filterBy}.
	             * @param {string} name - User-visible name of the input field
	             * @param {string} type - One of "text", "number", "date"
	             * @param {string} \[defaultValue\]] - The default value for the input
	             * @memberof ReportBuilder
	             * @instance
	             */
	            input: function input(name, type, defaultVal, displayName, opts) {
	                this.def.inputs.push(ditto.merge({
	                    name: name,
	                    type: type,
	                    default_value: defaultVal,
	                    displayName: displayName
	                }, opts));
	                return this;
	            },

	            /**
	             * Add a filter to restrict which records are shown in the report.
	             * To filter by a user input, use <code>'[?InputName]'</code> syntax
	             * in the compareTo argument.
	             * @param {string} field - Name of the data field to filter
	             * @param {string} comparison - One of: is, isnot, contains, doesnotcontain, gt, lt, gte, lte
	             * @param {string} compareTo - Expression against which the data field will be compared
	             * @memberof ReportBuilder
	             * @instance
	             */
	            filterBy: function filterBy(field, comparison, compareTo) {
	                this.def.filters.push({
	                    field: field || "",
	                    operator: comparison || "is",
	                    operand: typeof compareTo === "undefined" ? "" : compareTo
	                });
	                return this;
	            },

	            /**
	             * Add a text element at the specified location.
	             * @param {string} text - The content of the text element.
	             * @param {number} left - The distance from the left edge of the section to the left edge of the element, in report units (inches or mm), not including the page margin
	             * @param {number} top - The distance from the top edge of the section to the top edge of the element, in report units
	             * @param {number} width - The width of the element in report units
	             * @param {number} height - The height of the element in report units
	             * @param {object} opts - An object containing additional properties to apply to the element
	             * @memberof ReportBuilder
	             * @instance
	             */
	            text: function text(_text, left, top, width, height) {
	                var opts = arguments.length <= 5 || arguments[5] === undefined ? {} : arguments[5];

	                if (opts.font && typeof opts.font === 'string') {
	                    opts.font = { name: opts.font, css: opts.font };
	                }
	                this.lastSection.elements.push(ditto.merge(_ElementUtils2.default.getDefaultDef('text'), {
	                    id: getNextControlId.call(this),
	                    text: _text || "Text",
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 2),
	                    height: typeof height !== 'undefined' ? height : getInchesInReportUnits.call(this, 0.5)
	                }, opts));
	                return this;
	            },

	            /**
	             * Add an image element at the specified location.
	             * @param {string} url - The url of the image, either relative or absolute
	             * @param {number} left - The distance from the left edge of the section to the left edge of the element, in report units (inches or mm), not including the page margin
	             * @param {number} top - The distance from the top edge of the section to the top edge of the element, in report units
	             * @param {number} width - The width of the element in report units
	             * @param {number} height - The height of the element in report units
	             * @param {object} opts - An object containing additional properties to apply to the element
	             * @memberof ReportBuilder
	             * @instance
	             */
	            image: function image(url, left, top, width, height, opts) {
	                this.lastSection.elements.push(ditto.merge(_ElementUtils2.default.getDefaultDef('image'), {
	                    id: getNextControlId.call(this),
	                    url: url,
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 1),
	                    height: height || getInchesInReportUnits.call(this, 1)
	                }, opts));
	                return this;
	            },

	            /**
	             * Add a barcode element at the specified location.
	             * @param {string} value - The expression to be evaluated and displayed as a barcode
	             * @param {string} encoding - One of CODE39, CODE128, UPC, ITF14, pharmacode, QR
	             * @param {number} left - The distance from the left edge of the section to the left edge of the element, in report units (inches or mm), not including the page margin
	             * @param {number} top - The distance from the top edge of the section to the top edge of the element, in report units
	             * @param {number} width - The width of the element in report units
	             * @param {number} height - The height of the element in report units
	             * @param {object} opts - An object containing additional properties to apply to the element
	             * @memberof ReportBuilder
	             * @instance
	             */
	            barcode: function barcode(value, encoding, left, top, width, height, opts) {
	                this.lastSection.elements.push(ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: "barcode",
	                    barcode_type: encoding || 'CODE39',
	                    value: value,
	                    show_value: false,
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 1),
	                    height: height || getInchesInReportUnits.call(this, 1),
	                    visible: true
	                }, opts));
	                return this;
	            },

	            /**
	             * Add a box element at the specified location.
	             * @param {string} fill - The hex color code of the fill color, or 'transparent' (e.g. '#fc0')
	             * @param {string} stroke - The hex color code of the border color, or 'transparent' (e.g. '#000')
	             * @param {number} left - The distance from the left edge of the section to the left edge of the element, in report units (inches or mm), not including the page margin
	             * @param {number} top - The distance from the top edge of the section to the top edge of the element, in report units
	             * @param {number} width - The width of the element in report units
	             * @param {number} height - The height of the element in report units
	             * @param {object} opts - An object containing additional properties to apply to the element
	             * @memberof ReportBuilder
	             * @instance
	             */
	            box: function box(fill, stroke, left, top, width, height, opts) {
	                this.lastSection.elements.push(ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: 'box',
	                    corner_radius: 0,
	                    background_color: fill || "#cdf",
	                    border_color: stroke || "#000",
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 1),
	                    height: height || getInchesInReportUnits.call(this, 1),
	                    visible: true
	                }, opts));
	                return this;
	            },

	            checkbox: function checkbox(left, top, width, height, checked, opts) {
	                this.lastSection.elements.push(ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: 'checkbox',
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 1),
	                    height: height || getInchesInReportUnits.call(this, 1),
	                    visible: true,
	                    checked: checked
	                }, opts));
	                return this;
	            },

	            /**
	             * Add a chart element at the specified location.
	             * @param {string} chartType - One of 'line', 'bar', 'pie'
	             * @param {string} \[valueField\]] - The data field containing the y-values for line and bar charts, and slice sizes for pie charts
	             * @param {string} \[labelField\]] - The field containing slice labels for pie charts
	             * @param {number} left - The distance from the left edge of the section to the left edge of the element, in report units (inches or mm), not including the page margin
	             * @param {number} top - The distance from the top edge of the section to the top edge of the element, in report units
	             * @param {number} width - The width of the element in report units
	             * @param {number} height - The height of the element in report units
	             * @param {object} opts - An object containing additional properties to apply to the element
	             * @memberof ReportBuilder
	             * @instance
	             */
	            chart: function chart(chartType, valueField, labelField, left, top, width, height, opts) {
	                var types = ['line', 'bar', 'pie'];
	                if (typeof valueField === 'number') {
	                    opts = width;
	                    height = top;
	                    width = left;
	                    top = labelField;
	                    left = valueField;
	                    labelField = null;
	                    valueField = null;
	                }
	                var typeLower = chartType.toLowerCase();
	                if (types.indexOf(typeLower) < 0) {
	                    throw new Error('Allowed values for addChart chartType argument are: ' + JSON.stringify(types));
	                }
	                var series = valueField ? [{
	                    value_field: valueField
	                }] : [];
	                var template = {
	                    id: getNextControlId.call(this),
	                    type: 'chart_' + typeLower,
	                    series: series,
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 1),
	                    height: height || getInchesInReportUnits.call(this, 1),
	                    visible: true
	                };
	                switch (typeLower) {
	                    case "line":
	                    case "bar":
	                        template.x_axis = {
	                            label_field: labelField
	                        };
	                        break;
	                    case "pie":
	                        if (labelField && template.series.length > 0) {
	                            template.series[0].label_field = labelField;
	                        }
	                        break;
	                }
	                this.lastChart = ditto.merge(template, opts);
	                this.lastSection.elements.push(this.lastChart);
	                return this;
	            },

	            /**
	             * Add a data series to the previously added chart element (see [chart]{@link ReportBuilder#chart})
	             * @param {string} valueField - The data field containing the y-values for line and bar charts, and slice sizes for pie charts
	             * @param {string} \[labelField\]] - The field containing slice labels for pie charts
	             * @param {string} \[colorField\]] - The field containing slice labels for pie charts
	             * @memberof ReportBuilder
	             * @instance
	             */
	            series: function series(valueField, labelField, colorField) {
	                if (!this.lastChart) {
	                    throw new Error('Call to .series() requires preceding call to .chart()');
	                }
	                if (this.lastChart.type === 'chart_pie') {
	                    this.lastChart.series.push({
	                        label_field: labelField,
	                        value_field: valueField,
	                        color_field: colorField
	                    });
	                } else {
	                    this.lastChart.series.push({
	                        value_field: valueField,
	                        color_field: colorField
	                    });
	                    // x-axis gets first series's label
	                    if (labelField && this.lastChart.series.length === 1) {
	                        this.lastChart.x_axis.label_field = labelField;
	                    }
	                }
	                return this;
	            },

	            /**
	             * Add a table element at the specified location.
	             * @param {number} left - The distance from the left edge of the section to the left edge of the element, in report units (inches or mm), not including the page margin
	             * @param {number} top - The distance from the top edge of the section to the top edge of the element, in report units
	             * @param {number} width - The width of the element in report units
	             * @param {number} height - The height of the element in report units
	             * @param {object} opts - An object containing additional properties to apply to the element
	             * @memberof ReportBuilder
	             * @instance
	             * @example
	             * .table(0, 1.25, 4.75, 2.5, { data: 'changeItems', hasFooter: true, 
	             *     groupBy: 'category', fontSize: 9, hideRowWhenExpr: '!description' 
	             * })
	             * .column('50%', '   [description]', '', '', { 
	             *     align: 'left', group0Header: '[category]' })
	             * .column('25%', '[currentPeriod]', 'This Period', '[SUM(currentPeriod)]', { 
	             *     align: 'right',
	             *     detailStyle: {
	             *         pattern: '#,##0.00'
	             *     },
	             *     group0Header: '[SUM(currentPeriod)]',
	             *     group0HeaderStyle: {
	             *         pattern: '#,##0.00'
	             *     }
	             * })
	             * .column('25%', '[ytd]', 'Year-to-Date', '[SUM(ytd)]', { 
	             *     align: 'right',
	             *     detailStyle: {
	             *         pattern: '#,##0.00'
	             *     },
	             *     group0Header: '[SUM(ytd)]',
	             *     group0HeaderStyle: {
	             *         pattern: '#,##0.00'
	             *     }
	             * })
	             */
	            table: function table(left, top, width, height, opts) {
	                this.lastTable = ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: "table",
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 2),
	                    height: height || getInchesInReportUnits.call(this, 2),
	                    hasHeader: true,
	                    hasFooter: false,
	                    columns: []
	                }, opts);
	                this.lastSection.elements.push(this.lastTable);
	                return this;
	            },

	            /**
	             * Add a data series to the previously added table element (see [table]{@link ReportBuilder#table})
	             * @param {string|number} width - The width of the column, either a percentage of the table width (e.g. '100%') or a number in report units (e.g. 4 meaning 4 inches)
	             * @param {string} detail - The text expression to evaluate and render in each detail cell in this column
	             * @param {string} \[header\]] - The text expression to evaluate and render in the table header cell in this column (or null)
	             * @param {string} \[footer\]] - The text expression to evaluate and render in the table footer cell in this column (or null)
	             * @param {object} \[opts\]] - An object containing additional properties to apply to the column
	             * @memberof ReportBuilder
	             * @instance
	             */
	            column: function column(width, detail, header, footer, opts) {
	                if (!this.lastTable) {
	                    throw new Error('Call to .column() requires preceding call to .table()');
	                }
	                this.lastTable.columns.push(ditto.merge({
	                    width: width,
	                    detail: detail,
	                    header: header || null,
	                    footer: footer || null
	                }, opts));
	                return this;
	            },

	            subreport: function subreport(def, left, top, width, height, opts) {
	                this.lastSection.elements.push(ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: "subreport",
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || getInchesInReportUnits.call(this, 2),
	                    height: height || getInchesInReportUnits.call(this, 2),
	                    report: def
	                }, opts));
	                return this;
	            },

	            break: function _break(top, opts) {
	                this.lastSection.elements.push(ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: "break",
	                    left: 0,
	                    top: top || 0
	                }, opts));
	                return this;
	            },

	            line: function line(direction, startLeft, startTop, length, thicknessPts, color, opts) {
	                var ptsPerInch = 72;
	                thicknessPts = thicknessPts || 1;
	                var thicknessInches = thicknessPts / ptsPerInch;
	                direction = direction || 'horizontal';
	                this.lastSection.elements.push(ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: 'line',
	                    left: startLeft || 0,
	                    top: startTop || 0,
	                    width: direction === 'horizontal' ? length : thicknessInches,
	                    height: direction === 'horizontal' ? thicknessInches : length,
	                    thickness: thicknessPts || 1,
	                    direction: direction,
	                    color: color || 'black'
	                }, opts));
	                return this;
	            },

	            /**
	             * Add a new sub-grouping.  If groupBy has already been called, this adds a sub-grouping beneath that grouping.
	             * Records will be grouped by the values in the groupBy data field and the groups will be arranged relative to each
	             * other based on the sortBy data field, if specified.  Groups do not have headers or footers by default; use
	             * [addHeader]{@link ReportBuilder#header} and [addFooter]{@link ReportBuilder#footer} to add them.
	             * @param {string} groupBy - The data field containing the values defining the groups
	             * @param {string} \[sortBy\]] - The data field by which groups should be sorted relative to each other (default: same as groupBy)
	             * @param {string} \[sortDir\]] - One of: 'asc', 'desc' (ascending = A-Z, 0-9) (default: 'asc')
	             * @memberof ReportBuilder
	             * @instance
	             */
	            groupBy: function groupBy(_groupBy, sortBy, sortDir) {
	                if (typeof sortDir !== "undefined" && sortDir !== "asc" && sortDir !== "desc") {
	                    throw new Error('Allowed values for groupBy sortDir argument are: "asc", "desc"');
	                }
	                var default_section_height = getDefaultSectionHeight.call(this);
	                var group = {
	                    data_source: "__parentgroup",
	                    group_by: _groupBy,
	                    sort_by: sortBy || _groupBy,
	                    sort_dir: sortDir || "asc",
	                    header: {
	                        visible: false,
	                        height: default_section_height,
	                        elements: []
	                    },
	                    footer: {
	                        visible: false,
	                        height: default_section_height,
	                        elements: []
	                    }
	                };
	                var dataSection = this.currentDataSection || this.def.body;
	                dataSection.sublevels.push(group);
	                this.lastLevel = group;
	                return this;
	            },

	            subLevel: function subLevel(dataSource, joinParentField, joinChildField, groupBy, sortBy, sortDir) {
	                if (typeof sortDir !== "undefined" && sortDir !== "asc" && sortDir !== "desc") {
	                    throw new Error('Allowed values for groupBy sortDir argument are: "asc", "desc"');
	                }
	                var default_section_height = getDefaultSectionHeight.call(this);
	                var group = {
	                    data_source: dataSource,
	                    group_by: groupBy || null,
	                    sort_by: sortBy || groupBy || null,
	                    sort_dir: sortDir || "asc",
	                    where_parent_field: joinParentField || null,
	                    where_child_field: joinChildField || null,
	                    header: {
	                        visible: false,
	                        height: default_section_height,
	                        elements: []
	                    },
	                    footer: {
	                        visible: false,
	                        height: default_section_height,
	                        elements: []
	                    }
	                };
	                var dataSection = this.currentDataSection || this.def.body;
	                dataSection.sublevels.push(group);
	                this.lastLevel = group;
	                return this;
	            },

	            /**
	             * Move to the detail of the current data section
	             * @memberof ReportBuilder
	             * @instance
	             */
	            detail: function detail(height, opts) {
	                var dataSection = this.currentDataSection || this.def.body;
	                var detail = dataSection;
	                if (dataSection === this.lastDetailDataSection) {
	                    // Multiple calls to .detail() in same data section
	                    if (!detail.extraSections) {
	                        detail.extraSections = [];
	                    }
	                    detail = defineSection.call(this);
	                    dataSection.extraSections.push(detail);
	                }
	                ditto.merge(detail, {
	                    height: height
	                }, opts);
	                this.lastSection = detail;
	                this.lastDetailDataSection = dataSection;
	                return this;
	            },

	            /** 
	             * Add a sub-section to the current detail section.  A sub-section
	             * works like any other section, containing elements.  Sub-sections
	             * are stacked vertically in the order they are defined in the report.
	             * @memberof ReportBuilder
	             * @instance
	             */
	            // subSection: function(height, opts) {
	            //     const detail = this.currentDataSection || this.def.body;
	            //     if (!detail.subSections) {
	            //         detail.subSections = [];
	            //     }
	            //     const subSection = defineSection.call(this, height, opts);
	            //     detail.subSections.push(subSection);
	            //     this.lastSection = subSection;
	            //     return this;
	            // },

	            /**
	             * Set the height of the report's detail section, in report units (inches or mm).
	             * @memberof ReportBuilder
	             * @instance
	             */
	            detailHeight: function detailHeight(height) {
	                this.def.body.height = height;
	                return this;
	            },

	            /**
	             * Order records in the report detail section by the given data field, in the given direction.
	             * @param {string} sortBy - The name of the data field by which to sort
	             * @param {string} \[sortDir\]] - One of: 'asc', 'desc' (ascending = A-Z, 0-9) (default: 'asc')
	             * @memberof ReportBuilder
	             * @instance
	             */
	            sortDetailBy: function sortDetailBy(sortBy, sortDir) {
	                this.def.body.order_detail_by = sortBy;
	                this.def.body.order_detail_dir = sortDir || 'asc';
	                return this;
	            },

	            /**
	             * Make the report's detail section visible.
	             * @memberof ReportBuilder
	             * @instance
	             */
	            showDetail: function showDetail() {
	                this.def.body.show_detail = true;
	                return this;
	            },

	            /**
	             * Make the report's detail section invisible.
	             * @memberof ReportBuilder
	             * @instance
	             */
	            hideDetail: function hideDetail() {
	                this.def.body.show_detail = false;
	                return this;
	            },

	            elementDefaults: function elementDefaults(eltType, defaults) {
	                eltType = eltType.toLowerCase();
	                if (!this.def.elementDefaults) {
	                    this.def.elementDefaults = {};
	                }
	                if (eltType === 'text') {
	                    if (defaults.font && typeof defaults.font === 'string') {
	                        defaults.font = { css: defaults.font };
	                    }
	                }
	                this.def.elementDefaults[eltType.toLowerCase()] = defaults;
	                return this;
	            },

	            /** 
	             * Add an element by its type ID - for custom elements
	             * @memberof ReportBuilder
	             * @instance
	             */
	            element: function element(type, left, top, width, height, opts) {
	                if (typeof type !== 'string') throw new Error('element() method expected element type ID as first argument; got ' + (typeof type === 'undefined' ? 'undefined' : _typeof(type)) + ' ' + JSON.stringify(type) + ' instead.');
	                this.lastSection.elements.push(ditto.merge({
	                    id: getNextControlId.call(this),
	                    type: type,
	                    left: left || 0,
	                    top: top || 0,
	                    width: width || 0,
	                    height: height || 0
	                }, opts));
	                return this;
	            },

	            /**
	             * Set the report's name (used to generate filenames for download)
	             * @param {string} name - The new name for the report
	             * @memberof ReportBuilder
	             * @instance
	             */
	            name: function name(_name) {
	                this.def.title = _name;
	                return this;
	            },

	            /**
	             * Return the report definition in object form.  Call this at the end of a chain of calls that define the report.
	             * The object returned by this method is the report definition that you can pass to ditto.render()
	             * or ditto.export().
	             * @example
	             * // Define a simple report with one text element
	             * var reportDef = ditto.createReport()
	             *   .data('mydata')
	             *   .text('Data value is [myfield]')
	             *   .done();
	             * @memberof ReportBuilder
	             * @instance
	             */
	            done: function done() {
	                this.sanityCheck();
	                return this.def;
	            },

	            /**
	             * Like [done()]{@link ReportBuilder#done}, but returns the report definition in string format.
	             * @memberof ReportBuilder
	             * @instance
	             */
	            toString: function toString() {
	                return JSON.stringify(this.done());
	            },

	            toJSON: function toJSON() {
	                return this.done();
	            },

	            sanityCheck: function sanityCheck() {
	                var throwError = function throwError(msg) {
	                    throw new Error('ReportBuilder error: ' + msg);
	                };
	                var details = Array.isArray(this.def.body) ? this.def.body : [this.def.body];
	                details.forEach(function (detail) {
	                    if (!detail.data_source) {
	                        throwError('Missing data source in detail section ' + index + ' - call .data(datasetId)');
	                    }
	                });
	            }

	        };

	        api.getDetail = api.detail;
	        api.addGrouping = api.groupBy;
	        api.addText = api.text;
	        api.addChart = api.chart;
	        api.addBarcode = api.barcode;
	        api.addBox = api.box;
	        api.addImage = api.image;
	        api.image = api.image;
	        api.addHeader = api.header;
	        api.addFooter = api.footer;
	        api.addFilter = api.filterBy;
	        api.addInput = api.input;
	        api.setDataSource = api.data;
	        api.addPageHeader = api.pageHeader;
	        api.addPageFooter = api.pageFooter;
	        api.setPage = api.page;
	        api.setMargins = api.margins;
	        api.setDetailHeight = api.detailHeight;

	        return api;
	    }());

	    /**
	     * Create a new report builder.  Chain multiple calls as in the example below to
	     * build up the report, and finalize the report by calling [done]{@link ReportBuilder#done} to return the 
	     * report definition object.
	     * 
	     * @example
	     * var reportDef = ditto.createReport()
	     *   .data('balancesheet')
	     *   .page("8.5", "11", 'inches')
	     *   .margins(0, 0, 0, 0)
	     *   .groupBy('trialbalancesection', 'asc', true, true)
	     *      // Add a group header; the header goes on the group because it comes
	     *      // after the call to addGrouping.  To add a report-level header, call
	     *      // addHeader before addGrouping.  It's a good idea to define your report
	     *      // working outside-in.
	     *      .header(1)
	     *        .text('[trialbalancesectionheader]', 1, 0.25, 2.5, 0.5, {
	     *          bold: true
	     *        })
	     *      // Add a one-inch-tall footer with two text elements, with header and footer
	     *      .footer(1)
	     *        .text('Total [trialbalancesectionheader]', 1, 0.25, 2.5, 0.5, {
	     *          bold: true
	     *        })
	     *        // These elements go in the group footer because that is the most recently-
	     *        // added section
	     *        .text('[SUM(debitamount - creditamount)]', 3.25, 0.25, 1.0, 0.5, {
	     *          bold: true,
	     *          align: 'right'
	     *        })
	     *    // Move back to the detail section to add a couple of text elements there
	     *    .detail()
	     *      .text('[accountid] [accountname]', 0.15, 0.25, 2.1, 0.5)
	     *      .text('[=debitamount - creditamount]', 2.25, 0.25, 2, 0.5, {
	     *        align: 'right'
	     *      })
	     *    .detailHeight(1)
	     *    // Return the report definition object
	     *    .done();
	     */
	    ditto.createReport = function (opts) {
	        // Single string argument taken to be report name
	        if (typeof opts === 'string') {
	            opts = { name: opts };
	        }
	        return new ditto.ReportBuilder(opts);
	    };
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _ = __webpack_require__(3);

	module.exports = function (ditto, $) {

	    /** X2JS from https://code.google.com/p/x2js/ (Apache2 license) */
	    function X2JS(v) {
	        var q = "1.1.7";v = v || {};h();r();function h() {
	            if (v.escapeMode === undefined) {
	                v.escapeMode = true;
	            }v.attributePrefix = v.attributePrefix || "_";v.arrayAccessForm = v.arrayAccessForm || "none";v.emptyNodeForm = v.emptyNodeForm || "text";if (v.enableToStringFunc === undefined) {
	                v.enableToStringFunc = true;
	            }v.arrayAccessFormPaths = v.arrayAccessFormPaths || [];if (v.skipEmptyTextNodesForObj === undefined) {
	                v.skipEmptyTextNodesForObj = true;
	            }if (v.stripWhitespaces === undefined) {
	                v.stripWhitespaces = true;
	            }v.datetimeAccessFormPaths = v.datetimeAccessFormPaths || [];if (v.useDoubleQuotes === undefined) {
	                v.useDoubleQuotes = false;
	            }
	        }var g = { ELEMENT_NODE: 1, TEXT_NODE: 3, CDATA_SECTION_NODE: 4, COMMENT_NODE: 8, DOCUMENT_NODE: 9 };function r() {
	            function x(z) {
	                var y = String(z);if (y.length === 1) {
	                    y = "0" + y;
	                }return y;
	            }if (typeof String.prototype.trim !== "function") {
	                String.prototype.trim = function () {
	                    return this.replace(/^\s+|^\n+|(\s|\n)+$/g, "");
	                };
	            }if (typeof Date.prototype.toISOString !== "function") {
	                Date.prototype.toISOString = function () {
	                    return this.getUTCFullYear() + "-" + x(this.getUTCMonth() + 1) + "-" + x(this.getUTCDate()) + "T" + x(this.getUTCHours()) + ":" + x(this.getUTCMinutes()) + ":" + x(this.getUTCSeconds()) + "." + String((this.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5) + "Z";
	                };
	            }
	        }function t(x) {
	            var y = x.localName;if (y == null) {
	                y = x.baseName;
	            }if (y == null || y == "") {
	                y = x.nodeName;
	            }return y;
	        }function o(x) {
	            return x.prefix;
	        }function p(x) {
	            if (typeof x == "string") {
	                return x.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	            } else {
	                return x;
	            }
	        }function j(x) {
	            return x.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&amp;/g, "&");
	        }function l(B, y, A) {
	            switch (v.arrayAccessForm) {case "property":
	                    if (!(B[y] instanceof Array)) {
	                        B[y + "_asArray"] = [B[y]];
	                    } else {
	                        B[y + "_asArray"] = B[y];
	                    }break;}if (!(B[y] instanceof Array) && v.arrayAccessFormPaths.length > 0) {
	                var x = 0;for (; x < v.arrayAccessFormPaths.length; x++) {
	                    var z = v.arrayAccessFormPaths[x];if (typeof z === "string") {
	                        if (z == A) {
	                            break;
	                        }
	                    } else {
	                        if (z instanceof RegExp) {
	                            if (z.test(A)) {
	                                break;
	                            }
	                        } else {
	                            if (typeof z === "function") {
	                                if (z(B, y, A)) {
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                }if (x != v.arrayAccessFormPaths.length) {
	                    B[y] = [B[y]];
	                }
	            }
	        }function a(C) {
	            var A = C.split(/[-T:+Z]/g);var B = new Date(A[0], A[1] - 1, A[2]);var z = A[5].split(".");B.setHours(A[3], A[4], z[0]);if (z.length > 1) {
	                B.setMilliseconds(z[1]);
	            }if (A[6] && A[7]) {
	                var y = A[6] * 60 + Number(A[7]);var x = /\d\d-\d\d:\d\d$/.test(C) ? "-" : "+";y = 0 + (x == "-" ? -1 * y : y);B.setMinutes(B.getMinutes() - y - B.getTimezoneOffset());
	            } else {
	                if (C.indexOf("Z", C.length - 1) !== -1) {
	                    B = new Date(Date.UTC(B.getFullYear(), B.getMonth(), B.getDate(), B.getHours(), B.getMinutes(), B.getSeconds(), B.getMilliseconds()));
	                }
	            }return B;
	        }function n(A, y, z) {
	            if (v.datetimeAccessFormPaths.length > 0) {
	                var B = z.split(".#")[0];var x = 0;for (; x < v.datetimeAccessFormPaths.length; x++) {
	                    var C = v.datetimeAccessFormPaths[x];if (typeof C === "string") {
	                        if (C == B) {
	                            break;
	                        }
	                    } else {
	                        if (C instanceof RegExp) {
	                            if (C.test(B)) {
	                                break;
	                            }
	                        } else {
	                            if (typeof C === "function") {
	                                if (C(obj, y, B)) {
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                }if (x != v.datetimeAccessFormPaths.length) {
	                    return a(A);
	                } else {
	                    return A;
	                }
	            } else {
	                return A;
	            }
	        }function w(z, E) {
	            if (z.nodeType == g.DOCUMENT_NODE) {
	                var F = new Object();var x = z.childNodes;for (var G = 0; G < x.length; G++) {
	                    var y = x.item(G);if (y.nodeType == g.ELEMENT_NODE) {
	                        var D = t(y);F[D] = w(y, D);
	                    }
	                }return F;
	            } else {
	                if (z.nodeType == g.ELEMENT_NODE) {
	                    var F = new Object();F.__cnt = 0;var x = z.childNodes;for (var G = 0; G < x.length; G++) {
	                        var y = x.item(G);var D = t(y);if (y.nodeType != g.COMMENT_NODE) {
	                            F.__cnt++;if (F[D] == null) {
	                                F[D] = w(y, E + "." + D);l(F, D, E + "." + D);
	                            } else {
	                                if (F[D] != null) {
	                                    if (!(F[D] instanceof Array)) {
	                                        F[D] = [F[D]];l(F, D, E + "." + D);
	                                    }
	                                }F[D][F[D].length] = w(y, E + "." + D);
	                            }
	                        }
	                    }for (var A = 0; A < z.attributes.length; A++) {
	                        var B = z.attributes.item(A);F.__cnt++;F[v.attributePrefix + B.name] = B.value;
	                    }var C = o(z);if (C != null && C != "") {
	                        F.__cnt++;F.__prefix = C;
	                    }if (F["#text"] != null) {
	                        F.__text = F["#text"];if (F.__text instanceof Array) {
	                            F.__text = F.__text.join("\n");
	                        }if (v.stripWhitespaces) {
	                            F.__text = F.__text.trim();
	                        }delete F["#text"];if (v.arrayAccessForm == "property") {
	                            delete F["#text_asArray"];
	                        }F.__text = n(F.__text, D, E + "." + D);
	                    }if (F["#cdata-section"] != null) {
	                        F.__cdata = F["#cdata-section"];delete F["#cdata-section"];if (v.arrayAccessForm == "property") {
	                            delete F["#cdata-section_asArray"];
	                        }
	                    }if (F.__cnt == 1 && F.__text != null) {
	                        F = F.__text;
	                    } else {
	                        if (F.__cnt == 0 && v.emptyNodeForm == "text") {
	                            F = "";
	                        } else {
	                            if (F.__cnt > 1 && F.__text != null && v.skipEmptyTextNodesForObj) {
	                                if (v.stripWhitespaces && F.__text == "" || F.__text.trim() == "") {
	                                    delete F.__text;
	                                }
	                            }
	                        }
	                    }delete F.__cnt;if (v.enableToStringFunc && (F.__text != null || F.__cdata != null)) {
	                        F.toString = function () {
	                            return (this.__text != null ? this.__text : "") + (this.__cdata != null ? this.__cdata : "");
	                        };
	                    }return F;
	                } else {
	                    if (z.nodeType == g.TEXT_NODE || z.nodeType == g.CDATA_SECTION_NODE) {
	                        return z.nodeValue;
	                    }
	                }
	            }
	        }function m(E, B, D, y) {
	            var A = "<" + (E != null && E.__prefix != null ? E.__prefix + ":" : "") + B;if (D != null) {
	                for (var C = 0; C < D.length; C++) {
	                    var z = D[C];var x = E[z];if (v.escapeMode) {
	                        x = p(x);
	                    }A += " " + z.substr(v.attributePrefix.length) + "=";if (v.useDoubleQuotes) {
	                        A += '"' + x + '"';
	                    } else {
	                        A += "'" + x + "'";
	                    }
	                }
	            }if (!y) {
	                A += ">";
	            } else {
	                A += "/>";
	            }return A;
	        }function i(y, x) {
	            return "</" + (y.__prefix != null ? y.__prefix + ":" : "") + x + ">";
	        }function s(y, x) {
	            return y.indexOf(x, y.length - x.length) !== -1;
	        }function u(y, x) {
	            if (v.arrayAccessForm == "property" && s(x.toString(), "_asArray") || x.toString().indexOf(v.attributePrefix) == 0 || x.toString().indexOf("__") == 0 || y[x] instanceof Function) {
	                return true;
	            } else {
	                return false;
	            }
	        }function k(z) {
	            var y = 0;if (z instanceof Object) {
	                for (var x in z) {
	                    if (u(z, x)) {
	                        continue;
	                    }y++;
	                }
	            }return y;
	        }function b(z) {
	            var y = [];if (z instanceof Object) {
	                for (var x in z) {
	                    if (x.toString().indexOf("__") == -1 && x.toString().indexOf(v.attributePrefix) == 0) {
	                        y.push(x);
	                    }
	                }
	            }return y;
	        }function f(y) {
	            var x = "";if (y.__cdata != null) {
	                x += "<![CDATA[" + y.__cdata + "]]>";
	            }if (y.__text != null) {
	                if (v.escapeMode) {
	                    x += p(y.__text);
	                } else {
	                    x += y.__text;
	                }
	            }return x;
	        }function c(y) {
	            var x = "";if (y instanceof Object) {
	                x += f(y);
	            } else {
	                if (y != null) {
	                    if (v.escapeMode) {
	                        x += p(y);
	                    } else {
	                        x += y;
	                    }
	                }
	            }return x;
	        }function e(z, B, A) {
	            var x = "";if (z.length == 0) {
	                x += m(z, B, A, true);
	            } else {
	                for (var y = 0; y < z.length; y++) {
	                    x += m(z[y], B, b(z[y]), false);x += d(z[y]);x += i(z[y], B);
	                }
	            }return x;
	        }function d(D) {
	            var x = "";var B = k(D);if (B > 0) {
	                for (var A in D) {
	                    if (u(D, A)) {
	                        continue;
	                    }var z = D[A];var C = b(z);if (z == null || z == undefined) {
	                        x += m(z, A, C, true);
	                    } else {
	                        if (z instanceof Object) {
	                            if (z instanceof Array) {
	                                x += e(z, A, C);
	                            } else {
	                                if (z instanceof Date) {
	                                    x += m(z, A, C, false);x += z.toISOString();x += i(z, A);
	                                } else {
	                                    var y = k(z);if (y > 0 || z.__text != null || z.__cdata != null) {
	                                        x += m(z, A, C, false);x += d(z);x += i(z, A);
	                                    } else {
	                                        x += m(z, A, C, true);
	                                    }
	                                }
	                            }
	                        } else {
	                            x += m(z, A, C, false);x += c(z);x += i(z, A);
	                        }
	                    }
	                }
	            }x += c(D);return x;
	        }this.parseXmlString = function (z) {
	            var B = window.ActiveXObject || "ActiveXObject" in window;if (z === undefined) {
	                return null;
	            }var A;if (window.DOMParser) {
	                var C = new window.DOMParser();var x = null;if (!B) {
	                    try {
	                        x = C.parseFromString("INVALID", "text/xml").childNodes[0].namespaceURI;
	                    } catch (y) {
	                        x = null;
	                    }
	                }try {
	                    A = C.parseFromString(z, "text/xml");if (x != null && A.getElementsByTagNameNS(x, "parsererror").length > 0) {
	                        A = null;
	                    }
	                } catch (y) {
	                    A = null;
	                }
	            } else {
	                if (z.indexOf("<?") == 0) {
	                    z = z.substr(z.indexOf("?>") + 2);
	                }A = new ActiveXObject("Microsoft.XMLDOM");A.async = "false";A.loadXML(z);
	            }return A;
	        };this.asArray = function (x) {
	            if (x === undefined || x == null) {
	                return [];
	            } else {
	                if (x instanceof Array) {
	                    return x;
	                } else {
	                    return [x];
	                }
	            }
	        };this.toXmlDateTime = function (x) {
	            if (x instanceof Date) {
	                return x.toISOString();
	            } else {
	                if (typeof x === "number") {
	                    return new Date(x).toISOString();
	                } else {
	                    return null;
	                }
	            }
	        };this.asDateTime = function (x) {
	            if (typeof x == "string") {
	                return a(x);
	            } else {
	                return x;
	            }
	        };this.xml2json = function (x) {
	            return w(x);
	        };this.xml_str2json = function (x) {
	            var y = this.parseXmlString(x);if (y != null) {
	                return this.xml2json(y);
	            } else {
	                return null;
	            }
	        };this.json2xml_str = function (x) {
	            return d(x);
	        };this.json2xml = function (y) {
	            var x = this.json2xml_str(y);return this.parseXmlString(x);
	        };this.getVersion = function () {
	            return q;
	        };
	    }
	    /** vkBeautify - prettifyXml - https://github.com/vkiryukhin/vkBeautify (MIT license) */
	    function createShiftArr(e) {
	        var r = "    ";if (isNaN(parseInt(e))) r = e;else {
	            r = "";for (var s = 0; e > s; s++) {
	                r += " ";
	            }
	        }var c = ["\n"];for (var ix = 0; ix < 100; ix++) {
	            c.push(c[ix] + r);
	        }return c;
	    }function prettifyXml(e, r) {
	        var s = e.replace(/>\s{0,}</g, "><").replace(/</g, "~::~<").replace(/\s*xmlns\:/g, "~::~xmlns:").replace(/\s*xmlns\=/g, "~::~xmlns=").split("~::~"),
	            c = s.length,
	            a = !1,
	            h = 0,
	            l = "",
	            n = 0,
	            i = r ? createShiftArr(r) : this.shift;for (n = 0; c > n; n++) {
	            s[n].search(/<!/) > -1 ? (l += /*i[h]+*/s[n], a = !0, (s[n].search(/-->/) > -1 || s[n].search(/\]>/) > -1 || s[n].search(/!DOCTYPE/) > -1) && (a = !1)) : s[n].search(/-->/) > -1 || s[n].search(/\]>/) > -1 ? (l += s[n], a = !1) : /^<\w/.exec(s[n - 1]) && /^<\/\w/.exec(s[n]) && /^<[\w:\-\.\,]+/.exec(s[n - 1]) == /^<\/[\w:\-\.\,]+/.exec(s[n])[0].replace("/", "") ? (l += s[n], a || h--) : s[n].search(/<\w/) > -1 && -1 == s[n].search(/<\//) && -1 == s[n].search(/\/>/) ? l = l += a ? s[n] : i[h++] + s[n] : s[n].search(/<\w/) > -1 && s[n].search(/<\//) > -1 ? l = l += a ? s[n] : i[h] + s[n] : s[n].search(/<\//) > -1 ? l = l += a ? s[n] : i[--h] + s[n] : s[n].search(/\/>/) > -1 ? l = l += a ? s[n] : i[h] + s[n] : l += s[n].search(/<\?/) > -1 ? i[h] + s[n] : s[n].search(/xmlns\:/) > -1 || s[n].search(/xmlns\=/) > -1 ? i[h] + s[n] : s[n];
	        }return "\n" == l[0] ? l.slice(1) : l;
	    }

	    var EMPTY_JRXML = ['<jasperReport', 'xmlns="http://jasperreports.sourceforge.net/jasperreports"', 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ', 'xsi:schemaLocation="http://jasperreports.sourceforge.net/jasperreports http://jasperreports.sourceforge.net/xsd/jasperreport.xsd" ', 'name="Untitled Report" ', 'language="groovy" pageWidth="612" pageHeight="792" columnWidth="535" ', 'leftMargin="36" rightMargin="36" topMargin="36" bottomMargin="36">', '<detail>', '<band height="72">', '</band>', '</detail>', '</jasperReport>'].join(' ');

	    ditto.ns('integrations.jasper', ditto);

	    ditto.integrations.jasper.JasperReportDef = function (cfg) {
	        this.setJasperDef(jasperDefFromJRXML(EMPTY_JRXML));
	    };

	    function jasperDefFromJRXML(jrxml) {
	        var x2js = new X2JS();
	        return x2js.xml_str2json(jrxml);
	    }

	    // static method
	    ditto.integrations.jasper.JasperReportDef.fromJRXML = function (jrxmlStr) {
	        var obj = new ditto.integrations.jasper.JasperReportDef();
	        obj.setJasperDef(jasperDefFromJRXML(jrxmlStr));
	        return obj;
	    };

	    $.extend(ditto.integrations.jasper.JasperReportDef.prototype, function () {

	        var inputTypes = [{
	            ditto: ['text'],
	            jasper: ['java.lang.String']
	        }, {
	            ditto: ['number'],
	            jasper: ['java.lang.Integer' /* TODO other types */]
	        }, {
	            ditto: ['date'],
	            jasper: ['java.util.Date']
	        }];

	        var barcodeTypes = [['UPC', 'UPCA'], ['EAN', 'EAN13'], ['ITF14', 'Int2of5'], ['CODE128', 'Code128'], ['CODE39', 'Code39'], ['QR', 'Code39']].map(function (pair) {
	            return {
	                ditto: [pair[0]],
	                jasper: [pair[1]]
	            };
	        });

	        function getMappedValue(collection, from, to, value) {
	            var match = collection.filter(function (mapping) {
	                return mapping[from].indexOf(value) >= 0;
	            });
	            return match.length > 0 ? match[0][to][0] || null : null;
	        }

	        function getJasperValue(collection, jsrValue) {
	            return getMappedValue(collection, 'ditto', 'jasper', jsrValue);
	        }

	        function getJsrValue(collection, jasperValue) {
	            return getMappedValue(collection, 'jasper', 'ditto', jasperValue);
	        }

	        function textIsExpression(text) {
	            return text.indexOf('=') === 0 || text.indexOf('"') === 0 || text.indexOf('$P{') >= 0 || text.indexOf('$F{') >= 0 || text.indexOf('$V{') >= 0;
	        }

	        /** 
	         * JRXML requires child elements in a specific order; this information is
	         * derived from the JRXML schema reference at http://jasperreports.sourceforge.net/schema.reference.html 
	         */
	        var allowedChildOrderings = {
	            'textField': ['reportElement', 'box', 'textElement', 'textFieldExpression', 'patternExpression', 'anchorNameExpression', 'hyperlinkReferenceExpression', 'hyperlinkWhenExpression', 'hyperlinkAnchorExpression', 'hyperlinkPageExpression', 'hyperlinkTooltipExpression', 'hyperlinkParameter'],
	            'jasperReport': ['property', 'import', 'template', 'reportFont', 'style', 'subDataset', 'scriptlet', 'parameter', 'queryString', 'field', 'sortField', 'variable', 'filterExpression', 'group', 'background', 'title', 'pageHeader', 'columnHeader', 'detail', 'columnFooter', 'pageFooter', 'lastPageFooter', 'summary', 'noData'],
	            'lineChart': ['chart', 'categoryDataset', 'linePlot'],
	            'barChart': ['chart', 'categoryDataset', 'barPlot'],
	            'pieChart': ['chart', 'pieDataset', 'piePlot'],
	            'pieDataset': ['dataset', 'pieSeries', 'keyExpression', 'valueExpression', 'labelExpression', 'sectionHyperlink', 'otherKeyExpression', 'otherLabelExpression', 'otherSectionHyperlink'],
	            'categoryDataset': ['dataset', 'categorySeries'],
	            'categorySeries': ['seriesExpression', 'categoryExpression', 'valueExpression', 'labelExpression', 'itemHyperlink'],
	            'linePlot': ['plot', 'categoryAxisLabelExpression', 'categoryAxisFormat', 'valueAxisLabelExpression', 'valueAxisFormat', 'domainAxisMinValueExpression', 'domainAxisMaxValueExpression', 'rangeAxisMinValueExpression', 'rangeAxisMaxValueExpression'],
	            'barPlot': ['plot', 'itemLabel', 'categoryAxisLabelExpression', 'categoryAxisFormat', 'valueAxisLabelExpression', 'valueAxisFormat', 'domainAxisMinValueExpression', 'domainAxisMaxValueExpression', 'rangeAxisMinValueExpression', 'rangeAxisMaxValueExpression'],
	            'piePlot': ['plot', 'itemLabel']
	        };

	        function enforceChildOrdering(nodeName, val) {
	            var ordering = allowedChildOrderings[nodeName];
	            if (ordering) {
	                if (Array.isArray(val)) {
	                    return val.map(function (el) {
	                        return enforceChildOrdering(nodeName, el);
	                    });
	                }
	                if ((typeof val === "undefined" ? "undefined" : _typeof(val)) === 'object') {
	                    var temp = Object.keys(val).map(function (key) {
	                        return { key: key, val: val[key] };
	                    });
	                    temp.sort(function (a, b) {
	                        return ordering.indexOf(a.key) - ordering.indexOf(b.key);
	                    });
	                    val = {};
	                    temp.forEach(function (pair) {
	                        val[pair.key] = pair.val;
	                    });
	                }
	            }
	            return val;
	        }

	        // function findElement(def, jasperId) {
	        //     if (def['$jasperId'] === jasperId) return def;
	        //     var match = null;
	        //     Object.keys(def).forEach(function(key) {
	        //         var val = def[key];
	        //         if (val) {
	        //             var valType = typeof val;
	        //             if (valType !== 'array') {
	        //                 val = [ val ];
	        //             }
	        //             val.forEach(function(el) {
	        //                 if (typeof el === 'object') {
	        //                     match = match || findElement(el, jasperId);
	        //                 }
	        //             });
	        //         }
	        //     });
	        //     return match;
	        // }

	        // function forEachTreeNode(root, fn) {
	        //     fn.call(this, root);
	        //     Object.keys(root).forEach(function(key) {
	        //         var val = root[key];
	        //         if (val) {
	        //             if (!Array.isArray(val)) {
	        //                 val = [ val ];
	        //             }
	        //             val.forEach(function(node) {
	        //                 if (typeof node === 'object') {
	        //                     forEachTreeNode(node, fn);
	        //                 }
	        //             });
	        //         }
	        //     });
	        // }

	        // function find_path_to_element(jasper_el, root, path) {
	        //     if (!path) {
	        //         path = [];
	        //     }
	        //     if (jasper_el === root) {
	        //         console.log('found match');
	        //         return path;
	        //     }
	        //     var keys = Object.keys(root);
	        //     for (var j = 0; j < keys.length; j++) {
	        //         var key = keys[j];
	        //         var val = root[key];
	        //         var newPath = path.concat({
	        //             key: key,
	        //             val: val
	        //         });
	        //         console.log(newPath.map(function(el) { return el.key; }));
	        //         if (Array.isArray(val)) {
	        //             for (var i = 0; i < val.length; i++) {
	        //                 var found = find_path_to_element(jasper_el, val[i], newPath);
	        //                 if (found) {
	        //                     return found;
	        //                 };
	        //             }
	        //         } else if (typeof val === 'object') {
	        //             var found = find_path_to_element(jasper_el, val, newPath);
	        //             if (found) {
	        //                 return found;
	        //             };
	        //         }
	        //     }
	        //     return null;
	        // }

	        function capitalize(word) {
	            return word.charAt(0).toUpperCase() + word.substr(1);
	        }

	        function get_jasper_element_type(jsr_type) {
	            switch (jsr_type) {
	                case 'text':
	                    return 'textField';
	                case 'image':
	                    return 'image';
	                case 'box':
	                    return 'rectangle';
	                case 'barcode':
	                    return 'componentElement';
	                case 'chart_line':
	                    return 'lineChart';
	                case 'chart_pie':
	                    return 'pieChart';
	                case 'chart_bar':
	                    return 'barChart';
	                default:
	                    throw new Error('No known Jasper Reports type for ditto type: ' + jsr_type);
	            }
	        }

	        // var knownJasperElementTypes = ['staticText', 'textField', 'image', 'frame'];
	        var dpi = 72; // Jasper stores units in pixels at 72dpi

	        function requireArray(obj) {
	            if (obj && !Array.isArray(obj)) {
	                return [obj];
	            }
	            return obj;
	        }

	        function arrayFind(arr, predicate) {
	            var value;
	            for (var i = 0, length = arr.length; i < length; i++) {
	                value = arr[i];
	                if (predicate.call(this, value, i, arr)) {
	                    return value;
	                }
	            }
	            return undefined;
	        }

	        var stripQuotes = function stripQuotes(str) {
	            if (str.length > 1 && str[0] === '"' && str[str.length - 1] === '"') {
	                return str.substr(1, str.length - 2);
	            }
	            return str;
	        };

	        return {

	            jsrDefFromJasperDef: function jsrDefFromJasperDef(jasperDef) {
	                var me = this;
	                // console.log(jasperDef);
	                var builder = ditto.createReport(jasperDef._name);
	                builder.data('-');
	                delete builder.def.header;
	                delete builder.def.footer;
	                delete builder.def.page_header;
	                delete builder.def.page_footer;
	                this.ix = 1;
	                this.leftMarginInches = (jasperDef._leftMargin || 0) / dpi;
	                var units = 'inches';
	                builder.page(jasperDef._pageWidth / dpi, jasperDef._pageHeight / dpi, units);
	                builder.margins((jasperDef._topMargin || 0) / dpi, (jasperDef._rightMargin || 0) / dpi, (jasperDef._bottomMargin || 0) / dpi, (jasperDef._leftMargin || 0) / dpi);
	                if (jasperDef.parameter) {
	                    var params = requireArray(jasperDef.parameter);
	                    params.forEach(function (jasperParam) {
	                        jasperParam.$jasperId = me.ix++;
	                        builder.input(jasperParam._name, getJsrValue(inputTypes, jasperParam._class), null, { "$jasperId": jasperParam.$jasperId });
	                    });
	                }
	                this.embeddedSchema = { fields: [] };
	                var stylesheet = {}; // dictionary of classes by classname, no leading period
	                if (jasperDef.field) {
	                    var fields = requireArray(jasperDef.field);
	                    this.embeddedSchema.fields = fields.map(function (jasperField) {
	                        jasperField.$jasperId = me.ix++;
	                        return {
	                            name: jasperField._name,
	                            type: getJsrValue(inputTypes, jasperField._class),
	                            $jasperId: jasperField.$jasperId
	                        };
	                    });
	                }
	                if (jasperDef.style) {
	                    var styles = requireArray(jasperDef.style);
	                    styles.forEach(function (jasperStyle) {
	                        var className = jasperStyle._name;
	                        if (!className) return;
	                        var ruleList = [];
	                        if (jasperStyle._backcolor) {
	                            ruleList.push(['background-color', jasperStyle._backcolor]);
	                        }
	                        if (jasperStyle._forecolor) {
	                            ruleList.push(['color', jasperStyle._forecolor]);
	                        }
	                        if (jasperStyle._hTextAlign) {
	                            ruleList.push(['text-align', jasperStyle._hTextAlign.toLowerCase()]);
	                        }
	                        if (jasperStyle._fontName) {
	                            ruleList.push(['font-family', jasperStyle._fontName]);
	                        }
	                        if (jasperStyle._fontSize) {
	                            ruleList.push(['font-size', jasperStyle._fontSize + "pt"]);
	                        }
	                        if (jasperStyle._isBold) {
	                            ruleList.push(['font-weight', 'bold']);
	                        }
	                        stylesheet[className] = ruleList;
	                    });
	                }
	                this.createSectionIfPresent(jasperDef.title, builder, builder.header);
	                this.createSectionIfPresent(jasperDef.pageHeader, builder, builder.pageHeader);
	                this.createSectionIfPresent(jasperDef.columnHeader, builder, builder.columnHeader);
	                if (jasperDef.group) {
	                    if (!Array.isArray(jasperDef.group)) {
	                        jasperDef.group = [jasperDef.group];
	                    }
	                    jasperDef.group.forEach(function (group) {
	                        group.$jasperId = me.ix++;
	                        builder.groupBy(group.groupExpression.__cdata);
	                        builder.lastLevel.$jasperId = group.$jasperId;
	                        if (group.groupHeader) {
	                            builder.header(group.groupHeader.band._height / dpi);
	                            me.loadBand(group.groupHeader.band, builder);
	                        }
	                        if (group.groupFooter) {
	                            builder.footer(group.groupFooter.band._height / dpi);
	                            me.loadBand(group.groupFooter.band, builder);
	                        }
	                    });
	                }
	                // Have to manually reset level pointer here if groups were added
	                builder.lastLevel = null;
	                this.createSectionIfPresent(jasperDef.detail, builder, builder.detail);
	                this.createSectionIfPresent(jasperDef.columnFooter, builder, builder.columnFooter);
	                this.createSectionIfPresent(jasperDef.pageFooter, builder, builder.pageFooter);
	                this.createSectionIfPresent(jasperDef.summary, builder, builder.footer);
	                var def = builder.done();
	                if (!jasperDef.detail) {
	                    def.body.show_detail = false;
	                }
	                def.stylesheet = stylesheet;
	                // console.log('def is', def);
	                def.type = 'jasper';
	                return def;
	            },

	            setSchema: function setSchema(schema) {
	                this.schemaChanged = true;
	                this.embeddedSchema = schema;
	            },

	            createSectionIfPresent: function createSectionIfPresent(jasperSection, builder, createFn) {
	                if (jasperSection && jasperSection.band && typeof jasperSection.band._height !== 'undefined') {
	                    createFn.call(builder, jasperSection.band._height / dpi);
	                    this.loadBand(jasperSection.band, builder);
	                }
	            },

	            /** Load elements from a Jasper report def band into a ditto ReportBuilder (def).  Def is expected to be pointing at the correct report section. */
	            loadBand: function loadBand(band, def, offset) {
	                var me = this;
	                // Move any grouped elements out into the main band
	                requireArray(band.elementGroup || []).forEach(function (elGroup) {
	                    Object.keys(elGroup).forEach(function (eltType) {
	                        band[eltType] = (band[eltType] || []).concat(requireArray(elGroup[eltType]));
	                    });
	                });
	                Object.keys(band).forEach(function (eltType) {
	                    // skip attributes
	                    if (eltType.indexOf('_') === 0 || eltType === '$jasperId') return;
	                    var els = requireArray(band[eltType]);
	                    if (!els) return;
	                    els.forEach(function (el) {
	                        var rptEl = el.reportElement; //me.get_report_element(el);
	                        el['$jasperId'] = me.ix++;
	                        if (!rptEl) return;
	                        var pos = me.getElementPosition(el);
	                        var extraProps = {
	                            '$jasperId': el['$jasperId'],
	                            '$jasperType': eltType
	                        };
	                        if (offset) {
	                            pos.left += offset.left;
	                            pos.top += offset.top;
	                        }
	                        switch (eltType) {
	                            case 'staticText':
	                                me.readTextElement(el, rptEl, def, pos, extraProps, true);
	                                break;
	                            case 'image':
	                                var url = '';
	                                if (el.imageExpression && el.imageExpression.__cdata) {
	                                    url = el.imageExpression.__cdata;
	                                    if (url.length > 1 && url.charAt(0) === "\"") {
	                                        url = url.substr(1, url.length - 2);
	                                    }
	                                }
	                                def.image(url, pos.left, pos.top, pos.width, pos.height, extraProps);
	                                break;
	                            case 'frame':
	                                def.box(rptEl._backcolor, rptEl._forecolor, pos.left, pos.top, pos.width, pos.height, extraProps);
	                                // Put child elements of the frame into the same section
	                                me.loadBand(el, def, pos);
	                                break;
	                            case 'textField':
	                                me.readTextElement(el, rptEl, def, pos, extraProps, false);
	                                break;
	                            case 'componentElement':
	                                if (el.barbecue) {
	                                    var value = stripQuotes(el.barbecue.codeExpression.__cdata);
	                                    var barcodeType = getJsrValue(barcodeTypes, el.barbecue._type);
	                                    def.barcode(value, barcodeType, pos.left, pos.top, pos.width, pos.height, _.extend(extraProps, {
	                                        show_value: !!el.barbecue.codeExpression._drawText
	                                    }));
	                                } else if (el.QRCode) {
	                                    var _value = stripQuotes(el.QRCode.codeExpression.__cdata);
	                                    def.barcode(_value, 'QR', pos.left, pos.top, pos.width, pos.height, extraProps);
	                                } else {
	                                    console.error('Error: Unrecognized barcode element in JRXML: ', el);
	                                }
	                                break;
	                            default:
	                                extraProps.type = 'unknownJasperElement';
	                                def.text(eltType, pos.left, pos.top, pos.width, pos.height, extraProps);
	                                break;
	                        }
	                    });
	                });
	            },

	            readTextElement: function readTextElement(el, rptEl, def, pos, extraProps, isStatic) {
	                var text = (isStatic ? el.text && el.text.__cdata : el.textFieldExpression && el.textFieldExpression.__cdata) || '';
	                if (el.textElement) {
	                    var font = el.textElement.font;
	                    if (font) {
	                        extraProps.bold = font._isBold === 'true';
	                        extraProps.italic = font._isItalic === 'true';
	                        extraProps.underline = font._isUnderline === 'true';
	                        if (font._size) {
	                            extraProps.fontsize = Number(font._size);
	                        }
	                    }
	                    if (el.textElement._textAlignment) {
	                        extraProps.align = el.textElement._textAlignment;
	                    }
	                }
	                if (rptEl._forecolor) {
	                    extraProps.text_color = rptEl._forecolor;
	                }
	                if (rptEl._backcolor) {
	                    extraProps.background_color = rptEl._backcolor;
	                }
	                if (rptEl._style) {
	                    extraProps.styles = [rptEl._style];
	                }

	                if (el.box) {
	                    (function () {
	                        var box = el.box;
	                        var borders = {};
	                        ['top', 'left', 'bottom', 'right'].forEach(function (side) {
	                            var pen = box[side + "Pen"];
	                            if (pen) {
	                                var width = pen._lineWidth ? pen._lineWidth + "pt" : '';
	                                borders[side] = width + " " + (pen._lineStyle || '').toLowerCase() + " " + (pen._lineColor || '');
	                            }
	                        });
	                        extraProps.borders = borders;
	                    })();
	                }
	                def.text(text, pos.left, pos.top, pos.width, pos.height, extraProps);
	            },

	            getElementPosition: function getElementPosition(jasperEl) {
	                var rptEl = this.get_report_element(jasperEl);
	                return {
	                    left: rptEl._x / dpi,
	                    top: rptEl._y / dpi,
	                    width: rptEl._width / dpi,
	                    height: rptEl._height / dpi
	                };
	            },

	            // instance method, not to be called directly
	            setJasperDef: function setJasperDef(jasperDefObj) {
	                this.jasperDef = jasperDefObj;
	                this.jsrDef = this.jsrDefFromJasperDef(jasperDefObj.jasperReport);
	                // Store copy of jsrDef, for later diffing for changes
	                this.origJsrDef = JSON.parse(JSON.stringify(this.jsrDef));
	            },

	            toJRXML: function toJRXML() {
	                var x2js = new X2JS({ useDoubleQuotes: true, emptyNodeForm: 'object' });
	                var merged_jasper = this.remove_internal_properties(this.merge_all_changes());
	                // console.log('merged jasper is');
	                // console.log(JSON.stringify(merged_jasper, null, 2));
	                // console.log('XML is');
	                // console.log(prettifyXml(x2js.json2xml_str(merged_jasper), 4));
	                return prettifyXml(x2js.json2xml_str(merged_jasper), 4);
	            },

	            remove_internal_properties: function remove_internal_properties(jasperDef) {
	                var lastGroupName = '';
	                var prevKey = '';
	                return JSON.parse(JSON.stringify(jasperDef, function (k, v) {
	                    if (k && k.indexOf('$') === 0) {
	                        return undefined;
	                    }
	                    if (prevKey === 'group' && v._name) {
	                        lastGroupName = v._name;
	                    }
	                    prevKey = k;
	                    if (v && v['$insertGroupId']) {
	                        ['_resetGroup', '_evaluationGroup'].map(function (groupKey) {
	                            if (v.hasOwnProperty(groupKey)) {
	                                v[groupKey] = lastGroupName;
	                            }
	                        });
	                        delete v['$insertGroupId'];
	                    }
	                    v = enforceChildOrdering(k, v);
	                    return v;
	                }));
	            },

	            /** Find changes between origJsrDef and jsrDef and apply to jasperDef */
	            merge_all_changes: function merge_all_changes() {
	                var me = this;
	                // Work on a clone because we may need to merge again in future, keeping original for that
	                var jasperDef = JSON.parse(JSON.stringify(this.jasperDef));
	                this.handle_element_section_moves();
	                this.merge_section(jasperDef.jasperReport, 'title', this.origJsrDef.header, this.jsrDef.header);
	                this.merge_section(jasperDef.jasperReport, 'pageHeader', this.origJsrDef.page_header, this.jsrDef.page_header);
	                if (this.origJsrDef.columns || this.jsrDef.columns && this.jsrDef.columns.header) {
	                    this.merge_section(jasperDef.jasperReport, 'columnHeader', this.origJsrDef.columns ? this.origJsrDef.columns.header : null, this.jsrDef.columns ? this.jsrDef.columns.header : null);
	                }
	                this.merge_section(jasperDef.jasperReport, 'detail', this.origJsrDef.body, this.jsrDef.body);
	                if (this.origJsrDef.columns || this.jsrDef.columns && this.jsrDef.columns.footer) {
	                    this.merge_section(jasperDef.jasperReport, 'columnFooter', this.origJsrDef.columns ? this.origJsrDef.columns.footer : null, this.jsrDef.columns ? this.jsrDef.columns.footer : null);
	                }
	                this.merge_section(jasperDef.jasperReport, 'pageFooter', this.origJsrDef.page_footer, this.jsrDef.page_footer);
	                this.merge_section(jasperDef.jasperReport, 'summary', this.origJsrDef.footer, this.jsrDef.footer);
	                // If there have been any changes to the groups, just blindly overwrite all groups
	                var oldLevels = this.origJsrDef.body.sublevels || [];
	                var newLevels = this.jsrDef.body.sublevels || [];
	                var jasperGroups = requireArray(jasperDef.jasperReport.group || []);
	                // New and changed groups
	                // console.log('new levels are', newLevels);
	                newLevels.forEach(function (currentLevel, index) {
	                    var jasperId = currentLevel.$jasperId;
	                    var origLevel = arrayFind(oldLevels, function (lvl) {
	                        return lvl.$jasperId === jasperId;
	                    });
	                    var jasperGroup;
	                    if (origLevel) {
	                        // changed
	                        jasperGroup = arrayFind(jasperGroups, function (grp) {
	                            return grp.$jasperId === jasperId;
	                        });
	                        if (currentLevel.group_by !== origLevel.group_by) {
	                            jasperGroup.groupExpression = { __cdata: currentLevel.group_by };
	                        }
	                        if (!jasperGroup.groupHeader) {
	                            jasperGroup.groupHeader = { band: {} };
	                        }
	                        if (!jasperGroup.groupFooter) {
	                            jasperGroup.groupFooter = { band: {} };
	                        }
	                        me.merge_section(jasperGroup, 'groupHeader', origLevel.header, currentLevel.header);
	                        me.merge_section(jasperGroup, 'groupFooter', origLevel.footer, currentLevel.footer);
	                    } else {
	                        // new group
	                        if (!jasperDef.jasperReport.group) {
	                            jasperDef.jasperReport.group = [];
	                        }
	                        var jasperGroup = {
	                            _name: 'Group' + String(index + 1),
	                            groupExpression: { __cdata: currentLevel.group_by },
	                            groupHeader: {
	                                band: {}
	                            },
	                            groupFooter: {
	                                band: {}
	                            }
	                        };
	                        jasperGroups.push(jasperGroup);
	                        me.merge_section(jasperGroup, 'groupHeader', null, currentLevel.header);
	                        me.merge_section(jasperGroup, 'groupFooter', null, currentLevel.footer);
	                    }
	                    // console.log('jasper group', JSON.stringify(jasperGroup));
	                });
	                // Deleted groups
	                oldLevels.forEach(function (oldLevel) {
	                    var newLevel = arrayFind(newLevels, function (lvl) {
	                        return lvl.$jasperId === oldLevel.$jasperId;
	                    });
	                    if (!newLevel) {
	                        jasperGroup = arrayFind(jasperGroups, function (grp) {
	                            return grp.$jasperId === oldLevel.$jasperId;
	                        });
	                        jasperGroups.splice(jasperGroups.indexOf(jasperGroup), 1);
	                    }
	                });
	                if (jasperGroups.length === 0) {
	                    delete jasperDef.jasperReport.group;
	                } else {
	                    jasperDef.jasperReport.group = jasperGroups;
	                }
	                if (this.schemaChanged) {
	                    jasperDef.jasperReport.field = this.embeddedSchema.fields.map(function (field) {
	                        return {
	                            _name: field.name,
	                            _class: getJasperValue(inputTypes, field.type)
	                        };
	                    });
	                }
	                return jasperDef;
	            },

	            /** Find an array element by $jasperId property, caching in the provided object */
	            find_by_key: function find_by_key(arr, key_prop, key, cache) {
	                var hit = cache[key];
	                if (hit === null) return null;
	                return hit || (cache[key] = arr.find(function (item) {
	                    return item[key_prop] === key;
	                }) || null);
	            },

	            /** Identify elements that moved between jsr sections and move them in the jasper def */
	            handle_element_section_moves: function handle_element_section_moves() {},

	            // /** Merge a javascript array, taking handler fn to merge an item as argument */
	            // merge_collection: function(out, in_old, in_new, key_prop, merge_element_fn) {
	            //     var me = this;
	            //     var in_new_cache = [];
	            //     var in_old_cache = [];
	            //     // Remove deleted items
	            //     out = out.filter(function(out_item) {
	            //         return !!me.find_by_key(in_new, key_prop, out_item[key_prop], in_new_cache);
	            //     });
	            //     // Add any new items
	            //     in_new.forEach(function(item_new) {
	            //         var item_old = me.find_by_key(in_old, key_prop, item_new[key_prop], in_old_cache);
	            //         if (!item_old) {
	            //             var out_item = {};
	            //             out_item[key_prop] = item_new[key_prop];
	            //             out.push(merge_element_fn.call(me, out_item, null, item_new));
	            //         }
	            //     });
	            //     // Merge changed items
	            //     out.forEach(function(out_item) {
	            //         var old_item = me.find_by_key(in_old, key_prop, out_item[key_prop], in_old_cache);
	            //         var new_item = me.find_by_key(in_new, key_prop, out_item[key_prop], in_new_cache);
	            //         merge_element_fn.call(me, out_item, old_item, new_item);
	            //     });
	            //     // Sort so orderings match
	            //     out.sort(function(a, b) {
	            //         var jsr_a = me.find_by_key(in_new, key_prop, a[key_prop], in_new_cache);
	            //         var jsr_b = me.find_by_key(in_new, key_prop, b[key_prop], in_new_cache);
	            //         return in_new.indexOf(jsr_a) - in_new.indexOf(jsr_b);
	            //     });
	            //     return out;
	            // },

	            /** Special section merge because jasper doesn't store elements as a single collection */
	            merge_section: function merge_section(jasper_parent, section_name, old_section, new_section) {
	                // console.log('merge section', new_section, jasper_section);
	                var jasper_section = jasper_parent[section_name] || { band: {} };
	                if (!new_section) {
	                    if (old_section) {
	                        // Section removed; set band to empty element
	                        jasper_section.band = "";
	                    } else {
	                        // Neither section existed then or now
	                        return;
	                    }
	                } else if (!old_section) {
	                    // Section created
	                    jasper_section.band = {};
	                }
	                // console.log(old_section, new_section, jasper_section);
	                var me = this;
	                var in_new_cache = [];
	                var in_old_cache = [];
	                var jasper_el_types = ['line', 'rectangle', 'textField', 'staticText', 'image', 'componentElement'];
	                var in_new = new_section.elements;
	                // Old section may be null (when it's a new section)
	                var in_old = old_section ? old_section.elements : [];
	                var key_prop = '$jasperId';
	                var framed_els = {};
	                var jasper_band = jasper_section.band;
	                if (!jasper_band) {
	                    throw new Error('Couldn\'t find band for section ' + jasper_section);
	                }
	                if (jasper_band.frame) {
	                    var frames = requireArray(jasper_band.frame);
	                    frames.forEach(function (frameEl) {
	                        jasper_el_types.forEach(function (jtype) {
	                            var els = requireArray(frameEl[jtype]);
	                            if (!els) return;
	                            framed_els[jtype] = (framed_els[jtype] || []).concat(els);
	                        });
	                    });
	                }
	                // Remove deleted items
	                jasper_el_types.forEach(function (type) {
	                    var list = requireArray(jasper_band[type]);
	                    if (!list) return;
	                    var keep = list.filter(function (out_item) {
	                        var found = me.find_by_key(in_new, key_prop, out_item[key_prop], in_new_cache);
	                        if (!found) {
	                            console.warn("Can't find item with " + key_prop + " " + out_item[key_prop] + "; element: " + JSON.stringify(out_item));
	                        }
	                        return !!found;
	                    });
	                    if (keep.length === 0) {
	                        delete jasper_band[type];
	                    } else {
	                        jasper_band[type] = keep;
	                    }
	                });
	                // Add any new items
	                var alreadyProcessedNew = [];
	                in_new.forEach(function (item_new) {
	                    var item_old = me.find_by_key(in_old, key_prop, item_new[key_prop], in_old_cache);
	                    if (!item_old) {
	                        var out_item = {};
	                        out_item[key_prop] = item_new[key_prop];
	                        me.merge_element(out_item, null, item_new);
	                        var jasper_type = item_new['$jasperType'];
	                        var list = jasper_band[jasper_type];
	                        if (!list) {
	                            list = [];
	                        }
	                        if (!Array.isArray(list)) {
	                            list = [list];
	                        }
	                        list.push(out_item);
	                        alreadyProcessedNew.push(item_new);
	                        jasper_band[jasper_type] = list;
	                    }
	                });
	                // Merge changed items
	                jasper_el_types.forEach(function (type) {
	                    [jasper_band, framed_els].forEach(function (jasper_container) {
	                        var list = requireArray(jasper_container[type]);
	                        if (!list) return;
	                        list.forEach(function (out_item) {
	                            var new_item = me.find_by_key(in_new, key_prop, out_item[key_prop], in_new_cache);
	                            if (alreadyProcessedNew.indexOf(new_item) >= 0) return;
	                            var old_item = me.find_by_key(in_old, key_prop, out_item[key_prop], in_old_cache);
	                            me.merge_element(out_item, old_item, new_item);
	                        });
	                        // Sort so orderings match (this is probably not really needed for elements)
	                        list.sort(function (a, b) {
	                            var jsr_a = me.find_by_key(in_new, key_prop, a[key_prop], in_new_cache);
	                            var jsr_b = me.find_by_key(in_new, key_prop, b[key_prop], in_new_cache);
	                            return in_new.indexOf(jsr_a) - in_new.indexOf(jsr_b);
	                        });
	                    });
	                    if (jasper_band[type] && !Array.isArray(jasper_band[type])) {
	                        jasper_band[type] = [jasper_band[type]];
	                    }
	                });
	                var visible = section_name === 'detail' ? new_section.show_detail : new_section.visible;
	                if (visible === false) {
	                    jasper_band._height = 0;
	                } else {
	                    if (!old_section || old_section.height !== new_section.height) {
	                        jasper_band._height = (new_section.height * dpi).toFixed(0);
	                    }
	                }
	                jasper_parent[section_name] = jasper_section;
	            },

	            /** Merge changes from old jsr el to new jsr el into jasper el */
	            merge_element: function merge_element(jasper_el, old_el, new_el) {
	                // console.log('looking at el', new_el, new_el && new_el.$jasperType, old_el);
	                // Find out and save jasper type for new element
	                var me = this;
	                if (!old_el) {
	                    new_el['$jasperType'] = get_jasper_element_type(new_el.type);
	                    old_el = {};
	                }
	                // Handle any deleted properties
	                Object.keys(old_el).forEach(function (old_key) {
	                    if (typeof new_el[old_key] === 'undefined') {
	                        // Deleted property
	                        me.merge_element_property(jasper_el, new_el, old_key, old_el[old_key], undefined);
	                    }
	                });
	                // Changed properties and added properties
	                Object.keys(new_el).forEach(function (new_key) {
	                    // console.log('checking property', new_key, new_el[new_key]);
	                    me.merge_element_property(jasper_el, new_el, new_key, old_el[new_key], new_el[new_key]);
	                });
	                return jasper_el;
	            },

	            /** Translate jsr props back to jasper props, also handling addition/deletion of props */
	            merge_element_property: function merge_element_property(jasper_el, jsr_el, jsr_prop_name, old_val, new_val) {
	                if (new_val !== old_val) {
	                    // Common property handling
	                    var rptEl = this.get_report_element(jasper_el);
	                    switch (jsr_prop_name) {
	                        case 'top':
	                            rptEl._y = (new_val * dpi).toFixed(0);
	                            break;
	                        case 'left':
	                            rptEl._x = (new_val * dpi).toFixed(0);
	                            break;
	                        case 'width':
	                            rptEl._width = (new_val * dpi).toFixed(0);
	                            break;
	                        case 'height':
	                            rptEl._height = (new_val * dpi).toFixed(0);
	                            break;
	                        default:
	                            // Element-type-specific properties
	                            switch (jsr_el.type) {
	                                case 'text':
	                                    this.merge_text_property(jasper_el, jsr_el, jsr_prop_name, old_val, new_val);
	                                    break;
	                                case 'box':
	                                    this.merge_box_property(jasper_el, jsr_el, jsr_prop_name, old_val, new_val);
	                                    break;
	                                case 'image':
	                                    this.merge_image_property(jasper_el, jsr_el, jsr_prop_name, old_val, new_val);
	                                    break;
	                                case 'barcode':
	                                    this.merge_barcode_property(jasper_el, jsr_el, jsr_prop_name, old_val, new_val);
	                                    break;
	                                case 'chart_line':
	                                case 'chart_bar':
	                                case 'chart_pie':
	                                    this.merge_chart_property(jasper_el, jsr_el, jsr_prop_name, old_val, new_val);
	                                    break;
	                            }
	                            break;
	                    }
	                }
	            },

	            merge_text_property: function merge_text_property(jasper_el, jsr_el, prop_name, old_val, new_val) {
	                // console.log('mergetextproperty', prop_name, old_val, new_val);
	                switch (prop_name) {
	                    case 'text':
	                        if (jsr_el['$jasperType'] === 'textField') {
	                            if (textIsExpression(new_val)) {
	                                jasper_el.textFieldExpression = { __cdata: new_val };
	                            } else {
	                                jasper_el.textFieldExpression = { __cdata: '"' + new_val + '"' };
	                            }
	                        } else {
	                            // assume staticText
	                            jasper_el.text = new_val;
	                        }
	                        break;
	                    case 'text_color':
	                        // if (!jasper_el['$style']) {
	                        //     jasper_el['$style'] = {};
	                        // }
	                        // jasper_el['$style'].forecolor = new_val;
	                        this.get_report_element(jasper_el)._forecolor = new_val;
	                        break;
	                    case 'background_color':
	                        // if (!jasper_el['$style']) {
	                        //     jasper_el['$style'] = {};
	                        // }
	                        // jasper_el['$style'].backcolor = new_val;
	                        this.get_report_element(jasper_el)._backcolor = new_val;
	                        break;
	                    case 'align':
	                        this.get_text_element(jasper_el)._textAlignment = capitalize(new_val);
	                        break;
	                    case 'bold':
	                    /* falls through */
	                    case 'italic':
	                    /* falls through */
	                    case 'underline':
	                        this.get_font_node(jasper_el)['_is' + capitalize(prop_name)] = new_val;
	                        break;
	                    case 'fontsize':
	                        this.get_font_node(jasper_el)._size = new_val;
	                        break;
	                    case 'font':
	                        this.get_font_node(jasper_el)._fontName = new_val;
	                        break;
	                    // wrap
	                    // pattern
	                }
	            },

	            get_font_node: function get_font_node(el) {
	                this.get_text_element(el);
	                if (!el.textElement.font) {
	                    el.textElement.font = {};
	                }
	                return el.textElement.font;
	            },

	            get_text_element: function get_text_element(el) {
	                if (!el.textElement) {
	                    el.textElement = {};
	                }
	                return el.textElement;
	            },

	            get_report_element: function get_report_element(el) {
	                if (el.chart) {
	                    el = el.chart;
	                }
	                if (!el.reportElement) {
	                    el.reportElement = {};
	                }
	                return el.reportElement;
	            },

	            merge_box_property: function merge_box_property(jasper_el, jsr_el, prop_name, old_val, new_val) {
	                switch (prop_name) {
	                    case 'corner_radius':
	                        jasper_el._radius = new_val;
	                        break;
	                    case 'background_color':
	                        this.get_report_element(jasper_el)._backcolor = new_val;
	                        break;
	                    case 'border_color':
	                        if (!jasper_el.graphicElement) {
	                            jasper_el.graphicElement = {};
	                        }
	                        if (!jasper_el.graphicElement.pen) {
	                            jasper_el.graphicElement.pen = {};
	                        }
	                        jasper_el.graphicElement.pen._lineColor = new_val;
	                        break;
	                }
	            },

	            merge_barcode_property: function merge_barcode_property(jasper_el, jsr_el, prop_name, old_val, new_val) {
	                switch (prop_name) {
	                    case 'barcode_type':
	                    /* falls through */
	                    case 'value':
	                        // If type OR value changed, delete any existing jr:XXX and replace with a new one
	                        Object.keys(jasper_el).forEach(function (key) {
	                            if (key.indexOf('jr:') === 0) {
	                                delete jasper_el[key];
	                            }
	                        });
	                        if (jsr_el.barcode_type === 'QR') {
	                            jasper_el['jr:QRCode'] = {
	                                '_xmlns:jr': 'http://jasperreports.sourceforge.net/jasperreports/components',
	                                '_xsi:schemaLocation': "http://jasperreports.sourceforge.net/jasperreports/components http://jasperreports.sourceforge.net/xsd/components.xsd",
	                                'jr:codeExpression': {
	                                    __cdata: "\"" + jsr_el.value + "\""
	                                }
	                            };
	                        } else {
	                            jasper_el['jr:barbecue'] = {
	                                '_xmlns:jr': 'http://jasperreports.sourceforge.net/jasperreports/components',
	                                '_xsi:schemaLocation': 'http://jasperreports.sourceforge.net/jasperreports/components http://jasperreports.sourceforge.net/xsd/components.xsd',
	                                _type: getJasperValue(barcodeTypes, jsr_el.barcode_type),
	                                _drawText: jsr_el.show_value,
	                                _checksumRequired: "false",
	                                'jr:codeExpression': {
	                                    __cdata: "\"" + jsr_el.value + "\""
	                                }
	                            };
	                        }
	                        break;
	                }
	            },

	            merge_image_property: function merge_image_property(jasper_el, jsr_el, prop_name, old_val, new_val) {
	                switch (prop_name) {
	                    case 'url':
	                        jasper_el.imageExpression = { __cdata: '"' + new_val + '"' };
	                        break;
	                }
	            },

	            merge_chart_property: function merge_chart_property(jasper_el, jsr_el, prop_name, old_val, new_val) {
	                switch (prop_name) {
	                    case 'series':
	                        var valueField = '';
	                        var labelField = '';
	                        var enclosingGroupId = ''; // FIXME
	                        if (new_val.length > 0) {
	                            var series = new_val[0];
	                            valueField = series.value_field || '';
	                            labelField = series.label_field || '';
	                        }
	                        if (!jasper_el.chart) {
	                            jasper_el.chart = {
	                                _evaluationTime: 'Group',
	                                _evaluationGroup: '',
	                                reportElement: {},
	                                chartTitle: {},
	                                chartSubtitle: {},
	                                chartLegend: {},
	                                '$insertGroupId': true
	                            };
	                            // reportElement may be added in wrong place before
	                            // chart sub-element exists
	                            if (jasper_el.reportElement) {
	                                jasper_el.chart.reportElement = jasper_el.reportElement;
	                                delete jasper_el.reportElement;
	                            }
	                        }
	                        if (jsr_el.type === 'chart_line' || jsr_el.type === 'chart_bar') {
	                            if (!jasper_el.categoryDataset) {
	                                jasper_el.categoryDataset = {
	                                    dataset: {
	                                        _resetType: 'Group',
	                                        _resetGroup: '',
	                                        '$insertGroupId': true
	                                    },
	                                    categorySeries: {
	                                        seriesExpression: { __cdata: '"Series1"' },
	                                        categoryExpression: { __cdata: '$F{' + labelField + '}' },
	                                        valueExpression: { __cdata: '$F{' + valueField + '}' }
	                                    }
	                                };
	                            }
	                        } else if (jsr_el.type === 'chart_pie') {
	                            if (!jasper_el.pieDataset) {
	                                jasper_el.pieDataset = {
	                                    dataset: {
	                                        _resetType: 'Group',
	                                        _resetGroup: '',
	                                        '$insertGroupId': true
	                                    },
	                                    keyExpression: { __cdata: '$F{' + labelField + '}' },
	                                    valueExpression: { __cdata: '$F{' + valueField + '}' }
	                                };
	                            }
	                        }
	                        var plotObj;
	                        var plotKey;
	                        var lineBarPlotObj = {
	                            plot: {},
	                            categoryAxisFormat: {
	                                axisFormat: {}
	                            },
	                            valueAxisFormat: {
	                                axisFormat: {}
	                            }
	                        };
	                        switch (jsr_el.type) {
	                            case 'chart_line':
	                                if (!jasper_el.linePlot) {
	                                    jasper_el.linePlot = lineBarPlotObj;
	                                }
	                                break;
	                            case 'chart_bar':
	                                if (!jasper_el.barPlot) {
	                                    jasper_el.barPlot = lineBarPlotObj;
	                                    jasper_el.barPlot.itemLabel = {};
	                                }
	                                break;
	                            case 'chart_pie':
	                                if (!jasper_el.piePlot) {
	                                    jasper_el.piePlot = {
	                                        plot: {},
	                                        itemLabel: {}
	                                    };
	                                }
	                                break;
	                        }
	                        break;
	                }
	            }

	        };
	    }());
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _designerPlugins = __webpack_require__(294);

	var _designerPlugins2 = _interopRequireDefault(_designerPlugins);

	var _designerPlugins3 = __webpack_require__(295);

	var _designerPlugins4 = _interopRequireDefault(_designerPlugins3);

	var _designer = __webpack_require__(299);

	var _designer2 = _interopRequireDefault(_designer);

	var _ConditionalPropertiesPicker = __webpack_require__(322);

	var _ConditionalPropertiesPicker2 = _interopRequireDefault(_ConditionalPropertiesPicker);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Ditto Designer module root.  Builds ditto-designer.js.
	 * The resulting module should be required as follows:
	 *
	 * var ditto = require('./ditto');
	 * require('./ditto-designer')(ditto);
	 */

	var $ = __webpack_require__(13);


	module.exports = function (ditto) {
	  (0, _designerPlugins2.default)(ditto, $);
	  (0, _designerPlugins4.default)(ditto, $);
	  (0, _designer2.default)(ditto, $);
	  ditto.designer.components = {
	    ConditionalPropertiesPicker: _ConditionalPropertiesPicker2.default
	  };
	};

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';

	/*
	 * Ditto 1.4.122
	 * Copyright (c) 2017 Ditto
	 * http://dittojs.com
	 */

	module.exports = function (ditto, $) {

	    /** @namespace ditto.designer.plugins */
	    ditto.ns('designer.plugins', ditto);

	    /**
	     * @class ReportList
	     * @memberof ditto.designer.plugins
	     * @classdesc Adds a report selector drop-down to the designer toolbar, allowing the user to switch between
	     * report definitions.  Optionally supports a "New" button enabling creation of a new report.  Pass an array
	     * of plugins in the "plugins" config of the designer when creating a designer object, or pass the plugin
	     * configuration along with the pluginType 
	     *
	     * @param {Object} options - Configuration object with the following properties
	     * @param {Boolean} [options.allowNew] - Whether to show a button to create a new report, defaults to true
	     * @param {Boolean} [options.allowDelete] - Whether to show a button to allow deleting the currently selected report, defaults to true
	     * @param {Object} [options.newTemplate] - The report definition object to use as the template when the New Report button is clicked, defaults to built-in default template
	     * @param {string} [options.selectedReportId] - Which report is initially selected; defaults to none
	     * @param {Array} [options.reports] - The list of report definition objects with which to populate the selector.  Reports will be listed alphabetically by title.
	     * @param {Object} [options.listeners] - Event listeners, keyed by event name
	     * @param {string} [options.placeholder] - Placeholder text when no selection is made in the report selector, defaults to 'Select a report'
	     * @param {string} [options.selectorLabel] - Optional label text to show next to the report selector
	     *
	     * @example
	     * // Initialize a designer with a ReportList plugin by passing the plugin config 
	     * // as an element in the plugins config array
	     * var designer = new ditto.Designer({
	     *   dataSources: dataSources,
	     *   report: reportDef,
	     *   plugins: [{
	     *     pluginType: 'ReportList',
	     *     allowNew: true,
	     *     allowDelete: true,
	     *     newTemplate: myTemplateJson,
	     *     reports: [ 
	     *        // array of report definition objects
	     *     ]
	     *   }]
	     * });
	     */
	    ditto.designer.plugins.ReportList = function (cfg) {
	        var me = this;
	        $.extend(true, this, {
	            allowNew: true,
	            allowDelete: true,
	            newTemplate: null,
	            selectedReportId: null,
	            reports: [],
	            listeners: {},
	            placeholder: 'Select a report',
	            selectorLabel: '',
	            selectorCfg: {
	                dropdownAutoWidth: true,
	                minimumResultsForSearch: -1,
	                dropdownCssClass: 'jsr-select2-dropdown'
	            }
	        }, cfg);
	        this.selectorCfg.placeholder = this.placeholder;
	        Object.keys(this.listeners).forEach(function (evtname) {
	            $(me).on(evtname, me.listeners[evtname]);
	        });
	    };

	    $.extend(ditto.designer.plugins.ReportList.prototype, function () {

	        var nextReportId = 1;

	        return {

	            /** Bind this plugin to the designer */
	            bind: function bind(designer) {
	                this.designer = designer;
	                $(designer).on('render', this.onDesignerRender.bind(this));
	            },

	            /** @private */
	            onDesignerRender: function onDesignerRender() {
	                var $nav = this.designer.designer_el.find('.jsr-designer-toolbar');
	                var $wrap = $('<div class="jsr-plugin-reportlist jsr-toolbar-item-left">');
	                this.$select = $('<select class="jsr-plugin-reportlist-select">');
	                var i = 1;
	                this.usedIds = {};
	                this.usedTitles = {};
	                this.reports.forEach(this.validateReport.bind(this));
	                this.sortReports();
	                this.fillSelector();
	                if (this.selectorLabel) {
	                    $wrap.append($('<span class="jsr-plugin-reportlist-label">').text(this.selectorLabel));
	                }
	                $wrap.append(this.$select);
	                if (this.allowNew) {
	                    this.$newButton = $('<button class="jsr-btn jsr-plugin-reportlist-new">New Report</button>');
	                    this.$newButton.on('click', this.onNewButtonClick.bind(this));
	                    $wrap.append(this.$newButton);
	                }
	                if (this.allowDelete) {
	                    this.$deleteButton = $('<button class="jsr-btn jsr-plugin-reportlist-delete">Delete</button>');
	                    this.$deleteButton.on('click', this.onDeleteButtonClick.bind(this));
	                    $wrap.append(this.$deleteButton);
	                }
	                $nav.prepend($wrap);
	                this.$select.select2(this.selectorCfg);
	                this.$select.on('change', this.onSelectorChange.bind(this));
	                var designerReportId = this.designer.getReport();
	                // If no report ID specified for the plugin, take any active report ID from the designer
	                if (designerReportId && !this.selectedReportId) {
	                    this.selectedReportId = designerReportId;
	                }
	                this.onReportChange();
	            },

	            validateReport: function validateReport(report) {
	                if (!report.title) {
	                    report.title = 'Untitled Report';
	                    if (++i > 1) {
	                        report.title += ' ' + String(i);
	                    }
	                }
	                if (!report.id) {
	                    report.id = 'jsr-auto-id-' + String(nextReportId++);
	                } else {
	                    if (this.usedIds[report.id]) {
	                        throw new Error('Duplicate report ID passed to report list plugin: ' + report.id);
	                    }
	                }
	                this.usedIds[report.id] = true;
	            },

	            sortReports: function sortReports() {
	                this.reports.sort(function (a, b) {
	                    return a.title.localeCompare(b.title);
	                });
	            },

	            fillSelector: function fillSelector() {
	                var me = this;
	                this.$select.html('<option></option>');
	                this.reports.forEach(function (report) {
	                    me.$select.append($("<option>").attr('value', report.id).text(report.title));
	                });
	            },

	            /** Handle the user changing the selection in the drop-down */
	            onSelectorChange: function onSelectorChange() {
	                this.selectedReportId = this.$select.select2('val');
	                var selectedReport = this.findReportById(this.selectedReportId);
	                this.designer.setReport(selectedReport);
	                this.onReportChange();

	                /**
	                 * selectreport event fires when the user changes the active report in the drop-down.
	                 * @event selectreport
	                 * @memberof ReportList
	                 * @param {object} event - The jQuery event object
	                 * @param {object} report - The newly selected report definition
	                 */
	                $(this).trigger('selectreport', [selectedReport]);
	            },

	            /** Handle a report selection, including those coming from the designer or initial passed config value */
	            onReportChange: function onReportChange() {
	                this.$select.select2('val', this.selectedReportId || '');
	                if (this.$deleteButton) {
	                    this.$deleteButton.prop('disabled', !this.selectedReportId);
	                }
	            },

	            onNewButtonClick: function onNewButtonClick() {
	                // then generate new default report def (from provided template or default if none)
	                // and fire new event
	                this.createNewReport();
	            },

	            createNewReport: function createNewReport() {
	                var def = JSON.parse(JSON.stringify(this.newTemplate || ditto.defaultReport));
	                this.validateReport(def);
	                var i = 0,
	                    limit = 20,
	                    origTitle = def.title;
	                // Make title unique
	                while (this.reports.some(function (rpt) {
	                    return rpt.title === def.title;
	                }) && i++ < limit) {
	                    def.title = origTitle + ' ' + String(i + 1);
	                }
	                this.reports.push(def);
	                /**
	                 * createreport event fires when the user creates a new report using the New button.
	                 * @event createreport
	                 * @memberof ReportList
	                 * @param {object} event - The jQuery event object
	                 * @param {object} report - The new report definition
	                 */
	                $(this).trigger('createreport', [def]);
	                this.sortReports();
	                this.refreshSelector();
	                this.selectedReportId = def.id;
	                this.onReportChange();
	                this.designer.setReport(def);
	            },

	            onDeleteButtonClick: function onDeleteButtonClick() {
	                var me = this;
	                var report = this.findReportById(this.selectedReportId);
	                if (window.confirm('Are you sure you want to delete "' + (report.title || '') + '"?')) {
	                    me.onDeleteConfirm();
	                }
	            },

	            findReportById: function findReportById(id) {
	                var selectedReport = this.reports.filter(function (rpt) {
	                    return rpt.id === id;
	                });
	                return selectedReport.length > 0 ? selectedReport[0] : null;
	            },

	            refreshSelector: function refreshSelector() {
	                this.$select.select2('destroy');
	                this.fillSelector();
	                this.$select.select2(this.selectorCfg);
	            },

	            onDeleteConfirm: function onDeleteConfirm() {
	                var evt = $.Event('deletereport');
	                var report = this.findReportById(this.selectedReportId);
	                /**
	                 * deletereport event fires when the user deletes a report using the Delete button.
	                 * Listen on this event in order to delete any corresponding saved report definition on
	                 * the server when the report is deleted in the UI.
	                 * To prevent deletion of the report, call preventDefault() on the event object (first argument).
	                 * @event deletereport
	                 * @memberof ReportList
	                 * @param {object} event - The jQuery event object
	                 * @param {object} report - The report definition that was deleted
	                 */
	                $(this).trigger(evt, [report]);
	                if (evt.isDefaultPrevented()) {
	                    // Event cancelled by listener
	                    return;
	                }
	                // Recreate drop-down
	                this.reports = this.reports.filter(function (otherReport) {
	                    return otherReport.id !== report.id;
	                });
	                delete this.usedIds[report.id];
	                this.selectedReportId = null;
	                this.refreshSelector();
	                this.designer.setReport(null);
	                this.onReportChange();
	            }
	        };
	    }());
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(296);

	module.exports = function (ditto, $) {

	    __webpack_require__(298)($);

	    /** @namespace ditto.designer.plugins */
	    ditto.ns('designer.plugins', ditto);

	    /**
	     * @class PreviewButton
	     * @memberof ditto.designer.plugins
	     * @classdesc Adds a button to the designer toolbar that shows a preview of
	     * the current report.
	     *
	     * @param {Object} options - Configuration object with the following properties
	     * @param {Boolean} [options.label] - Text to show in preview button
	     *
	     * @example
	     * var designer = new ditto.Designer({
	     *   dataSources: dataSources,
	     *   report: reportDef,
	     *   plugins: [{
	     *     pluginType: 'PreviewButton',
	     *     label: 'Click for Preview'
	     *   }]
	     * });
	     */
	    ditto.designer.plugins.PreviewButton = function (cfg) {
	        $.extend(true, this, {
	            label: 'Preview'
	        }, cfg);
	    };

	    $.extend(ditto.designer.plugins.PreviewButton.prototype, function () {

	        return {

	            /** Bind this plugin to the designer, used to hook into the designer render event */
	            bind: function bind(designer) {
	                this.designer = designer;
	                $(designer).on('render', this.onDesignerRender.bind(this));
	            },

	            /** @private */
	            onDesignerRender: function onDesignerRender() {
	                var $nav = this.designer.designer_el.find('.jsr-designer-toolbar');
	                var $wrap = $('<span class="jsr-designer-plugin-previewbutton jsr-toolbar-item-right"></span>');
	                this.$newButton = $('<button class="jsr-btn jsr-plugin-reportlist-new"></button>').text(this.label);
	                this.$newButton.on('click', this.onButtonClick.bind(this));
	                $wrap.append(this.$newButton);
	                $nav.append($wrap);
	            },

	            onButtonClick: function onButtonClick() {
	                var designer = this.designer;
	                var report = designer.getReport();
	                if (!this.modalDiv) {
	                    this.modalDiv = $('<div class="jsr-designer-preview-content"></div>');
	                    $(document.body).append(this.modalDiv);
	                }
	                this.modalDiv.html('');
	                $(this.modalDiv).css({
	                    width: $(window).width() - 150 + 'px',
	                    height: $(window).height() - 150 + 'px'
	                });
	                $.featherlight(this.modalDiv, {
	                    variant: 'jsr-featherlight',
	                    // Featherlight relies on "this" in its afterOpen callback
	                    afterOpen: function afterOpen() {
	                        this.$content.html('');
	                        var viewer = ditto.render({
	                            report_def: report,
	                            target: this.$content,
	                            datasets: designer.data_sources,
	                            customElements: designer.customElements || []
	                        });
	                    }
	                });
	            }

	        };
	    }());
	}; /*
	    * Ditto 1.4.122
	    * Copyright (c) 2017 Ditto
	    * http://dittojs.com
	    */

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(297);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./featherlight.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./featherlight.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, "/**\n * Featherlight – ultra slim jQuery lightbox\n * Version 1.7.1 - http://noelboss.github.io/featherlight/\n *\n * Copyright 2017, Noël Raoul Bossart (http://www.noelboss.com)\n * MIT Licensed.\n**/\n@media all {\n  .featherlight {\n    display: none;\n\n    /* dimensions: spanning the background from edge to edge */\n    position:fixed;\n    top: 0; right: 0; bottom: 0; left: 0;\n    z-index: 2147483647; /* z-index needs to be >= elements on the site. */\n\n    /* position: centering content */\n    text-align: center;\n\n    /* insures that the ::before pseudo element doesn't force wrap with fixed width content; */\n    white-space: nowrap;\n\n    /* styling */\n    cursor: pointer;\n    background: #333;\n    /* IE8 \"hack\" for nested featherlights */\n    background: rgba(0, 0, 0, 0);\n  }\n\n  /* support for nested featherlights. Does not work in IE8 (use JS to fix) */\n  .featherlight:last-of-type {\n    background: rgba(0, 0, 0, 0.8);\n  }\n\n  .featherlight:before {\n    /* position: trick to center content vertically */\n    content: '';\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n  }\n\n  .featherlight .featherlight-content {\n    /* make content container for positioned elements (close button) */\n    position: relative;\n\n    /* position: centering vertical and horizontal */\n    text-align: left;\n    vertical-align: middle;\n    display: inline-block;\n\n    /* dimensions: cut off images */\n    overflow: auto;\n    padding: 25px 25px 0;\n    border-bottom: 25px solid transparent;\n\n    /* dimensions: handling large content */\n    margin-left: 5%;\n    margin-right: 5%;\n    max-height: 95%;\n\n    /* styling */\n    background: #fff;\n    cursor: auto;\n\n    /* reset white-space wrapping */\n    white-space: normal;\n  }\n\n  /* contains the content */\n  .featherlight .featherlight-inner {\n    /* make sure its visible */\n    display: block;\n  }\n\n  .featherlight .featherlight-close-icon {\n    /* position: centering vertical and horizontal */\n    position: absolute;\n    z-index: 9999;\n    top: 0;\n    right: 0;\n\n    /* dimensions: 25px x 25px */\n    line-height: 25px;\n    width: 25px;\n\n    /* styling */\n    cursor: pointer;\n    text-align: center;\n    font-family: Arial, sans-serif;\n    background: #fff; /* Set the background in case it overlaps the content */\n    background: rgba(255, 255, 255, 0.3);\n    color: #000;\n    border: none;\n    padding: 0;\n  }\n\n  /* See http://stackoverflow.com/questions/16077341/how-to-reset-all-default-styles-of-the-html5-button-element */\n  .featherlight .featherlight-close-icon::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n\n  .featherlight .featherlight-image {\n    /* styling */\n    width: 100%;\n  }\n\n\n  .featherlight-iframe .featherlight-content {\n    /* removed the border for image croping since iframe is edge to edge */\n    border-bottom: 0;\n    padding: 0;\n    -webkit-overflow-scrolling: touch;\n    overflow-y: scroll;\n  }\n\n  .featherlight iframe {\n    /* styling */\n    border: none;\n  }\n\n  .featherlight * { /* See https://github.com/noelboss/featherlight/issues/42 */\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n}\n\n/* handling phones and small screens */\n@media only screen and (max-width: 1024px) {\n  .featherlight .featherlight-content {\n    /* dimensions: maximize lightbox with for small screens */\n    margin-left: 0;\n    margin-right: 0;\n    max-height: 98%;\n\n    padding: 10px 10px 0;\n    border-bottom: 10px solid transparent;\n  }\n}", ""]);

	// exports


/***/ },
/* 298 */
/***/ function(module, exports) {

	/**
	 * Featherlight - ultra slim jQuery lightbox
	 * Version 1.7.1 - http://noelboss.github.io/featherlight/
	 *
	 * Copyright 2017, Noël Raoul Bossart (http://www.noelboss.com)
	 * MIT Licensed.
	**/
	module.exports = function($) {
	  "use strict";

	  if('undefined' === typeof $) {
	    if('console' in window){ window.console.info('Too much lightness, Featherlight needs jQuery.'); }
	    return;
	  }

	  /* Featherlight is exported as $.featherlight.
	     It is a function used to open a featherlight lightbox.

	     [tech]
	     Featherlight uses prototype inheritance.
	     Each opened lightbox will have a corresponding object.
	     That object may have some attributes that override the
	     prototype's.
	     Extensions created with Featherlight.extend will have their
	     own prototype that inherits from Featherlight's prototype,
	     thus attributes can be overriden either at the object level,
	     or at the extension level.
	     To create callbacks that chain themselves instead of overriding,
	     use chainCallbacks.
	     For those familiar with CoffeeScript, this correspond to
	     Featherlight being a class and the Gallery being a class
	     extending Featherlight.
	     The chainCallbacks is used since we don't have access to
	     CoffeeScript's `super`.
	  */

	  function Featherlight($content, config) {
	    if(this instanceof Featherlight) {  /* called with new */
	      this.id = Featherlight.id++;
	      this.setup($content, config);
	      this.chainCallbacks(Featherlight._callbackChain);
	    } else {
	      var fl = new Featherlight($content, config);
	      fl.open();
	      return fl;
	    }
	  }

	  var opened = [],
	    pruneOpened = function(remove) {
	      opened = $.grep(opened, function(fl) {
	        return fl !== remove && fl.$instance.closest('body').length > 0;
	      } );
	      return opened;
	    };

	  // Removes keys of `set` from `obj` and returns the removed key/values.
	  function slice(obj, set) {
	    var r = {};
	    for (var key in obj) {
	      if (key in set) {
	        r[key] = obj[key];
	        delete obj[key];
	      }
	    }
	    return r;
	  }

	  // NOTE: List of available [iframe attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe).
	  var iFrameAttributeSet = {
	    allowfullscreen: 1, frameborder: 1, height: 1, longdesc: 1, marginheight: 1, marginwidth: 1,
	    name: 1, referrerpolicy: 1, scrolling: 1, sandbox: 1, src: 1, srcdoc: 1, width: 1
	  };

	  // Converts camelCased attributes to dasherized versions for given prefix:
	  //   parseAttrs({hello: 1, hellFrozeOver: 2}, 'hell') => {froze-over: 2}
	  function parseAttrs(obj, prefix) {
	    var attrs = {},
	      regex = new RegExp('^' + prefix + '([A-Z])(.*)');
	    for (var key in obj) {
	      var match = key.match(regex);
	      if (match) {
	        var dasherized = (match[1] + match[2].replace(/([A-Z])/g, '-$1')).toLowerCase();
	        attrs[dasherized] = obj[key];
	      }
	    }
	    return attrs;
	  }

	  /* document wide key handler */
	  var eventMap = { keyup: 'onKeyUp', resize: 'onResize' };

	  var globalEventHandler = function(event) {
	    $.each(Featherlight.opened().reverse(), function() {
	      if (!event.isDefaultPrevented()) {
	        if (false === this[eventMap[event.type]](event)) {
	          event.preventDefault(); event.stopPropagation(); return false;
	        }
	      }
	    });
	  };

	  var toggleGlobalEvents = function(set) {
	      if(set !== Featherlight._globalHandlerInstalled) {
	        Featherlight._globalHandlerInstalled = set;
	        var events = $.map(eventMap, function(_, name) { return name+'.'+Featherlight.prototype.namespace; } ).join(' ');
	        $(window)[set ? 'on' : 'off'](events, globalEventHandler);
	      }
	    };

	  Featherlight.prototype = {
	    constructor: Featherlight,
	    /*** defaults ***/
	    /* extend featherlight with defaults and methods */
	    namespace:      'featherlight',        /* Name of the events and css class prefix */
	    targetAttr:     'data-featherlight',   /* Attribute of the triggered element that contains the selector to the lightbox content */
	    variant:        null,                  /* Class that will be added to change look of the lightbox */
	    resetCss:       false,                 /* Reset all css */
	    background:     null,                  /* Custom DOM for the background, wrapper and the closebutton */
	    openTrigger:    'click',               /* Event that triggers the lightbox */
	    closeTrigger:   'click',               /* Event that triggers the closing of the lightbox */
	    filter:         null,                  /* Selector to filter events. Think $(...).on('click', filter, eventHandler) */
	    root:           'body',                /* Where to append featherlights */
	    openSpeed:      250,                   /* Duration of opening animation */
	    closeSpeed:     250,                   /* Duration of closing animation */
	    closeOnClick:   'background',          /* Close lightbox on click ('background', 'anywhere' or false) */
	    closeOnEsc:     true,                  /* Close lightbox when pressing esc */
	    closeIcon:      '&#10005;',            /* Close icon */
	    loading:        '',                    /* Content to show while initial content is loading */
	    persist:        false,                 /* If set, the content will persist and will be shown again when opened again. 'shared' is a special value when binding multiple elements for them to share the same content */
	    otherClose:     null,                  /* Selector for alternate close buttons (e.g. "a.close") */
	    beforeOpen:     $.noop,                /* Called before open. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
	    beforeContent:  $.noop,                /* Called when content is loaded. Gets event as parameter, this contains all data */
	    beforeClose:    $.noop,                /* Called before close. can return false to prevent opening of lightbox. Gets event as parameter, this contains all data */
	    afterOpen:      $.noop,                /* Called after open. Gets event as parameter, this contains all data */
	    afterContent:   $.noop,                /* Called after content is ready and has been set. Gets event as parameter, this contains all data */
	    afterClose:     $.noop,                /* Called after close. Gets event as parameter, this contains all data */
	    onKeyUp:        $.noop,                /* Called on key up for the frontmost featherlight */
	    onResize:       $.noop,                /* Called after new content and when a window is resized */
	    type:           null,                  /* Specify type of lightbox. If unset, it will check for the targetAttrs value. */
	    contentFilters: ['jquery', 'image', 'html', 'ajax', 'iframe', 'text'], /* List of content filters to use to determine the content */

	    /*** methods ***/
	    /* setup iterates over a single instance of featherlight and prepares the background and binds the events */
	    setup: function(target, config){
	      /* all arguments are optional */
	      if (typeof target === 'object' && target instanceof $ === false && !config) {
	        config = target;
	        target = undefined;
	      }

	      var self = $.extend(this, config, {target: target}),
	        css = !self.resetCss ? self.namespace : self.namespace+'-reset', /* by adding -reset to the classname, we reset all the default css */
	        $background = $(self.background || [
	          '<div class="'+css+'-loading '+css+'">',
	            '<div class="'+css+'-content">',
	              '<button class="'+css+'-close-icon '+ self.namespace + '-close" aria-label="Close">',
	                self.closeIcon,
	              '</button>',
	              '<div class="'+self.namespace+'-inner">' + self.loading + '</div>',
	            '</div>',
	          '</div>'].join('')),
	        closeButtonSelector = '.'+self.namespace+'-close' + (self.otherClose ? ',' + self.otherClose : '');

	      self.$instance = $background.clone().addClass(self.variant); /* clone DOM for the background, wrapper and the close button */

	      /* close when click on background/anywhere/null or closebox */
	      self.$instance.on(self.closeTrigger+'.'+self.namespace, function(event) {
	        var $target = $(event.target);
	        if( ('background' === self.closeOnClick  && $target.is('.'+self.namespace))
	          || 'anywhere' === self.closeOnClick
	          || $target.closest(closeButtonSelector).length ){
	          self.close(event);
	          event.preventDefault();
	        }
	      });

	      return this;
	    },

	    /* this method prepares the content and converts it into a jQuery object or a promise */
	    getContent: function(){
	      if(this.persist !== false && this.$content) {
	        return this.$content;
	      }
	      var self = this,
	        filters = this.constructor.contentFilters,
	        readTargetAttr = function(name){ return self.$currentTarget && self.$currentTarget.attr(name); },
	        targetValue = readTargetAttr(self.targetAttr),
	        data = self.target || targetValue || '';

	      /* Find which filter applies */
	      var filter = filters[self.type]; /* check explicit type like {type: 'image'} */

	      /* check explicit type like data-featherlight="image" */
	      if(!filter && data in filters) {
	        filter = filters[data];
	        data = self.target && targetValue;
	      }
	      data = data || readTargetAttr('href') || '';

	      /* check explicity type & content like {image: 'photo.jpg'} */
	      if(!filter) {
	        for(var filterName in filters) {
	          if(self[filterName]) {
	            filter = filters[filterName];
	            data = self[filterName];
	          }
	        }
	      }

	      /* otherwise it's implicit, run checks */
	      if(!filter) {
	        var target = data;
	        data = null;
	        $.each(self.contentFilters, function() {
	          filter = filters[this];
	          if(filter.test)  {
	            data = filter.test(target);
	          }
	          if(!data && filter.regex && target.match && target.match(filter.regex)) {
	            data = target;
	          }
	          return !data;
	        });
	        if(!data) {
	          if('console' in window){ window.console.error('Featherlight: no content filter found ' + (target ? ' for "' + target + '"' : ' (no target specified)')); }
	          return false;
	        }
	      }
	      /* Process it */
	      return filter.process.call(self, data);
	    },

	    /* sets the content of $instance to $content */
	    setContent: function($content){
	      var self = this;
	      /* we need a special class for the iframe */
	      if($content.is('iframe')) {
	        self.$instance.addClass(self.namespace+'-iframe');
	      }

	      self.$instance.removeClass(self.namespace+'-loading');

	      /* replace content by appending to existing one before it is removed
	         this insures that featherlight-inner remain at the same relative
	         position to any other items added to featherlight-content */
	      self.$instance.find('.'+self.namespace+'-inner')
	        .not($content)                /* excluded new content, important if persisted */
	        .slice(1).remove().end()      /* In the unexpected event where there are many inner elements, remove all but the first one */
	        .replaceWith($.contains(self.$instance[0], $content[0]) ? '' : $content);

	      self.$content = $content.addClass(self.namespace+'-inner');

	      return self;
	    },

	    /* opens the lightbox. "this" contains $instance with the lightbox, and with the config.
	      Returns a promise that is resolved after is successfully opened. */
	    open: function(event){
	      var self = this;
	      self.$instance.hide().appendTo(self.root);
	      if((!event || !event.isDefaultPrevented())
	        && self.beforeOpen(event) !== false) {

	        if(event){
	          event.preventDefault();
	        }
	        var $content = self.getContent();

	        if($content) {
	          opened.push(self);

	          toggleGlobalEvents(true);

	          self.$instance.fadeIn(self.openSpeed);
	          self.beforeContent(event);

	          /* Set content and show */
	          return $.when($content)
	            .always(function($content){
	              self.setContent($content);
	              self.afterContent(event);
	            })
	            .then(self.$instance.promise())
	            /* Call afterOpen after fadeIn is done */
	            .done(function(){ self.afterOpen(event); });
	        }
	      }
	      self.$instance.detach();
	      return $.Deferred().reject().promise();
	    },

	    /* closes the lightbox. "this" contains $instance with the lightbox, and with the config
	      returns a promise, resolved after the lightbox is successfully closed. */
	    close: function(event){
	      var self = this,
	        deferred = $.Deferred();

	      if(self.beforeClose(event) === false) {
	        deferred.reject();
	      } else {

	        if (0 === pruneOpened(self).length) {
	          toggleGlobalEvents(false);
	        }

	        self.$instance.fadeOut(self.closeSpeed,function(){
	          self.$instance.detach();
	          self.afterClose(event);
	          deferred.resolve();
	        });
	      }
	      return deferred.promise();
	    },

	    /* resizes the content so it fits in visible area and keeps the same aspect ratio.
	        Does nothing if either the width or the height is not specified.
	        Called automatically on window resize.
	        Override if you want different behavior. */
	    resize: function(w, h) {
	      if (w && h) {
	        /* Reset apparent image size first so container grows */
	        this.$content.css('width', '').css('height', '');
	        /* Calculate the worst ratio so that dimensions fit */
	         /* Note: -1 to avoid rounding errors */
	        var ratio = Math.max(
	          w  / (parseInt(this.$content.parent().css('width'),10)-1),
	          h / (parseInt(this.$content.parent().css('height'),10)-1));
	        /* Resize content */
	        if (ratio > 1) {
	          ratio = h / Math.floor(h / ratio); /* Round ratio down so height calc works */
	          this.$content.css('width', '' + w / ratio + 'px').css('height', '' + h / ratio + 'px');
	        }
	      }
	    },

	    /* Utility function to chain callbacks
	       [Warning: guru-level]
	       Used be extensions that want to let users specify callbacks but
	       also need themselves to use the callbacks.
	       The argument 'chain' has callback names as keys and function(super, event)
	       as values. That function is meant to call `super` at some point.
	    */
	    chainCallbacks: function(chain) {
	      for (var name in chain) {
	        this[name] = $.proxy(chain[name], this, $.proxy(this[name], this));
	      }
	    }
	  };

	  $.extend(Featherlight, {
	    id: 0,                                    /* Used to id single featherlight instances */
	    autoBind:       '[data-featherlight]',    /* Will automatically bind elements matching this selector. Clear or set before onReady */
	    defaults:       Featherlight.prototype,   /* You can access and override all defaults using $.featherlight.defaults, which is just a synonym for $.featherlight.prototype */
	    /* Contains the logic to determine content */
	    contentFilters: {
	      jquery: {
	        regex: /^[#.]\w/,         /* Anything that starts with a class name or identifiers */
	        test: function(elem)    { return elem instanceof $ && elem; },
	        process: function(elem) { return this.persist !== false ? $(elem) : $(elem).clone(true); }
	      },
	      image: {
	        regex: /\.(png|jpg|jpeg|gif|tiff|bmp|svg)(\?\S*)?$/i,
	        process: function(url)  {
	          var self = this,
	            deferred = $.Deferred(),
	            img = new Image(),
	            $img = $('<img src="'+url+'" alt="" class="'+self.namespace+'-image" />');
	          img.onload  = function() {
	            /* Store naturalWidth & height for IE8 */
	            $img.naturalWidth = img.width; $img.naturalHeight = img.height;
	            deferred.resolve( $img );
	          };
	          img.onerror = function() { deferred.reject($img); };
	          img.src = url;
	          return deferred.promise();
	        }
	      },
	      html: {
	        regex: /^\s*<[\w!][^<]*>/, /* Anything that starts with some kind of valid tag */
	        process: function(html) { return $(html); }
	      },
	      ajax: {
	        regex: /./,            /* At this point, any content is assumed to be an URL */
	        process: function(url)  {
	          var self = this,
	            deferred = $.Deferred();
	          /* we are using load so one can specify a target with: url.html #targetelement */
	          var $container = $('<div></div>').load(url, function(response, status){
	            if ( status !== "error" ) {
	              deferred.resolve($container.contents());
	            }
	            deferred.fail();
	          });
	          return deferred.promise();
	        }
	      },
	      iframe: {
	        process: function(url) {
	          var deferred = new $.Deferred();
	          var $content = $('<iframe/>');
	          var css = parseAttrs(this, 'iframe');
	          var attrs = slice(css, iFrameAttributeSet);
	          $content.hide()
	            .attr('src', url)
	            .attr(attrs)
	            .css(css)
	            .on('load', function() { deferred.resolve($content.show()); })
	            // We can't move an <iframe> and avoid reloading it,
	            // so let's put it in place ourselves right now:
	            .appendTo(this.$instance.find('.' + this.namespace + '-content'));
	          return deferred.promise();
	        }
	      },
	      text: {
	        process: function(text) { return $('<div>', {text: text}); }
	      }
	    },

	    functionAttributes: ['beforeOpen', 'afterOpen', 'beforeContent', 'afterContent', 'beforeClose', 'afterClose'],

	    /*** class methods ***/
	    /* read element's attributes starting with data-featherlight- */
	    readElementConfig: function(element, namespace) {
	      var Klass = this,
	        regexp = new RegExp('^data-' + namespace + '-(.*)'),
	        config = {};
	      if (element && element.attributes) {
	        $.each(element.attributes, function(){
	          var match = this.name.match(regexp);
	          if (match) {
	            var val = this.value,
	              name = $.camelCase(match[1]);
	            if ($.inArray(name, Klass.functionAttributes) >= 0) {  /* jshint -W054 */
	              val = new Function(val);                           /* jshint +W054 */
	            } else {
	              try { val = JSON.parse(val); }
	              catch(e) {}
	            }
	            config[name] = val;
	          }
	        });
	      }
	      return config;
	    },

	    /* Used to create a Featherlight extension
	       [Warning: guru-level]
	       Creates the extension's prototype that in turn
	       inherits Featherlight's prototype.
	       Could be used to extend an extension too...
	       This is pretty high level wizardy, it comes pretty much straight
	       from CoffeeScript and won't teach you anything about Featherlight
	       as it's not really specific to this library.
	       My suggestion: move along and keep your sanity.
	    */
	    extend: function(child, defaults) {
	      /* Setup class hierarchy, adapted from CoffeeScript */
	      var Ctor = function(){ this.constructor = child; };
	      Ctor.prototype = this.prototype;
	      child.prototype = new Ctor();
	      child.__super__ = this.prototype;
	      /* Copy class methods & attributes */
	      $.extend(child, this, defaults);
	      child.defaults = child.prototype;
	      return child;
	    },

	    attach: function($source, $content, config) {
	      var Klass = this;
	      if (typeof $content === 'object' && $content instanceof $ === false && !config) {
	        config = $content;
	        $content = undefined;
	      }
	      /* make a copy */
	      config = $.extend({}, config);

	      /* Only for openTrigger and namespace... */
	      var namespace = config.namespace || Klass.defaults.namespace,
	        tempConfig = $.extend({}, Klass.defaults, Klass.readElementConfig($source[0], namespace), config),
	        sharedPersist;
	      var handler = function(event) {
	        /* ... since we might as well compute the config on the actual target */
	        var elemConfig = $.extend(
	          {$source: $source, $currentTarget: $(this)},
	          Klass.readElementConfig($source[0], tempConfig.namespace),
	          Klass.readElementConfig(this, tempConfig.namespace),
	          config);
	        var fl = sharedPersist || $(this).data('featherlight-persisted') || new Klass($content, elemConfig);
	        if(fl.persist === 'shared') {
	          sharedPersist = fl;
	        } else if(fl.persist !== false) {
	          $(this).data('featherlight-persisted', fl);
	        }
	        elemConfig.$currentTarget.blur(); // Otherwise 'enter' key might trigger the dialog again
	        fl.open(event);
	      };

	      $source.on(tempConfig.openTrigger+'.'+tempConfig.namespace, tempConfig.filter, handler);

	      return handler;
	    },

	    current: function() {
	      var all = this.opened();
	      return all[all.length - 1] || null;
	    },

	    opened: function() {
	      var klass = this;
	      pruneOpened();
	      return $.grep(opened, function(fl) { return fl instanceof klass; } );
	    },

	    close: function(event) {
	      var cur = this.current();
	      if(cur) { return cur.close(event); }
	    },

	    /* Does the auto binding on startup.
	       Meant only to be used by Featherlight and its extensions
	    */
	    _onReady: function() {
	      var Klass = this;
	      if(Klass.autoBind){
	        /* Bind existing elements */
	        $(Klass.autoBind).each(function(){
	          Klass.attach($(this));
	        });
	        /* If a click propagates to the document level, then we have an item that was added later on */
	        $(document).on('click', Klass.autoBind, function(evt) {
	          if (evt.isDefaultPrevented()) {
	            return;
	          }
	          /* Bind featherlight */
	          var handler = Klass.attach($(evt.currentTarget));
	          /* Dispatch event directly */
	          handler(evt);
	        });
	      }
	    },

	    /* Featherlight uses the onKeyUp callback to intercept the escape key.
	       Private to Featherlight.
	    */
	    _callbackChain: {
	      onKeyUp: function(_super, event){
	        if(27 === event.keyCode) {
	          if (this.closeOnEsc) {
	            $.featherlight.close(event);
	          }
	          return false;
	        } else {
	          return _super(event);
	        }
	      },

	      beforeOpen: function(_super, event) {
	        // Remember focus:
	        this._previouslyActive = document.activeElement;

	        // Disable tabbing:
	        // See http://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus
	        this._$previouslyTabbable = $("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]")
	          .not('[tabindex]')
	          .not(this.$instance.find('button'));

	        this._$previouslyWithTabIndex = $('[tabindex]').not('[tabindex="-1"]');
	        this._previousWithTabIndices = this._$previouslyWithTabIndex.map(function(_i, elem) {
	          return $(elem).attr('tabindex');
	        });

	        this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr('tabindex', -1);

	        document.activeElement.blur();
	        return _super(event);
	      },

	      afterClose: function(_super, event) {
	        var r = _super(event);
	        var self = this;
	        this._$previouslyTabbable.removeAttr('tabindex');
	        this._$previouslyWithTabIndex.each(function(i, elem) {
	          $(elem).attr('tabindex', self._previousWithTabIndices[i]);
	        });
	        this._previouslyActive.focus();
	        return r;
	      },

	      onResize: function(_super, event){
	        this.resize(this.$content.naturalWidth, this.$content.naturalHeight);
	        return _super(event);
	      },

	      afterContent: function(_super, event){
	        var r = _super(event);
	        this.$instance.find('[autofocus]:not([disabled])').focus();
	        this.onResize(event);
	        return r;
	      }
	    }
	  });

	  $.featherlight = Featherlight;

	  /* bind jQuery elements to trigger featherlight */
	  $.fn.featherlight = function($content, config) {
	    Featherlight.attach(this, $content, config);
	    return this;
	  };

	  /* bind featherlight on ready if config autoBind is set */
	  $(document).ready(function(){ Featherlight._onReady(); });
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** 
	                                                                                                                                                                                                                                                                   * @name ditto
	                                                                                                                                                                                                                                                                   * @namespace
	                                                                                                                                                                                                                                                                   */

	var _dropzone = __webpack_require__(300);

	var _dropzone2 = _interopRequireDefault(_dropzone);

	__webpack_require__(301);

	var _ReportElement = __webpack_require__(2);

	var _textarea = __webpack_require__(303);

	var _textarea2 = _interopRequireDefault(_textarea);

	var _textcomplete = __webpack_require__(312);

	var _textcomplete2 = _interopRequireDefault(_textcomplete);

	var _fonts = __webpack_require__(14);

	var _fonts2 = _interopRequireDefault(_fonts);

	var _Popup = __webpack_require__(22);

	var _Popup2 = _interopRequireDefault(_Popup);

	var _ConditionalPropertiesPicker = __webpack_require__(322);

	var _ConditionalPropertiesPicker2 = _interopRequireDefault(_ConditionalPropertiesPicker);

	var _designerActions = __webpack_require__(325);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	module.exports = function (ditto, $) {

	  __webpack_require__(24)($);
	  __webpack_require__(283)($);
	  __webpack_require__(326)($);
	  var dimple = __webpack_require__(183);
	  __webpack_require__(327)($);
	  __webpack_require__(328)($);
	  __webpack_require__(329)($);
	  __webpack_require__(284)(ditto, $);
	  var QRCode = __webpack_require__(277)(window);
	  var _ = __webpack_require__(3);
	  var showdown = __webpack_require__(282);

	  // let locale = require('json!./locales/EN_US.json')

	  var nextReportAutoId = 0;
	  var PRE_1_2_9_Y_SCALE_FACTOR = 1 / 82;
	  var ONCHANGE_DELAY_MS = 100;

	  var logged = {};
	  var productName = 'jsreports';

	  var t = ditto.translate;

	  function escapeHtml(unsafe) {
	    return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
	  }

	  var unknownElementIcon = 'data:image/svg+xml;base64,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';
	  var ZOOM_LEVELS = [0.5, 1, 1.5, 2];

	  /**
	   * @class
	   *
	   * A drag-and-drop report designer component.
	   *
	   * @param {Object} options
	   * @param {string} [options.reportDef] - The report definition object to edit.  If not provided, the designer will be empty.
	   * @param {Array} options.dataSources - Array of configuration objects for the available data sources for reports.
	   * @param {Array} options.images - Available images that can be used by the report.  Each array element should contain the following properties: <br/>name (String) A description of the image<br/>url (String) The location of the image
	   * @param {boolean} options.embedded - True to embed the designer in an element on the page (requires <b>container</b> config).  False to show designer in a popup.  Default: false.
	   * @param {HTMLElement} options.container - When <b>embedded</b> is true, the element into which to render the designer.
	   * @param {string} options.toolbarPosition - Controls where the toolbar for editing elements appears.  Options:<br/>top - Appears above report canvas<br/>bottom - Appears below report canvas<br/>float - Appears floating just below the selected element<br/>Default: top
	   *
	   * @example
	   * var designer = new ditto.Designer({
	   *     data_sources: [ ... ],
	   *     report_def: { ... },
	   *     images: [ ... ],
	   *     toolbarPosition: "top",
	   *     embedded: true,
	   *     container: $("#reportDesigner")
	   * });
	   *
	   */
	  ditto.Designer = function (cfg) {
	    var _this = this;

	    this.version = "1.4.122";
	    this.layout = "horizontal";
	    this.config = cfg;
	    this.nextToolbarItemId = 1;

	    // Back-compat: underscores to camelcase
	    cfg.report_def = ditto.firstDefined(cfg.report, cfg.reportDef, cfg.report_def);
	    cfg.data_sources = ditto.firstDefined(cfg.dataSources, cfg.data_sources);

	    if (cfg.report_def) {
	      if (typeof cfg.report_def === 'string') {
	        try {
	          cfg.report_def = JSON.parse(cfg.report_def);
	        } catch (e) {
	          throw new Error('Config property "report_def" for ditto.Designer constructor must be a report definition object or a JSON string representing one');
	        }
	      }
	      if (!cfg.report_def.id) {
	        cfg.report_def.id = "jsr-auto-id-" + String(nextReportAutoId++);
	      }
	    }
	    $.extend(true, this, {
	      report_def: null,
	      images: [],
	      enableBarcodes: true,
	      enableColumns: false,
	      toolbarPosition: "top",
	      embedded: false,
	      embedImages: false,
	      gridSize: 10,
	      gridSizeInches: 0.125,
	      gridSizeMm: 3.175,
	      edgeSnapThresholdPx: 6,
	      minimumElementSize: 10,
	      showDownloadButton: false,
	      showSaveButton: true,
	      showConfigPanel: true,
	      jasperDef: null,
	      plugins: [],
	      hideElementTypes: [],
	      hideTabs: [],
	      customElements: [],
	      allowImageUpload: true,
	      zoomLevel: 1
	    }, cfg);
	    if (!this.report_def) {
	      this.report_def = JSON.parse(JSON.stringify(ditto.defaultReport));
	    }
	    this.jasperMode = ditto.nsExists('integrations.jasper', ditto) && this.report_def.constructor === ditto.integrations.jasper.JasperReportDef;
	    if (this.jasperMode) {
	      this.jasperDef = this.report_def;
	      this.report_def = this.jasperDef.jsrDef;
	    }
	    // Apply any provided element defaults to all template elements
	    var eltDefaults = this.report_def.elementDefaults;
	    if (eltDefaults) {
	      this.getAllElementDefs().map(function (elt) {
	        var eltType = elt.type.toLowerCase();
	        if (eltDefaults[eltType]) {
	          var withDefaults = _.extend({}, eltDefaults[eltType], elt);
	          _.extend(elt, withDefaults);
	        }
	      });
	    }
	    /** Add any images in the report to the set of available images if not present */
	    this.getAllElementDefs().map(function (elt) {
	      if (elt.type === 'image') {
	        (function () {
	          var urlLower = (elt.url || '').toLowerCase().trim();
	          if (!_this.images.find(function (img) {
	            return (img.url || '').toLowerCase().trim() === urlLower;
	          })) {
	            _this.images.push({
	              url: elt.url,
	              name: elt.url
	            });
	          }
	        })();
	      }
	    });
	    this.plugins.forEach(function (plugin) {
	      if (typeof plugin === 'string') {
	        plugin = new ditto.designer.plugins[plugin]();
	      } else if (plugin.pluginType) {
	        var pType = plugin.pluginType;
	        delete plugin.pluginType;
	        plugin = new ditto.designer.plugins[pType](plugin);
	      } else {
	        return console.error('Unrecognized plugin provided to designer; expected string or object with string-type property \'pluginType\'');
	      }
	      plugin.bind(this);
	    }.bind(this));
	    this.init();
	  };

	  var printError = typeof console.error === 'function' ? console.error.bind(console) : function () {};

	  var PATTERN_OPTIONS = [['0.00', '123.45'], ['#,##0', '12,345'], ['#,##0.00', '12,345.67'], ['#.##0,00', '12.345,67'], ['$#,##0.00', '$12,345.67'], ['0%', '50%'], ['0.00%', '56.78%'], ['m/d/yy', '1/22/16'], ['d-mmm-yy', '22-Jan-16'], ['d-mmm', '22-Jan'], ['h:mm:ss AM/PM', '11:35:20 PM'], ['m/d/yyyy h:mm', '1/22/2016 23:35']].map(function (opt) {
	    return { id: opt[0], text: opt[0] + ' (ex: ' + opt[1] + ')' };
	  });

	  /** @lends ditto.Designer.prototype */
	  var privateApi = {
	    image_placeholder_url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAm4AAAGfAQMAAADcQMxxAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAGUExURcrKyv7+/sAhN/cAAANUSURBVHja7doxspUwGIZhkBlTprXLFtxBtmUXduCW6CzvFtiBlBRIDEngEJjb5P8cmTnf23htnrm/BxJOsGkYY4wxxhhjjDHGGGOMMcYYY4wxxtiD+oblfkC1boFyGsu5FTqrh3IayznvobNCOR24HjorkGs9lNtm9QN0VhwXZ8VxcVY/ojgL5dKsfoLOCuPirL9QXJpV+RnDqU2bOxQXZx06vwBnbVBcmjWoC27WMXCY1T3NGv5cYbMukQXOiuL2WcOah5w1cIDV3RxLE4Tzx6ZjAdxr1sANwFnDjwNw1sCJV/fuNSuCM6dFXcu506yBm4Czhg95As7ayDcLd35wEnNx1vX1NyGni81avFkUs4q5clbxZlHOKuauj5wyri1nlW4W+voQJuNuj9eivec2q2yzyI+ctypvDfsJt9TPiuMUlrNQ7tNZ6ziF5eKsHzAuXsMaxcWlboZx8ZMYsFwD5WYc18S1Cco1UG7euPsDYh3ntqcvJNcjOftwbkBy5tGcxl4ocG5CcurhHHQJ6NDcsnMDgGsP7vKeQspZD+HWzLnyH7DyCergLieyQq69HKFWcs4nrrs8DQs5heL6nUvAFxFnM6d3Tj2LG3YuffXRvYQzV84IufHCDRJOXzmL5dwo4yYkp65cvnXl3JJWLBHXxUft103W5ltXzs3nE6hqbikWKJWd6m/bBzelTxrCtXlx315Gf5dw675XDOmmW9upnmt2zu5H5F7PEs4nzqzH92UJ5zLXzccREoI7ff1eRFyP5GzBtVjuOAet5cx2FvCvOCXnxhOnj3d5lZz+l5yRc9OJs1JOFZzb36vUczOS6wrOQ7l82DhIuAXJtQf3Nd9jIE4dR6FjPddsh5WR0wOUM+N+VibifObsnO+xbQOv5tzOuQXKhXvVIrifkQvXXO/knM1cuOZGd7z6EHAfkQsXyeTlnMlcuEj+ADlTnMoKuN+RsxhOo7n0pOhe3CrgVOY8lGuxXAfiusQVL5HknMZyBsS1iSte5/VizoG4Ju+EUK582Tg8h3M+fQFFcgrG2fu7shHLiX+72+dTzZl34vSjOfVOXPdorgX+B5LHc81bce7RnH0nzjya01iOMcYYY4wxxhhjjDHGGGOMMcYYY4wxxhj7X/0FnfcF5c+YfkMAAAAASUVORK5CYII=",
	    chart_preview_line_data: [1, 4, 9, 16, 25].map(function (v, i) {
	      return { 'Value field': v, l: i };
	    }),
	    chart_preview_pie_data: [1, 4, 9, 16, 25].map(function (v, i) {
	      return { 'Value field': v, l: String.fromCharCode(65 + i) };
	    }),
	    input_default_placeholders: {
	      "text": t('INPUT_DEFAULT_VALUE_EXAMPLE_TEXT'),
	      "date": t('INPUT_DEFAULT_VALUE_EXAMPLE_DATE'),
	      "number": t('INPUT_DEFAULT_VALUE_EXAMPLE_NUMBER')
	    },
	    element_drag_handling_delay_ms: 150,
	    default_fonts: [{ name: "Times New Roman", css: 'TimesNewRoman, "Times New Roman", Times, Baskerville, Georgia, serif' }, { name: "Helvetica", css: '"Helvetica Neue", Helvetica, Arial, sans-serif' }, { name: "Consolas", css: 'Consolas, monaco, monospace' }, { name: "Monaco", css: 'Monaco, Consolas, "Lucida Console", monospace' }, { name: "Georgia", css: 'Georgia, Times, "Times New Roman", serif' }, { name: "Garamond", css: 'Garamond, Baskerville, "Baskerville Old Face", "Hoefler Text", "Times New Roman", serif' }, { name: "Calibri", css: 'Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif' }, { name: "Arial", css: 'Arial, "Helvetica Neue", Helvetica, sans-serif' }, { name: "Andale Mono", css: '"Andale Mono", AndaleMono, monospace' }, { name: "Lucida Grande", css: '"Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva, Verdana, sans-serif' }, { name: "Segoe UI", css: '"Segoe UI", Frutiger, "Frutiger Linotype", "Dejavu Sans", "Helvetica Neue", Arial, sans-serif' }, { name: "Palatino", css: 'Palatino, "Palatino Linotype", "Palatino LT STD", "Book Antiqua", Georgia, serif' }, { name: "Tahoma", css: 'Tahoma, Verdana, Segoe, sans-serif' }, { name: "Courier New", css: '"Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter", monospace' }].concat(_fonts2.default.map(function (webfont) {
	      return {
	        name: webfont.name,
	        css: '"' + webfont.name + '", ' + (webfont.fallback || 'sans-serif')
	      };
	    })),
	    font_size_options: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 26, 28, 32, 36, 40, 44, 48, 54, 60, 66, 72, 80, 88, 96],
	    color_palette: [["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(117, 117, 117)", "rgb(167, 167, 167)", "rgb(217, 217, 217)", "rgb(255, 255, 255)"], ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)", "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"], ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)", "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)", "rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)", "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)", "rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)", "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)", "rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)", "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)", "rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)", "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]],
	    auto_save_delay_ms: 5000,
	    paper_sizes: {
	      "letter": { name: t('PAPER_SIZE_LETTER'), inches: ["8.5", "11"], mm: ["216", "279"] },
	      "letter-landscape": { name: t('PAPER_SIZE_LETTER_LANDSCAPE'), inches: ["11", "8.5"], mm: ["279", "216"] },
	      "legal": { name: t('PAPER_SIZE_LEGAL'), inches: ["8.5", "14"], mm: ["216", "356"] },
	      "legal-landscape": { name: t('PAPER_SIZE_LEGAL_LANDSCAPE'), inches: ["14", "8.5"], mm: ["356", "216"] },
	      "tabloid": { name: t('PAPER_SIZE_TABLOID'), inches: ["11", "17"], mm: ["279", "432"] },
	      "ledger": { name: t('PAPER_SIZE_LEDGER'), inches: ["17", "11"], mm: ["432", "279"] },
	      "a4": { name: t('PAPER_SIZE_A4'), inches: ["8.27", "11.69"], mm: ["210", "297"] },
	      "a4-landscape": { name: t('PAPER_SIZE_A4_LANDSCAPE'), inches: ["11.69", "8.27"], mm: ["297", "210"] },
	      "a3": { name: t('PAPER_SIZE_A3'), inches: ["11.69", "16.54"], mm: ["297", "420"] },
	      "a3-landscape": { name: t('PAPER_SIZE_A3_LANDSCAPE'), inches: ["11.69", "16.54"], mm: ["297", "420"] }
	    },
	    mm_per_in: 25.40,
	    default_margins: {
	      "inches": {
	        "top": 0.5,
	        "left": 0.5,
	        "right": 0.5,
	        "bottom": 0.5
	      },
	      "mm": {
	        "top": 12.70,
	        "left": 12.70,
	        "bottom": 12.70,
	        "right": 12.70
	      }
	    },
	    group_aggregate_function_suggestions: ['[SUM()]', '[AVERAGE()]', '[MAX()]', '[MIN()]', '[COUNT()]'],
	    barcode_dummy_values: {
	      "UPC": "123456789012",
	      "EAN": "7501031311309",
	      "ITF14": "1234567890123",
	      "pharmacode": "123456",
	      "CODE128": "12345678",
	      "CODE39": "12345678",
	      "QR": "123456789012345678901"
	    },

	    dispatch: function dispatch(action) {
	      if (!this.debouncedOnChange) {
	        this.debouncedOnChange = _.debounce(this.onChange, ONCHANGE_DELAY_MS);
	      }
	      if (!this.history) {
	        this.history = [];
	      }
	      this.history.push(action);
	      this.debouncedOnChange();
	    },

	    onChange: function onChange() {
	      var history = this.history || [];
	      this.history = [];
	      // Make this the last call so there's no work still to do if a listener errors out
	      this.trigger('change', history);
	    },

	    render: function render(container) {
	      var me = this;
	      this.container = container;
	      this.designer_el = $(['<div class="ditto-designer jsr-style-root">', '<div class="jsr-designer-toolbar">', '<span class="designer-control-button"><button class="jsr-btn btn-success save-button" type="button">' + t('SAVE') + '</button></span>', '<span class="designer-control-button"><button class="jsr-btn cancel-button" type="button">' + t('CANCEL') + '</button></span>', '</div>', '</div>'].join(''));
	      $(this.container).empty().append(this.designer_el);
	      if (this.showDownloadButton && !this.jasperMode) {
	        var $downloadWrap = $(['<span class="designer-control-button dropdown">', '<button type="button" class="jsr-btn btn-default dropdown-toggle download-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">', t('DOWNLOAD') + ' <span class="caret"></span>', '</button>', '<ul class="dropdown-menu dropdown-menu-right" role="menu">', '<li role="menuitem"><a href="javascript:;" class="jsr-designer-download-pdf">' + t('PDF') + '</a></li>', '<li role="menuitem"><a href="javascript:;" class="jsr-designer-download-xlsx">' + t('EXCEL') + '</a></li>', '</ul>', '</span>'].join(''));
	        this.designer_el.find('.jsr-designer-toolbar').append($downloadWrap);
	        this.downloadButton = $downloadWrap.find('button');
	        $downloadWrap.find('.jsr-designer-download-pdf').on('click', this.onDownloadClick.bind(this, 'pdf'));
	        $downloadWrap.find('.jsr-designer-download-xlsx').on('click', this.onDownloadClick.bind(this, 'xlsx'));
	        this.downloadButton.jsrDropdown();
	      }
	      if (this.embedded) {
	        this.designer_el.addClass('jsr-designer-embedded');
	      } else {
	        this.designer_el.addClass('jsr-designer-popup');
	      }
	      // $(".navbar a:not(.logo-link, .email-support-link)", this.designer_el).on("click", this.show_header_panel.bind(this));
	      this.auto_save_debounced = _.debounce(this.auto_save.bind(this), this.auto_save_delay_ms);
	      $("body").on("mouseup", this.auto_save_debounced);
	      $("body").on("mouseover", this.auto_save_debounced);
	      $("body").on("keyup", this.auto_save_debounced);
	      this.designer_el.find(".save-button").on("click", this.on_save_button_click.bind(this));
	      this.designer_el.find(".cancel-button").on("click", this.on_cancel_button_click.bind(this));
	      if (this.embedded) {
	        this.designer_el.find(".cancel-button").hide();
	      }
	      if (this.showSaveButton === false) {
	        this.designer_el.find(".save-button").hide();
	      }
	      this.window_resize_delegate = this.on_window_resize.bind(this);
	      $(window).on("resize", this.window_resize_delegate);
	      ditto.key('del, delete', this.delete_selected_control.bind(this));
	      ditto.key('command+c, ctrl+c', this.copy_selection.bind(this));
	      ditto.key('command+v, ctrl+v', this.paste_selection.bind(this));
	      ditto.key('up, down, left, right, command+up, ctrl+up, ' + 'command+down, ctrl+down, command+left, ctrl+left, ' + 'command+right, ctrl+right', this.on_arrow_key.bind(this));
	      this.renderContent();
	      this.rendered = true;
	      this.trigger('render');
	    },

	    /** 
	     * @private 
	     * Renders report-specific areas like left and right panes (everything except top toolbar) 
	     */
	    renderContent: function renderContent() {
	      var _this2 = this;

	      var me = this;
	      this.designer_el.find('.jsr-designer-left, .jsr-designer-right, .jsr-designer-empty').remove();
	      if (!this.report_def) {
	        this.designer_el.append($(['<div class="jsr-designer-empty">', '<div class="jsr-designer-empty-message">' + t('NO_REPORT_LOADED') + '</div>', '</div>'].join('')));
	        return;
	      }
	      var hideInputsTab = this.hideTabs.indexOf('inputs') >= 0;
	      var hidePageTab = this.hideTabs.indexOf('page') >= 0;
	      var $pane = $(['<div class="jsr-designer-left">', '<div class="jsr-designer-header jsr-settings">', '<div class="navbar jsr-control-panel-toolbar">', '<div class="navbar-inner">', '<ul class="nav" style="width: 100%">', '<li class="active jsr-designer-tab"><a href="javascript:;" data-panelname="data">' + t('DATA') + '</a></li>', !hideInputsTab ? '<li class="jsr-designer-tab"><a href="javascript:;" data-panelname="inputs">' + t('INPUTS') + '</a></li>' : '', !hidePageTab ? '<li class="jsr-designer-tab"><a href="javascript:;" data-panelname="page-layout">' + t('PAGE') + '</a></li>' : '', '</ul>', '</div>', '</div>', '<div class="header-panel jsr-settings-panel jsr-settings-panel-data data active"></div>', '<div class="header-panel jsr-settings-panel jsr-settings-panel-groups groups"></div>', '<div class="header-panel jsr-settings-panel jsr-settings-panel-inputs inputs"></div>', '<div class="header-panel jsr-settings-panel jsr-settings-panel-page page-layout">', '<div class="settings-section jsr-settings-section">', '<h3>' + t('PAGE_UNITS') + '</h3>', '<select class="jsr-units">', '<option value="inches">' + t('PAGE_UNITS_INCHES') + '</option>', '<option value="mm">' + t('PAGE_UNITS_MM') + '</option>', '</select>', '</div>', '<div class="settings-section jsr-settings-section">', '<h3>' + t('PAPER_SIZE') + '</h3>', '<input class="jsr-paper-size" />', '</div>', '<div class="page-margins settings-section jsr-settings-section">', '<h3>' + t('MARGINS') + ' (<span class="margin-units"></span>)</h3>', '<label><span class="text">' + t('TOP') + ':</span> <input type="text" class="margin-input margin-top" data-side="top" /></label> ', '<label><span class="text">' + t('BOTTOM') + ':</span> <input type="text" class="margin-input margin-bottom" data-side="bottom" /></label> ', '<label><span class="text">' + t('LEFT') + ':</span> <input type="text" class="margin-input margin-left" data-side="left" /></label> ', '<label><span class="text">' + t('RIGHT') + ':</span> <input type="text" class="margin-input margin-right" data-side="right" /></label> ', '</div>', '<div class="settings-section jsr-settings-section">', '<h3>' + t('REPORT_HEADER_FOOTER') + '</h3>', '<div><label><input type="checkbox" class="show-report-header" checked /> ' + t('SHOW_REPORT_HEADER') + '</label></div>', '<div><label><input type="checkbox" class="show-report-footer" checked /> ' + t('SHOW_REPORT_FOOTER') + '</label></div>', '</div>', '<div class="settings-section jsr-settings-section">', '<h3>' + t('PAGE_HEADER_FOOTER') + '</h3>', '<div class="page-header"><label><input type="checkbox"> ' + t('SHOW_PAGE_HEADER') + '</label></div>', '<div class="page-footer"><label><input type="checkbox"> ' + t('SHOW_PAGE_FOOTER') + '</label></div>', '</div>', '<div class="settings-section jsr-settings-section">', '<h3>' + t('APPEARANCE') + '</h3>', '<div class="default-font">' + t('DEFAULT_FONT') + ': <select></select></div>', '<div class="default-font-size">' + t('DEFAULT_FONT_SIZE') + ': <input type="text" size="3" /> pts</div>', '</div>', '</div>', '</div>', '<div class="preview">', '<div class="page">', '<div class="jsr-section-highlight"></div>', '<div class="jsr-template-content"></div>', '</div>', '</div>', '<div class="left-pane-toggle-btn"></div>', '<div class="jsr-designer-zoom">', '<div class="jsr-designer-zoom-button jsr-designer-zoom-in" data-zoom="in">+</div>', '<div class="jsr-designer-zoom-button jsr-designer-zoom-out" data-zoom="out">−</div>', '</div>', '</div>', '<div class="jsr-designer-right">', '</div>'].join(''));
	      this.designer_el.append($pane);
	      this.designer_el.find(".jsr-control-panel-toolbar a").on("click", this.show_header_panel.bind(this));
	      this.onZoomChange();

	      this.designer_el.find('.jsr-designer-zoom-button').on('click', this.onZoomClick.bind(this));

	      this.previewViewportDomEl = $('.preview', this.designer_el)[0];
	      this.preview_el = $(".preview .jsr-template-content", this.designer_el);

	      if (this.layout === "horizontal") {
	        var $right = this.designer_el.find(".jsr-designer-right"),
	            $palette = this.designer_el.find(".palette"),
	            $preview_container = this.designer_el.find(".preview");
	        $right.append($palette);
	        $right.append($preview_container);
	        $right.append(this.designer_el.find('.jsr-designer-zoom'));
	        this.designer_el.addClass("jsr-designer-horizontal");
	      }
	      if (this.showToolbar === false) {
	        this.designer_el.find('.jsr-designer-toolbar').hide();
	      }
	      if (this.showConfigPanel === false) {
	        this.designer_el.find('.jsr-designer-left').addClass('collapsed');
	      }
	      this.reposition();

	      var current_template_y_pixels = this.preview_el.height(),
	          units = this.report_def.page.units,
	          paper_height = this.report_def.page.paper_size[units][1],
	          y_units_per_pixel = paper_height / current_template_y_pixels;

	      this.is_first_render = true;
	      this.render_template();
	      delete this.is_first_render;

	      this.render_data_panel();
	      this.populate_margins_panel();
	      this.render_inputs_panel();
	      this.preview_el.addClass("yui3-resize-knob");
	      this.preview_el.on("click", this.on_preview_canvas_click.bind(this));
	      this.preview_el.on("mousemove", this.on_preview_mousemove.bind(this));
	      this.otherSelections = [];
	      // $(".preview-button", this.designer_el).on("click", this.on_preview_button_click.bind(this))
	      //     .hide();
	      var $units = $(".jsr-units", this.container);
	      $units.select2({
	        minimumResultsForSearch: -1,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      $units.select2('val', this.report_def.page.units);

	      $units.on("change", function (evt) {
	        var units = $(evt.target).val();
	        me.report_def.page.units = units;
	        $(".margin-units, .paper-size-units").text((units === 'mm' ? t('MM') : t('INCHES')).toUpperCase());
	        var paper_seln = $("input.jsr-paper-size").select2("val");
	        $("input.jsr-paper-size").select2({
	          data: me.get_paper_size_options(),
	          dropdownAutoWidth: true,
	          dropdownCssClass: 'jsr-select2-dropdown'
	        }).val(paper_seln);
	        // convert margins to new units
	        var conversion = units === "mm" ? me.mm_per_in : 1 / me.mm_per_in;
	        var precision = units === 'mm' ? 2 : 4;
	        ["top", "left", "bottom", "right"].map(function (side) {
	          var $input = $("input.margin-" + side),
	              orig = Number($input.val()),
	              converted = orig * conversion;
	          $input.val(+converted.toFixed(precision));
	          me.report_def.page.margins[side] = converted;
	        });
	        // convert section heights
	        me.getAllSections(null, false).forEach(function (sectionWrapper) {
	          sectionWrapper.def.height = +(sectionWrapper.def.height * conversion).toFixed(precision);
	        });
	        // convert element dims/pos
	        me.getAllElementDefs(false).forEach(function (eltDef) {
	          ['top', 'left', 'width', 'height'].forEach(function (prop) {
	            eltDef[prop] = +(eltDef[prop] * conversion).toFixed(precision);
	          });
	        });
	        me.render_template();
	      });
	      $("input.jsr-paper-size").select2({
	        data: me.get_paper_size_options(),
	        minimumResultsForSearch: -1,
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      if (this.report_def.page.paper_size) {
	        $("input.jsr-paper-size").select2("val", this.report_def.page.paper_size.id);
	      }
	      $("input.jsr-paper-size").on("change", function (evt) {
	        var id = $(evt.target).val();
	        me.report_def.page.paper_size = me.paper_sizes[id];
	        me.report_def.page.paper_size.id = id;
	        me.render_template();
	      });
	      $(".margin-units, .paper-size-units").text(this.report_def.page.units.toUpperCase());
	      $("input.margin-input").on("change", function (evt) {
	        var $input = $(evt.target),
	            side = $input.data("side");
	        me.report_def.page.margins[side] = Number($input.val());
	        me.render_template();
	      });
	      this.designer_el.find(".left-pane-toggle-btn").on("click", this.on_left_pane_toggle_click.bind(this));
	      this.designer_el.find(".page-header input").prop("checked", this.report_def.page_header && !!this.report_def.page_header.visible).on("change", function (evt) {
	        if (!me.report_def.page_header) {
	          me.report_def.page_header = JSON.parse(JSON.stringify(ditto.defaultReport.page_header));
	        }
	        _this2.setSectionVisibility(me.report_def.page_header, $(evt.target).is(":checked"));
	        me.render_template();
	      });
	      this.designer_el.find(".page-footer input").prop("checked", this.report_def.page_footer && !!this.report_def.page_footer.visible).on("change", function (evt) {
	        if (!me.report_def.page_footer) {
	          me.report_def.page_footer = JSON.parse(JSON.stringify(ditto.defaultReport.page_footer));
	        }
	        _this2.setSectionVisibility(me.report_def.page_footer, $(evt.target).is(":checked"));
	        me.render_template();
	      });
	      $pane.find("input.show-report-header").prop("checked", this.report_def.header && this.report_def.header.visible !== false).on("change", function (evt) {
	        if (!_this2.report_def.header) {
	          _this2.report_def.header = JSON.parse(JSON.stringify(ditto.defaultReport.header));
	        }
	        _this2.setSectionVisibility(me.report_def.header, $(evt.target).is(":checked"));
	        _this2.render_template();
	      });
	      $pane.find("input.show-report-footer").prop("checked", this.report_def.footer && this.report_def.footer.visible !== false).on("change", function (evt) {
	        if (!_this2.report_def.footer) {
	          _this2.report_def.footer = JSON.parse(JSON.stringify(ditto.defaultReport.footer));
	        }
	        _this2.setSectionVisibility(me.report_def.footer, $(evt.target).is(":checked"));
	        _this2.render_template();
	      });

	      this.newElButton = $('<div class="jsr-new-element-button">+</div>');
	      $(".preview", this.designer_el).append(this.newElButton);
	      this.newElButton.on('click', function () {
	        if (!_this2.newElPopup) {
	          _this2.newElPopup = _this2.createNewElementPopup(_this2.newElButton[0]);
	          _this2.initPaletteEvents();
	        }
	        _this2.newElPopup.show();
	      });

	      var defaultFontSelectEl = $pane.find('.default-font select')[0];
	      this.populateFontSelector(defaultFontSelectEl, [{ id: '', text: '(None)' }]);
	      var defaultFont = this.report_def.defaultFont;
	      if (defaultFont) {
	        var fontName = defaultFont.css || defaultFont;
	        $(defaultFontSelectEl).val(fontName);
	      }
	      var $defaultFontSelect = $(defaultFontSelectEl).select2({
	        dropdownCssClass: 'jsr-select2-dropdown',
	        dropdownAutoWidth: true
	        // createSearchChoice: function(term, data) {
	        //   if ($(data).filter(function() {
	        //     return this.text.localeCompare(term)===0;
	        //   }).length === 0) {
	        //     return { id: term, text: term };
	        //   }
	        // }
	      });
	      $defaultFontSelect.on("change", function (evt) {
	        var fontname = $(evt.target).val(),
	            css = '';
	        if (fontname != '') {
	          css = me.default_fonts.find(function (font) {
	            return font.name.toLowerCase() === fontname.toLowerCase();
	          }).css;
	        }
	        me.report_def.defaultFont = { name: fontname, css: css };
	        me.render_template();
	      });
	      var defaultFontSizeInput = $pane.find('.default-font-size input')[0];
	      if (this.report_def.defaultFontSize !== undefined) {
	        var fontSizeNumber = Number(this.report_def.defaultFontSize);
	        $(defaultFontSizeInput).val(isNaN(fontSizeNumber) ? '' : fontSizeNumber);
	      }
	      $(defaultFontSizeInput).on('change', function (evt) {
	        var num = Number(evt.target.value);
	        if (isNaN(num) || evt.target.value.trim() === '') {
	          delete _this2.report_def.defaultFontSize;
	        } else {
	          _this2.report_def.defaultFontSize = num;
	        }
	        me.render_template();
	      });
	    },

	    onZoomChange: function onZoomChange() {
	      var right = this.designer_el.find(".jsr-designer-right");
	      right.removeClass('jsr-zoom-min').removeClass('jsr-zoom-max');
	      if (this.zoomLevel === 0) {
	        right.addClass('jsr-zoom-min');
	      } else if (this.zoomLevel === ZOOM_LEVELS.length - 1) {
	        right.addClass('jsr-zoom-max');
	      }
	    },

	    onZoomClick: function onZoomClick(evt) {
	      var direction = evt.target.dataset.zoom;
	      if (direction === 'in') {
	        this.zoomLevel = Math.min(ZOOM_LEVELS.length - 1, this.zoomLevel + 1);
	      } else if (direction === 'out') {
	        this.zoomLevel = Math.max(0, this.zoomLevel - 1);
	      }
	      this.render_template();
	      this.onZoomChange();
	    },

	    // computeDragEdges: function() {
	    //   const horiz = {};
	    //   const vert = {};
	    //   const add = (hash, key, val) => {
	    //     const existing = hash[key];
	    //     if (!existing) {
	    //       hash[key] = existing = [];
	    //     }
	    //     existing.push(val);
	    //   };
	    //   // Work from visible elements, not defs
	    //   this.dragEdges = { horiz, vert };
	    // },

	    createNewElementPopup: function createNewElementPopup(newElBtn) {
	      var _this3 = this;

	      var reportType = this.report_def.type || 'hierarchical';
	      var hiddenElementTypesLower = this.hideElementTypes.map(function (s) {
	        return s.toLowerCase();
	      });
	      var paletteItems = Object.keys(this.elementTypes).filter(function (elTypeId) {
	        var elClass = _this3.elementTypes[elTypeId].handler;
	        var allowedReportTypes = elClass && elClass.allowedReportTypes;
	        if (allowedReportTypes && allowedReportTypes.indexOf(reportType) < 0) {
	          return false;
	        }
	        return hiddenElementTypesLower.indexOf(elTypeId) < 0;
	      });
	      var html = ['<div class="jsr-new-element-palette">', paletteItems.map(function (elTypeId) {
	        return '<div class="palette-item ' + elTypeId + '" data-elementtype="' + elTypeId + '">' + (_this3.elementTypes[elTypeId].iconSrc ? '<div class="jsr-designer-palette-icon" style="background-image:url(' + _this3.elementTypes[elTypeId].iconSrc + ')"></div>' : '') + (t('ELEMENT_TYPE_NAME_' + elTypeId.toUpperCase()) + '</div>');
	      }).join(''), '</div>'].join(' ');
	      return new _Popup2.default({
	        className: 'jsr-new-element-popup',
	        target: newElBtn,
	        placement: 'right',
	        contentHtml: html,
	        onShow: function onShow() {
	          _this3.newElMenuVisible = true;
	        },
	        onHide: function onHide() {
	          _this3.newElMenuVisible = false;
	        }
	      });
	    },

	    setSectionVisibility: function setSectionVisibility(section, visible) {
	      section.visible = visible;
	      if (visible) {
	        section.height = Math.max(this.getMinDefaultSectionHeight(), section.height || 0);
	      }
	    },

	    getCurrentUnits: function getCurrentUnits() {
	      if (this.report_def && this.report_def.page && this.report_def.page.units === 'mm') {
	        return 'mm';
	      }
	      return 'in';
	    },

	    /** The minimum height to apply when making a section visible again via a checkbox */
	    getMinDefaultSectionHeight: function getMinDefaultSectionHeight() {
	      return this.getCurrentUnits() === 'mm' ? 12.7 : 0.5;
	    },

	    onDownloadClick: function onDownloadClick(format) {
	      ditto.export({
	        report_def: this.report_def,
	        format: format,
	        datasets: this.data_sources
	      });
	    },

	    addToolbarElement: function addToolbarElement(htmlOrDom, pos) {
	      if (!htmlOrDom) {
	        throw new Error("ditto.Designer.addToolbarElement requires a DOM element or HTML string as the first argument");
	      }
	      if (!pos) {
	        pos = ditto.ToolbarItemPosition.RIGHT;
	      }
	      var $elt = $(htmlOrDom);
	      var $toolbar = this.designer_el.find('.jsr-designer-toolbar');
	      switch (pos) {
	        case ditto.ToolbarItemPosition.LEFT:
	          $toolbar.prepend($elt);
	          break;
	        case ditto.ToolbarItemPosition.RIGHT:
	          // Right-aligned elements are floated, so insert in reverse order and must be wrapped in <li>
	          $elt.insertBefore($toolbar.find('.designer-control-button').first()).wrap('<span class="designer-control-button"></span>');
	          break;
	        default:
	          throw new Error('Direction must be ' + productName + '.ToolbarItemPosition.LEFT or ' + productName + '.ToolbarItemPosition.RIGHT');
	      }
	      return $elt[0];
	    },

	    addToolbarButton: function addToolbarButton(text, pos) {
	      if (!text) {
	        text = '';
	      }
	      var btn = this.addToolbarElement('<button class="jsr-btn" type="button"></button>', pos);
	      $(btn).text(text);
	      return btn;
	    },

	    on_window_resize: function on_window_resize() {
	      this.resize();
	    },

	    resize: function resize() {
	      this.reposition();
	      if (this.editing_control_elt && this.toolbarPosition === "float") {
	        var toolbar = this.editing_control_elt.data("toolbarObj");
	        if (toolbar.toolbar.is(":visible")) {
	          this.editing_control_elt.toolbar("calculatePosition");
	        }
	      }
	    },

	    on_left_pane_toggle_click: function on_left_pane_toggle_click() {
	      var $leftPane = this.designer_el.find(".jsr-designer-left");
	      if ($leftPane.hasClass("collapsed")) {
	        $leftPane.removeClass("collapsed");
	      } else {
	        $leftPane.addClass("collapsed");
	      }
	      this.reposition();
	    },

	    /**
	     * @private
	     * Change the column count in the preview, moving any detail section controls as needed
	     */
	    set_column_count: function set_column_count(section, column_count) {
	      var prev_count = section.column_count,
	          scale_factor = prev_count / column_count,
	          body_els = section.elements;
	      section.column_count = column_count;
	      for (var i = 0; i < body_els.length; i++) {
	        var el = body_els[i];
	        el.left *= scale_factor;
	        el.width *= scale_factor;
	      }
	      this.render_template();
	    },

	    getFontScaleFactor: function getFontScaleFactor() {
	      if (this.fontScaleFactor) return this.fontScaleFactor;
	      if (this.scaleFonts === false) {
	        this.fontScaleFactor = 1;
	        return this.fontScaleFactor;
	      }
	      var basePPI = 96;
	      var isInches = this.getCurrentUnits() === 'in';
	      var ppi = this.pixels_per_unit * (isInches ? 1 : 25.4);
	      return this.fontScaleFactor = ppi / basePPI;
	    },

	    highlightSection: function highlightSection(sectionInfo) {
	      var highlightEl = this.designer_el[0].querySelector('.preview .jsr-section-highlight');
	      this.currentlyHighlightedSectionInfo = sectionInfo;
	      if (sectionInfo) {
	        this.repositionSectionHighlight();
	      }
	      _.extend(highlightEl.style, {
	        display: sectionInfo ? 'block' : 'none'
	      });
	    },

	    repositionSectionHighlight: function repositionSectionHighlight() {
	      var highlightEl = this.designer_el[0].querySelector('.preview .jsr-section-highlight');
	      var sectionInfo = this.currentlyHighlightedSectionInfo;
	      if (!sectionInfo) return;
	      _.extend(highlightEl.style, {
	        top: sectionInfo.top + 'px',
	        height: sectionInfo.bottom - sectionInfo.top + 1 + 'px',
	        left: sectionInfo.left + 'px',
	        right: sectionInfo.right + 'px'
	      });
	    },

	    /**
	     * @private
	     * Lay out designer, adjusting overall size to fit screen if possible, then fitting internal regions.
	     * In embedded mode, do not change designer size.
	     */
	    reposition: function reposition() {
	      var _this4 = this;

	      if (!this.designer_el) return;
	      var collapsedLeftPaneWidth = 36,
	          window_width = $(window).width(),
	          window_height = $(window).height(),
	          designer_width = this.embedded ? Math.floor($(this.container).innerWidth()) : Math.max(1000, Math.min(1600, window_width - 100)),
	          // >1000, <1600
	      designer_height = this.embedded ? Math.floor($(this.container).innerHeight()) : Math.max(600, window_height - 100),
	          // >600
	      left_collapsed = this.designer_el.find(".jsr-designer-left").hasClass("collapsed"),
	          left_pane_width = left_collapsed ? collapsedLeftPaneWidth : Math.max(250, Math.min(350, Math.floor(designer_width * 0.4))),
	          $navbar = this.designer_el.find(".jsr-designer-toolbar"),
	          navbar_height = $navbar.is(":visible") ? $navbar.outerHeight() : 0,
	          pane_height = designer_height - navbar_height,
	          overlayMode = designer_width < 1000,
	          leftOverlayOpen = overlayMode && !left_collapsed;
	      this.designer_el.css({
	        width: designer_width,
	        height: designer_height
	      });
	      if (!this.embedded) {
	        this.designer_el.css({
	          top: Math.floor((window_height - designer_height) / 2),
	          left: Math.floor((window_width - designer_width) / 2)
	        });
	      }
	      var $leftPaneEl = this.designer_el.find(".jsr-designer-left");
	      if (this.showSettingsPane === false) {
	        $leftPaneEl.css('display', 'none');
	        left_pane_width = 0;
	        leftOverlayOpen = false;
	        collapsedLeftPaneWidth = 0;
	      } else {
	        $leftPaneEl.width(left_pane_width).height(pane_height).css('top', navbar_height + 'px');
	      }
	      // Re-check inner designer width because borders may cause it to be != requested width
	      var actualLeftPaneWidth = $leftPaneEl.outerWidth();
	      var newRightLeft = overlayMode ? collapsedLeftPaneWidth : actualLeftPaneWidth;
	      var newRightWidth = this.designer_el.innerWidth() - newRightLeft;
	      this.designer_el.toggleClass("jsr-overlay-left", overlayMode);
	      this.designer_el.find(".jsr-designer-right").width(newRightWidth) //Math.floor(this.designer_el.innerWidth() - (leftOverlayOpen ? collapsedLeftPaneWidth : actualLeftPaneWidth)))
	      .height(pane_height).css({
	        'left': newRightLeft + 'px',
	        'top': navbar_height + 'px'
	      }), this.adjust_preview_dimensions();
	      var preview_width = this.preview_el.width();
	      /** Don't re-render if dimensions remain unchanged */
	      if (this.initial_render_complete && (designer_width !== this.lastDesignerWidth || designer_height !== this.lastDesignerHeight || preview_width !== this.lastPreviewWidth)) {
	        this.render_template();
	      }
	      if (this.selectedSection) {
	        this.selectSection(this.preview_section_offsets.find(function (secInf) {
	          return secInf.def === _this4.selectedSection.def;
	        }));
	      }
	      this.lastPreviewWidth = preview_width;
	      this.lastDesignerWidth = designer_width;
	      this.lastDesignerHeight = designer_height;
	    },

	    on_preview_mousemove: function on_preview_mousemove(evt) {
	      this.last_cursor_page_y = evt.pageY;
	      if (!this.throttled_handle_cursor_move) {
	        this.throttled_handle_cursor_move = _.throttle(this.handle_cursor_move.bind(this), 250);
	      }
	      this.throttled_handle_cursor_move();
	    },

	    handle_cursor_move: function handle_cursor_move() {
	      var y_offset = this.last_cursor_page_y - this.preview_el.offset().top,
	          sec = this.find_section_by_y(y_offset);
	      if (sec) {
	        if (!this.newElMenuVisible) {
	          this.newElButton
	          // .show()
	          .css('top', sec.top + 15 + 'px').css('opacity', 1);
	        }
	        if (sec !== this.lastHoveredSection) {
	          this.lastHoveredSection = sec;
	          this.preview_el.find(".section-label").hide();
	          this.preview_el.find(".section-label").first().text(sec.label).css({
	            top: sec.top + 35,
	            width: this.preview_margins.left
	          }).fadeIn("fast");
	        }
	      } else {
	        this.preview_el.find(".section-label").hide();
	        this.lastHoveredSection = null;
	        // this.newElButton.hide();
	        this.newElButton.css('opacity', 0);
	      }
	    },

	    on_save_button_click: function on_save_button_click() {
	      var report_json = this.save();
	      if (this.subreportMode) {
	        var outerSubreportCtl = this.subreportCtlStack[this.subreportCtlStack.length - 1];
	        outerSubreportCtl.report = JSON.parse(report_json);
	        this.exitSubreport();
	        return;
	      }
	      // At top-level report
	      /**
	      * Save event.
	      * @event ditto.Designer#save
	      * @type {object}
	      * @property {boolean} reportJson - JSON string containing report definition
	      */
	      this.trigger('save', report_json);
	      if (!this.embedded) {
	        this.destroy();
	      }
	    },

	    save: function save() {
	      var report_json = JSON.stringify(this.getReport());
	      return report_json;
	    },

	    on_cancel_button_click: function on_cancel_button_click() {
	      var currentReportStr = this.getReportStrWithoutVersion(this.getReport());
	      var modified = currentReportStr !== this.originalReportStr;
	      var proceed = !modified || window.confirm(t('CONFIRM_DESIGNER_CANCEL'));
	      if (proceed) {
	        if (this.subreportMode) {
	          this.exitSubreport();
	        } else {
	          localStorage.removeItem(this.auto_save_key);
	          this.trigger("cancel");
	          this.destroy();
	        }
	      }
	    },

	    getReportStrWithoutVersion: function getReportStrWithoutVersion(report) {
	      return JSON.stringify(this.getReport(), function (key, val) {
	        if (key === 'version') return undefined;
	        return val;
	      });
	    },

	    destroy: function destroy() {
	      if (!this.embedded) {
	        if (this.showing_property_editor) {
	          this.hidePropertyEditor();
	        }
	        $("body").removeClass("jsr-designer-active");
	        $(window).off("resize", this.window_resize_delegate);
	        $(this.container).remove();
	        this.$body_mask.remove();
	        ditto.key.unbind('del, delete, command+c, ctrl+c, command+v, ctrl+v');
	      }
	    },

	    get_paper_size_options: function get_paper_size_options() {
	      var me = this,
	          units = this.report_def.page.units,
	          options = Object.keys(this.paper_sizes).map(function (size_id) {
	        var size = me.paper_sizes[size_id],
	            dimensions = size[units];
	        return {
	          id: size_id,
	          text: size.name + ' (' + dimensions[0] + ' x ' + dimensions[1] + ' ' + (units === 'mm' ? t('PAGE_UNITS_MM') : t('PAGE_UNITS_INCHES')) + ')'
	        };
	      });
	      return { results: options };
	    },

	    on_preview_canvas_click: function on_preview_canvas_click(evt) {
	      var offset = this.preview_el.offset();
	      var y = evt.pageY - offset.top + this.preview_el[0].scrollTop;
	      this.collapseLeftPaneIfOverlay();
	      // if (this.editing_control_def) {
	      //     return setTimeout(this.processCanvasClick.bind(this, y), 10);
	      // }
	      this.processCanvasClick(y);
	    },

	    processCanvasClick: function processCanvasClick(y) {
	      if (!this.dragging) {
	        this.clear_selection();
	      }
	      var section = this.find_section_by_y(y);
	      if (section) {
	        this.selectSection(section);
	      }
	    },

	    collapseLeftPaneIfOverlay: function collapseLeftPaneIfOverlay() {
	      if (!this.designer_el.hasClass('jsr-overlay-left')) return;
	      var $leftPane = this.designer_el.find(".jsr-designer-left");
	      if (!$leftPane.hasClass("collapsed")) {
	        $leftPane.addClass("collapsed");
	        this.reposition();
	      }
	    },

	    hide_preview_output: function hide_preview_output() {
	      this.$preview_output_div.hide();
	      this.$preview_mask.hide();
	    },

	    // on_preview_button_click: function() {
	    //  if (this.$preview_output_div) {
	    //      this.$preview_output_div.find(".ditto-preview-content").empty();
	    //  } else {
	    //      this.$preview_output_div = $('<div class="ditto-preview-output"><div class="ditto-preview-close-button">x</div><div class="ditto-preview-content"></div></div>');
	    //      this.$preview_mask = $('<div class="ditto-preview-mask"></div>');
	    //      $(document.body).append(this.$preview_mask);
	    //      $(document.body).append(this.$preview_output_div);
	    //      var hide_preview_dlgt = this.hide_preview_output.bind(this);
	    //      this.$preview_output_div.find(".ditto-preview-close-button").click(hide_preview_dlgt);
	    //      this.$preview_mask.click(hide_preview_dlgt);
	    //  }
	    //  this.$preview_mask.show();
	    //  this.$preview_output_div.show();
	    //  ditto.render({
	    //      report_def: this.report_def,
	    //      target: this.$preview_output_div.find(".ditto-preview-content"),
	    //      datasets: this.data_sources
	    //  });
	    // },

	    populate_margins_panel: function populate_margins_panel() {
	      var $margins = $(".page-margins", this.container);
	      $margins.find(".margin-top").val(this.report_def.page.margins.top);
	      $margins.find(".margin-left").val(this.report_def.page.margins.left);
	      $margins.find(".margin-bottom").val(this.report_def.page.margins.bottom);
	      $margins.find(".margin-right").val(this.report_def.page.margins.right);
	    },

	    show_header_panel: function show_header_panel(evt) {
	      $(".jsr-designer-header .navbar li.active", this.designer_el).removeClass("active");
	      $(evt.target).closest("li").addClass("active");
	      $(".header-panel.active", this.designer_el).removeClass("active");
	      $(".header-panel." + $(evt.target).data("panelname"), this.designer_el).addClass("active");
	    },

	    render_inputs_panel: function render_inputs_panel() {
	      var $target = $(".header-panel.inputs", this.container);
	      $target.html(['<div class="form-inline">', '<div><h3>' + (t('INPUTS') || '').toUpperCase() + '</h3></div>', '<div class="inputs-section">', '<div class="inputs-list"></div>', '<div style="clear: both"></div>', '<button class="add-input jsr-btn" type="button">' + t('ADD_INPUT') + '</button>', '</div>', '</div>'].join(""));
	      this.render_inputs();
	      $("button.add-input", this.container).on("click", this.add_input.bind(this));
	      $("select", $target).select2({
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      //this.apply_editable_row_hover();
	    },

	    render_inputs: function render_inputs() {
	      var me = this,
	          $target = $(".header-panel.inputs .inputs-list", this.container),
	          i = 0;
	      $target.empty();
	      this.report_def.inputs.map(function (inputdef) {
	        var $row = $(['<div class="editable-row input-row" data-inputindex="' + i++ + '" data-row-type="input">', '<div style="margin-bottom: 5px">', t('INPUT_NAME') + ': <span class="input-name"><input type="text" value="', inputdef.name, '" placeholder="' + t('INPUT_NAME_PLACEHOLDER') + '" /><span class="readonly"></span></span> ', '</div>', '<div style="margin-bottom: 5px">', t('INPUT_TYPE') + ': <span class="input-type">', '<select style="width: 120px">', '<option value="text">' + t('TEXT') + '</option>', '<option value="number">' + t('NUMBER') + '</option>', '<option value="date">' + t('DATE') + '</option>', '</select></span> ', '</div>', '<div style="margin-bottom: 5px">', t('INPUT_DEFAULT_LABEL') + ': <span class="input-default"><input type="text" value="', inputdef.default_value, '" placeholder="', this.input_default_placeholders[inputdef.type], '" /><span class="readonly"></span></span>', '</div>', '</div>'].join(''));
	        $(".input-type select", $row).val(inputdef.type).select2({
	          dropdownCssClass: 'jsr-select2-dropdown'
	        });
	        if (inputdef.type === "date") {
	          this.create_date_picker($(".input-default input", $row));
	        }
	        this.set_input_row_readonly_text($row);
	        $target.append($row);
	      }.bind(this));
	      $("select, input", $target).on("change", this.on_report_input_change.bind(this));
	      /*
	      $(".delete-row-icon", $target).on("click", function() {
	        var $row = $(this).closest(".input-row"),
	          ix = $row.index();
	        me.report_def.inputs.splice(ix, 1);
	        $row.remove();
	      });
	      */
	      this.apply_editable_row_hover($target);
	    },

	    on_report_input_change: function on_report_input_change(evt) {
	      var $row = $(evt.target).closest(".input-row"),
	          inputdef = this.report_def.inputs[$row.index()],
	          new_type = $(".input-type select", $row).val(),
	          value_input = $(".input-default input", $row),
	          existing_date_picker = value_input.data("datepicker");
	      value_input.attr('placeholder', this.input_default_placeholders[new_type]);
	      $.extend(inputdef, {
	        name: $(".input-name input", $row).val(),
	        type: new_type,
	        default_value: value_input.val()
	      });
	      this.set_input_row_readonly_text($row);
	      if (new_type === "date" && !existing_date_picker) {
	        this.create_date_picker(value_input);
	      } else if (new_type !== "date" && existing_date_picker) {
	        value_input.datepicker("remove");
	      }
	    },

	    create_date_picker: function create_date_picker($input) {
	      $input.datepicker({
	        format: "m/d/yy",
	        autoclose: true
	      }).on("changeDate", this.on_report_input_change.bind(this)).on("show", function (e) {});
	    },

	    set_input_row_readonly_text: function set_input_row_readonly_text($row) {
	      var name_input_val = $("span.input-name input", $row).val(),
	          $name_readonly = $("span.input-name .readonly", $row),
	          default_input_val = $("span.input-default input", $row).val(),
	          $default_readonly = $("span.input-default .readonly", $row);
	      $name_readonly.text(name_input_val === '' ? '(' + t('INPUT_NAME_PLACEHOLDER') + ')' : name_input_val);
	      $default_readonly.text(default_input_val === '' ? '(' + t('INPUT_DEFAULT_PLACEHOLDER') + ')' : default_input_val);
	    },

	    /** Render the left-side config controls for a single data section (inside accordion) */
	    renderDataSectionControls: function renderDataSectionControls(section, container, isFirst, canDelete) {
	      var _this5 = this;

	      var $target = $(container);
	      $target.append(['<div class="jsr-padding">', '<div class="form-inline">', '<div class="settings-section jsr-settings-section jsr-settings-section-data-source">', '<h3>' + t('DATA_SOURCE') + '</h3>', this.jasperMode ? '(' + t('EMBEDDED_SCHEMA') + ')' : ['<select class="level-0-data-source">', '<option></option>', '</select> '].join(''), '</div>', '<div class="settings-section jsr-settings-section filters-section">', '<h3>' + t('FILTERS') + '</h3>', '<div class="filters-list"></div>', '<div style="clear: both"></div>', '<button class="add-filter jsr-btn" type="button">' + t('ADD_FILTER') + '</button>', '</div>', '<div class="settings-section jsr-settings-section">', '<h3>' + t('GROUPING') + '</h3>', '<div class="levels-list"></div>', '<div style="margin-top: 5px;"><button class="add-sub-level jsr-btn" type="button">' + t('GROUP_RECORDS') + '</button></div>', '</div>', '<div class="settings-section jsr-settings-section">', '<h3>' + t('DETAIL').toUpperCase() + '</h3>', '<div><label><input type="checkbox" class="show-detail" checked /> ' + t('SHOW_DETAIL') + '</label></div>', '<div class="editable-row sort-detail-container">' + t('ORDER_DETAIL_BY') + ': ', '<input class="sort-detail-by" type="text" />', '<span class="sort-detail-direction-wrapper">, ', '<select class="sort-detail-direction">', '<option value="asc">' + escapeHtml(t('A_TO_Z')) + '</option>', '<option value="desc">' + escapeHtml(t('Z_TO_A')) + '</option>', '</select> ', '</span>', '</div>', '</div>', this.enableColumns ? '<div><label>' + t('COLUMNS') + ': <input type="text" class="detail-column-count" /></label></div>' : '',
	      // Pivot only supported in first data section for now
	      isFirst ? ['<div class="pivot-controls settings-section jsr-settings-section">', '<h3>' + t('PIVOT') + '</h3>', '<div><label><input type="checkbox" class="pivot-enabled" /> ' + t('ENABLE_PIVOT') + '</label></div>', '<div><label>' + t('PIVOT_FIELD') + ': <input type="hidden" class="pivot-column" /></label></div>', '<div><label>' + t('PIVOT_BUCKET_TYPE') + ': ', '<select class="pivot-column-bucket-type">', '<option value="">(' + t('PIVOT_BUCKET_NONE') + ')</option>', '<option value="day">' + t('PIVOT_BUCKET_DAY') + '</option>',
	      // '<option value="week">week</option>',
	      '<option value="month">' + t('PIVOT_BUCKET_MONTH') + '</option>',
	      // '<option value="quarter">quarter</option>',
	      '<option value="year">' + t('PIVOT_BUCKET_YEAR') + '</option>', '</select>', '</label></div>', '</div>'].join('') : '', '<div class="jsr-settings-section jsr-data-section-controls">', '<div><button class="jsr-btn jsr-add-data-section">Insert data section below</button></div>', canDelete ? '<div><button class="jsr-btn jsr-delete-data-section">Remove this data section</button></div>' : '', '</div>', '</div>', '</div>'].join(""));
	      if (!this.jasperMode) {
	        var $dslist = $("select.level-0-data-source", $target);
	        var opts = this.get_data_source_options_for_group().data.filter(function (opt) {
	          return opt.id !== '__parentgroup';
	        });
	        opts.forEach(function (opt) {
	          $dslist.append($("<option/>").attr("value", opt.id).text(opt.text));
	        });
	        $dslist.val(section.data_source || '').on("change", function (evt) {
	          var selectedId = $(evt.target).val();
	          if (_this5.onDataSourceSelected && typeof _this5.onDataSourceSelected === 'function') {
	            /** User-supplied function returns true if it handles the event and we don't */
	            if (_this5.onDataSourceSelected(selectedId)) return;
	          }
	          section.data_source = selectedId.toLowerCase();
	        }).select2({
	          minimumResultsForSearch: opts.length < 10 ? -1 : undefined,
	          placeholder: '(' + t('NONE') + ')',
	          dropdownAutoWidth: true,
	          dropdownCssClass: 'jsr-select2-dropdown'
	        });
	      }

	      if (this.config.showDataSourceSelector === false) {
	        $target[0].querySelector('.jsr-settings-section-data-source').style.display = 'none';
	      }

	      // Filters
	      var filtersParentNode = isFirst ? this.report_def : section;
	      var filterSectionDomEl = $('.filters-section', $target)[0];
	      this.refresh_filter_list(section, filterSectionDomEl, filtersParentNode);
	      $("button.add-filter", filterSectionDomEl).on("click", function () {
	        _this5.add_filter(filtersParentNode);
	        _this5.refresh_filter_list(section, filterSectionDomEl, filtersParentNode);
	      });

	      var order_detail_by = section.order_detail_by || '';
	      if (order_detail_by !== '') {
	        $target.find(".sort-detail-direction-wrapper").show();
	      } else {
	        $target.find(".sort-detail-direction-wrapper").hide();
	      }
	      $target.find("input.sort-detail-by").val(section.order_detail_by).on("change", function (evt) {
	        var val = $(evt.target).val();
	        section.order_detail_by = val;
	        if (val !== '') {
	          $target.find(".sort-detail-direction-wrapper").show();
	        } else {
	          $target.find(".sort-detail-direction-wrapper").hide();
	        }
	      }).select2({
	        query: this.detail_field_selector_query.bind(this, section),
	        initSelection: this.detail_field_selector_initselection.bind(this, section),
	        // allowClear: true,
	        placeholder: '(' + t('SELECT_FIELD') + ')',
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      $target.find("select.sort-detail-direction").val(section.order_detail_dir || "asc").on("change", function (evt) {
	        section.order_detail_dir = $(evt.target).val();
	      }.bind(this));
	      $target.find("input.show-detail").prop("checked", section.show_detail !== false).on("change", function (evt) {
	        section.show_detail = $(evt.target).prop("checked");
	        this.render_template();
	      }.bind(this));
	      $("select.sort-detail-direction", $target).select2({
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      if (this.enableColumns) {
	        $target.find("input.detail-column-count").val(section.column_count).on("change", function (evt) {
	          var column_count = parseInt($(evt.target).val(), 10);
	          if (!isNaN(column_count) && isFinite(column_count)) {
	            if (column_count < 1) {
	              column_count = 1;
	            } else if (column_count > 99) {
	              column_count = 99;
	            }
	            $(evt.target).val(column_count);
	            this.set_column_count(section, column_count);
	          } else {
	            $(evt.target).val(section.column_count);
	          }
	        }.bind(this));
	      }
	      this.apply_editable_row_hover($target);
	      $target.find(".sort-detail-container .icon-delete").remove();

	      this.render_sub_levels(section);
	      var add_grouping_button = $target.find("button.add-sub-level");
	      add_grouping_button.text(section.sublevels.length === 0 ? t('ADD_GROUP') : t('ADD_SUBGROUP'));
	      add_grouping_button.on("click", this.add_group_level.bind(this, section));

	      if (isFirst) {
	        if (this.jasperMode) {
	          // Pivot not supported in Jasper mode
	          $target.find('.pivot-controls').hide();
	        } else {
	          $target.find("input.pivot-enabled").prop("checked", !!section.pivot_enabled).on("change", function (evt) {
	            _this5.set_pivot_enabled($(evt.target).is(":checked"));
	          });
	          $target.find("input.pivot-column").val(section.pivot_expression || "").select2({
	            query: this.detail_field_selector_query.bind(this, section),
	            initSelection: this.detail_field_selector_initselection.bind(this, section),
	            // allowClear: true,
	            placeholder: t('PIVOT_FIELD_PLACEHOLDER'),
	            dropdownAutoWidth: true,
	            dropdownCssClass: 'jsr-select2-dropdown'
	          }).on("change", function (evt) {
	            var pivot_col = $(evt.target).val();
	            if (pivot_col) {
	              section.pivot_expression = "[" + pivot_col + "]";
	            }
	          });
	          $target.find("select.pivot-column-bucket-type").val(section.pivot_column_bucket_type || "").select2({
	            dropdownAutoWidth: true,
	            dropdownCssClass: 'jsr-select2-dropdown'
	          }).on("change", function (evt) {
	            var bucket_fn = $(evt.target).val();
	            section.pivot_column_bucket_type = bucket_fn || '';
	          });
	        }
	      }
	      $target.find('button.jsr-add-data-section').click(this.onAddDataSectionClick.bind(this, section));
	      $target.find('button.jsr-delete-data-section').click(this.onDeleteDataSectionClick.bind(this, section));
	    },

	    onAddDataSectionClick: function onAddDataSectionClick(section) {
	      var dataSections = this.getDataSections();
	      var ix = dataSections.indexOf(section);
	      this.report_def.body = dataSections;
	      var newSection = this.getDefaultDataSection();
	      this.trigger('dataSectionCreated', newSection);
	      dataSections.splice(ix + 1, 0, newSection);
	      this.render_data_panel();
	      this.render_template();
	      this.openDataSection(ix + 1);
	    },

	    onDeleteDataSectionClick: function onDeleteDataSectionClick(section) {
	      if (!confirm('Warning!  This will remove this data section, including any groupings and any elements within it.  Are you sure?')) return;
	      var body = this.report_def.body;
	      var dataSections = Array.isArray(body) ? body : [body];
	      var ix = dataSections.indexOf(section);
	      this.report_def.body = dataSections;
	      dataSections.splice(ix, 1);
	      this.render_data_panel();
	      this.render_template();
	    },

	    openDataSection: function openDataSection(index) {
	      var $headers = $(this.container).find(".header-panel.data .jsr-data-section-accordion-header", this.container);
	      $headers.eq(index).click();
	    },

	    getDefaultDataSection: function getDefaultDataSection() {
	      return JSON.parse(JSON.stringify(ditto.defaultReport.body));
	    },

	    render_data_panel: function render_data_panel() {
	      var _this6 = this;

	      var me = this,
	          $target = $(".header-panel.data", this.container);
	      var body = this.report_def.body;
	      var dataSections = Array.isArray(body) ? body : [body];
	      $target.empty();
	      if (dataSections.length === 1) {
	        this.renderDataSectionControls(dataSections[0], $target[0], true);
	      } else {
	        // Accordion UI
	        dataSections.forEach(function (sec, secIx) {
	          var $accnHeader = $('<div class="jsr-data-section-accordion-header"><span class="jsr-accordion-icon">\u25B8</span> Data Section ' + (secIx + 1) + '</div>');
	          $accnHeader.data('jsr-ix', secIx);
	          $accnHeader.on('click', _this6.onDataSectionAccordionHeaderClick.bind(_this6));
	          $target.append($accnHeader);
	          var $accnPaneBody = $('<div class="jsr-data-section-accordion-pane-body"></div>');
	          $target.append($accnPaneBody);
	          _this6.renderDataSectionControls(sec, $accnPaneBody[0], secIx === 0, true);
	        });
	        var totalHeaderHeight = 0;
	        $target.find('.jsr-data-section-accordion-header').each(function (ix, hdr) {
	          return totalHeaderHeight += $(hdr).outerHeight();
	        });
	        // Require at least 300px in case there are too many headers to fit
	        this.dataPaneHeight = Math.max(300, $target.innerHeight() - totalHeaderHeight - 1);
	        $target.find('.jsr-data-section-accordion-pane-body').first().height(this.dataPaneHeight);
	      }
	    },

	    onDataSectionAccordionHeaderClick: function onDataSectionAccordionHeaderClick(e) {
	      var $hdr = $(e.target).closest('.jsr-data-section-accordion-header');
	      var ix = $hdr.data('jsr-ix');
	      $(this.container).find('.jsr-data-section-accordion-header').removeClass('jsr-accordion-header-open');
	      $hdr.addClass('jsr-accordion-header-open');
	      var $allPanes = $(this.container).find('.header-panel.data .jsr-data-section-accordion-pane-body');
	      var $thisPane = $allPanes.eq(ix);
	      $allPanes.css('height', '0');
	      $thisPane.css('height', this.dataPaneHeight + 'px');
	    },

	    set_pivot_enabled: function set_pivot_enabled(enabled) {
	      var firstDetail = Array.isArray(this.report_def.body) ? this.report_def.body[0] : this.report_def.body;
	      firstDetail.pivot_enabled = enabled;
	      //var $pivot_inputs = $("");
	      this.set_pivot_dividers_visible(enabled);
	    },

	    set_pivot_dividers_visible: function set_pivot_dividers_visible(visible) {
	      if (!this.$pivot_dividers) {
	        this.render_pivot_dividers();
	      }
	      this.$pivot_dividers.toggle(visible);
	      this.$pivot_area_shading.toggle(visible);
	    },

	    render_pivot_dividers: function render_pivot_dividers() {
	      var me = this,
	          html = '<div class="divider vertical pivot-column-divider"></div>',
	          left_margin_in_units = this.report_def.page.margins["left"];
	      this.$pivot_dividers = $(html + html + html);
	      this.preview_el.append(this.$pivot_dividers);
	      this.$pivot_divider_left = this.$pivot_dividers.eq(0).addClass("pivot-divider-left");
	      this.$pivot_divider_right = this.$pivot_dividers.eq(1).addClass("pivot-divider-right");
	      this.$pivot_area_right = this.$pivot_dividers.eq(2).addClass("pivot-divider-right");
	      this.$pivot_area_shading = $('<div />').addClass("pivot-area-shading");
	      this.preview_el.append(this.$pivot_area_shading);
	      var units = this.report_def.page.units,
	          paper_width = this.report_def.page.paper_size[units][0],
	          preview_width = this.preview_el.width(),
	          pixels_per_unit = this.getCurrentPixelsPerUnit();
	      var pivot_prop_defaults = {
	        'pivot_column_left': 0.45,
	        'pivot_column_right': 0.55,
	        'pivot_area_right': 0.7
	      };
	      var firstDetail = Array.isArray(this.report_def.body) ? this.report_def.body[0] : this.report_def.body;
	      Object.keys(pivot_prop_defaults).forEach(function (prop) {
	        if (typeof firstDetail[prop] === 'undefined') {
	          firstDetail[prop] = paper_width * pivot_prop_defaults[prop] - left_margin_in_units;
	        }
	      });
	      this.$pivot_divider_left.css("left", Math.round((firstDetail.pivot_column_left + left_margin_in_units) * pixels_per_unit));
	      this.$pivot_divider_right.css("left", Math.round((firstDetail.pivot_column_right + left_margin_in_units) * pixels_per_unit));
	      this.$pivot_area_right.css("left", Math.round((firstDetail.pivot_area_right + left_margin_in_units) * pixels_per_unit));
	      this.refresh_pivot_shading();
	      this.$pivot_dividers.addClass('jsr-draggable').drag("start", function (ev, dd) {
	        var which = me.$pivot_dividers.index($(this));
	        dd.limit = {
	          left: which === 0 ? me.preview_el.find(".divider.margin.left").position().left : me.$pivot_dividers.eq(which - 1).position().left + 10,
	          right: which === 2 ? me.preview_el.find(".divider.margin.right").position().left : me.$pivot_dividers.eq(which + 1).position().left - 10
	        };
	      }).drag("end", function (ev, dd) {
	        var pixels_per_unit = me.getCurrentPixelsPerUnit(),
	            which = me.$pivot_dividers.index($(this)),
	            propname = Object.keys(pivot_prop_defaults)[which];
	        var pos = Math.max(dd.limit.left, Math.min(dd.limit.right, dd.offsetX));
	        firstDetail[propname] = pos / pixels_per_unit - left_margin_in_units;
	        me.refresh_pivot_shading();
	      }).drag(function (ev, dd) {
	        $(this).css("left", Math.max(dd.limit.left, Math.min(dd.limit.right, dd.offsetX)));
	      }, { relative: true });
	    },

	    refresh_pivot_shading: function refresh_pivot_shading() {
	      var firstDetail = Array.isArray(this.report_def.body) ? this.report_def.body[0] : this.report_def.body;
	      var left_margin_in_units = this.report_def.page.margins["left"];
	      var units = this.report_def.page.units,
	          pixels_per_unit = this.getCurrentPixelsPerUnit();
	      this.$pivot_area_shading.css({
	        'left': parseInt(this.$pivot_divider_right.css('left'), 10) - 2,
	        'width': (firstDetail.pivot_area_right - this.report_def.body.pivot_column_right) * pixels_per_unit + 1
	      });
	    },

	    // get_current_pixels_per_unit: function() {
	    //   var units = this.report_def.page.units,
	    //     paper_width = this.report_def.page.paper_size[units][0],
	    //     preview_width = this.preview_el.width();
	    //   return (preview_width / paper_width);
	    // },

	    // Get the name of the selected field based on available fields for detail section
	    detail_field_selector_initselection: function detail_field_selector_initselection(section, element, callback) {
	      var id = element.val(),
	          fieldname = id;
	      var data = { id: id, text: fieldname };
	      callback(data);
	    },

	    // Find the list of fields available in the detail section; depends on the group data sources
	    detail_field_selector_query: function detail_field_selector_query(section, options) {
	      var data = [];
	      if (section.sublevels.length > 0) {
	        // If groups exist, we have a function to find the effective data fields
	        data = this.get_fields_for_group_data_source(section, section.sublevels.length - 1).data;
	      } else {
	        // Otherwise, just use fields in the data section's root data source
	        data = this.get_root_data_source_fields(section).data;
	      }
	      options.callback({
	        more: false,
	        results: data
	      });
	    },

	    get_root_data_source_fields: function get_root_data_source_fields(dataSection) {
	      var schema = this.getSchemaForDataSection(dataSection);
	      return this.get_fields_for_schema(schema);
	    },

	    get_fields_for_schema: function get_fields_for_schema(schema) {
	      var fields = [];
	      var byId = {};
	      if (schema) {
	        fields = schema.fields.map(function (field) {
	          var safeName = field.name; //field.name.replace(/\W+/g, '_');
	          var option = { id: safeName, text: safeName };
	          byId[option.id] = option;
	          return option;
	        });
	      }
	      return { byId: byId, data: fields };
	    },

	    get_data_source_options_for_group: function get_data_source_options_for_group() {
	      var defaultOption = {
	        id: "__parentgroup",
	        text: "Rows in parent group"
	      },
	          options = void 0,
	          byId = {};
	      byId[defaultOption.id] = defaultOption;
	      if (this.getDataSourceOptions && typeof this.getDataSourceOptions === 'function') {
	        options = this.getDataSourceOptions(this.data_sources);
	      } else {
	        options = this.data_sources.map(function (ds) {
	          return {
	            id: ds.id.toLowerCase(),
	            text: ds.name || ""
	          };
	        });
	        options.sort(function (dsA, dsB) {
	          return dsA.text.localeCompare(dsB.text);
	        });
	      }
	      options.forEach(function (option) {
	        byId[option.id] = option;
	      });
	      options.splice(0, 0, defaultOption);
	      return {
	        data: options,
	        byId: byId
	      };
	    },

	    // Provide the list of data sources for the level data source drop-down
	    level_data_source_selector_query: function level_data_source_selector_query(options) {
	      var data_source_list = this.get_data_source_options_for_group();
	      options.callback({
	        more: false,
	        results: data_source_list.data
	      });
	    },

	    // Set the existing value in a level's data source drop-down
	    level_data_source_selector_initselection: function level_data_source_selector_initselection(element, callback) {
	      var id = element.val(),
	          data_source_list = this.get_data_source_options_for_group();
	      callback(data_source_list.byId[id]);
	    },

	    get_fields_for_group_data_source: function get_fields_for_group_data_source(section, group_index) {
	      var me = this;
	      var group = section.sublevels[group_index],
	          options = [],
	          byId = {},
	          schema_id = group.data_source;
	      // If parent is "__parentgroup", traverse upward to the closest non-parent or body datasource
	      while (group_index > 0 && schema_id === "__parentgroup") {
	        group_index--;
	        schema_id = section.sublevels[group_index].data_source;
	      }
	      var schema;
	      if (schema_id === "__parentgroup") {
	        schema = this.getSchemaForDataSection(section);
	      } else {
	        schema = this.data_source_schemas[schema_id];
	      }
	      if (schema) {
	        schema.fields.forEach(function (field) {
	          var safeName = field.name; //field.name.replace(/\W+/g, '_');
	          var option = {
	            id: me.jasperMode ? '$F{' + safeName + '}' : safeName,
	            text: safeName
	          };
	          options.push(option);
	          byId[option.id] = option;
	        });
	      }
	      options.sort(function (dsA, dsB) {
	        return dsA.text.localeCompare(dsB.text);
	      });
	      return {
	        data: options,
	        byId: byId
	      };
	    },

	    /** Helper fn to find data section owning a grouping input */
	    getDataSectionFromGroupingControl: function getDataSectionFromGroupingControl(ctlEl) {
	      var $levelList = $(ctlEl).closest('.levels-list');
	      var dataSectionIx = $(this.container).find('.levels-list').index($levelList);
	      return this.getDataSections()[dataSectionIx];
	    },

	    // Provide the list of fields in the current level's selected data source
	    level_field_selector_query: function level_field_selector_query(options) {
	      var $row = options.element.closest(".grouping-row"),
	          dataSection = this.getDataSectionFromGroupingControl(options.element),
	          group_index = $row.closest(".levels-list").find('.grouping-row').index($row);
	      var field_list = this.get_fields_for_group_data_source(dataSection, group_index);
	      options.callback({
	        more: false,
	        results: field_list.data
	      });
	    },

	    // Get the name of the selected "where" child field for a level
	    level_field_selector_initselection: function level_field_selector_initselection(element, callback) {
	      var $row = element.closest(".grouping-row"),
	          dataSection = this.getDataSectionFromGroupingControl(element),
	          group_index = $row.closest(".levels-list").find('.grouping-row').index($row);
	      var field_list = this.get_fields_for_group_data_source(dataSection, group_index);
	      var selectedVal = element.val();
	      callback(field_list.byId[selectedVal] || { id: selectedVal, text: selectedVal });
	    },

	    // Provide the list of fields in the parent level's selected data source
	    level_where_parent_field_query: function level_where_parent_field_query(options) {
	      var $row = options.element.closest(".grouping-row"),
	          dataSection = this.getDataSectionFromGroupingControl(options.element),
	          group_index = $row.closest(".levels-list").find('.grouping-row').index($row);
	      if (group_index < 1) return;
	      var field_list = this.get_fields_for_group_data_source(dataSection, group_index - 1);
	      options.callback({
	        more: false,
	        results: field_list.data
	      });
	    },

	    // Get the name of the selected "where" parent field for a level
	    level_where_parent_field_initselection: function level_where_parent_field_initselection(element, callback) {
	      var $row = element.closest(".grouping-row"),
	          dataSection = this.getDataSectionFromGroupingControl(element),
	          group_index = $row.closest(".levels-list").find('.grouping-row').index($row);
	      if (group_index < 1) return;
	      var field_list = this.get_fields_for_group_data_source(dataSection, group_index - 1);
	      callback(field_list.byId[element.val()]);
	    },

	    // on_data_source_change: function(evt) {
	    //     const firstDetail = Array.isArray(this.report_def.body) ? this.report_def.body[0] : this.report_def.body;
	    //     firstDetail.data_source = $(evt.target).val().toLowerCase();
	    // },

	    get_default_section_height: function get_default_section_height() {
	      return this.report_def.page.units === "mm" ? 25.4 : 1;
	    },

	    add_group_level: function add_group_level(section) {
	      var default_section_height = this.get_default_section_height();
	      section.sublevels.push({
	        "data_source": "__parentgroup",
	        "group_by": "",
	        "sort_dir": "asc",
	        header: {
	          visible: true,
	          height: default_section_height,
	          elements: []
	        },
	        footer: {
	          visible: true,
	          height: default_section_height,
	          elements: []
	        }
	      });
	      this.render_sub_levels(section);
	      this.render_template();
	    },

	    /**
	     * @private
	     * Note, removed hover effect, replaced with manual icons to switch in and out of 
	     * edit mode
	     */
	    apply_editable_row_hover: function apply_editable_row_hover(container, onDelete) {
	      var designer = this;
	      var $rows = $(".editable-row:not(.jsr-ready)", container);
	      $rows.append(['<div class="editable-row-buttons">', '<div class="editable-row-icon icon-check"><div class="icon-label">' + t('OK') + '</div></div>', '<div class="editable-row-icon icon-edit"><div class="icon-label">' + t('EDIT') + '</div></div>', '<div class="editable-row-icon icon-delete"><div class="icon-label">' + t('DELETE') + '</div></div>', '</div>'].join('')).addClass("inactive jsr-ready");
	      $rows.find(".icon-check").on("click", this.on_row_check_click.bind(this));
	      $rows.find(".icon-edit").on("click", this.on_row_edit_click.bind(this));
	      $rows.find(".icon-delete").on("click", onDelete || this.on_row_delete_click.bind(this));
	      $rows.find("input[type=checkbox]").prop("disabled", true);
	      // $rows.on("click", function(evt) {
	      //  var $row = $(evt.target).closest(".editable-row");
	      //  if ($row.length > 0 && $row.hasClass("inactive")) {
	      //      designer.on_row_edit_click.call(designer, evt);
	      //  }
	      // });
	      this.set_row_select2s_enabled($rows, false);
	    },

	    on_row_edit_click: function on_row_edit_click(evt) {
	      var $row = $(evt.target).closest(".editable-row");
	      $row.find("input[type=checkbox]").prop("disabled", false);
	      $row.removeClass("inactive");
	      this.set_row_select2s_enabled($row, true);
	    },

	    on_row_check_click: function on_row_check_click(evt) {
	      var $row = $(evt.target).closest(".editable-row");
	      if (!this.validateEditableControlGroup($row[0])) return;
	      $row.find("input[type=checkbox]").prop("disabled", true);
	      $row.addClass("inactive");
	      this.set_row_select2s_enabled($row, false);
	    },

	    validateEditableControlGroup: function validateEditableControlGroup(groupDomEl) {
	      var group = $(groupDomEl);
	      if (group.hasClass('filter-row')) {
	      } else if (group.hasClass('grouping-row')) {
	        var groupBy = group.find('.group-by');
	        if (!groupBy.select2('data')) {
	          groupBy.addClass('jsr-select2-error');
	          return false;
	        } else {
	          groupBy.removeClass('jsr-select2-error');
	        }
	      }
	      return true;
	    },

	    set_row_select2s_enabled: function set_row_select2s_enabled($row, enabled) {
	      $row.find("select, input").each(function (index, sel) {
	        var $select2 = $(sel).data("select2");
	        if ($select2) {
	          $select2.enable(enabled);
	        }
	      });
	    },

	    on_row_delete_click: function on_row_delete_click(evt) {
	      var $row = $(evt.target).closest(".editable-row");
	      switch ($row.data("row-type")) {
	        case "group":
	          this.delete_group_row($row);
	          break;
	        case "input":
	          this.delete_input_row($row);
	          break;
	      }
	    },

	    delete_group_row: function delete_group_row($row) {
	      var section = this.getDataSectionFromGroupingControl($row[0]);
	      var ix = $row.index(),
	          groupdef = section.sublevels[ix],
	          element_count = groupdef.header.elements.length + groupdef.footer.elements.length;
	      if (element_count > 0) {
	        var proceed = confirm(t('CONFIRM_DELETE_GROUP', { count: element_count }));
	        if (!proceed) return;
	      }
	      section.sublevels.splice(ix, 1);
	      this.render_sub_levels(section);
	      this.render_template();
	    },

	    delete_input_row: function delete_input_row($row) {
	      var ix = $row.index();
	      this.report_def.inputs.splice(ix, 1);
	      $row.remove();
	    },

	    reset_timeout: function reset_timeout($elt, fn, delay) {
	      var id = $elt.attr("id");
	      if (id && this.pending_timeouts[id]) {
	        window.clearTimeout(this.pending_timeouts[id]);
	      }
	      if (fn) {
	        this.pending_timeouts[id] = window.setTimeout(fn, delay);
	      }
	    },

	    add_filter: function add_filter(templateParentNode) {
	      if (!templateParentNode.filters) {
	        templateParentNode.filters = [];
	      }
	      templateParentNode.filters.push({
	        field: "",
	        operator: "is",
	        operand: ""
	      });
	    },

	    add_input: function add_input() {
	      this.report_def.inputs.push({
	        "name": "",
	        "type": "text",
	        "default": ""
	      });
	      this.render_inputs();
	    },

	    refresh_filter_list: function refresh_filter_list(dataSection, domEl, templateParent) {
	      var _this7 = this;

	      var me = this,
	          $filter_section = $(domEl),
	          $filter_list = $(".filters-list", $filter_section),
	          i = 1,

	      // dataSection = this.getDataSections()[0],
	      field_list_options_html = this.get_field_list_options_html(dataSection);
	      $filter_list.empty();
	      var filters = templateParent.filters || [];
	      filters.map(function (filterdef) {
	        var $filter_row = $(['<div class="editable-row filter-row" data-row-type="filter" data-filterindex="' + (i - 1) + '">', i + ': ', '<select class="filter-field filter-', i, '-field">', '<option value="">(' + t('SELECT_FIELD') + ')</option>', field_list_options_html, '</select><br/>', '<select class="filter-operator filter-' + i + '-operator">', '<option value="is" data-fortypes="all">' + t('FILTER_OPERATOR_IS') + '</option>', '<option value="isnot" data-fortypes="all">' + t('FILTER_OPERATOR_IS_NOT') + '</option>', '<option value="contains" data-fortypes="string">' + t('FILTER_OPERATOR_CONTAINS') + '</option>', '<option value="doesnotcontain" data-fortypes="string">' + t('FILTER_OPERATOR_DOES_NOT_CONTAIN') + '</option>', '<option value="gt" data-fortypes="number">' + t('FILTER_OPERATOR_GT') + '</option>', '<option value="lt" data-fortypes="number">' + t('FILTER_OPERATOR_LT') + '</option>', '<option value="gte" data-fortypes="number">' + t('FILTER_OPERATOR_GTE') + '</option>', '<option value="lte" data-fortypes="number">' + t('FILTER_OPERATOR_LTE') + '</option>', '<option value="before" data-fortypes="date">' + t('FILTER_OPERATOR_BEFORE') + '</option>', '<option value="after" data-fortypes="date">' + t('FILTER_OPERATOR_AFTER') + '</option>', '<option value="onorbefore" data-fortypes="date">' + t('FILTER_OPERATOR_ON_OR_BEFORE') + '</option>', '<option value="onorafter" data-fortypes="date">' + t('FILTER_OPERATOR_ON_OR_AFTER') + '</option>', '</select>', '<span class="filter-operand filter-', i, '-operand"><input class="" /><span class="readonly"></span></span>', '</div>'].join(''));
	        $filter_list.append($filter_row);
	        var $field_select = $(".filter-field", $filter_row);
	        $field_select.val(filterdef.field);
	        $field_select.on("change", function (evt) {
	          var $row = $(evt.target).closest(".filter-row");
	          me.update_filter_operand_availability($row);
	        });
	        var $operator_select = $(".filter-operator", $filter_row);
	        var $operand_input = $(".filter-operand input", $filter_row);
	        $operator_select.val(filterdef.operator).on("change", function (evt) {
	          this.set_filter_operand_placeholder($operator_select.val(), $operand_input);
	        }.bind(this));
	        $operand_input.val(filterdef.operand);
	        $operand_input.on("change", this.on_filter_operand_change.bind(this));
	        $operand_input.on("change", this.on_filter_input_change.bind(this, templateParent));
	        $("select", $filter_row).on("change", this.on_filter_input_change.bind(this, templateParent));
	        this.set_filter_operand_readonly_text($operand_input);
	        this.set_filter_operand_placeholder(filterdef.operator, $operand_input);
	        $(".icon-delete", $filter_row).on("click", function () {
	          var $row = $(this).closest(".filter-row"),
	              ix = $row.index();
	          templateParent.filters.splice(ix, 1);
	          $row.remove();
	        });
	        i++;
	      }.bind(this));
	      $("select", $filter_section).select2({
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      var onDelete = function onDelete(evt) {
	        var $row = $(evt.target).closest(".editable-row");
	        var ix = $row.index();
	        templateParent.filters.splice(ix, 1);
	        _this7.refresh_filter_list(dataSection, domEl, templateParent);
	      };
	      this.apply_editable_row_hover($filter_section, onDelete);
	    },

	    update_filter_operand_availability: function update_filter_operand_availability($row) {
	      // first set all enabled
	      var $all_operators = $(".filter-operator option", $row);
	      $all_operators.removeAttr("disabled");
	      var dataSection = this.getDataSections()[0]; // First only for now
	      var current_ds = this.getSchemaForDataSection(dataSection),
	          filter_fieldname = $("select.filter-field", $row).val();
	      if (current_ds && filter_fieldname) {
	        var field = this.find_field_by_fieldname(current_ds, filter_fieldname);
	        if (field) {
	          $all_operators.each(function (ix, option) {
	            var $option = $(option),
	                fortypes = $option.data("fortypes");
	            if (!(fortypes === "all" || fortypes.indexOf(field.type) > -1)) {
	              $option.attr("disabled", "disabled");
	            }
	          });
	        }
	      }
	    },

	    find_field_by_fieldname: function find_field_by_fieldname(ds, fieldname) {
	      for (var i = 0; i < ds.fields.length; i++) {
	        if (ds.fields[i].name === fieldname) {
	          return ds.fields[i];
	        }
	      }
	      return null;
	    },

	    on_filter_input_change: function on_filter_input_change(templateParent, evt) {
	      var $row = $(evt.target).closest(".filter-row"),
	          ix = Number($row.data("filterindex")),
	          field = $row.find("select.filter-field").val(),
	          operator = $row.find("select.filter-operator").val(),
	          operand = $row.find(".filter-operand input").val();
	      $.extend(templateParent.filters[ix], {
	        field: field,
	        operator: operator,
	        operand: operand
	      });
	    },

	    on_filter_operand_change: function on_filter_operand_change(evt) {
	      this.set_filter_operand_readonly_text($(evt.target));
	    },

	    set_filter_operand_readonly_text: function set_filter_operand_readonly_text($input) {
	      var val = $input.val(),
	          readonly = val === '' ? "(enter a value)" : val;
	      $input.closest(".filter-operand").find(".readonly").text(readonly);
	    },

	    set_filter_operand_placeholder: function set_filter_operand_placeholder(operand, $input) {
	      var placeholder = '';
	      switch (operand) {
	        case "is":
	        case "isnot":
	          placeholder = t('FILTER_OPERAND_EXAMPLE_ANY');
	          break;
	        case "contains":
	        case "doesnotcontain":
	          placeholder = t('FILTER_OPERAND_EXAMPLE_TEXT');
	          break;
	        case "gt":
	        case "lt":
	        case "gte":
	        case "lte":
	          placeholder = t('FILTER_OPERAND_EXAMPLE_NUMBER');
	          break;
	        case "before":
	        case "after":
	        case "onorbefore":
	        case "onorafter":
	          placeholder = t('FILTER_OPERAND_EXAMPLE_DATE');
	          break;
	        case "isoneof":
	          placeholder = t('FILTER_OPERAND_EXAMPLE_ONE_OF');
	          break;
	      }
	      $input.attr("placeholder", placeholder);
	    },

	    render_sub_levels: function render_sub_levels(dataSection) {
	      var body = this.report_def.body;
	      var dataSections = Array.isArray(body) ? body : [body];
	      var sectionIx = dataSections.indexOf(dataSection);
	      var $levels = $(this.container).find('.levels-list').eq(sectionIx);
	      var me = this,
	          i = 1,
	          field_list_options_html = this.get_field_list_options_html(dataSection);
	      $levels.empty();
	      dataSection.sublevels.forEach(function (level, index) {
	        var $level = $(['<div class="editable-row grouping-row" data-row-type="group">', i, ': ',
	        // Jasper mode doesn't allow different data sources for sublevels (only re-grouping parent set)
	        index > 0 && !me.jasperMode ? [t('SUBLEVEL_DATA_SOURCE_LABEL') + ': ', '<input class="level-', i, '-data-source level-data-source" type="text" /><br/>', '<div class="level-', i, '-where level-where">', t('SUBLEVEL_MATCH_CHILD_FIELD_LABEL') + ': ', '<input class="level-', i, '-where-child-field level-where-child-field" type="text" />', '<span class="level-where-parent-wrap">', ' ' + t('SUBLEVEL_MATCH_PARENT_FIELD_LABEL') + ' ', '<input class="level-', i, '-where-parent-field level-where-parent-field" type="text" />', '</span>', '</div>'].join('') : '', index === 0 || me.jasperMode ? t('SUBLEVEL_GROUP_BY_FIRST') : t('SUBLEVEL_GROUP_BY'), ' ', '<input class="level-', i, '-group-by group-by" type="text" />', '<div class="group-sort-controls">', t('GROUP_ORDER_LABEL') + ' ', '<input class="level-', i, '-sort-by group-sort-by" type="text" /> ', '<select class="level-', i, '-sort-dir group-sort-dir">', '<option value="asc">' + escapeHtml(t('A_TO_Z')) + '</option>', '<option value="desc">' + escapeHtml(t('Z_TO_A')) + '</option>', '</select>', '</div>', '<div>', t('GROUP_WITH') + ': ', '<label class="group-header-footer-vis-cb"><input type="checkbox" class="show-header-cb" /> ' + t('GROUP_HEADER_LABEL') + '</label> ', '<label class="group-header-footer-vis-cb"><input type="checkbox" class="show-footer-cb" /> ' + t('GROUP_FOOTER_LABEL') + '</label> ', '</div>', '</div>'].join(''));
	        $(".show-header-cb", $level).prop("checked", level.header.visible !== false);
	        $(".show-footer-cb", $level).prop("checked", level.footer.visible !== false);
	        $("input.group-by", $level).val(level.group_by || "");
	        if (me.jasperMode) {
	          $level.find('.group-sort-controls').hide();
	        } else {
	          $("input.group-sort-by", $level).val(level.sort_by || "");
	          $("select.group-sort-dir", $level).val(level.sort_dir || "asc");
	        }
	        var $child_filter_selector = $level.find(".level-where-child-field");
	        $child_filter_selector.val(level.where_child_field || "");
	        $level.find(".level-where-parent-field").val(level.where_parent_field || "");
	        me.set_level_parent_wrap_visibility($child_filter_selector);
	        if (index > 0 && !me.jasperMode) {
	          $("input.level-data-source", $level).val(level.data_source || "__parentgroup");
	          // Only levels coming from external data sources have a "where" clause
	          if (level.data_source === "__parentgroup") {
	            $level.find(".level-where").hide();
	          } else {
	            $level.find(".level-where").show();
	          }
	        }
	        $levels.append($level);
	        i++;
	      });
	      $("input.group-by, input.group-sort-by", $levels).select2({
	        query: this.level_field_selector_query.bind(this),
	        initSelection: this.level_field_selector_initselection.bind(this),
	        // allowClear: true,
	        placeholder: '(' + t('SELECT_FIELD') + ')',
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      $("input.level-data-source", $levels).select2({
	        query: this.level_data_source_selector_query.bind(this),
	        initSelection: this.level_data_source_selector_initselection.bind(this),
	        // allowClear: true,
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      }).on("change", function (evt) {
	        var $select = $(evt.target);
	        if (this.onDataSourceSelected && typeof this.onDataSourceSelected === 'function') {
	          /** User-supplied function returns true if it handles the event and we don't */
	          if (this.onDataSourceSelected($select.val())) return;
	        }
	        var $row = $select.closest(".grouping-row"),
	            row_index = $levels.find(".grouping-row").index($row),
	            groupdef = dataSection.sublevels[row_index];
	        groupdef.data_source = $select.val();
	        // When level data source changes, show/hide filter -- only allow filter for external data sources
	        var $ds = $(this),
	            $whereDiv = $ds.closest(".grouping-row").find(".level-where");
	        if ($ds.val() === "__parentgroup") {
	          $whereDiv.hide();
	        } else {
	          $whereDiv.show();
	        }
	      });
	      $("input.level-where-child-field", $levels).select2({
	        query: this.level_field_selector_query.bind(this),
	        initSelection: this.level_field_selector_initselection.bind(this),
	        placeholder: '(' + t('SUBLEVEL_MATCH_CHILD_FIELD_PLACEHOLDER') + ')',
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      }).on("change", function (evt) {
	        var $select = $(evt.target),
	            $row = $select.closest(".grouping-row"),
	            row_index = $levels.find(".grouping-row").index($row),
	            groupdef = dataSection.sublevels[row_index];
	        groupdef.where_child_field = $select.val();
	        me.set_level_parent_wrap_visibility($(this));
	      });
	      $("input.level-where-parent-field", $levels).select2({
	        query: this.level_where_parent_field_query.bind(this),
	        initSelection: this.level_where_parent_field_initselection.bind(this),
	        // allowClear: true,
	        placeholder: '(' + t('SELECT_FIELD') + ')',
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      }).on("change", function (evt) {
	        var $select = $(evt.target),
	            $row = $select.closest(".grouping-row"),
	            row_index = $levels.find(".grouping-row").index($row),
	            groupdef = dataSection.sublevels[row_index];
	        groupdef.where_parent_field = $select.val();
	        me.set_level_parent_wrap_visibility($(this));
	      });
	      $("select", $levels).select2({
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      $("input[type=checkbox]", $levels).on("change", function (evt) {
	        var $cb = $(evt.target),
	            $row = $cb.closest(".grouping-row"),
	            is_header_cb = $cb.hasClass("show-header-cb"),
	            row_index = $levels.find(".grouping-row").index($row),
	            checked = $cb.prop("checked"),
	            section_to_modify = dataSection.sublevels[row_index].header;
	        if (!is_header_cb) {
	          section_to_modify = dataSection.sublevels[row_index].footer;
	        }
	        section_to_modify.visible = checked;
	        var min_section_height = me.get_default_section_height();
	        // Enforce a minimum height when (re-)activating a header/footer, can't interact w/ it otherwise
	        if (checked && (section_to_modify.height || 0) < 10 / me.pixels_per_unit) {
	          section_to_modify.height = 10 / me.pixels_per_unit;
	        }
	        me.render_template();
	      });
	      $("input.group-by", $levels).on("change", function (evt) {
	        var $select = $(evt.target),
	            $row = $select.closest(".grouping-row"),
	            row_index = $levels.find(".grouping-row").index($row),
	            groupdef = dataSection.sublevels[row_index],
	            $group_sort_sel = $row.find("select.group-sort-by");
	        groupdef.group_by = $select.val();
	        // if "sort by" not already chosen, default to sort by the new grouping key
	        if ($group_sort_sel.val() === "") {
	          $group_sort_sel.select2("val", groupdef.group_by);
	        }
	      });
	      $("input.group-sort-by", $levels).on("change", function (evt) {
	        var $select = $(evt.target),
	            $row = $select.closest(".grouping-row"),
	            row_index = $levels.find(".grouping-row").index($row),
	            groupdef = dataSection.sublevels[row_index];
	        groupdef.sort_by = $select.val();
	      });
	      $("select.group-sort-dir", $levels).on("change", function (evt) {
	        var $select = $(evt.target),
	            $row = $select.closest(".grouping-row"),
	            row_index = $levels.find(".grouping-row").index($row),
	            groupdef = dataSection.sublevels[row_index];
	        groupdef.sort_dir = $select.val();
	      });
	      this.apply_editable_row_hover($levels);
	    },

	    set_level_parent_wrap_visibility: function set_level_parent_wrap_visibility($childFilterSelector) {
	      var $parentWrap = $childFilterSelector.closest(".grouping-row").find(".level-where-parent-wrap");
	      if ($childFilterSelector.val() !== "") {
	        $parentWrap.show();
	      } else {
	        $parentWrap.hide();
	      }
	    },

	    /** 
	     * From a section entry wrapper object (visible section in template rendering),
	     * get the data source schema for that section.
	     * Check upward from a detail section or sub-level (group header/footer) to the first
	     * non-inherited data source (non-"__parentgroup").
	     */
	    getSchemaForSectionEntry: function getSchemaForSectionEntry(sectionEntry) {
	      var dataSection = this.getDataSections()[sectionEntry.detailIndex || 0];
	      var group_index = sectionEntry.is_detail ? (dataSection.sublevels || []).length - 1 : sectionEntry.level;
	      var group = void 0;
	      var schema_id = '__parentgroup';
	      // Traverse upward to the closest non-parent or body datasource
	      while (group_index >= 0 && schema_id === "__parentgroup") {
	        group = dataSection.sublevels[group_index];
	        schema_id = group.data_source;
	        group_index--;
	      }
	      var schema;
	      if (schema_id === "__parentgroup") {
	        // Default to data source for dataSection
	        schema = this.getSchemaForDataSection(dataSection);
	      } else {
	        // Found direct ID reference to primary data source
	        schema = this.data_source_schemas[schema_id];
	      }
	      return schema;
	    },

	    /** Expects dataSection def (raw body definition object) */
	    getSchemaForDataSection: function getSchemaForDataSection(dataSection) {
	      if (!dataSection) return null;
	      if (this.jasperMode) {
	        return this.jasperDef.embeddedSchema;
	      }
	      var selected_ds_id = dataSection.data_source;
	      return selected_ds_id ? this.data_source_schemas[selected_ds_id] : null;
	    },

	    get_field_list_options_html: function get_field_list_options_html(dataSection) {
	      var me = this;
	      var sch = this.getSchemaForDataSection(dataSection);
	      if (!sch) {
	        return '<option value="">(' + t('MISSING_SCHEMA') + ')</option>';
	      }
	      var fields = sch.fields.sort(this.sort_fields_alpha);
	      return sch.fields.map(function (fld) {
	        var val = me.jasperMode ? '$F{' + fld.name + '}' : fld.name;
	        return '<option value="' + val + '">' + fld.name + '</option>';
	      }).join('');
	    },

	    sort_fields_alpha: function sort_fields_alpha(field_a, field_b) {
	      return field_a.name.localeCompare(field_b.name);
	    },

	    /**
	     * @private
	     * Convert the dimensioned user-specified current margins to usable pixel amounts based on current preview width
	     */
	    compute_preview_margins: function compute_preview_margins() {
	      this.preview_margins = {};
	      var preview_width = this.preview_el.width();
	      ["left", "top", "right", "bottom"].map(function (side) {
	        this.preview_margins[side] = Math.floor(Math.min(preview_width, this.report_def.page.margins[side] * this.pixels_per_unit));
	      }.bind(this));
	    },

	    getCurrentPixelsPerUnit: function getCurrentPixelsPerUnit() {
	      var preview_width = this.preview_el.width();
	      var units = this.report_def.page.units;
	      var paper_width = this.report_def.page.paper_size[units][0];
	      return preview_width / paper_width;
	    },

	    render_template: function render_template() {
	      if (this.toolbarPosition !== "float") {
	        this.hide_toolbar();
	      }
	      delete this.fontScaleFactor;
	      this.hideHintBar();
	      this.elements_by_id = {};
	      this.sections_by_element_id = {};
	      this.preview_el.empty();
	      this.$delete_element_button = null;
	      this.preview_section_offsets = [];
	      this.$pivot_dividers = null;
	      this.section_highlight_el = null;
	      this.hintBar = null;
	      delete this.snapline;
	      delete this.edgeMap;
	      if (this.report_def.defaultFont) {
	        var defaultFontCss = this.report_def.defaultFont.css || this.report_def.defaultFont;
	        this.preview_el.css('font-family', defaultFontCss);
	      }
	      this.preview_el.css('font-size', this.report_def.defaultFontSize !== undefined ? this.report_def.defaultFontSize + 'pt' : 'inherit');

	      var zoomFactor = ZOOM_LEVELS[this.zoomLevel];
	      var rightPaneWidth = this.designer_el.find('.preview').innerWidth() - 20;
	      var zoomedWidth = rightPaneWidth * zoomFactor;
	      this.preview_el.closest('.page').css('width', zoomedWidth + 'px');
	      this.preview_el.css('width', zoomedWidth + 'px');
	      this.pixels_per_unit = this.getCurrentPixelsPerUnit();
	      this.compute_preview_margins();

	      var me = this,
	          sections = this.getAllSections(null, true),
	          $preview_el = this.preview_el,
	          def = this.report_def,
	          preview_width = $preview_el.width(),
	          units = this.report_def.page.units,
	          paper_width = this.report_def.page.paper_size[units][0],

	      // pixels_per_unit = (preview_width / paper_width),
	      paper_height_px = this.report_def.page.paper_size[units][1] * this.pixels_per_unit,
	          offset = this.preview_margins.top;
	      var yOffsetUnits = this.report_def.page.margins.top;
	      // this.pixels_per_unit = pixels_per_unit;

	      var $divider = $('<div class="divider margin jsr-margin-top horizontal"></div>');
	      $divider.css("top", Math.min(paper_height_px, this.preview_margins.top) + "px");
	      $preview_el.append($divider);
	      $divider = $('<div class="divider margin left"></div>');
	      // Shift by 2px because we have some padding around the actual line, for a drag handle
	      $divider.css("left", this.preview_margins.left + 2 + "px");
	      $preview_el.append($divider);
	      $divider = $('<div class="divider margin right"></div>');
	      $divider.css("left", preview_width - this.preview_margins.right + 2 + "px");
	      $preview_el.append($divider);
	      $divider = $('<div class="divider margin jsr-margin-bottom horizontal"></div>');
	      $divider.css("top", Math.max(0, paper_height_px - this.preview_margins.bottom) + "px");
	      $preview_el.append($divider);
	      sections.map(function (section) {
	        this.render_template_section_elements(section, offset);
	        var $label = $(['<div class="section-label">', section.label, '</div>'].join(''));
	        $preview_el.append($label);
	        $label.css({
	          width: this.preview_margins.left,
	          left: 0,
	          top: offset + 35
	        });
	        // Keep track of section position for showing highlights when dragging
	        this.preview_section_offsets.push({
	          top: Math.round(offset),
	          topUnits: yOffsetUnits,
	          bottom: Math.round(offset + section.def.height * this.pixels_per_unit),
	          left: this.preview_margins.left,
	          right: this.preview_margins.right,
	          def: section.def,
	          sectionInfo: section,
	          label: section.label,
	          is_header: !!section.is_header,
	          is_footer: !!section.is_footer,
	          is_detail: !!section.is_detail,
	          level: section.level,
	          detailIndex: section.detailIndex,
	          extraSectionIndex: section.extraSectionIndex,
	          isExtraSection: section.isExtraSection
	        });

	        // Bottom divider for section
	        var $divider = $('<div class="divider section-divider horizontal movable"></div>');
	        $divider.css({
	          "top": offset + section.def.height * this.pixels_per_unit + "px",
	          "left": this.preview_margins.left + "px",
	          "right": this.preview_margins.right + "px"
	        });
	        $preview_el.append($divider);

	        $divider.addClass('jsr-draggable').drag("start", function (ev, dd) {
	          var top_limit = 0,
	              bottom_limit = 10000,
	              my_pos = $divider.position().top;
	          $preview_el.find('.divider.horizontal').each(function (ix, el) {
	            var $el = $(el);
	            if ($el.is($divider)) return;
	            var dividerPos = $el.position().top;
	            var isTopMargin = $el.hasClass('jsr-margin-top');
	            var isBottomMargin = $el.hasClass('jsr-margin-bottom');
	            if (dividerPos < my_pos && dividerPos > top_limit && !isBottomMargin) {
	              top_limit = dividerPos;
	            } else if (dividerPos > my_pos && dividerPos < bottom_limit && !isTopMargin) {
	              bottom_limit = dividerPos;
	            }
	          });
	          dd.limit = {
	            top: top_limit + 1,
	            bottom: bottom_limit - 1
	          };
	        }).drag("end", function (ev, dd) {
	          section.def.height += dd.deltaY / this.pixels_per_unit;
	          me.fit_section(section.def);
	          me.render_template();
	        }.bind(this)).drag(function (ev, dd) {
	          $(this).css({ top: Math.max(dd.limit.top, Math.min(dd.limit.bottom, dd.offsetY)) });
	        }, { relative: true });

	        // Render column dividers & mask
	        if (section.columns && section.columns > 1) {
	          var col_width = Math.floor((preview_width - this.preview_margins.left - this.preview_margins.right) / section.columns);
	          for (var i = 1; i < section.columns; i++) {
	            $divider = $('<div class="divider column-divider"></div>');
	            $divider.css({
	              "left": this.preview_margins.left + i * col_width + "px",
	              "top": offset + "px",
	              "height": section.def.height * this.pixels_per_unit + "px"
	            });
	            $preview_el.append($divider);
	          }
	          var $colmask = $('<div class="jsr-column-mask"></div>');
	          $colmask.css({
	            top: offset + "px",
	            height: section.def.height * this.pixels_per_unit + "px",
	            left: this.preview_margins.left + col_width + "px",
	            right: this.preview_margins.right + "px"
	          });
	          $preview_el.append($colmask);
	        }

	        if (section.def.height) {
	          offset += section.def.height * this.pixels_per_unit;
	          yOffsetUnits += section.def.height;
	        }
	      }.bind(this));
	      this.visibleSections = sections.map(function (secInfo) {
	        return secInfo.def;
	      });
	      this.adjust_preview_dimensions();
	      delete this.lastAutoScroll;
	      var firstDetail = Array.isArray(this.report_def.body) ? this.report_def.body[0] : this.report_def.body;
	      this.set_pivot_dividers_visible(!!firstDetail.pivot_enabled);
	      // Delay before cloning columns because some elements wait to render
	      setTimeout(function () {
	        this.update_column_clones();
	        // $preview_el.removeClass("redrawing");    
	        this.initial_render_complete = true;
	      }.bind(this), 0);
	    },

	    /**
	     * @private
	     * Return wrapper objects for all sections in the report
	     */
	    getAllSections: function getAllSections(def, visibleOnly) {
	      var sections = [];
	      if (!def) def = this.report_def;
	      function addPageHeader() {
	        if (def.page_header && (!visibleOnly || def.page_header.visible !== false)) {
	          sections.push({ label: t('PAGE_HEADER'), def: def.page_header, is_header: true });
	        }
	      }
	      function addReportHeader() {
	        if (def.header && (!visibleOnly || def.header.visible !== false)) {
	          sections.push({ label: t('REPORT_HEADER'), def: def.header, is_header: true });
	        }
	      }
	      if (this.jasperMode) {
	        addReportHeader();
	        addPageHeader();
	      } else {
	        addPageHeader();
	        addReportHeader();
	      }
	      if (def.columns && def.columns.header && (!visibleOnly || def.columns.header.visible !== false)) {
	        sections.push({ label: t('COLUMN_HEADER'), def: def.columns.header, is_header: true });
	      }
	      var i, sublevel, levelname;
	      var details = def.body;
	      if (!Array.isArray(details)) {
	        details = [details];
	      }
	      details.forEach(function (detail, detailIx) {
	        var sublevels = detail.sublevels || [];
	        for (i = 0; i < sublevels.length; i++) {
	          sublevel = sublevels[i];
	          levelname = sublevel.group_by ? t('SECTION_LABEL_GROUP_HEADER_NAMED', { group_field: sublevel.group_by }) : t('SECTION_LABEL_GROUP_HEADER', { index: i + 1 });
	          if (sublevel.header && (!visibleOnly || sublevel.header.visible !== false)) {
	            sections.push({ label: levelname, def: sublevel.header, is_header: true, level: i, detailIndex: detailIx });
	          }
	        }
	        if (!visibleOnly || detail.show_detail !== false) {
	          sections.push({
	            label: t('DETAIL_NUMBER', { index: detailIx + 1 }),
	            def: detail,
	            columns: detail.column_count,
	            is_detail: true,
	            detailIndex: detailIx
	          });
	          if (detail.extraSections) {
	            sections = sections.concat(detail.extraSections.map(function (section, extraIx) {
	              return {
	                label: t('DETAIL_NUMBER', { index: detailIx + 1 }),
	                def: section,
	                columns: 1,
	                is_detail: true,
	                detailIndex: detailIx,
	                extraSectionIndex: extraIx,
	                isExtraSection: true
	              };
	            }));
	          }
	        }
	        for (i = sublevels.length - 1; i >= 0; i--) {
	          sublevel = sublevels[i];
	          levelname = sublevel.group_by ? t('SECTION_LABEL_GROUP_FOOTER_NAMED', { group_field: sublevel.group_by }) : t('SECTION_LABEL_GROUP_FOOTER', { index: i + 1 });
	          if (sublevel.footer && (!visibleOnly || sublevel.footer.visible !== false)) {
	            sections.push({ label: levelname, def: sublevel.footer, is_footer: true, level: i, detailIndex: detailIx });
	          }
	        }
	      });
	      if (def.columns && def.columns.footer && (!visibleOnly || def.columns.footer.visible !== false)) {
	        sections.push({ label: t('COLUMN_FOOTER'), def: def.columns.footer, is_footer: true });
	      }
	      function addReportFooter() {
	        if (def.footer && (!visibleOnly || def.footer.visible !== false)) {
	          sections.push({ label: t('REPORT_FOOTER'), def: def.footer, is_footer: true });
	        }
	      }
	      function addPageFooter() {
	        if (def.page_footer && (!visibleOnly || def.page_footer.visible !== false)) {
	          sections.push({ label: t('PAGE_FOOTER'), def: def.page_footer, is_footer: true });
	        }
	      }
	      if (this.jasperMode) {
	        addPageFooter();
	        addReportFooter();
	      } else {
	        addReportFooter();
	        addPageFooter();
	      }
	      return sections;
	    },

	    /**
	     * @private
	     * Return all element definitions, visible or not
	     */
	    getAllElementDefs: function getAllElementDefs() {
	      var sections = this.getAllSections(null, false);
	      var elts = [];
	      sections.forEach(function (sectionWrapper) {
	        elts = elts.concat(sectionWrapper.def.elements || []);
	      });
	      return elts;
	    },

	    /**
	     * @private
	     * When redrawing the template or when a detail element is changed and there is more
	     * than one detail column, refresh the "phantom" rendering in columns 2..n to match
	     */
	    update_column_clones: function update_column_clones() {
	      var _this8 = this;

	      this.preview_el.find(".jsr-column-clone-element").remove();
	      var body = this.report_def.body;
	      var details = Array.isArray(body) ? body : [body];
	      var $clone;
	      details.forEach(function (detail) {
	        if (detail.column_count > 1) {
	          var col_width = Math.floor((_this8.preview_el.width() - _this8.preview_margins.left - _this8.preview_margins.right) / detail.column_count);
	          for (var i = 0; i < detail.elements.length; i++) {
	            var $el = _this8.preview_el.find("#" + detail.elements[i].id),
	                is_selected = $el.is(_this8.editing_control_elt);
	            if ($el) {
	              var left = parseInt($el.css("left"), 10);
	              for (var col = 1; col < detail.column_count; col++) {
	                $clone = $el.clone(false).addClass("jsr-column-clone-element");
	                if (is_selected) {
	                  $clone.find(".jsr-resize-handle").remove();
	                }
	                $clone.css({
	                  left: left + col * col_width + "px"
	                });
	                _this8.preview_el.append($clone);
	              }
	            }
	          }
	        }
	      });
	    },

	    find_section_by_y: function find_section_by_y(y) {
	      // All values in pixels
	      y = Math.round(y);
	      for (var i = 0; i < this.preview_section_offsets.length; i++) {
	        var sec = this.preview_section_offsets[i];
	        if (y >= sec.top && y < sec.bottom) {
	          return sec;
	        }
	      }
	      return null;
	    },

	    // set_section_height: function(sublevel_def, new_height) {
	    //  sublevel_def.height = new_height;
	    //  this.render_template();
	    // },

	    getConditionalPropertiesButton: function getConditionalPropertiesButton() {
	      var $btn = $('<div class="tool-item gradient jsr-toolbar-conditional-properties not-pressable"><div class="icon"></div><div class="jsr-cond-props-count-bubble"></div></div>');
	      $btn.on('click', this.onConditionalPropertiesButtonClick.bind(this));
	      return $btn;
	    },


	    /** 
	     * Takes the template div for jqtoolbar (for example, the one returned
	     * by create_text_toolbar) and adds the template item for the conditional
	     * properties button.  This button will need to be bound to the actual
	     * toolbar instance via bindConditionalPropertiesButton().
	     */
	    addConditionalPropertiesButtonToToolbar: function addConditionalPropertiesButtonToToolbar(toolbarTemplateEl) {
	      var existingButton = toolbarTemplateEl.querySelector('.jsr-toolbar-conditional-properties');
	      if (existingButton) return;
	      var $lastRow = $(toolbarTemplateEl).find('.tool-item').last().parent();
	      $lastRow.append(this.getConditionalPropertiesButton());
	    },


	    onConditionalPropertiesButtonClick: function onConditionalPropertiesButtonClick(evt) {
	      var _this9 = this;

	      var btn = $(evt.target).closest('.tool-item')[0];
	      var propTypes = this.selectedSection ? this.getPropertiesForSection() : this.getPropertiesForElementType(this.editing_control_def.type);
	      var containingSection = this.selectedSection || this.find_section_by_y(this.editing_control_elt.position().top).sectionInfo;
	      var activeSchema = this.getSchemaForSectionEntry(containingSection);
	      var context = {
	        schema: activeSchema
	      };
	      if (this.conditionalPropertiesPicker) return;
	      var saveCallback = $(btn).data('saveCallback') || null;
	      this.conditionalPropertiesTarget = $(btn).data('targetDef') || this.editing_control_def || this.selectedSection.def;
	      var getOperatorsCallback = this.getAllowedConditionalRulesOperators || null;
	      var picker = new _ConditionalPropertiesPicker2.default(propTypes, context, getOperatorsCallback);
	      picker.setColorPalette(this.color_palette);
	      picker.setFonts(this.default_fonts);
	      picker.setValue(this.conditionalPropertiesTarget.conditionalRules);
	      picker.showPopup(btn);
	      this.conditionalPropertiesPicker = picker;
	      // Temporarily store a reference to the active element due to timing issues when closing on blur
	      $(picker).on('save', function (evt, rules) {
	        var count = rules ? rules.length : 0;
	        if (count > 0) {
	          _this9.conditionalPropertiesTarget.conditionalRules = rules;
	        } else {
	          delete _this9.conditionalPropertiesTarget.conditionalRules;
	        }
	        _this9.setCondPropsCount(count, btn);
	        if (saveCallback) {
	          saveCallback(rules);
	        }
	      }).on('close', function () {
	        _this9.conditionalPropertiesPicker = null;
	        _this9.conditionalPropertiesTarget = null;
	      });
	    },

	    getPropertiesForSection: function getPropertiesForSection() {
	      return {
	        visible: _ReportElement.PropTypes.boolean,
	        shrinkToFit: _ReportElement.PropTypes.boolean
	      };
	    },

	    getPropertiesForElementType: function getPropertiesForElementType(eltType) {
	      var props = {
	        visible: _ReportElement.PropTypes.boolean,
	        left: _ReportElement.PropTypes.number,
	        top: _ReportElement.PropTypes.number,
	        width: _ReportElement.PropTypes.number,
	        height: _ReportElement.PropTypes.number
	      };
	      switch (eltType) {
	        case 'text':
	          _.extend(props, {
	            text: _ReportElement.PropTypes.string,
	            bold: _ReportElement.PropTypes.boolean,
	            underline: _ReportElement.PropTypes.boolean,
	            italic: _ReportElement.PropTypes.boolean,
	            text_color: _ReportElement.PropTypes.color,
	            background_color: _ReportElement.PropTypes.color,
	            font: _ReportElement.PropTypes.font,
	            fontsize: _ReportElement.PropTypes.number,
	            align: _ReportElement.PropTypes.oneOf(['left', 'center', 'right'])
	          });
	          break;
	        case 'image':
	          _.extend(props, {
	            url: _ReportElement.PropTypes.string
	          });
	          break;
	        case 'box':
	          _.extend(props, {
	            background_color: _ReportElement.PropTypes.color,
	            border_color: _ReportElement.PropTypes.color,
	            corner_radius: _ReportElement.PropTypes.number
	          });
	          break;
	        case 'barcode':
	          _.extend(props, {
	            value: _ReportElement.PropTypes.string
	          });
	          break;
	        case "chart_line":
	        case "chart_bar":
	        case "chart_pie":
	          break;
	        case 'break':
	          ['left', 'width', 'height'].forEach(function (removeProp) {
	            delete props[removeProp];
	          });
	          break;
	        default:
	          var elTypeInfo = this.elementTypes[eltType.toLowerCase()];
	          var elClass = elTypeInfo && elTypeInfo.handler;
	          if (elClass) {
	            props = _.extend({}, elClass.propTypes);
	          }
	      }
	      return props;
	    },

	    create_text_toolbar: function create_text_toolbar() {
	      var me = this;
	      this.text_toolbar = $(['<div id="jsr-designer-text-toolbar" style="display:none">', '<div>', '<div class="tool-item gradient jsr-toolbar-text-content not-pressable"><div class="input-wrap"></div></div>', '<div class="tool-item gradient jsr-toolbar-text-textcolor not-pressable"><input type="text" /></div>', '<div class="tool-item gradient jsr-toolbar-text-backgroundcolor not-pressable"><input type="text" /></div>', '</div>', '<div>', '<div class="tool-item gradient jsr-toolbar-text-bold"><div class="icon"></div></div>', '<div class="tool-item gradient jsr-toolbar-text-italic"><div class="icon"></div></div>', '<div class="tool-item gradient jsr-toolbar-text-underline"><div class="icon"></div></div>', '<div class="tool-item gradient jsr-toolbar-text-font-family not-pressable"><select></select>&nbsp;</div>', '<div class="tool-item gradient jsr-toolbar-text-font-size not-pressable"><select></select> pt</div>', '<div class="tool-item gradient jsr-toolbar-text-left"><div class="icon"></div></div>', '<div class="tool-item gradient jsr-toolbar-text-center"><div class="icon"></div></div>', '<div class="tool-item gradient jsr-toolbar-text-right"><div class="icon"></div></div>', '<div class="tool-item gradient jsr-toolbar-text-wrap not-pressable"><label><input type="checkbox" /> Wrap</label></div>', '<div class="tool-item gradient jsr-toolbar-text-rotate not-pressable">&nbsp;Rotate: <select style="width: 100px">', '<option value="">(None)</option>', '<option value="-90">-90 degrees (left / counter-clockwise)</option>', '<option value="90">90 degrees (right / clockwise)</option>', '</select>&nbsp;</div>', '</div>', '</div>'].join(''));
	      var $font_selector = $(".jsr-toolbar-text-font-family select", this.text_toolbar),
	          $size_selector = $(".jsr-toolbar-text-font-size select", this.text_toolbar);
	      this.populateFontSelector($font_selector[0], [{ id: 'default', text: '(' + t('DEFAULT_FONT') + ')' }]);
	      var font_size_options_html = ['<option value="default"></option>'];
	      this.font_size_options.map(function (size) {
	        var option = String(size);
	        font_size_options_html.push('<option value="' + option + '">' + option + '</option>');
	      });
	      $size_selector.append(font_size_options_html.join(''));
	      $font_selector.on("change", function (evt) {
	        var fontname = $(evt.target).val(),
	            css = "";
	        if (fontname != "default") {
	          css = me.default_fonts.filter(function (font) {
	            return font.name.toLowerCase() === fontname.toLowerCase();
	          })[0].css;
	        }
	        me.editing_control_def.font = { name: fontname, css: css };
	        me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	        me.onElementEdit();
	      });
	      $size_selector.on("change", function (evt) {
	        var size = $(evt.target).val();
	        me.editing_control_def.fontsize = size;
	        me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	        me.onElementEdit();
	      });
	      this.text_toolbar.find(".jsr-toolbar-text-left").on("click", this.handle_text_toolbar_alignment_click.bind(this, "left"));
	      this.text_toolbar.find(".jsr-toolbar-text-center").on("click", this.handle_text_toolbar_alignment_click.bind(this, "center"));
	      this.text_toolbar.find(".jsr-toolbar-text-right").on("click", this.handle_text_toolbar_alignment_click.bind(this, "right"));
	      this.text_toolbar.find(".jsr-toolbar-text-bold").on("click", function () {
	        me.editing_control_def.bold = !me.editing_control_def.bold;
	        me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	        me.onElementEdit();
	      });
	      this.text_toolbar.find(".jsr-toolbar-text-italic").on("click", function () {
	        me.editing_control_def.italic = !me.editing_control_def.italic;
	        me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	        me.onElementEdit();
	      });
	      this.text_toolbar.find(".jsr-toolbar-text-underline").on("click", function () {
	        me.editing_control_def.underline = !me.editing_control_def.underline;
	        me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	        me.onElementEdit();
	      });
	      this.text_toolbar.find(".jsr-toolbar-text-wrap input").prop("checked", me.editing_control_def.wrap !== false).on("change", function (evt) {
	        me.editing_control_def.wrap = $(evt.target).is(":checked");
	        me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	      });
	      this.text_toolbar.find(".jsr-toolbar-text-rotate select").val('' + (me.editing_control_def.rotateDegrees || '') + (me.editing_control_def.rotateDir || '')).on('change', function (evt) {
	        var val = $(evt.target).val();
	        if (val === '-90') {
	          me.editing_control_def.rotateDegrees = -90;
	        } else if (val === '90') {
	          me.editing_control_def.rotateDegrees = 90;
	        } else {
	          delete me.editing_control_def.rotateDegrees;
	        }
	        me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	        me.onElementEdit();
	      });
	      // Kill click events due to toolbar interference
	      this.text_toolbar.find(".jsr-toolbar-text-wrap").find("label, input").on("click", function (evt) {
	        evt.stopPropagation();
	      });
	      this.text_toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append(this.text_toolbar);
	    },

	    populateFontSelector: function populateFontSelector(selectEl, prependOptions) {
	      var font_options_html = prependOptions ? prependOptions.map(function (opt) {
	        return '<option value="' + opt.id + '">' + opt.text + '</option>';
	      }) : [];
	      this.default_fonts.sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	      }).map(function (font) {
	        font_options_html.push('<option value="' + font.name + '">' + font.name + '</option>');
	      });
	      $(selectEl).append(font_options_html.join(''));
	    },

	    get_advanced_editor_icon: function get_advanced_editor_icon() {
	      var icon = $('<div class="jsr-toolbar-advanced"></div>');
	      icon.on("click", this.on_advanced_editor_icon_click.bind(this));
	      return icon;
	    },

	    adjustPropsForAdvEditor: function adjustPropsForAdvEditor(eltDef) {
	      var adjusted = _extends({}, eltDef);
	      ['top', 'left', 'width', 'height'].forEach(function (prop) {
	        if (prop in adjusted) {
	          adjusted[prop] = Number(adjusted[prop]).toFixed(2);
	        }
	      });
	      delete adjusted.conditionalRules;
	      return adjusted;
	    },

	    on_advanced_editor_icon_click: function on_advanced_editor_icon_click(evt) {
	      var _this10 = this;

	      if (this.showing_property_editor) {
	        return;
	      }

	      var html = '\n      <div class="jsr-property-editor-scrollarea"></div>\n      <div class="jsr-property-editor-buttons">\n        <button class="jsr-btn jsr-property-editor-ok">' + t('OK') + '</button>\n        <button class="jsr-btn jsr-property-editor-cancel">' + t('CANCEL') + '</button>\n      </div>';

	      var popup = new _Popup2.default({
	        className: 'jsr-property-editor',
	        target: evt.target,
	        align: 'right',
	        contentHtml: html
	      });

	      var possible_props = {};
	      var current_props = {};
	      if (this.editing_control_def) {
	        if (this.activeElementInstance && this.activeElementInstance.getExtendedProperties) {
	          var context = this.getSelectedElementContext();
	          possible_props = this.activeElementInstance.getExtendedProperties(context);
	          current_props = this.activeElementInstance.getExtendedPropertyValues(context);
	          Object.keys(current_props).map(function (key) {
	            if (current_props[key] === undefined) {
	              current_props[key] = '';
	            }
	          });
	        } else {
	          possible_props = this.get_possible_props();
	          current_props = $.extend(this.get_default_props(this.editing_control_def.type), this.adjustPropsForAdvEditor(this.editing_control_def));
	        }
	      } else if (this.selectedSection) {
	        possible_props = this.getSectionProps();
	        current_props = this.getSectionPropValues(this.selectedSection.def);
	      }
	      _.each(possible_props, function (propDef) {
	        if (propDef.type === 'string' && propDef.options) {
	          propDef.type = 'options';
	        } else if (propDef.type === 'color') {
	          propDef.options = _.extend({
	            allowEmpty: true,
	            showInput: true,
	            showAlpha: true,
	            showPalette: true,
	            palette: _this10.color_palette
	          }, propDef.options);
	        }
	      });
	      if (current_props.font) {
	        current_props.font = current_props.font.name;
	      }
	      ['$jasperId', '$jasperType'].forEach(function (disallowedKey) {
	        if (current_props[disallowedKey]) {
	          delete current_props[disallowedKey];
	        }
	      });
	      var $popupEl = $(popup.el);
	      $popupEl.find('.jsr-property-editor-scrollarea').jqPropertyGrid(current_props, possible_props);
	      $popupEl.find('button.jsr-property-editor-ok').on('click', this.on_property_editor_ok.bind(this));
	      $popupEl.find('button.jsr-property-editor-cancel').on('click', this.on_property_editor_cancel.bind(this));
	      var patternField = $popupEl.find('input[id$="pattern"]');
	      if (patternField.length > 0) {
	        (function () {
	          var patternOpts = PATTERN_OPTIONS.slice(0);
	          var pattern = current_props.pattern;
	          if (pattern && !patternOpts.find(function (o) {
	            return o.id === pattern;
	          })) {
	            patternOpts.push({ id: pattern, text: pattern });
	          }
	          patternField.select2({
	            data: patternOpts,
	            dropdownAutoWidth: true,
	            dropdownCssClass: 'jsr-select2-dropdown',
	            createSearchChoice: function createSearchChoice(term, data) {
	              if ($(data).filter(function () {
	                return this.text.localeCompare(term) === 0;
	              }).length === 0) {
	                return { id: term, text: term };
	              }
	            }
	          });
	        })();
	      }
	      this.showing_property_editor = true;
	      this.property_editor = popup;
	    },

	    on_property_editor_ok: function on_property_editor_ok() {
	      var props = $(this.property_editor.el).find('.jsr-property-editor-scrollarea').jqPropertyGrid('get');
	      if (typeof props.font !== 'undefined') {
	        // Don't drop existing CSS unless font property was changed
	        if (this.editing_control_def.font && props.font !== this.editing_control_def.font.name) {
	          props.font = { name: props.font, css: props.font };
	        } else {
	          delete props.font;
	        }
	      }
	      if (this.editing_control_def) {
	        if (this.activeElementInstance) {
	          this.activeElementInstance.saveExtendedProperties(props);
	          // Write all properties back to template element definition
	          _.extend(this.editing_control_def, this.activeElementInstance.props);
	          this.updateElementRendering(this.editing_control_def, this.editing_control_elt);
	        } else {
	          $.extend(this.editing_control_def, props);
	        }
	      } else if (this.selectedSection) {
	        $.extend(this.selectedSection.def, props);
	      }
	      this.hidePropertyEditor();
	      this.render_template();
	    },

	    on_property_editor_cancel: function on_property_editor_cancel() {
	      this.hidePropertyEditor();
	    },

	    hidePropertyEditor: function hidePropertyEditor() {
	      this.property_editor.hide();
	      this.showing_property_editor = false;
	    },

	    get_default_props: function get_default_props(eltType) {
	      switch (eltType) {
	        case "text":
	          return {
	            align: "left",
	            visible: true,
	            text_color: "black",
	            background_color: "",
	            height: 20 / this.pixels_per_unit,
	            text: '',
	            fit_content: "vertical",
	            pattern: '',
	            syntax: 'plain'
	          };
	        case 'subreport':
	          return {
	            report: null,
	            height: 100 / this.pixels_per_unit
	          };
	      }
	      return {};
	    },

	    get_possible_props: function get_possible_props() {
	      var props = {
	        "left": { group: 'Position', name: 'Left' },
	        "top": { group: 'Position', name: 'Top' },
	        "width": { group: 'Position', name: 'Width' },
	        "height": { group: 'Position', name: 'Height' },
	        "visible": { group: 'Appearance', name: 'Visible', type: 'string' },
	        "left_px": { browsable: false },
	        "width_px": { browsable: false },
	        "type": { browsable: false },
	        "report": { browsable: false }
	      };
	      switch (this.editing_control_def.type) {
	        case "text":
	          props = $.extend(props, {
	            "text": { group: 'Content', name: 'Text' },
	            "pattern": { group: 'Content', name: 'Pattern', type: 'string' },
	            "text_color": { group: 'Appearance', name: 'Text color' },
	            "background_color": { group: 'Appearance', name: 'Background color' },
	            "font": { group: 'Appearance', name: 'Font', type: 'string' },
	            "font_size": { group: 'Appearance', name: 'Font size' },
	            'syntax': { group: 'Content', name: 'Syntax', type: 'string', options: ['plain', 'markdown', 'html'] }
	          });
	          break;
	        case "chart_line":
	        case "chart_bar":
	        case "chart_pie":
	          break;
	        case "box":
	          break;
	        case "image":
	          break;
	        case "barcode":
	          props = $.extend(props, {
	            "value": { group: 'Content', name: 'Value' }
	          });
	          break;
	      }
	      return props;
	    },

	    getSectionProps: function getSectionProps(section) {
	      return {
	        "visible": { group: 'Appearance', name: 'Visible', type: 'string' },
	        // "backgroundColor": { group: 'Position', name: 'Background color' },
	        // "altBackgroundColor": { group: 'Position', name: 'Alt background color' },
	        "shrinkToFit": { group: 'Position', name: 'Shrink to fit' },
	        "repeatEachPage": { group: 'Position', name: 'Repeat on every page' }
	      };
	    },

	    getSectionPropValues: function getSectionPropValues(section) {
	      return {
	        "visible": typeof section.visible === 'undefined' ? '' : section.visible,
	        // "backgroundColor": section.backgroundColor || '',
	        // "altBackgroundColor": section.altBackgroundColor || '',
	        "shrinkToFit": !!section.shrinkToFit,
	        "repeatEachPage": !!section.repeatEachPage
	      };
	    },

	    on_text_toolbar_text_change: function on_text_toolbar_text_change(def, el, text) {
	      var origDef = _extends({}, def);
	      def.text = text;
	      this.apply_text_styles(def, el);
	      this.onElementEdit();
	      this.dispatch((0, _designerActions.elementPropertyChangeAction)(origDef, 'text', text));
	    },

	    handle_text_toolbar_alignment_click: function handle_text_toolbar_alignment_click(alignment) {
	      var origDef = _extends({}, this.editing_control_def);
	      this.editing_control_def.align = alignment;
	      this.apply_text_styles(this.editing_control_def, this.editing_control_elt);
	      this.onElementEdit();
	      this.dispatch((0, _designerActions.elementPropertyChangeAction)(origDef, 'align', alignment));
	    },

	    apply_text_styles: function apply_text_styles(def, $wrapElt) {
	      var _this11 = this;

	      var $elt = $wrapElt.find('.jsr-text');
	      // Must pre-apply styles here to measure font size correctly
	      if (def.styles) {
	        if (Array.isArray(def.styles)) {
	          def.styles.map(function (cssClass) {
	            return $elt.addClass(cssClass);
	          });
	        } else {
	          $elt.addClass(def.styles);
	        }
	      }
	      if (def.italic !== undefined) {
	        $elt.css("font-style", def.italic ? "italic" : "normal");
	      }
	      if (def.underline !== undefined) {
	        $elt.css("text-decoration", def.underline ? "underline" : "none");
	      }
	      if (def.bold !== undefined) {
	        $elt.css("font-weight", def.bold ? "bold" : "normal");
	      }
	      if (def.align !== undefined) {
	        $elt.css("text-align", def.align || "left");
	      }
	      if (def.fontsize) {
	        var scaledFontSize = parseFloat(def.fontsize) * this.getFontScaleFactor();
	        $elt.css('font-size', scaledFontSize.toFixed(2) + 'pt');
	      } else {
	        (function () {
	          // Must measure without an element fontsize set, because font size can come
	          // from multiple places (CSS) and we can't calculate it directly
	          var fontScalePercent = _this11.getFontScaleFactor() * 100;
	          $elt[0].style.fontSize = '';
	          var defaultFontSizeCss = $elt.css('font-size');
	          if (!defaultFontSizeCss && !document.contains($wrapElt[0])) {
	            // Must temporarily attach to DOM to read font size
	            var origVis = $wrapElt.css('visibility');
	            $wrapElt.css('visibility', 'hidden');
	            _this11.preview_el.append($wrapElt);
	            defaultFontSizeCss = $elt.css('font-size');
	            $wrapElt.remove();
	            $wrapElt.css('visibility', origVis);
	          }
	          var units = ['pt', 'px', 'em', 'rem'].find(function (unit) {
	            return defaultFontSizeCss.indexOf(unit) >= 0;
	          });
	          var scaledFontSize = parseFloat(defaultFontSizeCss) * _this11.getFontScaleFactor();
	          $elt.css('font-size', '' + scaledFontSize.toFixed(2) + units);
	        })();
	      }
	      var font = def.font || this.report_def.defaultFont;
	      if (font) {
	        var fontCss = font.css || font;
	        var fontName = font.name || fontCss;
	        if (def.font) {
	          $elt.css("font-family", fontCss);
	          ditto.requireWebFont(fontName);
	        }
	      }
	      if (def.text_color) {
	        $elt.css("color", def.text_color);
	      }
	      if (def.background_color) {
	        $elt.css("background-color", def.background_color);
	      }
	      if (def.borders) {
	        ['top', 'right', 'bottom', 'left'].forEach(function (side) {
	          if (def.borders[side]) {
	            $elt.css('border-' + side, def.borders[side]);
	          }
	        });
	      }
	      [90, -90].forEach(function (deg) {
	        return $elt.removeClass('jsr-text-rotate-' + deg);
	      });
	      if (def.rotateDegrees) {
	        $elt.addClass('jsr-text-rotate-' + def.rotateDegrees);
	      }
	      var isMarkdown = def.syntax === 'markdown';
	      var shouldWrap = def.wrap !== false; // Now defaults to wrap=true
	      $elt.css("white-space", shouldWrap || isMarkdown ? "pre-line" : "nowrap");
	      var displayText = def.text.replace(/\\n/gim, '\n');
	      if (isMarkdown) {
	        if (!this.markdownConverter) {
	          this.markdownConverter = new showdown.Converter({
	            strikethrough: true
	          });
	        }
	        var html = this.markdownConverter.makeHtml(displayText);
	        if (html.startsWith('<p>') && html.endsWith('</p>')) {
	          html = html.substring(3, html.length - 4);
	        }
	        // Don't allow more than one linebreak between HTML tags
	        html = html.replace(/>\s*\n\s*</gim, '>\n<');
	        $elt.html(html);
	      } else {
	        $elt.text(displayText);
	      }
	    },

	    // The jquery color picker needs to be bound directly to the live instance (copy)
	    // of the toolbar, so we bind events separately after control selection
	    bind_text_toolbar_events: function bind_text_toolbar_events() {
	      var me = this,
	          tb_instance_el = this.editing_control_elt.toolbar("getToolbarElement");
	      tb_instance_el.find(".jsr-toolbar-text-textcolor input").spectrum({
	        color: this.editing_control_def.text_color || '',
	        showPalette: true,
	        palette: this.color_palette,
	        showAlpha: false,
	        allowEmpty: false,
	        change: function change(color) {
	          var color_hex = color === null ? "transparent" : color.toHexString();
	          tb_instance_el.find(".jsr-text-color-icon").css("border-bottom-color", color_hex);
	          me.editing_control_def.text_color = color_hex;
	          me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	          me.onElementEdit();
	        }
	      });
	      tb_instance_el.find(".jsr-toolbar-text-backgroundcolor input").spectrum({
	        color: this.editing_control_def.background_color || '',
	        showPalette: true,
	        palette: this.color_palette,
	        showAlpha: true,
	        allowEmpty: true,
	        change: function change(color) {
	          var color_hex = color === null ? "transparent" : color.toHexString();
	          me.editing_control_def.background_color = color_hex;
	          me.apply_text_styles(me.editing_control_def, me.editing_control_elt);
	          me.onElementEdit();
	        }
	      });
	      tb_instance_el.find(".jsr-toolbar-text-textcolor .sp-preview").append('<div class="jsr-text-color-icon">A</div>');
	    },

	    create_image_toolbar: function create_image_toolbar() {
	      var me = this;
	      this.image_toolbar = $(['<div id="jsr-designer-image-toolbar" style="display:none">', '<div>', '<div class="tool-item image-list">', '<div class="jsr-designer-image-dropzone">', '<span class="dz-message">Drop an image file here or click</span>', '</div>', '</div>', '</div>', '</div>'].join(''));
	      var $image_list = $(".image-list", this.image_toolbar);
	      this.images.map(function (imgdef) {
	        var $img = $('<div class="image-item"><div class="thumbnail"></div><div class="caption"></div></div>');
	        $img.find(".thumbnail").css("background-image", "url(" + imgdef.url + ")");
	        $img.find(".caption").html(imgdef.name);
	        $img.data("img-index", me.images.indexOf(imgdef));
	        $image_list.append($img);
	      });
	      $image_list.on("click", ".image-item", function (evt) {
	        var index = $(evt.target).closest(".image-item").data("img-index"),
	            url = me.images[index].url;
	        $.extend(me.editing_control_def, me.images[index]);
	        if (me.embedImages) {
	          me.capture_image_data(me.editing_control_def, url);
	        }
	        $("img", me.editing_control_elt).attr("src", url);
	        me.onElementEdit();
	      });
	      this.image_toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append(this.image_toolbar);
	    },

	    bind_image_toolbar: function bind_image_toolbar() {
	      var _this12 = this;

	      var me = this,
	          tb_instance_el = this.editing_control_elt.toolbar("getToolbarElement");
	      if (this.allowImageUpload) {
	        tb_instance_el.find('.jsr-designer-image-dropzone').dropzone({
	          url: '#',
	          autoProcessQueue: false,
	          clickable: true,
	          createImageThumbnails: false,
	          accept: function accept(file, done) {
	            _this12.handleDroppedImage(file, done);
	          }
	        });
	      } else {
	        tb_instance_el.find('.jsr-designer-image-dropzone').hide();
	      }
	    },

	    handleDroppedImage: function handleDroppedImage(file, done) {
	      var _this13 = this;

	      var fileReader;
	      fileReader = new FileReader();
	      fileReader.onload = function () {
	        var url = fileReader.result;
	        var baseName = 'Uploaded';
	        var name = baseName;
	        var suffix = 2;
	        while (_this13.images.find(function (img) {
	          return img.name.toLowerCase() === name.toLowerCase();
	        }) && suffix < 20) {
	          name = baseName + ' (' + suffix++ + ')';
	        }
	        _this13.images.push({
	          name: name,
	          url: url
	        });
	        setTimeout(_this13.rebuildImageToolbar.bind(_this13), 0);
	        done();
	      };
	      fileReader.readAsDataURL(file);
	    },

	    rebuildImageToolbar: function rebuildImageToolbar() {
	      var selectedEl = this.editing_control_elt;
	      this.clear_selection();
	      selectedEl.toolbar('getToolbarElement').remove();
	      selectedEl.data('toolbarObj', null);
	      delete this.image_toolbar;
	      $('#jsr-designer-image-toolbar').remove();
	      this.select_element(selectedEl);
	    },

	    capture_image_data: function capture_image_data(elt_def, img_url) {
	      var img = new Image();
	      img.onload = function () {
	        var canvas = document.createElement("canvas");
	        canvas.width = img.naturalWidth;
	        canvas.height = img.naturalHeight;
	        var ctx = canvas.getContext("2d");
	        ctx.drawImage(img, 0, 0);
	        elt_def.url = canvas.toDataURL("image/png");
	      };
	      img.src = img_url;
	    },

	    create_chart_toolbar: function create_chart_toolbar() {
	      var me = this;
	      var containingSection = this.find_section_by_y(this.editing_control_elt.position().top);
	      var dataSection = this.getDataSections()[containingSection.sectionInfo.detailIndex || 0];
	      var field_list_html = this.get_field_list_options_html(dataSection);
	      this.chart_toolbar = $(['<div id="jsr-designer-chart-toolbar" class="jsr-designer-chart-toolbar" style="display:none">', '<div>', '<div class="tool-item gradient jsr-toolbar-chart-type not-pressable">Type: <select><option value="line">Line</option><option value="bar">Bar</option><option value="pie">Pie</option></select></div>', '<div class="tool-item gradient jsr-toolbar-chart-value-field not-pressable">Value field: <select><option value="">(none)</option>', field_list_html, '</select></div>', '<div class="tool-item gradient jsr-toolbar-chart-label-field not-pressable">Label field: <select><option value="">(none)</option>', field_list_html, '</select></div>', '</div>', '</div>'].join(''));
	      $(".jsr-toolbar-chart-type select", this.chart_toolbar).on("change", function (evt) {
	        var newtype = "chart_" + $(evt.target).val(),

	        // $canvas = $("canvas", this.editing_control_elt),
	        $toolbar = $(evt.target).closest(".tool-container");
	        this.editing_control_def.type = newtype;
	        // Move the label field between series[0] and x_axis depending on chart type
	        switch (newtype) {
	          case "chart_line":
	          case "chart_bar":
	            if (!this.editing_control_def.x_axis) {
	              this.editing_control_def.x_axis = {};
	            }
	            this.editing_control_def.x_axis.label_field = $toolbar.find(".jsr-toolbar-chart-label-field select").val();
	            this.onElementEdit();
	            break;
	          case "chart_pie":
	            if (!this.editing_control_def.series) {
	              this.editing_control_def.series = [{}];
	            }
	            delete this.editing_control_def.x_axis;
	            this.editing_control_def.series[0].label_field = $toolbar.find(".jsr-toolbar-chart-label-field select").val();
	            this.onElementEdit();
	            break;
	        }
	        this.editing_control_elt.removeClass("chart_line chart_bar chart_pie");
	        this.editing_control_elt.addClass(newtype);
	        this.update_preview_chart(this.editing_control_elt);
	        this.onElementEdit();
	      }.bind(this));
	      $(".jsr-toolbar-chart-value-field select", this.chart_toolbar).on("change", function (evt) {
	        var newval = $(evt.target).val();
	        switch (this.editing_control_def.type) {
	          case "chart_line":
	          case "chart_bar":
	          case "chart_pie":
	            if (!this.editing_control_def.series) {
	              this.editing_control_def.series = [{}];
	            }
	            this.editing_control_def.series[0].value_field = newval;
	            this.onElementEdit();
	            break;
	        }
	      }.bind(this));
	      $(".jsr-toolbar-chart-label-field select", this.chart_toolbar).on("change", function (evt) {
	        var newval = $(evt.target).val();
	        switch (this.editing_control_def.type) {
	          case "chart_line":
	          case "chart_bar":
	            if (!this.editing_control_def.x_axis) {
	              this.editing_control_def.x_axis = {};
	            }
	            this.editing_control_def.x_axis.label_field = newval;
	            this.onElementEdit();
	            break;
	          case "chart_pie":
	            if (!this.editing_control_def.series) {
	              this.editing_control_def.series = [{}];
	            }
	            this.editing_control_def.series[0].label_field = newval;
	            this.onElementEdit();
	            break;
	        }
	      }.bind(this));
	      this.chart_toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append(this.chart_toolbar);
	    },

	    create_box_toolbar: function create_box_toolbar() {
	      var me = this;
	      this.box_toolbar = $(['<div id="jsr-designer-box-toolbar" style="display:none">', '<div>', '<div class="tool-item gradient jsr-toolbar-box-bordercolor not-pressable">Border: <input type="text" /></div>', '<div class="tool-item gradient jsr-toolbar-box-backgroundcolor not-pressable">Background: <input type="text" /></div>', '<div class="tool-item gradient jsr-toolbar-box-cornerradius not-pressable">Rounding: <input type="text" /></div>', '</div>', '</div>'].join(''));
	      this.box_toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append(this.box_toolbar);
	    },

	    bind_box_toolbar: function bind_box_toolbar() {
	      var me = this,
	          tb_instance_el = this.editing_control_elt.toolbar("getToolbarElement");
	      tb_instance_el.find(".jsr-toolbar-box-bordercolor input").spectrum({
	        color: this.editing_control_def.border_color || '',
	        showPalette: true,
	        palette: this.color_palette,
	        showAlpha: true,
	        allowEmpty: true,
	        change: function change(color) {
	          var color_hex = color === null ? "transparent" : color.toHexString();
	          me.editing_control_def.border_color = color_hex;
	          me.editing_control_elt.find(".jsr-box").css("border-color", color_hex);
	          me.onElementEdit();
	        }
	      });
	      tb_instance_el.find(".jsr-toolbar-box-backgroundcolor input").spectrum({
	        color: this.editing_control_def.background_color || '',
	        showPalette: true,
	        palette: this.color_palette,
	        showAlpha: true,
	        allowEmpty: true,
	        change: function change(color) {
	          var color_hex = color === null ? "transparent" : color.toHexString();
	          me.editing_control_def.background_color = color_hex;
	          me.editing_control_elt.find(".jsr-box").css("background-color", color_hex);
	          me.onElementEdit();
	        }
	      });
	      me.editing_control_elt.find(".jsr-box");
	      tb_instance_el.find(".jsr-toolbar-box-cornerradius input").val(me.editing_control_def.corner_radius || '').on("change", function (evt) {
	        var val = $(evt.target).val(),
	            is_number = !isNaN(parseInt(val, 10)) && isFinite(val);
	        if (is_number) {
	          me.editing_control_def.corner_radius = val;
	          me.editing_control_elt.find(".jsr-box").css("border-radius", String(val) + "px");
	          me.onElementEdit();
	        }
	      });
	      this.editing_control_elt.toolbar("calculatePosition");
	    },

	    create_barcode_toolbar: function create_barcode_toolbar() {
	      this.barcode_toolbar = $(['<div id="jsr-designer-barcode-toolbar" style="display:none">', '<div>', '<div class="tool-item gradient jsr-toolbar-barcode-value not-pressable"><div class="input-wrap"></div></div>', '</div>', '<div>', '<div class="tool-item gradient jsr-toolbar-barcode-type not-pressable">Type: <select>', '<option value="CODE128">Code 128</option>', '<option value="CODE39">Code 39</option>', '<option value="UPC">UPC-A</option>', '<option value="EAN">EAN-13</option>', '<option value="ITF14">ITF-14</option>', '<option value="pharmacode">Pharmacode</option>', '<option value="QR">QR Code</option>', '</select></div>', '<div class="tool-item gradient jsr-toolbar-barcode-show-value not-pressable"><label><input type="checkbox"> Show value</label></div>', '</div>', '</div>'].join(''));
	      this.barcode_toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append(this.barcode_toolbar);
	    },

	    bind_barcode_toolbar: function bind_barcode_toolbar() {
	      var me = this,
	          tb_instance_el = this.editing_control_elt.toolbar("getToolbarElement");

	      // Barcode value field
	      var $inputWrap = tb_instance_el.find(".jsr-toolbar-barcode-value .input-wrap");
	      this.initTextComplete($inputWrap, this.on_barcode_value_change.bind(this));
	      $inputWrap.find('textarea').val(me.editing_control_def.value);

	      // Barcode type
	      tb_instance_el.find(".jsr-toolbar-barcode-type select").val(me.editing_control_def.barcode_type || 'CODE128').on("change", function (evt) {
	        var val = $(evt.target).val();
	        me.editing_control_def.barcode_type = val;
	        me.render_barcode(me.editing_control_elt, me.editing_control_def);
	        setTimeout(function () {
	          me.onElementEdit();
	        }, 0);
	      });

	      // Show value
	      tb_instance_el.find(".jsr-toolbar-barcode-show-value input").prop("checked", me.editing_control_def.show_value).on("change", function (evt) {
	        var checked = $(evt.target).is(":checked");
	        me.editing_control_def.show_value = checked;
	        me.render_barcode(me.editing_control_elt, me.editing_control_def);
	        setTimeout(function () {
	          me.onElementEdit();
	        }, 0);
	      });
	      // Kill click events on "show value" checkbox, otherwise toolbar will interfere
	      tb_instance_el.find(".jsr-toolbar-barcode-show-value input, .jsr-toolbar-barcode-show-value label").on("click", function (evt) {
	        evt.stopPropagation();
	      });

	      this.editing_control_elt.toolbar("calculatePosition");
	    },

	    on_barcode_value_change: function on_barcode_value_change(text) {
	      this.editing_control_def.value = text;
	      this.onElementEdit();
	    },

	    create_break_toolbar: function create_break_toolbar() {
	      this.break_toolbar = $(['<div id="jsr-designer-break-toolbar" style="display:none">', '<div>', '<div class="tool-item gradient jsr-toolbar-break-type not-pressable">Page Break</div>', '<div class="tool-item gradient jsr-toolbar-break-every not-pressable">', 'Active every <input type="text" /> records', '</div>', '</div>', '</div>'].join(''));
	      this.break_toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append(this.break_toolbar);
	    },

	    bind_break_toolbar: function bind_break_toolbar() {
	      var me = this,
	          tb_instance_el = this.editing_control_elt.toolbar("getToolbarElement");

	      var $everyInput = tb_instance_el.find(".jsr-toolbar-break-every input");
	      $everyInput.val(me.editing_control_def.everyNth).on('change', this.onBreakEveryChange.bind(this));

	      this.editing_control_elt.toolbar("calculatePosition");
	    },

	    onBreakEveryChange: function onBreakEveryChange(evt) {
	      var val = $(evt.target).val();
	      if (!$.isNumeric(val)) {
	        val = 1;
	        $(evt.target).val(val);
	      }
	      this.editing_control_def.everyNth = val;
	    },

	    create_subreport_toolbar: function create_subreport_toolbar() {
	      this.subreport_toolbar = $(['<div id="jsr-designer-subreport-toolbar" style="display:none">', '<div>', '<div class="tool-item gradient jsr-toolbar-subreport-edit not-pressable"><button class="jsr-btn">Edit subreport</button></div>', '<div class="tool-item gradient jsr-toolbar-subreport-link not-pressable">', '<label>', '<input type="checkbox" class="link-fields-checkbox" /> ', 'Link master report field ', '</label> ', '<input type="text" class="subreport-link-parent" /> ', 'to subreport field <input type="text" class="subreport-link-child" />', '</div>', '</div>', '</div>'].join(''));
	      this.subreport_toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append(this.subreport_toolbar);
	    },

	    bind_subreport_toolbar: function bind_subreport_toolbar() {
	      var me = this,
	          tb_instance_el = this.editing_control_elt.toolbar("getToolbarElement"),
	          subreportDef = this.editing_control_def.report;
	      tb_instance_el.find('.jsr-toolbar-subreport-edit button').on('click', function () {
	        if (!me.editing_control_def.report) {
	          me.editing_control_def.report = JSON.parse(JSON.stringify(ditto.defaultReport));
	        }
	        var stack = me.reportStack || [me.report_def];
	        // stack.push(me.editing_control_def.report);
	        var reportClone = JSON.parse(JSON.stringify(me.editing_control_def.report));
	        stack.push(reportClone);
	        me.setReport(reportClone);
	        var subreportCtlStack = me.subreportCtlStack || [];
	        subreportCtlStack.push(me.editing_control_def);
	        me.subreportCtlStack = subreportCtlStack;
	        me.reportStack = stack;
	        // me.clear_selection();
	        me.set_subreport_mode(true);
	      });
	      var containingSection = this.find_section_by_y(this.editing_control_elt.position().top);
	      var dataSection = this.getDataSections()[containingSection.sectionInfo.detailIndex || 0];
	      var fields;
	      if (typeof containingSection.level !== 'undefined') {
	        fields = this.get_fields_for_group_data_source(dataSection, containingSection.level);
	      } else if (containingSection.is_detail && this.report_def.sublevels && this.report_def.sublevels.length > 0) {
	        // last section fields
	        fields = this.get_fields_for_group_data_source(dataSection, this.report_def.sublevels.length - 1);
	      } else {
	        // root data source fields
	        fields = this.get_root_data_source_fields(dataSection);
	      }
	      tb_instance_el.find('label').on('click', function (evt) {
	        evt.stopPropagation();
	      });
	      tb_instance_el.find('input.link-fields-checkbox').prop('checked', !!this.editing_control_def.linkFields).on('change', function (evt) {
	        this.editing_control_def.linkFields = $(evt.target).prop('checked');
	        tb_instance_el.find('input.subreport-link-parent').prop('disabled', !this.editing_control_def.linkFields);
	        tb_instance_el.find('input.subreport-link-child').prop('disabled', !this.editing_control_def.linkFields);
	      }.bind(this));
	      tb_instance_el.find('input.subreport-link-parent').val(this.editing_control_def.linkParentField).on("change", function (evt) {
	        this.editing_control_def.linkParentField = $(evt.target).val();
	      }.bind(this)).prop('disabled', !this.editing_control_def.linkFields).select2({
	        query: function (options) {
	          options.callback({
	            more: false,
	            results: fields.data
	          });
	        }.bind(this),
	        initSelection: function (element, callback) {
	          callback(fields.byId[element.val()]);
	        }.bind(this),
	        // allowClear: true,
	        placeholder: '(select a field)',
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      var subreportSchema = null;
	      if (subreportDef && subreportDef.body) {
	        var subreportDetails = Array.isArray(subreportDef.body) ? subreportDef.body : [subreportDef.body];
	        if (subreportDetails[0].data_source) {
	          subreportSchema = this.data_source_schemas[subreportDetails[0].data_source];
	        }
	      }
	      var subreportFields = this.get_fields_for_schema(subreportSchema);
	      tb_instance_el.find('input.subreport-link-child').val(this.editing_control_def.linkChildField).on("change", function (evt) {
	        this.editing_control_def.linkChildField = $(evt.target).val();
	      }.bind(this)).prop('disabled', !this.editing_control_def.linkFields).select2({
	        query: function (options) {
	          options.callback({
	            more: false,
	            results: subreportFields.data
	          });
	        }.bind(this),
	        initSelection: function (element, callback) {
	          callback(subreportFields.byId[element.val()]);
	        }.bind(this),
	        // allowClear: true,
	        placeholder: '(select a field)',
	        dropdownAutoWidth: true,
	        dropdownCssClass: 'jsr-select2-dropdown'
	      });
	      this.editing_control_elt.toolbar("calculatePosition");
	    },

	    set_subreport_mode: function set_subreport_mode(is_subreport) {
	      var $toolbar = $(this.container).find('.jsr-designer-toolbar');
	      var $indicator = $toolbar.find('.subreport-indicator');
	      if ($indicator.length > 0) {
	        $indicator.toggle(is_subreport);
	      } else if (is_subreport) {
	        $indicator = $('<div class="subreport-indicator">' + t('EDITING_SUBREPORT') + '</div>');
	        $toolbar.prepend($indicator);
	      }
	      $toolbar.find('.save-button').text(is_subreport ? t('SAVE_SUBREPORT') : t('SAVE'));
	      this.subreportMode = is_subreport;
	    },

	    createToolbarItem: function createToolbarItem(item) {
	      var $item = $('<div class="tool-item gradient not-pressable jsr-element-toolbar-item-custom"></div>');
	      var $input = null;
	      if (item.label) {
	        $item.append($(document.createElement('label')).text(item.label + ': '));
	      }
	      $item.addClass('jsr-toolbar-item-' + item.type);
	      switch (item.type) {
	        case 'dropdown':
	          $input = $(document.createElement('input'));
	          $item.append($input);
	          $input.data('jsr-toolbar-item', item);
	          break;
	        case 'text':
	          $input = $(document.createElement('input')).attr('type', 'text');
	          $item.append($input);
	          $input.data('jsr-toolbar-item', item);
	          break;
	        case 'color':
	          $input = $(document.createElement('input'));
	          $item.append($input);
	          $input.data('jsr-toolbar-item', item);
	          break;
	        case 'checkbox':
	          var id = 'jsr-element-toolbar-checkbox-' + this.nextToolbarItemId++;
	          $input = $(document.createElement('input')).attr({
	            type: 'checkbox',
	            name: id,
	            id: id,
	            value: id
	          });
	          $item.find('label').append($input);
	          $input.data('jsr-toolbar-item', item);
	          $item.find('label').on('click', function (e) {
	            e.stopPropagation();
	          });
	          break;
	        case 'conditionalRules':
	          $item = this.getConditionalPropertiesButton();
	          var rules = item.value || [];
	          this.setCondPropsCount(rules.length, $item[0]);
	          $item.data('targetDef', { conditionalRules: rules });
	          if (item.onChange) {
	            $item.data('saveCallback', function (rule) {
	              item.onChange(rules);
	            });
	          }
	          break;
	      }
	      return $item;
	    },

	    getDataSections: function getDataSections() {
	      var body = this.report_def.body;
	      return Array.isArray(body) ? body : [body];
	    },

	    getAvailableDataSourcesForElement: function getAvailableDataSourcesForElement() {
	      var _this14 = this;

	      var dataSectionIx = this.sections_by_element_id[this.editing_control_def.id].detailIndex;
	      var dataSection = this.getDataSections()[dataSectionIx];
	      var allDataSources = this.data_sources.map(function (ds) {
	        return {
	          id: ds.id.toLowerCase(),
	          name: ds.name || "",
	          schema: _this14.data_source_schemas[ds.id] || null
	        };
	      });
	      var schema = this.getSchemaForDataSection(dataSection);
	      if (schema) {
	        allDataSources = allDataSources.concat(schema.fields.filter(function (field) {
	          return field.type.toLowerCase() === 'array' && field.schema;
	        }).map(function (field) {
	          return {
	            id: field.name,
	            name: field.name,
	            schema: field.schema || null
	          };
	        }));
	      }
	      allDataSources.sort(function (dsA, dsB) {
	        return dsA.name.localeCompare(dsB.name);
	      });
	      return [{
	        id: "__parentgroup",
	        name: "Rows in parent group",
	        schema: schema
	      }].concat(allDataSources);
	    },


	    /**
	     * Get context about how the element is situated within the report
	     * (available data sources, etc) to pass to the element class to generate its
	     * toolbar options
	     */
	    getSelectedElementContext: function getSelectedElementContext() {
	      return {
	        dataSources: this.getAvailableDataSourcesForElement()
	      };
	    },

	    createElementToolbar: function createElementToolbar(elClass, inst, activeSchema) {
	      var _this15 = this;

	      var items = inst.getToolbarItems(activeSchema, this.getSelectedElementContext());
	      var $toolbar = $('<div id="jsr-designer-toolbar-' + elClass.typeId + '" style="display:none"></div>');
	      if (items.length > 0) {
	        if (!Array.isArray(items[0])) {
	          items = [items];
	        }
	        var rows = items;
	        rows.forEach(function (row) {
	          var $row = $('<div></div>');
	          row.forEach(function (item) {
	            return $row.append(_this15.createToolbarItem(item));
	          });
	          $toolbar.append($row);
	        });
	      }
	      $toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append($toolbar);
	    },

	    updateElementRendering: function updateElementRendering(elDef, elt) {
	      switch (elDef.type) {
	        case "barcode":
	          this.render_barcode(elt, elDef);
	          break;
	        case 'subreport':
	          this.renderSubreportPreview(elDef, elt);
	          break;
	        default:
	          var elTypeInfo = this.elementTypes[elDef.type.toLowerCase()];
	          var elClass = elTypeInfo && elTypeInfo.handler;
	          if (elClass) {
	            var inst = elt.data('jsr-element-instance');
	            if (!inst) {
	              inst = new elClass(elDef);
	            }
	            elt.data('jsr-element-instance', inst);
	            if (elDef === this.editing_control_def) {
	              this.activeElementInstance = inst;
	            }
	            if (elClass.isComposite) {
	              elt.find('.jsr-designer-subelement').remove();
	              elt.append(this.renderCompositeElementChildren(inst, this.pixels_per_unit));
	            } else {
	              elt.find(':not(.jsr-resize-handle)').remove();
	              elt.append(inst.getDesignerHtml());
	              if (inst.afterDesignerRender) {
	                inst.afterDesignerRender(elt[0]);
	              }
	            }
	            inst.raiseEvent = this.onElementEvent.bind(this);
	          }
	          break;
	      }
	    },

	    /** Called by element instances when they raise an event */
	    onElementEvent: function onElementEvent(eventName) {
	      switch (eventName) {
	        case 'toolbarchange':
	          this.refreshCustomElementToolbar();
	          break;
	        case 'propertychange':
	          this.onElementEdit();
	          // this.updateElementRendering(this.editing_control_def, this.editing_control_elt);
	          this.refreshCustomElementToolbar();
	          break;
	        default:
	          throw new Error('Unknown element event: ' + eventName);
	      }
	    },

	    bindElementToolbar: function bindElementToolbar(toolbarEl, elClass, eltDef) {
	      var _this16 = this;

	      var dropdowns = toolbarEl.querySelectorAll('.jsr-toolbar-item-dropdown input');
	      Array.prototype.forEach.call(dropdowns, function (input) {
	        var $input = $(input);
	        var item = $input.data('jsr-toolbar-item');
	        var savedValue = typeof item.value !== 'undefined' ? item.value : eltDef[item.boundProperty];
	        var hasSavedValue = typeof savedValue !== 'undefined';
	        var options = [].concat(_toConsumableArray(item.options));
	        var valueToSelect = savedValue;
	        // Add saved value to dropdown if not already in options
	        if (hasSavedValue) {
	          (function () {
	            var savedValueLower = String(savedValue).toLowerCase();
	            var matchingOption = options.find(function (opt) {
	              return String(typeof opt.id === 'undefined' ? opt : opt.id).toLowerCase() === savedValueLower;
	            });
	            if (matchingOption) {
	              valueToSelect = typeof matchingOption.id === 'undefined' ? matchingOption : matchingOption.id;
	            } else {
	              options.push(savedValue);
	            }
	          })();
	        }
	        $input.select2({
	          data: options.map(function (opt) {
	            return opt.id ? opt : {
	              id: opt,
	              text: opt
	            };
	          }),
	          dropdownAutoWidth: true,
	          dropdownCssClass: 'jsr-select2-dropdown',
	          createSearchChoice: function createSearchChoice(term, data) {
	            if (data.filter(function (existing) {
	              return existing.text.localeCompare(term) === 0;
	            }).length === 0) {
	              return { id: term, text: term };
	            }
	          }
	        }).on('change', function (evt) {
	          var val = $(evt.target).val();
	          _this16.handleToolbarInputForCustomElement(item, val);
	        });
	        if (hasSavedValue) {
	          $input.select2('val', String(valueToSelect));
	        }
	      });
	      var colors = toolbarEl.querySelectorAll(".jsr-toolbar-item-color input");
	      Array.prototype.forEach.call(colors, function (input) {
	        var item = $(input).data('jsr-toolbar-item');
	        $(input).spectrum({
	          color: _this16.editing_control_def[item.boundProperty] || '',
	          showPalette: true,
	          palette: _this16.color_palette,
	          showAlpha: false,
	          allowEmpty: false,
	          change: function change(color) {
	            var hexStr = color === null ? "transparent" : color.toHexString();
	            _this16.handleToolbarInputForCustomElement(item, hexStr);
	          }
	        });
	      });
	      var checkboxes = toolbarEl.querySelectorAll('.jsr-toolbar-item-checkbox input');
	      Array.prototype.forEach.call(checkboxes, function (input) {
	        var $input = $(input);
	        var item = $input.data('jsr-toolbar-item');
	        var savedValue = typeof item.value !== 'undefined' ? item.value : eltDef[item.boundProperty];
	        $input.prop('checked', !!savedValue);
	        $input.on('change', function (e) {
	          var checked = $(e.target).is(':checked');
	          _this16.handleToolbarInputForCustomElement(item, checked);
	        });
	      });
	      var texts = toolbarEl.querySelectorAll('.jsr-toolbar-item-text input');
	      Array.prototype.forEach.call(texts, function (input) {
	        var $input = $(input);
	        var item = $input.data('jsr-toolbar-item');
	        var savedValue = typeof item.value !== 'undefined' ? item.value : eltDef[item.boundProperty];
	        if (item.suggestions) {
	          var $wrap = $('<div class="input-wrap"></div>');
	          $input.replaceWith($wrap);
	          _this16.initTextComplete($wrap, function (text) {
	            _this16.handleToolbarInputForCustomElement(item, text);
	          });
	          $wrap.find('textarea').val(savedValue);
	          _this16.autoCompleteOptions = { list: item.suggestions };
	        }
	      });
	    },

	    handleToolbarInputForCustomElement: function handleToolbarInputForCustomElement(toolbarItem, val) {
	      /** Normalize the value UNLESS it's a formula, which we allow for all properties */
	      if (toolbarItem.normalizeValue && !(typeof val === 'string' && val.indexOf('=') === 0)) {
	        val = toolbarItem.normalizeValue(val);
	      }
	      if (toolbarItem.boundProperty) {
	        this.activeElementInstance.props[toolbarItem.boundProperty] = val;
	        // this.editing_control_def[toolbarItem.boundProperty] = val;
	      }
	      if (toolbarItem.onChange) {
	        var aborted = toolbarItem.onChange(val) === false;
	        if (aborted) {
	          if (toolbarItem.boundProperty) {
	            this.activeElementInstance.props[toolbarItem.boundProperty] = origVal;
	          }
	          this.refreshCustomElementToolbar();
	        }
	      }
	      this.onElementEdit();
	    },


	    /** 
	     * @private
	     * Back out one level from a subreport - either to the main report, or another higher subreport 
	     */
	    exitSubreport: function exitSubreport() {
	      this.subreportCtlStack.pop();
	      // Drop the last subreport (the one we were editing)
	      this.reportStack.pop();
	      var stack = this.reportStack;
	      var subreportCtlStack = this.subreportCtlStack;
	      this.setReport(this.reportStack[this.reportStack.length - 1]);
	      // Restore the stack because setReport wipes it out
	      this.reportStack = stack;
	      this.subreportCtlStack = subreportCtlStack;
	      this.set_subreport_mode(this.reportStack.length > 1);
	    },

	    sectionIsDetail: function sectionIsDetail(section) {
	      var body = this.report_def.body;
	      var details = Array.isArray(body) ? body : [body];
	      return !!details.find(function (detail) {
	        return detail === section;
	      });
	    },

	    /** 
	     * @private
	     * Whenever an element is modified (any property), we may need to do some bookkeeping --
	     * for instance, updating "shadow" (cloned) elements in columns 2..n
	     */
	    onElementEdit: function onElementEdit() {
	      if (!this.editing_control_elt) return;
	      if (this.activeElementInstance) {
	        _.extend(this.editing_control_def, this.activeElementInstance.props);
	      }
	      this.updateElementRendering(this.editing_control_def, this.editing_control_elt);
	      var section = this.find_section_by_y(this.editing_control_elt.position().top).def;
	      if (this.sectionIsDetail(section) && section.column_count && section.column_count > 1) {
	        this.update_column_clones();
	      }
	    },

	    render_template_section_elements: function render_template_section_elements(section, offset) {
	      var elements = section.def.elements;
	      for (var i = 0; i < elements.length; i++) {
	        var elt = elements[i];
	        var newdiv = this.render_template_element(elt, offset);
	        this.sections_by_element_id[elt.id] = section;
	        this.preview_el.append(newdiv);
	      }
	    },

	    get_next_element_id: function get_next_element_id() {
	      return "jsr-element-" + this.next_element_id++;
	    },

	    render_template_element: function render_template_element(elt, offset) {
	      var me = this;
	      if (elt.id) {
	        var idnum = Number(elt.id.substr(elt.id.lastIndexOf('-') + 1));
	        if (idnum >= this.next_element_id) {
	          this.next_element_id = idnum + 1;
	        }
	      } else {
	        elt.id = this.get_next_element_id();
	      }
	      this.elements_by_id[elt.id] = elt;

	      var newdiv = this.renderElementHtml(elt, offset, this.preview_margins.left, this.pixels_per_unit);

	      var dirs = ['t', 'l', 'b', 'r', 'tl', 'tr', 'bl', 'br'],
	          min_control_size = 10;
	      if (elt.type !== 'break') {
	        for (var i = 0; i < dirs.length; i++) {
	          newdiv.append('<div class="jsr-resize-handle jsr-resize-handle-' + dirs[i] + '"></div>');
	        }
	      }
	      newdiv.addClass('jsr-draggable').drag("start", function (ev, dd) {
	        me.dragging = true;
	        var $elt = $(ev.target).closest('div');
	        dd.attr = $elt.prop("className");
	        var resize_handle_classname_ix = dd.attr.indexOf("jsr-resize-handle-");
	        dd.width = $(this).width();
	        dd.height = $(this).height();
	        var dragHint = 'Hold ' + (ditto.isMac ? 'Cmd' : 'Ctrl') + ' for precise positioning';
	        if (resize_handle_classname_ix > -1) {
	          var dir = dd.attr.substr(resize_handle_classname_ix + 18, 2);
	          dd.resize_dir = dd.attr.substr(resize_handle_classname_ix + 18, 2);
	          // dd.origAspectRatio = dd.width / dd.height;
	          dragHint += ', Shift to preserve proportions';
	        }
	        var canvasOffs = me.preview_el.offset();
	        dd.canvasX = canvasOffs.left;
	        dd.canvasY = canvasOffs.top;
	        if (!newdiv.hasClass('active')) {
	          me.select_element(newdiv, true);
	        }
	        if (me.$delete_element_button) {
	          me.$delete_element_button.hide();
	        }

	        me.drag_elt_initial_section = me.find_section_by_y(newdiv.position().top);

	        me.current_drag_left_section = false;
	        if (me.toolbarPosition === "float") {
	          me.editing_control_elt.data("toolbarObj").hide();
	        }
	        me.nonDraggedElements = [];
	        var thisElId = me.editing_control_elt.attr('id');
	        Object.keys(me.elements_by_id).forEach(function (id) {
	          if (!me.preview_el.find("#" + id).hasClass('active')) {
	            me.nonDraggedElements.push(me.elements_by_id[id]);
	          }
	        });
	        me.dragSet = me.getEntireSelection();
	        var primaryDragEltPos = newdiv.position();
	        me.dragSet.forEach(function (draggedElt) {
	          var pos = draggedElt.elt.position();
	          var secInfo = me.find_section_by_y(pos.top);
	          draggedElt.relX = pos.left - primaryDragEltPos.left;
	          draggedElt.relY = pos.top - primaryDragEltPos.top;
	          draggedElt.origSection = secInfo;
	        });
	        // me.setGridVisible(true);
	        me.showHintBar(dragHint);
	      }).drag("end", function (ev, dd) {
	        // me.setGridVisible(false);
	        delete me.edgeMap;
	        me.showSelectionHints();
	        me.nonDraggedElements = [];
	        var $elt;
	        if (dd.resize_dir) {
	          // resize end
	          $elt = newdiv;
	          if (me.$delete_element_button) {
	            me.position_delete_button();
	            me.$delete_element_button.show();
	          }
	          setTimeout(function () {
	            var origElDef = _extends({}, me.editing_control_elt);
	            me.constrain_el_to_margins(me.editing_control_elt);
	            if ($elt.hasClass('jsr-chart')) {
	              me.update_preview_chart($elt);
	            }
	            var elt_pos = $elt.position(),
	                section = me.drag_elt_initial_section,
	                new_height = $elt[0].getBoundingClientRect().height;
	            // Snap dragged top back to top of section if it was dragged past
	            if (elt_pos.top < section.top) {
	              var top_overshoot = section.top - elt_pos.top;
	              new_height -= top_overshoot;
	              $elt.height(new_height);
	              $elt.css("top", elt_pos.top + top_overshoot);
	              elt_pos.top = section.top;
	            }
	            me.editing_control_def.top = (elt_pos.top - section.top) / me.pixels_per_unit;
	            me.editing_control_def.left = (elt_pos.left - section.left) / me.pixels_per_unit;
	            me.editing_control_def.width = $elt[0].getBoundingClientRect().width / me.pixels_per_unit;
	            // console.log('elt width is', me.editing_control_def.width, $elt.width(), $elt[0].getBoundingClientRect().width);
	            me.editing_control_def.height = new_height / me.pixels_per_unit;
	            if (me.activeElementInstance) {
	              ['left', 'top', 'width', 'height'].forEach(function (dir) {
	                me.activeElementInstance.props[dir] = me.editing_control_def[dir];
	              });
	            }
	            if (me.fit_section(section.def)) {
	              me.render_template();
	            }
	            // preview might have been redrawn, need to find the new div to select it
	            $elt = me.preview_el.find("#" + elt.id);
	            me.select_element($elt);
	            me.dispatch((0, _designerActions.elementResizeAction)(origElDef, me.editing_control_def));
	            me.onElementEdit();
	            setTimeout(function () {
	              if ($elt.data("toolbarObj")) {
	                me.show_toolbar($elt);
	              }
	              me.dragging = false;
	            }, 0);
	          }, 0);
	        } else {
	          var sectionsToFit;
	          var detailSectionTouched;

	          (function () {
	            // drag end
	            $elt = newdiv;
	            if (me.$delete_element_button) {
	              me.position_delete_button();
	              me.$delete_element_button.show();
	            }
	            if (me.section_highlight_el) {
	              me.section_highlight_el.hide();
	            }
	            sectionsToFit = [];
	            detailSectionTouched = false;

	            me.dragSet.forEach(function (draggedItem) {
	              var origWidth = draggedItem.elt.width();
	              var origHeight = draggedItem.elt.height();
	              me.constrain_el_to_margins(draggedItem.elt);
	              var elt_pos = draggedItem.elt.position(),
	                  new_section = me.find_section_by_y(elt_pos.top);
	              if (!new_section) {
	                var last_section = me.preview_section_offsets[me.preview_section_offsets.length - 1];
	                if (elt_pos.top > last_section.bottom) {
	                  // move the control back within the section
	                  draggedItem.elt.css("top", last_section.bottom - 1 + "px");
	                  elt_pos = draggedItem.elt.position();
	                  new_section = last_section;
	                }
	              }
	              draggedItem.def.top = (elt_pos.top - new_section.top) / me.pixels_per_unit;
	              draggedItem.def.left = (elt_pos.left - new_section.left) / me.pixels_per_unit;
	              var newWidth = draggedItem.elt.width();
	              var newHeight = draggedItem.elt.height();
	              if (newWidth !== origWidth) {
	                draggedItem.def.width = draggedItem.elt.width() / me.pixels_per_unit;
	              }
	              if (newHeight !== origHeight) {
	                draggedItem.def.height = draggedItem.elt.height() / me.pixels_per_unit;
	              }
	              if (new_section) {
	                // Move element definition between sections in the report def
	                if (new_section !== draggedItem.origSection) {
	                  var ix = draggedItem.origSection.def.elements.indexOf(draggedItem.def);
	                  if (ix !== -1) {
	                    draggedItem.origSection.def.elements.splice(ix, 1);
	                  }
	                  new_section.def.elements.push(draggedItem.def);
	                }
	                me.sections_by_element_id[draggedItem.def.id] = new_section;
	                sectionsToFit.push(new_section.def);
	                detailSectionTouched = me.sectionIsDetail(new_section.def);
	              }
	            });
	            var sectionHeightChanged = false;
	            sectionsToFit.forEach(function (section) {
	              sectionHeightChanged = me.fit_section(section) || sectionHeightChanged;
	            });
	            if (sectionHeightChanged) {
	              me.render_template();
	            }
	            if (detailSectionTouched) {
	              me.update_column_clones();
	            }
	            setTimeout(function () {
	              if (newdiv.data("toolbarObj")) {
	                me.show_toolbar(newdiv);
	              }
	              me.dragging = false;
	            }, 0);
	          })();
	        }
	        me.endSnapping();
	      }).drag(function (div, ev, dd) {
	        // mouse move during drag or resize
	        if (!this.throttledSnapHandlers) {
	          this.createThrottledSnapHandlers();
	        }
	        var props = {},
	            min_c;
	        var noSnap = ditto.key.command || ditto.key.control;
	        var dx,
	            dy,
	            startX = dd.startX - dd.canvasX,
	            startY = dd.startY - dd.canvasY;
	        if (noSnap) {
	          dx = dd.deltaX;
	          dy = dd.deltaY;
	        } else {
	          // Snap to grid
	          dx = Math.round((startX + dd.deltaX) / this.gridSize) * this.gridSize - startX;
	          dy = Math.round((startY + dd.deltaY) / this.gridSize) * this.gridSize - startY;
	        }
	        if (dd.resize_dir) {
	          // Resizing
	          if (noSnap) {
	            // Plain resize exactly to current pixel positions
	            var xUnits = (startX + dx) / this.pixels_per_unit;
	            var yUnits = (startY + dy) / this.pixels_per_unit;
	            this.handleResizeMove(div, dd.resize_dir, xUnits, yUnits);
	          } else {
	            this.snapResizeHandle(div, dd.resize_dir, startX, startY, dx, dy, dd.width, dd.height);
	          }
	        } else {
	          // Dragging whole element
	          var newX, newY;
	          if (noSnap) {
	            newX = dd.offsetX;
	            newY = dd.offsetY;
	          } else {
	            newX = Math.round(dd.offsetX / this.gridSize) * this.gridSize;
	            newY = Math.round(dd.offsetY / this.gridSize) * this.gridSize;
	          }
	          this.lastDragX = newX;
	          this.lastDragY = newY;
	          if (noSnap || !this.isSnapped) {
	            for (var i = 0; i < me.dragSet.length; i++) {
	              var item = me.dragSet[i];
	              item.elt.css({
	                top: newY + item.relY,
	                left: newX + item.relX
	              });
	            }
	          }
	          if (noSnap) {
	            this.highlightAlignedElements(div);
	          } else {
	            this.snapToPosition(div);
	          }
	          me.trigger_deferred_element_drag_handling();
	        }
	      }.bind(this, newdiv), { relative: true });
	      newdiv.on("click", this.on_preview_element_click.bind(this));
	      newdiv.data("element-id", elt.id);
	      newdiv.attr("id", elt.id);
	      return newdiv;
	    },

	    renderCompositeElementChildren: function renderCompositeElementChildren(elInst, pixelsPerUnit) {
	      var _this17 = this;

	      return _.flatten(elInst.getChildElementDefinitions().map(function (el) {
	        return ['<div class="jsr-designer-subelement" style="', 'left: ' + el.left * pixelsPerUnit + 'px;', 'top: ' + el.top * pixelsPerUnit + 'px;', 'width: ' + el.width * pixelsPerUnit + 'px;', 'height: ' + el.height * pixelsPerUnit + 'px">', _this17.renderElementHtml(el, 0, 0, pixelsPerUnit).html(), '</div>'];
	      })).join('');
	    },

	    renderElementHtml: function renderElementHtml(elt, offsetTop, offsetLeft, pixelsPerUnit) {
	      var me = this;
	      var html = ['<div class="preview-element">'];
	      var newdiv;
	      var inst = null;
	      switch (elt.type) {
	        case "text":
	          var rawText = elt.text.replace(/\\n/gim, '\n').replace(/\&/gim, '&amp;').replace(/\</gim, '&lt;').replace(/\>/gim, '&gt;');
	          html.push('<div class="jsr-text">' + rawText + '</div>');
	          html.push('</div>');
	          newdiv = $(html.join(''));
	          this.apply_text_styles(elt, newdiv);
	          break;
	        case "image":
	          html.push('<img class="jsr-designer-image"/>');
	          html.push('</div>');
	          newdiv = $(html.join(''));
	          var url = elt.url || this.image_placeholder_url;
	          var absoluteMatch = /http(s)?:\/\//.exec(url);
	          if (!(absoluteMatch && absoluteMatch.index === 0)) {
	            url = (this.imageUrlPrefix || '') + url;
	          }
	          newdiv.find('img').attr('src', url);
	          break;
	        case "chart_line":
	        /* falls through */
	        case "chart_pie":
	        /* falls through */
	        case "chart_bar":
	          // html.push('<canvas class="jsr-chart ' + elt.type + '"></canvas>');
	          html.push('</div>');
	          newdiv = $(html.join(''));
	          newdiv.addClass('jsr-chart ' + elt.type);
	          // Have to delay here so the chart has the properly sized element
	          window.setTimeout(function () {
	            var $chart_el = $("#" + elt.id, this.preview_el);
	            this.update_preview_chart($chart_el);
	          }.bind(this), 0);
	          break;
	        case "box":
	          html.push('<div class="jsr-box" style="background-color:' + elt.background_color + ';border-color:' + elt.border_color + ';border-radius:' + elt.corner_radius + '"></div>');
	          html.push('</div>');
	          newdiv = $(html.join(''));
	          newdiv.addClass('jsr-preview-element-box');
	          break;
	        case "barcode":
	          html.push('<div class="jsr-barcode"></div></div>');
	          newdiv = $(html.join(''));
	          window.setTimeout(function () {
	            me.render_barcode(newdiv, elt);
	          }.bind(this), 0);
	          break;
	        case "break":
	          html.push('<div class="jsr-break-icon"></div></div>');
	          newdiv = $(html.join(''));
	          newdiv.addClass('jsr-break');
	          break;
	        case "subreport":
	          html.push('</div>');
	          newdiv = $(html.join(''));
	          newdiv.addClass('jsr-subreport');
	          setTimeout(function () {
	            me.renderSubreportPreview(elt, newdiv);
	          }, 0);
	          break;
	        case "unknownJasperElement":
	          html.push('</div>');
	          newdiv = $(html.join(''));
	          newdiv.addClass('jsr-unknown-jasper-element');
	          break;
	        default:
	          var elClass = this.elementTypes[elt.type.toLowerCase()].handler;
	          inst = new elClass(elt);
	          if (elClass.isComposite) {
	            html.push(this.renderCompositeElementChildren(inst, pixelsPerUnit));
	          } else {
	            html.push(inst.getDesignerHtml());
	          }
	          html.push('</div>');
	          newdiv = $(html.join(''));
	          newdiv.addClass(elClass.cssClass || 'jsr-' + elt.type);
	          newdiv.data('jsr-element-instance', inst);
	          inst.raiseEvent = this.onElementEvent.bind(this);
	          break;
	      }
	      var left, width, height;
	      if (elt.type === 'break') {
	        left = 0;
	        width = '100%';
	        height = 0;
	      } else {
	        left = offsetLeft + elt.left * pixelsPerUnit + "px";
	        width = elt.width * pixelsPerUnit + "px";
	        height = elt.height * pixelsPerUnit + "px";
	      }
	      newdiv.css({
	        top: offsetTop + elt.top * pixelsPerUnit + "px",
	        left: left,
	        width: width,
	        height: height
	      });
	      if (elt.styles) {
	        if (Array.isArray(elt.styles)) {
	          elt.styles.map(function (cssClass) {
	            return newdiv.addClass(cssClass);
	          });
	        } else {
	          newdiv.addClass(elt.styles);
	        }
	      }
	      if (inst && inst.afterDesignerRender) {
	        inst.afterDesignerRender(newdiv[0]);
	      }
	      return newdiv;
	    },

	    /** 
	     * @private 
	     * Render a preview of the subreport into a subreport control 
	     */
	    renderSubreportPreview: function renderSubreportPreview(eltDef, subreportElt) {
	      if (!eltDef.report) return;
	      var me = this;
	      var $subreportPreview = $('<div class="jsr-subreport-preview"></div>');
	      subreportElt.find('.jsr-subreport-preview, .jsr-subreport-mask').remove();
	      subreportElt.append($subreportPreview);
	      var def = eltDef.report;
	      var units = def.page.units;
	      var paper_width = def.page.paper_size[units][0];
	      var pxPerUnit = subreportElt.width() / paper_width;
	      var subreportMarginLeft = def.page.margins.left * pxPerUnit;
	      var offset = 0;
	      var sections = this.getAllSections(def, true);
	      sections.map(function (section) {
	        section.def.elements.map(function (elt) {
	          $subreportPreview.append(me.renderElementHtml(elt, offset, subreportMarginLeft, pxPerUnit));
	        });
	        offset += section.def.height * pxPerUnit;
	      });
	      subreportElt.append($('<div class="jsr-subreport-mask"></div>'));
	    },

	    showHintBar: function showHintBar(hintText) {
	      if (!this.hintBar) {
	        this.hintBar = $('<div class="jsr-hint-bar"></div>');
	        this.designer_el.find('.jsr-designer-right').append(this.hintBar);
	      }
	      this.hintBar.text(hintText).show();
	    },

	    hideHintBar: function hideHintBar() {
	      if (this.hintBar) {
	        this.hintBar.hide();
	      }
	    },

	    setGridVisible: function setGridVisible(visible) {
	      if (visible) {
	        var nativeGridPx = 34;
	        var nativeGridWidth = 1020;
	        var nativeGridHeight = 680;
	        var offset = this.gridSize / nativeGridPx * 0; // 2px half-dot size
	        var scaleFactor = this.gridSize / nativeGridPx / 2;
	        this.preview_el.addClass('jsr-designer-grid').css({
	          'background-size': scaleFactor * nativeGridWidth + 'px ' + scaleFactor * nativeGridHeight + 'px',
	          'background-position': '-' + offset + 'px -' + offset + 'px'
	        });
	      } else {
	        this.preview_el.removeClass('jsr-designer-grid');
	      }
	      this.gridVisible = visible;
	    },

	    // /** 
	    //  * @private
	    //  * Resize the element based on an edge handle being moved, either freely with cursor or as a result of snapping 
	    //  */
	    // handleResizeMove: function(el, dir, ox, oy, dx, dy, width, height) {
	    //   var $el = $(el),
	    //     css = { width: width, height: height },
	    //     offs = $el.offset();
	    //   if ( dir.indexOf("r") > -1 ) {
	    //     css.width = Math.max( this.minimumElementSize, width + dx );
	    //   } else if ( dir.indexOf("l") > -1 ) {
	    //     css.width = Math.max( this.minimumElementSize, width - dx );
	    //   }
	    //   if ( dir.indexOf("b") > -1 ) {
	    //     css.height = Math.max( this.minimumElementSize, height + dy );
	    //   } else if ( dir.indexOf("t") > -1 ) {
	    //     css.height = Math.max( this.minimumElementSize, height - dy );
	    //   }
	    //   if (ditto.key.shift) {
	    //     // Keep whichever results in the greater size
	    //     if (css.width / width > css.height / height) {
	    //       css.height = css.width / (width / height);
	    //     } else {
	    //       css.width = css.height * (width / height);
	    //     }
	    //   }
	    //   if (dir.indexOf("l") > -1) {
	    //     css.left = ox + width - css.width;
	    //   }
	    //   if (dir.indexOf("t") > -1 ) {
	    //     css.top = oy + height - css.height;
	    //   }
	    //   $el.css(css);
	    // },

	    handleResizeMove: function handleResizeMove(el, dir, xUnits, yUnits) {
	      var def = this.editing_control_def,
	          elRect = el[0].getBoundingClientRect(),
	          canvasRect = this.preview_el[0].getBoundingClientRect(),
	          elLeft = elRect.left - canvasRect.left,
	          css = {};
	      var isLeft = dir.indexOf('l') >= 0;
	      var isRight = dir.indexOf('r') >= 0;
	      var isTop = dir.indexOf('t') >= 0;
	      var isBottom = dir.indexOf('b') >= 0;
	      if (isRight) {
	        var widthPx = (xUnits - this.report_def.page.margins.left - def.left) * this.pixels_per_unit;
	        css.width = Math.max(this.minimumElementSize, widthPx);
	      } else if (isLeft) {
	        var origLeft = elRect.left - canvasRect.left;
	        var leftPx = xUnits * this.pixels_per_unit;
	        css.left = leftPx;
	        css.width = Math.max(this.minimumElementSize, elRect.width + (origLeft - leftPx));
	      }
	      if (isBottom) {
	        var heightPx = yUnits * this.pixels_per_unit - (elRect.top - canvasRect.top);
	        css.height = Math.max(this.minimumElementSize, heightPx);
	      } else if (isTop) {
	        var origTop = elRect.top - canvasRect.top;
	        var topPx = yUnits * this.pixels_per_unit;
	        css.top = topPx;
	        css.height = Math.max(this.minimumElementSize, elRect.height + (origTop - topPx));
	      }
	      if (ditto.key.shift) {
	        // Keep whichever results in the greater size
	        if (css.width / elRect.width > css.height / elRect.height) {
	          var constrainedHeight = css.width / (elRect.width / elRect.height);
	          if (isTop) {
	            css.top += css.height - constrainedHeight;
	          }
	          css.height = constrainedHeight;
	        } else {
	          var constrainedWidth = css.height * (elRect.width / elRect.height);
	          if (isLeft) {
	            css.left += css.width - constrainedWidth;
	          }
	          css.width = constrainedWidth;
	        }
	      }
	      el.css(css);
	    },

	    createThrottledSnapHandlers: function createThrottledSnapHandlers() {
	      this.snapToPosition = _.throttle(this.snapToPositionImmediate.bind(this), 250);
	      this.highlightAlignedElements = _.throttle(this.highlightAlignedElementsImmediate.bind(this), 250);
	      this.snapResizeHandle = _.throttle(this.snapResizeHandleImmediate.bind(this), 250);
	      this.throttledSnapHandlers = true;
	    },

	    snapToPositionImmediate: function snapToPositionImmediate(el) {
	      var xUnits = this.lastDragX / this.pixels_per_unit - this.report_def.page.margins["left"];
	      var yUnits = this.lastDragY / this.pixels_per_unit - this.report_def.page.margins["top"];
	      var snapped = this.findNearestXYInUnits(xUnits, yUnits);
	      this.highlightElementsBySnapInfo(snapped);
	      this.isSnapped = false;
	      if (snapped.x !== null) {
	        var snapXPx = (snapped.x.pos + this.report_def.page.margins["left"]) * this.pixels_per_unit;
	        $(el).css("left", snapXPx + 'px');
	        this.isSnapped = true;
	      } else {
	        // Stop snapping, return to cursor pos
	        $(el).css("left", this.lastDragX + 'px');
	      }
	      if (snapped.y !== null) {
	        var snapYPx = (snapped.y.pos + this.report_def.page.margins["top"]) * this.pixels_per_unit;
	        $(el).css("top", snapYPx + 'px');
	        this.isSnapped = true;
	      } else {
	        // Stop snapping, return to cursor pos
	        $(el).css("top", this.lastDragY + 'px');
	      }
	    },

	    /** 
	     * @private 
	     * Attempt to snap edge during resize operation 
	     */
	    snapResizeHandleImmediate: function snapResizeHandleImmediate(el, dir, ox, oy, dx, dy, width, height) {
	      var xUnits = (ox + dx) / this.pixels_per_unit - this.report_def.page.margins["left"];
	      var yUnits = (oy + dy) / this.pixels_per_unit - this.report_def.page.margins["top"];
	      var snapped = this.findNearestXYInUnits(xUnits, yUnits);
	      this.highlightElementsBySnapInfo(snapped);
	      this.isSnapped = false;
	      if (snapped.x) {
	        xUnits = snapped.x.pos;
	        this.isSnapped = true;
	      }
	      xUnits += this.report_def.page.margins.left;
	      if (snapped.y) {
	        yUnits = snapped.y.pos;
	        this.isSnapped = true;
	      }
	      yUnits += this.report_def.page.margins.top;
	      this.handleResizeMove(el, dir, xUnits, yUnits);
	    },

	    /** 
	     * @private
	     * When the user is overriding snapping, still highlight any exact snaps they happen to hit 
	     */
	    highlightAlignedElementsImmediate: function highlightAlignedElementsImmediate(el) {
	      var xUnits = this.lastDragX / this.pixels_per_unit - this.report_def.page.margins["left"];
	      var yUnits = this.lastDragY / this.pixels_per_unit - this.report_def.page.margins["top"];
	      var lessThanOnePxInUnits = 0.9 / this.pixels_per_unit;
	      var snapped = this.findNearestXYInUnits(xUnits, yUnits, lessThanOnePxInUnits);
	      this.highlightElementsBySnapInfo(snapped);
	    },

	    /** 
	     * @private 
	     * Don't move any elements, but show snap results (snap lines and snap-to-element highlights) 
	     */
	    highlightElementsBySnapInfo: function highlightElementsBySnapInfo(snapped) {
	      var _this18 = this;

	      if (!this.snapline) {
	        this.createSnapLines();
	      }
	      var highlightSpan = function highlightSpan(dir, pos, start, length) {
	        var span = document.createElement('div');
	        span.className = 'ditto-snap-edge-highlight ditto-snap-edge-highlight-' + dir;
	        if (dir === 'horizontal') {
	          span.style.top = pos + 'px';
	          span.style.left = start + 'px';
	          span.style.width = length + 'px';
	        } else {
	          span.style.left = pos + 'px';
	          span.style.top = start + 'px';
	          span.style.height = length + 'px';
	        }
	        _this18.preview_el.append(span);
	        return span;
	      };
	      this.snapEdgeHighlights.map(function (el) {
	        return el.parentNode.removeChild(el);
	      });
	      this.snapEdgeHighlights = [];
	      if (snapped.x) {
	        var snapXPx = (snapped.x.pos + this.report_def.page.margins.left) * this.pixels_per_unit;
	        this.snapline.vertical.css({
	          display: 'block',
	          left: snapXPx + 'px'
	        });
	        this.snapEdgeHighlights = this.snapEdgeHighlights.concat(snapped.x.edges.map(function (edge) {
	          return highlightSpan('vertical', snapXPx - 1, (edge.start + _this18.report_def.page.margins.top) * _this18.pixels_per_unit, edge.length * _this18.pixels_per_unit);
	        }));
	      } else {
	        this.snapline.vertical.css('display', 'none');
	      }
	      if (snapped.y) {
	        var snapYPx = (snapped.y.pos + this.report_def.page.margins.top) * this.pixels_per_unit;
	        this.snapline.horizontal.css({
	          display: 'block',
	          top: snapYPx + 'px'
	        });
	        this.snapEdgeHighlights = this.snapEdgeHighlights.concat(snapped.y.edges.map(function (edge) {
	          return highlightSpan('horizontal', snapYPx - 1, (edge.start + _this18.report_def.page.margins.left) * _this18.pixels_per_unit, edge.length * _this18.pixels_per_unit);
	        }));
	      } else {
	        this.snapline.horizontal.css('display', 'none');
	      }
	    },

	    createSnapLines: function createSnapLines() {
	      var _this19 = this;

	      this.snapline = {};
	      ['horizontal', 'vertical'].map(function (dir) {
	        _this19.snapline[dir] = $('<div class="jsr-snap-marker jsr-snap-marker-' + dir + '"></div>');
	        _this19.preview_el.append(_this19.snapline[dir]);
	      });
	      this.snapEdgeHighlights = [];
	    },

	    endSnapping: function endSnapping() {
	      this.isSnapped = false;
	      if (this.snapline) {
	        this.snapline.vertical.css('display', 'none');
	        this.snapline.horizontal.css('display', 'none');
	        this.snapEdgeHighlights.map(function (el) {
	          return el.parentNode.removeChild(el);
	        });
	        this.snapEdgeHighlights = [];
	      }
	    },

	    /**
	     * @private
	     * Pre-compute dictionaries of edge locations for quicker lookup while dragging.
	     * This method should be called any time an element location or size changes, or
	     * elements are added/removed.
	     */
	    computeEdgeMap: function computeEdgeMap() {
	      var elIds = Object.keys(this.elements_by_id);
	      var bucketSizeInUnits = this.edgeSnapThresholdPx / this.pixels_per_unit;
	      var buckets = { x: {}, y: {} };
	      var xEdges = [];
	      var yEdges = [];
	      var yOffset = 0;
	      for (var s = 0; s < this.visibleSections.length; s++) {
	        var sec = this.visibleSections[s];

	        var _loop = function _loop(i) {
	          var el = sec.elements[i];
	          [el.left, el.left + el.width].map(function (xPos) {
	            return xEdges.push({ pos: xPos, start: yOffset + el.top, length: el.height, elId: el.id });
	          });
	          [el.top, el.top + el.height].map(function (yPos) {
	            return yEdges.push({ pos: yOffset + yPos, start: el.left, length: el.width, elId: el.id });
	          });
	        };

	        for (var i = 0; i < sec.elements.length; i++) {
	          _loop(i);
	        }
	        yOffset += sec.height || 0;
	      }
	      var getBucketIx = function getBucketIx(edge) {
	        return Math.floor(edge.pos / bucketSizeInUnits);
	      };
	      this.edgeMap = {
	        x: _.groupBy(xEdges, getBucketIx),
	        y: _.groupBy(yEdges, getBucketIx)
	      };
	    },

	    /**
	     * @private
	     * Accumulator function to `Array.reduce` edges down to the nearest matching set,
	     * from edge buckets, while snapping during a drag operation
	     */
	    findClosestEdges: function findClosestEdges(out, edge) {
	      var dist = Math.abs(edge.pos - out.targetPos);
	      if (dist > out.dist) return out;
	      if (edge.elId === out.skipElId) return out;
	      if (dist < out.dist) {
	        // Found a closer match; throw out old edges
	        out.edges = [];
	      }
	      out.pos = edge.pos;
	      out.dist = dist;
	      out.edges.push(edge);
	      return out;
	    },

	    /** 
	     * @private
	     * Find nearest snappable x, y to a given (x, y), each axis independently, in report units 
	     */
	    findNearestXYInUnits: function findNearestXYInUnits(xUnits, yUnits, thresholdUnits) {
	      if (!this.edgeMap) {
	        this.computeEdgeMap();
	      }
	      var bucketSizeInUnits = this.edgeSnapThresholdPx / this.pixels_per_unit;
	      var threshold = typeof thresholdUnits !== 'undefined' ? thresholdUnits : this.edgeSnapThresholdPx / this.pixels_per_unit;
	      var snapped = { x: null, y: null, els: $(), vSpans: [], hSpans: [] };
	      var xBucketIx = Math.floor(xUnits / bucketSizeInUnits);
	      var yBucketIx = Math.floor(yUnits / bucketSizeInUnits);
	      var selectedElId = this.editing_control_def.id;
	      var snapX = { targetPos: xUnits, dist: threshold, edges: [], skipElId: selectedElId };
	      var snapY = { targetPos: yUnits, dist: threshold, edges: [], skipElId: selectedElId };
	      // Consider the target bucket and its next-door neighbors
	      for (var i = -1; i <= 1; i++) {
	        snapX = _.reduce(this.edgeMap.x[xBucketIx + i] || [], this.findClosestEdges, snapX);
	        snapY = _.reduce(this.edgeMap.y[yBucketIx + i] || [], this.findClosestEdges, snapY);
	      }
	      return {
	        x: snapX.pos ? snapX : null,
	        y: snapY.pos ? snapY : null
	      };
	    },

	    /**
	     * @private
	     * Move the displayed control element back within the margin area, BEFORE we read its position to store in the def
	     */
	    constrain_el_to_margins: function constrain_el_to_margins($elt) {
	      if (this.jasperMode) return;
	      var pos = $elt.position(),
	          width = $elt.width(),
	          height = $elt.height();
	      if (pos.left < this.preview_margins.left) {
	        $elt.css("left", this.preview_margins.left + "px");
	        pos.left = this.preview_margins.left;
	      }
	      if (pos.top < this.preview_margins.top) {
	        $elt.css("top", this.preview_margins.top + "px");
	        pos.top = this.preview_margins.top;
	      }
	      if (pos.top + height > this.preview_el.height() - this.preview_margins.bottom) {
	        $elt.css("height", this.preview_el.height() - this.preview_margins.bottom - pos.top + "px");
	      }
	      if (pos.left + width > this.preview_el.width() - this.preview_margins.right) {
	        $elt.css("width", this.preview_el.width() - this.preview_margins.right - pos.left + "px");
	      }
	    },

	    /** 
	     * Increase section height if needed to contain its elements.  Returns whether
	     * or not the section height was changed.
	     */
	    fit_section: function fit_section(sectiondef) {
	      var max_y = Number(sectiondef.height) || 0;
	      sectiondef.elements.map(function (eltdef) {
	        max_y = Math.max(max_y, (Number(eltdef.top) || 0) + (Number(eltdef.height) || 0));
	      });
	      if (max_y > (Number(sectiondef.height) || 0)) {
	        sectiondef.height = max_y;
	        return true;
	      }
	      return false;
	    },

	    trigger_deferred_element_drag_handling: function trigger_deferred_element_drag_handling() {
	      if (this.element_drag_handling_timeout) {
	        //window.clearTimeout(this.element_drag_handling_timeout);
	        // continuing to delay while dragging results in a laggy feel,
	        // so instead we just throttle to a maximum of once per 150ms
	        return;
	      }
	      if (!this.dlgt_do_deferred_element_drag_handling) {
	        this.dlgt_do_deferred_element_drag_handling = this.do_deferred_element_drag_handling.bind(this);
	      }
	      this.element_drag_handling_timeout = window.setTimeout(this.dlgt_do_deferred_element_drag_handling, this.element_drag_handling_delay_ms);
	    },

	    do_deferred_element_drag_handling: function do_deferred_element_drag_handling() {
	      this.element_drag_handling_timeout = null;
	      if (!this.editing_control_elt) return;
	      var y = this.editing_control_elt.position().top,
	          sec_bounds = this.find_section_by_y(y);
	      if (sec_bounds) {
	        if (!this.current_drag_left_section && sec_bounds === this.drag_elt_initial_section) {
	          if (this.section_highlight_el) {
	            this.section_highlight_el.hide();
	          }
	          return;
	        }
	        this.current_drag_left_section = true;
	        this.highlightSection(sec_bounds);
	        // if (!this.section_highlight_el) {
	        //   this.section_highlight_el = $('<div class="jsr-section-highlight"></div>');
	        //   this.preview_el.append(this.section_highlight_el);
	        // }
	        // this.section_highlight_el.show();
	        // this.section_highlight_el.css({
	        //   top: sec_bounds.top + "px",
	        //   left: (sec_bounds.left - 3) + "px",
	        //   right: sec_bounds.right + "px",
	        //   height: (sec_bounds.bottom - sec_bounds.top) + "px"
	        // });
	      }
	    },

	    update_preview_chart: function update_preview_chart($elt) {
	      $elt.find('svg').remove();
	      var svg = dimple.newSvg($elt[0], $elt.width(), $elt.height());
	      var myChart = new dimple.chart(svg, $elt.hasClass("chart_pie") ? this.chart_preview_pie_data : this.chart_preview_line_data);
	      if ($elt.hasClass("chart_pie")) {
	        var legendWidth = Math.max(0, Math.min(130, $elt.width() * 0.25));
	        myChart.setBounds(20, 20, Math.max(0, $elt.width() - legendWidth - 30), Math.max($elt.height() - 40, 0));
	        myChart.addMeasureAxis('p', 'Value field');
	        myChart.addSeries('l', dimple.plot.pie);
	        myChart.addLegend($elt.width() - legendWidth, 20, legendWidth, Math.max($elt.height() - 40, 0), "left");
	      } else {
	        myChart.setBounds(40, 20, Math.max($elt.width() - 60, 0), Math.max($elt.height() - 40, 0));
	        myChart.addCategoryAxis('x', 'l');
	        myChart.addMeasureAxis('y', 'Value field');
	        myChart.addSeries(null, $elt.hasClass("chart_line") ? dimple.plot.line : dimple.plot.bar);
	      }
	      myChart.draw();
	    },

	    on_preview_element_click: function on_preview_element_click(evt) {
	      var multiSelectKeyPressed = ditto.key.command || ditto.key.control,
	          $el = $(evt.target).closest(".preview-element");
	      var eltId = $el.data("element-id");
	      if ($el.hasClass('active')) {
	        // cmd+click on already selected element = de-select but keep others selected
	        if (multiSelectKeyPressed) {
	          if ($el.is(this.editing_control_elt)) {
	            if (this.otherSelections && this.otherSelections.length > 0) {
	              this.editing_control_elt.removeClass('active');
	              var lastAddedOtherSelection = this.otherSelections.pop();
	              this.editing_control_elt = lastAddedOtherSelection.elt;
	              this.editing_control_def = lastAddedOtherSelection.def;
	            } else {
	              this.clear_selection();
	            }
	          } else {
	            for (var i = 0; i < this.otherSelections.length; i++) {
	              if ($el.is(this.otherSelections[i].elt)) {
	                this.otherSelections.splice(i, 1);
	                $el.removeClass('active');
	                break;
	              }
	            }
	          }
	        }
	      } else {
	        if (this.editing_control_elt && multiSelectKeyPressed) {
	          // Add to "other selected elements" list
	          if (!this.multiSelect) {
	            this.hide_toolbar();
	            this.multiSelect = true;
	          }
	          $el.addClass("active");
	          this.otherSelections.push({
	            elt: $el,
	            def: this.elements_by_id[eltId]
	          });
	        } else {
	          if (this.multiSelect) {
	            this.otherSelections = [];
	            this.multiSelect = false;
	          }
	          this.clear_selection();
	          // template might have been redrawn, original $el is useless
	          $el = this.preview_el.find('#' + eltId);
	          this.select_element($el);
	        }
	      }
	      if (this.preview_el.find('.active').length > 0) {
	        this.showSelectionHints();
	      } else {
	        this.hideHintBar();
	      }
	      evt.stopPropagation();
	    },

	    showSelectionHints: function showSelectionHints() {
	      var keyname = ditto.isMac ? 'Cmd' : 'Ctrl';
	      this.showHintBar(keyname + '+click to add to selection, ' + keyname + '+C to copy, ' + keyname + '+V to paste, Delete to delete');
	    },

	    generate_text_suggestions: function generate_text_suggestions(sectionEntry) {
	      var is_header_footer = sectionEntry.is_header || sectionEntry.is_footer;
	      // const dataSection = this.getDataSections()[sectionEntry.detailIndex];
	      // if (!dataSection) return [];
	      var me = this;
	      var getEmptyNode = function getEmptyNode() {
	        return { list: [], dict: {} };
	      };
	      var autoCompleteData = getEmptyNode();

	      var sch = this.getSchemaForSectionEntry(sectionEntry);
	      if (!sch) return autoCompleteData;

	      var fields = this.jasperMode ? sch.fields.map(function (fld) {
	        return '$F{' + fld.name + '}';
	      }) : ditto.elements.Text.getTextSuggestions(sch);

	      /** Fields can include dot-separated object properties.  We split on the dot and only suggest one piece at a time,
	        so we need to maintain a nested lookup level-by-level.  Keep pointers to all lists so we can sort them later. */
	      var listsToSort = [autoCompleteData.list];
	      fields.forEach(function (fieldName) {
	        if (fieldName[0] === '[' && fieldName[fieldName.length - 1] === ']') {
	          var parts = fieldName.replace(/[\[\]]/g, '').split('.');
	          var part = void 0,
	              node = autoCompleteData;
	          for (var i = 0; i < parts.length; i++) {
	            var _part = parts[i];
	            if (node.dict[_part] !== undefined) {
	              node = node.dict[_part];
	            } else {
	              // Must convert e.g. [partA.partB.partC] -> [partA]
	              node.list.push(i === 0 ? '[' + _part + ']' : _part);
	              node.dict[_part] = node = getEmptyNode();
	              listsToSort.push(node.list);
	            }
	          }
	        } else {
	          // Not brackets, push verbatim
	          autoCompleteData.list.push(fieldName);
	        }
	      });
	      this.report_def.inputs.forEach(function (input) {
	        autoCompleteData.list.push('[?' + input.name + ']');
	      });
	      if (is_header_footer) {
	        this.group_aggregate_function_suggestions.forEach(function (suggestion) {
	          autoCompleteData.list.push(suggestion);
	        });
	      }
	      listsToSort.forEach(function (list) {
	        return list.sort();
	      });
	      return autoCompleteData;
	    },

	    select_element: function select_element($el, hide_toolbar) {
	      var me = this;
	      this.selectedSection = null;
	      $(".preview .page .preview-element.active").removeClass("active");
	      $el.addClass("active");
	      var eltID = $el.data("element-id"),
	          elt = this.elements_by_id[eltID];
	      this.editing_control_def = elt;
	      this.editing_control_elt = $el;
	      this.activeElementInstance = null; // will be set in default: case below
	      var toolbar = $el.data("toolbarObj"),
	          toolbarExisted = !!toolbar;
	      var completer;
	      var section;
	      switch (elt.type) {
	        case "text":
	          if (!toolbarExisted) {
	            if (!this.text_toolbar) {
	              this.create_text_toolbar();
	            }
	            $el.toolbar({
	              content: "#jsr-designer-text-toolbar",
	              position: "bottom",
	              hideOnClick: this.toolbarPosition === "float"
	            });
	            $el.toolbar("getToolbarElement").closest(".tool-container").addClass("jsr-toolbar");
	            toolbar = $el.data("toolbarObj");
	            this.bind_text_toolbar_events();
	            var $inputWrap = toolbar.toolbar.find(".jsr-toolbar-text-content .input-wrap");
	            this.initTextComplete($inputWrap, me.on_text_toolbar_text_change.bind(me, elt, $el));
	          }
	          section = this.find_section_by_y($el.position().top);
	          this.autoCompleteOptions = this.generate_text_suggestions(section.sectionInfo);
	          toolbar.toolbar.find(".jsr-toolbar-text-content textarea").val(elt.text);
	          toolbar.toolbar.find(".jsr-toolbar-text-font-family select").val(elt.font ? elt.font.name : "default");
	          toolbar.toolbar.find(".jsr-toolbar-text-font-size select").val(elt.fontsize || '');
	          toolbar.toolbar.find(".tool-item").on("click", this.on_toolbar_element_click);
	          if (!hide_toolbar) {
	            this.show_toolbar($el);
	            // setTimeout(() => {
	            //     try {
	            //         completer.input.focus(); 
	            //     } catch(e) {}
	            // }, 10);
	          }
	          break;
	        case "image":
	          if (!toolbarExisted) {
	            if (!this.image_toolbar) {
	              this.create_image_toolbar();
	            }
	            $el.toolbar({
	              content: "#jsr-designer-image-toolbar",
	              position: "bottom",
	              hideOnClick: this.toolbarPosition === "float"
	            });
	            $el.toolbar("getToolbarElement").closest(".tool-container").addClass("jsr-toolbar");
	            this.bind_image_toolbar();
	          }
	          if (!hide_toolbar) {
	            this.show_toolbar($el);
	          }
	          break;
	        case "chart_line":
	        case "chart_pie":
	        case "chart_bar":
	          if (!toolbarExisted) {
	            if (!this.chart_toolbar) {
	              this.create_chart_toolbar();
	            }
	            $el.toolbar({
	              content: "#jsr-designer-chart-toolbar",
	              position: "bottom",
	              hideOnClick: this.toolbarPosition === "float"
	            });
	            $el.toolbar("getToolbarElement").closest(".tool-container").addClass("jsr-toolbar");
	            var value_field = this.editing_control_def.series && this.editing_control_def.series.length > 0 ? this.editing_control_def.series[0].value_field : "";
	            var label_field = "";
	            if (this.editing_control_def.type === "chart_line" || this.editing_control_def.type === "chart_bar") {
	              if (this.editing_control_def.x_axis) {
	                label_field = this.editing_control_def.x_axis.label_field;
	              }
	            } else if (this.editing_control_def.type === "chart_pie") {
	              if (this.editing_control_def.series && this.editing_control_def.series.length > 0) {
	                label_field = this.editing_control_def.series[0].label_field;
	              }
	            }
	            var chart_tb_instance = $el.toolbar("getToolbarElement");
	            chart_tb_instance.find(".jsr-toolbar-chart-value-field select").val(value_field);
	            chart_tb_instance.find(".jsr-toolbar-chart-label-field select").val(label_field);
	            switch (elt.type) {
	              case "chart_line":
	                chart_tb_instance.find(".jsr-toolbar-chart-type select").val("line");
	                break;
	              case "chart_bar":
	                chart_tb_instance.find(".jsr-toolbar-chart-type select").val("bar");
	                break;
	              case "chart_pie":
	                chart_tb_instance.find(".jsr-toolbar-chart-type select").val("pie");
	                break;
	            }
	            if (!hide_toolbar) {
	              setTimeout(function () {
	                this.show_toolbar($el);
	              }.bind(this), 250);
	            }
	          } else {
	            if (!hide_toolbar) {
	              this.show_toolbar($el);
	            }
	          }
	          break;
	        case "box":
	          if (!toolbarExisted) {
	            if (!this.box_toolbar) {
	              this.create_box_toolbar();
	            }
	            $el.toolbar({
	              content: "#jsr-designer-box-toolbar",
	              position: "bottom",
	              hideOnClick: this.toolbarPosition === "float"
	            });
	            $el.toolbar("getToolbarElement").closest(".tool-container").addClass("jsr-toolbar");
	            this.bind_box_toolbar();
	          }
	          if (!hide_toolbar) {
	            this.show_toolbar($el);
	          }
	          break;
	        case "barcode":
	          if (!toolbarExisted) {
	            if (!this.barcode_toolbar) {
	              this.create_barcode_toolbar();
	            }
	            $el.toolbar({
	              content: "#jsr-designer-barcode-toolbar",
	              position: "bottom",
	              hideOnClick: this.toolbarPosition === "float"
	            });
	            $el.toolbar("getToolbarElement").closest(".tool-container").addClass("jsr-toolbar");
	            this.bind_barcode_toolbar();
	          }
	          section = this.find_section_by_y($el.position().top);
	          this.autoCompleteOptions = this.generate_text_suggestions(section.sectionInfo);
	          $el.data("toolbarObj").toolbar.find(".jsr-toolbar-barcode-value input").val(elt.value);
	          if (!hide_toolbar) {
	            this.show_toolbar($el);
	          }
	          break;
	        case "break":
	          if (!toolbarExisted) {
	            if (!this.break_toolbar) {
	              this.create_break_toolbar();
	            }
	            $el.toolbar({
	              content: "#jsr-designer-break-toolbar",
	              position: "bottom",
	              hideOnClick: this.toolbarPosition === "float"
	            });
	            $el.toolbar("getToolbarElement").closest(".tool-container").addClass("jsr-toolbar");
	            this.bind_break_toolbar();
	          }
	          if (!hide_toolbar) {
	            this.show_toolbar($el);
	          }
	          break;
	        case "subreport":
	          if (!toolbarExisted) {
	            if (!this.subreport_toolbar) {
	              this.create_subreport_toolbar();
	            }
	            $el.toolbar({
	              content: "#jsr-designer-subreport-toolbar",
	              position: "bottom",
	              hideOnClick: this.toolbarPosition === "float"
	            });
	            $el.toolbar("getToolbarElement").closest(".tool-container").addClass("jsr-toolbar");
	            this.bind_subreport_toolbar();
	          }
	          if (!hide_toolbar) {
	            this.show_toolbar($el);
	          }
	          break;
	        default:
	          var elClass = this.elementTypes[elt.type.toLowerCase()].handler;
	          var inst = $el.data('jsr-element-instance');
	          if (!inst) {
	            inst = new elClass(elt);
	          }
	          this.activeElementInstance = inst;
	          this.refreshCustomElementToolbar();
	          if (!hide_toolbar) {
	            this.show_toolbar($el);
	          }
	          if (this.activeElementInstance.onDesignerSelect) {
	            this.activeElementInstance.onDesignerSelect($el[0]);
	          }
	          break;
	      }
	      var $toolbarEl = $el.toolbar("getToolbarElement");
	      if ($toolbarEl.length > 0) {
	        var toolbarDomEl = $toolbarEl[0];
	        var allowed = !this.allowToolbarControl || !!this.allowToolbarControl(elt.type, 'conditionalRules');
	        if (allowed) {
	          this.addConditionalPropertiesButtonToToolbar(toolbarDomEl);
	          var condPropsCount = elt && elt.conditionalRules ? elt.conditionalRules.length : 0;
	          this.setCondPropsCount(condPropsCount, toolbarDomEl);
	        }
	      }
	      if (!this.$delete_element_button) {
	        this.$delete_element_button = $('<div class="delete-element-button"><div style="float: right">' + t('DELETE') + ' <span class="delete-element-icon">X</span></div><div>');
	        this.$delete_element_button.on("click", this.delete_selected_control.bind(this));
	        this.preview_el.append(this.$delete_element_button);
	      }
	      this.position_delete_button();
	      this.collapseLeftPaneIfOverlay();
	      this.setGridVisible(true);
	    },

	    initTextComplete: function initTextComplete($inputWrap, onChangeHandler) {
	      var _this20 = this;

	      var me = this;
	      var getSubKeys = function getSubKeys(autocompleteData, objPath) {
	        var parts = objPath.split('.');
	        var node = autocompleteData;
	        for (var i = 0; i < parts.length; i++) {
	          node = node.dict[parts[i]];
	          if (!node) return [];
	        }
	        return node.list;
	      };

	      var autocompleteStrategy = {
	        id: 'textAutocompleteStrategy',
	        match: /(^|\s)((\[)?[\w\-\.]*)$/,
	        search: function search(term, callback) {
	          if (term[term.length - 1] === '.') {
	            // Assuming it starts with [ here
	            me.lastAutocompleteWasSubkey = true;
	            return callback(getSubKeys(me.autoCompleteOptions, term.substr(1, term.length - 2))
	            // .map(subkey => `${term}${subkey}`)
	            );
	          }
	          me.lastAutocompleteWasSubkey = false;
	          callback(me.autoCompleteOptions.list.filter(function (name) {
	            return name.startsWith(term);
	          }));
	        },
	        template: function template(name) {
	          return name;
	        },
	        replace: function replace(name) {
	          return me.lastAutocompleteWasSubkey ? '$1$2' + name : '$1' + name;
	        }
	      };

	      var $textArea = $('<textarea></textarea>');
	      $inputWrap.append($textArea);
	      var editor = new _textarea2.default($textArea[0]);
	      var textcomplete = new _textcomplete2.default(editor, {
	        dropdown: {
	          maxCount: Infinity
	        }
	      });
	      $textArea.data('textcomplete', textcomplete);
	      textcomplete.register([autocompleteStrategy]);
	      textcomplete.on('shown', function () {
	        var dds = Array.from(document.querySelectorAll('.textcomplete-dropdown'));
	        var windowHeight = window.innerHeight;
	        dds.forEach(function (dd) {
	          var rect = dd.getBoundingClientRect();
	          dd.style.maxHeight = Math.max(100, windowHeight - rect.top - 20) + 'px';
	        });
	      });
	      $textArea.on('focus', this.onToolbarTextInputFocus.bind(this));
	      $textArea.on('blur', this.onToolbarTextInputBlur.bind(this));
	      $textArea.on('change', function (evt) {
	        onChangeHandler(evt.target.value);
	        _this20.onElementEdit();
	      });
	    },

	    onToolbarTextInputFocus: function onToolbarTextInputFocus(evt) {
	      $(evt.target).closest('.input-wrap').addClass('jsr-input-active');
	    },

	    onToolbarTextInputBlur: function onToolbarTextInputBlur(evt) {
	      var $textarea = $(evt.target);
	      var completer = $textarea.data('textcomplete');
	      // console.log(`onToolbarTextInputBlur`, completer, completer.dropdown);
	      if (completer && completer.dropdown) {
	        completer.dropdown.deactivate();
	      }
	      $textarea.closest('.input-wrap').removeClass('jsr-input-active');
	    },

	    setCondPropsCount: function setCondPropsCount(count, toolbarDomEl) {
	      var $bubble = $(toolbarDomEl).find('.jsr-cond-props-count-bubble');
	      if (count > 0) {
	        $bubble.text(count).css('display', 'block');
	      } else {
	        $bubble.css('display', 'none');
	      }
	    },

	    refreshCustomElementToolbar: function refreshCustomElementToolbar() {
	      var elDef = this.editing_control_def;
	      var $el = this.editing_control_elt;
	      var inst = this.activeElementInstance;
	      var elClass = inst.constructor;
	      if ($el.data("toolbarObj")) {
	        $el.toolbar("getToolbarElement").remove();
	      }
	      $('#jsr-designer-toolbar-' + elDef.type).remove();
	      var containingSection = this.find_section_by_y($el.position().top).sectionInfo;
	      var activeSchema = this.getSchemaForSectionEntry(containingSection);
	      this.createElementToolbar(elClass, inst, activeSchema);
	      $el.toolbar({
	        content: '#jsr-designer-toolbar-' + elDef.type,
	        position: 'bottom',
	        hideOnClick: this.toolbarPosition === "float"
	      });
	      var toolbarEl = $el.toolbar("getToolbarElement");
	      toolbarEl.closest('.tool-container').addClass('jsr-toolbar');
	      this.bindElementToolbar(toolbarEl[0], elClass, elDef);
	      this.show_toolbar($el);
	    },

	    selectSection: function selectSection(sectionInfo) {
	      this.selectedSection = sectionInfo;
	      if (!this.sectionToolbar || !this.preview_el.data("toolbarObj")) {
	        this.createSectionToolbarTemplateEl();
	        this.preview_el.toolbar({
	          content: '#jsr-designer-toolbar-section',
	          position: 'bottom',
	          hideOnClick: false
	        });
	        this.preview_el.toolbar("getToolbarElement").closest('.tool-container').addClass('jsr-toolbar');
	        this.sectionToolbar = this.preview_el.data("toolbarObj");
	        var toolbarEl = this.preview_el.toolbar("getToolbarElement")[0];
	        toolbarEl.querySelector('.jsr-section-toolbar-insert-above button').addEventListener('click', this.onInsertSectionAbove.bind(this));
	        toolbarEl.querySelector('.jsr-section-toolbar-insert-below button').addEventListener('click', this.onInsertSectionBelow.bind(this));
	        toolbarEl.querySelector('.jsr-section-toolbar-remove button').addEventListener('click', this.onRemoveSection.bind(this));
	      }
	      var $toolbarEl = this.preview_el.toolbar("getToolbarElement");

	      // Add conditional rules button
	      if ($toolbarEl.length > 0) {
	        var toolbarDomEl = $toolbarEl[0];
	        var allowed = !this.allowToolbarControl || !!this.allowToolbarControl('section', 'conditionalRules');
	        if (allowed) {
	          this.addConditionalPropertiesButtonToToolbar(toolbarDomEl);
	          var def = sectionInfo.def;
	          var condPropsCount = def && def.conditionalRules ? def.conditionalRules.length : 0;
	          this.setCondPropsCount(condPropsCount, toolbarDomEl);
	        }
	      }

	      this.bindSectionToolbar($toolbarEl[0], sectionInfo);
	      // Hide any open element toolbar
	      if (this.current_toolbar_owner_el && this.toolbarPosition !== "float") {
	        this.hide_toolbar();
	      }
	      this.dock_toolbar(this.sectionToolbar.toolbar);
	      this.collapseLeftPaneIfOverlay();
	      this.highlightSection(sectionInfo);
	    },

	    createSectionToolbarTemplateEl: function createSectionToolbarTemplateEl() {
	      $('#jsr-designer-toolbar-section').remove();
	      var $toolbar = $(['<div id="jsr-designer-toolbar-section" style="display:none">', '<div>', '<div class="tool-item gradient jsr-section-toolbar-item jsr-toolbar-section-name not-pressable">', 'Section: <span class="jsr-section-toolbar-section-name"></span>', '</div>', '<div class="tool-item gradient jsr-section-toolbar-item jsr-section-toolbar-insert-above not-pressable">', '<button class="jsr-btn">Insert section above</button>', '</div>', '<div class="tool-item gradient jsr-section-toolbar-item jsr-section-toolbar-insert-below not-pressable">', '<button class="jsr-btn">Insert section below</button>', '</div>', '<div class="tool-item gradient jsr-section-toolbar-item jsr-section-toolbar-remove not-pressable">', '<button class="jsr-btn">Remove section</button>', '</div>', '</div>', '</div>'].join(''));
	      // const $toolbar = $(`<div id="jsr-designer-toolbar-section" style="display:none">Section: <span class="jsr-section-toolbar-section-name"></span></div>`);
	      $toolbar.append(this.get_advanced_editor_icon());
	      $(this.container).append($toolbar);
	    },

	    cloneDetailSection: function cloneDetailSection(section) {
	      var safeClone = function safeClone(node) {
	        return JSON.parse(JSON.stringify(node));
	      };
	      return safeClone({
	        height: section.height,
	        visible: section.visible,
	        elements: section.elements
	      });
	    },

	    getBlankDetailSection: function getBlankDetailSection() {
	      return this.cloneDetailSection(this.getDefaultDataSection());
	    },

	    onInsertSectionAbove: function onInsertSectionAbove() {
	      if (!this.selectedSection) return;
	      var dataSection = this.getDataSections()[this.selectedSection.detailIndex];
	      var newSection = this.getBlankDetailSection();
	      newSection.height = newSection.height / 2;
	      if (this.selectedSection.extraSectionIndex === undefined) {
	        // Is primary detail; push current into extraSections
	        if (!dataSection.extraSections) {
	          dataSection.extraSections = [];
	        }
	        dataSection.extraSections.splice(0, 0, this.cloneDetailSection(this.selectedSection.def));
	        _.extend(this.selectedSection.def, newSection);
	        newSection = this.selectedSection.def;
	      } else {
	        dataSection.extraSections.splice(this.selectedSection.extraSectionIndex, 0, newSection);
	      }
	      this.clear_selection();
	      this.render_template();
	      this.selectSection(this.preview_section_offsets.find(function (secInf) {
	        return secInf.def === newSection;
	      }));
	    },

	    onInsertSectionBelow: function onInsertSectionBelow() {
	      if (!this.selectedSection) return;
	      var dataSection = this.getDataSections()[this.selectedSection.detailIndex];
	      var newSection = this.getBlankDetailSection();
	      newSection.height = newSection.height / 2;
	      if (this.selectedSection.extraSectionIndex === undefined) {
	        if (!dataSection.extraSections) {
	          dataSection.extraSections = [];
	        }
	        dataSection.extraSections.splice(0, 0, newSection);
	      } else {
	        dataSection.extraSections.splice(this.selectedSection.extraSectionIndex + 1, 0, newSection);
	      }
	      this.clear_selection();
	      this.render_template();
	      this.selectSection(this.preview_section_offsets.find(function (secInf) {
	        return secInf.def === newSection;
	      }));
	    },

	    onRemoveSection: function onRemoveSection() {
	      if (!this.selectedSection) return;
	      var dataSection = this.getDataSections()[this.selectedSection.detailIndex];
	      var newSection = this.getBlankDetailSection();
	      if (this.selectedSection.extraSectionIndex === undefined) {
	        // Wipe out main detail and pop from extraSections
	        var firstExtra = dataSection.extraSections[0];
	        _.extend(this.selectedSection.def, firstExtra);
	        dataSection.extraSections.splice(0, 1);
	      } else {
	        dataSection.extraSections.splice(this.selectedSection.extraSectionIndex, 1);
	      }
	      this.clear_selection();
	      this.render_template();
	    },

	    bindSectionToolbar: function bindSectionToolbar(toolbarEl, sectionInfo) {
	      $('span.jsr-section-toolbar-section-name', toolbarEl).text(sectionInfo.label);
	      toolbarEl.querySelector('.jsr-section-toolbar-insert-above').style.display = sectionInfo.is_detail ? 'block' : 'none';
	      toolbarEl.querySelector('.jsr-section-toolbar-insert-below').style.display = sectionInfo.is_detail ? 'block' : 'none';
	      var canRemove = false;
	      if (sectionInfo.is_detail) {
	        var extraSections = this.getDataSections()[sectionInfo.detailIndex].extraSections;
	        if (extraSections && extraSections.length > 0) {
	          canRemove = true;
	        }
	      }
	      toolbarEl.querySelector('.jsr-section-toolbar-remove').style.display = canRemove ? 'block' : 'none';
	    },

	    show_toolbar: function show_toolbar($el) {
	      // Sometimes show_toolbar is called with a delay; check in case selection has changed
	      if (!this.editing_control_elt.is($el)) return;
	      // In docked mode, if another toolbar is present, hide it first
	      if (this.current_toolbar_owner_el && !this.current_toolbar_owner_el.is($el) && this.toolbarPosition !== "float") {
	        this.hide_toolbar();
	      }
	      var toolbar = $el.data("toolbarObj");
	      if (this.toolbarPosition === "float") {
	        toolbar.show();
	        $el.toolbar("calculatePosition");
	      } else {
	        this.dock_toolbar(toolbar.toolbar);
	      }
	      this.current_toolbar_owner_el = $el;
	    },

	    hide_toolbar: function hide_toolbar() {
	      if (this.showing_property_editor) {
	        this.on_property_editor_ok(); // Default to saving
	      }
	      var toolbar = null;
	      if (this.current_toolbar_owner_el) {
	        toolbar = this.current_toolbar_owner_el.data("toolbarObj");
	      } else if (this.selectedSection) {
	        toolbar = this.preview_el.data("toolbarObj");
	      }
	      if (toolbar && toolbar.toolbar.is(":visible")) {
	        toolbar.toolbar.hide();
	        this.adjust_preview_dimensions();
	      }
	      this.current_toolbar_owner_el = null;
	    },

	    dock_toolbar: function dock_toolbar($toolbar_el) {
	      var $right = this.designer_el.find(".jsr-designer-right"),
	          $preview_container = $right.find(".preview");
	      $right.append($toolbar_el);
	      if (this.toolbarPosition === "top") {
	        $toolbar_el.addClass("jsr-toolbar-docked").css({
	          position: "absolute",
	          top: 0,
	          left: 0,
	          width: "100%",
	          opacity: 1,
	          display: "block"
	        });
	        // this.designer_el[0].querySelector(`.preview .page`).style.marginTop = 
	        //   `${$toolbar_el[0].getBoundingClientRect().height}px`;
	      } else {
	        // Position at bottom
	        $toolbar_el.addClass("jsr-toolbar-docked").css({
	          position: "absolute",
	          top: "auto",
	          left: 0,
	          bottom: 0,
	          width: "100%",
	          opacity: 1,
	          display: "block"
	        });
	      }
	      this.adjust_preview_dimensions();
	    },

	    render_barcode: function render_barcode($elt, elt_def) {
	      var type = elt_def.barcode_type,
	          $barcode_container = $elt.find(".jsr-barcode");
	      $barcode_container.empty().removeClass("qrcode");
	      if (type === "QR") {
	        // QR code wants to be rendered directly into a <div>
	        var min_dimension = Math.min($elt.width(), $elt.height());
	        new QRCode($barcode_container[0], {
	          text: this.barcode_dummy_values[type],
	          width: min_dimension,
	          height: min_dimension
	        });
	        $barcode_container.addClass("qrcode");
	      } else {
	        // JSBarcode expects an <img>
	        var $img = $('<img>');
	        $barcode_container.append($img);
	        $img.JsBarcode(this.barcode_dummy_values[type], {
	          format: type,
	          displayValue: !!elt_def.show_value,
	          fontSize: Math.max(12, Math.floor($barcode_container.height() / 3))
	        });
	      }
	    },

	    on_toolbar_element_click: function on_toolbar_element_click(evt) {
	      //$(evt.target).closest(".tool-item").addClass("selected");
	    },

	    position_delete_button: function position_delete_button() {
	      var offs = this.editing_control_elt.position();
	      this.$delete_element_button.css({
	        top: offs.top - 19 + "px",
	        right: this.preview_el.width() - (offs.left + this.editing_control_elt.width() - 10) + "px"
	      });
	      this.$delete_element_button.show();
	    },

	    getEntireSelection: function getEntireSelection() {
	      return (this.otherSelections || []).concat([{
	        elt: this.editing_control_elt,
	        def: this.editing_control_def
	      }]);
	    },

	    delete_selected_control: function delete_selected_control() {
	      if (!this.editing_control_elt) return;
	      delete this.edgeMap;
	      var touchedDetail = false;
	      var eltsToRemove = $();
	      this.getEntireSelection().forEach(function (selectedItem) {
	        var sectiondef = this.sections_by_element_id[selectedItem.def.id].def;
	        sectiondef.elements.splice(sectiondef.elements.indexOf(selectedItem.def), 1);
	        delete this.sections_by_element_id[selectedItem.def.id];
	        eltsToRemove = eltsToRemove.add(selectedItem.elt);
	        touchedDetail = this.sectionIsDetail(sectiondef);
	      }.bind(this));
	      this.clear_selection();
	      eltsToRemove.remove();
	      if (touchedDetail) {
	        this.update_column_clones();
	      }
	    },

	    copy_selection: function copy_selection() {
	      if (!this.editing_control_def) return;
	      this.clipboard = (this.otherSelections || []).slice(0).concat([{
	        elt: this.editing_control_elt,
	        def: this.editing_control_def
	      }]);
	    },

	    paste_selection: function paste_selection() {
	      if (!this.clipboard) return;
	      var me = this;
	      this.clear_selection();
	      var affectedSections = {};
	      // Clone selected elements, one grid square to the right, and select them
	      this.clipboard.forEach(function (selection) {
	        var clonedDef = $.extend(true, {}, selection.def, {
	          id: me.get_next_element_id(),
	          left: selection.def.left + me.gridSize / me.pixels_per_unit,
	          top: selection.def.top + me.gridSize / me.pixels_per_unit
	        });
	        var section = me.find_section_by_y(selection.elt.position().top);
	        if (!section) {
	          section = me.preview_section_offsets[me.preview_section_offsets.length - 1];
	        }
	        section.def.elements.push(clonedDef);
	        me.sections_by_element_id[clonedDef.id] = section;
	        var clonedElt = me.render_template_element(clonedDef, section.top);
	        me.preview_el.append(clonedElt);
	        me.otherSelections.push({
	          def: clonedDef,
	          elt: clonedElt
	        });
	        if (!affectedSections[section.top]) {
	          affectedSections[section.top] = section;
	        }
	      });
	      var sectionHeightChanged = false;
	      Object.keys(affectedSections).forEach(function (sectionTop) {
	        var section = affectedSections[sectionTop];
	        sectionHeightChanged = me.fit_section(section.def) || sectionHeightChanged;
	      });
	      if (sectionHeightChanged) {
	        this.render_template();
	      }
	      this.otherSelections.forEach(function (newSeln) {
	        newSeln.elt = me.preview_el.find("#" + newSeln.def.id);
	        newSeln.elt.addClass('active');
	      });
	      var lastItem = this.otherSelections.pop();
	      this.editing_control_elt = lastItem.elt;
	      this.editing_control_def = lastItem.def;
	      this.multiSelect = this.otherSelections.length > 0;
	    },

	    clear_selection: function clear_selection() {
	      if (!this.editing_control_elt && !this.selectedSection) return;
	      this.highlightSection(null);
	      // this.designer_el[0].querySelector(`.preview .page`).style.marginTop = '0';
	      if (this.conditionalPropertiesPicker) {
	        this.conditionalPropertiesPicker.forceClose();
	        this.conditionalPropertiesPicker = null;
	      }
	      if (this.multiSelect) {
	        this.otherSelections.forEach(function (otherSel) {
	          otherSel.elt.removeClass('active');
	        });
	        this.otherSelections = [];
	        this.multiSelect = false;
	      }
	      var toolbar = null;
	      if (this.editing_control_elt) {
	        toolbar = this.editing_control_elt.data("toolbarObj");
	      } else if (this.selectedSection) {
	        toolbar = this.preview_el.data("toolbarObj");
	      }
	      if (toolbar) {
	        this.hide_toolbar();
	        // if (this.toolbarPosition !== "float") {
	        //     this.adjust_preview_dimensions();
	        // }
	      }
	      if (this.editing_control_elt) {
	        if (this.activeElementInstance && this.activeElementInstance.onDesignerDeselect) {
	          this.activeElementInstance.onDesignerDeselect(this.editing_control_elt[0]);
	        }
	        this.editing_control_elt.removeClass("active");
	        this.editing_control_elt = null;
	        this.editing_control_def = null;
	      }
	      this.activeElementInstance = null;
	      if (this.$delete_element_button) {
	        this.$delete_element_button.hide();
	      }
	      this.selectedSection = null;
	      this.hideHintBar();
	      this.setGridVisible(false);
	    },

	    on_arrow_key: function on_arrow_key(e) {
	      if (!this.editing_control_elt) return;
	      var elDef = this.editing_control_def;
	      var el = this.editing_control_elt;
	      var code = e.keyCode || e.which;
	      var unitsPerGridSquare = parseFloat((this.gridSize / this.pixels_per_unit).toFixed(4));
	      var onePixel = ditto.key.command || ditto.key.control;
	      var leftSquares = Math.floor(elDef.left / unitsPerGridSquare);
	      var leftGridLineUnits = leftSquares * unitsPerGridSquare;
	      var leftRemainder = elDef.left - leftGridLineUnits;
	      var topSquares = Math.floor(elDef.top / unitsPerGridSquare);
	      var topGridLineUnits = topSquares * unitsPerGridSquare;
	      var topRemainder = elDef.top - topGridLineUnits;
	      var leftOffset = parseFloat(el.css('left')) - elDef.left * this.pixels_per_unit;
	      var topOffset = parseFloat(el.css('top')) - elDef.top * this.pixels_per_unit;
	      var epsilon = 0.00005;
	      switch (code) {
	        case 37:
	          // left
	          if (onePixel) {
	            elDef.left -= 1 / this.pixels_per_unit;
	          } else {
	            if (leftRemainder > 0) {
	              elDef.left = leftGridLineUnits;
	            } else {
	              elDef.left = leftGridLineUnits - unitsPerGridSquare;
	            }
	          }
	          break;
	        case 38:
	          // up
	          if (onePixel) {
	            elDef.top -= 1 / this.pixels_per_unit;
	          } else {
	            if (topRemainder > 0) {
	              elDef.top = topGridLineUnits;
	            } else {
	              elDef.top = topGridLineUnits - unitsPerGridSquare;
	            }
	          }
	          break;
	        case 39:
	          // right
	          if (onePixel) {
	            elDef.left += 1 / this.pixels_per_unit;
	          } else {
	            elDef.left = (leftSquares + 1) * unitsPerGridSquare + epsilon;
	          }
	          break;
	        case 40:
	          // down
	          if (onePixel) {
	            elDef.top += 1 / this.pixels_per_unit;
	          } else {
	            elDef.top = (topSquares + 1) * unitsPerGridSquare + epsilon;
	          }
	          break;
	      }
	      elDef.left = Math.max(0, elDef.left);
	      elDef.top = Math.max(0, elDef.top);
	      this.editing_control_elt.css({
	        left: leftOffset + elDef.left * this.pixels_per_unit,
	        top: topOffset + elDef.top * this.pixels_per_unit
	      });
	      this.position_delete_button();
	      e.preventDefault();
	    },

	    addElementToTemplate: function addElementToTemplate(eltType, section) {
	      var _this21 = this;

	      delete this.edgeMap;
	      var elt = this.create_element(eltType);
	      var $newdiv = this.render_template_element(elt, section.top);
	      this.preview_el.append($newdiv);
	      window.setTimeout(function () {
	        _this21.constrain_el_to_margins($newdiv);
	        var elt_pos = $newdiv.position();
	        section.def.elements.push(elt);
	        _this21.sections_by_element_id[elt.id] = section;
	        elt.top = (elt_pos.top - section.top) / _this21.pixels_per_unit;
	        elt.left = (elt_pos.left - section.left) / _this21.pixels_per_unit;
	        elt.width = $newdiv.width() / _this21.pixels_per_unit;
	        elt.height = $newdiv.height() / _this21.pixels_per_unit;
	        // Update the backing instance if there is one, since we just changed props
	        var inst = $newdiv.data('jsr-element-instance');
	        if (inst) {
	          _.extend(inst.props, elt);
	        }
	        if (_this21.fit_section(section.def)) {
	          _this21.render_template();
	        }
	        // preview might have been redrawn, need to find the new div to select it
	        var $elt = _this21.preview_el.find("#" + elt.id);
	        _this21.select_element($elt);
	        if (_this21.sectionIsDetail(section.def)) {
	          _this21.update_column_clones();
	        }
	        $elt.addClass('jsr-element-added');
	        setTimeout(function () {
	          $elt.addClass('jsr-element-adding');
	        }, 0);
	        setTimeout(function () {
	          $elt.removeClass('jsr-element-added');
	        }, 0);
	        setTimeout(function () {
	          $elt.removeClass('jsr-element-adding');
	        }, 1000);
	      }, 0);
	    },

	    initPaletteEvents: function initPaletteEvents() {
	      var _this22 = this;

	      $(".palette-item", this.newElPopup.el).on('click', function (evt) {
	        _this22.newElPopup.hide();
	        var $item = $(evt.target).closest('.palette-item');
	        var eltType = $item.data("elementtype");
	        _this22.addElementToTemplate(eltType, _this22.lastHoveredSection);
	      });
	    },

	    create_element: function create_element(type, section) {
	      var elt = {
	        id: this.get_next_element_id(),
	        type: type,
	        left: 10 / this.pixels_per_unit,
	        top: 10 / this.pixels_per_unit,
	        width: 150 / this.pixels_per_unit,
	        height: 40 / this.pixels_per_unit,
	        visible: true
	      };
	      switch (type) {
	        case "text":
	          $.extend(elt, this.get_default_props(type));
	          break;
	        case "image":
	          elt.height = 150 / this.pixels_per_unit;
	          break;
	        case "chart":
	          elt.type = "chart_line"; // default to line type
	          elt.height = 150 / this.pixels_per_unit;
	          break;
	        case "box":
	          elt.height = 70 / this.pixels_per_unit;
	          elt.width = 70 / this.pixels_per_unit;
	          elt.corner_radius = 0;
	          elt.background_color = "#cdf";
	          elt.border_color = "#555";
	          break;
	        case "barcode":
	          elt.barcode_type = "CODE128";
	          elt.value = "";
	          elt.show_value = false;
	          break;
	        case "break":
	          elt.breakType = 'page';
	          elt.everyNth = 1;
	          break;
	        case "subreport":
	          $.extend(elt, this.get_default_props(type));
	          break;
	        default:
	          var elClass = this.elementTypes[type.toLowerCase()];
	          if (!elClass) throw new Error('Couldn\'t find class for element type ' + type);
	          var clazz = elClass.handler;
	          var inst = new clazz();
	          var props = inst.props;
	          if (clazz.units && clazz.units.toLowerCase() !== this.report_def.page.units) {
	            var toMm = this.report_def.page.units === 'mm';
	            if (props.width !== undefined) {
	              props.width = toMm ? props.width * this.mm_per_in : props.width / this.mm_per_in;
	            }
	            if (props.height !== undefined) {
	              props.height = toMm ? props.height * this.mm_per_in : props.height / this.mm_per_in;
	            }
	          }
	          Object.assign(elt, props);
	          break;
	      }
	      return elt;
	    },

	    adjust_preview_dimensions: function adjust_preview_dimensions() {
	      // May be no report loaded and nothing to reposition
	      if (!this.preview_el) return;

	      var designer_height = this.designer_el.find('.jsr-designer-right').innerHeight();
	      var $preview_container = this.designer_el.find(".preview");

	      var $toolbar = $preview_container.closest(".jsr-designer-right").find(".jsr-toolbar-docked:visible");
	      var toolbarHeight = $toolbar.length > 0 ? $toolbar.outerHeight() : 0;

	      var allToolbarsHeight = 0; //this.designer_el.find(".palette").outerHeight();
	      if ($toolbar.length > 0) {
	        allToolbarsHeight = Math.floor(Math.max(allToolbarsHeight, $toolbar.position().top + toolbarHeight));
	      }
	      var origHeight = $preview_container[0].clientHeight;
	      var origScrollTop = this.lastAutoScroll || Math.ceil($preview_container.scrollTop());
	      var newHeight = Math.floor(designer_height - allToolbarsHeight - 20); // padding
	      $preview_container.height(newHeight);

	      if (this.toolbarPosition === "top") {
	        $preview_container.css("top", allToolbarsHeight);
	      } else if (this.toolbarPosition === "bottom") {
	        $preview_container.css("top", toolbarHeight);
	      }
	      this.designer_el.find('.jsr-designer-right .jsr-designer-zoom').css('top', toolbarHeight + 10 + 'px');

	      var preview_width = this.preview_el.width(),
	          units = this.report_def.page.units,
	          paper_width = this.report_def.page.paper_size[units][0],
	          pixels_per_unit = preview_width / paper_width,
	          paper_height_px = this.report_def.page.paper_size[units][1] * pixels_per_unit;
	      // Show one full page height, or the template height if greater
	      var templateHeightInUnits = this.getAllSections().reduce(function (height, section) {
	        return height + (section.def.visible === false ? 0 : Number(section.def.height) || 0);
	      }, 0) + (this.report_def.page.margins.top || 0) + (this.report_def.page.margins.bottom || 0);
	      var templateHeightPx = templateHeightInUnits * pixels_per_unit;
	      this.preview_el.height(Math.floor(Math.max(paper_height_px, templateHeightPx)));
	      var gridSizeUnits = units === 'mm' ? this.gridSizeMm : this.gridSizeInches;
	      this.gridSize = gridSizeUnits * pixels_per_unit; //Math.round(gridSizeUnits * pixels_per_unit);
	      // Reset grid size
	      this.setGridVisible(this.gridVisible || false);

	      if (this.initial_render_complete && this.toolbarPosition === "top") {
	        var finalHeight = $preview_container[0].clientHeight;
	        // Offset scroll position to keep contents from moving around
	        var newScroll = Math.max(0, origScrollTop + (origHeight - finalHeight));
	        $preview_container.scrollTop(newScroll);
	        this.lastAutoScroll = newScroll < 0 ? newScroll : 0;
	      }
	    },

	    auto_save: function auto_save() {
	      try {
	        var defstr = JSON.stringify(this.report_def);
	        localStorage.setItem(this.auto_save_key, defstr);
	      } catch (e) {
	        if (console && console.warn) {
	          console.warn(e);
	        }
	      }
	    },

	    load_data_source_schemas: function load_data_source_schemas(dataSourceDefs) {
	      var me = this;
	      if (!this.data_source_schemas) {
	        this.data_source_schemas = {};
	      }
	      // Don't load actual data unless we might need to render the report
	      var schemasOnly = !this.showDownloadButton || this.jasperMode;
	      ditto.data.loadDatasets(dataSourceDefs, {}, this.data_source_schemas, schemasOnly, function () {
	        me.trigger("all_schemas_loaded");
	      });
	    },

	    /** 
	     * @private
	     * Called only once at first creation; does initial render and loads report def 
	     */
	    init: function init() {
	      var _this23 = this;

	      this.next_element_id = 0;
	      this.pending_timeouts = {};
	      this.elementToolbars = {};

	      this.elementTypes = {
	        text: { name: 'Text' },
	        chart: { name: 'Chart' },
	        image: { name: 'Picture' },
	        box: { name: 'Box' },
	        barcode: { name: 'Barcode' },
	        break: { name: 'Page Break' },
	        subreport: { name: 'Subreport' }
	      };

	      _.values(ditto.elements).concat(this.customElements).forEach(function (elementClass) {
	        if (typeof elementClass !== 'function') return;
	        var className = elementClass.name;
	        _this23.elementTypes[(elementClass.typeId || className).toLowerCase()] = {
	          name: elementClass.displayName || className,
	          handler: elementClass,
	          iconSrc: elementClass.iconSrc || unknownElementIcon
	        };
	      });

	      this.on("all_schemas_loaded", function () {
	        var $container;
	        if (this.embedded) {
	          $container = $(this.container);
	        } else {
	          $container = $('<div class="jsr-designer-container"></div>');
	          this.$body_mask = $('<div class="jsr-designer-mask"></div>');
	          $(document.body).append(this.$body_mask);
	          $(document.body).append($container);
	          $("body").addClass("jsr-designer-active");
	        }
	        var def = this.report_def;
	        delete this.report_def;
	        this.render($container[0]);
	        this.setReport(def);
	        if (!this.embedded) {
	          var $designer = $container.find(".ditto-designer");
	          $designer.addClass('before-fadein');
	          this.$body_mask.fadeIn();
	          this.$body_mask.css("opacity", "1");
	          $designer.removeClass('before-fadein');
	        }
	      }.bind(this));
	      this.load_data_source_schemas(this.data_sources);
	    },

	    /** 
	     * @public
	     * Change the active report definition in the designer.  Does not confirm; immediately overwrites any existing report in the designer.
	     */
	    setReport: function setReport(reportDef) {
	      var _this24 = this;

	      // fill in any required defaults that might be missing from the report def
	      this.auto_save_key = null;
	      this.report_def = reportDef;
	      this.reportStack = null;
	      if (this.report_def) {
	        this.auto_save_key = "jsr-temp-" + (this.report_def.id || "unsaved");
	        if (!this.report_def['page']) {
	          this.report_def['page'] = {};
	        }
	        if (!this.report_def['page']['units']) {
	          this.report_def['page']['units'] = "inches";
	        }
	        if (!this.report_def['page']['paper_size']) {
	          this.report_def['page']['paper_size'] = this.paper_sizes["letter"];
	          this.report_def['page']['paper_size'].id = "letter";
	        }
	        if (!this.report_def['page']['margins']) {
	          this.report_def['page']['margins'] = this.default_margins[this.report_def['page']['units']];
	        }
	        if (!this.report_def.filters) {
	          this.report_def.filters = [];
	        }
	        this.getAllSections(null, false).forEach(function (sec) {
	          _this24.fit_section(sec.def);
	        });
	        if (ditto.version_less_than(this.report_def.version, "1.2.9")) {
	          this.getAllSections(null, false).forEach(function (section) {
	            if (section.def.height) {
	              section.def.height *= PRE_1_2_9_Y_SCALE_FACTOR;
	            }
	          });
	          this.getAllElementDefs().forEach(function (elt) {
	            elt.top *= PRE_1_2_9_Y_SCALE_FACTOR;
	            elt.height *= PRE_1_2_9_Y_SCALE_FACTOR;
	          });
	        }
	      }
	      this.originalReportStr = this.getReportStrWithoutVersion(this.report_def);
	      if (this.designer_el) {
	        if (this.downloadButton) {
	          this.downloadButton.prop('disabled', !this.report_def);
	        }
	        this.designer_el.find(".save-button").prop('disabled', !this.report_def);
	        this.applyStylesheet(this.report_def.stylesheet);
	        this.renderContent();
	      }
	    },

	    /** 
	     * @public
	     * @returns {Object} The current active report definition object, possibly unsaved, possibly null if none loaded 
	     */
	    getReport: function getReport() {
	      if (this.report_def) {
	        this.report_def.version = this.version;
	      }
	      return this.report_def || null;
	    },

	    /** 
	     * @public
	     * @returns {Object} The current Jasper report definition object when in Jasper mode 
	     */
	    getJasperReport: function getJasperReport() {
	      return this.jasperDef || null;
	    },

	    applyStylesheet: function applyStylesheet(stylesheet) {
	      if (this.currentStylesheetDomEl) {
	        this.currentStylesheetDomEl.remove();
	      }
	      if (!stylesheet) return;
	      var style = document.createElement('style');
	      style.type = 'text/css';
	      document.getElementsByTagName('head')[0].appendChild(style);
	      Object.keys(stylesheet).forEach(function (name) {
	        var rules = stylesheet[name];
	        if (rules.length === 0) return;
	        var rulesText = rules.map(function (rule) {
	          return rule[0] + ': ' + rule[1] + ';';
	        }).join(' ');
	        if (!(style.sheet || {}).insertRule) {
	          (style.styleSheet || style.sheet).addRule('.' + name, rulesText);
	        } else {
	          style.sheet.insertRule('.' + name + ' { ' + rulesText + ' }', 0);
	        }
	      });
	      this.currentStylesheetDomEl = style;
	    },

	    on: function on(evtName, handler) {
	      var nameLower = String(evtName || '').toLowerCase();
	      if (!this.eventHandlers) {
	        this.eventHandlers = {};
	      }
	      var list = this.eventHandlers[nameLower];
	      if (!list) {
	        list = this.eventHandlers[nameLower] = [];
	      }
	      list.push(handler);
	    },

	    trigger: function trigger(evtName) {
	      var _this25 = this;

	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }

	      if (!this.eventHandlers) return;
	      var nameLower = String(evtName || '').toLowerCase();
	      var handlers = this.eventHandlers[nameLower];
	      if (handlers) {
	        handlers.map(function (handler) {
	          handler.apply(_this25, args);
	        });
	      }
	    }

	  };

	  $.extend(ditto.Designer.prototype, privateApi);
	};

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, module) {
	/*
	 *
	 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
	 *
	 * Copyright (c) 2012, Matias Meno
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 *
	 */

	(function() {
	  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
	    __slice = [].slice,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

	  noop = function() {};

	  Emitter = (function() {
	    function Emitter() {}

	    Emitter.prototype.addEventListener = Emitter.prototype.on;

	    Emitter.prototype.on = function(event, fn) {
	      this._callbacks = this._callbacks || {};
	      if (!this._callbacks[event]) {
	        this._callbacks[event] = [];
	      }
	      this._callbacks[event].push(fn);
	      return this;
	    };

	    Emitter.prototype.emit = function() {
	      var args, callback, callbacks, event, _i, _len;
	      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      this._callbacks = this._callbacks || {};
	      callbacks = this._callbacks[event];
	      if (callbacks) {
	        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
	          callback = callbacks[_i];
	          callback.apply(this, args);
	        }
	      }
	      return this;
	    };

	    Emitter.prototype.removeListener = Emitter.prototype.off;

	    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

	    Emitter.prototype.removeEventListener = Emitter.prototype.off;

	    Emitter.prototype.off = function(event, fn) {
	      var callback, callbacks, i, _i, _len;
	      if (!this._callbacks || arguments.length === 0) {
	        this._callbacks = {};
	        return this;
	      }
	      callbacks = this._callbacks[event];
	      if (!callbacks) {
	        return this;
	      }
	      if (arguments.length === 1) {
	        delete this._callbacks[event];
	        return this;
	      }
	      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
	        callback = callbacks[i];
	        if (callback === fn) {
	          callbacks.splice(i, 1);
	          break;
	        }
	      }
	      return this;
	    };

	    return Emitter;

	  })();

	  Dropzone = (function(_super) {
	    var extend, resolveOption;

	    __extends(Dropzone, _super);

	    Dropzone.prototype.Emitter = Emitter;


	    /*
	    This is a list of all available events you can register on a dropzone object.
	    
	    You can register an event handler like this:
	    
	        dropzone.on("dragEnter", function() { });
	     */

	    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

	    Dropzone.prototype.defaultOptions = {
	      url: null,
	      method: "post",
	      withCredentials: false,
	      parallelUploads: 2,
	      uploadMultiple: false,
	      maxFilesize: 256,
	      paramName: "file",
	      createImageThumbnails: true,
	      maxThumbnailFilesize: 10,
	      thumbnailWidth: 120,
	      thumbnailHeight: 120,
	      filesizeBase: 1000,
	      maxFiles: null,
	      params: {},
	      clickable: true,
	      ignoreHiddenFiles: true,
	      acceptedFiles: null,
	      acceptedMimeTypes: null,
	      autoProcessQueue: true,
	      autoQueue: true,
	      addRemoveLinks: false,
	      previewsContainer: null,
	      hiddenInputContainer: "body",
	      capture: null,
	      renameFilename: null,
	      dictDefaultMessage: "Drop files here to upload",
	      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
	      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
	      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
	      dictInvalidFileType: "You can't upload files of this type.",
	      dictResponseError: "Server responded with {{statusCode}} code.",
	      dictCancelUpload: "Cancel upload",
	      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
	      dictRemoveFile: "Remove file",
	      dictRemoveFileConfirmation: null,
	      dictMaxFilesExceeded: "You can not upload any more files.",
	      accept: function(file, done) {
	        return done();
	      },
	      init: function() {
	        return noop;
	      },
	      forceFallback: false,
	      fallback: function() {
	        var child, messageElement, span, _i, _len, _ref;
	        this.element.className = "" + this.element.className + " dz-browser-not-supported";
	        _ref = this.element.getElementsByTagName("div");
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          child = _ref[_i];
	          if (/(^| )dz-message($| )/.test(child.className)) {
	            messageElement = child;
	            child.className = "dz-message";
	            continue;
	          }
	        }
	        if (!messageElement) {
	          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
	          this.element.appendChild(messageElement);
	        }
	        span = messageElement.getElementsByTagName("span")[0];
	        if (span) {
	          if (span.textContent != null) {
	            span.textContent = this.options.dictFallbackMessage;
	          } else if (span.innerText != null) {
	            span.innerText = this.options.dictFallbackMessage;
	          }
	        }
	        return this.element.appendChild(this.getFallbackForm());
	      },
	      resize: function(file) {
	        var info, srcRatio, trgRatio;
	        info = {
	          srcX: 0,
	          srcY: 0,
	          srcWidth: file.width,
	          srcHeight: file.height
	        };
	        srcRatio = file.width / file.height;
	        info.optWidth = this.options.thumbnailWidth;
	        info.optHeight = this.options.thumbnailHeight;
	        if ((info.optWidth == null) && (info.optHeight == null)) {
	          info.optWidth = info.srcWidth;
	          info.optHeight = info.srcHeight;
	        } else if (info.optWidth == null) {
	          info.optWidth = srcRatio * info.optHeight;
	        } else if (info.optHeight == null) {
	          info.optHeight = (1 / srcRatio) * info.optWidth;
	        }
	        trgRatio = info.optWidth / info.optHeight;
	        if (file.height < info.optHeight || file.width < info.optWidth) {
	          info.trgHeight = info.srcHeight;
	          info.trgWidth = info.srcWidth;
	        } else {
	          if (srcRatio > trgRatio) {
	            info.srcHeight = file.height;
	            info.srcWidth = info.srcHeight * trgRatio;
	          } else {
	            info.srcWidth = file.width;
	            info.srcHeight = info.srcWidth / trgRatio;
	          }
	        }
	        info.srcX = (file.width - info.srcWidth) / 2;
	        info.srcY = (file.height - info.srcHeight) / 2;
	        return info;
	      },

	      /*
	      Those functions register themselves to the events on init and handle all
	      the user interface specific stuff. Overwriting them won't break the upload
	      but can break the way it's displayed.
	      You can overwrite them if you don't like the default behavior. If you just
	      want to add an additional event handler, register it on the dropzone object
	      and don't overwrite those options.
	       */
	      drop: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      dragstart: noop,
	      dragend: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      dragenter: function(e) {
	        return this.element.classList.add("dz-drag-hover");
	      },
	      dragover: function(e) {
	        return this.element.classList.add("dz-drag-hover");
	      },
	      dragleave: function(e) {
	        return this.element.classList.remove("dz-drag-hover");
	      },
	      paste: noop,
	      reset: function() {
	        return this.element.classList.remove("dz-started");
	      },
	      addedfile: function(file) {
	        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
	        if (this.element === this.previewsContainer) {
	          this.element.classList.add("dz-started");
	        }
	        if (this.previewsContainer) {
	          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
	          file.previewTemplate = file.previewElement;
	          this.previewsContainer.appendChild(file.previewElement);
	          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            node.textContent = this._renameFilename(file.name);
	          }
	          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
	          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
	            node = _ref1[_j];
	            node.innerHTML = this.filesize(file.size);
	          }
	          if (this.options.addRemoveLinks) {
	            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
	            file.previewElement.appendChild(file._removeLink);
	          }
	          removeFileEvent = (function(_this) {
	            return function(e) {
	              e.preventDefault();
	              e.stopPropagation();
	              if (file.status === Dropzone.UPLOADING) {
	                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
	                  return _this.removeFile(file);
	                });
	              } else {
	                if (_this.options.dictRemoveFileConfirmation) {
	                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
	                    return _this.removeFile(file);
	                  });
	                } else {
	                  return _this.removeFile(file);
	                }
	              }
	            };
	          })(this);
	          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
	          _results = [];
	          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
	            removeLink = _ref2[_k];
	            _results.push(removeLink.addEventListener("click", removeFileEvent));
	          }
	          return _results;
	        }
	      },
	      removedfile: function(file) {
	        var _ref;
	        if (file.previewElement) {
	          if ((_ref = file.previewElement) != null) {
	            _ref.parentNode.removeChild(file.previewElement);
	          }
	        }
	        return this._updateMaxFilesReachedClass();
	      },
	      thumbnail: function(file, dataUrl) {
	        var thumbnailElement, _i, _len, _ref;
	        if (file.previewElement) {
	          file.previewElement.classList.remove("dz-file-preview");
	          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            thumbnailElement = _ref[_i];
	            thumbnailElement.alt = file.name;
	            thumbnailElement.src = dataUrl;
	          }
	          return setTimeout(((function(_this) {
	            return function() {
	              return file.previewElement.classList.add("dz-image-preview");
	            };
	          })(this)), 1);
	        }
	      },
	      error: function(file, message) {
	        var node, _i, _len, _ref, _results;
	        if (file.previewElement) {
	          file.previewElement.classList.add("dz-error");
	          if (typeof message !== "String" && message.error) {
	            message = message.error;
	          }
	          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
	          _results = [];
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            _results.push(node.textContent = message);
	          }
	          return _results;
	        }
	      },
	      errormultiple: noop,
	      processing: function(file) {
	        if (file.previewElement) {
	          file.previewElement.classList.add("dz-processing");
	          if (file._removeLink) {
	            return file._removeLink.textContent = this.options.dictCancelUpload;
	          }
	        }
	      },
	      processingmultiple: noop,
	      uploadprogress: function(file, progress, bytesSent) {
	        var node, _i, _len, _ref, _results;
	        if (file.previewElement) {
	          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
	          _results = [];
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            node = _ref[_i];
	            if (node.nodeName === 'PROGRESS') {
	              _results.push(node.value = progress);
	            } else {
	              _results.push(node.style.width = "" + progress + "%");
	            }
	          }
	          return _results;
	        }
	      },
	      totaluploadprogress: noop,
	      sending: noop,
	      sendingmultiple: noop,
	      success: function(file) {
	        if (file.previewElement) {
	          return file.previewElement.classList.add("dz-success");
	        }
	      },
	      successmultiple: noop,
	      canceled: function(file) {
	        return this.emit("error", file, "Upload canceled.");
	      },
	      canceledmultiple: noop,
	      complete: function(file) {
	        if (file._removeLink) {
	          file._removeLink.textContent = this.options.dictRemoveFile;
	        }
	        if (file.previewElement) {
	          return file.previewElement.classList.add("dz-complete");
	        }
	      },
	      completemultiple: noop,
	      maxfilesexceeded: noop,
	      maxfilesreached: noop,
	      queuecomplete: noop,
	      addedfiles: noop,
	      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
	    };

	    extend = function() {
	      var key, object, objects, target, val, _i, _len;
	      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      for (_i = 0, _len = objects.length; _i < _len; _i++) {
	        object = objects[_i];
	        for (key in object) {
	          val = object[key];
	          target[key] = val;
	        }
	      }
	      return target;
	    };

	    function Dropzone(element, options) {
	      var elementOptions, fallback, _ref;
	      this.element = element;
	      this.version = Dropzone.version;
	      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
	      this.clickableElements = [];
	      this.listeners = [];
	      this.files = [];
	      if (typeof this.element === "string") {
	        this.element = document.querySelector(this.element);
	      }
	      if (!(this.element && (this.element.nodeType != null))) {
	        throw new Error("Invalid dropzone element.");
	      }
	      if (this.element.dropzone) {
	        throw new Error("Dropzone already attached.");
	      }
	      Dropzone.instances.push(this);
	      this.element.dropzone = this;
	      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
	      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
	      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
	        return this.options.fallback.call(this);
	      }
	      if (this.options.url == null) {
	        this.options.url = this.element.getAttribute("action");
	      }
	      if (!this.options.url) {
	        throw new Error("No URL provided.");
	      }
	      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
	        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
	      }
	      if (this.options.acceptedMimeTypes) {
	        this.options.acceptedFiles = this.options.acceptedMimeTypes;
	        delete this.options.acceptedMimeTypes;
	      }
	      this.options.method = this.options.method.toUpperCase();
	      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
	        fallback.parentNode.removeChild(fallback);
	      }
	      if (this.options.previewsContainer !== false) {
	        if (this.options.previewsContainer) {
	          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
	        } else {
	          this.previewsContainer = this.element;
	        }
	      }
	      if (this.options.clickable) {
	        if (this.options.clickable === true) {
	          this.clickableElements = [this.element];
	        } else {
	          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
	        }
	      }
	      this.init();
	    }

	    Dropzone.prototype.getAcceptedFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.accepted) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };

	    Dropzone.prototype.getRejectedFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (!file.accepted) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };

	    Dropzone.prototype.getFilesWithStatus = function(status) {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status === status) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };

	    Dropzone.prototype.getQueuedFiles = function() {
	      return this.getFilesWithStatus(Dropzone.QUEUED);
	    };

	    Dropzone.prototype.getUploadingFiles = function() {
	      return this.getFilesWithStatus(Dropzone.UPLOADING);
	    };

	    Dropzone.prototype.getAddedFiles = function() {
	      return this.getFilesWithStatus(Dropzone.ADDED);
	    };

	    Dropzone.prototype.getActiveFiles = function() {
	      var file, _i, _len, _ref, _results;
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
	          _results.push(file);
	        }
	      }
	      return _results;
	    };

	    Dropzone.prototype.init = function() {
	      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
	      if (this.element.tagName === "form") {
	        this.element.setAttribute("enctype", "multipart/form-data");
	      }
	      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
	        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
	      }
	      if (this.clickableElements.length) {
	        setupHiddenFileInput = (function(_this) {
	          return function() {
	            if (_this.hiddenFileInput) {
	              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
	            }
	            _this.hiddenFileInput = document.createElement("input");
	            _this.hiddenFileInput.setAttribute("type", "file");
	            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
	              _this.hiddenFileInput.setAttribute("multiple", "multiple");
	            }
	            _this.hiddenFileInput.className = "dz-hidden-input";
	            if (_this.options.acceptedFiles != null) {
	              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
	            }
	            if (_this.options.capture != null) {
	              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
	            }
	            _this.hiddenFileInput.style.visibility = "hidden";
	            _this.hiddenFileInput.style.position = "absolute";
	            _this.hiddenFileInput.style.top = "0";
	            _this.hiddenFileInput.style.left = "0";
	            _this.hiddenFileInput.style.height = "0";
	            _this.hiddenFileInput.style.width = "0";
	            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
	            return _this.hiddenFileInput.addEventListener("change", function() {
	              var file, files, _i, _len;
	              files = _this.hiddenFileInput.files;
	              if (files.length) {
	                for (_i = 0, _len = files.length; _i < _len; _i++) {
	                  file = files[_i];
	                  _this.addFile(file);
	                }
	              }
	              _this.emit("addedfiles", files);
	              return setupHiddenFileInput();
	            });
	          };
	        })(this);
	        setupHiddenFileInput();
	      }
	      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
	      _ref1 = this.events;
	      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	        eventName = _ref1[_i];
	        this.on(eventName, this.options[eventName]);
	      }
	      this.on("uploadprogress", (function(_this) {
	        return function() {
	          return _this.updateTotalUploadProgress();
	        };
	      })(this));
	      this.on("removedfile", (function(_this) {
	        return function() {
	          return _this.updateTotalUploadProgress();
	        };
	      })(this));
	      this.on("canceled", (function(_this) {
	        return function(file) {
	          return _this.emit("complete", file);
	        };
	      })(this));
	      this.on("complete", (function(_this) {
	        return function(file) {
	          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
	            return setTimeout((function() {
	              return _this.emit("queuecomplete");
	            }), 0);
	          }
	        };
	      })(this));
	      noPropagation = function(e) {
	        e.stopPropagation();
	        if (e.preventDefault) {
	          return e.preventDefault();
	        } else {
	          return e.returnValue = false;
	        }
	      };
	      this.listeners = [
	        {
	          element: this.element,
	          events: {
	            "dragstart": (function(_this) {
	              return function(e) {
	                return _this.emit("dragstart", e);
	              };
	            })(this),
	            "dragenter": (function(_this) {
	              return function(e) {
	                noPropagation(e);
	                return _this.emit("dragenter", e);
	              };
	            })(this),
	            "dragover": (function(_this) {
	              return function(e) {
	                var efct;
	                try {
	                  efct = e.dataTransfer.effectAllowed;
	                } catch (_error) {}
	                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
	                noPropagation(e);
	                return _this.emit("dragover", e);
	              };
	            })(this),
	            "dragleave": (function(_this) {
	              return function(e) {
	                return _this.emit("dragleave", e);
	              };
	            })(this),
	            "drop": (function(_this) {
	              return function(e) {
	                noPropagation(e);
	                return _this.drop(e);
	              };
	            })(this),
	            "dragend": (function(_this) {
	              return function(e) {
	                return _this.emit("dragend", e);
	              };
	            })(this)
	          }
	        }
	      ];
	      this.clickableElements.forEach((function(_this) {
	        return function(clickableElement) {
	          return _this.listeners.push({
	            element: clickableElement,
	            events: {
	              "click": function(evt) {
	                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
	                  _this.hiddenFileInput.click();
	                }
	                return true;
	              }
	            }
	          });
	        };
	      })(this));
	      this.enable();
	      return this.options.init.call(this);
	    };

	    Dropzone.prototype.destroy = function() {
	      var _ref;
	      this.disable();
	      this.removeAllFiles(true);
	      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
	        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
	        this.hiddenFileInput = null;
	      }
	      delete this.element.dropzone;
	      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
	    };

	    Dropzone.prototype.updateTotalUploadProgress = function() {
	      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
	      totalBytesSent = 0;
	      totalBytes = 0;
	      activeFiles = this.getActiveFiles();
	      if (activeFiles.length) {
	        _ref = this.getActiveFiles();
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          file = _ref[_i];
	          totalBytesSent += file.upload.bytesSent;
	          totalBytes += file.upload.total;
	        }
	        totalUploadProgress = 100 * totalBytesSent / totalBytes;
	      } else {
	        totalUploadProgress = 100;
	      }
	      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
	    };

	    Dropzone.prototype._getParamName = function(n) {
	      if (typeof this.options.paramName === "function") {
	        return this.options.paramName(n);
	      } else {
	        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
	      }
	    };

	    Dropzone.prototype._renameFilename = function(name) {
	      if (typeof this.options.renameFilename !== "function") {
	        return name;
	      }
	      return this.options.renameFilename(name);
	    };

	    Dropzone.prototype.getFallbackForm = function() {
	      var existingFallback, fields, fieldsString, form;
	      if (existingFallback = this.getExistingFallback()) {
	        return existingFallback;
	      }
	      fieldsString = "<div class=\"dz-fallback\">";
	      if (this.options.dictFallbackText) {
	        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
	      }
	      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
	      fields = Dropzone.createElement(fieldsString);
	      if (this.element.tagName !== "FORM") {
	        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
	        form.appendChild(fields);
	      } else {
	        this.element.setAttribute("enctype", "multipart/form-data");
	        this.element.setAttribute("method", this.options.method);
	      }
	      return form != null ? form : fields;
	    };

	    Dropzone.prototype.getExistingFallback = function() {
	      var fallback, getFallback, tagName, _i, _len, _ref;
	      getFallback = function(elements) {
	        var el, _i, _len;
	        for (_i = 0, _len = elements.length; _i < _len; _i++) {
	          el = elements[_i];
	          if (/(^| )fallback($| )/.test(el.className)) {
	            return el;
	          }
	        }
	      };
	      _ref = ["div", "form"];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        tagName = _ref[_i];
	        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
	          return fallback;
	        }
	      }
	    };

	    Dropzone.prototype.setupEventListeners = function() {
	      var elementListeners, event, listener, _i, _len, _ref, _results;
	      _ref = this.listeners;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        elementListeners = _ref[_i];
	        _results.push((function() {
	          var _ref1, _results1;
	          _ref1 = elementListeners.events;
	          _results1 = [];
	          for (event in _ref1) {
	            listener = _ref1[event];
	            _results1.push(elementListeners.element.addEventListener(event, listener, false));
	          }
	          return _results1;
	        })());
	      }
	      return _results;
	    };

	    Dropzone.prototype.removeEventListeners = function() {
	      var elementListeners, event, listener, _i, _len, _ref, _results;
	      _ref = this.listeners;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        elementListeners = _ref[_i];
	        _results.push((function() {
	          var _ref1, _results1;
	          _ref1 = elementListeners.events;
	          _results1 = [];
	          for (event in _ref1) {
	            listener = _ref1[event];
	            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
	          }
	          return _results1;
	        })());
	      }
	      return _results;
	    };

	    Dropzone.prototype.disable = function() {
	      var file, _i, _len, _ref, _results;
	      this.clickableElements.forEach(function(element) {
	        return element.classList.remove("dz-clickable");
	      });
	      this.removeEventListeners();
	      _ref = this.files;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        _results.push(this.cancelUpload(file));
	      }
	      return _results;
	    };

	    Dropzone.prototype.enable = function() {
	      this.clickableElements.forEach(function(element) {
	        return element.classList.add("dz-clickable");
	      });
	      return this.setupEventListeners();
	    };

	    Dropzone.prototype.filesize = function(size) {
	      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
	      selectedSize = 0;
	      selectedUnit = "b";
	      if (size > 0) {
	        units = ['TB', 'GB', 'MB', 'KB', 'b'];
	        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
	          unit = units[i];
	          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
	          if (size >= cutoff) {
	            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
	            selectedUnit = unit;
	            break;
	          }
	        }
	        selectedSize = Math.round(10 * selectedSize) / 10;
	      }
	      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
	    };

	    Dropzone.prototype._updateMaxFilesReachedClass = function() {
	      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        if (this.getAcceptedFiles().length === this.options.maxFiles) {
	          this.emit('maxfilesreached', this.files);
	        }
	        return this.element.classList.add("dz-max-files-reached");
	      } else {
	        return this.element.classList.remove("dz-max-files-reached");
	      }
	    };

	    Dropzone.prototype.drop = function(e) {
	      var files, items;
	      if (!e.dataTransfer) {
	        return;
	      }
	      this.emit("drop", e);
	      files = e.dataTransfer.files;
	      this.emit("addedfiles", files);
	      if (files.length) {
	        items = e.dataTransfer.items;
	        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
	          this._addFilesFromItems(items);
	        } else {
	          this.handleFiles(files);
	        }
	      }
	    };

	    Dropzone.prototype.paste = function(e) {
	      var items, _ref;
	      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
	        return;
	      }
	      this.emit("paste", e);
	      items = e.clipboardData.items;
	      if (items.length) {
	        return this._addFilesFromItems(items);
	      }
	    };

	    Dropzone.prototype.handleFiles = function(files) {
	      var file, _i, _len, _results;
	      _results = [];
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        _results.push(this.addFile(file));
	      }
	      return _results;
	    };

	    Dropzone.prototype._addFilesFromItems = function(items) {
	      var entry, item, _i, _len, _results;
	      _results = [];
	      for (_i = 0, _len = items.length; _i < _len; _i++) {
	        item = items[_i];
	        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
	          if (entry.isFile) {
	            _results.push(this.addFile(item.getAsFile()));
	          } else if (entry.isDirectory) {
	            _results.push(this._addFilesFromDirectory(entry, entry.name));
	          } else {
	            _results.push(void 0);
	          }
	        } else if (item.getAsFile != null) {
	          if ((item.kind == null) || item.kind === "file") {
	            _results.push(this.addFile(item.getAsFile()));
	          } else {
	            _results.push(void 0);
	          }
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };

	    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
	      var dirReader, errorHandler, readEntries;
	      dirReader = directory.createReader();
	      errorHandler = function(error) {
	        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
	      };
	      readEntries = (function(_this) {
	        return function() {
	          return dirReader.readEntries(function(entries) {
	            var entry, _i, _len;
	            if (entries.length > 0) {
	              for (_i = 0, _len = entries.length; _i < _len; _i++) {
	                entry = entries[_i];
	                if (entry.isFile) {
	                  entry.file(function(file) {
	                    if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
	                      return;
	                    }
	                    file.fullPath = "" + path + "/" + file.name;
	                    return _this.addFile(file);
	                  });
	                } else if (entry.isDirectory) {
	                  _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
	                }
	              }
	              readEntries();
	            }
	            return null;
	          }, errorHandler);
	        };
	      })(this);
	      return readEntries();
	    };

	    Dropzone.prototype.accept = function(file, done) {
	      if (file.size > this.options.maxFilesize * 1024 * 1024) {
	        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
	      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
	        return done(this.options.dictInvalidFileType);
	      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
	        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
	        return this.emit("maxfilesexceeded", file);
	      } else {
	        return this.options.accept.call(this, file, done);
	      }
	    };

	    Dropzone.prototype.addFile = function(file) {
	      file.upload = {
	        progress: 0,
	        total: file.size,
	        bytesSent: 0
	      };
	      this.files.push(file);
	      file.status = Dropzone.ADDED;
	      this.emit("addedfile", file);
	      this._enqueueThumbnail(file);
	      return this.accept(file, (function(_this) {
	        return function(error) {
	          if (error) {
	            file.accepted = false;
	            _this._errorProcessing([file], error);
	          } else {
	            file.accepted = true;
	            if (_this.options.autoQueue) {
	              _this.enqueueFile(file);
	            }
	          }
	          return _this._updateMaxFilesReachedClass();
	        };
	      })(this));
	    };

	    Dropzone.prototype.enqueueFiles = function(files) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        this.enqueueFile(file);
	      }
	      return null;
	    };

	    Dropzone.prototype.enqueueFile = function(file) {
	      if (file.status === Dropzone.ADDED && file.accepted === true) {
	        file.status = Dropzone.QUEUED;
	        if (this.options.autoProcessQueue) {
	          return setTimeout(((function(_this) {
	            return function() {
	              return _this.processQueue();
	            };
	          })(this)), 0);
	        }
	      } else {
	        throw new Error("This file can't be queued because it has already been processed or was rejected.");
	      }
	    };

	    Dropzone.prototype._thumbnailQueue = [];

	    Dropzone.prototype._processingThumbnail = false;

	    Dropzone.prototype._enqueueThumbnail = function(file) {
	      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
	        this._thumbnailQueue.push(file);
	        return setTimeout(((function(_this) {
	          return function() {
	            return _this._processThumbnailQueue();
	          };
	        })(this)), 0);
	      }
	    };

	    Dropzone.prototype._processThumbnailQueue = function() {
	      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
	        return;
	      }
	      this._processingThumbnail = true;
	      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
	        return function() {
	          _this._processingThumbnail = false;
	          return _this._processThumbnailQueue();
	        };
	      })(this));
	    };

	    Dropzone.prototype.removeFile = function(file) {
	      if (file.status === Dropzone.UPLOADING) {
	        this.cancelUpload(file);
	      }
	      this.files = without(this.files, file);
	      this.emit("removedfile", file);
	      if (this.files.length === 0) {
	        return this.emit("reset");
	      }
	    };

	    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
	      var file, _i, _len, _ref;
	      if (cancelIfNecessary == null) {
	        cancelIfNecessary = false;
	      }
	      _ref = this.files.slice();
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        file = _ref[_i];
	        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
	          this.removeFile(file);
	        }
	      }
	      return null;
	    };

	    Dropzone.prototype.createThumbnail = function(file, callback) {
	      var fileReader;
	      fileReader = new FileReader;
	      fileReader.onload = (function(_this) {
	        return function() {
	          if (file.type === "image/svg+xml") {
	            _this.emit("thumbnail", file, fileReader.result);
	            if (callback != null) {
	              callback();
	            }
	            return;
	          }
	          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
	        };
	      })(this);
	      return fileReader.readAsDataURL(file);
	    };

	    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
	      var img;
	      img = document.createElement("img");
	      if (crossOrigin) {
	        img.crossOrigin = crossOrigin;
	      }
	      img.onload = (function(_this) {
	        return function() {
	          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
	          file.width = img.width;
	          file.height = img.height;
	          resizeInfo = _this.options.resize.call(_this, file);
	          if (resizeInfo.trgWidth == null) {
	            resizeInfo.trgWidth = resizeInfo.optWidth;
	          }
	          if (resizeInfo.trgHeight == null) {
	            resizeInfo.trgHeight = resizeInfo.optHeight;
	          }
	          canvas = document.createElement("canvas");
	          ctx = canvas.getContext("2d");
	          canvas.width = resizeInfo.trgWidth;
	          canvas.height = resizeInfo.trgHeight;
	          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
	          thumbnail = canvas.toDataURL("image/png");
	          _this.emit("thumbnail", file, thumbnail);
	          if (callback != null) {
	            return callback();
	          }
	        };
	      })(this);
	      if (callback != null) {
	        img.onerror = callback;
	      }
	      return img.src = imageUrl;
	    };

	    Dropzone.prototype.processQueue = function() {
	      var i, parallelUploads, processingLength, queuedFiles;
	      parallelUploads = this.options.parallelUploads;
	      processingLength = this.getUploadingFiles().length;
	      i = processingLength;
	      if (processingLength >= parallelUploads) {
	        return;
	      }
	      queuedFiles = this.getQueuedFiles();
	      if (!(queuedFiles.length > 0)) {
	        return;
	      }
	      if (this.options.uploadMultiple) {
	        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
	      } else {
	        while (i < parallelUploads) {
	          if (!queuedFiles.length) {
	            return;
	          }
	          this.processFile(queuedFiles.shift());
	          i++;
	        }
	      }
	    };

	    Dropzone.prototype.processFile = function(file) {
	      return this.processFiles([file]);
	    };

	    Dropzone.prototype.processFiles = function(files) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.processing = true;
	        file.status = Dropzone.UPLOADING;
	        this.emit("processing", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("processingmultiple", files);
	      }
	      return this.uploadFiles(files);
	    };

	    Dropzone.prototype._getFilesWithXhr = function(xhr) {
	      var file, files;
	      return files = (function() {
	        var _i, _len, _ref, _results;
	        _ref = this.files;
	        _results = [];
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          file = _ref[_i];
	          if (file.xhr === xhr) {
	            _results.push(file);
	          }
	        }
	        return _results;
	      }).call(this);
	    };

	    Dropzone.prototype.cancelUpload = function(file) {
	      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
	      if (file.status === Dropzone.UPLOADING) {
	        groupedFiles = this._getFilesWithXhr(file.xhr);
	        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
	          groupedFile = groupedFiles[_i];
	          groupedFile.status = Dropzone.CANCELED;
	        }
	        file.xhr.abort();
	        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
	          groupedFile = groupedFiles[_j];
	          this.emit("canceled", groupedFile);
	        }
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", groupedFiles);
	        }
	      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
	        file.status = Dropzone.CANCELED;
	        this.emit("canceled", file);
	        if (this.options.uploadMultiple) {
	          this.emit("canceledmultiple", [file]);
	        }
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };

	    resolveOption = function() {
	      var args, option;
	      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      if (typeof option === 'function') {
	        return option.apply(this, args);
	      }
	      return option;
	    };

	    Dropzone.prototype.uploadFile = function(file) {
	      return this.uploadFiles([file]);
	    };

	    Dropzone.prototype.uploadFiles = function(files) {
	      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
	      xhr = new XMLHttpRequest();
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.xhr = xhr;
	      }
	      method = resolveOption(this.options.method, files);
	      url = resolveOption(this.options.url, files);
	      xhr.open(method, url, true);
	      xhr.withCredentials = !!this.options.withCredentials;
	      response = null;
	      handleError = (function(_this) {
	        return function() {
	          var _j, _len1, _results;
	          _results = [];
	          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	            file = files[_j];
	            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
	          }
	          return _results;
	        };
	      })(this);
	      updateProgress = (function(_this) {
	        return function(e) {
	          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
	          if (e != null) {
	            progress = 100 * e.loaded / e.total;
	            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	              file = files[_j];
	              file.upload = {
	                progress: progress,
	                total: e.total,
	                bytesSent: e.loaded
	              };
	            }
	          } else {
	            allFilesFinished = true;
	            progress = 100;
	            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
	              file = files[_k];
	              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
	                allFilesFinished = false;
	              }
	              file.upload.progress = progress;
	              file.upload.bytesSent = file.upload.total;
	            }
	            if (allFilesFinished) {
	              return;
	            }
	          }
	          _results = [];
	          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
	            file = files[_l];
	            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
	          }
	          return _results;
	        };
	      })(this);
	      xhr.onload = (function(_this) {
	        return function(e) {
	          var _ref;
	          if (files[0].status === Dropzone.CANCELED) {
	            return;
	          }
	          if (xhr.readyState !== 4) {
	            return;
	          }
	          response = xhr.responseText;
	          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
	            try {
	              response = JSON.parse(response);
	            } catch (_error) {
	              e = _error;
	              response = "Invalid JSON response from server.";
	            }
	          }
	          updateProgress();
	          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
	            return handleError();
	          } else {
	            return _this._finished(files, response, e);
	          }
	        };
	      })(this);
	      xhr.onerror = (function(_this) {
	        return function() {
	          if (files[0].status === Dropzone.CANCELED) {
	            return;
	          }
	          return handleError();
	        };
	      })(this);
	      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
	      progressObj.onprogress = updateProgress;
	      headers = {
	        "Accept": "application/json",
	        "Cache-Control": "no-cache",
	        "X-Requested-With": "XMLHttpRequest"
	      };
	      if (this.options.headers) {
	        extend(headers, this.options.headers);
	      }
	      for (headerName in headers) {
	        headerValue = headers[headerName];
	        if (headerValue) {
	          xhr.setRequestHeader(headerName, headerValue);
	        }
	      }
	      formData = new FormData();
	      if (this.options.params) {
	        _ref1 = this.options.params;
	        for (key in _ref1) {
	          value = _ref1[key];
	          formData.append(key, value);
	        }
	      }
	      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
	        file = files[_j];
	        this.emit("sending", file, xhr, formData);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("sendingmultiple", files, xhr, formData);
	      }
	      if (this.element.tagName === "FORM") {
	        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
	        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
	          input = _ref2[_k];
	          inputName = input.getAttribute("name");
	          inputType = input.getAttribute("type");
	          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
	            _ref3 = input.options;
	            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
	              option = _ref3[_l];
	              if (option.selected) {
	                formData.append(inputName, option.value);
	              }
	            }
	          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
	            formData.append(inputName, input.value);
	          }
	        }
	      }
	      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
	        formData.append(this._getParamName(i), files[i], this._renameFilename(files[i].name));
	      }
	      return this.submitRequest(xhr, formData, files);
	    };

	    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
	      return xhr.send(formData);
	    };

	    Dropzone.prototype._finished = function(files, responseText, e) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.status = Dropzone.SUCCESS;
	        this.emit("success", file, responseText, e);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("successmultiple", files, responseText, e);
	        this.emit("completemultiple", files);
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };

	    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
	      var file, _i, _len;
	      for (_i = 0, _len = files.length; _i < _len; _i++) {
	        file = files[_i];
	        file.status = Dropzone.ERROR;
	        this.emit("error", file, message, xhr);
	        this.emit("complete", file);
	      }
	      if (this.options.uploadMultiple) {
	        this.emit("errormultiple", files, message, xhr);
	        this.emit("completemultiple", files);
	      }
	      if (this.options.autoProcessQueue) {
	        return this.processQueue();
	      }
	    };

	    return Dropzone;

	  })(Emitter);

	  Dropzone.version = "4.3.0";

	  Dropzone.options = {};

	  Dropzone.optionsForElement = function(element) {
	    if (element.getAttribute("id")) {
	      return Dropzone.options[camelize(element.getAttribute("id"))];
	    } else {
	      return void 0;
	    }
	  };

	  Dropzone.instances = [];

	  Dropzone.forElement = function(element) {
	    if (typeof element === "string") {
	      element = document.querySelector(element);
	    }
	    if ((element != null ? element.dropzone : void 0) == null) {
	      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
	    }
	    return element.dropzone;
	  };

	  Dropzone.autoDiscover = true;

	  Dropzone.discover = function() {
	    var checkElements, dropzone, dropzones, _i, _len, _results;
	    if (document.querySelectorAll) {
	      dropzones = document.querySelectorAll(".dropzone");
	    } else {
	      dropzones = [];
	      checkElements = function(elements) {
	        var el, _i, _len, _results;
	        _results = [];
	        for (_i = 0, _len = elements.length; _i < _len; _i++) {
	          el = elements[_i];
	          if (/(^| )dropzone($| )/.test(el.className)) {
	            _results.push(dropzones.push(el));
	          } else {
	            _results.push(void 0);
	          }
	        }
	        return _results;
	      };
	      checkElements(document.getElementsByTagName("div"));
	      checkElements(document.getElementsByTagName("form"));
	    }
	    _results = [];
	    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
	      dropzone = dropzones[_i];
	      if (Dropzone.optionsForElement(dropzone) !== false) {
	        _results.push(new Dropzone(dropzone));
	      } else {
	        _results.push(void 0);
	      }
	    }
	    return _results;
	  };

	  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

	  Dropzone.isBrowserSupported = function() {
	    var capableBrowser, regex, _i, _len, _ref;
	    capableBrowser = true;
	    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
	      if (!("classList" in document.createElement("a"))) {
	        capableBrowser = false;
	      } else {
	        _ref = Dropzone.blacklistedBrowsers;
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          regex = _ref[_i];
	          if (regex.test(navigator.userAgent)) {
	            capableBrowser = false;
	            continue;
	          }
	        }
	      }
	    } else {
	      capableBrowser = false;
	    }
	    return capableBrowser;
	  };

	  without = function(list, rejectedItem) {
	    var item, _i, _len, _results;
	    _results = [];
	    for (_i = 0, _len = list.length; _i < _len; _i++) {
	      item = list[_i];
	      if (item !== rejectedItem) {
	        _results.push(item);
	      }
	    }
	    return _results;
	  };

	  camelize = function(str) {
	    return str.replace(/[\-_](\w)/g, function(match) {
	      return match.charAt(1).toUpperCase();
	    });
	  };

	  Dropzone.createElement = function(string) {
	    var div;
	    div = document.createElement("div");
	    div.innerHTML = string;
	    return div.childNodes[0];
	  };

	  Dropzone.elementInside = function(element, container) {
	    if (element === container) {
	      return true;
	    }
	    while (element = element.parentNode) {
	      if (element === container) {
	        return true;
	      }
	    }
	    return false;
	  };

	  Dropzone.getElement = function(el, name) {
	    var element;
	    if (typeof el === "string") {
	      element = document.querySelector(el);
	    } else if (el.nodeType != null) {
	      element = el;
	    }
	    if (element == null) {
	      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
	    }
	    return element;
	  };

	  Dropzone.getElements = function(els, name) {
	    var e, el, elements, _i, _j, _len, _len1, _ref;
	    if (els instanceof Array) {
	      elements = [];
	      try {
	        for (_i = 0, _len = els.length; _i < _len; _i++) {
	          el = els[_i];
	          elements.push(this.getElement(el, name));
	        }
	      } catch (_error) {
	        e = _error;
	        elements = null;
	      }
	    } else if (typeof els === "string") {
	      elements = [];
	      _ref = document.querySelectorAll(els);
	      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
	        el = _ref[_j];
	        elements.push(el);
	      }
	    } else if (els.nodeType != null) {
	      elements = [els];
	    }
	    if (!((elements != null) && elements.length)) {
	      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
	    }
	    return elements;
	  };

	  Dropzone.confirm = function(question, accepted, rejected) {
	    if (window.confirm(question)) {
	      return accepted();
	    } else if (rejected != null) {
	      return rejected();
	    }
	  };

	  Dropzone.isValidFile = function(file, acceptedFiles) {
	    var baseMimeType, mimeType, validType, _i, _len;
	    if (!acceptedFiles) {
	      return true;
	    }
	    acceptedFiles = acceptedFiles.split(",");
	    mimeType = file.type;
	    baseMimeType = mimeType.replace(/\/.*$/, "");
	    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
	      validType = acceptedFiles[_i];
	      validType = validType.trim();
	      if (validType.charAt(0) === ".") {
	        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
	          return true;
	        }
	      } else if (/\/\*$/.test(validType)) {
	        if (baseMimeType === validType.replace(/\/.*$/, "")) {
	          return true;
	        }
	      } else {
	        if (mimeType === validType) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };

	  if (typeof jQuery !== "undefined" && jQuery !== null) {
	    jQuery.fn.dropzone = function(options) {
	      return this.each(function() {
	        return new Dropzone(this, options);
	      });
	    };
	  }

	  if (typeof module !== "undefined" && module !== null) {
	    module.exports = Dropzone;
	  } else {
	    window.Dropzone = Dropzone;
	  }

	  Dropzone.ADDED = "added";

	  Dropzone.QUEUED = "queued";

	  Dropzone.ACCEPTED = Dropzone.QUEUED;

	  Dropzone.UPLOADING = "uploading";

	  Dropzone.PROCESSING = Dropzone.UPLOADING;

	  Dropzone.CANCELED = "canceled";

	  Dropzone.ERROR = "error";

	  Dropzone.SUCCESS = "success";


	  /*
	  
	  Bugfix for iOS 6 and 7
	  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
	  based on the work of https://github.com/stomita/ios-imagefile-megapixel
	   */

	  detectVerticalSquash = function(img) {
	    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
	    iw = img.naturalWidth;
	    ih = img.naturalHeight;
	    canvas = document.createElement("canvas");
	    canvas.width = 1;
	    canvas.height = ih;
	    ctx = canvas.getContext("2d");
	    ctx.drawImage(img, 0, 0);
	    data = ctx.getImageData(0, 0, 1, ih).data;
	    sy = 0;
	    ey = ih;
	    py = ih;
	    while (py > sy) {
	      alpha = data[(py - 1) * 4 + 3];
	      if (alpha === 0) {
	        ey = py;
	      } else {
	        sy = py;
	      }
	      py = (ey + sy) >> 1;
	    }
	    ratio = py / ih;
	    if (ratio === 0) {
	      return 1;
	    } else {
	      return ratio;
	    }
	  };

	  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
	    var vertSquashRatio;
	    vertSquashRatio = detectVerticalSquash(img);
	    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
	  };


	  /*
	   * contentloaded.js
	   *
	   * Author: Diego Perini (diego.perini at gmail.com)
	   * Summary: cross-browser wrapper for DOMContentLoaded
	   * Updated: 20101020
	   * License: MIT
	   * Version: 1.2
	   *
	   * URL:
	   * http://javascript.nwbox.com/ContentLoaded/
	   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
	   */

	  contentLoaded = function(win, fn) {
	    var add, doc, done, init, poll, pre, rem, root, top;
	    done = false;
	    top = true;
	    doc = win.document;
	    root = doc.documentElement;
	    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
	    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
	    pre = (doc.addEventListener ? "" : "on");
	    init = function(e) {
	      if (e.type === "readystatechange" && doc.readyState !== "complete") {
	        return;
	      }
	      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
	      if (!done && (done = true)) {
	        return fn.call(win, e.type || e);
	      }
	    };
	    poll = function() {
	      var e;
	      try {
	        root.doScroll("left");
	      } catch (_error) {
	        e = _error;
	        setTimeout(poll, 50);
	        return;
	      }
	      return init("poll");
	    };
	    if (doc.readyState !== "complete") {
	      if (doc.createEventObject && root.doScroll) {
	        try {
	          top = !win.frameElement;
	        } catch (_error) {}
	        if (top) {
	          poll();
	        }
	      }
	      doc[add](pre + "DOMContentLoaded", init, false);
	      doc[add](pre + "readystatechange", init, false);
	      return win[add](pre + "load", init, false);
	    }
	  };

	  Dropzone._autoDiscoverFunction = function() {
	    if (Dropzone.autoDiscover) {
	      return Dropzone.discover();
	    }
	  };

	  contentLoaded(window, Dropzone._autoDiscoverFunction);

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(8)(module)))

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../css-loader/index.js!./dropzone.css", function() {
				var newContent = require("!!./../../css-loader/index.js!./dropzone.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, "/*\n * The MIT License\n * Copyright (c) 2012 Matias Meno <m@tias.me>\n */\n@-webkit-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px); } }\n@-moz-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px); } }\n@keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px); } }\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); } }\n@-moz-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); } }\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px); }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px); } }\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1); }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); } }\n@-moz-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1); }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); } }\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1); }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1); } }\n.dropzone, .dropzone * {\n  box-sizing: border-box; }\n\n.dropzone {\n  min-height: 150px;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  background: white;\n  padding: 20px 20px; }\n  .dropzone.dz-clickable {\n    cursor: pointer; }\n    .dropzone.dz-clickable * {\n      cursor: default; }\n    .dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {\n      cursor: pointer; }\n  .dropzone.dz-started .dz-message {\n    display: none; }\n  .dropzone.dz-drag-hover {\n    border-style: solid; }\n    .dropzone.dz-drag-hover .dz-message {\n      opacity: 0.5; }\n  .dropzone .dz-message {\n    text-align: center;\n    margin: 2em 0; }\n  .dropzone .dz-preview {\n    position: relative;\n    display: inline-block;\n    vertical-align: top;\n    margin: 16px;\n    min-height: 100px; }\n    .dropzone .dz-preview:hover {\n      z-index: 1000; }\n      .dropzone .dz-preview:hover .dz-details {\n        opacity: 1; }\n    .dropzone .dz-preview.dz-file-preview .dz-image {\n      border-radius: 20px;\n      background: #999;\n      background: linear-gradient(to bottom, #eee, #ddd); }\n    .dropzone .dz-preview.dz-file-preview .dz-details {\n      opacity: 1; }\n    .dropzone .dz-preview.dz-image-preview {\n      background: white; }\n      .dropzone .dz-preview.dz-image-preview .dz-details {\n        -webkit-transition: opacity 0.2s linear;\n        -moz-transition: opacity 0.2s linear;\n        -ms-transition: opacity 0.2s linear;\n        -o-transition: opacity 0.2s linear;\n        transition: opacity 0.2s linear; }\n    .dropzone .dz-preview .dz-remove {\n      font-size: 14px;\n      text-align: center;\n      display: block;\n      cursor: pointer;\n      border: none; }\n      .dropzone .dz-preview .dz-remove:hover {\n        text-decoration: underline; }\n    .dropzone .dz-preview:hover .dz-details {\n      opacity: 1; }\n    .dropzone .dz-preview .dz-details {\n      z-index: 20;\n      position: absolute;\n      top: 0;\n      left: 0;\n      opacity: 0;\n      font-size: 13px;\n      min-width: 100%;\n      max-width: 100%;\n      padding: 2em 1em;\n      text-align: center;\n      color: rgba(0, 0, 0, 0.9);\n      line-height: 150%; }\n      .dropzone .dz-preview .dz-details .dz-size {\n        margin-bottom: 1em;\n        font-size: 16px; }\n      .dropzone .dz-preview .dz-details .dz-filename {\n        white-space: nowrap; }\n        .dropzone .dz-preview .dz-details .dz-filename:hover span {\n          border: 1px solid rgba(200, 200, 200, 0.8);\n          background-color: rgba(255, 255, 255, 0.8); }\n        .dropzone .dz-preview .dz-details .dz-filename:not(:hover) {\n          overflow: hidden;\n          text-overflow: ellipsis; }\n          .dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {\n            border: 1px solid transparent; }\n      .dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {\n        background-color: rgba(255, 255, 255, 0.4);\n        padding: 0 0.4em;\n        border-radius: 3px; }\n    .dropzone .dz-preview:hover .dz-image img {\n      -webkit-transform: scale(1.05, 1.05);\n      -moz-transform: scale(1.05, 1.05);\n      -ms-transform: scale(1.05, 1.05);\n      -o-transform: scale(1.05, 1.05);\n      transform: scale(1.05, 1.05);\n      -webkit-filter: blur(8px);\n      filter: blur(8px); }\n    .dropzone .dz-preview .dz-image {\n      border-radius: 20px;\n      overflow: hidden;\n      width: 120px;\n      height: 120px;\n      position: relative;\n      display: block;\n      z-index: 10; }\n      .dropzone .dz-preview .dz-image img {\n        display: block; }\n    .dropzone .dz-preview.dz-success .dz-success-mark {\n      -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n      animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1); }\n    .dropzone .dz-preview.dz-error .dz-error-mark {\n      opacity: 1;\n      -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n      animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1); }\n    .dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {\n      pointer-events: none;\n      opacity: 0;\n      z-index: 500;\n      position: absolute;\n      display: block;\n      top: 50%;\n      left: 50%;\n      margin-left: -27px;\n      margin-top: -27px; }\n      .dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {\n        display: block;\n        width: 54px;\n        height: 54px; }\n    .dropzone .dz-preview.dz-processing .dz-progress {\n      opacity: 1;\n      -webkit-transition: all 0.2s linear;\n      -moz-transition: all 0.2s linear;\n      -ms-transition: all 0.2s linear;\n      -o-transition: all 0.2s linear;\n      transition: all 0.2s linear; }\n    .dropzone .dz-preview.dz-complete .dz-progress {\n      opacity: 0;\n      -webkit-transition: opacity 0.4s ease-in;\n      -moz-transition: opacity 0.4s ease-in;\n      -ms-transition: opacity 0.4s ease-in;\n      -o-transition: opacity 0.4s ease-in;\n      transition: opacity 0.4s ease-in; }\n    .dropzone .dz-preview:not(.dz-processing) .dz-progress {\n      -webkit-animation: pulse 6s ease infinite;\n      -moz-animation: pulse 6s ease infinite;\n      -ms-animation: pulse 6s ease infinite;\n      -o-animation: pulse 6s ease infinite;\n      animation: pulse 6s ease infinite; }\n    .dropzone .dz-preview .dz-progress {\n      opacity: 1;\n      z-index: 1000;\n      pointer-events: none;\n      position: absolute;\n      height: 16px;\n      left: 50%;\n      top: 50%;\n      margin-top: -8px;\n      width: 80px;\n      margin-left: -40px;\n      background: rgba(255, 255, 255, 0.9);\n      -webkit-transform: scale(1);\n      border-radius: 8px;\n      overflow: hidden; }\n      .dropzone .dz-preview .dz-progress .dz-upload {\n        background: #333;\n        background: linear-gradient(to bottom, #666, #444);\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        width: 0;\n        -webkit-transition: width 300ms ease-in-out;\n        -moz-transition: width 300ms ease-in-out;\n        -ms-transition: width 300ms ease-in-out;\n        -o-transition: width 300ms ease-in-out;\n        transition: width 300ms ease-in-out; }\n    .dropzone .dz-preview.dz-error .dz-error-message {\n      display: block; }\n    .dropzone .dz-preview.dz-error:hover .dz-error-message {\n      opacity: 1;\n      pointer-events: auto; }\n    .dropzone .dz-preview .dz-error-message {\n      pointer-events: none;\n      z-index: 1000;\n      position: absolute;\n      display: block;\n      display: none;\n      opacity: 0;\n      -webkit-transition: opacity 0.3s ease;\n      -moz-transition: opacity 0.3s ease;\n      -ms-transition: opacity 0.3s ease;\n      -o-transition: opacity 0.3s ease;\n      transition: opacity 0.3s ease;\n      border-radius: 8px;\n      font-size: 13px;\n      top: 130px;\n      left: -10px;\n      width: 140px;\n      background: #be2626;\n      background: linear-gradient(to bottom, #be2626, #a92222);\n      padding: 0.5em 1.2em;\n      color: white; }\n      .dropzone .dz-preview .dz-error-message:after {\n        content: '';\n        position: absolute;\n        top: -6px;\n        left: 64px;\n        width: 0;\n        height: 0;\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-bottom: 6px solid #be2626; }\n", ""]);

	// exports


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _editor = __webpack_require__(304);

	var _editor2 = _interopRequireDefault(_editor);

	var _utils = __webpack_require__(305);

	var _lodash = __webpack_require__(308);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _lineHeight = __webpack_require__(309);

	var _lineHeight2 = _interopRequireDefault(_lineHeight);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var getCaretCoordinates = __webpack_require__(311);

	var CALLBACK_METHODS = ['onInput', 'onKeydown', 'onKeyup'];

	/**
	 * Encapsulate the target textarea element.
	 *
	 * @extends Editor
	 * @prop {HTMLTextAreaElement} el - Where the textcomplete works on.
	 */

	var Textarea = function (_Editor) {
	  _inherits(Textarea, _Editor);

	  /**
	   * @param {HTMLTextAreaElement} el
	   */

	  function Textarea(el) {
	    _classCallCheck(this, Textarea);

	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Textarea).call(this));

	    _this.el = el;
	    _this.isIE9 = (0, _utils.getIEVersion)() === 9;

	    (0, _lodash2.default)(_this, CALLBACK_METHODS);

	    _this.startListening();
	    return _this;
	  }

	  /** @override */


	  _createClass(Textarea, [{
	    key: 'finalize',
	    value: function finalize() {
	      _get(Object.getPrototypeOf(Textarea.prototype), 'finalize', this).call(this);
	      this.stopListening();
	      this.el = null;
	      return this;
	    }

	    /**
	     * @override
	     * @param {SearchResult} searchResult
	     */

	  }, {
	    key: 'applySearchResult',
	    value: function applySearchResult(searchResult) {
	      var replace = searchResult.replace(this.getBeforeCursor(), this.getAfterCursor());
	      if (Array.isArray(replace)) {
	        this.el.value = replace[0] + replace[1];
	        this.el.selectionStart = this.el.selectionEnd = replace[0].length;
	      }
	      this.el.focus(); // Clicking a dropdown item removes focus from the element.
	    }
	  }, {
	    key: 'getCursorOffset',
	    value: function getCursorOffset() {
	      var elOffset = (0, _utils.calculateElementOffset)(this.el);
	      var elScroll = this.getElScroll();
	      var cursorPosition = this.getCursorPosition();
	      var top = elOffset.top - elScroll.top + cursorPosition.top + (0, _lineHeight2.default)(this.el);
	      var left = elOffset.left - elScroll.left + cursorPosition.left;
	      if (this.el.dir !== 'rtl') {
	        return { top: top, left: left };
	      } else {
	        return { top: top, right: document.documentElement.clientWidth - left };
	      }
	    }

	    /** @override */

	  }, {
	    key: 'getBeforeCursor',
	    value: function getBeforeCursor() {
	      return this.el.value.substring(0, this.el.selectionEnd);
	    }

	    /** @override */

	  }, {
	    key: 'getAfterCursor',
	    value: function getAfterCursor() {
	      return this.el.value.substring(this.el.selectionEnd);
	    }

	    /**
	     * @private
	     * @returns {{top: number, left: number}}
	     */

	  }, {
	    key: 'getElScroll',
	    value: function getElScroll() {
	      return { top: this.el.scrollTop, left: this.el.scrollLeft };
	    }

	    /**
	     * The input cursor's relative coordinates from the textarea's left
	     * top corner.
	     *
	     * @private
	     * @returns {{top: number, left: number}}
	     */

	  }, {
	    key: 'getCursorPosition',
	    value: function getCursorPosition() {
	      return getCaretCoordinates(this.el, this.el.selectionEnd);
	    }

	    /**
	     * @private
	     * @fires Editor#change
	     * @param {InputEvent} _e
	     */

	  }, {
	    key: 'onInput',
	    value: function onInput(_e) {
	      this.emitChangeEvent();
	    }

	    /**
	     * @private
	     * @fires Editor#move
	     * @param {KeyboardEvent} e
	     */

	  }, {
	    key: 'onKeydown',
	    value: function onKeydown(e) {
	      var code = this.getCode(e);
	      var event = undefined;
	      switch (code) {
	        case _editor.UP:
	        case _editor.DOWN:
	          event = this.emitMoveEvent(code);
	          break;
	        case _editor.ENTER:
	          {
	            event = this.emitEnterEvent();
	            break;
	          }
	        case _editor.ESC:
	          {
	            event = this.emitEscEvent();
	            break;
	          }
	      }
	      if (event && event.defaultPrevented) {
	        e.preventDefault();
	      }
	    }

	    /**
	     * @private
	     * @fires Editor#change
	     * @param {KeyboardEvent} e
	     */

	  }, {
	    key: 'onKeyup',
	    value: function onKeyup(e) {
	      var code = this.getCode(e);
	      // IE 9 does not fire an input event when the user deletes characters from an input.
	      // https://developer.mozilla.org/en-US/docs/Web/Events/input#Browser_compatibility
	      if (code === _editor.BS && this.isIE9) {
	        this.emitChangeEvent();
	      }
	    }

	    /**
	     * @private
	     */

	  }, {
	    key: 'startListening',
	    value: function startListening() {
	      this.el.addEventListener('input', this.onInput);
	      this.el.addEventListener('keydown', this.onKeydown);
	      this.el.addEventListener('keyup', this.onKeyup);
	    }

	    /**
	     * @private
	     */

	  }, {
	    key: 'stopListening',
	    value: function stopListening() {
	      this.el.removeEventListener('input', this.onInput);
	      this.el.removeEventListener('keydown', this.onKeydown);
	      this.el.removeEventListener('keyup', this.onKeyup);
	    }
	  }]);

	  return Textarea;
	}(_editor2.default);

	exports.default = Textarea;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ESC = exports.BS = exports.OTHER = exports.DOWN = exports.UP = exports.ENTER = undefined;

	var _utils = __webpack_require__(305);

	var _events = __webpack_require__(307);

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var ENTER = exports.ENTER = 0;
	var UP = exports.UP = 1;
	var DOWN = exports.DOWN = 2;
	var OTHER = exports.OTHER = 3;
	var BS = exports.BS = 4;
	var ESC = exports.ESC = 5;

	/**
	 * @event Editor#move
	 * @type {CustomEvent}
	 * @prop {function} preventDefault
	 * @prop {object} detail
	 * @prop {number} detail.code
	 */

	/**
	 * @event Editor#enter
	 * @type {CustomEvent}
	 * @prop {function} preventDefault
	 */

	/**
	 * @event Editor#esc
	 * @type {CustomEvent}
	 * @prop {function} preventDefault
	 */

	/**
	 * @event Editor#change
	 * @type {CustomEvent}
	 * @prop {object} detail
	 * @prop {string} detail.beforeCursor
	 */

	/**
	 * Abstract class representing a editor target.
	 *
	 * Editor classes must implement `#applySearchResult`, `#getCursorOffset`,
	 * `#getBeforeCursor` and `#getAfterCursor` methods.
	 *
	 * @abstract
	 * @extends EventEmitter
	 */

	var Editor = function (_EventEmitter) {
	  _inherits(Editor, _EventEmitter);

	  function Editor() {
	    _classCallCheck(this, Editor);

	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Editor).apply(this, arguments));
	  }

	  _createClass(Editor, [{
	    key: 'finalize',

	    /**
	     * @returns {this}
	     */
	    value: function finalize() {
	      return this;
	    }

	    /**
	     * It is called when a search result is selected by a user.
	     *
	     * @param {SearchResult} _searchResult
	     */

	  }, {
	    key: 'applySearchResult',
	    value: function applySearchResult(_searchResult) {
	      throw new Error('Not implemented.');
	    }

	    /**
	     * The input cursor's absolute coordinates from the window's left
	     * top corner. It is intended to be overridden by sub classes.
	     *
	     * @type {Dropdown~Offset}
	     */

	  }, {
	    key: 'getCursorOffset',
	    value: function getCursorOffset() {
	      throw new Error('Not implemented.');
	    }

	    /**
	     * Editor string value from head to cursor.
	     *
	     * @private
	     */

	  }, {
	    key: 'getBeforeCursor',
	    value: function getBeforeCursor() {
	      throw new Error('Not implemented.');
	    }

	    /**
	     * Editor string value from cursor to tail.
	     *
	     * @private
	     */

	  }, {
	    key: 'getAfterCursor',
	    value: function getAfterCursor() {
	      throw new Error('Not implemented.');
	    }

	    /**
	     * @private
	     * @fires Editor#move
	     * @param {UP|DOWN} code
	     * @returns {Editor#move}
	     */

	  }, {
	    key: 'emitMoveEvent',
	    value: function emitMoveEvent(code) {
	      var moveEvent = (0, _utils.createCustomEvent)('move', {
	        cancelable: true,
	        detail: {
	          code: code
	        }
	      });
	      this.emit('move', moveEvent);
	      return moveEvent;
	    }

	    /**
	     * @private
	     * @fires Editor#enter
	     * @returns {Editor#enter}
	     */

	  }, {
	    key: 'emitEnterEvent',
	    value: function emitEnterEvent() {
	      var enterEvent = (0, _utils.createCustomEvent)('enter', { cancelable: true });
	      this.emit('enter', enterEvent);
	      return enterEvent;
	    }

	    /**
	     * @private
	     * @fires Editor#change
	     * @returns {Editor#change}
	     */

	  }, {
	    key: 'emitChangeEvent',
	    value: function emitChangeEvent() {
	      var changeEvent = (0, _utils.createCustomEvent)('change', {
	        detail: {
	          beforeCursor: this.getBeforeCursor()
	        }
	      });
	      this.emit('change', changeEvent);
	      return changeEvent;
	    }

	    /**
	     * @private
	     * @fires Editor#esc
	     * @returns {Editor#esc}
	     */

	  }, {
	    key: 'emitEscEvent',
	    value: function emitEscEvent() {
	      var escEvent = (0, _utils.createCustomEvent)('esc', { cancelable: true });
	      this.emit('esc', escEvent);
	      return escEvent;
	    }

	    /**
	     * @private
	     * @param {KeyboardEvent} e
	     * @returns {ENTER|UP|DOWN|OTHER|BS}
	     */

	  }, {
	    key: 'getCode',
	    value: function getCode(e) {
	      return e.keyCode === 8 ? BS // backspace
	      : e.keyCode === 9 ? ENTER // tab
	      : e.keyCode === 13 ? ENTER // enter
	      : e.keyCode === 27 ? ESC // esc
	      : e.keyCode === 38 ? UP // up
	      : e.keyCode === 40 ? DOWN // down
	      : e.keyCode === 78 && e.ctrlKey ? DOWN // ctrl-n
	      : e.keyCode === 80 && e.ctrlKey ? UP // ctrl-p
	      : OTHER;
	    }
	  }]);

	  return Editor;
	}(_events.EventEmitter);

	exports.default = Editor;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lock = lock;
	exports.createFragment = createFragment;
	exports.createCustomEvent = createCustomEvent;
	exports.calculateElementOffset = calculateElementOffset;
	exports.getIEVersion = getIEVersion;

	var _lodash = __webpack_require__(306);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * Exclusive execution control utility.
	 *
	 * @param {function} func - The function to be locked. It is executed with a
	 *                          function named `free` as the first argument. Once
	 *                          it is called, additional execution are ignored
	 *                          until the free is invoked. Then the last ignored
	 *                          execution will be replayed immediately.
	 * @example
	 * var lockedFunc = lock(function (free) {
	 *   setTimeout(function { free(); }, 1000); // It will be free in 1 sec.
	 *   console.log('Hello, world');
	 * });
	 * lockedFunc();  // => 'Hello, world'
	 * lockedFunc();  // none
	 * lockedFunc();  // none
	 * // 1 sec past then
	 * // => 'Hello, world'
	 * lockedFunc();  // => 'Hello, world'
	 * lockedFunc();  // none
	 * @returns {function} A wrapped function.
	 */
	function lock(func) {
	  var locked, queuedArgsToReplay;

	  return function () {
	    // Convert arguments into a real array.
	    var args = Array.prototype.slice.call(arguments);
	    if (locked) {
	      // Keep a copy of this argument list to replay later.
	      // OK to overwrite a previous value because we only replay
	      // the last one.
	      queuedArgsToReplay = args;
	      return;
	    }
	    locked = true;
	    var self = this;
	    function replayOrFree() {
	      if (queuedArgsToReplay) {
	        // Other request(s) arrived while we were locked.
	        // Now that the lock is becoming available, replay
	        // the latest such request, then call back here to
	        // unlock (or replay another request that arrived
	        // while this one was in flight).
	        var replayArgs = queuedArgsToReplay;
	        queuedArgsToReplay = undefined;
	        replayArgs.unshift(replayOrFree);
	        func.apply(self, replayArgs);
	      } else {
	        locked = false;
	      }
	    }
	    args.unshift(replayOrFree);
	    func.apply(this, args);
	  };
	}

	/**
	 * Create a document fragment by the given HTML string.
	 *
	 * @param {string} tagString
	 * @returns {DocumentFragment}
	 */
	function createFragment(tagString) {
	  var div = document.createElement('div');
	  div.innerHTML = tagString;
	  var childNodes = div.childNodes;
	  var fragment = document.createDocumentFragment();
	  for (var i = 0, l = childNodes.length; i < l; i++) {
	    fragment.appendChild(childNodes[i]);
	  }
	  return fragment;
	}

	/**
	 * @param {string} type
	 * @param {Object} [options]
	 * @param {Object} [options.detail=undefined]
	 * @param {Boolean} [options.cancelable=false]
	 * @returns {CustomEvent}
	 */
	function createCustomEvent(type, options) {
	  return new document.defaultView.CustomEvent(type, (0, _lodash2.default)({
	    cancelable: false,
	    detail: undefined
	  }, options));
	}

	/**
	 * Get the current coordinates of the `el` relative to the document.
	 *
	 * @param {HTMLElement} el
	 * @returns {{top: number, left: number}}
	 */
	function calculateElementOffset(el) {
	  var rect = el.getBoundingClientRect();
	  var _el$ownerDocument = el.ownerDocument;
	  var defaultView = _el$ownerDocument.defaultView;
	  var documentElement = _el$ownerDocument.documentElement;

	  return {
	    top: rect.top + defaultView.pageYOffset - documentElement.clientTop,
	    left: rect.left + defaultView.pageXOffset - documentElement.clientLeft
	  };
	}

	/**
	 * @returns {?number} Returns IE version or if not IE return null.
	 */
	function getIEVersion() {
	  var nav = navigator.userAgent.toLowerCase();
	  return nav.indexOf('msie') !== -1 ? parseInt(nav.split('msie')[1], 10) : null;
	}

/***/ },
/* 306 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];

	  var length = result.length,
	      skipIndexes = !!length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}

	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];

	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);

	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;

	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}

	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;

	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;

	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}

	module.exports = assignIn;


/***/ },
/* 307 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};

	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;

	  if (!this._events)
	    this._events = {};

	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }

	  handler = this._events[type];

	  if (isUndefined(handler))
	    return false;

	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }

	  return true;
	};

	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events)
	    this._events = {};

	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);

	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];

	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }

	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	      }
	    }
	  }

	  return this;
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  var fired = false;

	  function g() {
	    this.removeListener(type, g);

	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }

	  g.listener = listener;
	  this.on(type, g);

	  return this;
	};

	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events || !this._events[type])
	    return this;

	  list = this._events[type];
	  length = list.length;
	  position = -1;

	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);

	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }

	    if (position < 0)
	      return this;

	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }

	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }

	  return this;
	};

	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;

	  if (!this._events)
	    return this;

	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }

	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }

	  listeners = this._events[type];

	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];

	  return this;
	};

	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};

	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];

	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};

	function isFunction(arg) {
	  return typeof arg === 'function';
	}

	function isNumber(arg) {
	  return typeof arg === 'number';
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 308 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';

	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256,
	    FLIP_FLAG = 512;

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;

	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', ARY_FLAG],
	  ['bind', BIND_FLAG],
	  ['bindKey', BIND_KEY_FLAG],
	  ['curry', CURRY_FLAG],
	  ['curryRight', CURRY_RIGHT_FLAG],
	  ['flip', FLIP_FLAG],
	  ['partial', PARTIAL_FLAG],
	  ['partialRight', PARTIAL_RIGHT_FLAG],
	  ['rearg', REARG_FLAG]
	];

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);

	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;

	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;

	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Symbol = root.Symbol,
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;

	/* Used to set `toString` methods. */
	var defineProperty = (function() {
	  var func = getNative(Object, 'defineProperty'),
	      name = getNative.name;

	  return (name && name.length > 2) ? func : undefined;
	}());

	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}

	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;

	  predicate || (predicate = isFlattenable);
	  result || (result = []);

	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);

	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}

	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;

	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}

	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;

	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);

	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}

	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);

	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}

	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);

	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);

	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);

	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}

	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);

	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;

	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;

	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}

	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);

	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}

	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;

	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }

	  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}

	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;

	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;

	    partials = holders = undefined;
	  }

	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];

	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);

	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  return setWrapToString(result, func, bitmask);
	}

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}

	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length,
	      lastIndex = length - 1;

	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}

	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);

	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}

	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return defineProperty(wrapper, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	  });
	};

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}

	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}

	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;

	  return result === result ? (remainder ? result - remainder : result) : 0;
	}

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}

	/**
	 * Binds methods of an object to the object itself, overwriting the existing
	 * method.
	 *
	 * **Note:** This method doesn't set the "length" property of bound functions.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {Object} object The object to bind and assign the bound methods to.
	 * @param {...(string|string[])} methodNames The object method names to bind.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var view = {
	 *   'label': 'docs',
	 *   'click': function() {
	 *     console.log('clicked ' + this.label);
	 *   }
	 * };
	 *
	 * _.bindAll(view, ['click']);
	 * jQuery(element).on('click', view.click);
	 * // => Logs 'clicked docs' when clicked.
	 */
	var bindAll = baseRest(function(object, methodNames) {
	  arrayEach(baseFlatten(methodNames, 1), function(key) {
	    key = toKey(key);
	    object[key] = bind(object[key], object);
	  });
	  return object;
	});

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}

	// Assign default placeholders.
	bind.placeholder = {};

	module.exports = bindAll;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	// Load in dependencies
	var computedStyle = __webpack_require__(310);

	/**
	 * Calculate the `line-height` of a given node
	 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
	 * @returns {Number} `line-height` of the element in pixels
	 */
	function lineHeight(node) {
	  // Grab the line-height via style
	  var lnHeightStr = computedStyle(node, 'line-height'),
	      lnHeight = parseFloat(lnHeightStr, 10);

	  // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
	  if (lnHeightStr === lnHeight + '') {
	    // Save the old lineHeight style and update the em unit to the element
	    var _lnHeightStyle = node.style.lineHeight;
	    node.style.lineHeight = lnHeightStr + 'em';

	    // Calculate the em based height
	    lnHeightStr = computedStyle(node, 'line-height');
	    lnHeight = parseFloat(lnHeightStr, 10);

	    // Revert the lineHeight style
	    if (_lnHeightStyle) {
	      node.style.lineHeight = _lnHeightStyle;
	    } else {
	      delete node.style.lineHeight;
	    }
	  }

	  // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
	  // DEV: `em` units are converted to `pt` in IE6
	  // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
	  if (lnHeightStr.indexOf('pt') !== -1) {
	    lnHeight *= 4;
	    lnHeight /= 3;
	  } else if (lnHeightStr.indexOf('mm') !== -1) {
	  // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
	    lnHeight *= 96;
	    lnHeight /= 25.4;
	  } else if (lnHeightStr.indexOf('cm') !== -1) {
	  // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
	    lnHeight *= 96;
	    lnHeight /= 2.54;
	  } else if (lnHeightStr.indexOf('in') !== -1) {
	  // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
	    lnHeight *= 96;
	  } else if (lnHeightStr.indexOf('pc') !== -1) {
	  // Otherwise, if the lineHeight is in `pc`, convert it to pixels (12pt for 1pc)
	    lnHeight *= 16;
	  }

	  // Continue our computation
	  lnHeight = Math.round(lnHeight);

	  // If the line-height is "normal", calculate by font-size
	  if (lnHeightStr === 'normal') {
	    // Create a temporary node
	    var nodeName = node.nodeName,
	        _node = document.createElement(nodeName);
	    _node.innerHTML = '&nbsp;';

	    // Set the font-size of the element
	    var fontSizeStr = computedStyle(node, 'font-size');
	    _node.style.fontSize = fontSizeStr;

	    // Append it to the body
	    var body = document.body;
	    body.appendChild(_node);

	    // Assume the line height of the element is the height
	    var height = _node.offsetHeight;
	    lnHeight = height;

	    // Remove our child from the DOM
	    body.removeChild(_node);
	  }

	  // Return the calculated height
	  return lnHeight;
	}

	// Export lineHeight
	module.exports = lineHeight;

/***/ },
/* 310 */
/***/ function(module, exports) {

	// This code has been refactored for 140 bytes
	// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
	var computedStyle = function (el, prop, getComputedStyle) {
	  getComputedStyle = window.getComputedStyle;

	  // In one fell swoop
	  return (
	    // If we have getComputedStyle
	    getComputedStyle ?
	      // Query it
	      getComputedStyle(el) :

	    // Otherwise, we are in IE and use currentStyle
	      el.currentStyle
	  )[
	    // Switch to camelCase for CSSOM
	    // DEV: Grabbed from jQuery
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
	    prop.replace(/-(\w)/gi, function (word, letter) {
	      return letter.toUpperCase();
	    })
	  ];
	};

	module.exports = computedStyle;


/***/ },
/* 311 */
/***/ function(module, exports) {

	/* jshint browser: true */

	(function () {

	// The properties that we copy into a mirrored div.
	// Note that some browsers, such as Firefox,
	// do not concatenate properties, i.e. padding-top, bottom etc. -> padding,
	// so we have to do every single property specifically.
	var properties = [
	  'direction',  // RTL support
	  'boxSizing',
	  'width',  // on Chrome and IE, exclude the scrollbar, so the mirror div wraps exactly as the textarea does
	  'height',
	  'overflowX',
	  'overflowY',  // copy the scrollbar for IE

	  'borderTopWidth',
	  'borderRightWidth',
	  'borderBottomWidth',
	  'borderLeftWidth',
	  'borderStyle',

	  'paddingTop',
	  'paddingRight',
	  'paddingBottom',
	  'paddingLeft',

	  // https://developer.mozilla.org/en-US/docs/Web/CSS/font
	  'fontStyle',
	  'fontVariant',
	  'fontWeight',
	  'fontStretch',
	  'fontSize',
	  'fontSizeAdjust',
	  'lineHeight',
	  'fontFamily',

	  'textAlign',
	  'textTransform',
	  'textIndent',
	  'textDecoration',  // might not make a difference, but better be safe

	  'letterSpacing',
	  'wordSpacing',

	  'tabSize',
	  'MozTabSize'

	];

	var isBrowser = (typeof window !== 'undefined');
	var isFirefox = (isBrowser && window.mozInnerScreenX != null);

	function getCaretCoordinates(element, position, options) {
	  if(!isBrowser) {
	    throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
	  }

	  var debug = options && options.debug || false;
	  if (debug) {
	    var el = document.querySelector('#input-textarea-caret-position-mirror-div');
	    if ( el ) { el.parentNode.removeChild(el); }
	  }

	  // mirrored div
	  var div = document.createElement('div');
	  div.id = 'input-textarea-caret-position-mirror-div';
	  document.body.appendChild(div);

	  var style = div.style;
	  var computed = window.getComputedStyle? getComputedStyle(element) : element.currentStyle;  // currentStyle for IE < 9

	  // default textarea styles
	  style.whiteSpace = 'pre-wrap';
	  if (element.nodeName !== 'INPUT')
	    style.wordWrap = 'break-word';  // only for textarea-s

	  // position off-screen
	  style.position = 'absolute';  // required to return coordinates properly
	  if (!debug)
	    style.visibility = 'hidden';  // not 'display: none' because we want rendering

	  // transfer the element's properties to the div
	  properties.forEach(function (prop) {
	    style[prop] = computed[prop];
	  });

	  if (isFirefox) {
	    // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
	    if (element.scrollHeight > parseInt(computed.height))
	      style.overflowY = 'scroll';
	  } else {
	    style.overflow = 'hidden';  // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
	  }

	  div.textContent = element.value.substring(0, position);
	  // the second special handling for input type="text" vs textarea: spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
	  if (element.nodeName === 'INPUT')
	    div.textContent = div.textContent.replace(/\s/g, '\u00a0');

	  var span = document.createElement('span');
	  // Wrapping must be replicated *exactly*, including when a long word gets
	  // onto the next line, with whitespace at the end of the line before (#7).
	  // The  *only* reliable way to do that is to copy the *entire* rest of the
	  // textarea's content into the <span> created at the caret position.
	  // for inputs, just '.' would be enough, but why bother?
	  span.textContent = element.value.substring(position) || '.';  // || because a completely empty faux span doesn't render at all
	  div.appendChild(span);

	  var coordinates = {
	    top: span.offsetTop + parseInt(computed['borderTopWidth']),
	    left: span.offsetLeft + parseInt(computed['borderLeftWidth'])
	  };

	  if (debug) {
	    span.style.backgroundColor = '#aaa';
	  } else {
	    document.body.removeChild(div);
	  }

	  return coordinates;
	}

	if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
	  module.exports = getCaretCoordinates;
	} else if(isBrowser){
	  window.getCaretCoordinates = getCaretCoordinates;
	}

	}());


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _completer = __webpack_require__(313);

	var _completer2 = _interopRequireDefault(_completer);

	var _dropdown = __webpack_require__(314);

	var _dropdown2 = _interopRequireDefault(_dropdown);

	var _strategy = __webpack_require__(318);

	var _strategy2 = _interopRequireDefault(_strategy);

	var _editor = __webpack_require__(304);

	var _utils = __webpack_require__(305);

	var _lodash = __webpack_require__(308);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _lodash3 = __webpack_require__(317);

	var _lodash4 = _interopRequireDefault(_lodash3);

	var _events = __webpack_require__(307);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CALLBACK_METHODS = ['handleChange', 'handleEnter', 'handleEsc', 'handleHit', 'handleMove', 'handleSelect'];

	/**
	 * Options for a textcomplete.
	 *
	 * @typedef {Object} Textcomplete~Options
	 * @prop {Dropdown~Options} dropdown
	 */

	/**
	 * The core of textcomplete. It acts as a mediator.
	 *
	 * @prop {Completer} completer
	 * @prop {Dropdown} dropdown
	 * @prop {Editor} editor
	 * @extends EventEmitter
	 * @tutorial getting-started
	 */

	var Textcomplete = function (_EventEmitter) {
	  _inherits(Textcomplete, _EventEmitter);

	  /**
	   * @param {Editor} editor - Where the textcomplete works on.
	   * @param {Textcomplete~Options} options
	   */

	  function Textcomplete(editor) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    _classCallCheck(this, Textcomplete);

	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Textcomplete).call(this));

	    _this.completer = new _completer2.default();
	    _this.dropdown = new _dropdown2.default(options.dropdown || {});
	    _this.editor = editor;
	    _this.options = options;

	    (0, _lodash2.default)(_this, CALLBACK_METHODS);

	    _this.lockableTrigger = (0, _utils.lock)(function (free, text) {
	      this.free = free;
	      this.completer.run(text);
	    });

	    _this.startListening();
	    return _this;
	  }

	  /**
	   * @public
	   * @param {boolean} [finalizeEditor=true]
	   * @returns {this}
	   */


	  _createClass(Textcomplete, [{
	    key: 'finalize',
	    value: function finalize() {
	      var finalizeEditor = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

	      this.completer.finalize();
	      this.dropdown.finalize();
	      if (finalizeEditor) {
	        this.editor.finalize();
	      }
	      this.stopListening();
	      return this;
	    }

	    /**
	     * @public
	     * @param {Strategy~Properties[]} strategyPropsArray
	     * @returns {this}
	     * @example
	     * textcomplete.register([{
	     *   match: /(^|\s)(\w+)$/,
	     *   search: function (term, callback) {
	     *     $.ajax({ ... })
	     *       .done(callback)
	     *       .fail([]);
	     *   },
	     *   replace: function (value) {
	     *     return '$1' + value + ' ';
	     *   }
	     * }]);
	     */

	  }, {
	    key: 'register',
	    value: function register(strategyPropsArray) {
	      var _this2 = this;

	      strategyPropsArray.forEach(function (props) {
	        _this2.completer.registerStrategy(new _strategy2.default(props));
	      });
	      return this;
	    }

	    /**
	     * Start autocompleting.
	     *
	     * @public
	     * @param {string} text - Head to input cursor.
	     * @returns {this}
	     * @listens Editor#change
	     */

	  }, {
	    key: 'trigger',
	    value: function trigger(text) {
	      this.lockableTrigger(text);
	      return this;
	    }

	    /**
	     * Unlock trigger method.
	     *
	     * @private
	     * @returns {this}
	     */

	  }, {
	    key: 'unlock',
	    value: function unlock() {
	      // Calling free function may assign a new function to `this.free`.
	      // It depends on whether extra function call was made or not.
	      var free = this.free;
	      this.free = null;
	      if ((0, _lodash4.default)(free)) {
	        free();
	      }
	      return this;
	    }

	    /**
	     * @private
	     * @param {SearchResult[]} searchResults
	     * @listens Completer#hit
	     */

	  }, {
	    key: 'handleHit',
	    value: function handleHit(_ref) {
	      var searchResults = _ref.searchResults;

	      if (searchResults.length) {
	        this.dropdown.render(searchResults, this.editor.getCursorOffset());
	      } else {
	        this.dropdown.deactivate();
	      }
	      this.unlock();
	    }

	    /**
	     * @private
	     * @param {Editor#move} e
	     * @listens Editor#move
	     */

	  }, {
	    key: 'handleMove',
	    value: function handleMove(e) {
	      var action = e.detail.code === _editor.UP ? 'up' : 'down';
	      this.dropdown[action](e);
	    }

	    /**
	     * @private
	     * @param {Editor#enter} e
	     * @listens Editor#enter
	     */

	  }, {
	    key: 'handleEnter',
	    value: function handleEnter(e) {
	      var activeItem = this.dropdown.getActiveItem();
	      if (activeItem) {
	        this.dropdown.select(activeItem);
	        e.preventDefault();
	      }
	    }

	    /**
	     * @private
	     * @param {Editor#esc} e
	     * @listens Editor#esc
	     */

	  }, {
	    key: 'handleEsc',
	    value: function handleEsc(e) {
	      if (this.dropdown.shown) {
	        this.dropdown.deactivate();
	        e.preventDefault();
	      }
	    }

	    /**
	     * @private
	     * @param {Editor#change} e
	     * @listens Editor#change
	     */

	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      this.trigger(e.detail.beforeCursor);
	    }

	    /**
	     * @private
	     * @param {Dropdown#select} selectEvent
	     * @listens Dropdown#select
	     */

	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(selectEvent) {
	      this.emit('select', selectEvent);
	      if (!selectEvent.defaultPrevented) {
	        this.editor.applySearchResult(selectEvent.detail.searchResult);
	      }
	    }

	    /**
	     * @private
	     * @param {string} eventName
	     * @returns {function}
	     */

	  }, {
	    key: 'buildHandler',
	    value: function buildHandler(eventName) {
	      var _this3 = this;

	      return function () {
	        return _this3.emit(eventName);
	      };
	    }

	    /**
	     * @private
	     */

	  }, {
	    key: 'startListening',
	    value: function startListening() {
	      var _this4 = this;

	      this.editor.on('move', this.handleMove).on('enter', this.handleEnter).on('esc', this.handleEsc).on('change', this.handleChange);
	      this.dropdown.on('select', this.handleSelect);
	      ['show', 'shown', 'render', 'rendered', 'selected', 'hidden', 'hide'].forEach(function (eventName) {
	        _this4.dropdown.on(eventName, _this4.buildHandler(eventName));
	      });
	      this.completer.on('hit', this.handleHit);
	    }

	    /**
	     * @private
	     */

	  }, {
	    key: 'stopListening',
	    value: function stopListening() {
	      this.completer.removeAllListeners();
	      this.dropdown.removeAllListeners();
	      this.editor.removeListener('move', this.handleMove).removeListener('enter', this.handleEnter).removeListener('esc', this.handleEsc).removeListener('change', this.handleChange);
	    }
	  }]);

	  return Textcomplete;
	}(_events.EventEmitter);

	exports.default = Textcomplete;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(308);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _events = __webpack_require__(307);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var CALLBACK_METHODS = ['handleQueryResult'];

	/**
	 * @extends EventEmitter
	 */

	var Completer = function (_EventEmitter) {
	  _inherits(Completer, _EventEmitter);

	  function Completer() {
	    _classCallCheck(this, Completer);

	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Completer).call(this));

	    _this.strategies = [];

	    (0, _lodash2.default)(_this, CALLBACK_METHODS);
	    return _this;
	  }

	  /**
	   * @returns {this}
	   */


	  _createClass(Completer, [{
	    key: 'finalize',
	    value: function finalize() {
	      this.strategies.forEach(function (strategy) {
	        return strategy.finalize();
	      });
	      return this;
	    }

	    /**
	     * Register a strategy to the completer.
	     *
	     * @public
	     * @param {Strategy} strategy
	     * @returns {this}
	     */

	  }, {
	    key: 'registerStrategy',
	    value: function registerStrategy(strategy) {
	      this.strategies.push(strategy);
	      return this;
	    }

	    /**
	     * @public
	     * @param {string} text - Head to input cursor.
	     * @fires Completer#hit
	     */

	  }, {
	    key: 'run',
	    value: function run(text) {
	      var query = this.extractQuery(text);
	      if (query) {
	        query.execute(this.handleQueryResult);
	      } else {
	        this.handleQueryResult([]);
	      }
	    }

	    /**
	     * Find a query, which matches to the given text.
	     *
	     * @private
	     * @param {string} text - Head to input cursor.
	     * @returns {?Query}
	     */

	  }, {
	    key: 'extractQuery',
	    value: function extractQuery(text) {
	      for (var i = 0; i < this.strategies.length; i++) {
	        var query = this.strategies[i].buildQuery(text);
	        if (query) {
	          return query;
	        }
	      }
	      return null;
	    }

	    /**
	     * Callbacked by Query#execute.
	     *
	     * @private
	     * @param {SearchResult[]} searchResults
	     */

	  }, {
	    key: 'handleQueryResult',
	    value: function handleQueryResult(searchResults) {
	      /**
	       * @event Completer#hit
	       * @type {object}
	       * @prop {SearchResult[]} searchResults
	       */
	      this.emit('hit', { searchResults: searchResults });
	    }
	  }]);

	  return Completer;
	}(_events.EventEmitter);

	exports.default = Completer;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _dropdown_item = __webpack_require__(315);

	var _dropdown_item2 = _interopRequireDefault(_dropdown_item);

	var _utils = __webpack_require__(305);

	var _lodash = __webpack_require__(306);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _lodash3 = __webpack_require__(316);

	var _lodash4 = _interopRequireDefault(_lodash3);

	var _lodash5 = __webpack_require__(317);

	var _lodash6 = _interopRequireDefault(_lodash5);

	var _events = __webpack_require__(307);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var DEFAULT_CLASS_NAME = 'dropdown-menu textcomplete-dropdown';

	/**
	 * @typedef {Object} Dropdown~Offset
	 * @prop {number} [top]
	 * @prop {number} [left]
	 * @prop {number} [right]
	 */

	/**
	 * @typedef {Object} Dropdown~Options
	 * @prop {boolean} [rotate]
	 * @prop {function|string} [footer]
	 * @prop {function|string} [header]
	 * @prop {number} [maxCount]
	 * @prop {object} [style]
	 * @prop {string} [className]
	 */

	/**
	 * @event Dropdown#render
	 * @type {CustomEvent}
	 * @prop {function} preventDefault
	 */

	/**
	 * @event Dropdown#rendered
	 * @type {CustomEvent}
	 */

	/**
	 * @event Dropdown#select
	 * @type {CustomEvent}
	 * @prop {function} preventDefault
	 * @prop {object} detail
	 * @prop {SearchResult} detail.searchResult
	 */

	/**
	 * @event Dropdown#selected
	 * @type {CustomEvent}
	 * @prop {object} detail
	 * @prop {SearchResult} detail.searchResult
	 */

	/**
	 * @event Dropdown#show
	 * @type {CustomEvent}
	 * @prop {function} preventDefault
	 */

	/**
	 * @event Dropdown#shown
	 * @type {CustomEvent}
	 */

	/**
	 * @event Dropdown#hide
	 * @type {CustomEvent}
	 * @prop {function} preventDefault
	 */

	/**
	 * @event Dropdown#hidden
	 * @type {CustomEvent}
	 */

	/**
	 * Encapsulate a dropdown view.
	 *
	 * @prop {boolean} shown - Whether the #el is shown or not.
	 * @prop {DropdownItem[]} items - The array of rendered dropdown items.
	 * @extends EventEmitter
	 */

	var Dropdown = function (_EventEmitter) {
	  _inherits(Dropdown, _EventEmitter);

	  _createClass(Dropdown, null, [{
	    key: 'createElement',

	    /**
	     * @returns {HTMLUListElement}
	     */
	    value: function createElement() {
	      var el = document.createElement('ul');
	      el.id = (0, _lodash4.default)('textcomplete-dropdown-');
	      (0, _lodash2.default)(el.style, {
	        display: 'none',
	        position: 'absolute',
	        zIndex: 10000
	      });
	      document.body.appendChild(el);
	      return el;
	    }

	    /**
	     * @param {string} [className=DEFAULT_CLASS_NAME] - The class attribute of the el.
	     * @param {function|string} [footer]
	     * @param {function|string} [header]
	     * @param {number} [maxCount=10]
	     * @param {object} [style] - The style of the el.
	     * @param {boolean} [rotate=true]
	     */

	  }]);

	  function Dropdown(_ref) {
	    var _ref$className = _ref.className;
	    var className = _ref$className === undefined ? DEFAULT_CLASS_NAME : _ref$className;
	    var footer = _ref.footer;
	    var header = _ref.header;
	    var _ref$maxCount = _ref.maxCount;
	    var maxCount = _ref$maxCount === undefined ? 10 : _ref$maxCount;
	    var style = _ref.style;
	    var _ref$rotate = _ref.rotate;
	    var rotate = _ref$rotate === undefined ? true : _ref$rotate;

	    _classCallCheck(this, Dropdown);

	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dropdown).call(this));

	    _this.shown = false;
	    _this.items = [];
	    _this.footer = footer;
	    _this.header = header;
	    _this.maxCount = maxCount;
	    _this.el.className = className;
	    _this.rotate = rotate;
	    if (style) {
	      (0, _lodash2.default)(_this.el.style, style);
	    }
	    return _this;
	  }

	  /**
	   * @returns {this}
	   */


	  _createClass(Dropdown, [{
	    key: 'finalize',
	    value: function finalize() {
	      this.el.parentNode.removeChild(this.el);
	      this.clear()._el = null;
	      return this;
	    }

	    /**
	     * @returns {HTMLUListElement} the dropdown element.
	     */

	  }, {
	    key: 'render',


	    /**
	     * Render the given data as dropdown items.
	     *
	     * @param {SearchResult[]} searchResults
	     * @param {Dropdown~Offset} cursorOffset
	     * @returns {this}
	     * @fires Dropdown#render
	     * @fires Dropdown#rendered
	     */
	    value: function render(searchResults, cursorOffset) {
	      var _this2 = this;

	      var renderEvent = (0, _utils.createCustomEvent)('render', { cancelable: true });
	      this.emit('render', renderEvent);
	      if (renderEvent.defaultPrevented) {
	        return this;
	      }
	      var rawResults = [],
	          dropdownItems = [];
	      searchResults.forEach(function (searchResult) {
	        rawResults.push(searchResult.data);
	        if (dropdownItems.length < _this2.maxCount) {
	          dropdownItems.push(new _dropdown_item2.default(searchResult));
	        }
	      });
	      this.clear().setStrategyId(searchResults[0]).renderEdge(rawResults, 'header').append(dropdownItems).renderEdge(rawResults, 'footer').setOffset(cursorOffset).show();
	      this.emit('rendered', (0, _utils.createCustomEvent)('rendered'));
	      return this;
	    }

	    /**
	     * Hide the dropdown then sweep out items.
	     *
	     * @returns {this}
	     */

	  }, {
	    key: 'deactivate',
	    value: function deactivate() {
	      return this.hide().clear();
	    }

	    /**
	     * @param {DropdownItem} dropdownItem
	     * @returns {this}
	     * @fires Dropdown#select
	     */

	  }, {
	    key: 'select',
	    value: function select(dropdownItem) {
	      var detail = { searchResult: dropdownItem.searchResult };
	      var selectEvent = (0, _utils.createCustomEvent)('select', { cancelable: true, detail: detail });
	      this.emit('select', selectEvent);
	      if (selectEvent.defaultPrevented) {
	        return this;
	      }
	      this.deactivate();
	      this.emit('selected', (0, _utils.createCustomEvent)('selected', { detail: detail }));
	      return this;
	    }

	    /**
	     * @param {Editor#move} e
	     * @returns {this}
	     */

	  }, {
	    key: 'up',
	    value: function up(e) {
	      return this.shown ? this.moveActiveItem('prev', e) : this;
	    }

	    /**
	     * @param {Editor#move} e
	     * @returns {this}
	     */

	  }, {
	    key: 'down',
	    value: function down(e) {
	      return this.shown ? this.moveActiveItem('next', e) : this;
	    }

	    /**
	     * Retrieve the active item.
	     *
	     * @returns {DropdownItem|undefined}
	     */

	  }, {
	    key: 'getActiveItem',
	    value: function getActiveItem() {
	      return this.items.find(function (item) {
	        return item.active;
	      });
	    }

	    /**
	     * Add items to dropdown.
	     *
	     * @private
	     * @param {DropdownItem[]} items
	     * @returns {this};
	     */

	  }, {
	    key: 'append',
	    value: function append(items) {
	      var _this3 = this;

	      var fragment = document.createDocumentFragment();
	      items.forEach(function (item) {
	        _this3.items.push(item);
	        item.appended(_this3);
	        fragment.appendChild(item.el);
	      });
	      this.el.appendChild(fragment);
	      return this;
	    }

	    /**
	     * @private
	     * @param {Dropdown~Offset} cursorOffset
	     * @returns {this}
	     */

	  }, {
	    key: 'setOffset',
	    value: function setOffset(cursorOffset) {
	      var _this4 = this;

	      ['top', 'right', 'bottom', 'left'].forEach(function (name) {
	        if (cursorOffset.hasOwnProperty(name)) {
	          _this4.el.style[name] = cursorOffset[name] + 'px';
	        }
	      });
	      return this;
	    }

	    /**
	     * Show the element.
	     *
	     * @private
	     * @returns {this}
	     * @fires Dropdown#show
	     * @fires Dropdown#shown
	     */

	  }, {
	    key: 'show',
	    value: function show() {
	      if (!this.shown) {
	        var showEvent = (0, _utils.createCustomEvent)('show', { cancelable: true });
	        this.emit('show', showEvent);
	        if (showEvent.defaultPrevented) {
	          return this;
	        }
	        this.el.style.display = 'block';
	        this.shown = true;
	        this.emit('shown', (0, _utils.createCustomEvent)('shown'));
	      }
	      return this;
	    }

	    /**
	     * Hide the element.
	     *
	     * @private
	     * @returns {this}
	     * @fires Dropdown#hide
	     * @fires Dropdown#hidden
	     */

	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (this.shown) {
	        var hideEvent = (0, _utils.createCustomEvent)('hide', { cancelable: true });
	        this.emit('hide', hideEvent);
	        if (hideEvent.defaultPrevented) {
	          return this;
	        }
	        this.el.style.display = 'none';
	        this.shown = false;
	        this.emit('hidden', (0, _utils.createCustomEvent)('hidden'));
	      }
	      return this;
	    }

	    /**
	     * Clear search results.
	     *
	     * @private
	     * @returns {this}
	     */

	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.el.innerHTML = '';
	      this.items.forEach(function (item) {
	        return item.finalize();
	      });
	      this.items = [];
	      return this;
	    }

	    /**
	     * @private
	     * @param {string} name - "next" or "prev".
	     * @param {Editor#move} e
	     * @returns {this}
	     */

	  }, {
	    key: 'moveActiveItem',
	    value: function moveActiveItem(name, e) {
	      var activeItem = this.getActiveItem();
	      var nextActiveItem = undefined;
	      if (activeItem) {
	        nextActiveItem = activeItem[name];
	      } else {
	        nextActiveItem = name === 'next' ? this.items[0] : this.items[this.items.length - 1];
	      }
	      if (nextActiveItem) {
	        nextActiveItem.activate();
	        e.preventDefault();
	      }
	      return this;
	    }

	    /**
	     * @private
	     * @param {?SearchResult} searchResult
	     * @returns {this}
	     */

	  }, {
	    key: 'setStrategyId',
	    value: function setStrategyId(searchResult) {
	      var strategyId = searchResult && searchResult.strategy.props.id;
	      if (strategyId) {
	        this.el.setAttribute('data-strategy', strategyId);
	      } else {
	        this.el.removeAttribute('data-strategy');
	      }
	      return this;
	    }

	    /**
	     * @private
	     * @param {object[]} rawResults - What callbacked by search function.
	     * @param {string} type - 'header' or 'footer'.
	     * @returns {this}
	     */

	  }, {
	    key: 'renderEdge',
	    value: function renderEdge(rawResults, type) {
	      var source = this[type];
	      if (source) {
	        var content = (0, _lodash6.default)(source) ? source(rawResults) : source;
	        var fragment = (0, _utils.createFragment)('<li class="textcomplete-' + type + '">' + content + '</li>');
	        this.el.appendChild(fragment);
	      }
	      return this;
	    }
	  }, {
	    key: 'el',
	    get: function get() {
	      this._el || (this._el = Dropdown.createElement());
	      return this._el;
	    }
	  }]);

	  return Dropdown;
	}(_events.EventEmitter);

	exports.default = Dropdown;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CLASS_NAME = undefined;

	var _lodash = __webpack_require__(316);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _lodash3 = __webpack_require__(308);

	var _lodash4 = _interopRequireDefault(_lodash3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CLASS_NAME = exports.CLASS_NAME = 'textcomplete-item';
	var ACTIVE_CLASS_NAME = CLASS_NAME + ' active';
	var CALLBACK_METHODS = ['onClick', 'onMouseover'];

	/**
	 * Encapsulate an item of dropdown.
	 */

	var DropdownItem = function () {
	  /**
	   * @param {SearchResult} searchResult
	   */

	  function DropdownItem(searchResult) {
	    _classCallCheck(this, DropdownItem);

	    this.searchResult = searchResult;
	    this.id = (0, _lodash2.default)('dropdown-item-');
	    this.active = false;

	    (0, _lodash4.default)(this, CALLBACK_METHODS);
	  }

	  /**
	   * @public
	   * @returns {HTMLLIElement}
	   */


	  _createClass(DropdownItem, [{
	    key: 'finalize',


	    /**
	     * Try to free resources and perform other cleanup operations.
	     *
	     * @public
	     */
	    value: function finalize() {
	      this.el.removeEventListener('mousedown', this.onClick, false);
	      this.el.removeEventListener('mouseover', this.onMouseover, false);
	      this.el.removeEventListener('touchstart', this.onClick, false);
	      // This element has already been removed by `Dropdown#clear`.
	      this._el = null;
	    }

	    /**
	     * Callbacked when it is appended to a dropdown.
	     *
	     * @public
	     * @param {Dropdown} dropdown
	     * @see Dropdown#append
	     */

	  }, {
	    key: 'appended',
	    value: function appended(dropdown) {
	      this.dropdown = dropdown;
	      this.siblings = dropdown.items;
	      this.index = this.siblings.length - 1;
	    }

	    /**
	     * Deactivate active item then activate itself.
	     *
	     * @public
	     * @returns {this}
	     */

	  }, {
	    key: 'activate',
	    value: function activate() {
	      if (!this.active) {
	        var activeItem = this.dropdown.getActiveItem();
	        if (activeItem) {
	          activeItem.deactivate();
	        }
	        this.active = true;
	        this.el.className = ACTIVE_CLASS_NAME;
	      }
	      return this;
	    }

	    /**
	     * Get the next sibling.
	     *
	     * @public
	     * @returns {?DropdownItem}
	     */

	  }, {
	    key: 'deactivate',


	    /**
	     * @private
	     * @returns {this}
	     */
	    value: function deactivate() {
	      if (this.active) {
	        this.active = false;
	        this.el.className = CLASS_NAME;
	      }
	      return this;
	    }

	    /**
	     * @private
	     * @param {MouseEvent} e
	     */

	  }, {
	    key: 'onClick',
	    value: function onClick(e) {
	      e.preventDefault(); // Prevent blur event
	      this.dropdown.select(this);
	    }

	    /**
	     * @private
	     * @param {MouseEvent} _e
	     */

	  }, {
	    key: 'onMouseover',
	    value: function onMouseover(_e) {
	      this.activate();
	    }
	  }, {
	    key: 'el',
	    get: function get() {
	      if (!this._el) {
	        var li = document.createElement('li');
	        li.id = this.id;
	        li.className = this.active ? ACTIVE_CLASS_NAME : CLASS_NAME;
	        var a = document.createElement('a');
	        a.innerHTML = this.searchResult.render();
	        li.appendChild(a);
	        this._el = li;
	        li.addEventListener('mousedown', this.onClick);
	        li.addEventListener('mouseover', this.onMouseover);
	        li.addEventListener('touchstart', this.onClick);
	      }
	      return this._el;
	    }
	  }, {
	    key: 'next',
	    get: function get() {
	      var nextIndex = undefined;
	      if (this.index === this.siblings.length - 1) {
	        if (!this.dropdown.rotate) {
	          return null;
	        }
	        nextIndex = 0;
	      } else {
	        nextIndex = this.index + 1;
	      }
	      return this.siblings[nextIndex];
	    }

	    /**
	     * Get the previous sibling.
	     *
	     * @public
	     * @returns {DropdownItem}
	     */

	  }, {
	    key: 'prev',
	    get: function get() {
	      var nextIndex = undefined;
	      if (this.index === 0) {
	        if (!this.dropdown.rotate) {
	          return null;
	        }
	        nextIndex = this.siblings.length - 1;
	      } else {
	        nextIndex = this.index - 1;
	      }
	      return this.siblings[nextIndex];
	    }
	  }]);

	  return DropdownItem;
	}();

	exports.default = DropdownItem;

/***/ },
/* 316 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to generate unique IDs. */
	var idCounter = 0;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Built-in value references. */
	var Symbol = root.Symbol;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}

	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}

	module.exports = uniqueId;

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 317 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */

	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array constructors, and
	  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	module.exports = isFunction;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _query = __webpack_require__(319);

	var _query2 = _interopRequireDefault(_query);

	var _lodash = __webpack_require__(317);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _lodash3 = __webpack_require__(321);

	var _lodash4 = _interopRequireDefault(_lodash3);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DEFAULT_INDEX = 2;

	function DEFAULT_TEMPLATE(value) {
	  return value;
	}

	/**
	 * Properties for a strategy.
	 *
	 * @typedef {Object} Strategy~Properties
	 * @prop {regexp|function} match - If it is a function, it must return a RegExp.
	 * @prop {function} search
	 * @prop {function} replace
	 * @prop {boolean} [cache]
	 * @prop {function} [context]
	 * @prop {function} [template]
	 * @prop {number} [index=2]
	 * @prop {string} [id]
	 */

	/**
	 * Encapsulate a single strategy.
	 *
	 * @prop {Strategy~Properties} props - Its properties.
	 */

	var Strategy = function () {
	  /**
	   * @param {Strategy~Properties} props
	   */

	  function Strategy(props) {
	    _classCallCheck(this, Strategy);

	    this.props = props;
	    this.cache = props.cache ? {} : null;
	  }

	  /**
	   * @returns {this}
	   */


	  _createClass(Strategy, [{
	    key: 'finalize',
	    value: function finalize() {
	      this.cache = null;
	      return this;
	    }

	    /**
	     * Build a Query object by the given string if this matches to the string.
	     *
	     * @param {string} text - Head to input cursor.
	     * @returns {?Query}
	     */

	  }, {
	    key: 'buildQuery',
	    value: function buildQuery(text) {
	      if ((0, _lodash2.default)(this.props.context)) {
	        var context = this.props.context(text);
	        if ((0, _lodash4.default)(context)) {
	          text = context;
	        } else if (!context) {
	          return null;
	        }
	      }
	      var match = text.match(this.getMatchRegexp(text));
	      return match ? new _query2.default(this, match[this.index], match) : null;
	    }

	    /**
	     * @param {string} term
	     * @param {function} callback
	     * @param {string[]} match
	     */

	  }, {
	    key: 'search',
	    value: function search(term, callback, match) {
	      if (this.cache) {
	        this.searchWithCache(term, callback, match);
	      } else {
	        this.props.search(term, callback, match);
	      }
	    }

	    /**
	     * @param {object} data - An element of array callbacked by search function.
	     * @returns {string[]|string|null}
	     */

	  }, {
	    key: 'replace',
	    value: function replace(data) {
	      return this.props.replace(data);
	    }

	    /**
	     * @private
	     * @param {string} term
	     * @param {function} callback
	     * @param {string[]} match
	     */

	  }, {
	    key: 'searchWithCache',
	    value: function searchWithCache(term, callback, match) {
	      var _this = this;

	      var cache = this.cache[term];
	      if (cache) {
	        callback(cache);
	      } else {
	        this.props.search(term, function (results) {
	          _this.cache[term] = results;
	          callback(results);
	        }, match);
	      }
	    }

	    /**
	     * @private
	     * @param {string} text
	     * @returns {RegExp}
	     */

	  }, {
	    key: 'getMatchRegexp',
	    value: function getMatchRegexp(text) {
	      return (0, _lodash2.default)(this.match) ? this.match(text) : this.match;
	    }

	    /**
	     * @private
	     * @returns {RegExp|Function}
	     */

	  }, {
	    key: 'match',
	    get: function get() {
	      return this.props.match;
	    }

	    /**
	     * @private
	     * @returns {Number}
	     */

	  }, {
	    key: 'index',
	    get: function get() {
	      return this.props.index || DEFAULT_INDEX;
	    }

	    /**
	     * @returns {function}
	     */

	  }, {
	    key: 'template',
	    get: function get() {
	      return this.props.template || DEFAULT_TEMPLATE;
	    }
	  }]);

	  return Strategy;
	}();

	exports.default = Strategy;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _search_result = __webpack_require__(320);

	var _search_result2 = _interopRequireDefault(_search_result);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * Encapsulate matching condition between a Strategy and current editor's value.
	 */

	var Query = function () {
	  /**
	   * @param {Strategy} strategy
	   * @param {string} term
	   * @param {string[]} match
	   */

	  function Query(strategy, term, match) {
	    _classCallCheck(this, Query);

	    this.strategy = strategy;
	    this.term = term;
	    this.match = match;
	  }

	  /**
	   * Invoke search strategy and callback the given function.
	   *
	   * @public
	   * @param {function} callback
	   */


	  _createClass(Query, [{
	    key: 'execute',
	    value: function execute(callback) {
	      var _this = this;

	      this.strategy.search(this.term, function (results) {
	        callback(results.map(function (result) {
	          return new _search_result2.default(result, _this.term, _this.strategy);
	        }));
	      }, this.match);
	    }
	  }]);

	  return Query;
	}();

	exports.default = Query;

/***/ },
/* 320 */
/***/ function(module, exports) {

	"use strict";

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SearchResult = function () {
	  /**
	   * @param {object} data - An element of array callbacked by search function.
	   * @param {string} term
	   * @param {Strategy} strategy
	   */

	  function SearchResult(data, term, strategy) {
	    _classCallCheck(this, SearchResult);

	    this.data = data;
	    this.term = term;
	    this.strategy = strategy;
	  }

	  /**
	   * @param {string} beforeCursor
	   * @param {string} afterCursor
	   * @returns {string[]|undefined}
	   */


	  _createClass(SearchResult, [{
	    key: "replace",
	    value: function replace(beforeCursor, afterCursor) {
	      var replacement = this.strategy.replace(this.data);
	      if (replacement != null) {
	        if (Array.isArray(replacement)) {
	          afterCursor = replacement[1] + afterCursor;
	          replacement = replacement[0];
	        }
	        return [beforeCursor.replace(this.strategy.match, replacement), afterCursor];
	      }
	    }

	    /**
	     * @returns {string}
	     */

	  }, {
	    key: "render",
	    value: function render() {
	      return this.strategy.template(this.data, this.term);
	    }
	  }]);

	  return SearchResult;
	}();

	exports.default = SearchResult;

/***/ },
/* 321 */
/***/ function(module, exports) {

	/**
	 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */

	/** `Object#toString` result references. */
	var stringTag = '[object String]';

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type Function
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}

	module.exports = isString;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _ReportElement = __webpack_require__(2);

	var _underscore = __webpack_require__(3);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _textarea = __webpack_require__(303);

	var _textarea2 = _interopRequireDefault(_textarea);

	var _textcomplete = __webpack_require__(312);

	var _textcomplete2 = _interopRequireDefault(_textcomplete);

	var _Text = __webpack_require__(9);

	var _Text2 = _interopRequireDefault(_Text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var $ = __webpack_require__(13);
	__webpack_require__(283)($);

	__webpack_require__(323);

	var operators = [['is', 'is equal to'], ['isnot', 'is not equal to'], ['contains', 'contains'], ['doesnotcontain', 'does not contain'], ['gt', 'is greater than', 'number'], ['lt', 'is less than', 'number'], ['gte', 'is greater than or equal to', 'number'], ['lte', 'is less than or equal to', 'number'], ['before', 'is before', 'date'], ['after', 'is after', 'date'], ['onorbefore', 'is on or before', 'date'], ['onorafter', 'is on or after', 'date']];

	var defaultCondition = {
	  field: '',
	  operator: '',
	  operand: ''
	};

	var defaultEffect = {
	  property: '',
	  value: ''
	};

	var defaultRule = {
	  conditions: [defaultCondition],
	  effects: [defaultEffect]
	};

	var ownSelect2DropDownClass = 'jsr-condprops-select2-dropdown';
	var select2DropDownCssClass = 'jsr-select2-dropdown ' + ownSelect2DropDownClass;

	var supportedPropertyTypes = [_ReportElement.PropTypes.string, _ReportElement.PropTypes.boolean, _ReportElement.PropTypes.number, _ReportElement.PropTypes.color, _ReportElement.PropTypes.font];

	/** Generic function to enable Select2 to support freely-entered text */
	var createSearchChoice = function createSearchChoice(term, data) {
	  if (data.filter(function (existing) {
	    return existing.text.localeCompare(term) === 0;
	  }).length === 0) {
	    return { id: term, text: term };
	  }
	};

	var select2DefaultConfig = {
	  createSearchChoice: createSearchChoice,
	  allowClear: true,
	  placeholder: 'Enter a value',
	  dropdownAutoWidth: true,
	  dropdownCssClass: select2DropDownCssClass
	};

	var getTextSuggestions = function getTextSuggestions(schema) {
	  if (!schema) return [];
	  var fields = _Text2.default.getTextSuggestions(schema);
	  /** Fields can include dot-separated object properties.  We split on the dot and only suggest one piece at a time,
	      so we need to maintain a nested lookup level-by-level.  Keep pointers to all lists so we can sort them later. */
	  var getEmptyNode = function getEmptyNode() {
	    return { list: [], dict: {} };
	  };
	  var autoCompleteData = getEmptyNode();
	  var listsToSort = [autoCompleteData.list];
	  fields.forEach(function (fieldName) {
	    if (fieldName[0] === '[' && fieldName[fieldName.length - 1] === ']') {
	      var parts = fieldName.replace(/[\[\]]/g, '').split('.');
	      var part = void 0,
	          node = autoCompleteData;
	      for (var i = 0; i < parts.length; i++) {
	        var _part = parts[i];
	        if (node.dict[_part] !== undefined) {
	          node = node.dict[_part];
	        } else {
	          // Must convert e.g. [partA.partB.partC] -> [partA]
	          node.list.push(_part);
	          node.dict[_part] = node = getEmptyNode();
	          listsToSort.push(node.list);
	        }
	      }
	    } else {
	      // Not brackets, push verbatim
	      autoCompleteData.list.push(fieldName);
	    }
	  });
	  listsToSort.forEach(function (list) {
	    return list.sort();
	  });
	  return autoCompleteData;
	};

	var initTextComplete = function initTextComplete($textarea, schema, onChangeHandler) {

	  var autoCompleteOptions = getTextSuggestions(schema);
	  var lastAutocompleteWasSubkey = false;

	  var getSubKeys = function getSubKeys(autocompleteData, objPath) {
	    var parts = objPath.split('.');
	    var node = autocompleteData;
	    for (var i = 0; i < parts.length; i++) {
	      node = node.dict[parts[i]];
	      if (!node) return [];
	    }
	    return node.list;
	  };

	  var autocompleteStrategy = {
	    id: 'textAutocompleteStrategy',
	    match: /(^|\s)([\w\-\.]*)$/,
	    search: function search(term, callback) {
	      if (term[term.length - 1] === '.') {
	        lastAutocompleteWasSubkey = true;
	        return callback(getSubKeys(autoCompleteOptions, term.substr(0, term.length - 1)));
	      }
	      lastAutocompleteWasSubkey = false;
	      callback(autoCompleteOptions.list.filter(function (name) {
	        return name.startsWith(term);
	      }));
	    },
	    template: function template(name) {
	      return name;
	    },
	    replace: function replace(name) {
	      return lastAutocompleteWasSubkey ? '$1$2' + name : '$1' + name;
	    }
	  };

	  var editor = new _textarea2.default($textarea[0]);
	  var textcomplete = new _textcomplete2.default(editor, {
	    dropdown: {
	      maxCount: Infinity
	    }
	  });
	  $textarea.data('textcomplete', textcomplete);
	  textcomplete.register([autocompleteStrategy]);
	  $textarea.on('change', function (evt) {
	    onChangeHandler(evt.target.value);
	  });
	};

	/**
	 * Designer toolbar picker for specifying rules that modify
	 * an element's properties based on conditional expressions evaluated at runtime
	 */

	var ConditionalPropertiesPicker = function () {
	  function ConditionalPropertiesPicker(elementPropTypes, elementContext, getAllowedOperators) {
	    var _this = this;

	    _classCallCheck(this, ConditionalPropertiesPicker);

	    this.propTypes = this.filterPropTypes(elementPropTypes);
	    this.context = elementContext;
	    this.rules = [];
	    this.allowedOperators = operators;
	    if (getAllowedOperators) {
	      (function () {
	        var allowedOperatorNames = getAllowedOperators();
	        _this.allowedOperators = _this.allowedOperators.filter(function (operator) {
	          return allowedOperatorNames.indexOf(operator[0]) >= 0;
	        });
	      })();
	    }
	  }

	  /** Only support primitive and "oneOf" types */


	  _createClass(ConditionalPropertiesPicker, [{
	    key: 'filterPropTypes',
	    value: function filterPropTypes(allTypes) {
	      var filteredProps = {};
	      _underscore2.default.each(allTypes, function (propType, propKey) {
	        if (propType && (supportedPropertyTypes.indexOf(propType) >= 0 || propType.type === 'oneOf')) {
	          filteredProps[propKey] = propType;
	        }
	      });
	      return filteredProps;
	    }

	    /** Open in popup mode next to an anchor element */

	  }, {
	    key: 'showPopup',
	    value: function showPopup(anchorEl) {
	      var _this2 = this;

	      if (!this.popup) {
	        this.popup = $('<div class="jsr-cond-prop-popup"></div>');
	        this.popup.append('<div class="jsr-cond-prop-popup-arrow"></div>');
	        $(document.body).append(this.popup);
	      }
	      var screenHeight = $(window).height();
	      var screenWidth = $(window).width();
	      var anchorOffset = $(anchorEl).offset();
	      // Make visible for measurement
	      this.popup.css({
	        display: 'block',
	        visibility: 'hidden'
	      });
	      this.render(this.popup[0]);
	      // Now measure and position correctly
	      var anchorMiddle = anchorOffset.left + $(anchorEl).outerWidth() / 2;
	      var popupLeft = Math.max(10, anchorMiddle - this.popup.width() / 2);
	      var popupTop = Math.max(0, anchorOffset.top + $(anchorEl).outerHeight() + 3);
	      var arrowLeft = Math.max(4, anchorMiddle - popupLeft - 7);
	      this.popup.css({
	        left: popupLeft + 'px',
	        top: popupTop + 'px',
	        visibility: 'visible'
	      });
	      this.popup.find('.jsr-cond-prop-popup-arrow').css('left', arrowLeft + 'px');
	      this.popup.find('.jsr-cond-prop-picker').css('max-height', Math.max(400, screenHeight - popupTop - 50) + 'px');
	      // Stop clicks on elements within the picker from triggering a body click blur
	      this.popup.on('click', function (evt) {
	        evt.stopPropagation();
	      });
	      this.isOpen = true;
	      setTimeout(function () {
	        $(document.body).on({
	          'click': _this2.onBodyClick.bind(_this2),
	          'resize': _this2.onWindowResize.bind(_this2)
	        });
	      }, 0);
	    }
	  }, {
	    key: 'onBodyClick',
	    value: function onBodyClick(evt) {
	      if (this.isOpen) {
	        // If this is a click-out that's closing one of our own select2 sub-popups, don't close whole picker
	        // (We have to check here because of how the select2 mask works)
	        if ($('.' + ownSelect2DropDownClass + '.select2-drop-active').length > 0) return;
	        this.forceClose();
	      }
	    }
	  }, {
	    key: 'onWindowResize',
	    value: function onWindowResize(evt) {
	      if (this.isOpen) {
	        this.forceClose();
	      }
	    }

	    /** 
	     * Close the picker.  Called directly by the designer when a different element
	     * is selected; also called internally when a click is detected outside the
	     * picker.  Prompts to save any changes.
	     */

	  }, {
	    key: 'forceClose',
	    value: function forceClose() {
	      // if (confirm(`Save changes to conditional properties?`)) {
	      $(this).trigger('save', [this.rules]);
	      // }
	      this.popup.hide();
	      this.isOpen = false;
	      $(this).trigger('close');
	    }
	  }, {
	    key: 'render',
	    value: function render(containerDomEl) {
	      var _this3 = this;

	      this.container = containerDomEl;
	      var $container = $(containerDomEl);
	      var $wrap = $container.find('.jsr-cond-prop-picker');
	      if ($wrap.length === 0) {
	        $wrap = $('<div class="jsr-cond-prop-picker"></div>');
	        $container.append($wrap);
	      }
	      $wrap.empty();
	      var $rules = $('<div class="jsr-cond-prop-rules"></div>');
	      $wrap.append($rules);
	      if (this.rules.length === 0) {
	        $wrap.append('<div class="jsr-cond-prop-picker-empty-text">No conditional rules defined.</div>');
	      } else {
	        this.rules.forEach(function (rule) {
	          return $rules.append(_this3.renderRule(rule));
	        });
	      }
	      $wrap.append('\n      <div class="jsr-cond-prop-picker-controls">\n        <a class="jsr-cond-prop-add-rule" href="javascript:;" role="button">Add a rule</a>\n        <button class="jsr-btn jsr-cond-prop-close-btn">Close</button>\n      </div>\n    ');
	      $wrap.find('.jsr-cond-prop-picker-controls a.jsr-cond-prop-add-rule').click(function (e) {
	        return _this3.addRule();
	      });
	      $wrap.find('.jsr-cond-prop-close-btn').click(this.forceClose.bind(this));
	    }

	    /** A rule is the top-level grouping, a set of conditions plus a set of effects */

	  }, {
	    key: 'renderRule',
	    value: function renderRule(rule) {
	      var _this4 = this;

	      var $rule = $('<div class="jsr-cond-prop-rule"></div>');
	      $rule.append('<div>When...<div class="jsr-cond-prop-delete-rule jsr-cond-prop-delete-button"></div></div>');
	      var $conds = $('<div class="jsr-cond-prop-conditions"></div>');
	      $rule.append($conds);
	      rule.conditions.forEach(function (cond, ix) {
	        if (ix > 0) {
	          $rule.find('.jsr-cond-prop-condition:last-child').append('<span>and</span>');
	        }
	        $conds.append(_this4.renderCondition(rule, cond));
	      });
	      $rule.append('<div>then set:</div>');
	      var $effects = $('<div class="jsr-cond-prop-effects"></div>');
	      $rule.append($effects);
	      rule.effects.forEach(function (effect) {
	        return $effects.append(_this4.renderEffect(rule, effect));
	      });
	      var $addEffect = $('<div class="jsr-cond-prop-add-effect"><a href="javascript:;" role="button">+</a></div>');
	      $rule.find('.jsr-cond-prop-effect:last-child').append($addEffect);
	      $addEffect.click(function (e) {
	        return _this4.addEffect(rule);
	      });
	      $rule.find('.jsr-cond-prop-delete-rule').on('click', this.deleteRule.bind(this, rule));
	      return $rule;
	    }

	    /** Conditions come under the When... section, e.g. "[category] [is equal to] [apparel]" */

	  }, {
	    key: 'renderCondition',
	    value: function renderCondition(rule, cond) {
	      var _this5 = this;

	      var fields = this.getDataFields().map(function (f) {
	        return f.name;
	      });
	      var $cond = $('<div class="jsr-cond-prop-condition"></div>');

	      // ---
	      // const $fieldSelect = $(`<select></select>`);
	      // fields.forEach(field => $fieldSelect.append(`<option value="${field}">${field}</option>`));
	      // $cond.append($fieldSelect);
	      // $fieldSelect.val(cond.field)
	      //   .select2(_.extend({}, select2DefaultConfig, {
	      //     placeholder: 'Select a data field',
	      //     createSearchChoice: undefined,
	      //     formatNoMatches: (term) => 'No data fields. Check that element is in a data section.'
	      //   }));
	      // $fieldSelect.on('change', e => {
	      //   cond.field = $(e.target).val();
	      // });
	      var $textarea = $('<textarea type="text" class="jsr-cond-prop-field"></textarea>');
	      $textarea.val(cond.field);
	      $cond.append($textarea);
	      initTextComplete.call(this, $textarea, this.context.schema, function (newValue) {
	        cond.field = newValue;
	      });

	      var $operatorInput = $('<input type="text" />');
	      $cond.append($operatorInput);
	      $operatorInput.val(cond.operator).select2(_underscore2.default.extend({}, select2DefaultConfig, {
	        data: this.allowedOperators.map(function (op) {
	          return { id: op[0], text: op[1] };
	        })
	      }));
	      $operatorInput.on('change', function (e) {
	        cond.operator = $(e.target).val();
	      });
	      var $operandInput = $('<input type="text" />');
	      $cond.append($operandInput);
	      $operandInput.val(cond.operand).select2(_underscore2.default.extend({}, select2DefaultConfig, {
	        query: this.valueInputQuery.bind(this),
	        initSelection: this.valueInputInitSelection.bind(this)
	      }));
	      $operandInput.on('change', function (e) {
	        cond.operand = $(e.target).val();
	      });
	      // Add button
	      var $addCond = $('<div class="jsr-cond-prop-add-condition"><a href="javascript:;" role="button">+</a></div>');
	      $cond.append($addCond);
	      $addCond.click(function (e) {
	        return _this5.addCondition(rule);
	      });
	      // Delete button
	      $cond.append('<div class="jsr-cond-prop-delete-button"></div>');
	      $cond.find('.jsr-cond-prop-delete-button').click(function (e) {
	        return _this5.deleteCondition(rule, cond);
	      });
	      return $cond;
	    }

	    /** 
	     * Convert 'snake_case' and 'camelCase' to 'Snake case' and 'Camel case'
	     */

	  }, {
	    key: 'capitalizePropertyName',
	    value: function capitalizePropertyName(propKey) {
	      var spaced = propKey.replace(/_/g, ' ').replace(/([A-Z])/g, function (_, capitalLetter) {
	        return ' ' + capitalLetter.toLowerCase();
	      });
	      return spaced[0].toUpperCase() + spaced.substr(1);
	    }
	  }, {
	    key: 'renderEffect',
	    value: function renderEffect(rule, effect) {
	      var _this6 = this;

	      var propNames = Object.keys(this.propTypes);
	      propNames.sort();
	      var props = propNames.map(function (propKey) {
	        return { key: propKey, name: _this6.capitalizePropertyName(propKey) };
	      });
	      var $eff = $('<div class="jsr-cond-prop-effect"></div>');
	      var $propSelect = $('<select></select>');
	      $propSelect.append(props.map(function (prop) {
	        return $('<option value="' + prop.key + '">' + prop.name + '</option>');
	      }));
	      $eff.append($propSelect);
	      $propSelect.val(effect.property);
	      $propSelect.select2(_underscore2.default.extend({}, select2DefaultConfig, {
	        placeholder: 'Select a property',
	        createSearchChoice: undefined
	      }));
	      $propSelect.on('change', function (e) {
	        effect.property = $(e.target).val();
	        effect.value = '';
	        _this6.refresh();
	      });
	      $eff.append('<div>to</div>');
	      var $effectValueWrap = $('<div></div>');
	      $eff.append($effectValueWrap);
	      this.renderEffectValueInput($effectValueWrap, effect);
	      $eff.append('<div class="jsr-cond-prop-delete-button"></div>');
	      $eff.find('.jsr-cond-prop-delete-button').click(function (e) {
	        return _this6.deleteEffect(rule, effect);
	      });
	      return $eff;
	    }
	  }, {
	    key: 'renderEffectValueInput',
	    value: function renderEffectValueInput($container, effect) {
	      var _this7 = this;

	      var propType = this.propTypes[effect.property || ''] || 'string';
	      switch (propType) {
	        case _ReportElement.PropTypes.color:
	          var $colorInput = $('<input type="text" />');
	          $colorInput.val(effect.value);
	          $container.append($colorInput);
	          $colorInput.spectrum({
	            color: effect.value || '',
	            showPalette: true,
	            palette: this.colorPalette,
	            showAlpha: false,
	            allowEmpty: false,
	            showInput: true,
	            change: function change(color) {
	              effect.value = color === null ? "transparent" : color.toHexString();
	            }
	          });
	          break;
	        case _ReportElement.PropTypes.number:
	          var $numberInput = $('<input type="text" />');
	          $numberInput.val(effect.value);
	          $container.append($numberInput);
	          $numberInput.on('change', function (e) {
	            var strVal = $(e.target).val();
	            var numeric = Number(strVal);
	            // Save as number if numeric; otherwise leave as string (for formulas)
	            effect.value = isNaN(numeric) ? strVal : numeric;
	          });
	          break;
	        case _ReportElement.PropTypes.boolean:
	          var $valInput = $('<input type="text" />');
	          $valInput.val(effect.value);
	          $container.append($valInput);
	          $valInput.select2(_underscore2.default.extend({}, select2DefaultConfig, {
	            data: [{ id: 'true', text: 'true' }, { id: 'false', text: 'false' }]
	          }));
	          $valInput.on('change', function (e) {
	            effect.value = $(e.target).val() === 'true';
	          });
	          break;
	        case _ReportElement.PropTypes.font:
	          var $fontSelect = $('<select></select>');
	          var selectedFont = effect.value;
	          $fontSelect.append(this.fonts.map(function (font) {
	            return $('<option value="' + font.name + '">' + font.name + '</option>');
	          }));
	          $fontSelect.val(selectedFont && selectedFont.name ? selectedFont.name : '');
	          $container.append($fontSelect);
	          $fontSelect.select2(_underscore2.default.extend({}, select2DefaultConfig, {
	            placeholder: 'Select a font',
	            createSearchChoice: undefined
	          }));
	          $fontSelect.on('change', function (e) {
	            var fontName = $(e.target).val();
	            var fontNameLower = fontName.toLowerCase();
	            var css = '';
	            if (fontName != "default") {
	              css = _this7.fonts.filter(function (font) {
	                return font.name.toLowerCase() === fontNameLower;
	              })[0].css;
	            }
	            effect.value = { name: fontName, css: css };
	          });
	          break;
	        default:
	          if (propType.type === 'oneOf') {
	            var $valSelect = $('<select></select>');
	            $valSelect.append(propType.values.map(function (opt) {
	              return $('<option value="' + opt + '">' + opt + '</option>');
	            }));
	            $valSelect.val(effect.value);
	            $container.append($valSelect);
	            $valSelect.select2(_underscore2.default.extend({}, select2DefaultConfig, {
	              placeholder: 'Select an option',
	              /** For OneOf, limited to options in list */
	              createSearchChoice: undefined
	            }));
	            $valSelect.on('change', function (e) {
	              effect.value = $(e.target).val();
	            });
	          } else {
	            // Default is string input
	            var _$valInput = $('<input type="text" />');
	            _$valInput.val(effect.value);
	            $container.append(_$valInput);
	            _$valInput.select2(_underscore2.default.extend({}, select2DefaultConfig, {
	              query: this.valueInputQuery.bind(this),
	              initSelection: this.valueInputInitSelection.bind(this),
	              /** Provide the list of data fields as suggestions */
	              data: this.getDataFields().map(function (f) {
	                return { id: '[' + f.name + ']', text: '[' + f.name + ']' };
	              })
	            }));
	            _$valInput.on('change', function (e) {
	              effect.value = $(e.target).val();
	            });
	          }
	      }
	    }
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(rule) {
	      if (confirm('Are you sure you want to remove this rule with all of its conditions and effects?')) {
	        this.rules.splice(this.rules.indexOf(rule), 1);
	        this.refresh();
	      }
	    }
	  }, {
	    key: 'addRule',
	    value: function addRule() {
	      this.rules.push(JSON.parse(JSON.stringify(defaultRule)));
	      this.refresh();
	    }
	  }, {
	    key: 'addEffect',
	    value: function addEffect(rule) {
	      rule.effects.push(JSON.parse(JSON.stringify(defaultEffect)));
	      this.refresh();
	    }
	  }, {
	    key: 'addCondition',
	    value: function addCondition(rule) {
	      rule.conditions.push(JSON.parse(JSON.stringify(defaultCondition)));
	      this.refresh();
	    }
	  }, {
	    key: 'deleteEffect',
	    value: function deleteEffect(rule, effect) {
	      if (!confirm('Delete this effect?')) return;
	      rule.effects.splice(rule.effects.indexOf(effect), 1);
	      this.refresh();
	    }
	  }, {
	    key: 'deleteCondition',
	    value: function deleteCondition(rule, cond) {
	      if (!confirm('Delete this condition?')) return;
	      rule.conditions.splice(rule.conditions.indexOf(cond), 1);
	      this.refresh();
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      this.render(this.container);
	    }
	  }, {
	    key: 'valueInputQuery',
	    value: function valueInputQuery(options) {
	      options.callback({
	        more: false,
	        results: this.getDataFields().map(function (f) {
	          return { id: '[' + f.name + ']', text: '[' + f.name + ']' };
	        })
	      });
	    }
	  }, {
	    key: 'getDataFields',
	    value: function getDataFields() {
	      return this.context && this.context.schema ? this.context.schema.fields : [];
	    }
	  }, {
	    key: 'valueInputInitSelection',
	    value: function valueInputInitSelection(element, callback) {
	      var selectedVal = element.val();
	      callback({ id: selectedVal, text: selectedVal });
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(val) {
	      this.rules = val || [];
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.rules;
	    }
	  }, {
	    key: 'setColorPalette',
	    value: function setColorPalette(palette) {
	      this.colorPalette = palette;
	    }
	  }, {
	    key: 'setFonts',
	    value: function setFonts(fonts) {
	      this.fonts = fonts;
	    }
	  }]);

	  return ConditionalPropertiesPicker;
	}();

	exports.default = ConditionalPropertiesPicker;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(324);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(29)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./ConditionalPropertiesPicker.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./ConditionalPropertiesPicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(28)();
	// imports


	// module
	exports.push([module.id, ".jsr-cond-prop-picker {\n  font-family: Helvetica, sans-serif;\n  font-size: 14px;\n  overflow: auto;\n}\n\n.jsr-cond-prop-popup {\n  position: absolute;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 15px;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n  z-index: 9998;\n  min-width: 400px;\n}\n\n.jsr-cond-prop-popup .jsr-cond-prop-popup-arrow {\n  position: absolute;\n  top: -8px;  \n  left: 20px;\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAICAYAAAAm06XyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAA6VpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgICAgICAgICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iPgogICAgICAgICA8eG1wOk1vZGlmeURhdGU+MjAxNi0xMC0wOVQyMToxMDo3MzwveG1wOk1vZGlmeURhdGU+CiAgICAgICAgIDx4bXA6Q3JlYXRvclRvb2w+UGl4ZWxtYXRvciAzLjU8L3htcDpDcmVhdG9yVG9vbD4KICAgICAgICAgPHRpZmY6T3JpZW50YXRpb24+MTwvdGlmZjpPcmllbnRhdGlvbj4KICAgICAgICAgPHRpZmY6Q29tcHJlc3Npb24+NTwvdGlmZjpDb21wcmVzc2lvbj4KICAgICAgICAgPHRpZmY6UmVzb2x1dGlvblVuaXQ+MjwvdGlmZjpSZXNvbHV0aW9uVW5pdD4KICAgICAgICAgPHRpZmY6WVJlc29sdXRpb24+NzI8L3RpZmY6WVJlc29sdXRpb24+CiAgICAgICAgIDx0aWZmOlhSZXNvbHV0aW9uPjcyPC90aWZmOlhSZXNvbHV0aW9uPgogICAgICAgICA8ZXhpZjpQaXhlbFhEaW1lbnNpb24+MTU8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpDb2xvclNwYWNlPjE8L2V4aWY6Q29sb3JTcGFjZT4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjg8L2V4aWY6UGl4ZWxZRGltZW5zaW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4K2iF5uAAAADhJREFUGBljYMADzpw58x+PNG4pkEYQINkAmEawblIMQNdItAG4NBI0gJBGnAYQqxHDAFI1IhsAAEa/9gqrpvPoAAAAAElFTkSuQmCC) 0 0 no-repeat;\n  width: 15px;\n  height: 8px;\n}\n\n.jsr-cond-prop-effect > div,\n.jsr-cond-prop-condition > div {\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.jsr-cond-prop-effect,\n.jsr-cond-prop-condition {\n  margin: 5px 0;\n}\n\n.jsr-cond-prop-condition .jsr-cond-prop-add-condition {\n  display: none;\n}\n.jsr-cond-prop-condition:last-child .jsr-cond-prop-add-condition {\n  display: inline-block;\n}\n\n.jsr-cond-prop-picker .select2-container a {\n  background-image: none;\n}\n\n.jsr-cond-prop-picker .select2-container .select2-arrow {\n  background: none;\n  border-left: none;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-picker-controls {\n  margin-top: 20px;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-rule {\n  padding: 10px 0;\n  border-bottom: 1px solid #ccc;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-rule:first-child {\n  padding-top: 0;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-add-condition,\n.jsr-cond-prop-picker .jsr-cond-prop-add-effect {\n  font-size: 150%;\n  font-weight: bold;\n  opacity: 0.3;\n  transition: opacity 250ms;\n  position: relative;\n  top: 1px;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-add-condition a,\n.jsr-cond-prop-picker .jsr-cond-prop-add-effect a {\n  color: black;\n  text-decoration: none;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-add-condition:hover,\n.jsr-cond-prop-picker .jsr-cond-prop-add-effect:hover {\n  opacity: 1;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-delete-button {\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABLElEQVQ4y73Vu0oDQRTG8Z93vFWxtrbTlPa2gqBiQNE38CnESpCID6CFYKEPIKKNtVgFr9EHMIja2BjXZhaWdXcNJnjgNIfv/JmZ880M2TGAFRyjjpeQdRxhOWhaigU8IfolHzFfBOpBtQVQOrdD74/Y/QMszmoaNtcGLMIXZmNYPx7aBEa4Qx9UcgTnKOE0Vb/COE4yehbhMAc4HXYwhLMErBTq6xk9B8JSs4ANTIXmYWwF2Aj2cnqu4b3gXBqYTAxvArcF+rdudBd4sxQcEEcvxgr0XUVbjrATRKOYCU3lsPIs/U3RUKoJ2AU+sZqAvuYNJc825QQsrjWxhkFc5tkmz9jPYWrpehP3Rcbu+NWLY7MN4Ma/PF8df2DTX0AF+6jhI2QtXLulvC/gGz+0BAHp9nG7AAAAAElFTkSuQmCC) 0 0 no-repeat;\n  width: 16px;\n  height: 16px;\n  background-size: 16px;\n  display: inline-block;\n  opacity: 0.25;\n  transition: opacity 250ms;\n  margin-left: 10px;\n  cursor: pointer;\n  position: relative;\n  top: 4px;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-delete-button:hover {\n  opacity: 1;\n}\n\n.jsr-cond-prop-picker .jsr-cond-prop-condition:last-child .jsr-cond-prop-delete-button,\n.jsr-cond-prop-picker .jsr-cond-prop-effect:last-child .jsr-cond-prop-delete-button {\n  display: none;\n}\n\n.jsr-cond-prop-picker-empty-text {\n  color: #888;\n}\n\n.jsr-toolbar-conditional-properties {\n  position: relative;\n}\n\n.jsr-cond-props-count-bubble {\n  position: absolute;\n  top: 1px;\n  right: 1px;\n  font-size: 10px;\n  padding: 2px;\n  border-radius: 10px;\n  background: rgba(0, 0, 255, 0.5);\n  color: white;\n  line-height: 1em;\n  color: white;\n  min-width: 10px;\n}\n\n.jsr-cond-prop-delete-rule {\n  margin-left: 20px;\n}\n\n.jsr-cond-prop-close-btn {\n  margin-left: 15px;\n}\n\n.jsr-cond-prop-picker input[type=text] {\n    border: 1px solid #aaa;\n    border-radius: 3px;\n    line-height: 26px;\n    font-size: 14px;\n    padding: 0 6px;\n}\n\n.jsr-cond-prop-field {\n  border: 1px solid rgb(170, 170, 170);\n  border-radius: 4px;\n  height: 26px;\n  line-height: 26px;\n  padding: 0 8px;\n  font-size: 14px;\n  vertical-align: top;\n  margin-right: 10px;\n}\n", ""]);

	// exports


/***/ },
/* 325 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var ELEMENT_RESIZE = 'ELEMENT_RESIZE';
	var ELEMENT_PROPERTY_CHANGE = 'ELEMENT_PROPERTY_CHANGE';

	var elementResizeAction = exports.elementResizeAction = function elementResizeAction(oldElDef, newElDef) {
	  return {
	    type: ELEMENT_RESIZE,
	    oldElDef: _extends({}, oldElDef),
	    newElDef: _extends({}, newElDef)
	  };
	};

	var elementPropertyChangeAction = exports.elementPropertyChangeAction = function elementPropertyChangeAction(oldElDef, propName, propVal) {
	  return {
	    type: ELEMENT_PROPERTY_CHANGE,
	    oldElDef: _extends({}, oldElDef),
	    propName: propName,
	    propVal: propVal
	  };
	};

/***/ },
/* 326 */
/***/ function(module, exports) {

	/**
	 * Toolbar.js
	 *
	 * @fileoverview  jQuery plugin that creates tooltip style toolbars.
	 * @link          http://paulkinzett.github.com/toolbar/
	 * @author        Paul Kinzett (http://kinzett.co.nz/)
	 * @version       1.0.4
	 * @requires      jQuery 1.7+
	 *
	 * @license jQuery Toolbar Plugin v1.0.4
	 * http://paulkinzett.github.com/toolbar/
	 * Copyright 2013 Paul Kinzett (http://kinzett.co.nz/)
	 * Released under the MIT license.
	 * <https://raw.github.com/paulkinzett/toolbar/master/LICENSE.txt>
	 */
	module.exports = function(jQuery) {

	if ( typeof Object.create !== 'function' ) {
	    Object.create = function( obj ) {
	        function F() {}
	        F.prototype = obj;
	        return new F();
	    };
	}

	(function( $, window, document, undefined ) {

	    var ToolBar = {
	        init: function( options, elem ) {
	            var self = this;
	            self.elem = elem;
	            self.$elem = $( elem );
	            self.options = $.extend( {}, $.fn.toolbar.options, options );
	            self.toolbar = $('<div class="tool-container gradient" />')
	                .addClass('tool-'+self.options.position)
	                .addClass('tool-rounded')
	                .append('<div class="tool-items" />')
	                .append('<div class="arrow-bdr" />')
	                .append('<div class="arrow" />')
	                .appendTo('body')
	                .css('opacity', 0)
	                .hide();
	            self.toolbar_arrow = self.toolbar.find('.arrow');
	            self.toolbar_arrow_bdr = self.toolbar.find('.arrow-bdr');
	            self.initializeToolbar();
	        },

	        initializeToolbar: function() {
	            var self = this;
	            self.populateContent();
	            self.setTrigger();
	            self.toolbarWidth = self.toolbar.width();
	        },

	        setTrigger: function() {
	            var self = this;

				/*
	            self.$elem.on('click', function(event) {
	                event.preventDefault();
	                if(self.$elem.hasClass('pressed')) {
	                    self.hide();
	                } else {
	                    self.show();
	                }
	            });
	            */

	            if (self.options.hideOnClick) {
	                $('html').on("click.toolbar", function ( event ) {
	                    if (event.target != self.elem &&
	                        self.$elem.has(event.target).length === 0 &&
	                        self.toolbar.has(event.target).length === 0 &&
	                        self.toolbar.is(":visible")) {
	                        self.hide();
	                    }
	                });
	            }

	            // $(window).resize(function( event ) {
	            //     event.stopPropagation();
	            //     if ( self.toolbar.is(":visible") ) {
	            //         self.toolbarCss = self.getCoordinates(self.options.position, 20);
	            //         self.collisionDetection();
	            //         self.toolbar.css( self.toolbarCss );
	            //         self.toolbar_arrow.css( self.arrowCss );
	            //         self.toolbar_arrow_bdr.css( self.arrowCss );
	            //     }
	            // });
	        },

	        handleWindowResize: function() {
	            var self = this;
	            if ( self.toolbar.is(":visible") ) {
	                self.toolbarCss = self.getCoordinates(self.options.position, 20);
	                self.collisionDetection();
	                self.toolbar.css( self.toolbarCss );
	                self.toolbar_arrow.css( self.arrowCss );
	                self.toolbar_arrow_bdr.css( self.arrowCss );
	            }
	        },

	        populateContent: function() {
	            var self = this;
	            var location = self.toolbar.find('.tool-items');
	            var content = $(self.options.content).clone( true ).contents(); //find('a').addClass('tool-item gradient');
	            location.html(content);
	            location.find('.tool-item').on('click', function(event) {
	                event.preventDefault();
	                self.$elem.trigger('toolbarItemClick', this);
	            });
	        },

	        calculatePosition: function() {
	            var self = this;
	                self.arrowCss = {};
	                self.toolbarCss = self.getCoordinates(self.options.position, 0);
	                self.toolbarCss.position = 'absolute';
	                self.toolbarCss.zIndex = self.options.zIndex;
	                self.collisionDetection();
	                self.toolbar.css(self.toolbarCss);
	                self.toolbar_arrow.css(self.arrowCss);
	                self.toolbar_arrow_bdr.css( self.arrowCss );
	        },

	        getCoordinates: function( position, adjustment ) {
	            var self = this;
	            self.coordinates = self.$elem.offset();

	            if (self.options.adjustment && self.options.adjustment[self.options.position]) {
	                adjustment = self.options.adjustment[self.options.position] + adjustment;
	            }

	            switch(self.options.position) {
	                case 'top':
	                    return {
	                        left: self.coordinates.left-(self.toolbar.width()/2)+(self.$elem.outerWidth()/2),
	                        top: self.coordinates.top-self.$elem.height()-adjustment,
	                        right: 'auto'
	                    };
	                case 'left':
	                    return {
	                        left: self.coordinates.left-(self.toolbar.width()/2)-(self.$elem.width()/2)-adjustment,
	                        top: self.coordinates.top-(self.toolbar.height()/2)+(self.$elem.outerHeight()/2),
	                        right: 'auto'
	                    };
	                case 'right':
	                    return {
	                        left: self.coordinates.left+(self.toolbar.width()/2)+(self.$elem.width()/3)+adjustment,
	                        top: self.coordinates.top-(self.toolbar.height()/2)+(self.$elem.outerHeight()/2),
	                        right: 'auto'
	                    };
	                case 'bottom':
	                    return {
	                        left: self.coordinates.left-(self.toolbar.width()/2)+(self.$elem.outerWidth()/2),
	                        top: self.coordinates.top+self.$elem.height()+adjustment,
	                        right: 'auto'
	                    };
	            }
	        },

	        collisionDetection: function() {
	            var self = this;
	            var edgeOffset = 20;
	            self.toolbarWidth = self.toolbar.width();
	            if (self.options.position == 'top' || self.options.position == 'bottom') {
	                self.arrowCss = {left: '50%', right: '50%'};
	                if( self.toolbarCss.left < edgeOffset ) {
	                    self.toolbarCss.left = edgeOffset;
	                    self.arrowCss.left = self.$elem.offset().left + self.$elem.width()/2-(edgeOffset);
	                }
	                else if (($(window).width() - (self.toolbarCss.left + self.toolbarWidth)) < edgeOffset) {
	                    self.toolbarCss.right = edgeOffset;
	                    self.toolbarCss.left = 'auto';
	                    self.arrowCss.left = 'auto';
	                    self.arrowCss.right = ($(window).width()-self.$elem.offset().left)-(self.$elem.width()/2)-(edgeOffset)-5;
	                }
	            }
	        },

	        show: function() {
	            var self = this;
	            var animation = {'opacity': 1};

	            self.$elem.addClass('pressed');
	            self.calculatePosition();

	            switch(self.options.position) {
	                case 'top':
	                    animation.top = '-=20';
	                    break;
	                case 'left':
	                    animation.left = '-=20';
	                    break;
	                case 'right':
	                    animation.left = '+=20';
	                    break;
	                case 'bottom':
	                    animation.top = '+=20';
	                    break;
	            }

	            self.toolbar.show().animate(animation, 200 );
	            self.$elem.trigger('toolbarShown');
	        },

	        hide: function() {
	            var self = this;
	            var animation = {'opacity': 0};

	            self.$elem.removeClass('pressed');

	            switch(self.options.position) {
	                case 'top':
	                    animation.top = '+=20';
	                    break;
	                case 'left':
	                    animation.left = '+=20';
	                    break;
	                case 'right':
	                    animation.left = '-=20';
	                    break;
	                case 'bottom':
	                    animation.top = '-=20';
	                    break;
	            }

	            self.toolbar.animate(animation, 200, function() {
	                self.toolbar.hide();
	            });

	            self.$elem.trigger('toolbarHidden');
	        },

	        getToolbarElement: function () {
	            return this.toolbar.find('.tool-items');
	        }
	    };

	    $.fn.toolbar = function( options ) {
	        if ($.isPlainObject( options )) {
	            return this.each(function() {
	                var toolbarObj = Object.create( ToolBar );
	                toolbarObj.init( options, this );
	                $(this).data('toolbarObj', toolbarObj);
	            });
	        } else if ( typeof options === 'string' && options.indexOf('_') !== 0 ) {
	            var toolbarObj = $(this).data('toolbarObj');
	            var method = toolbarObj[options];
	            return method.apply(toolbarObj, $.makeArray(arguments).slice(1));
	        }
	    };

	    $.fn.toolbar.options = {
	        content: '#myContent',
	        position: 'top',
	        hideOnClick: false,
	        zIndex: 120
	    };

	}) ( jQuery, window, document );

	};

/***/ },
/* 327 */
/***/ function(module, exports) {

	// Spectrum Colorpicker v1.3.4
	// https://github.com/bgrins/spectrum
	// Author: Brian Grinstead
	// License: MIT
	module.exports = function(jQuery) {

	(function (window, $, undefined) {
	    var defaultOpts = {

	        // Callbacks
	        beforeShow: noop,
	        move: noop,
	        change: noop,
	        show: noop,
	        hide: noop,

	        // Options
	        color: false,
	        flat: false,
	        showInput: false,
	        allowEmpty: false,
	        showButtons: true,
	        clickoutFiresChange: false,
	        showInitial: false,
	        showPalette: false,
	        showPaletteOnly: false,
	        showSelectionPalette: true,
	        localStorageKey: false,
	        appendTo: "body",
	        maxSelectionSize: 7,
	        cancelText: "cancel",
	        chooseText: "choose",
	        clearText: "Clear Color Selection",
	        preferredFormat: false,
	        className: "", // Deprecated - use containerClassName and replacerClassName instead.
	        containerClassName: "",
	        replacerClassName: "",
	        showAlpha: false,
	        theme: "sp-light",
	        palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
	        selectionPalette: [],
	        disabled: false
	    },
	    spectrums = [],
	    IE = !!/msie/i.exec( window.navigator.userAgent ),
	    rgbaSupport = (function() {
	        function contains( str, substr ) {
	            return !!~('' + str).indexOf(substr);
	        }

	        var elem = document.createElement('div');
	        var style = elem.style;
	        style.cssText = 'background-color:rgba(0,0,0,.5)';
	        return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
	    })(),
	    inputTypeColorSupport = (function() {
	        var colorInput = $("<input type='color' value='#ffffff' />")[0];
	        return colorInput.type === "color" && colorInput.value !== "#ffffff";
	    })(),
	    replaceInput = [
	        "<div class='sp-replacer'>",
	            "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
	            "<div class='sp-dd'>\u25be</div>",
	        "</div>"
	    ].join(''),
	    markup = (function () {

	        // IE does not support gradients with multiple stops, so we need to simulate
	        //  that for the rainbow slider with 8 divs that each have a single gradient
	        var gradientFix = "";
	        if (IE) {
	            for (var i = 1; i <= 6; i++) {
	                gradientFix += "<div class='sp-" + i + "'></div>";
	            }
	        }

	        return [
	            "<div class='sp-container sp-hidden'>",
	                "<div class='sp-palette-container'>",
	                    "<div class='sp-palette sp-thumb sp-cf'></div>",
	                "</div>",
	                "<div class='sp-picker-container'>",
	                    "<div class='sp-top sp-cf'>",
	                        "<div class='sp-fill'></div>",
	                        "<div class='sp-top-inner'>",
	                            "<div class='sp-color'>",
	                                "<div class='sp-sat'>",
	                                    "<div class='sp-val'>",
	                                        "<div class='sp-dragger'></div>",
	                                    "</div>",
	                                "</div>",
	                            "</div>",
	                            "<div class='sp-clear sp-clear-display'>",
	                            "</div>",
	                            "<div class='sp-hue'>",
	                                "<div class='sp-slider'></div>",
	                                gradientFix,
	                            "</div>",
	                        "</div>",
	                        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
	                    "</div>",
	                    "<div class='sp-input-container sp-cf'>",
	                        "<input class='sp-input' type='text' spellcheck='false'  />",
	                    "</div>",
	                    "<div class='sp-initial sp-thumb sp-cf'></div>",
	                    "<div class='sp-button-container sp-cf'>",
	                        "<a class='sp-cancel' href='#'></a>",
	                        "<button type='button' class='sp-choose'></button>",
	                    "</div>",
	                "</div>",
	            "</div>"
	        ].join("");
	    })();

	    function paletteTemplate (p, color, className, tooltipFormat) {
	        var html = [];
	        for (var i = 0; i < p.length; i++) {
	            var current = p[i];
	            if(current) {
	                var tiny = tinycolor(current);
	                var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
	                c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";

	                var formattedString = tiny.toString(tooltipFormat || "rgb");
	                var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
	                html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';" /></span>');
	            } else {
	                var cls = 'sp-clear-display';
	                html.push('<span title="No Color Selected" data-color="" style="background-color:transparent;" class="' + cls + '"></span>');
	            }
	        }
	        return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
	    }

	    function hideAll() {
	        for (var i = 0; i < spectrums.length; i++) {
	            if (spectrums[i]) {
	                spectrums[i].hide();
	            }
	        }
	    }

	    function instanceOptions(o, callbackContext) {
	        var opts = $.extend({}, defaultOpts, o);
	        opts.callbacks = {
	            'move': bind(opts.move, callbackContext),
	            'change': bind(opts.change, callbackContext),
	            'show': bind(opts.show, callbackContext),
	            'hide': bind(opts.hide, callbackContext),
	            'beforeShow': bind(opts.beforeShow, callbackContext)
	        };

	        return opts;
	    }

	    function spectrum(element, o) {

	        var opts = instanceOptions(o, element),
	            flat = opts.flat,
	            showSelectionPalette = opts.showSelectionPalette,
	            localStorageKey = opts.localStorageKey,
	            theme = opts.theme,
	            callbacks = opts.callbacks,
	            resize = throttle(reflow, 10),
	            visible = false,
	            dragWidth = 0,
	            dragHeight = 0,
	            dragHelperHeight = 0,
	            slideHeight = 0,
	            slideWidth = 0,
	            alphaWidth = 0,
	            alphaSlideHelperWidth = 0,
	            slideHelperHeight = 0,
	            currentHue = 0,
	            currentSaturation = 0,
	            currentValue = 0,
	            currentAlpha = 1,
	            palette = [],
	            paletteArray = [],
	            paletteLookup = {},
	            selectionPalette = opts.selectionPalette.slice(0),
	            maxSelectionSize = opts.maxSelectionSize,
	            draggingClass = "sp-dragging",
	            shiftMovementDirection = null;

	        var doc = element.ownerDocument,
	            body = doc.body,
	            boundElement = $(element),
	            disabled = false,
	            container = $(markup, doc).addClass(theme),
	            dragger = container.find(".sp-color"),
	            dragHelper = container.find(".sp-dragger"),
	            slider = container.find(".sp-hue"),
	            slideHelper = container.find(".sp-slider"),
	            alphaSliderInner = container.find(".sp-alpha-inner"),
	            alphaSlider = container.find(".sp-alpha"),
	            alphaSlideHelper = container.find(".sp-alpha-handle"),
	            textInput = container.find(".sp-input"),
	            paletteContainer = container.find(".sp-palette"),
	            initialColorContainer = container.find(".sp-initial"),
	            cancelButton = container.find(".sp-cancel"),
	            clearButton = container.find(".sp-clear"),
	            chooseButton = container.find(".sp-choose"),
	            isInput = boundElement.is("input"),
	            isInputTypeColor = isInput && inputTypeColorSupport && boundElement.attr("type") === "color",
	            shouldReplace = isInput && !flat,
	            replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
	            offsetElement = (shouldReplace) ? replacer : boundElement,
	            previewElement = replacer.find(".sp-preview-inner"),
	            initialColor = opts.color || (isInput && boundElement.val()),
	            colorOnShow = false,
	            preferredFormat = opts.preferredFormat,
	            currentPreferredFormat = preferredFormat,
	            clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
	            isEmpty = !initialColor,
	            allowEmpty = opts.allowEmpty && !isInputTypeColor;

	        function applyOptions() {

	            if (opts.showPaletteOnly) {
	                opts.showPalette = true;
	            }

	            if (opts.palette) {
	                palette = opts.palette.slice(0);
	                paletteArray = $.isArray(palette[0]) ? palette : [palette];
	                paletteLookup = {};
	                for (var i = 0; i < paletteArray.length; i++) {
	                    for (var j = 0; j < paletteArray[i].length; j++) {
	                        var rgb = tinycolor(paletteArray[i][j]).toRgbString();
	                        paletteLookup[rgb] = true;
	                    }
	                }
	            }

	            container.toggleClass("sp-flat", flat);
	            container.toggleClass("sp-input-disabled", !opts.showInput);
	            container.toggleClass("sp-alpha-enabled", opts.showAlpha);
	            container.toggleClass("sp-clear-enabled", allowEmpty);
	            container.toggleClass("sp-buttons-disabled", !opts.showButtons);
	            container.toggleClass("sp-palette-disabled", !opts.showPalette);
	            container.toggleClass("sp-palette-only", opts.showPaletteOnly);
	            container.toggleClass("sp-initial-disabled", !opts.showInitial);
	            container.addClass(opts.className).addClass(opts.containerClassName);

	            reflow();
	        }

	        function initialize() {

	            if (IE) {
	                container.find("*:not(input)").attr("unselectable", "on");
	            }

	            applyOptions();

	            if (shouldReplace) {
	                boundElement.after(replacer).hide();
	            }

	            if (!allowEmpty) {
	                clearButton.hide();
	            }

	            if (flat) {
	                boundElement.after(container).hide();
	            }
	            else {

	                var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
	                if (appendTo.length !== 1) {
	                    appendTo = $("body");
	                }

	                appendTo.append(container);
	            }

	            updateSelectionPaletteFromStorage();

	            offsetElement.bind("click.spectrum touchstart.spectrum", function (e) {
	                if (!disabled) {
	                    toggle();
	                }

	                e.stopPropagation();

	                if (!$(e.target).is("input")) {
	                    e.preventDefault();
	                }
	            });

	            if(boundElement.is(":disabled") || (opts.disabled === true)) {
	                disable();
	            }

	            // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
	            container.click(stopPropagation);

	            // Handle user typed input
	            textInput.change(setFromTextInput);
	            textInput.bind("paste", function () {
	                setTimeout(setFromTextInput, 1);
	            });
	            textInput.keydown(function (e) { if (e.keyCode == 13) { setFromTextInput(); } });

	            cancelButton.text(opts.cancelText);
	            cancelButton.bind("click.spectrum", function (e) {
	                e.stopPropagation();
	                e.preventDefault();
	                hide("cancel");
	            });

	            clearButton.attr("title", opts.clearText);
	            clearButton.bind("click.spectrum", function (e) {
	                e.stopPropagation();
	                e.preventDefault();
	                isEmpty = true;
	                move();

	                if(flat) {
	                    //for the flat style, this is a change event
	                    updateOriginalInput(true);
	                }
	            });

	            chooseButton.text(opts.chooseText);
	            chooseButton.bind("click.spectrum", function (e) {
	                e.stopPropagation();
	                e.preventDefault();

	                if (isValid()) {
	                    updateOriginalInput(true);
	                    hide();
	                }
	            });

	            draggable(alphaSlider, function (dragX, dragY, e) {
	                currentAlpha = (dragX / alphaWidth);
	                isEmpty = false;
	                if (e.shiftKey) {
	                    currentAlpha = Math.round(currentAlpha * 10) / 10;
	                }

	                move();
	            }, dragStart, dragStop);

	            draggable(slider, function (dragX, dragY) {
	                currentHue = parseFloat(dragY / slideHeight);
	                isEmpty = false;
	                if (!opts.showAlpha) {
	                    currentAlpha = 1;
	                }
	                move();
	            }, dragStart, dragStop);

	            draggable(dragger, function (dragX, dragY, e) {

	                // shift+drag should snap the movement to either the x or y axis.
	                if (!e.shiftKey) {
	                    shiftMovementDirection = null;
	                }
	                else if (!shiftMovementDirection) {
	                    var oldDragX = currentSaturation * dragWidth;
	                    var oldDragY = dragHeight - (currentValue * dragHeight);
	                    var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

	                    shiftMovementDirection = furtherFromX ? "x" : "y";
	                }

	                var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
	                var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

	                if (setSaturation) {
	                    currentSaturation = parseFloat(dragX / dragWidth);
	                }
	                if (setValue) {
	                    currentValue = parseFloat((dragHeight - dragY) / dragHeight);
	                }

	                isEmpty = false;
	                if (!opts.showAlpha) {
	                    currentAlpha = 1;
	                }

	                move();

	            }, dragStart, dragStop);

	            if (!!initialColor) {
	                set(initialColor);

	                // In case color was black - update the preview UI and set the format
	                // since the set function will not run (default color is black).
	                updateUI();
	                currentPreferredFormat = preferredFormat || tinycolor(initialColor).format;

	                addColorToSelectionPalette(initialColor);
	            }
	            else {
	                updateUI();
	            }

	            if (flat) {
	                show();
	            }

	            function palletElementClick(e) {
	                if (e.data && e.data.ignore) {
	                    set($(this).data("color"));
	                    move();
	                }
	                else {
	                    set($(this).data("color"));
	                    move();
	                    updateOriginalInput(true);
	                    hide();
	                }

	                return false;
	            }

	            var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
	            paletteContainer.delegate(".sp-thumb-el", paletteEvent, palletElementClick);
	            initialColorContainer.delegate(".sp-thumb-el:nth-child(1)", paletteEvent, { ignore: true }, palletElementClick);
	        }

	        function updateSelectionPaletteFromStorage() {

	            if (localStorageKey && window.localStorage) {

	                // Migrate old palettes over to new format.  May want to remove this eventually.
	                try {
	                    var oldPalette = window.localStorage[localStorageKey].split(",#");
	                    if (oldPalette.length > 1) {
	                        delete window.localStorage[localStorageKey];
	                        $.each(oldPalette, function(i, c) {
	                             addColorToSelectionPalette(c);
	                        });
	                    }
	                }
	                catch(e) { }

	                try {
	                    selectionPalette = window.localStorage[localStorageKey].split(";");
	                }
	                catch (e) { }
	            }
	        }

	        function addColorToSelectionPalette(color) {
	            if (showSelectionPalette) {
	                var rgb = tinycolor(color).toRgbString();
	                if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
	                    selectionPalette.push(rgb);
	                    while(selectionPalette.length > maxSelectionSize) {
	                        selectionPalette.shift();
	                    }
	                }

	                if (localStorageKey && window.localStorage) {
	                    try {
	                        window.localStorage[localStorageKey] = selectionPalette.join(";");
	                    }
	                    catch(e) { }
	                }
	            }
	        }

	        function getUniqueSelectionPalette() {
	            var unique = [];
	            if (opts.showPalette) {
	                for (i = 0; i < selectionPalette.length; i++) {
	                    var rgb = tinycolor(selectionPalette[i]).toRgbString();

	                    if (!paletteLookup[rgb]) {
	                        unique.push(selectionPalette[i]);
	                    }
	                }
	            }

	            return unique.reverse().slice(0, opts.maxSelectionSize);
	        }

	        function drawPalette() {

	            var currentColor = get();

	            var html = $.map(paletteArray, function (palette, i) {
	                return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts.preferredFormat);
	            });

	            updateSelectionPaletteFromStorage();

	            if (selectionPalette) {
	                html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts.preferredFormat));
	            }

	            paletteContainer.html(html.join(""));
	        }

	        function drawInitial() {
	            if (opts.showInitial) {
	                var initial = colorOnShow;
	                var current = get();
	                initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts.preferredFormat));
	            }
	        }

	        function dragStart() {
	            if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
	                reflow();
	            }
	            container.addClass(draggingClass);
	            shiftMovementDirection = null;
	            boundElement.trigger('dragstart.spectrum', [ get() ]);
	        }

	        function dragStop() {
	            container.removeClass(draggingClass);
	            boundElement.trigger('dragstop.spectrum', [ get() ]);
	        }

	        function setFromTextInput() {

	            var value = textInput.val();

	            if ((value === null || value === "") && allowEmpty) {
	                set(null);
	                updateOriginalInput(true);
	            }
	            else {
	                var tiny = tinycolor(value);
	                if (tiny.ok) {
	                    set(tiny);
	                    updateOriginalInput(true);
	                }
	                else {
	                    textInput.addClass("sp-validation-error");
	                }
	            }
	        }

	        function toggle() {
	            if (visible) {
	                hide();
	            }
	            else {
	                show();
	            }
	        }

	        function show() {
	            var event = $.Event('beforeShow.spectrum');

	            if (visible) {
	                reflow();
	                return;
	            }

	            boundElement.trigger(event, [ get() ]);

	            if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
	                return;
	            }

	            hideAll();
	            visible = true;

	            $(doc).bind("click.spectrum", hide);
	            $(window).bind("resize.spectrum", resize);
	            replacer.addClass("sp-active");
	            container.removeClass("sp-hidden");

	            reflow();
	            updateUI();

	            colorOnShow = get();

	            drawInitial();
	            callbacks.show(colorOnShow);
	            boundElement.trigger('show.spectrum', [ colorOnShow ]);
	        }

	        function hide(e) {

	            // Return on right click
	            if (e && e.type == "click" && e.button == 2) { return; }

	            // Return if hiding is unnecessary
	            if (!visible || flat) { return; }
	            visible = false;

	            $(doc).unbind("click.spectrum", hide);
	            $(window).unbind("resize.spectrum", resize);

	            replacer.removeClass("sp-active");
	            container.addClass("sp-hidden");

	            var colorHasChanged = !tinycolor.equals(get(), colorOnShow);

	            if (colorHasChanged) {
	                if (clickoutFiresChange && e !== "cancel") {
	                    updateOriginalInput(true);
	                }
	                else {
	                    revert();
	                }
	            }

	            callbacks.hide(get());
	            boundElement.trigger('hide.spectrum', [ get() ]);
	        }

	        function revert() {
	            set(colorOnShow, true);
	        }

	        function set(color, ignoreFormatChange) {
	            if (tinycolor.equals(color, get())) {
	                // Update UI just in case a validation error needs
	                // to be cleared.
	                updateUI();
	                return;
	            }

	            var newColor, newHsv;
	            if (!color && allowEmpty) {
	                isEmpty = true;
	            } else {
	                isEmpty = false;
	                newColor = tinycolor(color);
	                newHsv = newColor.toHsv();

	                currentHue = (newHsv.h % 360) / 360;
	                currentSaturation = newHsv.s;
	                currentValue = newHsv.v;
	                currentAlpha = newHsv.a;
	            }
	            updateUI();

	            if (newColor && newColor.ok && !ignoreFormatChange) {
	                currentPreferredFormat = preferredFormat || newColor.format;
	            }
	        }

	        function get(opts) {
	            opts = opts || { };

	            if (allowEmpty && isEmpty) {
	                return null;
	            }

	            return tinycolor.fromRatio({
	                h: currentHue,
	                s: currentSaturation,
	                v: currentValue,
	                a: Math.round(currentAlpha * 100) / 100
	            }, { format: opts.format || currentPreferredFormat });
	        }

	        function isValid() {
	            return !textInput.hasClass("sp-validation-error");
	        }

	        function move() {
	            updateUI();

	            callbacks.move(get());
	            boundElement.trigger('move.spectrum', [ get() ]);
	        }

	        function updateUI() {

	            textInput.removeClass("sp-validation-error");

	            updateHelperLocations();

	            // Update dragger background color (gradients take care of saturation and value).
	            var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
	            dragger.css("background-color", flatColor.toHexString());

	            // Get a format that alpha will be included in (hex and names ignore alpha)
	            var format = currentPreferredFormat;
	            if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
	                if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
	                    format = "rgb";
	                }
	            }

	            var realColor = get({ format: format }),
	                displayColor = '';

	             //reset background info for preview element
	            previewElement.removeClass("sp-clear-display");
	            previewElement.css('background-color', 'transparent');

	            if (!realColor && allowEmpty) {
	                // Update the replaced elements background with icon indicating no color selection
	                previewElement.addClass("sp-clear-display");
	            }
	            else {
	                var realHex = realColor.toHexString(),
	                    realRgb = realColor.toRgbString();

	                // Update the replaced elements background color (with actual selected color)
	                if (rgbaSupport || realColor.alpha === 1) {
	                    previewElement.css("background-color", realRgb);
	                }
	                else {
	                    previewElement.css("background-color", "transparent");
	                    previewElement.css("filter", realColor.toFilter());
	                }

	                if (opts.showAlpha) {
	                    var rgb = realColor.toRgb();
	                    rgb.a = 0;
	                    var realAlpha = tinycolor(rgb).toRgbString();
	                    var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

	                    if (IE) {
	                        alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
	                    }
	                    else {
	                        alphaSliderInner.css("background", "-webkit-" + gradient);
	                        alphaSliderInner.css("background", "-moz-" + gradient);
	                        alphaSliderInner.css("background", "-ms-" + gradient);
	                        // Use current syntax gradient on unprefixed property.
	                        alphaSliderInner.css("background",
	                            "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
	                    }
	                }

	                displayColor = realColor.toString(format);
	            }

	            // Update the text entry input as it changes happen
	            if (opts.showInput) {
	                textInput.val(displayColor);
	            }

	            if (opts.showPalette) {
	                drawPalette();
	            }

	            drawInitial();
	        }

	        function updateHelperLocations() {
	            var s = currentSaturation;
	            var v = currentValue;

	            if(allowEmpty && isEmpty) {
	                //if selected color is empty, hide the helpers
	                alphaSlideHelper.hide();
	                slideHelper.hide();
	                dragHelper.hide();
	            }
	            else {
	                //make sure helpers are visible
	                alphaSlideHelper.show();
	                slideHelper.show();
	                dragHelper.show();

	                // Where to show the little circle in that displays your current selected color
	                var dragX = s * dragWidth;
	                var dragY = dragHeight - (v * dragHeight);
	                dragX = Math.max(
	                    -dragHelperHeight,
	                    Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
	                );
	                dragY = Math.max(
	                    -dragHelperHeight,
	                    Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
	                );
	                dragHelper.css({
	                    "top": dragY + "px",
	                    "left": dragX + "px"
	                });

	                var alphaX = currentAlpha * alphaWidth;
	                alphaSlideHelper.css({
	                    "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
	                });

	                // Where to show the bar that displays your current selected hue
	                var slideY = (currentHue) * slideHeight;
	                slideHelper.css({
	                    "top": (slideY - slideHelperHeight) + "px"
	                });
	            }
	        }

	        function updateOriginalInput(fireCallback) {
	            var color = get(),
	                displayColor = '',
	                hasChanged = !tinycolor.equals(color, colorOnShow);

	            if (color) {
	                displayColor = color.toString(currentPreferredFormat);
	                // Update the selection palette with the current color
	                addColorToSelectionPalette(color);
	            }

	            if (isInput) {
	                boundElement.val(displayColor);
	            }

	            colorOnShow = color;

	            if (fireCallback && hasChanged) {
	                callbacks.change(color);
	                boundElement.trigger('change', [ color ]);
	            }
	        }

	        function reflow() {
	            dragWidth = dragger.width();
	            dragHeight = dragger.height();
	            dragHelperHeight = dragHelper.height();
	            slideWidth = slider.width();
	            slideHeight = slider.height();
	            slideHelperHeight = slideHelper.height();
	            alphaWidth = alphaSlider.width();
	            alphaSlideHelperWidth = alphaSlideHelper.width();

	            if (!flat) {
	                container.css("position", "absolute");
	                container.offset(getOffset(container, offsetElement));
	            }

	            updateHelperLocations();

	            if (opts.showPalette) {
	                drawPalette();
	            }

	            boundElement.trigger('reflow.spectrum');
	        }

	        function destroy() {
	            boundElement.show();
	            offsetElement.unbind("click.spectrum touchstart.spectrum");
	            container.remove();
	            replacer.remove();
	            spectrums[spect.id] = null;
	        }

	        function option(optionName, optionValue) {
	            if (optionName === undefined) {
	                return $.extend({}, opts);
	            }
	            if (optionValue === undefined) {
	                return opts[optionName];
	            }

	            opts[optionName] = optionValue;
	            applyOptions();
	        }

	        function enable() {
	            disabled = false;
	            boundElement.attr("disabled", false);
	            offsetElement.removeClass("sp-disabled");
	        }

	        function disable() {
	            hide();
	            disabled = true;
	            boundElement.attr("disabled", true);
	            offsetElement.addClass("sp-disabled");
	        }

	        initialize();

	        var spect = {
	            show: show,
	            hide: hide,
	            toggle: toggle,
	            reflow: reflow,
	            option: option,
	            enable: enable,
	            disable: disable,
	            set: function (c) {
	                set(c);
	                updateOriginalInput();
	            },
	            get: get,
	            destroy: destroy,
	            container: container
	        };

	        spect.id = spectrums.push(spect) - 1;

	        return spect;
	    }

	    /**
	    * checkOffset - get the offset below/above and left/right element depending on screen position
	    * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
	    */
	    function getOffset(picker, input) {
	        var extraY = 0;
	        var dpWidth = picker.outerWidth();
	        var dpHeight = picker.outerHeight();
	        var inputHeight = input.outerHeight();
	        var doc = picker[0].ownerDocument;
	        var docElem = doc.documentElement;
	        var viewWidth = docElem.clientWidth + $(doc).scrollLeft() - 20;
	        var viewHeight = docElem.clientHeight + $(doc).scrollTop() - 20;
	        var offset = input.offset();
	        offset.top += inputHeight;

	        offset.left -=
	            Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
	            Math.abs(offset.left + dpWidth - viewWidth) : 0);

	        offset.top -=
	            Math.min(offset.top, ((offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
	            Math.abs(dpHeight + inputHeight - extraY) : extraY));

	        return offset;
	    }

	    /**
	    * noop - do nothing
	    */
	    function noop() {

	    }

	    /**
	    * stopPropagation - makes the code only doing this a little easier to read in line
	    */
	    function stopPropagation(e) {
	        e.stopPropagation();
	    }

	    /**
	    * Create a function bound to a given object
	    * Thanks to underscore.js
	    */
	    function bind(func, obj) {
	        var slice = Array.prototype.slice;
	        var args = slice.call(arguments, 2);
	        return function () {
	            return func.apply(obj, args.concat(slice.call(arguments)));
	        };
	    }

	    /**
	    * Lightweight drag helper.  Handles containment within the element, so that
	    * when dragging, the x is within [0,element.width] and y is within [0,element.height]
	    */
	    function draggable(element, onmove, onstart, onstop) {
	        onmove = onmove || function () { };
	        onstart = onstart || function () { };
	        onstop = onstop || function () { };
	        var doc = element.ownerDocument || document;
	        var dragging = false;
	        var offset = {};
	        var maxHeight = 0;
	        var maxWidth = 0;
	        var hasTouch = ('ontouchstart' in window);

	        var duringDragEvents = {};
	        duringDragEvents["selectstart"] = prevent;
	        duringDragEvents["dragstart"] = prevent;
	        duringDragEvents["touchmove mousemove"] = move;
	        duringDragEvents["touchend mouseup"] = stop;

	        function prevent(e) {
	            if (e.stopPropagation) {
	                e.stopPropagation();
	            }
	            if (e.preventDefault) {
	                e.preventDefault();
	            }
	            e.returnValue = false;
	        }

	        function move(e) {
	            if (dragging) {
	                // Mouseup happened outside of window
	                if (IE && document.documentMode < 9 && !e.button) {
	                    return stop();
	                }

	                var touches = e.originalEvent.touches;
	                var pageX = touches ? touches[0].pageX : e.pageX;
	                var pageY = touches ? touches[0].pageY : e.pageY;

	                var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
	                var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

	                if (hasTouch) {
	                    // Stop scrolling in iOS
	                    prevent(e);
	                }

	                onmove.apply(element, [dragX, dragY, e]);
	            }
	        }

	        function start(e) {
	            var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);
	            var touches = e.originalEvent.touches;

	            if (!rightclick && !dragging) {
	                if (onstart.apply(element, arguments) !== false) {
	                    dragging = true;
	                    maxHeight = $(element).height();
	                    maxWidth = $(element).width();
	                    offset = $(element).offset();

	                    $(doc).bind(duringDragEvents);
	                    $(doc.body).addClass("sp-dragging");

	                    if (!hasTouch) {
	                        move(e);
	                    }

	                    prevent(e);
	                }
	            }
	        }

	        function stop() {
	            if (dragging) {
	                $(doc).unbind(duringDragEvents);
	                $(doc.body).removeClass("sp-dragging");
	                onstop.apply(element, arguments);
	            }
	            dragging = false;
	        }

	        $(element).bind("touchstart mousedown", start);
	    }

	    function throttle(func, wait, debounce) {
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            var throttler = function () {
	                timeout = null;
	                func.apply(context, args);
	            };
	            if (debounce) clearTimeout(timeout);
	            if (debounce || !timeout) timeout = setTimeout(throttler, wait);
	        };
	    }

	    function log(){/* jshint -W021 */if(window.console){if(Function.prototype.bind)log=Function.prototype.bind.call(console.log,console);else log=function(){Function.prototype.apply.call(console.log,console,arguments);};log.apply(this,arguments);}}

	    /**
	    * Define a jQuery plugin
	    */
	    var dataID = "spectrum.id";
	    $.fn.spectrum = function (opts, extra) {

	        if (typeof opts == "string") {

	            var returnValue = this;
	            var args = Array.prototype.slice.call( arguments, 1 );

	            this.each(function () {
	                var spect = spectrums[$(this).data(dataID)];
	                if (spect) {
	                    var method = spect[opts];
	                    if (!method) {
	                        throw new Error( "Spectrum: no such method: '" + opts + "'" );
	                    }

	                    if (opts == "get") {
	                        returnValue = spect.get();
	                    }
	                    else if (opts == "container") {
	                        returnValue = spect.container;
	                    }
	                    else if (opts == "option") {
	                        returnValue = spect.option.apply(spect, args);
	                    }
	                    else if (opts == "destroy") {
	                        spect.destroy();
	                        $(this).removeData(dataID);
	                    }
	                    else {
	                        method.apply(spect, args);
	                    }
	                }
	            });

	            return returnValue;
	        }

	        // Initializing a new instance of spectrum
	        return this.spectrum("destroy").each(function () {
	            var options = $.extend({}, opts, $(this).data());
	            var spect = spectrum(this, options);
	            $(this).data(dataID, spect.id);
	        });
	    };

	    $.fn.spectrum.load = true;
	    $.fn.spectrum.loadOpts = {};
	    $.fn.spectrum.draggable = draggable;
	    $.fn.spectrum.defaults = defaultOpts;

	    $.spectrum = { };
	    $.spectrum.localization = { };
	    $.spectrum.palettes = { };

	    $.fn.spectrum.processNativeColorInputs = function () {
	        if (!inputTypeColorSupport) {
	            $("input[type=color]").spectrum({
	                preferredFormat: "hex6"
	            });
	        }
	    };

	    // TinyColor v0.9.17
	    // https://github.com/bgrins/TinyColor
	    // 2013-08-10, Brian Grinstead, MIT License

	    (function() {

	    var trimLeft = /^[\s,#]+/,
	        trimRight = /\s+$/,
	        tinyCounter = 0,
	        math = Math,
	        mathRound = math.round,
	        mathMin = math.min,
	        mathMax = math.max,
	        mathRandom = math.random;

	    function tinycolor (color, opts) {

	        color = (color) ? color : '';
	        opts = opts || { };

	        // If input is already a tinycolor, return itself
	        if (typeof color == "object" && color.hasOwnProperty("_tc_id")) {
	           return color;
	        }

	        var rgb = inputToRGB(color);
	        var r = rgb.r,
	            g = rgb.g,
	            b = rgb.b,
	            a = rgb.a,
	            roundA = mathRound(100*a) / 100,
	            format = opts.format || rgb.format;

	        // Don't let the range of [0,255] come back in [0,1].
	        // Potentially lose a little bit of precision here, but will fix issues where
	        // .5 gets interpreted as half of the total, instead of half of 1
	        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	        if (r < 1) { r = mathRound(r); }
	        if (g < 1) { g = mathRound(g); }
	        if (b < 1) { b = mathRound(b); }

	        return {
	            ok: rgb.ok,
	            format: format,
	            _tc_id: tinyCounter++,
	            alpha: a,
	            getAlpha: function() {
	                return a;
	            },
	            setAlpha: function(value) {
	                a = boundAlpha(value);
	                roundA = mathRound(100*a) / 100;
	            },
	            toHsv: function() {
	                var hsv = rgbToHsv(r, g, b);
	                return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: a };
	            },
	            toHsvString: function() {
	                var hsv = rgbToHsv(r, g, b);
	                var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	                return (a == 1) ?
	                  "hsv("  + h + ", " + s + "%, " + v + "%)" :
	                  "hsva(" + h + ", " + s + "%, " + v + "%, "+ roundA + ")";
	            },
	            toHsl: function() {
	                var hsl = rgbToHsl(r, g, b);
	                return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: a };
	            },
	            toHslString: function() {
	                var hsl = rgbToHsl(r, g, b);
	                var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	                return (a == 1) ?
	                  "hsl("  + h + ", " + s + "%, " + l + "%)" :
	                  "hsla(" + h + ", " + s + "%, " + l + "%, "+ roundA + ")";
	            },
	            toHex: function(allow3Char) {
	                return rgbToHex(r, g, b, allow3Char);
	            },
	            toHexString: function(allow3Char) {
	                return '#' + this.toHex(allow3Char);
	            },
	            toHex8: function() {
	                return rgbaToHex(r, g, b, a);
	            },
	            toHex8String: function() {
	                return '#' + this.toHex8();
	            },
	            toRgb: function() {
	                return { r: mathRound(r), g: mathRound(g), b: mathRound(b), a: a };
	            },
	            toRgbString: function() {
	                return (a == 1) ?
	                  "rgb("  + mathRound(r) + ", " + mathRound(g) + ", " + mathRound(b) + ")" :
	                  "rgba(" + mathRound(r) + ", " + mathRound(g) + ", " + mathRound(b) + ", " + roundA + ")";
	            },
	            toPercentageRgb: function() {
	                return { r: mathRound(bound01(r, 255) * 100) + "%", g: mathRound(bound01(g, 255) * 100) + "%", b: mathRound(bound01(b, 255) * 100) + "%", a: a };
	            },
	            toPercentageRgbString: function() {
	                return (a == 1) ?
	                  "rgb("  + mathRound(bound01(r, 255) * 100) + "%, " + mathRound(bound01(g, 255) * 100) + "%, " + mathRound(bound01(b, 255) * 100) + "%)" :
	                  "rgba(" + mathRound(bound01(r, 255) * 100) + "%, " + mathRound(bound01(g, 255) * 100) + "%, " + mathRound(bound01(b, 255) * 100) + "%, " + roundA + ")";
	            },
	            toName: function() {
	                if (a === 0) {
	                    return "transparent";
	                }

	                return hexNames[rgbToHex(r, g, b, true)] || false;
	            },
	            toFilter: function(secondColor) {
	                var hex8String = '#' + rgbaToHex(r, g, b, a);
	                var secondHex8String = hex8String;
	                var gradientType = opts && opts.gradientType ? "GradientType = 1, " : "";

	                if (secondColor) {
	                    var s = tinycolor(secondColor);
	                    secondHex8String = s.toHex8String();
	                }

	                return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	            },
	            toString: function(format) {
	                var formatSet = !!format;
	                format = format || this.format;

	                var formattedString = false;
	                var hasAlphaAndFormatNotSet = !formatSet && a < 1 && a > 0;
	                var formatWithAlpha = hasAlphaAndFormatNotSet && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

	                if (format === "rgb") {
	                    formattedString = this.toRgbString();
	                }
	                if (format === "prgb") {
	                    formattedString = this.toPercentageRgbString();
	                }
	                if (format === "hex" || format === "hex6") {
	                    formattedString = this.toHexString();
	                }
	                if (format === "hex3") {
	                    formattedString = this.toHexString(true);
	                }
	                if (format === "hex8") {
	                    formattedString = this.toHex8String();
	                }
	                if (format === "name") {
	                    formattedString = this.toName();
	                }
	                if (format === "hsl") {
	                    formattedString = this.toHslString();
	                }
	                if (format === "hsv") {
	                    formattedString = this.toHsvString();
	                }

	                if (formatWithAlpha) {
	                    return this.toRgbString();
	                }

	                return formattedString || this.toHexString();
	            }
	        };
	    }

	    // If input is an object, force 1 into "1.0" to handle ratios properly
	    // String input requires "1.0" as input, so 1 will be treated as 1
	    tinycolor.fromRatio = function(color, opts) {
	        if (typeof color == "object") {
	            var newColor = {};
	            for (var i in color) {
	                if (color.hasOwnProperty(i)) {
	                    if (i === "a") {
	                        newColor[i] = color[i];
	                    }
	                    else {
	                        newColor[i] = convertToPercentage(color[i]);
	                    }
	                }
	            }
	            color = newColor;
	        }

	        return tinycolor(color, opts);
	    };

	    // Given a string or object, convert that input to RGB
	    // Possible string inputs:
	    //
	    //     "red"
	    //     "#f00" or "f00"
	    //     "#ff0000" or "ff0000"
	    //     "#ff000000" or "ff000000"
	    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
	    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	    //
	    function inputToRGB(color) {

	        var rgb = { r: 0, g: 0, b: 0 };
	        var a = 1;
	        var ok = false;
	        var format = false;

	        if (typeof color == "string") {
	            color = stringInputToObject(color);
	        }

	        if (typeof color == "object") {
	            if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
	                rgb = rgbToRgb(color.r, color.g, color.b);
	                ok = true;
	                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	            }
	            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
	                color.s = convertToPercentage(color.s);
	                color.v = convertToPercentage(color.v);
	                rgb = hsvToRgb(color.h, color.s, color.v);
	                ok = true;
	                format = "hsv";
	            }
	            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
	                color.s = convertToPercentage(color.s);
	                color.l = convertToPercentage(color.l);
	                rgb = hslToRgb(color.h, color.s, color.l);
	                ok = true;
	                format = "hsl";
	            }

	            if (color.hasOwnProperty("a")) {
	                a = color.a;
	            }
	        }

	        a = boundAlpha(a);

	        return {
	            ok: ok,
	            format: color.format || format,
	            r: mathMin(255, mathMax(rgb.r, 0)),
	            g: mathMin(255, mathMax(rgb.g, 0)),
	            b: mathMin(255, mathMax(rgb.b, 0)),
	            a: a
	        };
	    }


	    // Conversion Functions
	    // --------------------

	    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

	    // `rgbToRgb`
	    // Handle bounds / percentage checking to conform to CSS color spec
	    // <http://www.w3.org/TR/css3-color/>
	    // *Assumes:* r, g, b in [0, 255] or [0, 1]
	    // *Returns:* { r, g, b } in [0, 255]
	    function rgbToRgb(r, g, b){
	        return {
	            r: bound01(r, 255) * 255,
	            g: bound01(g, 255) * 255,
	            b: bound01(b, 255) * 255
	        };
	    }

	    // `rgbToHsl`
	    // Converts an RGB color value to HSL.
	    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	    // *Returns:* { h, s, l } in [0,1]
	    function rgbToHsl(r, g, b) {

	        r = bound01(r, 255);
	        g = bound01(g, 255);
	        b = bound01(b, 255);

	        var max = mathMax(r, g, b), min = mathMin(r, g, b);
	        var h, s, l = (max + min) / 2;

	        if(max == min) {
	            h = s = 0; // achromatic
	        }
	        else {
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max) {
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }

	            h /= 6;
	        }

	        return { h: h, s: s, l: l };
	    }

	    // `hslToRgb`
	    // Converts an HSL color value to RGB.
	    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	    // *Returns:* { r, g, b } in the set [0, 255]
	    function hslToRgb(h, s, l) {
	        var r, g, b;

	        h = bound01(h, 360);
	        s = bound01(s, 100);
	        l = bound01(l, 100);

	        function hue2rgb(p, q, t) {
	            if(t < 0) t += 1;
	            if(t > 1) t -= 1;
	            if(t < 1/6) return p + (q - p) * 6 * t;
	            if(t < 1/2) return q;
	            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	            return p;
	        }

	        if(s === 0) {
	            r = g = b = l; // achromatic
	        }
	        else {
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }

	        return { r: r * 255, g: g * 255, b: b * 255 };
	    }

	    // `rgbToHsv`
	    // Converts an RGB color value to HSV
	    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	    // *Returns:* { h, s, v } in [0,1]
	    function rgbToHsv(r, g, b) {

	        r = bound01(r, 255);
	        g = bound01(g, 255);
	        b = bound01(b, 255);

	        var max = mathMax(r, g, b), min = mathMin(r, g, b);
	        var h, s, v = max;

	        var d = max - min;
	        s = max === 0 ? 0 : d / max;

	        if(max == min) {
	            h = 0; // achromatic
	        }
	        else {
	            switch(max) {
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	        return { h: h, s: s, v: v };
	    }

	    // `hsvToRgb`
	    // Converts an HSV color value to RGB.
	    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	    // *Returns:* { r, g, b } in the set [0, 255]
	     function hsvToRgb(h, s, v) {

	        h = bound01(h, 360) * 6;
	        s = bound01(s, 100);
	        v = bound01(v, 100);

	        var i = math.floor(h),
	            f = h - i,
	            p = v * (1 - s),
	            q = v * (1 - f * s),
	            t = v * (1 - (1 - f) * s),
	            mod = i % 6,
	            r = [v, q, p, p, t, v][mod],
	            g = [t, v, v, q, p, p][mod],
	            b = [p, p, t, v, v, q][mod];

	        return { r: r * 255, g: g * 255, b: b * 255 };
	    }

	    // `rgbToHex`
	    // Converts an RGB color to hex
	    // Assumes r, g, and b are contained in the set [0, 255]
	    // Returns a 3 or 6 character hex
	    function rgbToHex(r, g, b, allow3Char) {

	        var hex = [
	            pad2(mathRound(r).toString(16)),
	            pad2(mathRound(g).toString(16)),
	            pad2(mathRound(b).toString(16))
	        ];

	        // Return a 3 character hex if possible
	        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	        }

	        return hex.join("");
	    }
	        // `rgbaToHex`
	        // Converts an RGBA color plus alpha transparency to hex
	        // Assumes r, g, b and a are contained in the set [0, 255]
	        // Returns an 8 character hex
	        function rgbaToHex(r, g, b, a) {

	            var hex = [
	                pad2(convertDecimalToHex(a)),
	                pad2(mathRound(r).toString(16)),
	                pad2(mathRound(g).toString(16)),
	                pad2(mathRound(b).toString(16))
	            ];

	            return hex.join("");
	        }

	    // `equals`
	    // Can be called with any tinycolor input
	    tinycolor.equals = function (color1, color2) {
	        if (!color1 || !color2) { return false; }
	        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	    };
	    tinycolor.random = function() {
	        return tinycolor.fromRatio({
	            r: mathRandom(),
	            g: mathRandom(),
	            b: mathRandom()
	        });
	    };


	    // Modification Functions
	    // ----------------------
	    // Thanks to less.js for some of the basics here
	    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

	    tinycolor.desaturate = function (color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.s -= amount / 100;
	        hsl.s = clamp01(hsl.s);
	        return tinycolor(hsl);
	    };
	    tinycolor.saturate = function (color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.s += amount / 100;
	        hsl.s = clamp01(hsl.s);
	        return tinycolor(hsl);
	    };
	    tinycolor.greyscale = function(color) {
	        return tinycolor.desaturate(color, 100);
	    };
	    tinycolor.lighten = function(color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.l += amount / 100;
	        hsl.l = clamp01(hsl.l);
	        return tinycolor(hsl);
	    };
	    tinycolor.darken = function (color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.l -= amount / 100;
	        hsl.l = clamp01(hsl.l);
	        return tinycolor(hsl);
	    };
	    tinycolor.complement = function(color) {
	        var hsl = tinycolor(color).toHsl();
	        hsl.h = (hsl.h + 180) % 360;
	        return tinycolor(hsl);
	    };


	    // Combination Functions
	    // ---------------------
	    // Thanks to jQuery xColor for some of the ideas behind these
	    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

	    tinycolor.triad = function(color) {
	        var hsl = tinycolor(color).toHsl();
	        var h = hsl.h;
	        return [
	            tinycolor(color),
	            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	        ];
	    };
	    tinycolor.tetrad = function(color) {
	        var hsl = tinycolor(color).toHsl();
	        var h = hsl.h;
	        return [
	            tinycolor(color),
	            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	        ];
	    };
	    tinycolor.splitcomplement = function(color) {
	        var hsl = tinycolor(color).toHsl();
	        var h = hsl.h;
	        return [
	            tinycolor(color),
	            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	        ];
	    };
	    tinycolor.analogous = function(color, results, slices) {
	        results = results || 6;
	        slices = slices || 30;

	        var hsl = tinycolor(color).toHsl();
	        var part = 360 / slices;
	        var ret = [tinycolor(color)];

	        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	            hsl.h = (hsl.h + part) % 360;
	            ret.push(tinycolor(hsl));
	        }
	        return ret;
	    };
	    tinycolor.monochromatic = function(color, results) {
	        results = results || 6;
	        var hsv = tinycolor(color).toHsv();
	        var h = hsv.h, s = hsv.s, v = hsv.v;
	        var ret = [];
	        var modification = 1 / results;

	        while (results--) {
	            ret.push(tinycolor({ h: h, s: s, v: v}));
	            v = (v + modification) % 1;
	        }

	        return ret;
	    };


	    // Readability Functions
	    // ---------------------
	    // <http://www.w3.org/TR/AERT#color-contrast>

	    // `readability`
	    // Analyze the 2 colors and returns an object with the following properties:
	    //    `brightness`: difference in brightness between the two colors
	    //    `color`: difference in color/hue between the two colors
	    tinycolor.readability = function(color1, color2) {
	        var a = tinycolor(color1).toRgb();
	        var b = tinycolor(color2).toRgb();
	        var brightnessA = (a.r * 299 + a.g * 587 + a.b * 114) / 1000;
	        var brightnessB = (b.r * 299 + b.g * 587 + b.b * 114) / 1000;
	        var colorDiff = (
	            Math.max(a.r, b.r) - Math.min(a.r, b.r) +
	            Math.max(a.g, b.g) - Math.min(a.g, b.g) +
	            Math.max(a.b, b.b) - Math.min(a.b, b.b)
	        );

	        return {
	            brightness: Math.abs(brightnessA - brightnessB),
	            color: colorDiff
	        };
	    };

	    // `readable`
	    // http://www.w3.org/TR/AERT#color-contrast
	    // Ensure that foreground and background color combinations provide sufficient contrast.
	    // *Example*
	    //    tinycolor.readable("#000", "#111") => false
	    tinycolor.readable = function(color1, color2) {
	        var readability = tinycolor.readability(color1, color2);
	        return readability.brightness > 125 && readability.color > 500;
	    };

	    // `mostReadable`
	    // Given a base color and a list of possible foreground or background
	    // colors for that base, returns the most readable color.
	    // *Example*
	    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
	    tinycolor.mostReadable = function(baseColor, colorList) {
	        var bestColor = null;
	        var bestScore = 0;
	        var bestIsReadable = false;
	        for (var i=0; i < colorList.length; i++) {

	            // We normalize both around the "acceptable" breaking point,
	            // but rank brightness constrast higher than hue.

	            var readability = tinycolor.readability(baseColor, colorList[i]);
	            var readable = readability.brightness > 125 && readability.color > 500;
	            var score = 3 * (readability.brightness / 125) + (readability.color / 500);

	            if ((readable && ! bestIsReadable) ||
	                (readable && bestIsReadable && score > bestScore) ||
	                ((! readable) && (! bestIsReadable) && score > bestScore)) {
	                bestIsReadable = readable;
	                bestScore = score;
	                bestColor = tinycolor(colorList[i]);
	            }
	        }
	        return bestColor;
	    };


	    // Big List of Colors
	    // ------------------
	    // <http://www.w3.org/TR/css3-color/#svg-color>
	    var names = tinycolor.names = {
	        aliceblue: "f0f8ff",
	        antiquewhite: "faebd7",
	        aqua: "0ff",
	        aquamarine: "7fffd4",
	        azure: "f0ffff",
	        beige: "f5f5dc",
	        bisque: "ffe4c4",
	        black: "000",
	        blanchedalmond: "ffebcd",
	        blue: "00f",
	        blueviolet: "8a2be2",
	        brown: "a52a2a",
	        burlywood: "deb887",
	        burntsienna: "ea7e5d",
	        cadetblue: "5f9ea0",
	        chartreuse: "7fff00",
	        chocolate: "d2691e",
	        coral: "ff7f50",
	        cornflowerblue: "6495ed",
	        cornsilk: "fff8dc",
	        crimson: "dc143c",
	        cyan: "0ff",
	        darkblue: "00008b",
	        darkcyan: "008b8b",
	        darkgoldenrod: "b8860b",
	        darkgray: "a9a9a9",
	        darkgreen: "006400",
	        darkgrey: "a9a9a9",
	        darkkhaki: "bdb76b",
	        darkmagenta: "8b008b",
	        darkolivegreen: "556b2f",
	        darkorange: "ff8c00",
	        darkorchid: "9932cc",
	        darkred: "8b0000",
	        darksalmon: "e9967a",
	        darkseagreen: "8fbc8f",
	        darkslateblue: "483d8b",
	        darkslategray: "2f4f4f",
	        darkslategrey: "2f4f4f",
	        darkturquoise: "00ced1",
	        darkviolet: "9400d3",
	        deeppink: "ff1493",
	        deepskyblue: "00bfff",
	        dimgray: "696969",
	        dimgrey: "696969",
	        dodgerblue: "1e90ff",
	        firebrick: "b22222",
	        floralwhite: "fffaf0",
	        forestgreen: "228b22",
	        fuchsia: "f0f",
	        gainsboro: "dcdcdc",
	        ghostwhite: "f8f8ff",
	        gold: "ffd700",
	        goldenrod: "daa520",
	        gray: "808080",
	        green: "008000",
	        greenyellow: "adff2f",
	        grey: "808080",
	        honeydew: "f0fff0",
	        hotpink: "ff69b4",
	        indianred: "cd5c5c",
	        indigo: "4b0082",
	        ivory: "fffff0",
	        khaki: "f0e68c",
	        lavender: "e6e6fa",
	        lavenderblush: "fff0f5",
	        lawngreen: "7cfc00",
	        lemonchiffon: "fffacd",
	        lightblue: "add8e6",
	        lightcoral: "f08080",
	        lightcyan: "e0ffff",
	        lightgoldenrodyellow: "fafad2",
	        lightgray: "d3d3d3",
	        lightgreen: "90ee90",
	        lightgrey: "d3d3d3",
	        lightpink: "ffb6c1",
	        lightsalmon: "ffa07a",
	        lightseagreen: "20b2aa",
	        lightskyblue: "87cefa",
	        lightslategray: "789",
	        lightslategrey: "789",
	        lightsteelblue: "b0c4de",
	        lightyellow: "ffffe0",
	        lime: "0f0",
	        limegreen: "32cd32",
	        linen: "faf0e6",
	        magenta: "f0f",
	        maroon: "800000",
	        mediumaquamarine: "66cdaa",
	        mediumblue: "0000cd",
	        mediumorchid: "ba55d3",
	        mediumpurple: "9370db",
	        mediumseagreen: "3cb371",
	        mediumslateblue: "7b68ee",
	        mediumspringgreen: "00fa9a",
	        mediumturquoise: "48d1cc",
	        mediumvioletred: "c71585",
	        midnightblue: "191970",
	        mintcream: "f5fffa",
	        mistyrose: "ffe4e1",
	        moccasin: "ffe4b5",
	        navajowhite: "ffdead",
	        navy: "000080",
	        oldlace: "fdf5e6",
	        olive: "808000",
	        olivedrab: "6b8e23",
	        orange: "ffa500",
	        orangered: "ff4500",
	        orchid: "da70d6",
	        palegoldenrod: "eee8aa",
	        palegreen: "98fb98",
	        paleturquoise: "afeeee",
	        palevioletred: "db7093",
	        papayawhip: "ffefd5",
	        peachpuff: "ffdab9",
	        peru: "cd853f",
	        pink: "ffc0cb",
	        plum: "dda0dd",
	        powderblue: "b0e0e6",
	        purple: "800080",
	        red: "f00",
	        rosybrown: "bc8f8f",
	        royalblue: "4169e1",
	        saddlebrown: "8b4513",
	        salmon: "fa8072",
	        sandybrown: "f4a460",
	        seagreen: "2e8b57",
	        seashell: "fff5ee",
	        sienna: "a0522d",
	        silver: "c0c0c0",
	        skyblue: "87ceeb",
	        slateblue: "6a5acd",
	        slategray: "708090",
	        slategrey: "708090",
	        snow: "fffafa",
	        springgreen: "00ff7f",
	        steelblue: "4682b4",
	        tan: "d2b48c",
	        teal: "008080",
	        thistle: "d8bfd8",
	        tomato: "ff6347",
	        turquoise: "40e0d0",
	        violet: "ee82ee",
	        wheat: "f5deb3",
	        white: "fff",
	        whitesmoke: "f5f5f5",
	        yellow: "ff0",
	        yellowgreen: "9acd32"
	    };

	    // Make it easy to access colors via `hexNames[hex]`
	    var hexNames = tinycolor.hexNames = flip(names);


	    // Utilities
	    // ---------

	    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	    function flip(o) {
	        var flipped = { };
	        for (var i in o) {
	            if (o.hasOwnProperty(i)) {
	                flipped[o[i]] = i;
	            }
	        }
	        return flipped;
	    }

	    // Return a valid alpha value [0,1] with all invalid values being set to 1
	    function boundAlpha(a) {
	        a = parseFloat(a);

	        if (isNaN(a) || a < 0 || a > 1) {
	            a = 1;
	        }

	        return a;
	    }

	    // Take input from [0, n] and return it as [0, 1]
	    function bound01(n, max) {
	        if (isOnePointZero(n)) { n = "100%"; }

	        var processPercent = isPercentage(n);
	        n = mathMin(max, mathMax(0, parseFloat(n)));

	        // Automatically convert percentage into number
	        if (processPercent) {
	            n = parseInt(n * max, 10) / 100;
	        }

	        // Handle floating point rounding errors
	        if ((math.abs(n - max) < 0.000001)) {
	            return 1;
	        }

	        // Convert into [0, 1] range if it isn't already
	        return (n % max) / parseFloat(max);
	    }

	    // Force a number between 0 and 1
	    function clamp01(val) {
	        return mathMin(1, mathMax(0, val));
	    }

	    // Parse a base-16 hex value into a base-10 integer
	    function parseIntFromHex(val) {
	        return parseInt(val, 16);
	    }

	    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	    function isOnePointZero(n) {
	        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	    }

	    // Check to see if string passed in is a percentage
	    function isPercentage(n) {
	        return typeof n === "string" && n.indexOf('%') != -1;
	    }

	    // Force a hex value to have 2 characters
	    function pad2(c) {
	        return c.length == 1 ? '0' + c : '' + c;
	    }

	    // Replace a decimal with it's percentage value
	    function convertToPercentage(n) {
	        if (n <= 1) {
	            n = (n * 100) + "%";
	        }

	        return n;
	    }

	    // Converts a decimal to a hex value
	    function convertDecimalToHex(d) {
	        return Math.round(parseFloat(d) * 255).toString(16);
	    }
	    // Converts a hex value to a decimal
	    function convertHexToDecimal(h) {
	        return (parseIntFromHex(h) / 255);
	    }

	    var matchers = (function() {

	        // <http://www.w3.org/TR/css3-values/#integers>
	        var CSS_INTEGER = "[-\\+]?\\d+%?";

	        // <http://www.w3.org/TR/css3-values/#number-value>
	        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

	        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

	        // Actual matching.
	        // Parentheses and commas are optional, but not required.
	        // Whitespace can take the place of commas or opening paren
	        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

	        return {
	            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	        };
	    })();

	    // `stringInputToObject`
	    // Permissive string parsing.  Take in a number of formats, and output an object
	    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	    function stringInputToObject(color) {

	        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	        var named = false;
	        if (names[color]) {
	            color = names[color];
	            named = true;
	        }
	        else if (color == 'transparent') {
	            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	        }

	        // Try to match string input using regular expressions.
	        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	        // Just return an object and let the conversion functions handle that.
	        // This way the result will be the same whether the tinycolor is initialized with string or object.
	        var match;
	        if ((match = matchers.rgb.exec(color))) {
	            return { r: match[1], g: match[2], b: match[3] };
	        }
	        if ((match = matchers.rgba.exec(color))) {
	            return { r: match[1], g: match[2], b: match[3], a: match[4] };
	        }
	        if ((match = matchers.hsl.exec(color))) {
	            return { h: match[1], s: match[2], l: match[3] };
	        }
	        if ((match = matchers.hsla.exec(color))) {
	            return { h: match[1], s: match[2], l: match[3], a: match[4] };
	        }
	        if ((match = matchers.hsv.exec(color))) {
	            return { h: match[1], s: match[2], v: match[3] };
	        }
	        if ((match = matchers.hex8.exec(color))) {
	            return {
	                a: convertHexToDecimal(match[1]),
	                r: parseIntFromHex(match[2]),
	                g: parseIntFromHex(match[3]),
	                b: parseIntFromHex(match[4]),
	                format: named ? "name" : "hex8"
	            };
	        }
	        if ((match = matchers.hex6.exec(color))) {
	            return {
	                r: parseIntFromHex(match[1]),
	                g: parseIntFromHex(match[2]),
	                b: parseIntFromHex(match[3]),
	                format: named ? "name" : "hex"
	            };
	        }
	        if ((match = matchers.hex3.exec(color))) {
	            return {
	                r: parseIntFromHex(match[1] + '' + match[1]),
	                g: parseIntFromHex(match[2] + '' + match[2]),
	                b: parseIntFromHex(match[3] + '' + match[3]),
	                format: named ? "name" : "hex"
	            };
	        }

	        return false;
	    }

	    // Expose tinycolor to window, does not need to run in non-browser context.
	    window.tinycolor = tinycolor;

	    })();


	    $(function () {
	        if ($.fn.spectrum.load) {
	            $.fn.spectrum.processNativeColorInputs();
	        }
	    });

	})(window, jQuery);

	};

/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * jqPropertyGrid
	 * https://github.com/ValYouW/jqPropertyGrid
	 * Author: YuvalW (ValYouW)
	 * License: MIT
	 */

	/* jshint -W089 */
	module.exports = function($) {
	    var OTHER_GROUP_NAME = 'Other';
	    var GET_VALS_FUNC_KEY = 'pg.getValues';
	    var pgIdSequence = 0;

	    /**
	     * Generates the property grid
	     * @param {object} obj - The object whose properties we want to display
	     * @param {object} meta - A metadata object describing the obj properties
	     */
	    $.fn.jqPropertyGrid = function(obj, meta) {
	        // Check if the user called the 'get' function (to get the values back from the grid).
	        if (typeof obj === 'string' && obj === 'get') {
	            if (typeof this.data(GET_VALS_FUNC_KEY) === 'function') {
	                return this.data(GET_VALS_FUNC_KEY)();
	            }
	            return null;
	        } else if (typeof obj === 'string') {
	            console.error('jqPropertyGrid got invalid option:', obj);
	            return;
	        } else if (typeof obj !== 'object' || obj === null) {
	            console.error('jqPropertyGrid must get an object in order to initialize the grid.');
	            return;
	        }

	        // Seems like we are ok to create the grid
	        meta = meta && typeof meta === 'object' ? meta : {};
	        var propertyRowsHTML = { OTHER_GROUP_NAME: '' };
	        var groupsHeaderRowHTML = { };
	        var postCreateInitFuncs = [];
	        var getValueFuncs = {};
	        var pgId = 'pg' + (pgIdSequence++);

	        var currGroup;
	        for (var prop in obj) {
	            // Skip if this is not a direct property, a function, or its meta says it's non browsable
	            if (!obj.hasOwnProperty(prop) || typeof obj[prop] === 'function' || (meta[prop] && meta[prop].browsable === false)) {
	                continue;
	            }

	            // Check what is the group of the current property or use the default 'Other' group
	            currGroup = (meta[prop] && meta[prop].group) || OTHER_GROUP_NAME;

	            // If this is the first time we run into this group create the group row
	            if (currGroup !== OTHER_GROUP_NAME && !groupsHeaderRowHTML[currGroup]) {
	                groupsHeaderRowHTML[currGroup] = getGroupHeaderRowHtml(currGroup);
	            }

	            // Initialize the group cells html
	            propertyRowsHTML[currGroup] = propertyRowsHTML[currGroup] || '';

	            // Append the current cell html into the group html
	            propertyRowsHTML[currGroup] += getPropertyRowHtml(pgId, prop, obj[prop], meta[prop], postCreateInitFuncs, getValueFuncs);
	        }

	        // Now we have all the html we need, just assemble it
	        var innerHTML = '<table class="pgTable">';
	        for (var group in groupsHeaderRowHTML) {
	            // Add the group row
	            innerHTML += groupsHeaderRowHTML[group];
	            // Add the group cells
	            innerHTML += propertyRowsHTML[group];
	        }

	        // Finally we add the 'Other' group (if we have something there)
	        if (propertyRowsHTML[OTHER_GROUP_NAME]) {
	            innerHTML += getGroupHeaderRowHtml(OTHER_GROUP_NAME);
	            innerHTML += propertyRowsHTML[OTHER_GROUP_NAME];
	        }

	        // Close the table and apply it to the div
	        innerHTML += '</table>';
	        this.html(innerHTML);

	        // Call the post init functions
	        for (var i = 0; i < postCreateInitFuncs.length; ++i) {
	            if (typeof postCreateInitFuncs[i] === 'function') {
	                postCreateInitFuncs[i]();
	                // just in case make sure we are not holding any reference to the functions
	                postCreateInitFuncs[i] = null;
	            }
	        }

	        // Create a function that will return tha values back from the property grid
	        var getValues = function() {
	            var result = {};
	            for (var prop in getValueFuncs) {
	                if (typeof getValueFuncs[prop] !== 'function') {continue;}
	                result[prop] = getValueFuncs[prop]();
	            }

	            return result;
	        };

	        this.data(GET_VALS_FUNC_KEY, getValues);
	    };

	    /**
	     * Gets the html of a group header row
	     * @param {string} displayName - The group display name
	     */
	    function getGroupHeaderRowHtml(displayName) {
	        return '<tr class="pgGroupRow"><td colspan="2" class="pgGroupCell">' + displayName + '</td></tr>';
	    }

	    /**
	     * Gets the html of a specific property row
	     * @param {string} pgId - The property-grid id being rendered
	     * @param {string} name - The property name
	     * @param {*} value - The current property value
	     * @param {object} meta - A metadata object describing this property
	     * @param {function[]} [postCreateInitFuncs] - An array to fill with functions to run after the grid was created
	     * @param {object.<string, function>} [getValueFuncs] - A dictionary where the key is the property name and the value is a function to retrieve the propery selected value
	     */
	    function getPropertyRowHtml(pgId, name, value, meta, postCreateInitFuncs, getValueFuncs) {
	        if (!name) {return '';}
	        meta = meta || {};
	        // We use the name in the meta if available
	        var displayName = meta.name || name;
	        var type = meta.type || '';
	        var elemId = pgId + name;

	        var valueHTML;

	        // If boolean create checkbox
	        if (type === 'boolean' || (type === '' && typeof value === 'boolean')) {
	            valueHTML = '<input type="checkbox" id="' + elemId + '" value="' + name + '"' + (value ? ' checked' : '') + ' />';
	            if (getValueFuncs) { getValueFuncs[name] = function() {return $('#'+elemId).prop('checked');}; }

	        // If options create drop-down list
	        } else if (type === 'options' && Array.isArray(meta.options)) {
	            valueHTML = getSelectOptionHtml(elemId, value, meta.options);
	            if (getValueFuncs) { getValueFuncs[name] = function() {return $('#'+elemId).val();}; }

	        // If number and a jqueryUI spinner is loaded use it
	        } else if (typeof $.fn.spinner === 'function' && (type === 'number' || (type === '' && typeof value === 'number'))) {
	            valueHTML = '<input type="text" id="' + elemId + '" value="' + value + '" style="width:50px" />';
	            if (postCreateInitFuncs) { postCreateInitFuncs.push(initSpinner(elemId, meta.options)); }
	            if (getValueFuncs) { getValueFuncs[name] = function() {return $('#'+elemId).spinner('value');}; }

	        // If color and we have the spectrum color picker use it
	        } else if (type === 'color' && typeof $.fn.spectrum === 'function') {
	            valueHTML = '<input type="text" id="' + elemId + '" />';
	            if (postCreateInitFuncs) { postCreateInitFuncs.push(initColorPicker(elemId, value, meta.options)); }
	            if (getValueFuncs) { 
	                getValueFuncs[name] = function() {
	                    var spectrumVal = $('#'+elemId).spectrum('get');
	                    if (!spectrumVal) return '';
	                    return spectrumVal.toHexString();
	                }; 
	            }

	        // If label (for read-only)
	            } else if (type === 'label') {
	            if (typeof meta.description === 'string' && meta.description) {
	                        valueHTML = '<label for="' + elemId + '" title="' + meta.description + '">' + value + '</label>';
	                    } else {
	                        valueHTML = '<label for="' + elemId + '">' + value + '</label>';
	            }

	        // Default is textbox
	        } else {
	            valueHTML = '<input type="text" id="' + elemId + '" value="' + value + '"</input>';
	            if (getValueFuncs) { getValueFuncs[name] = function() {return $('#'+elemId).val();}; }
	        }

	        if (typeof meta.description === 'string' && meta.description && 
	           (typeof meta.showHelp === 'undefined' || meta.showHelp)) {
	            displayName += '<span class="pgTooltip" title="' + meta.description + '">[?]</span>';
	        }

	        return '<tr class="pgRow"><td class="pgCell">' + displayName + '</td><td class="pgCell">' + valueHTML + '</td></tr>';
	    }

	    /**
	     * Gets a select-option (dropdown) html
	     * @param {string} id - The select element id
	     * @param {string} [selectedValue] - The current selected value
	     * @param {*[]} options - An array of option. An element can be an object with value/text pairs, or just a string which is both the value and text
	     * @returns {string} The select element html
	     */
	    function getSelectOptionHtml(id, selectedValue, options) {
	        id = id || '';
	        selectedValue = selectedValue || '';
	        options = options || [];

	        var html = '<select';
	        if (id) {html += ' id="' + id + '"';}
	        html += '>';

	        var text, value;
	        for (var i = 0; i < options.length; i++) {
	            value = typeof options[i] === 'object' ? options[i].value : options[i];
	            text = typeof options[i] === 'object' ? options[i].text : options[i];

	            html += '<option value="' + value + '"' + (selectedValue === value ? ' selected>' : '>');
	            html += text + '</option>';
	        }

	        html += '</select>';
	        return html;
	    }

	    /**
	     * Gets an init function to a number textbox
	     * @param {string} id - The number textbox id
	     * @param {object} [options] - The spinner options
	     * @returns {function}
	     */
	    function initSpinner(id, options) {
	        if (!id) {return null;}
	        // Copy the options so we won't change the user "copy"
	        var opts = {};
	        $.extend(opts, options);

	        // Add a handler to the change event to verify the min/max (only if not provided by the user)
	        opts.change = typeof opts.change === 'undefined' ? onSpinnerChange : opts.change;

	        return function() {
	            $('#' + id).spinner(opts);
	        };
	    }

	    /**
	     * Gets an init function to a color textbox
	     * @param {string} id - The color textbox id
	     * @param {string} [color] - The current color (e.g #000000)
	     * @param {object} [options] - The color picker options
	     * @returns {function}
	     */
	    function initColorPicker(id, color, options) {
	        if (!id) {return null;}
	        var opts = {};
	        $.extend(opts, options);
	        if (typeof color === 'string') {opts.color = color;}
	        return function() {
	            $('#' + id).spectrum(opts);
	        };
	    }

	    /**
	     * Handler for the spinner change event
	     */
	    function onSpinnerChange() {
	        var $spinner = $(this);
	        var value = $spinner.spinner('value');

	        // If the value is null and the real value in the textbox is string we empty the textbox
	        if (value === null && typeof $spinner.val() === 'string') {
	            $spinner.val('');
	            return;
	        }

	        // Now check that the number is in the min/max range.
	        var min = $spinner.spinner('option', 'min');
	        var max = $spinner.spinner('option', 'max');
	        if (typeof min === 'number' && this.value < min) {
	            this.value = min;
	            return;
	        }

	        if (typeof max === 'number' && this.value > max) {
	            this.value = max;
	        }
	    }
	};

/***/ },
/* 329 */
/***/ function(module, exports) {

	/* =========================================================
	 * bootstrap-datepicker.js
	 * Repo: https://github.com/eternicode/bootstrap-datepicker/
	 * Demo: http://eternicode.github.io/bootstrap-datepicker/
	 * Docs: http://bootstrap-datepicker.readthedocs.org/
	 * Forked from http://www.eyecon.ro/bootstrap-datepicker
	 * =========================================================
	 * Started by Stefan Petre; improvements by Andrew Rowls + contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ========================================================= */
	module.exports = function(jQuery) {
	(function($, undefined){

		var $window = $(window);

		function UTCDate(){
			return new Date(Date.UTC.apply(Date, arguments));
		}
		function UTCToday(){
			var today = new Date();
			return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
		}
		function alias(method){
			return function(){
				return this[method].apply(this, arguments);
			};
		}

		var DateArray = (function(){
			var extras = {
				get: function(i){
					return this.slice(i)[0];
				},
				contains: function(d){
					// Array.indexOf is not cross-browser;
					// $.inArray doesn't work with Dates
					var val = d && d.valueOf();
					for (var i=0, l=this.length; i < l; i++)
						if (this[i].valueOf() === val)
							return i;
					return -1;
				},
				remove: function(i){
					this.splice(i,1);
				},
				replace: function(new_array){
					if (!new_array)
						return;
					if (!$.isArray(new_array))
						new_array = [new_array];
					this.clear();
					this.push.apply(this, new_array);
				},
				clear: function(){
					this.length = 0;
				},
				copy: function(){
					var a = new DateArray();
					a.replace(this);
					return a;
				}
			};

			return function(){
				var a = [];
				a.push.apply(a, arguments);
				$.extend(a, extras);
				return a;
			};
		})();


		// Picker object

		var Datepicker = function(element, options){
			this.dates = new DateArray();
			this.viewDate = UTCToday();
			this.focusDate = null;

			this._process_options(options);

			this.element = $(element);
			this.isInline = false;
			this.isInput = this.element.is('input');
			this.component = this.element.is('.date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
			this.hasInput = this.component && this.element.find('input').length;
			if (this.component && this.component.length === 0)
				this.component = false;

			this.picker = $(DPGlobal.template);
			this._buildEvents();
			this._attachEvents();

			if (this.isInline){
				this.picker.addClass('datepicker-inline').appendTo(this.element);
			}
			else {
				this.picker.addClass('datepicker-dropdown dropdown-menu');
			}

			if (this.o.rtl){
				this.picker.addClass('datepicker-rtl');
			}

			this.viewMode = this.o.startView;

			if (this.o.calendarWeeks)
				this.picker.find('tfoot th.today')
							.attr('colspan', function(i, val){
								return parseInt(val) + 1;
							});

			this._allow_update = false;

			this.setStartDate(this._o.startDate);
			this.setEndDate(this._o.endDate);
			this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);

			this.fillDow();
			this.fillMonths();

			this._allow_update = true;

			this.update();
			this.showMode();

			if (this.isInline){
				this.show();
			}
		};

		Datepicker.prototype = {
			constructor: Datepicker,

			_process_options: function(opts){
				// Store raw options for reference
				this._o = $.extend({}, this._o, opts);
				// Processed options
				var o = this.o = $.extend({}, this._o);

				// Check if "de-DE" style date is available, if not language should
				// fallback to 2 letter code eg "de"
				var lang = o.language;
				if (!dates[lang]){
					lang = lang.split('-')[0];
					if (!dates[lang])
						lang = defaults.language;
				}
				o.language = lang;

				switch (o.startView){
					case 2:
					case 'decade':
						o.startView = 2;
						break;
					case 1:
					case 'year':
						o.startView = 1;
						break;
					default:
						o.startView = 0;
				}

				switch (o.minViewMode){
					case 1:
					case 'months':
						o.minViewMode = 1;
						break;
					case 2:
					case 'years':
						o.minViewMode = 2;
						break;
					default:
						o.minViewMode = 0;
				}

				o.startView = Math.max(o.startView, o.minViewMode);

				// true, false, or Number > 0
				if (o.multidate !== true){
					o.multidate = Number(o.multidate) || false;
					if (o.multidate !== false)
						o.multidate = Math.max(0, o.multidate);
					else
						o.multidate = 1;
				}
				o.multidateSeparator = String(o.multidateSeparator);

				o.weekStart %= 7;
				o.weekEnd = ((o.weekStart + 6) % 7);

				var format = DPGlobal.parseFormat(o.format);
				if (o.startDate !== -Infinity){
					if (!!o.startDate){
						if (o.startDate instanceof Date)
							o.startDate = this._local_to_utc(this._zero_time(o.startDate));
						else
							o.startDate = DPGlobal.parseDate(o.startDate, format, o.language);
					}
					else {
						o.startDate = -Infinity;
					}
				}
				if (o.endDate !== Infinity){
					if (!!o.endDate){
						if (o.endDate instanceof Date)
							o.endDate = this._local_to_utc(this._zero_time(o.endDate));
						else
							o.endDate = DPGlobal.parseDate(o.endDate, format, o.language);
					}
					else {
						o.endDate = Infinity;
					}
				}

				o.daysOfWeekDisabled = o.daysOfWeekDisabled||[];
				if (!$.isArray(o.daysOfWeekDisabled))
					o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
				o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function(d){
					return parseInt(d, 10);
				});

				var plc = String(o.orientation).toLowerCase().split(/\s+/g),
					_plc = o.orientation.toLowerCase();
				plc = $.grep(plc, function(word){
					return (/^auto|left|right|top|bottom$/).test(word);
				});
				o.orientation = {x: 'auto', y: 'auto'};
				if (!_plc || _plc === 'auto')
					; // no action
				else if (plc.length === 1){
					switch (plc[0]){
						case 'top':
						case 'bottom':
							o.orientation.y = plc[0];
							break;
						case 'left':
						case 'right':
							o.orientation.x = plc[0];
							break;
					}
				}
				else {
					_plc = $.grep(plc, function(word){
						return (/^left|right$/).test(word);
					});
					o.orientation.x = _plc[0] || 'auto';

					_plc = $.grep(plc, function(word){
						return (/^top|bottom$/).test(word);
					});
					o.orientation.y = _plc[0] || 'auto';
				}
			},
			_events: [],
			_secondaryEvents: [],
			_applyEvents: function(evs){
				for (var i=0, el, ch, ev; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					}
					else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			},
			_unapplyEvents: function(evs){
				for (var i=0, el, ev, ch; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					}
					else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			},
			_buildEvents: function(){
				if (this.isInput){ // single input
					this._events = [
						[this.element, {
							focus: $.proxy(this.show, this),
							keyup: $.proxy(function(e){
								if ($.inArray(e.keyCode, [27,37,39,38,40,32,13,9]) === -1)
									this.update();
							}, this),
							keydown: $.proxy(this.keydown, this)
						}]
					];
				}
				else if (this.component && this.hasInput){ // component: input + button
					this._events = [
						// For components that are not readonly, allow keyboard nav
						[this.element.find('input'), {
							focus: $.proxy(this.show, this),
							keyup: $.proxy(function(e){
								if ($.inArray(e.keyCode, [27,37,39,38,40,32,13,9]) === -1)
									this.update();
							}, this),
							keydown: $.proxy(this.keydown, this)
						}],
						[this.component, {
							click: $.proxy(this.show, this)
						}]
					];
				}
				else if (this.element.is('div')){  // inline datepicker
					this.isInline = true;
				}
				else {
					this._events = [
						[this.element, {
							click: $.proxy(this.show, this)
						}]
					];
				}
				this._events.push(
					// Component: listen for blur on element descendants
					[this.element, '*', {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}],
					// Input: listen for blur on element
					[this.element, {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}]
				);

				this._secondaryEvents = [
					[this.picker, {
						click: $.proxy(this.click, this)
					}],
					[$(window), {
						resize: $.proxy(this.place, this)
					}],
					[$(document), {
						'mousedown touchstart': $.proxy(function(e){
							// Clicked outside the datepicker, hide it
							if (!(
								this.element.is(e.target) ||
								this.element.find(e.target).length ||
								this.picker.is(e.target) ||
								this.picker.find(e.target).length
							)){
								this.hide();
							}
						}, this)
					}]
				];
			},
			_attachEvents: function(){
				this._detachEvents();
				this._applyEvents(this._events);
			},
			_detachEvents: function(){
				this._unapplyEvents(this._events);
			},
			_attachSecondaryEvents: function(){
				this._detachSecondaryEvents();
				this._applyEvents(this._secondaryEvents);
			},
			_detachSecondaryEvents: function(){
				this._unapplyEvents(this._secondaryEvents);
			},
			_trigger: function(event, altdate){
				var date = altdate || this.dates.get(-1),
					local_date = this._utc_to_local(date);

				this.element.trigger({
					type: event,
					date: local_date,
					dates: $.map(this.dates, this._utc_to_local),
					format: $.proxy(function(ix, format){
						if (arguments.length === 0){
							ix = this.dates.length - 1;
							format = this.o.format;
						}
						else if (typeof ix === 'string'){
							format = ix;
							ix = this.dates.length - 1;
						}
						format = format || this.o.format;
						var date = this.dates.get(ix);
						return DPGlobal.formatDate(date, format, this.o.language);
					}, this)
				});
			},

			show: function(){
				if (!this.isInline)
					this.picker.appendTo('body');
				this.picker.show();
				this.place();
				this._attachSecondaryEvents();
				this._trigger('show');
			},

			hide: function(){
				if (this.isInline)
					return;
				if (!this.picker.is(':visible'))
					return;
				this.focusDate = null;
				this.picker.hide().detach();
				this._detachSecondaryEvents();
				this.viewMode = this.o.startView;
				this.showMode();

				if (
					this.o.forceParse &&
					(
						this.isInput && this.element.val() ||
						this.hasInput && this.element.find('input').val()
					)
				)
					this.setValue();
				this._trigger('hide');
			},

			remove: function(){
				this.hide();
				this._detachEvents();
				this._detachSecondaryEvents();
				this.picker.remove();
				delete this.element.data().datepicker;
				if (!this.isInput){
					delete this.element.data().date;
				}
			},

			_utc_to_local: function(utc){
				return utc && new Date(utc.getTime() + (utc.getTimezoneOffset()*60000));
			},
			_local_to_utc: function(local){
				return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
			},
			_zero_time: function(local){
				return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
			},
			_zero_utc_time: function(utc){
				return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
			},

			getDates: function(){
				return $.map(this.dates, this._utc_to_local);
			},

			getUTCDates: function(){
				return $.map(this.dates, function(d){
					return new Date(d);
				});
			},

			getDate: function(){
				return this._utc_to_local(this.getUTCDate());
			},

			getUTCDate: function(){
				return new Date(this.dates.get(-1));
			},

			setDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, args);
				this._trigger('changeDate');
				this.setValue();
			},

			setUTCDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, $.map(args, this._utc_to_local));
				this._trigger('changeDate');
				this.setValue();
			},

			setDate: alias('setDates'),
			setUTCDate: alias('setUTCDates'),

			setValue: function(){
				var formatted = this.getFormattedDate();
				if (!this.isInput){
					if (this.component){
						this.element.find('input').val(formatted).change();
					}
				}
				else {
					this.element.val(formatted).change();
				}
			},

			getFormattedDate: function(format){
				if (format === undefined)
					format = this.o.format;

				var lang = this.o.language;
				return $.map(this.dates, function(d){
					return DPGlobal.formatDate(d, format, lang);
				}).join(this.o.multidateSeparator);
			},

			setStartDate: function(startDate){
				this._process_options({startDate: startDate});
				this.update();
				this.updateNavArrows();
			},

			setEndDate: function(endDate){
				this._process_options({endDate: endDate});
				this.update();
				this.updateNavArrows();
			},

			setDaysOfWeekDisabled: function(daysOfWeekDisabled){
				this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
				this.update();
				this.updateNavArrows();
			},

			place: function(){
				if (this.isInline)
					return;
				var calendarWidth = this.picker.outerWidth(),
					calendarHeight = this.picker.outerHeight(),
					visualPadding = 10,
					windowWidth = $window.width(),
					windowHeight = $window.height(),
					scrollTop = $window.scrollTop();

				var zIndex = parseInt(this.element.parents().filter(function(){
						return $(this).css('z-index') !== 'auto';
					}).first().css('z-index'))+10;
				var offset = this.component ? this.component.parent().offset() : this.element.offset();
				var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
				var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
				var left = offset.left,
					top = offset.top;

				this.picker.removeClass(
					'datepicker-orient-top datepicker-orient-bottom '+
					'datepicker-orient-right datepicker-orient-left'
				);

				if (this.o.orientation.x !== 'auto'){
					this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
					if (this.o.orientation.x === 'right')
						left -= calendarWidth - width;
				}
				// auto x orientation is best-placement: if it crosses a window
				// edge, fudge it sideways
				else {
					// Default to left
					this.picker.addClass('datepicker-orient-left');
					if (offset.left < 0)
						left -= offset.left - visualPadding;
					else if (offset.left + calendarWidth > windowWidth)
						left = windowWidth - calendarWidth - visualPadding;
				}

				// auto y orientation is best-situation: top or bottom, no fudging,
				// decision based on which shows more of the calendar
				var yorient = this.o.orientation.y,
					top_overflow, bottom_overflow;
				if (yorient === 'auto'){
					top_overflow = -scrollTop + offset.top - calendarHeight;
					bottom_overflow = scrollTop + windowHeight - (offset.top + height + calendarHeight);
					if (Math.max(top_overflow, bottom_overflow) === bottom_overflow)
						yorient = 'top';
					else
						yorient = 'bottom';
				}
				this.picker.addClass('datepicker-orient-' + yorient);
				if (yorient === 'top')
					top += height;
				else
					top -= calendarHeight + parseInt(this.picker.css('padding-top'));

				this.picker.css({
					top: top,
					left: left,
					zIndex: zIndex
				});
			},

			_allow_update: true,
			update: function(){
				if (!this._allow_update)
					return;

				var oldDates = this.dates.copy(),
					dates = [],
					fromArgs = false;
				if (arguments.length){
					$.each(arguments, $.proxy(function(i, date){
						if (date instanceof Date)
							date = this._local_to_utc(date);
						dates.push(date);
					}, this));
					fromArgs = true;
				}
				else {
					dates = this.isInput
							? this.element.val()
							: this.element.data('date') || this.element.find('input').val();
					if (dates && this.o.multidate)
						dates = dates.split(this.o.multidateSeparator);
					else
						dates = [dates];
					delete this.element.data().date;
				}

				dates = $.map(dates, $.proxy(function(date){
					return DPGlobal.parseDate(date, this.o.format, this.o.language);
				}, this));
				dates = $.grep(dates, $.proxy(function(date){
					return (
						date < this.o.startDate ||
						date > this.o.endDate ||
						!date
					);
				}, this), true);
				this.dates.replace(dates);

				if (this.dates.length)
					this.viewDate = new Date(this.dates.get(-1));
				else if (this.viewDate < this.o.startDate)
					this.viewDate = new Date(this.o.startDate);
				else if (this.viewDate > this.o.endDate)
					this.viewDate = new Date(this.o.endDate);

				if (fromArgs){
					// setting date by clicking
					this.setValue();
				}
				else if (dates.length){
					// setting date by typing
					if (String(oldDates) !== String(this.dates))
						this._trigger('changeDate');
				}
				if (!this.dates.length && oldDates.length)
					this._trigger('clearDate');

				this.fill();
			},

			fillDow: function(){
				var dowCnt = this.o.weekStart,
					html = '<tr>';
				if (this.o.calendarWeeks){
					var cell = '<th class="cw">&nbsp;</th>';
					html += cell;
					this.picker.find('.datepicker-days thead tr:first-child').prepend(cell);
				}
				while (dowCnt < this.o.weekStart + 7){
					html += '<th class="dow">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
				}
				html += '</tr>';
				this.picker.find('.datepicker-days thead').append(html);
			},

			fillMonths: function(){
				var html = '',
				i = 0;
				while (i < 12){
					html += '<span class="month">'+dates[this.o.language].monthsShort[i++]+'</span>';
				}
				this.picker.find('.datepicker-months td').html(html);
			},

			setRange: function(range){
				if (!range || !range.length)
					delete this.range;
				else
					this.range = $.map(range, function(d){
						return d.valueOf();
					});
				this.fill();
			},

			getClassNames: function(date){
				var cls = [],
					year = this.viewDate.getUTCFullYear(),
					month = this.viewDate.getUTCMonth(),
					today = new Date();
				if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
					cls.push('old');
				}
				else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
					cls.push('new');
				}
				if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
					cls.push('focused');
				// Compare internal UTC date with local today, not UTC today
				if (this.o.todayHighlight &&
					date.getUTCFullYear() === today.getFullYear() &&
					date.getUTCMonth() === today.getMonth() &&
					date.getUTCDate() === today.getDate()){
					cls.push('today');
				}
				if (this.dates.contains(date) !== -1)
					cls.push('active');
				if (date.valueOf() < this.o.startDate || date.valueOf() > this.o.endDate ||
					$.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1){
					cls.push('disabled');
				}
				if (this.range){
					if (date > this.range[0] && date < this.range[this.range.length-1]){
						cls.push('range');
					}
					if ($.inArray(date.valueOf(), this.range) !== -1){
						cls.push('selected');
					}
				}
				return cls;
			},

			fill: function(){
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth(),
					startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
					startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
					endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
					endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
					todaytxt = dates[this.o.language].today || dates['en'].today || '',
					cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
					tooltip;
				this.picker.find('.datepicker-days thead th.datepicker-switch')
							.text(dates[this.o.language].months[month]+' '+year);
				this.picker.find('tfoot th.today')
							.text(todaytxt)
							.toggle(this.o.todayBtn !== false);
				this.picker.find('tfoot th.clear')
							.text(cleartxt)
							.toggle(this.o.clearBtn !== false);
				this.updateNavArrows();
				this.fillMonths();
				var prevMonth = UTCDate(year, month-1, 28),
					day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
				prevMonth.setUTCDate(day);
				prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
				var nextMonth = new Date(prevMonth);
				nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
				nextMonth = nextMonth.valueOf();
				var html = [];
				var clsName;
				while (prevMonth.valueOf() < nextMonth){
					if (prevMonth.getUTCDay() === this.o.weekStart){
						html.push('<tr>');
						if (this.o.calendarWeeks){
							// ISO 8601: First week contains first thursday.
							// ISO also states week starts on Monday, but we can be more abstract here.
							var
								// Start of current week: based on weekstart/current date
								ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 864e5),
								// Thursday of this week
								th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
								// First Thursday of year, year from thursday
								yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay())%7*864e5),
								// Calendar week: ms between thursdays, div ms per day, div 7 days
								calWeek =  (th - yth) / 864e5 / 7 + 1;
							html.push('<td class="cw">'+ calWeek +'</td>');

						}
					}
					clsName = this.getClassNames(prevMonth);
					clsName.push('day');

					if (this.o.beforeShowDay !== $.noop){
						var before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
						if (before === undefined)
							before = {};
						else if (typeof(before) === 'boolean')
							before = {enabled: before};
						else if (typeof(before) === 'string')
							before = {classes: before};
						if (before.enabled === false)
							clsName.push('disabled');
						if (before.classes)
							clsName = clsName.concat(before.classes.split(/\s+/));
						if (before.tooltip)
							tooltip = before.tooltip;
					}

					clsName = $.unique(clsName);
					html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + '>'+prevMonth.getUTCDate() + '</td>');
					if (prevMonth.getUTCDay() === this.o.weekEnd){
						html.push('</tr>');
					}
					prevMonth.setUTCDate(prevMonth.getUTCDate()+1);
				}
				this.picker.find('.datepicker-days tbody').empty().append(html.join(''));

				var months = this.picker.find('.datepicker-months')
							.find('th:eq(1)')
								.text(year)
								.end()
							.find('span').removeClass('active');

				$.each(this.dates, function(i, d){
					if (d.getUTCFullYear() === year)
						months.eq(d.getUTCMonth()).addClass('active');
				});

				if (year < startYear || year > endYear){
					months.addClass('disabled');
				}
				if (year === startYear){
					months.slice(0, startMonth).addClass('disabled');
				}
				if (year === endYear){
					months.slice(endMonth+1).addClass('disabled');
				}

				html = '';
				year = parseInt(year/10, 10) * 10;
				var yearCont = this.picker.find('.datepicker-years')
									.find('th:eq(1)')
										.text(year + '-' + (year + 9))
										.end()
									.find('td');
				year -= 1;
				var years = $.map(this.dates, function(d){
						return d.getUTCFullYear();
					}),
					classes;
				for (var i = -1; i < 11; i++){
					classes = ['year'];
					if (i === -1)
						classes.push('old');
					else if (i === 10)
						classes.push('new');
					if ($.inArray(year, years) !== -1)
						classes.push('active');
					if (year < startYear || year > endYear)
						classes.push('disabled');
					html += '<span class="' + classes.join(' ') + '">'+year+'</span>';
					year += 1;
				}
				yearCont.html(html);
			},

			updateNavArrows: function(){
				if (!this._allow_update)
					return;

				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth();
				switch (this.viewMode){
					case 0:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()){
							this.picker.find('.prev').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.prev').css({visibility: 'visible'});
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()){
							this.picker.find('.next').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.next').css({visibility: 'visible'});
						}
						break;
					case 1:
					case 2:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear()){
							this.picker.find('.prev').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.prev').css({visibility: 'visible'});
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear()){
							this.picker.find('.next').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.next').css({visibility: 'visible'});
						}
						break;
				}
			},

			click: function(e){
				e.preventDefault();
				var target = $(e.target).closest('span, td, th'),
					year, month, day;
				if (target.length === 1){
					switch (target[0].nodeName.toLowerCase()){
						case 'th':
							switch (target[0].className){
								case 'datepicker-switch':
									this.showMode(1);
									break;
								case 'prev':
								case 'next':
									var dir = DPGlobal.modes[this.viewMode].navStep * (target[0].className === 'prev' ? -1 : 1);
									switch (this.viewMode){
										case 0:
											this.viewDate = this.moveMonth(this.viewDate, dir);
											this._trigger('changeMonth', this.viewDate);
											break;
										case 1:
										case 2:
											this.viewDate = this.moveYear(this.viewDate, dir);
											if (this.viewMode === 1)
												this._trigger('changeYear', this.viewDate);
											break;
									}
									this.fill();
									break;
								case 'today':
									var date = new Date();
									date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);

									this.showMode(-2);
									var which = this.o.todayBtn === 'linked' ? null : 'view';
									this._setDate(date, which);
									break;
								case 'clear':
									var element;
									if (this.isInput)
										element = this.element;
									else if (this.component)
										element = this.element.find('input');
									if (element)
										element.val("").change();
									this.update();
									this._trigger('changeDate');
									if (this.o.autoclose)
										this.hide();
									break;
							}
							break;
						case 'span':
							if (!target.is('.disabled')){
								this.viewDate.setUTCDate(1);
								if (target.is('.month')){
									day = 1;
									month = target.parent().find('span').index(target);
									year = this.viewDate.getUTCFullYear();
									this.viewDate.setUTCMonth(month);
									this._trigger('changeMonth', this.viewDate);
									if (this.o.minViewMode === 1){
										this._setDate(UTCDate(year, month, day));
									}
								}
								else {
									day = 1;
									month = 0;
									year = parseInt(target.text(), 10)||0;
									this.viewDate.setUTCFullYear(year);
									this._trigger('changeYear', this.viewDate);
									if (this.o.minViewMode === 2){
										this._setDate(UTCDate(year, month, day));
									}
								}
								this.showMode(-1);
								this.fill();
							}
							break;
						case 'td':
							if (target.is('.day') && !target.is('.disabled')){
								day = parseInt(target.text(), 10)||1;
								year = this.viewDate.getUTCFullYear();
								month = this.viewDate.getUTCMonth();
								if (target.is('.old')){
									if (month === 0){
										month = 11;
										year -= 1;
									}
									else {
										month -= 1;
									}
								}
								else if (target.is('.new')){
									if (month === 11){
										month = 0;
										year += 1;
									}
									else {
										month += 1;
									}
								}
								this._setDate(UTCDate(year, month, day));
							}
							break;
					}
				}
				if (this.picker.is(':visible') && this._focused_from){
					$(this._focused_from).focus();
				}
				delete this._focused_from;
			},

			_toggle_multidate: function(date){
				var ix = this.dates.contains(date);
				if (!date){
					this.dates.clear();
				}
				else if (ix !== -1){
					this.dates.remove(ix);
				}
				else {
					this.dates.push(date);
				}
				if (typeof this.o.multidate === 'number')
					while (this.dates.length > this.o.multidate)
						this.dates.remove(0);
			},

			_setDate: function(date, which){
				if (!which || which === 'date')
					this._toggle_multidate(date && new Date(date));
				if (!which || which  === 'view')
					this.viewDate = date && new Date(date);

				this.fill();
				this.setValue();
				this._trigger('changeDate');
				var element;
				if (this.isInput){
					element = this.element;
				}
				else if (this.component){
					element = this.element.find('input');
				}
				if (element){
					element.change();
				}
				if (this.o.autoclose && (!which || which === 'date')){
					this.hide();
				}
			},

			moveMonth: function(date, dir){
				if (!date)
					return undefined;
				if (!dir)
					return date;
				var new_date = new Date(date.valueOf()),
					day = new_date.getUTCDate(),
					month = new_date.getUTCMonth(),
					mag = Math.abs(dir),
					new_month, test;
				dir = dir > 0 ? 1 : -1;
				if (mag === 1){
					test = dir === -1
						// If going back one month, make sure month is not current month
						// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
						? function(){
							return new_date.getUTCMonth() === month;
						}
						// If going forward one month, make sure month is as expected
						// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
						: function(){
							return new_date.getUTCMonth() !== new_month;
						};
					new_month = month + dir;
					new_date.setUTCMonth(new_month);
					// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
					if (new_month < 0 || new_month > 11)
						new_month = (new_month + 12) % 12;
				}
				else {
					// For magnitudes >1, move one month at a time...
					for (var i=0; i < mag; i++)
						// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
						new_date = this.moveMonth(new_date, dir);
					// ...then reset the day, keeping it in the new month
					new_month = new_date.getUTCMonth();
					new_date.setUTCDate(day);
					test = function(){
						return new_month !== new_date.getUTCMonth();
					};
				}
				// Common date-resetting loop -- if date is beyond end of month, make it
				// end of month
				while (test()){
					new_date.setUTCDate(--day);
					new_date.setUTCMonth(new_month);
				}
				return new_date;
			},

			moveYear: function(date, dir){
				return this.moveMonth(date, dir*12);
			},

			dateWithinRange: function(date){
				return date >= this.o.startDate && date <= this.o.endDate;
			},

			keydown: function(e){
				if (this.picker.is(':not(:visible)')){
					if (e.keyCode === 27) // allow escape to hide and re-show picker
						this.show();
					return;
				}
				var dateChanged = false,
					dir, newDate, newViewDate,
					focusDate = this.focusDate || this.viewDate;
				switch (e.keyCode){
					case 27: // escape
						if (this.focusDate){
							this.focusDate = null;
							this.viewDate = this.dates.get(-1) || this.viewDate;
							this.fill();
						}
						else
							this.hide();
						e.preventDefault();
						break;
					case 37: // left
					case 39: // right
						if (!this.o.keyboardNavigation)
							break;
						dir = e.keyCode === 37 ? -1 : 1;
						if (e.ctrlKey){
							newDate = this.moveYear(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveYear(focusDate, dir);
							this._trigger('changeYear', this.viewDate);
						}
						else if (e.shiftKey){
							newDate = this.moveMonth(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveMonth(focusDate, dir);
							this._trigger('changeMonth', this.viewDate);
						}
						else {
							newDate = new Date(this.dates.get(-1) || UTCToday());
							newDate.setUTCDate(newDate.getUTCDate() + dir);
							newViewDate = new Date(focusDate);
							newViewDate.setUTCDate(focusDate.getUTCDate() + dir);
						}
						if (this.dateWithinRange(newDate)){
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 38: // up
					case 40: // down
						if (!this.o.keyboardNavigation)
							break;
						dir = e.keyCode === 38 ? -1 : 1;
						if (e.ctrlKey){
							newDate = this.moveYear(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveYear(focusDate, dir);
							this._trigger('changeYear', this.viewDate);
						}
						else if (e.shiftKey){
							newDate = this.moveMonth(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveMonth(focusDate, dir);
							this._trigger('changeMonth', this.viewDate);
						}
						else {
							newDate = new Date(this.dates.get(-1) || UTCToday());
							newDate.setUTCDate(newDate.getUTCDate() + dir * 7);
							newViewDate = new Date(focusDate);
							newViewDate.setUTCDate(focusDate.getUTCDate() + dir * 7);
						}
						if (this.dateWithinRange(newDate)){
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 32: // spacebar
						// Spacebar is used in manually typing dates in some formats.
						// As such, its behavior should not be hijacked.
						break;
					case 13: // enter
						focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
						this._toggle_multidate(focusDate);
						dateChanged = true;
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.setValue();
						this.fill();
						if (this.picker.is(':visible')){
							e.preventDefault();
							if (this.o.autoclose)
								this.hide();
						}
						break;
					case 9: // tab
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
						this.hide();
						break;
				}
				if (dateChanged){
					if (this.dates.length)
						this._trigger('changeDate');
					else
						this._trigger('clearDate');
					var element;
					if (this.isInput){
						element = this.element;
					}
					else if (this.component){
						element = this.element.find('input');
					}
					if (element){
						element.change();
					}
				}
			},

			showMode: function(dir){
				if (dir){
					this.viewMode = Math.max(this.o.minViewMode, Math.min(2, this.viewMode + dir));
				}
				this.picker
					.find('>div')
					.hide()
					.filter('.datepicker-'+DPGlobal.modes[this.viewMode].clsName)
						.css('display', 'block');
				this.updateNavArrows();
			}
		};

		var DateRangePicker = function(element, options){
			this.element = $(element);
			this.inputs = $.map(options.inputs, function(i){
				return i.jquery ? i[0] : i;
			});
			delete options.inputs;

			$(this.inputs)
				.datepicker(options)
				.bind('changeDate', $.proxy(this.dateUpdated, this));

			this.pickers = $.map(this.inputs, function(i){
				return $(i).data('datepicker');
			});
			this.updateDates();
		};
		DateRangePicker.prototype = {
			updateDates: function(){
				this.dates = $.map(this.pickers, function(i){
					return i.getUTCDate();
				});
				this.updateRanges();
			},
			updateRanges: function(){
				var range = $.map(this.dates, function(d){
					return d.valueOf();
				});
				$.each(this.pickers, function(i, p){
					p.setRange(range);
				});
			},
			dateUpdated: function(e){
				// `this.updating` is a workaround for preventing infinite recursion
				// between `changeDate` triggering and `setUTCDate` calling.  Until
				// there is a better mechanism.
				if (this.updating)
					return;
				this.updating = true;

				var dp = $(e.target).data('datepicker'),
					new_date = dp.getUTCDate(),
					i = $.inArray(e.target, this.inputs),
					l = this.inputs.length;
				if (i === -1)
					return;

				$.each(this.pickers, function(i, p){
					if (!p.getUTCDate())
						p.setUTCDate(new_date);
				});

				if (new_date < this.dates[i]){
					// Date being moved earlier/left
					while (i >= 0 && new_date < this.dates[i]){
						this.pickers[i--].setUTCDate(new_date);
					}
				}
				else if (new_date > this.dates[i]){
					// Date being moved later/right
					while (i < l && new_date > this.dates[i]){
						this.pickers[i++].setUTCDate(new_date);
					}
				}
				this.updateDates();

				delete this.updating;
			},
			remove: function(){
				$.map(this.pickers, function(p){ p.remove(); });
				delete this.element.data().datepicker;
			}
		};

		function opts_from_el(el, prefix){
			// Derive options from element data-attrs
			var data = $(el).data(),
				out = {}, inkey,
				replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
			prefix = new RegExp('^' + prefix.toLowerCase());
			function re_lower(_,a){
				return a.toLowerCase();
			}
			for (var key in data)
				if (prefix.test(key)){
					inkey = key.replace(replace, re_lower);
					out[inkey] = data[key];
				}
			return out;
		}

		function opts_from_locale(lang){
			// Derive options from locale plugins
			var out = {};
			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					return;
			}
			var d = dates[lang];
			$.each(locale_opts, function(i,k){
				if (k in d)
					out[k] = d[k];
			});
			return out;
		}

		var old = $.fn.datepicker;
		$.fn.datepicker = function(option){
			var args = Array.apply(null, arguments);
			args.shift();
			var internal_return;
			this.each(function(){
				var $this = $(this),
					data = $this.data('datepicker'),
					options = typeof option === 'object' && option;
				if (!data){
					var elopts = opts_from_el(this, 'date'),
						// Preliminary otions
						xopts = $.extend({}, defaults, elopts, options),
						locopts = opts_from_locale(xopts.language),
						// Options priority: js args, data-attrs, locales, defaults
						opts = $.extend({}, defaults, locopts, elopts, options);
					if ($this.is('.input-daterange') || opts.inputs){
						var ropts = {
							inputs: opts.inputs || $this.find('input').toArray()
						};
						$this.data('datepicker', (data = new DateRangePicker(this, $.extend(opts, ropts))));
					}
					else {
						$this.data('datepicker', (data = new Datepicker(this, opts)));
					}
				}
				if (typeof option === 'string' && typeof data[option] === 'function'){
					internal_return = data[option].apply(data, args);
					if (internal_return !== undefined)
						return false;
				}
			});
			if (internal_return !== undefined)
				return internal_return;
			else
				return this;
		};

		var defaults = $.fn.datepicker.defaults = {
			autoclose: false,
			beforeShowDay: $.noop,
			calendarWeeks: false,
			clearBtn: false,
			daysOfWeekDisabled: [],
			endDate: Infinity,
			forceParse: true,
			format: 'mm/dd/yyyy',
			keyboardNavigation: true,
			language: 'en',
			minViewMode: 0,
			multidate: false,
			multidateSeparator: ',',
			orientation: "auto",
			rtl: false,
			startDate: -Infinity,
			startView: 0,
			todayBtn: false,
			todayHighlight: false,
			weekStart: 0
		};
		var locale_opts = $.fn.datepicker.locale_opts = [
			'format',
			'rtl',
			'weekStart'
		];
		$.fn.datepicker.Constructor = Datepicker;
		var dates = $.fn.datepicker.dates = {
			en: {
				days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
				daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
				daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
				months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				today: "Today",
				clear: "Clear"
			}
		};

		var DPGlobal = {
			modes: [
				{
					clsName: 'days',
					navFnc: 'Month',
					navStep: 1
				},
				{
					clsName: 'months',
					navFnc: 'FullYear',
					navStep: 1
				},
				{
					clsName: 'years',
					navFnc: 'FullYear',
					navStep: 10
			}],
			isLeapYear: function(year){
				return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
			},
			getDaysInMonth: function(year, month){
				return [31, (DPGlobal.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
			},
			validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
			nonpunctuation: /[^ -\/:-@\[\u3400-\u9fff-`{-~\t\n\r]+/g,
			parseFormat: function(format){
				// IE treats \0 as a string end in inputs (truncating the value),
				// so it's a bad format delimiter, anyway
				var separators = format.replace(this.validParts, '\0').split('\0'),
					parts = format.match(this.validParts);
				if (!separators || !separators.length || !parts || parts.length === 0){
					throw new Error("Invalid date format.");
				}
				return {separators: separators, parts: parts};
			},
			parseDate: function(date, format, language){
				if (!date)
					return undefined;
				if (date instanceof Date)
					return date;
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				var part_re = /([\-+]\d+)([dmwy])/,
					parts = date.match(/([\-+]\d+)([dmwy])/g),
					part, dir, i;
				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
					date = new Date();
					for (i=0; i < parts.length; i++){
						part = part_re.exec(parts[i]);
						dir = parseInt(part[1]);
						switch (part[2]){
							case 'd':
								date.setUTCDate(date.getUTCDate() + dir);
								break;
							case 'm':
								date = Datepicker.prototype.moveMonth.call(Datepicker.prototype, date, dir);
								break;
							case 'w':
								date.setUTCDate(date.getUTCDate() + dir * 7);
								break;
							case 'y':
								date = Datepicker.prototype.moveYear.call(Datepicker.prototype, date, dir);
								break;
						}
					}
					return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
				}
				parts = date && date.match(this.nonpunctuation) || [];
				date = new Date();
				var parsed = {},
					setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
					setters_map = {
						yyyy: function(d,v){
							return d.setUTCFullYear(v);
						},
						yy: function(d,v){
							return d.setUTCFullYear(2000+v);
						},
						m: function(d,v){
							if (isNaN(d))
								return d;
							v -= 1;
							while (v < 0) v += 12;
							v %= 12;
							d.setUTCMonth(v);
							while (d.getUTCMonth() !== v)
								d.setUTCDate(d.getUTCDate()-1);
							return d;
						},
						d: function(d,v){
							return d.setUTCDate(v);
						}
					},
					val, filtered;
				setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
				setters_map['dd'] = setters_map['d'];
				date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
				var fparts = format.parts.slice();
				// Remove noop parts
				if (parts.length !== fparts.length){
					fparts = $(fparts).filter(function(i,p){
						return $.inArray(p, setters_order) !== -1;
					}).toArray();
				}
				// Process remainder
				function match_part(){
					var m = this.slice(0, parts[i].length),
						p = parts[i].slice(0, m.length);
					return m === p;
				}
				if (parts.length === fparts.length){
					var cnt;
					for (i=0, cnt = fparts.length; i < cnt; i++){
						val = parseInt(parts[i], 10);
						part = fparts[i];
						if (isNaN(val)){
							switch (part){
								case 'MM':
									filtered = $(dates[language].months).filter(match_part);
									val = $.inArray(filtered[0], dates[language].months) + 1;
									break;
								case 'M':
									filtered = $(dates[language].monthsShort).filter(match_part);
									val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
									break;
							}
						}
						parsed[part] = val;
					}
					var _date, s;
					for (i=0; i < setters_order.length; i++){
						s = setters_order[i];
						if (s in parsed && !isNaN(parsed[s])){
							_date = new Date(date);
							setters_map[s](_date, parsed[s]);
							if (!isNaN(_date))
								date = _date;
						}
					}
				}
				return date;
			},
			formatDate: function(date, format, language){
				if (!date)
					return '';
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				var val = {
					d: date.getUTCDate(),
					D: dates[language].daysShort[date.getUTCDay()],
					DD: dates[language].days[date.getUTCDay()],
					m: date.getUTCMonth() + 1,
					M: dates[language].monthsShort[date.getUTCMonth()],
					MM: dates[language].months[date.getUTCMonth()],
					yy: date.getUTCFullYear().toString().substring(2),
					yyyy: date.getUTCFullYear()
				};
				val.dd = (val.d < 10 ? '0' : '') + val.d;
				val.mm = (val.m < 10 ? '0' : '') + val.m;
				date = [];
				var seps = $.extend([], format.separators);
				for (var i=0, cnt = format.parts.length; i <= cnt; i++){
					if (seps.length)
						date.push(seps.shift());
					date.push(val[format.parts[i]]);
				}
				return date.join('');
			},
			headTemplate: '<thead>'+
								'<tr>'+
									'<th class="prev">&laquo;</th>'+
									'<th colspan="5" class="datepicker-switch"></th>'+
									'<th class="next">&raquo;</th>'+
								'</tr>'+
							'</thead>',
			contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
			footTemplate: '<tfoot>'+
								'<tr>'+
									'<th colspan="7" class="today"></th>'+
								'</tr>'+
								'<tr>'+
									'<th colspan="7" class="clear"></th>'+
								'</tr>'+
							'</tfoot>'
		};
		DPGlobal.template = '<div class="datepicker">'+
								'<div class="datepicker-days">'+
									'<table class=" table-condensed">'+
										DPGlobal.headTemplate+
										'<tbody></tbody>'+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-months">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-years">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
							'</div>';

		$.fn.datepicker.DPGlobal = DPGlobal;


		/* DATEPICKER NO CONFLICT
		* =================== */

		$.fn.datepicker.noConflict = function(){
			$.fn.datepicker = old;
			return this;
		};


		/* DATEPICKER DATA-API
		* ================== */

		$(document).on(
			'focus.datepicker.data-api click.datepicker.data-api',
			'[data-provide="datepicker"]',
			function(e){
				var $this = $(this);
				if ($this.data('datepicker'))
					return;
				e.preventDefault();
				// component click requires us to explicitly show it
				$this.datepicker('show');
			}
		);
		$(function(){
			$('[data-provide="datepicker-inline"]').datepicker();
		});

	}(jQuery));
	};

/***/ }
/******/ ])
});
;
